var hae = Object.defineProperty;
var pae = (e, r, t) => r in e ? hae(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var Gn = (e, r, t) => pae(e, typeof r != "symbol" ? r + "" : r, t);
import { jsx as l, Fragment as he, jsxs as C } from "react/jsx-runtime";
import * as h from "react";
import D, { Fragment as Do, forwardRef as re, createElement as lr, useState as ie, useMemo as $e, useCallback as Yi, useEffect as Pe, useRef as Yr, useLayoutEffect as Eq, createContext as et, useContext as rt, Children as Hi, isValidElement as Ci, cloneElement as at, useReducer as mae, useImperativeHandle as kq, useId as gae, PureComponent as Gs, Component as tR, useDebugValue as iR } from "react";
import { a as nc, M as Q7, b as Te, A as Tc } from "./conversations-B6_5aJ5K.js";
import { t as Dn, h as nR, e as sR } from "./i18n-DoHK2p36.js";
import { f as Is, g as vae } from "./localisationConfig-BfnSuGmH.js";
import { c as We, f as bae } from "./react-D7zVIf_f.js";
import { c as _, a as ur, b as vo, g as Mr } from "./tailwind-BXrsiEcF.js";
import { l as uR, k as hy, u as Ur, j as si, q as yae, S as Aae, i as ua, f as wae, h as oR, m as dR, n as aR, g as VR, a as Cae, d as Pae, P as gr, e as Sae, b as Nae, p as Oq } from "./useGetSubdivisionType-CuJXxyQE.js";
import { useQueryClient as Mae } from "@tanstack/react-query";
import "./services.gen-D7DK4RCL.js";
import { h as Tae, c as Eae, a as kae, b as Oae, f as Dae, u as Dq } from "./useReviseConversationExpertResult-D8w2nkRT.js";
import * as qs from "react-dom";
import Us, { flushSync as lR } from "react-dom";
import { useFormContext as Rae, Controller as Iae } from "react-hook-form";
import { FormProvider as urr, useController as orr, useFieldArray as drr, useForm as arr, useFormContext as Vrr, useWatch as lrr } from "react-hook-form";
import { VicSmartEligibility as bV } from "./types.js";
import { i as ku, e as Rw } from "./typePredicates-CHcjxMc5.js";
function Lae({
  template: e,
  renderFunctions: r
}) {
  const t = /\[\[([^\]]+)]]/g;
  return /* @__PURE__ */ l(he, { children: (() => {
    const n = [];
    let s = 0, u;
    for (; (u = t.exec(e)) !== null; ) {
      const [o, d] = u, a = u.index;
      if (a > s) {
        const V = e.slice(s, a);
        n.push(
          /* @__PURE__ */ l(
            "span",
            {
              dangerouslySetInnerHTML: { __html: V }
            },
            `text-${s}`
          )
        );
      }
      r[d] ? n.push(
        /* @__PURE__ */ l(Do, { children: r[d]() }, `${d}-${a}`)
      ) : n.push(
        /* @__PURE__ */ l(
          "span",
          {
            dangerouslySetInnerHTML: { __html: o }
          },
          `missing-${a}`
        )
      ), s = a + o.length;
    }
    if (s < e.length) {
      const o = e.slice(s);
      n.push(
        /* @__PURE__ */ l(
          "span",
          {
            dangerouslySetInnerHTML: { __html: o }
          },
          `text-${s}`
        )
      );
    }
    return n;
  })() });
}
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _ae = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Hae = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (r, t, i) => i ? i.toUpperCase() : t.toLowerCase()
), Iw = (e) => {
  const r = Hae(e);
  return r.charAt(0).toUpperCase() + r.slice(1);
}, cR = (...e) => e.filter((r, t, i) => !!r && r.trim() !== "" && i.indexOf(r) === t).join(" ").trim(), jae = (e) => {
  for (const r in e)
    if (r.startsWith("aria-") || r === "role" || r === "title")
      return !0;
};
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var zae = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Bae = re(
  ({
    color: e = "currentColor",
    size: r = 24,
    strokeWidth: t = 2,
    absoluteStrokeWidth: i,
    className: n = "",
    children: s,
    iconNode: u,
    ...o
  }, d) => lr(
    "svg",
    {
      ref: d,
      ...zae,
      width: r,
      height: r,
      stroke: e,
      strokeWidth: i ? Number(t) * 24 / Number(r) : t,
      className: cR("lucide", n),
      ...!s && !jae(o) && { "aria-hidden": "true" },
      ...o
    },
    [
      ...u.map(([a, V]) => lr(a, V)),
      ...Array.isArray(s) ? s : [s]
    ]
  )
);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dr = (e, r) => {
  const t = re(
    ({ className: i, ...n }, s) => lr(Bae, {
      ref: s,
      iconNode: r,
      className: cR(
        `lucide-${_ae(Iw(e))}`,
        `lucide-${e}`,
        i
      ),
      ...n
    })
  );
  return t.displayName = Iw(e), t;
};
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wae = [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
], Gae = Dr("arrow-up", Wae);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uae = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], FR = Dr("calendar", Uae);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zae = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Bo = Dr("check", Zae);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jae = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], e2 = Dr("chevron-down", Jae);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $ae = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], Qae = Dr("chevron-left", $ae);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eVe = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], xR = Dr("chevron-right", eVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rVe = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], tVe = Dr("chevron-up", rVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iVe = [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
], nVe = Dr("chevrons-up-down", iVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sVe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], uVe = Dr("circle-check", sVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oVe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], dVe = Dr("circle-question-mark", oVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aVe = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], Gc = Dr("circle", aVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VVe = [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
], lVe = Dr("eye-off", VVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cVe = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
], bd = Dr("file-text", cVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FVe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], Lw = Dr("frown", FVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xVe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], XVe = Dr("info", xVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qVe = [
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M4 10h2", key: "16xx2s" }],
  ["path", { d: "M4 6h1v4", key: "cnovpq" }],
  ["path", { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1", key: "m9a95d" }]
], YVe = Dr("list-ordered", qVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fVe = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], Zs = Dr("loader-circle", fVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KVe = [
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M3 18h.01", key: "1tta3j" }],
  ["path", { d: "M3 6h.01", key: "1rqtza" }],
  ["path", { d: "M8 12h13", key: "1za7za" }],
  ["path", { d: "M8 18h13", key: "1lx6n3" }],
  ["path", { d: "M8 6h13", key: "ik3vkj" }]
], hVe = Dr("list", KVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pVe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "8", x2: "16", y1: "15", y2: "15", key: "1xb1d9" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], _w = Dr("meh", pVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mVe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }]
], gVe = Dr("panel-left", mVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vVe = [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["path", { d: "m9 20 3-6 3 6", key: "se2kox" }],
  ["path", { d: "m6 8 6 2 6-2", key: "4o3us4" }],
  ["path", { d: "M12 10v4", key: "1kjpxc" }]
], yd = Dr("person-standing", vVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bVe = [
  ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
  ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
  ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
  ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
  ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
  ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }]
], yVe = Dr("sliders-horizontal", bVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AVe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
], Hw = Dr("smile", AVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wVe = [
  ["path", { d: "M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6", key: "y09zxi" }],
  ["path", { d: "m21 3-9 9", key: "mpx6sq" }],
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }]
], CVe = Dr("square-arrow-out-up-right", wVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PVe = [
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  [
    "path",
    {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
      key: "m61m77"
    }
  ]
], xi = Dr("thumbs-down", PVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SVe = [
  ["path", { d: "M7 10v12", key: "1qc93n" }],
  [
    "path",
    {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
      key: "emmmcr"
    }
  ]
], Xi = Dr("thumbs-up", SVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NVe = [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], MVe = Dr("triangle-alert", NVe);
/**
 * @license lucide-react v0.540.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TVe = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], r2 = Dr("x", TVe);
function EVe({
  content: e,
  onClickSubmit: r,
  onOpenChange: t,
  open: i,
  submitting: n,
  title: s,
  subTitle: u
}) {
  const [o, d] = ie(!0), [a, V] = ie(e);
  return /* @__PURE__ */ l(vY, { open: i, onOpenChange: t, children: /* @__PURE__ */ C(
    q2,
    {
      "aria-describedby": void 0,
      className: "flex max-h-[90%] flex-col gap-6 md:w-[80%] md:max-w-[80%] 2xl:max-w-[1280px]",
      children: [
        /* @__PURE__ */ C("div", { className: "flex flex-col gap-1", children: [
          /* @__PURE__ */ l(yY, { children: s }),
          u || null
        ] }),
        /* @__PURE__ */ l(
          eL,
          {
            value: a,
            onChange: (F) => {
              var X;
              Array.isArray(F.target.value) ? V(F.target.value.join(`
`)) : V(((X = F.target.value) == null ? void 0 : X.toString()) || "");
            }
          }
        ),
        /* @__PURE__ */ C("div", { className: "flex items-center gap-1", children: [
          /* @__PURE__ */ l("span", { className: "text-bodysm font-semibold", children: "Overwrite result: " }),
          /* @__PURE__ */ l(
            b2,
            {
              checked: o,
              onCheckedChange: d
            }
          )
        ] }),
        /* @__PURE__ */ C(bY, { children: [
          /* @__PURE__ */ l(
            er,
            {
              disabled: n,
              onClick: () => t(!1),
              variant: "outline",
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ C(er, { disabled: n, onClick: () => {
            r(a, o);
          }, children: [
            n ? /* @__PURE__ */ l(Zs, { className: "animate-spin" }) : null,
            "Amend"
          ] })
        ] })
      ]
    }
  ) });
}
function kVe({
  onOpenChange: e,
  open: r
}) {
  return /* @__PURE__ */ l(Q2e, { onOpenChange: e, open: r, children: /* @__PURE__ */ C(ZI, { children: [
    /* @__PURE__ */ l($I, { children: "You must create an issue first before amending" }),
    /* @__PURE__ */ l(JI, { children: /* @__PURE__ */ l(QI, { autoFocus: !0, children: "Ok" }) })
  ] }) });
}
function XR({
  children: e,
  // conversation,
  expertName: r,
  noticeboardData: t,
  // outputKey,
  title: i,
  subTitle: n
}) {
  const s = Mae(), [u, o] = ie(!1), [d, a] = ie(!1), { toast: V } = oU(), c = $e(() => {
    var f, p;
    return (f = t == null ? void 0 : t[r]) != null && f.raw_output ? (p = t == null ? void 0 : t[r]) == null ? void 0 : p.raw_output : "";
  }, [r, t]), { mutate: F, isPending: X } = Tae({
    onError: (f) => {
      console.error(
        "<EditExpertResultDialogContainer> useReviseConversationExpertResult()",
        f
      ), V({
        description: f.message,
        title: "Error updating expert result",
        variant: "destructive"
      });
    },
    onSuccess: () => {
      var f;
      console.log(
        "<EditExpertResultDialogContainer> useReviseConversationExpertResult()"
      ), s.invalidateQueries({
        queryKey: Eae({
          path: {
            conversation_id: ((f = t == null ? void 0 : t[r]) == null ? void 0 : f.conversation_id) || ""
          }
        })
      }), o(!1);
    }
  }), Y = (f, p) => {
    const m = t == null ? void 0 : t[r];
    m && m.conversation_expert_result_id && F({
      body: {
        conversation_expert_result: m.conversation_expert_result_id,
        revision_type: p ? "OVERWRITE" : "REINSTRUCTED",
        text: f
      }
    });
  }, q = Yi(() => {
    o(!0);
  }, []);
  return /* @__PURE__ */ C(he, { children: [
    e({ setOpen: q }),
    /* @__PURE__ */ l(
      EVe,
      {
        content: c,
        onClickSubmit: Y,
        onOpenChange: o,
        open: u,
        submitting: X,
        subTitle: n,
        title: i
      }
    ),
    /* @__PURE__ */ l(
      kVe,
      {
        onOpenChange: a,
        open: d
      }
    )
  ] });
}
const py = 6048e5, OVe = 864e5, qR = 6e4, YR = 36e5, jw = Symbol.for("constructDateFrom");
function ct(e, r) {
  return typeof e == "function" ? e(r) : e && typeof e == "object" && jw in e ? e[jw](r) : e instanceof Date ? new e.constructor(r) : new Date(r);
}
function Xr(e, r) {
  return ct(r || e, e);
}
function Xt(e, r, t) {
  const i = Xr(e, t == null ? void 0 : t.in);
  return isNaN(r) ? ct((t == null ? void 0 : t.in) || e, NaN) : (r && i.setDate(i.getDate() + r), i);
}
function us(e, r, t) {
  const i = Xr(e, t == null ? void 0 : t.in);
  if (isNaN(r)) return ct((t == null ? void 0 : t.in) || e, NaN);
  if (!r)
    return i;
  const n = i.getDate(), s = ct((t == null ? void 0 : t.in) || e, i.getTime());
  s.setMonth(i.getMonth() + r + 1, 0);
  const u = s.getDate();
  return n >= u ? s : (i.setFullYear(
    s.getFullYear(),
    s.getMonth(),
    n
  ), i);
}
let DVe = {};
function t2() {
  return DVe;
}
function ds(e, r) {
  var o, d, a, V;
  const t = t2(), i = (r == null ? void 0 : r.weekStartsOn) ?? ((d = (o = r == null ? void 0 : r.locale) == null ? void 0 : o.options) == null ? void 0 : d.weekStartsOn) ?? t.weekStartsOn ?? ((V = (a = t.locale) == null ? void 0 : a.options) == null ? void 0 : V.weekStartsOn) ?? 0, n = Xr(e, r == null ? void 0 : r.in), s = n.getDay(), u = (s < i ? 7 : 0) + s - i;
  return n.setDate(n.getDate() - u), n.setHours(0, 0, 0, 0), n;
}
function jd(e, r) {
  return ds(e, { ...r, weekStartsOn: 1 });
}
function fR(e, r) {
  const t = Xr(e, r == null ? void 0 : r.in), i = t.getFullYear(), n = ct(t, 0);
  n.setFullYear(i + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const s = jd(n), u = ct(t, 0);
  u.setFullYear(i, 0, 4), u.setHours(0, 0, 0, 0);
  const o = jd(u);
  return t.getTime() >= s.getTime() ? i + 1 : t.getTime() >= o.getTime() ? i : i - 1;
}
function Jx(e) {
  const r = Xr(e), t = new Date(
    Date.UTC(
      r.getFullYear(),
      r.getMonth(),
      r.getDate(),
      r.getHours(),
      r.getMinutes(),
      r.getSeconds(),
      r.getMilliseconds()
    )
  );
  return t.setUTCFullYear(r.getFullYear()), +e - +t;
}
function ql(e, ...r) {
  const t = ct.bind(
    null,
    e || r.find((i) => typeof i == "object")
  );
  return r.map(t);
}
function zd(e, r) {
  const t = Xr(e, r == null ? void 0 : r.in);
  return t.setHours(0, 0, 0, 0), t;
}
function Ps(e, r, t) {
  const [i, n] = ql(
    t == null ? void 0 : t.in,
    e,
    r
  ), s = zd(i), u = zd(n), o = +s - Jx(s), d = +u - Jx(u);
  return Math.round((o - d) / OVe);
}
function RVe(e, r) {
  const t = fR(e, r), i = ct(e, 0);
  return i.setFullYear(t, 0, 4), i.setHours(0, 0, 0, 0), jd(i);
}
function av(e, r, t) {
  return Xt(e, r * 7, t);
}
function IVe(e, r, t) {
  return us(e, r * 12, t);
}
function LVe(e, r) {
  let t, i = r == null ? void 0 : r.in;
  return e.forEach((n) => {
    !i && typeof n == "object" && (i = ct.bind(null, n));
    const s = Xr(n, i);
    (!t || t < s || isNaN(+s)) && (t = s);
  }), ct(i, t || NaN);
}
function _Ve(e, r) {
  let t, i = r == null ? void 0 : r.in;
  return e.forEach((n) => {
    !i && typeof n == "object" && (i = ct.bind(null, n));
    const s = Xr(n, i);
    (!t || t > s || isNaN(+s)) && (t = s);
  }), ct(i, t || NaN);
}
function HVe(e) {
  return ct(e, Date.now());
}
function Ai(e, r, t) {
  const [i, n] = ql(
    t == null ? void 0 : t.in,
    e,
    r
  );
  return +zd(i) == +zd(n);
}
function my(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function jVe(e) {
  return !(!my(e) && typeof e != "number" || isNaN(+Xr(e)));
}
function Uc(e, r, t) {
  const [i, n] = ql(
    t == null ? void 0 : t.in,
    e,
    r
  ), s = i.getFullYear() - n.getFullYear(), u = i.getMonth() - n.getMonth();
  return s * 12 + u;
}
function zVe(e, r, t) {
  const [i, n] = ql(
    t == null ? void 0 : t.in,
    e,
    r
  ), s = ds(i, t), u = ds(n, t), o = +s - Jx(s), d = +u - Jx(u);
  return Math.round((o - d) / py);
}
function zw(e, r) {
  const t = Xr(e, r == null ? void 0 : r.in);
  return t.setHours(23, 59, 59, 999), t;
}
function gy(e, r) {
  const t = Xr(e, r == null ? void 0 : r.in), i = t.getMonth();
  return t.setFullYear(t.getFullYear(), i + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function ji(e, r) {
  const t = Xr(e, r == null ? void 0 : r.in);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function KR(e, r) {
  const t = Xr(e, r == null ? void 0 : r.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function vy(e, r) {
  var o, d, a, V;
  const t = t2(), i = (r == null ? void 0 : r.weekStartsOn) ?? ((d = (o = r == null ? void 0 : r.locale) == null ? void 0 : o.options) == null ? void 0 : d.weekStartsOn) ?? t.weekStartsOn ?? ((V = (a = t.locale) == null ? void 0 : a.options) == null ? void 0 : V.weekStartsOn) ?? 0, n = Xr(e, r == null ? void 0 : r.in), s = n.getDay(), u = (s < i ? -7 : 0) + 6 - (s - i);
  return n.setDate(n.getDate() + u), n.setHours(23, 59, 59, 999), n;
}
function hR(e, r) {
  return vy(e, { ...r, weekStartsOn: 1 });
}
const BVe = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, WVe = (e, r, t) => {
  let i;
  const n = BVe[e];
  return typeof n == "string" ? i = n : r === 1 ? i = n.one : i = n.other.replace("{{count}}", r.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + i : i + " ago" : i;
};
function hh(e) {
  return (r = {}) => {
    const t = r.width ? String(r.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const GVe = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, UVe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, ZVe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, JVe = {
  date: hh({
    formats: GVe,
    defaultWidth: "full"
  }),
  time: hh({
    formats: UVe,
    defaultWidth: "full"
  }),
  dateTime: hh({
    formats: ZVe,
    defaultWidth: "full"
  })
}, $Ve = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, QVe = (e, r, t, i) => $Ve[e];
function sc(e) {
  return (r, t) => {
    const i = t != null && t.context ? String(t.context) : "standalone";
    let n;
    if (i === "formatting" && e.formattingValues) {
      const u = e.defaultFormattingWidth || e.defaultWidth, o = t != null && t.width ? String(t.width) : u;
      n = e.formattingValues[o] || e.formattingValues[u];
    } else {
      const u = e.defaultWidth, o = t != null && t.width ? String(t.width) : e.defaultWidth;
      n = e.values[o] || e.values[u];
    }
    const s = e.argumentCallback ? e.argumentCallback(r) : r;
    return n[s];
  };
}
const ele = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, rle = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, tle = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, ile = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, nle = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, sle = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ule = (e, r) => {
  const t = Number(e), i = t % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, ole = {
  ordinalNumber: ule,
  era: sc({
    values: ele,
    defaultWidth: "wide"
  }),
  quarter: sc({
    values: rle,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: sc({
    values: tle,
    defaultWidth: "wide"
  }),
  day: sc({
    values: ile,
    defaultWidth: "wide"
  }),
  dayPeriod: sc({
    values: nle,
    defaultWidth: "wide",
    formattingValues: sle,
    defaultFormattingWidth: "wide"
  })
};
function uc(e) {
  return (r, t = {}) => {
    const i = t.width, n = i && e.matchPatterns[i] || e.matchPatterns[e.defaultMatchWidth], s = r.match(n);
    if (!s)
      return null;
    const u = s[0], o = i && e.parsePatterns[i] || e.parsePatterns[e.defaultParseWidth], d = Array.isArray(o) ? ale(o, (c) => c.test(u)) : (
      // [TODO] -- I challenge you to fix the type
      dle(o, (c) => c.test(u))
    );
    let a;
    a = e.valueCallback ? e.valueCallback(d) : d, a = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(a)
    ) : a;
    const V = r.slice(u.length);
    return { value: a, rest: V };
  };
}
function dle(e, r) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && r(e[t]))
      return t;
}
function ale(e, r) {
  for (let t = 0; t < e.length; t++)
    if (r(e[t]))
      return t;
}
function Vle(e) {
  return (r, t = {}) => {
    const i = r.match(e.matchPattern);
    if (!i) return null;
    const n = i[0], s = r.match(e.parsePattern);
    if (!s) return null;
    let u = e.valueCallback ? e.valueCallback(s[0]) : s[0];
    u = t.valueCallback ? t.valueCallback(u) : u;
    const o = r.slice(n.length);
    return { value: u, rest: o };
  };
}
const lle = /^(\d+)(th|st|nd|rd)?/i, cle = /\d+/i, Fle = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, xle = {
  any: [/^b/i, /^(a|c)/i]
}, Xle = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, qle = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Yle = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, fle = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Kle = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, hle = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, ple = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, mle = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, gle = {
  ordinalNumber: Vle({
    matchPattern: lle,
    parsePattern: cle,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: uc({
    matchPatterns: Fle,
    defaultMatchWidth: "wide",
    parsePatterns: xle,
    defaultParseWidth: "any"
  }),
  quarter: uc({
    matchPatterns: Xle,
    defaultMatchWidth: "wide",
    parsePatterns: qle,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: uc({
    matchPatterns: Yle,
    defaultMatchWidth: "wide",
    parsePatterns: fle,
    defaultParseWidth: "any"
  }),
  day: uc({
    matchPatterns: Kle,
    defaultMatchWidth: "wide",
    parsePatterns: hle,
    defaultParseWidth: "any"
  }),
  dayPeriod: uc({
    matchPatterns: ple,
    defaultMatchWidth: "any",
    parsePatterns: mle,
    defaultParseWidth: "any"
  })
}, pR = {
  code: "en-US",
  formatDistance: WVe,
  formatLong: JVe,
  formatRelative: QVe,
  localize: ole,
  match: gle,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function vle(e, r) {
  const t = Xr(e, r == null ? void 0 : r.in);
  return Ps(t, KR(t)) + 1;
}
function mR(e, r) {
  const t = Xr(e, r == null ? void 0 : r.in), i = +jd(t) - +RVe(t);
  return Math.round(i / py) + 1;
}
function gR(e, r) {
  var V, c, F, X;
  const t = Xr(e, r == null ? void 0 : r.in), i = t.getFullYear(), n = t2(), s = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((c = (V = r == null ? void 0 : r.locale) == null ? void 0 : V.options) == null ? void 0 : c.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((X = (F = n.locale) == null ? void 0 : F.options) == null ? void 0 : X.firstWeekContainsDate) ?? 1, u = ct((r == null ? void 0 : r.in) || e, 0);
  u.setFullYear(i + 1, 0, s), u.setHours(0, 0, 0, 0);
  const o = ds(u, r), d = ct((r == null ? void 0 : r.in) || e, 0);
  d.setFullYear(i, 0, s), d.setHours(0, 0, 0, 0);
  const a = ds(d, r);
  return +t >= +o ? i + 1 : +t >= +a ? i : i - 1;
}
function ble(e, r) {
  var o, d, a, V;
  const t = t2(), i = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((d = (o = r == null ? void 0 : r.locale) == null ? void 0 : o.options) == null ? void 0 : d.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((V = (a = t.locale) == null ? void 0 : a.options) == null ? void 0 : V.firstWeekContainsDate) ?? 1, n = gR(e, r), s = ct((r == null ? void 0 : r.in) || e, 0);
  return s.setFullYear(n, 0, i), s.setHours(0, 0, 0, 0), ds(s, r);
}
function vR(e, r) {
  const t = Xr(e, r == null ? void 0 : r.in), i = +ds(t, r) - +ble(t, r);
  return Math.round(i / py) + 1;
}
function Fr(e, r) {
  const t = e < 0 ? "-" : "", i = Math.abs(e).toString().padStart(r, "0");
  return t + i;
}
const Vo = {
  // Year
  y(e, r) {
    const t = e.getFullYear(), i = t > 0 ? t : 1 - t;
    return Fr(r === "yy" ? i % 100 : i, r.length);
  },
  // Month
  M(e, r) {
    const t = e.getMonth();
    return r === "M" ? String(t + 1) : Fr(t + 1, 2);
  },
  // Day of the month
  d(e, r) {
    return Fr(e.getDate(), r.length);
  },
  // AM or PM
  a(e, r) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, r) {
    return Fr(e.getHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H(e, r) {
    return Fr(e.getHours(), r.length);
  },
  // Minute
  m(e, r) {
    return Fr(e.getMinutes(), r.length);
  },
  // Second
  s(e, r) {
    return Fr(e.getSeconds(), r.length);
  },
  // Fraction of second
  S(e, r) {
    const t = r.length, i = e.getMilliseconds(), n = Math.trunc(
      i * Math.pow(10, t - 3)
    );
    return Fr(n, r.length);
  }
}, Na = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Bw = {
  // Era
  G: function(e, r, t) {
    const i = e.getFullYear() > 0 ? 1 : 0;
    switch (r) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(i, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(i, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(i, { width: "wide" });
    }
  },
  // Year
  y: function(e, r, t) {
    if (r === "yo") {
      const i = e.getFullYear(), n = i > 0 ? i : 1 - i;
      return t.ordinalNumber(n, { unit: "year" });
    }
    return Vo.y(e, r);
  },
  // Local week-numbering year
  Y: function(e, r, t, i) {
    const n = gR(e, i), s = n > 0 ? n : 1 - n;
    if (r === "YY") {
      const u = s % 100;
      return Fr(u, 2);
    }
    return r === "Yo" ? t.ordinalNumber(s, { unit: "year" }) : Fr(s, r.length);
  },
  // ISO week-numbering year
  R: function(e, r) {
    const t = fR(e);
    return Fr(t, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, r) {
    const t = e.getFullYear();
    return Fr(t, r.length);
  },
  // Quarter
  Q: function(e, r, t) {
    const i = Math.ceil((e.getMonth() + 1) / 3);
    switch (r) {
      // 1, 2, 3, 4
      case "Q":
        return String(i);
      // 01, 02, 03, 04
      case "QQ":
        return Fr(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(i, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, r, t) {
    const i = Math.ceil((e.getMonth() + 1) / 3);
    switch (r) {
      // 1, 2, 3, 4
      case "q":
        return String(i);
      // 01, 02, 03, 04
      case "qq":
        return Fr(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(i, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, r, t) {
    const i = e.getMonth();
    switch (r) {
      case "M":
      case "MM":
        return Vo.M(e, r);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(i + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(i, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(i, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, r, t) {
    const i = e.getMonth();
    switch (r) {
      // 1, 2, ..., 12
      case "L":
        return String(i + 1);
      // 01, 02, ..., 12
      case "LL":
        return Fr(i + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(i + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(i, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(i, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, r, t, i) {
    const n = vR(e, i);
    return r === "wo" ? t.ordinalNumber(n, { unit: "week" }) : Fr(n, r.length);
  },
  // ISO week of year
  I: function(e, r, t) {
    const i = mR(e);
    return r === "Io" ? t.ordinalNumber(i, { unit: "week" }) : Fr(i, r.length);
  },
  // Day of the month
  d: function(e, r, t) {
    return r === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : Vo.d(e, r);
  },
  // Day of year
  D: function(e, r, t) {
    const i = vle(e);
    return r === "Do" ? t.ordinalNumber(i, { unit: "dayOfYear" }) : Fr(i, r.length);
  },
  // Day of week
  E: function(e, r, t) {
    const i = e.getDay();
    switch (r) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return t.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, r, t, i) {
    const n = e.getDay(), s = (n - i.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(s);
      // Padded numerical value
      case "ee":
        return Fr(s, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(s, { unit: "day" });
      case "eee":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, r, t, i) {
    const n = e.getDay(), s = (n - i.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      // Numerical value (same as in `e`)
      case "c":
        return String(s);
      // Padded numerical value
      case "cc":
        return Fr(s, r.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return t.day(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(n, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(n, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return t.day(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, r, t) {
    const i = e.getDay(), n = i === 0 ? 7 : i;
    switch (r) {
      // 2
      case "i":
        return String(n);
      // 02
      case "ii":
        return Fr(n, r.length);
      // 2nd
      case "io":
        return t.ordinalNumber(n, { unit: "day" });
      // Tue
      case "iii":
        return t.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return t.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, r, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return t.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, r, t) {
    const i = e.getHours();
    let n;
    switch (i === 12 ? n = Na.noon : i === 0 ? n = Na.midnight : n = i / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return t.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, r, t) {
    const i = e.getHours();
    let n;
    switch (i >= 17 ? n = Na.evening : i >= 12 ? n = Na.afternoon : i >= 4 ? n = Na.morning : n = Na.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, r, t) {
    if (r === "ho") {
      let i = e.getHours() % 12;
      return i === 0 && (i = 12), t.ordinalNumber(i, { unit: "hour" });
    }
    return Vo.h(e, r);
  },
  // Hour [0-23]
  H: function(e, r, t) {
    return r === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : Vo.H(e, r);
  },
  // Hour [0-11]
  K: function(e, r, t) {
    const i = e.getHours() % 12;
    return r === "Ko" ? t.ordinalNumber(i, { unit: "hour" }) : Fr(i, r.length);
  },
  // Hour [1-24]
  k: function(e, r, t) {
    let i = e.getHours();
    return i === 0 && (i = 24), r === "ko" ? t.ordinalNumber(i, { unit: "hour" }) : Fr(i, r.length);
  },
  // Minute
  m: function(e, r, t) {
    return r === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Vo.m(e, r);
  },
  // Second
  s: function(e, r, t) {
    return r === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : Vo.s(e, r);
  },
  // Fraction of second
  S: function(e, r) {
    return Vo.S(e, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, r, t) {
    const i = e.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (r) {
      // Hours and optional minutes
      case "X":
        return Gw(i);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return fd(i);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return fd(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, r, t) {
    const i = e.getTimezoneOffset();
    switch (r) {
      // Hours and optional minutes
      case "x":
        return Gw(i);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return fd(i);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return fd(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, r, t) {
    const i = e.getTimezoneOffset();
    switch (r) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ww(i, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + fd(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, r, t) {
    const i = e.getTimezoneOffset();
    switch (r) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ww(i, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + fd(i, ":");
    }
  },
  // Seconds timestamp
  t: function(e, r, t) {
    const i = Math.trunc(+e / 1e3);
    return Fr(i, r.length);
  },
  // Milliseconds timestamp
  T: function(e, r, t) {
    return Fr(+e, r.length);
  }
};
function Ww(e, r = "") {
  const t = e > 0 ? "-" : "+", i = Math.abs(e), n = Math.trunc(i / 60), s = i % 60;
  return s === 0 ? t + String(n) : t + String(n) + r + Fr(s, 2);
}
function Gw(e, r) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Fr(Math.abs(e) / 60, 2) : fd(e, r);
}
function fd(e, r = "") {
  const t = e > 0 ? "-" : "+", i = Math.abs(e), n = Fr(Math.trunc(i / 60), 2), s = Fr(i % 60, 2);
  return t + n + r + s;
}
const Uw = (e, r) => {
  switch (e) {
    case "P":
      return r.date({ width: "short" });
    case "PP":
      return r.date({ width: "medium" });
    case "PPP":
      return r.date({ width: "long" });
    case "PPPP":
    default:
      return r.date({ width: "full" });
  }
}, bR = (e, r) => {
  switch (e) {
    case "p":
      return r.time({ width: "short" });
    case "pp":
      return r.time({ width: "medium" });
    case "ppp":
      return r.time({ width: "long" });
    case "pppp":
    default:
      return r.time({ width: "full" });
  }
}, yle = (e, r) => {
  const t = e.match(/(P+)(p+)?/) || [], i = t[1], n = t[2];
  if (!n)
    return Uw(e, r);
  let s;
  switch (i) {
    case "P":
      s = r.dateTime({ width: "short" });
      break;
    case "PP":
      s = r.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = r.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      s = r.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", Uw(i, r)).replace("{{time}}", bR(n, r));
}, Ale = {
  p: bR,
  P: yle
}, wle = /^D+$/, Cle = /^Y+$/, Ple = ["D", "DD", "YY", "YYYY"];
function Sle(e) {
  return wle.test(e);
}
function Nle(e) {
  return Cle.test(e);
}
function Mle(e, r, t) {
  const i = Tle(e, r, t);
  if (console.warn(i), Ple.includes(e)) throw new RangeError(i);
}
function Tle(e, r, t) {
  const i = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${r}\`) for formatting ${i} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Ele = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, kle = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ole = /^'([^]*?)'?$/, Dle = /''/g, Rle = /[a-zA-Z]/;
function ut(e, r, t) {
  var V, c, F, X, Y, q, f, p;
  const i = t2(), n = (t == null ? void 0 : t.locale) ?? i.locale ?? pR, s = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (V = t == null ? void 0 : t.locale) == null ? void 0 : V.options) == null ? void 0 : c.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((X = (F = i.locale) == null ? void 0 : F.options) == null ? void 0 : X.firstWeekContainsDate) ?? 1, u = (t == null ? void 0 : t.weekStartsOn) ?? ((q = (Y = t == null ? void 0 : t.locale) == null ? void 0 : Y.options) == null ? void 0 : q.weekStartsOn) ?? i.weekStartsOn ?? ((p = (f = i.locale) == null ? void 0 : f.options) == null ? void 0 : p.weekStartsOn) ?? 0, o = Xr(e, t == null ? void 0 : t.in);
  if (!jVe(o))
    throw new RangeError("Invalid time value");
  let d = r.match(kle).map((m) => {
    const g = m[0];
    if (g === "p" || g === "P") {
      const y = Ale[g];
      return y(m, n.formatLong);
    }
    return m;
  }).join("").match(Ele).map((m) => {
    if (m === "''")
      return { isToken: !1, value: "'" };
    const g = m[0];
    if (g === "'")
      return { isToken: !1, value: Ile(m) };
    if (Bw[g])
      return { isToken: !0, value: m };
    if (g.match(Rle))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + g + "`"
      );
    return { isToken: !1, value: m };
  });
  n.localize.preprocessor && (d = n.localize.preprocessor(o, d));
  const a = {
    firstWeekContainsDate: s,
    weekStartsOn: u,
    locale: n
  };
  return d.map((m) => {
    if (!m.isToken) return m.value;
    const g = m.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && Nle(g) || !(t != null && t.useAdditionalDayOfYearTokens) && Sle(g)) && Mle(g, r, String(e));
    const y = Bw[g[0]];
    return y(o, g, n.localize, a);
  }).join("");
}
function Ile(e) {
  const r = e.match(Ole);
  return r ? r[1].replace(Dle, "'") : e;
}
function Ec(e, r) {
  const t = Xr(e, r == null ? void 0 : r.in);
  if (isNaN(+t))
    throw new RangeError("Invalid time value");
  let i = "", n = "";
  const s = "-", u = ":";
  {
    const o = Fr(t.getDate(), 2), d = Fr(t.getMonth() + 1, 2);
    i = `${Fr(t.getFullYear(), 4)}${s}${d}${s}${o}`;
  }
  {
    const o = t.getTimezoneOffset();
    if (o !== 0) {
      const X = Math.abs(o), Y = Fr(Math.trunc(X / 60), 2), q = Fr(X % 60, 2);
      n = `${o < 0 ? "+" : "-"}${Y}:${q}`;
    } else
      n = "Z";
    const d = Fr(t.getHours(), 2), a = Fr(t.getMinutes(), 2), V = Fr(t.getSeconds(), 2), c = i === "" ? "" : "T", F = [d, a, V].join(u);
    i = `${i}${c}${F}${n}`;
  }
  return i;
}
function Lle(e, r) {
  const t = Xr(e, r == null ? void 0 : r.in), i = t.getFullYear(), n = t.getMonth(), s = ct(t, 0);
  return s.setFullYear(i, n + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function _le(e) {
  return Math.trunc(+Xr(e) / 1e3);
}
function Hle(e, r) {
  const t = Xr(e, r == null ? void 0 : r.in), i = t.getMonth();
  return t.setFullYear(t.getFullYear(), i + 1, 0), t.setHours(0, 0, 0, 0), Xr(t, r == null ? void 0 : r.in);
}
function jle(e, r) {
  const t = Xr(e, r == null ? void 0 : r.in);
  return zVe(
    Hle(t, r),
    ji(t, r),
    r
  ) + 1;
}
function Vv(e, r) {
  return +Xr(e) > +Xr(r);
}
function yR(e, r) {
  return +Xr(e) < +Xr(r);
}
function by(e, r, t) {
  const [i, n] = ql(
    t == null ? void 0 : t.in,
    e,
    r
  );
  return i.getFullYear() === n.getFullYear() && i.getMonth() === n.getMonth();
}
function zle(e, r, t) {
  const [i, n] = ql(
    t == null ? void 0 : t.in,
    e,
    r
  );
  return i.getFullYear() === n.getFullYear();
}
function Ble(e, r) {
  return Ai(
    ct(e, e),
    HVe(e)
  );
}
function ph(e, r, t) {
  return Xt(e, -r, t);
}
function Ss(e, r) {
  const t = () => ct(r == null ? void 0 : r.in, NaN), n = Zle(e);
  let s;
  if (n.date) {
    const a = Jle(n.date, 2);
    s = $le(a.restDateString, a.year);
  }
  if (!s || isNaN(+s)) return t();
  const u = +s;
  let o = 0, d;
  if (n.time && (o = Qle(n.time), isNaN(o)))
    return t();
  if (n.timezone) {
    if (d = ece(n.timezone), isNaN(d)) return t();
  } else {
    const a = new Date(u + o), V = Xr(0, r == null ? void 0 : r.in);
    return V.setFullYear(
      a.getUTCFullYear(),
      a.getUTCMonth(),
      a.getUTCDate()
    ), V.setHours(
      a.getUTCHours(),
      a.getUTCMinutes(),
      a.getUTCSeconds(),
      a.getUTCMilliseconds()
    ), V;
  }
  return Xr(u + o + d, r == null ? void 0 : r.in);
}
const PF = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Wle = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Gle = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, Ule = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Zle(e) {
  const r = {}, t = e.split(PF.dateTimeDelimiter);
  let i;
  if (t.length > 2)
    return r;
  if (/:/.test(t[0]) ? i = t[0] : (r.date = t[0], i = t[1], PF.timeZoneDelimiter.test(r.date) && (r.date = e.split(PF.timeZoneDelimiter)[0], i = e.substr(
    r.date.length,
    e.length
  ))), i) {
    const n = PF.timezone.exec(i);
    n ? (r.time = i.replace(n[1], ""), r.timezone = n[1]) : r.time = i;
  }
  return r;
}
function Jle(e, r) {
  const t = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + r) + "})|(\\d{2}|[+-]\\d{" + (2 + r) + "})$)"
  ), i = e.match(t);
  if (!i) return { year: NaN, restDateString: "" };
  const n = i[1] ? parseInt(i[1]) : null, s = i[2] ? parseInt(i[2]) : null;
  return {
    year: s === null ? n : s * 100,
    restDateString: e.slice((i[1] || i[2]).length)
  };
}
function $le(e, r) {
  if (r === null) return /* @__PURE__ */ new Date(NaN);
  const t = e.match(Wle);
  if (!t) return /* @__PURE__ */ new Date(NaN);
  const i = !!t[4], n = oc(t[1]), s = oc(t[2]) - 1, u = oc(t[3]), o = oc(t[4]), d = oc(t[5]) - 1;
  if (i)
    return sce(r, o, d) ? rce(r, o, d) : /* @__PURE__ */ new Date(NaN);
  {
    const a = /* @__PURE__ */ new Date(0);
    return !ice(r, s, u) || !nce(r, n) ? /* @__PURE__ */ new Date(NaN) : (a.setUTCFullYear(r, s, Math.max(n, u)), a);
  }
}
function oc(e) {
  return e ? parseInt(e) : 1;
}
function Qle(e) {
  const r = e.match(Gle);
  if (!r) return NaN;
  const t = mh(r[1]), i = mh(r[2]), n = mh(r[3]);
  return uce(t, i, n) ? t * YR + i * qR + n * 1e3 : NaN;
}
function mh(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function ece(e) {
  if (e === "Z") return 0;
  const r = e.match(Ule);
  if (!r) return 0;
  const t = r[1] === "+" ? -1 : 1, i = parseInt(r[2]), n = r[3] && parseInt(r[3]) || 0;
  return oce(i, n) ? t * (i * YR + n * qR) : NaN;
}
function rce(e, r, t) {
  const i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(e, 0, 4);
  const n = i.getUTCDay() || 7, s = (r - 1) * 7 + t + 1 - n;
  return i.setUTCDate(i.getUTCDate() + s), i;
}
const tce = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function AR(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function ice(e, r, t) {
  return r >= 0 && r <= 11 && t >= 1 && t <= (tce[r] || (AR(e) ? 29 : 28));
}
function nce(e, r) {
  return r >= 1 && r <= (AR(e) ? 366 : 365);
}
function sce(e, r, t) {
  return r >= 1 && r <= 53 && t >= 0 && t <= 6;
}
function uce(e, r, t) {
  return e === 24 ? r === 0 && t === 0 : t >= 0 && t < 60 && r >= 0 && r < 60 && e >= 0 && e < 25;
}
function oce(e, r) {
  return r >= 0 && r <= 59;
}
function Mx(e, r, t) {
  const i = Xr(e, t == null ? void 0 : t.in), n = i.getFullYear(), s = i.getDate(), u = ct(e, 0);
  u.setFullYear(n, r, 15), u.setHours(0, 0, 0, 0);
  const o = Lle(u);
  return i.setMonth(r, Math.min(s, o)), i;
}
function dce(e, r, t) {
  let i = Xr(e, t == null ? void 0 : t.in);
  return isNaN(+i) ? ct(e, NaN) : (r.year != null && i.setFullYear(r.year), r.month != null && (i = Mx(i, r.month)), r.date != null && i.setDate(r.date), r.hours != null && i.setHours(r.hours), r.minutes != null && i.setMinutes(r.minutes), r.seconds != null && i.setSeconds(r.seconds), r.milliseconds != null && i.setMilliseconds(r.milliseconds), i);
}
function Zw(e, r, t) {
  const i = Xr(e, t == null ? void 0 : t.in);
  return isNaN(+i) ? ct(e, NaN) : (i.setFullYear(r), i);
}
function ace({
  onChangeSelectedRevisionId: e,
  revisions: r,
  selectedRevisionId: t
}) {
  const i = $e(() => r.map((n) => ({
    id: n.id,
    content: n.revised_by,
    icon: "",
    title: /* @__PURE__ */ C("div", { className: "flex gap-2 whitespace-nowrap", children: [
      n.created_at ? ut(n.created_at, "dd-MM-yyyy HH:mm") : "",
      /* @__PURE__ */ l(Cye, { className: "text-bodyxs", children: n.revision_type })
    ] })
  })), [r]);
  return /* @__PURE__ */ l(
    Pye,
    {
      itemClassName: "px-2 pt-2",
      items: i,
      onClick: e,
      selectedId: t
    }
  );
}
function Vce({
  onOpenChange: e,
  open: r,
  revisions: t,
  subTitle: i,
  title: n
}) {
  const [s, u] = ie(
    null
  ), o = $e(() => t.find((d) => d.id === s), [t, s]);
  return Pe(() => {
    t.length > 0 && !s && t[0].id && u(t[0].id);
  }, [t, s]), /* @__PURE__ */ l(vY, { open: r, onOpenChange: e, children: /* @__PURE__ */ C(
    q2,
    {
      "aria-describedby": void 0,
      className: "flex h-full max-h-[90%] w-full flex-col gap-6 md:w-[80%] md:max-w-[80%] 2xl:max-w-[1280px]",
      disableAnimation: !0,
      onKeyDown: (d) => {
        console.log("onKeyDown", d.key), d.key === "ArrowUp" ? (d.preventDefault(), u((a) => {
          const V = t.findIndex((c) => c.id === a);
          return V > 0 ? t[V - 1].id : a;
        })) : d.key === "ArrowDown" && (d.preventDefault(), u((a) => {
          const V = t.findIndex((c) => c.id === a);
          return V < t.length - 1 ? t[V + 1].id : a;
        }));
      },
      children: [
        /* @__PURE__ */ C("div", { className: "flex flex-col gap-1", children: [
          /* @__PURE__ */ l(yY, { children: n }),
          i || null
        ] }),
        /* @__PURE__ */ C("div", { className: "flex h-full gap-2 overflow-hidden", children: [
          /* @__PURE__ */ l(
            ace,
            {
              onChangeSelectedRevisionId: u,
              revisions: t || [],
              selectedRevisionId: s
            }
          ),
          /* @__PURE__ */ l("div", { className: "border-interfaceBorder h-full overflow-auto rounded border p-2", children: We((o == null ? void 0 : o.raw_output) || "") })
        ] }),
        /* @__PURE__ */ l(bY, { children: /* @__PURE__ */ l(er, { onClick: () => e(!1), children: "Close" }) })
      ]
    }
  ) });
}
function wR({
  children: e,
  expertName: r,
  noticeboardData: t,
  subTitle: i,
  title: n
}) {
  const [s, u] = ie(!1), o = $e(() => {
    var d, a;
    return (d = t == null ? void 0 : t[r]) != null && d.revisions ? (a = t == null ? void 0 : t[r]) == null ? void 0 : a.revisions : [];
  }, [r, t]);
  return /* @__PURE__ */ C(he, { children: [
    e({ setOpen: u }),
    /* @__PURE__ */ l(
      Vce,
      {
        onOpenChange: u,
        open: s,
        revisions: o,
        subTitle: i,
        title: n
      }
    )
  ] });
}
function Ls({
  allowEditing: e,
  children: r,
  conversation: t,
  expertName: i,
  noticeboardData: n,
  outputKey: s
}) {
  const { hasRevisions: u } = uR({ expertName: i, noticeboardData: n });
  return e ? /* @__PURE__ */ C("div", { className: "relative my-1 p-1", children: [
    /* @__PURE__ */ C("div", { className: "bg-blueBorder absolute right-0 top-[-25px] flex items-center gap-2 rounded-sm p-1", children: [
      u && /* @__PURE__ */ l("div", { title: "This section has revisions", children: /* @__PURE__ */ l(MVe, { className: "h-4 w-4 text-orange-500" }) }),
      /* @__PURE__ */ C("span", { className: "text-bodyxs text-textPrimary font-semibold", children: [
        i,
        s && ` --> ${s}`
      ] }),
      /* @__PURE__ */ l(
        XR,
        {
          conversation: t,
          expertName: i,
          noticeboardData: n,
          outputKey: s,
          subTitle: /* @__PURE__ */ C("p", { className: "text-bodysm font-semibold", children: [
            "Expert:",
            " ",
            /* @__PURE__ */ C("span", { className: "text-textSubdued", children: [
              i,
              s && ` --> ${s}`
            ] })
          ] }),
          title: "Amend expert result",
          children: ({ setOpen: o }) => /* @__PURE__ */ l(
            er,
            {
              className: "text-bodyxs px-1",
              onClick: () => o(!0),
              size: "tight",
              variant: "outline",
              children: "Amend"
            }
          )
        }
      ),
      u ? /* @__PURE__ */ l(
        wR,
        {
          expertName: i,
          noticeboardData: n,
          subTitle: /* @__PURE__ */ C("p", { className: "text-bodysm font-semibold", children: [
            "Expert:",
            " ",
            /* @__PURE__ */ C("span", { className: "text-textSubdued", children: [
              i,
              s && ` --> ${s}`
            ] })
          ] }),
          title: "Expert result revisions",
          children: ({ setOpen: o }) => /* @__PURE__ */ l(
            er,
            {
              className: "text-bodyxs px-1",
              onClick: () => o(!0),
              size: "tight",
              variant: "outline",
              children: "Revisions"
            }
          )
        }
      ) : null
    ] }),
    /* @__PURE__ */ l("div", { className: "border-blueBorder rounded-xs pointer-events-none absolute inset-0 border border-dashed" }),
    r
  ] }) : /* @__PURE__ */ l(he, { children: r });
}
const Ma = {
  DEFAULT: "default",
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  DANGER: "danger"
};
function dc(e) {
  const r = new CustomEvent(e);
  document.dispatchEvent(r);
}
function Rq({
  children: e,
  className: r,
  title: t,
  translate: i,
  type: n = Ma.DEFAULT
}) {
  return /* @__PURE__ */ C(
    "div",
    {
      className: _(
        "text-textPrimary text-bodymd flex flex-col gap-1 rounded border-l-4 px-5 py-4",
        {
          "bg-interfaceBgDefault border-interfaceBorder": n === Ma.DEFAULT
        },
        {
          "bg-greenBgLight border-greenDefault": n === Ma.SUCCESS
        },
        {
          "bg-blueBgLight border-blueDefault": n === Ma.INFO
        },
        {
          "bg-yellowBgLight border-yellowDefault": n === Ma.WARNING
        },
        {
          "bg-redBgLight border-redDefault": n === Ma.DANGER
        },
        r
      ),
      children: [
        /* @__PURE__ */ l("h3", { className: "text-headingmd", children: t }),
        typeof e == "string" ? /* @__PURE__ */ l("div", { children: /* @__PURE__ */ l(
          Lae,
          {
            template: e,
            renderFunctions: {
              navigate_permit_requirements: () => /* @__PURE__ */ l(
                "a",
                {
                  className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                  onClick: () => {
                    dc(
                      nc.SHOW_PERMIT_REQUIREMENTS
                    );
                  },
                  children: i == null ? void 0 : i.getText("permit requirements")
                }
              ),
              navigate_application_requirements: () => /* @__PURE__ */ l(
                "a",
                {
                  className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                  onClick: () => {
                    dc(
                      nc.SHOW_APPLICATION_REQUIREMENTS
                    );
                  },
                  children: i == null ? void 0 : i.getText("application requirements")
                }
              ),
              navigate_lot_and_proposal: () => /* @__PURE__ */ l(
                "a",
                {
                  className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                  onClick: () => {
                    dc(
                      nc.SHOW_LOT_AND_PROPOSAL
                    );
                  },
                  children: i == null ? void 0 : i.getText("lot and proposal")
                }
              ),
              navigate_next_steps: () => /* @__PURE__ */ l(
                "a",
                {
                  className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                  onClick: () => {
                    dc(nc.SHOW_NEXT_STEPS);
                  },
                  children: i == null ? void 0 : i.getText("next steps")
                }
              ),
              restart_conversation: () => /* @__PURE__ */ l(
                "a",
                {
                  className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                  onClick: () => {
                    dc(
                      nc.RESTART_CONVERSATION
                    );
                  },
                  children: i == null ? void 0 : i.getText("restart")
                }
              )
            }
          }
        ) }) : e
      ]
    }
  );
}
function lce({
  conversation: e,
  translate: r
}) {
  const i = hy({
    messages: (e == null ? void 0 : e.messages) || [],
    messageType: Q7.ROUTING_QUESTION
  }).at(0);
  if (!i) return;
  const n = i.question_data || {};
  if ("application_requirements_callouts" in n && Array.isArray(n.application_requirements_callouts))
    return n.application_requirements_callouts.map(
      (s) => /* @__PURE__ */ l(
        Rq,
        {
          title: s.title,
          translate: r,
          type: s.color,
          children: s.content
        },
        i.id
      )
    );
}
function cce(e, r, t) {
  var u, o;
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), { content: n, parsedOutput: s = {} } = i(
    `${t}.vic_smart_eligibility`
  );
  return "<1>" in s && ((u = s["<1>"]) == null ? void 0 : u.toLowerCase()) !== "n/a" ? "eligible" : "<2>" in s && ((o = s["<2>"]) == null ? void 0 : o.toLowerCase()) !== "n/a" ? "ineligible" : parseInt(n) === 1 ? "eligible" : parseInt(n) === 2 ? "ineligible" : "unknown";
}
function Fce(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), { content: n } = i(
    `${t}.missing_information`
  );
  return n;
}
function xce(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), {
    expert_name: n = "",
    output_key: s = "",
    content: u
  } = i(`${t}.application_requirements`);
  return { expert_name: n, output_key: s, applicationRequirementsText: u };
}
function Xce(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), {
    expert_name: n = "",
    output_key: s = "",
    content: u
  } = i(`${t}.report_abstract`);
  return { expert_name: n, output_key: s, reportAbstractText: u };
}
function qce(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), {
    expert_name: n = "",
    output_key: s = "",
    content: u
  } = i(`${t}.report_heading`);
  return { expert_name: n, output_key: s, reportHeadingText: u };
}
function CR(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), {
    expert_name: n = "",
    output_key: s = "",
    content: u
  } = i(`${t}.mandatory_requirements`);
  return { expert_name: n, output_key: s, mandatoryRequirementsText: u };
}
function Yce(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), { parsedOutput: n = {} } = i(
    `${t}.show_mandatory_requirements`
  );
  return "<1>" in n ? !0 : !!("eligibility_status" in n && ["ELIGIBLE", "ELIGIBLE_MISSING_INFO", "ELIGIBLE_EXCEEDED"].includes(
    n.eligibility_status
  ));
}
function fce(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), { parsedOutput: n = {} } = i(
    `${t}.design_and_sitting_clause`
  );
  return n.rescode;
}
function fQe(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), { content: n } = i(`${t}.features_in_testing`);
  return n;
}
function Jw({
  allowEditing: e,
  configPrefix: r,
  conversation: t,
  noticeboardData: i
}) {
  const { getLocalisationEntry: n } = si(t), s = n("councilOrdinanceLink"), u = (V) => We(V, {
    components: {
      h1({ children: c }) {
        return /* @__PURE__ */ l("h5", { className: "text-bodymd font-bold", children: c });
      },
      h2({ children: c }) {
        return /* @__PURE__ */ l("h5", { className: "text-bodymd font-bold", children: c });
      },
      h3({ children: c }) {
        return /* @__PURE__ */ l("h5", { className: "text-bodymd font-bold", children: c });
      },
      h4({ children: c }) {
        return /* @__PURE__ */ l("h5", { className: "text-bodymd font-bold", children: c });
      }
    },
    ordinanceLink: s
  }), { expert_name: o, output_key: d, applicationRequirementsText: a } = xce(t, i, r);
  return /* @__PURE__ */ l(
    Ls,
    {
      allowEditing: e,
      expertName: o,
      conversation: t,
      noticeboardData: i,
      outputKey: d,
      children: u(a)
    }
  );
}
function $w({
  allowEditing: e,
  configPrefix: r,
  conversation: t,
  isVicSmartStandardApplicationRequirementsEnabled: i,
  messages: n,
  noticeboardData: s,
  printable: u,
  translate: o = Dn
}) {
  var E, I;
  const { getConfig: d } = Ur({
    conversation: t,
    noticeboardData: s
  }), {
    expert_name: a = "",
    output_key: V,
    content: c
  } = d(`${r}.vic_smart`), { content: F } = d(
    `${r}.vic_smart_application_requirements`
  ), { content: X } = d(
    `${r}.application_requirements`
  ), q = cce(
    t,
    s,
    r
  ) === bV.eligible, { getLocalisationEntry: f } = si(t), p = f("councilOrdinanceLink"), m = f("councilContactLink"), g = f(
    "councilApplicationGuideLink"
  ), y = yae(t, s), b = !!y && y !== Aae["n/a"] && ((I = (E = t == null ? void 0 : t.address_data) == null ? void 0 : E.state) == null ? void 0 : I.toUpperCase()) === "VIC", A = (R) => We(R, {
    components: {
      h1({ children: H }) {
        return /* @__PURE__ */ l("h5", { className: "text-bodymd font-bold", children: H });
      },
      h2({ children: H }) {
        return /* @__PURE__ */ l("h5", { className: "text-bodymd font-bold", children: H });
      },
      h3({ children: H }) {
        return /* @__PURE__ */ l("h5", { className: "text-bodymd font-bold", children: H });
      },
      h4({ children: H }) {
        return /* @__PURE__ */ l("h5", { className: "text-bodymd font-bold", children: H });
      }
    },
    ordinanceLink: p
  }), w = () => /* @__PURE__ */ C(he, { children: [
    /* @__PURE__ */ l("p", { children: o.getText(
      "When you apply for a planning permit through the standard pathway, what you need to provide will depend on your proposal, and the overlays and zone that apply to the property."
    ) }),
    /* @__PURE__ */ C(
      "a",
      {
        className: "text-textLink hover:text-textLinkHover flex cursor-pointer items-center gap-1 underline",
        href: g,
        rel: "noreferrer",
        tabIndex: 0,
        target: "_blank",
        children: [
          o.getText("Read our application guide"),
          " ",
          /* @__PURE__ */ l(M_e, {})
        ]
      }
    )
  ] }), S = () => {
    var R;
    return /* @__PURE__ */ C(he, { children: [
      /* @__PURE__ */ l("p", { children: o.interpolate(
        "{{contactLink}} to speak to one of our planners and discuss your standard application requirements. When you contact us, tell us your session ID:",
        {
          contactLink: /* @__PURE__ */ l(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: m,
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: o.getText("Contact Council")
            }
          )
        }
      ) }),
      /* @__PURE__ */ l("span", { className: "text-bodylg border-interactiveBorder w-min rounded border px-2 py-1.5 font-medium tracking-[2.7px] whitespace-nowrap", children: ((R = t == null ? void 0 : t.identifier) == null ? void 0 : R.toUpperCase()) || "" })
    ] });
  }, N = () => X ? A(X) : /* @__PURE__ */ C("p", { className: "text-textPrimary text-bodylg flex items-center gap-1", children: [
    /* @__PURE__ */ l(Zs, { className: "animate-spin" }),
    " Generating..."
  ] }), O = () => /* @__PURE__ */ C("div", { className: "text-textPrimary", children: [
    /* @__PURE__ */ l("h3", { className: "text-headingmd", children: o == null ? void 0 : o.getText("☝️Check with a licensed land surveyor") }),
    /* @__PURE__ */ l("div", { className: "text-bodymd", children: o == null ? void 0 : o.getText(
      "Some types of subdivision can be applied for through VicSmart, such as:"
    ) }),
    /* @__PURE__ */ C("ul", { className: "text-bodymd mt-1 list-inside list-disc pl-4", children: [
      /* @__PURE__ */ l("li", { children: o == null ? void 0 : o.getText("realigning a common boundary") }),
      /* @__PURE__ */ l("li", { children: o == null ? void 0 : o.getText("subdividing buildings and car parking spaces") }),
      /* @__PURE__ */ l("li", { children: o == null ? void 0 : o.getText("some 2-lot subdivisions in rural areas") }),
      /* @__PURE__ */ l("li", { children: o == null ? void 0 : o.getText(
        "compliant 2-lot subdivisions in residential areas"
      ) })
    ] }),
    /* @__PURE__ */ l("div", { className: "text-bodymd mt-2", children: o == null ? void 0 : o.getText(
      "A licensed land surveyor can help you determine if your subdivision is eligible."
    ) })
  ] });
  return /* @__PURE__ */ C("div", { className: "flex flex-col gap-5", children: [
    /* @__PURE__ */ C("div", { className: "flex flex-col gap-0.5", children: [
      /* @__PURE__ */ l("h2", { className: "text-headingxl text-textPrimary", children: o.getText("VicSmart eligibility") }),
      /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: o.getText(
        "VicSmart is a streamlined planning permit process for straightforward applications."
      ) })
    ] }),
    b ? O() : /* @__PURE__ */ l("div", { className: "flex flex-col gap-2", children: /* @__PURE__ */ l(
      Ls,
      {
        allowEditing: e,
        expertName: a,
        conversation: t,
        noticeboardData: s,
        outputKey: V,
        children: A(c)
      }
    ) }),
    /* @__PURE__ */ l(Qd, { orientation: "horizontal" }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h2", { className: "text-headingxl text-textPrimary", children: o.getText("Application checklist") }),
      /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: o.getText(
        "What information you'll need to provide when you apply for a planning permit."
      ) })
    ] }),
    q && /* @__PURE__ */ C("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ l(
        _s,
        {
          collapsible: !0,
          defaultValue: u ? "vicsmart" : void 0,
          type: "single",
          children: /* @__PURE__ */ C(as, { value: "vicsmart", children: [
            /* @__PURE__ */ l(Vs, { className: "cursor-pointer !py-0", children: /* @__PURE__ */ C("div", { className: "flex flex-col gap-1 text-left", children: [
              /* @__PURE__ */ l("h3", { className: "text-headingmd text-textPrimary", children: o.getText("VicSmart requirements") }),
              /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: o.getText(
                "Refer to this checklist if you meet the VicSmart eligibility criteria."
              ) })
            ] }) }),
            /* @__PURE__ */ l(ls, { className: "mt-3", children: A(F) })
          ] })
        }
      ),
      /* @__PURE__ */ l(Qd, { orientation: "horizontal", className: "my-2" }),
      /* @__PURE__ */ l(
        _s,
        {
          collapsible: !0,
          defaultValue: u ? "standard" : void 0,
          type: "single",
          children: /* @__PURE__ */ C(as, { value: "standard", children: [
            /* @__PURE__ */ l(Vs, { className: "cursor-pointer !py-0", children: /* @__PURE__ */ C("div", { className: "flex flex-col gap-1 text-left", children: [
              /* @__PURE__ */ l("h3", { className: "text-headingmd text-textPrimary", children: o.getText("Standard requirements") }),
              /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: o.getText(
                "If you're ineligible for VicSmart, refer to this checklist."
              ) })
            ] }) }),
            /* @__PURE__ */ C(ls, { className: "text-bodymd text-textPrimary mt-3 flex flex-col gap-3", children: [
              i && N(),
              !i && g && w(),
              !i && !g && S()
            ] })
          ] })
        }
      )
    ] }),
    i && !q && N(),
    !i && !q && g && w(),
    !i && !q && !g && S()
  ] });
}
function KQe({
  allowEditing: e,
  configPrefix: r,
  conversation: t,
  messages: i,
  noticeboardData: n,
  printable: s,
  translate: u = Dn,
  showVicSmart: o,
  isVicSmartStandardApplicationRequirementsEnabled: d
}) {
  const { getLocalisationEntry: a } = si(t), V = a("councilOrdinanceLink"), c = ua(
    t,
    n,
    r
  ), F = c && c !== Te.Prohibited, { getConfig: X } = Ur({
    conversation: t,
    noticeboardData: n
  }), Y = (f) => We(f, {
    components: {
      h1({ children: p }) {
        return /* @__PURE__ */ l("h5", { className: "text-bodymd font-bold", children: p });
      },
      h2({ children: p }) {
        return /* @__PURE__ */ l("h5", { className: "text-bodymd font-bold", children: p });
      },
      h3({ children: p }) {
        return /* @__PURE__ */ l("h5", { className: "text-bodymd font-bold", children: p });
      },
      h4({ children: p }) {
        return /* @__PURE__ */ l("h5", { className: "text-bodymd font-bold", children: p });
      }
    },
    ordinanceLink: V
  }), q = () => {
    const {
      expert_name: f = "",
      output_key: p,
      content: m
    } = X(`${r}.vic_smart`);
    switch (c) {
      case Te.NoPermitRequired: {
        const g = a(
          "councilBuildingPermitLink"
        );
        return /* @__PURE__ */ C("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ l("h2", { className: "text-headingxl text-textPrimary", children: u.getText(
            "No application requirements are relevant to your proposal"
          ) }),
          /* @__PURE__ */ l("p", { className: "text-bodylg text-textPrimary mb-1", children: u.getText(
            "Your proposal likely doesn't require a planning permit, so no application requirements have been generated."
          ) }),
          /* @__PURE__ */ l("p", { className: "text-bodylg text-textPrimary", children: u.getText(
            "However, you may still require other permits, such as a building permit. Building permits are issued separately from planning permits and are required to ensure construction work complies with national building regulations."
          ) }),
          g && /* @__PURE__ */ C(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover flex cursor-pointer items-center gap-1 underline",
              href: g,
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: [
                u.getText("Check if you need a building permit"),
                " ",
                /* @__PURE__ */ l(CVe, { className: "h-4 w-4" })
              ]
            }
          )
        ] });
      }
      case Te.MoreInformationRequired:
        return o ? /* @__PURE__ */ l(
          $w,
          {
            allowEditing: e,
            configPrefix: r,
            conversation: t,
            isVicSmartStandardApplicationRequirementsEnabled: d,
            messages: i,
            noticeboardData: n,
            printable: s,
            translate: u
          }
        ) : /* @__PURE__ */ C("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ l("h2", { className: "text-headingxl text-textPrimary", children: u.getText(
            "You need to apply through the standard pathway"
          ) }),
          /* @__PURE__ */ l(
            Ls,
            {
              allowEditing: e,
              expertName: f,
              conversation: t,
              noticeboardData: n,
              outputKey: p,
              children: /* @__PURE__ */ l(
                yr,
                {
                  className: "mt-2",
                  ...s && { maxHeight: 99999 },
                  translate: u,
                  children: Y(m)
                }
              )
            }
          ),
          /* @__PURE__ */ l("div", { className: _("my-2 w-full border-b md:my-2.5") }),
          /* @__PURE__ */ C("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ l("h3", { className: "text-headinglg text-textPrimary", children: u.getText(
              "What you'll need to provide when you apply"
            ) }),
            /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: u.getText(
              "This list should be used as a guide only. Always speak to a Council planner before preparing a planning permit application."
            ) })
          ] }),
          /* @__PURE__ */ l(
            Jw,
            {
              allowEditing: e,
              configPrefix: r,
              conversation: t,
              noticeboardData: n
            }
          )
        ] });
      case Te.RequiresPermit:
        return o ? /* @__PURE__ */ l(
          $w,
          {
            allowEditing: e,
            configPrefix: r,
            conversation: t,
            isVicSmartStandardApplicationRequirementsEnabled: d,
            messages: i,
            noticeboardData: n,
            printable: s,
            translate: u
          }
        ) : /* @__PURE__ */ C("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ l("h2", { className: "text-headingxl text-textPrimary", children: u.getText(
            "You need to apply through the standard pathway"
          ) }),
          /* @__PURE__ */ l(
            Ls,
            {
              allowEditing: e,
              expertName: f,
              conversation: t,
              noticeboardData: n,
              outputKey: p,
              children: /* @__PURE__ */ l(
                yr,
                {
                  className: "mt-2",
                  ...s && { maxHeight: 99999 },
                  translate: u,
                  children: Y(m)
                }
              )
            }
          ),
          /* @__PURE__ */ l("div", { className: _("my-2 w-full border-b md:my-2.5") }),
          /* @__PURE__ */ C("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ l("h3", { className: "text-headinglg text-textPrimary", children: u.getText(
              "What you'll need to provide when you apply"
            ) }),
            /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: u.getText(
              "This list should be used as a guide only. Always speak to a Council planner before preparing a planning permit application."
            ) })
          ] }),
          /* @__PURE__ */ l(
            Jw,
            {
              allowEditing: e,
              configPrefix: r,
              conversation: t,
              noticeboardData: n
            }
          )
        ] });
      case Te.Prohibited:
        return /* @__PURE__ */ C("div", { className: "flex flex-col gap-3", children: [
          /* @__PURE__ */ l("h2", { className: "text-headingxl text-textPrimary", children: u.getText(
            "We haven't generated application requirements because your proposal is likely prohibited"
          ) }),
          /* @__PURE__ */ l("p", { className: "text-bodylg text-textPrimary", children: u.getText(
            "Based on our analysis of your responses, it's likely your proposal is prohibited. We don't recommend applying for a planning permit because it's unlikely Council will support your proposal."
          ) }),
          /* @__PURE__ */ l("p", { className: "text-bodylg text-textPrimary", children: u.interpolate(
            "If you have questions about your result, {{contactLink}} to talk to one of our planners.",
            {
              contactLink: /* @__PURE__ */ l(
                "a",
                {
                  className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                  href: a("councilContactLink"),
                  rel: "noreferrer",
                  tabIndex: 0,
                  target: "_blank",
                  children: u.getText("contact Council")
                }
              )
            }
          ) })
        ] });
    }
  };
  return /* @__PURE__ */ C("div", { className: "flex flex-col gap-5", children: [
    F && /* @__PURE__ */ l("div", { className: "flex flex-col gap-6 empty:hidden", children: /* @__PURE__ */ l(
      lce,
      {
        conversation: t,
        translate: u
      }
    ) }),
    /* @__PURE__ */ l(
      "div",
      {
        className: _(
          "border-interactiveBorder bg-textWhite flex flex-col gap-6 rounded-lg border border-l-[12px] p-5 md:p-8"
        ),
        "data-testid": "assessment-report",
        children: q()
      }
    )
  ] });
}
function Kce({
  conversation: e,
  reportColors: r,
  translate: t
}) {
  const n = hy({
    messages: (e == null ? void 0 : e.messages) || [],
    messageType: Q7.ROUTING_QUESTION
  }).at(0);
  if (!n) return;
  const s = n.question_data || {};
  if ("inside_permit_requirements_callouts" in s && Array.isArray(s.inside_permit_requirements_callouts) && s.inside_permit_requirements_callouts.length > 0)
    return s.inside_permit_requirements_callouts.map(
      (u, o) => /* @__PURE__ */ l(
        Rq,
        {
          className: `${r.border} bg-textWhite`,
          title: u.title,
          translate: t,
          children: /* @__PURE__ */ l(
            "div",
            {
              className: "[&>a]:text-textLink [&>a]:hover:text-textLinkHover [&>a]:underline",
              dangerouslySetInnerHTML: { __html: u.content }
            }
          )
        },
        `${n.id}-${o}`
      )
    );
}
const hce = {
  orange: "warning",
  yellow: "warning",
  red: "danger",
  green: "success",
  blue: "info"
};
function pce(e) {
  return hce[e.toLowerCase()] || "default";
}
function mce(e) {
  return Array.isArray(e) && e.length > 0 && e.every(
    (r) => r && typeof r == "object" && "disclaimer_color" in r && "disclaimer_content" in r && "disclaimer_title" in r
  );
}
function SF({
  allowEditing: e,
  className: r,
  configPrefix: t,
  conversation: i,
  noticeboardData: n,
  reportColors: s,
  translate: u = Dn
}) {
  const { getLocalisationEntry: o } = si(i), d = o("councilOrdinanceLink"), { expert_name: a, output_key: V, reportAbstractText: c } = Xce(
    i,
    n,
    t
  ), { getConfig: F } = Ur({
    conversation: i,
    noticeboardData: n
  }), { content: X } = F(
    `${t}.report_disclaimers`
  );
  if (c)
    return /* @__PURE__ */ l(
      Ls,
      {
        allowEditing: e,
        expertName: a,
        conversation: i,
        noticeboardData: n,
        outputKey: V,
        children: /* @__PURE__ */ C("div", { className: "flex flex-col gap-4", children: [
          /* @__PURE__ */ l("div", { className: _("text-bodylg text-textPrimary", r), children: We(c, {
            components: {
              h1({ children: Y }) {
                return /* @__PURE__ */ l("h3", { className: "text-headingmd", children: Y });
              },
              h2({ children: Y }) {
                return /* @__PURE__ */ l("h3", { className: "text-headingmd", children: Y });
              },
              h3({ children: Y }) {
                return /* @__PURE__ */ l("h3", { className: "text-headingmd", children: Y });
              },
              h4({ children: Y }) {
                return /* @__PURE__ */ l("h3", { className: "text-headingmd", children: Y });
              }
            },
            ordinanceLink: d
          }) }),
          mce(X) && X.map((Y) => /* @__PURE__ */ l(
            Rq,
            {
              title: Y.disclaimer_title,
              translate: u,
              type: pce(
                Y.disclaimer_color
              ),
              children: /* @__PURE__ */ l("div", { children: /* @__PURE__ */ l("div", { className: _("text-bodylg text-textPrimary", r), children: We(Y.disclaimer_content, {
                components: {
                  h1({ children: q }) {
                    return /* @__PURE__ */ l("h3", { className: "text-headingmd", children: q });
                  },
                  h2({ children: q }) {
                    return /* @__PURE__ */ l("h3", { className: "text-headingmd", children: q });
                  },
                  h3({ children: q }) {
                    return /* @__PURE__ */ l("h3", { className: "text-headingmd", children: q });
                  },
                  h4({ children: q }) {
                    return /* @__PURE__ */ l("h3", { className: "text-headingmd", children: q });
                  }
                },
                ordinanceLink: d
              }) }) })
            },
            Y.disclaimer_title
          )),
          /* @__PURE__ */ l(
            Kce,
            {
              conversation: i,
              reportColors: s,
              translate: u
            }
          )
        ] })
      }
    );
}
function gce({
  allowEditing: e,
  className: r,
  configPrefix: t,
  conversation: i,
  noticeboardData: n,
  translate: s = Dn
}) {
  const { expert_name: u, output_key: o, reportHeadingText: d } = qce(
    i,
    n,
    t
  ), a = $e(() => {
    if (i != null && i.address_data && i.address_data.state === "QLD")
      switch (i.report_outcome) {
        case "Accepted":
          return s.getText(
            "Your proposal likely qualifies as an Accepted Development"
          );
        case "Self assess":
          return s.getText(
            "Your proposal may qualify as an Accepted Development"
          );
        case "Code":
          return s.getText(
            "Your pathway likely requires a Code Assessment"
          );
        case "Impact":
          return s.getText(
            "Your pathway likely requires an Impact Assessment"
          );
        case "Prohibited":
          return s.getText("Your proposal is likely prohibited");
      }
    return d;
  }, [i, d, s]);
  return /* @__PURE__ */ l(
    Ls,
    {
      allowEditing: e,
      expertName: u,
      conversation: i,
      noticeboardData: n,
      outputKey: o,
      children: /* @__PURE__ */ l(
        "h2",
        {
          className: _(
            "text-textPrimary text-heading2xl font-medium",
            r
          ),
          children: a
        }
      )
    }
  );
}
function vce({
  allowEditing: e,
  className: r,
  clause: t,
  configPrefix: i,
  conversation: n,
  noticeboardData: s,
  printable: u,
  translate: o = Dn
}) {
  const { getLocalisationEntry: d } = si(n), a = d("councilOrdinanceLink"), { expert_name: V, output_key: c, mandatoryRequirementsText: F } = CR(n, s, i), X = () => /* @__PURE__ */ C("div", { className: "text-bodymd text-textPrimary", children: [
    /* @__PURE__ */ l("h4", { className: "text-headingsm", children: o == null ? void 0 : o.getText("Additional design considerations") }),
    /* @__PURE__ */ l("p", { className: "text-bodymd", children: o == null ? void 0 : o.interpolate(
      "{{clause54Link}} applies to your proposal because you're proposing a dwelling. Check that you meet all of its applicable objectives.",
      {
        clause54Link: /* @__PURE__ */ l(
          "a",
          {
            className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
            href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/54",
            rel: "noreferrer",
            tabIndex: 0,
            target: "_blank",
            children: o == null ? void 0 : o.getText("Clause 54")
          }
        )
      }
    ) }),
    /* @__PURE__ */ C("ul", { className: "list-disc pl-5", children: [
      /* @__PURE__ */ l("li", { children: o == null ? void 0 : o.interpolate(
        "{{neighbourhoodCharacterLink}}: setbacks, the closeness of walls to site boundaries, fencing, canopy coverage and other factors related to neighbourhood character.",
        {
          neighbourhoodCharacterLink: /* @__PURE__ */ l(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/54.02",
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: o == null ? void 0 : o.getText("Neighbourhood character")
            }
          )
        }
      ) }),
      /* @__PURE__ */ l("li", { children: o == null ? void 0 : o.interpolate(
        "{{liveabilityLink}}: safety, accessibility, private open space and overall street integration.",
        {
          liveabilityLink: /* @__PURE__ */ l(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/54.03",
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: o == null ? void 0 : o.getText("Liveability")
            }
          )
        }
      ) }),
      /* @__PURE__ */ l("li", { children: o == null ? void 0 : o.interpolate(
        "{{externalAmenityLink}}: standards to ensure there is adequate daylight, solar access and privacy, and prevent avoidable overshadowing.",
        {
          externalAmenityLink: /* @__PURE__ */ l(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/54.04",
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: o == null ? void 0 : o.getText("External amenity")
            }
          )
        }
      ) }),
      /* @__PURE__ */ l("li", { children: o == null ? void 0 : o.interpolate(
        "{{sustainabilityLink}}: managing impacts of stormwater run-off, allowing for solar access, and considerations for sufficient shadowing and urban cooling.",
        {
          sustainabilityLink: /* @__PURE__ */ l(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/54.05",
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: o == null ? void 0 : o.getText("Sustainability")
            }
          )
        }
      ) })
    ] })
  ] }), Y = () => /* @__PURE__ */ C("div", { className: "text-bodymd text-textPrimary", children: [
    /* @__PURE__ */ l("h4", { className: "text-headingsm", children: o == null ? void 0 : o.getText("Particular provisions") }),
    /* @__PURE__ */ l("p", { className: "text-bodymd", children: o == null ? void 0 : o.interpolate(
      "{{clause55Link}} applies to your proposal because you're proposing multiple dwellings on a lot. Check that you meet all of its applicable objectives.",
      {
        clause55Link: /* @__PURE__ */ l(
          "a",
          {
            className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
            href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/55",
            rel: "noreferrer",
            tabIndex: 0,
            target: "_blank",
            children: o == null ? void 0 : o.getText("Clause 55")
          }
        )
      }
    ) }),
    /* @__PURE__ */ C("ul", { className: "list-disc pl-5", children: [
      /* @__PURE__ */ l("li", { children: o == null ? void 0 : o.interpolate(
        "{{neighbourhoodCharacterLink}}: setbacks, the closeness of walls to site boundaries, fencing, canopy coverage and other factors related to neighbourhood character.",
        {
          neighbourhoodCharacterLink: /* @__PURE__ */ l(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/55.02",
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: o == null ? void 0 : o.getText("Neighbourhood character")
            }
          )
        }
      ) }),
      /* @__PURE__ */ l("li", { children: o == null ? void 0 : o.interpolate(
        "{{liveabilityLink}}: safety and access/entry, parking, dwelling diversity, ventilation, private open space and overall street integration.",
        {
          liveabilityLink: /* @__PURE__ */ l(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/55.03",
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: o == null ? void 0 : o.getText("Liveability")
            }
          )
        }
      ) }),
      /* @__PURE__ */ l("li", { children: o == null ? void 0 : o.interpolate(
        "{{externalAmenityLink}}: standards to ensure there is adequate daylight, solar access and privacy, internal views, and prevent avoidable overshadowing.",
        {
          externalAmenityLink: /* @__PURE__ */ l(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/55.04",
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: o == null ? void 0 : o.getText("External amenity")
            }
          )
        }
      ) }),
      /* @__PURE__ */ l("li", { children: o == null ? void 0 : o.interpolate(
        "{{sustainabilityLink}}: managing impacts of stormwater run-off, allowing for solar access, and considerations for waste management, sufficient shadowing and urban cooling.",
        {
          sustainabilityLink: /* @__PURE__ */ l(
            "a",
            {
              className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
              href: "https://planning-schemes.app.planning.vic.gov.au/Yarra%20Ranges/ordinance/55.05",
              rel: "noreferrer",
              tabIndex: 0,
              target: "_blank",
              children: o == null ? void 0 : o.getText("Sustainability")
            }
          )
        }
      ) })
    ] })
  ] });
  return /* @__PURE__ */ C(he, { children: [
    /* @__PURE__ */ l("div", { className: _("w-full border-b", r) }),
    /* @__PURE__ */ l(
      _s,
      {
        collapsible: !0,
        type: "single",
        ...u && {
          collapsible: !1,
          value: "design-and-sitting-requirements"
        },
        children: /* @__PURE__ */ C(
          as,
          {
            className: "border-b-0",
            value: "design-and-sitting-requirements",
            children: [
              /* @__PURE__ */ l(Vs, { className: "!py-0", children: /* @__PURE__ */ C("div", { className: "text-left", children: [
                /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary", children: o.getText("Design and siting requirements") }),
                /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: o.getText(
                  "Additional requirements from the zone, overlays, and particular provisions."
                ) })
              ] }) }),
              /* @__PURE__ */ C(ls, { className: "!pb-0 pt-5", children: [
                /* @__PURE__ */ l(
                  Ls,
                  {
                    allowEditing: e,
                    expertName: V,
                    conversation: n,
                    noticeboardData: s,
                    outputKey: c,
                    children: We(F, {
                      components: {
                        h1({ children: q }) {
                          return /* @__PURE__ */ l("h4", { className: "text-headingsm mb-2", children: q });
                        },
                        h2({ children: q }) {
                          return /* @__PURE__ */ l("h4", { className: "text-headingsm mb-2", children: q });
                        },
                        h3({ children: q }) {
                          return /* @__PURE__ */ l("h4", { className: "text-headingsm mb-2", children: q });
                        },
                        h4({ children: q }) {
                          return /* @__PURE__ */ l("h4", { className: "text-headingsm mb-2", children: q });
                        }
                      },
                      ordinanceLink: a
                    })
                  }
                ),
                t === "54" && X(),
                t === "55" && Y()
              ] })
            ]
          }
        )
      }
    )
  ] });
}
function gh({
  allowEditing: e,
  className: r,
  configPrefix: t,
  conversation: i,
  noticeboardData: n,
  printable: s,
  translate: u = Dn
}) {
  const { getLocalisationEntry: o } = si(i), d = o("councilOrdinanceLink"), a = Yce(
    i,
    n,
    t
  ), V = fce(
    i,
    n,
    t
  ), c = ["54", "55"].includes(
    V || ""
  ), { expert_name: F, output_key: X, mandatoryRequirementsText: Y } = CR(i, n, t);
  if (c)
    return /* @__PURE__ */ l(
      vce,
      {
        allowEditing: e,
        className: r,
        clause: V,
        configPrefix: t,
        conversation: i,
        noticeboardData: n
      }
    );
  if (!(!a || !Y))
    return /* @__PURE__ */ C(he, { children: [
      /* @__PURE__ */ l("div", { className: _("w-full border-b", r) }),
      /* @__PURE__ */ l(
        _s,
        {
          collapsible: !0,
          type: "single",
          ...s && {
            collapsible: !1,
            value: "mandatory-requirements"
          },
          children: /* @__PURE__ */ C(as, { className: "border-b-0", value: "mandatory-requirements", children: [
            /* @__PURE__ */ l(Vs, { className: "!py-0", children: /* @__PURE__ */ C("div", { className: "text-left", children: [
              /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary", children: u.getText("Mandatory requirements") }),
              /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: u.getText(
                "Check your proposal complies with these requirements or it won't be accepted."
              ) })
            ] }) }),
            /* @__PURE__ */ l(ls, { className: "!pb-0 pt-5", children: /* @__PURE__ */ l(
              Ls,
              {
                allowEditing: e,
                expertName: F,
                conversation: i,
                noticeboardData: n,
                outputKey: X,
                children: We(Y, {
                  ordinanceLink: d
                })
              }
            ) })
          ] })
        }
      )
    ] });
}
function bce({
  conversation: e,
  translate: r
}) {
  const i = hy({
    messages: (e == null ? void 0 : e.messages) || [],
    messageType: Q7.ROUTING_QUESTION
  }).at(0);
  if (!i) return;
  const n = i.question_data || {};
  if ("permit_requirements_callouts" in n && Array.isArray(n.permit_requirements_callouts))
    return n.permit_requirements_callouts.map(
      (s, u) => /* @__PURE__ */ l(
        Rq,
        {
          title: s.title,
          translate: r,
          type: s.color,
          children: s.content
        },
        `${i.id}-${u}`
      )
    );
}
function lv(e) {
  return !e || e.trim().toLowerCase().startsWith("no content") || /^no (.+) at this address/.test(e.trim().toLowerCase());
}
function yce(e) {
  var r;
  return ((r = e == null ? void 0 : e.split(`
`)[0]) == null ? void 0 : r.trim()) || "";
}
function Ace({
  configPrefix: e,
  conversation: r,
  noticeboardData: t,
  translate: i = Dn
}) {
  const { getConfigs: n } = Ur({
    conversation: r,
    noticeboardData: t
  }), s = n(`${e}.report_details`), u = $e(() => s.filter((d) => {
    const { content: a } = d;
    return !lv(a);
  }), [s]), o = () => u.map((d, a) => {
    const { content: V, title: c, parsedOutput: F } = d;
    if (lv(V))
      return null;
    const X = nR(
      (F == null ? void 0 : F.title) || c || yce(V) || ""
    ), Y = F == null ? void 0 : F.permit_determination_heading;
    return /* @__PURE__ */ C("li", { className: "not-first:mt-1", children: [
      /* @__PURE__ */ C(
        "a",
        {
          className: "text-bodymd text-textLink hover:text-textLinkHover underline",
          href: `#detailed-analysis-section-${a}`,
          children: [
            /* @__PURE__ */ C("span", { children: [
              a + 1,
              "."
            ] }),
            " ",
            X
          ]
        }
      ),
      Y && ` | ${Y}`
    ] }, a);
  });
  return /* @__PURE__ */ C("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ l("p", { className: "text-bodymd", children: i == null ? void 0 : i.getText("Jump to...") }),
    /* @__PURE__ */ l("ul", { className: "list-outside list-none pl-3", children: o() })
  ] });
}
function wce({
  allowEditing: e,
  configPrefix: r,
  conversation: t,
  noticeboardData: i,
  printable: n,
  reportColors: s,
  translate: u = Dn
}) {
  const { getLocalisationEntry: o } = si(t), d = o("councilOrdinanceLink"), { getConfigs: a } = Ur({
    conversation: t,
    noticeboardData: i
  }), V = $e(() => a(`${r}.report_details`).filter((X) => {
    const { content: Y } = X;
    return !lv(Y);
  }), [a, r]), c = () => /* @__PURE__ */ l("div", { className: "flex flex-col gap-5", children: V.map((F, X) => {
    const {
      expert_name: Y = "",
      output_key: q,
      content: f,
      title: p,
      parsedOutput: m
    } = F, g = X === V.length - 1, y = nR(
      p || (m == null ? void 0 : m.title) || ""
    );
    return /* @__PURE__ */ C(Do, { children: [
      /* @__PURE__ */ C(
        "div",
        {
          className: "flex flex-col gap-1",
          id: `detailed-analysis-section-${X}`,
          children: [
            y && /* @__PURE__ */ l("h3", { className: "text-headingsm text-textPrimary", children: y }),
            /* @__PURE__ */ l(
              Ls,
              {
                allowEditing: e,
                expertName: Y,
                conversation: t,
                noticeboardData: i,
                outputKey: q,
                children: We(f, {
                  components: {
                    h1({ children: b }) {
                      return /* @__PURE__ */ l("h4", { className: "text-headingsm mb-2", children: b });
                    },
                    h2({ children: b }) {
                      return /* @__PURE__ */ l("h4", { className: "text-headingsm mb-2", children: b });
                    },
                    h3({ children: b }) {
                      return /* @__PURE__ */ l("h4", { className: "text-headingsm mb-2", children: b });
                    },
                    h4({ children: b }) {
                      return /* @__PURE__ */ l("h4", { className: "text-headingsm mb-2", children: b });
                    }
                  },
                  ordinanceLink: d,
                  reportColors: s
                })
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ C(
        "a",
        {
          className: "text-bodymd text-textLink hover:text-textLinkHover flex cursor-pointer items-center",
          href: "#detailed-analysis-heading",
          children: [
            /* @__PURE__ */ l(Gae, { className: "size-5" }),
            " ",
            /* @__PURE__ */ l("span", { className: "underline", children: u.getText("Back to top") })
          ]
        }
      ),
      !g && /* @__PURE__ */ l("div", { className: _("w-full border-b", s.border) })
    ] }, X);
  }) });
  return /* @__PURE__ */ l(
    _s,
    {
      collapsible: !0,
      type: "single",
      ...n && { collapsible: !1, value: "detailed-analysis" },
      children: /* @__PURE__ */ C(as, { className: "border-b-0", value: "detailed-analysis", children: [
        /* @__PURE__ */ l(Vs, { className: "!py-0", children: /* @__PURE__ */ C("div", { children: [
          /* @__PURE__ */ l(
            "h2",
            {
              className: "text-headingmd text-textPrimary flex",
              id: "detailed-analysis-heading",
              children: u.getText("Detailed analysis")
            }
          ),
          /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued [text-align:initial]", children: u.getText(
            "Breakdown by the zone, overlays, and other controls relevant to your proposal."
          ) })
        ] }) }),
        /* @__PURE__ */ C(ls, { className: "flex flex-col gap-5 !pb-0 pt-5", children: [
          /* @__PURE__ */ l(
            Ace,
            {
              configPrefix: r,
              conversation: t,
              noticeboardData: i,
              translate: u
            }
          ),
          c()
        ] })
      ] })
    }
  );
}
function Cce({
  allowEditing: e,
  configPrefix: r,
  conversation: t,
  noticeboardData: i,
  printable: n,
  reportColors: s,
  translate: u
}) {
  const { getLocalisationEntry: o } = si(t), d = o("councilOrdinanceLink"), { getConfigs: a } = Ur({
    conversation: t,
    noticeboardData: i
  }), [V, c] = ie("0"), F = () => {
    switch (V) {
      case "0":
        return /* @__PURE__ */ l("p", { className: "text-bodymd pt-4", children: u == null ? void 0 : u.interpolate(
          "Some minor building renovations or works don't need any planning or building approval. In NSW, this is referred to as {{link}}.",
          {
            link: /* @__PURE__ */ l(
              "a",
              {
                className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                href: "https://www.planning.nsw.gov.au/assess-and-regulate/development-assessment/planning-approval-pathways/exempt-development",
                rel: "noreferrer",
                tabIndex: 0,
                target: "_blank",
                children: "exempt development"
              }
            )
          }
        ) });
      case "1":
        return /* @__PURE__ */ l("p", { className: "text-bodymd pt-4", children: u == null ? void 0 : u.interpolate(
          "{{link}} is a combined planning and construction approval for straightforward development that can be determined through a fast-track assessment.",
          {
            link: /* @__PURE__ */ l(
              "a",
              {
                className: "text-textLink hover:text-textLinkHover cursor-pointer underline",
                href: "https://www.planning.nsw.gov.au/assess-and-regulate/development-assessment/planning-approval-pathways/complying-development",
                rel: "noreferrer",
                tabIndex: 0,
                target: "_blank",
                children: "Complying development"
              }
            )
          }
        ) });
    }
  }, X = () => {
    const Y = a(`${r}.report_details`);
    return /* @__PURE__ */ C(
      vu,
      {
        className: "w-full overflow-hidden p-0",
        onValueChange: (q) => {
          c(q);
        },
        value: V,
        defaultValue: "0",
        children: [
          /* @__PURE__ */ l(Ms, { className: "bg-blueBgSelect flex w-full items-end justify-start rounded border-b-[1px] border-b-transparent p-0", children: Y.map((q, f) => /* @__PURE__ */ l(
            Rt,
            {
              type: void 0,
              value: f.toString(),
              className: "text-textPrimary text-bodysm data-[state=active]:bg-interfaceBgLightPaper m-1 grow rounded border-none px-4 py-2 font-normal",
              children: q.title
            },
            f
          )) }),
          Y.map((q, f) => {
            const { expert_name: p = "", output_key: m, content: g } = q;
            return /* @__PURE__ */ l(St, { value: f.toString(), children: /* @__PURE__ */ C("div", { className: "flex flex-col gap-1", children: [
              F(),
              /* @__PURE__ */ l(
                Ls,
                {
                  allowEditing: e,
                  expertName: p,
                  conversation: t,
                  noticeboardData: i,
                  outputKey: m,
                  children: /* @__PURE__ */ l("div", { className: "pt-6", children: We(g, {
                    components: {
                      h1({ children: y }) {
                        return /* @__PURE__ */ l("h4", { className: "text-headingsm", children: y });
                      },
                      h2({ children: y }) {
                        return /* @__PURE__ */ l("h4", { className: "text-headingsm", children: y });
                      },
                      h3({ children: y }) {
                        return /* @__PURE__ */ l("h4", { className: "text-headingsm", children: y });
                      },
                      h4({ children: y }) {
                        return /* @__PURE__ */ l("h4", { className: "text-headingsm", children: y });
                      }
                    },
                    ordinanceLink: d,
                    reportColors: s
                  }) })
                }
              )
            ] }) }, q.title);
          })
        ]
      }
    );
  };
  return /* @__PURE__ */ l(
    _s,
    {
      collapsible: !0,
      type: "single",
      ...n && { collapsible: !1, value: "detailed-analysis" },
      children: /* @__PURE__ */ C(as, { className: "border-b-0", value: "detailed-analysis", children: [
        /* @__PURE__ */ l(Vs, { className: "!py-0", children: /* @__PURE__ */ C("div", { className: "text-left", children: [
          /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary", children: u == null ? void 0 : u.getText("Detailed analysis") }),
          /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: u == null ? void 0 : u.getText(
            "How your proposal was assessed against each of NSW's approval pathways."
          ) })
        ] }) }),
        /* @__PURE__ */ l(ls, { className: "pt-5 !pb-0", children: X() })
      ] })
    }
  );
}
function vh({
  allowEditing: e,
  configPrefix: r,
  conversation: t,
  noticeboardData: i,
  printable: n,
  reportColors: s,
  translate: u
}) {
  var a, V;
  const o = ((V = (a = t == null ? void 0 : t.address_data) == null ? void 0 : a.state) == null ? void 0 : V.toUpperCase()) || "";
  if (wae(
    t,
    r
  ))
    switch (o) {
      case "NSW":
        return /* @__PURE__ */ l(
          Cce,
          {
            allowEditing: e,
            configPrefix: r,
            conversation: t,
            noticeboardData: i,
            printable: n,
            reportColors: s,
            translate: u
          }
        );
      default:
        return /* @__PURE__ */ l(
          wce,
          {
            allowEditing: e,
            configPrefix: r,
            conversation: t,
            noticeboardData: i,
            printable: n,
            reportColors: s,
            translate: u
          }
        );
    }
}
const Qw = {
  [Te.NoPermitRequired]: {
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [Te.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [Te.RequiresPermit]: {
    text: "text-warningHover",
    border: "border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [Te.Prohibited]: {
    text: "text-destructiveHover",
    border: "border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  },
  // forced report colours
  green: {
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  blue: {
    text: "text-actionDefault",
    border: "border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  orange: {
    text: "text-warningHover",
    border: "border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  red: {
    text: "text-destructiveHover",
    border: "border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  },
  grey: {
    text: "text-textPrimary",
    border: "border-interactiveBorder",
    bgLight: "bg-textWhite",
    bgDark: "bg-textWhite"
  }
};
function hQe({
  allowEditing: e,
  configPrefix: r,
  conversation: t,
  messages: i,
  noticeboardData: n,
  printable: s,
  translate: u = Dn
}) {
  const [o, d] = ie({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), a = ua(
    t,
    n,
    r
  ), V = a && a !== Te.Prohibited;
  Pe(() => {
    t != null && t.forced_report_color ? d(Qw[t.forced_report_color]) : a && ["1", "2", "3", "4"].includes(a.toString()) ? d(Qw[a.toString()]) : d({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [
    a,
    t == null ? void 0 : t.forced_report_color,
    t == null ? void 0 : t.phase
  ]);
  const c = () => {
    switch (a) {
      case Te.NoPermitRequired:
        return /* @__PURE__ */ C("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ l(
            SF,
            {
              allowEditing: e,
              configPrefix: r,
              conversation: t,
              noticeboardData: n,
              reportColors: o,
              translate: u
            }
          ),
          /* @__PURE__ */ l(
            gh,
            {
              allowEditing: e,
              className: o.border,
              configPrefix: r,
              conversation: t,
              noticeboardData: n,
              printable: s,
              translate: u
            }
          ),
          /* @__PURE__ */ l("div", { className: _("w-full border-b last:hidden", o.border) }),
          /* @__PURE__ */ l(
            vh,
            {
              allowEditing: e,
              configPrefix: r,
              conversation: t,
              noticeboardData: n,
              printable: s,
              reportColors: o,
              translate: u
            }
          )
        ] });
      case Te.MoreInformationRequired:
        return /* @__PURE__ */ C("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ l(
            SF,
            {
              allowEditing: e,
              configPrefix: r,
              conversation: t,
              noticeboardData: n,
              reportColors: o,
              translate: u
            }
          ),
          /* @__PURE__ */ l(
            gh,
            {
              allowEditing: e,
              className: o.border,
              configPrefix: r,
              conversation: t,
              noticeboardData: n,
              printable: s,
              translate: u
            }
          ),
          /* @__PURE__ */ l("div", { className: _("w-full border-b last:hidden", o.border) }),
          /* @__PURE__ */ l(
            vh,
            {
              allowEditing: e,
              configPrefix: r,
              conversation: t,
              noticeboardData: n,
              printable: s,
              reportColors: o,
              translate: u
            }
          )
        ] });
      case Te.RequiresPermit:
        return /* @__PURE__ */ C("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ l(
            SF,
            {
              allowEditing: e,
              configPrefix: r,
              conversation: t,
              noticeboardData: n,
              reportColors: o,
              translate: u
            }
          ),
          /* @__PURE__ */ l(
            gh,
            {
              allowEditing: e,
              className: o.border,
              configPrefix: r,
              conversation: t,
              noticeboardData: n,
              printable: s,
              translate: u
            }
          ),
          /* @__PURE__ */ l("div", { className: _("w-full border-b last:hidden", o.border) }),
          /* @__PURE__ */ l(
            vh,
            {
              allowEditing: e,
              configPrefix: r,
              conversation: t,
              noticeboardData: n,
              printable: s,
              reportColors: o,
              translate: u
            }
          )
        ] });
      case Te.Prohibited:
        return /* @__PURE__ */ l("div", { className: "flex flex-col gap-6", children: /* @__PURE__ */ l(
          SF,
          {
            allowEditing: e,
            configPrefix: r,
            conversation: t,
            noticeboardData: n,
            reportColors: o,
            translate: u
          }
        ) });
    }
  };
  return /* @__PURE__ */ C("div", { className: "flex flex-col gap-5", children: [
    V && /* @__PURE__ */ l("div", { className: "flex flex-col gap-6 empty:hidden", children: /* @__PURE__ */ l(
      bce,
      {
        conversation: t,
        translate: u
      }
    ) }),
    /* @__PURE__ */ C(
      "div",
      {
        className: _(
          "flex flex-col gap-6 rounded-lg border border-l-[12px] p-5 md:p-8",
          o.border,
          o.bgLight
        ),
        "data-testid": "assessment-report",
        children: [
          /* @__PURE__ */ l(
            gce,
            {
              allowEditing: e,
              configPrefix: r,
              conversation: t,
              noticeboardData: n,
              translate: u
            }
          ),
          c()
        ]
      }
    )
  ] });
}
function pQe({
  configPrefix: e,
  conversation: r,
  noticeboardData: t
}) {
  const { getLocalisationEntry: i } = si(r), n = i("councilOrdinanceLink"), s = Fce(
    r,
    t,
    e
  );
  return /* @__PURE__ */ l("div", { className: "flex flex-col gap-5", children: We(s, {
    components: {
      h1({ children: u }) {
        return /* @__PURE__ */ l("h4", { className: "text-headingsm", children: u });
      },
      h2({ children: u }) {
        return /* @__PURE__ */ l("h4", { className: "text-headingsm", children: u });
      },
      h3({ children: u }) {
        return /* @__PURE__ */ l("h4", { className: "text-headingsm", children: u });
      },
      h4({ children: u }) {
        return /* @__PURE__ */ l("h4", { className: "text-headingsm", children: u });
      }
    },
    ordinanceLink: n
  }) });
}
function i2(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), { content: n } = i(
    `${t}.report_heading`
  );
  return n;
}
function Pce(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), { content: n } = i(
    `${t}.report_abstract`
  );
  return n;
}
function Iq(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), { content: n } = i(
    `${t}.report_summary`
  );
  return n;
}
function yy(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), { content: n } = i(
    `${t}.mandatory_requirements`
  );
  return n;
}
function Ay(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), { parsedOutput: n = {} } = i(
    `${t}.show_mandatory_requirements`
  );
  return "<1>" in n;
}
function wy(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), { content: n } = i(
    `${t}.easy_read_report`
  );
  return n;
}
function Cy(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), { content: n } = i(
    `${t}.application_requirements`
  );
  return n;
}
function Sce(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), { content: n } = i(
    `${t}.lodgement_requirements`
  );
  return n;
}
function Nce(e) {
  var r;
  return (r = e == null ? void 0 : e.vicsmart_classifier_combined) != null && r.parsed_output.vicsmart ? e.vicsmart_classifier_combined.parsed_output.vicsmart : "";
}
function Py(e, r, t) {
  var s, u;
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), { parsedOutput: n = {} } = i(
    `${t}.vic_smart_eligibility`
  );
  return "<1>" in n && ((s = n["<1>"]) == null ? void 0 : s.toLowerCase()) !== "n/a" ? "eligible" : "<2>" in n && ((u = n["<2>"]) == null ? void 0 : u.toLowerCase()) !== "n/a" ? "ineligible" : "unknown";
}
function Sy(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), { content: n } = i(
    `${t}.vic_smart`
  );
  return n;
}
function Mce(e, r, t) {
  const { getConfig: i } = Ur({
    conversation: e,
    noticeboardData: r
  }), { content: n } = i(
    `${t}.vic_smart_application_requirements`
  );
  return n;
}
function cv({
  configPrefix: e,
  conversation: r,
  noticeboardData: t,
  ordinanceLink: i
}) {
  const n = Py(
    r,
    t,
    e
  ), s = Sy(
    r,
    t,
    e
  );
  if (oR() && n !== "unknown")
    return /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { className: "text-headingmd text-textPrimary mb-1", children: "VicSmart eligibility" }),
      /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued mb-2", children: "VicSmart is an approval pathway for straightforward planning applications. If you're eligible, lodging a VicSmart application will be much faster than the standard pathway." }),
      n === bV.eligible ? /* @__PURE__ */ l(yr, { className: "mt-2", children: We(s, {
        ordinanceLink: i
      }) }) : null
    ] });
}
function Fv({
  configPrefix: e,
  conversation: r,
  noticeboardData: t,
  ordinanceLink: i
}) {
  const n = Cy(
    r,
    t,
    e
  );
  return /* @__PURE__ */ C("div", { children: [
    /* @__PURE__ */ l("h3", { className: "text-headingmd text-textPrimary mb-1", children: "Required documents and information" }),
    /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued mb-5", children: "If your proposal isn't eligible for VicSmart, you may need to provide the following documents when you submit a planning permit application. It is recommended that you speak to a planner to confirm if these documents are required for your proposal." }),
    /* @__PURE__ */ l(yr, { children: We(n, {
      components: {
        h1({ children: s }) {
          return /* @__PURE__ */ l("h5", { className: "text-bodymd font-bold", children: s });
        },
        h2({ children: s }) {
          return /* @__PURE__ */ l("h5", { className: "text-bodymd font-bold", children: s });
        },
        h3({ children: s }) {
          return /* @__PURE__ */ l("h5", { className: "text-bodymd font-bold", children: s });
        },
        h4({ children: s }) {
          return /* @__PURE__ */ l("h5", { className: "text-bodymd font-bold", children: s });
        }
      },
      ordinanceLink: i
    }) })
  ] });
}
const Tce = {
  [Te.NoPermitRequired]: {
    text: "text-successHover",
    border: "!border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [Te.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "!border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [Te.RequiresPermit]: {
    text: "text-warningHover",
    border: "!border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [Te.Prohibited]: {
    text: "text-destructiveHover",
    border: "!border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  }
};
function mQe({
  configPrefix: e,
  conversation: r,
  messages: t,
  noticeboardData: i,
  onClickCheckExemptionCriteria: n,
  onClickApplicationRequirements: s,
  publicView: u = !1
}) {
  const [o, d] = ie({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), { getLocalisationEntry: a } = si(r), V = a("councilOrdinanceLink"), c = dR({ messages: t }), F = aR({ conversation: r, messages: t }), X = VR(
    r,
    e
  );
  console.log("<AnalysisReport>", {
    isReportFinalised: c,
    isReportLocked: F,
    isFollowUpFlowEnabled: X,
    phase: r == null ? void 0 : r.phase
  });
  const Y = ua(
    r,
    i,
    e
  );
  Pe(() => {
    Y && ["1", "2", "3", "4"].includes(Y.toString()) ? d(Tce[Y.toString()]) : d({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [Y, r == null ? void 0 : r.phase]);
  const q = wy(
    r,
    i,
    e
  ), f = () => /* @__PURE__ */ l("div", { children: We(q, { ordinanceLink: V }) }), p = Iq(
    r,
    i,
    e
  ), m = yy(
    r,
    i,
    e
  ), g = Ay(
    r,
    i,
    e
  ), y = () => {
    switch (Y) {
      case Te.NoPermitRequired:
        return /* @__PURE__ */ C("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ C("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Why your proposal likely doesn't require a planning permit." }),
            /* @__PURE__ */ C(vu, { defaultValue: "summary", children: [
              /* @__PURE__ */ C(Ms, { className: "pb-3", children: [
                /* @__PURE__ */ C(
                  Rt,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 !bg-transparent px-2",
                    value: "summary",
                    children: [
                      /* @__PURE__ */ l(bd, {}),
                      " Full assessment"
                    ]
                  }
                ),
                /* @__PURE__ */ C(
                  Rt,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 !bg-transparent px-2",
                    value: "easy-read",
                    children: [
                      /* @__PURE__ */ l(yd, {}),
                      " Easy read"
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ l(St, { value: "easy-read", children: /* @__PURE__ */ l(yr, { maxHeight: 300, children: f() }) }),
              /* @__PURE__ */ l(St, { value: "summary", children: /* @__PURE__ */ l(yr, { maxHeight: 300, children: We(p, { ordinanceLink: V }) }) })
            ] })
          ] }),
          g && m ? /* @__PURE__ */ C("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ l(yr, { children: We(m, {
              ordinanceLink: V
            }) })
          ] }) : null
        ] });
      case Te.MoreInformationRequired:
        return /* @__PURE__ */ C("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ C("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Why a planning permit could be required" }),
            /* @__PURE__ */ C(vu, { defaultValue: "summary", children: [
              /* @__PURE__ */ C(Ms, { className: "pb-3", children: [
                /* @__PURE__ */ C(
                  Rt,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 !bg-transparent px-2",
                    value: "summary",
                    children: [
                      /* @__PURE__ */ l(bd, {}),
                      " Full assessment"
                    ]
                  }
                ),
                /* @__PURE__ */ C(
                  Rt,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 !bg-transparent px-2",
                    value: "easy-read",
                    children: [
                      /* @__PURE__ */ l(yd, {}),
                      " Easy read"
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ l(St, { value: "easy-read", children: /* @__PURE__ */ l("div", { children: f() }) }),
              /* @__PURE__ */ l(St, { value: "summary", children: /* @__PURE__ */ l(yr, { maxHeight: 300, children: We(p, { ordinanceLink: V }) }) })
            ] })
          ] }),
          g && m ? /* @__PURE__ */ C("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ l(yr, { children: We(m, {
              ordinanceLink: V
            }) })
          ] }) : null,
          X && !F && !c && !u ? /* @__PURE__ */ l(er, { className: "w-min", onClick: n, children: "Check exemption criteria" }) : null,
          X && c ? /* @__PURE__ */ C("div", { children: [
            /* @__PURE__ */ l(
              "div",
              {
                className: _("mb-6 w-full border-b", o.border)
              }
            ),
            /* @__PURE__ */ l(
              "h2",
              {
                className: "text-headinglg text-textPrimary mb-5",
                id: "application-requirements",
                children: "Application requirements"
              }
            ),
            /* @__PURE__ */ l(
              cv,
              {
                configPrefix: e,
                conversation: r,
                noticeboardData: i,
                ordinanceLink: V
              }
            ),
            /* @__PURE__ */ l("div", { className: "h-4" }),
            /* @__PURE__ */ l(
              Fv,
              {
                configPrefix: e,
                conversation: r,
                noticeboardData: i,
                ordinanceLink: V
              }
            )
          ] }) : null
        ] });
      case Te.RequiresPermit:
        return /* @__PURE__ */ C("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ C("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Why a permit is likely required" }),
            /* @__PURE__ */ C(vu, { defaultValue: "summary", children: [
              /* @__PURE__ */ C(Ms, { className: "pb-3", children: [
                /* @__PURE__ */ C(
                  Rt,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 !bg-transparent px-2",
                    value: "summary",
                    children: [
                      /* @__PURE__ */ l(bd, {}),
                      " Full assessment"
                    ]
                  }
                ),
                /* @__PURE__ */ C(
                  Rt,
                  {
                    className: "data-[state=active]:text-textLink flex gap-1 !bg-transparent px-2",
                    value: "easy-read",
                    children: [
                      /* @__PURE__ */ l(yd, {}),
                      " Easy read"
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ l(St, { value: "easy-read", children: /* @__PURE__ */ l(yr, { maxHeight: 300, children: f() }) }),
              /* @__PURE__ */ l(St, { value: "summary", children: /* @__PURE__ */ l(yr, { maxHeight: 300, children: We(p, { ordinanceLink: V }) }) })
            ] })
          ] }),
          g && m ? /* @__PURE__ */ C("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ l(yr, { children: We(m, {
              ordinanceLink: V
            }) })
          ] }) : null,
          X && !F && !c && !u ? /* @__PURE__ */ C("div", { children: [
            /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Ready to apply?" }),
            /* @__PURE__ */ l("p", { className: "text-bodymd text-textPrimary mb-3", children: "Check what information you'll need to provide to council when you apply." }),
            /* @__PURE__ */ l(
              er,
              {
                className: "w-min",
                onClick: s,
                children: "Check application requirements"
              }
            )
          ] }) : null,
          X && c ? /* @__PURE__ */ C("div", { children: [
            /* @__PURE__ */ l(
              "div",
              {
                className: _("mb-6 w-full border-b", o.border)
              }
            ),
            /* @__PURE__ */ l(
              "h2",
              {
                className: "text-headinglg text-textPrimary mb-5",
                id: "application-requirements",
                children: "Application requirements"
              }
            ),
            /* @__PURE__ */ l(
              cv,
              {
                configPrefix: e,
                conversation: r,
                noticeboardData: i,
                ordinanceLink: V
              }
            ),
            /* @__PURE__ */ l("div", { className: "h-4" }),
            /* @__PURE__ */ l(
              Fv,
              {
                configPrefix: e,
                conversation: r,
                noticeboardData: i,
                ordinanceLink: V
              }
            )
          ] }) : null
        ] });
      case Te.Prohibited:
        return /* @__PURE__ */ C("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Why your proposal is likely prohibited" }),
          /* @__PURE__ */ C(vu, { defaultValue: "summary", children: [
            /* @__PURE__ */ C(Ms, { className: "pb-3", children: [
              /* @__PURE__ */ C(
                Rt,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 !bg-transparent px-2",
                  value: "summary",
                  children: [
                    /* @__PURE__ */ l(bd, {}),
                    " Full assessment"
                  ]
                }
              ),
              /* @__PURE__ */ C(
                Rt,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 !bg-transparent px-2",
                  value: "easy-read",
                  children: [
                    /* @__PURE__ */ l(yd, {}),
                    " Easy read"
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ l(St, { value: "easy-read", children: /* @__PURE__ */ l(yr, { maxHeight: 300, children: f() }) }),
            /* @__PURE__ */ l(St, { value: "summary", children: /* @__PURE__ */ l(yr, { maxHeight: 300, children: We(p, { ordinanceLink: V }) }) })
          ] })
        ] });
    }
  };
  return /* @__PURE__ */ C(
    "div",
    {
      className: _(
        "flex flex-col gap-6 rounded-lg border border-l-[12px] p-5 md:p-8",
        o.border,
        o.bgLight
      ),
      "data-testid": "assessment-report",
      children: [
        /* @__PURE__ */ l(
          "h2",
          {
            className: `text-heading2xl font-medium ${o.text}`,
            children: i2(r, i, e)
          }
        ),
        y()
      ]
    }
  );
}
const Ece = {
  [Te.NoPermitRequired]: {
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [Te.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [Te.RequiresPermit]: {
    text: "text-warningHover",
    border: "border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [Te.Prohibited]: {
    text: "text-destructiveHover",
    border: "border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  }
};
function gQe({
  configPrefix: e,
  conversation: r,
  expertMap: t,
  messages: i,
  noticeboardData: n,
  onClickCheckExemptionCriteria: s,
  onClickApplicationRequirements: u,
  publicView: o = !1
}) {
  const [d, a] = ie({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), { getLocalisationEntry: V } = si(r), c = V("councilOrdinanceLink"), F = dR({ messages: i }), X = aR({ conversation: r, messages: i }), Y = VR(
    r,
    e
  ), q = ua(
    r,
    n,
    e
  );
  Pe(() => {
    q && ["1", "2", "3", "4"].includes(q.toString()) ? a(Ece[q.toString()]) : a({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [q, r == null ? void 0 : r.phase]);
  const f = Pce(
    r,
    n,
    e
  ), p = () => {
    if (f)
      return /* @__PURE__ */ l("div", { className: "text-bodylg text-textPrimary mb-1", children: We(f, { ordinanceLink: c }) });
  }, m = Ay(
    r,
    n,
    e
  ), g = yy(
    r,
    n,
    e
  ), y = () => {
    if (m && g)
      return /* @__PURE__ */ C(he, { children: [
        /* @__PURE__ */ l("div", { className: _("w-full border-b", d.border) }),
        /* @__PURE__ */ l(_s, { collapsible: !0, type: "single", children: /* @__PURE__ */ C(
          as,
          {
            className: "border-b-0",
            value: "mandatory-requirements",
            children: [
              /* @__PURE__ */ l(Vs, { className: "!py-0", children: /* @__PURE__ */ C("div", { className: "text-left", children: [
                /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary", children: "Mandatory requirements" }),
                /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: "Check your proposal complies with these requirements or it won't be accepted." })
              ] }) }),
              /* @__PURE__ */ l(ls, { className: "!pb-0 pt-5", children: We(g, {
                ordinanceLink: c
              }) })
            ]
          }
        ) })
      ] });
  }, b = () => {
    let I = [
      {
        expert_name: "landuse_report",
        title: "Land use"
      },
      {
        expert_name: "zone_works_report",
        title: "Buildings and works"
      },
      {
        expert_name: "provisions_assessor_report",
        title: "Particular provisions"
      },
      {
        expert_name: "bmo_overlay_report",
        title: "Bushfire Management Overlay"
      },
      {
        expert_name: "ddo_overlay_report",
        title: "Design and Development Overlay"
      },
      {
        expert_name: "emo_overlay_report",
        title: "Erosion Management Overlay"
      },
      {
        expert_name: "eso_overlay_report",
        title: "Environmental Significance Overlay"
      },
      {
        expert_name: "ho_overlay_report",
        title: "Heritage Overlay"
      },
      {
        expert_name: "lsio_overlay_report",
        title: "Land Subject to Inundation Overlay"
      },
      {
        expert_name: "sbo_overlay_report",
        title: "Special Building Overlay"
      },
      {
        expert_name: "slo_overlay_report",
        title: "Significant Landscape Overlay"
      },
      {
        expert_name: "vpo_overlay_report",
        title: "Vegetation Protection Overlay"
      },
      {
        expert_name: "tree_policy_assessor",
        title: "Local policies"
      }
    ];
    return t && Array.isArray(t.report_details) && t.report_details.length > 0 && (I = t.report_details), /* @__PURE__ */ l("div", { className: "flex flex-col gap-5", children: I.map((R, H) => {
      var Z, le, te, U, de, Ke, xe, be, qe, me, ne, fe;
      const { expert_name: W = "", output_key: B = "", title: L } = R;
      let z = "";
      if (B && ((le = (Z = n == null ? void 0 : n[W]) == null ? void 0 : Z.parsed_output) != null && le[B]) ? z = (U = (te = n == null ? void 0 : n[W]) == null ? void 0 : te.parsed_output) == null ? void 0 : U[B] : (de = n == null ? void 0 : n[W]) != null && de.raw_output && (z = (Ke = n == null ? void 0 : n[W]) == null ? void 0 : Ke.raw_output), !z || z.trim().toLowerCase().startsWith("no content") || /^no (.+) at this address/.test(z.trim().toLowerCase()))
        return null;
      if (R.filter) {
        const { target: Ye, operation: Q, output_key: we } = R.filter;
        let oe = "";
        if (we && ((be = (xe = n == null ? void 0 : n[W]) == null ? void 0 : xe.parsed_output) != null && be[we]) ? oe = (me = (qe = n == null ? void 0 : n[W]) == null ? void 0 : qe.parsed_output) == null ? void 0 : me[we] : (ne = n == null ? void 0 : n[W]) != null && ne.raw_output && (oe = (fe = n == null ? void 0 : n[W]) == null ? void 0 : fe.raw_output), Ye && Q === "includes" && oe.includes(Ye))
          return null;
      }
      return /* @__PURE__ */ C("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ l("h3", { className: "text-headingsm text-textPrimary", children: L }),
        We(z, {
          components: {
            h1({ children: Ye }) {
              return /* @__PURE__ */ l("h4", { className: "text-headingsm", children: Ye });
            },
            h2({ children: Ye }) {
              return /* @__PURE__ */ l("h4", { className: "text-headingsm", children: Ye });
            },
            h3({ children: Ye }) {
              return /* @__PURE__ */ l("h4", { className: "text-headingsm", children: Ye });
            },
            h4({ children: Ye }) {
              return /* @__PURE__ */ l("h4", { className: "text-headingsm", children: Ye });
            }
          },
          ordinanceLink: c
        })
      ] }, H);
    }) });
  }, A = () => /* @__PURE__ */ C(he, { children: [
    /* @__PURE__ */ l("div", { className: _("w-full border-b", d.border) }),
    /* @__PURE__ */ l(_s, { collapsible: !0, type: "single", children: /* @__PURE__ */ C(as, { className: "border-b-0", value: "detailed-analysis", children: [
      /* @__PURE__ */ l(Vs, { className: "!py-0", children: /* @__PURE__ */ C("div", { className: "text-left", children: [
        /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary", children: "Detailed analysis" }),
        /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: "Breakdown by the zone, overlays, and other controls relevant to your proposal." })
      ] }) }),
      /* @__PURE__ */ l(ls, { className: "!pb-0 pt-5", children: /* @__PURE__ */ l(yr, { maxHeight: 300, children: b() }) })
    ] }) })
  ] }), w = () => {
    if (Y && !X && !F && !o)
      return /* @__PURE__ */ C(he, { children: [
        /* @__PURE__ */ l("div", { className: _("w-full border-b", d.border) }),
        /* @__PURE__ */ l(er, { className: "w-min", onClick: s, children: "Check exemption criteria" })
      ] });
  }, S = () => {
    if (Y && !X && !F && !o)
      return /* @__PURE__ */ C(he, { children: [
        /* @__PURE__ */ l("div", { className: _("w-full border-b", d.border) }),
        /* @__PURE__ */ C("div", { children: [
          /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary mb-1", children: "Ready to apply?" }),
          /* @__PURE__ */ l("p", { className: "text-bodymd text-textPrimary mb-3", children: "Check what information you'll need to provide to council when you apply." }),
          /* @__PURE__ */ l(er, { className: "w-min", onClick: u, children: "Check application requirements" })
        ] })
      ] });
  }, N = () => {
    if (Y && F)
      return /* @__PURE__ */ C(he, { children: [
        /* @__PURE__ */ l("div", { className: _("w-full border-b", d.border) }),
        /* @__PURE__ */ C("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ l(
            "h2",
            {
              className: "text-headinglg text-textPrimary",
              id: "application-requirements",
              children: "Application requirements"
            }
          ),
          /* @__PURE__ */ l(
            cv,
            {
              configPrefix: e,
              conversation: r,
              noticeboardData: n,
              ordinanceLink: c
            }
          ),
          /* @__PURE__ */ l(
            Fv,
            {
              configPrefix: e,
              conversation: r,
              noticeboardData: n,
              ordinanceLink: c
            }
          )
        ] })
      ] });
  }, O = () => {
    var E, I, R, H;
    switch (q) {
      case Te.NoPermitRequired:
        return /* @__PURE__ */ C("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ C("div", { className: "flex flex-col gap-1", children: [
            ((E = r == null ? void 0 : r.address_data) == null ? void 0 : E.lga_name) !== "Sunshine Coast" ? /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary", children: "Why your proposal likely doesn't require a planning permit." }) : null,
            p()
          ] }),
          y(),
          A()
        ] });
      case Te.MoreInformationRequired:
        return /* @__PURE__ */ C("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ C("div", { className: "flex flex-col gap-1", children: [
            ((I = r == null ? void 0 : r.address_data) == null ? void 0 : I.lga_name) !== "Sunshine Coast" ? /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary", children: "Why a planning permit could be required" }) : null,
            p()
          ] }),
          y(),
          A(),
          w(),
          N()
        ] });
      case Te.RequiresPermit:
        return /* @__PURE__ */ C("div", { className: "flex flex-col gap-6", children: [
          /* @__PURE__ */ C("div", { className: "flex flex-col gap-1", children: [
            ((R = r == null ? void 0 : r.address_data) == null ? void 0 : R.lga_name) !== "Sunshine Coast" ? /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary", children: "Why a permit is likely required" }) : null,
            p()
          ] }),
          y(),
          A(),
          N(),
          S()
        ] });
      case Te.Prohibited:
        return /* @__PURE__ */ l("div", { className: "flex flex-col gap-6", children: /* @__PURE__ */ C("div", { className: "flex flex-col gap-1", children: [
          ((H = r == null ? void 0 : r.address_data) == null ? void 0 : H.lga_name) !== "Sunshine Coast" ? /* @__PURE__ */ l("h2", { className: "text-headingmd text-textPrimary", children: "Why your proposal is likely prohibited" }) : null,
          p()
        ] }) });
    }
  };
  return /* @__PURE__ */ C(
    "div",
    {
      className: _(
        "flex flex-col gap-6 rounded-lg border border-l-[12px] p-5 md:p-8",
        d.border,
        d.bgLight
      ),
      "data-testid": "assessment-report",
      children: [
        /* @__PURE__ */ l("h2", { className: "text-textPrimary text-heading2xl font-medium", children: i2(r, n, e) }),
        O()
      ]
    }
  );
}
function Wo(e, r = []) {
  let t = [];
  function i(s, u) {
    const o = h.createContext(u), d = t.length;
    t = [...t, u];
    function a(c) {
      const { scope: F, children: X, ...Y } = c, q = (F == null ? void 0 : F[e][d]) || o, f = h.useMemo(() => Y, Object.values(Y));
      return /* @__PURE__ */ l(q.Provider, { value: f, children: X });
    }
    function V(c, F) {
      const X = (F == null ? void 0 : F[e][d]) || o, Y = h.useContext(X);
      if (Y) return Y;
      if (u !== void 0) return u;
      throw new Error(`\`${c}\` must be used within \`${s}\``);
    }
    return a.displayName = s + "Provider", [a, V];
  }
  const n = () => {
    const s = t.map((u) => h.createContext(u));
    return function(o) {
      const d = (o == null ? void 0 : o[e]) || s;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: d } }),
        [o, d]
      );
    };
  };
  return n.scopeName = e, [i, kce(n, ...r)];
}
function kce(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const t = () => {
    const i = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(s) {
      const u = i.reduce((o, { useScope: d, scopeName: a }) => {
        const c = d(s)[`__scope${a}`];
        return { ...o, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${r.scopeName}`]: u }), [u]);
    };
  };
  return t.scopeName = r.scopeName, t;
}
function Oce(e, r) {
  typeof e == "function" ? e(r) : e != null && (e.current = r);
}
function PR(...e) {
  return (r) => e.forEach((t) => Oce(t, r));
}
function rr(...e) {
  return h.useCallback(PR(...e), e);
}
var yV = h.forwardRef((e, r) => {
  const { children: t, ...i } = e, n = h.Children.toArray(t), s = n.find(Rce);
  if (s) {
    const u = s.props.children, o = n.map((d) => d === s ? h.Children.count(u) > 1 ? h.Children.only(null) : h.isValidElement(u) ? u.props.children : null : d);
    return /* @__PURE__ */ l(xv, { ...i, ref: r, children: h.isValidElement(u) ? h.cloneElement(u, void 0, o) : null });
  }
  return /* @__PURE__ */ l(xv, { ...i, ref: r, children: t });
});
yV.displayName = "Slot";
var xv = h.forwardRef((e, r) => {
  const { children: t, ...i } = e;
  if (h.isValidElement(t)) {
    const n = Lce(t);
    return h.cloneElement(t, {
      ...Ice(i, t.props),
      // @ts-ignore
      ref: r ? PR(r, n) : n
    });
  }
  return h.Children.count(t) > 1 ? h.Children.only(null) : null;
});
xv.displayName = "SlotClone";
var Dce = ({ children: e }) => /* @__PURE__ */ l(he, { children: e });
function Rce(e) {
  return h.isValidElement(e) && e.type === Dce;
}
function Ice(e, r) {
  const t = { ...r };
  for (const i in r) {
    const n = e[i], s = r[i];
    /^on[A-Z]/.test(i) ? n && s ? t[i] = (...o) => {
      s(...o), n(...o);
    } : n && (t[i] = n) : i === "style" ? t[i] = { ...n, ...s } : i === "className" && (t[i] = [n, s].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function Lce(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
function Lq(e) {
  const r = e + "CollectionProvider", [t, i] = Wo(r), [n, s] = t(
    r,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), u = (X) => {
    const { scope: Y, children: q } = X, f = D.useRef(null), p = D.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ l(n, { scope: Y, itemMap: p, collectionRef: f, children: q });
  };
  u.displayName = r;
  const o = e + "CollectionSlot", d = D.forwardRef(
    (X, Y) => {
      const { scope: q, children: f } = X, p = s(o, q), m = rr(Y, p.collectionRef);
      return /* @__PURE__ */ l(yV, { ref: m, children: f });
    }
  );
  d.displayName = o;
  const a = e + "CollectionItemSlot", V = "data-radix-collection-item", c = D.forwardRef(
    (X, Y) => {
      const { scope: q, children: f, ...p } = X, m = D.useRef(null), g = rr(Y, m), y = s(a, q);
      return D.useEffect(() => (y.itemMap.set(m, { ref: m, ...p }), () => void y.itemMap.delete(m))), /* @__PURE__ */ l(yV, { [V]: "", ref: g, children: f });
    }
  );
  c.displayName = a;
  function F(X) {
    const Y = s(e + "CollectionConsumer", X);
    return D.useCallback(() => {
      const f = Y.collectionRef.current;
      if (!f) return [];
      const p = Array.from(f.querySelectorAll(`[${V}]`));
      return Array.from(Y.itemMap.values()).sort(
        (y, b) => p.indexOf(y.ref.current) - p.indexOf(b.ref.current)
      );
    }, [Y.collectionRef, Y.itemMap]);
  }
  return [
    { Provider: u, Slot: d, ItemSlot: c },
    F,
    i
  ];
}
function Ne(e, r, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), t === !1 || !n.defaultPrevented)
      return r == null ? void 0 : r(n);
  };
}
function Ee(e) {
  const r = h.useRef(e);
  return h.useEffect(() => {
    r.current = e;
  }), h.useMemo(() => (...t) => {
    var i;
    return (i = r.current) == null ? void 0 : i.call(r, ...t);
  }, []);
}
function Gr({
  prop: e,
  defaultProp: r,
  onChange: t = () => {
  }
}) {
  const [i, n] = _ce({ defaultProp: r, onChange: t }), s = e !== void 0, u = s ? e : i, o = Ee(t), d = h.useCallback(
    (a) => {
      if (s) {
        const c = typeof a == "function" ? a(e) : a;
        c !== e && o(c);
      } else
        n(a);
    },
    [s, e, n, o]
  );
  return [u, d];
}
function _ce({
  defaultProp: e,
  onChange: r
}) {
  const t = h.useState(e), [i] = t, n = h.useRef(i), s = Ee(r);
  return h.useEffect(() => {
    n.current !== i && (s(i), n.current = i);
  }, [i, n, s]), t;
}
var Hce = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Me = Hce.reduce((e, r) => {
  const t = h.forwardRef((i, n) => {
    const { asChild: s, ...u } = i, o = s ? yV : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l(o, { ...u, ref: n });
  });
  return t.displayName = `Primitive.${r}`, { ...e, [r]: t };
}, {});
function _q(e, r) {
  e && qs.flushSync(() => e.dispatchEvent(r));
}
var ze = globalThis != null && globalThis.document ? h.useLayoutEffect : () => {
};
function jce(e, r) {
  return h.useReducer((t, i) => r[t][i] ?? t, e);
}
var Hq = (e) => {
  const { present: r, children: t } = e, i = zce(r), n = typeof t == "function" ? t({ present: i.isPresent }) : h.Children.only(t), s = rr(i.ref, Bce(n));
  return typeof t == "function" || i.isPresent ? h.cloneElement(n, { ref: s }) : null;
};
Hq.displayName = "Presence";
function zce(e) {
  const [r, t] = h.useState(), i = h.useRef({}), n = h.useRef(e), s = h.useRef("none"), u = e ? "mounted" : "unmounted", [o, d] = jce(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return h.useEffect(() => {
    const a = NF(i.current);
    s.current = o === "mounted" ? a : "none";
  }, [o]), ze(() => {
    const a = i.current, V = n.current;
    if (V !== e) {
      const F = s.current, X = NF(a);
      e ? d("MOUNT") : X === "none" || (a == null ? void 0 : a.display) === "none" ? d("UNMOUNT") : d(V && F !== X ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, d]), ze(() => {
    if (r) {
      const a = (c) => {
        const X = NF(i.current).includes(c.animationName);
        c.target === r && X && qs.flushSync(() => d("ANIMATION_END"));
      }, V = (c) => {
        c.target === r && (s.current = NF(i.current));
      };
      return r.addEventListener("animationstart", V), r.addEventListener("animationcancel", a), r.addEventListener("animationend", a), () => {
        r.removeEventListener("animationstart", V), r.removeEventListener("animationcancel", a), r.removeEventListener("animationend", a);
      };
    } else
      d("ANIMATION_END");
  }, [r, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: h.useCallback((a) => {
      a && (i.current = getComputedStyle(a)), t(a);
    }, [])
  };
}
function NF(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Bce(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var Wce = h.useId || (() => {
}), Gce = 0;
function ot(e) {
  const [r, t] = h.useState(Wce());
  return ze(() => {
    t((i) => i ?? String(Gce++));
  }, [e]), r ? `radix-${r}` : "";
}
var Ny = "Collapsible", [Uce, SR] = Wo(Ny), [Zce, My] = Uce(Ny), NR = h.forwardRef(
  (e, r) => {
    const {
      __scopeCollapsible: t,
      open: i,
      defaultOpen: n,
      disabled: s,
      onOpenChange: u,
      ...o
    } = e, [d = !1, a] = Gr({
      prop: i,
      defaultProp: n,
      onChange: u
    });
    return /* @__PURE__ */ l(
      Zce,
      {
        scope: t,
        disabled: s,
        contentId: ot(),
        open: d,
        onOpenToggle: h.useCallback(() => a((V) => !V), [a]),
        children: /* @__PURE__ */ l(
          Me.div,
          {
            "data-state": Ey(d),
            "data-disabled": s ? "" : void 0,
            ...o,
            ref: r
          }
        )
      }
    );
  }
);
NR.displayName = Ny;
var MR = "CollapsibleTrigger", TR = h.forwardRef(
  (e, r) => {
    const { __scopeCollapsible: t, ...i } = e, n = My(MR, t);
    return /* @__PURE__ */ l(
      Me.button,
      {
        type: "button",
        "aria-controls": n.contentId,
        "aria-expanded": n.open || !1,
        "data-state": Ey(n.open),
        "data-disabled": n.disabled ? "" : void 0,
        disabled: n.disabled,
        ...i,
        ref: r,
        onClick: Ne(e.onClick, n.onOpenToggle)
      }
    );
  }
);
TR.displayName = MR;
var Ty = "CollapsibleContent", ER = h.forwardRef(
  (e, r) => {
    const { forceMount: t, ...i } = e, n = My(Ty, e.__scopeCollapsible);
    return /* @__PURE__ */ l(Hq, { present: t || n.open, children: ({ present: s }) => /* @__PURE__ */ l(Jce, { ...i, ref: r, present: s }) });
  }
);
ER.displayName = Ty;
var Jce = h.forwardRef((e, r) => {
  const { __scopeCollapsible: t, present: i, children: n, ...s } = e, u = My(Ty, t), [o, d] = h.useState(i), a = h.useRef(null), V = rr(r, a), c = h.useRef(0), F = c.current, X = h.useRef(0), Y = X.current, q = u.open || o, f = h.useRef(q), p = h.useRef();
  return h.useEffect(() => {
    const m = requestAnimationFrame(() => f.current = !1);
    return () => cancelAnimationFrame(m);
  }, []), ze(() => {
    const m = a.current;
    if (m) {
      p.current = p.current || {
        transitionDuration: m.style.transitionDuration,
        animationName: m.style.animationName
      }, m.style.transitionDuration = "0s", m.style.animationName = "none";
      const g = m.getBoundingClientRect();
      c.current = g.height, X.current = g.width, f.current || (m.style.transitionDuration = p.current.transitionDuration, m.style.animationName = p.current.animationName), d(i);
    }
  }, [u.open, i]), /* @__PURE__ */ l(
    Me.div,
    {
      "data-state": Ey(u.open),
      "data-disabled": u.disabled ? "" : void 0,
      id: u.contentId,
      hidden: !q,
      ...s,
      ref: V,
      style: {
        "--radix-collapsible-content-height": F ? `${F}px` : void 0,
        "--radix-collapsible-content-width": Y ? `${Y}px` : void 0,
        ...e.style
      },
      children: q && n
    }
  );
});
function Ey(e) {
  return e ? "open" : "closed";
}
var $ce = NR, Qce = TR, e7e = ER, r7e = h.createContext(void 0);
function Rn(e) {
  const r = h.useContext(r7e);
  return e || r || "ltr";
}
var ju = "Accordion", t7e = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [ky, i7e, n7e] = Lq(ju), [jq, vQe] = Wo(ju, [
  n7e,
  SR
]), Oy = SR(), kR = D.forwardRef(
  (e, r) => {
    const { type: t, ...i } = e, n = i, s = i;
    return /* @__PURE__ */ l(ky.Provider, { scope: e.__scopeAccordion, children: t === "multiple" ? /* @__PURE__ */ l(d7e, { ...s, ref: r }) : /* @__PURE__ */ l(o7e, { ...n, ref: r }) });
  }
);
kR.displayName = ju;
var [OR, s7e] = jq(ju), [DR, u7e] = jq(
  ju,
  { collapsible: !1 }
), o7e = D.forwardRef(
  (e, r) => {
    const {
      value: t,
      defaultValue: i,
      onValueChange: n = () => {
      },
      collapsible: s = !1,
      ...u
    } = e, [o, d] = Gr({
      prop: t,
      defaultProp: i,
      onChange: n
    });
    return /* @__PURE__ */ l(
      OR,
      {
        scope: e.__scopeAccordion,
        value: o ? [o] : [],
        onItemOpen: d,
        onItemClose: D.useCallback(() => s && d(""), [s, d]),
        children: /* @__PURE__ */ l(DR, { scope: e.__scopeAccordion, collapsible: s, children: /* @__PURE__ */ l(RR, { ...u, ref: r }) })
      }
    );
  }
), d7e = D.forwardRef((e, r) => {
  const {
    value: t,
    defaultValue: i,
    onValueChange: n = () => {
    },
    ...s
  } = e, [u = [], o] = Gr({
    prop: t,
    defaultProp: i,
    onChange: n
  }), d = D.useCallback(
    (V) => o((c = []) => [...c, V]),
    [o]
  ), a = D.useCallback(
    (V) => o((c = []) => c.filter((F) => F !== V)),
    [o]
  );
  return /* @__PURE__ */ l(
    OR,
    {
      scope: e.__scopeAccordion,
      value: u,
      onItemOpen: d,
      onItemClose: a,
      children: /* @__PURE__ */ l(DR, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ l(RR, { ...s, ref: r }) })
    }
  );
}), [a7e, zq] = jq(ju), RR = D.forwardRef(
  (e, r) => {
    const { __scopeAccordion: t, disabled: i, dir: n, orientation: s = "vertical", ...u } = e, o = D.useRef(null), d = rr(o, r), a = i7e(t), c = Rn(n) === "ltr", F = Ne(e.onKeyDown, (X) => {
      var S;
      if (!t7e.includes(X.key)) return;
      const Y = X.target, q = a().filter((N) => {
        var O;
        return !((O = N.ref.current) != null && O.disabled);
      }), f = q.findIndex((N) => N.ref.current === Y), p = q.length;
      if (f === -1) return;
      X.preventDefault();
      let m = f;
      const g = 0, y = p - 1, b = () => {
        m = f + 1, m > y && (m = g);
      }, A = () => {
        m = f - 1, m < g && (m = y);
      };
      switch (X.key) {
        case "Home":
          m = g;
          break;
        case "End":
          m = y;
          break;
        case "ArrowRight":
          s === "horizontal" && (c ? b() : A());
          break;
        case "ArrowDown":
          s === "vertical" && b();
          break;
        case "ArrowLeft":
          s === "horizontal" && (c ? A() : b());
          break;
        case "ArrowUp":
          s === "vertical" && A();
          break;
      }
      const w = m % p;
      (S = q[w].ref.current) == null || S.focus();
    });
    return /* @__PURE__ */ l(
      a7e,
      {
        scope: t,
        disabled: i,
        direction: n,
        orientation: s,
        children: /* @__PURE__ */ l(ky.Slot, { scope: t, children: /* @__PURE__ */ l(
          Me.div,
          {
            ...u,
            "data-orientation": s,
            ref: d,
            onKeyDown: i ? void 0 : F
          }
        ) })
      }
    );
  }
), $x = "AccordionItem", [V7e, Dy] = jq($x), IR = D.forwardRef(
  (e, r) => {
    const { __scopeAccordion: t, value: i, ...n } = e, s = zq($x, t), u = s7e($x, t), o = Oy(t), d = ot(), a = i && u.value.includes(i) || !1, V = s.disabled || e.disabled;
    return /* @__PURE__ */ l(
      V7e,
      {
        scope: t,
        open: a,
        disabled: V,
        triggerId: d,
        children: /* @__PURE__ */ l(
          $ce,
          {
            "data-orientation": s.orientation,
            "data-state": BR(a),
            ...o,
            ...n,
            ref: r,
            disabled: V,
            open: a,
            onOpenChange: (c) => {
              c ? u.onItemOpen(i) : u.onItemClose(i);
            }
          }
        )
      }
    );
  }
);
IR.displayName = $x;
var LR = "AccordionHeader", _R = D.forwardRef(
  (e, r) => {
    const { __scopeAccordion: t, ...i } = e, n = zq(ju, t), s = Dy(LR, t);
    return /* @__PURE__ */ l(
      Me.h3,
      {
        "data-orientation": n.orientation,
        "data-state": BR(s.open),
        "data-disabled": s.disabled ? "" : void 0,
        ...i,
        ref: r
      }
    );
  }
);
_R.displayName = LR;
var Xv = "AccordionTrigger", HR = D.forwardRef(
  (e, r) => {
    const { __scopeAccordion: t, ...i } = e, n = zq(ju, t), s = Dy(Xv, t), u = u7e(Xv, t), o = Oy(t);
    return /* @__PURE__ */ l(ky.ItemSlot, { scope: t, children: /* @__PURE__ */ l(
      Qce,
      {
        "aria-disabled": s.open && !u.collapsible || void 0,
        "data-orientation": n.orientation,
        id: s.triggerId,
        ...o,
        ...i,
        ref: r
      }
    ) });
  }
);
HR.displayName = Xv;
var jR = "AccordionContent", zR = D.forwardRef(
  (e, r) => {
    const { __scopeAccordion: t, ...i } = e, n = zq(ju, t), s = Dy(jR, t), u = Oy(t);
    return /* @__PURE__ */ l(
      e7e,
      {
        role: "region",
        "aria-labelledby": s.triggerId,
        "data-orientation": n.orientation,
        ...u,
        ...i,
        ref: r,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
zR.displayName = jR;
function BR(e) {
  return e ? "open" : "closed";
}
var l7e = kR, c7e = IR, F7e = _R, WR = HR, GR = zR;
const _s = l7e, as = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  c7e,
  {
    ref: t,
    className: _("not-last:border-b border-border", e),
    ...r
  }
));
as.displayName = "AccordionItem";
const Vs = re(({ className: e, children: r, ...t }, i) => /* @__PURE__ */ l(F7e, { className: "flex", children: /* @__PURE__ */ C(
  WR,
  {
    ref: i,
    className: _(
      "flex flex-1 items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180",
      e
    ),
    ...t,
    children: [
      r,
      /* @__PURE__ */ l(
        e2,
        {
          "data-open-indicator": !0,
          className: "min-h-4 min-w-4 transition-transform duration-200"
        }
      )
    ]
  }
) }));
Vs.displayName = WR.displayName;
const ls = re(({ className: e, children: r, ...t }, i) => /* @__PURE__ */ l(
  GR,
  {
    ref: i,
    className: "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down text-bodysm overflow-hidden transition-all",
    ...t,
    children: /* @__PURE__ */ l("div", { className: _("pb-4 pt-0", e), children: r })
  }
));
ls.displayName = GR.displayName;
function bQe({
  onSelectSuggestion: e,
  placeholder: r,
  selectedAddressId: t
}) {
  var f;
  const [i, n] = ie(!1), s = Yi(() => n(!0), []), u = Yi(() => n(!1), []), [o, d] = ie(""), a = (p) => {
    p.key === "Escape" && u();
  }, {
    data: V,
    mutate: c,
    isPending: F
  } = kae(), X = Cae(o, 500);
  Pe(() => {
    X && c({
      body: { address: X }
    });
  }, [X, c]);
  const Y = $e(() => {
    var p;
    return ((p = V == null ? void 0 : V.data) == null ? void 0 : p.suggestions) || [];
  }, [(f = V == null ? void 0 : V.data) == null ? void 0 : f.suggestions]), q = $e(() => {
    if (!(!t || !Array.isArray(Y)))
      return Y.find(
        (p) => p.address_id === t
      );
  }, [Y, t]);
  return /* @__PURE__ */ C(
    hl,
    {
      className: "h-auto overflow-visible",
      onKeyDown: a,
      shouldFilter: !1,
      children: [
        /* @__PURE__ */ l("div", { className: "bg-background ring-offset-background focus-within:ring-ring text-bodymd flex w-full items-center justify-between rounded-lg border focus-within:ring-2 focus-within:ring-offset-2", children: q ? /* @__PURE__ */ C("div", { className: "flex w-full cursor-pointer items-center py-3 pr-3", children: [
          /* @__PURE__ */ l("span", { className: "w-full grow px-3", children: q.address }),
          /* @__PURE__ */ l(r2, { onClick: () => e("") })
        ] }) : /* @__PURE__ */ l(
          ui.Input,
          {
            className: _("w-full p-3 outline-none"),
            onBlur: u,
            onFocus: s,
            onValueChange: d,
            placeholder: r || "Enter address",
            value: o
          }
        ) }),
        /* @__PURE__ */ l("div", { className: "animate-in fade-in-0 zoom-in-95 relative h-auto", children: /* @__PURE__ */ l(a2, { children: i && /* @__PURE__ */ l("div", { className: "absolute top-1.5 z-50 w-full", children: /* @__PURE__ */ C(V2, { className: "bg-background relative z-50 h-auto min-w-[8rem] overflow-hidden rounded-md border shadow-md", children: [
          F ? /* @__PURE__ */ l("div", { className: "flex h-28 items-center justify-center", children: /* @__PURE__ */ l(Zs, { className: "size-6 animate-spin" }) }) : /* @__PURE__ */ l(he, { children: Y.map((p) => /* @__PURE__ */ l(
            l2,
            {
              className: "aria-selected:bg-accent aria-selected:text-accent-foreground hover:bg-accent hover:text-accent-foreground flex h-max cursor-pointer select-text flex-col items-start gap-0.5 rounded-md p-2 px-3",
              onMouseDown: (m) => m.preventDefault(),
              onSelect: () => {
                d(""), e(p.address_id), u();
              },
              value: p.address,
              children: p.address
            },
            p.address_id
          )) }),
          /* @__PURE__ */ l(a3, { children: !F && Y.length === 0 && /* @__PURE__ */ l("div", { className: "flex items-center justify-center py-4", children: o === "" ? "Please enter an address" : "No address found" }) })
        ] }) }) }) })
      ]
    }
  );
}
const e9 = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, r9 = ur, Js = (e, r) => (t) => {
  var i;
  if ((r == null ? void 0 : r.variants) == null) return r9(e, t == null ? void 0 : t.class, t == null ? void 0 : t.className);
  const { variants: n, defaultVariants: s } = r, u = Object.keys(n).map((a) => {
    const V = t == null ? void 0 : t[a], c = s == null ? void 0 : s[a];
    if (V === null) return null;
    const F = e9(V) || e9(c);
    return n[a][F];
  }), o = t && Object.entries(t).reduce((a, V) => {
    let [c, F] = V;
    return F === void 0 || (a[c] = F), a;
  }, {}), d = r == null || (i = r.compoundVariants) === null || i === void 0 ? void 0 : i.reduce((a, V) => {
    let { class: c, className: F, ...X } = V;
    return Object.entries(X).every((Y) => {
      let [q, f] = Y;
      return Array.isArray(f) ? f.includes({
        ...s,
        ...o
      }[q]) : {
        ...s,
        ...o
      }[q] === f;
    }) ? [
      ...a,
      c,
      F
    ] : a;
  }, []);
  return r9(e, u, d, t == null ? void 0 : t.class, t == null ? void 0 : t.className);
}, x7e = Js(
  "relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), X7e = re(({ className: e, variant: r, ...t }, i) => /* @__PURE__ */ l(
  "div",
  {
    ref: i,
    role: "alert",
    className: _(x7e({ variant: r }), e),
    ...t
  }
));
X7e.displayName = "Alert";
const q7e = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "h5",
  {
    ref: t,
    className: _(
      "mb-1 font-medium leading-none tracking-tight",
      e
    ),
    ...r
  }
));
q7e.displayName = "AlertTitle";
const Y7e = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "div",
  {
    ref: t,
    className: _("text-bodysm [&_p]:leading-relaxed", e),
    ...r
  }
));
Y7e.displayName = "AlertDescription";
function f7e(e, r) {
  const t = h.createContext(r), i = (s) => {
    const { children: u, ...o } = s, d = h.useMemo(() => o, Object.values(o));
    return /* @__PURE__ */ l(t.Provider, { value: d, children: u });
  };
  i.displayName = e + "Provider";
  function n(s) {
    const u = h.useContext(t);
    if (u) return u;
    if (r !== void 0) return r;
    throw new Error(`\`${s}\` must be used within \`${e}\``);
  }
  return [i, n];
}
function UR(e, r = []) {
  let t = [];
  function i(s, u) {
    const o = h.createContext(u), d = t.length;
    t = [...t, u];
    const a = (c) => {
      var p;
      const { scope: F, children: X, ...Y } = c, q = ((p = F == null ? void 0 : F[e]) == null ? void 0 : p[d]) || o, f = h.useMemo(() => Y, Object.values(Y));
      return /* @__PURE__ */ l(q.Provider, { value: f, children: X });
    };
    a.displayName = s + "Provider";
    function V(c, F) {
      var q;
      const X = ((q = F == null ? void 0 : F[e]) == null ? void 0 : q[d]) || o, Y = h.useContext(X);
      if (Y) return Y;
      if (u !== void 0) return u;
      throw new Error(`\`${c}\` must be used within \`${s}\``);
    }
    return [a, V];
  }
  const n = () => {
    const s = t.map((u) => h.createContext(u));
    return function(o) {
      const d = (o == null ? void 0 : o[e]) || s;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: d } }),
        [o, d]
      );
    };
  };
  return n.scopeName = e, [i, K7e(n, ...r)];
}
function K7e(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const t = () => {
    const i = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(s) {
      const u = i.reduce((o, { useScope: d, scopeName: a }) => {
        const c = d(s)[`__scope${a}`];
        return { ...o, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${r.scopeName}`]: u }), [u]);
    };
  };
  return t.scopeName = r.scopeName, t;
}
function t9(e, r) {
  if (typeof e == "function")
    return e(r);
  e != null && (e.current = r);
}
function ZR(...e) {
  return (r) => {
    let t = !1;
    const i = e.map((n) => {
      const s = t9(n, r);
      return !t && typeof s == "function" && (t = !0), s;
    });
    if (t)
      return () => {
        for (let n = 0; n < i.length; n++) {
          const s = i[n];
          typeof s == "function" ? s() : t9(e[n], null);
        }
      };
  };
}
function zu(...e) {
  return h.useCallback(ZR(...e), e);
}
function wu(e, r, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), t === !1 || !n.defaultPrevented)
      return r == null ? void 0 : r(n);
  };
}
var Ry = h.forwardRef((e, r) => {
  const { children: t, ...i } = e, n = h.Children.toArray(t), s = n.find(h7e);
  if (s) {
    const u = s.props.children, o = n.map((d) => d === s ? h.Children.count(u) > 1 ? h.Children.only(null) : h.isValidElement(u) ? u.props.children : null : d);
    return /* @__PURE__ */ l(qv, { ...i, ref: r, children: h.isValidElement(u) ? h.cloneElement(u, void 0, o) : null });
  }
  return /* @__PURE__ */ l(qv, { ...i, ref: r, children: t });
});
Ry.displayName = "Slot";
var qv = h.forwardRef((e, r) => {
  const { children: t, ...i } = e;
  if (h.isValidElement(t)) {
    const n = m7e(t);
    return h.cloneElement(t, {
      ...p7e(i, t.props),
      // @ts-ignore
      ref: r ? ZR(r, n) : n
    });
  }
  return h.Children.count(t) > 1 ? h.Children.only(null) : null;
});
qv.displayName = "SlotClone";
var JR = ({ children: e }) => /* @__PURE__ */ l(he, { children: e });
function h7e(e) {
  return h.isValidElement(e) && e.type === JR;
}
function p7e(e, r) {
  const t = { ...r };
  for (const i in r) {
    const n = e[i], s = r[i];
    /^on[A-Z]/.test(i) ? n && s ? t[i] = (...o) => {
      s(...o), n(...o);
    } : n && (t[i] = n) : i === "style" ? t[i] = { ...n, ...s } : i === "className" && (t[i] = [n, s].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function m7e(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var g7e = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Bu = g7e.reduce((e, r) => {
  const t = h.forwardRef((i, n) => {
    const { asChild: s, ...u } = i, o = s ? Ry : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l(o, { ...u, ref: n });
  });
  return t.displayName = `Primitive.${r}`, { ...e, [r]: t };
}, {});
function v7e(e, r) {
  e && qs.flushSync(() => e.dispatchEvent(r));
}
function oa(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Ee(e);
  h.useEffect(() => {
    const i = (n) => {
      n.key === "Escape" && t(n);
    };
    return r.addEventListener("keydown", i, { capture: !0 }), () => r.removeEventListener("keydown", i, { capture: !0 });
  }, [t, r]);
}
var b7e = "DismissableLayer", Yv = "dismissableLayer.update", y7e = "dismissableLayer.pointerDownOutside", A7e = "dismissableLayer.focusOutside", i9, $R = h.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), QR = h.forwardRef(
  (e, r) => {
    const {
      disableOutsidePointerEvents: t = !1,
      onEscapeKeyDown: i,
      onPointerDownOutside: n,
      onFocusOutside: s,
      onInteractOutside: u,
      onDismiss: o,
      ...d
    } = e, a = h.useContext($R), [V, c] = h.useState(null), F = (V == null ? void 0 : V.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, X] = h.useState({}), Y = zu(r, (w) => c(w)), q = Array.from(a.layers), [f] = [...a.layersWithOutsidePointerEventsDisabled].slice(-1), p = q.indexOf(f), m = V ? q.indexOf(V) : -1, g = a.layersWithOutsidePointerEventsDisabled.size > 0, y = m >= p, b = P7e((w) => {
      const S = w.target, N = [...a.branches].some((O) => O.contains(S));
      !y || N || (n == null || n(w), u == null || u(w), w.defaultPrevented || o == null || o());
    }, F), A = S7e((w) => {
      const S = w.target;
      [...a.branches].some((O) => O.contains(S)) || (s == null || s(w), u == null || u(w), w.defaultPrevented || o == null || o());
    }, F);
    return oa((w) => {
      m === a.layers.size - 1 && (i == null || i(w), !w.defaultPrevented && o && (w.preventDefault(), o()));
    }, F), h.useEffect(() => {
      if (V)
        return t && (a.layersWithOutsidePointerEventsDisabled.size === 0 && (i9 = F.body.style.pointerEvents, F.body.style.pointerEvents = "none"), a.layersWithOutsidePointerEventsDisabled.add(V)), a.layers.add(V), n9(), () => {
          t && a.layersWithOutsidePointerEventsDisabled.size === 1 && (F.body.style.pointerEvents = i9);
        };
    }, [V, F, t, a]), h.useEffect(() => () => {
      V && (a.layers.delete(V), a.layersWithOutsidePointerEventsDisabled.delete(V), n9());
    }, [V, a]), h.useEffect(() => {
      const w = () => X({});
      return document.addEventListener(Yv, w), () => document.removeEventListener(Yv, w);
    }, []), /* @__PURE__ */ l(
      Bu.div,
      {
        ...d,
        ref: Y,
        style: {
          pointerEvents: g ? y ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: wu(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: wu(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: wu(
          e.onPointerDownCapture,
          b.onPointerDownCapture
        )
      }
    );
  }
);
QR.displayName = b7e;
var w7e = "DismissableLayerBranch", C7e = h.forwardRef((e, r) => {
  const t = h.useContext($R), i = h.useRef(null), n = zu(r, i);
  return h.useEffect(() => {
    const s = i.current;
    if (s)
      return t.branches.add(s), () => {
        t.branches.delete(s);
      };
  }, [t.branches]), /* @__PURE__ */ l(Bu.div, { ...e, ref: n });
});
C7e.displayName = w7e;
function P7e(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Ee(e), i = h.useRef(!1), n = h.useRef(() => {
  });
  return h.useEffect(() => {
    const s = (o) => {
      if (o.target && !i.current) {
        let d = function() {
          eI(
            y7e,
            t,
            a,
            { discrete: !0 }
          );
        };
        const a = { originalEvent: o };
        o.pointerType === "touch" ? (r.removeEventListener("click", n.current), n.current = d, r.addEventListener("click", n.current, { once: !0 })) : d();
      } else
        r.removeEventListener("click", n.current);
      i.current = !1;
    }, u = window.setTimeout(() => {
      r.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(u), r.removeEventListener("pointerdown", s), r.removeEventListener("click", n.current);
    };
  }, [r, t]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => i.current = !0
  };
}
function S7e(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Ee(e), i = h.useRef(!1);
  return h.useEffect(() => {
    const n = (s) => {
      s.target && !i.current && eI(A7e, t, { originalEvent: s }, {
        discrete: !1
      });
    };
    return r.addEventListener("focusin", n), () => r.removeEventListener("focusin", n);
  }, [r, t]), {
    onFocusCapture: () => i.current = !0,
    onBlurCapture: () => i.current = !1
  };
}
function n9() {
  const e = new CustomEvent(Yv);
  document.dispatchEvent(e);
}
function eI(e, r, t, { discrete: i }) {
  const n = t.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: t });
  r && n.addEventListener(e, r, { once: !0 }), i ? v7e(n, s) : n.dispatchEvent(s);
}
var bh = "focusScope.autoFocusOnMount", yh = "focusScope.autoFocusOnUnmount", s9 = { bubbles: !1, cancelable: !0 }, N7e = "FocusScope", rI = h.forwardRef((e, r) => {
  const {
    loop: t = !1,
    trapped: i = !1,
    onMountAutoFocus: n,
    onUnmountAutoFocus: s,
    ...u
  } = e, [o, d] = h.useState(null), a = Ee(n), V = Ee(s), c = h.useRef(null), F = zu(r, (q) => d(q)), X = h.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  h.useEffect(() => {
    if (i) {
      let q = function(g) {
        if (X.paused || !o) return;
        const y = g.target;
        o.contains(y) ? c.current = y : lo(c.current, { select: !0 });
      }, f = function(g) {
        if (X.paused || !o) return;
        const y = g.relatedTarget;
        y !== null && (o.contains(y) || lo(c.current, { select: !0 }));
      }, p = function(g) {
        if (document.activeElement === document.body)
          for (const b of g)
            b.removedNodes.length > 0 && lo(o);
      };
      document.addEventListener("focusin", q), document.addEventListener("focusout", f);
      const m = new MutationObserver(p);
      return o && m.observe(o, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", q), document.removeEventListener("focusout", f), m.disconnect();
      };
    }
  }, [i, o, X.paused]), h.useEffect(() => {
    if (o) {
      o9.add(X);
      const q = document.activeElement;
      if (!o.contains(q)) {
        const p = new CustomEvent(bh, s9);
        o.addEventListener(bh, a), o.dispatchEvent(p), p.defaultPrevented || (M7e(D7e(tI(o)), { select: !0 }), document.activeElement === q && lo(o));
      }
      return () => {
        o.removeEventListener(bh, a), setTimeout(() => {
          const p = new CustomEvent(yh, s9);
          o.addEventListener(yh, V), o.dispatchEvent(p), p.defaultPrevented || lo(q ?? document.body, { select: !0 }), o.removeEventListener(yh, V), o9.remove(X);
        }, 0);
      };
    }
  }, [o, a, V, X]);
  const Y = h.useCallback(
    (q) => {
      if (!t && !i || X.paused) return;
      const f = q.key === "Tab" && !q.altKey && !q.ctrlKey && !q.metaKey, p = document.activeElement;
      if (f && p) {
        const m = q.currentTarget, [g, y] = T7e(m);
        g && y ? !q.shiftKey && p === y ? (q.preventDefault(), t && lo(g, { select: !0 })) : q.shiftKey && p === g && (q.preventDefault(), t && lo(y, { select: !0 })) : p === m && q.preventDefault();
      }
    },
    [t, i, X.paused]
  );
  return /* @__PURE__ */ l(Bu.div, { tabIndex: -1, ...u, ref: F, onKeyDown: Y });
});
rI.displayName = N7e;
function M7e(e, { select: r = !1 } = {}) {
  const t = document.activeElement;
  for (const i of e)
    if (lo(i, { select: r }), document.activeElement !== t) return;
}
function T7e(e) {
  const r = tI(e), t = u9(r, e), i = u9(r.reverse(), e);
  return [t, i];
}
function tI(e) {
  const r = [], t = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (i) => {
      const n = i.tagName === "INPUT" && i.type === "hidden";
      return i.disabled || i.hidden || n ? NodeFilter.FILTER_SKIP : i.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); ) r.push(t.currentNode);
  return r;
}
function u9(e, r) {
  for (const t of e)
    if (!E7e(t, { upTo: r })) return t;
}
function E7e(e, { upTo: r }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (r !== void 0 && e === r) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function k7e(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function lo(e, { select: r = !1 } = {}) {
  if (e && e.focus) {
    const t = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== t && k7e(e) && r && e.select();
  }
}
var o9 = O7e();
function O7e() {
  let e = [];
  return {
    add(r) {
      const t = e[0];
      r !== t && (t == null || t.pause()), e = d9(e, r), e.unshift(r);
    },
    remove(r) {
      var t;
      e = d9(e, r), (t = e[0]) == null || t.resume();
    }
  };
}
function d9(e, r) {
  const t = [...e], i = t.indexOf(r);
  return i !== -1 && t.splice(i, 1), t;
}
function D7e(e) {
  return e.filter((r) => r.tagName !== "A");
}
var R7e = "Portal", iI = h.forwardRef((e, r) => {
  var o;
  const { container: t, ...i } = e, [n, s] = h.useState(!1);
  ze(() => s(!0), []);
  const u = t || n && ((o = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : o.body);
  return u ? Us.createPortal(/* @__PURE__ */ l(Bu.div, { ...i, ref: r }), u) : null;
});
iI.displayName = R7e;
function I7e(e, r) {
  return h.useReducer((t, i) => r[t][i] ?? t, e);
}
var Bq = (e) => {
  const { present: r, children: t } = e, i = L7e(r), n = typeof t == "function" ? t({ present: i.isPresent }) : h.Children.only(t), s = zu(i.ref, _7e(n));
  return typeof t == "function" || i.isPresent ? h.cloneElement(n, { ref: s }) : null;
};
Bq.displayName = "Presence";
function L7e(e) {
  const [r, t] = h.useState(), i = h.useRef({}), n = h.useRef(e), s = h.useRef("none"), u = e ? "mounted" : "unmounted", [o, d] = I7e(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return h.useEffect(() => {
    const a = MF(i.current);
    s.current = o === "mounted" ? a : "none";
  }, [o]), ze(() => {
    const a = i.current, V = n.current;
    if (V !== e) {
      const F = s.current, X = MF(a);
      e ? d("MOUNT") : X === "none" || (a == null ? void 0 : a.display) === "none" ? d("UNMOUNT") : d(V && F !== X ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, d]), ze(() => {
    if (r) {
      let a;
      const V = r.ownerDocument.defaultView ?? window, c = (X) => {
        const q = MF(i.current).includes(X.animationName);
        if (X.target === r && q && (d("ANIMATION_END"), !n.current)) {
          const f = r.style.animationFillMode;
          r.style.animationFillMode = "forwards", a = V.setTimeout(() => {
            r.style.animationFillMode === "forwards" && (r.style.animationFillMode = f);
          });
        }
      }, F = (X) => {
        X.target === r && (s.current = MF(i.current));
      };
      return r.addEventListener("animationstart", F), r.addEventListener("animationcancel", c), r.addEventListener("animationend", c), () => {
        V.clearTimeout(a), r.removeEventListener("animationstart", F), r.removeEventListener("animationcancel", c), r.removeEventListener("animationend", c);
      };
    } else
      d("ANIMATION_END");
  }, [r, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: h.useCallback((a) => {
      a && (i.current = getComputedStyle(a)), t(a);
    }, [])
  };
}
function MF(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function _7e(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var Ah = 0;
function Iy() {
  h.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? a9()), document.body.insertAdjacentElement("beforeend", e[1] ?? a9()), Ah++, () => {
      Ah === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((r) => r.remove()), Ah--;
    };
  }, []);
}
function a9() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Ge = function() {
  return Ge = Object.assign || function(r) {
    for (var t, i = 1, n = arguments.length; i < n; i++) {
      t = arguments[i];
      for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (r[s] = t[s]);
    }
    return r;
  }, Ge.apply(this, arguments);
};
function $s(e, r) {
  var t = {};
  for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && r.indexOf(i) < 0 && (t[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, i = Object.getOwnPropertySymbols(e); n < i.length; n++)
      r.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (t[i[n]] = e[i[n]]);
  return t;
}
function Yl(e, r, t) {
  if (t || arguments.length === 2) for (var i = 0, n = r.length, s; i < n; i++)
    (s || !(i in r)) && (s || (s = Array.prototype.slice.call(r, 0, i)), s[i] = r[i]);
  return e.concat(s || Array.prototype.slice.call(r));
}
var Tx = "right-scroll-bar-position", Ex = "width-before-scroll-bar", H7e = "with-scroll-bars-hidden", j7e = "--removed-body-scroll-bar-size";
function wh(e, r) {
  return typeof e == "function" ? e(r) : e && (e.current = r), e;
}
function z7e(e, r) {
  var t = ie(function() {
    return {
      // value
      value: e,
      // last callback
      callback: r,
      // "memoized" public interface
      facade: {
        get current() {
          return t.value;
        },
        set current(i) {
          var n = t.value;
          n !== i && (t.value = i, t.callback(i, n));
        }
      }
    };
  })[0];
  return t.callback = r, t.facade;
}
var B7e = typeof window < "u" ? h.useLayoutEffect : h.useEffect, V9 = /* @__PURE__ */ new WeakMap();
function W7e(e, r) {
  var t = z7e(null, function(i) {
    return e.forEach(function(n) {
      return wh(n, i);
    });
  });
  return B7e(function() {
    var i = V9.get(t);
    if (i) {
      var n = new Set(i), s = new Set(e), u = t.current;
      n.forEach(function(o) {
        s.has(o) || wh(o, null);
      }), s.forEach(function(o) {
        n.has(o) || wh(o, u);
      });
    }
    V9.set(t, e);
  }, [e]), t;
}
function G7e(e) {
  return e;
}
function U7e(e, r) {
  r === void 0 && (r = G7e);
  var t = [], i = !1, n = {
    read: function() {
      if (i)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return t.length ? t[t.length - 1] : e;
    },
    useMedium: function(s) {
      var u = r(s, i);
      return t.push(u), function() {
        t = t.filter(function(o) {
          return o !== u;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (i = !0; t.length; ) {
        var u = t;
        t = [], u.forEach(s);
      }
      t = {
        push: function(o) {
          return s(o);
        },
        filter: function() {
          return t;
        }
      };
    },
    assignMedium: function(s) {
      i = !0;
      var u = [];
      if (t.length) {
        var o = t;
        t = [], o.forEach(s), u = t;
      }
      var d = function() {
        var V = u;
        u = [], V.forEach(s);
      }, a = function() {
        return Promise.resolve().then(d);
      };
      a(), t = {
        push: function(V) {
          u.push(V), a();
        },
        filter: function(V) {
          return u = u.filter(V), t;
        }
      };
    }
  };
  return n;
}
function Z7e(e) {
  e === void 0 && (e = {});
  var r = U7e(null);
  return r.options = Ge({ async: !0, ssr: !1 }, e), r;
}
var nI = function(e) {
  var r = e.sideCar, t = $s(e, ["sideCar"]);
  if (!r)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var i = r.read();
  if (!i)
    throw new Error("Sidecar medium not found");
  return h.createElement(i, Ge({}, t));
};
nI.isSideCarExport = !0;
function J7e(e, r) {
  return e.useMedium(r), nI;
}
var sI = Z7e(), Ch = function() {
}, Wq = h.forwardRef(function(e, r) {
  var t = h.useRef(null), i = h.useState({
    onScrollCapture: Ch,
    onWheelCapture: Ch,
    onTouchMoveCapture: Ch
  }), n = i[0], s = i[1], u = e.forwardProps, o = e.children, d = e.className, a = e.removeScrollBar, V = e.enabled, c = e.shards, F = e.sideCar, X = e.noIsolation, Y = e.inert, q = e.allowPinchZoom, f = e.as, p = f === void 0 ? "div" : f, m = e.gapMode, g = $s(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), y = F, b = W7e([t, r]), A = Ge(Ge({}, g), n);
  return h.createElement(
    h.Fragment,
    null,
    V && h.createElement(y, { sideCar: sI, removeScrollBar: a, shards: c, noIsolation: X, inert: Y, setCallbacks: s, allowPinchZoom: !!q, lockRef: t, gapMode: m }),
    u ? h.cloneElement(h.Children.only(o), Ge(Ge({}, A), { ref: b })) : h.createElement(p, Ge({}, A, { className: d, ref: b }), o)
  );
});
Wq.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Wq.classNames = {
  fullWidth: Ex,
  zeroRight: Tx
};
var Gq = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function $7e() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var r = Gq();
  return r && e.setAttribute("nonce", r), e;
}
function Q7e(e, r) {
  e.styleSheet ? e.styleSheet.cssText = r : e.appendChild(document.createTextNode(r));
}
function e2e(e) {
  var r = document.head || document.getElementsByTagName("head")[0];
  r.appendChild(e);
}
var r2e = function() {
  var e = 0, r = null;
  return {
    add: function(t) {
      e == 0 && (r = $7e()) && (Q7e(r, t), e2e(r)), e++;
    },
    remove: function() {
      e--, !e && r && (r.parentNode && r.parentNode.removeChild(r), r = null);
    }
  };
}, t2e = function() {
  var e = r2e();
  return function(r, t) {
    h.useEffect(function() {
      return e.add(r), function() {
        e.remove();
      };
    }, [r && t]);
  };
}, uI = function() {
  var e = t2e(), r = function(t) {
    var i = t.styles, n = t.dynamic;
    return e(i, n), null;
  };
  return r;
}, i2e = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Ph = function(e) {
  return parseInt(e || "", 10) || 0;
}, n2e = function(e) {
  var r = window.getComputedStyle(document.body), t = r[e === "padding" ? "paddingLeft" : "marginLeft"], i = r[e === "padding" ? "paddingTop" : "marginTop"], n = r[e === "padding" ? "paddingRight" : "marginRight"];
  return [Ph(t), Ph(i), Ph(n)];
}, s2e = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return i2e;
  var r = n2e(e), t = document.documentElement.clientWidth, i = window.innerWidth;
  return {
    left: r[0],
    top: r[1],
    right: r[2],
    gap: Math.max(0, i - t + r[2] - r[0])
  };
}, u2e = uI(), dV = "data-scroll-locked", o2e = function(e, r, t, i) {
  var n = e.left, s = e.top, u = e.right, o = e.gap;
  return t === void 0 && (t = "margin"), `
  .`.concat(H7e, ` {
   overflow: hidden `).concat(i, `;
   padding-right: `).concat(o, "px ").concat(i, `;
  }
  body[`).concat(dV, `] {
    overflow: hidden `).concat(i, `;
    overscroll-behavior: contain;
    `).concat([
    r && "position: relative ".concat(i, ";"),
    t === "margin" && `
    padding-left: `.concat(n, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(u, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(o, "px ").concat(i, `;
    `),
    t === "padding" && "padding-right: ".concat(o, "px ").concat(i, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Tx, ` {
    right: `).concat(o, "px ").concat(i, `;
  }
  
  .`).concat(Ex, ` {
    margin-right: `).concat(o, "px ").concat(i, `;
  }
  
  .`).concat(Tx, " .").concat(Tx, ` {
    right: 0 `).concat(i, `;
  }
  
  .`).concat(Ex, " .").concat(Ex, ` {
    margin-right: 0 `).concat(i, `;
  }
  
  body[`).concat(dV, `] {
    `).concat(j7e, ": ").concat(o, `px;
  }
`);
}, l9 = function() {
  var e = parseInt(document.body.getAttribute(dV) || "0", 10);
  return isFinite(e) ? e : 0;
}, d2e = function() {
  h.useEffect(function() {
    return document.body.setAttribute(dV, (l9() + 1).toString()), function() {
      var e = l9() - 1;
      e <= 0 ? document.body.removeAttribute(dV) : document.body.setAttribute(dV, e.toString());
    };
  }, []);
}, a2e = function(e) {
  var r = e.noRelative, t = e.noImportant, i = e.gapMode, n = i === void 0 ? "margin" : i;
  d2e();
  var s = h.useMemo(function() {
    return s2e(n);
  }, [n]);
  return h.createElement(u2e, { styles: o2e(s, !r, n, t ? "" : "!important") });
}, fv = !1;
if (typeof window < "u")
  try {
    var TF = Object.defineProperty({}, "passive", {
      get: function() {
        return fv = !0, !0;
      }
    });
    window.addEventListener("test", TF, TF), window.removeEventListener("test", TF, TF);
  } catch {
    fv = !1;
  }
var Ta = fv ? { passive: !1 } : !1, V2e = function(e) {
  return e.tagName === "TEXTAREA";
}, oI = function(e, r) {
  if (!(e instanceof Element))
    return !1;
  var t = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    t[r] !== "hidden" && // contains scroll inside self
    !(t.overflowY === t.overflowX && !V2e(e) && t[r] === "visible")
  );
}, l2e = function(e) {
  return oI(e, "overflowY");
}, c2e = function(e) {
  return oI(e, "overflowX");
}, c9 = function(e, r) {
  var t = r.ownerDocument, i = r;
  do {
    typeof ShadowRoot < "u" && i instanceof ShadowRoot && (i = i.host);
    var n = dI(e, i);
    if (n) {
      var s = aI(e, i), u = s[1], o = s[2];
      if (u > o)
        return !0;
    }
    i = i.parentNode;
  } while (i && i !== t.body);
  return !1;
}, F2e = function(e) {
  var r = e.scrollTop, t = e.scrollHeight, i = e.clientHeight;
  return [
    r,
    t,
    i
  ];
}, x2e = function(e) {
  var r = e.scrollLeft, t = e.scrollWidth, i = e.clientWidth;
  return [
    r,
    t,
    i
  ];
}, dI = function(e, r) {
  return e === "v" ? l2e(r) : c2e(r);
}, aI = function(e, r) {
  return e === "v" ? F2e(r) : x2e(r);
}, X2e = function(e, r) {
  return e === "h" && r === "rtl" ? -1 : 1;
}, q2e = function(e, r, t, i, n) {
  var s = X2e(e, window.getComputedStyle(r).direction), u = s * i, o = t.target, d = r.contains(o), a = !1, V = u > 0, c = 0, F = 0;
  do {
    var X = aI(e, o), Y = X[0], q = X[1], f = X[2], p = q - f - s * Y;
    (Y || p) && dI(e, o) && (c += p, F += Y), o instanceof ShadowRoot ? o = o.host : o = o.parentNode;
  } while (
    // portaled content
    !d && o !== document.body || // self content
    d && (r.contains(o) || r === o)
  );
  return (V && Math.abs(c) < 1 || !V && Math.abs(F) < 1) && (a = !0), a;
}, EF = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, F9 = function(e) {
  return [e.deltaX, e.deltaY];
}, x9 = function(e) {
  return e && "current" in e ? e.current : e;
}, Y2e = function(e, r) {
  return e[0] === r[0] && e[1] === r[1];
}, f2e = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, K2e = 0, Ea = [];
function h2e(e) {
  var r = h.useRef([]), t = h.useRef([0, 0]), i = h.useRef(), n = h.useState(K2e++)[0], s = h.useState(uI)[0], u = h.useRef(e);
  h.useEffect(function() {
    u.current = e;
  }, [e]), h.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(n));
      var q = Yl([e.lockRef.current], (e.shards || []).map(x9), !0).filter(Boolean);
      return q.forEach(function(f) {
        return f.classList.add("allow-interactivity-".concat(n));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(n)), q.forEach(function(f) {
          return f.classList.remove("allow-interactivity-".concat(n));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var o = h.useCallback(function(q, f) {
    if ("touches" in q && q.touches.length === 2 || q.type === "wheel" && q.ctrlKey)
      return !u.current.allowPinchZoom;
    var p = EF(q), m = t.current, g = "deltaX" in q ? q.deltaX : m[0] - p[0], y = "deltaY" in q ? q.deltaY : m[1] - p[1], b, A = q.target, w = Math.abs(g) > Math.abs(y) ? "h" : "v";
    if ("touches" in q && w === "h" && A.type === "range")
      return !1;
    var S = c9(w, A);
    if (!S)
      return !0;
    if (S ? b = w : (b = w === "v" ? "h" : "v", S = c9(w, A)), !S)
      return !1;
    if (!i.current && "changedTouches" in q && (g || y) && (i.current = b), !b)
      return !0;
    var N = i.current || b;
    return q2e(N, f, q, N === "h" ? g : y);
  }, []), d = h.useCallback(function(q) {
    var f = q;
    if (!(!Ea.length || Ea[Ea.length - 1] !== s)) {
      var p = "deltaY" in f ? F9(f) : EF(f), m = r.current.filter(function(b) {
        return b.name === f.type && (b.target === f.target || f.target === b.shadowParent) && Y2e(b.delta, p);
      })[0];
      if (m && m.should) {
        f.cancelable && f.preventDefault();
        return;
      }
      if (!m) {
        var g = (u.current.shards || []).map(x9).filter(Boolean).filter(function(b) {
          return b.contains(f.target);
        }), y = g.length > 0 ? o(f, g[0]) : !u.current.noIsolation;
        y && f.cancelable && f.preventDefault();
      }
    }
  }, []), a = h.useCallback(function(q, f, p, m) {
    var g = { name: q, delta: f, target: p, should: m, shadowParent: p2e(p) };
    r.current.push(g), setTimeout(function() {
      r.current = r.current.filter(function(y) {
        return y !== g;
      });
    }, 1);
  }, []), V = h.useCallback(function(q) {
    t.current = EF(q), i.current = void 0;
  }, []), c = h.useCallback(function(q) {
    a(q.type, F9(q), q.target, o(q, e.lockRef.current));
  }, []), F = h.useCallback(function(q) {
    a(q.type, EF(q), q.target, o(q, e.lockRef.current));
  }, []);
  h.useEffect(function() {
    return Ea.push(s), e.setCallbacks({
      onScrollCapture: c,
      onWheelCapture: c,
      onTouchMoveCapture: F
    }), document.addEventListener("wheel", d, Ta), document.addEventListener("touchmove", d, Ta), document.addEventListener("touchstart", V, Ta), function() {
      Ea = Ea.filter(function(q) {
        return q !== s;
      }), document.removeEventListener("wheel", d, Ta), document.removeEventListener("touchmove", d, Ta), document.removeEventListener("touchstart", V, Ta);
    };
  }, []);
  var X = e.removeScrollBar, Y = e.inert;
  return h.createElement(
    h.Fragment,
    null,
    Y ? h.createElement(s, { styles: f2e(n) }) : null,
    X ? h.createElement(a2e, { gapMode: e.gapMode }) : null
  );
}
function p2e(e) {
  for (var r = null; e !== null; )
    e instanceof ShadowRoot && (r = e.host, e = e.host), e = e.parentNode;
  return r;
}
const m2e = J7e(sI, h2e);
var VI = h.forwardRef(function(e, r) {
  return h.createElement(Wq, Ge({}, e, { ref: r, sideCar: m2e }));
});
VI.classNames = Wq.classNames;
var g2e = function(e) {
  if (typeof document > "u")
    return null;
  var r = Array.isArray(e) ? e[0] : e;
  return r.ownerDocument.body;
}, ka = /* @__PURE__ */ new WeakMap(), kF = /* @__PURE__ */ new WeakMap(), OF = {}, Sh = 0, lI = function(e) {
  return e && (e.host || lI(e.parentNode));
}, v2e = function(e, r) {
  return r.map(function(t) {
    if (e.contains(t))
      return t;
    var i = lI(t);
    return i && e.contains(i) ? i : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(t) {
    return !!t;
  });
}, b2e = function(e, r, t, i) {
  var n = v2e(r, Array.isArray(e) ? e : [e]);
  OF[t] || (OF[t] = /* @__PURE__ */ new WeakMap());
  var s = OF[t], u = [], o = /* @__PURE__ */ new Set(), d = new Set(n), a = function(c) {
    !c || o.has(c) || (o.add(c), a(c.parentNode));
  };
  n.forEach(a);
  var V = function(c) {
    !c || d.has(c) || Array.prototype.forEach.call(c.children, function(F) {
      if (o.has(F))
        V(F);
      else
        try {
          var X = F.getAttribute(i), Y = X !== null && X !== "false", q = (ka.get(F) || 0) + 1, f = (s.get(F) || 0) + 1;
          ka.set(F, q), s.set(F, f), u.push(F), q === 1 && Y && kF.set(F, !0), f === 1 && F.setAttribute(t, "true"), Y || F.setAttribute(i, "true");
        } catch (p) {
          console.error("aria-hidden: cannot operate on ", F, p);
        }
    });
  };
  return V(r), o.clear(), Sh++, function() {
    u.forEach(function(c) {
      var F = ka.get(c) - 1, X = s.get(c) - 1;
      ka.set(c, F), s.set(c, X), F || (kF.has(c) || c.removeAttribute(i), kF.delete(c)), X || c.removeAttribute(t);
    }), Sh--, Sh || (ka = /* @__PURE__ */ new WeakMap(), ka = /* @__PURE__ */ new WeakMap(), kF = /* @__PURE__ */ new WeakMap(), OF = {});
  };
}, fl = function(e, r, t) {
  t === void 0 && (t = "data-aria-hidden");
  var i = Array.from(Array.isArray(e) ? e : [e]), n = g2e(e);
  return n ? (i.push.apply(i, Array.from(n.querySelectorAll("[aria-live]"))), b2e(i, n, t, "aria-hidden")) : function() {
    return null;
  };
}, Ly = "Dialog", [cI, FI] = UR(Ly), [y2e, Ys] = cI(Ly), xI = (e) => {
  const {
    __scopeDialog: r,
    children: t,
    open: i,
    defaultOpen: n,
    onOpenChange: s,
    modal: u = !0
  } = e, o = h.useRef(null), d = h.useRef(null), [a = !1, V] = Gr({
    prop: i,
    defaultProp: n,
    onChange: s
  });
  return /* @__PURE__ */ l(
    y2e,
    {
      scope: r,
      triggerRef: o,
      contentRef: d,
      contentId: ot(),
      titleId: ot(),
      descriptionId: ot(),
      open: a,
      onOpenChange: V,
      onOpenToggle: h.useCallback(() => V((c) => !c), [V]),
      modal: u,
      children: t
    }
  );
};
xI.displayName = Ly;
var XI = "DialogTrigger", qI = h.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, ...i } = e, n = Ys(XI, t), s = zu(r, n.triggerRef);
    return /* @__PURE__ */ l(
      Bu.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": n.open,
        "aria-controls": n.contentId,
        "data-state": jy(n.open),
        ...i,
        ref: s,
        onClick: wu(e.onClick, n.onOpenToggle)
      }
    );
  }
);
qI.displayName = XI;
var _y = "DialogPortal", [A2e, YI] = cI(_y, {
  forceMount: void 0
}), fI = (e) => {
  const { __scopeDialog: r, forceMount: t, children: i, container: n } = e, s = Ys(_y, r);
  return /* @__PURE__ */ l(A2e, { scope: r, forceMount: t, children: h.Children.map(i, (u) => /* @__PURE__ */ l(Bq, { present: t || s.open, children: /* @__PURE__ */ l(iI, { asChild: !0, container: n, children: u }) })) });
};
fI.displayName = _y;
var Qx = "DialogOverlay", KI = h.forwardRef(
  (e, r) => {
    const t = YI(Qx, e.__scopeDialog), { forceMount: i = t.forceMount, ...n } = e, s = Ys(Qx, e.__scopeDialog);
    return s.modal ? /* @__PURE__ */ l(Bq, { present: i || s.open, children: /* @__PURE__ */ l(w2e, { ...n, ref: r }) }) : null;
  }
);
KI.displayName = Qx;
var w2e = h.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, ...i } = e, n = Ys(Qx, t);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ l(VI, { as: Ry, allowPinchZoom: !0, shards: [n.contentRef], children: /* @__PURE__ */ l(
        Bu.div,
        {
          "data-state": jy(n.open),
          ...i,
          ref: r,
          style: { pointerEvents: "auto", ...i.style }
        }
      ) })
    );
  }
), Bd = "DialogContent", hI = h.forwardRef(
  (e, r) => {
    const t = YI(Bd, e.__scopeDialog), { forceMount: i = t.forceMount, ...n } = e, s = Ys(Bd, e.__scopeDialog);
    return /* @__PURE__ */ l(Bq, { present: i || s.open, children: s.modal ? /* @__PURE__ */ l(C2e, { ...n, ref: r }) : /* @__PURE__ */ l(P2e, { ...n, ref: r }) });
  }
);
hI.displayName = Bd;
var C2e = h.forwardRef(
  (e, r) => {
    const t = Ys(Bd, e.__scopeDialog), i = h.useRef(null), n = zu(r, t.contentRef, i);
    return h.useEffect(() => {
      const s = i.current;
      if (s) return fl(s);
    }, []), /* @__PURE__ */ l(
      pI,
      {
        ...e,
        ref: n,
        trapFocus: t.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: wu(e.onCloseAutoFocus, (s) => {
          var u;
          s.preventDefault(), (u = t.triggerRef.current) == null || u.focus();
        }),
        onPointerDownOutside: wu(e.onPointerDownOutside, (s) => {
          const u = s.detail.originalEvent, o = u.button === 0 && u.ctrlKey === !0;
          (u.button === 2 || o) && s.preventDefault();
        }),
        onFocusOutside: wu(
          e.onFocusOutside,
          (s) => s.preventDefault()
        )
      }
    );
  }
), P2e = h.forwardRef(
  (e, r) => {
    const t = Ys(Bd, e.__scopeDialog), i = h.useRef(!1), n = h.useRef(!1);
    return /* @__PURE__ */ l(
      pI,
      {
        ...e,
        ref: r,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var u, o;
          (u = e.onCloseAutoFocus) == null || u.call(e, s), s.defaultPrevented || (i.current || (o = t.triggerRef.current) == null || o.focus(), s.preventDefault()), i.current = !1, n.current = !1;
        },
        onInteractOutside: (s) => {
          var d, a;
          (d = e.onInteractOutside) == null || d.call(e, s), s.defaultPrevented || (i.current = !0, s.detail.originalEvent.type === "pointerdown" && (n.current = !0));
          const u = s.target;
          ((a = t.triggerRef.current) == null ? void 0 : a.contains(u)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && n.current && s.preventDefault();
        }
      }
    );
  }
), pI = h.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, trapFocus: i, onOpenAutoFocus: n, onCloseAutoFocus: s, ...u } = e, o = Ys(Bd, t), d = h.useRef(null), a = zu(r, d);
    return Iy(), /* @__PURE__ */ C(he, { children: [
      /* @__PURE__ */ l(
        rI,
        {
          asChild: !0,
          loop: !0,
          trapped: i,
          onMountAutoFocus: n,
          onUnmountAutoFocus: s,
          children: /* @__PURE__ */ l(
            QR,
            {
              role: "dialog",
              id: o.contentId,
              "aria-describedby": o.descriptionId,
              "aria-labelledby": o.titleId,
              "data-state": jy(o.open),
              ...u,
              ref: a,
              onDismiss: () => o.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ C(he, { children: [
        /* @__PURE__ */ l(N2e, { titleId: o.titleId }),
        /* @__PURE__ */ l(T2e, { contentRef: d, descriptionId: o.descriptionId })
      ] })
    ] });
  }
), Hy = "DialogTitle", mI = h.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, ...i } = e, n = Ys(Hy, t);
    return /* @__PURE__ */ l(Bu.h2, { id: n.titleId, ...i, ref: r });
  }
);
mI.displayName = Hy;
var gI = "DialogDescription", vI = h.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, ...i } = e, n = Ys(gI, t);
    return /* @__PURE__ */ l(Bu.p, { id: n.descriptionId, ...i, ref: r });
  }
);
vI.displayName = gI;
var bI = "DialogClose", yI = h.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, ...i } = e, n = Ys(bI, t);
    return /* @__PURE__ */ l(
      Bu.button,
      {
        type: "button",
        ...i,
        ref: r,
        onClick: wu(e.onClick, () => n.onOpenChange(!1))
      }
    );
  }
);
yI.displayName = bI;
function jy(e) {
  return e ? "open" : "closed";
}
var AI = "DialogTitleWarning", [S2e, wI] = f7e(AI, {
  contentName: Bd,
  titleName: Hy,
  docsSlug: "dialog"
}), N2e = ({ titleId: e }) => {
  const r = wI(AI), t = `\`${r.contentName}\` requires a \`${r.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${r.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${r.docsSlug}`;
  return h.useEffect(() => {
    e && (document.getElementById(e) || console.error(t));
  }, [t, e]), null;
}, M2e = "DialogDescriptionWarning", T2e = ({ contentRef: e, descriptionId: r }) => {
  const i = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${wI(M2e).contentName}}.`;
  return h.useEffect(() => {
    var s;
    const n = (s = e.current) == null ? void 0 : s.getAttribute("aria-describedby");
    r && n && (document.getElementById(r) || console.warn(i));
  }, [i, e, r]), null;
}, E2e = xI, k2e = qI, O2e = fI, D2e = KI, R2e = hI, I2e = mI, L2e = vI, CI = yI, PI = "AlertDialog", [_2e, yQe] = UR(PI, [
  FI
]), Wu = FI(), SI = (e) => {
  const { __scopeAlertDialog: r, ...t } = e, i = Wu(r);
  return /* @__PURE__ */ l(E2e, { ...i, ...t, modal: !0 });
};
SI.displayName = PI;
var H2e = "AlertDialogTrigger", NI = h.forwardRef(
  (e, r) => {
    const { __scopeAlertDialog: t, ...i } = e, n = Wu(t);
    return /* @__PURE__ */ l(k2e, { ...n, ...i, ref: r });
  }
);
NI.displayName = H2e;
var j2e = "AlertDialogPortal", MI = (e) => {
  const { __scopeAlertDialog: r, ...t } = e, i = Wu(r);
  return /* @__PURE__ */ l(O2e, { ...i, ...t });
};
MI.displayName = j2e;
var z2e = "AlertDialogOverlay", TI = h.forwardRef(
  (e, r) => {
    const { __scopeAlertDialog: t, ...i } = e, n = Wu(t);
    return /* @__PURE__ */ l(D2e, { ...n, ...i, ref: r });
  }
);
TI.displayName = z2e;
var aV = "AlertDialogContent", [B2e, W2e] = _2e(aV), EI = h.forwardRef(
  (e, r) => {
    const { __scopeAlertDialog: t, children: i, ...n } = e, s = Wu(t), u = h.useRef(null), o = zu(r, u), d = h.useRef(null);
    return /* @__PURE__ */ l(
      S2e,
      {
        contentName: aV,
        titleName: kI,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ l(B2e, { scope: t, cancelRef: d, children: /* @__PURE__ */ C(
          R2e,
          {
            role: "alertdialog",
            ...s,
            ...n,
            ref: o,
            onOpenAutoFocus: wu(n.onOpenAutoFocus, (a) => {
              var V;
              a.preventDefault(), (V = d.current) == null || V.focus({ preventScroll: !0 });
            }),
            onPointerDownOutside: (a) => a.preventDefault(),
            onInteractOutside: (a) => a.preventDefault(),
            children: [
              /* @__PURE__ */ l(JR, { children: i }),
              /* @__PURE__ */ l(U2e, { contentRef: u })
            ]
          }
        ) })
      }
    );
  }
);
EI.displayName = aV;
var kI = "AlertDialogTitle", OI = h.forwardRef(
  (e, r) => {
    const { __scopeAlertDialog: t, ...i } = e, n = Wu(t);
    return /* @__PURE__ */ l(I2e, { ...n, ...i, ref: r });
  }
);
OI.displayName = kI;
var DI = "AlertDialogDescription", RI = h.forwardRef((e, r) => {
  const { __scopeAlertDialog: t, ...i } = e, n = Wu(t);
  return /* @__PURE__ */ l(L2e, { ...n, ...i, ref: r });
});
RI.displayName = DI;
var G2e = "AlertDialogAction", II = h.forwardRef(
  (e, r) => {
    const { __scopeAlertDialog: t, ...i } = e, n = Wu(t);
    return /* @__PURE__ */ l(CI, { ...n, ...i, ref: r });
  }
);
II.displayName = G2e;
var LI = "AlertDialogCancel", _I = h.forwardRef(
  (e, r) => {
    const { __scopeAlertDialog: t, ...i } = e, { cancelRef: n } = W2e(LI, t), s = Wu(t), u = zu(r, n);
    return /* @__PURE__ */ l(CI, { ...s, ...i, ref: u });
  }
);
_I.displayName = LI;
var U2e = ({ contentRef: e }) => {
  const r = `\`${aV}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${aV}\` by passing a \`${DI}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${aV}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  return h.useEffect(() => {
    var i;
    document.getElementById(
      (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby")
    ) || console.warn(r);
  }, [r, e]), null;
}, Z2e = SI, J2e = NI, $2e = MI, HI = TI, jI = EI, zI = II, BI = _I, WI = OI, GI = RI;
const Q2e = Z2e, AQe = J2e, eFe = $2e, UI = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  HI,
  {
    className: _(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0  fixed inset-0 z-50 bg-black/25",
      e
    ),
    ...r,
    ref: t
  }
));
UI.displayName = HI.displayName;
const ZI = re(({ className: e, ...r }, t) => /* @__PURE__ */ C(eFe, { children: [
  /* @__PURE__ */ l(UI, {}),
  /* @__PURE__ */ l(
    jI,
    {
      ref: t,
      className: _(
        "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border p-6 shadow-lg duration-200 sm:rounded-lg",
        e
      ),
      ...r
    }
  )
] }));
ZI.displayName = jI.displayName;
const rFe = ({
  className: e,
  ...r
}) => /* @__PURE__ */ l(
  "div",
  {
    className: _(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...r
  }
);
rFe.displayName = "AlertDialogHeader";
const JI = ({
  className: e,
  ...r
}) => /* @__PURE__ */ l(
  "div",
  {
    className: _(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...r
  }
);
JI.displayName = "AlertDialogFooter";
const $I = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  WI,
  {
    ref: t,
    className: _("text-bodylg font-semibold", e),
    ...r
  }
));
$I.displayName = WI.displayName;
const tFe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  GI,
  {
    ref: t,
    className: _("text-muted-foreground text-bodysm", e),
    ...r
  }
));
tFe.displayName = GI.displayName;
const QI = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  zI,
  {
    ref: t,
    className: _(AV(), e),
    ...r
  }
));
QI.displayName = zI.displayName;
const iFe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  BI,
  {
    ref: t,
    className: _(
      AV({ variant: "outline" }),
      "mt-2 sm:mt-0",
      e
    ),
    ...r
  }
));
iFe.displayName = BI.displayName;
function wQe({
  className: e,
  onCompleteAnimation: r,
  pauseAnimation: t,
  text: i,
  textAnimationSpeed: n = 500
}) {
  const [s, u] = ie(i), [o, d] = ie(""), [a, V] = ie(0), c = Yr(null);
  return Pe(() => {
    u(i), d(""), V(0), c.current && clearTimeout(c.current);
  }, [i]), Pe(() => {
    if (!t)
      return c.current = setTimeout(() => {
        d((F) => F + (s[a] || "")), V((F) => F + 1);
      }, n), () => {
        c.current && clearTimeout(c.current);
      };
  }, [a, s, t, n]), Pe(() => {
    a > s.length && (d(""), V(0), s.length > 0 && r && r());
  }, [a, r, s]), /* @__PURE__ */ l("div", { className: e, children: o || /* @__PURE__ */ l(he, { children: " " }) });
}
function Kv() {
  return Kv = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t) ({}).hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Kv.apply(null, arguments);
}
function nFe(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e) if ({}.hasOwnProperty.call(e, i)) {
    if (r.includes(i)) continue;
    t[i] = e[i];
  }
  return t;
}
var sFe = Eq, uFe = function(r) {
  var t = h.useRef(r);
  return sFe(function() {
    t.current = r;
  }), t;
}, X9 = function(r, t) {
  if (typeof r == "function") {
    r(t);
    return;
  }
  r.current = t;
}, oFe = function(r, t) {
  var i = Yr();
  return Yi(function(n) {
    r.current = n, i.current && X9(i.current, null), i.current = t, t && X9(t, n);
  }, [t]);
}, q9 = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0",
  display: "block"
}, dFe = function(r) {
  Object.keys(q9).forEach(function(t) {
    r.style.setProperty(t, q9[t], "important");
  });
}, Y9 = dFe, vi = null, f9 = function(r, t) {
  var i = r.scrollHeight;
  return t.sizingStyle.boxSizing === "border-box" ? i + t.borderSize : i - t.paddingSize;
};
function aFe(e, r, t, i) {
  t === void 0 && (t = 1), i === void 0 && (i = 1 / 0), vi || (vi = document.createElement("textarea"), vi.setAttribute("tabindex", "-1"), vi.setAttribute("aria-hidden", "true"), Y9(vi)), vi.parentNode === null && document.body.appendChild(vi);
  var n = e.paddingSize, s = e.borderSize, u = e.sizingStyle, o = u.boxSizing;
  Object.keys(u).forEach(function(F) {
    var X = F;
    vi.style[X] = u[X];
  }), Y9(vi), vi.value = r;
  var d = f9(vi, e);
  vi.value = r, d = f9(vi, e), vi.value = "x";
  var a = vi.scrollHeight - n, V = a * t;
  o === "border-box" && (V = V + n + s), d = Math.max(V, d);
  var c = a * i;
  return o === "border-box" && (c = c + n + s), d = Math.min(c, d), [d, a];
}
var K9 = function() {
}, VFe = function(r, t) {
  return r.reduce(function(i, n) {
    return i[n] = t[n], i;
  }, {});
}, lFe = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak",
  "wordSpacing",
  "scrollbarGutter"
], cFe = !!document.documentElement.currentStyle, FFe = function(r) {
  var t = window.getComputedStyle(r);
  if (t === null)
    return null;
  var i = VFe(lFe, t), n = i.boxSizing;
  if (n === "")
    return null;
  cFe && n === "border-box" && (i.width = parseFloat(i.width) + parseFloat(i.borderRightWidth) + parseFloat(i.borderLeftWidth) + parseFloat(i.paddingRight) + parseFloat(i.paddingLeft) + "px");
  var s = parseFloat(i.paddingBottom) + parseFloat(i.paddingTop), u = parseFloat(i.borderBottomWidth) + parseFloat(i.borderTopWidth);
  return {
    sizingStyle: i,
    paddingSize: s,
    borderSize: u
  };
}, xFe = FFe;
function zy(e, r, t) {
  var i = uFe(t);
  h.useLayoutEffect(function() {
    var n = function(u) {
      return i.current(u);
    };
    if (e)
      return e.addEventListener(r, n), function() {
        return e.removeEventListener(r, n);
      };
  }, []);
}
var XFe = function(r, t) {
  zy(document.body, "reset", function(i) {
    r.current.form === i.target && t(i);
  });
}, qFe = function(r) {
  zy(window, "resize", r);
}, YFe = function(r) {
  zy(document.fonts, "loadingdone", r);
}, fFe = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], KFe = function(r, t) {
  var i = r.cacheMeasurements, n = r.maxRows, s = r.minRows, u = r.onChange, o = u === void 0 ? K9 : u, d = r.onHeightChange, a = d === void 0 ? K9 : d, V = nFe(r, fFe), c = V.value !== void 0, F = h.useRef(null), X = oFe(F, t), Y = h.useRef(0), q = h.useRef(), f = function() {
    var g = F.current, y = i && q.current ? q.current : xFe(g);
    if (y) {
      q.current = y;
      var b = aFe(y, g.value || g.placeholder || "x", s, n), A = b[0], w = b[1];
      Y.current !== A && (Y.current = A, g.style.setProperty("height", A + "px", "important"), a(A, {
        rowHeight: w
      }));
    }
  }, p = function(g) {
    c || f(), o(g);
  };
  return h.useLayoutEffect(f), XFe(F, function() {
    if (!c) {
      var m = F.current.value;
      requestAnimationFrame(function() {
        var g = F.current;
        g && m !== g.value && f();
      });
    }
  }), qFe(f), YFe(f), /* @__PURE__ */ h.createElement("textarea", Kv({}, V, {
    onChange: p,
    ref: X
  }));
}, Cu = /* @__PURE__ */ h.forwardRef(KFe);
const eL = re(
  ({ className: e, ...r }, t) => /* @__PURE__ */ l(
    Cu,
    {
      className: _(
        "border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring focus-visible:outline-hidden flex min-h-[80px] w-full rounded-md border px-3 py-2 text-[1rem] leading-[1.25rem] placeholder:text-[1rem] placeholder:leading-[1.25rem] focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: t,
      ...r
    }
  )
);
eL.displayName = "AutoResizeTextarea";
function h9(e, r) {
  if (typeof e == "function")
    return e(r);
  e != null && (e.current = r);
}
function hFe(...e) {
  return (r) => {
    let t = !1;
    const i = e.map((n) => {
      const s = h9(n, r);
      return !t && typeof s == "function" && (t = !0), s;
    });
    if (t)
      return () => {
        for (let n = 0; n < i.length; n++) {
          const s = i[n];
          typeof s == "function" ? s() : h9(e[n], null);
        }
      };
  };
}
var xn = h.forwardRef((e, r) => {
  const { children: t, ...i } = e, n = h.Children.toArray(t), s = n.find(mFe);
  if (s) {
    const u = s.props.children, o = n.map((d) => d === s ? h.Children.count(u) > 1 ? h.Children.only(null) : h.isValidElement(u) ? u.props.children : null : d);
    return /* @__PURE__ */ l(hv, { ...i, ref: r, children: h.isValidElement(u) ? h.cloneElement(u, void 0, o) : null });
  }
  return /* @__PURE__ */ l(hv, { ...i, ref: r, children: t });
});
xn.displayName = "Slot";
var hv = h.forwardRef((e, r) => {
  const { children: t, ...i } = e;
  if (h.isValidElement(t)) {
    const n = vFe(t);
    return h.cloneElement(t, {
      ...gFe(i, t.props),
      // @ts-ignore
      ref: r ? hFe(r, n) : n
    });
  }
  return h.Children.count(t) > 1 ? h.Children.only(null) : null;
});
hv.displayName = "SlotClone";
var pFe = ({ children: e }) => /* @__PURE__ */ l(he, { children: e });
function mFe(e) {
  return h.isValidElement(e) && e.type === pFe;
}
function gFe(e, r) {
  const t = { ...r };
  for (const i in r) {
    const n = e[i], s = r[i];
    /^on[A-Z]/.test(i) ? n && s ? t[i] = (...o) => {
      s(...o), n(...o);
    } : n && (t[i] = n) : i === "style" ? t[i] = { ...n, ...s } : i === "className" && (t[i] = [n, s].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function vFe(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
const AV = Js(
  "cursor-pointer inline-flex items-center justify-center whitespace-nowrap rounded-md text-headingmd font-normal ring-offset-background transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 gap-2 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "bg-background border border-blueDefault text-blueDefault hover:bg-blueBgLight",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-textLink underline-offset-4 hover:underline",
        plain: ""
      },
      size: {
        default: "h-10 px-4 py-2",
        xs: "px-2 py-1 text-headingxs",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
        tight: ""
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), er = re(
  ({ className: e, variant: r, size: t, asChild: i = !1, ...n }, s) => /* @__PURE__ */ l(
    i ? xn : "button",
    {
      className: _(AV({ variant: r, size: t }), e),
      ref: s,
      ...n
    }
  )
);
er.displayName = "Button";
const bFe = Js(
  "inline-flex items-center rounded-full border border-border px-2.5 py-0.5 text-bodysm font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function Pt({ className: e, variant: r, ...t }) {
  return /* @__PURE__ */ l("div", { className: _(bFe({ variant: r }), e), ...t });
}
var Be = function() {
  return Be = Object.assign || function(r) {
    for (var t, i = 1, n = arguments.length; i < n; i++) {
      t = arguments[i];
      for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (r[s] = t[s]);
    }
    return r;
  }, Be.apply(this, arguments);
};
function yFe(e, r) {
  var t = {};
  for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && r.indexOf(i) < 0 && (t[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, i = Object.getOwnPropertySymbols(e); n < i.length; n++)
      r.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (t[i[n]] = e[i[n]]);
  return t;
}
function rL(e, r, t) {
  for (var i = 0, n = r.length, s; i < n; i++)
    (s || !(i in r)) && (s || (s = Array.prototype.slice.call(r, 0, i)), s[i] = r[i]);
  return e.concat(s || Array.prototype.slice.call(r));
}
function n2(e) {
  return e.mode === "multiple";
}
function s2(e) {
  return e.mode === "range";
}
function Uq(e) {
  return e.mode === "single";
}
var AFe = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function wFe(e, r) {
  return ut(e, "LLLL y", r);
}
function CFe(e, r) {
  return ut(e, "d", r);
}
function PFe(e, r) {
  return ut(e, "LLLL", r);
}
function SFe(e) {
  return "".concat(e);
}
function NFe(e, r) {
  return ut(e, "cccccc", r);
}
function MFe(e, r) {
  return ut(e, "yyyy", r);
}
var TFe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: wFe,
  formatDay: CFe,
  formatMonthCaption: PFe,
  formatWeekNumber: SFe,
  formatWeekdayName: NFe,
  formatYearCaption: MFe
}), EFe = function(e, r, t) {
  return ut(e, "do MMMM (EEEE)", t);
}, kFe = function() {
  return "Month: ";
}, OFe = function() {
  return "Go to next month";
}, DFe = function() {
  return "Go to previous month";
}, RFe = function(e, r) {
  return ut(e, "cccc", r);
}, IFe = function(e) {
  return "Week n. ".concat(e);
}, LFe = function() {
  return "Year: ";
}, _Fe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: EFe,
  labelMonthDropdown: kFe,
  labelNext: OFe,
  labelPrevious: DFe,
  labelWeekNumber: IFe,
  labelWeekday: RFe,
  labelYearDropdown: LFe
});
function HFe() {
  var e = "buttons", r = AFe, t = pR, i = {}, n = {}, s = 1, u = {}, o = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: r,
    formatters: TFe,
    labels: _Fe,
    locale: t,
    modifiersClassNames: i,
    modifiers: n,
    numberOfMonths: s,
    styles: u,
    today: o,
    mode: "default"
  };
}
function jFe(e) {
  var r = e.fromYear, t = e.toYear, i = e.fromMonth, n = e.toMonth, s = e.fromDate, u = e.toDate;
  return i ? s = ji(i) : r && (s = new Date(r, 0, 1)), n ? u = gy(n) : t && (u = new Date(t, 11, 31)), {
    fromDate: s ? zd(s) : void 0,
    toDate: u ? zd(u) : void 0
  };
}
var tL = et(void 0);
function zFe(e) {
  var r, t = e.initialProps, i = HFe(), n = jFe(t), s = n.fromDate, u = n.toDate, o = (r = t.captionLayout) !== null && r !== void 0 ? r : i.captionLayout;
  o !== "buttons" && (!s || !u) && (o = "buttons");
  var d;
  (Uq(t) || n2(t) || s2(t)) && (d = t.onSelect);
  var a = Be(Be(Be({}, i), t), { captionLayout: o, classNames: Be(Be({}, i.classNames), t.classNames), components: Be({}, t.components), formatters: Be(Be({}, i.formatters), t.formatters), fromDate: s, labels: Be(Be({}, i.labels), t.labels), mode: t.mode || i.mode, modifiers: Be(Be({}, i.modifiers), t.modifiers), modifiersClassNames: Be(Be({}, i.modifiersClassNames), t.modifiersClassNames), onSelect: d, styles: Be(Be({}, i.styles), t.styles), toDate: u });
  return l(tL.Provider, { value: a, children: e.children });
}
function Zr() {
  var e = rt(tL);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function iL(e) {
  var r = Zr(), t = r.locale, i = r.classNames, n = r.styles, s = r.formatters.formatCaption;
  return l("div", { className: i.caption_label, style: n.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: s(e.displayMonth, { locale: t }) });
}
function BFe(e) {
  return l("svg", Be({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: l("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function nL(e) {
  var r, t, i = e.onChange, n = e.value, s = e.children, u = e.caption, o = e.className, d = e.style, a = Zr(), V = (t = (r = a.components) === null || r === void 0 ? void 0 : r.IconDropdown) !== null && t !== void 0 ? t : BFe;
  return C("div", { className: o, style: d, children: [l("span", { className: a.classNames.vhidden, children: e["aria-label"] }), l("select", { name: e.name, "aria-label": e["aria-label"], className: a.classNames.dropdown, style: a.styles.dropdown, value: n, onChange: i, children: s }), C("div", { className: a.classNames.caption_label, style: a.styles.caption_label, "aria-hidden": "true", children: [u, l(V, { className: a.classNames.dropdown_icon, style: a.styles.dropdown_icon })] })] });
}
function WFe(e) {
  var r, t = Zr(), i = t.fromDate, n = t.toDate, s = t.styles, u = t.locale, o = t.formatters.formatMonthCaption, d = t.classNames, a = t.components, V = t.labels.labelMonthDropdown;
  if (!i)
    return l(he, {});
  if (!n)
    return l(he, {});
  var c = [];
  if (zle(i, n))
    for (var F = ji(i), X = i.getMonth(); X <= n.getMonth(); X++)
      c.push(Mx(F, X));
  else
    for (var F = ji(/* @__PURE__ */ new Date()), X = 0; X <= 11; X++)
      c.push(Mx(F, X));
  var Y = function(f) {
    var p = Number(f.target.value), m = Mx(ji(e.displayMonth), p);
    e.onChange(m);
  }, q = (r = a == null ? void 0 : a.Dropdown) !== null && r !== void 0 ? r : nL;
  return l(q, { name: "months", "aria-label": V(), className: d.dropdown_month, style: s.dropdown_month, onChange: Y, value: e.displayMonth.getMonth(), caption: o(e.displayMonth, { locale: u }), children: c.map(function(f) {
    return l("option", { value: f.getMonth(), children: o(f, { locale: u }) }, f.getMonth());
  }) });
}
function GFe(e) {
  var r, t = e.displayMonth, i = Zr(), n = i.fromDate, s = i.toDate, u = i.locale, o = i.styles, d = i.classNames, a = i.components, V = i.formatters.formatYearCaption, c = i.labels.labelYearDropdown, F = [];
  if (!n)
    return l(he, {});
  if (!s)
    return l(he, {});
  for (var X = n.getFullYear(), Y = s.getFullYear(), q = X; q <= Y; q++)
    F.push(Zw(KR(/* @__PURE__ */ new Date()), q));
  var f = function(m) {
    var g = Zw(ji(t), Number(m.target.value));
    e.onChange(g);
  }, p = (r = a == null ? void 0 : a.Dropdown) !== null && r !== void 0 ? r : nL;
  return l(p, { name: "years", "aria-label": c(), className: d.dropdown_year, style: o.dropdown_year, onChange: f, value: t.getFullYear(), caption: V(t, { locale: u }), children: F.map(function(m) {
    return l("option", { value: m.getFullYear(), children: V(m, { locale: u }) }, m.getFullYear());
  }) });
}
function UFe(e, r) {
  var t = ie(e), i = t[0], n = t[1], s = r === void 0 ? i : r;
  return [s, n];
}
function ZFe(e) {
  var r = e.month, t = e.defaultMonth, i = e.today, n = r || t || i || /* @__PURE__ */ new Date(), s = e.toDate, u = e.fromDate, o = e.numberOfMonths, d = o === void 0 ? 1 : o;
  if (s && Uc(s, n) < 0) {
    var a = -1 * (d - 1);
    n = us(s, a);
  }
  return u && Uc(n, u) < 0 && (n = u), ji(n);
}
function JFe() {
  var e = Zr(), r = ZFe(e), t = UFe(r, e.month), i = t[0], n = t[1], s = function(u) {
    var o;
    if (!e.disableNavigation) {
      var d = ji(u);
      n(d), (o = e.onMonthChange) === null || o === void 0 || o.call(e, d);
    }
  };
  return [i, s];
}
function $Fe(e, r) {
  for (var t = r.reverseMonths, i = r.numberOfMonths, n = ji(e), s = ji(us(n, i)), u = Uc(s, n), o = [], d = 0; d < u; d++) {
    var a = us(n, d);
    o.push(a);
  }
  return t && (o = o.reverse()), o;
}
function QFe(e, r) {
  if (!r.disableNavigation) {
    var t = r.toDate, i = r.pagedNavigation, n = r.numberOfMonths, s = n === void 0 ? 1 : n, u = i ? s : 1, o = ji(e);
    if (!t)
      return us(o, u);
    var d = Uc(t, e);
    if (!(d < s))
      return us(o, u);
  }
}
function exe(e, r) {
  if (!r.disableNavigation) {
    var t = r.fromDate, i = r.pagedNavigation, n = r.numberOfMonths, s = n === void 0 ? 1 : n, u = i ? s : 1, o = ji(e);
    if (!t)
      return us(o, -u);
    var d = Uc(o, t);
    if (!(d <= 0))
      return us(o, -u);
  }
}
var sL = et(void 0);
function rxe(e) {
  var r = Zr(), t = JFe(), i = t[0], n = t[1], s = $Fe(i, r), u = QFe(i, r), o = exe(i, r), d = function(c) {
    return s.some(function(F) {
      return by(c, F);
    });
  }, a = function(c, F) {
    d(c) || (F && yR(c, F) ? n(us(c, 1 + r.numberOfMonths * -1)) : n(c));
  }, V = {
    currentMonth: i,
    displayMonths: s,
    goToMonth: n,
    goToDate: a,
    previousMonth: o,
    nextMonth: u,
    isDateDisplayed: d
  };
  return l(sL.Provider, { value: V, children: e.children });
}
function u2() {
  var e = rt(sL);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function p9(e) {
  var r, t = Zr(), i = t.classNames, n = t.styles, s = t.components, u = u2().goToMonth, o = function(V) {
    u(us(V, e.displayIndex ? -e.displayIndex : 0));
  }, d = (r = s == null ? void 0 : s.CaptionLabel) !== null && r !== void 0 ? r : iL, a = l(d, { id: e.id, displayMonth: e.displayMonth });
  return C("div", { className: i.caption_dropdowns, style: n.caption_dropdowns, children: [l("div", { className: i.vhidden, children: a }), l(WFe, { onChange: o, displayMonth: e.displayMonth }), l(GFe, { onChange: o, displayMonth: e.displayMonth })] });
}
function txe(e) {
  return l("svg", Be({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: l("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function ixe(e) {
  return l("svg", Be({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: l("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var eX = re(function(e, r) {
  var t = Zr(), i = t.classNames, n = t.styles, s = [i.button_reset, i.button];
  e.className && s.push(e.className);
  var u = s.join(" "), o = Be(Be({}, n.button_reset), n.button);
  return e.style && Object.assign(o, e.style), l("button", Be({}, e, { ref: r, type: "button", className: u, style: o }));
});
function nxe(e) {
  var r, t, i = Zr(), n = i.dir, s = i.locale, u = i.classNames, o = i.styles, d = i.labels, a = d.labelPrevious, V = d.labelNext, c = i.components;
  if (!e.nextMonth && !e.previousMonth)
    return l(he, {});
  var F = a(e.previousMonth, { locale: s }), X = [
    u.nav_button,
    u.nav_button_previous
  ].join(" "), Y = V(e.nextMonth, { locale: s }), q = [
    u.nav_button,
    u.nav_button_next
  ].join(" "), f = (r = c == null ? void 0 : c.IconRight) !== null && r !== void 0 ? r : ixe, p = (t = c == null ? void 0 : c.IconLeft) !== null && t !== void 0 ? t : txe;
  return C("div", { className: u.nav, style: o.nav, children: [!e.hidePrevious && l(eX, { name: "previous-month", "aria-label": F, className: X, style: o.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: n === "rtl" ? l(f, { className: u.nav_icon, style: o.nav_icon }) : l(p, { className: u.nav_icon, style: o.nav_icon }) }), !e.hideNext && l(eX, { name: "next-month", "aria-label": Y, className: q, style: o.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: n === "rtl" ? l(p, { className: u.nav_icon, style: o.nav_icon }) : l(f, { className: u.nav_icon, style: o.nav_icon }) })] });
}
function m9(e) {
  var r = Zr().numberOfMonths, t = u2(), i = t.previousMonth, n = t.nextMonth, s = t.goToMonth, u = t.displayMonths, o = u.findIndex(function(Y) {
    return by(e.displayMonth, Y);
  }), d = o === 0, a = o === u.length - 1, V = r > 1 && (d || !a), c = r > 1 && (a || !d), F = function() {
    i && s(i);
  }, X = function() {
    n && s(n);
  };
  return l(nxe, { displayMonth: e.displayMonth, hideNext: V, hidePrevious: c, nextMonth: n, previousMonth: i, onPreviousClick: F, onNextClick: X });
}
function sxe(e) {
  var r, t = Zr(), i = t.classNames, n = t.disableNavigation, s = t.styles, u = t.captionLayout, o = t.components, d = (r = o == null ? void 0 : o.CaptionLabel) !== null && r !== void 0 ? r : iL, a;
  return n ? a = l(d, { id: e.id, displayMonth: e.displayMonth }) : u === "dropdown" ? a = l(p9, { displayMonth: e.displayMonth, id: e.id }) : u === "dropdown-buttons" ? a = C(he, { children: [l(p9, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), l(m9, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : a = C(he, { children: [l(d, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), l(m9, { displayMonth: e.displayMonth, id: e.id })] }), l("div", { className: i.caption, style: s.caption, children: a });
}
function uxe(e) {
  var r = Zr(), t = r.footer, i = r.styles, n = r.classNames.tfoot;
  return t ? l("tfoot", { className: n, style: i.tfoot, children: l("tr", { children: l("td", { colSpan: 8, children: t }) }) }) : l(he, {});
}
function oxe(e, r, t) {
  for (var i = t ? jd(/* @__PURE__ */ new Date()) : ds(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: r }), n = [], s = 0; s < 7; s++) {
    var u = Xt(i, s);
    n.push(u);
  }
  return n;
}
function dxe() {
  var e = Zr(), r = e.classNames, t = e.styles, i = e.showWeekNumber, n = e.locale, s = e.weekStartsOn, u = e.ISOWeek, o = e.formatters.formatWeekdayName, d = e.labels.labelWeekday, a = oxe(n, s, u);
  return C("tr", { style: t.head_row, className: r.head_row, children: [i && l("td", { style: t.head_cell, className: r.head_cell }), a.map(function(V, c) {
    return l("th", { scope: "col", className: r.head_cell, style: t.head_cell, "aria-label": d(V, { locale: n }), children: o(V, { locale: n }) }, c);
  })] });
}
function axe() {
  var e, r = Zr(), t = r.classNames, i = r.styles, n = r.components, s = (e = n == null ? void 0 : n.HeadRow) !== null && e !== void 0 ? e : dxe;
  return l("thead", { style: i.head, className: t.head, children: l(s, {}) });
}
function Vxe(e) {
  var r = Zr(), t = r.locale, i = r.formatters.formatDay;
  return l(he, { children: i(e.date, { locale: t }) });
}
var By = et(void 0);
function lxe(e) {
  if (!n2(e.initialProps)) {
    var r = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return l(By.Provider, { value: r, children: e.children });
  }
  return l(cxe, { initialProps: e.initialProps, children: e.children });
}
function cxe(e) {
  var r = e.initialProps, t = e.children, i = r.selected, n = r.min, s = r.max, u = function(a, V, c) {
    var F, X;
    (F = r.onDayClick) === null || F === void 0 || F.call(r, a, V, c);
    var Y = !!(V.selected && n && (i == null ? void 0 : i.length) === n);
    if (!Y) {
      var q = !!(!V.selected && s && (i == null ? void 0 : i.length) === s);
      if (!q) {
        var f = i ? rL([], i) : [];
        if (V.selected) {
          var p = f.findIndex(function(m) {
            return Ai(a, m);
          });
          f.splice(p, 1);
        } else
          f.push(a);
        (X = r.onSelect) === null || X === void 0 || X.call(r, f, a, V, c);
      }
    }
  }, o = {
    disabled: []
  };
  i && o.disabled.push(function(a) {
    var V = s && i.length > s - 1, c = i.some(function(F) {
      return Ai(F, a);
    });
    return !!(V && !c);
  });
  var d = {
    selected: i,
    onDayClick: u,
    modifiers: o
  };
  return l(By.Provider, { value: d, children: t });
}
function Wy() {
  var e = rt(By);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function Fxe(e, r) {
  var t = r || {}, i = t.from, n = t.to;
  return i && n ? Ai(n, e) && Ai(i, e) ? void 0 : Ai(n, e) ? { from: n, to: void 0 } : Ai(i, e) ? void 0 : Vv(i, e) ? { from: e, to: n } : { from: i, to: e } : n ? Vv(e, n) ? { from: n, to: e } : { from: e, to: n } : i ? yR(e, i) ? { from: e, to: i } : { from: i, to: e } : { from: e, to: void 0 };
}
var Gy = et(void 0);
function xxe(e) {
  if (!s2(e.initialProps)) {
    var r = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return l(Gy.Provider, { value: r, children: e.children });
  }
  return l(Xxe, { initialProps: e.initialProps, children: e.children });
}
function Xxe(e) {
  var r = e.initialProps, t = e.children, i = r.selected, n = i || {}, s = n.from, u = n.to, o = r.min, d = r.max, a = function(X, Y, q) {
    var f, p;
    (f = r.onDayClick) === null || f === void 0 || f.call(r, X, Y, q);
    var m = Fxe(X, i);
    (p = r.onSelect) === null || p === void 0 || p.call(r, m, X, Y, q);
  }, V = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (s ? (V.range_start = [s], u ? (V.range_end = [u], Ai(s, u) || (V.range_middle = [
    {
      after: s,
      before: u
    }
  ])) : V.range_end = [s]) : u && (V.range_start = [u], V.range_end = [u]), o && (s && !u && V.disabled.push({
    after: ph(s, o - 1),
    before: Xt(s, o - 1)
  }), s && u && V.disabled.push({
    after: s,
    before: Xt(s, o - 1)
  }), !s && u && V.disabled.push({
    after: ph(u, o - 1),
    before: Xt(u, o - 1)
  })), d) {
    if (s && !u && (V.disabled.push({
      before: Xt(s, -d + 1)
    }), V.disabled.push({
      after: Xt(s, d - 1)
    })), s && u) {
      var c = Ps(u, s) + 1, F = d - c;
      V.disabled.push({
        before: ph(s, F)
      }), V.disabled.push({
        after: Xt(u, F)
      });
    }
    !s && u && (V.disabled.push({
      before: Xt(u, -d + 1)
    }), V.disabled.push({
      after: Xt(u, d - 1)
    }));
  }
  return l(Gy.Provider, { value: { selected: i, onDayClick: a, modifiers: V }, children: t });
}
function Uy() {
  var e = rt(Gy);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function kx(e) {
  return Array.isArray(e) ? rL([], e) : e !== void 0 ? [e] : [];
}
function qxe(e) {
  var r = {};
  return Object.entries(e).forEach(function(t) {
    var i = t[0], n = t[1];
    r[i] = kx(n);
  }), r;
}
var cs;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(cs || (cs = {}));
var Yxe = cs.Selected, qu = cs.Disabled, fxe = cs.Hidden, Kxe = cs.Today, Nh = cs.RangeEnd, Mh = cs.RangeMiddle, Th = cs.RangeStart, hxe = cs.Outside;
function pxe(e, r, t) {
  var i, n = (i = {}, i[Yxe] = kx(e.selected), i[qu] = kx(e.disabled), i[fxe] = kx(e.hidden), i[Kxe] = [e.today], i[Nh] = [], i[Mh] = [], i[Th] = [], i[hxe] = [], i);
  return e.fromDate && n[qu].push({ before: e.fromDate }), e.toDate && n[qu].push({ after: e.toDate }), n2(e) ? n[qu] = n[qu].concat(r.modifiers[qu]) : s2(e) && (n[qu] = n[qu].concat(t.modifiers[qu]), n[Th] = t.modifiers[Th], n[Mh] = t.modifiers[Mh], n[Nh] = t.modifiers[Nh]), n;
}
var uL = et(void 0);
function mxe(e) {
  var r = Zr(), t = Wy(), i = Uy(), n = pxe(r, t, i), s = qxe(r.modifiers), u = Be(Be({}, n), s);
  return l(uL.Provider, { value: u, children: e.children });
}
function oL() {
  var e = rt(uL);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function gxe(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function vxe(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function bxe(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function yxe(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function Axe(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function wxe(e, r) {
  var t, i = r.from, n = r.to;
  if (i && n) {
    var s = Ps(n, i) < 0;
    s && (t = [n, i], i = t[0], n = t[1]);
    var u = Ps(e, i) >= 0 && Ps(n, e) >= 0;
    return u;
  }
  return n ? Ai(n, e) : i ? Ai(i, e) : !1;
}
function Cxe(e) {
  return my(e);
}
function Pxe(e) {
  return Array.isArray(e) && e.every(my);
}
function Sxe(e, r) {
  return r.some(function(t) {
    if (typeof t == "boolean")
      return t;
    if (Cxe(t))
      return Ai(e, t);
    if (Pxe(t))
      return t.includes(e);
    if (vxe(t))
      return wxe(e, t);
    if (Axe(t))
      return t.dayOfWeek.includes(e.getDay());
    if (gxe(t)) {
      var i = Ps(t.before, e), n = Ps(t.after, e), s = i > 0, u = n < 0, o = Vv(t.before, t.after);
      return o ? u && s : s || u;
    }
    return bxe(t) ? Ps(e, t.after) > 0 : yxe(t) ? Ps(t.before, e) > 0 : typeof t == "function" ? t(e) : !1;
  });
}
function Zy(e, r, t) {
  var i = Object.keys(r).reduce(function(s, u) {
    var o = r[u];
    return Sxe(e, o) && s.push(u), s;
  }, []), n = {};
  return i.forEach(function(s) {
    return n[s] = !0;
  }), t && !by(e, t) && (n.outside = !0), n;
}
function Nxe(e, r) {
  for (var t = ji(e[0]), i = gy(e[e.length - 1]), n, s, u = t; u <= i; ) {
    var o = Zy(u, r), d = !o.disabled && !o.hidden;
    if (!d) {
      u = Xt(u, 1);
      continue;
    }
    if (o.selected)
      return u;
    o.today && !s && (s = u), n || (n = u), u = Xt(u, 1);
  }
  return s || n;
}
var Mxe = 365;
function dL(e, r) {
  var t = r.moveBy, i = r.direction, n = r.context, s = r.modifiers, u = r.retry, o = u === void 0 ? { count: 0, lastFocused: e } : u, d = n.weekStartsOn, a = n.fromDate, V = n.toDate, c = n.locale, F = {
    day: Xt,
    week: av,
    month: us,
    year: IVe,
    startOfWeek: function(f) {
      return n.ISOWeek ? jd(f) : ds(f, { locale: c, weekStartsOn: d });
    },
    endOfWeek: function(f) {
      return n.ISOWeek ? hR(f) : vy(f, { locale: c, weekStartsOn: d });
    }
  }, X = F[t](e, i === "after" ? 1 : -1);
  i === "before" && a ? X = LVe([a, X]) : i === "after" && V && (X = _Ve([V, X]));
  var Y = !0;
  if (s) {
    var q = Zy(X, s);
    Y = !q.disabled && !q.hidden;
  }
  return Y ? X : o.count > Mxe ? o.lastFocused : dL(X, {
    moveBy: t,
    direction: i,
    context: n,
    modifiers: s,
    retry: Be(Be({}, o), { count: o.count + 1 })
  });
}
var aL = et(void 0);
function Txe(e) {
  var r = u2(), t = oL(), i = ie(), n = i[0], s = i[1], u = ie(), o = u[0], d = u[1], a = Nxe(r.displayMonths, t), V = n ?? (o && r.isDateDisplayed(o)) ? o : a, c = function() {
    d(n), s(void 0);
  }, F = function(f) {
    s(f);
  }, X = Zr(), Y = function(f, p) {
    if (n) {
      var m = dL(n, {
        moveBy: f,
        direction: p,
        context: X,
        modifiers: t
      });
      Ai(n, m) || (r.goToDate(m, n), F(m));
    }
  }, q = {
    focusedDay: n,
    focusTarget: V,
    blur: c,
    focus: F,
    focusDayAfter: function() {
      return Y("day", "after");
    },
    focusDayBefore: function() {
      return Y("day", "before");
    },
    focusWeekAfter: function() {
      return Y("week", "after");
    },
    focusWeekBefore: function() {
      return Y("week", "before");
    },
    focusMonthBefore: function() {
      return Y("month", "before");
    },
    focusMonthAfter: function() {
      return Y("month", "after");
    },
    focusYearBefore: function() {
      return Y("year", "before");
    },
    focusYearAfter: function() {
      return Y("year", "after");
    },
    focusStartOfWeek: function() {
      return Y("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return Y("endOfWeek", "after");
    }
  };
  return l(aL.Provider, { value: q, children: e.children });
}
function Jy() {
  var e = rt(aL);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function Exe(e, r) {
  var t = oL(), i = Zy(e, t, r);
  return i;
}
var $y = et(void 0);
function kxe(e) {
  if (!Uq(e.initialProps)) {
    var r = {
      selected: void 0
    };
    return l($y.Provider, { value: r, children: e.children });
  }
  return l(Oxe, { initialProps: e.initialProps, children: e.children });
}
function Oxe(e) {
  var r = e.initialProps, t = e.children, i = function(s, u, o) {
    var d, a, V;
    if ((d = r.onDayClick) === null || d === void 0 || d.call(r, s, u, o), u.selected && !r.required) {
      (a = r.onSelect) === null || a === void 0 || a.call(r, void 0, s, u, o);
      return;
    }
    (V = r.onSelect) === null || V === void 0 || V.call(r, s, s, u, o);
  }, n = {
    selected: r.selected,
    onDayClick: i
  };
  return l($y.Provider, { value: n, children: t });
}
function VL() {
  var e = rt($y);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function Dxe(e, r) {
  var t = Zr(), i = VL(), n = Wy(), s = Uy(), u = Jy(), o = u.focusDayAfter, d = u.focusDayBefore, a = u.focusWeekAfter, V = u.focusWeekBefore, c = u.blur, F = u.focus, X = u.focusMonthBefore, Y = u.focusMonthAfter, q = u.focusYearBefore, f = u.focusYearAfter, p = u.focusStartOfWeek, m = u.focusEndOfWeek, g = function(L) {
    var z, Z, le, te;
    Uq(t) ? (z = i.onDayClick) === null || z === void 0 || z.call(i, e, r, L) : n2(t) ? (Z = n.onDayClick) === null || Z === void 0 || Z.call(n, e, r, L) : s2(t) ? (le = s.onDayClick) === null || le === void 0 || le.call(s, e, r, L) : (te = t.onDayClick) === null || te === void 0 || te.call(t, e, r, L);
  }, y = function(L) {
    var z;
    F(e), (z = t.onDayFocus) === null || z === void 0 || z.call(t, e, r, L);
  }, b = function(L) {
    var z;
    c(), (z = t.onDayBlur) === null || z === void 0 || z.call(t, e, r, L);
  }, A = function(L) {
    var z;
    (z = t.onDayMouseEnter) === null || z === void 0 || z.call(t, e, r, L);
  }, w = function(L) {
    var z;
    (z = t.onDayMouseLeave) === null || z === void 0 || z.call(t, e, r, L);
  }, S = function(L) {
    var z;
    (z = t.onDayPointerEnter) === null || z === void 0 || z.call(t, e, r, L);
  }, N = function(L) {
    var z;
    (z = t.onDayPointerLeave) === null || z === void 0 || z.call(t, e, r, L);
  }, O = function(L) {
    var z;
    (z = t.onDayTouchCancel) === null || z === void 0 || z.call(t, e, r, L);
  }, E = function(L) {
    var z;
    (z = t.onDayTouchEnd) === null || z === void 0 || z.call(t, e, r, L);
  }, I = function(L) {
    var z;
    (z = t.onDayTouchMove) === null || z === void 0 || z.call(t, e, r, L);
  }, R = function(L) {
    var z;
    (z = t.onDayTouchStart) === null || z === void 0 || z.call(t, e, r, L);
  }, H = function(L) {
    var z;
    (z = t.onDayKeyUp) === null || z === void 0 || z.call(t, e, r, L);
  }, W = function(L) {
    var z;
    switch (L.key) {
      case "ArrowLeft":
        L.preventDefault(), L.stopPropagation(), t.dir === "rtl" ? o() : d();
        break;
      case "ArrowRight":
        L.preventDefault(), L.stopPropagation(), t.dir === "rtl" ? d() : o();
        break;
      case "ArrowDown":
        L.preventDefault(), L.stopPropagation(), a();
        break;
      case "ArrowUp":
        L.preventDefault(), L.stopPropagation(), V();
        break;
      case "PageUp":
        L.preventDefault(), L.stopPropagation(), L.shiftKey ? q() : X();
        break;
      case "PageDown":
        L.preventDefault(), L.stopPropagation(), L.shiftKey ? f() : Y();
        break;
      case "Home":
        L.preventDefault(), L.stopPropagation(), p();
        break;
      case "End":
        L.preventDefault(), L.stopPropagation(), m();
        break;
    }
    (z = t.onDayKeyDown) === null || z === void 0 || z.call(t, e, r, L);
  }, B = {
    onClick: g,
    onFocus: y,
    onBlur: b,
    onKeyDown: W,
    onKeyUp: H,
    onMouseEnter: A,
    onMouseLeave: w,
    onPointerEnter: S,
    onPointerLeave: N,
    onTouchCancel: O,
    onTouchEnd: E,
    onTouchMove: I,
    onTouchStart: R
  };
  return B;
}
function Rxe() {
  var e = Zr(), r = VL(), t = Wy(), i = Uy(), n = Uq(e) ? r.selected : n2(e) ? t.selected : s2(e) ? i.selected : void 0;
  return n;
}
function Ixe(e) {
  return Object.values(cs).includes(e);
}
function Lxe(e, r) {
  var t = [e.classNames.day];
  return Object.keys(r).forEach(function(i) {
    var n = e.modifiersClassNames[i];
    if (n)
      t.push(n);
    else if (Ixe(i)) {
      var s = e.classNames["day_".concat(i)];
      s && t.push(s);
    }
  }), t;
}
function _xe(e, r) {
  var t = Be({}, e.styles.day);
  return Object.keys(r).forEach(function(i) {
    var n;
    t = Be(Be({}, t), (n = e.modifiersStyles) === null || n === void 0 ? void 0 : n[i]);
  }), t;
}
function Hxe(e, r, t) {
  var i, n, s, u = Zr(), o = Jy(), d = Exe(e, r), a = Dxe(e, d), V = Rxe(), c = !!(u.onDayClick || u.mode !== "default");
  Pe(function() {
    var A;
    d.outside || o.focusedDay && c && Ai(o.focusedDay, e) && ((A = t.current) === null || A === void 0 || A.focus());
  }, [
    o.focusedDay,
    e,
    t,
    c,
    d.outside
  ]);
  var F = Lxe(u, d).join(" "), X = _xe(u, d), Y = !!(d.outside && !u.showOutsideDays || d.hidden), q = (s = (n = u.components) === null || n === void 0 ? void 0 : n.DayContent) !== null && s !== void 0 ? s : Vxe, f = l(q, { date: e, displayMonth: r, activeModifiers: d }), p = {
    style: X,
    className: F,
    children: f,
    role: "gridcell"
  }, m = o.focusTarget && Ai(o.focusTarget, e) && !d.outside, g = o.focusedDay && Ai(o.focusedDay, e), y = Be(Be(Be({}, p), (i = { disabled: d.disabled, role: "gridcell" }, i["aria-selected"] = d.selected, i.tabIndex = g || m ? 0 : -1, i)), a), b = {
    isButton: c,
    isHidden: Y,
    activeModifiers: d,
    selectedDays: V,
    buttonProps: y,
    divProps: p
  };
  return b;
}
function jxe(e) {
  var r = Yr(null), t = Hxe(e.date, e.displayMonth, r);
  return t.isHidden ? l("div", { role: "gridcell" }) : t.isButton ? l(eX, Be({ name: "day", ref: r }, t.buttonProps)) : l("div", Be({}, t.divProps));
}
function zxe(e) {
  var r = e.number, t = e.dates, i = Zr(), n = i.onWeekNumberClick, s = i.styles, u = i.classNames, o = i.locale, d = i.labels.labelWeekNumber, a = i.formatters.formatWeekNumber, V = a(Number(r), { locale: o });
  if (!n)
    return l("span", { className: u.weeknumber, style: s.weeknumber, children: V });
  var c = d(Number(r), { locale: o }), F = function(X) {
    n(r, t, X);
  };
  return l(eX, { name: "week-number", "aria-label": c, className: u.weeknumber, style: s.weeknumber, onClick: F, children: V });
}
function Bxe(e) {
  var r, t, i = Zr(), n = i.styles, s = i.classNames, u = i.showWeekNumber, o = i.components, d = (r = o == null ? void 0 : o.Day) !== null && r !== void 0 ? r : jxe, a = (t = o == null ? void 0 : o.WeekNumber) !== null && t !== void 0 ? t : zxe, V;
  return u && (V = l("td", { className: s.cell, style: n.cell, children: l(a, { number: e.weekNumber, dates: e.dates }) })), C("tr", { className: s.row, style: n.row, children: [V, e.dates.map(function(c) {
    return l("td", { className: s.cell, style: n.cell, role: "presentation", children: l(d, { displayMonth: e.displayMonth, date: c }) }, _le(c));
  })] });
}
function g9(e, r, t) {
  for (var i = t != null && t.ISOWeek ? hR(r) : vy(r, t), n = t != null && t.ISOWeek ? jd(e) : ds(e, t), s = Ps(i, n), u = [], o = 0; o <= s; o++)
    u.push(Xt(n, o));
  var d = u.reduce(function(a, V) {
    var c = t != null && t.ISOWeek ? mR(V) : vR(V, t), F = a.find(function(X) {
      return X.weekNumber === c;
    });
    return F ? (F.dates.push(V), a) : (a.push({
      weekNumber: c,
      dates: [V]
    }), a);
  }, []);
  return d;
}
function Wxe(e, r) {
  var t = g9(ji(e), gy(e), r);
  if (r != null && r.useFixedWeeks) {
    var i = jle(e, r);
    if (i < 6) {
      var n = t[t.length - 1], s = n.dates[n.dates.length - 1], u = av(s, 6 - i), o = g9(av(s, 1), u, r);
      t.push.apply(t, o);
    }
  }
  return t;
}
function Gxe(e) {
  var r, t, i, n = Zr(), s = n.locale, u = n.classNames, o = n.styles, d = n.hideHead, a = n.fixedWeeks, V = n.components, c = n.weekStartsOn, F = n.firstWeekContainsDate, X = n.ISOWeek, Y = Wxe(e.displayMonth, {
    useFixedWeeks: !!a,
    ISOWeek: X,
    locale: s,
    weekStartsOn: c,
    firstWeekContainsDate: F
  }), q = (r = V == null ? void 0 : V.Head) !== null && r !== void 0 ? r : axe, f = (t = V == null ? void 0 : V.Row) !== null && t !== void 0 ? t : Bxe, p = (i = V == null ? void 0 : V.Footer) !== null && i !== void 0 ? i : uxe;
  return C("table", { id: e.id, className: u.table, style: o.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!d && l(q, {}), l("tbody", { className: u.tbody, style: o.tbody, children: Y.map(function(m) {
    return l(f, { displayMonth: e.displayMonth, dates: m.dates, weekNumber: m.weekNumber }, m.weekNumber);
  }) }), l(p, { displayMonth: e.displayMonth })] });
}
function Uxe() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var Zxe = Uxe() ? Eq : Pe, Eh = !1, Jxe = 0;
function v9() {
  return "react-day-picker-".concat(++Jxe);
}
function $xe(e) {
  var r, t = e ?? (Eh ? v9() : null), i = ie(t), n = i[0], s = i[1];
  return Zxe(function() {
    n === null && s(v9());
  }, []), Pe(function() {
    Eh === !1 && (Eh = !0);
  }, []), (r = e ?? n) !== null && r !== void 0 ? r : void 0;
}
function Qxe(e) {
  var r, t, i = Zr(), n = i.dir, s = i.classNames, u = i.styles, o = i.components, d = u2().displayMonths, a = $xe(i.id ? "".concat(i.id, "-").concat(e.displayIndex) : void 0), V = i.id ? "".concat(i.id, "-grid-").concat(e.displayIndex) : void 0, c = [s.month], F = u.month, X = e.displayIndex === 0, Y = e.displayIndex === d.length - 1, q = !X && !Y;
  n === "rtl" && (r = [X, Y], Y = r[0], X = r[1]), X && (c.push(s.caption_start), F = Be(Be({}, F), u.caption_start)), Y && (c.push(s.caption_end), F = Be(Be({}, F), u.caption_end)), q && (c.push(s.caption_between), F = Be(Be({}, F), u.caption_between));
  var f = (t = o == null ? void 0 : o.Caption) !== null && t !== void 0 ? t : sxe;
  return C("div", { className: c.join(" "), style: F, children: [l(f, { id: a, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), l(Gxe, { id: V, "aria-labelledby": a, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function eXe(e) {
  var r = Zr(), t = r.classNames, i = r.styles;
  return l("div", { className: t.months, style: i.months, children: e.children });
}
function rXe(e) {
  var r, t, i = e.initialProps, n = Zr(), s = Jy(), u = u2(), o = ie(!1), d = o[0], a = o[1];
  Pe(function() {
    n.initialFocus && s.focusTarget && (d || (s.focus(s.focusTarget), a(!0)));
  }, [
    n.initialFocus,
    d,
    s.focus,
    s.focusTarget,
    s
  ]);
  var V = [n.classNames.root, n.className];
  n.numberOfMonths > 1 && V.push(n.classNames.multiple_months), n.showWeekNumber && V.push(n.classNames.with_weeknumber);
  var c = Be(Be({}, n.styles.root), n.style), F = Object.keys(i).filter(function(Y) {
    return Y.startsWith("data-");
  }).reduce(function(Y, q) {
    var f;
    return Be(Be({}, Y), (f = {}, f[q] = i[q], f));
  }, {}), X = (t = (r = i.components) === null || r === void 0 ? void 0 : r.Months) !== null && t !== void 0 ? t : eXe;
  return l("div", Be({ className: V.join(" "), style: c, dir: n.dir, id: n.id, nonce: i.nonce, title: i.title, lang: i.lang }, F, { children: l(X, { children: u.displayMonths.map(function(Y, q) {
    return l(Qxe, { displayIndex: q, displayMonth: Y }, q);
  }) }) }));
}
function tXe(e) {
  var r = e.children, t = yFe(e, ["children"]);
  return l(zFe, { initialProps: t, children: l(rxe, { children: l(kxe, { initialProps: t, children: l(lxe, { initialProps: t, children: l(xxe, { initialProps: t, children: l(mxe, { children: l(Txe, { children: r }) }) }) }) }) }) });
}
function iXe(e) {
  return l(tXe, Be({}, e, { children: l(rXe, { initialProps: e }) }));
}
function Qy({
  className: e,
  classNames: r,
  showOutsideDays: t = !0,
  ...i
}) {
  return /* @__PURE__ */ l(
    iXe,
    {
      showOutsideDays: t,
      className: _("p-3", e),
      classNames: {
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-bodysm font-medium",
        nav: "space-x-1 flex items-center",
        nav_button: _(
          AV({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell: "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
        row: "flex w-full mt-2",
        cell: "h-9 w-9 text-center text-bodysm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
        day: _(
          AV({ variant: "ghost" }),
          "h-9 w-9 p-0 font-normal aria-selected:opacity-100"
        ),
        day_range_end: "day-range-end",
        day_selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
        day_today: "bg-accent text-accent-foreground",
        day_outside: "day-outside text-muted-foreground aria-selected:bg-accent/50 aria-selected:text-muted-foreground",
        day_disabled: "text-muted-foreground opacity-50",
        day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
        day_hidden: "invisible",
        ...r
      },
      components: {
        IconLeft: ({ className: n, ...s }) => /* @__PURE__ */ l(Qae, { className: _("h-4 w-4", n), ...s }),
        IconRight: ({ className: n, ...s }) => /* @__PURE__ */ l(xR, { className: _("h-4 w-4", n), ...s })
      },
      ...i
    }
  );
}
Qy.displayName = "Calendar";
function CQe({ children: e, className: r }) {
  return /* @__PURE__ */ l(
    "span",
    {
      className: _(
        "rounded-xs border-interfaceBorder bg-interfaceBgDarkPaper inline-block border-l-4 py-3 pl-4 pr-3",
        r
      ),
      children: e
    }
  );
}
const Pr = re(
  ({ className: e, ...r }, t) => /* @__PURE__ */ l(
    "div",
    {
      ref: t,
      className: _(
        "bg-card text-card-foreground border-border shadow-xs rounded-lg border",
        e
      ),
      ...r
    }
  )
);
Pr.displayName = "Card";
const Sr = re(
  ({ className: e, ...r }, t) => /* @__PURE__ */ l(
    "div",
    {
      ref: t,
      className: _("flex flex-col space-y-1.5 p-6", e),
      ...r
    }
  )
);
Sr.displayName = "CardHeader";
const Or = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "h3",
  {
    ref: t,
    className: _(
      "text-heading2xl font-semibold leading-none tracking-tight",
      e
    ),
    ...r
  }
));
Or.displayName = "CardTitle";
const ii = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "p",
  {
    ref: t,
    className: _("text-muted-foreground text-bodysm", e),
    ...r
  }
));
ii.displayName = "CardDescription";
const Nr = re(
  ({ className: e, ...r }, t) => /* @__PURE__ */ l("div", { ref: t, className: _("p-6 pt-0", e), ...r })
);
Nr.displayName = "CardContent";
const e3 = re(
  ({ className: e, ...r }, t) => /* @__PURE__ */ l(
    "div",
    {
      ref: t,
      className: _("flex items-center p-6 pt-0", e),
      ...r
    }
  )
);
e3.displayName = "CardFooter";
function b9(e, r) {
  if (typeof e == "function")
    return e(r);
  e != null && (e.current = r);
}
function lL(...e) {
  return (r) => {
    let t = !1;
    const i = e.map((n) => {
      const s = b9(n, r);
      return !t && typeof s == "function" && (t = !0), s;
    });
    if (t)
      return () => {
        for (let n = 0; n < i.length; n++) {
          const s = i[n];
          typeof s == "function" ? s() : b9(e[n], null);
        }
      };
  };
}
function cL(...e) {
  return h.useCallback(lL(...e), e);
}
function nXe(e, r = []) {
  let t = [];
  function i(s, u) {
    const o = h.createContext(u), d = t.length;
    t = [...t, u];
    const a = (c) => {
      var p;
      const { scope: F, children: X, ...Y } = c, q = ((p = F == null ? void 0 : F[e]) == null ? void 0 : p[d]) || o, f = h.useMemo(() => Y, Object.values(Y));
      return /* @__PURE__ */ l(q.Provider, { value: f, children: X });
    };
    a.displayName = s + "Provider";
    function V(c, F) {
      var q;
      const X = ((q = F == null ? void 0 : F[e]) == null ? void 0 : q[d]) || o, Y = h.useContext(X);
      if (Y) return Y;
      if (u !== void 0) return u;
      throw new Error(`\`${c}\` must be used within \`${s}\``);
    }
    return [a, V];
  }
  const n = () => {
    const s = t.map((u) => h.createContext(u));
    return function(o) {
      const d = (o == null ? void 0 : o[e]) || s;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: d } }),
        [o, d]
      );
    };
  };
  return n.scopeName = e, [i, sXe(n, ...r)];
}
function sXe(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const t = () => {
    const i = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(s) {
      const u = i.reduce((o, { useScope: d, scopeName: a }) => {
        const c = d(s)[`__scope${a}`];
        return { ...o, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${r.scopeName}`]: u }), [u]);
    };
  };
  return t.scopeName = r.scopeName, t;
}
function y9(e, r, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), t === !1 || !n.defaultPrevented)
      return r == null ? void 0 : r(n);
  };
}
function Kl(e) {
  const r = h.useRef({ value: e, previous: e });
  return h.useMemo(() => (r.current.value !== e && (r.current.previous = r.current.value, r.current.value = e), r.current.previous), [e]);
}
function da(e) {
  const [r, t] = h.useState(void 0);
  return ze(() => {
    if (e) {
      t({ width: e.offsetWidth, height: e.offsetHeight });
      const i = new ResizeObserver((n) => {
        if (!Array.isArray(n) || !n.length)
          return;
        const s = n[0];
        let u, o;
        if ("borderBoxSize" in s) {
          const d = s.borderBoxSize, a = Array.isArray(d) ? d[0] : d;
          u = a.inlineSize, o = a.blockSize;
        } else
          u = e.offsetWidth, o = e.offsetHeight;
        t({ width: u, height: o });
      });
      return i.observe(e, { box: "border-box" }), () => i.unobserve(e);
    } else
      t(void 0);
  }, [e]), r;
}
function uXe(e, r) {
  return h.useReducer((t, i) => r[t][i] ?? t, e);
}
var FL = (e) => {
  const { present: r, children: t } = e, i = oXe(r), n = typeof t == "function" ? t({ present: i.isPresent }) : h.Children.only(t), s = cL(i.ref, dXe(n));
  return typeof t == "function" || i.isPresent ? h.cloneElement(n, { ref: s }) : null;
};
FL.displayName = "Presence";
function oXe(e) {
  const [r, t] = h.useState(), i = h.useRef({}), n = h.useRef(e), s = h.useRef("none"), u = e ? "mounted" : "unmounted", [o, d] = uXe(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return h.useEffect(() => {
    const a = DF(i.current);
    s.current = o === "mounted" ? a : "none";
  }, [o]), ze(() => {
    const a = i.current, V = n.current;
    if (V !== e) {
      const F = s.current, X = DF(a);
      e ? d("MOUNT") : X === "none" || (a == null ? void 0 : a.display) === "none" ? d("UNMOUNT") : d(V && F !== X ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, d]), ze(() => {
    if (r) {
      let a;
      const V = r.ownerDocument.defaultView ?? window, c = (X) => {
        const q = DF(i.current).includes(X.animationName);
        if (X.target === r && q && (d("ANIMATION_END"), !n.current)) {
          const f = r.style.animationFillMode;
          r.style.animationFillMode = "forwards", a = V.setTimeout(() => {
            r.style.animationFillMode === "forwards" && (r.style.animationFillMode = f);
          });
        }
      }, F = (X) => {
        X.target === r && (s.current = DF(i.current));
      };
      return r.addEventListener("animationstart", F), r.addEventListener("animationcancel", c), r.addEventListener("animationend", c), () => {
        V.clearTimeout(a), r.removeEventListener("animationstart", F), r.removeEventListener("animationcancel", c), r.removeEventListener("animationend", c);
      };
    } else
      d("ANIMATION_END");
  }, [r, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: h.useCallback((a) => {
      a && (i.current = getComputedStyle(a)), t(a);
    }, [])
  };
}
function DF(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function dXe(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var xL = h.forwardRef((e, r) => {
  const { children: t, ...i } = e, n = h.Children.toArray(t), s = n.find(VXe);
  if (s) {
    const u = s.props.children, o = n.map((d) => d === s ? h.Children.count(u) > 1 ? h.Children.only(null) : h.isValidElement(u) ? u.props.children : null : d);
    return /* @__PURE__ */ l(pv, { ...i, ref: r, children: h.isValidElement(u) ? h.cloneElement(u, void 0, o) : null });
  }
  return /* @__PURE__ */ l(pv, { ...i, ref: r, children: t });
});
xL.displayName = "Slot";
var pv = h.forwardRef((e, r) => {
  const { children: t, ...i } = e;
  if (h.isValidElement(t)) {
    const n = cXe(t);
    return h.cloneElement(t, {
      ...lXe(i, t.props),
      // @ts-ignore
      ref: r ? lL(r, n) : n
    });
  }
  return h.Children.count(t) > 1 ? h.Children.only(null) : null;
});
pv.displayName = "SlotClone";
var aXe = ({ children: e }) => /* @__PURE__ */ l(he, { children: e });
function VXe(e) {
  return h.isValidElement(e) && e.type === aXe;
}
function lXe(e, r) {
  const t = { ...r };
  for (const i in r) {
    const n = e[i], s = r[i];
    /^on[A-Z]/.test(i) ? n && s ? t[i] = (...o) => {
      s(...o), n(...o);
    } : n && (t[i] = n) : i === "style" ? t[i] = { ...n, ...s } : i === "className" && (t[i] = [n, s].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function cXe(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var FXe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], XL = FXe.reduce((e, r) => {
  const t = h.forwardRef((i, n) => {
    const { asChild: s, ...u } = i, o = s ? xL : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l(o, { ...u, ref: n });
  });
  return t.displayName = `Primitive.${r}`, { ...e, [r]: t };
}, {}), r3 = "Checkbox", [xXe, PQe] = nXe(r3), [XXe, qXe] = xXe(r3), qL = h.forwardRef(
  (e, r) => {
    const {
      __scopeCheckbox: t,
      name: i,
      checked: n,
      defaultChecked: s,
      required: u,
      disabled: o,
      value: d = "on",
      onCheckedChange: a,
      form: V,
      ...c
    } = e, [F, X] = h.useState(null), Y = cL(r, (y) => X(y)), q = h.useRef(!1), f = F ? V || !!F.closest("form") : !0, [p = !1, m] = Gr({
      prop: n,
      defaultProp: s,
      onChange: a
    }), g = h.useRef(p);
    return h.useEffect(() => {
      const y = F == null ? void 0 : F.form;
      if (y) {
        const b = () => m(g.current);
        return y.addEventListener("reset", b), () => y.removeEventListener("reset", b);
      }
    }, [F, m]), /* @__PURE__ */ C(XXe, { scope: t, state: p, disabled: o, children: [
      /* @__PURE__ */ l(
        XL.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": No(p) ? "mixed" : p,
          "aria-required": u,
          "data-state": KL(p),
          "data-disabled": o ? "" : void 0,
          disabled: o,
          value: d,
          ...c,
          ref: Y,
          onKeyDown: y9(e.onKeyDown, (y) => {
            y.key === "Enter" && y.preventDefault();
          }),
          onClick: y9(e.onClick, (y) => {
            m((b) => No(b) ? !0 : !b), f && (q.current = y.isPropagationStopped(), q.current || y.stopPropagation());
          })
        }
      ),
      f && /* @__PURE__ */ l(
        YXe,
        {
          control: F,
          bubbles: !q.current,
          name: i,
          value: d,
          checked: p,
          required: u,
          disabled: o,
          form: V,
          style: { transform: "translateX(-100%)" },
          defaultChecked: No(s) ? !1 : s
        }
      )
    ] });
  }
);
qL.displayName = r3;
var YL = "CheckboxIndicator", fL = h.forwardRef(
  (e, r) => {
    const { __scopeCheckbox: t, forceMount: i, ...n } = e, s = qXe(YL, t);
    return /* @__PURE__ */ l(FL, { present: i || No(s.state) || s.state === !0, children: /* @__PURE__ */ l(
      XL.span,
      {
        "data-state": KL(s.state),
        "data-disabled": s.disabled ? "" : void 0,
        ...n,
        ref: r,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
fL.displayName = YL;
var YXe = (e) => {
  const { control: r, checked: t, bubbles: i = !0, defaultChecked: n, ...s } = e, u = h.useRef(null), o = Kl(t), d = da(r);
  h.useEffect(() => {
    const V = u.current, c = window.HTMLInputElement.prototype, X = Object.getOwnPropertyDescriptor(c, "checked").set;
    if (o !== t && X) {
      const Y = new Event("click", { bubbles: i });
      V.indeterminate = No(t), X.call(V, No(t) ? !1 : t), V.dispatchEvent(Y);
    }
  }, [o, t, i]);
  const a = h.useRef(No(t) ? !1 : t);
  return /* @__PURE__ */ l(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n ?? a.current,
      ...s,
      tabIndex: -1,
      ref: u,
      style: {
        ...e.style,
        ...d,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function No(e) {
  return e === "indeterminate";
}
function KL(e) {
  return No(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var hL = qL, fXe = fL;
const Ad = h.forwardRef(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  hL,
  {
    ref: t,
    className: _(
      "ring-offset-background focus-visible:ring-ring data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground border-interactiveBorder peer h-6 w-6 shrink-0 rounded-xs border focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...r,
    children: /* @__PURE__ */ l(
      fXe,
      {
        className: _("flex items-center justify-center text-current"),
        children: /* @__PURE__ */ l(Bo, { className: "h-4 w-4" })
      }
    )
  }
));
Ad.displayName = hL.displayName;
function SQe({
  className: e,
  options: r,
  onChange: t,
  values: i
}) {
  return /* @__PURE__ */ l("ul", { className: _("flex flex-col gap-2", e), children: r.map((n, s) => {
    const u = i.some((o) => o.value === n.value);
    return /* @__PURE__ */ l("li", { children: /* @__PURE__ */ C(_r, { className: _("flex gap-2", e), children: [
      /* @__PURE__ */ l(
        Ad,
        {
          checked: u,
          onCheckedChange: (o) => t(
            o ? [...i, n] : i.filter((d) => d.value !== n.value)
          )
        }
      ),
      n.label
    ] }) }, `${n.value}-${s}`);
  }) });
}
function NQe({
  noOptionsFoundMessage: e = "no options found.",
  onChange: r,
  options: t,
  placeholder: i,
  value: n
}) {
  var o;
  const [s, u] = ie(!1);
  return /* @__PURE__ */ C(qY, { open: s, onOpenChange: u, children: [
    /* @__PURE__ */ l(YY, { asChild: !0, children: /* @__PURE__ */ C(
      er,
      {
        variant: "outline",
        role: "combobox",
        "aria-expanded": s,
        className: "w-[200px] justify-between",
        children: [
          n ? (o = t.find((d) => d.value === n)) == null ? void 0 : o.label : i,
          /* @__PURE__ */ l(nVe, { className: "ml-2 h-4 w-4 shrink-0 opacity-50" })
        ]
      }
    ) }),
    /* @__PURE__ */ l(x2, { className: "w-[200px] p-0", children: /* @__PURE__ */ C(
      hl,
      {
        filter: (d, a, V) => V != null && V[0].includes(a) ? 1 : 0,
        children: [
          /* @__PURE__ */ l(HL, { placeholder: i }),
          /* @__PURE__ */ C(a2, { children: [
            /* @__PURE__ */ l(a3, { children: e }),
            /* @__PURE__ */ l(V2, { children: t.map((d) => /* @__PURE__ */ C(
              l2,
              {
                keywords: [d.label],
                value: d.value || "",
                onSelect: (a) => {
                  r(a === n ? "" : a), u(!1);
                },
                children: [
                  /* @__PURE__ */ l(
                    Bo,
                    {
                      className: _(
                        "mr-2 h-4 w-4",
                        n === d.value ? "opacity-100" : "opacity-0"
                      )
                    }
                  ),
                  d.label
                ]
              },
              d.value
            )) })
          ] })
        ]
      }
    ) })
  ] });
}
function Zq(e, r) {
  if (e == null) return {};
  var t = {}, i = Object.keys(e), n, s;
  for (s = 0; s < i.length; s++)
    n = i[s], !(r.indexOf(n) >= 0) && (t[n] = e[n]);
  return t;
}
var KXe = ["color"], hXe = /* @__PURE__ */ re(function(e, r) {
  var t = e.color, i = t === void 0 ? "currentColor" : t, n = Zq(e, KXe);
  return lr("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, n, {
    ref: r
  }), lr("path", {
    d: "M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z",
    fill: i,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), pXe = ["color"], mXe = /* @__PURE__ */ re(function(e, r) {
  var t = e.color, i = t === void 0 ? "currentColor" : t, n = Zq(e, pXe);
  return lr("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, n, {
    ref: r
  }), lr("path", {
    d: "M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z",
    fill: i,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), gXe = ["color"], vXe = /* @__PURE__ */ re(function(e, r) {
  var t = e.color, i = t === void 0 ? "currentColor" : t, n = Zq(e, gXe);
  return lr("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, n, {
    ref: r
  }), lr("path", {
    d: "M3.625 7.5C3.625 8.12132 3.12132 8.625 2.5 8.625C1.87868 8.625 1.375 8.12132 1.375 7.5C1.375 6.87868 1.87868 6.375 2.5 6.375C3.12132 6.375 3.625 6.87868 3.625 7.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM12.5 8.625C13.1213 8.625 13.625 8.12132 13.625 7.5C13.625 6.87868 13.1213 6.375 12.5 6.375C11.8787 6.375 11.375 6.87868 11.375 7.5C11.375 8.12132 11.8787 8.625 12.5 8.625Z",
    fill: i,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), bXe = ["color"], yXe = /* @__PURE__ */ re(function(e, r) {
  var t = e.color, i = t === void 0 ? "currentColor" : t, n = Zq(e, bXe);
  return lr("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, n, {
    ref: r
  }), lr("path", {
    d: "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159Z",
    fill: i,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), A9 = 1, AXe = 0.9, wXe = 0.8, CXe = 0.17, kh = 0.1, Oh = 0.999, PXe = 0.9999, SXe = 0.99, NXe = /[\\\/_+.#"@\[\(\{&]/, MXe = /[\\\/_+.#"@\[\(\{&]/g, TXe = /[\s-]/, pL = /[\s-]/g;
function mv(e, r, t, i, n, s, u) {
  if (s === r.length) return n === e.length ? A9 : SXe;
  var o = `${n},${s}`;
  if (u[o] !== void 0) return u[o];
  for (var d = i.charAt(s), a = t.indexOf(d, n), V = 0, c, F, X, Y; a >= 0; ) c = mv(e, r, t, i, a + 1, s + 1, u), c > V && (a === n ? c *= A9 : NXe.test(e.charAt(a - 1)) ? (c *= wXe, X = e.slice(n, a - 1).match(MXe), X && n > 0 && (c *= Math.pow(Oh, X.length))) : TXe.test(e.charAt(a - 1)) ? (c *= AXe, Y = e.slice(n, a - 1).match(pL), Y && n > 0 && (c *= Math.pow(Oh, Y.length))) : (c *= CXe, n > 0 && (c *= Math.pow(Oh, a - n))), e.charAt(a) !== r.charAt(s) && (c *= PXe)), (c < kh && t.charAt(a - 1) === i.charAt(s + 1) || i.charAt(s + 1) === i.charAt(s) && t.charAt(a - 1) !== i.charAt(s)) && (F = mv(e, r, t, i, a + 1, s + 2, u), F * kh > c && (c = F * kh)), c > V && (V = c), a = t.indexOf(d, a + 1);
  return u[o] = V, V;
}
function w9(e) {
  return e.toLowerCase().replace(pL, " ");
}
function EXe(e, r, t) {
  return e = t && t.length > 0 ? `${e + " " + t.join(" ")}` : e, mv(e, r, w9(e), w9(r), 0, 0, {});
}
function Pi() {
  return Pi = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t) ({}).hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Pi.apply(null, arguments);
}
function VV(e, r, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), t === !1 || !n.defaultPrevented) return r == null ? void 0 : r(n);
  };
}
function kXe(e, r) {
  typeof e == "function" ? e(r) : e != null && (e.current = r);
}
function mL(...e) {
  return (r) => e.forEach(
    (t) => kXe(t, r)
  );
}
function o2(...e) {
  return Yi(mL(...e), e);
}
function OXe(e, r) {
  const t = /* @__PURE__ */ et(r);
  function i(s) {
    const { children: u, ...o } = s, d = $e(
      () => o,
      Object.values(o)
    );
    return /* @__PURE__ */ lr(t.Provider, {
      value: d
    }, u);
  }
  function n(s) {
    const u = rt(t);
    if (u) return u;
    if (r !== void 0) return r;
    throw new Error(`\`${s}\` must be used within \`${e}\``);
  }
  return i.displayName = e + "Provider", [
    i,
    n
  ];
}
function DXe(e, r = []) {
  let t = [];
  function i(s, u) {
    const o = /* @__PURE__ */ et(u), d = t.length;
    t = [
      ...t,
      u
    ];
    function a(c) {
      const { scope: F, children: X, ...Y } = c, q = (F == null ? void 0 : F[e][d]) || o, f = $e(
        () => Y,
        Object.values(Y)
      );
      return /* @__PURE__ */ lr(q.Provider, {
        value: f
      }, X);
    }
    function V(c, F) {
      const X = (F == null ? void 0 : F[e][d]) || o, Y = rt(X);
      if (Y) return Y;
      if (u !== void 0) return u;
      throw new Error(`\`${c}\` must be used within \`${s}\``);
    }
    return a.displayName = s + "Provider", [
      a,
      V
    ];
  }
  const n = () => {
    const s = t.map((u) => /* @__PURE__ */ et(u));
    return function(o) {
      const d = (o == null ? void 0 : o[e]) || s;
      return $e(
        () => ({
          [`__scope${e}`]: {
            ...o,
            [e]: d
          }
        }),
        [
          o,
          d
        ]
      );
    };
  };
  return n.scopeName = e, [
    i,
    RXe(n, ...r)
  ];
}
function RXe(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const t = () => {
    const i = e.map(
      (n) => ({
        useScope: n(),
        scopeName: n.scopeName
      })
    );
    return function(s) {
      const u = i.reduce((o, { useScope: d, scopeName: a }) => {
        const c = d(s)[`__scope${a}`];
        return {
          ...o,
          ...c
        };
      }, {});
      return $e(
        () => ({
          [`__scope${r.scopeName}`]: u
        }),
        [
          u
        ]
      );
    };
  };
  return t.scopeName = r.scopeName, t;
}
const gv = globalThis != null && globalThis.document ? Eq : () => {
}, IXe = h.useId || (() => {
});
let LXe = 0;
function Dh(e) {
  const [r, t] = h.useState(IXe());
  return gv(() => {
    t(
      (i) => i ?? String(LXe++)
    );
  }, [
    e
  ]), e || (r ? `radix-${r}` : "");
}
function Wd(e) {
  const r = Yr(e);
  return Pe(() => {
    r.current = e;
  }), $e(
    () => (...t) => {
      var i;
      return (i = r.current) === null || i === void 0 ? void 0 : i.call(r, ...t);
    },
    []
  );
}
function _Xe({ prop: e, defaultProp: r, onChange: t = () => {
} }) {
  const [i, n] = HXe({
    defaultProp: r,
    onChange: t
  }), s = e !== void 0, u = s ? e : i, o = Wd(t), d = Yi((a) => {
    if (s) {
      const c = typeof a == "function" ? a(e) : a;
      c !== e && o(c);
    } else n(a);
  }, [
    s,
    e,
    n,
    o
  ]);
  return [
    u,
    d
  ];
}
function HXe({ defaultProp: e, onChange: r }) {
  const t = ie(e), [i] = t, n = Yr(i), s = Wd(r);
  return Pe(() => {
    n.current !== i && (s(i), n.current = i);
  }, [
    i,
    n,
    s
  ]), t;
}
const t3 = /* @__PURE__ */ re((e, r) => {
  const { children: t, ...i } = e, n = Hi.toArray(t), s = n.find(zXe);
  if (s) {
    const u = s.props.children, o = n.map((d) => d === s ? Hi.count(u) > 1 ? Hi.only(null) : /* @__PURE__ */ Ci(u) ? u.props.children : null : d);
    return /* @__PURE__ */ lr(vv, Pi({}, i, {
      ref: r
    }), /* @__PURE__ */ Ci(u) ? /* @__PURE__ */ at(u, void 0, o) : null);
  }
  return /* @__PURE__ */ lr(vv, Pi({}, i, {
    ref: r
  }), t);
});
t3.displayName = "Slot";
const vv = /* @__PURE__ */ re((e, r) => {
  const { children: t, ...i } = e;
  return /* @__PURE__ */ Ci(t) ? /* @__PURE__ */ at(t, {
    ...BXe(i, t.props),
    ref: r ? mL(r, t.ref) : t.ref
  }) : Hi.count(t) > 1 ? Hi.only(null) : null;
});
vv.displayName = "SlotClone";
const jXe = ({ children: e }) => /* @__PURE__ */ lr(Do, null, e);
function zXe(e) {
  return /* @__PURE__ */ Ci(e) && e.type === jXe;
}
function BXe(e, r) {
  const t = {
    ...r
  };
  for (const i in r) {
    const n = e[i], s = r[i];
    /^on[A-Z]/.test(i) ? n && s ? t[i] = (...o) => {
      s(...o), n(...o);
    } : n && (t[i] = n) : i === "style" ? t[i] = {
      ...n,
      ...s
    } : i === "className" && (t[i] = [
      n,
      s
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...t
  };
}
const WXe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], In = WXe.reduce((e, r) => {
  const t = /* @__PURE__ */ re((i, n) => {
    const { asChild: s, ...u } = i, o = s ? t3 : r;
    return Pe(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ lr(o, Pi({}, u, {
      ref: n
    }));
  });
  return t.displayName = `Primitive.${r}`, {
    ...e,
    [r]: t
  };
}, {});
function GXe(e, r) {
  e && lR(
    () => e.dispatchEvent(r)
  );
}
function UXe(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Wd(e);
  Pe(() => {
    const i = (n) => {
      n.key === "Escape" && t(n);
    };
    return r.addEventListener("keydown", i), () => r.removeEventListener("keydown", i);
  }, [
    t,
    r
  ]);
}
const bv = "dismissableLayer.update", ZXe = "dismissableLayer.pointerDownOutside", JXe = "dismissableLayer.focusOutside";
let C9;
const $Xe = /* @__PURE__ */ et({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), QXe = /* @__PURE__ */ re((e, r) => {
  var t;
  const { disableOutsidePointerEvents: i = !1, onEscapeKeyDown: n, onPointerDownOutside: s, onFocusOutside: u, onInteractOutside: o, onDismiss: d, ...a } = e, V = rt($Xe), [c, F] = ie(null), X = (t = c == null ? void 0 : c.ownerDocument) !== null && t !== void 0 ? t : globalThis == null ? void 0 : globalThis.document, [, Y] = ie({}), q = o2(
    r,
    (S) => F(S)
  ), f = Array.from(V.layers), [p] = [
    ...V.layersWithOutsidePointerEventsDisabled
  ].slice(-1), m = f.indexOf(p), g = c ? f.indexOf(c) : -1, y = V.layersWithOutsidePointerEventsDisabled.size > 0, b = g >= m, A = eqe((S) => {
    const N = S.target, O = [
      ...V.branches
    ].some(
      (E) => E.contains(N)
    );
    !b || O || (s == null || s(S), o == null || o(S), S.defaultPrevented || d == null || d());
  }, X), w = rqe((S) => {
    const N = S.target;
    [
      ...V.branches
    ].some(
      (E) => E.contains(N)
    ) || (u == null || u(S), o == null || o(S), S.defaultPrevented || d == null || d());
  }, X);
  return UXe((S) => {
    g === V.layers.size - 1 && (n == null || n(S), !S.defaultPrevented && d && (S.preventDefault(), d()));
  }, X), Pe(() => {
    if (c)
      return i && (V.layersWithOutsidePointerEventsDisabled.size === 0 && (C9 = X.body.style.pointerEvents, X.body.style.pointerEvents = "none"), V.layersWithOutsidePointerEventsDisabled.add(c)), V.layers.add(c), P9(), () => {
        i && V.layersWithOutsidePointerEventsDisabled.size === 1 && (X.body.style.pointerEvents = C9);
      };
  }, [
    c,
    X,
    i,
    V
  ]), Pe(() => () => {
    c && (V.layers.delete(c), V.layersWithOutsidePointerEventsDisabled.delete(c), P9());
  }, [
    c,
    V
  ]), Pe(() => {
    const S = () => Y({});
    return document.addEventListener(bv, S), () => document.removeEventListener(bv, S);
  }, []), /* @__PURE__ */ lr(In.div, Pi({}, a, {
    ref: q,
    style: {
      pointerEvents: y ? b ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: VV(e.onFocusCapture, w.onFocusCapture),
    onBlurCapture: VV(e.onBlurCapture, w.onBlurCapture),
    onPointerDownCapture: VV(e.onPointerDownCapture, A.onPointerDownCapture)
  }));
});
function eqe(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Wd(e), i = Yr(!1), n = Yr(() => {
  });
  return Pe(() => {
    const s = (o) => {
      if (o.target && !i.current) {
        let a = function() {
          gL(ZXe, t, d, {
            discrete: !0
          });
        };
        const d = {
          originalEvent: o
        };
        o.pointerType === "touch" ? (r.removeEventListener("click", n.current), n.current = a, r.addEventListener("click", n.current, {
          once: !0
        })) : a();
      } else
        r.removeEventListener("click", n.current);
      i.current = !1;
    }, u = window.setTimeout(() => {
      r.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(u), r.removeEventListener("pointerdown", s), r.removeEventListener("click", n.current);
    };
  }, [
    r,
    t
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => i.current = !0
  };
}
function rqe(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Wd(e), i = Yr(!1);
  return Pe(() => {
    const n = (s) => {
      s.target && !i.current && gL(JXe, t, {
        originalEvent: s
      }, {
        discrete: !1
      });
    };
    return r.addEventListener("focusin", n), () => r.removeEventListener("focusin", n);
  }, [
    r,
    t
  ]), {
    onFocusCapture: () => i.current = !0,
    onBlurCapture: () => i.current = !1
  };
}
function P9() {
  const e = new CustomEvent(bv);
  document.dispatchEvent(e);
}
function gL(e, r, t, { discrete: i }) {
  const n = t.originalEvent.target, s = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: t
  });
  r && n.addEventListener(e, r, {
    once: !0
  }), i ? GXe(n, s) : n.dispatchEvent(s);
}
const Rh = "focusScope.autoFocusOnMount", Ih = "focusScope.autoFocusOnUnmount", S9 = {
  bubbles: !1,
  cancelable: !0
}, tqe = /* @__PURE__ */ re((e, r) => {
  const { loop: t = !1, trapped: i = !1, onMountAutoFocus: n, onUnmountAutoFocus: s, ...u } = e, [o, d] = ie(null), a = Wd(n), V = Wd(s), c = Yr(null), F = o2(
    r,
    (q) => d(q)
  ), X = Yr({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  Pe(() => {
    if (i) {
      let q = function(g) {
        if (X.paused || !o) return;
        const y = g.target;
        o.contains(y) ? c.current = y : co(c.current, {
          select: !0
        });
      }, f = function(g) {
        if (X.paused || !o) return;
        const y = g.relatedTarget;
        y !== null && (o.contains(y) || co(c.current, {
          select: !0
        }));
      }, p = function(g) {
        if (document.activeElement === document.body)
          for (const b of g) b.removedNodes.length > 0 && co(o);
      };
      document.addEventListener("focusin", q), document.addEventListener("focusout", f);
      const m = new MutationObserver(p);
      return o && m.observe(o, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", q), document.removeEventListener("focusout", f), m.disconnect();
      };
    }
  }, [
    i,
    o,
    X.paused
  ]), Pe(() => {
    if (o) {
      M9.add(X);
      const q = document.activeElement;
      if (!o.contains(q)) {
        const p = new CustomEvent(Rh, S9);
        o.addEventListener(Rh, a), o.dispatchEvent(p), p.defaultPrevented || (iqe(dqe(vL(o)), {
          select: !0
        }), document.activeElement === q && co(o));
      }
      return () => {
        o.removeEventListener(Rh, a), setTimeout(() => {
          const p = new CustomEvent(Ih, S9);
          o.addEventListener(Ih, V), o.dispatchEvent(p), p.defaultPrevented || co(q ?? document.body, {
            select: !0
          }), o.removeEventListener(Ih, V), M9.remove(X);
        }, 0);
      };
    }
  }, [
    o,
    a,
    V,
    X
  ]);
  const Y = Yi((q) => {
    if (!t && !i || X.paused) return;
    const f = q.key === "Tab" && !q.altKey && !q.ctrlKey && !q.metaKey, p = document.activeElement;
    if (f && p) {
      const m = q.currentTarget, [g, y] = nqe(m);
      g && y ? !q.shiftKey && p === y ? (q.preventDefault(), t && co(g, {
        select: !0
      })) : q.shiftKey && p === g && (q.preventDefault(), t && co(y, {
        select: !0
      })) : p === m && q.preventDefault();
    }
  }, [
    t,
    i,
    X.paused
  ]);
  return /* @__PURE__ */ lr(In.div, Pi({
    tabIndex: -1
  }, u, {
    ref: F,
    onKeyDown: Y
  }));
});
function iqe(e, { select: r = !1 } = {}) {
  const t = document.activeElement;
  for (const i of e)
    if (co(i, {
      select: r
    }), document.activeElement !== t) return;
}
function nqe(e) {
  const r = vL(e), t = N9(r, e), i = N9(r.reverse(), e);
  return [
    t,
    i
  ];
}
function vL(e) {
  const r = [], t = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (i) => {
      const n = i.tagName === "INPUT" && i.type === "hidden";
      return i.disabled || i.hidden || n ? NodeFilter.FILTER_SKIP : i.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); ) r.push(t.currentNode);
  return r;
}
function N9(e, r) {
  for (const t of e)
    if (!sqe(t, {
      upTo: r
    })) return t;
}
function sqe(e, { upTo: r }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (r !== void 0 && e === r) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function uqe(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function co(e, { select: r = !1 } = {}) {
  if (e && e.focus) {
    const t = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== t && uqe(e) && r && e.select();
  }
}
const M9 = oqe();
function oqe() {
  let e = [];
  return {
    add(r) {
      const t = e[0];
      r !== t && (t == null || t.pause()), e = T9(e, r), e.unshift(r);
    },
    remove(r) {
      var t;
      e = T9(e, r), (t = e[0]) === null || t === void 0 || t.resume();
    }
  };
}
function T9(e, r) {
  const t = [
    ...e
  ], i = t.indexOf(r);
  return i !== -1 && t.splice(i, 1), t;
}
function dqe(e) {
  return e.filter(
    (r) => r.tagName !== "A"
  );
}
const aqe = /* @__PURE__ */ re((e, r) => {
  var t;
  const { container: i = globalThis == null || (t = globalThis.document) === null || t === void 0 ? void 0 : t.body, ...n } = e;
  return i ? /* @__PURE__ */ Us.createPortal(/* @__PURE__ */ lr(In.div, Pi({}, n, {
    ref: r
  })), i) : null;
});
function Vqe(e, r) {
  return mae((t, i) => {
    const n = r[t][i];
    return n ?? t;
  }, e);
}
const Jq = (e) => {
  const { present: r, children: t } = e, i = lqe(r), n = typeof t == "function" ? t({
    present: i.isPresent
  }) : Hi.only(t), s = o2(i.ref, n.ref);
  return typeof t == "function" || i.isPresent ? /* @__PURE__ */ at(n, {
    ref: s
  }) : null;
};
Jq.displayName = "Presence";
function lqe(e) {
  const [r, t] = ie(), i = Yr({}), n = Yr(e), s = Yr("none"), u = e ? "mounted" : "unmounted", [o, d] = Vqe(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Pe(() => {
    const a = RF(i.current);
    s.current = o === "mounted" ? a : "none";
  }, [
    o
  ]), gv(() => {
    const a = i.current, V = n.current;
    if (V !== e) {
      const F = s.current, X = RF(a);
      e ? d("MOUNT") : X === "none" || (a == null ? void 0 : a.display) === "none" ? d("UNMOUNT") : d(V && F !== X ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [
    e,
    d
  ]), gv(() => {
    if (r) {
      const a = (c) => {
        const X = RF(i.current).includes(c.animationName);
        c.target === r && X && lR(
          () => d("ANIMATION_END")
        );
      }, V = (c) => {
        c.target === r && (s.current = RF(i.current));
      };
      return r.addEventListener("animationstart", V), r.addEventListener("animationcancel", a), r.addEventListener("animationend", a), () => {
        r.removeEventListener("animationstart", V), r.removeEventListener("animationcancel", a), r.removeEventListener("animationend", a);
      };
    } else
      d("ANIMATION_END");
  }, [
    r,
    d
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(o),
    ref: Yi((a) => {
      a && (i.current = getComputedStyle(a)), t(a);
    }, [])
  };
}
function RF(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
let Lh = 0;
function cqe() {
  Pe(() => {
    var e, r;
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = t[0]) !== null && e !== void 0 ? e : E9()), document.body.insertAdjacentElement("beforeend", (r = t[1]) !== null && r !== void 0 ? r : E9()), Lh++, () => {
      Lh === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (i) => i.remove()
      ), Lh--;
    };
  }, []);
}
function E9() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var lV = "right-scroll-bar-position", cV = "width-before-scroll-bar", Fqe = "with-scroll-bars-hidden", xqe = "--removed-body-scroll-bar-size";
function _h(e, r) {
  return typeof e == "function" ? e(r) : e && (e.current = r), e;
}
function Xqe(e, r) {
  var t = ie(function() {
    return {
      // value
      value: e,
      // last callback
      callback: r,
      // "memoized" public interface
      facade: {
        get current() {
          return t.value;
        },
        set current(i) {
          var n = t.value;
          n !== i && (t.value = i, t.callback(i, n));
        }
      }
    };
  })[0];
  return t.callback = r, t.facade;
}
var qqe = typeof window < "u" ? h.useLayoutEffect : h.useEffect, k9 = /* @__PURE__ */ new WeakMap();
function i3(e, r) {
  var t = Xqe(null, function(i) {
    return e.forEach(function(n) {
      return _h(n, i);
    });
  });
  return qqe(function() {
    var i = k9.get(t);
    if (i) {
      var n = new Set(i), s = new Set(e), u = t.current;
      n.forEach(function(o) {
        s.has(o) || _h(o, null);
      }), s.forEach(function(o) {
        n.has(o) || _h(o, u);
      });
    }
    k9.set(t, e);
  }, [e]), t;
}
function Yqe(e) {
  return e;
}
function fqe(e, r) {
  r === void 0 && (r = Yqe);
  var t = [], i = !1, n = {
    read: function() {
      if (i)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return t.length ? t[t.length - 1] : e;
    },
    useMedium: function(s) {
      var u = r(s, i);
      return t.push(u), function() {
        t = t.filter(function(o) {
          return o !== u;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (i = !0; t.length; ) {
        var u = t;
        t = [], u.forEach(s);
      }
      t = {
        push: function(o) {
          return s(o);
        },
        filter: function() {
          return t;
        }
      };
    },
    assignMedium: function(s) {
      i = !0;
      var u = [];
      if (t.length) {
        var o = t;
        t = [], o.forEach(s), u = t;
      }
      var d = function() {
        var V = u;
        u = [], V.forEach(s);
      }, a = function() {
        return Promise.resolve().then(d);
      };
      a(), t = {
        push: function(V) {
          u.push(V), a();
        },
        filter: function(V) {
          return u = u.filter(V), t;
        }
      };
    }
  };
  return n;
}
function n3(e) {
  e === void 0 && (e = {});
  var r = fqe(null);
  return r.options = Ge({ async: !0, ssr: !1 }, e), r;
}
var bL = function(e) {
  var r = e.sideCar, t = $s(e, ["sideCar"]);
  if (!r)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var i = r.read();
  if (!i)
    throw new Error("Sidecar medium not found");
  return h.createElement(i, Ge({}, t));
};
bL.isSideCarExport = !0;
function s3(e, r) {
  return e.useMedium(r), bL;
}
var yL = n3(), Hh = function() {
}, $q = h.forwardRef(function(e, r) {
  var t = h.useRef(null), i = h.useState({
    onScrollCapture: Hh,
    onWheelCapture: Hh,
    onTouchMoveCapture: Hh
  }), n = i[0], s = i[1], u = e.forwardProps, o = e.children, d = e.className, a = e.removeScrollBar, V = e.enabled, c = e.shards, F = e.sideCar, X = e.noIsolation, Y = e.inert, q = e.allowPinchZoom, f = e.as, p = f === void 0 ? "div" : f, m = $s(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), g = F, y = i3([t, r]), b = Ge(Ge({}, m), n);
  return h.createElement(
    h.Fragment,
    null,
    V && h.createElement(g, { sideCar: yL, removeScrollBar: a, shards: c, noIsolation: X, inert: Y, setCallbacks: s, allowPinchZoom: !!q, lockRef: t }),
    u ? h.cloneElement(h.Children.only(o), Ge(Ge({}, b), { ref: y })) : h.createElement(p, Ge({}, b, { className: d, ref: y }), o)
  );
});
$q.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
$q.classNames = {
  fullWidth: cV,
  zeroRight: lV
};
function Kqe() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var r = Gq();
  return r && e.setAttribute("nonce", r), e;
}
function hqe(e, r) {
  e.styleSheet ? e.styleSheet.cssText = r : e.appendChild(document.createTextNode(r));
}
function pqe(e) {
  var r = document.head || document.getElementsByTagName("head")[0];
  r.appendChild(e);
}
var mqe = function() {
  var e = 0, r = null;
  return {
    add: function(t) {
      e == 0 && (r = Kqe()) && (hqe(r, t), pqe(r)), e++;
    },
    remove: function() {
      e--, !e && r && (r.parentNode && r.parentNode.removeChild(r), r = null);
    }
  };
}, gqe = function() {
  var e = mqe();
  return function(r, t) {
    h.useEffect(function() {
      return e.add(r), function() {
        e.remove();
      };
    }, [r && t]);
  };
}, Qq = function() {
  var e = gqe(), r = function(t) {
    var i = t.styles, n = t.dynamic;
    return e(i, n), null;
  };
  return r;
}, vqe = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, jh = function(e) {
  return parseInt(e || "", 10) || 0;
}, bqe = function(e) {
  var r = window.getComputedStyle(document.body), t = r[e === "padding" ? "paddingLeft" : "marginLeft"], i = r[e === "padding" ? "paddingTop" : "marginTop"], n = r[e === "padding" ? "paddingRight" : "marginRight"];
  return [jh(t), jh(i), jh(n)];
}, yqe = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return vqe;
  var r = bqe(e), t = document.documentElement.clientWidth, i = window.innerWidth;
  return {
    left: r[0],
    top: r[1],
    right: r[2],
    gap: Math.max(0, i - t + r[2] - r[0])
  };
}, Aqe = Qq(), FV = "data-scroll-locked", wqe = function(e, r, t, i) {
  var n = e.left, s = e.top, u = e.right, o = e.gap;
  return t === void 0 && (t = "margin"), `
  .`.concat(Fqe, ` {
   overflow: hidden `).concat(i, `;
   padding-right: `).concat(o, "px ").concat(i, `;
  }
  body[`).concat(FV, `] {
    overflow: hidden `).concat(i, `;
    overscroll-behavior: contain;
    `).concat([
    r && "position: relative ".concat(i, ";"),
    t === "margin" && `
    padding-left: `.concat(n, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(u, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(o, "px ").concat(i, `;
    `),
    t === "padding" && "padding-right: ".concat(o, "px ").concat(i, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(lV, ` {
    right: `).concat(o, "px ").concat(i, `;
  }
  
  .`).concat(cV, ` {
    margin-right: `).concat(o, "px ").concat(i, `;
  }
  
  .`).concat(lV, " .").concat(lV, ` {
    right: 0 `).concat(i, `;
  }
  
  .`).concat(cV, " .").concat(cV, ` {
    margin-right: 0 `).concat(i, `;
  }
  
  body[`).concat(FV, `] {
    `).concat(xqe, ": ").concat(o, `px;
  }
`);
}, O9 = function() {
  var e = parseInt(document.body.getAttribute(FV) || "0", 10);
  return isFinite(e) ? e : 0;
}, Cqe = function() {
  h.useEffect(function() {
    return document.body.setAttribute(FV, (O9() + 1).toString()), function() {
      var e = O9() - 1;
      e <= 0 ? document.body.removeAttribute(FV) : document.body.setAttribute(FV, e.toString());
    };
  }, []);
}, u3 = function(e) {
  var r = e.noRelative, t = e.noImportant, i = e.gapMode, n = i === void 0 ? "margin" : i;
  Cqe();
  var s = h.useMemo(function() {
    return yqe(n);
  }, [n]);
  return h.createElement(Aqe, { styles: wqe(s, !r, n, t ? "" : "!important") });
}, yv = !1;
if (typeof window < "u")
  try {
    var IF = Object.defineProperty({}, "passive", {
      get: function() {
        return yv = !0, !0;
      }
    });
    window.addEventListener("test", IF, IF), window.removeEventListener("test", IF, IF);
  } catch {
    yv = !1;
  }
var Oa = yv ? { passive: !1 } : !1, Pqe = function(e) {
  return e.tagName === "TEXTAREA";
}, AL = function(e, r) {
  var t = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    t[r] !== "hidden" && // contains scroll inside self
    !(t.overflowY === t.overflowX && !Pqe(e) && t[r] === "visible")
  );
}, Sqe = function(e) {
  return AL(e, "overflowY");
}, Nqe = function(e) {
  return AL(e, "overflowX");
}, D9 = function(e, r) {
  var t = r;
  do {
    typeof ShadowRoot < "u" && t instanceof ShadowRoot && (t = t.host);
    var i = wL(e, t);
    if (i) {
      var n = CL(e, t), s = n[1], u = n[2];
      if (s > u)
        return !0;
    }
    t = t.parentNode;
  } while (t && t !== document.body);
  return !1;
}, Mqe = function(e) {
  var r = e.scrollTop, t = e.scrollHeight, i = e.clientHeight;
  return [
    r,
    t,
    i
  ];
}, Tqe = function(e) {
  var r = e.scrollLeft, t = e.scrollWidth, i = e.clientWidth;
  return [
    r,
    t,
    i
  ];
}, wL = function(e, r) {
  return e === "v" ? Sqe(r) : Nqe(r);
}, CL = function(e, r) {
  return e === "v" ? Mqe(r) : Tqe(r);
}, Eqe = function(e, r) {
  return e === "h" && r === "rtl" ? -1 : 1;
}, kqe = function(e, r, t, i, n) {
  var s = Eqe(e, window.getComputedStyle(r).direction), u = s * i, o = t.target, d = r.contains(o), a = !1, V = u > 0, c = 0, F = 0;
  do {
    var X = CL(e, o), Y = X[0], q = X[1], f = X[2], p = q - f - s * Y;
    (Y || p) && wL(e, o) && (c += p, F += Y), o = o.parentNode;
  } while (
    // portaled content
    !d && o !== document.body || // self content
    d && (r.contains(o) || r === o)
  );
  return (V && c === 0 || !V && F === 0) && (a = !0), a;
}, LF = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, R9 = function(e) {
  return [e.deltaX, e.deltaY];
}, I9 = function(e) {
  return e && "current" in e ? e.current : e;
}, Oqe = function(e, r) {
  return e[0] === r[0] && e[1] === r[1];
}, Dqe = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Rqe = 0, Da = [];
function Iqe(e) {
  var r = h.useRef([]), t = h.useRef([0, 0]), i = h.useRef(), n = h.useState(Rqe++)[0], s = h.useState(function() {
    return Qq();
  })[0], u = h.useRef(e);
  h.useEffect(function() {
    u.current = e;
  }, [e]), h.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(n));
      var q = Yl([e.lockRef.current], (e.shards || []).map(I9), !0).filter(Boolean);
      return q.forEach(function(f) {
        return f.classList.add("allow-interactivity-".concat(n));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(n)), q.forEach(function(f) {
          return f.classList.remove("allow-interactivity-".concat(n));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var o = h.useCallback(function(q, f) {
    if ("touches" in q && q.touches.length === 2)
      return !u.current.allowPinchZoom;
    var p = LF(q), m = t.current, g = "deltaX" in q ? q.deltaX : m[0] - p[0], y = "deltaY" in q ? q.deltaY : m[1] - p[1], b, A = q.target, w = Math.abs(g) > Math.abs(y) ? "h" : "v";
    if ("touches" in q && w === "h" && A.type === "range")
      return !1;
    var S = D9(w, A);
    if (!S)
      return !0;
    if (S ? b = w : (b = w === "v" ? "h" : "v", S = D9(w, A)), !S)
      return !1;
    if (!i.current && "changedTouches" in q && (g || y) && (i.current = b), !b)
      return !0;
    var N = i.current || b;
    return kqe(N, f, q, N === "h" ? g : y);
  }, []), d = h.useCallback(function(q) {
    var f = q;
    if (!(!Da.length || Da[Da.length - 1] !== s)) {
      var p = "deltaY" in f ? R9(f) : LF(f), m = r.current.filter(function(b) {
        return b.name === f.type && b.target === f.target && Oqe(b.delta, p);
      })[0];
      if (m && m.should) {
        f.cancelable && f.preventDefault();
        return;
      }
      if (!m) {
        var g = (u.current.shards || []).map(I9).filter(Boolean).filter(function(b) {
          return b.contains(f.target);
        }), y = g.length > 0 ? o(f, g[0]) : !u.current.noIsolation;
        y && f.cancelable && f.preventDefault();
      }
    }
  }, []), a = h.useCallback(function(q, f, p, m) {
    var g = { name: q, delta: f, target: p, should: m };
    r.current.push(g), setTimeout(function() {
      r.current = r.current.filter(function(y) {
        return y !== g;
      });
    }, 1);
  }, []), V = h.useCallback(function(q) {
    t.current = LF(q), i.current = void 0;
  }, []), c = h.useCallback(function(q) {
    a(q.type, R9(q), q.target, o(q, e.lockRef.current));
  }, []), F = h.useCallback(function(q) {
    a(q.type, LF(q), q.target, o(q, e.lockRef.current));
  }, []);
  h.useEffect(function() {
    return Da.push(s), e.setCallbacks({
      onScrollCapture: c,
      onWheelCapture: c,
      onTouchMoveCapture: F
    }), document.addEventListener("wheel", d, Oa), document.addEventListener("touchmove", d, Oa), document.addEventListener("touchstart", V, Oa), function() {
      Da = Da.filter(function(q) {
        return q !== s;
      }), document.removeEventListener("wheel", d, Oa), document.removeEventListener("touchmove", d, Oa), document.removeEventListener("touchstart", V, Oa);
    };
  }, []);
  var X = e.removeScrollBar, Y = e.inert;
  return h.createElement(
    h.Fragment,
    null,
    Y ? h.createElement(s, { styles: Dqe(n) }) : null,
    X ? h.createElement(u3, { gapMode: "margin" }) : null
  );
}
const Lqe = s3(yL, Iqe);
var PL = h.forwardRef(function(e, r) {
  return h.createElement($q, Ge({}, e, { ref: r, sideCar: Lqe }));
});
PL.classNames = $q.classNames;
const SL = "Dialog", [NL, MQe] = DXe(SL), [_qe, aa] = NL(SL), Hqe = (e) => {
  const { __scopeDialog: r, children: t, open: i, defaultOpen: n, onOpenChange: s, modal: u = !0 } = e, o = Yr(null), d = Yr(null), [a = !1, V] = _Xe({
    prop: i,
    defaultProp: n,
    onChange: s
  });
  return /* @__PURE__ */ lr(_qe, {
    scope: r,
    triggerRef: o,
    contentRef: d,
    contentId: Dh(),
    titleId: Dh(),
    descriptionId: Dh(),
    open: a,
    onOpenChange: V,
    onOpenToggle: Yi(
      () => V(
        (c) => !c
      ),
      [
        V
      ]
    ),
    modal: u
  }, t);
}, ML = "DialogPortal", [jqe, TL] = NL(ML, {
  forceMount: void 0
}), zqe = (e) => {
  const { __scopeDialog: r, forceMount: t, children: i, container: n } = e, s = aa(ML, r);
  return /* @__PURE__ */ lr(jqe, {
    scope: r,
    forceMount: t
  }, Hi.map(
    i,
    (u) => /* @__PURE__ */ lr(Jq, {
      present: t || s.open
    }, /* @__PURE__ */ lr(aqe, {
      asChild: !0,
      container: n
    }, u))
  ));
}, Av = "DialogOverlay", Bqe = /* @__PURE__ */ re((e, r) => {
  const t = TL(Av, e.__scopeDialog), { forceMount: i = t.forceMount, ...n } = e, s = aa(Av, e.__scopeDialog);
  return s.modal ? /* @__PURE__ */ lr(Jq, {
    present: i || s.open
  }, /* @__PURE__ */ lr(Wqe, Pi({}, n, {
    ref: r
  }))) : null;
}), Wqe = /* @__PURE__ */ re((e, r) => {
  const { __scopeDialog: t, ...i } = e, n = aa(Av, t);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ lr(PL, {
      as: t3,
      allowPinchZoom: !0,
      shards: [
        n.contentRef
      ]
    }, /* @__PURE__ */ lr(In.div, Pi({
      "data-state": kL(n.open)
    }, i, {
      ref: r,
      style: {
        pointerEvents: "auto",
        ...i.style
      }
    })))
  );
}), wV = "DialogContent", Gqe = /* @__PURE__ */ re((e, r) => {
  const t = TL(wV, e.__scopeDialog), { forceMount: i = t.forceMount, ...n } = e, s = aa(wV, e.__scopeDialog);
  return /* @__PURE__ */ lr(Jq, {
    present: i || s.open
  }, s.modal ? /* @__PURE__ */ lr(Uqe, Pi({}, n, {
    ref: r
  })) : /* @__PURE__ */ lr(Zqe, Pi({}, n, {
    ref: r
  })));
}), Uqe = /* @__PURE__ */ re((e, r) => {
  const t = aa(wV, e.__scopeDialog), i = Yr(null), n = o2(r, t.contentRef, i);
  return Pe(() => {
    const s = i.current;
    if (s) return fl(s);
  }, []), /* @__PURE__ */ lr(EL, Pi({}, e, {
    ref: n,
    trapFocus: t.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: VV(e.onCloseAutoFocus, (s) => {
      var u;
      s.preventDefault(), (u = t.triggerRef.current) === null || u === void 0 || u.focus();
    }),
    onPointerDownOutside: VV(e.onPointerDownOutside, (s) => {
      const u = s.detail.originalEvent, o = u.button === 0 && u.ctrlKey === !0;
      (u.button === 2 || o) && s.preventDefault();
    }),
    onFocusOutside: VV(
      e.onFocusOutside,
      (s) => s.preventDefault()
    )
  }));
}), Zqe = /* @__PURE__ */ re((e, r) => {
  const t = aa(wV, e.__scopeDialog), i = Yr(!1), n = Yr(!1);
  return /* @__PURE__ */ lr(EL, Pi({}, e, {
    ref: r,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (s) => {
      var u;
      if ((u = e.onCloseAutoFocus) === null || u === void 0 || u.call(e, s), !s.defaultPrevented) {
        var o;
        i.current || (o = t.triggerRef.current) === null || o === void 0 || o.focus(), s.preventDefault();
      }
      i.current = !1, n.current = !1;
    },
    onInteractOutside: (s) => {
      var u, o;
      (u = e.onInteractOutside) === null || u === void 0 || u.call(e, s), s.defaultPrevented || (i.current = !0, s.detail.originalEvent.type === "pointerdown" && (n.current = !0));
      const d = s.target;
      ((o = t.triggerRef.current) === null || o === void 0 ? void 0 : o.contains(d)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && n.current && s.preventDefault();
    }
  }));
}), EL = /* @__PURE__ */ re((e, r) => {
  const { __scopeDialog: t, trapFocus: i, onOpenAutoFocus: n, onCloseAutoFocus: s, ...u } = e, o = aa(wV, t), d = Yr(null), a = o2(r, d);
  return cqe(), /* @__PURE__ */ lr(Do, null, /* @__PURE__ */ lr(tqe, {
    asChild: !0,
    loop: !0,
    trapped: i,
    onMountAutoFocus: n,
    onUnmountAutoFocus: s
  }, /* @__PURE__ */ lr(QXe, Pi({
    role: "dialog",
    id: o.contentId,
    "aria-describedby": o.descriptionId,
    "aria-labelledby": o.titleId,
    "data-state": kL(o.open)
  }, u, {
    ref: a,
    onDismiss: () => o.onOpenChange(!1)
  }))), !1);
}), Jqe = "DialogTitle";
function kL(e) {
  return e ? "open" : "closed";
}
const $qe = "DialogTitleWarning";
OXe($qe, {
  contentName: wV,
  titleName: Jqe,
  docsSlug: "dialog"
});
const Qqe = Hqe, eYe = zqe, rYe = Bqe, tYe = Gqe;
var ac = '[cmdk-group=""]', zh = '[cmdk-group-items=""]', iYe = '[cmdk-group-heading=""]', o3 = '[cmdk-item=""]', L9 = `${o3}:not([aria-disabled="true"])`, wv = "cmdk-item-select", pd = "data-value", nYe = (e, r, t) => EXe(e, r, t), OL = h.createContext(void 0), d2 = () => h.useContext(OL), DL = h.createContext(void 0), d3 = () => h.useContext(DL), RL = h.createContext(void 0), IL = h.forwardRef((e, r) => {
  let t = Qa(() => {
    var U, de;
    return { search: "", value: (de = (U = e.value) != null ? U : e.defaultValue) != null ? de : "", filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), i = Qa(() => /* @__PURE__ */ new Set()), n = Qa(() => /* @__PURE__ */ new Map()), s = Qa(() => /* @__PURE__ */ new Map()), u = Qa(() => /* @__PURE__ */ new Set()), o = LL(e), { label: d, children: a, value: V, onValueChange: c, filter: F, shouldFilter: X, loop: Y, disablePointerSelection: q = !1, vimBindings: f = !0, ...p } = e, m = h.useId(), g = h.useId(), y = h.useId(), b = h.useRef(null), A = XYe();
  Gd(() => {
    if (V !== void 0) {
      let U = V.trim();
      t.current.value = U, w.emit();
    }
  }, [V]), Gd(() => {
    A(6, R);
  }, []);
  let w = h.useMemo(() => ({ subscribe: (U) => (u.current.add(U), () => u.current.delete(U)), snapshot: () => t.current, setState: (U, de, Ke) => {
    var xe, be, qe;
    if (!Object.is(t.current[U], de)) {
      if (t.current[U] = de, U === "search") I(), O(), A(1, E);
      else if (U === "value" && (Ke || A(5, R), ((xe = o.current) == null ? void 0 : xe.value) !== void 0)) {
        let me = de ?? "";
        (qe = (be = o.current).onValueChange) == null || qe.call(be, me);
        return;
      }
      w.emit();
    }
  }, emit: () => {
    u.current.forEach((U) => U());
  } }), []), S = h.useMemo(() => ({ value: (U, de, Ke) => {
    var xe;
    de !== ((xe = s.current.get(U)) == null ? void 0 : xe.value) && (s.current.set(U, { value: de, keywords: Ke }), t.current.filtered.items.set(U, N(de, Ke)), A(2, () => {
      O(), w.emit();
    }));
  }, item: (U, de) => (i.current.add(U), de && (n.current.has(de) ? n.current.get(de).add(U) : n.current.set(de, /* @__PURE__ */ new Set([U]))), A(3, () => {
    I(), O(), t.current.value || E(), w.emit();
  }), () => {
    s.current.delete(U), i.current.delete(U), t.current.filtered.items.delete(U);
    let Ke = H();
    A(4, () => {
      I(), (Ke == null ? void 0 : Ke.getAttribute("id")) === U && E(), w.emit();
    });
  }), group: (U) => (n.current.has(U) || n.current.set(U, /* @__PURE__ */ new Set()), () => {
    s.current.delete(U), n.current.delete(U);
  }), filter: () => o.current.shouldFilter, label: d || e["aria-label"], disablePointerSelection: q, listId: m, inputId: y, labelId: g, listInnerRef: b }), []);
  function N(U, de) {
    var Ke, xe;
    let be = (xe = (Ke = o.current) == null ? void 0 : Ke.filter) != null ? xe : nYe;
    return U ? be(U, t.current.search, de) : 0;
  }
  function O() {
    if (!t.current.search || o.current.shouldFilter === !1) return;
    let U = t.current.filtered.items, de = [];
    t.current.filtered.groups.forEach((xe) => {
      let be = n.current.get(xe), qe = 0;
      be.forEach((me) => {
        let ne = U.get(me);
        qe = Math.max(ne, qe);
      }), de.push([xe, qe]);
    });
    let Ke = b.current;
    W().sort((xe, be) => {
      var qe, me;
      let ne = xe.getAttribute("id"), fe = be.getAttribute("id");
      return ((qe = U.get(fe)) != null ? qe : 0) - ((me = U.get(ne)) != null ? me : 0);
    }).forEach((xe) => {
      let be = xe.closest(zh);
      be ? be.appendChild(xe.parentElement === be ? xe : xe.closest(`${zh} > *`)) : Ke.appendChild(xe.parentElement === Ke ? xe : xe.closest(`${zh} > *`));
    }), de.sort((xe, be) => be[1] - xe[1]).forEach((xe) => {
      let be = b.current.querySelector(`${ac}[${pd}="${encodeURIComponent(xe[0])}"]`);
      be == null || be.parentElement.appendChild(be);
    });
  }
  function E() {
    let U = W().find((Ke) => Ke.getAttribute("aria-disabled") !== "true"), de = U == null ? void 0 : U.getAttribute(pd);
    w.setState("value", de || void 0);
  }
  function I() {
    var U, de, Ke, xe;
    if (!t.current.search || o.current.shouldFilter === !1) {
      t.current.filtered.count = i.current.size;
      return;
    }
    t.current.filtered.groups = /* @__PURE__ */ new Set();
    let be = 0;
    for (let qe of i.current) {
      let me = (de = (U = s.current.get(qe)) == null ? void 0 : U.value) != null ? de : "", ne = (xe = (Ke = s.current.get(qe)) == null ? void 0 : Ke.keywords) != null ? xe : [], fe = N(me, ne);
      t.current.filtered.items.set(qe, fe), fe > 0 && be++;
    }
    for (let [qe, me] of n.current) for (let ne of me) if (t.current.filtered.items.get(ne) > 0) {
      t.current.filtered.groups.add(qe);
      break;
    }
    t.current.filtered.count = be;
  }
  function R() {
    var U, de, Ke;
    let xe = H();
    xe && (((U = xe.parentElement) == null ? void 0 : U.firstChild) === xe && ((Ke = (de = xe.closest(ac)) == null ? void 0 : de.querySelector(iYe)) == null || Ke.scrollIntoView({ block: "nearest" })), xe.scrollIntoView({ block: "nearest" }));
  }
  function H() {
    var U;
    return (U = b.current) == null ? void 0 : U.querySelector(`${o3}[aria-selected="true"]`);
  }
  function W() {
    var U;
    return Array.from((U = b.current) == null ? void 0 : U.querySelectorAll(L9));
  }
  function B(U) {
    let de = W()[U];
    de && w.setState("value", de.getAttribute(pd));
  }
  function L(U) {
    var de;
    let Ke = H(), xe = W(), be = xe.findIndex((me) => me === Ke), qe = xe[be + U];
    (de = o.current) != null && de.loop && (qe = be + U < 0 ? xe[xe.length - 1] : be + U === xe.length ? xe[0] : xe[be + U]), qe && w.setState("value", qe.getAttribute(pd));
  }
  function z(U) {
    let de = H(), Ke = de == null ? void 0 : de.closest(ac), xe;
    for (; Ke && !xe; ) Ke = U > 0 ? FYe(Ke, ac) : xYe(Ke, ac), xe = Ke == null ? void 0 : Ke.querySelector(L9);
    xe ? w.setState("value", xe.getAttribute(pd)) : L(U);
  }
  let Z = () => B(W().length - 1), le = (U) => {
    U.preventDefault(), U.metaKey ? Z() : U.altKey ? z(1) : L(1);
  }, te = (U) => {
    U.preventDefault(), U.metaKey ? B(0) : U.altKey ? z(-1) : L(-1);
  };
  return h.createElement(In.div, { ref: r, tabIndex: -1, ...p, "cmdk-root": "", onKeyDown: (U) => {
    var de;
    if ((de = p.onKeyDown) == null || de.call(p, U), !U.defaultPrevented) switch (U.key) {
      case "n":
      case "j": {
        f && U.ctrlKey && le(U);
        break;
      }
      case "ArrowDown": {
        le(U);
        break;
      }
      case "p":
      case "k": {
        f && U.ctrlKey && te(U);
        break;
      }
      case "ArrowUp": {
        te(U);
        break;
      }
      case "Home": {
        U.preventDefault(), B(0);
        break;
      }
      case "End": {
        U.preventDefault(), Z();
        break;
      }
      case "Enter":
        if (!U.nativeEvent.isComposing && U.keyCode !== 229) {
          U.preventDefault();
          let Ke = H();
          if (Ke) {
            let xe = new Event(wv);
            Ke.dispatchEvent(xe);
          }
        }
    }
  } }, h.createElement("label", { "cmdk-label": "", htmlFor: S.inputId, id: S.labelId, style: YYe }, d), eY(e, (U) => h.createElement(DL.Provider, { value: w }, h.createElement(OL.Provider, { value: S }, U))));
}), sYe = h.forwardRef((e, r) => {
  var t, i;
  let n = h.useId(), s = h.useRef(null), u = h.useContext(RL), o = d2(), d = LL(e), a = (i = (t = d.current) == null ? void 0 : t.forceMount) != null ? i : u == null ? void 0 : u.forceMount;
  Gd(() => {
    if (!a) return o.item(n, u == null ? void 0 : u.id);
  }, [a]);
  let V = _L(n, s, [e.value, e.children, s], e.keywords), c = d3(), F = Ud((A) => A.value && A.value === V.current), X = Ud((A) => a || o.filter() === !1 ? !0 : A.search ? A.filtered.items.get(n) > 0 : !0);
  h.useEffect(() => {
    let A = s.current;
    if (!(!A || e.disabled)) return A.addEventListener(wv, Y), () => A.removeEventListener(wv, Y);
  }, [X, e.onSelect, e.disabled]);
  function Y() {
    var A, w;
    q(), (w = (A = d.current).onSelect) == null || w.call(A, V.current);
  }
  function q() {
    c.setState("value", V.current, !0);
  }
  if (!X) return null;
  let { disabled: f, value: p, onSelect: m, forceMount: g, keywords: y, ...b } = e;
  return h.createElement(In.div, { ref: Zc([s, r]), ...b, id: n, "cmdk-item": "", role: "option", "aria-disabled": !!f, "aria-selected": !!F, "data-disabled": !!f, "data-selected": !!F, onPointerMove: f || o.disablePointerSelection ? void 0 : q, onClick: f ? void 0 : Y }, e.children);
}), uYe = h.forwardRef((e, r) => {
  let { heading: t, children: i, forceMount: n, ...s } = e, u = h.useId(), o = h.useRef(null), d = h.useRef(null), a = h.useId(), V = d2(), c = Ud((X) => n || V.filter() === !1 ? !0 : X.search ? X.filtered.groups.has(u) : !0);
  Gd(() => V.group(u), []), _L(u, o, [e.value, e.heading, d]);
  let F = h.useMemo(() => ({ id: u, forceMount: n }), [n]);
  return h.createElement(In.div, { ref: Zc([o, r]), ...s, "cmdk-group": "", role: "presentation", hidden: c ? void 0 : !0 }, t && h.createElement("div", { ref: d, "cmdk-group-heading": "", "aria-hidden": !0, id: a }, t), eY(e, (X) => h.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": t ? a : void 0 }, h.createElement(RL.Provider, { value: F }, X))));
}), oYe = h.forwardRef((e, r) => {
  let { alwaysRender: t, ...i } = e, n = h.useRef(null), s = Ud((u) => !u.search);
  return !t && !s ? null : h.createElement(In.div, { ref: Zc([n, r]), ...i, "cmdk-separator": "", role: "separator" });
}), dYe = h.forwardRef((e, r) => {
  let { onValueChange: t, ...i } = e, n = e.value != null, s = d3(), u = Ud((V) => V.search), o = Ud((V) => V.value), d = d2(), a = h.useMemo(() => {
    var V;
    let c = (V = d.listInnerRef.current) == null ? void 0 : V.querySelector(`${o3}[${pd}="${encodeURIComponent(o)}"]`);
    return c == null ? void 0 : c.getAttribute("id");
  }, []);
  return h.useEffect(() => {
    e.value != null && s.setState("search", e.value);
  }, [e.value]), h.createElement(In.input, { ref: r, ...i, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": d.listId, "aria-labelledby": d.labelId, "aria-activedescendant": a, id: d.inputId, type: "text", value: n ? e.value : u, onChange: (V) => {
    n || s.setState("search", V.target.value), t == null || t(V.target.value);
  } });
}), aYe = h.forwardRef((e, r) => {
  let { children: t, label: i = "Suggestions", ...n } = e, s = h.useRef(null), u = h.useRef(null), o = d2();
  return h.useEffect(() => {
    if (u.current && s.current) {
      let d = u.current, a = s.current, V, c = new ResizeObserver(() => {
        V = requestAnimationFrame(() => {
          let F = d.offsetHeight;
          a.style.setProperty("--cmdk-list-height", F.toFixed(1) + "px");
        });
      });
      return c.observe(d), () => {
        cancelAnimationFrame(V), c.unobserve(d);
      };
    }
  }, []), h.createElement(In.div, { ref: Zc([s, r]), ...n, "cmdk-list": "", role: "listbox", "aria-label": i, id: o.listId }, eY(e, (d) => h.createElement("div", { ref: Zc([u, o.listInnerRef]), "cmdk-list-sizer": "" }, d)));
}), VYe = h.forwardRef((e, r) => {
  let { open: t, onOpenChange: i, overlayClassName: n, contentClassName: s, container: u, ...o } = e;
  return h.createElement(Qqe, { open: t, onOpenChange: i }, h.createElement(eYe, { container: u }, h.createElement(rYe, { "cmdk-overlay": "", className: n }), h.createElement(tYe, { "aria-label": e.label, "cmdk-dialog": "", className: s }, h.createElement(IL, { ref: r, ...o }))));
}), lYe = h.forwardRef((e, r) => Ud((t) => t.filtered.count === 0) ? h.createElement(In.div, { ref: r, ...e, "cmdk-empty": "", role: "presentation" }) : null), cYe = h.forwardRef((e, r) => {
  let { progress: t, children: i, label: n = "Loading...", ...s } = e;
  return h.createElement(In.div, { ref: r, ...s, "cmdk-loading": "", role: "progressbar", "aria-valuenow": t, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": n }, eY(e, (u) => h.createElement("div", { "aria-hidden": !0 }, u)));
}), ui = Object.assign(IL, { List: aYe, Item: sYe, Input: dYe, Group: uYe, Separator: oYe, Dialog: VYe, Empty: lYe, Loading: cYe });
function FYe(e, r) {
  let t = e.nextElementSibling;
  for (; t; ) {
    if (t.matches(r)) return t;
    t = t.nextElementSibling;
  }
}
function xYe(e, r) {
  let t = e.previousElementSibling;
  for (; t; ) {
    if (t.matches(r)) return t;
    t = t.previousElementSibling;
  }
}
function LL(e) {
  let r = h.useRef(e);
  return Gd(() => {
    r.current = e;
  }), r;
}
var Gd = typeof window > "u" ? h.useEffect : h.useLayoutEffect;
function Qa(e) {
  let r = h.useRef();
  return r.current === void 0 && (r.current = e()), r;
}
function Zc(e) {
  return (r) => {
    e.forEach((t) => {
      typeof t == "function" ? t(r) : t != null && (t.current = r);
    });
  };
}
function Ud(e) {
  let r = d3(), t = () => e(r.snapshot());
  return h.useSyncExternalStore(r.subscribe, t, t);
}
function _L(e, r, t, i = []) {
  let n = h.useRef(), s = d2();
  return Gd(() => {
    var u;
    let o = (() => {
      var a;
      for (let V of t) {
        if (typeof V == "string") return V.trim();
        if (typeof V == "object" && "current" in V) return V.current ? (a = V.current.textContent) == null ? void 0 : a.trim() : n.current;
      }
    })(), d = i.map((a) => a.trim());
    s.value(e, o, d), (u = r.current) == null || u.setAttribute(pd, o), n.current = o;
  }), n;
}
var XYe = () => {
  let [e, r] = h.useState(), t = Qa(() => /* @__PURE__ */ new Map());
  return Gd(() => {
    t.current.forEach((i) => i()), t.current = /* @__PURE__ */ new Map();
  }, [e]), (i, n) => {
    t.current.set(i, n), r({});
  };
};
function qYe(e) {
  let r = e.type;
  return typeof r == "function" ? r(e.props) : "render" in r ? r.render(e.props) : e;
}
function eY({ asChild: e, children: r }, t) {
  return e && h.isValidElement(r) ? h.cloneElement(qYe(r), { ref: r.ref }, t(r.props.children)) : t(r);
}
var YYe = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const hl = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  ui,
  {
    ref: t,
    className: _(
      "bg-popover text-popover-foreground flex h-full w-full flex-col overflow-hidden rounded-md",
      e
    ),
    ...r
  }
));
hl.displayName = ui.displayName;
const TQe = ({ children: e, ...r }) => /* @__PURE__ */ l(vY, { ...r, children: /* @__PURE__ */ l(q2, { className: "overflow-hidden p-0", children: /* @__PURE__ */ l(hl, { className: "[&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5", children: e }) }) }), HL = re(({ className: e, wrapperClassName: r, ...t }, i) => /* @__PURE__ */ C(
  "div",
  {
    className: _("flex items-center border-b px-3", r),
    "cmdk-input-wrapper": "",
    children: [
      /* @__PURE__ */ l(yXe, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
      /* @__PURE__ */ l(
        ui.Input,
        {
          ref: i,
          className: _(
            "placeholder:text-muted-foreground outline-hidden flex h-10 w-full rounded-md bg-transparent py-3 text-bodysm disabled:cursor-not-allowed disabled:opacity-50",
            e
          ),
          ...t
        }
      )
    ]
  }
));
HL.displayName = ui.Input.displayName;
const a2 = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  ui.List,
  {
    ref: t,
    className: _("max-h-[300px] overflow-y-auto overflow-x-hidden", e),
    ...r
  }
));
a2.displayName = ui.List.displayName;
const a3 = re((e, r) => /* @__PURE__ */ l(
  ui.Empty,
  {
    ref: r,
    className: "py-6 text-center text-bodysm",
    ...e
  }
));
a3.displayName = ui.Empty.displayName;
const V2 = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  ui.Group,
  {
    ref: t,
    className: _(
      "text-foreground [&_[cmdk-group-heading]]:text-muted-foreground overflow-hidden p-1 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-bodysm [&_[cmdk-group-heading]]:font-medium",
      e
    ),
    ...r
  }
));
V2.displayName = ui.Group.displayName;
const fYe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  ui.Separator,
  {
    ref: t,
    className: _("bg-border -mx-1 h-px", e),
    ...r
  }
));
fYe.displayName = ui.Separator.displayName;
const l2 = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  ui.Item,
  {
    ref: t,
    className: _(
      "data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground rounded-xs outline-hidden relative flex cursor-default select-none items-center px-2 py-1.5 text-bodysm data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50",
      e
    ),
    ...r
  }
));
l2.displayName = ui.Item.displayName;
const KYe = ({
  className: e,
  ...r
}) => /* @__PURE__ */ l(
  "span",
  {
    className: _(
      "text-muted-foreground ml-auto text-bodysmxs tracking-widest",
      e
    ),
    ...r
  }
);
KYe.displayName = "CommandShortcut";
function rY(e, r = []) {
  let t = [];
  function i(s, u) {
    const o = h.createContext(u), d = t.length;
    t = [...t, u];
    const a = (c) => {
      var p;
      const { scope: F, children: X, ...Y } = c, q = ((p = F == null ? void 0 : F[e]) == null ? void 0 : p[d]) || o, f = h.useMemo(() => Y, Object.values(Y));
      return /* @__PURE__ */ l(q.Provider, { value: f, children: X });
    };
    a.displayName = s + "Provider";
    function V(c, F) {
      var q;
      const X = ((q = F == null ? void 0 : F[e]) == null ? void 0 : q[d]) || o, Y = h.useContext(X);
      if (Y) return Y;
      if (u !== void 0) return u;
      throw new Error(`\`${c}\` must be used within \`${s}\``);
    }
    return [a, V];
  }
  const n = () => {
    const s = t.map((u) => h.createContext(u));
    return function(o) {
      const d = (o == null ? void 0 : o[e]) || s;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: d } }),
        [o, d]
      );
    };
  };
  return n.scopeName = e, [i, hYe(n, ...r)];
}
function hYe(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const t = () => {
    const i = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(s) {
      const u = i.reduce((o, { useScope: d, scopeName: a }) => {
        const c = d(s)[`__scope${a}`];
        return { ...o, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${r.scopeName}`]: u }), [u]);
    };
  };
  return t.scopeName = r.scopeName, t;
}
function pYe(e, r) {
  return h.useReducer((t, i) => r[t][i] ?? t, e);
}
var jL = (e) => {
  const { present: r, children: t } = e, i = mYe(r), n = typeof t == "function" ? t({ present: i.isPresent }) : h.Children.only(t), s = rr(i.ref, gYe(n));
  return typeof t == "function" || i.isPresent ? h.cloneElement(n, { ref: s }) : null;
};
jL.displayName = "Presence";
function mYe(e) {
  const [r, t] = h.useState(), i = h.useRef({}), n = h.useRef(e), s = h.useRef("none"), u = e ? "mounted" : "unmounted", [o, d] = pYe(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return h.useEffect(() => {
    const a = _F(i.current);
    s.current = o === "mounted" ? a : "none";
  }, [o]), ze(() => {
    const a = i.current, V = n.current;
    if (V !== e) {
      const F = s.current, X = _F(a);
      e ? d("MOUNT") : X === "none" || (a == null ? void 0 : a.display) === "none" ? d("UNMOUNT") : d(V && F !== X ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, d]), ze(() => {
    if (r) {
      let a;
      const V = r.ownerDocument.defaultView ?? window, c = (X) => {
        const q = _F(i.current).includes(X.animationName);
        if (X.target === r && q && (d("ANIMATION_END"), !n.current)) {
          const f = r.style.animationFillMode;
          r.style.animationFillMode = "forwards", a = V.setTimeout(() => {
            r.style.animationFillMode === "forwards" && (r.style.animationFillMode = f);
          });
        }
      }, F = (X) => {
        X.target === r && (s.current = _F(i.current));
      };
      return r.addEventListener("animationstart", F), r.addEventListener("animationcancel", c), r.addEventListener("animationend", c), () => {
        V.clearTimeout(a), r.removeEventListener("animationstart", F), r.removeEventListener("animationcancel", c), r.removeEventListener("animationend", c);
      };
    } else
      d("ANIMATION_END");
  }, [r, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: h.useCallback((a) => {
      a && (i.current = getComputedStyle(a)), t(a);
    }, [])
  };
}
function _F(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function gYe(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var V3 = "Collapsible", [vYe, EQe] = rY(V3), [bYe, l3] = vYe(V3), zL = h.forwardRef(
  (e, r) => {
    const {
      __scopeCollapsible: t,
      open: i,
      defaultOpen: n,
      disabled: s,
      onOpenChange: u,
      ...o
    } = e, [d = !1, a] = Gr({
      prop: i,
      defaultProp: n,
      onChange: u
    });
    return /* @__PURE__ */ l(
      bYe,
      {
        scope: t,
        disabled: s,
        contentId: ot(),
        open: d,
        onOpenToggle: h.useCallback(() => a((V) => !V), [a]),
        children: /* @__PURE__ */ l(
          Me.div,
          {
            "data-state": F3(d),
            "data-disabled": s ? "" : void 0,
            ...o,
            ref: r
          }
        )
      }
    );
  }
);
zL.displayName = V3;
var BL = "CollapsibleTrigger", WL = h.forwardRef(
  (e, r) => {
    const { __scopeCollapsible: t, ...i } = e, n = l3(BL, t);
    return /* @__PURE__ */ l(
      Me.button,
      {
        type: "button",
        "aria-controls": n.contentId,
        "aria-expanded": n.open || !1,
        "data-state": F3(n.open),
        "data-disabled": n.disabled ? "" : void 0,
        disabled: n.disabled,
        ...i,
        ref: r,
        onClick: Ne(e.onClick, n.onOpenToggle)
      }
    );
  }
);
WL.displayName = BL;
var c3 = "CollapsibleContent", GL = h.forwardRef(
  (e, r) => {
    const { forceMount: t, ...i } = e, n = l3(c3, e.__scopeCollapsible);
    return /* @__PURE__ */ l(jL, { present: t || n.open, children: ({ present: s }) => /* @__PURE__ */ l(yYe, { ...i, ref: r, present: s }) });
  }
);
GL.displayName = c3;
var yYe = h.forwardRef((e, r) => {
  const { __scopeCollapsible: t, present: i, children: n, ...s } = e, u = l3(c3, t), [o, d] = h.useState(i), a = h.useRef(null), V = rr(r, a), c = h.useRef(0), F = c.current, X = h.useRef(0), Y = X.current, q = u.open || o, f = h.useRef(q), p = h.useRef();
  return h.useEffect(() => {
    const m = requestAnimationFrame(() => f.current = !1);
    return () => cancelAnimationFrame(m);
  }, []), ze(() => {
    const m = a.current;
    if (m) {
      p.current = p.current || {
        transitionDuration: m.style.transitionDuration,
        animationName: m.style.animationName
      }, m.style.transitionDuration = "0s", m.style.animationName = "none";
      const g = m.getBoundingClientRect();
      c.current = g.height, X.current = g.width, f.current || (m.style.transitionDuration = p.current.transitionDuration, m.style.animationName = p.current.animationName), d(i);
    }
  }, [u.open, i]), /* @__PURE__ */ l(
    Me.div,
    {
      "data-state": F3(u.open),
      "data-disabled": u.disabled ? "" : void 0,
      id: u.contentId,
      hidden: !q,
      ...s,
      ref: V,
      style: {
        "--radix-collapsible-content-height": F ? `${F}px` : void 0,
        "--radix-collapsible-content-width": Y ? `${Y}px` : void 0,
        ...e.style
      },
      children: q && n
    }
  );
});
function F3(e) {
  return e ? "open" : "closed";
}
var AYe = zL;
const kQe = AYe, OQe = WL, DQe = GL;
function RQe({
  table: e
}) {
  const r = e == null ? void 0 : e.getAllLeafColumns().reduce((i, n) => n.getIsVisible() ? i : i + 1, 0), t = () => {
    const n = ((e == null ? void 0 : e.getAllLeafColumns()) || []).filter((s) => s.getCanHide());
    return /* @__PURE__ */ l("ul", { className: "flex flex-col gap-2", children: n.map((s) => /* @__PURE__ */ l("li", { children: /* @__PURE__ */ C(_r, { className: "text-bodymd flex items-center gap-1", children: [
      /* @__PURE__ */ l(
        b2,
        {
          checked: s.getIsVisible(),
          className: "!h-3 !w-6",
          onCheckedChange: (u) => s.toggleVisibility(u),
          thumbClassName: "!h-2 !w-2 data-[state=checked]:!translate-x-3"
        }
      ),
      " ",
      /* @__PURE__ */ l(he, { children: s.columnDef.header })
    ] }) }, s.id)) });
  };
  return /* @__PURE__ */ C(qY, { children: [
    /* @__PURE__ */ l(YY, { asChild: !0, children: /* @__PURE__ */ C(
      er,
      {
        className: _(
          "text-textPrimary !rounded",
          r === 0 ? "!border-interactiveBorder" : "!border-blueBorder bg-blueBgDefault"
        ),
        variant: "outline",
        children: [
          /* @__PURE__ */ l(lVe, {}),
          r === 0 ? "Hide fields" : `${r} hidden fields`
        ]
      }
    ) }),
    /* @__PURE__ */ C(
      x2,
      {
        align: "start",
        className: "flex flex-col gap-3",
        side: "bottom",
        children: [
          t(),
          /* @__PURE__ */ l(
            er,
            {
              className: "!border-interactiveBorder text-textPrimary !text-bodysm h-min w-full py-1.5",
              onClick: () => e == null ? void 0 : e.toggleAllColumnsVisible(!0),
              variant: "outline",
              children: "Show all"
            }
          )
        ]
      }
    )
  ] });
}
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function IQe() {
  return {
    accessor: (e, r) => typeof e == "function" ? {
      ...r,
      accessorFn: e
    } : {
      ...r,
      accessorKey: e
    },
    display: (e) => e,
    group: (e) => e
  };
}
function bo(e, r) {
  return typeof e == "function" ? e(r) : e;
}
function Xn(e, r) {
  return (t) => {
    r.setState((i) => ({
      ...i,
      [e]: bo(t, i[e])
    }));
  };
}
function tY(e) {
  return e instanceof Function;
}
function wYe(e) {
  return Array.isArray(e) && e.every((r) => typeof r == "number");
}
function CYe(e, r) {
  const t = [], i = (n) => {
    n.forEach((s) => {
      t.push(s);
      const u = r(s);
      u != null && u.length && i(u);
    });
  };
  return i(e), t;
}
function He(e, r, t) {
  let i = [], n;
  return (s) => {
    let u;
    t.key && t.debug && (u = Date.now());
    const o = e(s);
    if (!(o.length !== i.length || o.some((V, c) => i[c] !== V)))
      return n;
    i = o;
    let a;
    if (t.key && t.debug && (a = Date.now()), n = r(...o), t == null || t.onChange == null || t.onChange(n), t.key && t.debug && t != null && t.debug()) {
      const V = Math.round((Date.now() - u) * 100) / 100, c = Math.round((Date.now() - a) * 100) / 100, F = c / 16, X = (Y, q) => {
        for (Y = String(Y); Y.length < q; )
          Y = " " + Y;
        return Y;
      };
      console.info(`%c⏱ ${X(c, 5)} /${X(V, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * F, 120))}deg 100% 31%);`, t == null ? void 0 : t.key);
    }
    return n;
  };
}
function je(e, r, t, i) {
  return {
    debug: () => {
      var n;
      return (n = e == null ? void 0 : e.debugAll) != null ? n : e[r];
    },
    key: process.env.NODE_ENV === "development" && t,
    onChange: i
  };
}
function PYe(e, r, t, i) {
  const n = () => {
    var u;
    return (u = s.getValue()) != null ? u : e.options.renderFallbackValue;
  }, s = {
    id: `${r.id}_${t.id}`,
    row: r,
    column: t,
    getValue: () => r.getValue(i),
    renderValue: n,
    getContext: He(() => [e, t, r, s], (u, o, d, a) => ({
      table: u,
      column: o,
      row: d,
      cell: a,
      getValue: a.getValue,
      renderValue: a.renderValue
    }), je(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((u) => {
    u.createCell == null || u.createCell(s, t, r, e);
  }, {}), s;
}
function SYe(e, r, t, i) {
  var n, s;
  const o = {
    ...e._getDefaultColumnDef(),
    ...r
  }, d = o.accessorKey;
  let a = (n = (s = o.id) != null ? s : d ? typeof String.prototype.replaceAll == "function" ? d.replaceAll(".", "_") : d.replace(/\./g, "_") : void 0) != null ? n : typeof o.header == "string" ? o.header : void 0, V;
  if (o.accessorFn ? V = o.accessorFn : d && (d.includes(".") ? V = (F) => {
    let X = F;
    for (const q of d.split(".")) {
      var Y;
      X = (Y = X) == null ? void 0 : Y[q], process.env.NODE_ENV !== "production" && X === void 0 && console.warn(`"${q}" in deeply nested key "${d}" returned undefined.`);
    }
    return X;
  } : V = (F) => F[o.accessorKey]), !a)
    throw process.env.NODE_ENV !== "production" ? new Error(o.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let c = {
    id: `${String(a)}`,
    accessorFn: V,
    parent: i,
    depth: t,
    columnDef: o,
    columns: [],
    getFlatColumns: He(() => [!0], () => {
      var F;
      return [c, ...(F = c.columns) == null ? void 0 : F.flatMap((X) => X.getFlatColumns())];
    }, je(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: He(() => [e._getOrderColumnsFn()], (F) => {
      var X;
      if ((X = c.columns) != null && X.length) {
        let Y = c.columns.flatMap((q) => q.getLeafColumns());
        return F(Y);
      }
      return [c];
    }, je(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const F of e._features)
    F.createColumn == null || F.createColumn(c, e);
  return c;
}
const Vi = "debugHeaders";
function _9(e, r, t) {
  var i;
  let s = {
    id: (i = t.id) != null ? i : r.id,
    column: r,
    index: t.index,
    isPlaceholder: !!t.isPlaceholder,
    placeholderId: t.placeholderId,
    depth: t.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const u = [], o = (d) => {
        d.subHeaders && d.subHeaders.length && d.subHeaders.map(o), u.push(d);
      };
      return o(s), u;
    },
    getContext: () => ({
      table: e,
      header: s,
      column: r
    })
  };
  return e._features.forEach((u) => {
    u.createHeader == null || u.createHeader(s, e);
  }), s;
}
const NYe = {
  createTable: (e) => {
    e.getHeaderGroups = He(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (r, t, i, n) => {
      var s, u;
      const o = (s = i == null ? void 0 : i.map((c) => t.find((F) => F.id === c)).filter(Boolean)) != null ? s : [], d = (u = n == null ? void 0 : n.map((c) => t.find((F) => F.id === c)).filter(Boolean)) != null ? u : [], a = t.filter((c) => !(i != null && i.includes(c.id)) && !(n != null && n.includes(c.id)));
      return HF(r, [...o, ...a, ...d], e);
    }, je(e.options, Vi, "getHeaderGroups")), e.getCenterHeaderGroups = He(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (r, t, i, n) => (t = t.filter((s) => !(i != null && i.includes(s.id)) && !(n != null && n.includes(s.id))), HF(r, t, e, "center")), je(e.options, Vi, "getCenterHeaderGroups")), e.getLeftHeaderGroups = He(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (r, t, i) => {
      var n;
      const s = (n = i == null ? void 0 : i.map((u) => t.find((o) => o.id === u)).filter(Boolean)) != null ? n : [];
      return HF(r, s, e, "left");
    }, je(e.options, Vi, "getLeftHeaderGroups")), e.getRightHeaderGroups = He(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (r, t, i) => {
      var n;
      const s = (n = i == null ? void 0 : i.map((u) => t.find((o) => o.id === u)).filter(Boolean)) != null ? n : [];
      return HF(r, s, e, "right");
    }, je(e.options, Vi, "getRightHeaderGroups")), e.getFooterGroups = He(() => [e.getHeaderGroups()], (r) => [...r].reverse(), je(e.options, Vi, "getFooterGroups")), e.getLeftFooterGroups = He(() => [e.getLeftHeaderGroups()], (r) => [...r].reverse(), je(e.options, Vi, "getLeftFooterGroups")), e.getCenterFooterGroups = He(() => [e.getCenterHeaderGroups()], (r) => [...r].reverse(), je(e.options, Vi, "getCenterFooterGroups")), e.getRightFooterGroups = He(() => [e.getRightHeaderGroups()], (r) => [...r].reverse(), je(e.options, Vi, "getRightFooterGroups")), e.getFlatHeaders = He(() => [e.getHeaderGroups()], (r) => r.map((t) => t.headers).flat(), je(e.options, Vi, "getFlatHeaders")), e.getLeftFlatHeaders = He(() => [e.getLeftHeaderGroups()], (r) => r.map((t) => t.headers).flat(), je(e.options, Vi, "getLeftFlatHeaders")), e.getCenterFlatHeaders = He(() => [e.getCenterHeaderGroups()], (r) => r.map((t) => t.headers).flat(), je(e.options, Vi, "getCenterFlatHeaders")), e.getRightFlatHeaders = He(() => [e.getRightHeaderGroups()], (r) => r.map((t) => t.headers).flat(), je(e.options, Vi, "getRightFlatHeaders")), e.getCenterLeafHeaders = He(() => [e.getCenterFlatHeaders()], (r) => r.filter((t) => {
      var i;
      return !((i = t.subHeaders) != null && i.length);
    }), je(e.options, Vi, "getCenterLeafHeaders")), e.getLeftLeafHeaders = He(() => [e.getLeftFlatHeaders()], (r) => r.filter((t) => {
      var i;
      return !((i = t.subHeaders) != null && i.length);
    }), je(e.options, Vi, "getLeftLeafHeaders")), e.getRightLeafHeaders = He(() => [e.getRightFlatHeaders()], (r) => r.filter((t) => {
      var i;
      return !((i = t.subHeaders) != null && i.length);
    }), je(e.options, Vi, "getRightLeafHeaders")), e.getLeafHeaders = He(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (r, t, i) => {
      var n, s, u, o, d, a;
      return [...(n = (s = r[0]) == null ? void 0 : s.headers) != null ? n : [], ...(u = (o = t[0]) == null ? void 0 : o.headers) != null ? u : [], ...(d = (a = i[0]) == null ? void 0 : a.headers) != null ? d : []].map((V) => V.getLeafHeaders()).flat();
    }, je(e.options, Vi, "getLeafHeaders"));
  }
};
function HF(e, r, t, i) {
  var n, s;
  let u = 0;
  const o = function(F, X) {
    X === void 0 && (X = 1), u = Math.max(u, X), F.filter((Y) => Y.getIsVisible()).forEach((Y) => {
      var q;
      (q = Y.columns) != null && q.length && o(Y.columns, X + 1);
    }, 0);
  };
  o(e);
  let d = [];
  const a = (F, X) => {
    const Y = {
      depth: X,
      id: [i, `${X}`].filter(Boolean).join("_"),
      headers: []
    }, q = [];
    F.forEach((f) => {
      const p = [...q].reverse()[0], m = f.column.depth === Y.depth;
      let g, y = !1;
      if (m && f.column.parent ? g = f.column.parent : (g = f.column, y = !0), p && (p == null ? void 0 : p.column) === g)
        p.subHeaders.push(f);
      else {
        const b = _9(t, g, {
          id: [i, X, g.id, f == null ? void 0 : f.id].filter(Boolean).join("_"),
          isPlaceholder: y,
          placeholderId: y ? `${q.filter((A) => A.column === g).length}` : void 0,
          depth: X,
          index: q.length
        });
        b.subHeaders.push(f), q.push(b);
      }
      Y.headers.push(f), f.headerGroup = Y;
    }), d.push(Y), X > 0 && a(q, X - 1);
  }, V = r.map((F, X) => _9(t, F, {
    depth: u,
    index: X
  }));
  a(V, u - 1), d.reverse();
  const c = (F) => F.filter((Y) => Y.column.getIsVisible()).map((Y) => {
    let q = 0, f = 0, p = [0];
    Y.subHeaders && Y.subHeaders.length ? (p = [], c(Y.subHeaders).forEach((g) => {
      let {
        colSpan: y,
        rowSpan: b
      } = g;
      q += y, p.push(b);
    })) : q = 1;
    const m = Math.min(...p);
    return f = f + m, Y.colSpan = q, Y.rowSpan = f, {
      colSpan: q,
      rowSpan: f
    };
  });
  return c((n = (s = d[0]) == null ? void 0 : s.headers) != null ? n : []), d;
}
const x3 = (e, r, t, i, n, s, u) => {
  let o = {
    id: r,
    index: i,
    original: t,
    depth: n,
    parentId: u,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (d) => {
      if (o._valuesCache.hasOwnProperty(d))
        return o._valuesCache[d];
      const a = e.getColumn(d);
      if (a != null && a.accessorFn)
        return o._valuesCache[d] = a.accessorFn(o.original, i), o._valuesCache[d];
    },
    getUniqueValues: (d) => {
      if (o._uniqueValuesCache.hasOwnProperty(d))
        return o._uniqueValuesCache[d];
      const a = e.getColumn(d);
      if (a != null && a.accessorFn)
        return a.columnDef.getUniqueValues ? (o._uniqueValuesCache[d] = a.columnDef.getUniqueValues(o.original, i), o._uniqueValuesCache[d]) : (o._uniqueValuesCache[d] = [o.getValue(d)], o._uniqueValuesCache[d]);
    },
    renderValue: (d) => {
      var a;
      return (a = o.getValue(d)) != null ? a : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => CYe(o.subRows, (d) => d.subRows),
    getParentRow: () => o.parentId ? e.getRow(o.parentId, !0) : void 0,
    getParentRows: () => {
      let d = [], a = o;
      for (; ; ) {
        const V = a.getParentRow();
        if (!V) break;
        d.push(V), a = V;
      }
      return d.reverse();
    },
    getAllCells: He(() => [e.getAllLeafColumns()], (d) => d.map((a) => PYe(e, o, a, a.id)), je(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: He(() => [o.getAllCells()], (d) => d.reduce((a, V) => (a[V.column.id] = V, a), {}), je(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let d = 0; d < e._features.length; d++) {
    const a = e._features[d];
    a == null || a.createRow == null || a.createRow(o, e);
  }
  return o;
}, MYe = {
  createColumn: (e, r) => {
    e._getFacetedRowModel = r.options.getFacetedRowModel && r.options.getFacetedRowModel(r, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : r.getPreFilteredRowModel(), e._getFacetedUniqueValues = r.options.getFacetedUniqueValues && r.options.getFacetedUniqueValues(r, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = r.options.getFacetedMinMaxValues && r.options.getFacetedMinMaxValues(r, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, UL = (e, r, t) => {
  var i, n;
  const s = t == null || (i = t.toString()) == null ? void 0 : i.toLowerCase();
  return !!(!((n = e.getValue(r)) == null || (n = n.toString()) == null || (n = n.toLowerCase()) == null) && n.includes(s));
};
UL.autoRemove = (e) => ns(e);
const ZL = (e, r, t) => {
  var i;
  return !!(!((i = e.getValue(r)) == null || (i = i.toString()) == null) && i.includes(t));
};
ZL.autoRemove = (e) => ns(e);
const JL = (e, r, t) => {
  var i;
  return ((i = e.getValue(r)) == null || (i = i.toString()) == null ? void 0 : i.toLowerCase()) === (t == null ? void 0 : t.toLowerCase());
};
JL.autoRemove = (e) => ns(e);
const $L = (e, r, t) => {
  var i;
  return (i = e.getValue(r)) == null ? void 0 : i.includes(t);
};
$L.autoRemove = (e) => ns(e) || !(e != null && e.length);
const QL = (e, r, t) => !t.some((i) => {
  var n;
  return !((n = e.getValue(r)) != null && n.includes(i));
});
QL.autoRemove = (e) => ns(e) || !(e != null && e.length);
const e_ = (e, r, t) => t.some((i) => {
  var n;
  return (n = e.getValue(r)) == null ? void 0 : n.includes(i);
});
e_.autoRemove = (e) => ns(e) || !(e != null && e.length);
const r_ = (e, r, t) => e.getValue(r) === t;
r_.autoRemove = (e) => ns(e);
const t_ = (e, r, t) => e.getValue(r) == t;
t_.autoRemove = (e) => ns(e);
const X3 = (e, r, t) => {
  let [i, n] = t;
  const s = e.getValue(r);
  return s >= i && s <= n;
};
X3.resolveFilterValue = (e) => {
  let [r, t] = e, i = typeof r != "number" ? parseFloat(r) : r, n = typeof t != "number" ? parseFloat(t) : t, s = r === null || Number.isNaN(i) ? -1 / 0 : i, u = t === null || Number.isNaN(n) ? 1 / 0 : n;
  if (s > u) {
    const o = s;
    s = u, u = o;
  }
  return [s, u];
};
X3.autoRemove = (e) => ns(e) || ns(e[0]) && ns(e[1]);
const Ku = {
  includesString: UL,
  includesStringSensitive: ZL,
  equalsString: JL,
  arrIncludes: $L,
  arrIncludesAll: QL,
  arrIncludesSome: e_,
  equals: r_,
  weakEquals: t_,
  inNumberRange: X3
};
function ns(e) {
  return e == null || e === "";
}
const TYe = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: Xn("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, r) => {
    e.getAutoFilterFn = () => {
      const t = r.getCoreRowModel().flatRows[0], i = t == null ? void 0 : t.getValue(e.id);
      return typeof i == "string" ? Ku.includesString : typeof i == "number" ? Ku.inNumberRange : typeof i == "boolean" || i !== null && typeof i == "object" ? Ku.equals : Array.isArray(i) ? Ku.arrIncludes : Ku.weakEquals;
    }, e.getFilterFn = () => {
      var t, i;
      return tY(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (t = (i = r.options.filterFns) == null ? void 0 : i[e.columnDef.filterFn]) != null ? t : Ku[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var t, i, n;
      return ((t = e.columnDef.enableColumnFilter) != null ? t : !0) && ((i = r.options.enableColumnFilters) != null ? i : !0) && ((n = r.options.enableFilters) != null ? n : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var t;
      return (t = r.getState().columnFilters) == null || (t = t.find((i) => i.id === e.id)) == null ? void 0 : t.value;
    }, e.getFilterIndex = () => {
      var t, i;
      return (t = (i = r.getState().columnFilters) == null ? void 0 : i.findIndex((n) => n.id === e.id)) != null ? t : -1;
    }, e.setFilterValue = (t) => {
      r.setColumnFilters((i) => {
        const n = e.getFilterFn(), s = i == null ? void 0 : i.find((V) => V.id === e.id), u = bo(t, s ? s.value : void 0);
        if (H9(n, u, e)) {
          var o;
          return (o = i == null ? void 0 : i.filter((V) => V.id !== e.id)) != null ? o : [];
        }
        const d = {
          id: e.id,
          value: u
        };
        if (s) {
          var a;
          return (a = i == null ? void 0 : i.map((V) => V.id === e.id ? d : V)) != null ? a : [];
        }
        return i != null && i.length ? [...i, d] : [d];
      });
    };
  },
  createRow: (e, r) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (r) => {
      const t = e.getAllLeafColumns(), i = (n) => {
        var s;
        return (s = bo(r, n)) == null ? void 0 : s.filter((u) => {
          const o = t.find((d) => d.id === u.id);
          if (o) {
            const d = o.getFilterFn();
            if (H9(d, u.value, o))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(i);
    }, e.resetColumnFilters = (r) => {
      var t, i;
      e.setColumnFilters(r ? [] : (t = (i = e.initialState) == null ? void 0 : i.columnFilters) != null ? t : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function H9(e, r, t) {
  return (e && e.autoRemove ? e.autoRemove(r, t) : !1) || typeof r > "u" || typeof r == "string" && !r;
}
const EYe = (e, r, t) => t.reduce((i, n) => {
  const s = n.getValue(e);
  return i + (typeof s == "number" ? s : 0);
}, 0), kYe = (e, r, t) => {
  let i;
  return t.forEach((n) => {
    const s = n.getValue(e);
    s != null && (i > s || i === void 0 && s >= s) && (i = s);
  }), i;
}, OYe = (e, r, t) => {
  let i;
  return t.forEach((n) => {
    const s = n.getValue(e);
    s != null && (i < s || i === void 0 && s >= s) && (i = s);
  }), i;
}, DYe = (e, r, t) => {
  let i, n;
  return t.forEach((s) => {
    const u = s.getValue(e);
    u != null && (i === void 0 ? u >= u && (i = n = u) : (i > u && (i = u), n < u && (n = u)));
  }), [i, n];
}, RYe = (e, r) => {
  let t = 0, i = 0;
  if (r.forEach((n) => {
    let s = n.getValue(e);
    s != null && (s = +s) >= s && (++t, i += s);
  }), t) return i / t;
}, IYe = (e, r) => {
  if (!r.length)
    return;
  const t = r.map((s) => s.getValue(e));
  if (!wYe(t))
    return;
  if (t.length === 1)
    return t[0];
  const i = Math.floor(t.length / 2), n = t.sort((s, u) => s - u);
  return t.length % 2 !== 0 ? n[i] : (n[i - 1] + n[i]) / 2;
}, LYe = (e, r) => Array.from(new Set(r.map((t) => t.getValue(e))).values()), _Ye = (e, r) => new Set(r.map((t) => t.getValue(e))).size, HYe = (e, r) => r.length, Bh = {
  sum: EYe,
  min: kYe,
  max: OYe,
  extent: DYe,
  mean: RYe,
  median: IYe,
  unique: LYe,
  uniqueCount: _Ye,
  count: HYe
}, jYe = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var r, t;
      return (r = (t = e.getValue()) == null || t.toString == null ? void 0 : t.toString()) != null ? r : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: Xn("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, r) => {
    e.toggleGrouping = () => {
      r.setGrouping((t) => t != null && t.includes(e.id) ? t.filter((i) => i !== e.id) : [...t ?? [], e.id]);
    }, e.getCanGroup = () => {
      var t, i;
      return ((t = e.columnDef.enableGrouping) != null ? t : !0) && ((i = r.options.enableGrouping) != null ? i : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var t;
      return (t = r.getState().grouping) == null ? void 0 : t.includes(e.id);
    }, e.getGroupedIndex = () => {
      var t;
      return (t = r.getState().grouping) == null ? void 0 : t.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const t = e.getCanGroup();
      return () => {
        t && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const t = r.getCoreRowModel().flatRows[0], i = t == null ? void 0 : t.getValue(e.id);
      if (typeof i == "number")
        return Bh.sum;
      if (Object.prototype.toString.call(i) === "[object Date]")
        return Bh.extent;
    }, e.getAggregationFn = () => {
      var t, i;
      if (!e)
        throw new Error();
      return tY(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (t = (i = r.options.aggregationFns) == null ? void 0 : i[e.columnDef.aggregationFn]) != null ? t : Bh[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (r) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(r), e.resetGrouping = (r) => {
      var t, i;
      e.setGrouping(r ? [] : (t = (i = e.initialState) == null ? void 0 : i.grouping) != null ? t : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, r) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (t) => {
      if (e._groupingValuesCache.hasOwnProperty(t))
        return e._groupingValuesCache[t];
      const i = r.getColumn(t);
      return i != null && i.columnDef.getGroupingValue ? (e._groupingValuesCache[t] = i.columnDef.getGroupingValue(e.original), e._groupingValuesCache[t]) : e.getValue(t);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, r, t, i) => {
    e.getIsGrouped = () => r.getIsGrouped() && r.id === t.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && r.getIsGrouped(), e.getIsAggregated = () => {
      var n;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((n = t.subRows) != null && n.length);
    };
  }
};
function zYe(e, r, t) {
  if (!(r != null && r.length) || !t)
    return e;
  const i = e.filter((s) => !r.includes(s.id));
  return t === "remove" ? i : [...r.map((s) => e.find((u) => u.id === s)).filter(Boolean), ...i];
}
const BYe = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: Xn("columnOrder", e)
  }),
  createColumn: (e, r) => {
    e.getIndex = He((t) => [kc(r, t)], (t) => t.findIndex((i) => i.id === e.id), je(r.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (t) => {
      var i;
      return ((i = kc(r, t)[0]) == null ? void 0 : i.id) === e.id;
    }, e.getIsLastColumn = (t) => {
      var i;
      const n = kc(r, t);
      return ((i = n[n.length - 1]) == null ? void 0 : i.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (r) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(r), e.resetColumnOrder = (r) => {
      var t;
      e.setColumnOrder(r ? [] : (t = e.initialState.columnOrder) != null ? t : []);
    }, e._getOrderColumnsFn = He(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (r, t, i) => (n) => {
      let s = [];
      if (!(r != null && r.length))
        s = n;
      else {
        const u = [...r], o = [...n];
        for (; o.length && u.length; ) {
          const d = u.shift(), a = o.findIndex((V) => V.id === d);
          a > -1 && s.push(o.splice(a, 1)[0]);
        }
        s = [...s, ...o];
      }
      return zYe(s, t, i);
    }, je(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, Wh = () => ({
  left: [],
  right: []
}), WYe = {
  getInitialState: (e) => ({
    columnPinning: Wh(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: Xn("columnPinning", e)
  }),
  createColumn: (e, r) => {
    e.pin = (t) => {
      const i = e.getLeafColumns().map((n) => n.id).filter(Boolean);
      r.setColumnPinning((n) => {
        var s, u;
        if (t === "right") {
          var o, d;
          return {
            left: ((o = n == null ? void 0 : n.left) != null ? o : []).filter((c) => !(i != null && i.includes(c))),
            right: [...((d = n == null ? void 0 : n.right) != null ? d : []).filter((c) => !(i != null && i.includes(c))), ...i]
          };
        }
        if (t === "left") {
          var a, V;
          return {
            left: [...((a = n == null ? void 0 : n.left) != null ? a : []).filter((c) => !(i != null && i.includes(c))), ...i],
            right: ((V = n == null ? void 0 : n.right) != null ? V : []).filter((c) => !(i != null && i.includes(c)))
          };
        }
        return {
          left: ((s = n == null ? void 0 : n.left) != null ? s : []).filter((c) => !(i != null && i.includes(c))),
          right: ((u = n == null ? void 0 : n.right) != null ? u : []).filter((c) => !(i != null && i.includes(c)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((i) => {
      var n, s, u;
      return ((n = i.columnDef.enablePinning) != null ? n : !0) && ((s = (u = r.options.enableColumnPinning) != null ? u : r.options.enablePinning) != null ? s : !0);
    }), e.getIsPinned = () => {
      const t = e.getLeafColumns().map((o) => o.id), {
        left: i,
        right: n
      } = r.getState().columnPinning, s = t.some((o) => i == null ? void 0 : i.includes(o)), u = t.some((o) => n == null ? void 0 : n.includes(o));
      return s ? "left" : u ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var t, i;
      const n = e.getIsPinned();
      return n ? (t = (i = r.getState().columnPinning) == null || (i = i[n]) == null ? void 0 : i.indexOf(e.id)) != null ? t : -1 : 0;
    };
  },
  createRow: (e, r) => {
    e.getCenterVisibleCells = He(() => [e._getAllVisibleCells(), r.getState().columnPinning.left, r.getState().columnPinning.right], (t, i, n) => {
      const s = [...i ?? [], ...n ?? []];
      return t.filter((u) => !s.includes(u.column.id));
    }, je(r.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = He(() => [e._getAllVisibleCells(), r.getState().columnPinning.left], (t, i) => (i ?? []).map((s) => t.find((u) => u.column.id === s)).filter(Boolean).map((s) => ({
      ...s,
      position: "left"
    })), je(r.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = He(() => [e._getAllVisibleCells(), r.getState().columnPinning.right], (t, i) => (i ?? []).map((s) => t.find((u) => u.column.id === s)).filter(Boolean).map((s) => ({
      ...s,
      position: "right"
    })), je(r.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (r) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(r), e.resetColumnPinning = (r) => {
      var t, i;
      return e.setColumnPinning(r ? Wh() : (t = (i = e.initialState) == null ? void 0 : i.columnPinning) != null ? t : Wh());
    }, e.getIsSomeColumnsPinned = (r) => {
      var t;
      const i = e.getState().columnPinning;
      if (!r) {
        var n, s;
        return !!((n = i.left) != null && n.length || (s = i.right) != null && s.length);
      }
      return !!((t = i[r]) != null && t.length);
    }, e.getLeftLeafColumns = He(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (r, t) => (t ?? []).map((i) => r.find((n) => n.id === i)).filter(Boolean), je(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = He(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (r, t) => (t ?? []).map((i) => r.find((n) => n.id === i)).filter(Boolean), je(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = He(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (r, t, i) => {
      const n = [...t ?? [], ...i ?? []];
      return r.filter((s) => !n.includes(s.id));
    }, je(e.options, "debugColumns", "getCenterLeafColumns"));
  }
}, jF = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, Gh = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), GYe = {
  getDefaultColumnDef: () => jF,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: Gh(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: Xn("columnSizing", e),
    onColumnSizingInfoChange: Xn("columnSizingInfo", e)
  }),
  createColumn: (e, r) => {
    e.getSize = () => {
      var t, i, n;
      const s = r.getState().columnSizing[e.id];
      return Math.min(Math.max((t = e.columnDef.minSize) != null ? t : jF.minSize, (i = s ?? e.columnDef.size) != null ? i : jF.size), (n = e.columnDef.maxSize) != null ? n : jF.maxSize);
    }, e.getStart = He((t) => [t, kc(r, t), r.getState().columnSizing], (t, i) => i.slice(0, e.getIndex(t)).reduce((n, s) => n + s.getSize(), 0), je(r.options, "debugColumns", "getStart")), e.getAfter = He((t) => [t, kc(r, t), r.getState().columnSizing], (t, i) => i.slice(e.getIndex(t) + 1).reduce((n, s) => n + s.getSize(), 0), je(r.options, "debugColumns", "getAfter")), e.resetSize = () => {
      r.setColumnSizing((t) => {
        let {
          [e.id]: i,
          ...n
        } = t;
        return n;
      });
    }, e.getCanResize = () => {
      var t, i;
      return ((t = e.columnDef.enableResizing) != null ? t : !0) && ((i = r.options.enableColumnResizing) != null ? i : !0);
    }, e.getIsResizing = () => r.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, r) => {
    e.getSize = () => {
      let t = 0;
      const i = (n) => {
        if (n.subHeaders.length)
          n.subHeaders.forEach(i);
        else {
          var s;
          t += (s = n.column.getSize()) != null ? s : 0;
        }
      };
      return i(e), t;
    }, e.getStart = () => {
      if (e.index > 0) {
        const t = e.headerGroup.headers[e.index - 1];
        return t.getStart() + t.getSize();
      }
      return 0;
    }, e.getResizeHandler = (t) => {
      const i = r.getColumn(e.column.id), n = i == null ? void 0 : i.getCanResize();
      return (s) => {
        if (!i || !n || (s.persist == null || s.persist(), Uh(s) && s.touches && s.touches.length > 1))
          return;
        const u = e.getSize(), o = e ? e.getLeafHeaders().map((p) => [p.column.id, p.column.getSize()]) : [[i.id, i.getSize()]], d = Uh(s) ? Math.round(s.touches[0].clientX) : s.clientX, a = {}, V = (p, m) => {
          typeof m == "number" && (r.setColumnSizingInfo((g) => {
            var y, b;
            const A = r.options.columnResizeDirection === "rtl" ? -1 : 1, w = (m - ((y = g == null ? void 0 : g.startOffset) != null ? y : 0)) * A, S = Math.max(w / ((b = g == null ? void 0 : g.startSize) != null ? b : 0), -0.999999);
            return g.columnSizingStart.forEach((N) => {
              let [O, E] = N;
              a[O] = Math.round(Math.max(E + E * S, 0) * 100) / 100;
            }), {
              ...g,
              deltaOffset: w,
              deltaPercentage: S
            };
          }), (r.options.columnResizeMode === "onChange" || p === "end") && r.setColumnSizing((g) => ({
            ...g,
            ...a
          })));
        }, c = (p) => V("move", p), F = (p) => {
          V("end", p), r.setColumnSizingInfo((m) => ({
            ...m,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, X = t || typeof document < "u" ? document : null, Y = {
          moveHandler: (p) => c(p.clientX),
          upHandler: (p) => {
            X == null || X.removeEventListener("mousemove", Y.moveHandler), X == null || X.removeEventListener("mouseup", Y.upHandler), F(p.clientX);
          }
        }, q = {
          moveHandler: (p) => (p.cancelable && (p.preventDefault(), p.stopPropagation()), c(p.touches[0].clientX), !1),
          upHandler: (p) => {
            var m;
            X == null || X.removeEventListener("touchmove", q.moveHandler), X == null || X.removeEventListener("touchend", q.upHandler), p.cancelable && (p.preventDefault(), p.stopPropagation()), F((m = p.touches[0]) == null ? void 0 : m.clientX);
          }
        }, f = UYe() ? {
          passive: !1
        } : !1;
        Uh(s) ? (X == null || X.addEventListener("touchmove", q.moveHandler, f), X == null || X.addEventListener("touchend", q.upHandler, f)) : (X == null || X.addEventListener("mousemove", Y.moveHandler, f), X == null || X.addEventListener("mouseup", Y.upHandler, f)), r.setColumnSizingInfo((p) => ({
          ...p,
          startOffset: d,
          startSize: u,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: o,
          isResizingColumn: i.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (r) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(r), e.setColumnSizingInfo = (r) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(r), e.resetColumnSizing = (r) => {
      var t;
      e.setColumnSizing(r ? {} : (t = e.initialState.columnSizing) != null ? t : {});
    }, e.resetHeaderSizeInfo = (r) => {
      var t;
      e.setColumnSizingInfo(r ? Gh() : (t = e.initialState.columnSizingInfo) != null ? t : Gh());
    }, e.getTotalSize = () => {
      var r, t;
      return (r = (t = e.getHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((i, n) => i + n.getSize(), 0)) != null ? r : 0;
    }, e.getLeftTotalSize = () => {
      var r, t;
      return (r = (t = e.getLeftHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((i, n) => i + n.getSize(), 0)) != null ? r : 0;
    }, e.getCenterTotalSize = () => {
      var r, t;
      return (r = (t = e.getCenterHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((i, n) => i + n.getSize(), 0)) != null ? r : 0;
    }, e.getRightTotalSize = () => {
      var r, t;
      return (r = (t = e.getRightHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((i, n) => i + n.getSize(), 0)) != null ? r : 0;
    };
  }
};
let zF = null;
function UYe() {
  if (typeof zF == "boolean") return zF;
  let e = !1;
  try {
    const r = {
      get passive() {
        return e = !0, !1;
      }
    }, t = () => {
    };
    window.addEventListener("test", t, r), window.removeEventListener("test", t);
  } catch {
    e = !1;
  }
  return zF = e, zF;
}
function Uh(e) {
  return e.type === "touchstart";
}
const ZYe = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: Xn("columnVisibility", e)
  }),
  createColumn: (e, r) => {
    e.toggleVisibility = (t) => {
      e.getCanHide() && r.setColumnVisibility((i) => ({
        ...i,
        [e.id]: t ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var t, i;
      const n = e.columns;
      return (t = n.length ? n.some((s) => s.getIsVisible()) : (i = r.getState().columnVisibility) == null ? void 0 : i[e.id]) != null ? t : !0;
    }, e.getCanHide = () => {
      var t, i;
      return ((t = e.columnDef.enableHiding) != null ? t : !0) && ((i = r.options.enableHiding) != null ? i : !0);
    }, e.getToggleVisibilityHandler = () => (t) => {
      e.toggleVisibility == null || e.toggleVisibility(t.target.checked);
    };
  },
  createRow: (e, r) => {
    e._getAllVisibleCells = He(() => [e.getAllCells(), r.getState().columnVisibility], (t) => t.filter((i) => i.column.getIsVisible()), je(r.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = He(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (t, i, n) => [...t, ...i, ...n], je(r.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const r = (t, i) => He(() => [i(), i().filter((n) => n.getIsVisible()).map((n) => n.id).join("_")], (n) => n.filter((s) => s.getIsVisible == null ? void 0 : s.getIsVisible()), je(e.options, "debugColumns", t));
    e.getVisibleFlatColumns = r("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = r("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = r("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = r("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = r("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (t) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(t), e.resetColumnVisibility = (t) => {
      var i;
      e.setColumnVisibility(t ? {} : (i = e.initialState.columnVisibility) != null ? i : {});
    }, e.toggleAllColumnsVisible = (t) => {
      var i;
      t = (i = t) != null ? i : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((n, s) => ({
        ...n,
        [s.id]: t || !(s.getCanHide != null && s.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((t) => !(t.getIsVisible != null && t.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((t) => t.getIsVisible == null ? void 0 : t.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (t) => {
      var i;
      e.toggleAllColumnsVisible((i = t.target) == null ? void 0 : i.checked);
    };
  }
};
function kc(e, r) {
  return r ? r === "center" ? e.getCenterVisibleLeafColumns() : r === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const JYe = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, $Ye = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: Xn("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (r) => {
      var t;
      const i = (t = e.getCoreRowModel().flatRows[0]) == null || (t = t._getAllCellsByColumnId()[r.id]) == null ? void 0 : t.getValue();
      return typeof i == "string" || typeof i == "number";
    }
  }),
  createColumn: (e, r) => {
    e.getCanGlobalFilter = () => {
      var t, i, n, s;
      return ((t = e.columnDef.enableGlobalFilter) != null ? t : !0) && ((i = r.options.enableGlobalFilter) != null ? i : !0) && ((n = r.options.enableFilters) != null ? n : !0) && ((s = r.options.getColumnCanGlobalFilter == null ? void 0 : r.options.getColumnCanGlobalFilter(e)) != null ? s : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => Ku.includesString, e.getGlobalFilterFn = () => {
      var r, t;
      const {
        globalFilterFn: i
      } = e.options;
      return tY(i) ? i : i === "auto" ? e.getGlobalAutoFilterFn() : (r = (t = e.options.filterFns) == null ? void 0 : t[i]) != null ? r : Ku[i];
    }, e.setGlobalFilter = (r) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(r);
    }, e.resetGlobalFilter = (r) => {
      e.setGlobalFilter(r ? void 0 : e.initialState.globalFilter);
    };
  }
}, QYe = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: Xn("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let r = !1, t = !1;
    e._autoResetExpanded = () => {
      var i, n;
      if (!r) {
        e._queue(() => {
          r = !0;
        });
        return;
      }
      if ((i = (n = e.options.autoResetAll) != null ? n : e.options.autoResetExpanded) != null ? i : !e.options.manualExpanding) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetExpanded(), t = !1;
        });
      }
    }, e.setExpanded = (i) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(i), e.toggleAllRowsExpanded = (i) => {
      i ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (i) => {
      var n, s;
      e.setExpanded(i ? {} : (n = (s = e.initialState) == null ? void 0 : s.expanded) != null ? n : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((i) => i.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (i) => {
      i.persist == null || i.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const i = e.getState().expanded;
      return i === !0 || Object.values(i).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const i = e.getState().expanded;
      return typeof i == "boolean" ? i === !0 : !(!Object.keys(i).length || e.getRowModel().flatRows.some((n) => !n.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let i = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((s) => {
        const u = s.split(".");
        i = Math.max(i, u.length);
      }), i;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, r) => {
    e.toggleExpanded = (t) => {
      r.setExpanded((i) => {
        var n;
        const s = i === !0 ? !0 : !!(i != null && i[e.id]);
        let u = {};
        if (i === !0 ? Object.keys(r.getRowModel().rowsById).forEach((o) => {
          u[o] = !0;
        }) : u = i, t = (n = t) != null ? n : !s, !s && t)
          return {
            ...u,
            [e.id]: !0
          };
        if (s && !t) {
          const {
            [e.id]: o,
            ...d
          } = u;
          return d;
        }
        return i;
      });
    }, e.getIsExpanded = () => {
      var t;
      const i = r.getState().expanded;
      return !!((t = r.options.getIsRowExpanded == null ? void 0 : r.options.getIsRowExpanded(e)) != null ? t : i === !0 || i != null && i[e.id]);
    }, e.getCanExpand = () => {
      var t, i, n;
      return (t = r.options.getRowCanExpand == null ? void 0 : r.options.getRowCanExpand(e)) != null ? t : ((i = r.options.enableExpanding) != null ? i : !0) && !!((n = e.subRows) != null && n.length);
    }, e.getIsAllParentsExpanded = () => {
      let t = !0, i = e;
      for (; t && i.parentId; )
        i = r.getRow(i.parentId, !0), t = i.getIsExpanded();
      return t;
    }, e.getToggleExpandedHandler = () => {
      const t = e.getCanExpand();
      return () => {
        t && e.toggleExpanded();
      };
    };
  }
}, Cv = 0, Pv = 10, Zh = () => ({
  pageIndex: Cv,
  pageSize: Pv
}), efe = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...Zh(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: Xn("pagination", e)
  }),
  createTable: (e) => {
    let r = !1, t = !1;
    e._autoResetPageIndex = () => {
      var i, n;
      if (!r) {
        e._queue(() => {
          r = !0;
        });
        return;
      }
      if ((i = (n = e.options.autoResetAll) != null ? n : e.options.autoResetPageIndex) != null ? i : !e.options.manualPagination) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetPageIndex(), t = !1;
        });
      }
    }, e.setPagination = (i) => {
      const n = (s) => bo(i, s);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(n);
    }, e.resetPagination = (i) => {
      var n;
      e.setPagination(i ? Zh() : (n = e.initialState.pagination) != null ? n : Zh());
    }, e.setPageIndex = (i) => {
      e.setPagination((n) => {
        let s = bo(i, n.pageIndex);
        const u = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return s = Math.max(0, Math.min(s, u)), {
          ...n,
          pageIndex: s
        };
      });
    }, e.resetPageIndex = (i) => {
      var n, s;
      e.setPageIndex(i ? Cv : (n = (s = e.initialState) == null || (s = s.pagination) == null ? void 0 : s.pageIndex) != null ? n : Cv);
    }, e.resetPageSize = (i) => {
      var n, s;
      e.setPageSize(i ? Pv : (n = (s = e.initialState) == null || (s = s.pagination) == null ? void 0 : s.pageSize) != null ? n : Pv);
    }, e.setPageSize = (i) => {
      e.setPagination((n) => {
        const s = Math.max(1, bo(i, n.pageSize)), u = n.pageSize * n.pageIndex, o = Math.floor(u / s);
        return {
          ...n,
          pageIndex: o,
          pageSize: s
        };
      });
    }, e.setPageCount = (i) => e.setPagination((n) => {
      var s;
      let u = bo(i, (s = e.options.pageCount) != null ? s : -1);
      return typeof u == "number" && (u = Math.max(-1, u)), {
        ...n,
        pageCount: u
      };
    }), e.getPageOptions = He(() => [e.getPageCount()], (i) => {
      let n = [];
      return i && i > 0 && (n = [...new Array(i)].fill(null).map((s, u) => u)), n;
    }, je(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: i
      } = e.getState().pagination, n = e.getPageCount();
      return n === -1 ? !0 : n === 0 ? !1 : i < n - 1;
    }, e.previousPage = () => e.setPageIndex((i) => i - 1), e.nextPage = () => e.setPageIndex((i) => i + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var i;
      return (i = e.options.pageCount) != null ? i : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var i;
      return (i = e.options.rowCount) != null ? i : e.getPrePaginationRowModel().rows.length;
    };
  }
}, Jh = () => ({
  top: [],
  bottom: []
}), rfe = {
  getInitialState: (e) => ({
    rowPinning: Jh(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: Xn("rowPinning", e)
  }),
  createRow: (e, r) => {
    e.pin = (t, i, n) => {
      const s = i ? e.getLeafRows().map((d) => {
        let {
          id: a
        } = d;
        return a;
      }) : [], u = n ? e.getParentRows().map((d) => {
        let {
          id: a
        } = d;
        return a;
      }) : [], o = /* @__PURE__ */ new Set([...u, e.id, ...s]);
      r.setRowPinning((d) => {
        var a, V;
        if (t === "bottom") {
          var c, F;
          return {
            top: ((c = d == null ? void 0 : d.top) != null ? c : []).filter((q) => !(o != null && o.has(q))),
            bottom: [...((F = d == null ? void 0 : d.bottom) != null ? F : []).filter((q) => !(o != null && o.has(q))), ...Array.from(o)]
          };
        }
        if (t === "top") {
          var X, Y;
          return {
            top: [...((X = d == null ? void 0 : d.top) != null ? X : []).filter((q) => !(o != null && o.has(q))), ...Array.from(o)],
            bottom: ((Y = d == null ? void 0 : d.bottom) != null ? Y : []).filter((q) => !(o != null && o.has(q)))
          };
        }
        return {
          top: ((a = d == null ? void 0 : d.top) != null ? a : []).filter((q) => !(o != null && o.has(q))),
          bottom: ((V = d == null ? void 0 : d.bottom) != null ? V : []).filter((q) => !(o != null && o.has(q)))
        };
      });
    }, e.getCanPin = () => {
      var t;
      const {
        enableRowPinning: i,
        enablePinning: n
      } = r.options;
      return typeof i == "function" ? i(e) : (t = i ?? n) != null ? t : !0;
    }, e.getIsPinned = () => {
      const t = [e.id], {
        top: i,
        bottom: n
      } = r.getState().rowPinning, s = t.some((o) => i == null ? void 0 : i.includes(o)), u = t.some((o) => n == null ? void 0 : n.includes(o));
      return s ? "top" : u ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var t, i;
      const n = e.getIsPinned();
      if (!n) return -1;
      const s = (t = n === "top" ? r.getTopRows() : r.getBottomRows()) == null ? void 0 : t.map((u) => {
        let {
          id: o
        } = u;
        return o;
      });
      return (i = s == null ? void 0 : s.indexOf(e.id)) != null ? i : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (r) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(r), e.resetRowPinning = (r) => {
      var t, i;
      return e.setRowPinning(r ? Jh() : (t = (i = e.initialState) == null ? void 0 : i.rowPinning) != null ? t : Jh());
    }, e.getIsSomeRowsPinned = (r) => {
      var t;
      const i = e.getState().rowPinning;
      if (!r) {
        var n, s;
        return !!((n = i.top) != null && n.length || (s = i.bottom) != null && s.length);
      }
      return !!((t = i[r]) != null && t.length);
    }, e._getPinnedRows = (r, t, i) => {
      var n;
      return ((n = e.options.keepPinnedRows) == null || n ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (t ?? []).map((u) => {
          const o = e.getRow(u, !0);
          return o.getIsAllParentsExpanded() ? o : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (t ?? []).map((u) => r.find((o) => o.id === u))
      )).filter(Boolean).map((u) => ({
        ...u,
        position: i
      }));
    }, e.getTopRows = He(() => [e.getRowModel().rows, e.getState().rowPinning.top], (r, t) => e._getPinnedRows(r, t, "top"), je(e.options, "debugRows", "getTopRows")), e.getBottomRows = He(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (r, t) => e._getPinnedRows(r, t, "bottom"), je(e.options, "debugRows", "getBottomRows")), e.getCenterRows = He(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (r, t, i) => {
      const n = /* @__PURE__ */ new Set([...t ?? [], ...i ?? []]);
      return r.filter((s) => !n.has(s.id));
    }, je(e.options, "debugRows", "getCenterRows"));
  }
}, tfe = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: Xn("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (r) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(r), e.resetRowSelection = (r) => {
      var t;
      return e.setRowSelection(r ? {} : (t = e.initialState.rowSelection) != null ? t : {});
    }, e.toggleAllRowsSelected = (r) => {
      e.setRowSelection((t) => {
        r = typeof r < "u" ? r : !e.getIsAllRowsSelected();
        const i = {
          ...t
        }, n = e.getPreGroupedRowModel().flatRows;
        return r ? n.forEach((s) => {
          s.getCanSelect() && (i[s.id] = !0);
        }) : n.forEach((s) => {
          delete i[s.id];
        }), i;
      });
    }, e.toggleAllPageRowsSelected = (r) => e.setRowSelection((t) => {
      const i = typeof r < "u" ? r : !e.getIsAllPageRowsSelected(), n = {
        ...t
      };
      return e.getRowModel().rows.forEach((s) => {
        Sv(n, s.id, i, !0, e);
      }), n;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = He(() => [e.getState().rowSelection, e.getCoreRowModel()], (r, t) => Object.keys(r).length ? $h(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, je(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = He(() => [e.getState().rowSelection, e.getFilteredRowModel()], (r, t) => Object.keys(r).length ? $h(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, je(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = He(() => [e.getState().rowSelection, e.getSortedRowModel()], (r, t) => Object.keys(r).length ? $h(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, je(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const r = e.getFilteredRowModel().flatRows, {
        rowSelection: t
      } = e.getState();
      let i = !!(r.length && Object.keys(t).length);
      return i && r.some((n) => n.getCanSelect() && !t[n.id]) && (i = !1), i;
    }, e.getIsAllPageRowsSelected = () => {
      const r = e.getPaginationRowModel().flatRows.filter((n) => n.getCanSelect()), {
        rowSelection: t
      } = e.getState();
      let i = !!r.length;
      return i && r.some((n) => !t[n.id]) && (i = !1), i;
    }, e.getIsSomeRowsSelected = () => {
      var r;
      const t = Object.keys((r = e.getState().rowSelection) != null ? r : {}).length;
      return t > 0 && t < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const r = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : r.filter((t) => t.getCanSelect()).some((t) => t.getIsSelected() || t.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (r) => {
      e.toggleAllRowsSelected(r.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (r) => {
      e.toggleAllPageRowsSelected(r.target.checked);
    };
  },
  createRow: (e, r) => {
    e.toggleSelected = (t, i) => {
      const n = e.getIsSelected();
      r.setRowSelection((s) => {
        var u;
        if (t = typeof t < "u" ? t : !n, e.getCanSelect() && n === t)
          return s;
        const o = {
          ...s
        };
        return Sv(o, e.id, t, (u = i == null ? void 0 : i.selectChildren) != null ? u : !0, r), o;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: t
      } = r.getState();
      return q3(e, t);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: t
      } = r.getState();
      return Nv(e, t) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: t
      } = r.getState();
      return Nv(e, t) === "all";
    }, e.getCanSelect = () => {
      var t;
      return typeof r.options.enableRowSelection == "function" ? r.options.enableRowSelection(e) : (t = r.options.enableRowSelection) != null ? t : !0;
    }, e.getCanSelectSubRows = () => {
      var t;
      return typeof r.options.enableSubRowSelection == "function" ? r.options.enableSubRowSelection(e) : (t = r.options.enableSubRowSelection) != null ? t : !0;
    }, e.getCanMultiSelect = () => {
      var t;
      return typeof r.options.enableMultiRowSelection == "function" ? r.options.enableMultiRowSelection(e) : (t = r.options.enableMultiRowSelection) != null ? t : !0;
    }, e.getToggleSelectedHandler = () => {
      const t = e.getCanSelect();
      return (i) => {
        var n;
        t && e.toggleSelected((n = i.target) == null ? void 0 : n.checked);
      };
    };
  }
}, Sv = (e, r, t, i, n) => {
  var s;
  const u = n.getRow(r, !0);
  t ? (u.getCanMultiSelect() || Object.keys(e).forEach((o) => delete e[o]), u.getCanSelect() && (e[r] = !0)) : delete e[r], i && (s = u.subRows) != null && s.length && u.getCanSelectSubRows() && u.subRows.forEach((o) => Sv(e, o.id, t, i, n));
};
function $h(e, r) {
  const t = e.getState().rowSelection, i = [], n = {}, s = function(u, o) {
    return u.map((d) => {
      var a;
      const V = q3(d, t);
      if (V && (i.push(d), n[d.id] = d), (a = d.subRows) != null && a.length && (d = {
        ...d,
        subRows: s(d.subRows)
      }), V)
        return d;
    }).filter(Boolean);
  };
  return {
    rows: s(r.rows),
    flatRows: i,
    rowsById: n
  };
}
function q3(e, r) {
  var t;
  return (t = r[e.id]) != null ? t : !1;
}
function Nv(e, r, t) {
  var i;
  if (!((i = e.subRows) != null && i.length)) return !1;
  let n = !0, s = !1;
  return e.subRows.forEach((u) => {
    if (!(s && !n) && (u.getCanSelect() && (q3(u, r) ? s = !0 : n = !1), u.subRows && u.subRows.length)) {
      const o = Nv(u, r);
      o === "all" ? s = !0 : (o === "some" && (s = !0), n = !1);
    }
  }), n ? "all" : s ? "some" : !1;
}
const Mv = /([0-9]+)/gm, ife = (e, r, t) => i_(Ro(e.getValue(t)).toLowerCase(), Ro(r.getValue(t)).toLowerCase()), nfe = (e, r, t) => i_(Ro(e.getValue(t)), Ro(r.getValue(t))), sfe = (e, r, t) => Y3(Ro(e.getValue(t)).toLowerCase(), Ro(r.getValue(t)).toLowerCase()), ufe = (e, r, t) => Y3(Ro(e.getValue(t)), Ro(r.getValue(t))), ofe = (e, r, t) => {
  const i = e.getValue(t), n = r.getValue(t);
  return i > n ? 1 : i < n ? -1 : 0;
}, dfe = (e, r, t) => Y3(e.getValue(t), r.getValue(t));
function Y3(e, r) {
  return e === r ? 0 : e > r ? 1 : -1;
}
function Ro(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function i_(e, r) {
  const t = e.split(Mv).filter(Boolean), i = r.split(Mv).filter(Boolean);
  for (; t.length && i.length; ) {
    const n = t.shift(), s = i.shift(), u = parseInt(n, 10), o = parseInt(s, 10), d = [u, o].sort();
    if (isNaN(d[0])) {
      if (n > s)
        return 1;
      if (s > n)
        return -1;
      continue;
    }
    if (isNaN(d[1]))
      return isNaN(u) ? -1 : 1;
    if (u > o)
      return 1;
    if (o > u)
      return -1;
  }
  return t.length - i.length;
}
const Vc = {
  alphanumeric: ife,
  alphanumericCaseSensitive: nfe,
  text: sfe,
  textCaseSensitive: ufe,
  datetime: ofe,
  basic: dfe
}, afe = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: Xn("sorting", e),
    isMultiSortEvent: (r) => r.shiftKey
  }),
  createColumn: (e, r) => {
    e.getAutoSortingFn = () => {
      const t = r.getFilteredRowModel().flatRows.slice(10);
      let i = !1;
      for (const n of t) {
        const s = n == null ? void 0 : n.getValue(e.id);
        if (Object.prototype.toString.call(s) === "[object Date]")
          return Vc.datetime;
        if (typeof s == "string" && (i = !0, s.split(Mv).length > 1))
          return Vc.alphanumeric;
      }
      return i ? Vc.text : Vc.basic;
    }, e.getAutoSortDir = () => {
      const t = r.getFilteredRowModel().flatRows[0];
      return typeof (t == null ? void 0 : t.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var t, i;
      if (!e)
        throw new Error();
      return tY(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (t = (i = r.options.sortingFns) == null ? void 0 : i[e.columnDef.sortingFn]) != null ? t : Vc[e.columnDef.sortingFn];
    }, e.toggleSorting = (t, i) => {
      const n = e.getNextSortingOrder(), s = typeof t < "u" && t !== null;
      r.setSorting((u) => {
        const o = u == null ? void 0 : u.find((X) => X.id === e.id), d = u == null ? void 0 : u.findIndex((X) => X.id === e.id);
        let a = [], V, c = s ? t : n === "desc";
        if (u != null && u.length && e.getCanMultiSort() && i ? o ? V = "toggle" : V = "add" : u != null && u.length && d !== u.length - 1 ? V = "replace" : o ? V = "toggle" : V = "replace", V === "toggle" && (s || n || (V = "remove")), V === "add") {
          var F;
          a = [...u, {
            id: e.id,
            desc: c
          }], a.splice(0, a.length - ((F = r.options.maxMultiSortColCount) != null ? F : Number.MAX_SAFE_INTEGER));
        } else V === "toggle" ? a = u.map((X) => X.id === e.id ? {
          ...X,
          desc: c
        } : X) : V === "remove" ? a = u.filter((X) => X.id !== e.id) : a = [{
          id: e.id,
          desc: c
        }];
        return a;
      });
    }, e.getFirstSortDir = () => {
      var t, i;
      return ((t = (i = e.columnDef.sortDescFirst) != null ? i : r.options.sortDescFirst) != null ? t : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (t) => {
      var i, n;
      const s = e.getFirstSortDir(), u = e.getIsSorted();
      return u ? u !== s && ((i = r.options.enableSortingRemoval) == null || i) && // If enableSortRemove, enable in general
      (!(t && (n = r.options.enableMultiRemove) != null) || n) ? !1 : u === "desc" ? "asc" : "desc" : s;
    }, e.getCanSort = () => {
      var t, i;
      return ((t = e.columnDef.enableSorting) != null ? t : !0) && ((i = r.options.enableSorting) != null ? i : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var t, i;
      return (t = (i = e.columnDef.enableMultiSort) != null ? i : r.options.enableMultiSort) != null ? t : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var t;
      const i = (t = r.getState().sorting) == null ? void 0 : t.find((n) => n.id === e.id);
      return i ? i.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var t, i;
      return (t = (i = r.getState().sorting) == null ? void 0 : i.findIndex((n) => n.id === e.id)) != null ? t : -1;
    }, e.clearSorting = () => {
      r.setSorting((t) => t != null && t.length ? t.filter((i) => i.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const t = e.getCanSort();
      return (i) => {
        t && (i.persist == null || i.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? r.options.isMultiSortEvent == null ? void 0 : r.options.isMultiSortEvent(i) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (r) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(r), e.resetSorting = (r) => {
      var t, i;
      e.setSorting(r ? [] : (t = (i = e.initialState) == null ? void 0 : i.sorting) != null ? t : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, Vfe = [
  NYe,
  ZYe,
  BYe,
  WYe,
  MYe,
  TYe,
  JYe,
  //depends on ColumnFaceting
  $Ye,
  //depends on ColumnFiltering
  afe,
  jYe,
  //depends on RowSorting
  QYe,
  efe,
  rfe,
  tfe,
  GYe
];
function lfe(e) {
  var r, t;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const i = [...Vfe, ...(r = e._features) != null ? r : []];
  let n = {
    _features: i
  };
  const s = n._features.reduce((F, X) => Object.assign(F, X.getDefaultOptions == null ? void 0 : X.getDefaultOptions(n)), {}), u = (F) => n.options.mergeOptions ? n.options.mergeOptions(s, F) : {
    ...s,
    ...F
  };
  let d = {
    ...{},
    ...(t = e.initialState) != null ? t : {}
  };
  n._features.forEach((F) => {
    var X;
    d = (X = F.getInitialState == null ? void 0 : F.getInitialState(d)) != null ? X : d;
  });
  const a = [];
  let V = !1;
  const c = {
    _features: i,
    options: {
      ...s,
      ...e
    },
    initialState: d,
    _queue: (F) => {
      a.push(F), V || (V = !0, Promise.resolve().then(() => {
        for (; a.length; )
          a.shift()();
        V = !1;
      }).catch((X) => setTimeout(() => {
        throw X;
      })));
    },
    reset: () => {
      n.setState(n.initialState);
    },
    setOptions: (F) => {
      const X = bo(F, n.options);
      n.options = u(X);
    },
    getState: () => n.options.state,
    setState: (F) => {
      n.options.onStateChange == null || n.options.onStateChange(F);
    },
    _getRowId: (F, X, Y) => {
      var q;
      return (q = n.options.getRowId == null ? void 0 : n.options.getRowId(F, X, Y)) != null ? q : `${Y ? [Y.id, X].join(".") : X}`;
    },
    getCoreRowModel: () => (n._getCoreRowModel || (n._getCoreRowModel = n.options.getCoreRowModel(n)), n._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => n.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (F, X) => {
      let Y = (X ? n.getPrePaginationRowModel() : n.getRowModel()).rowsById[F];
      if (!Y && (Y = n.getCoreRowModel().rowsById[F], !Y))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${F}`) : new Error();
      return Y;
    },
    _getDefaultColumnDef: He(() => [n.options.defaultColumn], (F) => {
      var X;
      return F = (X = F) != null ? X : {}, {
        header: (Y) => {
          const q = Y.header.column.columnDef;
          return q.accessorKey ? q.accessorKey : q.accessorFn ? q.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (Y) => {
          var q, f;
          return (q = (f = Y.renderValue()) == null || f.toString == null ? void 0 : f.toString()) != null ? q : null;
        },
        ...n._features.reduce((Y, q) => Object.assign(Y, q.getDefaultColumnDef == null ? void 0 : q.getDefaultColumnDef()), {}),
        ...F
      };
    }, je(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => n.options.columns,
    getAllColumns: He(() => [n._getColumnDefs()], (F) => {
      const X = function(Y, q, f) {
        return f === void 0 && (f = 0), Y.map((p) => {
          const m = SYe(n, p, f, q), g = p;
          return m.columns = g.columns ? X(g.columns, m, f + 1) : [], m;
        });
      };
      return X(F);
    }, je(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: He(() => [n.getAllColumns()], (F) => F.flatMap((X) => X.getFlatColumns()), je(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: He(() => [n.getAllFlatColumns()], (F) => F.reduce((X, Y) => (X[Y.id] = Y, X), {}), je(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: He(() => [n.getAllColumns(), n._getOrderColumnsFn()], (F, X) => {
      let Y = F.flatMap((q) => q.getLeafColumns());
      return X(Y);
    }, je(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (F) => {
      const X = n._getAllFlatColumnsById()[F];
      return process.env.NODE_ENV !== "production" && !X && console.error(`[Table] Column with id '${F}' does not exist.`), X;
    }
  };
  Object.assign(n, c);
  for (let F = 0; F < n._features.length; F++) {
    const X = n._features[F];
    X == null || X.createTable == null || X.createTable(n);
  }
  return n;
}
function cfe() {
  return (e) => He(() => [e.options.data], (r) => {
    const t = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, i = function(n, s, u) {
      s === void 0 && (s = 0);
      const o = [];
      for (let a = 0; a < n.length; a++) {
        const V = x3(e, e._getRowId(n[a], a, u), n[a], a, s, void 0, u == null ? void 0 : u.id);
        if (t.flatRows.push(V), t.rowsById[V.id] = V, o.push(V), e.options.getSubRows) {
          var d;
          V.originalSubRows = e.options.getSubRows(n[a], a), (d = V.originalSubRows) != null && d.length && (V.subRows = i(V.originalSubRows, s + 1, V));
        }
      }
      return o;
    };
    return t.rows = i(r), t;
  }, je(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function Ffe(e) {
  const r = [], t = (i) => {
    var n;
    r.push(i), (n = i.subRows) != null && n.length && i.getIsExpanded() && i.subRows.forEach(t);
  };
  return e.rows.forEach(t), {
    rows: r,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function xfe(e, r, t) {
  return t.options.filterFromLeafRows ? Xfe(e, r, t) : qfe(e, r, t);
}
function Xfe(e, r, t) {
  var i;
  const n = [], s = {}, u = (i = t.options.maxLeafRowFilterDepth) != null ? i : 100, o = function(d, a) {
    a === void 0 && (a = 0);
    const V = [];
    for (let F = 0; F < d.length; F++) {
      var c;
      let X = d[F];
      const Y = x3(t, X.id, X.original, X.index, X.depth, void 0, X.parentId);
      if (Y.columnFilters = X.columnFilters, (c = X.subRows) != null && c.length && a < u) {
        if (Y.subRows = o(X.subRows, a + 1), X = Y, r(X) && !Y.subRows.length) {
          V.push(X), s[X.id] = X, n.push(X);
          continue;
        }
        if (r(X) || Y.subRows.length) {
          V.push(X), s[X.id] = X, n.push(X);
          continue;
        }
      } else
        X = Y, r(X) && (V.push(X), s[X.id] = X, n.push(X));
    }
    return V;
  };
  return {
    rows: o(e),
    flatRows: n,
    rowsById: s
  };
}
function qfe(e, r, t) {
  var i;
  const n = [], s = {}, u = (i = t.options.maxLeafRowFilterDepth) != null ? i : 100, o = function(d, a) {
    a === void 0 && (a = 0);
    const V = [];
    for (let F = 0; F < d.length; F++) {
      let X = d[F];
      if (r(X)) {
        var c;
        if ((c = X.subRows) != null && c.length && a < u) {
          const q = x3(t, X.id, X.original, X.index, X.depth, void 0, X.parentId);
          q.subRows = o(X.subRows, a + 1), X = q;
        }
        V.push(X), n.push(X), s[X.id] = X;
      }
    }
    return V;
  };
  return {
    rows: o(e),
    flatRows: n,
    rowsById: s
  };
}
function Yfe() {
  return (e) => He(() => [e.getPreFilteredRowModel(), e.getState().columnFilters, e.getState().globalFilter], (r, t, i) => {
    if (!r.rows.length || !(t != null && t.length) && !i) {
      for (let F = 0; F < r.flatRows.length; F++)
        r.flatRows[F].columnFilters = {}, r.flatRows[F].columnFiltersMeta = {};
      return r;
    }
    const n = [], s = [];
    (t ?? []).forEach((F) => {
      var X;
      const Y = e.getColumn(F.id);
      if (!Y)
        return;
      const q = Y.getFilterFn();
      if (!q) {
        process.env.NODE_ENV !== "production" && console.warn(`Could not find a valid 'column.filterFn' for column with the ID: ${Y.id}.`);
        return;
      }
      n.push({
        id: F.id,
        filterFn: q,
        resolvedValue: (X = q.resolveFilterValue == null ? void 0 : q.resolveFilterValue(F.value)) != null ? X : F.value
      });
    });
    const u = (t ?? []).map((F) => F.id), o = e.getGlobalFilterFn(), d = e.getAllLeafColumns().filter((F) => F.getCanGlobalFilter());
    i && o && d.length && (u.push("__global__"), d.forEach((F) => {
      var X;
      s.push({
        id: F.id,
        filterFn: o,
        resolvedValue: (X = o.resolveFilterValue == null ? void 0 : o.resolveFilterValue(i)) != null ? X : i
      });
    }));
    let a, V;
    for (let F = 0; F < r.flatRows.length; F++) {
      const X = r.flatRows[F];
      if (X.columnFilters = {}, n.length)
        for (let Y = 0; Y < n.length; Y++) {
          a = n[Y];
          const q = a.id;
          X.columnFilters[q] = a.filterFn(X, q, a.resolvedValue, (f) => {
            X.columnFiltersMeta[q] = f;
          });
        }
      if (s.length) {
        for (let Y = 0; Y < s.length; Y++) {
          V = s[Y];
          const q = V.id;
          if (V.filterFn(X, q, V.resolvedValue, (f) => {
            X.columnFiltersMeta[q] = f;
          })) {
            X.columnFilters.__global__ = !0;
            break;
          }
        }
        X.columnFilters.__global__ !== !0 && (X.columnFilters.__global__ = !1);
      }
    }
    const c = (F) => {
      for (let X = 0; X < u.length; X++)
        if (F.columnFilters[u[X]] === !1)
          return !1;
      return !0;
    };
    return xfe(r.rows, c, e);
  }, je(e.options, "debugTable", "getFilteredRowModel", () => e._autoResetPageIndex()));
}
function ffe(e) {
  return (r) => He(() => [r.getState().pagination, r.getPrePaginationRowModel(), r.options.paginateExpandedRows ? void 0 : r.getState().expanded], (t, i) => {
    if (!i.rows.length)
      return i;
    const {
      pageSize: n,
      pageIndex: s
    } = t;
    let {
      rows: u,
      flatRows: o,
      rowsById: d
    } = i;
    const a = n * s, V = a + n;
    u = u.slice(a, V);
    let c;
    r.options.paginateExpandedRows ? c = {
      rows: u,
      flatRows: o,
      rowsById: d
    } : c = Ffe({
      rows: u,
      flatRows: o,
      rowsById: d
    }), c.flatRows = [];
    const F = (X) => {
      c.flatRows.push(X), X.subRows.length && X.subRows.forEach(F);
    };
    return c.rows.forEach(F), c;
  }, je(r.options, "debugTable", "getPaginationRowModel"));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function j9(e, r) {
  return e ? Kfe(e) ? /* @__PURE__ */ h.createElement(e, r) : e : null;
}
function Kfe(e) {
  return hfe(e) || typeof e == "function" || pfe(e);
}
function hfe(e) {
  return typeof e == "function" && (() => {
    const r = Object.getPrototypeOf(e);
    return r.prototype && r.prototype.isReactComponent;
  })();
}
function pfe(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function mfe(e) {
  const r = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [t] = h.useState(() => ({
    current: lfe(r)
  })), [i, n] = h.useState(() => t.current.initialState);
  return t.current.setOptions((s) => ({
    ...s,
    ...e,
    state: {
      ...i,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (u) => {
      n(u), e.onStateChange == null || e.onStateChange(u);
    }
  })), t.current;
}
const pl = re(
  ({ className: e, ...r }, t) => /* @__PURE__ */ l("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ l(
    "table",
    {
      ref: t,
      className: _("w-full caption-bottom text-bodysm", e),
      ...r
    }
  ) })
);
pl.displayName = "Table";
const ml = re(({ className: e, ...r }, t) => /* @__PURE__ */ l("thead", { ref: t, className: _("[&_tr]:border-b", e), ...r }));
ml.displayName = "TableHeader";
const gl = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "tbody",
  {
    ref: t,
    className: _("[&_tr:last-child]:border-0", e),
    ...r
  }
));
gl.displayName = "TableBody";
const gfe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "tfoot",
  {
    ref: t,
    className: _("bg-primary text-primary-foreground font-medium", e),
    ...r
  }
));
gfe.displayName = "TableFooter";
const ti = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "tr",
  {
    ref: t,
    className: _(
      "hover:bg-muted/50 data-[state=selected]:bg-muted border-b transition-colors",
      e
    ),
    ...r
  }
));
ti.displayName = "TableRow";
const Ir = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "th",
  {
    ref: t,
    className: _(
      "text-muted-foreground h-12 px-4 text-left align-middle font-medium [&:has([role=checkbox])]:pr-0",
      e
    ),
    ...r
  }
));
Ir.displayName = "TableHead";
const De = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "td",
  {
    ref: t,
    className: _("p-4 align-middle [&:has([role=checkbox])]:pr-0", e),
    ...r
  }
));
De.displayName = "TableCell";
const vfe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "caption",
  {
    ref: t,
    className: _("text-muted-foreground mt-4 text-bodysm", e),
    ...r
  }
));
vfe.displayName = "TableCaption";
function bfe({
  columnFilters: e,
  columns: r,
  columnVisibility: t,
  data: i,
  enableMultiRowSelection: n = !1,
  enableRowSelection: s = !1,
  getRowClassName: u,
  getRowId: o,
  manualPagination: d = !0,
  noResultsMessage: a = "No results",
  onColumnFiltersChange: V,
  onColumnVisibilityChange: c,
  onRowsSelected: F,
  state: X
}, Y) {
  const q = X || {};
  e && (q.columnFilters = e), t && (q.columnVisibility = t);
  const f = mfe({
    columns: r,
    data: i,
    enableRowSelection: s,
    enableMultiRowSelection: n,
    getCoreRowModel: cfe(),
    getFilteredRowModel: Yfe(),
    getPaginationRowModel: ffe(),
    getRowId: o,
    manualPagination: d,
    onColumnFiltersChange: V,
    onColumnVisibilityChange: c,
    state: q
  }), p = f.getRowModel().rows || [], m = f.getSelectedRowModel();
  return Pe(() => {
    F && F(m);
  }, [m]), kq(
    Y,
    () => ({
      table: f
    }),
    [f]
  ), /* @__PURE__ */ C(pl, { className: "border-interactiveBorder rounded-xs border ", children: [
    /* @__PURE__ */ l(ml, { className: "px-3 py-0", children: f.getHeaderGroups().map((g) => /* @__PURE__ */ l(
      ti,
      {
        className: "border-interactiveBorder border bg-transparent p-0 hover:bg-transparent",
        children: g.headers.map((y) => /* @__PURE__ */ l(
          Ir,
          {
            className: "text-textSubdued px-3 py-0 text-bodymd font-normal",
            children: y.isPlaceholder ? null : j9(
              y.column.columnDef.header,
              y.getContext()
            )
          },
          y.id
        ))
      },
      g.id
    )) }),
    /* @__PURE__ */ C(gl, { children: [
      p.length > 0 ? p.map((g) => /* @__PURE__ */ l(
        ti,
        {
          className: _(
            "border-interfaceBorder bg-interfaceWhite cursor-pointer border-b hover:bg-[#F9F8F5]",
            u ? u(g) : ""
          ),
          id: `row-${g.id}`,
          "data-state": g.getIsSelected() && "selected",
          onClick: () => g.toggleSelected(),
          children: g.getVisibleCells().map((y) => /* @__PURE__ */ l(De, { className: "", children: j9(y.column.columnDef.cell, y.getContext()) }, y.id))
        },
        g.id
      )) : null,
      p.length === 0 ? /* @__PURE__ */ l(ti, { className: "border-interfaceBorder bg-interfaceWhite hover:bg-interfaceWhite border-b", children: /* @__PURE__ */ l(De, { colSpan: r.length, className: "text-center", children: a }) }) : null
    ] })
  ] });
}
const LQe = bae(bfe), n_ = ({ className: e, ...r }) => /* @__PURE__ */ l(
  "nav",
  {
    role: "navigation",
    "aria-label": "pagination",
    className: _("flex justify-center", e),
    ...r
  }
);
n_.displayName = "Pagination";
const s_ = re(
  ({ className: e, ...r }, t) => /* @__PURE__ */ l(
    "ul",
    {
      ref: t,
      className: _("flex flex-row items-center gap-1", e),
      ...r
    }
  )
);
s_.displayName = "PaginationContent";
const vc = re(
  ({ className: e, ...r }, t) => /* @__PURE__ */ l("li", { ref: t, className: _("", e), ...r })
);
vc.displayName = "PaginationItem";
const iY = ({
  className: e,
  isActive: r,
  onClick: t,
  size: i = "icon",
  ...n
}) => {
  const s = (u) => {
    t && !n.disabled && t(u);
  };
  return /* @__PURE__ */ l(
    "a",
    {
      "aria-current": r ? "page" : void 0,
      className: _(
        AV({
          variant: r ? "outline" : "ghost",
          size: i
        }),
        e
      ),
      onClick: s,
      ...n
    }
  );
};
iY.displayName = "PaginationLink";
const u_ = ({
  className: e,
  ...r
}) => /* @__PURE__ */ C(
  iY,
  {
    "aria-label": "Go to previous page",
    size: "default",
    className: _("gap-1 pl-2.5", e),
    ...r,
    children: [
      /* @__PURE__ */ l(hXe, { className: "h-4 w-4" }),
      /* @__PURE__ */ l("span", { children: "Prev" })
    ]
  }
);
u_.displayName = "PaginationPrevious";
const o_ = ({
  className: e,
  ...r
}) => /* @__PURE__ */ C(
  iY,
  {
    "aria-label": "Next page",
    size: "default",
    className: _("gap-1 pr-2.5", e),
    ...r,
    children: [
      /* @__PURE__ */ l("span", { children: "Next" }),
      /* @__PURE__ */ l(mXe, { className: "h-4 w-4" })
    ]
  }
);
o_.displayName = "PaginationNext";
const d_ = ({
  className: e,
  ...r
}) => /* @__PURE__ */ C(
  "span",
  {
    "aria-hidden": !0,
    className: _(
      "flex h-9 w-9 items-center justify-center",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ l(vXe, { className: "h-4 w-4" }),
      /* @__PURE__ */ l("span", { className: "sr-only", children: "More pages" })
    ]
  }
);
d_.displayName = "PaginationEllipsis";
function yfe({
  className: e,
  onClickNext: r,
  onClickPageNumber: t,
  onClickPrevious: i,
  pageNumber: n,
  pageSize: s,
  totalRecords: u
}) {
  const o = $e(() => u < s ? 1 : Math.ceil(u / s), [s, u]), d = (c) => /* @__PURE__ */ l(vc, { children: /* @__PURE__ */ l(
    iY,
    {
      isActive: n === c,
      onClick: () => t == null ? void 0 : t(c),
      children: c
    }
  ) }, c), a = () => /* @__PURE__ */ l(vc, { children: /* @__PURE__ */ l(d_, {}) });
  return /* @__PURE__ */ l(n_, { className: e, children: /* @__PURE__ */ C(s_, { children: [
    /* @__PURE__ */ l(vc, { children: /* @__PURE__ */ l(
      u_,
      {
        disabled: n === 1,
        onClick: i
      }
    ) }),
    o <= 5 ? Array.from(Array(o).keys()).map(
      (c) => d(c + 1)
    ) : o > 5 && n < 5 ? /* @__PURE__ */ C(he, { children: [
      d(1),
      d(2),
      d(3),
      d(4),
      a(),
      d(o)
    ] }) : o > 5 && n > 4 && n <= o - 4 ? /* @__PURE__ */ C(he, { children: [
      d(1),
      a(),
      Array.from({ length: 2 }, (c, F) => F).map(
        (c) => d(c + n)
      ),
      a(),
      d(o)
    ] }) : /* @__PURE__ */ C(he, { children: [
      d(1),
      a(),
      d(o - 3),
      d(o - 2),
      d(o - 1),
      d(o)
    ] }),
    /* @__PURE__ */ l(vc, { children: /* @__PURE__ */ l(
      o_,
      {
        disabled: n === o,
        onClick: r
      }
    ) })
  ] }) });
}
function _Qe({
  modelLabel: e,
  page: r,
  pageSize: t,
  total: i
}) {
  const n = (r - 1) * t + 1, s = Math.min(r * t, i);
  return /* @__PURE__ */ C("div", { className: "text-bodysm text-textPrimary", children: [
    "Showing ",
    n,
    "–",
    s,
    " of ",
    i,
    " ",
    e
  ] });
}
function HQe({
  onPageChange: e,
  pageNumber: r,
  pageSize: t,
  totalRecords: i
}) {
  const n = (d) => {
    e(d);
  }, s = () => {
    e(r - 1);
  }, u = () => {
    e(r + 1);
  };
  return {
    DataTablePagination: () => /* @__PURE__ */ l(
      yfe,
      {
        onClickPageNumber: n,
        onClickPrevious: s,
        onClickNext: u,
        pageNumber: r,
        pageSize: t,
        totalRecords: i
      }
    )
  };
}
function Ii({
  title: e,
  subtitle: r,
  className: t,
  children: i
}) {
  return /* @__PURE__ */ C(Pr, { className: _("w-full", t), children: [
    /* @__PURE__ */ C(Sr, { className: "p-3 pb-2", children: [
      /* @__PURE__ */ l(Or, { className: "text-bodylg font-medium", children: e }),
      r && /* @__PURE__ */ l(ii, { className: "text-bodysm", children: r })
    ] }),
    /* @__PURE__ */ l(Nr, { className: "p-3", children: /* @__PURE__ */ l("div", { className: "text-5xl font-semibold", children: i }) })
  ] });
}
function Afe(e, r = []) {
  let t = [];
  function i(s, u) {
    const o = h.createContext(u), d = t.length;
    t = [...t, u];
    const a = (c) => {
      var p;
      const { scope: F, children: X, ...Y } = c, q = ((p = F == null ? void 0 : F[e]) == null ? void 0 : p[d]) || o, f = h.useMemo(() => Y, Object.values(Y));
      return /* @__PURE__ */ l(q.Provider, { value: f, children: X });
    };
    a.displayName = s + "Provider";
    function V(c, F) {
      var q;
      const X = ((q = F == null ? void 0 : F[e]) == null ? void 0 : q[d]) || o, Y = h.useContext(X);
      if (Y) return Y;
      if (u !== void 0) return u;
      throw new Error(`\`${c}\` must be used within \`${s}\``);
    }
    return [a, V];
  }
  const n = () => {
    const s = t.map((u) => h.createContext(u));
    return function(o) {
      const d = (o == null ? void 0 : o[e]) || s;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: d } }),
        [o, d]
      );
    };
  };
  return n.scopeName = e, [i, wfe(n, ...r)];
}
function wfe(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const t = () => {
    const i = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(s) {
      const u = i.reduce((o, { useScope: d, scopeName: a }) => {
        const c = d(s)[`__scope${a}`];
        return { ...o, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${r.scopeName}`]: u }), [u]);
    };
  };
  return t.scopeName = r.scopeName, t;
}
var Cfe = "DismissableLayer", Tv = "dismissableLayer.update", Pfe = "dismissableLayer.pointerDownOutside", Sfe = "dismissableLayer.focusOutside", z9, a_ = h.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), V_ = h.forwardRef(
  (e, r) => {
    const {
      disableOutsidePointerEvents: t = !1,
      onEscapeKeyDown: i,
      onPointerDownOutside: n,
      onFocusOutside: s,
      onInteractOutside: u,
      onDismiss: o,
      ...d
    } = e, a = h.useContext(a_), [V, c] = h.useState(null), F = (V == null ? void 0 : V.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, X] = h.useState({}), Y = rr(r, (w) => c(w)), q = Array.from(a.layers), [f] = [...a.layersWithOutsidePointerEventsDisabled].slice(-1), p = q.indexOf(f), m = V ? q.indexOf(V) : -1, g = a.layersWithOutsidePointerEventsDisabled.size > 0, y = m >= p, b = Tfe((w) => {
      const S = w.target, N = [...a.branches].some((O) => O.contains(S));
      !y || N || (n == null || n(w), u == null || u(w), w.defaultPrevented || o == null || o());
    }, F), A = Efe((w) => {
      const S = w.target;
      [...a.branches].some((O) => O.contains(S)) || (s == null || s(w), u == null || u(w), w.defaultPrevented || o == null || o());
    }, F);
    return oa((w) => {
      m === a.layers.size - 1 && (i == null || i(w), !w.defaultPrevented && o && (w.preventDefault(), o()));
    }, F), h.useEffect(() => {
      if (V)
        return t && (a.layersWithOutsidePointerEventsDisabled.size === 0 && (z9 = F.body.style.pointerEvents, F.body.style.pointerEvents = "none"), a.layersWithOutsidePointerEventsDisabled.add(V)), a.layers.add(V), B9(), () => {
          t && a.layersWithOutsidePointerEventsDisabled.size === 1 && (F.body.style.pointerEvents = z9);
        };
    }, [V, F, t, a]), h.useEffect(() => () => {
      V && (a.layers.delete(V), a.layersWithOutsidePointerEventsDisabled.delete(V), B9());
    }, [V, a]), h.useEffect(() => {
      const w = () => X({});
      return document.addEventListener(Tv, w), () => document.removeEventListener(Tv, w);
    }, []), /* @__PURE__ */ l(
      Me.div,
      {
        ...d,
        ref: Y,
        style: {
          pointerEvents: g ? y ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Ne(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: Ne(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: Ne(
          e.onPointerDownCapture,
          b.onPointerDownCapture
        )
      }
    );
  }
);
V_.displayName = Cfe;
var Nfe = "DismissableLayerBranch", Mfe = h.forwardRef((e, r) => {
  const t = h.useContext(a_), i = h.useRef(null), n = rr(r, i);
  return h.useEffect(() => {
    const s = i.current;
    if (s)
      return t.branches.add(s), () => {
        t.branches.delete(s);
      };
  }, [t.branches]), /* @__PURE__ */ l(Me.div, { ...e, ref: n });
});
Mfe.displayName = Nfe;
function Tfe(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Ee(e), i = h.useRef(!1), n = h.useRef(() => {
  });
  return h.useEffect(() => {
    const s = (o) => {
      if (o.target && !i.current) {
        let d = function() {
          l_(
            Pfe,
            t,
            a,
            { discrete: !0 }
          );
        };
        const a = { originalEvent: o };
        o.pointerType === "touch" ? (r.removeEventListener("click", n.current), n.current = d, r.addEventListener("click", n.current, { once: !0 })) : d();
      } else
        r.removeEventListener("click", n.current);
      i.current = !1;
    }, u = window.setTimeout(() => {
      r.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(u), r.removeEventListener("pointerdown", s), r.removeEventListener("click", n.current);
    };
  }, [r, t]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => i.current = !0
  };
}
function Efe(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Ee(e), i = h.useRef(!1);
  return h.useEffect(() => {
    const n = (s) => {
      s.target && !i.current && l_(Sfe, t, { originalEvent: s }, {
        discrete: !1
      });
    };
    return r.addEventListener("focusin", n), () => r.removeEventListener("focusin", n);
  }, [r, t]), {
    onFocusCapture: () => i.current = !0,
    onBlurCapture: () => i.current = !1
  };
}
function B9() {
  const e = new CustomEvent(Tv);
  document.dispatchEvent(e);
}
function l_(e, r, t, { discrete: i }) {
  const n = t.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: t });
  r && n.addEventListener(e, r, { once: !0 }), i ? _q(n, s) : n.dispatchEvent(s);
}
var Qh = 0;
function kfe() {
  h.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? W9()), document.body.insertAdjacentElement("beforeend", e[1] ?? W9()), Qh++, () => {
      Qh === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((r) => r.remove()), Qh--;
    };
  }, []);
}
function W9() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var ep = "focusScope.autoFocusOnMount", rp = "focusScope.autoFocusOnUnmount", G9 = { bubbles: !1, cancelable: !0 }, Ofe = "FocusScope", f3 = h.forwardRef((e, r) => {
  const {
    loop: t = !1,
    trapped: i = !1,
    onMountAutoFocus: n,
    onUnmountAutoFocus: s,
    ...u
  } = e, [o, d] = h.useState(null), a = Ee(n), V = Ee(s), c = h.useRef(null), F = rr(r, (q) => d(q)), X = h.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  h.useEffect(() => {
    if (i) {
      let q = function(g) {
        if (X.paused || !o) return;
        const y = g.target;
        o.contains(y) ? c.current = y : Fo(c.current, { select: !0 });
      }, f = function(g) {
        if (X.paused || !o) return;
        const y = g.relatedTarget;
        y !== null && (o.contains(y) || Fo(c.current, { select: !0 }));
      }, p = function(g) {
        if (document.activeElement === document.body)
          for (const b of g)
            b.removedNodes.length > 0 && Fo(o);
      };
      document.addEventListener("focusin", q), document.addEventListener("focusout", f);
      const m = new MutationObserver(p);
      return o && m.observe(o, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", q), document.removeEventListener("focusout", f), m.disconnect();
      };
    }
  }, [i, o, X.paused]), h.useEffect(() => {
    if (o) {
      Z9.add(X);
      const q = document.activeElement;
      if (!o.contains(q)) {
        const p = new CustomEvent(ep, G9);
        o.addEventListener(ep, a), o.dispatchEvent(p), p.defaultPrevented || (Dfe(Hfe(c_(o)), { select: !0 }), document.activeElement === q && Fo(o));
      }
      return () => {
        o.removeEventListener(ep, a), setTimeout(() => {
          const p = new CustomEvent(rp, G9);
          o.addEventListener(rp, V), o.dispatchEvent(p), p.defaultPrevented || Fo(q ?? document.body, { select: !0 }), o.removeEventListener(rp, V), Z9.remove(X);
        }, 0);
      };
    }
  }, [o, a, V, X]);
  const Y = h.useCallback(
    (q) => {
      if (!t && !i || X.paused) return;
      const f = q.key === "Tab" && !q.altKey && !q.ctrlKey && !q.metaKey, p = document.activeElement;
      if (f && p) {
        const m = q.currentTarget, [g, y] = Rfe(m);
        g && y ? !q.shiftKey && p === y ? (q.preventDefault(), t && Fo(g, { select: !0 })) : q.shiftKey && p === g && (q.preventDefault(), t && Fo(y, { select: !0 })) : p === m && q.preventDefault();
      }
    },
    [t, i, X.paused]
  );
  return /* @__PURE__ */ l(Me.div, { tabIndex: -1, ...u, ref: F, onKeyDown: Y });
});
f3.displayName = Ofe;
function Dfe(e, { select: r = !1 } = {}) {
  const t = document.activeElement;
  for (const i of e)
    if (Fo(i, { select: r }), document.activeElement !== t) return;
}
function Rfe(e) {
  const r = c_(e), t = U9(r, e), i = U9(r.reverse(), e);
  return [t, i];
}
function c_(e) {
  const r = [], t = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (i) => {
      const n = i.tagName === "INPUT" && i.type === "hidden";
      return i.disabled || i.hidden || n ? NodeFilter.FILTER_SKIP : i.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); ) r.push(t.currentNode);
  return r;
}
function U9(e, r) {
  for (const t of e)
    if (!Ife(t, { upTo: r })) return t;
}
function Ife(e, { upTo: r }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (r !== void 0 && e === r) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Lfe(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Fo(e, { select: r = !1 } = {}) {
  if (e && e.focus) {
    const t = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== t && Lfe(e) && r && e.select();
  }
}
var Z9 = _fe();
function _fe() {
  let e = [];
  return {
    add(r) {
      const t = e[0];
      r !== t && (t == null || t.pause()), e = J9(e, r), e.unshift(r);
    },
    remove(r) {
      var t;
      e = J9(e, r), (t = e[0]) == null || t.resume();
    }
  };
}
function J9(e, r) {
  const t = [...e], i = t.indexOf(r);
  return i !== -1 && t.splice(i, 1), t;
}
function Hfe(e) {
  return e.filter((r) => r.tagName !== "A");
}
const jfe = ["top", "right", "bottom", "left"], Ns = Math.min, an = Math.max, rX = Math.round, BF = Math.floor, Io = (e) => ({
  x: e,
  y: e
}), zfe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Bfe = {
  start: "end",
  end: "start"
};
function Ev(e, r, t) {
  return an(e, Ns(r, t));
}
function Ou(e, r) {
  return typeof e == "function" ? e(r) : e;
}
function Du(e) {
  return e.split("-")[0];
}
function vl(e) {
  return e.split("-")[1];
}
function K3(e) {
  return e === "x" ? "y" : "x";
}
function h3(e) {
  return e === "y" ? "height" : "width";
}
function Lo(e) {
  return ["top", "bottom"].includes(Du(e)) ? "y" : "x";
}
function p3(e) {
  return K3(Lo(e));
}
function Wfe(e, r, t) {
  t === void 0 && (t = !1);
  const i = vl(e), n = p3(e), s = h3(n);
  let u = n === "x" ? i === (t ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return r.reference[s] > r.floating[s] && (u = tX(u)), [u, tX(u)];
}
function Gfe(e) {
  const r = tX(e);
  return [kv(e), r, kv(r)];
}
function kv(e) {
  return e.replace(/start|end/g, (r) => Bfe[r]);
}
function Ufe(e, r, t) {
  const i = ["left", "right"], n = ["right", "left"], s = ["top", "bottom"], u = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return t ? r ? n : i : r ? i : n;
    case "left":
    case "right":
      return r ? s : u;
    default:
      return [];
  }
}
function Zfe(e, r, t, i) {
  const n = vl(e);
  let s = Ufe(Du(e), t === "start", i);
  return n && (s = s.map((u) => u + "-" + n), r && (s = s.concat(s.map(kv)))), s;
}
function tX(e) {
  return e.replace(/left|right|bottom|top/g, (r) => zfe[r]);
}
function Jfe(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function F_(e) {
  return typeof e != "number" ? Jfe(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function iX(e) {
  const {
    x: r,
    y: t,
    width: i,
    height: n
  } = e;
  return {
    width: i,
    height: n,
    top: t,
    left: r,
    right: r + i,
    bottom: t + n,
    x: r,
    y: t
  };
}
function $9(e, r, t) {
  let {
    reference: i,
    floating: n
  } = e;
  const s = Lo(r), u = p3(r), o = h3(u), d = Du(r), a = s === "y", V = i.x + i.width / 2 - n.width / 2, c = i.y + i.height / 2 - n.height / 2, F = i[o] / 2 - n[o] / 2;
  let X;
  switch (d) {
    case "top":
      X = {
        x: V,
        y: i.y - n.height
      };
      break;
    case "bottom":
      X = {
        x: V,
        y: i.y + i.height
      };
      break;
    case "right":
      X = {
        x: i.x + i.width,
        y: c
      };
      break;
    case "left":
      X = {
        x: i.x - n.width,
        y: c
      };
      break;
    default:
      X = {
        x: i.x,
        y: i.y
      };
  }
  switch (vl(r)) {
    case "start":
      X[u] -= F * (t && a ? -1 : 1);
      break;
    case "end":
      X[u] += F * (t && a ? -1 : 1);
      break;
  }
  return X;
}
const $fe = async (e, r, t) => {
  const {
    placement: i = "bottom",
    strategy: n = "absolute",
    middleware: s = [],
    platform: u
  } = t, o = s.filter(Boolean), d = await (u.isRTL == null ? void 0 : u.isRTL(r));
  let a = await u.getElementRects({
    reference: e,
    floating: r,
    strategy: n
  }), {
    x: V,
    y: c
  } = $9(a, i, d), F = i, X = {}, Y = 0;
  for (let q = 0; q < o.length; q++) {
    const {
      name: f,
      fn: p
    } = o[q], {
      x: m,
      y: g,
      data: y,
      reset: b
    } = await p({
      x: V,
      y: c,
      initialPlacement: i,
      placement: F,
      strategy: n,
      middlewareData: X,
      rects: a,
      platform: u,
      elements: {
        reference: e,
        floating: r
      }
    });
    V = m ?? V, c = g ?? c, X = {
      ...X,
      [f]: {
        ...X[f],
        ...y
      }
    }, b && Y <= 50 && (Y++, typeof b == "object" && (b.placement && (F = b.placement), b.rects && (a = b.rects === !0 ? await u.getElementRects({
      reference: e,
      floating: r,
      strategy: n
    }) : b.rects), {
      x: V,
      y: c
    } = $9(a, F, d)), q = -1);
  }
  return {
    x: V,
    y: c,
    placement: F,
    strategy: n,
    middlewareData: X
  };
};
async function Jc(e, r) {
  var t;
  r === void 0 && (r = {});
  const {
    x: i,
    y: n,
    platform: s,
    rects: u,
    elements: o,
    strategy: d
  } = e, {
    boundary: a = "clippingAncestors",
    rootBoundary: V = "viewport",
    elementContext: c = "floating",
    altBoundary: F = !1,
    padding: X = 0
  } = Ou(r, e), Y = F_(X), f = o[F ? c === "floating" ? "reference" : "floating" : c], p = iX(await s.getClippingRect({
    element: (t = await (s.isElement == null ? void 0 : s.isElement(f))) == null || t ? f : f.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(o.floating)),
    boundary: a,
    rootBoundary: V,
    strategy: d
  })), m = c === "floating" ? {
    x: i,
    y: n,
    width: u.floating.width,
    height: u.floating.height
  } : u.reference, g = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(o.floating)), y = await (s.isElement == null ? void 0 : s.isElement(g)) ? await (s.getScale == null ? void 0 : s.getScale(g)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = iX(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: m,
    offsetParent: g,
    strategy: d
  }) : m);
  return {
    top: (p.top - b.top + Y.top) / y.y,
    bottom: (b.bottom - p.bottom + Y.bottom) / y.y,
    left: (p.left - b.left + Y.left) / y.x,
    right: (b.right - p.right + Y.right) / y.x
  };
}
const Qfe = (e) => ({
  name: "arrow",
  options: e,
  async fn(r) {
    const {
      x: t,
      y: i,
      placement: n,
      rects: s,
      platform: u,
      elements: o,
      middlewareData: d
    } = r, {
      element: a,
      padding: V = 0
    } = Ou(e, r) || {};
    if (a == null)
      return {};
    const c = F_(V), F = {
      x: t,
      y: i
    }, X = p3(n), Y = h3(X), q = await u.getDimensions(a), f = X === "y", p = f ? "top" : "left", m = f ? "bottom" : "right", g = f ? "clientHeight" : "clientWidth", y = s.reference[Y] + s.reference[X] - F[X] - s.floating[Y], b = F[X] - s.reference[X], A = await (u.getOffsetParent == null ? void 0 : u.getOffsetParent(a));
    let w = A ? A[g] : 0;
    (!w || !await (u.isElement == null ? void 0 : u.isElement(A))) && (w = o.floating[g] || s.floating[Y]);
    const S = y / 2 - b / 2, N = w / 2 - q[Y] / 2 - 1, O = Ns(c[p], N), E = Ns(c[m], N), I = O, R = w - q[Y] - E, H = w / 2 - q[Y] / 2 + S, W = Ev(I, H, R), B = !d.arrow && vl(n) != null && H !== W && s.reference[Y] / 2 - (H < I ? O : E) - q[Y] / 2 < 0, L = B ? H < I ? H - I : H - R : 0;
    return {
      [X]: F[X] + L,
      data: {
        [X]: W,
        centerOffset: H - W - L,
        ...B && {
          alignmentOffset: L
        }
      },
      reset: B
    };
  }
}), eKe = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(r) {
      var t, i;
      const {
        placement: n,
        middlewareData: s,
        rects: u,
        initialPlacement: o,
        platform: d,
        elements: a
      } = r, {
        mainAxis: V = !0,
        crossAxis: c = !0,
        fallbackPlacements: F,
        fallbackStrategy: X = "bestFit",
        fallbackAxisSideDirection: Y = "none",
        flipAlignment: q = !0,
        ...f
      } = Ou(e, r);
      if ((t = s.arrow) != null && t.alignmentOffset)
        return {};
      const p = Du(n), m = Lo(o), g = Du(o) === o, y = await (d.isRTL == null ? void 0 : d.isRTL(a.floating)), b = F || (g || !q ? [tX(o)] : Gfe(o)), A = Y !== "none";
      !F && A && b.push(...Zfe(o, q, Y, y));
      const w = [o, ...b], S = await Jc(r, f), N = [];
      let O = ((i = s.flip) == null ? void 0 : i.overflows) || [];
      if (V && N.push(S[p]), c) {
        const H = Wfe(n, u, y);
        N.push(S[H[0]], S[H[1]]);
      }
      if (O = [...O, {
        placement: n,
        overflows: N
      }], !N.every((H) => H <= 0)) {
        var E, I;
        const H = (((E = s.flip) == null ? void 0 : E.index) || 0) + 1, W = w[H];
        if (W)
          return {
            data: {
              index: H,
              overflows: O
            },
            reset: {
              placement: W
            }
          };
        let B = (I = O.filter((L) => L.overflows[0] <= 0).sort((L, z) => L.overflows[1] - z.overflows[1])[0]) == null ? void 0 : I.placement;
        if (!B)
          switch (X) {
            case "bestFit": {
              var R;
              const L = (R = O.filter((z) => {
                if (A) {
                  const Z = Lo(z.placement);
                  return Z === m || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Z === "y";
                }
                return !0;
              }).map((z) => [z.placement, z.overflows.filter((Z) => Z > 0).reduce((Z, le) => Z + le, 0)]).sort((z, Z) => z[1] - Z[1])[0]) == null ? void 0 : R[0];
              L && (B = L);
              break;
            }
            case "initialPlacement":
              B = o;
              break;
          }
        if (n !== B)
          return {
            reset: {
              placement: B
            }
          };
      }
      return {};
    }
  };
};
function Q9(e, r) {
  return {
    top: e.top - r.height,
    right: e.right - r.width,
    bottom: e.bottom - r.height,
    left: e.left - r.width
  };
}
function eC(e) {
  return jfe.some((r) => e[r] >= 0);
}
const rKe = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(r) {
      const {
        rects: t
      } = r, {
        strategy: i = "referenceHidden",
        ...n
      } = Ou(e, r);
      switch (i) {
        case "referenceHidden": {
          const s = await Jc(r, {
            ...n,
            elementContext: "reference"
          }), u = Q9(s, t.reference);
          return {
            data: {
              referenceHiddenOffsets: u,
              referenceHidden: eC(u)
            }
          };
        }
        case "escaped": {
          const s = await Jc(r, {
            ...n,
            altBoundary: !0
          }), u = Q9(s, t.floating);
          return {
            data: {
              escapedOffsets: u,
              escaped: eC(u)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function tKe(e, r) {
  const {
    placement: t,
    platform: i,
    elements: n
  } = e, s = await (i.isRTL == null ? void 0 : i.isRTL(n.floating)), u = Du(t), o = vl(t), d = Lo(t) === "y", a = ["left", "top"].includes(u) ? -1 : 1, V = s && d ? -1 : 1, c = Ou(r, e);
  let {
    mainAxis: F,
    crossAxis: X,
    alignmentAxis: Y
  } = typeof c == "number" ? {
    mainAxis: c,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...c
  };
  return o && typeof Y == "number" && (X = o === "end" ? Y * -1 : Y), d ? {
    x: X * V,
    y: F * a
  } : {
    x: F * a,
    y: X * V
  };
}
const iKe = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(r) {
      var t, i;
      const {
        x: n,
        y: s,
        placement: u,
        middlewareData: o
      } = r, d = await tKe(r, e);
      return u === ((t = o.offset) == null ? void 0 : t.placement) && (i = o.arrow) != null && i.alignmentOffset ? {} : {
        x: n + d.x,
        y: s + d.y,
        data: {
          ...d,
          placement: u
        }
      };
    }
  };
}, nKe = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(r) {
      const {
        x: t,
        y: i,
        placement: n
      } = r, {
        mainAxis: s = !0,
        crossAxis: u = !1,
        limiter: o = {
          fn: (f) => {
            let {
              x: p,
              y: m
            } = f;
            return {
              x: p,
              y: m
            };
          }
        },
        ...d
      } = Ou(e, r), a = {
        x: t,
        y: i
      }, V = await Jc(r, d), c = Lo(Du(n)), F = K3(c);
      let X = a[F], Y = a[c];
      if (s) {
        const f = F === "y" ? "top" : "left", p = F === "y" ? "bottom" : "right", m = X + V[f], g = X - V[p];
        X = Ev(m, X, g);
      }
      if (u) {
        const f = c === "y" ? "top" : "left", p = c === "y" ? "bottom" : "right", m = Y + V[f], g = Y - V[p];
        Y = Ev(m, Y, g);
      }
      const q = o.fn({
        ...r,
        [F]: X,
        [c]: Y
      });
      return {
        ...q,
        data: {
          x: q.x - t,
          y: q.y - i
        }
      };
    }
  };
}, sKe = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(r) {
      const {
        x: t,
        y: i,
        placement: n,
        rects: s,
        middlewareData: u
      } = r, {
        offset: o = 0,
        mainAxis: d = !0,
        crossAxis: a = !0
      } = Ou(e, r), V = {
        x: t,
        y: i
      }, c = Lo(n), F = K3(c);
      let X = V[F], Y = V[c];
      const q = Ou(o, r), f = typeof q == "number" ? {
        mainAxis: q,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...q
      };
      if (d) {
        const g = F === "y" ? "height" : "width", y = s.reference[F] - s.floating[g] + f.mainAxis, b = s.reference[F] + s.reference[g] - f.mainAxis;
        X < y ? X = y : X > b && (X = b);
      }
      if (a) {
        var p, m;
        const g = F === "y" ? "width" : "height", y = ["top", "left"].includes(Du(n)), b = s.reference[c] - s.floating[g] + (y && ((p = u.offset) == null ? void 0 : p[c]) || 0) + (y ? 0 : f.crossAxis), A = s.reference[c] + s.reference[g] + (y ? 0 : ((m = u.offset) == null ? void 0 : m[c]) || 0) - (y ? f.crossAxis : 0);
        Y < b ? Y = b : Y > A && (Y = A);
      }
      return {
        [F]: X,
        [c]: Y
      };
    }
  };
}, uKe = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(r) {
      const {
        placement: t,
        rects: i,
        platform: n,
        elements: s
      } = r, {
        apply: u = () => {
        },
        ...o
      } = Ou(e, r), d = await Jc(r, o), a = Du(t), V = vl(t), c = Lo(t) === "y", {
        width: F,
        height: X
      } = i.floating;
      let Y, q;
      a === "top" || a === "bottom" ? (Y = a, q = V === (await (n.isRTL == null ? void 0 : n.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (q = a, Y = V === "end" ? "top" : "bottom");
      const f = X - d.top - d.bottom, p = F - d.left - d.right, m = Ns(X - d[Y], f), g = Ns(F - d[q], p), y = !r.middlewareData.shift;
      let b = m, A = g;
      if (c ? A = V || y ? Ns(g, p) : p : b = V || y ? Ns(m, f) : f, y && !V) {
        const S = an(d.left, 0), N = an(d.right, 0), O = an(d.top, 0), E = an(d.bottom, 0);
        c ? A = F - 2 * (S !== 0 || N !== 0 ? S + N : an(d.left, d.right)) : b = X - 2 * (O !== 0 || E !== 0 ? O + E : an(d.top, d.bottom));
      }
      await u({
        ...r,
        availableWidth: A,
        availableHeight: b
      });
      const w = await n.getDimensions(s.floating);
      return F !== w.width || X !== w.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function bl(e) {
  return x_(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function cn(e) {
  var r;
  return (e == null || (r = e.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function Gu(e) {
  var r;
  return (r = (x_(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : r.documentElement;
}
function x_(e) {
  return e instanceof Node || e instanceof cn(e).Node;
}
function Fs(e) {
  return e instanceof Element || e instanceof cn(e).Element;
}
function Hs(e) {
  return e instanceof HTMLElement || e instanceof cn(e).HTMLElement;
}
function rC(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof cn(e).ShadowRoot;
}
function c2(e) {
  const {
    overflow: r,
    overflowX: t,
    overflowY: i,
    display: n
  } = xs(e);
  return /auto|scroll|overlay|hidden|clip/.test(r + i + t) && !["inline", "contents"].includes(n);
}
function oKe(e) {
  return ["table", "td", "th"].includes(bl(e));
}
function nY(e) {
  return [":popover-open", ":modal"].some((r) => {
    try {
      return e.matches(r);
    } catch {
      return !1;
    }
  });
}
function m3(e) {
  const r = g3(), t = Fs(e) ? xs(e) : e;
  return t.transform !== "none" || t.perspective !== "none" || (t.containerType ? t.containerType !== "normal" : !1) || !r && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !r && (t.filter ? t.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((i) => (t.willChange || "").includes(i)) || ["paint", "layout", "strict", "content"].some((i) => (t.contain || "").includes(i));
}
function dKe(e) {
  let r = _o(e);
  for (; Hs(r) && !CV(r); ) {
    if (m3(r))
      return r;
    if (nY(r))
      return null;
    r = _o(r);
  }
  return null;
}
function g3() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function CV(e) {
  return ["html", "body", "#document"].includes(bl(e));
}
function xs(e) {
  return cn(e).getComputedStyle(e);
}
function sY(e) {
  return Fs(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function _o(e) {
  if (bl(e) === "html")
    return e;
  const r = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    rC(e) && e.host || // Fallback.
    Gu(e)
  );
  return rC(r) ? r.host : r;
}
function X_(e) {
  const r = _o(e);
  return CV(r) ? e.ownerDocument ? e.ownerDocument.body : e.body : Hs(r) && c2(r) ? r : X_(r);
}
function $c(e, r, t) {
  var i;
  r === void 0 && (r = []), t === void 0 && (t = !0);
  const n = X_(e), s = n === ((i = e.ownerDocument) == null ? void 0 : i.body), u = cn(n);
  if (s) {
    const o = Ov(u);
    return r.concat(u, u.visualViewport || [], c2(n) ? n : [], o && t ? $c(o) : []);
  }
  return r.concat(n, $c(n, [], t));
}
function Ov(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function q_(e) {
  const r = xs(e);
  let t = parseFloat(r.width) || 0, i = parseFloat(r.height) || 0;
  const n = Hs(e), s = n ? e.offsetWidth : t, u = n ? e.offsetHeight : i, o = rX(t) !== s || rX(i) !== u;
  return o && (t = s, i = u), {
    width: t,
    height: i,
    $: o
  };
}
function v3(e) {
  return Fs(e) ? e : e.contextElement;
}
function xV(e) {
  const r = v3(e);
  if (!Hs(r))
    return Io(1);
  const t = r.getBoundingClientRect(), {
    width: i,
    height: n,
    $: s
  } = q_(r);
  let u = (s ? rX(t.width) : t.width) / i, o = (s ? rX(t.height) : t.height) / n;
  return (!u || !Number.isFinite(u)) && (u = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: u,
    y: o
  };
}
const aKe = /* @__PURE__ */ Io(0);
function Y_(e) {
  const r = cn(e);
  return !g3() || !r.visualViewport ? aKe : {
    x: r.visualViewport.offsetLeft,
    y: r.visualViewport.offsetTop
  };
}
function VKe(e, r, t) {
  return r === void 0 && (r = !1), !t || r && t !== cn(e) ? !1 : r;
}
function Zd(e, r, t, i) {
  r === void 0 && (r = !1), t === void 0 && (t = !1);
  const n = e.getBoundingClientRect(), s = v3(e);
  let u = Io(1);
  r && (i ? Fs(i) && (u = xV(i)) : u = xV(e));
  const o = VKe(s, t, i) ? Y_(s) : Io(0);
  let d = (n.left + o.x) / u.x, a = (n.top + o.y) / u.y, V = n.width / u.x, c = n.height / u.y;
  if (s) {
    const F = cn(s), X = i && Fs(i) ? cn(i) : i;
    let Y = F, q = Ov(Y);
    for (; q && i && X !== Y; ) {
      const f = xV(q), p = q.getBoundingClientRect(), m = xs(q), g = p.left + (q.clientLeft + parseFloat(m.paddingLeft)) * f.x, y = p.top + (q.clientTop + parseFloat(m.paddingTop)) * f.y;
      d *= f.x, a *= f.y, V *= f.x, c *= f.y, d += g, a += y, Y = cn(q), q = Ov(Y);
    }
  }
  return iX({
    width: V,
    height: c,
    x: d,
    y: a
  });
}
function lKe(e) {
  let {
    elements: r,
    rect: t,
    offsetParent: i,
    strategy: n
  } = e;
  const s = n === "fixed", u = Gu(i), o = r ? nY(r.floating) : !1;
  if (i === u || o && s)
    return t;
  let d = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = Io(1);
  const V = Io(0), c = Hs(i);
  if ((c || !c && !s) && ((bl(i) !== "body" || c2(u)) && (d = sY(i)), Hs(i))) {
    const F = Zd(i);
    a = xV(i), V.x = F.x + i.clientLeft, V.y = F.y + i.clientTop;
  }
  return {
    width: t.width * a.x,
    height: t.height * a.y,
    x: t.x * a.x - d.scrollLeft * a.x + V.x,
    y: t.y * a.y - d.scrollTop * a.y + V.y
  };
}
function cKe(e) {
  return Array.from(e.getClientRects());
}
function f_(e) {
  return Zd(Gu(e)).left + sY(e).scrollLeft;
}
function FKe(e) {
  const r = Gu(e), t = sY(e), i = e.ownerDocument.body, n = an(r.scrollWidth, r.clientWidth, i.scrollWidth, i.clientWidth), s = an(r.scrollHeight, r.clientHeight, i.scrollHeight, i.clientHeight);
  let u = -t.scrollLeft + f_(e);
  const o = -t.scrollTop;
  return xs(i).direction === "rtl" && (u += an(r.clientWidth, i.clientWidth) - n), {
    width: n,
    height: s,
    x: u,
    y: o
  };
}
function xKe(e, r) {
  const t = cn(e), i = Gu(e), n = t.visualViewport;
  let s = i.clientWidth, u = i.clientHeight, o = 0, d = 0;
  if (n) {
    s = n.width, u = n.height;
    const a = g3();
    (!a || a && r === "fixed") && (o = n.offsetLeft, d = n.offsetTop);
  }
  return {
    width: s,
    height: u,
    x: o,
    y: d
  };
}
function XKe(e, r) {
  const t = Zd(e, !0, r === "fixed"), i = t.top + e.clientTop, n = t.left + e.clientLeft, s = Hs(e) ? xV(e) : Io(1), u = e.clientWidth * s.x, o = e.clientHeight * s.y, d = n * s.x, a = i * s.y;
  return {
    width: u,
    height: o,
    x: d,
    y: a
  };
}
function tC(e, r, t) {
  let i;
  if (r === "viewport")
    i = xKe(e, t);
  else if (r === "document")
    i = FKe(Gu(e));
  else if (Fs(r))
    i = XKe(r, t);
  else {
    const n = Y_(e);
    i = {
      ...r,
      x: r.x - n.x,
      y: r.y - n.y
    };
  }
  return iX(i);
}
function K_(e, r) {
  const t = _o(e);
  return t === r || !Fs(t) || CV(t) ? !1 : xs(t).position === "fixed" || K_(t, r);
}
function qKe(e, r) {
  const t = r.get(e);
  if (t)
    return t;
  let i = $c(e, [], !1).filter((o) => Fs(o) && bl(o) !== "body"), n = null;
  const s = xs(e).position === "fixed";
  let u = s ? _o(e) : e;
  for (; Fs(u) && !CV(u); ) {
    const o = xs(u), d = m3(u);
    !d && o.position === "fixed" && (n = null), (s ? !d && !n : !d && o.position === "static" && !!n && ["absolute", "fixed"].includes(n.position) || c2(u) && !d && K_(e, u)) ? i = i.filter((V) => V !== u) : n = o, u = _o(u);
  }
  return r.set(e, i), i;
}
function YKe(e) {
  let {
    element: r,
    boundary: t,
    rootBoundary: i,
    strategy: n
  } = e;
  const u = [...t === "clippingAncestors" ? nY(r) ? [] : qKe(r, this._c) : [].concat(t), i], o = u[0], d = u.reduce((a, V) => {
    const c = tC(r, V, n);
    return a.top = an(c.top, a.top), a.right = Ns(c.right, a.right), a.bottom = Ns(c.bottom, a.bottom), a.left = an(c.left, a.left), a;
  }, tC(r, o, n));
  return {
    width: d.right - d.left,
    height: d.bottom - d.top,
    x: d.left,
    y: d.top
  };
}
function fKe(e) {
  const {
    width: r,
    height: t
  } = q_(e);
  return {
    width: r,
    height: t
  };
}
function KKe(e, r, t) {
  const i = Hs(r), n = Gu(r), s = t === "fixed", u = Zd(e, !0, s, r);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const d = Io(0);
  if (i || !i && !s)
    if ((bl(r) !== "body" || c2(n)) && (o = sY(r)), i) {
      const c = Zd(r, !0, s, r);
      d.x = c.x + r.clientLeft, d.y = c.y + r.clientTop;
    } else n && (d.x = f_(n));
  const a = u.left + o.scrollLeft - d.x, V = u.top + o.scrollTop - d.y;
  return {
    x: a,
    y: V,
    width: u.width,
    height: u.height
  };
}
function tp(e) {
  return xs(e).position === "static";
}
function iC(e, r) {
  return !Hs(e) || xs(e).position === "fixed" ? null : r ? r(e) : e.offsetParent;
}
function h_(e, r) {
  const t = cn(e);
  if (nY(e))
    return t;
  if (!Hs(e)) {
    let n = _o(e);
    for (; n && !CV(n); ) {
      if (Fs(n) && !tp(n))
        return n;
      n = _o(n);
    }
    return t;
  }
  let i = iC(e, r);
  for (; i && oKe(i) && tp(i); )
    i = iC(i, r);
  return i && CV(i) && tp(i) && !m3(i) ? t : i || dKe(e) || t;
}
const hKe = async function(e) {
  const r = this.getOffsetParent || h_, t = this.getDimensions, i = await t(e.floating);
  return {
    reference: KKe(e.reference, await r(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: i.width,
      height: i.height
    }
  };
};
function pKe(e) {
  return xs(e).direction === "rtl";
}
const mKe = {
  convertOffsetParentRelativeRectToViewportRelativeRect: lKe,
  getDocumentElement: Gu,
  getClippingRect: YKe,
  getOffsetParent: h_,
  getElementRects: hKe,
  getClientRects: cKe,
  getDimensions: fKe,
  getScale: xV,
  isElement: Fs,
  isRTL: pKe
};
function gKe(e, r) {
  let t = null, i;
  const n = Gu(e);
  function s() {
    var o;
    clearTimeout(i), (o = t) == null || o.disconnect(), t = null;
  }
  function u(o, d) {
    o === void 0 && (o = !1), d === void 0 && (d = 1), s();
    const {
      left: a,
      top: V,
      width: c,
      height: F
    } = e.getBoundingClientRect();
    if (o || r(), !c || !F)
      return;
    const X = BF(V), Y = BF(n.clientWidth - (a + c)), q = BF(n.clientHeight - (V + F)), f = BF(a), m = {
      rootMargin: -X + "px " + -Y + "px " + -q + "px " + -f + "px",
      threshold: an(0, Ns(1, d)) || 1
    };
    let g = !0;
    function y(b) {
      const A = b[0].intersectionRatio;
      if (A !== d) {
        if (!g)
          return u();
        A ? u(!1, A) : i = setTimeout(() => {
          u(!1, 1e-7);
        }, 1e3);
      }
      g = !1;
    }
    try {
      t = new IntersectionObserver(y, {
        ...m,
        // Handle <iframe>s
        root: n.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(y, m);
    }
    t.observe(e);
  }
  return u(!0), s;
}
function uY(e, r, t, i) {
  i === void 0 && (i = {});
  const {
    ancestorScroll: n = !0,
    ancestorResize: s = !0,
    elementResize: u = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: d = !1
  } = i, a = v3(e), V = n || s ? [...a ? $c(a) : [], ...$c(r)] : [];
  V.forEach((p) => {
    n && p.addEventListener("scroll", t, {
      passive: !0
    }), s && p.addEventListener("resize", t);
  });
  const c = a && o ? gKe(a, t) : null;
  let F = -1, X = null;
  u && (X = new ResizeObserver((p) => {
    let [m] = p;
    m && m.target === a && X && (X.unobserve(r), cancelAnimationFrame(F), F = requestAnimationFrame(() => {
      var g;
      (g = X) == null || g.observe(r);
    })), t();
  }), a && !d && X.observe(a), X.observe(r));
  let Y, q = d ? Zd(e) : null;
  d && f();
  function f() {
    const p = Zd(e);
    q && (p.x !== q.x || p.y !== q.y || p.width !== q.width || p.height !== q.height) && t(), q = p, Y = requestAnimationFrame(f);
  }
  return t(), () => {
    var p;
    V.forEach((m) => {
      n && m.removeEventListener("scroll", t), s && m.removeEventListener("resize", t);
    }), c == null || c(), (p = X) == null || p.disconnect(), X = null, d && cancelAnimationFrame(Y);
  };
}
const vKe = iKe, bKe = nKe, yKe = eKe, AKe = uKe, wKe = rKe, nC = Qfe, CKe = sKe, PKe = (e, r, t) => {
  const i = /* @__PURE__ */ new Map(), n = {
    platform: mKe,
    ...t
  }, s = {
    ...n.platform,
    _c: i
  };
  return $fe(e, r, {
    ...n,
    platform: s
  });
};
var Ox = typeof document < "u" ? Eq : Pe;
function nX(e, r) {
  if (e === r)
    return !0;
  if (typeof e != typeof r)
    return !1;
  if (typeof e == "function" && e.toString() === r.toString())
    return !0;
  let t, i, n;
  if (e && r && typeof e == "object") {
    if (Array.isArray(e)) {
      if (t = e.length, t !== r.length) return !1;
      for (i = t; i-- !== 0; )
        if (!nX(e[i], r[i]))
          return !1;
      return !0;
    }
    if (n = Object.keys(e), t = n.length, t !== Object.keys(r).length)
      return !1;
    for (i = t; i-- !== 0; )
      if (!{}.hasOwnProperty.call(r, n[i]))
        return !1;
    for (i = t; i-- !== 0; ) {
      const s = n[i];
      if (!(s === "_owner" && e.$$typeof) && !nX(e[s], r[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && r !== r;
}
function p_(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function sC(e, r) {
  const t = p_(e);
  return Math.round(r * t) / t;
}
function uC(e) {
  const r = h.useRef(e);
  return Ox(() => {
    r.current = e;
  }), r;
}
function oY(e) {
  e === void 0 && (e = {});
  const {
    placement: r = "bottom",
    strategy: t = "absolute",
    middleware: i = [],
    platform: n,
    elements: {
      reference: s,
      floating: u
    } = {},
    transform: o = !0,
    whileElementsMounted: d,
    open: a
  } = e, [V, c] = h.useState({
    x: 0,
    y: 0,
    strategy: t,
    placement: r,
    middlewareData: {},
    isPositioned: !1
  }), [F, X] = h.useState(i);
  nX(F, i) || X(i);
  const [Y, q] = h.useState(null), [f, p] = h.useState(null), m = h.useCallback((L) => {
    L !== A.current && (A.current = L, q(L));
  }, []), g = h.useCallback((L) => {
    L !== w.current && (w.current = L, p(L));
  }, []), y = s || Y, b = u || f, A = h.useRef(null), w = h.useRef(null), S = h.useRef(V), N = d != null, O = uC(d), E = uC(n), I = h.useCallback(() => {
    if (!A.current || !w.current)
      return;
    const L = {
      placement: r,
      strategy: t,
      middleware: F
    };
    E.current && (L.platform = E.current), PKe(A.current, w.current, L).then((z) => {
      const Z = {
        ...z,
        isPositioned: !0
      };
      R.current && !nX(S.current, Z) && (S.current = Z, qs.flushSync(() => {
        c(Z);
      }));
    });
  }, [F, r, t, E]);
  Ox(() => {
    a === !1 && S.current.isPositioned && (S.current.isPositioned = !1, c((L) => ({
      ...L,
      isPositioned: !1
    })));
  }, [a]);
  const R = h.useRef(!1);
  Ox(() => (R.current = !0, () => {
    R.current = !1;
  }), []), Ox(() => {
    if (y && (A.current = y), b && (w.current = b), y && b) {
      if (O.current)
        return O.current(y, b, I);
      I();
    }
  }, [y, b, I, O, N]);
  const H = h.useMemo(() => ({
    reference: A,
    floating: w,
    setReference: m,
    setFloating: g
  }), [m, g]), W = h.useMemo(() => ({
    reference: y,
    floating: b
  }), [y, b]), B = h.useMemo(() => {
    const L = {
      position: t,
      left: 0,
      top: 0
    };
    if (!W.floating)
      return L;
    const z = sC(W.floating, V.x), Z = sC(W.floating, V.y);
    return o ? {
      ...L,
      transform: "translate(" + z + "px, " + Z + "px)",
      ...p_(W.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: t,
      left: z,
      top: Z
    };
  }, [t, o, W.floating, V.x, V.y]);
  return h.useMemo(() => ({
    ...V,
    update: I,
    refs: H,
    elements: W,
    floatingStyles: B
  }), [V, I, H, W, B]);
}
const SKe = (e) => {
  function r(t) {
    return {}.hasOwnProperty.call(t, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const {
        element: i,
        padding: n
      } = typeof e == "function" ? e(t) : e;
      return i && r(i) ? i.current != null ? nC({
        element: i.current,
        padding: n
      }).fn(t) : {} : i ? nC({
        element: i,
        padding: n
      }).fn(t) : {};
    }
  };
}, dY = (e, r) => ({
  ...vKe(e),
  options: [e, r]
}), aY = (e, r) => ({
  ...bKe(e),
  options: [e, r]
}), VY = (e, r) => ({
  ...CKe(e),
  options: [e, r]
}), lY = (e, r) => ({
  ...yKe(e),
  options: [e, r]
}), cY = (e, r) => ({
  ...AKe(e),
  options: [e, r]
}), FY = (e, r) => ({
  ...wKe(e),
  options: [e, r]
}), xY = (e, r) => ({
  ...SKe(e),
  options: [e, r]
});
var NKe = "Arrow", m_ = h.forwardRef((e, r) => {
  const { children: t, width: i = 10, height: n = 5, ...s } = e;
  return /* @__PURE__ */ l(
    Me.svg,
    {
      ...s,
      ref: r,
      width: i,
      height: n,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? t : /* @__PURE__ */ l("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
m_.displayName = NKe;
var MKe = m_, b3 = "Popper", [g_, v_] = Wo(b3), [TKe, b_] = g_(b3), y_ = (e) => {
  const { __scopePopper: r, children: t } = e, [i, n] = h.useState(null);
  return /* @__PURE__ */ l(TKe, { scope: r, anchor: i, onAnchorChange: n, children: t });
};
y_.displayName = b3;
var A_ = "PopperAnchor", w_ = h.forwardRef(
  (e, r) => {
    const { __scopePopper: t, virtualRef: i, ...n } = e, s = b_(A_, t), u = h.useRef(null), o = rr(r, u);
    return h.useEffect(() => {
      s.onAnchorChange((i == null ? void 0 : i.current) || u.current);
    }), i ? null : /* @__PURE__ */ l(Me.div, { ...n, ref: o });
  }
);
w_.displayName = A_;
var y3 = "PopperContent", [EKe, kKe] = g_(y3), C_ = h.forwardRef(
  (e, r) => {
    var qe, me, ne, fe, Ye, Q;
    const {
      __scopePopper: t,
      side: i = "bottom",
      sideOffset: n = 0,
      align: s = "center",
      alignOffset: u = 0,
      arrowPadding: o = 0,
      avoidCollisions: d = !0,
      collisionBoundary: a = [],
      collisionPadding: V = 0,
      sticky: c = "partial",
      hideWhenDetached: F = !1,
      updatePositionStrategy: X = "optimized",
      onPlaced: Y,
      ...q
    } = e, f = b_(y3, t), [p, m] = h.useState(null), g = rr(r, (we) => m(we)), [y, b] = h.useState(null), A = da(y), w = (A == null ? void 0 : A.width) ?? 0, S = (A == null ? void 0 : A.height) ?? 0, N = i + (s !== "center" ? "-" + s : ""), O = typeof V == "number" ? V : { top: 0, right: 0, bottom: 0, left: 0, ...V }, E = Array.isArray(a) ? a : [a], I = E.length > 0, R = {
      padding: O,
      boundary: E.filter(DKe),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: I
    }, { refs: H, floatingStyles: W, placement: B, isPositioned: L, middlewareData: z } = oY({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: N,
      whileElementsMounted: (...we) => uY(...we, {
        animationFrame: X === "always"
      }),
      elements: {
        reference: f.anchor
      },
      middleware: [
        dY({ mainAxis: n + S, alignmentAxis: u }),
        d && aY({
          mainAxis: !0,
          crossAxis: !1,
          limiter: c === "partial" ? VY() : void 0,
          ...R
        }),
        d && lY({ ...R }),
        cY({
          ...R,
          apply: ({ elements: we, rects: oe, availableWidth: tr, availableHeight: ar }) => {
            const { width: or, height: bt } = oe.reference, Tr = we.floating.style;
            Tr.setProperty("--radix-popper-available-width", `${tr}px`), Tr.setProperty("--radix-popper-available-height", `${ar}px`), Tr.setProperty("--radix-popper-anchor-width", `${or}px`), Tr.setProperty("--radix-popper-anchor-height", `${bt}px`);
          }
        }),
        y && xY({ element: y, padding: o }),
        RKe({ arrowWidth: w, arrowHeight: S }),
        F && FY({ strategy: "referenceHidden", ...R })
      ]
    }), [Z, le] = N_(B), te = Ee(Y);
    ze(() => {
      L && (te == null || te());
    }, [L, te]);
    const U = (qe = z.arrow) == null ? void 0 : qe.x, de = (me = z.arrow) == null ? void 0 : me.y, Ke = ((ne = z.arrow) == null ? void 0 : ne.centerOffset) !== 0, [xe, be] = h.useState();
    return ze(() => {
      p && be(window.getComputedStyle(p).zIndex);
    }, [p]), /* @__PURE__ */ l(
      "div",
      {
        ref: H.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...W,
          transform: L ? W.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: xe,
          "--radix-popper-transform-origin": [
            (fe = z.transformOrigin) == null ? void 0 : fe.x,
            (Ye = z.transformOrigin) == null ? void 0 : Ye.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Q = z.hide) == null ? void 0 : Q.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ l(
          EKe,
          {
            scope: t,
            placedSide: Z,
            onArrowChange: b,
            arrowX: U,
            arrowY: de,
            shouldHideArrow: Ke,
            children: /* @__PURE__ */ l(
              Me.div,
              {
                "data-side": Z,
                "data-align": le,
                ...q,
                ref: g,
                style: {
                  ...q.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: L ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
C_.displayName = y3;
var P_ = "PopperArrow", OKe = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, S_ = h.forwardRef(function(r, t) {
  const { __scopePopper: i, ...n } = r, s = kKe(P_, i), u = OKe[s.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ l(
      "span",
      {
        ref: s.onArrowChange,
        style: {
          position: "absolute",
          left: s.arrowX,
          top: s.arrowY,
          [u]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[s.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[s.placedSide],
          visibility: s.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ l(
          MKe,
          {
            ...n,
            ref: t,
            style: {
              ...n.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
S_.displayName = P_;
function DKe(e) {
  return e !== null;
}
var RKe = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(r) {
    var f, p, m;
    const { placement: t, rects: i, middlewareData: n } = r, u = ((f = n.arrow) == null ? void 0 : f.centerOffset) !== 0, o = u ? 0 : e.arrowWidth, d = u ? 0 : e.arrowHeight, [a, V] = N_(t), c = { start: "0%", center: "50%", end: "100%" }[V], F = (((p = n.arrow) == null ? void 0 : p.x) ?? 0) + o / 2, X = (((m = n.arrow) == null ? void 0 : m.y) ?? 0) + d / 2;
    let Y = "", q = "";
    return a === "bottom" ? (Y = u ? c : `${F}px`, q = `${-d}px`) : a === "top" ? (Y = u ? c : `${F}px`, q = `${i.floating.height + d}px`) : a === "right" ? (Y = `${-d}px`, q = u ? c : `${X}px`) : a === "left" && (Y = `${i.floating.width + d}px`, q = u ? c : `${X}px`), { data: { x: Y, y: q } };
  }
});
function N_(e) {
  const [r, t = "center"] = e.split("-");
  return [r, t];
}
var IKe = y_, M_ = w_, LKe = C_, _Ke = S_, HKe = "Portal", T_ = h.forwardRef((e, r) => {
  var o;
  const { container: t, ...i } = e, [n, s] = h.useState(!1);
  ze(() => s(!0), []);
  const u = t || n && ((o = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : o.body);
  return u ? Us.createPortal(/* @__PURE__ */ l(Me.div, { ...i, ref: r }), u) : null;
});
T_.displayName = HKe;
function jKe(e, r) {
  return h.useReducer((t, i) => r[t][i] ?? t, e);
}
var A3 = (e) => {
  const { present: r, children: t } = e, i = zKe(r), n = typeof t == "function" ? t({ present: i.isPresent }) : h.Children.only(t), s = rr(i.ref, BKe(n));
  return typeof t == "function" || i.isPresent ? h.cloneElement(n, { ref: s }) : null;
};
A3.displayName = "Presence";
function zKe(e) {
  const [r, t] = h.useState(), i = h.useRef({}), n = h.useRef(e), s = h.useRef("none"), u = e ? "mounted" : "unmounted", [o, d] = jKe(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return h.useEffect(() => {
    const a = WF(i.current);
    s.current = o === "mounted" ? a : "none";
  }, [o]), ze(() => {
    const a = i.current, V = n.current;
    if (V !== e) {
      const F = s.current, X = WF(a);
      e ? d("MOUNT") : X === "none" || (a == null ? void 0 : a.display) === "none" ? d("UNMOUNT") : d(V && F !== X ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, d]), ze(() => {
    if (r) {
      let a;
      const V = r.ownerDocument.defaultView ?? window, c = (X) => {
        const q = WF(i.current).includes(X.animationName);
        if (X.target === r && q && (d("ANIMATION_END"), !n.current)) {
          const f = r.style.animationFillMode;
          r.style.animationFillMode = "forwards", a = V.setTimeout(() => {
            r.style.animationFillMode === "forwards" && (r.style.animationFillMode = f);
          });
        }
      }, F = (X) => {
        X.target === r && (s.current = WF(i.current));
      };
      return r.addEventListener("animationstart", F), r.addEventListener("animationcancel", c), r.addEventListener("animationend", c), () => {
        V.clearTimeout(a), r.removeEventListener("animationstart", F), r.removeEventListener("animationcancel", c), r.removeEventListener("animationend", c);
      };
    } else
      d("ANIMATION_END");
  }, [r, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: h.useCallback((a) => {
      a && (i.current = getComputedStyle(a)), t(a);
    }, [])
  };
}
function WF(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function BKe(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var E_ = n3(), ip = function() {
}, XY = h.forwardRef(function(e, r) {
  var t = h.useRef(null), i = h.useState({
    onScrollCapture: ip,
    onWheelCapture: ip,
    onTouchMoveCapture: ip
  }), n = i[0], s = i[1], u = e.forwardProps, o = e.children, d = e.className, a = e.removeScrollBar, V = e.enabled, c = e.shards, F = e.sideCar, X = e.noIsolation, Y = e.inert, q = e.allowPinchZoom, f = e.as, p = f === void 0 ? "div" : f, m = e.gapMode, g = $s(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), y = F, b = i3([t, r]), A = Ge(Ge({}, g), n);
  return h.createElement(
    h.Fragment,
    null,
    V && h.createElement(y, { sideCar: E_, removeScrollBar: a, shards: c, noIsolation: X, inert: Y, setCallbacks: s, allowPinchZoom: !!q, lockRef: t, gapMode: m }),
    u ? h.cloneElement(h.Children.only(o), Ge(Ge({}, A), { ref: b })) : h.createElement(p, Ge({}, A, { className: d, ref: b }), o)
  );
});
XY.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
XY.classNames = {
  fullWidth: cV,
  zeroRight: lV
};
var Dv = !1;
if (typeof window < "u")
  try {
    var GF = Object.defineProperty({}, "passive", {
      get: function() {
        return Dv = !0, !0;
      }
    });
    window.addEventListener("test", GF, GF), window.removeEventListener("test", GF, GF);
  } catch {
    Dv = !1;
  }
var Ra = Dv ? { passive: !1 } : !1, WKe = function(e) {
  return e.tagName === "TEXTAREA";
}, k_ = function(e, r) {
  if (!(e instanceof Element))
    return !1;
  var t = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    t[r] !== "hidden" && // contains scroll inside self
    !(t.overflowY === t.overflowX && !WKe(e) && t[r] === "visible")
  );
}, GKe = function(e) {
  return k_(e, "overflowY");
}, UKe = function(e) {
  return k_(e, "overflowX");
}, oC = function(e, r) {
  var t = r.ownerDocument, i = r;
  do {
    typeof ShadowRoot < "u" && i instanceof ShadowRoot && (i = i.host);
    var n = O_(e, i);
    if (n) {
      var s = D_(e, i), u = s[1], o = s[2];
      if (u > o)
        return !0;
    }
    i = i.parentNode;
  } while (i && i !== t.body);
  return !1;
}, ZKe = function(e) {
  var r = e.scrollTop, t = e.scrollHeight, i = e.clientHeight;
  return [
    r,
    t,
    i
  ];
}, JKe = function(e) {
  var r = e.scrollLeft, t = e.scrollWidth, i = e.clientWidth;
  return [
    r,
    t,
    i
  ];
}, O_ = function(e, r) {
  return e === "v" ? GKe(r) : UKe(r);
}, D_ = function(e, r) {
  return e === "v" ? ZKe(r) : JKe(r);
}, $Ke = function(e, r) {
  return e === "h" && r === "rtl" ? -1 : 1;
}, QKe = function(e, r, t, i, n) {
  var s = $Ke(e, window.getComputedStyle(r).direction), u = s * i, o = t.target, d = r.contains(o), a = !1, V = u > 0, c = 0, F = 0;
  do {
    var X = D_(e, o), Y = X[0], q = X[1], f = X[2], p = q - f - s * Y;
    (Y || p) && O_(e, o) && (c += p, F += Y), o instanceof ShadowRoot ? o = o.host : o = o.parentNode;
  } while (
    // portaled content
    !d && o !== document.body || // self content
    d && (r.contains(o) || r === o)
  );
  return (V && Math.abs(c) < 1 || !V && Math.abs(F) < 1) && (a = !0), a;
}, UF = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, dC = function(e) {
  return [e.deltaX, e.deltaY];
}, aC = function(e) {
  return e && "current" in e ? e.current : e;
}, ehe = function(e, r) {
  return e[0] === r[0] && e[1] === r[1];
}, rhe = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, the = 0, Ia = [];
function ihe(e) {
  var r = h.useRef([]), t = h.useRef([0, 0]), i = h.useRef(), n = h.useState(the++)[0], s = h.useState(Qq)[0], u = h.useRef(e);
  h.useEffect(function() {
    u.current = e;
  }, [e]), h.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(n));
      var q = Yl([e.lockRef.current], (e.shards || []).map(aC), !0).filter(Boolean);
      return q.forEach(function(f) {
        return f.classList.add("allow-interactivity-".concat(n));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(n)), q.forEach(function(f) {
          return f.classList.remove("allow-interactivity-".concat(n));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var o = h.useCallback(function(q, f) {
    if ("touches" in q && q.touches.length === 2 || q.type === "wheel" && q.ctrlKey)
      return !u.current.allowPinchZoom;
    var p = UF(q), m = t.current, g = "deltaX" in q ? q.deltaX : m[0] - p[0], y = "deltaY" in q ? q.deltaY : m[1] - p[1], b, A = q.target, w = Math.abs(g) > Math.abs(y) ? "h" : "v";
    if ("touches" in q && w === "h" && A.type === "range")
      return !1;
    var S = oC(w, A);
    if (!S)
      return !0;
    if (S ? b = w : (b = w === "v" ? "h" : "v", S = oC(w, A)), !S)
      return !1;
    if (!i.current && "changedTouches" in q && (g || y) && (i.current = b), !b)
      return !0;
    var N = i.current || b;
    return QKe(N, f, q, N === "h" ? g : y);
  }, []), d = h.useCallback(function(q) {
    var f = q;
    if (!(!Ia.length || Ia[Ia.length - 1] !== s)) {
      var p = "deltaY" in f ? dC(f) : UF(f), m = r.current.filter(function(b) {
        return b.name === f.type && (b.target === f.target || f.target === b.shadowParent) && ehe(b.delta, p);
      })[0];
      if (m && m.should) {
        f.cancelable && f.preventDefault();
        return;
      }
      if (!m) {
        var g = (u.current.shards || []).map(aC).filter(Boolean).filter(function(b) {
          return b.contains(f.target);
        }), y = g.length > 0 ? o(f, g[0]) : !u.current.noIsolation;
        y && f.cancelable && f.preventDefault();
      }
    }
  }, []), a = h.useCallback(function(q, f, p, m) {
    var g = { name: q, delta: f, target: p, should: m, shadowParent: nhe(p) };
    r.current.push(g), setTimeout(function() {
      r.current = r.current.filter(function(y) {
        return y !== g;
      });
    }, 1);
  }, []), V = h.useCallback(function(q) {
    t.current = UF(q), i.current = void 0;
  }, []), c = h.useCallback(function(q) {
    a(q.type, dC(q), q.target, o(q, e.lockRef.current));
  }, []), F = h.useCallback(function(q) {
    a(q.type, UF(q), q.target, o(q, e.lockRef.current));
  }, []);
  h.useEffect(function() {
    return Ia.push(s), e.setCallbacks({
      onScrollCapture: c,
      onWheelCapture: c,
      onTouchMoveCapture: F
    }), document.addEventListener("wheel", d, Ra), document.addEventListener("touchmove", d, Ra), document.addEventListener("touchstart", V, Ra), function() {
      Ia = Ia.filter(function(q) {
        return q !== s;
      }), document.removeEventListener("wheel", d, Ra), document.removeEventListener("touchmove", d, Ra), document.removeEventListener("touchstart", V, Ra);
    };
  }, []);
  var X = e.removeScrollBar, Y = e.inert;
  return h.createElement(
    h.Fragment,
    null,
    Y ? h.createElement(s, { styles: rhe(n) }) : null,
    X ? h.createElement(u3, { gapMode: e.gapMode }) : null
  );
}
function nhe(e) {
  for (var r = null; e !== null; )
    e instanceof ShadowRoot && (r = e.host, e = e.host), e = e.parentNode;
  return r;
}
const she = s3(E_, ihe);
var R_ = h.forwardRef(function(e, r) {
  return h.createElement(XY, Ge({}, e, { ref: r, sideCar: she }));
});
R_.classNames = XY.classNames;
var w3 = "Popover", [I_, jQe] = Afe(w3, [
  v_
]), F2 = v_(), [uhe, Go] = I_(w3), L_ = (e) => {
  const {
    __scopePopover: r,
    children: t,
    open: i,
    defaultOpen: n,
    onOpenChange: s,
    modal: u = !1
  } = e, o = F2(r), d = h.useRef(null), [a, V] = h.useState(!1), [c = !1, F] = Gr({
    prop: i,
    defaultProp: n,
    onChange: s
  });
  return /* @__PURE__ */ l(IKe, { ...o, children: /* @__PURE__ */ l(
    uhe,
    {
      scope: r,
      contentId: ot(),
      triggerRef: d,
      open: c,
      onOpenChange: F,
      onOpenToggle: h.useCallback(() => F((X) => !X), [F]),
      hasCustomAnchor: a,
      onCustomAnchorAdd: h.useCallback(() => V(!0), []),
      onCustomAnchorRemove: h.useCallback(() => V(!1), []),
      modal: u,
      children: t
    }
  ) });
};
L_.displayName = w3;
var __ = "PopoverAnchor", H_ = h.forwardRef(
  (e, r) => {
    const { __scopePopover: t, ...i } = e, n = Go(__, t), s = F2(t), { onCustomAnchorAdd: u, onCustomAnchorRemove: o } = n;
    return h.useEffect(() => (u(), () => o()), [u, o]), /* @__PURE__ */ l(M_, { ...s, ...i, ref: r });
  }
);
H_.displayName = __;
var j_ = "PopoverTrigger", z_ = h.forwardRef(
  (e, r) => {
    const { __scopePopover: t, ...i } = e, n = Go(j_, t), s = F2(t), u = rr(r, n.triggerRef), o = /* @__PURE__ */ l(
      Me.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": n.open,
        "aria-controls": n.contentId,
        "data-state": Z_(n.open),
        ...i,
        ref: u,
        onClick: Ne(e.onClick, n.onOpenToggle)
      }
    );
    return n.hasCustomAnchor ? o : /* @__PURE__ */ l(M_, { asChild: !0, ...s, children: o });
  }
);
z_.displayName = j_;
var C3 = "PopoverPortal", [ohe, dhe] = I_(C3, {
  forceMount: void 0
}), B_ = (e) => {
  const { __scopePopover: r, forceMount: t, children: i, container: n } = e, s = Go(C3, r);
  return /* @__PURE__ */ l(ohe, { scope: r, forceMount: t, children: /* @__PURE__ */ l(A3, { present: t || s.open, children: /* @__PURE__ */ l(T_, { asChild: !0, container: n, children: i }) }) });
};
B_.displayName = C3;
var PV = "PopoverContent", W_ = h.forwardRef(
  (e, r) => {
    const t = dhe(PV, e.__scopePopover), { forceMount: i = t.forceMount, ...n } = e, s = Go(PV, e.__scopePopover);
    return /* @__PURE__ */ l(A3, { present: i || s.open, children: s.modal ? /* @__PURE__ */ l(ahe, { ...n, ref: r }) : /* @__PURE__ */ l(Vhe, { ...n, ref: r }) });
  }
);
W_.displayName = PV;
var ahe = h.forwardRef(
  (e, r) => {
    const t = Go(PV, e.__scopePopover), i = h.useRef(null), n = rr(r, i), s = h.useRef(!1);
    return h.useEffect(() => {
      const u = i.current;
      if (u) return fl(u);
    }, []), /* @__PURE__ */ l(R_, { as: yV, allowPinchZoom: !0, children: /* @__PURE__ */ l(
      G_,
      {
        ...e,
        ref: n,
        trapFocus: t.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Ne(e.onCloseAutoFocus, (u) => {
          var o;
          u.preventDefault(), s.current || (o = t.triggerRef.current) == null || o.focus();
        }),
        onPointerDownOutside: Ne(
          e.onPointerDownOutside,
          (u) => {
            const o = u.detail.originalEvent, d = o.button === 0 && o.ctrlKey === !0, a = o.button === 2 || d;
            s.current = a;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: Ne(
          e.onFocusOutside,
          (u) => u.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), Vhe = h.forwardRef(
  (e, r) => {
    const t = Go(PV, e.__scopePopover), i = h.useRef(!1), n = h.useRef(!1);
    return /* @__PURE__ */ l(
      G_,
      {
        ...e,
        ref: r,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var u, o;
          (u = e.onCloseAutoFocus) == null || u.call(e, s), s.defaultPrevented || (i.current || (o = t.triggerRef.current) == null || o.focus(), s.preventDefault()), i.current = !1, n.current = !1;
        },
        onInteractOutside: (s) => {
          var d, a;
          (d = e.onInteractOutside) == null || d.call(e, s), s.defaultPrevented || (i.current = !0, s.detail.originalEvent.type === "pointerdown" && (n.current = !0));
          const u = s.target;
          ((a = t.triggerRef.current) == null ? void 0 : a.contains(u)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && n.current && s.preventDefault();
        }
      }
    );
  }
), G_ = h.forwardRef(
  (e, r) => {
    const {
      __scopePopover: t,
      trapFocus: i,
      onOpenAutoFocus: n,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: u,
      onEscapeKeyDown: o,
      onPointerDownOutside: d,
      onFocusOutside: a,
      onInteractOutside: V,
      ...c
    } = e, F = Go(PV, t), X = F2(t);
    return kfe(), /* @__PURE__ */ l(
      f3,
      {
        asChild: !0,
        loop: !0,
        trapped: i,
        onMountAutoFocus: n,
        onUnmountAutoFocus: s,
        children: /* @__PURE__ */ l(
          V_,
          {
            asChild: !0,
            disableOutsidePointerEvents: u,
            onInteractOutside: V,
            onEscapeKeyDown: o,
            onPointerDownOutside: d,
            onFocusOutside: a,
            onDismiss: () => F.onOpenChange(!1),
            children: /* @__PURE__ */ l(
              LKe,
              {
                "data-state": Z_(F.open),
                role: "dialog",
                id: F.contentId,
                ...X,
                ...c,
                ref: r,
                style: {
                  ...c.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), U_ = "PopoverClose", lhe = h.forwardRef(
  (e, r) => {
    const { __scopePopover: t, ...i } = e, n = Go(U_, t);
    return /* @__PURE__ */ l(
      Me.button,
      {
        type: "button",
        ...i,
        ref: r,
        onClick: Ne(e.onClick, () => n.onOpenChange(!1))
      }
    );
  }
);
lhe.displayName = U_;
var che = "PopoverArrow", Fhe = h.forwardRef(
  (e, r) => {
    const { __scopePopover: t, ...i } = e, n = F2(t);
    return /* @__PURE__ */ l(_Ke, { ...n, ...i, ref: r });
  }
);
Fhe.displayName = che;
function Z_(e) {
  return e ? "open" : "closed";
}
var xhe = L_, Xhe = H_, qhe = z_, Yhe = B_, J_ = W_;
const qY = xhe, YY = qhe, zQe = Xhe, x2 = re(
  ({ className: e, align: r = "center", sideOffset: t = 4, usePortal: i = !0, ...n }, s) => {
    const u = () => /* @__PURE__ */ l(
      J_,
      {
        ref: s,
        align: r,
        sideOffset: t,
        className: _(
          "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 outline-hidden z-50 w-72 rounded-md border p-4 shadow-md",
          e
        ),
        ...n
      }
    );
    return i ? /* @__PURE__ */ l(Yhe, { children: u() }) : u();
  }
);
x2.displayName = J_.displayName;
function fhe({
  className: e,
  onChange: r,
  dateRange: t
}) {
  const i = /* @__PURE__ */ new Date();
  i.setHours(23, 59, 59, 999);
  const n = (u) => {
    const o = /* @__PURE__ */ new Date();
    o.setHours(23, 59, 59, 999);
    const d = Xt(o, -u + 1);
    d.setHours(0, 0, 0, 0), r({
      from: d,
      to: o
    });
  }, s = () => {
    t && (t != null && t.from) && (t != null && t.to) && r({
      from: t.from,
      to: t.to
    });
  };
  return /* @__PURE__ */ l("div", { className: _("grid gap-2", e), children: /* @__PURE__ */ C("div", { className: "flex gap-2", children: [
    /* @__PURE__ */ C(qY, { children: [
      /* @__PURE__ */ l(YY, { asChild: !0, children: /* @__PURE__ */ C(
        er,
        {
          "data-testid": "date-picker",
          id: "date",
          variant: "outline",
          className: _(
            "w-[300px] justify-start text-left font-normal",
            !t && "text-muted-foreground"
          ),
          children: [
            /* @__PURE__ */ l(FR, {}),
            t != null && t.from ? t.to ? /* @__PURE__ */ C(he, { children: [
              ut(t.from, "LLL dd, y"),
              " -",
              " ",
              ut(t.to, "LLL dd, y")
            ] }) : ut(t.from, "LLL dd, y") : /* @__PURE__ */ l("span", { children: "Pick a date" })
          ]
        }
      ) }),
      /* @__PURE__ */ l(x2, { className: "w-auto p-4", align: "start", children: /* @__PURE__ */ C("div", { className: "flex flex-col gap-4", children: [
        /* @__PURE__ */ C("div", { className: "flex flex-wrap gap-2", children: [
          /* @__PURE__ */ l(
            er,
            {
              "data-testid": "today",
              onClick: () => n(1),
              size: "xs",
              variant: "outline",
              children: "Today"
            }
          ),
          /* @__PURE__ */ l(
            er,
            {
              "data-testid": "yesterday",
              onClick: () => {
                const u = /* @__PURE__ */ new Date(), o = Xt(u, -1);
                o.setHours(0, 0, 0, 0);
                const d = Xt(u, -1);
                d.setHours(23, 59, 59, 999), r({
                  from: o,
                  to: d
                });
              },
              size: "xs",
              variant: "outline",
              children: "Yesterday"
            }
          ),
          /* @__PURE__ */ l(
            er,
            {
              "data-testid": "this-week",
              onClick: () => {
                const u = /* @__PURE__ */ new Date(), o = ds(u), d = Xt(u, -1);
                d.setHours(23, 59, 59, 999), r({
                  from: o,
                  to: d
                });
              },
              size: "xs",
              variant: "outline",
              children: "This week"
            }
          ),
          /* @__PURE__ */ l(
            er,
            {
              "data-testid": "last-week",
              onClick: () => n(7),
              size: "xs",
              variant: "outline",
              children: "Last Week"
            }
          ),
          /* @__PURE__ */ l(
            er,
            {
              "data-testid": "last-month",
              onClick: () => n(30),
              size: "xs",
              variant: "outline",
              children: "Last Month"
            }
          ),
          /* @__PURE__ */ l(
            er,
            {
              "data-testid": "last-3-months",
              onClick: () => n(90),
              size: "xs",
              variant: "outline",
              children: "Last 3 Months"
            }
          ),
          /* @__PURE__ */ l(
            er,
            {
              "data-testid": "last-12-months",
              onClick: () => n(365),
              size: "xs",
              variant: "outline",
              children: "Last 12 Months"
            }
          )
        ] }),
        /* @__PURE__ */ l(
          Qy,
          {
            initialFocus: !0,
            mode: "range",
            defaultMonth: t == null ? void 0 : t.from,
            selected: t,
            onSelect: (u) => {
              r(u);
            },
            numberOfMonths: 2,
            disabled: { after: i },
            toDate: i
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ l(
      er,
      {
        "data-testid": "update-date-range",
        disabled: !t || !t.from || !t.to,
        onClick: s,
        children: "Update"
      }
    )
  ] }) });
}
function Khe(e, r) {
  const t = h.createContext(r), i = (s) => {
    const { children: u, ...o } = s, d = h.useMemo(() => o, Object.values(o));
    return /* @__PURE__ */ l(t.Provider, { value: d, children: u });
  };
  i.displayName = e + "Provider";
  function n(s) {
    const u = h.useContext(t);
    if (u) return u;
    if (r !== void 0) return r;
    throw new Error(`\`${s}\` must be used within \`${e}\``);
  }
  return [i, n];
}
function hhe(e, r = []) {
  let t = [];
  function i(s, u) {
    const o = h.createContext(u), d = t.length;
    t = [...t, u];
    const a = (c) => {
      var p;
      const { scope: F, children: X, ...Y } = c, q = ((p = F == null ? void 0 : F[e]) == null ? void 0 : p[d]) || o, f = h.useMemo(() => Y, Object.values(Y));
      return /* @__PURE__ */ l(q.Provider, { value: f, children: X });
    };
    a.displayName = s + "Provider";
    function V(c, F) {
      var q;
      const X = ((q = F == null ? void 0 : F[e]) == null ? void 0 : q[d]) || o, Y = h.useContext(X);
      if (Y) return Y;
      if (u !== void 0) return u;
      throw new Error(`\`${c}\` must be used within \`${s}\``);
    }
    return [a, V];
  }
  const n = () => {
    const s = t.map((u) => h.createContext(u));
    return function(o) {
      const d = (o == null ? void 0 : o[e]) || s;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: d } }),
        [o, d]
      );
    };
  };
  return n.scopeName = e, [i, phe(n, ...r)];
}
function phe(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const t = () => {
    const i = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(s) {
      const u = i.reduce((o, { useScope: d, scopeName: a }) => {
        const c = d(s)[`__scope${a}`];
        return { ...o, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${r.scopeName}`]: u }), [u]);
    };
  };
  return t.scopeName = r.scopeName, t;
}
var mhe = "DismissableLayer", Rv = "dismissableLayer.update", ghe = "dismissableLayer.pointerDownOutside", vhe = "dismissableLayer.focusOutside", VC, $_ = h.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Q_ = h.forwardRef(
  (e, r) => {
    const {
      disableOutsidePointerEvents: t = !1,
      onEscapeKeyDown: i,
      onPointerDownOutside: n,
      onFocusOutside: s,
      onInteractOutside: u,
      onDismiss: o,
      ...d
    } = e, a = h.useContext($_), [V, c] = h.useState(null), F = (V == null ? void 0 : V.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, X] = h.useState({}), Y = rr(r, (w) => c(w)), q = Array.from(a.layers), [f] = [...a.layersWithOutsidePointerEventsDisabled].slice(-1), p = q.indexOf(f), m = V ? q.indexOf(V) : -1, g = a.layersWithOutsidePointerEventsDisabled.size > 0, y = m >= p, b = Ahe((w) => {
      const S = w.target, N = [...a.branches].some((O) => O.contains(S));
      !y || N || (n == null || n(w), u == null || u(w), w.defaultPrevented || o == null || o());
    }, F), A = whe((w) => {
      const S = w.target;
      [...a.branches].some((O) => O.contains(S)) || (s == null || s(w), u == null || u(w), w.defaultPrevented || o == null || o());
    }, F);
    return oa((w) => {
      m === a.layers.size - 1 && (i == null || i(w), !w.defaultPrevented && o && (w.preventDefault(), o()));
    }, F), h.useEffect(() => {
      if (V)
        return t && (a.layersWithOutsidePointerEventsDisabled.size === 0 && (VC = F.body.style.pointerEvents, F.body.style.pointerEvents = "none"), a.layersWithOutsidePointerEventsDisabled.add(V)), a.layers.add(V), lC(), () => {
          t && a.layersWithOutsidePointerEventsDisabled.size === 1 && (F.body.style.pointerEvents = VC);
        };
    }, [V, F, t, a]), h.useEffect(() => () => {
      V && (a.layers.delete(V), a.layersWithOutsidePointerEventsDisabled.delete(V), lC());
    }, [V, a]), h.useEffect(() => {
      const w = () => X({});
      return document.addEventListener(Rv, w), () => document.removeEventListener(Rv, w);
    }, []), /* @__PURE__ */ l(
      Me.div,
      {
        ...d,
        ref: Y,
        style: {
          pointerEvents: g ? y ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Ne(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: Ne(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: Ne(
          e.onPointerDownCapture,
          b.onPointerDownCapture
        )
      }
    );
  }
);
Q_.displayName = mhe;
var bhe = "DismissableLayerBranch", yhe = h.forwardRef((e, r) => {
  const t = h.useContext($_), i = h.useRef(null), n = rr(r, i);
  return h.useEffect(() => {
    const s = i.current;
    if (s)
      return t.branches.add(s), () => {
        t.branches.delete(s);
      };
  }, [t.branches]), /* @__PURE__ */ l(Me.div, { ...e, ref: n });
});
yhe.displayName = bhe;
function Ahe(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Ee(e), i = h.useRef(!1), n = h.useRef(() => {
  });
  return h.useEffect(() => {
    const s = (o) => {
      if (o.target && !i.current) {
        let d = function() {
          eH(
            ghe,
            t,
            a,
            { discrete: !0 }
          );
        };
        const a = { originalEvent: o };
        o.pointerType === "touch" ? (r.removeEventListener("click", n.current), n.current = d, r.addEventListener("click", n.current, { once: !0 })) : d();
      } else
        r.removeEventListener("click", n.current);
      i.current = !1;
    }, u = window.setTimeout(() => {
      r.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(u), r.removeEventListener("pointerdown", s), r.removeEventListener("click", n.current);
    };
  }, [r, t]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => i.current = !0
  };
}
function whe(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Ee(e), i = h.useRef(!1);
  return h.useEffect(() => {
    const n = (s) => {
      s.target && !i.current && eH(vhe, t, { originalEvent: s }, {
        discrete: !1
      });
    };
    return r.addEventListener("focusin", n), () => r.removeEventListener("focusin", n);
  }, [r, t]), {
    onFocusCapture: () => i.current = !0,
    onBlurCapture: () => i.current = !1
  };
}
function lC() {
  const e = new CustomEvent(Rv);
  document.dispatchEvent(e);
}
function eH(e, r, t, { discrete: i }) {
  const n = t.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: t });
  r && n.addEventListener(e, r, { once: !0 }), i ? _q(n, s) : n.dispatchEvent(s);
}
var Che = "Portal", rH = h.forwardRef((e, r) => {
  var o;
  const { container: t, ...i } = e, [n, s] = h.useState(!1);
  ze(() => s(!0), []);
  const u = t || n && ((o = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : o.body);
  return u ? Us.createPortal(/* @__PURE__ */ l(Me.div, { ...i, ref: r }), u) : null;
});
rH.displayName = Che;
function Phe(e, r) {
  return h.useReducer((t, i) => r[t][i] ?? t, e);
}
var fY = (e) => {
  const { present: r, children: t } = e, i = She(r), n = typeof t == "function" ? t({ present: i.isPresent }) : h.Children.only(t), s = rr(i.ref, Nhe(n));
  return typeof t == "function" || i.isPresent ? h.cloneElement(n, { ref: s }) : null;
};
fY.displayName = "Presence";
function She(e) {
  const [r, t] = h.useState(), i = h.useRef({}), n = h.useRef(e), s = h.useRef("none"), u = e ? "mounted" : "unmounted", [o, d] = Phe(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return h.useEffect(() => {
    const a = ZF(i.current);
    s.current = o === "mounted" ? a : "none";
  }, [o]), ze(() => {
    const a = i.current, V = n.current;
    if (V !== e) {
      const F = s.current, X = ZF(a);
      e ? d("MOUNT") : X === "none" || (a == null ? void 0 : a.display) === "none" ? d("UNMOUNT") : d(V && F !== X ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, d]), ze(() => {
    if (r) {
      let a;
      const V = r.ownerDocument.defaultView ?? window, c = (X) => {
        const q = ZF(i.current).includes(X.animationName);
        if (X.target === r && q && (d("ANIMATION_END"), !n.current)) {
          const f = r.style.animationFillMode;
          r.style.animationFillMode = "forwards", a = V.setTimeout(() => {
            r.style.animationFillMode === "forwards" && (r.style.animationFillMode = f);
          });
        }
      }, F = (X) => {
        X.target === r && (s.current = ZF(i.current));
      };
      return r.addEventListener("animationstart", F), r.addEventListener("animationcancel", c), r.addEventListener("animationend", c), () => {
        V.clearTimeout(a), r.removeEventListener("animationstart", F), r.removeEventListener("animationcancel", c), r.removeEventListener("animationend", c);
      };
    } else
      d("ANIMATION_END");
  }, [r, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: h.useCallback((a) => {
      a && (i.current = getComputedStyle(a)), t(a);
    }, [])
  };
}
function ZF(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Nhe(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var np = 0;
function Mhe() {
  h.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? cC()), document.body.insertAdjacentElement("beforeend", e[1] ?? cC()), np++, () => {
      np === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((r) => r.remove()), np--;
    };
  }, []);
}
function cC() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var tH = n3(), sp = function() {
}, KY = h.forwardRef(function(e, r) {
  var t = h.useRef(null), i = h.useState({
    onScrollCapture: sp,
    onWheelCapture: sp,
    onTouchMoveCapture: sp
  }), n = i[0], s = i[1], u = e.forwardProps, o = e.children, d = e.className, a = e.removeScrollBar, V = e.enabled, c = e.shards, F = e.sideCar, X = e.noIsolation, Y = e.inert, q = e.allowPinchZoom, f = e.as, p = f === void 0 ? "div" : f, m = e.gapMode, g = $s(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), y = F, b = i3([t, r]), A = Ge(Ge({}, g), n);
  return h.createElement(
    h.Fragment,
    null,
    V && h.createElement(y, { sideCar: tH, removeScrollBar: a, shards: c, noIsolation: X, inert: Y, setCallbacks: s, allowPinchZoom: !!q, lockRef: t, gapMode: m }),
    u ? h.cloneElement(h.Children.only(o), Ge(Ge({}, A), { ref: b })) : h.createElement(p, Ge({}, A, { className: d, ref: b }), o)
  );
});
KY.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
KY.classNames = {
  fullWidth: cV,
  zeroRight: lV
};
var Iv = !1;
if (typeof window < "u")
  try {
    var JF = Object.defineProperty({}, "passive", {
      get: function() {
        return Iv = !0, !0;
      }
    });
    window.addEventListener("test", JF, JF), window.removeEventListener("test", JF, JF);
  } catch {
    Iv = !1;
  }
var La = Iv ? { passive: !1 } : !1, The = function(e) {
  return e.tagName === "TEXTAREA";
}, iH = function(e, r) {
  if (!(e instanceof Element))
    return !1;
  var t = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    t[r] !== "hidden" && // contains scroll inside self
    !(t.overflowY === t.overflowX && !The(e) && t[r] === "visible")
  );
}, Ehe = function(e) {
  return iH(e, "overflowY");
}, khe = function(e) {
  return iH(e, "overflowX");
}, FC = function(e, r) {
  var t = r.ownerDocument, i = r;
  do {
    typeof ShadowRoot < "u" && i instanceof ShadowRoot && (i = i.host);
    var n = nH(e, i);
    if (n) {
      var s = sH(e, i), u = s[1], o = s[2];
      if (u > o)
        return !0;
    }
    i = i.parentNode;
  } while (i && i !== t.body);
  return !1;
}, Ohe = function(e) {
  var r = e.scrollTop, t = e.scrollHeight, i = e.clientHeight;
  return [
    r,
    t,
    i
  ];
}, Dhe = function(e) {
  var r = e.scrollLeft, t = e.scrollWidth, i = e.clientWidth;
  return [
    r,
    t,
    i
  ];
}, nH = function(e, r) {
  return e === "v" ? Ehe(r) : khe(r);
}, sH = function(e, r) {
  return e === "v" ? Ohe(r) : Dhe(r);
}, Rhe = function(e, r) {
  return e === "h" && r === "rtl" ? -1 : 1;
}, Ihe = function(e, r, t, i, n) {
  var s = Rhe(e, window.getComputedStyle(r).direction), u = s * i, o = t.target, d = r.contains(o), a = !1, V = u > 0, c = 0, F = 0;
  do {
    var X = sH(e, o), Y = X[0], q = X[1], f = X[2], p = q - f - s * Y;
    (Y || p) && nH(e, o) && (c += p, F += Y), o instanceof ShadowRoot ? o = o.host : o = o.parentNode;
  } while (
    // portaled content
    !d && o !== document.body || // self content
    d && (r.contains(o) || r === o)
  );
  return (V && Math.abs(c) < 1 || !V && Math.abs(F) < 1) && (a = !0), a;
}, $F = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, xC = function(e) {
  return [e.deltaX, e.deltaY];
}, XC = function(e) {
  return e && "current" in e ? e.current : e;
}, Lhe = function(e, r) {
  return e[0] === r[0] && e[1] === r[1];
}, _he = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Hhe = 0, _a = [];
function jhe(e) {
  var r = h.useRef([]), t = h.useRef([0, 0]), i = h.useRef(), n = h.useState(Hhe++)[0], s = h.useState(Qq)[0], u = h.useRef(e);
  h.useEffect(function() {
    u.current = e;
  }, [e]), h.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(n));
      var q = Yl([e.lockRef.current], (e.shards || []).map(XC), !0).filter(Boolean);
      return q.forEach(function(f) {
        return f.classList.add("allow-interactivity-".concat(n));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(n)), q.forEach(function(f) {
          return f.classList.remove("allow-interactivity-".concat(n));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var o = h.useCallback(function(q, f) {
    if ("touches" in q && q.touches.length === 2 || q.type === "wheel" && q.ctrlKey)
      return !u.current.allowPinchZoom;
    var p = $F(q), m = t.current, g = "deltaX" in q ? q.deltaX : m[0] - p[0], y = "deltaY" in q ? q.deltaY : m[1] - p[1], b, A = q.target, w = Math.abs(g) > Math.abs(y) ? "h" : "v";
    if ("touches" in q && w === "h" && A.type === "range")
      return !1;
    var S = FC(w, A);
    if (!S)
      return !0;
    if (S ? b = w : (b = w === "v" ? "h" : "v", S = FC(w, A)), !S)
      return !1;
    if (!i.current && "changedTouches" in q && (g || y) && (i.current = b), !b)
      return !0;
    var N = i.current || b;
    return Ihe(N, f, q, N === "h" ? g : y);
  }, []), d = h.useCallback(function(q) {
    var f = q;
    if (!(!_a.length || _a[_a.length - 1] !== s)) {
      var p = "deltaY" in f ? xC(f) : $F(f), m = r.current.filter(function(b) {
        return b.name === f.type && (b.target === f.target || f.target === b.shadowParent) && Lhe(b.delta, p);
      })[0];
      if (m && m.should) {
        f.cancelable && f.preventDefault();
        return;
      }
      if (!m) {
        var g = (u.current.shards || []).map(XC).filter(Boolean).filter(function(b) {
          return b.contains(f.target);
        }), y = g.length > 0 ? o(f, g[0]) : !u.current.noIsolation;
        y && f.cancelable && f.preventDefault();
      }
    }
  }, []), a = h.useCallback(function(q, f, p, m) {
    var g = { name: q, delta: f, target: p, should: m, shadowParent: zhe(p) };
    r.current.push(g), setTimeout(function() {
      r.current = r.current.filter(function(y) {
        return y !== g;
      });
    }, 1);
  }, []), V = h.useCallback(function(q) {
    t.current = $F(q), i.current = void 0;
  }, []), c = h.useCallback(function(q) {
    a(q.type, xC(q), q.target, o(q, e.lockRef.current));
  }, []), F = h.useCallback(function(q) {
    a(q.type, $F(q), q.target, o(q, e.lockRef.current));
  }, []);
  h.useEffect(function() {
    return _a.push(s), e.setCallbacks({
      onScrollCapture: c,
      onWheelCapture: c,
      onTouchMoveCapture: F
    }), document.addEventListener("wheel", d, La), document.addEventListener("touchmove", d, La), document.addEventListener("touchstart", V, La), function() {
      _a = _a.filter(function(q) {
        return q !== s;
      }), document.removeEventListener("wheel", d, La), document.removeEventListener("touchmove", d, La), document.removeEventListener("touchstart", V, La);
    };
  }, []);
  var X = e.removeScrollBar, Y = e.inert;
  return h.createElement(
    h.Fragment,
    null,
    Y ? h.createElement(s, { styles: _he(n) }) : null,
    X ? h.createElement(u3, { gapMode: e.gapMode }) : null
  );
}
function zhe(e) {
  for (var r = null; e !== null; )
    e instanceof ShadowRoot && (r = e.host, e = e.host), e = e.parentNode;
  return r;
}
const Bhe = s3(tH, jhe);
var uH = h.forwardRef(function(e, r) {
  return h.createElement(KY, Ge({}, e, { ref: r, sideCar: Bhe }));
});
uH.classNames = KY.classNames;
var P3 = "Dialog", [oH, BQe] = hhe(P3), [Whe, fs] = oH(P3), dH = (e) => {
  const {
    __scopeDialog: r,
    children: t,
    open: i,
    defaultOpen: n,
    onOpenChange: s,
    modal: u = !0
  } = e, o = h.useRef(null), d = h.useRef(null), [a = !1, V] = Gr({
    prop: i,
    defaultProp: n,
    onChange: s
  });
  return /* @__PURE__ */ l(
    Whe,
    {
      scope: r,
      triggerRef: o,
      contentRef: d,
      contentId: ot(),
      titleId: ot(),
      descriptionId: ot(),
      open: a,
      onOpenChange: V,
      onOpenToggle: h.useCallback(() => V((c) => !c), [V]),
      modal: u,
      children: t
    }
  );
};
dH.displayName = P3;
var aH = "DialogTrigger", VH = h.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, ...i } = e, n = fs(aH, t), s = rr(r, n.triggerRef);
    return /* @__PURE__ */ l(
      Me.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": n.open,
        "aria-controls": n.contentId,
        "data-state": M3(n.open),
        ...i,
        ref: s,
        onClick: Ne(e.onClick, n.onOpenToggle)
      }
    );
  }
);
VH.displayName = aH;
var S3 = "DialogPortal", [Ghe, lH] = oH(S3, {
  forceMount: void 0
}), cH = (e) => {
  const { __scopeDialog: r, forceMount: t, children: i, container: n } = e, s = fs(S3, r);
  return /* @__PURE__ */ l(Ghe, { scope: r, forceMount: t, children: h.Children.map(i, (u) => /* @__PURE__ */ l(fY, { present: t || s.open, children: /* @__PURE__ */ l(rH, { asChild: !0, container: n, children: u }) })) });
};
cH.displayName = S3;
var sX = "DialogOverlay", FH = h.forwardRef(
  (e, r) => {
    const t = lH(sX, e.__scopeDialog), { forceMount: i = t.forceMount, ...n } = e, s = fs(sX, e.__scopeDialog);
    return s.modal ? /* @__PURE__ */ l(fY, { present: i || s.open, children: /* @__PURE__ */ l(Uhe, { ...n, ref: r }) }) : null;
  }
);
FH.displayName = sX;
var Uhe = h.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, ...i } = e, n = fs(sX, t);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ l(uH, { as: yV, allowPinchZoom: !0, shards: [n.contentRef], children: /* @__PURE__ */ l(
        Me.div,
        {
          "data-state": M3(n.open),
          ...i,
          ref: r,
          style: { pointerEvents: "auto", ...i.style }
        }
      ) })
    );
  }
), Jd = "DialogContent", xH = h.forwardRef(
  (e, r) => {
    const t = lH(Jd, e.__scopeDialog), { forceMount: i = t.forceMount, ...n } = e, s = fs(Jd, e.__scopeDialog);
    return /* @__PURE__ */ l(fY, { present: i || s.open, children: s.modal ? /* @__PURE__ */ l(Zhe, { ...n, ref: r }) : /* @__PURE__ */ l(Jhe, { ...n, ref: r }) });
  }
);
xH.displayName = Jd;
var Zhe = h.forwardRef(
  (e, r) => {
    const t = fs(Jd, e.__scopeDialog), i = h.useRef(null), n = rr(r, t.contentRef, i);
    return h.useEffect(() => {
      const s = i.current;
      if (s) return fl(s);
    }, []), /* @__PURE__ */ l(
      XH,
      {
        ...e,
        ref: n,
        trapFocus: t.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Ne(e.onCloseAutoFocus, (s) => {
          var u;
          s.preventDefault(), (u = t.triggerRef.current) == null || u.focus();
        }),
        onPointerDownOutside: Ne(e.onPointerDownOutside, (s) => {
          const u = s.detail.originalEvent, o = u.button === 0 && u.ctrlKey === !0;
          (u.button === 2 || o) && s.preventDefault();
        }),
        onFocusOutside: Ne(
          e.onFocusOutside,
          (s) => s.preventDefault()
        )
      }
    );
  }
), Jhe = h.forwardRef(
  (e, r) => {
    const t = fs(Jd, e.__scopeDialog), i = h.useRef(!1), n = h.useRef(!1);
    return /* @__PURE__ */ l(
      XH,
      {
        ...e,
        ref: r,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var u, o;
          (u = e.onCloseAutoFocus) == null || u.call(e, s), s.defaultPrevented || (i.current || (o = t.triggerRef.current) == null || o.focus(), s.preventDefault()), i.current = !1, n.current = !1;
        },
        onInteractOutside: (s) => {
          var d, a;
          (d = e.onInteractOutside) == null || d.call(e, s), s.defaultPrevented || (i.current = !0, s.detail.originalEvent.type === "pointerdown" && (n.current = !0));
          const u = s.target;
          ((a = t.triggerRef.current) == null ? void 0 : a.contains(u)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && n.current && s.preventDefault();
        }
      }
    );
  }
), XH = h.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, trapFocus: i, onOpenAutoFocus: n, onCloseAutoFocus: s, ...u } = e, o = fs(Jd, t), d = h.useRef(null), a = rr(r, d);
    return Mhe(), /* @__PURE__ */ C(he, { children: [
      /* @__PURE__ */ l(
        f3,
        {
          asChild: !0,
          loop: !0,
          trapped: i,
          onMountAutoFocus: n,
          onUnmountAutoFocus: s,
          children: /* @__PURE__ */ l(
            Q_,
            {
              role: "dialog",
              id: o.contentId,
              "aria-describedby": o.descriptionId,
              "aria-labelledby": o.titleId,
              "data-state": M3(o.open),
              ...u,
              ref: a,
              onDismiss: () => o.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ C(he, { children: [
        /* @__PURE__ */ l($he, { titleId: o.titleId }),
        /* @__PURE__ */ l(epe, { contentRef: d, descriptionId: o.descriptionId })
      ] })
    ] });
  }
), N3 = "DialogTitle", qH = h.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, ...i } = e, n = fs(N3, t);
    return /* @__PURE__ */ l(Me.h2, { id: n.titleId, ...i, ref: r });
  }
);
qH.displayName = N3;
var YH = "DialogDescription", fH = h.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, ...i } = e, n = fs(YH, t);
    return /* @__PURE__ */ l(Me.p, { id: n.descriptionId, ...i, ref: r });
  }
);
fH.displayName = YH;
var KH = "DialogClose", hH = h.forwardRef(
  (e, r) => {
    const { __scopeDialog: t, ...i } = e, n = fs(KH, t);
    return /* @__PURE__ */ l(
      Me.button,
      {
        type: "button",
        ...i,
        ref: r,
        onClick: Ne(e.onClick, () => n.onOpenChange(!1))
      }
    );
  }
);
hH.displayName = KH;
function M3(e) {
  return e ? "open" : "closed";
}
var pH = "DialogTitleWarning", [WQe, mH] = Khe(pH, {
  contentName: Jd,
  titleName: N3,
  docsSlug: "dialog"
}), $he = ({ titleId: e }) => {
  const r = mH(pH), t = `\`${r.contentName}\` requires a \`${r.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${r.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${r.docsSlug}`;
  return h.useEffect(() => {
    e && (document.getElementById(e) || console.error(t));
  }, [t, e]), null;
}, Qhe = "DialogDescriptionWarning", epe = ({ contentRef: e, descriptionId: r }) => {
  const i = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${mH(Qhe).contentName}}.`;
  return h.useEffect(() => {
    var s;
    const n = (s = e.current) == null ? void 0 : s.getAttribute("aria-describedby");
    r && n && (document.getElementById(r) || console.warn(i));
  }, [i, e, r]), null;
}, gH = dH, vH = VH, bH = cH, hY = FH, pY = xH, X2 = qH, mY = fH, gY = hH;
const vY = gH, GQe = vH, rpe = bH, UQe = gY, yH = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  hY,
  {
    ref: t,
    className: _(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/25",
      e
    ),
    ...r
  }
));
yH.displayName = hY.displayName;
const q2 = re(
  ({
    className: e,
    children: r,
    disableAnimation: t,
    hideCloseButton: i,
    portalContainer: n,
    ...s
  }, u) => /* @__PURE__ */ C(rpe, { container: n, children: [
    /* @__PURE__ */ l(yH, {}),
    /* @__PURE__ */ C(
      pY,
      {
        ref: u,
        className: _(
          "bg-background border-border fixed left-[50%] top-[50%] z-50 grid translate-x-[-50%] translate-y-[-50%] gap-4 border shadow-lg sm:rounded-lg",
          !t && "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-top-[48%] duration-200",
          "w-full max-w-[calc(100%-2.25rem)] p-6 md:max-w-lg",
          e
        ),
        ...s,
        children: [
          r,
          i ? null : /* @__PURE__ */ C(gY, { className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground rounded-xs focus:outline-hidden absolute right-4 top-4 opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none", children: [
            /* @__PURE__ */ l(r2, { className: "h-4 w-4" }),
            /* @__PURE__ */ l("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] })
);
q2.displayName = pY.displayName;
const tpe = ({
  className: e,
  ...r
}) => /* @__PURE__ */ l(
  "div",
  {
    className: _(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      e
    ),
    ...r
  }
);
tpe.displayName = "DialogHeader";
const bY = ({
  className: e,
  ...r
}) => /* @__PURE__ */ l(
  "div",
  {
    className: _(
      "flex flex-col-reverse gap-3 sm:flex-row sm:justify-end",
      e
    ),
    ...r
  }
);
bY.displayName = "DialogFooter";
const yY = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  X2,
  {
    ref: t,
    className: _("text-headingxl leading-none tracking-tight", e),
    ...r
  }
));
yY.displayName = X2.displayName;
const ipe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  mY,
  {
    ref: t,
    className: _("text-muted-foreground text-bodysm", e),
    ...r
  }
));
ipe.displayName = mY.displayName;
const npe = "data:image/svg+xml,%3csvg%20width='63'%20height='63'%20viewBox='0%200%2063%2063'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M43.6098%2014.4513L40.9935%2017.0676L39.3672%2015.4413L46.2968%208.51164L47.9232%2010.138L45.3069%2012.7543L52.5901%2020.0375L50.893%2021.7345L43.6098%2014.4513Z'%20fill='black'%20fill-opacity='0.04'/%3e%3cpath%20d='M32.8652%2021.9434L38.8049%2016.0037L40.4313%2017.63L36.1886%2021.8726L38.3807%2024.0647L41.8455%2020.5999L43.4718%2022.2262L40.007%2025.691L43.4718%2029.1558L41.7748%2030.8529L32.8652%2021.9434Z'%20fill='black'%20fill-opacity='0.04'/%3e%3cpath%20d='M27.1335%2027.6754L28.6891%2026.1197L40.922%2031.7059L39.1543%2033.4737L36.6794%2032.2716L33.2853%2035.6657L34.4874%2038.1406L32.7196%2039.9083L27.1335%2027.6754ZM34.5581%2031.2816L30.174%2029.1603L32.2953%2033.5444L34.5581%2031.2816Z'%20fill='black'%20fill-opacity='0.04'/%3e%3cpath%20d='M16.8862%2037.9223L20.4218%2034.3868C20.846%2033.9625%2021.3127%2033.6467%2021.8218%2033.4392C22.331%2033.213%2022.8448%2033.0951%2023.3633%2033.0857C23.8819%2033.0763%2024.3863%2033.1658%2024.8765%2033.3544C25.3574%2033.5335%2025.7816%2033.8069%2026.1493%2034.1746C26.649%2034.6743%2026.9649%2035.1882%2027.0969%2035.7161C27.2288%2036.2441%2027.276%2036.7344%2027.2383%2037.1869C27.2006%2037.7149%2027.0733%2038.2193%2026.8564%2038.7001L32.5133%2040.1143L30.6041%2042.0235L25.5129%2040.6093L24.2401%2041.8821L27.4928%2045.1348L25.7958%2046.8318L16.8862%2037.9223ZM24.4523%2038.4173C24.8105%2038.059%2024.9944%2037.6395%2025.0038%2037.1586C25.0038%2036.6684%2024.8435%2036.263%2024.523%2035.9424C24.2024%2035.6218%2023.8017%2035.4663%2023.3209%2035.4757C22.8306%2035.4757%2022.4064%2035.6548%2022.0481%2036.0131L20.2096%2037.8516L22.6138%2040.2558L24.4523%2038.4173Z'%20fill='black'%20fill-opacity='0.04'/%3e%3cpath%20d='M8.32373%2046.4849L11.1522%2043.6565C11.7367%2043.072%2012.4155%2042.6383%2013.1886%2042.3554C13.9523%2042.0632%2014.7395%2041.917%2015.5504%2041.917C16.3612%2041.917%2017.1531%2042.0679%2017.9262%2042.3696C18.6993%2042.6713%2019.3876%2043.1238%2019.991%2043.7272C20.5944%2044.3306%2021.0469%2045.0189%2021.3486%2045.792C21.6503%2046.5651%2021.8012%2047.357%2021.8012%2048.1678C21.8012%2048.9787%2021.6598%2049.7706%2021.3769%2050.5437C21.0847%2051.3074%2020.6462%2051.9815%2020.0617%2052.566L17.2333%2055.3945L8.32373%2046.4849ZM18.4354%2050.9397C18.7842%2050.5909%2019.0435%2050.1807%2019.2132%2049.7093C19.3923%2049.2285%2019.4772%2048.7382%2019.4677%2048.2385C19.4677%2047.7294%2019.3687%2047.2345%2019.1707%2046.7536C18.9728%2046.2539%2018.6805%2045.8108%2018.2939%2045.4243C17.9074%2045.0377%2017.469%2044.7502%2016.9787%2044.5616C16.4885%2044.3542%2015.9888%2044.2505%2015.4797%2044.2505C14.98%2044.241%2014.4897%2044.3259%2014.0089%2044.505C13.5375%2044.6747%2013.1273%2044.934%2012.7785%2045.2828L11.6471%2046.4142L17.304%2052.0711L18.4354%2050.9397Z'%20fill='black'%20fill-opacity='0.04'/%3e%3c/svg%3e";
function spe() {
  return /* @__PURE__ */ l(
    "div",
    {
      className: "absolute inset-0",
      style: {
        backgroundImage: `url("${npe}")`,
        backgroundSize: "100px 100px",
        pointerEvents: "none"
      }
    }
  );
}
function uX(e, r, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), t === !1 || !n.defaultPrevented)
      return r == null ? void 0 : r(n);
  };
}
function qC(e, r) {
  if (typeof e == "function")
    return e(r);
  e != null && (e.current = r);
}
function AH(...e) {
  return (r) => {
    let t = !1;
    const i = e.map((n) => {
      const s = qC(n, r);
      return !t && typeof s == "function" && (t = !0), s;
    });
    if (t)
      return () => {
        for (let n = 0; n < i.length; n++) {
          const s = i[n];
          typeof s == "function" ? s() : qC(e[n], null);
        }
      };
  };
}
function upe(e, r = []) {
  let t = [];
  function i(s, u) {
    const o = h.createContext(u), d = t.length;
    t = [...t, u];
    const a = (c) => {
      var p;
      const { scope: F, children: X, ...Y } = c, q = ((p = F == null ? void 0 : F[e]) == null ? void 0 : p[d]) || o, f = h.useMemo(() => Y, Object.values(Y));
      return /* @__PURE__ */ l(q.Provider, { value: f, children: X });
    };
    a.displayName = s + "Provider";
    function V(c, F) {
      var q;
      const X = ((q = F == null ? void 0 : F[e]) == null ? void 0 : q[d]) || o, Y = h.useContext(X);
      if (Y) return Y;
      if (u !== void 0) return u;
      throw new Error(`\`${c}\` must be used within \`${s}\``);
    }
    return [a, V];
  }
  const n = () => {
    const s = t.map((u) => h.createContext(u));
    return function(o) {
      const d = (o == null ? void 0 : o[e]) || s;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: d } }),
        [o, d]
      );
    };
  };
  return n.scopeName = e, [i, ope(n, ...r)];
}
function ope(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const t = () => {
    const i = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(s) {
      const u = i.reduce((o, { useScope: d, scopeName: a }) => {
        const c = d(s)[`__scope${a}`];
        return { ...o, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${r.scopeName}`]: u }), [u]);
    };
  };
  return t.scopeName = r.scopeName, t;
}
var wH = h.forwardRef((e, r) => {
  const { children: t, ...i } = e, n = h.Children.toArray(t), s = n.find(ape);
  if (s) {
    const u = s.props.children, o = n.map((d) => d === s ? h.Children.count(u) > 1 ? h.Children.only(null) : h.isValidElement(u) ? u.props.children : null : d);
    return /* @__PURE__ */ l(Lv, { ...i, ref: r, children: h.isValidElement(u) ? h.cloneElement(u, void 0, o) : null });
  }
  return /* @__PURE__ */ l(Lv, { ...i, ref: r, children: t });
});
wH.displayName = "Slot";
var Lv = h.forwardRef((e, r) => {
  const { children: t, ...i } = e;
  if (h.isValidElement(t)) {
    const n = lpe(t);
    return h.cloneElement(t, {
      ...Vpe(i, t.props),
      // @ts-ignore
      ref: r ? AH(r, n) : n
    });
  }
  return h.Children.count(t) > 1 ? h.Children.only(null) : null;
});
Lv.displayName = "SlotClone";
var dpe = ({ children: e }) => /* @__PURE__ */ l(he, { children: e });
function ape(e) {
  return h.isValidElement(e) && e.type === dpe;
}
function Vpe(e, r) {
  const t = { ...r };
  for (const i in r) {
    const n = e[i], s = r[i];
    /^on[A-Z]/.test(i) ? n && s ? t[i] = (...o) => {
      s(...o), n(...o);
    } : n && (t[i] = n) : i === "style" ? t[i] = { ...n, ...s } : i === "className" && (t[i] = [n, s].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function lpe(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var cpe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Fpe = cpe.reduce((e, r) => {
  const t = h.forwardRef((i, n) => {
    const { asChild: s, ...u } = i, o = s ? wH : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l(o, { ...u, ref: n });
  });
  return t.displayName = `Primitive.${r}`, { ...e, [r]: t };
}, {});
function Ar(e, r, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), t === !1 || !n.defaultPrevented)
      return r == null ? void 0 : r(n);
  };
}
function AY(e, r = []) {
  let t = [];
  function i(s, u) {
    const o = h.createContext(u), d = t.length;
    t = [...t, u];
    const a = (c) => {
      var p;
      const { scope: F, children: X, ...Y } = c, q = ((p = F == null ? void 0 : F[e]) == null ? void 0 : p[d]) || o, f = h.useMemo(() => Y, Object.values(Y));
      return /* @__PURE__ */ l(q.Provider, { value: f, children: X });
    };
    a.displayName = s + "Provider";
    function V(c, F) {
      var q;
      const X = ((q = F == null ? void 0 : F[e]) == null ? void 0 : q[d]) || o, Y = h.useContext(X);
      if (Y) return Y;
      if (u !== void 0) return u;
      throw new Error(`\`${c}\` must be used within \`${s}\``);
    }
    return [a, V];
  }
  const n = () => {
    const s = t.map((u) => h.createContext(u));
    return function(o) {
      const d = (o == null ? void 0 : o[e]) || s;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: d } }),
        [o, d]
      );
    };
  };
  return n.scopeName = e, [i, xpe(n, ...r)];
}
function xpe(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const t = () => {
    const i = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(s) {
      const u = i.reduce((o, { useScope: d, scopeName: a }) => {
        const c = d(s)[`__scope${a}`];
        return { ...o, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${r.scopeName}`]: u }), [u]);
    };
  };
  return t.scopeName = r.scopeName, t;
}
function YC(e, r) {
  if (typeof e == "function")
    return e(r);
  e != null && (e.current = r);
}
function T3(...e) {
  return (r) => {
    let t = !1;
    const i = e.map((n) => {
      const s = YC(n, r);
      return !t && typeof s == "function" && (t = !0), s;
    });
    if (t)
      return () => {
        for (let n = 0; n < i.length; n++) {
          const s = i[n];
          typeof s == "function" ? s() : YC(e[n], null);
        }
      };
  };
}
function Wi(...e) {
  return h.useCallback(T3(...e), e);
}
var Qc = h.forwardRef((e, r) => {
  const { children: t, ...i } = e, n = h.Children.toArray(t), s = n.find(qpe);
  if (s) {
    const u = s.props.children, o = n.map((d) => d === s ? h.Children.count(u) > 1 ? h.Children.only(null) : h.isValidElement(u) ? u.props.children : null : d);
    return /* @__PURE__ */ l(_v, { ...i, ref: r, children: h.isValidElement(u) ? h.cloneElement(u, void 0, o) : null });
  }
  return /* @__PURE__ */ l(_v, { ...i, ref: r, children: t });
});
Qc.displayName = "Slot";
var _v = h.forwardRef((e, r) => {
  const { children: t, ...i } = e;
  if (h.isValidElement(t)) {
    const n = fpe(t);
    return h.cloneElement(t, {
      ...Ype(i, t.props),
      // @ts-ignore
      ref: r ? T3(r, n) : n
    });
  }
  return h.Children.count(t) > 1 ? h.Children.only(null) : null;
});
_v.displayName = "SlotClone";
var Xpe = ({ children: e }) => /* @__PURE__ */ l(he, { children: e });
function qpe(e) {
  return h.isValidElement(e) && e.type === Xpe;
}
function Ype(e, r) {
  const t = { ...r };
  for (const i in r) {
    const n = e[i], s = r[i];
    /^on[A-Z]/.test(i) ? n && s ? t[i] = (...o) => {
      s(...o), n(...o);
    } : n && (t[i] = n) : i === "style" ? t[i] = { ...n, ...s } : i === "className" && (t[i] = [n, s].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function fpe(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
function CH(e) {
  const r = e + "CollectionProvider", [t, i] = AY(r), [n, s] = t(
    r,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), u = (X) => {
    const { scope: Y, children: q } = X, f = D.useRef(null), p = D.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ l(n, { scope: Y, itemMap: p, collectionRef: f, children: q });
  };
  u.displayName = r;
  const o = e + "CollectionSlot", d = D.forwardRef(
    (X, Y) => {
      const { scope: q, children: f } = X, p = s(o, q), m = Wi(Y, p.collectionRef);
      return /* @__PURE__ */ l(Qc, { ref: m, children: f });
    }
  );
  d.displayName = o;
  const a = e + "CollectionItemSlot", V = "data-radix-collection-item", c = D.forwardRef(
    (X, Y) => {
      const { scope: q, children: f, ...p } = X, m = D.useRef(null), g = Wi(Y, m), y = s(a, q);
      return D.useEffect(() => (y.itemMap.set(m, { ref: m, ...p }), () => void y.itemMap.delete(m))), /* @__PURE__ */ l(Qc, { [V]: "", ref: g, children: f });
    }
  );
  c.displayName = a;
  function F(X) {
    const Y = s(e + "CollectionConsumer", X);
    return D.useCallback(() => {
      const f = Y.collectionRef.current;
      if (!f) return [];
      const p = Array.from(f.querySelectorAll(`[${V}]`));
      return Array.from(Y.itemMap.values()).sort(
        (y, b) => p.indexOf(y.ref.current) - p.indexOf(b.ref.current)
      );
    }, [Y.collectionRef, Y.itemMap]);
  }
  return [
    { Provider: u, Slot: d, ItemSlot: c },
    F,
    i
  ];
}
var Kpe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], $i = Kpe.reduce((e, r) => {
  const t = h.forwardRef((i, n) => {
    const { asChild: s, ...u } = i, o = s ? Qc : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l(o, { ...u, ref: n });
  });
  return t.displayName = `Primitive.${r}`, { ...e, [r]: t };
}, {});
function PH(e, r) {
  e && qs.flushSync(() => e.dispatchEvent(r));
}
var hpe = "DismissableLayer", Hv = "dismissableLayer.update", ppe = "dismissableLayer.pointerDownOutside", mpe = "dismissableLayer.focusOutside", fC, SH = h.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), NH = h.forwardRef(
  (e, r) => {
    const {
      disableOutsidePointerEvents: t = !1,
      onEscapeKeyDown: i,
      onPointerDownOutside: n,
      onFocusOutside: s,
      onInteractOutside: u,
      onDismiss: o,
      ...d
    } = e, a = h.useContext(SH), [V, c] = h.useState(null), F = (V == null ? void 0 : V.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, X] = h.useState({}), Y = Wi(r, (w) => c(w)), q = Array.from(a.layers), [f] = [...a.layersWithOutsidePointerEventsDisabled].slice(-1), p = q.indexOf(f), m = V ? q.indexOf(V) : -1, g = a.layersWithOutsidePointerEventsDisabled.size > 0, y = m >= p, b = bpe((w) => {
      const S = w.target, N = [...a.branches].some((O) => O.contains(S));
      !y || N || (n == null || n(w), u == null || u(w), w.defaultPrevented || o == null || o());
    }, F), A = ype((w) => {
      const S = w.target;
      [...a.branches].some((O) => O.contains(S)) || (s == null || s(w), u == null || u(w), w.defaultPrevented || o == null || o());
    }, F);
    return oa((w) => {
      m === a.layers.size - 1 && (i == null || i(w), !w.defaultPrevented && o && (w.preventDefault(), o()));
    }, F), h.useEffect(() => {
      if (V)
        return t && (a.layersWithOutsidePointerEventsDisabled.size === 0 && (fC = F.body.style.pointerEvents, F.body.style.pointerEvents = "none"), a.layersWithOutsidePointerEventsDisabled.add(V)), a.layers.add(V), KC(), () => {
          t && a.layersWithOutsidePointerEventsDisabled.size === 1 && (F.body.style.pointerEvents = fC);
        };
    }, [V, F, t, a]), h.useEffect(() => () => {
      V && (a.layers.delete(V), a.layersWithOutsidePointerEventsDisabled.delete(V), KC());
    }, [V, a]), h.useEffect(() => {
      const w = () => X({});
      return document.addEventListener(Hv, w), () => document.removeEventListener(Hv, w);
    }, []), /* @__PURE__ */ l(
      $i.div,
      {
        ...d,
        ref: Y,
        style: {
          pointerEvents: g ? y ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Ar(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: Ar(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: Ar(
          e.onPointerDownCapture,
          b.onPointerDownCapture
        )
      }
    );
  }
);
NH.displayName = hpe;
var gpe = "DismissableLayerBranch", vpe = h.forwardRef((e, r) => {
  const t = h.useContext(SH), i = h.useRef(null), n = Wi(r, i);
  return h.useEffect(() => {
    const s = i.current;
    if (s)
      return t.branches.add(s), () => {
        t.branches.delete(s);
      };
  }, [t.branches]), /* @__PURE__ */ l($i.div, { ...e, ref: n });
});
vpe.displayName = gpe;
function bpe(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Ee(e), i = h.useRef(!1), n = h.useRef(() => {
  });
  return h.useEffect(() => {
    const s = (o) => {
      if (o.target && !i.current) {
        let d = function() {
          MH(
            ppe,
            t,
            a,
            { discrete: !0 }
          );
        };
        const a = { originalEvent: o };
        o.pointerType === "touch" ? (r.removeEventListener("click", n.current), n.current = d, r.addEventListener("click", n.current, { once: !0 })) : d();
      } else
        r.removeEventListener("click", n.current);
      i.current = !1;
    }, u = window.setTimeout(() => {
      r.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(u), r.removeEventListener("pointerdown", s), r.removeEventListener("click", n.current);
    };
  }, [r, t]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => i.current = !0
  };
}
function ype(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Ee(e), i = h.useRef(!1);
  return h.useEffect(() => {
    const n = (s) => {
      s.target && !i.current && MH(mpe, t, { originalEvent: s }, {
        discrete: !1
      });
    };
    return r.addEventListener("focusin", n), () => r.removeEventListener("focusin", n);
  }, [r, t]), {
    onFocusCapture: () => i.current = !0,
    onBlurCapture: () => i.current = !1
  };
}
function KC() {
  const e = new CustomEvent(Hv);
  document.dispatchEvent(e);
}
function MH(e, r, t, { discrete: i }) {
  const n = t.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: t });
  r && n.addEventListener(e, r, { once: !0 }), i ? PH(n, s) : n.dispatchEvent(s);
}
var up = "focusScope.autoFocusOnMount", op = "focusScope.autoFocusOnUnmount", hC = { bubbles: !1, cancelable: !0 }, Ape = "FocusScope", TH = h.forwardRef((e, r) => {
  const {
    loop: t = !1,
    trapped: i = !1,
    onMountAutoFocus: n,
    onUnmountAutoFocus: s,
    ...u
  } = e, [o, d] = h.useState(null), a = Ee(n), V = Ee(s), c = h.useRef(null), F = Wi(r, (q) => d(q)), X = h.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  h.useEffect(() => {
    if (i) {
      let q = function(g) {
        if (X.paused || !o) return;
        const y = g.target;
        o.contains(y) ? c.current = y : xo(c.current, { select: !0 });
      }, f = function(g) {
        if (X.paused || !o) return;
        const y = g.relatedTarget;
        y !== null && (o.contains(y) || xo(c.current, { select: !0 }));
      }, p = function(g) {
        if (document.activeElement === document.body)
          for (const b of g)
            b.removedNodes.length > 0 && xo(o);
      };
      document.addEventListener("focusin", q), document.addEventListener("focusout", f);
      const m = new MutationObserver(p);
      return o && m.observe(o, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", q), document.removeEventListener("focusout", f), m.disconnect();
      };
    }
  }, [i, o, X.paused]), h.useEffect(() => {
    if (o) {
      mC.add(X);
      const q = document.activeElement;
      if (!o.contains(q)) {
        const p = new CustomEvent(up, hC);
        o.addEventListener(up, a), o.dispatchEvent(p), p.defaultPrevented || (wpe(Mpe(EH(o)), { select: !0 }), document.activeElement === q && xo(o));
      }
      return () => {
        o.removeEventListener(up, a), setTimeout(() => {
          const p = new CustomEvent(op, hC);
          o.addEventListener(op, V), o.dispatchEvent(p), p.defaultPrevented || xo(q ?? document.body, { select: !0 }), o.removeEventListener(op, V), mC.remove(X);
        }, 0);
      };
    }
  }, [o, a, V, X]);
  const Y = h.useCallback(
    (q) => {
      if (!t && !i || X.paused) return;
      const f = q.key === "Tab" && !q.altKey && !q.ctrlKey && !q.metaKey, p = document.activeElement;
      if (f && p) {
        const m = q.currentTarget, [g, y] = Cpe(m);
        g && y ? !q.shiftKey && p === y ? (q.preventDefault(), t && xo(g, { select: !0 })) : q.shiftKey && p === g && (q.preventDefault(), t && xo(y, { select: !0 })) : p === m && q.preventDefault();
      }
    },
    [t, i, X.paused]
  );
  return /* @__PURE__ */ l($i.div, { tabIndex: -1, ...u, ref: F, onKeyDown: Y });
});
TH.displayName = Ape;
function wpe(e, { select: r = !1 } = {}) {
  const t = document.activeElement;
  for (const i of e)
    if (xo(i, { select: r }), document.activeElement !== t) return;
}
function Cpe(e) {
  const r = EH(e), t = pC(r, e), i = pC(r.reverse(), e);
  return [t, i];
}
function EH(e) {
  const r = [], t = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (i) => {
      const n = i.tagName === "INPUT" && i.type === "hidden";
      return i.disabled || i.hidden || n ? NodeFilter.FILTER_SKIP : i.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); ) r.push(t.currentNode);
  return r;
}
function pC(e, r) {
  for (const t of e)
    if (!Ppe(t, { upTo: r })) return t;
}
function Ppe(e, { upTo: r }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (r !== void 0 && e === r) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Spe(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function xo(e, { select: r = !1 } = {}) {
  if (e && e.focus) {
    const t = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== t && Spe(e) && r && e.select();
  }
}
var mC = Npe();
function Npe() {
  let e = [];
  return {
    add(r) {
      const t = e[0];
      r !== t && (t == null || t.pause()), e = gC(e, r), e.unshift(r);
    },
    remove(r) {
      var t;
      e = gC(e, r), (t = e[0]) == null || t.resume();
    }
  };
}
function gC(e, r) {
  const t = [...e], i = t.indexOf(r);
  return i !== -1 && t.splice(i, 1), t;
}
function Mpe(e) {
  return e.filter((r) => r.tagName !== "A");
}
var Tpe = "Arrow", kH = h.forwardRef((e, r) => {
  const { children: t, width: i = 10, height: n = 5, ...s } = e;
  return /* @__PURE__ */ l(
    $i.svg,
    {
      ...s,
      ref: r,
      width: i,
      height: n,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? t : /* @__PURE__ */ l("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
kH.displayName = Tpe;
var Epe = kH, E3 = "Popper", [OH, DH] = AY(E3), [kpe, RH] = OH(E3), IH = (e) => {
  const { __scopePopper: r, children: t } = e, [i, n] = h.useState(null);
  return /* @__PURE__ */ l(kpe, { scope: r, anchor: i, onAnchorChange: n, children: t });
};
IH.displayName = E3;
var LH = "PopperAnchor", _H = h.forwardRef(
  (e, r) => {
    const { __scopePopper: t, virtualRef: i, ...n } = e, s = RH(LH, t), u = h.useRef(null), o = Wi(r, u);
    return h.useEffect(() => {
      s.onAnchorChange((i == null ? void 0 : i.current) || u.current);
    }), i ? null : /* @__PURE__ */ l($i.div, { ...n, ref: o });
  }
);
_H.displayName = LH;
var k3 = "PopperContent", [Ope, Dpe] = OH(k3), HH = h.forwardRef(
  (e, r) => {
    var qe, me, ne, fe, Ye, Q;
    const {
      __scopePopper: t,
      side: i = "bottom",
      sideOffset: n = 0,
      align: s = "center",
      alignOffset: u = 0,
      arrowPadding: o = 0,
      avoidCollisions: d = !0,
      collisionBoundary: a = [],
      collisionPadding: V = 0,
      sticky: c = "partial",
      hideWhenDetached: F = !1,
      updatePositionStrategy: X = "optimized",
      onPlaced: Y,
      ...q
    } = e, f = RH(k3, t), [p, m] = h.useState(null), g = Wi(r, (we) => m(we)), [y, b] = h.useState(null), A = da(y), w = (A == null ? void 0 : A.width) ?? 0, S = (A == null ? void 0 : A.height) ?? 0, N = i + (s !== "center" ? "-" + s : ""), O = typeof V == "number" ? V : { top: 0, right: 0, bottom: 0, left: 0, ...V }, E = Array.isArray(a) ? a : [a], I = E.length > 0, R = {
      padding: O,
      boundary: E.filter(Ipe),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: I
    }, { refs: H, floatingStyles: W, placement: B, isPositioned: L, middlewareData: z } = oY({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: N,
      whileElementsMounted: (...we) => uY(...we, {
        animationFrame: X === "always"
      }),
      elements: {
        reference: f.anchor
      },
      middleware: [
        dY({ mainAxis: n + S, alignmentAxis: u }),
        d && aY({
          mainAxis: !0,
          crossAxis: !1,
          limiter: c === "partial" ? VY() : void 0,
          ...R
        }),
        d && lY({ ...R }),
        cY({
          ...R,
          apply: ({ elements: we, rects: oe, availableWidth: tr, availableHeight: ar }) => {
            const { width: or, height: bt } = oe.reference, Tr = we.floating.style;
            Tr.setProperty("--radix-popper-available-width", `${tr}px`), Tr.setProperty("--radix-popper-available-height", `${ar}px`), Tr.setProperty("--radix-popper-anchor-width", `${or}px`), Tr.setProperty("--radix-popper-anchor-height", `${bt}px`);
          }
        }),
        y && xY({ element: y, padding: o }),
        Lpe({ arrowWidth: w, arrowHeight: S }),
        F && FY({ strategy: "referenceHidden", ...R })
      ]
    }), [Z, le] = BH(B), te = Ee(Y);
    ze(() => {
      L && (te == null || te());
    }, [L, te]);
    const U = (qe = z.arrow) == null ? void 0 : qe.x, de = (me = z.arrow) == null ? void 0 : me.y, Ke = ((ne = z.arrow) == null ? void 0 : ne.centerOffset) !== 0, [xe, be] = h.useState();
    return ze(() => {
      p && be(window.getComputedStyle(p).zIndex);
    }, [p]), /* @__PURE__ */ l(
      "div",
      {
        ref: H.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...W,
          transform: L ? W.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: xe,
          "--radix-popper-transform-origin": [
            (fe = z.transformOrigin) == null ? void 0 : fe.x,
            (Ye = z.transformOrigin) == null ? void 0 : Ye.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Q = z.hide) == null ? void 0 : Q.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ l(
          Ope,
          {
            scope: t,
            placedSide: Z,
            onArrowChange: b,
            arrowX: U,
            arrowY: de,
            shouldHideArrow: Ke,
            children: /* @__PURE__ */ l(
              $i.div,
              {
                "data-side": Z,
                "data-align": le,
                ...q,
                ref: g,
                style: {
                  ...q.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: L ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
HH.displayName = k3;
var jH = "PopperArrow", Rpe = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, zH = h.forwardRef(function(r, t) {
  const { __scopePopper: i, ...n } = r, s = Dpe(jH, i), u = Rpe[s.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ l(
      "span",
      {
        ref: s.onArrowChange,
        style: {
          position: "absolute",
          left: s.arrowX,
          top: s.arrowY,
          [u]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[s.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[s.placedSide],
          visibility: s.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ l(
          Epe,
          {
            ...n,
            ref: t,
            style: {
              ...n.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
zH.displayName = jH;
function Ipe(e) {
  return e !== null;
}
var Lpe = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(r) {
    var f, p, m;
    const { placement: t, rects: i, middlewareData: n } = r, u = ((f = n.arrow) == null ? void 0 : f.centerOffset) !== 0, o = u ? 0 : e.arrowWidth, d = u ? 0 : e.arrowHeight, [a, V] = BH(t), c = { start: "0%", center: "50%", end: "100%" }[V], F = (((p = n.arrow) == null ? void 0 : p.x) ?? 0) + o / 2, X = (((m = n.arrow) == null ? void 0 : m.y) ?? 0) + d / 2;
    let Y = "", q = "";
    return a === "bottom" ? (Y = u ? c : `${F}px`, q = `${-d}px`) : a === "top" ? (Y = u ? c : `${F}px`, q = `${i.floating.height + d}px`) : a === "right" ? (Y = `${-d}px`, q = u ? c : `${X}px`) : a === "left" && (Y = `${i.floating.width + d}px`, q = u ? c : `${X}px`), { data: { x: Y, y: q } };
  }
});
function BH(e) {
  const [r, t = "center"] = e.split("-");
  return [r, t];
}
var WH = IH, _pe = _H, Hpe = HH, jpe = zH, zpe = "Portal", GH = h.forwardRef((e, r) => {
  var o;
  const { container: t, ...i } = e, [n, s] = h.useState(!1);
  ze(() => s(!0), []);
  const u = t || n && ((o = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : o.body);
  return u ? Us.createPortal(/* @__PURE__ */ l($i.div, { ...i, ref: r }), u) : null;
});
GH.displayName = zpe;
function Bpe(e, r) {
  return h.useReducer((t, i) => r[t][i] ?? t, e);
}
var Y2 = (e) => {
  const { present: r, children: t } = e, i = Wpe(r), n = typeof t == "function" ? t({ present: i.isPresent }) : h.Children.only(t), s = Wi(i.ref, Gpe(n));
  return typeof t == "function" || i.isPresent ? h.cloneElement(n, { ref: s }) : null;
};
Y2.displayName = "Presence";
function Wpe(e) {
  const [r, t] = h.useState(), i = h.useRef({}), n = h.useRef(e), s = h.useRef("none"), u = e ? "mounted" : "unmounted", [o, d] = Bpe(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return h.useEffect(() => {
    const a = QF(i.current);
    s.current = o === "mounted" ? a : "none";
  }, [o]), ze(() => {
    const a = i.current, V = n.current;
    if (V !== e) {
      const F = s.current, X = QF(a);
      e ? d("MOUNT") : X === "none" || (a == null ? void 0 : a.display) === "none" ? d("UNMOUNT") : d(V && F !== X ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, d]), ze(() => {
    if (r) {
      let a;
      const V = r.ownerDocument.defaultView ?? window, c = (X) => {
        const q = QF(i.current).includes(X.animationName);
        if (X.target === r && q && (d("ANIMATION_END"), !n.current)) {
          const f = r.style.animationFillMode;
          r.style.animationFillMode = "forwards", a = V.setTimeout(() => {
            r.style.animationFillMode === "forwards" && (r.style.animationFillMode = f);
          });
        }
      }, F = (X) => {
        X.target === r && (s.current = QF(i.current));
      };
      return r.addEventListener("animationstart", F), r.addEventListener("animationcancel", c), r.addEventListener("animationend", c), () => {
        V.clearTimeout(a), r.removeEventListener("animationstart", F), r.removeEventListener("animationcancel", c), r.removeEventListener("animationend", c);
      };
    } else
      d("ANIMATION_END");
  }, [r, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: h.useCallback((a) => {
      a && (i.current = getComputedStyle(a)), t(a);
    }, [])
  };
}
function QF(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Gpe(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var dp = "rovingFocusGroup.onEntryFocus", Upe = { bubbles: !1, cancelable: !0 }, wY = "RovingFocusGroup", [jv, UH, Zpe] = CH(wY), [Jpe, ZH] = AY(
  wY,
  [Zpe]
), [$pe, Qpe] = Jpe(wY), JH = h.forwardRef(
  (e, r) => /* @__PURE__ */ l(jv.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ l(jv.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ l(e0e, { ...e, ref: r }) }) })
);
JH.displayName = wY;
var e0e = h.forwardRef((e, r) => {
  const {
    __scopeRovingFocusGroup: t,
    orientation: i,
    loop: n = !1,
    dir: s,
    currentTabStopId: u,
    defaultCurrentTabStopId: o,
    onCurrentTabStopIdChange: d,
    onEntryFocus: a,
    preventScrollOnEntryFocus: V = !1,
    ...c
  } = e, F = h.useRef(null), X = Wi(r, F), Y = Rn(s), [q = null, f] = Gr({
    prop: u,
    defaultProp: o,
    onChange: d
  }), [p, m] = h.useState(!1), g = Ee(a), y = UH(t), b = h.useRef(!1), [A, w] = h.useState(0);
  return h.useEffect(() => {
    const S = F.current;
    if (S)
      return S.addEventListener(dp, g), () => S.removeEventListener(dp, g);
  }, [g]), /* @__PURE__ */ l(
    $pe,
    {
      scope: t,
      orientation: i,
      dir: Y,
      loop: n,
      currentTabStopId: q,
      onItemFocus: h.useCallback(
        (S) => f(S),
        [f]
      ),
      onItemShiftTab: h.useCallback(() => m(!0), []),
      onFocusableItemAdd: h.useCallback(
        () => w((S) => S + 1),
        []
      ),
      onFocusableItemRemove: h.useCallback(
        () => w((S) => S - 1),
        []
      ),
      children: /* @__PURE__ */ l(
        $i.div,
        {
          tabIndex: p || A === 0 ? -1 : 0,
          "data-orientation": i,
          ...c,
          ref: X,
          style: { outline: "none", ...e.style },
          onMouseDown: Ar(e.onMouseDown, () => {
            b.current = !0;
          }),
          onFocus: Ar(e.onFocus, (S) => {
            const N = !b.current;
            if (S.target === S.currentTarget && N && !p) {
              const O = new CustomEvent(dp, Upe);
              if (S.currentTarget.dispatchEvent(O), !O.defaultPrevented) {
                const E = y().filter((B) => B.focusable), I = E.find((B) => B.active), R = E.find((B) => B.id === q), W = [I, R, ...E].filter(
                  Boolean
                ).map((B) => B.ref.current);
                ej(W, V);
              }
            }
            b.current = !1;
          }),
          onBlur: Ar(e.onBlur, () => m(!1))
        }
      )
    }
  );
}), $H = "RovingFocusGroupItem", QH = h.forwardRef(
  (e, r) => {
    const {
      __scopeRovingFocusGroup: t,
      focusable: i = !0,
      active: n = !1,
      tabStopId: s,
      ...u
    } = e, o = ot(), d = s || o, a = Qpe($H, t), V = a.currentTabStopId === d, c = UH(t), { onFocusableItemAdd: F, onFocusableItemRemove: X } = a;
    return h.useEffect(() => {
      if (i)
        return F(), () => X();
    }, [i, F, X]), /* @__PURE__ */ l(
      jv.ItemSlot,
      {
        scope: t,
        id: d,
        focusable: i,
        active: n,
        children: /* @__PURE__ */ l(
          $i.span,
          {
            tabIndex: V ? 0 : -1,
            "data-orientation": a.orientation,
            ...u,
            ref: r,
            onMouseDown: Ar(e.onMouseDown, (Y) => {
              i ? a.onItemFocus(d) : Y.preventDefault();
            }),
            onFocus: Ar(e.onFocus, () => a.onItemFocus(d)),
            onKeyDown: Ar(e.onKeyDown, (Y) => {
              if (Y.key === "Tab" && Y.shiftKey) {
                a.onItemShiftTab();
                return;
              }
              if (Y.target !== Y.currentTarget) return;
              const q = i0e(Y, a.orientation, a.dir);
              if (q !== void 0) {
                if (Y.metaKey || Y.ctrlKey || Y.altKey || Y.shiftKey) return;
                Y.preventDefault();
                let p = c().filter((m) => m.focusable).map((m) => m.ref.current);
                if (q === "last") p.reverse();
                else if (q === "prev" || q === "next") {
                  q === "prev" && p.reverse();
                  const m = p.indexOf(Y.currentTarget);
                  p = a.loop ? n0e(p, m + 1) : p.slice(m + 1);
                }
                setTimeout(() => ej(p));
              }
            })
          }
        )
      }
    );
  }
);
QH.displayName = $H;
var r0e = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function t0e(e, r) {
  return r !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function i0e(e, r, t) {
  const i = t0e(e.key, t);
  if (!(r === "vertical" && ["ArrowLeft", "ArrowRight"].includes(i)) && !(r === "horizontal" && ["ArrowUp", "ArrowDown"].includes(i)))
    return r0e[i];
}
function ej(e, r = !1) {
  const t = document.activeElement;
  for (const i of e)
    if (i === t || (i.focus({ preventScroll: r }), document.activeElement !== t)) return;
}
function n0e(e, r) {
  return e.map((t, i) => e[(r + i) % e.length]);
}
var s0e = JH, u0e = QH, Dx = "right-scroll-bar-position", Rx = "width-before-scroll-bar", o0e = "with-scroll-bars-hidden", d0e = "--removed-body-scroll-bar-size";
function ap(e, r) {
  return typeof e == "function" ? e(r) : e && (e.current = r), e;
}
function a0e(e, r) {
  var t = ie(function() {
    return {
      // value
      value: e,
      // last callback
      callback: r,
      // "memoized" public interface
      facade: {
        get current() {
          return t.value;
        },
        set current(i) {
          var n = t.value;
          n !== i && (t.value = i, t.callback(i, n));
        }
      }
    };
  })[0];
  return t.callback = r, t.facade;
}
var V0e = typeof window < "u" ? h.useLayoutEffect : h.useEffect, vC = /* @__PURE__ */ new WeakMap();
function l0e(e, r) {
  var t = a0e(null, function(i) {
    return e.forEach(function(n) {
      return ap(n, i);
    });
  });
  return V0e(function() {
    var i = vC.get(t);
    if (i) {
      var n = new Set(i), s = new Set(e), u = t.current;
      n.forEach(function(o) {
        s.has(o) || ap(o, null);
      }), s.forEach(function(o) {
        n.has(o) || ap(o, u);
      });
    }
    vC.set(t, e);
  }, [e]), t;
}
function c0e(e) {
  return e;
}
function F0e(e, r) {
  r === void 0 && (r = c0e);
  var t = [], i = !1, n = {
    read: function() {
      if (i)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return t.length ? t[t.length - 1] : e;
    },
    useMedium: function(s) {
      var u = r(s, i);
      return t.push(u), function() {
        t = t.filter(function(o) {
          return o !== u;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (i = !0; t.length; ) {
        var u = t;
        t = [], u.forEach(s);
      }
      t = {
        push: function(o) {
          return s(o);
        },
        filter: function() {
          return t;
        }
      };
    },
    assignMedium: function(s) {
      i = !0;
      var u = [];
      if (t.length) {
        var o = t;
        t = [], o.forEach(s), u = t;
      }
      var d = function() {
        var V = u;
        u = [], V.forEach(s);
      }, a = function() {
        return Promise.resolve().then(d);
      };
      a(), t = {
        push: function(V) {
          u.push(V), a();
        },
        filter: function(V) {
          return u = u.filter(V), t;
        }
      };
    }
  };
  return n;
}
function x0e(e) {
  e === void 0 && (e = {});
  var r = F0e(null);
  return r.options = Ge({ async: !0, ssr: !1 }, e), r;
}
var rj = function(e) {
  var r = e.sideCar, t = $s(e, ["sideCar"]);
  if (!r)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var i = r.read();
  if (!i)
    throw new Error("Sidecar medium not found");
  return h.createElement(i, Ge({}, t));
};
rj.isSideCarExport = !0;
function X0e(e, r) {
  return e.useMedium(r), rj;
}
var tj = x0e(), Vp = function() {
}, CY = h.forwardRef(function(e, r) {
  var t = h.useRef(null), i = h.useState({
    onScrollCapture: Vp,
    onWheelCapture: Vp,
    onTouchMoveCapture: Vp
  }), n = i[0], s = i[1], u = e.forwardProps, o = e.children, d = e.className, a = e.removeScrollBar, V = e.enabled, c = e.shards, F = e.sideCar, X = e.noIsolation, Y = e.inert, q = e.allowPinchZoom, f = e.as, p = f === void 0 ? "div" : f, m = e.gapMode, g = $s(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), y = F, b = l0e([t, r]), A = Ge(Ge({}, g), n);
  return h.createElement(
    h.Fragment,
    null,
    V && h.createElement(y, { sideCar: tj, removeScrollBar: a, shards: c, noIsolation: X, inert: Y, setCallbacks: s, allowPinchZoom: !!q, lockRef: t, gapMode: m }),
    u ? h.cloneElement(h.Children.only(o), Ge(Ge({}, A), { ref: b })) : h.createElement(p, Ge({}, A, { className: d, ref: b }), o)
  );
});
CY.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
CY.classNames = {
  fullWidth: Rx,
  zeroRight: Dx
};
function q0e() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var r = Gq();
  return r && e.setAttribute("nonce", r), e;
}
function Y0e(e, r) {
  e.styleSheet ? e.styleSheet.cssText = r : e.appendChild(document.createTextNode(r));
}
function f0e(e) {
  var r = document.head || document.getElementsByTagName("head")[0];
  r.appendChild(e);
}
var K0e = function() {
  var e = 0, r = null;
  return {
    add: function(t) {
      e == 0 && (r = q0e()) && (Y0e(r, t), f0e(r)), e++;
    },
    remove: function() {
      e--, !e && r && (r.parentNode && r.parentNode.removeChild(r), r = null);
    }
  };
}, h0e = function() {
  var e = K0e();
  return function(r, t) {
    h.useEffect(function() {
      return e.add(r), function() {
        e.remove();
      };
    }, [r && t]);
  };
}, ij = function() {
  var e = h0e(), r = function(t) {
    var i = t.styles, n = t.dynamic;
    return e(i, n), null;
  };
  return r;
}, p0e = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, lp = function(e) {
  return parseInt(e || "", 10) || 0;
}, m0e = function(e) {
  var r = window.getComputedStyle(document.body), t = r[e === "padding" ? "paddingLeft" : "marginLeft"], i = r[e === "padding" ? "paddingTop" : "marginTop"], n = r[e === "padding" ? "paddingRight" : "marginRight"];
  return [lp(t), lp(i), lp(n)];
}, g0e = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return p0e;
  var r = m0e(e), t = document.documentElement.clientWidth, i = window.innerWidth;
  return {
    left: r[0],
    top: r[1],
    right: r[2],
    gap: Math.max(0, i - t + r[2] - r[0])
  };
}, v0e = ij(), XV = "data-scroll-locked", b0e = function(e, r, t, i) {
  var n = e.left, s = e.top, u = e.right, o = e.gap;
  return t === void 0 && (t = "margin"), `
  .`.concat(o0e, ` {
   overflow: hidden `).concat(i, `;
   padding-right: `).concat(o, "px ").concat(i, `;
  }
  body[`).concat(XV, `] {
    overflow: hidden `).concat(i, `;
    overscroll-behavior: contain;
    `).concat([
    r && "position: relative ".concat(i, ";"),
    t === "margin" && `
    padding-left: `.concat(n, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(u, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(o, "px ").concat(i, `;
    `),
    t === "padding" && "padding-right: ".concat(o, "px ").concat(i, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Dx, ` {
    right: `).concat(o, "px ").concat(i, `;
  }
  
  .`).concat(Rx, ` {
    margin-right: `).concat(o, "px ").concat(i, `;
  }
  
  .`).concat(Dx, " .").concat(Dx, ` {
    right: 0 `).concat(i, `;
  }
  
  .`).concat(Rx, " .").concat(Rx, ` {
    margin-right: 0 `).concat(i, `;
  }
  
  body[`).concat(XV, `] {
    `).concat(d0e, ": ").concat(o, `px;
  }
`);
}, bC = function() {
  var e = parseInt(document.body.getAttribute(XV) || "0", 10);
  return isFinite(e) ? e : 0;
}, y0e = function() {
  h.useEffect(function() {
    return document.body.setAttribute(XV, (bC() + 1).toString()), function() {
      var e = bC() - 1;
      e <= 0 ? document.body.removeAttribute(XV) : document.body.setAttribute(XV, e.toString());
    };
  }, []);
}, A0e = function(e) {
  var r = e.noRelative, t = e.noImportant, i = e.gapMode, n = i === void 0 ? "margin" : i;
  y0e();
  var s = h.useMemo(function() {
    return g0e(n);
  }, [n]);
  return h.createElement(v0e, { styles: b0e(s, !r, n, t ? "" : "!important") });
}, zv = !1;
if (typeof window < "u")
  try {
    var ex = Object.defineProperty({}, "passive", {
      get: function() {
        return zv = !0, !0;
      }
    });
    window.addEventListener("test", ex, ex), window.removeEventListener("test", ex, ex);
  } catch {
    zv = !1;
  }
var Ha = zv ? { passive: !1 } : !1, w0e = function(e) {
  return e.tagName === "TEXTAREA";
}, nj = function(e, r) {
  if (!(e instanceof Element))
    return !1;
  var t = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    t[r] !== "hidden" && // contains scroll inside self
    !(t.overflowY === t.overflowX && !w0e(e) && t[r] === "visible")
  );
}, C0e = function(e) {
  return nj(e, "overflowY");
}, P0e = function(e) {
  return nj(e, "overflowX");
}, yC = function(e, r) {
  var t = r.ownerDocument, i = r;
  do {
    typeof ShadowRoot < "u" && i instanceof ShadowRoot && (i = i.host);
    var n = sj(e, i);
    if (n) {
      var s = uj(e, i), u = s[1], o = s[2];
      if (u > o)
        return !0;
    }
    i = i.parentNode;
  } while (i && i !== t.body);
  return !1;
}, S0e = function(e) {
  var r = e.scrollTop, t = e.scrollHeight, i = e.clientHeight;
  return [
    r,
    t,
    i
  ];
}, N0e = function(e) {
  var r = e.scrollLeft, t = e.scrollWidth, i = e.clientWidth;
  return [
    r,
    t,
    i
  ];
}, sj = function(e, r) {
  return e === "v" ? C0e(r) : P0e(r);
}, uj = function(e, r) {
  return e === "v" ? S0e(r) : N0e(r);
}, M0e = function(e, r) {
  return e === "h" && r === "rtl" ? -1 : 1;
}, T0e = function(e, r, t, i, n) {
  var s = M0e(e, window.getComputedStyle(r).direction), u = s * i, o = t.target, d = r.contains(o), a = !1, V = u > 0, c = 0, F = 0;
  do {
    var X = uj(e, o), Y = X[0], q = X[1], f = X[2], p = q - f - s * Y;
    (Y || p) && sj(e, o) && (c += p, F += Y), o instanceof ShadowRoot ? o = o.host : o = o.parentNode;
  } while (
    // portaled content
    !d && o !== document.body || // self content
    d && (r.contains(o) || r === o)
  );
  return (V && Math.abs(c) < 1 || !V && Math.abs(F) < 1) && (a = !0), a;
}, rx = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, AC = function(e) {
  return [e.deltaX, e.deltaY];
}, wC = function(e) {
  return e && "current" in e ? e.current : e;
}, E0e = function(e, r) {
  return e[0] === r[0] && e[1] === r[1];
}, k0e = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, O0e = 0, ja = [];
function D0e(e) {
  var r = h.useRef([]), t = h.useRef([0, 0]), i = h.useRef(), n = h.useState(O0e++)[0], s = h.useState(ij)[0], u = h.useRef(e);
  h.useEffect(function() {
    u.current = e;
  }, [e]), h.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(n));
      var q = Yl([e.lockRef.current], (e.shards || []).map(wC), !0).filter(Boolean);
      return q.forEach(function(f) {
        return f.classList.add("allow-interactivity-".concat(n));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(n)), q.forEach(function(f) {
          return f.classList.remove("allow-interactivity-".concat(n));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var o = h.useCallback(function(q, f) {
    if ("touches" in q && q.touches.length === 2 || q.type === "wheel" && q.ctrlKey)
      return !u.current.allowPinchZoom;
    var p = rx(q), m = t.current, g = "deltaX" in q ? q.deltaX : m[0] - p[0], y = "deltaY" in q ? q.deltaY : m[1] - p[1], b, A = q.target, w = Math.abs(g) > Math.abs(y) ? "h" : "v";
    if ("touches" in q && w === "h" && A.type === "range")
      return !1;
    var S = yC(w, A);
    if (!S)
      return !0;
    if (S ? b = w : (b = w === "v" ? "h" : "v", S = yC(w, A)), !S)
      return !1;
    if (!i.current && "changedTouches" in q && (g || y) && (i.current = b), !b)
      return !0;
    var N = i.current || b;
    return T0e(N, f, q, N === "h" ? g : y);
  }, []), d = h.useCallback(function(q) {
    var f = q;
    if (!(!ja.length || ja[ja.length - 1] !== s)) {
      var p = "deltaY" in f ? AC(f) : rx(f), m = r.current.filter(function(b) {
        return b.name === f.type && (b.target === f.target || f.target === b.shadowParent) && E0e(b.delta, p);
      })[0];
      if (m && m.should) {
        f.cancelable && f.preventDefault();
        return;
      }
      if (!m) {
        var g = (u.current.shards || []).map(wC).filter(Boolean).filter(function(b) {
          return b.contains(f.target);
        }), y = g.length > 0 ? o(f, g[0]) : !u.current.noIsolation;
        y && f.cancelable && f.preventDefault();
      }
    }
  }, []), a = h.useCallback(function(q, f, p, m) {
    var g = { name: q, delta: f, target: p, should: m, shadowParent: R0e(p) };
    r.current.push(g), setTimeout(function() {
      r.current = r.current.filter(function(y) {
        return y !== g;
      });
    }, 1);
  }, []), V = h.useCallback(function(q) {
    t.current = rx(q), i.current = void 0;
  }, []), c = h.useCallback(function(q) {
    a(q.type, AC(q), q.target, o(q, e.lockRef.current));
  }, []), F = h.useCallback(function(q) {
    a(q.type, rx(q), q.target, o(q, e.lockRef.current));
  }, []);
  h.useEffect(function() {
    return ja.push(s), e.setCallbacks({
      onScrollCapture: c,
      onWheelCapture: c,
      onTouchMoveCapture: F
    }), document.addEventListener("wheel", d, Ha), document.addEventListener("touchmove", d, Ha), document.addEventListener("touchstart", V, Ha), function() {
      ja = ja.filter(function(q) {
        return q !== s;
      }), document.removeEventListener("wheel", d, Ha), document.removeEventListener("touchmove", d, Ha), document.removeEventListener("touchstart", V, Ha);
    };
  }, []);
  var X = e.removeScrollBar, Y = e.inert;
  return h.createElement(
    h.Fragment,
    null,
    Y ? h.createElement(s, { styles: k0e(n) }) : null,
    X ? h.createElement(A0e, { gapMode: e.gapMode }) : null
  );
}
function R0e(e) {
  for (var r = null; e !== null; )
    e instanceof ShadowRoot && (r = e.host, e = e.host), e = e.parentNode;
  return r;
}
const I0e = X0e(tj, D0e);
var oj = h.forwardRef(function(e, r) {
  return h.createElement(CY, Ge({}, e, { ref: r, sideCar: I0e }));
});
oj.classNames = CY.classNames;
var Bv = ["Enter", " "], L0e = ["ArrowDown", "PageUp", "Home"], dj = ["ArrowUp", "PageDown", "End"], _0e = [...L0e, ...dj], H0e = {
  ltr: [...Bv, "ArrowRight"],
  rtl: [...Bv, "ArrowLeft"]
}, j0e = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, f2 = "Menu", [e7, z0e, B0e] = CH(f2), [Va, aj] = AY(f2, [
  B0e,
  DH,
  ZH
]), K2 = DH(), Vj = ZH(), [lj, Uo] = Va(f2), [W0e, h2] = Va(f2), cj = (e) => {
  const { __scopeMenu: r, open: t = !1, children: i, dir: n, onOpenChange: s, modal: u = !0 } = e, o = K2(r), [d, a] = h.useState(null), V = h.useRef(!1), c = Ee(s), F = Rn(n);
  return h.useEffect(() => {
    const X = () => {
      V.current = !0, document.addEventListener("pointerdown", Y, { capture: !0, once: !0 }), document.addEventListener("pointermove", Y, { capture: !0, once: !0 });
    }, Y = () => V.current = !1;
    return document.addEventListener("keydown", X, { capture: !0 }), () => {
      document.removeEventListener("keydown", X, { capture: !0 }), document.removeEventListener("pointerdown", Y, { capture: !0 }), document.removeEventListener("pointermove", Y, { capture: !0 });
    };
  }, []), /* @__PURE__ */ l(WH, { ...o, children: /* @__PURE__ */ l(
    lj,
    {
      scope: r,
      open: t,
      onOpenChange: c,
      content: d,
      onContentChange: a,
      children: /* @__PURE__ */ l(
        W0e,
        {
          scope: r,
          onClose: h.useCallback(() => c(!1), [c]),
          isUsingKeyboardRef: V,
          dir: F,
          modal: u,
          children: i
        }
      )
    }
  ) });
};
cj.displayName = f2;
var G0e = "MenuAnchor", O3 = h.forwardRef(
  (e, r) => {
    const { __scopeMenu: t, ...i } = e, n = K2(t);
    return /* @__PURE__ */ l(_pe, { ...n, ...i, ref: r });
  }
);
O3.displayName = G0e;
var D3 = "MenuPortal", [U0e, Fj] = Va(D3, {
  forceMount: void 0
}), xj = (e) => {
  const { __scopeMenu: r, forceMount: t, children: i, container: n } = e, s = Uo(D3, r);
  return /* @__PURE__ */ l(U0e, { scope: r, forceMount: t, children: /* @__PURE__ */ l(Y2, { present: t || s.open, children: /* @__PURE__ */ l(GH, { asChild: !0, container: n, children: i }) }) });
};
xj.displayName = D3;
var Nn = "MenuContent", [Z0e, R3] = Va(Nn), Xj = h.forwardRef(
  (e, r) => {
    const t = Fj(Nn, e.__scopeMenu), { forceMount: i = t.forceMount, ...n } = e, s = Uo(Nn, e.__scopeMenu), u = h2(Nn, e.__scopeMenu);
    return /* @__PURE__ */ l(e7.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ l(Y2, { present: i || s.open, children: /* @__PURE__ */ l(e7.Slot, { scope: e.__scopeMenu, children: u.modal ? /* @__PURE__ */ l(J0e, { ...n, ref: r }) : /* @__PURE__ */ l($0e, { ...n, ref: r }) }) }) });
  }
), J0e = h.forwardRef(
  (e, r) => {
    const t = Uo(Nn, e.__scopeMenu), i = h.useRef(null), n = Wi(r, i);
    return h.useEffect(() => {
      const s = i.current;
      if (s) return fl(s);
    }, []), /* @__PURE__ */ l(
      I3,
      {
        ...e,
        ref: n,
        trapFocus: t.open,
        disableOutsidePointerEvents: t.open,
        disableOutsideScroll: !0,
        onFocusOutside: Ar(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => t.onOpenChange(!1)
      }
    );
  }
), $0e = h.forwardRef((e, r) => {
  const t = Uo(Nn, e.__scopeMenu);
  return /* @__PURE__ */ l(
    I3,
    {
      ...e,
      ref: r,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => t.onOpenChange(!1)
    }
  );
}), I3 = h.forwardRef(
  (e, r) => {
    const {
      __scopeMenu: t,
      loop: i = !1,
      trapFocus: n,
      onOpenAutoFocus: s,
      onCloseAutoFocus: u,
      disableOutsidePointerEvents: o,
      onEntryFocus: d,
      onEscapeKeyDown: a,
      onPointerDownOutside: V,
      onFocusOutside: c,
      onInteractOutside: F,
      onDismiss: X,
      disableOutsideScroll: Y,
      ...q
    } = e, f = Uo(Nn, t), p = h2(Nn, t), m = K2(t), g = Vj(t), y = z0e(t), [b, A] = h.useState(null), w = h.useRef(null), S = Wi(r, w, f.onContentChange), N = h.useRef(0), O = h.useRef(""), E = h.useRef(0), I = h.useRef(null), R = h.useRef("right"), H = h.useRef(0), W = Y ? oj : h.Fragment, B = Y ? { as: Qc, allowPinchZoom: !0 } : void 0, L = (Z) => {
      var qe, me;
      const le = O.current + Z, te = y().filter((ne) => !ne.disabled), U = document.activeElement, de = (qe = te.find((ne) => ne.ref.current === U)) == null ? void 0 : qe.textValue, Ke = te.map((ne) => ne.textValue), xe = V1e(Ke, le, de), be = (me = te.find((ne) => ne.textValue === xe)) == null ? void 0 : me.ref.current;
      (function ne(fe) {
        O.current = fe, window.clearTimeout(N.current), fe !== "" && (N.current = window.setTimeout(() => ne(""), 1e3));
      })(le), be && setTimeout(() => be.focus());
    };
    h.useEffect(() => () => window.clearTimeout(N.current), []), Iy();
    const z = h.useCallback((Z) => {
      var te, U;
      return R.current === ((te = I.current) == null ? void 0 : te.side) && c1e(Z, (U = I.current) == null ? void 0 : U.area);
    }, []);
    return /* @__PURE__ */ l(
      Z0e,
      {
        scope: t,
        searchRef: O,
        onItemEnter: h.useCallback(
          (Z) => {
            z(Z) && Z.preventDefault();
          },
          [z]
        ),
        onItemLeave: h.useCallback(
          (Z) => {
            var le;
            z(Z) || ((le = w.current) == null || le.focus(), A(null));
          },
          [z]
        ),
        onTriggerLeave: h.useCallback(
          (Z) => {
            z(Z) && Z.preventDefault();
          },
          [z]
        ),
        pointerGraceTimerRef: E,
        onPointerGraceIntentChange: h.useCallback((Z) => {
          I.current = Z;
        }, []),
        children: /* @__PURE__ */ l(W, { ...B, children: /* @__PURE__ */ l(
          TH,
          {
            asChild: !0,
            trapped: n,
            onMountAutoFocus: Ar(s, (Z) => {
              var le;
              Z.preventDefault(), (le = w.current) == null || le.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: u,
            children: /* @__PURE__ */ l(
              NH,
              {
                asChild: !0,
                disableOutsidePointerEvents: o,
                onEscapeKeyDown: a,
                onPointerDownOutside: V,
                onFocusOutside: c,
                onInteractOutside: F,
                onDismiss: X,
                children: /* @__PURE__ */ l(
                  s0e,
                  {
                    asChild: !0,
                    ...g,
                    dir: p.dir,
                    orientation: "vertical",
                    loop: i,
                    currentTabStopId: b,
                    onCurrentTabStopIdChange: A,
                    onEntryFocus: Ar(d, (Z) => {
                      p.isUsingKeyboardRef.current || Z.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ l(
                      Hpe,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Nj(f.open),
                        "data-radix-menu-content": "",
                        dir: p.dir,
                        ...m,
                        ...q,
                        ref: S,
                        style: { outline: "none", ...q.style },
                        onKeyDown: Ar(q.onKeyDown, (Z) => {
                          const te = Z.target.closest("[data-radix-menu-content]") === Z.currentTarget, U = Z.ctrlKey || Z.altKey || Z.metaKey, de = Z.key.length === 1;
                          te && (Z.key === "Tab" && Z.preventDefault(), !U && de && L(Z.key));
                          const Ke = w.current;
                          if (Z.target !== Ke || !_0e.includes(Z.key)) return;
                          Z.preventDefault();
                          const be = y().filter((qe) => !qe.disabled).map((qe) => qe.ref.current);
                          dj.includes(Z.key) && be.reverse(), d1e(be);
                        }),
                        onBlur: Ar(e.onBlur, (Z) => {
                          Z.currentTarget.contains(Z.target) || (window.clearTimeout(N.current), O.current = "");
                        }),
                        onPointerMove: Ar(
                          e.onPointerMove,
                          r7((Z) => {
                            const le = Z.target, te = H.current !== Z.clientX;
                            if (Z.currentTarget.contains(le) && te) {
                              const U = Z.clientX > H.current ? "right" : "left";
                              R.current = U, H.current = Z.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Xj.displayName = Nn;
var Q0e = "MenuGroup", L3 = h.forwardRef(
  (e, r) => {
    const { __scopeMenu: t, ...i } = e;
    return /* @__PURE__ */ l($i.div, { role: "group", ...i, ref: r });
  }
);
L3.displayName = Q0e;
var e1e = "MenuLabel", qj = h.forwardRef(
  (e, r) => {
    const { __scopeMenu: t, ...i } = e;
    return /* @__PURE__ */ l($i.div, { ...i, ref: r });
  }
);
qj.displayName = e1e;
var oX = "MenuItem", CC = "menu.itemSelect", PY = h.forwardRef(
  (e, r) => {
    const { disabled: t = !1, onSelect: i, ...n } = e, s = h.useRef(null), u = h2(oX, e.__scopeMenu), o = R3(oX, e.__scopeMenu), d = Wi(r, s), a = h.useRef(!1), V = () => {
      const c = s.current;
      if (!t && c) {
        const F = new CustomEvent(CC, { bubbles: !0, cancelable: !0 });
        c.addEventListener(CC, (X) => i == null ? void 0 : i(X), { once: !0 }), PH(c, F), F.defaultPrevented ? a.current = !1 : u.onClose();
      }
    };
    return /* @__PURE__ */ l(
      Yj,
      {
        ...n,
        ref: d,
        disabled: t,
        onClick: Ar(e.onClick, V),
        onPointerDown: (c) => {
          var F;
          (F = e.onPointerDown) == null || F.call(e, c), a.current = !0;
        },
        onPointerUp: Ar(e.onPointerUp, (c) => {
          var F;
          a.current || (F = c.currentTarget) == null || F.click();
        }),
        onKeyDown: Ar(e.onKeyDown, (c) => {
          const F = o.searchRef.current !== "";
          t || F && c.key === " " || Bv.includes(c.key) && (c.currentTarget.click(), c.preventDefault());
        })
      }
    );
  }
);
PY.displayName = oX;
var Yj = h.forwardRef(
  (e, r) => {
    const { __scopeMenu: t, disabled: i = !1, textValue: n, ...s } = e, u = R3(oX, t), o = Vj(t), d = h.useRef(null), a = Wi(r, d), [V, c] = h.useState(!1), [F, X] = h.useState("");
    return h.useEffect(() => {
      const Y = d.current;
      Y && X((Y.textContent ?? "").trim());
    }, [s.children]), /* @__PURE__ */ l(
      e7.ItemSlot,
      {
        scope: t,
        disabled: i,
        textValue: n ?? F,
        children: /* @__PURE__ */ l(u0e, { asChild: !0, ...o, focusable: !i, children: /* @__PURE__ */ l(
          $i.div,
          {
            role: "menuitem",
            "data-highlighted": V ? "" : void 0,
            "aria-disabled": i || void 0,
            "data-disabled": i ? "" : void 0,
            ...s,
            ref: a,
            onPointerMove: Ar(
              e.onPointerMove,
              r7((Y) => {
                i ? u.onItemLeave(Y) : (u.onItemEnter(Y), Y.defaultPrevented || Y.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: Ar(
              e.onPointerLeave,
              r7((Y) => u.onItemLeave(Y))
            ),
            onFocus: Ar(e.onFocus, () => c(!0)),
            onBlur: Ar(e.onBlur, () => c(!1))
          }
        ) })
      }
    );
  }
), r1e = "MenuCheckboxItem", fj = h.forwardRef(
  (e, r) => {
    const { checked: t = !1, onCheckedChange: i, ...n } = e;
    return /* @__PURE__ */ l(gj, { scope: e.__scopeMenu, checked: t, children: /* @__PURE__ */ l(
      PY,
      {
        role: "menuitemcheckbox",
        "aria-checked": dX(t) ? "mixed" : t,
        ...n,
        ref: r,
        "data-state": j3(t),
        onSelect: Ar(
          n.onSelect,
          () => i == null ? void 0 : i(dX(t) ? !0 : !t),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
fj.displayName = r1e;
var Kj = "MenuRadioGroup", [t1e, i1e] = Va(
  Kj,
  { value: void 0, onValueChange: () => {
  } }
), hj = h.forwardRef(
  (e, r) => {
    const { value: t, onValueChange: i, ...n } = e, s = Ee(i);
    return /* @__PURE__ */ l(t1e, { scope: e.__scopeMenu, value: t, onValueChange: s, children: /* @__PURE__ */ l(L3, { ...n, ref: r }) });
  }
);
hj.displayName = Kj;
var pj = "MenuRadioItem", mj = h.forwardRef(
  (e, r) => {
    const { value: t, ...i } = e, n = i1e(pj, e.__scopeMenu), s = t === n.value;
    return /* @__PURE__ */ l(gj, { scope: e.__scopeMenu, checked: s, children: /* @__PURE__ */ l(
      PY,
      {
        role: "menuitemradio",
        "aria-checked": s,
        ...i,
        ref: r,
        "data-state": j3(s),
        onSelect: Ar(
          i.onSelect,
          () => {
            var u;
            return (u = n.onValueChange) == null ? void 0 : u.call(n, t);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
mj.displayName = pj;
var _3 = "MenuItemIndicator", [gj, n1e] = Va(
  _3,
  { checked: !1 }
), vj = h.forwardRef(
  (e, r) => {
    const { __scopeMenu: t, forceMount: i, ...n } = e, s = n1e(_3, t);
    return /* @__PURE__ */ l(
      Y2,
      {
        present: i || dX(s.checked) || s.checked === !0,
        children: /* @__PURE__ */ l(
          $i.span,
          {
            ...n,
            ref: r,
            "data-state": j3(s.checked)
          }
        )
      }
    );
  }
);
vj.displayName = _3;
var s1e = "MenuSeparator", bj = h.forwardRef(
  (e, r) => {
    const { __scopeMenu: t, ...i } = e;
    return /* @__PURE__ */ l(
      $i.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...i,
        ref: r
      }
    );
  }
);
bj.displayName = s1e;
var u1e = "MenuArrow", yj = h.forwardRef(
  (e, r) => {
    const { __scopeMenu: t, ...i } = e, n = K2(t);
    return /* @__PURE__ */ l(jpe, { ...n, ...i, ref: r });
  }
);
yj.displayName = u1e;
var H3 = "MenuSub", [o1e, Aj] = Va(H3), wj = (e) => {
  const { __scopeMenu: r, children: t, open: i = !1, onOpenChange: n } = e, s = Uo(H3, r), u = K2(r), [o, d] = h.useState(null), [a, V] = h.useState(null), c = Ee(n);
  return h.useEffect(() => (s.open === !1 && c(!1), () => c(!1)), [s.open, c]), /* @__PURE__ */ l(WH, { ...u, children: /* @__PURE__ */ l(
    lj,
    {
      scope: r,
      open: i,
      onOpenChange: c,
      content: a,
      onContentChange: V,
      children: /* @__PURE__ */ l(
        o1e,
        {
          scope: r,
          contentId: ot(),
          triggerId: ot(),
          trigger: o,
          onTriggerChange: d,
          children: t
        }
      )
    }
  ) });
};
wj.displayName = H3;
var bc = "MenuSubTrigger", Cj = h.forwardRef(
  (e, r) => {
    const t = Uo(bc, e.__scopeMenu), i = h2(bc, e.__scopeMenu), n = Aj(bc, e.__scopeMenu), s = R3(bc, e.__scopeMenu), u = h.useRef(null), { pointerGraceTimerRef: o, onPointerGraceIntentChange: d } = s, a = { __scopeMenu: e.__scopeMenu }, V = h.useCallback(() => {
      u.current && window.clearTimeout(u.current), u.current = null;
    }, []);
    return h.useEffect(() => V, [V]), h.useEffect(() => {
      const c = o.current;
      return () => {
        window.clearTimeout(c), d(null);
      };
    }, [o, d]), /* @__PURE__ */ l(O3, { asChild: !0, ...a, children: /* @__PURE__ */ l(
      Yj,
      {
        id: n.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": t.open,
        "aria-controls": n.contentId,
        "data-state": Nj(t.open),
        ...e,
        ref: T3(r, n.onTriggerChange),
        onClick: (c) => {
          var F;
          (F = e.onClick) == null || F.call(e, c), !(e.disabled || c.defaultPrevented) && (c.currentTarget.focus(), t.open || t.onOpenChange(!0));
        },
        onPointerMove: Ar(
          e.onPointerMove,
          r7((c) => {
            s.onItemEnter(c), !c.defaultPrevented && !e.disabled && !t.open && !u.current && (s.onPointerGraceIntentChange(null), u.current = window.setTimeout(() => {
              t.onOpenChange(!0), V();
            }, 100));
          })
        ),
        onPointerLeave: Ar(
          e.onPointerLeave,
          r7((c) => {
            var X, Y;
            V();
            const F = (X = t.content) == null ? void 0 : X.getBoundingClientRect();
            if (F) {
              const q = (Y = t.content) == null ? void 0 : Y.dataset.side, f = q === "right", p = f ? -5 : 5, m = F[f ? "left" : "right"], g = F[f ? "right" : "left"];
              s.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: c.clientX + p, y: c.clientY },
                  { x: m, y: F.top },
                  { x: g, y: F.top },
                  { x: g, y: F.bottom },
                  { x: m, y: F.bottom }
                ],
                side: q
              }), window.clearTimeout(o.current), o.current = window.setTimeout(
                () => s.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (s.onTriggerLeave(c), c.defaultPrevented) return;
              s.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: Ar(e.onKeyDown, (c) => {
          var X;
          const F = s.searchRef.current !== "";
          e.disabled || F && c.key === " " || H0e[i.dir].includes(c.key) && (t.onOpenChange(!0), (X = t.content) == null || X.focus(), c.preventDefault());
        })
      }
    ) });
  }
);
Cj.displayName = bc;
var Pj = "MenuSubContent", Sj = h.forwardRef(
  (e, r) => {
    const t = Fj(Nn, e.__scopeMenu), { forceMount: i = t.forceMount, ...n } = e, s = Uo(Nn, e.__scopeMenu), u = h2(Nn, e.__scopeMenu), o = Aj(Pj, e.__scopeMenu), d = h.useRef(null), a = Wi(r, d);
    return /* @__PURE__ */ l(e7.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ l(Y2, { present: i || s.open, children: /* @__PURE__ */ l(e7.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ l(
      I3,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...n,
        ref: a,
        align: "start",
        side: u.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (V) => {
          var c;
          u.isUsingKeyboardRef.current && ((c = d.current) == null || c.focus()), V.preventDefault();
        },
        onCloseAutoFocus: (V) => V.preventDefault(),
        onFocusOutside: Ar(e.onFocusOutside, (V) => {
          V.target !== o.trigger && s.onOpenChange(!1);
        }),
        onEscapeKeyDown: Ar(e.onEscapeKeyDown, (V) => {
          u.onClose(), V.preventDefault();
        }),
        onKeyDown: Ar(e.onKeyDown, (V) => {
          var X;
          const c = V.currentTarget.contains(V.target), F = j0e[u.dir].includes(V.key);
          c && F && (s.onOpenChange(!1), (X = o.trigger) == null || X.focus(), V.preventDefault());
        })
      }
    ) }) }) });
  }
);
Sj.displayName = Pj;
function Nj(e) {
  return e ? "open" : "closed";
}
function dX(e) {
  return e === "indeterminate";
}
function j3(e) {
  return dX(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function d1e(e) {
  const r = document.activeElement;
  for (const t of e)
    if (t === r || (t.focus(), document.activeElement !== r)) return;
}
function a1e(e, r) {
  return e.map((t, i) => e[(r + i) % e.length]);
}
function V1e(e, r, t) {
  const n = r.length > 1 && Array.from(r).every((a) => a === r[0]) ? r[0] : r, s = t ? e.indexOf(t) : -1;
  let u = a1e(e, Math.max(s, 0));
  n.length === 1 && (u = u.filter((a) => a !== t));
  const d = u.find(
    (a) => a.toLowerCase().startsWith(n.toLowerCase())
  );
  return d !== t ? d : void 0;
}
function l1e(e, r) {
  const { x: t, y: i } = e;
  let n = !1;
  for (let s = 0, u = r.length - 1; s < r.length; u = s++) {
    const o = r[s].x, d = r[s].y, a = r[u].x, V = r[u].y;
    d > i != V > i && t < (a - o) * (i - d) / (V - d) + o && (n = !n);
  }
  return n;
}
function c1e(e, r) {
  if (!r) return !1;
  const t = { x: e.clientX, y: e.clientY };
  return l1e(t, r);
}
function r7(e) {
  return (r) => r.pointerType === "mouse" ? e(r) : void 0;
}
var F1e = cj, x1e = O3, X1e = xj, q1e = Xj, Y1e = L3, f1e = qj, K1e = PY, h1e = fj, p1e = hj, m1e = mj, g1e = vj, v1e = bj, b1e = yj, y1e = wj, A1e = Cj, w1e = Sj, z3 = "DropdownMenu", [C1e, ZQe] = upe(
  z3,
  [aj]
), fi = aj(), [P1e, Mj] = C1e(z3), Tj = (e) => {
  const {
    __scopeDropdownMenu: r,
    children: t,
    dir: i,
    open: n,
    defaultOpen: s,
    onOpenChange: u,
    modal: o = !0
  } = e, d = fi(r), a = h.useRef(null), [V = !1, c] = Gr({
    prop: n,
    defaultProp: s,
    onChange: u
  });
  return /* @__PURE__ */ l(
    P1e,
    {
      scope: r,
      triggerId: ot(),
      triggerRef: a,
      contentId: ot(),
      open: V,
      onOpenChange: c,
      onOpenToggle: h.useCallback(() => c((F) => !F), [c]),
      modal: o,
      children: /* @__PURE__ */ l(F1e, { ...d, open: V, onOpenChange: c, dir: i, modal: o, children: t })
    }
  );
};
Tj.displayName = z3;
var Ej = "DropdownMenuTrigger", kj = h.forwardRef(
  (e, r) => {
    const { __scopeDropdownMenu: t, disabled: i = !1, ...n } = e, s = Mj(Ej, t), u = fi(t);
    return /* @__PURE__ */ l(x1e, { asChild: !0, ...u, children: /* @__PURE__ */ l(
      Fpe.button,
      {
        type: "button",
        id: s.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": s.open,
        "aria-controls": s.open ? s.contentId : void 0,
        "data-state": s.open ? "open" : "closed",
        "data-disabled": i ? "" : void 0,
        disabled: i,
        ...n,
        ref: AH(r, s.triggerRef),
        onPointerDown: uX(e.onPointerDown, (o) => {
          !i && o.button === 0 && o.ctrlKey === !1 && (s.onOpenToggle(), s.open || o.preventDefault());
        }),
        onKeyDown: uX(e.onKeyDown, (o) => {
          i || (["Enter", " "].includes(o.key) && s.onOpenToggle(), o.key === "ArrowDown" && s.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(o.key) && o.preventDefault());
        })
      }
    ) });
  }
);
kj.displayName = Ej;
var S1e = "DropdownMenuPortal", Oj = (e) => {
  const { __scopeDropdownMenu: r, ...t } = e, i = fi(r);
  return /* @__PURE__ */ l(X1e, { ...i, ...t });
};
Oj.displayName = S1e;
var Dj = "DropdownMenuContent", Rj = h.forwardRef(
  (e, r) => {
    const { __scopeDropdownMenu: t, ...i } = e, n = Mj(Dj, t), s = fi(t), u = h.useRef(!1);
    return /* @__PURE__ */ l(
      q1e,
      {
        id: n.contentId,
        "aria-labelledby": n.triggerId,
        ...s,
        ...i,
        ref: r,
        onCloseAutoFocus: uX(e.onCloseAutoFocus, (o) => {
          var d;
          u.current || (d = n.triggerRef.current) == null || d.focus(), u.current = !1, o.preventDefault();
        }),
        onInteractOutside: uX(e.onInteractOutside, (o) => {
          const d = o.detail.originalEvent, a = d.button === 0 && d.ctrlKey === !0, V = d.button === 2 || a;
          (!n.modal || V) && (u.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Rj.displayName = Dj;
var N1e = "DropdownMenuGroup", Ij = h.forwardRef(
  (e, r) => {
    const { __scopeDropdownMenu: t, ...i } = e, n = fi(t);
    return /* @__PURE__ */ l(Y1e, { ...n, ...i, ref: r });
  }
);
Ij.displayName = N1e;
var M1e = "DropdownMenuLabel", Lj = h.forwardRef(
  (e, r) => {
    const { __scopeDropdownMenu: t, ...i } = e, n = fi(t);
    return /* @__PURE__ */ l(f1e, { ...n, ...i, ref: r });
  }
);
Lj.displayName = M1e;
var T1e = "DropdownMenuItem", _j = h.forwardRef(
  (e, r) => {
    const { __scopeDropdownMenu: t, ...i } = e, n = fi(t);
    return /* @__PURE__ */ l(K1e, { ...n, ...i, ref: r });
  }
);
_j.displayName = T1e;
var E1e = "DropdownMenuCheckboxItem", Hj = h.forwardRef((e, r) => {
  const { __scopeDropdownMenu: t, ...i } = e, n = fi(t);
  return /* @__PURE__ */ l(h1e, { ...n, ...i, ref: r });
});
Hj.displayName = E1e;
var k1e = "DropdownMenuRadioGroup", jj = h.forwardRef((e, r) => {
  const { __scopeDropdownMenu: t, ...i } = e, n = fi(t);
  return /* @__PURE__ */ l(p1e, { ...n, ...i, ref: r });
});
jj.displayName = k1e;
var O1e = "DropdownMenuRadioItem", zj = h.forwardRef((e, r) => {
  const { __scopeDropdownMenu: t, ...i } = e, n = fi(t);
  return /* @__PURE__ */ l(m1e, { ...n, ...i, ref: r });
});
zj.displayName = O1e;
var D1e = "DropdownMenuItemIndicator", Bj = h.forwardRef((e, r) => {
  const { __scopeDropdownMenu: t, ...i } = e, n = fi(t);
  return /* @__PURE__ */ l(g1e, { ...n, ...i, ref: r });
});
Bj.displayName = D1e;
var R1e = "DropdownMenuSeparator", Wj = h.forwardRef((e, r) => {
  const { __scopeDropdownMenu: t, ...i } = e, n = fi(t);
  return /* @__PURE__ */ l(v1e, { ...n, ...i, ref: r });
});
Wj.displayName = R1e;
var I1e = "DropdownMenuArrow", L1e = h.forwardRef(
  (e, r) => {
    const { __scopeDropdownMenu: t, ...i } = e, n = fi(t);
    return /* @__PURE__ */ l(b1e, { ...n, ...i, ref: r });
  }
);
L1e.displayName = I1e;
var _1e = (e) => {
  const { __scopeDropdownMenu: r, children: t, open: i, onOpenChange: n, defaultOpen: s } = e, u = fi(r), [o = !1, d] = Gr({
    prop: i,
    defaultProp: s,
    onChange: n
  });
  return /* @__PURE__ */ l(y1e, { ...u, open: o, onOpenChange: d, children: t });
}, H1e = "DropdownMenuSubTrigger", Gj = h.forwardRef((e, r) => {
  const { __scopeDropdownMenu: t, ...i } = e, n = fi(t);
  return /* @__PURE__ */ l(A1e, { ...n, ...i, ref: r });
});
Gj.displayName = H1e;
var j1e = "DropdownMenuSubContent", Uj = h.forwardRef((e, r) => {
  const { __scopeDropdownMenu: t, ...i } = e, n = fi(t);
  return /* @__PURE__ */ l(
    w1e,
    {
      ...n,
      ...i,
      ref: r,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Uj.displayName = j1e;
var z1e = Tj, B1e = kj, Zj = Oj, Jj = Rj, W1e = Ij, $j = Lj, Qj = _j, ez = Hj, G1e = jj, rz = zj, tz = Bj, iz = Wj, U1e = _1e, nz = Gj, sz = Uj;
const JQe = z1e, $Qe = B1e, QQe = W1e, eer = Zj, rer = U1e, ter = G1e, Z1e = re(({ className: e, inset: r, children: t, ...i }, n) => /* @__PURE__ */ C(
  nz,
  {
    ref: n,
    className: _(
      "focus:bg-accent data-[state=open]:bg-accent text-bodysm flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 outline-none [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      r && "pl-8",
      e
    ),
    ...i,
    children: [
      t,
      /* @__PURE__ */ l(xR, { className: "ml-auto" })
    ]
  }
));
Z1e.displayName = nz.displayName;
const J1e = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  sz,
  {
    ref: t,
    className: _(
      "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] overflow-hidden rounded-md border p-1 shadow-lg",
      e
    ),
    ...r
  }
));
J1e.displayName = sz.displayName;
const $1e = re(({ className: e, sideOffset: r = 4, ...t }, i) => /* @__PURE__ */ l(Zj, { children: /* @__PURE__ */ l(
  Jj,
  {
    ref: i,
    sideOffset: r,
    className: _(
      "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 border-border z-50 min-w-[8rem] overflow-hidden rounded-md border p-1 shadow-md",
      e
    ),
    ...t
  }
) }));
$1e.displayName = Jj.displayName;
const Q1e = re(({ className: e, inset: r, ...t }, i) => /* @__PURE__ */ l(
  Qj,
  {
    ref: i,
    className: _(
      "focus:bg-accent focus:text-accent-foreground text-bodysm relative flex cursor-pointer select-none items-center gap-2 rounded-sm px-2 py-1.5 outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      r && "pl-8",
      e
    ),
    ...t
  }
));
Q1e.displayName = Qj.displayName;
const eme = re(({ className: e, children: r, checked: t, ...i }, n) => /* @__PURE__ */ C(
  ez,
  {
    ref: n,
    className: _(
      "focus:bg-accent focus:text-accent-foreground text-bodysm relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: t,
    ...i,
    children: [
      /* @__PURE__ */ l("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ l(tz, { children: /* @__PURE__ */ l(Bo, { className: "h-4 w-4" }) }) }),
      r
    ]
  }
));
eme.displayName = ez.displayName;
const rme = re(({ className: e, children: r, ...t }, i) => /* @__PURE__ */ C(
  rz,
  {
    ref: i,
    className: _(
      "focus:bg-accent focus:text-accent-foreground text-bodysm relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 outline-none transition-colors data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...t,
    children: [
      /* @__PURE__ */ l("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ l(tz, { children: /* @__PURE__ */ l(Gc, { className: "h-2 w-2 fill-current" }) }) }),
      r
    ]
  }
));
rme.displayName = rz.displayName;
const tme = re(({ className: e, inset: r, ...t }, i) => /* @__PURE__ */ l(
  $j,
  {
    ref: i,
    className: _(
      "text-bodysm px-2 py-1.5 font-semibold",
      r && "pl-8",
      e
    ),
    ...t
  }
));
tme.displayName = $j.displayName;
const ime = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  iz,
  {
    ref: t,
    className: _("bg-interactiveBorder -mx-1 my-1 h-px", e),
    ...r
  }
));
ime.displayName = iz.displayName;
const nme = ({
  className: e,
  ...r
}) => /* @__PURE__ */ l(
  "span",
  {
    className: _("ml-auto text-body tracking-widest opacity-60", e),
    ...r
  }
);
nme.displayName = "DropdownMenuShortcut";
const uz = et(
  {}
), oz = et(
  {}
), SY = () => {
  const e = rt(uz), r = rt(oz), { getFieldState: t, formState: i } = Rae(), n = t(e.name, i);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: s } = r;
  return {
    id: s,
    name: e.name,
    formItemId: `${s}-form-item`,
    formDescriptionId: `${s}-form-item-description`,
    formMessageId: `${s}-form-item-message`,
    ...n
  };
}, ier = ({
  ...e
}) => /* @__PURE__ */ l(uz.Provider, { value: { name: e.name }, children: /* @__PURE__ */ l(Iae, { ...e }) }), sme = re(
  ({ className: e, ...r }, t) => {
    const i = gae();
    return /* @__PURE__ */ l(oz.Provider, { value: { id: i }, children: /* @__PURE__ */ l("div", { ref: t, className: _("space-y-2", e), ...r }) });
  }
);
sme.displayName = "FormItem";
const ume = re(({ className: e, children: r, required: t, ...i }, n) => {
  const { error: s, formItemId: u } = SY();
  return /* @__PURE__ */ C(
    _r,
    {
      ref: n,
      className: _(s && "text-destructive", e),
      htmlFor: u,
      ...i,
      children: [
        r,
        t ? /* @__PURE__ */ l("span", { className: "text-destructive ml-1", children: "*" }) : null
      ]
    }
  );
});
ume.displayName = "FormLabel";
const ome = re(({ ...e }, r) => {
  const { error: t, formItemId: i, formDescriptionId: n, formMessageId: s } = SY();
  return /* @__PURE__ */ l(
    xn,
    {
      ref: r,
      id: i,
      "aria-describedby": t ? `${n} ${s}` : `${n}`,
      "aria-invalid": !!t,
      ...e
    }
  );
});
ome.displayName = "FormControl";
const dme = re(({ className: e, ...r }, t) => {
  const { formDescriptionId: i } = SY();
  return /* @__PURE__ */ l(
    "p",
    {
      ref: t,
      id: i,
      className: _("text-muted-foreground text-bodysm", e),
      ...r
    }
  );
});
dme.displayName = "FormDescription";
const ame = re(({ className: e, children: r, ...t }, i) => {
  const { error: n, invalid: s, formMessageId: u } = SY(), o = n != null && n.message ? String(n.message) : r;
  return !s || !o ? null : /* @__PURE__ */ l(
    "p",
    {
      ref: i,
      id: u,
      className: _("text-destructive text-bodysm font-medium", e),
      ...t,
      children: o
    }
  );
});
ame.displayName = "FormMessage";
function dz(e, r = []) {
  let t = [];
  function i(s, u) {
    const o = h.createContext(u), d = t.length;
    t = [...t, u];
    const a = (c) => {
      var p;
      const { scope: F, children: X, ...Y } = c, q = ((p = F == null ? void 0 : F[e]) == null ? void 0 : p[d]) || o, f = h.useMemo(() => Y, Object.values(Y));
      return /* @__PURE__ */ l(q.Provider, { value: f, children: X });
    };
    a.displayName = s + "Provider";
    function V(c, F) {
      var q;
      const X = ((q = F == null ? void 0 : F[e]) == null ? void 0 : q[d]) || o, Y = h.useContext(X);
      if (Y) return Y;
      if (u !== void 0) return u;
      throw new Error(`\`${c}\` must be used within \`${s}\``);
    }
    return [a, V];
  }
  const n = () => {
    const s = t.map((u) => h.createContext(u));
    return function(o) {
      const d = (o == null ? void 0 : o[e]) || s;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: d } }),
        [o, d]
      );
    };
  };
  return n.scopeName = e, [i, Vme(n, ...r)];
}
function Vme(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const t = () => {
    const i = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(s) {
      const u = i.reduce((o, { useScope: d, scopeName: a }) => {
        const c = d(s)[`__scope${a}`];
        return { ...o, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${r.scopeName}`]: u }), [u]);
    };
  };
  return t.scopeName = r.scopeName, t;
}
var cp = "rovingFocusGroup.onEntryFocus", lme = { bubbles: !1, cancelable: !0 }, NY = "RovingFocusGroup", [Wv, az, cme] = Lq(NY), [Fme, MY] = Wo(
  NY,
  [cme]
), [xme, Xme] = Fme(NY), Vz = h.forwardRef(
  (e, r) => /* @__PURE__ */ l(Wv.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ l(Wv.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ l(qme, { ...e, ref: r }) }) })
);
Vz.displayName = NY;
var qme = h.forwardRef((e, r) => {
  const {
    __scopeRovingFocusGroup: t,
    orientation: i,
    loop: n = !1,
    dir: s,
    currentTabStopId: u,
    defaultCurrentTabStopId: o,
    onCurrentTabStopIdChange: d,
    onEntryFocus: a,
    preventScrollOnEntryFocus: V = !1,
    ...c
  } = e, F = h.useRef(null), X = rr(r, F), Y = Rn(s), [q = null, f] = Gr({
    prop: u,
    defaultProp: o,
    onChange: d
  }), [p, m] = h.useState(!1), g = Ee(a), y = az(t), b = h.useRef(!1), [A, w] = h.useState(0);
  return h.useEffect(() => {
    const S = F.current;
    if (S)
      return S.addEventListener(cp, g), () => S.removeEventListener(cp, g);
  }, [g]), /* @__PURE__ */ l(
    xme,
    {
      scope: t,
      orientation: i,
      dir: Y,
      loop: n,
      currentTabStopId: q,
      onItemFocus: h.useCallback(
        (S) => f(S),
        [f]
      ),
      onItemShiftTab: h.useCallback(() => m(!0), []),
      onFocusableItemAdd: h.useCallback(
        () => w((S) => S + 1),
        []
      ),
      onFocusableItemRemove: h.useCallback(
        () => w((S) => S - 1),
        []
      ),
      children: /* @__PURE__ */ l(
        Me.div,
        {
          tabIndex: p || A === 0 ? -1 : 0,
          "data-orientation": i,
          ...c,
          ref: X,
          style: { outline: "none", ...e.style },
          onMouseDown: Ne(e.onMouseDown, () => {
            b.current = !0;
          }),
          onFocus: Ne(e.onFocus, (S) => {
            const N = !b.current;
            if (S.target === S.currentTarget && N && !p) {
              const O = new CustomEvent(cp, lme);
              if (S.currentTarget.dispatchEvent(O), !O.defaultPrevented) {
                const E = y().filter((B) => B.focusable), I = E.find((B) => B.active), R = E.find((B) => B.id === q), W = [I, R, ...E].filter(
                  Boolean
                ).map((B) => B.ref.current);
                Fz(W, V);
              }
            }
            b.current = !1;
          }),
          onBlur: Ne(e.onBlur, () => m(!1))
        }
      )
    }
  );
}), lz = "RovingFocusGroupItem", cz = h.forwardRef(
  (e, r) => {
    const {
      __scopeRovingFocusGroup: t,
      focusable: i = !0,
      active: n = !1,
      tabStopId: s,
      ...u
    } = e, o = ot(), d = s || o, a = Xme(lz, t), V = a.currentTabStopId === d, c = az(t), { onFocusableItemAdd: F, onFocusableItemRemove: X } = a;
    return h.useEffect(() => {
      if (i)
        return F(), () => X();
    }, [i, F, X]), /* @__PURE__ */ l(
      Wv.ItemSlot,
      {
        scope: t,
        id: d,
        focusable: i,
        active: n,
        children: /* @__PURE__ */ l(
          Me.span,
          {
            tabIndex: V ? 0 : -1,
            "data-orientation": a.orientation,
            ...u,
            ref: r,
            onMouseDown: Ne(e.onMouseDown, (Y) => {
              i ? a.onItemFocus(d) : Y.preventDefault();
            }),
            onFocus: Ne(e.onFocus, () => a.onItemFocus(d)),
            onKeyDown: Ne(e.onKeyDown, (Y) => {
              if (Y.key === "Tab" && Y.shiftKey) {
                a.onItemShiftTab();
                return;
              }
              if (Y.target !== Y.currentTarget) return;
              const q = Kme(Y, a.orientation, a.dir);
              if (q !== void 0) {
                if (Y.metaKey || Y.ctrlKey || Y.altKey || Y.shiftKey) return;
                Y.preventDefault();
                let p = c().filter((m) => m.focusable).map((m) => m.ref.current);
                if (q === "last") p.reverse();
                else if (q === "prev" || q === "next") {
                  q === "prev" && p.reverse();
                  const m = p.indexOf(Y.currentTarget);
                  p = a.loop ? hme(p, m + 1) : p.slice(m + 1);
                }
                setTimeout(() => Fz(p));
              }
            })
          }
        )
      }
    );
  }
);
cz.displayName = lz;
var Yme = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function fme(e, r) {
  return r !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Kme(e, r, t) {
  const i = fme(e.key, t);
  if (!(r === "vertical" && ["ArrowLeft", "ArrowRight"].includes(i)) && !(r === "horizontal" && ["ArrowUp", "ArrowDown"].includes(i)))
    return Yme[i];
}
function Fz(e, r = !1) {
  const t = document.activeElement;
  for (const i of e)
    if (i === t || (i.focus({ preventScroll: r }), document.activeElement !== t)) return;
}
function hme(e, r) {
  return e.map((t, i) => e[(r + i) % e.length]);
}
var xz = Vz, Xz = cz;
function pme(e, r) {
  return h.useReducer((t, i) => r[t][i] ?? t, e);
}
var qz = (e) => {
  const { present: r, children: t } = e, i = mme(r), n = typeof t == "function" ? t({ present: i.isPresent }) : h.Children.only(t), s = rr(i.ref, gme(n));
  return typeof t == "function" || i.isPresent ? h.cloneElement(n, { ref: s }) : null;
};
qz.displayName = "Presence";
function mme(e) {
  const [r, t] = h.useState(), i = h.useRef({}), n = h.useRef(e), s = h.useRef("none"), u = e ? "mounted" : "unmounted", [o, d] = pme(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return h.useEffect(() => {
    const a = tx(i.current);
    s.current = o === "mounted" ? a : "none";
  }, [o]), ze(() => {
    const a = i.current, V = n.current;
    if (V !== e) {
      const F = s.current, X = tx(a);
      e ? d("MOUNT") : X === "none" || (a == null ? void 0 : a.display) === "none" ? d("UNMOUNT") : d(V && F !== X ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, d]), ze(() => {
    if (r) {
      let a;
      const V = r.ownerDocument.defaultView ?? window, c = (X) => {
        const q = tx(i.current).includes(X.animationName);
        if (X.target === r && q && (d("ANIMATION_END"), !n.current)) {
          const f = r.style.animationFillMode;
          r.style.animationFillMode = "forwards", a = V.setTimeout(() => {
            r.style.animationFillMode === "forwards" && (r.style.animationFillMode = f);
          });
        }
      }, F = (X) => {
        X.target === r && (s.current = tx(i.current));
      };
      return r.addEventListener("animationstart", F), r.addEventListener("animationcancel", c), r.addEventListener("animationend", c), () => {
        V.clearTimeout(a), r.removeEventListener("animationstart", F), r.removeEventListener("animationcancel", c), r.removeEventListener("animationend", c);
      };
    } else
      d("ANIMATION_END");
  }, [r, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: h.useCallback((a) => {
      a && (i.current = getComputedStyle(a)), t(a);
    }, [])
  };
}
function tx(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function gme(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var B3 = "Radio", [vme, Yz] = dz(B3), [bme, yme] = vme(B3), fz = h.forwardRef(
  (e, r) => {
    const {
      __scopeRadio: t,
      name: i,
      checked: n = !1,
      required: s,
      disabled: u,
      value: o = "on",
      onCheck: d,
      form: a,
      ...V
    } = e, [c, F] = h.useState(null), X = rr(r, (f) => F(f)), Y = h.useRef(!1), q = c ? a || !!c.closest("form") : !0;
    return /* @__PURE__ */ C(bme, { scope: t, checked: n, disabled: u, children: [
      /* @__PURE__ */ l(
        Me.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": n,
          "data-state": pz(n),
          "data-disabled": u ? "" : void 0,
          disabled: u,
          value: o,
          ...V,
          ref: X,
          onClick: Ne(e.onClick, (f) => {
            n || d == null || d(), q && (Y.current = f.isPropagationStopped(), Y.current || f.stopPropagation());
          })
        }
      ),
      q && /* @__PURE__ */ l(
        Ame,
        {
          control: c,
          bubbles: !Y.current,
          name: i,
          value: o,
          checked: n,
          required: s,
          disabled: u,
          form: a,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
fz.displayName = B3;
var Kz = "RadioIndicator", hz = h.forwardRef(
  (e, r) => {
    const { __scopeRadio: t, forceMount: i, ...n } = e, s = yme(Kz, t);
    return /* @__PURE__ */ l(qz, { present: i || s.checked, children: /* @__PURE__ */ l(
      Me.span,
      {
        "data-state": pz(s.checked),
        "data-disabled": s.disabled ? "" : void 0,
        ...n,
        ref: r
      }
    ) });
  }
);
hz.displayName = Kz;
var Ame = (e) => {
  const { control: r, checked: t, bubbles: i = !0, ...n } = e, s = h.useRef(null), u = Kl(t), o = da(r);
  return h.useEffect(() => {
    const d = s.current, a = window.HTMLInputElement.prototype, c = Object.getOwnPropertyDescriptor(a, "checked").set;
    if (u !== t && c) {
      const F = new Event("click", { bubbles: i });
      c.call(d, t), d.dispatchEvent(F);
    }
  }, [u, t, i]), /* @__PURE__ */ l(
    "input",
    {
      type: "radio",
      "aria-hidden": !0,
      defaultChecked: t,
      ...n,
      tabIndex: -1,
      ref: s,
      style: {
        ...e.style,
        ...o,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function pz(e) {
  return e ? "checked" : "unchecked";
}
var wme = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], W3 = "RadioGroup", [Cme, ner] = dz(W3, [
  MY,
  Yz
]), mz = MY(), gz = Yz(), [Pme, Sme] = Cme(W3), vz = h.forwardRef(
  (e, r) => {
    const {
      __scopeRadioGroup: t,
      name: i,
      defaultValue: n,
      value: s,
      required: u = !1,
      disabled: o = !1,
      orientation: d,
      dir: a,
      loop: V = !0,
      onValueChange: c,
      ...F
    } = e, X = mz(t), Y = Rn(a), [q, f] = Gr({
      prop: s,
      defaultProp: n,
      onChange: c
    });
    return /* @__PURE__ */ l(
      Pme,
      {
        scope: t,
        name: i,
        required: u,
        disabled: o,
        value: q,
        onValueChange: f,
        children: /* @__PURE__ */ l(
          xz,
          {
            asChild: !0,
            ...X,
            orientation: d,
            dir: Y,
            loop: V,
            children: /* @__PURE__ */ l(
              Me.div,
              {
                role: "radiogroup",
                "aria-required": u,
                "aria-orientation": d,
                "data-disabled": o ? "" : void 0,
                dir: Y,
                ...F,
                ref: r
              }
            )
          }
        )
      }
    );
  }
);
vz.displayName = W3;
var bz = "RadioGroupItem", yz = h.forwardRef(
  (e, r) => {
    const { __scopeRadioGroup: t, disabled: i, ...n } = e, s = Sme(bz, t), u = s.disabled || i, o = mz(t), d = gz(t), a = h.useRef(null), V = rr(r, a), c = s.value === n.value, F = h.useRef(!1);
    return h.useEffect(() => {
      const X = (q) => {
        wme.includes(q.key) && (F.current = !0);
      }, Y = () => F.current = !1;
      return document.addEventListener("keydown", X), document.addEventListener("keyup", Y), () => {
        document.removeEventListener("keydown", X), document.removeEventListener("keyup", Y);
      };
    }, []), /* @__PURE__ */ l(
      Xz,
      {
        asChild: !0,
        ...o,
        focusable: !u,
        active: c,
        children: /* @__PURE__ */ l(
          fz,
          {
            disabled: u,
            required: s.required,
            checked: c,
            ...d,
            ...n,
            name: s.name,
            ref: V,
            onCheck: () => s.onValueChange(n.value),
            onKeyDown: Ne((X) => {
              X.key === "Enter" && X.preventDefault();
            }),
            onFocus: Ne(n.onFocus, () => {
              var X;
              F.current && ((X = a.current) == null || X.click());
            })
          }
        )
      }
    );
  }
);
yz.displayName = bz;
var Nme = "RadioGroupIndicator", Az = h.forwardRef(
  (e, r) => {
    const { __scopeRadioGroup: t, ...i } = e, n = gz(t);
    return /* @__PURE__ */ l(hz, { ...n, ...i, ref: r });
  }
);
Az.displayName = Nme;
var p2 = vz, yo = yz, Mme = Az;
function Ed({
  options: e,
  radioValue: r,
  setRadioValue: t
}) {
  return /* @__PURE__ */ l(
    p2,
    {
      className: "flex flex-row",
      value: r,
      onValueChange: (i) => {
        t(i);
      },
      "aria-label": "View density",
      children: /* @__PURE__ */ l("div", { className: "flex items-center gap-x-1", children: e.length > 0 && e.map((i, n) => /* @__PURE__ */ C(
        yo,
        {
          className: _(
            "data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:border-interactiveBorderHover data-[state=unchecked]:hover:bg-interfaceBgDefault flex h-12 w-12 flex-col items-center justify-center rounded border p-2 data-[state=checked]:border-2",
            i.bgColor,
            i.borderColor,
            i.textColor
          ),
          onClick: () => {
            i.text === r && t("");
          },
          tabIndex: 1,
          value: i.text,
          children: [
            i.icon,
            /* @__PURE__ */ l("p", { className: "mt-1 text-bodysm font-normal", children: i.text })
          ]
        },
        n
      )) })
    }
  );
}
const G3 = re(
  ({ className: e, type: r, ...t }, i) => /* @__PURE__ */ l(
    "input",
    {
      type: r,
      className: _(
        "border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-[1rem] leading-[1.25rem] file:border-0 file:bg-transparent file:text-bodysm file:font-medium placeholder:text-[1rem] placeholder:leading-[1.25rem] focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: i,
      ...t
    }
  )
);
G3.displayName = "Input";
const Tme = Js(
  "flex items-center h-10 w-full px-3 py-2 text-bodymd bg-transparent file:border-0 file:text-bodysm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 border border-transparent focus-within:outline-none aria-invalid:ring-1 aria-invalid:ring-destructive aria-invalid:focus-within:ring-2 aria-invalid:focus-within:ring-destructive",
  {
    variants: {
      rounded: {
        none: "rounded-none",
        sm: "rounded-sm",
        md: "rounded-md"
      },
      variant: {
        outline: "border-interactiveBorder focus-within:border-primary focus-within:shadow-[0_0px_0px_1px_hsl(var(--primary))] aria-invalid:border-transparent",
        filled: "border-2 bg-background focus-within:border-primary focus-within:bg-transparent",
        underlined: "rounded-none border-b-border focus-within:border-b-primary focus-within:shadow-[0_1px_0px_0px_hsl(var(--primary))]",
        unstyled: ""
      }
    },
    defaultVariants: {
      rounded: "md",
      variant: "outline"
    }
  }
), Eme = re(
  ({
    className: e,
    endClassName: r,
    endContent: t,
    rounded: i,
    startClassName: n,
    startContent: s,
    variant: u,
    ...o
  }, d) => /* @__PURE__ */ C(
    "div",
    {
      "aria-invalid": o["aria-invalid"],
      className: _(
        Tme({ variant: u, rounded: i, className: e }),
        e
      ),
      children: [
        s && /* @__PURE__ */ l(
          "span",
          {
            className: _(
              "text-muted-foreground pointer-events-none flex items-center",
              n
            ),
            children: s
          }
        ),
        /* @__PURE__ */ l(
          "input",
          {
            ref: d,
            ...o,
            className: _(
              "w-full bg-transparent outline-none focus-visible:outline-none",
              {
                "pl-1.5": !!s,
                "pr-1.5": !!t
              }
            )
          }
        ),
        t && /* @__PURE__ */ l(
          "span",
          {
            className: _(
              "text-muted-foreground pointer-events-none flex items-center",
              r
            ),
            children: t
          }
        )
      ]
    }
  )
);
Eme.displayName = "Input2";
var kme = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ome = kme.reduce((e, r) => {
  const t = h.forwardRef((i, n) => {
    const { asChild: s, ...u } = i, o = s ? xn : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l(o, { ...u, ref: n });
  });
  return t.displayName = `Primitive.${r}`, { ...e, [r]: t };
}, {}), Dme = "Label", wz = h.forwardRef((e, r) => /* @__PURE__ */ l(
  Ome.label,
  {
    ...e,
    ref: r,
    onMouseDown: (t) => {
      var n;
      t.target.closest("button, input, select, textarea") || ((n = e.onMouseDown) == null || n.call(e, t), !t.defaultPrevented && t.detail > 1 && t.preventDefault());
    }
  }
));
wz.displayName = Dme;
var Cz = wz;
const Rme = Js(
  "font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), _r = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  Cz,
  {
    ref: t,
    className: _(Rme(), e),
    ...r
  }
));
_r.displayName = Cz.displayName;
const Pz = re(function({
  allowMultiSelect: r = !0,
  className: t,
  disabled: i,
  // noOptionsFoundMessage,
  filter: n,
  onChange: s,
  onInputChange: u,
  options: o,
  placeholder: d,
  values: a
}, V) {
  const c = Yr(null), [F, X] = ie(!1), [Y, q] = ie(""), f = Yi(
    (m) => {
      const g = a.filter((y) => y.value !== m.value);
      s(g);
    },
    [s, a]
  ), p = Yi(
    (m) => {
      const g = c.current;
      if (g) {
        if ((m.key === "Delete" || m.key === "Backspace") && g.value === "") {
          const y = [...a];
          y.pop(), s(y);
        }
        m.key === "Escape" && g.blur();
      }
    },
    [s, a]
  );
  return kq(V, () => ({
    resetInput: () => {
      q("");
    }
  }), []), /* @__PURE__ */ C(
    hl,
    {
      className: "overflow-visible bg-transparent",
      filter: n,
      onKeyDown: p,
      children: [
        /* @__PURE__ */ l(
          "div",
          {
            className: _(
              "border-input bg-interfaceWhite ring-offset-background focus-within:ring-ring focus:outline-hidden group rounded-md border px-3 py-2 text-bodysm focus-within:ring-2 focus-within:ring-offset-2",
              t
            ),
            children: /* @__PURE__ */ C("div", { className: "flex flex-wrap gap-1", children: [
              a.map((m) => /* @__PURE__ */ C(Pt, { variant: "secondary", children: [
                m.label,
                /* @__PURE__ */ l(
                  "button",
                  {
                    className: "ring-offset-background focus:ring-ring outline-hidden ml-1 rounded-full focus:ring-2 focus:ring-offset-2",
                    onKeyDown: (g) => {
                      g.key === "Enter" && f(m);
                    },
                    onClick: () => f(m),
                    onMouseDown: (g) => {
                      g.preventDefault(), g.stopPropagation();
                    },
                    type: "button",
                    children: /* @__PURE__ */ l(r2, { className: "text-muted-foreground hover:text-foreground h-3 w-3" })
                  }
                )
              ] }, m.value)),
              /* @__PURE__ */ l(
                ui.Input,
                {
                  className: "placeholder:text-muted-foreground outline-hidden ml-2 flex-1 bg-transparent",
                  disabled: i,
                  onBlur: () => X(!1),
                  onFocus: () => X(!0),
                  onValueChange: (m) => {
                    q(m), u == null || u(m);
                  },
                  placeholder: d,
                  ref: c,
                  value: Y
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ l("div", { className: "relative", children: /* @__PURE__ */ l(a2, { children: F && o.length > 0 ? /* @__PURE__ */ l("div", { className: "bg-popover text-popover-foreground animate-in outline-hidden absolute top-0 z-10 mt-2 max-h-64 w-full overflow-auto rounded-md border shadow-md", children: /* @__PURE__ */ l(V2, { className: "h-full", children: o.map((m) => /* @__PURE__ */ l(
          l2,
          {
            className: "cursor-pointer",
            disabled: i,
            keywords: m.keywords,
            onMouseDown: (g) => {
              g.preventDefault(), g.stopPropagation();
            },
            onSelect: (g) => {
              if (q(""), u == null || u(""), !r)
                s([m]);
              else {
                if (a.some(
                  (b) => b.value === m.value
                )) return;
                s([...a, m]);
              }
            },
            children: m.label
          },
          m.value
        )) }) }) : null }) })
      ]
    }
  );
});
function Sz(e, r = []) {
  let t = [];
  function i(s, u) {
    const o = h.createContext(u), d = t.length;
    t = [...t, u];
    const a = (c) => {
      var p;
      const { scope: F, children: X, ...Y } = c, q = ((p = F == null ? void 0 : F[e]) == null ? void 0 : p[d]) || o, f = h.useMemo(() => Y, Object.values(Y));
      return /* @__PURE__ */ l(q.Provider, { value: f, children: X });
    };
    a.displayName = s + "Provider";
    function V(c, F) {
      var q;
      const X = ((q = F == null ? void 0 : F[e]) == null ? void 0 : q[d]) || o, Y = h.useContext(X);
      if (Y) return Y;
      if (u !== void 0) return u;
      throw new Error(`\`${c}\` must be used within \`${s}\``);
    }
    return [a, V];
  }
  const n = () => {
    const s = t.map((u) => h.createContext(u));
    return function(o) {
      const d = (o == null ? void 0 : o[e]) || s;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: d } }),
        [o, d]
      );
    };
  };
  return n.scopeName = e, [i, Ime(n, ...r)];
}
function Ime(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const t = () => {
    const i = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(s) {
      const u = i.reduce((o, { useScope: d, scopeName: a }) => {
        const c = d(s)[`__scope${a}`];
        return { ...o, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${r.scopeName}`]: u }), [u]);
    };
  };
  return t.scopeName = r.scopeName, t;
}
function Lt(e, r, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), t === !1 || !n.defaultPrevented)
      return r == null ? void 0 : r(n);
  };
}
function PC(e, r) {
  if (typeof e == "function")
    return e(r);
  e != null && (e.current = r);
}
function U3(...e) {
  return (r) => {
    let t = !1;
    const i = e.map((n) => {
      const s = PC(n, r);
      return !t && typeof s == "function" && (t = !0), s;
    });
    if (t)
      return () => {
        for (let n = 0; n < i.length; n++) {
          const s = i[n];
          typeof s == "function" ? s() : PC(e[n], null);
        }
      };
  };
}
function js(...e) {
  return h.useCallback(U3(...e), e);
}
var aX = h.forwardRef((e, r) => {
  const { children: t, ...i } = e, n = h.Children.toArray(t), s = n.find(_me);
  if (s) {
    const u = s.props.children, o = n.map((d) => d === s ? h.Children.count(u) > 1 ? h.Children.only(null) : h.isValidElement(u) ? u.props.children : null : d);
    return /* @__PURE__ */ l(Gv, { ...i, ref: r, children: h.isValidElement(u) ? h.cloneElement(u, void 0, o) : null });
  }
  return /* @__PURE__ */ l(Gv, { ...i, ref: r, children: t });
});
aX.displayName = "Slot";
var Gv = h.forwardRef((e, r) => {
  const { children: t, ...i } = e;
  if (h.isValidElement(t)) {
    const n = jme(t);
    return h.cloneElement(t, {
      ...Hme(i, t.props),
      // @ts-ignore
      ref: r ? U3(r, n) : n
    });
  }
  return h.Children.count(t) > 1 ? h.Children.only(null) : null;
});
Gv.displayName = "SlotClone";
var Lme = ({ children: e }) => /* @__PURE__ */ l(he, { children: e });
function _me(e) {
  return h.isValidElement(e) && e.type === Lme;
}
function Hme(e, r) {
  const t = { ...r };
  for (const i in r) {
    const n = e[i], s = r[i];
    /^on[A-Z]/.test(i) ? n && s ? t[i] = (...o) => {
      s(...o), n(...o);
    } : n && (t[i] = n) : i === "style" ? t[i] = { ...n, ...s } : i === "className" && (t[i] = [n, s].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function jme(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var zme = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Gi = zme.reduce((e, r) => {
  const t = h.forwardRef((i, n) => {
    const { asChild: s, ...u } = i, o = s ? aX : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l(o, { ...u, ref: n });
  });
  return t.displayName = `Primitive.${r}`, { ...e, [r]: t };
}, {});
function Uv(e, r) {
  e && qs.flushSync(() => e.dispatchEvent(r));
}
function Bme(e, r) {
  return h.useReducer((t, i) => r[t][i] ?? t, e);
}
var m2 = (e) => {
  const { present: r, children: t } = e, i = Wme(r), n = typeof t == "function" ? t({ present: i.isPresent }) : h.Children.only(t), s = js(i.ref, Gme(n));
  return typeof t == "function" || i.isPresent ? h.cloneElement(n, { ref: s }) : null;
};
m2.displayName = "Presence";
function Wme(e) {
  const [r, t] = h.useState(), i = h.useRef({}), n = h.useRef(e), s = h.useRef("none"), u = e ? "mounted" : "unmounted", [o, d] = Bme(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return h.useEffect(() => {
    const a = ix(i.current);
    s.current = o === "mounted" ? a : "none";
  }, [o]), ze(() => {
    const a = i.current, V = n.current;
    if (V !== e) {
      const F = s.current, X = ix(a);
      e ? d("MOUNT") : X === "none" || (a == null ? void 0 : a.display) === "none" ? d("UNMOUNT") : d(V && F !== X ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, d]), ze(() => {
    if (r) {
      let a;
      const V = r.ownerDocument.defaultView ?? window, c = (X) => {
        const q = ix(i.current).includes(X.animationName);
        if (X.target === r && q && (d("ANIMATION_END"), !n.current)) {
          const f = r.style.animationFillMode;
          r.style.animationFillMode = "forwards", a = V.setTimeout(() => {
            r.style.animationFillMode === "forwards" && (r.style.animationFillMode = f);
          });
        }
      }, F = (X) => {
        X.target === r && (s.current = ix(i.current));
      };
      return r.addEventListener("animationstart", F), r.addEventListener("animationcancel", c), r.addEventListener("animationend", c), () => {
        V.clearTimeout(a), r.removeEventListener("animationstart", F), r.removeEventListener("animationcancel", c), r.removeEventListener("animationend", c);
      };
    } else
      d("ANIMATION_END");
  }, [r, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: h.useCallback((a) => {
      a && (i.current = getComputedStyle(a)), t(a);
    }, [])
  };
}
function ix(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Gme(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
function Nz(e) {
  const r = e + "CollectionProvider", [t, i] = Sz(r), [n, s] = t(
    r,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), u = (X) => {
    const { scope: Y, children: q } = X, f = D.useRef(null), p = D.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ l(n, { scope: Y, itemMap: p, collectionRef: f, children: q });
  };
  u.displayName = r;
  const o = e + "CollectionSlot", d = D.forwardRef(
    (X, Y) => {
      const { scope: q, children: f } = X, p = s(o, q), m = js(Y, p.collectionRef);
      return /* @__PURE__ */ l(aX, { ref: m, children: f });
    }
  );
  d.displayName = o;
  const a = e + "CollectionItemSlot", V = "data-radix-collection-item", c = D.forwardRef(
    (X, Y) => {
      const { scope: q, children: f, ...p } = X, m = D.useRef(null), g = js(Y, m), y = s(a, q);
      return D.useEffect(() => (y.itemMap.set(m, { ref: m, ...p }), () => void y.itemMap.delete(m))), /* @__PURE__ */ l(aX, { [V]: "", ref: g, children: f });
    }
  );
  c.displayName = a;
  function F(X) {
    const Y = s(e + "CollectionConsumer", X);
    return D.useCallback(() => {
      const f = Y.collectionRef.current;
      if (!f) return [];
      const p = Array.from(f.querySelectorAll(`[${V}]`));
      return Array.from(Y.itemMap.values()).sort(
        (y, b) => p.indexOf(y.ref.current) - p.indexOf(b.ref.current)
      );
    }, [Y.collectionRef, Y.itemMap]);
  }
  return [
    { Provider: u, Slot: d, ItemSlot: c },
    F,
    i
  ];
}
var Ume = "DismissableLayer", Zv = "dismissableLayer.update", Zme = "dismissableLayer.pointerDownOutside", Jme = "dismissableLayer.focusOutside", SC, Mz = h.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Tz = h.forwardRef(
  (e, r) => {
    const {
      disableOutsidePointerEvents: t = !1,
      onEscapeKeyDown: i,
      onPointerDownOutside: n,
      onFocusOutside: s,
      onInteractOutside: u,
      onDismiss: o,
      ...d
    } = e, a = h.useContext(Mz), [V, c] = h.useState(null), F = (V == null ? void 0 : V.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, X] = h.useState({}), Y = js(r, (w) => c(w)), q = Array.from(a.layers), [f] = [...a.layersWithOutsidePointerEventsDisabled].slice(-1), p = q.indexOf(f), m = V ? q.indexOf(V) : -1, g = a.layersWithOutsidePointerEventsDisabled.size > 0, y = m >= p, b = ege((w) => {
      const S = w.target, N = [...a.branches].some((O) => O.contains(S));
      !y || N || (n == null || n(w), u == null || u(w), w.defaultPrevented || o == null || o());
    }, F), A = rge((w) => {
      const S = w.target;
      [...a.branches].some((O) => O.contains(S)) || (s == null || s(w), u == null || u(w), w.defaultPrevented || o == null || o());
    }, F);
    return oa((w) => {
      m === a.layers.size - 1 && (i == null || i(w), !w.defaultPrevented && o && (w.preventDefault(), o()));
    }, F), h.useEffect(() => {
      if (V)
        return t && (a.layersWithOutsidePointerEventsDisabled.size === 0 && (SC = F.body.style.pointerEvents, F.body.style.pointerEvents = "none"), a.layersWithOutsidePointerEventsDisabled.add(V)), a.layers.add(V), NC(), () => {
          t && a.layersWithOutsidePointerEventsDisabled.size === 1 && (F.body.style.pointerEvents = SC);
        };
    }, [V, F, t, a]), h.useEffect(() => () => {
      V && (a.layers.delete(V), a.layersWithOutsidePointerEventsDisabled.delete(V), NC());
    }, [V, a]), h.useEffect(() => {
      const w = () => X({});
      return document.addEventListener(Zv, w), () => document.removeEventListener(Zv, w);
    }, []), /* @__PURE__ */ l(
      Gi.div,
      {
        ...d,
        ref: Y,
        style: {
          pointerEvents: g ? y ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Lt(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: Lt(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: Lt(
          e.onPointerDownCapture,
          b.onPointerDownCapture
        )
      }
    );
  }
);
Tz.displayName = Ume;
var $me = "DismissableLayerBranch", Qme = h.forwardRef((e, r) => {
  const t = h.useContext(Mz), i = h.useRef(null), n = js(r, i);
  return h.useEffect(() => {
    const s = i.current;
    if (s)
      return t.branches.add(s), () => {
        t.branches.delete(s);
      };
  }, [t.branches]), /* @__PURE__ */ l(Gi.div, { ...e, ref: n });
});
Qme.displayName = $me;
function ege(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Ee(e), i = h.useRef(!1), n = h.useRef(() => {
  });
  return h.useEffect(() => {
    const s = (o) => {
      if (o.target && !i.current) {
        let d = function() {
          Ez(
            Zme,
            t,
            a,
            { discrete: !0 }
          );
        };
        const a = { originalEvent: o };
        o.pointerType === "touch" ? (r.removeEventListener("click", n.current), n.current = d, r.addEventListener("click", n.current, { once: !0 })) : d();
      } else
        r.removeEventListener("click", n.current);
      i.current = !1;
    }, u = window.setTimeout(() => {
      r.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(u), r.removeEventListener("pointerdown", s), r.removeEventListener("click", n.current);
    };
  }, [r, t]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => i.current = !0
  };
}
function rge(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Ee(e), i = h.useRef(!1);
  return h.useEffect(() => {
    const n = (s) => {
      s.target && !i.current && Ez(Jme, t, { originalEvent: s }, {
        discrete: !1
      });
    };
    return r.addEventListener("focusin", n), () => r.removeEventListener("focusin", n);
  }, [r, t]), {
    onFocusCapture: () => i.current = !0,
    onBlurCapture: () => i.current = !1
  };
}
function NC() {
  const e = new CustomEvent(Zv);
  document.dispatchEvent(e);
}
function Ez(e, r, t, { discrete: i }) {
  const n = t.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: t });
  r && n.addEventListener(e, r, { once: !0 }), i ? Uv(n, s) : n.dispatchEvent(s);
}
var tge = "VisuallyHidden", kz = h.forwardRef(
  (e, r) => /* @__PURE__ */ l(
    Gi.span,
    {
      ...e,
      ref: r,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
kz.displayName = tge;
var ige = kz, yl = "NavigationMenu", [Z3, Oz, nge] = Nz(yl), [Jv, sge, uge] = Nz(yl), [J3, ser] = Sz(
  yl,
  [nge, uge]
), [oge, Ln] = J3(yl), [dge, age] = J3(yl), Dz = h.forwardRef(
  (e, r) => {
    const {
      __scopeNavigationMenu: t,
      value: i,
      onValueChange: n,
      defaultValue: s,
      delayDuration: u = 200,
      skipDelayDuration: o = 300,
      orientation: d = "horizontal",
      dir: a,
      ...V
    } = e, [c, F] = h.useState(null), X = js(r, (N) => F(N)), Y = Rn(a), q = h.useRef(0), f = h.useRef(0), p = h.useRef(0), [m, g] = h.useState(!0), [y = "", b] = Gr({
      prop: i,
      onChange: (N) => {
        const O = N !== "", E = o > 0;
        O ? (window.clearTimeout(p.current), E && g(!1)) : (window.clearTimeout(p.current), p.current = window.setTimeout(
          () => g(!0),
          o
        )), n == null || n(N);
      },
      defaultProp: s
    }), A = h.useCallback(() => {
      window.clearTimeout(f.current), f.current = window.setTimeout(() => b(""), 150);
    }, [b]), w = h.useCallback(
      (N) => {
        window.clearTimeout(f.current), b(N);
      },
      [b]
    ), S = h.useCallback(
      (N) => {
        y === N ? window.clearTimeout(f.current) : q.current = window.setTimeout(() => {
          window.clearTimeout(f.current), b(N);
        }, u);
      },
      [y, b, u]
    );
    return h.useEffect(() => () => {
      window.clearTimeout(q.current), window.clearTimeout(f.current), window.clearTimeout(p.current);
    }, []), /* @__PURE__ */ l(
      Iz,
      {
        scope: t,
        isRootMenu: !0,
        value: y,
        dir: Y,
        orientation: d,
        rootNavigationMenu: c,
        onTriggerEnter: (N) => {
          window.clearTimeout(q.current), m ? S(N) : w(N);
        },
        onTriggerLeave: () => {
          window.clearTimeout(q.current), A();
        },
        onContentEnter: () => window.clearTimeout(f.current),
        onContentLeave: A,
        onItemSelect: (N) => {
          b((O) => O === N ? "" : N);
        },
        onItemDismiss: () => b(""),
        children: /* @__PURE__ */ l(
          Gi.nav,
          {
            "aria-label": "Main",
            "data-orientation": d,
            dir: Y,
            ...V,
            ref: X
          }
        )
      }
    );
  }
);
Dz.displayName = yl;
var Rz = "NavigationMenuSub", Vge = h.forwardRef(
  (e, r) => {
    const {
      __scopeNavigationMenu: t,
      value: i,
      onValueChange: n,
      defaultValue: s,
      orientation: u = "horizontal",
      ...o
    } = e, d = Ln(Rz, t), [a = "", V] = Gr({
      prop: i,
      onChange: n,
      defaultProp: s
    });
    return /* @__PURE__ */ l(
      Iz,
      {
        scope: t,
        isRootMenu: !1,
        value: a,
        dir: d.dir,
        orientation: u,
        rootNavigationMenu: d.rootNavigationMenu,
        onTriggerEnter: (c) => V(c),
        onItemSelect: (c) => V(c),
        onItemDismiss: () => V(""),
        children: /* @__PURE__ */ l(Gi.div, { "data-orientation": u, ...o, ref: r })
      }
    );
  }
);
Vge.displayName = Rz;
var Iz = (e) => {
  const {
    scope: r,
    isRootMenu: t,
    rootNavigationMenu: i,
    dir: n,
    orientation: s,
    children: u,
    value: o,
    onItemSelect: d,
    onItemDismiss: a,
    onTriggerEnter: V,
    onTriggerLeave: c,
    onContentEnter: F,
    onContentLeave: X
  } = e, [Y, q] = h.useState(null), [f, p] = h.useState(/* @__PURE__ */ new Map()), [m, g] = h.useState(null);
  return /* @__PURE__ */ l(
    oge,
    {
      scope: r,
      isRootMenu: t,
      rootNavigationMenu: i,
      value: o,
      previousValue: Kl(o),
      baseId: ot(),
      dir: n,
      orientation: s,
      viewport: Y,
      onViewportChange: q,
      indicatorTrack: m,
      onIndicatorTrackChange: g,
      onTriggerEnter: Ee(V),
      onTriggerLeave: Ee(c),
      onContentEnter: Ee(F),
      onContentLeave: Ee(X),
      onItemSelect: Ee(d),
      onItemDismiss: Ee(a),
      onViewportContentChange: h.useCallback((y, b) => {
        p((A) => (A.set(y, b), new Map(A)));
      }, []),
      onViewportContentRemove: h.useCallback((y) => {
        p((b) => b.has(y) ? (b.delete(y), new Map(b)) : b);
      }, []),
      children: /* @__PURE__ */ l(Z3.Provider, { scope: r, children: /* @__PURE__ */ l(dge, { scope: r, items: f, children: u }) })
    }
  );
}, Lz = "NavigationMenuList", _z = h.forwardRef(
  (e, r) => {
    const { __scopeNavigationMenu: t, ...i } = e, n = Ln(Lz, t), s = /* @__PURE__ */ l(Gi.ul, { "data-orientation": n.orientation, ...i, ref: r });
    return /* @__PURE__ */ l(Gi.div, { style: { position: "relative" }, ref: n.onIndicatorTrackChange, children: /* @__PURE__ */ l(Z3.Slot, { scope: t, children: n.isRootMenu ? /* @__PURE__ */ l($z, { asChild: !0, children: s }) : s }) });
  }
);
_z.displayName = Lz;
var Hz = "NavigationMenuItem", [lge, jz] = J3(Hz), zz = h.forwardRef(
  (e, r) => {
    const { __scopeNavigationMenu: t, value: i, ...n } = e, s = ot(), u = i || s || "LEGACY_REACT_AUTO_VALUE", o = h.useRef(null), d = h.useRef(null), a = h.useRef(null), V = h.useRef(() => {
    }), c = h.useRef(!1), F = h.useCallback((Y = "start") => {
      if (o.current) {
        V.current();
        const q = Qv(o.current);
        q.length && eA(Y === "start" ? q : q.reverse());
      }
    }, []), X = h.useCallback(() => {
      if (o.current) {
        const Y = Qv(o.current);
        Y.length && (V.current = fge(Y));
      }
    }, []);
    return /* @__PURE__ */ l(
      lge,
      {
        scope: t,
        value: u,
        triggerRef: d,
        contentRef: o,
        focusProxyRef: a,
        wasEscapeCloseRef: c,
        onEntryKeyDown: F,
        onFocusProxyEnter: F,
        onRootContentClose: X,
        onContentFocusOutside: X,
        children: /* @__PURE__ */ l(Gi.li, { ...n, ref: r })
      }
    );
  }
);
zz.displayName = Hz;
var $v = "NavigationMenuTrigger", Bz = h.forwardRef((e, r) => {
  const { __scopeNavigationMenu: t, disabled: i, ...n } = e, s = Ln($v, e.__scopeNavigationMenu), u = jz($v, e.__scopeNavigationMenu), o = h.useRef(null), d = js(o, u.triggerRef, r), a = eB(s.baseId, u.value), V = rB(s.baseId, u.value), c = h.useRef(!1), F = h.useRef(!1), X = u.value === s.value;
  return /* @__PURE__ */ C(he, { children: [
    /* @__PURE__ */ l(Z3.ItemSlot, { scope: t, value: u.value, children: /* @__PURE__ */ l(Qz, { asChild: !0, children: /* @__PURE__ */ l(
      Gi.button,
      {
        id: a,
        disabled: i,
        "data-disabled": i ? "" : void 0,
        "data-state": rA(X),
        "aria-expanded": X,
        "aria-controls": V,
        ...n,
        ref: d,
        onPointerEnter: Lt(e.onPointerEnter, () => {
          F.current = !1, u.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: Lt(
          e.onPointerMove,
          VX(() => {
            i || F.current || u.wasEscapeCloseRef.current || c.current || (s.onTriggerEnter(u.value), c.current = !0);
          })
        ),
        onPointerLeave: Lt(
          e.onPointerLeave,
          VX(() => {
            i || (s.onTriggerLeave(), c.current = !1);
          })
        ),
        onClick: Lt(e.onClick, () => {
          s.onItemSelect(u.value), F.current = X;
        }),
        onKeyDown: Lt(e.onKeyDown, (Y) => {
          const f = { horizontal: "ArrowDown", vertical: s.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[s.orientation];
          X && Y.key === f && (u.onEntryKeyDown(), Y.preventDefault());
        })
      }
    ) }) }),
    X && /* @__PURE__ */ C(he, { children: [
      /* @__PURE__ */ l(
        ige,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: u.focusProxyRef,
          onFocus: (Y) => {
            const q = u.contentRef.current, f = Y.relatedTarget, p = f === o.current, m = q == null ? void 0 : q.contains(f);
            (p || !m) && u.onFocusProxyEnter(p ? "start" : "end");
          }
        }
      ),
      s.viewport && /* @__PURE__ */ l("span", { "aria-owns": V })
    ] })
  ] });
});
Bz.displayName = $v;
var cge = "NavigationMenuLink", MC = "navigationMenu.linkSelect", Wz = h.forwardRef(
  (e, r) => {
    const { __scopeNavigationMenu: t, active: i, onSelect: n, ...s } = e;
    return /* @__PURE__ */ l(Qz, { asChild: !0, children: /* @__PURE__ */ l(
      Gi.a,
      {
        "data-active": i ? "" : void 0,
        "aria-current": i ? "page" : void 0,
        ...s,
        ref: r,
        onClick: Lt(
          e.onClick,
          (u) => {
            const o = u.target, d = new CustomEvent(MC, {
              bubbles: !0,
              cancelable: !0
            });
            if (o.addEventListener(MC, (a) => n == null ? void 0 : n(a), { once: !0 }), Uv(o, d), !d.defaultPrevented && !u.metaKey) {
              const a = new CustomEvent(Ix, {
                bubbles: !0,
                cancelable: !0
              });
              Uv(o, a);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Wz.displayName = cge;
var $3 = "NavigationMenuIndicator", Gz = h.forwardRef((e, r) => {
  const { forceMount: t, ...i } = e, n = Ln($3, e.__scopeNavigationMenu), s = !!n.value;
  return n.indicatorTrack ? Us.createPortal(
    /* @__PURE__ */ l(m2, { present: t || s, children: /* @__PURE__ */ l(Fge, { ...i, ref: r }) }),
    n.indicatorTrack
  ) : null;
});
Gz.displayName = $3;
var Fge = h.forwardRef((e, r) => {
  const { __scopeNavigationMenu: t, ...i } = e, n = Ln($3, t), s = Oz(t), [u, o] = h.useState(
    null
  ), [d, a] = h.useState(null), V = n.orientation === "horizontal", c = !!n.value;
  h.useEffect(() => {
    var q;
    const Y = (q = s().find((f) => f.value === n.value)) == null ? void 0 : q.ref.current;
    Y && o(Y);
  }, [s, n.value]);
  const F = () => {
    u && a({
      size: V ? u.offsetWidth : u.offsetHeight,
      offset: V ? u.offsetLeft : u.offsetTop
    });
  };
  return e8(u, F), e8(n.indicatorTrack, F), d ? /* @__PURE__ */ l(
    Gi.div,
    {
      "aria-hidden": !0,
      "data-state": c ? "visible" : "hidden",
      "data-orientation": n.orientation,
      ...i,
      ref: r,
      style: {
        position: "absolute",
        ...V ? {
          left: 0,
          width: d.size + "px",
          transform: `translateX(${d.offset}px)`
        } : {
          top: 0,
          height: d.size + "px",
          transform: `translateY(${d.offset}px)`
        },
        ...i.style
      }
    }
  ) : null;
}), SV = "NavigationMenuContent", Uz = h.forwardRef((e, r) => {
  const { forceMount: t, ...i } = e, n = Ln(SV, e.__scopeNavigationMenu), s = jz(SV, e.__scopeNavigationMenu), u = js(s.contentRef, r), o = s.value === n.value, d = {
    value: s.value,
    triggerRef: s.triggerRef,
    focusProxyRef: s.focusProxyRef,
    wasEscapeCloseRef: s.wasEscapeCloseRef,
    onContentFocusOutside: s.onContentFocusOutside,
    onRootContentClose: s.onRootContentClose,
    ...i
  };
  return n.viewport ? /* @__PURE__ */ l(xge, { forceMount: t, ...d, ref: u }) : /* @__PURE__ */ l(m2, { present: t || o, children: /* @__PURE__ */ l(
    Zz,
    {
      "data-state": rA(o),
      ...d,
      ref: u,
      onPointerEnter: Lt(e.onPointerEnter, n.onContentEnter),
      onPointerLeave: Lt(
        e.onPointerLeave,
        VX(n.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !o && n.isRootMenu ? "none" : void 0,
        ...d.style
      }
    }
  ) });
});
Uz.displayName = SV;
var xge = h.forwardRef((e, r) => {
  const t = Ln(SV, e.__scopeNavigationMenu), { onViewportContentChange: i, onViewportContentRemove: n } = t;
  return ze(() => {
    i(e.value, {
      ref: r,
      ...e
    });
  }, [e, r, i]), ze(() => () => n(e.value), [e.value, n]), null;
}), Ix = "navigationMenu.rootContentDismiss", Zz = h.forwardRef((e, r) => {
  const {
    __scopeNavigationMenu: t,
    value: i,
    triggerRef: n,
    focusProxyRef: s,
    wasEscapeCloseRef: u,
    onRootContentClose: o,
    onContentFocusOutside: d,
    ...a
  } = e, V = Ln(SV, t), c = h.useRef(null), F = js(c, r), X = eB(V.baseId, i), Y = rB(V.baseId, i), q = Oz(t), f = h.useRef(null), { onItemDismiss: p } = V;
  h.useEffect(() => {
    const g = c.current;
    if (V.isRootMenu && g) {
      const y = () => {
        var b;
        p(), o(), g.contains(document.activeElement) && ((b = n.current) == null || b.focus());
      };
      return g.addEventListener(Ix, y), () => g.removeEventListener(Ix, y);
    }
  }, [V.isRootMenu, e.value, n, p, o]);
  const m = h.useMemo(() => {
    const y = q().map((O) => O.value);
    V.dir === "rtl" && y.reverse();
    const b = y.indexOf(V.value), A = y.indexOf(V.previousValue), w = i === V.value, S = A === y.indexOf(i);
    if (!w && !S) return f.current;
    const N = (() => {
      if (b !== A) {
        if (w && A !== -1) return b > A ? "from-end" : "from-start";
        if (S && b !== -1) return b > A ? "to-start" : "to-end";
      }
      return null;
    })();
    return f.current = N, N;
  }, [V.previousValue, V.value, V.dir, q, i]);
  return /* @__PURE__ */ l($z, { asChild: !0, children: /* @__PURE__ */ l(
    Tz,
    {
      id: Y,
      "aria-labelledby": X,
      "data-motion": m,
      "data-orientation": V.orientation,
      ...a,
      ref: F,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        var y;
        const g = new Event(Ix, {
          bubbles: !0,
          cancelable: !0
        });
        (y = c.current) == null || y.dispatchEvent(g);
      },
      onFocusOutside: Lt(e.onFocusOutside, (g) => {
        var b;
        d();
        const y = g.target;
        (b = V.rootNavigationMenu) != null && b.contains(y) && g.preventDefault();
      }),
      onPointerDownOutside: Lt(e.onPointerDownOutside, (g) => {
        var w;
        const y = g.target, b = q().some((S) => {
          var N;
          return (N = S.ref.current) == null ? void 0 : N.contains(y);
        }), A = V.isRootMenu && ((w = V.viewport) == null ? void 0 : w.contains(y));
        (b || A || !V.isRootMenu) && g.preventDefault();
      }),
      onKeyDown: Lt(e.onKeyDown, (g) => {
        var A;
        const y = g.altKey || g.ctrlKey || g.metaKey;
        if (g.key === "Tab" && !y) {
          const w = Qv(g.currentTarget), S = document.activeElement, N = w.findIndex((I) => I === S), E = g.shiftKey ? w.slice(0, N).reverse() : w.slice(N + 1, w.length);
          eA(E) ? g.preventDefault() : (A = s.current) == null || A.focus();
        }
      }),
      onEscapeKeyDown: Lt(e.onEscapeKeyDown, (g) => {
        u.current = !0;
      })
    }
  ) });
}), Q3 = "NavigationMenuViewport", Jz = h.forwardRef((e, r) => {
  const { forceMount: t, ...i } = e, s = !!Ln(Q3, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ l(m2, { present: t || s, children: /* @__PURE__ */ l(Xge, { ...i, ref: r }) });
});
Jz.displayName = Q3;
var Xge = h.forwardRef((e, r) => {
  const { __scopeNavigationMenu: t, children: i, ...n } = e, s = Ln(Q3, t), u = js(r, s.onViewportChange), o = age(
    SV,
    e.__scopeNavigationMenu
  ), [d, a] = h.useState(null), [V, c] = h.useState(null), F = d ? (d == null ? void 0 : d.width) + "px" : void 0, X = d ? (d == null ? void 0 : d.height) + "px" : void 0, Y = !!s.value, q = Y ? s.value : s.previousValue;
  return e8(V, () => {
    V && a({ width: V.offsetWidth, height: V.offsetHeight });
  }), /* @__PURE__ */ l(
    Gi.div,
    {
      "data-state": rA(Y),
      "data-orientation": s.orientation,
      ...n,
      ref: u,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !Y && s.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": F,
        "--radix-navigation-menu-viewport-height": X,
        ...n.style
      },
      onPointerEnter: Lt(e.onPointerEnter, s.onContentEnter),
      onPointerLeave: Lt(e.onPointerLeave, VX(s.onContentLeave)),
      children: Array.from(o.items).map(([p, { ref: m, forceMount: g, ...y }]) => {
        const b = q === p;
        return /* @__PURE__ */ l(m2, { present: g || b, children: /* @__PURE__ */ l(
          Zz,
          {
            ...y,
            ref: U3(m, (A) => {
              b && A && c(A);
            })
          }
        ) }, p);
      })
    }
  );
}), qge = "FocusGroup", $z = h.forwardRef(
  (e, r) => {
    const { __scopeNavigationMenu: t, ...i } = e, n = Ln(qge, t);
    return /* @__PURE__ */ l(Jv.Provider, { scope: t, children: /* @__PURE__ */ l(Jv.Slot, { scope: t, children: /* @__PURE__ */ l(Gi.div, { dir: n.dir, ...i, ref: r }) }) });
  }
), TC = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], Yge = "FocusGroupItem", Qz = h.forwardRef(
  (e, r) => {
    const { __scopeNavigationMenu: t, ...i } = e, n = sge(t), s = Ln(Yge, t);
    return /* @__PURE__ */ l(Jv.ItemSlot, { scope: t, children: /* @__PURE__ */ l(
      Gi.button,
      {
        ...i,
        ref: r,
        onKeyDown: Lt(e.onKeyDown, (u) => {
          if (["Home", "End", ...TC].includes(u.key)) {
            let d = n().map((c) => c.ref.current);
            if ([s.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(u.key) && d.reverse(), TC.includes(u.key)) {
              const c = d.indexOf(u.currentTarget);
              d = d.slice(c + 1);
            }
            setTimeout(() => eA(d)), u.preventDefault();
          }
        })
      }
    ) });
  }
);
function Qv(e) {
  const r = [], t = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (i) => {
      const n = i.tagName === "INPUT" && i.type === "hidden";
      return i.disabled || i.hidden || n ? NodeFilter.FILTER_SKIP : i.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); ) r.push(t.currentNode);
  return r;
}
function eA(e) {
  const r = document.activeElement;
  return e.some((t) => t === r ? !0 : (t.focus(), document.activeElement !== r));
}
function fge(e) {
  return e.forEach((r) => {
    r.dataset.tabindex = r.getAttribute("tabindex") || "", r.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((r) => {
      const t = r.dataset.tabindex;
      r.setAttribute("tabindex", t);
    });
  };
}
function e8(e, r) {
  const t = Ee(r);
  ze(() => {
    let i = 0;
    if (e) {
      const n = new ResizeObserver(() => {
        cancelAnimationFrame(i), i = window.requestAnimationFrame(t);
      });
      return n.observe(e), () => {
        window.cancelAnimationFrame(i), n.unobserve(e);
      };
    }
  }, [e, t]);
}
function rA(e) {
  return e ? "open" : "closed";
}
function eB(e, r) {
  return `${e}-trigger-${r}`;
}
function rB(e, r) {
  return `${e}-content-${r}`;
}
function VX(e) {
  return (r) => r.pointerType === "mouse" ? e(r) : void 0;
}
var tB = Dz, iB = _z, Kge = zz, nB = Bz, hge = Wz, sB = Gz, uB = Uz, oB = Jz;
const pge = re(({ className: e, children: r, ...t }, i) => /* @__PURE__ */ C(
  tB,
  {
    ref: i,
    className: _(
      "relative z-10 flex max-w-max flex-1 items-center justify-center",
      e
    ),
    ...t,
    children: [
      r,
      /* @__PURE__ */ l(dB, {})
    ]
  }
));
pge.displayName = tB.displayName;
const mge = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  iB,
  {
    ref: t,
    className: _(
      "group flex flex-1 list-none items-center justify-center space-x-1",
      e
    ),
    ...r
  }
));
mge.displayName = iB.displayName;
const uer = Kge, gge = Js(
  "group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-bodysm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-hidden disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50"
), vge = re(({ className: e, children: r, ...t }, i) => /* @__PURE__ */ C(
  nB,
  {
    ref: i,
    className: _(gge(), "group", e),
    ...t,
    children: [
      r,
      " ",
      /* @__PURE__ */ l(
        e2,
        {
          className: "relative top-[1px] ml-1 h-3 w-3 transition duration-200 group-data-[state=open]:rotate-180",
          "aria-hidden": "true"
        }
      )
    ]
  }
));
vge.displayName = nB.displayName;
const bge = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  uB,
  {
    ref: t,
    className: _(
      "data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52 left-0 top-0 w-full md:absolute md:w-auto ",
      e
    ),
    ...r
  }
));
bge.displayName = uB.displayName;
const oer = hge, dB = re(({ className: e, ...r }, t) => /* @__PURE__ */ l("div", { className: _("absolute left-0 top-full flex justify-center"), children: /* @__PURE__ */ l(
  oB,
  {
    className: _(
      "origin-top-center bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-90 relative mt-1.5 h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden rounded-md border shadow-lg md:w-[var(--radix-navigation-menu-viewport-width)]",
      e
    ),
    ref: t,
    ...r
  }
) }));
dB.displayName = oB.displayName;
const yge = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  sB,
  {
    ref: t,
    className: _(
      "data-[state=visible]:animate-in data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:fade-in top-full z-[1] flex h-1.5 items-end justify-center overflow-hidden",
      e
    ),
    ...r,
    children: /* @__PURE__ */ l("div", { className: "bg-border relative top-[60%] h-2 w-2 rotate-45 rounded-tl-sm shadow-md" })
  }
));
yge.displayName = sB.displayName;
const Age = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  p2,
  {
    className: _("grid gap-2", e),
    ...r,
    ref: t
  }
));
Age.displayName = p2.displayName;
const wge = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  yo,
  {
    ref: t,
    className: _(
      "border-primary text-primary ring-offset-background focus-visible:ring-ring aspect-square h-4 w-4 rounded-full focus:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 border",
      e
    ),
    ...r,
    children: /* @__PURE__ */ l(Mme, { className: "flex items-center justify-center", children: /* @__PURE__ */ l(Gc, { className: "h-2.5 w-2.5 fill-current text-current" }) })
  }
));
wge.displayName = yo.displayName;
function Cge({ checked: e, className: r }) {
  return /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      className: r,
      children: [
        /* @__PURE__ */ l("rect", { x: "1", y: "1", width: "22", height: "22", rx: "11", fill: "none" }),
        /* @__PURE__ */ l(
          "rect",
          {
            x: "1",
            y: "1",
            width: "22",
            height: "22",
            rx: "11",
            stroke: "currentcolor",
            strokeWidth: "2"
          }
        ),
        /* @__PURE__ */ l("circle", { cx: "12", cy: "12", r: "8", fill: e ? "currentcolor" : "none" })
      ]
    }
  );
}
function aB({
  allowMultiSelect: e = !0,
  className: r,
  disabled: t,
  filter: i,
  hideHeader: n,
  hideSearch: s,
  onChange: u,
  onInputChange: o,
  options: d,
  placeholder: a,
  renderInline: V = !1,
  values: c
}) {
  const F = Yr(null), [X, Y] = ie(V), [q, f] = ie(""), p = Yi(
    (m) => {
      const g = F.current;
      if (g) {
        if ((m.key === "Delete" || m.key === "Backspace") && g.value === "") {
          const y = [...c];
          y.pop(), u(y);
        }
        m.key === "Escape" && g.blur();
      }
    },
    [u, c]
  );
  return /* @__PURE__ */ C(
    hl,
    {
      className: "overflow-visible bg-transparent",
      filter: i,
      onKeyDown: p,
      children: [
        n ? null : /* @__PURE__ */ C(
          "div",
          {
            className: _(
              "border-input bg-interfaceWhite ring-offset-background focus-within:ring-ring text-bodysm focus:outline-hidden group flex w-full items-center justify-between rounded-md border px-3 py-2 focus-within:ring-2 focus-within:ring-offset-2",
              r
            ),
            ...s ? {
              tabIndex: 0,
              onBlur: () => {
                V || Y(!1);
              },
              onFocus: () => Y(!0)
            } : {},
            children: [
              /* @__PURE__ */ C("div", { className: "flex flex-wrap gap-1 text-ellipsis", children: [
                c.map((m, g) => {
                  const y = g === c.length - 1;
                  return /* @__PURE__ */ C("span", { children: [
                    m.label,
                    y ? null : ", "
                  ] }, m.value);
                }),
                a && s && c.length === 0 ? /* @__PURE__ */ l("span", { className: "text-muted-foreground bg-transparent", children: a }) : null,
                s ? null : /* @__PURE__ */ l(
                  ui.Input,
                  {
                    className: "placeholder:text-muted-foreground outline-hidden ml-2 flex-1 bg-transparent",
                    disabled: t,
                    onBlur: () => {
                      V || Y(!1);
                    },
                    onFocus: () => Y(!0),
                    onValueChange: (m) => {
                      f(m), o == null || o(m);
                    },
                    placeholder: a,
                    ref: F,
                    value: q
                  }
                )
              ] }),
              /* @__PURE__ */ l(
                "div",
                {
                  onClick: () => {
                    var m;
                    Y((g) => !g), s || (m = F.current) == null || m.focus();
                  },
                  children: /* @__PURE__ */ l(e2, { className: "h-4 w-4" })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ l("div", { className: "relative", children: /* @__PURE__ */ l(a2, { children: X && d.length > 0 ? /* @__PURE__ */ l(
          "div",
          {
            className: _(
              "text-popover-foreground animate-in outline-hidden mt-2 max-h-64 w-full overflow-auto rounded-md shadow-md",
              V ? "" : "bg-popover border-border absolute top-0 z-10 border"
            ),
            children: /* @__PURE__ */ l(V2, { className: "h-full", children: d.map((m) => {
              const g = c.some((y) => y.value === m.value);
              return /* @__PURE__ */ C(
                l2,
                {
                  className: "text-bodymd cursor-pointer gap-2",
                  disabled: t,
                  keywords: m.keywords,
                  onMouseDown: (y) => {
                    y.preventDefault(), y.stopPropagation();
                  },
                  onSelect: (y) => {
                    if (f(""), o == null || o(""), !e)
                      u([m]);
                    else {
                      const b = c.some(
                        (A) => A.value === m.value
                      );
                      u(
                        b ? c.filter((A) => A.value !== m.value) : [...c, m]
                      );
                    }
                  },
                  children: [
                    e ? /* @__PURE__ */ l(Ad, { checked: g }) : /* @__PURE__ */ l(
                      Cge,
                      {
                        checked: g,
                        className: _(
                          "min-h-6 min-w-6",
                          g ? "text-textLink" : "text-interactiveBorder"
                        )
                      }
                    ),
                    m.label
                  ]
                },
                m.value
              );
            }) })
          }
        ) : null }) })
      ]
    }
  );
}
var Pge = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], r8 = Pge.reduce((e, r) => {
  const t = h.forwardRef((i, n) => {
    const { asChild: s, ...u } = i, o = s ? xn : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l(o, { ...u, ref: n });
  });
  return t.displayName = `Primitive.${r}`, { ...e, [r]: t };
}, {});
function qV(e, r, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), t === !1 || !n.defaultPrevented)
      return r == null ? void 0 : r(n);
  };
}
function EC(e, r) {
  if (typeof e == "function")
    return e(r);
  e != null && (e.current = r);
}
function Sge(...e) {
  return (r) => {
    let t = !1;
    const i = e.map((n) => {
      const s = EC(n, r);
      return !t && typeof s == "function" && (t = !0), s;
    });
    if (t)
      return () => {
        for (let n = 0; n < i.length; n++) {
          const s = i[n];
          typeof s == "function" ? s() : EC(e[n], null);
        }
      };
  };
}
function kC(...e) {
  return h.useCallback(Sge(...e), e);
}
function Nge(e) {
  const r = e + "CollectionProvider", [t, i] = rY(r), [n, s] = t(
    r,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), u = (X) => {
    const { scope: Y, children: q } = X, f = D.useRef(null), p = D.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ l(n, { scope: Y, itemMap: p, collectionRef: f, children: q });
  };
  u.displayName = r;
  const o = e + "CollectionSlot", d = D.forwardRef(
    (X, Y) => {
      const { scope: q, children: f } = X, p = s(o, q), m = kC(Y, p.collectionRef);
      return /* @__PURE__ */ l(xn, { ref: m, children: f });
    }
  );
  d.displayName = o;
  const a = e + "CollectionItemSlot", V = "data-radix-collection-item", c = D.forwardRef(
    (X, Y) => {
      const { scope: q, children: f, ...p } = X, m = D.useRef(null), g = kC(Y, m), y = s(a, q);
      return D.useEffect(() => (y.itemMap.set(m, { ref: m, ...p }), () => void y.itemMap.delete(m))), /* @__PURE__ */ l(xn, { [V]: "", ref: g, children: f });
    }
  );
  c.displayName = a;
  function F(X) {
    const Y = s(e + "CollectionConsumer", X);
    return D.useCallback(() => {
      const f = Y.collectionRef.current;
      if (!f) return [];
      const p = Array.from(f.querySelectorAll(`[${V}]`));
      return Array.from(Y.itemMap.values()).sort(
        (y, b) => p.indexOf(y.ref.current) - p.indexOf(b.ref.current)
      );
    }, [Y.collectionRef, Y.itemMap]);
  }
  return [
    { Provider: u, Slot: d, ItemSlot: c },
    F,
    i
  ];
}
function OC(e, r) {
  if (typeof e == "function")
    return e(r);
  e != null && (e.current = r);
}
function Mge(...e) {
  return (r) => {
    let t = !1;
    const i = e.map((n) => {
      const s = OC(n, r);
      return !t && typeof s == "function" && (t = !0), s;
    });
    if (t)
      return () => {
        for (let n = 0; n < i.length; n++) {
          const s = i[n];
          typeof s == "function" ? s() : OC(e[n], null);
        }
      };
  };
}
function Tge(...e) {
  return h.useCallback(Mge(...e), e);
}
var Ege = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], VB = Ege.reduce((e, r) => {
  const t = h.forwardRef((i, n) => {
    const { asChild: s, ...u } = i, o = s ? xn : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l(o, { ...u, ref: n });
  });
  return t.displayName = `Primitive.${r}`, { ...e, [r]: t };
}, {}), Fp = "rovingFocusGroup.onEntryFocus", kge = { bubbles: !1, cancelable: !0 }, TY = "RovingFocusGroup", [t8, lB, Oge] = Nge(TY), [Dge, cB] = rY(
  TY,
  [Oge]
), [Rge, Ige] = Dge(TY), FB = h.forwardRef(
  (e, r) => /* @__PURE__ */ l(t8.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ l(t8.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ l(Lge, { ...e, ref: r }) }) })
);
FB.displayName = TY;
var Lge = h.forwardRef((e, r) => {
  const {
    __scopeRovingFocusGroup: t,
    orientation: i,
    loop: n = !1,
    dir: s,
    currentTabStopId: u,
    defaultCurrentTabStopId: o,
    onCurrentTabStopIdChange: d,
    onEntryFocus: a,
    preventScrollOnEntryFocus: V = !1,
    ...c
  } = e, F = h.useRef(null), X = Tge(r, F), Y = Rn(s), [q = null, f] = Gr({
    prop: u,
    defaultProp: o,
    onChange: d
  }), [p, m] = h.useState(!1), g = Ee(a), y = lB(t), b = h.useRef(!1), [A, w] = h.useState(0);
  return h.useEffect(() => {
    const S = F.current;
    if (S)
      return S.addEventListener(Fp, g), () => S.removeEventListener(Fp, g);
  }, [g]), /* @__PURE__ */ l(
    Rge,
    {
      scope: t,
      orientation: i,
      dir: Y,
      loop: n,
      currentTabStopId: q,
      onItemFocus: h.useCallback(
        (S) => f(S),
        [f]
      ),
      onItemShiftTab: h.useCallback(() => m(!0), []),
      onFocusableItemAdd: h.useCallback(
        () => w((S) => S + 1),
        []
      ),
      onFocusableItemRemove: h.useCallback(
        () => w((S) => S - 1),
        []
      ),
      children: /* @__PURE__ */ l(
        VB.div,
        {
          tabIndex: p || A === 0 ? -1 : 0,
          "data-orientation": i,
          ...c,
          ref: X,
          style: { outline: "none", ...e.style },
          onMouseDown: qV(e.onMouseDown, () => {
            b.current = !0;
          }),
          onFocus: qV(e.onFocus, (S) => {
            const N = !b.current;
            if (S.target === S.currentTarget && N && !p) {
              const O = new CustomEvent(Fp, kge);
              if (S.currentTarget.dispatchEvent(O), !O.defaultPrevented) {
                const E = y().filter((B) => B.focusable), I = E.find((B) => B.active), R = E.find((B) => B.id === q), W = [I, R, ...E].filter(
                  Boolean
                ).map((B) => B.ref.current);
                qB(W, V);
              }
            }
            b.current = !1;
          }),
          onBlur: qV(e.onBlur, () => m(!1))
        }
      )
    }
  );
}), xB = "RovingFocusGroupItem", XB = h.forwardRef(
  (e, r) => {
    const {
      __scopeRovingFocusGroup: t,
      focusable: i = !0,
      active: n = !1,
      tabStopId: s,
      ...u
    } = e, o = ot(), d = s || o, a = Ige(xB, t), V = a.currentTabStopId === d, c = lB(t), { onFocusableItemAdd: F, onFocusableItemRemove: X } = a;
    return h.useEffect(() => {
      if (i)
        return F(), () => X();
    }, [i, F, X]), /* @__PURE__ */ l(
      t8.ItemSlot,
      {
        scope: t,
        id: d,
        focusable: i,
        active: n,
        children: /* @__PURE__ */ l(
          VB.span,
          {
            tabIndex: V ? 0 : -1,
            "data-orientation": a.orientation,
            ...u,
            ref: r,
            onMouseDown: qV(e.onMouseDown, (Y) => {
              i ? a.onItemFocus(d) : Y.preventDefault();
            }),
            onFocus: qV(e.onFocus, () => a.onItemFocus(d)),
            onKeyDown: qV(e.onKeyDown, (Y) => {
              if (Y.key === "Tab" && Y.shiftKey) {
                a.onItemShiftTab();
                return;
              }
              if (Y.target !== Y.currentTarget) return;
              const q = jge(Y, a.orientation, a.dir);
              if (q !== void 0) {
                if (Y.metaKey || Y.ctrlKey || Y.altKey || Y.shiftKey) return;
                Y.preventDefault();
                let p = c().filter((m) => m.focusable).map((m) => m.ref.current);
                if (q === "last") p.reverse();
                else if (q === "prev" || q === "next") {
                  q === "prev" && p.reverse();
                  const m = p.indexOf(Y.currentTarget);
                  p = a.loop ? zge(p, m + 1) : p.slice(m + 1);
                }
                setTimeout(() => qB(p));
              }
            })
          }
        )
      }
    );
  }
);
XB.displayName = xB;
var _ge = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Hge(e, r) {
  return r !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function jge(e, r, t) {
  const i = Hge(e.key, t);
  if (!(r === "vertical" && ["ArrowLeft", "ArrowRight"].includes(i)) && !(r === "horizontal" && ["ArrowUp", "ArrowDown"].includes(i)))
    return _ge[i];
}
function qB(e, r = !1) {
  const t = document.activeElement;
  for (const i of e)
    if (i === t || (i.focus({ preventScroll: r }), document.activeElement !== t)) return;
}
function zge(e, r) {
  return e.map((t, i) => e[(r + i) % e.length]);
}
var Bge = FB, Wge = XB;
function Gge(e, r, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), t === !1 || !n.defaultPrevented)
      return r == null ? void 0 : r(n);
  };
}
var Uge = "Toggle", YB = h.forwardRef((e, r) => {
  const { pressed: t, defaultPressed: i = !1, onPressedChange: n, ...s } = e, [u = !1, o] = Gr({
    prop: t,
    onChange: n,
    defaultProp: i
  });
  return /* @__PURE__ */ l(
    r8.button,
    {
      type: "button",
      "aria-pressed": u,
      "data-state": u ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...s,
      ref: r,
      onClick: Gge(e.onClick, () => {
        e.disabled || o(!u);
      })
    }
  );
});
YB.displayName = Uge;
var Al = "ToggleGroup", [fB, der] = rY(Al, [
  cB
]), KB = cB(), tA = D.forwardRef((e, r) => {
  const { type: t, ...i } = e;
  if (t === "single")
    return /* @__PURE__ */ l(Zge, { ...i, ref: r });
  if (t === "multiple")
    return /* @__PURE__ */ l(Jge, { ...i, ref: r });
  throw new Error(`Missing prop \`type\` expected on \`${Al}\``);
});
tA.displayName = Al;
var [hB, pB] = fB(Al), Zge = D.forwardRef((e, r) => {
  const {
    value: t,
    defaultValue: i,
    onValueChange: n = () => {
    },
    ...s
  } = e, [u, o] = Gr({
    prop: t,
    defaultProp: i,
    onChange: n
  });
  return /* @__PURE__ */ l(
    hB,
    {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: u ? [u] : [],
      onItemActivate: o,
      onItemDeactivate: D.useCallback(() => o(""), [o]),
      children: /* @__PURE__ */ l(mB, { ...s, ref: r })
    }
  );
}), Jge = D.forwardRef((e, r) => {
  const {
    value: t,
    defaultValue: i,
    onValueChange: n = () => {
    },
    ...s
  } = e, [u = [], o] = Gr({
    prop: t,
    defaultProp: i,
    onChange: n
  }), d = D.useCallback(
    (V) => o((c = []) => [...c, V]),
    [o]
  ), a = D.useCallback(
    (V) => o((c = []) => c.filter((F) => F !== V)),
    [o]
  );
  return /* @__PURE__ */ l(
    hB,
    {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: u,
      onItemActivate: d,
      onItemDeactivate: a,
      children: /* @__PURE__ */ l(mB, { ...s, ref: r })
    }
  );
});
tA.displayName = Al;
var [$ge, Qge] = fB(Al), mB = D.forwardRef(
  (e, r) => {
    const {
      __scopeToggleGroup: t,
      disabled: i = !1,
      rovingFocus: n = !0,
      orientation: s,
      dir: u,
      loop: o = !0,
      ...d
    } = e, a = KB(t), V = Rn(u), c = { role: "group", dir: V, ...d };
    return /* @__PURE__ */ l($ge, { scope: t, rovingFocus: n, disabled: i, children: n ? /* @__PURE__ */ l(
      Bge,
      {
        asChild: !0,
        ...a,
        orientation: s,
        dir: V,
        loop: o,
        children: /* @__PURE__ */ l(r8.div, { ...c, ref: r })
      }
    ) : /* @__PURE__ */ l(r8.div, { ...c, ref: r }) });
  }
), lX = "ToggleGroupItem", gB = D.forwardRef(
  (e, r) => {
    const t = pB(lX, e.__scopeToggleGroup), i = Qge(lX, e.__scopeToggleGroup), n = KB(e.__scopeToggleGroup), s = t.value.includes(e.value), u = i.disabled || e.disabled, o = { ...e, pressed: s, disabled: u }, d = D.useRef(null);
    return i.rovingFocus ? /* @__PURE__ */ l(
      Wge,
      {
        asChild: !0,
        ...n,
        focusable: !u,
        active: s,
        ref: d,
        children: /* @__PURE__ */ l(DC, { ...o, ref: r })
      }
    ) : /* @__PURE__ */ l(DC, { ...o, ref: r });
  }
);
gB.displayName = lX;
var DC = D.forwardRef(
  (e, r) => {
    const { __scopeToggleGroup: t, value: i, ...n } = e, s = pB(lX, t), u = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, o = s.type === "single" ? u : void 0;
    return /* @__PURE__ */ l(
      YB,
      {
        ...o,
        ...n,
        ref: r,
        onPressedChange: (d) => {
          d ? s.onItemActivate(i) : s.onItemDeactivate(i);
        }
      }
    );
  }
), eve = tA, rve = gB;
function tve({
  options: e,
  groupValue: r,
  setGroupValue: t
}) {
  return /* @__PURE__ */ l("div", { children: /* @__PURE__ */ l(
    eve,
    {
      className: "flex flex-row flex-wrap gap-1",
      type: "multiple",
      orientation: "horizontal",
      value: r,
      onValueChange: (i) => t(i),
      "aria-label": "Text alignment",
      children: e.length > 0 && e.map((i, n) => /* @__PURE__ */ C(
        rve,
        {
          className: "data-[state=on]:bg-actionBgSelect data-[state=on]:text-actionHover data-[state=on]:border-actionBorder border-interactiveBorder bg-interfaceWhite data-[state=off]:hover:bg-interfaceBgDefault data-[state=off]:hover:border-interactiveBorderHover flex flex-row items-center rounded-sm border px-3 py-2 text-bodymd font-normal data-[state=on]:border-2",
          value: i,
          children: [
            /* @__PURE__ */ l(
              "div",
              {
                className: `${r.includes(i) ? "bg-actionDefault border-none" : "bg-interfaceWhite"} border-interactiveBorder mr-1.5 flex h-3 w-3 items-center justify-center rounded-xs border`,
                children: r.includes(i) && /* @__PURE__ */ l(Bo, { className: "text-textWhite h-3 w-3" })
              }
            ),
            /* @__PURE__ */ l("div", { children: i })
          ]
        },
        n
      ))
    }
  ) });
}
function ive(e, r) {
  return h.useReducer((t, i) => r[t][i] ?? t, e);
}
var g2 = (e) => {
  const { present: r, children: t } = e, i = nve(r), n = typeof t == "function" ? t({ present: i.isPresent }) : h.Children.only(t), s = rr(i.ref, sve(n));
  return typeof t == "function" || i.isPresent ? h.cloneElement(n, { ref: s }) : null;
};
g2.displayName = "Presence";
function nve(e) {
  const [r, t] = h.useState(), i = h.useRef({}), n = h.useRef(e), s = h.useRef("none"), u = e ? "mounted" : "unmounted", [o, d] = ive(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return h.useEffect(() => {
    const a = nx(i.current);
    s.current = o === "mounted" ? a : "none";
  }, [o]), ze(() => {
    const a = i.current, V = n.current;
    if (V !== e) {
      const F = s.current, X = nx(a);
      e ? d("MOUNT") : X === "none" || (a == null ? void 0 : a.display) === "none" ? d("UNMOUNT") : d(V && F !== X ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, d]), ze(() => {
    if (r) {
      let a;
      const V = r.ownerDocument.defaultView ?? window, c = (X) => {
        const q = nx(i.current).includes(X.animationName);
        if (X.target === r && q && (d("ANIMATION_END"), !n.current)) {
          const f = r.style.animationFillMode;
          r.style.animationFillMode = "forwards", a = V.setTimeout(() => {
            r.style.animationFillMode === "forwards" && (r.style.animationFillMode = f);
          });
        }
      }, F = (X) => {
        X.target === r && (s.current = nx(i.current));
      };
      return r.addEventListener("animationstart", F), r.addEventListener("animationcancel", c), r.addEventListener("animationend", c), () => {
        V.clearTimeout(a), r.removeEventListener("animationstart", F), r.removeEventListener("animationcancel", c), r.removeEventListener("animationend", c);
      };
    } else
      d("ANIMATION_END");
  }, [r, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: h.useCallback((a) => {
      a && (i.current = getComputedStyle(a)), t(a);
    }, [])
  };
}
function nx(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function sve(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
function uve(e, r = []) {
  let t = [];
  function i(s, u) {
    const o = h.createContext(u), d = t.length;
    t = [...t, u];
    const a = (c) => {
      var p;
      const { scope: F, children: X, ...Y } = c, q = ((p = F == null ? void 0 : F[e]) == null ? void 0 : p[d]) || o, f = h.useMemo(() => Y, Object.values(Y));
      return /* @__PURE__ */ l(q.Provider, { value: f, children: X });
    };
    a.displayName = s + "Provider";
    function V(c, F) {
      var q;
      const X = ((q = F == null ? void 0 : F[e]) == null ? void 0 : q[d]) || o, Y = h.useContext(X);
      if (Y) return Y;
      if (u !== void 0) return u;
      throw new Error(`\`${c}\` must be used within \`${s}\``);
    }
    return [a, V];
  }
  const n = () => {
    const s = t.map((u) => h.createContext(u));
    return function(o) {
      const d = (o == null ? void 0 : o[e]) || s;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: d } }),
        [o, d]
      );
    };
  };
  return n.scopeName = e, [i, ove(n, ...r)];
}
function ove(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const t = () => {
    const i = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(s) {
      const u = i.reduce((o, { useScope: d, scopeName: a }) => {
        const c = d(s)[`__scope${a}`];
        return { ...o, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${r.scopeName}`]: u }), [u]);
    };
  };
  return t.scopeName = r.scopeName, t;
}
function t7(e, [r, t]) {
  return Math.min(t, Math.max(r, e));
}
function dve(e, r) {
  return h.useReducer((t, i) => r[t][i] ?? t, e);
}
var iA = "ScrollArea", [vB, aer] = uve(iA), [ave, _n] = vB(iA), bB = h.forwardRef(
  (e, r) => {
    const {
      __scopeScrollArea: t,
      type: i = "hover",
      dir: n,
      scrollHideDelay: s = 600,
      ...u
    } = e, [o, d] = h.useState(null), [a, V] = h.useState(null), [c, F] = h.useState(null), [X, Y] = h.useState(null), [q, f] = h.useState(null), [p, m] = h.useState(0), [g, y] = h.useState(0), [b, A] = h.useState(!1), [w, S] = h.useState(!1), N = rr(r, (E) => d(E)), O = Rn(n);
    return /* @__PURE__ */ l(
      ave,
      {
        scope: t,
        type: i,
        dir: O,
        scrollHideDelay: s,
        scrollArea: o,
        viewport: a,
        onViewportChange: V,
        content: c,
        onContentChange: F,
        scrollbarX: X,
        onScrollbarXChange: Y,
        scrollbarXEnabled: b,
        onScrollbarXEnabledChange: A,
        scrollbarY: q,
        onScrollbarYChange: f,
        scrollbarYEnabled: w,
        onScrollbarYEnabledChange: S,
        onCornerWidthChange: m,
        onCornerHeightChange: y,
        children: /* @__PURE__ */ l(
          Me.div,
          {
            dir: O,
            ...u,
            ref: N,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": p + "px",
              "--radix-scroll-area-corner-height": g + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
bB.displayName = iA;
var yB = "ScrollAreaViewport", AB = h.forwardRef(
  (e, r) => {
    const { __scopeScrollArea: t, children: i, nonce: n, ...s } = e, u = _n(yB, t), o = h.useRef(null), d = rr(r, o, u.onViewportChange);
    return /* @__PURE__ */ C(he, { children: [
      /* @__PURE__ */ l(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ l(
        Me.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...s,
          ref: d,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: u.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: u.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ l("div", { ref: u.onContentChange, style: { minWidth: "100%", display: "table" }, children: i })
        }
      )
    ] });
  }
);
AB.displayName = yB;
var Qs = "ScrollAreaScrollbar", nA = h.forwardRef(
  (e, r) => {
    const { forceMount: t, ...i } = e, n = _n(Qs, e.__scopeScrollArea), { onScrollbarXEnabledChange: s, onScrollbarYEnabledChange: u } = n, o = e.orientation === "horizontal";
    return h.useEffect(() => (o ? s(!0) : u(!0), () => {
      o ? s(!1) : u(!1);
    }), [o, s, u]), n.type === "hover" ? /* @__PURE__ */ l(Vve, { ...i, ref: r, forceMount: t }) : n.type === "scroll" ? /* @__PURE__ */ l(lve, { ...i, ref: r, forceMount: t }) : n.type === "auto" ? /* @__PURE__ */ l(wB, { ...i, ref: r, forceMount: t }) : n.type === "always" ? /* @__PURE__ */ l(sA, { ...i, ref: r }) : null;
  }
);
nA.displayName = Qs;
var Vve = h.forwardRef((e, r) => {
  const { forceMount: t, ...i } = e, n = _n(Qs, e.__scopeScrollArea), [s, u] = h.useState(!1);
  return h.useEffect(() => {
    const o = n.scrollArea;
    let d = 0;
    if (o) {
      const a = () => {
        window.clearTimeout(d), u(!0);
      }, V = () => {
        d = window.setTimeout(() => u(!1), n.scrollHideDelay);
      };
      return o.addEventListener("pointerenter", a), o.addEventListener("pointerleave", V), () => {
        window.clearTimeout(d), o.removeEventListener("pointerenter", a), o.removeEventListener("pointerleave", V);
      };
    }
  }, [n.scrollArea, n.scrollHideDelay]), /* @__PURE__ */ l(g2, { present: t || s, children: /* @__PURE__ */ l(
    wB,
    {
      "data-state": s ? "visible" : "hidden",
      ...i,
      ref: r
    }
  ) });
}), lve = h.forwardRef((e, r) => {
  const { forceMount: t, ...i } = e, n = _n(Qs, e.__scopeScrollArea), s = e.orientation === "horizontal", u = kY(() => d("SCROLL_END"), 100), [o, d] = dve("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return h.useEffect(() => {
    if (o === "idle") {
      const a = window.setTimeout(() => d("HIDE"), n.scrollHideDelay);
      return () => window.clearTimeout(a);
    }
  }, [o, n.scrollHideDelay, d]), h.useEffect(() => {
    const a = n.viewport, V = s ? "scrollLeft" : "scrollTop";
    if (a) {
      let c = a[V];
      const F = () => {
        const X = a[V];
        c !== X && (d("SCROLL"), u()), c = X;
      };
      return a.addEventListener("scroll", F), () => a.removeEventListener("scroll", F);
    }
  }, [n.viewport, s, d, u]), /* @__PURE__ */ l(g2, { present: t || o !== "hidden", children: /* @__PURE__ */ l(
    sA,
    {
      "data-state": o === "hidden" ? "hidden" : "visible",
      ...i,
      ref: r,
      onPointerEnter: Ne(e.onPointerEnter, () => d("POINTER_ENTER")),
      onPointerLeave: Ne(e.onPointerLeave, () => d("POINTER_LEAVE"))
    }
  ) });
}), wB = h.forwardRef((e, r) => {
  const t = _n(Qs, e.__scopeScrollArea), { forceMount: i, ...n } = e, [s, u] = h.useState(!1), o = e.orientation === "horizontal", d = kY(() => {
    if (t.viewport) {
      const a = t.viewport.offsetWidth < t.viewport.scrollWidth, V = t.viewport.offsetHeight < t.viewport.scrollHeight;
      u(o ? a : V);
    }
  }, 10);
  return NV(t.viewport, d), NV(t.content, d), /* @__PURE__ */ l(g2, { present: i || s, children: /* @__PURE__ */ l(
    sA,
    {
      "data-state": s ? "visible" : "hidden",
      ...n,
      ref: r
    }
  ) });
}), sA = h.forwardRef((e, r) => {
  const { orientation: t = "vertical", ...i } = e, n = _n(Qs, e.__scopeScrollArea), s = h.useRef(null), u = h.useRef(0), [o, d] = h.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), a = MB(o.viewport, o.content), V = {
    ...i,
    sizes: o,
    onSizesChange: d,
    hasThumb: a > 0 && a < 1,
    onThumbChange: (F) => s.current = F,
    onThumbPointerUp: () => u.current = 0,
    onThumbPointerDown: (F) => u.current = F
  };
  function c(F, X) {
    return Yve(F, u.current, o, X);
  }
  return t === "horizontal" ? /* @__PURE__ */ l(
    cve,
    {
      ...V,
      ref: r,
      onThumbPositionChange: () => {
        if (n.viewport && s.current) {
          const F = n.viewport.scrollLeft, X = RC(F, o, n.dir);
          s.current.style.transform = `translate3d(${X}px, 0, 0)`;
        }
      },
      onWheelScroll: (F) => {
        n.viewport && (n.viewport.scrollLeft = F);
      },
      onDragScroll: (F) => {
        n.viewport && (n.viewport.scrollLeft = c(F, n.dir));
      }
    }
  ) : t === "vertical" ? /* @__PURE__ */ l(
    Fve,
    {
      ...V,
      ref: r,
      onThumbPositionChange: () => {
        if (n.viewport && s.current) {
          const F = n.viewport.scrollTop, X = RC(F, o);
          s.current.style.transform = `translate3d(0, ${X}px, 0)`;
        }
      },
      onWheelScroll: (F) => {
        n.viewport && (n.viewport.scrollTop = F);
      },
      onDragScroll: (F) => {
        n.viewport && (n.viewport.scrollTop = c(F));
      }
    }
  ) : null;
}), cve = h.forwardRef((e, r) => {
  const { sizes: t, onSizesChange: i, ...n } = e, s = _n(Qs, e.__scopeScrollArea), [u, o] = h.useState(), d = h.useRef(null), a = rr(r, d, s.onScrollbarXChange);
  return h.useEffect(() => {
    d.current && o(getComputedStyle(d.current));
  }, [d]), /* @__PURE__ */ l(
    PB,
    {
      "data-orientation": "horizontal",
      ...n,
      ref: a,
      sizes: t,
      style: {
        bottom: 0,
        left: s.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: s.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": EY(t) + "px",
        ...e.style
      },
      onThumbPointerDown: (V) => e.onThumbPointerDown(V.x),
      onDragScroll: (V) => e.onDragScroll(V.x),
      onWheelScroll: (V, c) => {
        if (s.viewport) {
          const F = s.viewport.scrollLeft + V.deltaX;
          e.onWheelScroll(F), EB(F, c) && V.preventDefault();
        }
      },
      onResize: () => {
        d.current && s.viewport && u && i({
          content: s.viewport.scrollWidth,
          viewport: s.viewport.offsetWidth,
          scrollbar: {
            size: d.current.clientWidth,
            paddingStart: FX(u.paddingLeft),
            paddingEnd: FX(u.paddingRight)
          }
        });
      }
    }
  );
}), Fve = h.forwardRef((e, r) => {
  const { sizes: t, onSizesChange: i, ...n } = e, s = _n(Qs, e.__scopeScrollArea), [u, o] = h.useState(), d = h.useRef(null), a = rr(r, d, s.onScrollbarYChange);
  return h.useEffect(() => {
    d.current && o(getComputedStyle(d.current));
  }, [d]), /* @__PURE__ */ l(
    PB,
    {
      "data-orientation": "vertical",
      ...n,
      ref: a,
      sizes: t,
      style: {
        top: 0,
        right: s.dir === "ltr" ? 0 : void 0,
        left: s.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": EY(t) + "px",
        ...e.style
      },
      onThumbPointerDown: (V) => e.onThumbPointerDown(V.y),
      onDragScroll: (V) => e.onDragScroll(V.y),
      onWheelScroll: (V, c) => {
        if (s.viewport) {
          const F = s.viewport.scrollTop + V.deltaY;
          e.onWheelScroll(F), EB(F, c) && V.preventDefault();
        }
      },
      onResize: () => {
        d.current && s.viewport && u && i({
          content: s.viewport.scrollHeight,
          viewport: s.viewport.offsetHeight,
          scrollbar: {
            size: d.current.clientHeight,
            paddingStart: FX(u.paddingTop),
            paddingEnd: FX(u.paddingBottom)
          }
        });
      }
    }
  );
}), [xve, CB] = vB(Qs), PB = h.forwardRef((e, r) => {
  const {
    __scopeScrollArea: t,
    sizes: i,
    hasThumb: n,
    onThumbChange: s,
    onThumbPointerUp: u,
    onThumbPointerDown: o,
    onThumbPositionChange: d,
    onDragScroll: a,
    onWheelScroll: V,
    onResize: c,
    ...F
  } = e, X = _n(Qs, t), [Y, q] = h.useState(null), f = rr(r, (N) => q(N)), p = h.useRef(null), m = h.useRef(""), g = X.viewport, y = i.content - i.viewport, b = Ee(V), A = Ee(d), w = kY(c, 10);
  function S(N) {
    if (p.current) {
      const O = N.clientX - p.current.left, E = N.clientY - p.current.top;
      a({ x: O, y: E });
    }
  }
  return h.useEffect(() => {
    const N = (O) => {
      const E = O.target;
      (Y == null ? void 0 : Y.contains(E)) && b(O, y);
    };
    return document.addEventListener("wheel", N, { passive: !1 }), () => document.removeEventListener("wheel", N, { passive: !1 });
  }, [g, Y, y, b]), h.useEffect(A, [i, A]), NV(Y, w), NV(X.content, w), /* @__PURE__ */ l(
    xve,
    {
      scope: t,
      scrollbar: Y,
      hasThumb: n,
      onThumbChange: Ee(s),
      onThumbPointerUp: Ee(u),
      onThumbPositionChange: A,
      onThumbPointerDown: Ee(o),
      children: /* @__PURE__ */ l(
        Me.div,
        {
          ...F,
          ref: f,
          style: { position: "absolute", ...F.style },
          onPointerDown: Ne(e.onPointerDown, (N) => {
            N.button === 0 && (N.target.setPointerCapture(N.pointerId), p.current = Y.getBoundingClientRect(), m.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", X.viewport && (X.viewport.style.scrollBehavior = "auto"), S(N));
          }),
          onPointerMove: Ne(e.onPointerMove, S),
          onPointerUp: Ne(e.onPointerUp, (N) => {
            const O = N.target;
            O.hasPointerCapture(N.pointerId) && O.releasePointerCapture(N.pointerId), document.body.style.webkitUserSelect = m.current, X.viewport && (X.viewport.style.scrollBehavior = ""), p.current = null;
          })
        }
      )
    }
  );
}), cX = "ScrollAreaThumb", SB = h.forwardRef(
  (e, r) => {
    const { forceMount: t, ...i } = e, n = CB(cX, e.__scopeScrollArea);
    return /* @__PURE__ */ l(g2, { present: t || n.hasThumb, children: /* @__PURE__ */ l(Xve, { ref: r, ...i }) });
  }
), Xve = h.forwardRef(
  (e, r) => {
    const { __scopeScrollArea: t, style: i, ...n } = e, s = _n(cX, t), u = CB(cX, t), { onThumbPositionChange: o } = u, d = rr(
      r,
      (c) => u.onThumbChange(c)
    ), a = h.useRef(), V = kY(() => {
      a.current && (a.current(), a.current = void 0);
    }, 100);
    return h.useEffect(() => {
      const c = s.viewport;
      if (c) {
        const F = () => {
          if (V(), !a.current) {
            const X = fve(c, o);
            a.current = X, o();
          }
        };
        return o(), c.addEventListener("scroll", F), () => c.removeEventListener("scroll", F);
      }
    }, [s.viewport, V, o]), /* @__PURE__ */ l(
      Me.div,
      {
        "data-state": u.hasThumb ? "visible" : "hidden",
        ...n,
        ref: d,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...i
        },
        onPointerDownCapture: Ne(e.onPointerDownCapture, (c) => {
          const X = c.target.getBoundingClientRect(), Y = c.clientX - X.left, q = c.clientY - X.top;
          u.onThumbPointerDown({ x: Y, y: q });
        }),
        onPointerUp: Ne(e.onPointerUp, u.onThumbPointerUp)
      }
    );
  }
);
SB.displayName = cX;
var uA = "ScrollAreaCorner", NB = h.forwardRef(
  (e, r) => {
    const t = _n(uA, e.__scopeScrollArea), i = !!(t.scrollbarX && t.scrollbarY);
    return t.type !== "scroll" && i ? /* @__PURE__ */ l(qve, { ...e, ref: r }) : null;
  }
);
NB.displayName = uA;
var qve = h.forwardRef((e, r) => {
  const { __scopeScrollArea: t, ...i } = e, n = _n(uA, t), [s, u] = h.useState(0), [o, d] = h.useState(0), a = !!(s && o);
  return NV(n.scrollbarX, () => {
    var c;
    const V = ((c = n.scrollbarX) == null ? void 0 : c.offsetHeight) || 0;
    n.onCornerHeightChange(V), d(V);
  }), NV(n.scrollbarY, () => {
    var c;
    const V = ((c = n.scrollbarY) == null ? void 0 : c.offsetWidth) || 0;
    n.onCornerWidthChange(V), u(V);
  }), a ? /* @__PURE__ */ l(
    Me.div,
    {
      ...i,
      ref: r,
      style: {
        width: s,
        height: o,
        position: "absolute",
        right: n.dir === "ltr" ? 0 : void 0,
        left: n.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function FX(e) {
  return e ? parseInt(e, 10) : 0;
}
function MB(e, r) {
  const t = e / r;
  return isNaN(t) ? 0 : t;
}
function EY(e) {
  const r = MB(e.viewport, e.content), t = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, i = (e.scrollbar.size - t) * r;
  return Math.max(i, 18);
}
function Yve(e, r, t, i = "ltr") {
  const n = EY(t), s = n / 2, u = r || s, o = n - u, d = t.scrollbar.paddingStart + u, a = t.scrollbar.size - t.scrollbar.paddingEnd - o, V = t.content - t.viewport, c = i === "ltr" ? [0, V] : [V * -1, 0];
  return TB([d, a], c)(e);
}
function RC(e, r, t = "ltr") {
  const i = EY(r), n = r.scrollbar.paddingStart + r.scrollbar.paddingEnd, s = r.scrollbar.size - n, u = r.content - r.viewport, o = s - i, d = t === "ltr" ? [0, u] : [u * -1, 0], a = t7(e, d);
  return TB([0, u], [0, o])(a);
}
function TB(e, r) {
  return (t) => {
    if (e[0] === e[1] || r[0] === r[1]) return r[0];
    const i = (r[1] - r[0]) / (e[1] - e[0]);
    return r[0] + i * (t - e[0]);
  };
}
function EB(e, r) {
  return e > 0 && e < r;
}
var fve = (e, r = () => {
}) => {
  let t = { left: e.scrollLeft, top: e.scrollTop }, i = 0;
  return function n() {
    const s = { left: e.scrollLeft, top: e.scrollTop }, u = t.left !== s.left, o = t.top !== s.top;
    (u || o) && r(), t = s, i = window.requestAnimationFrame(n);
  }(), () => window.cancelAnimationFrame(i);
};
function kY(e, r) {
  const t = Ee(e), i = h.useRef(0);
  return h.useEffect(() => () => window.clearTimeout(i.current), []), h.useCallback(() => {
    window.clearTimeout(i.current), i.current = window.setTimeout(t, r);
  }, [t, r]);
}
function NV(e, r) {
  const t = Ee(r);
  ze(() => {
    let i = 0;
    if (e) {
      const n = new ResizeObserver(() => {
        cancelAnimationFrame(i), i = window.requestAnimationFrame(t);
      });
      return n.observe(e), () => {
        window.cancelAnimationFrame(i), n.unobserve(e);
      };
    }
  }, [e, t]);
}
var kB = bB, Kve = AB, hve = NB;
const pve = re(({ className: e, children: r, ...t }, i) => /* @__PURE__ */ C(
  kB,
  {
    ref: i,
    className: _("relative overflow-hidden", e),
    ...t,
    children: [
      /* @__PURE__ */ l(Kve, { className: "h-full w-full rounded-[inherit]", children: r }),
      /* @__PURE__ */ l(OB, {}),
      /* @__PURE__ */ l(hve, {})
    ]
  }
));
pve.displayName = kB.displayName;
const OB = re(({ className: e, orientation: r = "vertical", ...t }, i) => /* @__PURE__ */ l(
  nA,
  {
    ref: i,
    orientation: r,
    className: _(
      "flex touch-none select-none transition-colors",
      r === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      r === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...t,
    children: /* @__PURE__ */ l(SB, { className: "bg-border relative flex-1 rounded-full" })
  }
));
OB.displayName = nA.displayName;
function Yt(e, r, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), t === !1 || !n.defaultPrevented)
      return r == null ? void 0 : r(n);
  };
}
function oA(e, r = []) {
  let t = [];
  function i(s, u) {
    const o = h.createContext(u), d = t.length;
    t = [...t, u];
    const a = (c) => {
      var p;
      const { scope: F, children: X, ...Y } = c, q = ((p = F == null ? void 0 : F[e]) == null ? void 0 : p[d]) || o, f = h.useMemo(() => Y, Object.values(Y));
      return /* @__PURE__ */ l(q.Provider, { value: f, children: X });
    };
    a.displayName = s + "Provider";
    function V(c, F) {
      var q;
      const X = ((q = F == null ? void 0 : F[e]) == null ? void 0 : q[d]) || o, Y = h.useContext(X);
      if (Y) return Y;
      if (u !== void 0) return u;
      throw new Error(`\`${c}\` must be used within \`${s}\``);
    }
    return [a, V];
  }
  const n = () => {
    const s = t.map((u) => h.createContext(u));
    return function(o) {
      const d = (o == null ? void 0 : o[e]) || s;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: d } }),
        [o, d]
      );
    };
  };
  return n.scopeName = e, [i, mve(n, ...r)];
}
function mve(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const t = () => {
    const i = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(s) {
      const u = i.reduce((o, { useScope: d, scopeName: a }) => {
        const c = d(s)[`__scope${a}`];
        return { ...o, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${r.scopeName}`]: u }), [u]);
    };
  };
  return t.scopeName = r.scopeName, t;
}
function IC(e, r) {
  if (typeof e == "function")
    return e(r);
  e != null && (e.current = r);
}
function DB(...e) {
  return (r) => {
    let t = !1;
    const i = e.map((n) => {
      const s = IC(n, r);
      return !t && typeof s == "function" && (t = !0), s;
    });
    if (t)
      return () => {
        for (let n = 0; n < i.length; n++) {
          const s = i[n];
          typeof s == "function" ? s() : IC(e[n], null);
        }
      };
  };
}
function ni(...e) {
  return h.useCallback(DB(...e), e);
}
var i7 = h.forwardRef((e, r) => {
  const { children: t, ...i } = e, n = h.Children.toArray(t), s = n.find(vve);
  if (s) {
    const u = s.props.children, o = n.map((d) => d === s ? h.Children.count(u) > 1 ? h.Children.only(null) : h.isValidElement(u) ? u.props.children : null : d);
    return /* @__PURE__ */ l(i8, { ...i, ref: r, children: h.isValidElement(u) ? h.cloneElement(u, void 0, o) : null });
  }
  return /* @__PURE__ */ l(i8, { ...i, ref: r, children: t });
});
i7.displayName = "Slot";
var i8 = h.forwardRef((e, r) => {
  const { children: t, ...i } = e;
  if (h.isValidElement(t)) {
    const n = yve(t);
    return h.cloneElement(t, {
      ...bve(i, t.props),
      // @ts-ignore
      ref: r ? DB(r, n) : n
    });
  }
  return h.Children.count(t) > 1 ? h.Children.only(null) : null;
});
i8.displayName = "SlotClone";
var gve = ({ children: e }) => /* @__PURE__ */ l(he, { children: e });
function vve(e) {
  return h.isValidElement(e) && e.type === gve;
}
function bve(e, r) {
  const t = { ...r };
  for (const i in r) {
    const n = e[i], s = r[i];
    /^on[A-Z]/.test(i) ? n && s ? t[i] = (...o) => {
      s(...o), n(...o);
    } : n && (t[i] = n) : i === "style" ? t[i] = { ...n, ...s } : i === "className" && (t[i] = [n, s].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function yve(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
function Ave(e) {
  const r = e + "CollectionProvider", [t, i] = oA(r), [n, s] = t(
    r,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), u = (X) => {
    const { scope: Y, children: q } = X, f = D.useRef(null), p = D.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ l(n, { scope: Y, itemMap: p, collectionRef: f, children: q });
  };
  u.displayName = r;
  const o = e + "CollectionSlot", d = D.forwardRef(
    (X, Y) => {
      const { scope: q, children: f } = X, p = s(o, q), m = ni(Y, p.collectionRef);
      return /* @__PURE__ */ l(i7, { ref: m, children: f });
    }
  );
  d.displayName = o;
  const a = e + "CollectionItemSlot", V = "data-radix-collection-item", c = D.forwardRef(
    (X, Y) => {
      const { scope: q, children: f, ...p } = X, m = D.useRef(null), g = ni(Y, m), y = s(a, q);
      return D.useEffect(() => (y.itemMap.set(m, { ref: m, ...p }), () => void y.itemMap.delete(m))), /* @__PURE__ */ l(i7, { [V]: "", ref: g, children: f });
    }
  );
  c.displayName = a;
  function F(X) {
    const Y = s(e + "CollectionConsumer", X);
    return D.useCallback(() => {
      const f = Y.collectionRef.current;
      if (!f) return [];
      const p = Array.from(f.querySelectorAll(`[${V}]`));
      return Array.from(Y.itemMap.values()).sort(
        (y, b) => p.indexOf(y.ref.current) - p.indexOf(b.ref.current)
      );
    }, [Y.collectionRef, Y.itemMap]);
  }
  return [
    { Provider: u, Slot: d, ItemSlot: c },
    F,
    i
  ];
}
var wve = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ht = wve.reduce((e, r) => {
  const t = h.forwardRef((i, n) => {
    const { asChild: s, ...u } = i, o = s ? i7 : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l(o, { ...u, ref: n });
  });
  return t.displayName = `Primitive.${r}`, { ...e, [r]: t };
}, {});
function Cve(e, r) {
  e && qs.flushSync(() => e.dispatchEvent(r));
}
var Pve = "DismissableLayer", n8 = "dismissableLayer.update", Sve = "dismissableLayer.pointerDownOutside", Nve = "dismissableLayer.focusOutside", LC, RB = h.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), IB = h.forwardRef(
  (e, r) => {
    const {
      disableOutsidePointerEvents: t = !1,
      onEscapeKeyDown: i,
      onPointerDownOutside: n,
      onFocusOutside: s,
      onInteractOutside: u,
      onDismiss: o,
      ...d
    } = e, a = h.useContext(RB), [V, c] = h.useState(null), F = (V == null ? void 0 : V.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, X] = h.useState({}), Y = ni(r, (w) => c(w)), q = Array.from(a.layers), [f] = [...a.layersWithOutsidePointerEventsDisabled].slice(-1), p = q.indexOf(f), m = V ? q.indexOf(V) : -1, g = a.layersWithOutsidePointerEventsDisabled.size > 0, y = m >= p, b = Eve((w) => {
      const S = w.target, N = [...a.branches].some((O) => O.contains(S));
      !y || N || (n == null || n(w), u == null || u(w), w.defaultPrevented || o == null || o());
    }, F), A = kve((w) => {
      const S = w.target;
      [...a.branches].some((O) => O.contains(S)) || (s == null || s(w), u == null || u(w), w.defaultPrevented || o == null || o());
    }, F);
    return oa((w) => {
      m === a.layers.size - 1 && (i == null || i(w), !w.defaultPrevented && o && (w.preventDefault(), o()));
    }, F), h.useEffect(() => {
      if (V)
        return t && (a.layersWithOutsidePointerEventsDisabled.size === 0 && (LC = F.body.style.pointerEvents, F.body.style.pointerEvents = "none"), a.layersWithOutsidePointerEventsDisabled.add(V)), a.layers.add(V), _C(), () => {
          t && a.layersWithOutsidePointerEventsDisabled.size === 1 && (F.body.style.pointerEvents = LC);
        };
    }, [V, F, t, a]), h.useEffect(() => () => {
      V && (a.layers.delete(V), a.layersWithOutsidePointerEventsDisabled.delete(V), _C());
    }, [V, a]), h.useEffect(() => {
      const w = () => X({});
      return document.addEventListener(n8, w), () => document.removeEventListener(n8, w);
    }, []), /* @__PURE__ */ l(
      ht.div,
      {
        ...d,
        ref: Y,
        style: {
          pointerEvents: g ? y ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Yt(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: Yt(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: Yt(
          e.onPointerDownCapture,
          b.onPointerDownCapture
        )
      }
    );
  }
);
IB.displayName = Pve;
var Mve = "DismissableLayerBranch", Tve = h.forwardRef((e, r) => {
  const t = h.useContext(RB), i = h.useRef(null), n = ni(r, i);
  return h.useEffect(() => {
    const s = i.current;
    if (s)
      return t.branches.add(s), () => {
        t.branches.delete(s);
      };
  }, [t.branches]), /* @__PURE__ */ l(ht.div, { ...e, ref: n });
});
Tve.displayName = Mve;
function Eve(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Ee(e), i = h.useRef(!1), n = h.useRef(() => {
  });
  return h.useEffect(() => {
    const s = (o) => {
      if (o.target && !i.current) {
        let d = function() {
          LB(
            Sve,
            t,
            a,
            { discrete: !0 }
          );
        };
        const a = { originalEvent: o };
        o.pointerType === "touch" ? (r.removeEventListener("click", n.current), n.current = d, r.addEventListener("click", n.current, { once: !0 })) : d();
      } else
        r.removeEventListener("click", n.current);
      i.current = !1;
    }, u = window.setTimeout(() => {
      r.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(u), r.removeEventListener("pointerdown", s), r.removeEventListener("click", n.current);
    };
  }, [r, t]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => i.current = !0
  };
}
function kve(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Ee(e), i = h.useRef(!1);
  return h.useEffect(() => {
    const n = (s) => {
      s.target && !i.current && LB(Nve, t, { originalEvent: s }, {
        discrete: !1
      });
    };
    return r.addEventListener("focusin", n), () => r.removeEventListener("focusin", n);
  }, [r, t]), {
    onFocusCapture: () => i.current = !0,
    onBlurCapture: () => i.current = !1
  };
}
function _C() {
  const e = new CustomEvent(n8);
  document.dispatchEvent(e);
}
function LB(e, r, t, { discrete: i }) {
  const n = t.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: t });
  r && n.addEventListener(e, r, { once: !0 }), i ? Cve(n, s) : n.dispatchEvent(s);
}
var xp = "focusScope.autoFocusOnMount", Xp = "focusScope.autoFocusOnUnmount", HC = { bubbles: !1, cancelable: !0 }, Ove = "FocusScope", _B = h.forwardRef((e, r) => {
  const {
    loop: t = !1,
    trapped: i = !1,
    onMountAutoFocus: n,
    onUnmountAutoFocus: s,
    ...u
  } = e, [o, d] = h.useState(null), a = Ee(n), V = Ee(s), c = h.useRef(null), F = ni(r, (q) => d(q)), X = h.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  h.useEffect(() => {
    if (i) {
      let q = function(g) {
        if (X.paused || !o) return;
        const y = g.target;
        o.contains(y) ? c.current = y : Xo(c.current, { select: !0 });
      }, f = function(g) {
        if (X.paused || !o) return;
        const y = g.relatedTarget;
        y !== null && (o.contains(y) || Xo(c.current, { select: !0 }));
      }, p = function(g) {
        if (document.activeElement === document.body)
          for (const b of g)
            b.removedNodes.length > 0 && Xo(o);
      };
      document.addEventListener("focusin", q), document.addEventListener("focusout", f);
      const m = new MutationObserver(p);
      return o && m.observe(o, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", q), document.removeEventListener("focusout", f), m.disconnect();
      };
    }
  }, [i, o, X.paused]), h.useEffect(() => {
    if (o) {
      zC.add(X);
      const q = document.activeElement;
      if (!o.contains(q)) {
        const p = new CustomEvent(xp, HC);
        o.addEventListener(xp, a), o.dispatchEvent(p), p.defaultPrevented || (Dve(Hve(HB(o)), { select: !0 }), document.activeElement === q && Xo(o));
      }
      return () => {
        o.removeEventListener(xp, a), setTimeout(() => {
          const p = new CustomEvent(Xp, HC);
          o.addEventListener(Xp, V), o.dispatchEvent(p), p.defaultPrevented || Xo(q ?? document.body, { select: !0 }), o.removeEventListener(Xp, V), zC.remove(X);
        }, 0);
      };
    }
  }, [o, a, V, X]);
  const Y = h.useCallback(
    (q) => {
      if (!t && !i || X.paused) return;
      const f = q.key === "Tab" && !q.altKey && !q.ctrlKey && !q.metaKey, p = document.activeElement;
      if (f && p) {
        const m = q.currentTarget, [g, y] = Rve(m);
        g && y ? !q.shiftKey && p === y ? (q.preventDefault(), t && Xo(g, { select: !0 })) : q.shiftKey && p === g && (q.preventDefault(), t && Xo(y, { select: !0 })) : p === m && q.preventDefault();
      }
    },
    [t, i, X.paused]
  );
  return /* @__PURE__ */ l(ht.div, { tabIndex: -1, ...u, ref: F, onKeyDown: Y });
});
_B.displayName = Ove;
function Dve(e, { select: r = !1 } = {}) {
  const t = document.activeElement;
  for (const i of e)
    if (Xo(i, { select: r }), document.activeElement !== t) return;
}
function Rve(e) {
  const r = HB(e), t = jC(r, e), i = jC(r.reverse(), e);
  return [t, i];
}
function HB(e) {
  const r = [], t = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (i) => {
      const n = i.tagName === "INPUT" && i.type === "hidden";
      return i.disabled || i.hidden || n ? NodeFilter.FILTER_SKIP : i.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); ) r.push(t.currentNode);
  return r;
}
function jC(e, r) {
  for (const t of e)
    if (!Ive(t, { upTo: r })) return t;
}
function Ive(e, { upTo: r }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (r !== void 0 && e === r) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Lve(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Xo(e, { select: r = !1 } = {}) {
  if (e && e.focus) {
    const t = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== t && Lve(e) && r && e.select();
  }
}
var zC = _ve();
function _ve() {
  let e = [];
  return {
    add(r) {
      const t = e[0];
      r !== t && (t == null || t.pause()), e = BC(e, r), e.unshift(r);
    },
    remove(r) {
      var t;
      e = BC(e, r), (t = e[0]) == null || t.resume();
    }
  };
}
function BC(e, r) {
  const t = [...e], i = t.indexOf(r);
  return i !== -1 && t.splice(i, 1), t;
}
function Hve(e) {
  return e.filter((r) => r.tagName !== "A");
}
var jve = "Arrow", jB = h.forwardRef((e, r) => {
  const { children: t, width: i = 10, height: n = 5, ...s } = e;
  return /* @__PURE__ */ l(
    ht.svg,
    {
      ...s,
      ref: r,
      width: i,
      height: n,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? t : /* @__PURE__ */ l("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
jB.displayName = jve;
var zve = jB, dA = "Popper", [zB, BB] = oA(dA), [Bve, WB] = zB(dA), GB = (e) => {
  const { __scopePopper: r, children: t } = e, [i, n] = h.useState(null);
  return /* @__PURE__ */ l(Bve, { scope: r, anchor: i, onAnchorChange: n, children: t });
};
GB.displayName = dA;
var UB = "PopperAnchor", ZB = h.forwardRef(
  (e, r) => {
    const { __scopePopper: t, virtualRef: i, ...n } = e, s = WB(UB, t), u = h.useRef(null), o = ni(r, u);
    return h.useEffect(() => {
      s.onAnchorChange((i == null ? void 0 : i.current) || u.current);
    }), i ? null : /* @__PURE__ */ l(ht.div, { ...n, ref: o });
  }
);
ZB.displayName = UB;
var aA = "PopperContent", [Wve, Gve] = zB(aA), JB = h.forwardRef(
  (e, r) => {
    var qe, me, ne, fe, Ye, Q;
    const {
      __scopePopper: t,
      side: i = "bottom",
      sideOffset: n = 0,
      align: s = "center",
      alignOffset: u = 0,
      arrowPadding: o = 0,
      avoidCollisions: d = !0,
      collisionBoundary: a = [],
      collisionPadding: V = 0,
      sticky: c = "partial",
      hideWhenDetached: F = !1,
      updatePositionStrategy: X = "optimized",
      onPlaced: Y,
      ...q
    } = e, f = WB(aA, t), [p, m] = h.useState(null), g = ni(r, (we) => m(we)), [y, b] = h.useState(null), A = da(y), w = (A == null ? void 0 : A.width) ?? 0, S = (A == null ? void 0 : A.height) ?? 0, N = i + (s !== "center" ? "-" + s : ""), O = typeof V == "number" ? V : { top: 0, right: 0, bottom: 0, left: 0, ...V }, E = Array.isArray(a) ? a : [a], I = E.length > 0, R = {
      padding: O,
      boundary: E.filter(Zve),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: I
    }, { refs: H, floatingStyles: W, placement: B, isPositioned: L, middlewareData: z } = oY({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: N,
      whileElementsMounted: (...we) => uY(...we, {
        animationFrame: X === "always"
      }),
      elements: {
        reference: f.anchor
      },
      middleware: [
        dY({ mainAxis: n + S, alignmentAxis: u }),
        d && aY({
          mainAxis: !0,
          crossAxis: !1,
          limiter: c === "partial" ? VY() : void 0,
          ...R
        }),
        d && lY({ ...R }),
        cY({
          ...R,
          apply: ({ elements: we, rects: oe, availableWidth: tr, availableHeight: ar }) => {
            const { width: or, height: bt } = oe.reference, Tr = we.floating.style;
            Tr.setProperty("--radix-popper-available-width", `${tr}px`), Tr.setProperty("--radix-popper-available-height", `${ar}px`), Tr.setProperty("--radix-popper-anchor-width", `${or}px`), Tr.setProperty("--radix-popper-anchor-height", `${bt}px`);
          }
        }),
        y && xY({ element: y, padding: o }),
        Jve({ arrowWidth: w, arrowHeight: S }),
        F && FY({ strategy: "referenceHidden", ...R })
      ]
    }), [Z, le] = eW(B), te = Ee(Y);
    ze(() => {
      L && (te == null || te());
    }, [L, te]);
    const U = (qe = z.arrow) == null ? void 0 : qe.x, de = (me = z.arrow) == null ? void 0 : me.y, Ke = ((ne = z.arrow) == null ? void 0 : ne.centerOffset) !== 0, [xe, be] = h.useState();
    return ze(() => {
      p && be(window.getComputedStyle(p).zIndex);
    }, [p]), /* @__PURE__ */ l(
      "div",
      {
        ref: H.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...W,
          transform: L ? W.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: xe,
          "--radix-popper-transform-origin": [
            (fe = z.transformOrigin) == null ? void 0 : fe.x,
            (Ye = z.transformOrigin) == null ? void 0 : Ye.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Q = z.hide) == null ? void 0 : Q.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ l(
          Wve,
          {
            scope: t,
            placedSide: Z,
            onArrowChange: b,
            arrowX: U,
            arrowY: de,
            shouldHideArrow: Ke,
            children: /* @__PURE__ */ l(
              ht.div,
              {
                "data-side": Z,
                "data-align": le,
                ...q,
                ref: g,
                style: {
                  ...q.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: L ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
JB.displayName = aA;
var $B = "PopperArrow", Uve = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, QB = h.forwardRef(function(r, t) {
  const { __scopePopper: i, ...n } = r, s = Gve($B, i), u = Uve[s.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ l(
      "span",
      {
        ref: s.onArrowChange,
        style: {
          position: "absolute",
          left: s.arrowX,
          top: s.arrowY,
          [u]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[s.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[s.placedSide],
          visibility: s.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ l(
          zve,
          {
            ...n,
            ref: t,
            style: {
              ...n.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
QB.displayName = $B;
function Zve(e) {
  return e !== null;
}
var Jve = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(r) {
    var f, p, m;
    const { placement: t, rects: i, middlewareData: n } = r, u = ((f = n.arrow) == null ? void 0 : f.centerOffset) !== 0, o = u ? 0 : e.arrowWidth, d = u ? 0 : e.arrowHeight, [a, V] = eW(t), c = { start: "0%", center: "50%", end: "100%" }[V], F = (((p = n.arrow) == null ? void 0 : p.x) ?? 0) + o / 2, X = (((m = n.arrow) == null ? void 0 : m.y) ?? 0) + d / 2;
    let Y = "", q = "";
    return a === "bottom" ? (Y = u ? c : `${F}px`, q = `${-d}px`) : a === "top" ? (Y = u ? c : `${F}px`, q = `${i.floating.height + d}px`) : a === "right" ? (Y = `${-d}px`, q = u ? c : `${X}px`) : a === "left" && (Y = `${i.floating.width + d}px`, q = u ? c : `${X}px`), { data: { x: Y, y: q } };
  }
});
function eW(e) {
  const [r, t = "center"] = e.split("-");
  return [r, t];
}
var $ve = GB, Qve = ZB, e8e = JB, r8e = QB, t8e = "Portal", rW = h.forwardRef((e, r) => {
  var o;
  const { container: t, ...i } = e, [n, s] = h.useState(!1);
  ze(() => s(!0), []);
  const u = t || n && ((o = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : o.body);
  return u ? Us.createPortal(/* @__PURE__ */ l(ht.div, { ...i, ref: r }), u) : null;
});
rW.displayName = t8e;
var i8e = "VisuallyHidden", tW = h.forwardRef(
  (e, r) => /* @__PURE__ */ l(
    ht.span,
    {
      ...e,
      ref: r,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
tW.displayName = i8e;
var Lx = "right-scroll-bar-position", _x = "width-before-scroll-bar", n8e = "with-scroll-bars-hidden", s8e = "--removed-body-scroll-bar-size";
function qp(e, r) {
  return typeof e == "function" ? e(r) : e && (e.current = r), e;
}
function u8e(e, r) {
  var t = ie(function() {
    return {
      // value
      value: e,
      // last callback
      callback: r,
      // "memoized" public interface
      facade: {
        get current() {
          return t.value;
        },
        set current(i) {
          var n = t.value;
          n !== i && (t.value = i, t.callback(i, n));
        }
      }
    };
  })[0];
  return t.callback = r, t.facade;
}
var o8e = typeof window < "u" ? h.useLayoutEffect : h.useEffect, WC = /* @__PURE__ */ new WeakMap();
function d8e(e, r) {
  var t = u8e(null, function(i) {
    return e.forEach(function(n) {
      return qp(n, i);
    });
  });
  return o8e(function() {
    var i = WC.get(t);
    if (i) {
      var n = new Set(i), s = new Set(e), u = t.current;
      n.forEach(function(o) {
        s.has(o) || qp(o, null);
      }), s.forEach(function(o) {
        n.has(o) || qp(o, u);
      });
    }
    WC.set(t, e);
  }, [e]), t;
}
function a8e(e) {
  return e;
}
function V8e(e, r) {
  r === void 0 && (r = a8e);
  var t = [], i = !1, n = {
    read: function() {
      if (i)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return t.length ? t[t.length - 1] : e;
    },
    useMedium: function(s) {
      var u = r(s, i);
      return t.push(u), function() {
        t = t.filter(function(o) {
          return o !== u;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (i = !0; t.length; ) {
        var u = t;
        t = [], u.forEach(s);
      }
      t = {
        push: function(o) {
          return s(o);
        },
        filter: function() {
          return t;
        }
      };
    },
    assignMedium: function(s) {
      i = !0;
      var u = [];
      if (t.length) {
        var o = t;
        t = [], o.forEach(s), u = t;
      }
      var d = function() {
        var V = u;
        u = [], V.forEach(s);
      }, a = function() {
        return Promise.resolve().then(d);
      };
      a(), t = {
        push: function(V) {
          u.push(V), a();
        },
        filter: function(V) {
          return u = u.filter(V), t;
        }
      };
    }
  };
  return n;
}
function l8e(e) {
  e === void 0 && (e = {});
  var r = V8e(null);
  return r.options = Ge({ async: !0, ssr: !1 }, e), r;
}
var iW = function(e) {
  var r = e.sideCar, t = $s(e, ["sideCar"]);
  if (!r)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var i = r.read();
  if (!i)
    throw new Error("Sidecar medium not found");
  return h.createElement(i, Ge({}, t));
};
iW.isSideCarExport = !0;
function c8e(e, r) {
  return e.useMedium(r), iW;
}
var nW = l8e(), Yp = function() {
}, OY = h.forwardRef(function(e, r) {
  var t = h.useRef(null), i = h.useState({
    onScrollCapture: Yp,
    onWheelCapture: Yp,
    onTouchMoveCapture: Yp
  }), n = i[0], s = i[1], u = e.forwardProps, o = e.children, d = e.className, a = e.removeScrollBar, V = e.enabled, c = e.shards, F = e.sideCar, X = e.noIsolation, Y = e.inert, q = e.allowPinchZoom, f = e.as, p = f === void 0 ? "div" : f, m = e.gapMode, g = $s(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), y = F, b = d8e([t, r]), A = Ge(Ge({}, g), n);
  return h.createElement(
    h.Fragment,
    null,
    V && h.createElement(y, { sideCar: nW, removeScrollBar: a, shards: c, noIsolation: X, inert: Y, setCallbacks: s, allowPinchZoom: !!q, lockRef: t, gapMode: m }),
    u ? h.cloneElement(h.Children.only(o), Ge(Ge({}, A), { ref: b })) : h.createElement(p, Ge({}, A, { className: d, ref: b }), o)
  );
});
OY.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
OY.classNames = {
  fullWidth: _x,
  zeroRight: Lx
};
function F8e() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var r = Gq();
  return r && e.setAttribute("nonce", r), e;
}
function x8e(e, r) {
  e.styleSheet ? e.styleSheet.cssText = r : e.appendChild(document.createTextNode(r));
}
function X8e(e) {
  var r = document.head || document.getElementsByTagName("head")[0];
  r.appendChild(e);
}
var q8e = function() {
  var e = 0, r = null;
  return {
    add: function(t) {
      e == 0 && (r = F8e()) && (x8e(r, t), X8e(r)), e++;
    },
    remove: function() {
      e--, !e && r && (r.parentNode && r.parentNode.removeChild(r), r = null);
    }
  };
}, Y8e = function() {
  var e = q8e();
  return function(r, t) {
    h.useEffect(function() {
      return e.add(r), function() {
        e.remove();
      };
    }, [r && t]);
  };
}, sW = function() {
  var e = Y8e(), r = function(t) {
    var i = t.styles, n = t.dynamic;
    return e(i, n), null;
  };
  return r;
}, f8e = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, fp = function(e) {
  return parseInt(e || "", 10) || 0;
}, K8e = function(e) {
  var r = window.getComputedStyle(document.body), t = r[e === "padding" ? "paddingLeft" : "marginLeft"], i = r[e === "padding" ? "paddingTop" : "marginTop"], n = r[e === "padding" ? "paddingRight" : "marginRight"];
  return [fp(t), fp(i), fp(n)];
}, h8e = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return f8e;
  var r = K8e(e), t = document.documentElement.clientWidth, i = window.innerWidth;
  return {
    left: r[0],
    top: r[1],
    right: r[2],
    gap: Math.max(0, i - t + r[2] - r[0])
  };
}, p8e = sW(), YV = "data-scroll-locked", m8e = function(e, r, t, i) {
  var n = e.left, s = e.top, u = e.right, o = e.gap;
  return t === void 0 && (t = "margin"), `
  .`.concat(n8e, ` {
   overflow: hidden `).concat(i, `;
   padding-right: `).concat(o, "px ").concat(i, `;
  }
  body[`).concat(YV, `] {
    overflow: hidden `).concat(i, `;
    overscroll-behavior: contain;
    `).concat([
    r && "position: relative ".concat(i, ";"),
    t === "margin" && `
    padding-left: `.concat(n, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(u, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(o, "px ").concat(i, `;
    `),
    t === "padding" && "padding-right: ".concat(o, "px ").concat(i, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Lx, ` {
    right: `).concat(o, "px ").concat(i, `;
  }
  
  .`).concat(_x, ` {
    margin-right: `).concat(o, "px ").concat(i, `;
  }
  
  .`).concat(Lx, " .").concat(Lx, ` {
    right: 0 `).concat(i, `;
  }
  
  .`).concat(_x, " .").concat(_x, ` {
    margin-right: 0 `).concat(i, `;
  }
  
  body[`).concat(YV, `] {
    `).concat(s8e, ": ").concat(o, `px;
  }
`);
}, GC = function() {
  var e = parseInt(document.body.getAttribute(YV) || "0", 10);
  return isFinite(e) ? e : 0;
}, g8e = function() {
  h.useEffect(function() {
    return document.body.setAttribute(YV, (GC() + 1).toString()), function() {
      var e = GC() - 1;
      e <= 0 ? document.body.removeAttribute(YV) : document.body.setAttribute(YV, e.toString());
    };
  }, []);
}, v8e = function(e) {
  var r = e.noRelative, t = e.noImportant, i = e.gapMode, n = i === void 0 ? "margin" : i;
  g8e();
  var s = h.useMemo(function() {
    return h8e(n);
  }, [n]);
  return h.createElement(p8e, { styles: m8e(s, !r, n, t ? "" : "!important") });
}, s8 = !1;
if (typeof window < "u")
  try {
    var sx = Object.defineProperty({}, "passive", {
      get: function() {
        return s8 = !0, !0;
      }
    });
    window.addEventListener("test", sx, sx), window.removeEventListener("test", sx, sx);
  } catch {
    s8 = !1;
  }
var za = s8 ? { passive: !1 } : !1, b8e = function(e) {
  return e.tagName === "TEXTAREA";
}, uW = function(e, r) {
  if (!(e instanceof Element))
    return !1;
  var t = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    t[r] !== "hidden" && // contains scroll inside self
    !(t.overflowY === t.overflowX && !b8e(e) && t[r] === "visible")
  );
}, y8e = function(e) {
  return uW(e, "overflowY");
}, A8e = function(e) {
  return uW(e, "overflowX");
}, UC = function(e, r) {
  var t = r.ownerDocument, i = r;
  do {
    typeof ShadowRoot < "u" && i instanceof ShadowRoot && (i = i.host);
    var n = oW(e, i);
    if (n) {
      var s = dW(e, i), u = s[1], o = s[2];
      if (u > o)
        return !0;
    }
    i = i.parentNode;
  } while (i && i !== t.body);
  return !1;
}, w8e = function(e) {
  var r = e.scrollTop, t = e.scrollHeight, i = e.clientHeight;
  return [
    r,
    t,
    i
  ];
}, C8e = function(e) {
  var r = e.scrollLeft, t = e.scrollWidth, i = e.clientWidth;
  return [
    r,
    t,
    i
  ];
}, oW = function(e, r) {
  return e === "v" ? y8e(r) : A8e(r);
}, dW = function(e, r) {
  return e === "v" ? w8e(r) : C8e(r);
}, P8e = function(e, r) {
  return e === "h" && r === "rtl" ? -1 : 1;
}, S8e = function(e, r, t, i, n) {
  var s = P8e(e, window.getComputedStyle(r).direction), u = s * i, o = t.target, d = r.contains(o), a = !1, V = u > 0, c = 0, F = 0;
  do {
    var X = dW(e, o), Y = X[0], q = X[1], f = X[2], p = q - f - s * Y;
    (Y || p) && oW(e, o) && (c += p, F += Y), o instanceof ShadowRoot ? o = o.host : o = o.parentNode;
  } while (
    // portaled content
    !d && o !== document.body || // self content
    d && (r.contains(o) || r === o)
  );
  return (V && Math.abs(c) < 1 || !V && Math.abs(F) < 1) && (a = !0), a;
}, ux = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, ZC = function(e) {
  return [e.deltaX, e.deltaY];
}, JC = function(e) {
  return e && "current" in e ? e.current : e;
}, N8e = function(e, r) {
  return e[0] === r[0] && e[1] === r[1];
}, M8e = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, T8e = 0, Ba = [];
function E8e(e) {
  var r = h.useRef([]), t = h.useRef([0, 0]), i = h.useRef(), n = h.useState(T8e++)[0], s = h.useState(sW)[0], u = h.useRef(e);
  h.useEffect(function() {
    u.current = e;
  }, [e]), h.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(n));
      var q = Yl([e.lockRef.current], (e.shards || []).map(JC), !0).filter(Boolean);
      return q.forEach(function(f) {
        return f.classList.add("allow-interactivity-".concat(n));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(n)), q.forEach(function(f) {
          return f.classList.remove("allow-interactivity-".concat(n));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var o = h.useCallback(function(q, f) {
    if ("touches" in q && q.touches.length === 2 || q.type === "wheel" && q.ctrlKey)
      return !u.current.allowPinchZoom;
    var p = ux(q), m = t.current, g = "deltaX" in q ? q.deltaX : m[0] - p[0], y = "deltaY" in q ? q.deltaY : m[1] - p[1], b, A = q.target, w = Math.abs(g) > Math.abs(y) ? "h" : "v";
    if ("touches" in q && w === "h" && A.type === "range")
      return !1;
    var S = UC(w, A);
    if (!S)
      return !0;
    if (S ? b = w : (b = w === "v" ? "h" : "v", S = UC(w, A)), !S)
      return !1;
    if (!i.current && "changedTouches" in q && (g || y) && (i.current = b), !b)
      return !0;
    var N = i.current || b;
    return S8e(N, f, q, N === "h" ? g : y);
  }, []), d = h.useCallback(function(q) {
    var f = q;
    if (!(!Ba.length || Ba[Ba.length - 1] !== s)) {
      var p = "deltaY" in f ? ZC(f) : ux(f), m = r.current.filter(function(b) {
        return b.name === f.type && (b.target === f.target || f.target === b.shadowParent) && N8e(b.delta, p);
      })[0];
      if (m && m.should) {
        f.cancelable && f.preventDefault();
        return;
      }
      if (!m) {
        var g = (u.current.shards || []).map(JC).filter(Boolean).filter(function(b) {
          return b.contains(f.target);
        }), y = g.length > 0 ? o(f, g[0]) : !u.current.noIsolation;
        y && f.cancelable && f.preventDefault();
      }
    }
  }, []), a = h.useCallback(function(q, f, p, m) {
    var g = { name: q, delta: f, target: p, should: m, shadowParent: k8e(p) };
    r.current.push(g), setTimeout(function() {
      r.current = r.current.filter(function(y) {
        return y !== g;
      });
    }, 1);
  }, []), V = h.useCallback(function(q) {
    t.current = ux(q), i.current = void 0;
  }, []), c = h.useCallback(function(q) {
    a(q.type, ZC(q), q.target, o(q, e.lockRef.current));
  }, []), F = h.useCallback(function(q) {
    a(q.type, ux(q), q.target, o(q, e.lockRef.current));
  }, []);
  h.useEffect(function() {
    return Ba.push(s), e.setCallbacks({
      onScrollCapture: c,
      onWheelCapture: c,
      onTouchMoveCapture: F
    }), document.addEventListener("wheel", d, za), document.addEventListener("touchmove", d, za), document.addEventListener("touchstart", V, za), function() {
      Ba = Ba.filter(function(q) {
        return q !== s;
      }), document.removeEventListener("wheel", d, za), document.removeEventListener("touchmove", d, za), document.removeEventListener("touchstart", V, za);
    };
  }, []);
  var X = e.removeScrollBar, Y = e.inert;
  return h.createElement(
    h.Fragment,
    null,
    Y ? h.createElement(s, { styles: M8e(n) }) : null,
    X ? h.createElement(v8e, { gapMode: e.gapMode }) : null
  );
}
function k8e(e) {
  for (var r = null; e !== null; )
    e instanceof ShadowRoot && (r = e.host, e = e.host), e = e.parentNode;
  return r;
}
const O8e = c8e(nW, E8e);
var aW = h.forwardRef(function(e, r) {
  return h.createElement(OY, Ge({}, e, { ref: r, sideCar: O8e }));
});
aW.classNames = OY.classNames;
var D8e = [" ", "Enter", "ArrowUp", "ArrowDown"], R8e = [" ", "Enter"], v2 = "Select", [DY, RY, I8e] = Ave(v2), [wl, Ver] = oA(v2, [
  I8e,
  BB
]), IY = BB(), [L8e, Zo] = wl(v2), [_8e, H8e] = wl(v2), VW = (e) => {
  const {
    __scopeSelect: r,
    children: t,
    open: i,
    defaultOpen: n,
    onOpenChange: s,
    value: u,
    defaultValue: o,
    onValueChange: d,
    dir: a,
    name: V,
    autoComplete: c,
    disabled: F,
    required: X,
    form: Y
  } = e, q = IY(r), [f, p] = h.useState(null), [m, g] = h.useState(null), [y, b] = h.useState(!1), A = Rn(a), [w = !1, S] = Gr({
    prop: i,
    defaultProp: n,
    onChange: s
  }), [N, O] = Gr({
    prop: u,
    defaultProp: o,
    onChange: d
  }), E = h.useRef(null), I = f ? Y || !!f.closest("form") : !0, [R, H] = h.useState(/* @__PURE__ */ new Set()), W = Array.from(R).map((B) => B.props.value).join(";");
  return /* @__PURE__ */ l($ve, { ...q, children: /* @__PURE__ */ C(
    L8e,
    {
      required: X,
      scope: r,
      trigger: f,
      onTriggerChange: p,
      valueNode: m,
      onValueNodeChange: g,
      valueNodeHasChildren: y,
      onValueNodeHasChildrenChange: b,
      contentId: ot(),
      value: N,
      onValueChange: O,
      open: w,
      onOpenChange: S,
      dir: A,
      triggerPointerDownPosRef: E,
      disabled: F,
      children: [
        /* @__PURE__ */ l(DY.Provider, { scope: r, children: /* @__PURE__ */ l(
          _8e,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: h.useCallback((B) => {
              H((L) => new Set(L).add(B));
            }, []),
            onNativeOptionRemove: h.useCallback((B) => {
              H((L) => {
                const z = new Set(L);
                return z.delete(B), z;
              });
            }, []),
            children: t
          }
        ) }),
        I ? /* @__PURE__ */ C(
          TW,
          {
            "aria-hidden": !0,
            required: X,
            tabIndex: -1,
            name: V,
            autoComplete: c,
            value: N,
            onChange: (B) => O(B.target.value),
            disabled: F,
            form: Y,
            children: [
              N === void 0 ? /* @__PURE__ */ l("option", { value: "" }) : null,
              Array.from(R)
            ]
          },
          W
        ) : null
      ]
    }
  ) });
};
VW.displayName = v2;
var lW = "SelectTrigger", cW = h.forwardRef(
  (e, r) => {
    const { __scopeSelect: t, disabled: i = !1, ...n } = e, s = IY(t), u = Zo(lW, t), o = u.disabled || i, d = ni(r, u.onTriggerChange), a = RY(t), V = h.useRef("touch"), [c, F, X] = EW((q) => {
      const f = a().filter((g) => !g.disabled), p = f.find((g) => g.value === u.value), m = kW(f, q, p);
      m !== void 0 && u.onValueChange(m.value);
    }), Y = (q) => {
      o || (u.onOpenChange(!0), X()), q && (u.triggerPointerDownPosRef.current = {
        x: Math.round(q.pageX),
        y: Math.round(q.pageY)
      });
    };
    return /* @__PURE__ */ l(Qve, { asChild: !0, ...s, children: /* @__PURE__ */ l(
      ht.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": u.contentId,
        "aria-expanded": u.open,
        "aria-required": u.required,
        "aria-autocomplete": "none",
        dir: u.dir,
        "data-state": u.open ? "open" : "closed",
        disabled: o,
        "data-disabled": o ? "" : void 0,
        "data-placeholder": MW(u.value) ? "" : void 0,
        ...n,
        ref: d,
        onClick: Yt(n.onClick, (q) => {
          q.currentTarget.focus(), V.current !== "mouse" && Y(q);
        }),
        onPointerDown: Yt(n.onPointerDown, (q) => {
          V.current = q.pointerType;
          const f = q.target;
          f.hasPointerCapture(q.pointerId) && f.releasePointerCapture(q.pointerId), q.button === 0 && q.ctrlKey === !1 && q.pointerType === "mouse" && (Y(q), q.preventDefault());
        }),
        onKeyDown: Yt(n.onKeyDown, (q) => {
          const f = c.current !== "";
          !(q.ctrlKey || q.altKey || q.metaKey) && q.key.length === 1 && F(q.key), !(f && q.key === " ") && D8e.includes(q.key) && (Y(), q.preventDefault());
        })
      }
    ) });
  }
);
cW.displayName = lW;
var FW = "SelectValue", xW = h.forwardRef(
  (e, r) => {
    const { __scopeSelect: t, className: i, style: n, children: s, placeholder: u = "", ...o } = e, d = Zo(FW, t), { onValueNodeHasChildrenChange: a } = d, V = s !== void 0, c = ni(r, d.onValueNodeChange);
    return ze(() => {
      a(V);
    }, [a, V]), /* @__PURE__ */ l(
      ht.span,
      {
        ...o,
        ref: c,
        style: { pointerEvents: "none" },
        children: MW(d.value) ? /* @__PURE__ */ l(he, { children: u }) : s
      }
    );
  }
);
xW.displayName = FW;
var j8e = "SelectIcon", XW = h.forwardRef(
  (e, r) => {
    const { __scopeSelect: t, children: i, ...n } = e;
    return /* @__PURE__ */ l(ht.span, { "aria-hidden": !0, ...n, ref: r, children: i || "▼" });
  }
);
XW.displayName = j8e;
var z8e = "SelectPortal", qW = (e) => /* @__PURE__ */ l(rW, { asChild: !0, ...e });
qW.displayName = z8e;
var $d = "SelectContent", YW = h.forwardRef(
  (e, r) => {
    const t = Zo($d, e.__scopeSelect), [i, n] = h.useState();
    if (ze(() => {
      n(new DocumentFragment());
    }, []), !t.open) {
      const s = i;
      return s ? qs.createPortal(
        /* @__PURE__ */ l(fW, { scope: e.__scopeSelect, children: /* @__PURE__ */ l(DY.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ l("div", { children: e.children }) }) }),
        s
      ) : null;
    }
    return /* @__PURE__ */ l(KW, { ...e, ref: r });
  }
);
YW.displayName = $d;
var Jn = 10, [fW, Jo] = wl($d), B8e = "SelectContentImpl", KW = h.forwardRef(
  (e, r) => {
    const {
      __scopeSelect: t,
      position: i = "item-aligned",
      onCloseAutoFocus: n,
      onEscapeKeyDown: s,
      onPointerDownOutside: u,
      //
      // PopperContent props
      side: o,
      sideOffset: d,
      align: a,
      alignOffset: V,
      arrowPadding: c,
      collisionBoundary: F,
      collisionPadding: X,
      sticky: Y,
      hideWhenDetached: q,
      avoidCollisions: f,
      //
      ...p
    } = e, m = Zo($d, t), [g, y] = h.useState(null), [b, A] = h.useState(null), w = ni(r, (qe) => y(qe)), [S, N] = h.useState(null), [O, E] = h.useState(
      null
    ), I = RY(t), [R, H] = h.useState(!1), W = h.useRef(!1);
    h.useEffect(() => {
      if (g) return fl(g);
    }, [g]), Iy();
    const B = h.useCallback(
      (qe) => {
        const [me, ...ne] = I().map((Q) => Q.ref.current), [fe] = ne.slice(-1), Ye = document.activeElement;
        for (const Q of qe)
          if (Q === Ye || (Q == null || Q.scrollIntoView({ block: "nearest" }), Q === me && b && (b.scrollTop = 0), Q === fe && b && (b.scrollTop = b.scrollHeight), Q == null || Q.focus(), document.activeElement !== Ye)) return;
      },
      [I, b]
    ), L = h.useCallback(
      () => B([S, g]),
      [B, S, g]
    );
    h.useEffect(() => {
      R && L();
    }, [R, L]);
    const { onOpenChange: z, triggerPointerDownPosRef: Z } = m;
    h.useEffect(() => {
      if (g) {
        let qe = { x: 0, y: 0 };
        const me = (fe) => {
          var Ye, Q;
          qe = {
            x: Math.abs(Math.round(fe.pageX) - (((Ye = Z.current) == null ? void 0 : Ye.x) ?? 0)),
            y: Math.abs(Math.round(fe.pageY) - (((Q = Z.current) == null ? void 0 : Q.y) ?? 0))
          };
        }, ne = (fe) => {
          qe.x <= 10 && qe.y <= 10 ? fe.preventDefault() : g.contains(fe.target) || z(!1), document.removeEventListener("pointermove", me), Z.current = null;
        };
        return Z.current !== null && (document.addEventListener("pointermove", me), document.addEventListener("pointerup", ne, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", me), document.removeEventListener("pointerup", ne, { capture: !0 });
        };
      }
    }, [g, z, Z]), h.useEffect(() => {
      const qe = () => z(!1);
      return window.addEventListener("blur", qe), window.addEventListener("resize", qe), () => {
        window.removeEventListener("blur", qe), window.removeEventListener("resize", qe);
      };
    }, [z]);
    const [le, te] = EW((qe) => {
      const me = I().filter((Ye) => !Ye.disabled), ne = me.find((Ye) => Ye.ref.current === document.activeElement), fe = kW(me, qe, ne);
      fe && setTimeout(() => fe.ref.current.focus());
    }), U = h.useCallback(
      (qe, me, ne) => {
        const fe = !W.current && !ne;
        (m.value !== void 0 && m.value === me || fe) && (N(qe), fe && (W.current = !0));
      },
      [m.value]
    ), de = h.useCallback(() => g == null ? void 0 : g.focus(), [g]), Ke = h.useCallback(
      (qe, me, ne) => {
        const fe = !W.current && !ne;
        (m.value !== void 0 && m.value === me || fe) && E(qe);
      },
      [m.value]
    ), xe = i === "popper" ? u8 : hW, be = xe === u8 ? {
      side: o,
      sideOffset: d,
      align: a,
      alignOffset: V,
      arrowPadding: c,
      collisionBoundary: F,
      collisionPadding: X,
      sticky: Y,
      hideWhenDetached: q,
      avoidCollisions: f
    } : {};
    return /* @__PURE__ */ l(
      fW,
      {
        scope: t,
        content: g,
        viewport: b,
        onViewportChange: A,
        itemRefCallback: U,
        selectedItem: S,
        onItemLeave: de,
        itemTextRefCallback: Ke,
        focusSelectedItem: L,
        selectedItemText: O,
        position: i,
        isPositioned: R,
        searchRef: le,
        children: /* @__PURE__ */ l(aW, { as: i7, allowPinchZoom: !0, children: /* @__PURE__ */ l(
          _B,
          {
            asChild: !0,
            trapped: m.open,
            onMountAutoFocus: (qe) => {
              qe.preventDefault();
            },
            onUnmountAutoFocus: Yt(n, (qe) => {
              var me;
              (me = m.trigger) == null || me.focus({ preventScroll: !0 }), qe.preventDefault();
            }),
            children: /* @__PURE__ */ l(
              IB,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: s,
                onPointerDownOutside: u,
                onFocusOutside: (qe) => qe.preventDefault(),
                onDismiss: () => m.onOpenChange(!1),
                children: /* @__PURE__ */ l(
                  xe,
                  {
                    role: "listbox",
                    id: m.contentId,
                    "data-state": m.open ? "open" : "closed",
                    dir: m.dir,
                    onContextMenu: (qe) => qe.preventDefault(),
                    ...p,
                    ...be,
                    onPlaced: () => H(!0),
                    ref: w,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...p.style
                    },
                    onKeyDown: Yt(p.onKeyDown, (qe) => {
                      const me = qe.ctrlKey || qe.altKey || qe.metaKey;
                      if (qe.key === "Tab" && qe.preventDefault(), !me && qe.key.length === 1 && te(qe.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(qe.key)) {
                        let fe = I().filter((Ye) => !Ye.disabled).map((Ye) => Ye.ref.current);
                        if (["ArrowUp", "End"].includes(qe.key) && (fe = fe.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(qe.key)) {
                          const Ye = qe.target, Q = fe.indexOf(Ye);
                          fe = fe.slice(Q + 1);
                        }
                        setTimeout(() => B(fe)), qe.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
KW.displayName = B8e;
var W8e = "SelectItemAlignedPosition", hW = h.forwardRef((e, r) => {
  const { __scopeSelect: t, onPlaced: i, ...n } = e, s = Zo($d, t), u = Jo($d, t), [o, d] = h.useState(null), [a, V] = h.useState(null), c = ni(r, (w) => V(w)), F = RY(t), X = h.useRef(!1), Y = h.useRef(!0), { viewport: q, selectedItem: f, selectedItemText: p, focusSelectedItem: m } = u, g = h.useCallback(() => {
    if (s.trigger && s.valueNode && o && a && q && f && p) {
      const w = s.trigger.getBoundingClientRect(), S = a.getBoundingClientRect(), N = s.valueNode.getBoundingClientRect(), O = p.getBoundingClientRect();
      if (s.dir !== "rtl") {
        const Ye = O.left - S.left, Q = N.left - Ye, we = w.left - Q, oe = w.width + we, tr = Math.max(oe, S.width), ar = window.innerWidth - Jn, or = t7(Q, [
          Jn,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Jn, ar - tr)
        ]);
        o.style.minWidth = oe + "px", o.style.left = or + "px";
      } else {
        const Ye = S.right - O.right, Q = window.innerWidth - N.right - Ye, we = window.innerWidth - w.right - Q, oe = w.width + we, tr = Math.max(oe, S.width), ar = window.innerWidth - Jn, or = t7(Q, [
          Jn,
          Math.max(Jn, ar - tr)
        ]);
        o.style.minWidth = oe + "px", o.style.right = or + "px";
      }
      const E = F(), I = window.innerHeight - Jn * 2, R = q.scrollHeight, H = window.getComputedStyle(a), W = parseInt(H.borderTopWidth, 10), B = parseInt(H.paddingTop, 10), L = parseInt(H.borderBottomWidth, 10), z = parseInt(H.paddingBottom, 10), Z = W + B + R + z + L, le = Math.min(f.offsetHeight * 5, Z), te = window.getComputedStyle(q), U = parseInt(te.paddingTop, 10), de = parseInt(te.paddingBottom, 10), Ke = w.top + w.height / 2 - Jn, xe = I - Ke, be = f.offsetHeight / 2, qe = f.offsetTop + be, me = W + B + qe, ne = Z - me;
      if (me <= Ke) {
        const Ye = E.length > 0 && f === E[E.length - 1].ref.current;
        o.style.bottom = "0px";
        const Q = a.clientHeight - q.offsetTop - q.offsetHeight, we = Math.max(
          xe,
          be + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (Ye ? de : 0) + Q + L
        ), oe = me + we;
        o.style.height = oe + "px";
      } else {
        const Ye = E.length > 0 && f === E[0].ref.current;
        o.style.top = "0px";
        const we = Math.max(
          Ke,
          W + q.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (Ye ? U : 0) + be
        ) + ne;
        o.style.height = we + "px", q.scrollTop = me - Ke + q.offsetTop;
      }
      o.style.margin = `${Jn}px 0`, o.style.minHeight = le + "px", o.style.maxHeight = I + "px", i == null || i(), requestAnimationFrame(() => X.current = !0);
    }
  }, [
    F,
    s.trigger,
    s.valueNode,
    o,
    a,
    q,
    f,
    p,
    s.dir,
    i
  ]);
  ze(() => g(), [g]);
  const [y, b] = h.useState();
  ze(() => {
    a && b(window.getComputedStyle(a).zIndex);
  }, [a]);
  const A = h.useCallback(
    (w) => {
      w && Y.current === !0 && (g(), m == null || m(), Y.current = !1);
    },
    [g, m]
  );
  return /* @__PURE__ */ l(
    U8e,
    {
      scope: t,
      contentWrapper: o,
      shouldExpandOnScrollRef: X,
      onScrollButtonChange: A,
      children: /* @__PURE__ */ l(
        "div",
        {
          ref: d,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: y
          },
          children: /* @__PURE__ */ l(
            ht.div,
            {
              ...n,
              ref: c,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...n.style
              }
            }
          )
        }
      )
    }
  );
});
hW.displayName = W8e;
var G8e = "SelectPopperPosition", u8 = h.forwardRef((e, r) => {
  const {
    __scopeSelect: t,
    align: i = "start",
    collisionPadding: n = Jn,
    ...s
  } = e, u = IY(t);
  return /* @__PURE__ */ l(
    e8e,
    {
      ...u,
      ...s,
      ref: r,
      align: i,
      collisionPadding: n,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...s.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
u8.displayName = G8e;
var [U8e, VA] = wl($d, {}), o8 = "SelectViewport", pW = h.forwardRef(
  (e, r) => {
    const { __scopeSelect: t, nonce: i, ...n } = e, s = Jo(o8, t), u = VA(o8, t), o = ni(r, s.onViewportChange), d = h.useRef(0);
    return /* @__PURE__ */ C(he, { children: [
      /* @__PURE__ */ l(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: i
        }
      ),
      /* @__PURE__ */ l(DY.Slot, { scope: t, children: /* @__PURE__ */ l(
        ht.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...n,
          ref: o,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...n.style
          },
          onScroll: Yt(n.onScroll, (a) => {
            const V = a.currentTarget, { contentWrapper: c, shouldExpandOnScrollRef: F } = u;
            if (F != null && F.current && c) {
              const X = Math.abs(d.current - V.scrollTop);
              if (X > 0) {
                const Y = window.innerHeight - Jn * 2, q = parseFloat(c.style.minHeight), f = parseFloat(c.style.height), p = Math.max(q, f);
                if (p < Y) {
                  const m = p + X, g = Math.min(Y, m), y = m - g;
                  c.style.height = g + "px", c.style.bottom === "0px" && (V.scrollTop = y > 0 ? y : 0, c.style.justifyContent = "flex-end");
                }
              }
            }
            d.current = V.scrollTop;
          })
        }
      ) })
    ] });
  }
);
pW.displayName = o8;
var mW = "SelectGroup", [Z8e, J8e] = wl(mW), gW = h.forwardRef(
  (e, r) => {
    const { __scopeSelect: t, ...i } = e, n = ot();
    return /* @__PURE__ */ l(Z8e, { scope: t, id: n, children: /* @__PURE__ */ l(ht.div, { role: "group", "aria-labelledby": n, ...i, ref: r }) });
  }
);
gW.displayName = mW;
var vW = "SelectLabel", bW = h.forwardRef(
  (e, r) => {
    const { __scopeSelect: t, ...i } = e, n = J8e(vW, t);
    return /* @__PURE__ */ l(ht.div, { id: n.id, ...i, ref: r });
  }
);
bW.displayName = vW;
var xX = "SelectItem", [$8e, yW] = wl(xX), AW = h.forwardRef(
  (e, r) => {
    const {
      __scopeSelect: t,
      value: i,
      disabled: n = !1,
      textValue: s,
      ...u
    } = e, o = Zo(xX, t), d = Jo(xX, t), a = o.value === i, [V, c] = h.useState(s ?? ""), [F, X] = h.useState(!1), Y = ni(
      r,
      (m) => {
        var g;
        return (g = d.itemRefCallback) == null ? void 0 : g.call(d, m, i, n);
      }
    ), q = ot(), f = h.useRef("touch"), p = () => {
      n || (o.onValueChange(i), o.onOpenChange(!1));
    };
    if (i === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ l(
      $8e,
      {
        scope: t,
        value: i,
        disabled: n,
        textId: q,
        isSelected: a,
        onItemTextChange: h.useCallback((m) => {
          c((g) => g || ((m == null ? void 0 : m.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ l(
          DY.ItemSlot,
          {
            scope: t,
            value: i,
            disabled: n,
            textValue: V,
            children: /* @__PURE__ */ l(
              ht.div,
              {
                role: "option",
                "aria-labelledby": q,
                "data-highlighted": F ? "" : void 0,
                "aria-selected": a && F,
                "data-state": a ? "checked" : "unchecked",
                "aria-disabled": n || void 0,
                "data-disabled": n ? "" : void 0,
                tabIndex: n ? void 0 : -1,
                ...u,
                ref: Y,
                onFocus: Yt(u.onFocus, () => X(!0)),
                onBlur: Yt(u.onBlur, () => X(!1)),
                onClick: Yt(u.onClick, () => {
                  f.current !== "mouse" && p();
                }),
                onPointerUp: Yt(u.onPointerUp, () => {
                  f.current === "mouse" && p();
                }),
                onPointerDown: Yt(u.onPointerDown, (m) => {
                  f.current = m.pointerType;
                }),
                onPointerMove: Yt(u.onPointerMove, (m) => {
                  var g;
                  f.current = m.pointerType, n ? (g = d.onItemLeave) == null || g.call(d) : f.current === "mouse" && m.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: Yt(u.onPointerLeave, (m) => {
                  var g;
                  m.currentTarget === document.activeElement && ((g = d.onItemLeave) == null || g.call(d));
                }),
                onKeyDown: Yt(u.onKeyDown, (m) => {
                  var y;
                  ((y = d.searchRef) == null ? void 0 : y.current) !== "" && m.key === " " || (R8e.includes(m.key) && p(), m.key === " " && m.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
AW.displayName = xX;
var yc = "SelectItemText", wW = h.forwardRef(
  (e, r) => {
    const { __scopeSelect: t, className: i, style: n, ...s } = e, u = Zo(yc, t), o = Jo(yc, t), d = yW(yc, t), a = H8e(yc, t), [V, c] = h.useState(null), F = ni(
      r,
      (p) => c(p),
      d.onItemTextChange,
      (p) => {
        var m;
        return (m = o.itemTextRefCallback) == null ? void 0 : m.call(o, p, d.value, d.disabled);
      }
    ), X = V == null ? void 0 : V.textContent, Y = h.useMemo(
      () => /* @__PURE__ */ l("option", { value: d.value, disabled: d.disabled, children: X }, d.value),
      [d.disabled, d.value, X]
    ), { onNativeOptionAdd: q, onNativeOptionRemove: f } = a;
    return ze(() => (q(Y), () => f(Y)), [q, f, Y]), /* @__PURE__ */ C(he, { children: [
      /* @__PURE__ */ l(ht.span, { id: d.textId, ...s, ref: F }),
      d.isSelected && u.valueNode && !u.valueNodeHasChildren ? qs.createPortal(s.children, u.valueNode) : null
    ] });
  }
);
wW.displayName = yc;
var CW = "SelectItemIndicator", PW = h.forwardRef(
  (e, r) => {
    const { __scopeSelect: t, ...i } = e;
    return yW(CW, t).isSelected ? /* @__PURE__ */ l(ht.span, { "aria-hidden": !0, ...i, ref: r }) : null;
  }
);
PW.displayName = CW;
var d8 = "SelectScrollUpButton", Q8e = h.forwardRef((e, r) => {
  const t = Jo(d8, e.__scopeSelect), i = VA(d8, e.__scopeSelect), [n, s] = h.useState(!1), u = ni(r, i.onScrollButtonChange);
  return ze(() => {
    if (t.viewport && t.isPositioned) {
      let o = function() {
        const a = d.scrollTop > 0;
        s(a);
      };
      const d = t.viewport;
      return o(), d.addEventListener("scroll", o), () => d.removeEventListener("scroll", o);
    }
  }, [t.viewport, t.isPositioned]), n ? /* @__PURE__ */ l(
    SW,
    {
      ...e,
      ref: u,
      onAutoScroll: () => {
        const { viewport: o, selectedItem: d } = t;
        o && d && (o.scrollTop = o.scrollTop - d.offsetHeight);
      }
    }
  ) : null;
});
Q8e.displayName = d8;
var a8 = "SelectScrollDownButton", ebe = h.forwardRef((e, r) => {
  const t = Jo(a8, e.__scopeSelect), i = VA(a8, e.__scopeSelect), [n, s] = h.useState(!1), u = ni(r, i.onScrollButtonChange);
  return ze(() => {
    if (t.viewport && t.isPositioned) {
      let o = function() {
        const a = d.scrollHeight - d.clientHeight, V = Math.ceil(d.scrollTop) < a;
        s(V);
      };
      const d = t.viewport;
      return o(), d.addEventListener("scroll", o), () => d.removeEventListener("scroll", o);
    }
  }, [t.viewport, t.isPositioned]), n ? /* @__PURE__ */ l(
    SW,
    {
      ...e,
      ref: u,
      onAutoScroll: () => {
        const { viewport: o, selectedItem: d } = t;
        o && d && (o.scrollTop = o.scrollTop + d.offsetHeight);
      }
    }
  ) : null;
});
ebe.displayName = a8;
var SW = h.forwardRef((e, r) => {
  const { __scopeSelect: t, onAutoScroll: i, ...n } = e, s = Jo("SelectScrollButton", t), u = h.useRef(null), o = RY(t), d = h.useCallback(() => {
    u.current !== null && (window.clearInterval(u.current), u.current = null);
  }, []);
  return h.useEffect(() => () => d(), [d]), ze(() => {
    var V;
    const a = o().find((c) => c.ref.current === document.activeElement);
    (V = a == null ? void 0 : a.ref.current) == null || V.scrollIntoView({ block: "nearest" });
  }, [o]), /* @__PURE__ */ l(
    ht.div,
    {
      "aria-hidden": !0,
      ...n,
      ref: r,
      style: { flexShrink: 0, ...n.style },
      onPointerDown: Yt(n.onPointerDown, () => {
        u.current === null && (u.current = window.setInterval(i, 50));
      }),
      onPointerMove: Yt(n.onPointerMove, () => {
        var a;
        (a = s.onItemLeave) == null || a.call(s), u.current === null && (u.current = window.setInterval(i, 50));
      }),
      onPointerLeave: Yt(n.onPointerLeave, () => {
        d();
      })
    }
  );
}), rbe = "SelectSeparator", NW = h.forwardRef(
  (e, r) => {
    const { __scopeSelect: t, ...i } = e;
    return /* @__PURE__ */ l(ht.div, { "aria-hidden": !0, ...i, ref: r });
  }
);
NW.displayName = rbe;
var V8 = "SelectArrow", tbe = h.forwardRef(
  (e, r) => {
    const { __scopeSelect: t, ...i } = e, n = IY(t), s = Zo(V8, t), u = Jo(V8, t);
    return s.open && u.position === "popper" ? /* @__PURE__ */ l(r8e, { ...n, ...i, ref: r }) : null;
  }
);
tbe.displayName = V8;
function MW(e) {
  return e === "" || e === void 0;
}
var TW = h.forwardRef(
  (e, r) => {
    const { value: t, ...i } = e, n = h.useRef(null), s = ni(r, n), u = Kl(t);
    return h.useEffect(() => {
      const o = n.current, d = window.HTMLSelectElement.prototype, V = Object.getOwnPropertyDescriptor(
        d,
        "value"
      ).set;
      if (u !== t && V) {
        const c = new Event("change", { bubbles: !0 });
        V.call(o, t), o.dispatchEvent(c);
      }
    }, [u, t]), /* @__PURE__ */ l(tW, { asChild: !0, children: /* @__PURE__ */ l("select", { ...i, ref: s, defaultValue: t }) });
  }
);
TW.displayName = "BubbleSelect";
function EW(e) {
  const r = Ee(e), t = h.useRef(""), i = h.useRef(0), n = h.useCallback(
    (u) => {
      const o = t.current + u;
      r(o), function d(a) {
        t.current = a, window.clearTimeout(i.current), a !== "" && (i.current = window.setTimeout(() => d(""), 1e3));
      }(o);
    },
    [r]
  ), s = h.useCallback(() => {
    t.current = "", window.clearTimeout(i.current);
  }, []);
  return h.useEffect(() => () => window.clearTimeout(i.current), []), [t, n, s];
}
function kW(e, r, t) {
  const n = r.length > 1 && Array.from(r).every((a) => a === r[0]) ? r[0] : r, s = t ? e.indexOf(t) : -1;
  let u = ibe(e, Math.max(s, 0));
  n.length === 1 && (u = u.filter((a) => a !== t));
  const d = u.find(
    (a) => a.textValue.toLowerCase().startsWith(n.toLowerCase())
  );
  return d !== t ? d : void 0;
}
function ibe(e, r) {
  return e.map((t, i) => e[(r + i) % e.length]);
}
var nbe = VW, OW = cW, sbe = xW, ube = XW, obe = qW, DW = YW, dbe = pW, abe = gW, RW = bW, IW = AW, Vbe = wW, lbe = PW, LW = NW;
const cbe = nbe, ler = abe, Fbe = sbe, _W = re(({ className: e, children: r, ...t }, i) => /* @__PURE__ */ C(
  OW,
  {
    ref: i,
    className: _(
      "border-input bg-background ring-offset-background placeholder:text-muted-foreground focus:ring-ring flex h-10 w-full items-center justify-between rounded-md border px-3 py-2 text-bodysm focus:outline-hidden focus:ring-2 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...t,
    children: [
      r,
      /* @__PURE__ */ l(ube, { asChild: !0, children: /* @__PURE__ */ l(e2, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
_W.displayName = OW.displayName;
const HW = re(({ className: e, children: r, position: t = "popper", ...i }, n) => /* @__PURE__ */ l(obe, { children: /* @__PURE__ */ l(
  DW,
  {
    ref: n,
    className: _(
      "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 min-w-[8rem] overflow-hidden rounded-md border border-border shadow-md",
      t === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: t,
    ...i,
    children: /* @__PURE__ */ l(
      dbe,
      {
        className: _(
          "p-1",
          t === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
        ),
        children: r
      }
    )
  }
) }));
HW.displayName = DW.displayName;
const xbe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  RW,
  {
    ref: t,
    className: _("py-1.5 pl-8 pr-2 text-bodysm font-semibold", e),
    ...r
  }
));
xbe.displayName = RW.displayName;
const l8 = re(({ className: e, children: r, ...t }, i) => /* @__PURE__ */ C(
  IW,
  {
    ref: i,
    className: _(
      "focus:bg-accent focus:text-accent-foreground relative flex w-full cursor-default select-none items-center rounded-xs py-1.5 pl-8 pr-2 text-bodysm outline-hidden data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...t,
    children: [
      /* @__PURE__ */ l("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ l(lbe, { children: /* @__PURE__ */ l(Bo, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ l(Vbe, { children: r })
    ]
  }
));
l8.displayName = IW.displayName;
const Xbe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  LW,
  {
    ref: t,
    className: _("bg-muted -mx-1 my-1 h-px", e),
    ...r
  }
));
Xbe.displayName = LW.displayName;
var qbe = "Separator", $C = "horizontal", Ybe = ["horizontal", "vertical"], jW = h.forwardRef((e, r) => {
  const { decorative: t, orientation: i = $C, ...n } = e, s = fbe(i) ? i : $C, o = t ? { role: "none" } : { "aria-orientation": s === "vertical" ? s : void 0, role: "separator" };
  return /* @__PURE__ */ l(
    Me.div,
    {
      "data-orientation": s,
      ...o,
      ...n,
      ref: r
    }
  );
});
jW.displayName = qbe;
function fbe(e) {
  return Ybe.includes(e);
}
var zW = jW;
const Qd = re(
  ({ className: e, orientation: r = "horizontal", decorative: t = !0, ...i }, n) => /* @__PURE__ */ l(
    zW,
    {
      ref: n,
      decorative: t,
      orientation: r,
      className: _(
        "bg-border shrink-0",
        r === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        e
      ),
      ...i
    }
  )
);
Qd.displayName = zW.displayName;
const BW = gH, Kbe = vH, cer = gY, hbe = bH, WW = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  hY,
  {
    className: _(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/40",
      e
    ),
    ...r,
    ref: t
  }
));
WW.displayName = hY.displayName;
const pbe = Js(
  "fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), lA = re(
  ({
    className: e,
    children: r,
    hideCloseButton: t,
    showOverlay: i = !0,
    side: n = "right",
    ...s
  }, u) => /* @__PURE__ */ C(hbe, { children: [
    i && /* @__PURE__ */ l(WW, {}),
    /* @__PURE__ */ C(
      pY,
      {
        "aria-describedby": void 0,
        ref: u,
        className: _(pbe({ side: n }), e),
        ...s,
        children: [
          s.title && /* @__PURE__ */ l(X2, { children: s.title }),
          r,
          !t && /* @__PURE__ */ C(gY, { className: "ring-offset-background focus:ring-ring data-[state=open]:bg-secondary rounded-xs focus:outline-hidden absolute right-4 top-4 opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none", children: [
            /* @__PURE__ */ l(r2, { className: "h-4 w-4" }),
            /* @__PURE__ */ l("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] })
);
lA.displayName = pY.displayName;
const mbe = ({
  className: e,
  ...r
}) => /* @__PURE__ */ l(
  "div",
  {
    className: _(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...r
  }
);
mbe.displayName = "SheetHeader";
const GW = ({
  className: e,
  ...r
}) => /* @__PURE__ */ l(
  "div",
  {
    className: _(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...r
  }
);
GW.displayName = "SheetFooter";
const UW = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  X2,
  {
    ref: t,
    className: _("text-foreground text-bodylg font-semibold", e),
    ...r
  }
));
UW.displayName = X2.displayName;
const gbe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  mY,
  {
    ref: t,
    className: _("text-muted-foreground text-bodysm", e),
    ...r
  }
));
gbe.displayName = mY.displayName;
var Ac = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var vbe = Ac.exports, QC;
function bbe() {
  return QC || (QC = 1, function(e, r) {
    (function() {
      var t, i = "4.17.21", n = 200, s = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", u = "Expected a function", o = "Invalid `variable` option passed into `_.template`", d = "__lodash_hash_undefined__", a = 500, V = "__lodash_placeholder__", c = 1, F = 2, X = 4, Y = 1, q = 2, f = 1, p = 2, m = 4, g = 8, y = 16, b = 32, A = 64, w = 128, S = 256, N = 512, O = 30, E = "...", I = 800, R = 16, H = 1, W = 2, B = 3, L = 1 / 0, z = 9007199254740991, Z = 17976931348623157e292, le = NaN, te = 4294967295, U = te - 1, de = te >>> 1, Ke = [
        ["ary", w],
        ["bind", f],
        ["bindKey", p],
        ["curry", g],
        ["curryRight", y],
        ["flip", N],
        ["partial", b],
        ["partialRight", A],
        ["rearg", S]
      ], xe = "[object Arguments]", be = "[object Array]", qe = "[object AsyncFunction]", me = "[object Boolean]", ne = "[object Date]", fe = "[object DOMException]", Ye = "[object Error]", Q = "[object Function]", we = "[object GeneratorFunction]", oe = "[object Map]", tr = "[object Number]", ar = "[object Null]", or = "[object Object]", bt = "[object Promise]", Tr = "[object Proxy]", ms = "[object RegExp]", yt = "[object Set]", hi = "[object String]", $u = "[object Symbol]", _l = "[object Undefined]", uu = "[object WeakMap]", L2 = "[object WeakSet]", Qu = "[object ArrayBuffer]", Ya = "[object DataView]", Qf = "[object Float32Array]", eK = "[object Float64Array]", rK = "[object Int8Array]", tK = "[object Int16Array]", iK = "[object Int32Array]", nK = "[object Uint8Array]", sK = "[object Uint8ClampedArray]", uK = "[object Uint16Array]", oK = "[object Uint32Array]", Lre = /\b__p \+= '';/g, _re = /\b(__p \+=) '' \+/g, Hre = /(__e\(.*?\)|\b__t\)) \+\n'';/g, V5 = /&(?:amp|lt|gt|quot|#39);/g, l5 = /[&<>"']/g, jre = RegExp(V5.source), zre = RegExp(l5.source), Bre = /<%-([\s\S]+?)%>/g, Wre = /<%([\s\S]+?)%>/g, c5 = /<%=([\s\S]+?)%>/g, Gre = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ure = /^\w*$/, Zre = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, dK = /[\\^$.*+?()[\]{}|]/g, Jre = RegExp(dK.source), aK = /^\s+/, $re = /\s/, Qre = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, ete = /\{\n\/\* \[wrapped with (.+)\] \*/, rte = /,? & /, tte = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, ite = /[()=,{}\[\]\/\s]/, nte = /\\(\\)?/g, ste = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, F5 = /\w*$/, ute = /^[-+]0x[0-9a-f]+$/i, ote = /^0b[01]+$/i, dte = /^\[object .+?Constructor\]$/, ate = /^0o[0-7]+$/i, Vte = /^(?:0|[1-9]\d*)$/, lte = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, _2 = /($^)/, cte = /['\n\r\u2028\u2029\\]/g, H2 = "\\ud800-\\udfff", Fte = "\\u0300-\\u036f", xte = "\\ufe20-\\ufe2f", Xte = "\\u20d0-\\u20ff", x5 = Fte + xte + Xte, X5 = "\\u2700-\\u27bf", q5 = "a-z\\xdf-\\xf6\\xf8-\\xff", qte = "\\xac\\xb1\\xd7\\xf7", Yte = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", fte = "\\u2000-\\u206f", Kte = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Y5 = "A-Z\\xc0-\\xd6\\xd8-\\xde", f5 = "\\ufe0e\\ufe0f", K5 = qte + Yte + fte + Kte, VK = "['’]", hte = "[" + H2 + "]", h5 = "[" + K5 + "]", j2 = "[" + x5 + "]", p5 = "\\d+", pte = "[" + X5 + "]", m5 = "[" + q5 + "]", g5 = "[^" + H2 + K5 + p5 + X5 + q5 + Y5 + "]", lK = "\\ud83c[\\udffb-\\udfff]", mte = "(?:" + j2 + "|" + lK + ")", v5 = "[^" + H2 + "]", cK = "(?:\\ud83c[\\udde6-\\uddff]){2}", FK = "[\\ud800-\\udbff][\\udc00-\\udfff]", fa = "[" + Y5 + "]", b5 = "\\u200d", y5 = "(?:" + m5 + "|" + g5 + ")", gte = "(?:" + fa + "|" + g5 + ")", A5 = "(?:" + VK + "(?:d|ll|m|re|s|t|ve))?", w5 = "(?:" + VK + "(?:D|LL|M|RE|S|T|VE))?", C5 = mte + "?", P5 = "[" + f5 + "]?", vte = "(?:" + b5 + "(?:" + [v5, cK, FK].join("|") + ")" + P5 + C5 + ")*", bte = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", yte = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", S5 = P5 + C5 + vte, Ate = "(?:" + [pte, cK, FK].join("|") + ")" + S5, wte = "(?:" + [v5 + j2 + "?", j2, cK, FK, hte].join("|") + ")", Cte = RegExp(VK, "g"), Pte = RegExp(j2, "g"), xK = RegExp(lK + "(?=" + lK + ")|" + wte + S5, "g"), Ste = RegExp([
        fa + "?" + m5 + "+" + A5 + "(?=" + [h5, fa, "$"].join("|") + ")",
        gte + "+" + w5 + "(?=" + [h5, fa + y5, "$"].join("|") + ")",
        fa + "?" + y5 + "+" + A5,
        fa + "+" + w5,
        yte,
        bte,
        p5,
        Ate
      ].join("|"), "g"), Nte = RegExp("[" + b5 + H2 + x5 + f5 + "]"), Mte = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Tte = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], Ete = -1, $r = {};
      $r[Qf] = $r[eK] = $r[rK] = $r[tK] = $r[iK] = $r[nK] = $r[sK] = $r[uK] = $r[oK] = !0, $r[xe] = $r[be] = $r[Qu] = $r[me] = $r[Ya] = $r[ne] = $r[Ye] = $r[Q] = $r[oe] = $r[tr] = $r[or] = $r[ms] = $r[yt] = $r[hi] = $r[uu] = !1;
      var zr = {};
      zr[xe] = zr[be] = zr[Qu] = zr[Ya] = zr[me] = zr[ne] = zr[Qf] = zr[eK] = zr[rK] = zr[tK] = zr[iK] = zr[oe] = zr[tr] = zr[or] = zr[ms] = zr[yt] = zr[hi] = zr[$u] = zr[nK] = zr[sK] = zr[uK] = zr[oK] = !0, zr[Ye] = zr[Q] = zr[uu] = !1;
      var kte = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, Ote = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, Dte = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, Rte = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, Ite = parseFloat, Lte = parseInt, N5 = typeof vo == "object" && vo && vo.Object === Object && vo, _te = typeof self == "object" && self && self.Object === Object && self, Ut = N5 || _te || Function("return this")(), XK = r && !r.nodeType && r, ud = XK && !0 && e && !e.nodeType && e, M5 = ud && ud.exports === XK, qK = M5 && N5.process, Yn = function() {
        try {
          var J = ud && ud.require && ud.require("util").types;
          return J || qK && qK.binding && qK.binding("util");
        } catch {
        }
      }(), T5 = Yn && Yn.isArrayBuffer, E5 = Yn && Yn.isDate, k5 = Yn && Yn.isMap, O5 = Yn && Yn.isRegExp, D5 = Yn && Yn.isSet, R5 = Yn && Yn.isTypedArray;
      function en(J, ue, ee) {
        switch (ee.length) {
          case 0:
            return J.call(ue);
          case 1:
            return J.call(ue, ee[0]);
          case 2:
            return J.call(ue, ee[0], ee[1]);
          case 3:
            return J.call(ue, ee[0], ee[1], ee[2]);
        }
        return J.apply(ue, ee);
      }
      function Hte(J, ue, ee, ye) {
        for (var Je = -1, pr = J == null ? 0 : J.length; ++Je < pr; ) {
          var At = J[Je];
          ue(ye, At, ee(At), J);
        }
        return ye;
      }
      function fn(J, ue) {
        for (var ee = -1, ye = J == null ? 0 : J.length; ++ee < ye && ue(J[ee], ee, J) !== !1; )
          ;
        return J;
      }
      function jte(J, ue) {
        for (var ee = J == null ? 0 : J.length; ee-- && ue(J[ee], ee, J) !== !1; )
          ;
        return J;
      }
      function I5(J, ue) {
        for (var ee = -1, ye = J == null ? 0 : J.length; ++ee < ye; )
          if (!ue(J[ee], ee, J))
            return !1;
        return !0;
      }
      function eo(J, ue) {
        for (var ee = -1, ye = J == null ? 0 : J.length, Je = 0, pr = []; ++ee < ye; ) {
          var At = J[ee];
          ue(At, ee, J) && (pr[Je++] = At);
        }
        return pr;
      }
      function z2(J, ue) {
        var ee = J == null ? 0 : J.length;
        return !!ee && Ka(J, ue, 0) > -1;
      }
      function YK(J, ue, ee) {
        for (var ye = -1, Je = J == null ? 0 : J.length; ++ye < Je; )
          if (ee(ue, J[ye]))
            return !0;
        return !1;
      }
      function tt(J, ue) {
        for (var ee = -1, ye = J == null ? 0 : J.length, Je = Array(ye); ++ee < ye; )
          Je[ee] = ue(J[ee], ee, J);
        return Je;
      }
      function ro(J, ue) {
        for (var ee = -1, ye = ue.length, Je = J.length; ++ee < ye; )
          J[Je + ee] = ue[ee];
        return J;
      }
      function fK(J, ue, ee, ye) {
        var Je = -1, pr = J == null ? 0 : J.length;
        for (ye && pr && (ee = J[++Je]); ++Je < pr; )
          ee = ue(ee, J[Je], Je, J);
        return ee;
      }
      function zte(J, ue, ee, ye) {
        var Je = J == null ? 0 : J.length;
        for (ye && Je && (ee = J[--Je]); Je--; )
          ee = ue(ee, J[Je], Je, J);
        return ee;
      }
      function KK(J, ue) {
        for (var ee = -1, ye = J == null ? 0 : J.length; ++ee < ye; )
          if (ue(J[ee], ee, J))
            return !0;
        return !1;
      }
      var Bte = hK("length");
      function Wte(J) {
        return J.split("");
      }
      function Gte(J) {
        return J.match(tte) || [];
      }
      function L5(J, ue, ee) {
        var ye;
        return ee(J, function(Je, pr, At) {
          if (ue(Je, pr, At))
            return ye = pr, !1;
        }), ye;
      }
      function B2(J, ue, ee, ye) {
        for (var Je = J.length, pr = ee + (ye ? 1 : -1); ye ? pr-- : ++pr < Je; )
          if (ue(J[pr], pr, J))
            return pr;
        return -1;
      }
      function Ka(J, ue, ee) {
        return ue === ue ? uie(J, ue, ee) : B2(J, _5, ee);
      }
      function Ute(J, ue, ee, ye) {
        for (var Je = ee - 1, pr = J.length; ++Je < pr; )
          if (ye(J[Je], ue))
            return Je;
        return -1;
      }
      function _5(J) {
        return J !== J;
      }
      function H5(J, ue) {
        var ee = J == null ? 0 : J.length;
        return ee ? mK(J, ue) / ee : le;
      }
      function hK(J) {
        return function(ue) {
          return ue == null ? t : ue[J];
        };
      }
      function pK(J) {
        return function(ue) {
          return J == null ? t : J[ue];
        };
      }
      function j5(J, ue, ee, ye, Je) {
        return Je(J, function(pr, At, Rr) {
          ee = ye ? (ye = !1, pr) : ue(ee, pr, At, Rr);
        }), ee;
      }
      function Zte(J, ue) {
        var ee = J.length;
        for (J.sort(ue); ee--; )
          J[ee] = J[ee].value;
        return J;
      }
      function mK(J, ue) {
        for (var ee, ye = -1, Je = J.length; ++ye < Je; ) {
          var pr = ue(J[ye]);
          pr !== t && (ee = ee === t ? pr : ee + pr);
        }
        return ee;
      }
      function gK(J, ue) {
        for (var ee = -1, ye = Array(J); ++ee < J; )
          ye[ee] = ue(ee);
        return ye;
      }
      function Jte(J, ue) {
        return tt(ue, function(ee) {
          return [ee, J[ee]];
        });
      }
      function z5(J) {
        return J && J.slice(0, U5(J) + 1).replace(aK, "");
      }
      function rn(J) {
        return function(ue) {
          return J(ue);
        };
      }
      function vK(J, ue) {
        return tt(ue, function(ee) {
          return J[ee];
        });
      }
      function Hl(J, ue) {
        return J.has(ue);
      }
      function B5(J, ue) {
        for (var ee = -1, ye = J.length; ++ee < ye && Ka(ue, J[ee], 0) > -1; )
          ;
        return ee;
      }
      function W5(J, ue) {
        for (var ee = J.length; ee-- && Ka(ue, J[ee], 0) > -1; )
          ;
        return ee;
      }
      function $te(J, ue) {
        for (var ee = J.length, ye = 0; ee--; )
          J[ee] === ue && ++ye;
        return ye;
      }
      var Qte = pK(kte), eie = pK(Ote);
      function rie(J) {
        return "\\" + Rte[J];
      }
      function tie(J, ue) {
        return J == null ? t : J[ue];
      }
      function ha(J) {
        return Nte.test(J);
      }
      function iie(J) {
        return Mte.test(J);
      }
      function nie(J) {
        for (var ue, ee = []; !(ue = J.next()).done; )
          ee.push(ue.value);
        return ee;
      }
      function bK(J) {
        var ue = -1, ee = Array(J.size);
        return J.forEach(function(ye, Je) {
          ee[++ue] = [Je, ye];
        }), ee;
      }
      function G5(J, ue) {
        return function(ee) {
          return J(ue(ee));
        };
      }
      function to(J, ue) {
        for (var ee = -1, ye = J.length, Je = 0, pr = []; ++ee < ye; ) {
          var At = J[ee];
          (At === ue || At === V) && (J[ee] = V, pr[Je++] = ee);
        }
        return pr;
      }
      function W2(J) {
        var ue = -1, ee = Array(J.size);
        return J.forEach(function(ye) {
          ee[++ue] = ye;
        }), ee;
      }
      function sie(J) {
        var ue = -1, ee = Array(J.size);
        return J.forEach(function(ye) {
          ee[++ue] = [ye, ye];
        }), ee;
      }
      function uie(J, ue, ee) {
        for (var ye = ee - 1, Je = J.length; ++ye < Je; )
          if (J[ye] === ue)
            return ye;
        return -1;
      }
      function oie(J, ue, ee) {
        for (var ye = ee + 1; ye--; )
          if (J[ye] === ue)
            return ye;
        return ye;
      }
      function pa(J) {
        return ha(J) ? aie(J) : Bte(J);
      }
      function jn(J) {
        return ha(J) ? Vie(J) : Wte(J);
      }
      function U5(J) {
        for (var ue = J.length; ue-- && $re.test(J.charAt(ue)); )
          ;
        return ue;
      }
      var die = pK(Dte);
      function aie(J) {
        for (var ue = xK.lastIndex = 0; xK.test(J); )
          ++ue;
        return ue;
      }
      function Vie(J) {
        return J.match(xK) || [];
      }
      function lie(J) {
        return J.match(Ste) || [];
      }
      var cie = function J(ue) {
        ue = ue == null ? Ut : ma.defaults(Ut.Object(), ue, ma.pick(Ut, Tte));
        var ee = ue.Array, ye = ue.Date, Je = ue.Error, pr = ue.Function, At = ue.Math, Rr = ue.Object, yK = ue.RegExp, Fie = ue.String, Kn = ue.TypeError, G2 = ee.prototype, xie = pr.prototype, ga = Rr.prototype, U2 = ue["__core-js_shared__"], Z2 = xie.toString, Cr = ga.hasOwnProperty, Xie = 0, Z5 = function() {
          var x = /[^.]+$/.exec(U2 && U2.keys && U2.keys.IE_PROTO || "");
          return x ? "Symbol(src)_1." + x : "";
        }(), J2 = ga.toString, qie = Z2.call(Rr), Yie = Ut._, fie = yK(
          "^" + Z2.call(Cr).replace(dK, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), $2 = M5 ? ue.Buffer : t, io = ue.Symbol, Q2 = ue.Uint8Array, J5 = $2 ? $2.allocUnsafe : t, eF = G5(Rr.getPrototypeOf, Rr), $5 = Rr.create, Q5 = ga.propertyIsEnumerable, rF = G2.splice, e6 = io ? io.isConcatSpreadable : t, jl = io ? io.iterator : t, od = io ? io.toStringTag : t, tF = function() {
          try {
            var x = cd(Rr, "defineProperty");
            return x({}, "", {}), x;
          } catch {
          }
        }(), Kie = ue.clearTimeout !== Ut.clearTimeout && ue.clearTimeout, hie = ye && ye.now !== Ut.Date.now && ye.now, pie = ue.setTimeout !== Ut.setTimeout && ue.setTimeout, iF = At.ceil, nF = At.floor, AK = Rr.getOwnPropertySymbols, mie = $2 ? $2.isBuffer : t, r6 = ue.isFinite, gie = G2.join, vie = G5(Rr.keys, Rr), wt = At.max, di = At.min, bie = ye.now, yie = ue.parseInt, t6 = At.random, Aie = G2.reverse, wK = cd(ue, "DataView"), zl = cd(ue, "Map"), CK = cd(ue, "Promise"), va = cd(ue, "Set"), Bl = cd(ue, "WeakMap"), Wl = cd(Rr, "create"), sF = Bl && new Bl(), ba = {}, wie = Fd(wK), Cie = Fd(zl), Pie = Fd(CK), Sie = Fd(va), Nie = Fd(Bl), uF = io ? io.prototype : t, Gl = uF ? uF.valueOf : t, i6 = uF ? uF.toString : t;
        function T(x) {
          if (dt(x) && !Qe(x) && !(x instanceof xr)) {
            if (x instanceof hn)
              return x;
            if (Cr.call(x, "__wrapped__"))
              return nw(x);
          }
          return new hn(x);
        }
        var ya = /* @__PURE__ */ function() {
          function x() {
          }
          return function(K) {
            if (!st(K))
              return {};
            if ($5)
              return $5(K);
            x.prototype = K;
            var v = new x();
            return x.prototype = t, v;
          };
        }();
        function oF() {
        }
        function hn(x, K) {
          this.__wrapped__ = x, this.__actions__ = [], this.__chain__ = !!K, this.__index__ = 0, this.__values__ = t;
        }
        T.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: Bre,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Wre,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: c5,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: T
          }
        }, T.prototype = oF.prototype, T.prototype.constructor = T, hn.prototype = ya(oF.prototype), hn.prototype.constructor = hn;
        function xr(x) {
          this.__wrapped__ = x, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = te, this.__views__ = [];
        }
        function Mie() {
          var x = new xr(this.__wrapped__);
          return x.__actions__ = ki(this.__actions__), x.__dir__ = this.__dir__, x.__filtered__ = this.__filtered__, x.__iteratees__ = ki(this.__iteratees__), x.__takeCount__ = this.__takeCount__, x.__views__ = ki(this.__views__), x;
        }
        function Tie() {
          if (this.__filtered__) {
            var x = new xr(this);
            x.__dir__ = -1, x.__filtered__ = !0;
          } else
            x = this.clone(), x.__dir__ *= -1;
          return x;
        }
        function Eie() {
          var x = this.__wrapped__.value(), K = this.__dir__, v = Qe(x), P = K < 0, M = v ? x.length : 0, k = Wne(0, M, this.__views__), j = k.start, G = k.end, $ = G - j, ae = P ? G : j - 1, Ve = this.__iteratees__, ce = Ve.length, ge = 0, Se = di($, this.__takeCount__);
          if (!v || !P && M == $ && Se == $)
            return A6(x, this.__actions__);
          var Re = [];
          e:
            for (; $-- && ge < Se; ) {
              ae += K;
              for (var sr = -1, Ie = x[ae]; ++sr < ce; ) {
                var cr = Ve[sr], qr = cr.iteratee, sn = cr.type, gi = qr(Ie);
                if (sn == W)
                  Ie = gi;
                else if (!gi) {
                  if (sn == H)
                    continue e;
                  break e;
                }
              }
              Re[ge++] = Ie;
            }
          return Re;
        }
        xr.prototype = ya(oF.prototype), xr.prototype.constructor = xr;
        function dd(x) {
          var K = -1, v = x == null ? 0 : x.length;
          for (this.clear(); ++K < v; ) {
            var P = x[K];
            this.set(P[0], P[1]);
          }
        }
        function kie() {
          this.__data__ = Wl ? Wl(null) : {}, this.size = 0;
        }
        function Oie(x) {
          var K = this.has(x) && delete this.__data__[x];
          return this.size -= K ? 1 : 0, K;
        }
        function Die(x) {
          var K = this.__data__;
          if (Wl) {
            var v = K[x];
            return v === d ? t : v;
          }
          return Cr.call(K, x) ? K[x] : t;
        }
        function Rie(x) {
          var K = this.__data__;
          return Wl ? K[x] !== t : Cr.call(K, x);
        }
        function Iie(x, K) {
          var v = this.__data__;
          return this.size += this.has(x) ? 0 : 1, v[x] = Wl && K === t ? d : K, this;
        }
        dd.prototype.clear = kie, dd.prototype.delete = Oie, dd.prototype.get = Die, dd.prototype.has = Rie, dd.prototype.set = Iie;
        function ou(x) {
          var K = -1, v = x == null ? 0 : x.length;
          for (this.clear(); ++K < v; ) {
            var P = x[K];
            this.set(P[0], P[1]);
          }
        }
        function Lie() {
          this.__data__ = [], this.size = 0;
        }
        function _ie(x) {
          var K = this.__data__, v = dF(K, x);
          if (v < 0)
            return !1;
          var P = K.length - 1;
          return v == P ? K.pop() : rF.call(K, v, 1), --this.size, !0;
        }
        function Hie(x) {
          var K = this.__data__, v = dF(K, x);
          return v < 0 ? t : K[v][1];
        }
        function jie(x) {
          return dF(this.__data__, x) > -1;
        }
        function zie(x, K) {
          var v = this.__data__, P = dF(v, x);
          return P < 0 ? (++this.size, v.push([x, K])) : v[P][1] = K, this;
        }
        ou.prototype.clear = Lie, ou.prototype.delete = _ie, ou.prototype.get = Hie, ou.prototype.has = jie, ou.prototype.set = zie;
        function du(x) {
          var K = -1, v = x == null ? 0 : x.length;
          for (this.clear(); ++K < v; ) {
            var P = x[K];
            this.set(P[0], P[1]);
          }
        }
        function Bie() {
          this.size = 0, this.__data__ = {
            hash: new dd(),
            map: new (zl || ou)(),
            string: new dd()
          };
        }
        function Wie(x) {
          var K = hF(this, x).delete(x);
          return this.size -= K ? 1 : 0, K;
        }
        function Gie(x) {
          return hF(this, x).get(x);
        }
        function Uie(x) {
          return hF(this, x).has(x);
        }
        function Zie(x, K) {
          var v = hF(this, x), P = v.size;
          return v.set(x, K), this.size += v.size == P ? 0 : 1, this;
        }
        du.prototype.clear = Bie, du.prototype.delete = Wie, du.prototype.get = Gie, du.prototype.has = Uie, du.prototype.set = Zie;
        function ad(x) {
          var K = -1, v = x == null ? 0 : x.length;
          for (this.__data__ = new du(); ++K < v; )
            this.add(x[K]);
        }
        function Jie(x) {
          return this.__data__.set(x, d), this;
        }
        function $ie(x) {
          return this.__data__.has(x);
        }
        ad.prototype.add = ad.prototype.push = Jie, ad.prototype.has = $ie;
        function zn(x) {
          var K = this.__data__ = new ou(x);
          this.size = K.size;
        }
        function Qie() {
          this.__data__ = new ou(), this.size = 0;
        }
        function ene(x) {
          var K = this.__data__, v = K.delete(x);
          return this.size = K.size, v;
        }
        function rne(x) {
          return this.__data__.get(x);
        }
        function tne(x) {
          return this.__data__.has(x);
        }
        function ine(x, K) {
          var v = this.__data__;
          if (v instanceof ou) {
            var P = v.__data__;
            if (!zl || P.length < n - 1)
              return P.push([x, K]), this.size = ++v.size, this;
            v = this.__data__ = new du(P);
          }
          return v.set(x, K), this.size = v.size, this;
        }
        zn.prototype.clear = Qie, zn.prototype.delete = ene, zn.prototype.get = rne, zn.prototype.has = tne, zn.prototype.set = ine;
        function n6(x, K) {
          var v = Qe(x), P = !v && xd(x), M = !v && !P && ao(x), k = !v && !P && !M && Pa(x), j = v || P || M || k, G = j ? gK(x.length, Fie) : [], $ = G.length;
          for (var ae in x)
            (K || Cr.call(x, ae)) && !(j && // Safari 9 has enumerable `arguments.length` in strict mode.
            (ae == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            M && (ae == "offset" || ae == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            k && (ae == "buffer" || ae == "byteLength" || ae == "byteOffset") || // Skip index properties.
            cu(ae, $))) && G.push(ae);
          return G;
        }
        function s6(x) {
          var K = x.length;
          return K ? x[IK(0, K - 1)] : t;
        }
        function nne(x, K) {
          return pF(ki(x), Vd(K, 0, x.length));
        }
        function sne(x) {
          return pF(ki(x));
        }
        function PK(x, K, v) {
          (v !== t && !Bn(x[K], v) || v === t && !(K in x)) && au(x, K, v);
        }
        function Ul(x, K, v) {
          var P = x[K];
          (!(Cr.call(x, K) && Bn(P, v)) || v === t && !(K in x)) && au(x, K, v);
        }
        function dF(x, K) {
          for (var v = x.length; v--; )
            if (Bn(x[v][0], K))
              return v;
          return -1;
        }
        function une(x, K, v, P) {
          return no(x, function(M, k, j) {
            K(P, M, v(M), j);
          }), P;
        }
        function u6(x, K) {
          return x && vs(K, kt(K), x);
        }
        function one(x, K) {
          return x && vs(K, Di(K), x);
        }
        function au(x, K, v) {
          K == "__proto__" && tF ? tF(x, K, {
            configurable: !0,
            enumerable: !0,
            value: v,
            writable: !0
          }) : x[K] = v;
        }
        function SK(x, K) {
          for (var v = -1, P = K.length, M = ee(P), k = x == null; ++v < P; )
            M[v] = k ? t : lh(x, K[v]);
          return M;
        }
        function Vd(x, K, v) {
          return x === x && (v !== t && (x = x <= v ? x : v), K !== t && (x = x >= K ? x : K)), x;
        }
        function pn(x, K, v, P, M, k) {
          var j, G = K & c, $ = K & F, ae = K & X;
          if (v && (j = M ? v(x, P, M, k) : v(x)), j !== t)
            return j;
          if (!st(x))
            return x;
          var Ve = Qe(x);
          if (Ve) {
            if (j = Une(x), !G)
              return ki(x, j);
          } else {
            var ce = ai(x), ge = ce == Q || ce == we;
            if (ao(x))
              return P6(x, G);
            if (ce == or || ce == xe || ge && !M) {
              if (j = $ || ge ? {} : U6(x), !G)
                return $ ? Dne(x, one(j, x)) : One(x, u6(j, x));
            } else {
              if (!zr[ce])
                return M ? x : {};
              j = Zne(x, ce, G);
            }
          }
          k || (k = new zn());
          var Se = k.get(x);
          if (Se)
            return Se;
          k.set(x, j), vw(x) ? x.forEach(function(Ie) {
            j.add(pn(Ie, K, v, Ie, x, k));
          }) : mw(x) && x.forEach(function(Ie, cr) {
            j.set(cr, pn(Ie, K, v, cr, x, k));
          });
          var Re = ae ? $ ? JK : ZK : $ ? Di : kt, sr = Ve ? t : Re(x);
          return fn(sr || x, function(Ie, cr) {
            sr && (cr = Ie, Ie = x[cr]), Ul(j, cr, pn(Ie, K, v, cr, x, k));
          }), j;
        }
        function dne(x) {
          var K = kt(x);
          return function(v) {
            return o6(v, x, K);
          };
        }
        function o6(x, K, v) {
          var P = v.length;
          if (x == null)
            return !P;
          for (x = Rr(x); P--; ) {
            var M = v[P], k = K[M], j = x[M];
            if (j === t && !(M in x) || !k(j))
              return !1;
          }
          return !0;
        }
        function d6(x, K, v) {
          if (typeof x != "function")
            throw new Kn(u);
          return tc(function() {
            x.apply(t, v);
          }, K);
        }
        function Zl(x, K, v, P) {
          var M = -1, k = z2, j = !0, G = x.length, $ = [], ae = K.length;
          if (!G)
            return $;
          v && (K = tt(K, rn(v))), P ? (k = YK, j = !1) : K.length >= n && (k = Hl, j = !1, K = new ad(K));
          e:
            for (; ++M < G; ) {
              var Ve = x[M], ce = v == null ? Ve : v(Ve);
              if (Ve = P || Ve !== 0 ? Ve : 0, j && ce === ce) {
                for (var ge = ae; ge--; )
                  if (K[ge] === ce)
                    continue e;
                $.push(Ve);
              } else k(K, ce, P) || $.push(Ve);
            }
          return $;
        }
        var no = E6(gs), a6 = E6(MK, !0);
        function ane(x, K) {
          var v = !0;
          return no(x, function(P, M, k) {
            return v = !!K(P, M, k), v;
          }), v;
        }
        function aF(x, K, v) {
          for (var P = -1, M = x.length; ++P < M; ) {
            var k = x[P], j = K(k);
            if (j != null && (G === t ? j === j && !nn(j) : v(j, G)))
              var G = j, $ = k;
          }
          return $;
        }
        function Vne(x, K, v, P) {
          var M = x.length;
          for (v = ir(v), v < 0 && (v = -v > M ? 0 : M + v), P = P === t || P > M ? M : ir(P), P < 0 && (P += M), P = v > P ? 0 : yw(P); v < P; )
            x[v++] = K;
          return x;
        }
        function V6(x, K) {
          var v = [];
          return no(x, function(P, M, k) {
            K(P, M, k) && v.push(P);
          }), v;
        }
        function Zt(x, K, v, P, M) {
          var k = -1, j = x.length;
          for (v || (v = $ne), M || (M = []); ++k < j; ) {
            var G = x[k];
            K > 0 && v(G) ? K > 1 ? Zt(G, K - 1, v, P, M) : ro(M, G) : P || (M[M.length] = G);
          }
          return M;
        }
        var NK = k6(), l6 = k6(!0);
        function gs(x, K) {
          return x && NK(x, K, kt);
        }
        function MK(x, K) {
          return x && l6(x, K, kt);
        }
        function VF(x, K) {
          return eo(K, function(v) {
            return Fu(x[v]);
          });
        }
        function ld(x, K) {
          K = uo(K, x);
          for (var v = 0, P = K.length; x != null && v < P; )
            x = x[bs(K[v++])];
          return v && v == P ? x : t;
        }
        function c6(x, K, v) {
          var P = K(x);
          return Qe(x) ? P : ro(P, v(x));
        }
        function pi(x) {
          return x == null ? x === t ? _l : ar : od && od in Rr(x) ? Bne(x) : sse(x);
        }
        function TK(x, K) {
          return x > K;
        }
        function lne(x, K) {
          return x != null && Cr.call(x, K);
        }
        function cne(x, K) {
          return x != null && K in Rr(x);
        }
        function Fne(x, K, v) {
          return x >= di(K, v) && x < wt(K, v);
        }
        function EK(x, K, v) {
          for (var P = v ? YK : z2, M = x[0].length, k = x.length, j = k, G = ee(k), $ = 1 / 0, ae = []; j--; ) {
            var Ve = x[j];
            j && K && (Ve = tt(Ve, rn(K))), $ = di(Ve.length, $), G[j] = !v && (K || M >= 120 && Ve.length >= 120) ? new ad(j && Ve) : t;
          }
          Ve = x[0];
          var ce = -1, ge = G[0];
          e:
            for (; ++ce < M && ae.length < $; ) {
              var Se = Ve[ce], Re = K ? K(Se) : Se;
              if (Se = v || Se !== 0 ? Se : 0, !(ge ? Hl(ge, Re) : P(ae, Re, v))) {
                for (j = k; --j; ) {
                  var sr = G[j];
                  if (!(sr ? Hl(sr, Re) : P(x[j], Re, v)))
                    continue e;
                }
                ge && ge.push(Re), ae.push(Se);
              }
            }
          return ae;
        }
        function xne(x, K, v, P) {
          return gs(x, function(M, k, j) {
            K(P, v(M), k, j);
          }), P;
        }
        function Jl(x, K, v) {
          K = uo(K, x), x = Q6(x, K);
          var P = x == null ? x : x[bs(gn(K))];
          return P == null ? t : en(P, x, v);
        }
        function F6(x) {
          return dt(x) && pi(x) == xe;
        }
        function Xne(x) {
          return dt(x) && pi(x) == Qu;
        }
        function qne(x) {
          return dt(x) && pi(x) == ne;
        }
        function $l(x, K, v, P, M) {
          return x === K ? !0 : x == null || K == null || !dt(x) && !dt(K) ? x !== x && K !== K : Yne(x, K, v, P, $l, M);
        }
        function Yne(x, K, v, P, M, k) {
          var j = Qe(x), G = Qe(K), $ = j ? be : ai(x), ae = G ? be : ai(K);
          $ = $ == xe ? or : $, ae = ae == xe ? or : ae;
          var Ve = $ == or, ce = ae == or, ge = $ == ae;
          if (ge && ao(x)) {
            if (!ao(K))
              return !1;
            j = !0, Ve = !1;
          }
          if (ge && !Ve)
            return k || (k = new zn()), j || Pa(x) ? B6(x, K, v, P, M, k) : jne(x, K, $, v, P, M, k);
          if (!(v & Y)) {
            var Se = Ve && Cr.call(x, "__wrapped__"), Re = ce && Cr.call(K, "__wrapped__");
            if (Se || Re) {
              var sr = Se ? x.value() : x, Ie = Re ? K.value() : K;
              return k || (k = new zn()), M(sr, Ie, v, P, k);
            }
          }
          return ge ? (k || (k = new zn()), zne(x, K, v, P, M, k)) : !1;
        }
        function fne(x) {
          return dt(x) && ai(x) == oe;
        }
        function kK(x, K, v, P) {
          var M = v.length, k = M, j = !P;
          if (x == null)
            return !k;
          for (x = Rr(x); M--; ) {
            var G = v[M];
            if (j && G[2] ? G[1] !== x[G[0]] : !(G[0] in x))
              return !1;
          }
          for (; ++M < k; ) {
            G = v[M];
            var $ = G[0], ae = x[$], Ve = G[1];
            if (j && G[2]) {
              if (ae === t && !($ in x))
                return !1;
            } else {
              var ce = new zn();
              if (P)
                var ge = P(ae, Ve, $, x, K, ce);
              if (!(ge === t ? $l(Ve, ae, Y | q, P, ce) : ge))
                return !1;
            }
          }
          return !0;
        }
        function x6(x) {
          if (!st(x) || ese(x))
            return !1;
          var K = Fu(x) ? fie : dte;
          return K.test(Fd(x));
        }
        function Kne(x) {
          return dt(x) && pi(x) == ms;
        }
        function hne(x) {
          return dt(x) && ai(x) == yt;
        }
        function pne(x) {
          return dt(x) && AF(x.length) && !!$r[pi(x)];
        }
        function X6(x) {
          return typeof x == "function" ? x : x == null ? Ri : typeof x == "object" ? Qe(x) ? f6(x[0], x[1]) : Y6(x) : Ow(x);
        }
        function OK(x) {
          if (!rc(x))
            return vie(x);
          var K = [];
          for (var v in Rr(x))
            Cr.call(x, v) && v != "constructor" && K.push(v);
          return K;
        }
        function mne(x) {
          if (!st(x))
            return nse(x);
          var K = rc(x), v = [];
          for (var P in x)
            P == "constructor" && (K || !Cr.call(x, P)) || v.push(P);
          return v;
        }
        function DK(x, K) {
          return x < K;
        }
        function q6(x, K) {
          var v = -1, P = Oi(x) ? ee(x.length) : [];
          return no(x, function(M, k, j) {
            P[++v] = K(M, k, j);
          }), P;
        }
        function Y6(x) {
          var K = QK(x);
          return K.length == 1 && K[0][2] ? J6(K[0][0], K[0][1]) : function(v) {
            return v === x || kK(v, x, K);
          };
        }
        function f6(x, K) {
          return rh(x) && Z6(K) ? J6(bs(x), K) : function(v) {
            var P = lh(v, x);
            return P === t && P === K ? ch(v, x) : $l(K, P, Y | q);
          };
        }
        function lF(x, K, v, P, M) {
          x !== K && NK(K, function(k, j) {
            if (M || (M = new zn()), st(k))
              gne(x, K, j, v, lF, P, M);
            else {
              var G = P ? P(ih(x, j), k, j + "", x, K, M) : t;
              G === t && (G = k), PK(x, j, G);
            }
          }, Di);
        }
        function gne(x, K, v, P, M, k, j) {
          var G = ih(x, v), $ = ih(K, v), ae = j.get($);
          if (ae) {
            PK(x, v, ae);
            return;
          }
          var Ve = k ? k(G, $, v + "", x, K, j) : t, ce = Ve === t;
          if (ce) {
            var ge = Qe($), Se = !ge && ao($), Re = !ge && !Se && Pa($);
            Ve = $, ge || Se || Re ? Qe(G) ? Ve = G : Ft(G) ? Ve = ki(G) : Se ? (ce = !1, Ve = P6($, !0)) : Re ? (ce = !1, Ve = S6($, !0)) : Ve = [] : ic($) || xd($) ? (Ve = G, xd(G) ? Ve = Aw(G) : (!st(G) || Fu(G)) && (Ve = U6($))) : ce = !1;
          }
          ce && (j.set($, Ve), M(Ve, $, P, k, j), j.delete($)), PK(x, v, Ve);
        }
        function K6(x, K) {
          var v = x.length;
          if (v)
            return K += K < 0 ? v : 0, cu(K, v) ? x[K] : t;
        }
        function h6(x, K, v) {
          K.length ? K = tt(K, function(k) {
            return Qe(k) ? function(j) {
              return ld(j, k.length === 1 ? k[0] : k);
            } : k;
          }) : K = [Ri];
          var P = -1;
          K = tt(K, rn(Oe()));
          var M = q6(x, function(k, j, G) {
            var $ = tt(K, function(ae) {
              return ae(k);
            });
            return { criteria: $, index: ++P, value: k };
          });
          return Zte(M, function(k, j) {
            return kne(k, j, v);
          });
        }
        function vne(x, K) {
          return p6(x, K, function(v, P) {
            return ch(x, P);
          });
        }
        function p6(x, K, v) {
          for (var P = -1, M = K.length, k = {}; ++P < M; ) {
            var j = K[P], G = ld(x, j);
            v(G, j) && Ql(k, uo(j, x), G);
          }
          return k;
        }
        function bne(x) {
          return function(K) {
            return ld(K, x);
          };
        }
        function RK(x, K, v, P) {
          var M = P ? Ute : Ka, k = -1, j = K.length, G = x;
          for (x === K && (K = ki(K)), v && (G = tt(x, rn(v))); ++k < j; )
            for (var $ = 0, ae = K[k], Ve = v ? v(ae) : ae; ($ = M(G, Ve, $, P)) > -1; )
              G !== x && rF.call(G, $, 1), rF.call(x, $, 1);
          return x;
        }
        function m6(x, K) {
          for (var v = x ? K.length : 0, P = v - 1; v--; ) {
            var M = K[v];
            if (v == P || M !== k) {
              var k = M;
              cu(M) ? rF.call(x, M, 1) : HK(x, M);
            }
          }
          return x;
        }
        function IK(x, K) {
          return x + nF(t6() * (K - x + 1));
        }
        function yne(x, K, v, P) {
          for (var M = -1, k = wt(iF((K - x) / (v || 1)), 0), j = ee(k); k--; )
            j[P ? k : ++M] = x, x += v;
          return j;
        }
        function LK(x, K) {
          var v = "";
          if (!x || K < 1 || K > z)
            return v;
          do
            K % 2 && (v += x), K = nF(K / 2), K && (x += x);
          while (K);
          return v;
        }
        function dr(x, K) {
          return nh($6(x, K, Ri), x + "");
        }
        function Ane(x) {
          return s6(Sa(x));
        }
        function wne(x, K) {
          var v = Sa(x);
          return pF(v, Vd(K, 0, v.length));
        }
        function Ql(x, K, v, P) {
          if (!st(x))
            return x;
          K = uo(K, x);
          for (var M = -1, k = K.length, j = k - 1, G = x; G != null && ++M < k; ) {
            var $ = bs(K[M]), ae = v;
            if ($ === "__proto__" || $ === "constructor" || $ === "prototype")
              return x;
            if (M != j) {
              var Ve = G[$];
              ae = P ? P(Ve, $, G) : t, ae === t && (ae = st(Ve) ? Ve : cu(K[M + 1]) ? [] : {});
            }
            Ul(G, $, ae), G = G[$];
          }
          return x;
        }
        var g6 = sF ? function(x, K) {
          return sF.set(x, K), x;
        } : Ri, Cne = tF ? function(x, K) {
          return tF(x, "toString", {
            configurable: !0,
            enumerable: !1,
            value: xh(K),
            writable: !0
          });
        } : Ri;
        function Pne(x) {
          return pF(Sa(x));
        }
        function mn(x, K, v) {
          var P = -1, M = x.length;
          K < 0 && (K = -K > M ? 0 : M + K), v = v > M ? M : v, v < 0 && (v += M), M = K > v ? 0 : v - K >>> 0, K >>>= 0;
          for (var k = ee(M); ++P < M; )
            k[P] = x[P + K];
          return k;
        }
        function Sne(x, K) {
          var v;
          return no(x, function(P, M, k) {
            return v = K(P, M, k), !v;
          }), !!v;
        }
        function cF(x, K, v) {
          var P = 0, M = x == null ? P : x.length;
          if (typeof K == "number" && K === K && M <= de) {
            for (; P < M; ) {
              var k = P + M >>> 1, j = x[k];
              j !== null && !nn(j) && (v ? j <= K : j < K) ? P = k + 1 : M = k;
            }
            return M;
          }
          return _K(x, K, Ri, v);
        }
        function _K(x, K, v, P) {
          var M = 0, k = x == null ? 0 : x.length;
          if (k === 0)
            return 0;
          K = v(K);
          for (var j = K !== K, G = K === null, $ = nn(K), ae = K === t; M < k; ) {
            var Ve = nF((M + k) / 2), ce = v(x[Ve]), ge = ce !== t, Se = ce === null, Re = ce === ce, sr = nn(ce);
            if (j)
              var Ie = P || Re;
            else ae ? Ie = Re && (P || ge) : G ? Ie = Re && ge && (P || !Se) : $ ? Ie = Re && ge && !Se && (P || !sr) : Se || sr ? Ie = !1 : Ie = P ? ce <= K : ce < K;
            Ie ? M = Ve + 1 : k = Ve;
          }
          return di(k, U);
        }
        function v6(x, K) {
          for (var v = -1, P = x.length, M = 0, k = []; ++v < P; ) {
            var j = x[v], G = K ? K(j) : j;
            if (!v || !Bn(G, $)) {
              var $ = G;
              k[M++] = j === 0 ? 0 : j;
            }
          }
          return k;
        }
        function b6(x) {
          return typeof x == "number" ? x : nn(x) ? le : +x;
        }
        function tn(x) {
          if (typeof x == "string")
            return x;
          if (Qe(x))
            return tt(x, tn) + "";
          if (nn(x))
            return i6 ? i6.call(x) : "";
          var K = x + "";
          return K == "0" && 1 / x == -1 / 0 ? "-0" : K;
        }
        function so(x, K, v) {
          var P = -1, M = z2, k = x.length, j = !0, G = [], $ = G;
          if (v)
            j = !1, M = YK;
          else if (k >= n) {
            var ae = K ? null : _ne(x);
            if (ae)
              return W2(ae);
            j = !1, M = Hl, $ = new ad();
          } else
            $ = K ? [] : G;
          e:
            for (; ++P < k; ) {
              var Ve = x[P], ce = K ? K(Ve) : Ve;
              if (Ve = v || Ve !== 0 ? Ve : 0, j && ce === ce) {
                for (var ge = $.length; ge--; )
                  if ($[ge] === ce)
                    continue e;
                K && $.push(ce), G.push(Ve);
              } else M($, ce, v) || ($ !== G && $.push(ce), G.push(Ve));
            }
          return G;
        }
        function HK(x, K) {
          return K = uo(K, x), x = Q6(x, K), x == null || delete x[bs(gn(K))];
        }
        function y6(x, K, v, P) {
          return Ql(x, K, v(ld(x, K)), P);
        }
        function FF(x, K, v, P) {
          for (var M = x.length, k = P ? M : -1; (P ? k-- : ++k < M) && K(x[k], k, x); )
            ;
          return v ? mn(x, P ? 0 : k, P ? k + 1 : M) : mn(x, P ? k + 1 : 0, P ? M : k);
        }
        function A6(x, K) {
          var v = x;
          return v instanceof xr && (v = v.value()), fK(K, function(P, M) {
            return M.func.apply(M.thisArg, ro([P], M.args));
          }, v);
        }
        function jK(x, K, v) {
          var P = x.length;
          if (P < 2)
            return P ? so(x[0]) : [];
          for (var M = -1, k = ee(P); ++M < P; )
            for (var j = x[M], G = -1; ++G < P; )
              G != M && (k[M] = Zl(k[M] || j, x[G], K, v));
          return so(Zt(k, 1), K, v);
        }
        function w6(x, K, v) {
          for (var P = -1, M = x.length, k = K.length, j = {}; ++P < M; ) {
            var G = P < k ? K[P] : t;
            v(j, x[P], G);
          }
          return j;
        }
        function zK(x) {
          return Ft(x) ? x : [];
        }
        function BK(x) {
          return typeof x == "function" ? x : Ri;
        }
        function uo(x, K) {
          return Qe(x) ? x : rh(x, K) ? [x] : iw(mr(x));
        }
        var Nne = dr;
        function oo(x, K, v) {
          var P = x.length;
          return v = v === t ? P : v, !K && v >= P ? x : mn(x, K, v);
        }
        var C6 = Kie || function(x) {
          return Ut.clearTimeout(x);
        };
        function P6(x, K) {
          if (K)
            return x.slice();
          var v = x.length, P = J5 ? J5(v) : new x.constructor(v);
          return x.copy(P), P;
        }
        function WK(x) {
          var K = new x.constructor(x.byteLength);
          return new Q2(K).set(new Q2(x)), K;
        }
        function Mne(x, K) {
          var v = K ? WK(x.buffer) : x.buffer;
          return new x.constructor(v, x.byteOffset, x.byteLength);
        }
        function Tne(x) {
          var K = new x.constructor(x.source, F5.exec(x));
          return K.lastIndex = x.lastIndex, K;
        }
        function Ene(x) {
          return Gl ? Rr(Gl.call(x)) : {};
        }
        function S6(x, K) {
          var v = K ? WK(x.buffer) : x.buffer;
          return new x.constructor(v, x.byteOffset, x.length);
        }
        function N6(x, K) {
          if (x !== K) {
            var v = x !== t, P = x === null, M = x === x, k = nn(x), j = K !== t, G = K === null, $ = K === K, ae = nn(K);
            if (!G && !ae && !k && x > K || k && j && $ && !G && !ae || P && j && $ || !v && $ || !M)
              return 1;
            if (!P && !k && !ae && x < K || ae && v && M && !P && !k || G && v && M || !j && M || !$)
              return -1;
          }
          return 0;
        }
        function kne(x, K, v) {
          for (var P = -1, M = x.criteria, k = K.criteria, j = M.length, G = v.length; ++P < j; ) {
            var $ = N6(M[P], k[P]);
            if ($) {
              if (P >= G)
                return $;
              var ae = v[P];
              return $ * (ae == "desc" ? -1 : 1);
            }
          }
          return x.index - K.index;
        }
        function M6(x, K, v, P) {
          for (var M = -1, k = x.length, j = v.length, G = -1, $ = K.length, ae = wt(k - j, 0), Ve = ee($ + ae), ce = !P; ++G < $; )
            Ve[G] = K[G];
          for (; ++M < j; )
            (ce || M < k) && (Ve[v[M]] = x[M]);
          for (; ae--; )
            Ve[G++] = x[M++];
          return Ve;
        }
        function T6(x, K, v, P) {
          for (var M = -1, k = x.length, j = -1, G = v.length, $ = -1, ae = K.length, Ve = wt(k - G, 0), ce = ee(Ve + ae), ge = !P; ++M < Ve; )
            ce[M] = x[M];
          for (var Se = M; ++$ < ae; )
            ce[Se + $] = K[$];
          for (; ++j < G; )
            (ge || M < k) && (ce[Se + v[j]] = x[M++]);
          return ce;
        }
        function ki(x, K) {
          var v = -1, P = x.length;
          for (K || (K = ee(P)); ++v < P; )
            K[v] = x[v];
          return K;
        }
        function vs(x, K, v, P) {
          var M = !v;
          v || (v = {});
          for (var k = -1, j = K.length; ++k < j; ) {
            var G = K[k], $ = P ? P(v[G], x[G], G, v, x) : t;
            $ === t && ($ = x[G]), M ? au(v, G, $) : Ul(v, G, $);
          }
          return v;
        }
        function One(x, K) {
          return vs(x, eh(x), K);
        }
        function Dne(x, K) {
          return vs(x, W6(x), K);
        }
        function xF(x, K) {
          return function(v, P) {
            var M = Qe(v) ? Hte : une, k = K ? K() : {};
            return M(v, x, Oe(P, 2), k);
          };
        }
        function Aa(x) {
          return dr(function(K, v) {
            var P = -1, M = v.length, k = M > 1 ? v[M - 1] : t, j = M > 2 ? v[2] : t;
            for (k = x.length > 3 && typeof k == "function" ? (M--, k) : t, j && mi(v[0], v[1], j) && (k = M < 3 ? t : k, M = 1), K = Rr(K); ++P < M; ) {
              var G = v[P];
              G && x(K, G, P, k);
            }
            return K;
          });
        }
        function E6(x, K) {
          return function(v, P) {
            if (v == null)
              return v;
            if (!Oi(v))
              return x(v, P);
            for (var M = v.length, k = K ? M : -1, j = Rr(v); (K ? k-- : ++k < M) && P(j[k], k, j) !== !1; )
              ;
            return v;
          };
        }
        function k6(x) {
          return function(K, v, P) {
            for (var M = -1, k = Rr(K), j = P(K), G = j.length; G--; ) {
              var $ = j[x ? G : ++M];
              if (v(k[$], $, k) === !1)
                break;
            }
            return K;
          };
        }
        function Rne(x, K, v) {
          var P = K & f, M = ec(x);
          function k() {
            var j = this && this !== Ut && this instanceof k ? M : x;
            return j.apply(P ? v : this, arguments);
          }
          return k;
        }
        function O6(x) {
          return function(K) {
            K = mr(K);
            var v = ha(K) ? jn(K) : t, P = v ? v[0] : K.charAt(0), M = v ? oo(v, 1).join("") : K.slice(1);
            return P[x]() + M;
          };
        }
        function wa(x) {
          return function(K) {
            return fK(Ew(Tw(K).replace(Cte, "")), x, "");
          };
        }
        function ec(x) {
          return function() {
            var K = arguments;
            switch (K.length) {
              case 0:
                return new x();
              case 1:
                return new x(K[0]);
              case 2:
                return new x(K[0], K[1]);
              case 3:
                return new x(K[0], K[1], K[2]);
              case 4:
                return new x(K[0], K[1], K[2], K[3]);
              case 5:
                return new x(K[0], K[1], K[2], K[3], K[4]);
              case 6:
                return new x(K[0], K[1], K[2], K[3], K[4], K[5]);
              case 7:
                return new x(K[0], K[1], K[2], K[3], K[4], K[5], K[6]);
            }
            var v = ya(x.prototype), P = x.apply(v, K);
            return st(P) ? P : v;
          };
        }
        function Ine(x, K, v) {
          var P = ec(x);
          function M() {
            for (var k = arguments.length, j = ee(k), G = k, $ = Ca(M); G--; )
              j[G] = arguments[G];
            var ae = k < 3 && j[0] !== $ && j[k - 1] !== $ ? [] : to(j, $);
            if (k -= ae.length, k < v)
              return _6(
                x,
                K,
                XF,
                M.placeholder,
                t,
                j,
                ae,
                t,
                t,
                v - k
              );
            var Ve = this && this !== Ut && this instanceof M ? P : x;
            return en(Ve, this, j);
          }
          return M;
        }
        function D6(x) {
          return function(K, v, P) {
            var M = Rr(K);
            if (!Oi(K)) {
              var k = Oe(v, 3);
              K = kt(K), v = function(G) {
                return k(M[G], G, M);
              };
            }
            var j = x(K, v, P);
            return j > -1 ? M[k ? K[j] : j] : t;
          };
        }
        function R6(x) {
          return lu(function(K) {
            var v = K.length, P = v, M = hn.prototype.thru;
            for (x && K.reverse(); P--; ) {
              var k = K[P];
              if (typeof k != "function")
                throw new Kn(u);
              if (M && !j && KF(k) == "wrapper")
                var j = new hn([], !0);
            }
            for (P = j ? P : v; ++P < v; ) {
              k = K[P];
              var G = KF(k), $ = G == "wrapper" ? $K(k) : t;
              $ && th($[0]) && $[1] == (w | g | b | S) && !$[4].length && $[9] == 1 ? j = j[KF($[0])].apply(j, $[3]) : j = k.length == 1 && th(k) ? j[G]() : j.thru(k);
            }
            return function() {
              var ae = arguments, Ve = ae[0];
              if (j && ae.length == 1 && Qe(Ve))
                return j.plant(Ve).value();
              for (var ce = 0, ge = v ? K[ce].apply(this, ae) : Ve; ++ce < v; )
                ge = K[ce].call(this, ge);
              return ge;
            };
          });
        }
        function XF(x, K, v, P, M, k, j, G, $, ae) {
          var Ve = K & w, ce = K & f, ge = K & p, Se = K & (g | y), Re = K & N, sr = ge ? t : ec(x);
          function Ie() {
            for (var cr = arguments.length, qr = ee(cr), sn = cr; sn--; )
              qr[sn] = arguments[sn];
            if (Se)
              var gi = Ca(Ie), un = $te(qr, gi);
            if (P && (qr = M6(qr, P, M, Se)), k && (qr = T6(qr, k, j, Se)), cr -= un, Se && cr < ae) {
              var xt = to(qr, gi);
              return _6(
                x,
                K,
                XF,
                Ie.placeholder,
                v,
                qr,
                xt,
                G,
                $,
                ae - cr
              );
            }
            var Wn = ce ? v : this, Xu = ge ? Wn[x] : x;
            return cr = qr.length, G ? qr = use(qr, G) : Re && cr > 1 && qr.reverse(), Ve && $ < cr && (qr.length = $), this && this !== Ut && this instanceof Ie && (Xu = sr || ec(Xu)), Xu.apply(Wn, qr);
          }
          return Ie;
        }
        function I6(x, K) {
          return function(v, P) {
            return xne(v, x, K(P), {});
          };
        }
        function qF(x, K) {
          return function(v, P) {
            var M;
            if (v === t && P === t)
              return K;
            if (v !== t && (M = v), P !== t) {
              if (M === t)
                return P;
              typeof v == "string" || typeof P == "string" ? (v = tn(v), P = tn(P)) : (v = b6(v), P = b6(P)), M = x(v, P);
            }
            return M;
          };
        }
        function GK(x) {
          return lu(function(K) {
            return K = tt(K, rn(Oe())), dr(function(v) {
              var P = this;
              return x(K, function(M) {
                return en(M, P, v);
              });
            });
          });
        }
        function YF(x, K) {
          K = K === t ? " " : tn(K);
          var v = K.length;
          if (v < 2)
            return v ? LK(K, x) : K;
          var P = LK(K, iF(x / pa(K)));
          return ha(K) ? oo(jn(P), 0, x).join("") : P.slice(0, x);
        }
        function Lne(x, K, v, P) {
          var M = K & f, k = ec(x);
          function j() {
            for (var G = -1, $ = arguments.length, ae = -1, Ve = P.length, ce = ee(Ve + $), ge = this && this !== Ut && this instanceof j ? k : x; ++ae < Ve; )
              ce[ae] = P[ae];
            for (; $--; )
              ce[ae++] = arguments[++G];
            return en(ge, M ? v : this, ce);
          }
          return j;
        }
        function L6(x) {
          return function(K, v, P) {
            return P && typeof P != "number" && mi(K, v, P) && (v = P = t), K = xu(K), v === t ? (v = K, K = 0) : v = xu(v), P = P === t ? K < v ? 1 : -1 : xu(P), yne(K, v, P, x);
          };
        }
        function fF(x) {
          return function(K, v) {
            return typeof K == "string" && typeof v == "string" || (K = vn(K), v = vn(v)), x(K, v);
          };
        }
        function _6(x, K, v, P, M, k, j, G, $, ae) {
          var Ve = K & g, ce = Ve ? j : t, ge = Ve ? t : j, Se = Ve ? k : t, Re = Ve ? t : k;
          K |= Ve ? b : A, K &= ~(Ve ? A : b), K & m || (K &= -4);
          var sr = [
            x,
            K,
            M,
            Se,
            ce,
            Re,
            ge,
            G,
            $,
            ae
          ], Ie = v.apply(t, sr);
          return th(x) && ew(Ie, sr), Ie.placeholder = P, rw(Ie, x, K);
        }
        function UK(x) {
          var K = At[x];
          return function(v, P) {
            if (v = vn(v), P = P == null ? 0 : di(ir(P), 292), P && r6(v)) {
              var M = (mr(v) + "e").split("e"), k = K(M[0] + "e" + (+M[1] + P));
              return M = (mr(k) + "e").split("e"), +(M[0] + "e" + (+M[1] - P));
            }
            return K(v);
          };
        }
        var _ne = va && 1 / W2(new va([, -0]))[1] == L ? function(x) {
          return new va(x);
        } : Yh;
        function H6(x) {
          return function(K) {
            var v = ai(K);
            return v == oe ? bK(K) : v == yt ? sie(K) : Jte(K, x(K));
          };
        }
        function Vu(x, K, v, P, M, k, j, G) {
          var $ = K & p;
          if (!$ && typeof x != "function")
            throw new Kn(u);
          var ae = P ? P.length : 0;
          if (ae || (K &= -97, P = M = t), j = j === t ? j : wt(ir(j), 0), G = G === t ? G : ir(G), ae -= M ? M.length : 0, K & A) {
            var Ve = P, ce = M;
            P = M = t;
          }
          var ge = $ ? t : $K(x), Se = [
            x,
            K,
            v,
            P,
            M,
            Ve,
            ce,
            k,
            j,
            G
          ];
          if (ge && ise(Se, ge), x = Se[0], K = Se[1], v = Se[2], P = Se[3], M = Se[4], G = Se[9] = Se[9] === t ? $ ? 0 : x.length : wt(Se[9] - ae, 0), !G && K & (g | y) && (K &= -25), !K || K == f)
            var Re = Rne(x, K, v);
          else K == g || K == y ? Re = Ine(x, K, G) : (K == b || K == (f | b)) && !M.length ? Re = Lne(x, K, v, P) : Re = XF.apply(t, Se);
          var sr = ge ? g6 : ew;
          return rw(sr(Re, Se), x, K);
        }
        function j6(x, K, v, P) {
          return x === t || Bn(x, ga[v]) && !Cr.call(P, v) ? K : x;
        }
        function z6(x, K, v, P, M, k) {
          return st(x) && st(K) && (k.set(K, x), lF(x, K, t, z6, k), k.delete(K)), x;
        }
        function Hne(x) {
          return ic(x) ? t : x;
        }
        function B6(x, K, v, P, M, k) {
          var j = v & Y, G = x.length, $ = K.length;
          if (G != $ && !(j && $ > G))
            return !1;
          var ae = k.get(x), Ve = k.get(K);
          if (ae && Ve)
            return ae == K && Ve == x;
          var ce = -1, ge = !0, Se = v & q ? new ad() : t;
          for (k.set(x, K), k.set(K, x); ++ce < G; ) {
            var Re = x[ce], sr = K[ce];
            if (P)
              var Ie = j ? P(sr, Re, ce, K, x, k) : P(Re, sr, ce, x, K, k);
            if (Ie !== t) {
              if (Ie)
                continue;
              ge = !1;
              break;
            }
            if (Se) {
              if (!KK(K, function(cr, qr) {
                if (!Hl(Se, qr) && (Re === cr || M(Re, cr, v, P, k)))
                  return Se.push(qr);
              })) {
                ge = !1;
                break;
              }
            } else if (!(Re === sr || M(Re, sr, v, P, k))) {
              ge = !1;
              break;
            }
          }
          return k.delete(x), k.delete(K), ge;
        }
        function jne(x, K, v, P, M, k, j) {
          switch (v) {
            case Ya:
              if (x.byteLength != K.byteLength || x.byteOffset != K.byteOffset)
                return !1;
              x = x.buffer, K = K.buffer;
            case Qu:
              return !(x.byteLength != K.byteLength || !k(new Q2(x), new Q2(K)));
            case me:
            case ne:
            case tr:
              return Bn(+x, +K);
            case Ye:
              return x.name == K.name && x.message == K.message;
            case ms:
            case hi:
              return x == K + "";
            case oe:
              var G = bK;
            case yt:
              var $ = P & Y;
              if (G || (G = W2), x.size != K.size && !$)
                return !1;
              var ae = j.get(x);
              if (ae)
                return ae == K;
              P |= q, j.set(x, K);
              var Ve = B6(G(x), G(K), P, M, k, j);
              return j.delete(x), Ve;
            case $u:
              if (Gl)
                return Gl.call(x) == Gl.call(K);
          }
          return !1;
        }
        function zne(x, K, v, P, M, k) {
          var j = v & Y, G = ZK(x), $ = G.length, ae = ZK(K), Ve = ae.length;
          if ($ != Ve && !j)
            return !1;
          for (var ce = $; ce--; ) {
            var ge = G[ce];
            if (!(j ? ge in K : Cr.call(K, ge)))
              return !1;
          }
          var Se = k.get(x), Re = k.get(K);
          if (Se && Re)
            return Se == K && Re == x;
          var sr = !0;
          k.set(x, K), k.set(K, x);
          for (var Ie = j; ++ce < $; ) {
            ge = G[ce];
            var cr = x[ge], qr = K[ge];
            if (P)
              var sn = j ? P(qr, cr, ge, K, x, k) : P(cr, qr, ge, x, K, k);
            if (!(sn === t ? cr === qr || M(cr, qr, v, P, k) : sn)) {
              sr = !1;
              break;
            }
            Ie || (Ie = ge == "constructor");
          }
          if (sr && !Ie) {
            var gi = x.constructor, un = K.constructor;
            gi != un && "constructor" in x && "constructor" in K && !(typeof gi == "function" && gi instanceof gi && typeof un == "function" && un instanceof un) && (sr = !1);
          }
          return k.delete(x), k.delete(K), sr;
        }
        function lu(x) {
          return nh($6(x, t, ow), x + "");
        }
        function ZK(x) {
          return c6(x, kt, eh);
        }
        function JK(x) {
          return c6(x, Di, W6);
        }
        var $K = sF ? function(x) {
          return sF.get(x);
        } : Yh;
        function KF(x) {
          for (var K = x.name + "", v = ba[K], P = Cr.call(ba, K) ? v.length : 0; P--; ) {
            var M = v[P], k = M.func;
            if (k == null || k == x)
              return M.name;
          }
          return K;
        }
        function Ca(x) {
          var K = Cr.call(T, "placeholder") ? T : x;
          return K.placeholder;
        }
        function Oe() {
          var x = T.iteratee || Xh;
          return x = x === Xh ? X6 : x, arguments.length ? x(arguments[0], arguments[1]) : x;
        }
        function hF(x, K) {
          var v = x.__data__;
          return Qne(K) ? v[typeof K == "string" ? "string" : "hash"] : v.map;
        }
        function QK(x) {
          for (var K = kt(x), v = K.length; v--; ) {
            var P = K[v], M = x[P];
            K[v] = [P, M, Z6(M)];
          }
          return K;
        }
        function cd(x, K) {
          var v = tie(x, K);
          return x6(v) ? v : t;
        }
        function Bne(x) {
          var K = Cr.call(x, od), v = x[od];
          try {
            x[od] = t;
            var P = !0;
          } catch {
          }
          var M = J2.call(x);
          return P && (K ? x[od] = v : delete x[od]), M;
        }
        var eh = AK ? function(x) {
          return x == null ? [] : (x = Rr(x), eo(AK(x), function(K) {
            return Q5.call(x, K);
          }));
        } : fh, W6 = AK ? function(x) {
          for (var K = []; x; )
            ro(K, eh(x)), x = eF(x);
          return K;
        } : fh, ai = pi;
        (wK && ai(new wK(new ArrayBuffer(1))) != Ya || zl && ai(new zl()) != oe || CK && ai(CK.resolve()) != bt || va && ai(new va()) != yt || Bl && ai(new Bl()) != uu) && (ai = function(x) {
          var K = pi(x), v = K == or ? x.constructor : t, P = v ? Fd(v) : "";
          if (P)
            switch (P) {
              case wie:
                return Ya;
              case Cie:
                return oe;
              case Pie:
                return bt;
              case Sie:
                return yt;
              case Nie:
                return uu;
            }
          return K;
        });
        function Wne(x, K, v) {
          for (var P = -1, M = v.length; ++P < M; ) {
            var k = v[P], j = k.size;
            switch (k.type) {
              case "drop":
                x += j;
                break;
              case "dropRight":
                K -= j;
                break;
              case "take":
                K = di(K, x + j);
                break;
              case "takeRight":
                x = wt(x, K - j);
                break;
            }
          }
          return { start: x, end: K };
        }
        function Gne(x) {
          var K = x.match(ete);
          return K ? K[1].split(rte) : [];
        }
        function G6(x, K, v) {
          K = uo(K, x);
          for (var P = -1, M = K.length, k = !1; ++P < M; ) {
            var j = bs(K[P]);
            if (!(k = x != null && v(x, j)))
              break;
            x = x[j];
          }
          return k || ++P != M ? k : (M = x == null ? 0 : x.length, !!M && AF(M) && cu(j, M) && (Qe(x) || xd(x)));
        }
        function Une(x) {
          var K = x.length, v = new x.constructor(K);
          return K && typeof x[0] == "string" && Cr.call(x, "index") && (v.index = x.index, v.input = x.input), v;
        }
        function U6(x) {
          return typeof x.constructor == "function" && !rc(x) ? ya(eF(x)) : {};
        }
        function Zne(x, K, v) {
          var P = x.constructor;
          switch (K) {
            case Qu:
              return WK(x);
            case me:
            case ne:
              return new P(+x);
            case Ya:
              return Mne(x, v);
            case Qf:
            case eK:
            case rK:
            case tK:
            case iK:
            case nK:
            case sK:
            case uK:
            case oK:
              return S6(x, v);
            case oe:
              return new P();
            case tr:
            case hi:
              return new P(x);
            case ms:
              return Tne(x);
            case yt:
              return new P();
            case $u:
              return Ene(x);
          }
        }
        function Jne(x, K) {
          var v = K.length;
          if (!v)
            return x;
          var P = v - 1;
          return K[P] = (v > 1 ? "& " : "") + K[P], K = K.join(v > 2 ? ", " : " "), x.replace(Qre, `{
/* [wrapped with ` + K + `] */
`);
        }
        function $ne(x) {
          return Qe(x) || xd(x) || !!(e6 && x && x[e6]);
        }
        function cu(x, K) {
          var v = typeof x;
          return K = K ?? z, !!K && (v == "number" || v != "symbol" && Vte.test(x)) && x > -1 && x % 1 == 0 && x < K;
        }
        function mi(x, K, v) {
          if (!st(v))
            return !1;
          var P = typeof K;
          return (P == "number" ? Oi(v) && cu(K, v.length) : P == "string" && K in v) ? Bn(v[K], x) : !1;
        }
        function rh(x, K) {
          if (Qe(x))
            return !1;
          var v = typeof x;
          return v == "number" || v == "symbol" || v == "boolean" || x == null || nn(x) ? !0 : Ure.test(x) || !Gre.test(x) || K != null && x in Rr(K);
        }
        function Qne(x) {
          var K = typeof x;
          return K == "string" || K == "number" || K == "symbol" || K == "boolean" ? x !== "__proto__" : x === null;
        }
        function th(x) {
          var K = KF(x), v = T[K];
          if (typeof v != "function" || !(K in xr.prototype))
            return !1;
          if (x === v)
            return !0;
          var P = $K(v);
          return !!P && x === P[0];
        }
        function ese(x) {
          return !!Z5 && Z5 in x;
        }
        var rse = U2 ? Fu : Kh;
        function rc(x) {
          var K = x && x.constructor, v = typeof K == "function" && K.prototype || ga;
          return x === v;
        }
        function Z6(x) {
          return x === x && !st(x);
        }
        function J6(x, K) {
          return function(v) {
            return v == null ? !1 : v[x] === K && (K !== t || x in Rr(v));
          };
        }
        function tse(x) {
          var K = bF(x, function(P) {
            return v.size === a && v.clear(), P;
          }), v = K.cache;
          return K;
        }
        function ise(x, K) {
          var v = x[1], P = K[1], M = v | P, k = M < (f | p | w), j = P == w && v == g || P == w && v == S && x[7].length <= K[8] || P == (w | S) && K[7].length <= K[8] && v == g;
          if (!(k || j))
            return x;
          P & f && (x[2] = K[2], M |= v & f ? 0 : m);
          var G = K[3];
          if (G) {
            var $ = x[3];
            x[3] = $ ? M6($, G, K[4]) : G, x[4] = $ ? to(x[3], V) : K[4];
          }
          return G = K[5], G && ($ = x[5], x[5] = $ ? T6($, G, K[6]) : G, x[6] = $ ? to(x[5], V) : K[6]), G = K[7], G && (x[7] = G), P & w && (x[8] = x[8] == null ? K[8] : di(x[8], K[8])), x[9] == null && (x[9] = K[9]), x[0] = K[0], x[1] = M, x;
        }
        function nse(x) {
          var K = [];
          if (x != null)
            for (var v in Rr(x))
              K.push(v);
          return K;
        }
        function sse(x) {
          return J2.call(x);
        }
        function $6(x, K, v) {
          return K = wt(K === t ? x.length - 1 : K, 0), function() {
            for (var P = arguments, M = -1, k = wt(P.length - K, 0), j = ee(k); ++M < k; )
              j[M] = P[K + M];
            M = -1;
            for (var G = ee(K + 1); ++M < K; )
              G[M] = P[M];
            return G[K] = v(j), en(x, this, G);
          };
        }
        function Q6(x, K) {
          return K.length < 2 ? x : ld(x, mn(K, 0, -1));
        }
        function use(x, K) {
          for (var v = x.length, P = di(K.length, v), M = ki(x); P--; ) {
            var k = K[P];
            x[P] = cu(k, v) ? M[k] : t;
          }
          return x;
        }
        function ih(x, K) {
          if (!(K === "constructor" && typeof x[K] == "function") && K != "__proto__")
            return x[K];
        }
        var ew = tw(g6), tc = pie || function(x, K) {
          return Ut.setTimeout(x, K);
        }, nh = tw(Cne);
        function rw(x, K, v) {
          var P = K + "";
          return nh(x, Jne(P, ose(Gne(P), v)));
        }
        function tw(x) {
          var K = 0, v = 0;
          return function() {
            var P = bie(), M = R - (P - v);
            if (v = P, M > 0) {
              if (++K >= I)
                return arguments[0];
            } else
              K = 0;
            return x.apply(t, arguments);
          };
        }
        function pF(x, K) {
          var v = -1, P = x.length, M = P - 1;
          for (K = K === t ? P : K; ++v < K; ) {
            var k = IK(v, M), j = x[k];
            x[k] = x[v], x[v] = j;
          }
          return x.length = K, x;
        }
        var iw = tse(function(x) {
          var K = [];
          return x.charCodeAt(0) === 46 && K.push(""), x.replace(Zre, function(v, P, M, k) {
            K.push(M ? k.replace(nte, "$1") : P || v);
          }), K;
        });
        function bs(x) {
          if (typeof x == "string" || nn(x))
            return x;
          var K = x + "";
          return K == "0" && 1 / x == -1 / 0 ? "-0" : K;
        }
        function Fd(x) {
          if (x != null) {
            try {
              return Z2.call(x);
            } catch {
            }
            try {
              return x + "";
            } catch {
            }
          }
          return "";
        }
        function ose(x, K) {
          return fn(Ke, function(v) {
            var P = "_." + v[0];
            K & v[1] && !z2(x, P) && x.push(P);
          }), x.sort();
        }
        function nw(x) {
          if (x instanceof xr)
            return x.clone();
          var K = new hn(x.__wrapped__, x.__chain__);
          return K.__actions__ = ki(x.__actions__), K.__index__ = x.__index__, K.__values__ = x.__values__, K;
        }
        function dse(x, K, v) {
          (v ? mi(x, K, v) : K === t) ? K = 1 : K = wt(ir(K), 0);
          var P = x == null ? 0 : x.length;
          if (!P || K < 1)
            return [];
          for (var M = 0, k = 0, j = ee(iF(P / K)); M < P; )
            j[k++] = mn(x, M, M += K);
          return j;
        }
        function ase(x) {
          for (var K = -1, v = x == null ? 0 : x.length, P = 0, M = []; ++K < v; ) {
            var k = x[K];
            k && (M[P++] = k);
          }
          return M;
        }
        function Vse() {
          var x = arguments.length;
          if (!x)
            return [];
          for (var K = ee(x - 1), v = arguments[0], P = x; P--; )
            K[P - 1] = arguments[P];
          return ro(Qe(v) ? ki(v) : [v], Zt(K, 1));
        }
        var lse = dr(function(x, K) {
          return Ft(x) ? Zl(x, Zt(K, 1, Ft, !0)) : [];
        }), cse = dr(function(x, K) {
          var v = gn(K);
          return Ft(v) && (v = t), Ft(x) ? Zl(x, Zt(K, 1, Ft, !0), Oe(v, 2)) : [];
        }), Fse = dr(function(x, K) {
          var v = gn(K);
          return Ft(v) && (v = t), Ft(x) ? Zl(x, Zt(K, 1, Ft, !0), t, v) : [];
        });
        function xse(x, K, v) {
          var P = x == null ? 0 : x.length;
          return P ? (K = v || K === t ? 1 : ir(K), mn(x, K < 0 ? 0 : K, P)) : [];
        }
        function Xse(x, K, v) {
          var P = x == null ? 0 : x.length;
          return P ? (K = v || K === t ? 1 : ir(K), K = P - K, mn(x, 0, K < 0 ? 0 : K)) : [];
        }
        function qse(x, K) {
          return x && x.length ? FF(x, Oe(K, 3), !0, !0) : [];
        }
        function Yse(x, K) {
          return x && x.length ? FF(x, Oe(K, 3), !0) : [];
        }
        function fse(x, K, v, P) {
          var M = x == null ? 0 : x.length;
          return M ? (v && typeof v != "number" && mi(x, K, v) && (v = 0, P = M), Vne(x, K, v, P)) : [];
        }
        function sw(x, K, v) {
          var P = x == null ? 0 : x.length;
          if (!P)
            return -1;
          var M = v == null ? 0 : ir(v);
          return M < 0 && (M = wt(P + M, 0)), B2(x, Oe(K, 3), M);
        }
        function uw(x, K, v) {
          var P = x == null ? 0 : x.length;
          if (!P)
            return -1;
          var M = P - 1;
          return v !== t && (M = ir(v), M = v < 0 ? wt(P + M, 0) : di(M, P - 1)), B2(x, Oe(K, 3), M, !0);
        }
        function ow(x) {
          var K = x == null ? 0 : x.length;
          return K ? Zt(x, 1) : [];
        }
        function Kse(x) {
          var K = x == null ? 0 : x.length;
          return K ? Zt(x, L) : [];
        }
        function hse(x, K) {
          var v = x == null ? 0 : x.length;
          return v ? (K = K === t ? 1 : ir(K), Zt(x, K)) : [];
        }
        function pse(x) {
          for (var K = -1, v = x == null ? 0 : x.length, P = {}; ++K < v; ) {
            var M = x[K];
            P[M[0]] = M[1];
          }
          return P;
        }
        function dw(x) {
          return x && x.length ? x[0] : t;
        }
        function mse(x, K, v) {
          var P = x == null ? 0 : x.length;
          if (!P)
            return -1;
          var M = v == null ? 0 : ir(v);
          return M < 0 && (M = wt(P + M, 0)), Ka(x, K, M);
        }
        function gse(x) {
          var K = x == null ? 0 : x.length;
          return K ? mn(x, 0, -1) : [];
        }
        var vse = dr(function(x) {
          var K = tt(x, zK);
          return K.length && K[0] === x[0] ? EK(K) : [];
        }), bse = dr(function(x) {
          var K = gn(x), v = tt(x, zK);
          return K === gn(v) ? K = t : v.pop(), v.length && v[0] === x[0] ? EK(v, Oe(K, 2)) : [];
        }), yse = dr(function(x) {
          var K = gn(x), v = tt(x, zK);
          return K = typeof K == "function" ? K : t, K && v.pop(), v.length && v[0] === x[0] ? EK(v, t, K) : [];
        });
        function Ase(x, K) {
          return x == null ? "" : gie.call(x, K);
        }
        function gn(x) {
          var K = x == null ? 0 : x.length;
          return K ? x[K - 1] : t;
        }
        function wse(x, K, v) {
          var P = x == null ? 0 : x.length;
          if (!P)
            return -1;
          var M = P;
          return v !== t && (M = ir(v), M = M < 0 ? wt(P + M, 0) : di(M, P - 1)), K === K ? oie(x, K, M) : B2(x, _5, M, !0);
        }
        function Cse(x, K) {
          return x && x.length ? K6(x, ir(K)) : t;
        }
        var Pse = dr(aw);
        function aw(x, K) {
          return x && x.length && K && K.length ? RK(x, K) : x;
        }
        function Sse(x, K, v) {
          return x && x.length && K && K.length ? RK(x, K, Oe(v, 2)) : x;
        }
        function Nse(x, K, v) {
          return x && x.length && K && K.length ? RK(x, K, t, v) : x;
        }
        var Mse = lu(function(x, K) {
          var v = x == null ? 0 : x.length, P = SK(x, K);
          return m6(x, tt(K, function(M) {
            return cu(M, v) ? +M : M;
          }).sort(N6)), P;
        });
        function Tse(x, K) {
          var v = [];
          if (!(x && x.length))
            return v;
          var P = -1, M = [], k = x.length;
          for (K = Oe(K, 3); ++P < k; ) {
            var j = x[P];
            K(j, P, x) && (v.push(j), M.push(P));
          }
          return m6(x, M), v;
        }
        function sh(x) {
          return x == null ? x : Aie.call(x);
        }
        function Ese(x, K, v) {
          var P = x == null ? 0 : x.length;
          return P ? (v && typeof v != "number" && mi(x, K, v) ? (K = 0, v = P) : (K = K == null ? 0 : ir(K), v = v === t ? P : ir(v)), mn(x, K, v)) : [];
        }
        function kse(x, K) {
          return cF(x, K);
        }
        function Ose(x, K, v) {
          return _K(x, K, Oe(v, 2));
        }
        function Dse(x, K) {
          var v = x == null ? 0 : x.length;
          if (v) {
            var P = cF(x, K);
            if (P < v && Bn(x[P], K))
              return P;
          }
          return -1;
        }
        function Rse(x, K) {
          return cF(x, K, !0);
        }
        function Ise(x, K, v) {
          return _K(x, K, Oe(v, 2), !0);
        }
        function Lse(x, K) {
          var v = x == null ? 0 : x.length;
          if (v) {
            var P = cF(x, K, !0) - 1;
            if (Bn(x[P], K))
              return P;
          }
          return -1;
        }
        function _se(x) {
          return x && x.length ? v6(x) : [];
        }
        function Hse(x, K) {
          return x && x.length ? v6(x, Oe(K, 2)) : [];
        }
        function jse(x) {
          var K = x == null ? 0 : x.length;
          return K ? mn(x, 1, K) : [];
        }
        function zse(x, K, v) {
          return x && x.length ? (K = v || K === t ? 1 : ir(K), mn(x, 0, K < 0 ? 0 : K)) : [];
        }
        function Bse(x, K, v) {
          var P = x == null ? 0 : x.length;
          return P ? (K = v || K === t ? 1 : ir(K), K = P - K, mn(x, K < 0 ? 0 : K, P)) : [];
        }
        function Wse(x, K) {
          return x && x.length ? FF(x, Oe(K, 3), !1, !0) : [];
        }
        function Gse(x, K) {
          return x && x.length ? FF(x, Oe(K, 3)) : [];
        }
        var Use = dr(function(x) {
          return so(Zt(x, 1, Ft, !0));
        }), Zse = dr(function(x) {
          var K = gn(x);
          return Ft(K) && (K = t), so(Zt(x, 1, Ft, !0), Oe(K, 2));
        }), Jse = dr(function(x) {
          var K = gn(x);
          return K = typeof K == "function" ? K : t, so(Zt(x, 1, Ft, !0), t, K);
        });
        function $se(x) {
          return x && x.length ? so(x) : [];
        }
        function Qse(x, K) {
          return x && x.length ? so(x, Oe(K, 2)) : [];
        }
        function eue(x, K) {
          return K = typeof K == "function" ? K : t, x && x.length ? so(x, t, K) : [];
        }
        function uh(x) {
          if (!(x && x.length))
            return [];
          var K = 0;
          return x = eo(x, function(v) {
            if (Ft(v))
              return K = wt(v.length, K), !0;
          }), gK(K, function(v) {
            return tt(x, hK(v));
          });
        }
        function Vw(x, K) {
          if (!(x && x.length))
            return [];
          var v = uh(x);
          return K == null ? v : tt(v, function(P) {
            return en(K, t, P);
          });
        }
        var rue = dr(function(x, K) {
          return Ft(x) ? Zl(x, K) : [];
        }), tue = dr(function(x) {
          return jK(eo(x, Ft));
        }), iue = dr(function(x) {
          var K = gn(x);
          return Ft(K) && (K = t), jK(eo(x, Ft), Oe(K, 2));
        }), nue = dr(function(x) {
          var K = gn(x);
          return K = typeof K == "function" ? K : t, jK(eo(x, Ft), t, K);
        }), sue = dr(uh);
        function uue(x, K) {
          return w6(x || [], K || [], Ul);
        }
        function oue(x, K) {
          return w6(x || [], K || [], Ql);
        }
        var due = dr(function(x) {
          var K = x.length, v = K > 1 ? x[K - 1] : t;
          return v = typeof v == "function" ? (x.pop(), v) : t, Vw(x, v);
        });
        function lw(x) {
          var K = T(x);
          return K.__chain__ = !0, K;
        }
        function aue(x, K) {
          return K(x), x;
        }
        function mF(x, K) {
          return K(x);
        }
        var Vue = lu(function(x) {
          var K = x.length, v = K ? x[0] : 0, P = this.__wrapped__, M = function(k) {
            return SK(k, x);
          };
          return K > 1 || this.__actions__.length || !(P instanceof xr) || !cu(v) ? this.thru(M) : (P = P.slice(v, +v + (K ? 1 : 0)), P.__actions__.push({
            func: mF,
            args: [M],
            thisArg: t
          }), new hn(P, this.__chain__).thru(function(k) {
            return K && !k.length && k.push(t), k;
          }));
        });
        function lue() {
          return lw(this);
        }
        function cue() {
          return new hn(this.value(), this.__chain__);
        }
        function Fue() {
          this.__values__ === t && (this.__values__ = bw(this.value()));
          var x = this.__index__ >= this.__values__.length, K = x ? t : this.__values__[this.__index__++];
          return { done: x, value: K };
        }
        function xue() {
          return this;
        }
        function Xue(x) {
          for (var K, v = this; v instanceof oF; ) {
            var P = nw(v);
            P.__index__ = 0, P.__values__ = t, K ? M.__wrapped__ = P : K = P;
            var M = P;
            v = v.__wrapped__;
          }
          return M.__wrapped__ = x, K;
        }
        function que() {
          var x = this.__wrapped__;
          if (x instanceof xr) {
            var K = x;
            return this.__actions__.length && (K = new xr(this)), K = K.reverse(), K.__actions__.push({
              func: mF,
              args: [sh],
              thisArg: t
            }), new hn(K, this.__chain__);
          }
          return this.thru(sh);
        }
        function Yue() {
          return A6(this.__wrapped__, this.__actions__);
        }
        var fue = xF(function(x, K, v) {
          Cr.call(x, v) ? ++x[v] : au(x, v, 1);
        });
        function Kue(x, K, v) {
          var P = Qe(x) ? I5 : ane;
          return v && mi(x, K, v) && (K = t), P(x, Oe(K, 3));
        }
        function hue(x, K) {
          var v = Qe(x) ? eo : V6;
          return v(x, Oe(K, 3));
        }
        var pue = D6(sw), mue = D6(uw);
        function gue(x, K) {
          return Zt(gF(x, K), 1);
        }
        function vue(x, K) {
          return Zt(gF(x, K), L);
        }
        function bue(x, K, v) {
          return v = v === t ? 1 : ir(v), Zt(gF(x, K), v);
        }
        function cw(x, K) {
          var v = Qe(x) ? fn : no;
          return v(x, Oe(K, 3));
        }
        function Fw(x, K) {
          var v = Qe(x) ? jte : a6;
          return v(x, Oe(K, 3));
        }
        var yue = xF(function(x, K, v) {
          Cr.call(x, v) ? x[v].push(K) : au(x, v, [K]);
        });
        function Aue(x, K, v, P) {
          x = Oi(x) ? x : Sa(x), v = v && !P ? ir(v) : 0;
          var M = x.length;
          return v < 0 && (v = wt(M + v, 0)), wF(x) ? v <= M && x.indexOf(K, v) > -1 : !!M && Ka(x, K, v) > -1;
        }
        var wue = dr(function(x, K, v) {
          var P = -1, M = typeof K == "function", k = Oi(x) ? ee(x.length) : [];
          return no(x, function(j) {
            k[++P] = M ? en(K, j, v) : Jl(j, K, v);
          }), k;
        }), Cue = xF(function(x, K, v) {
          au(x, v, K);
        });
        function gF(x, K) {
          var v = Qe(x) ? tt : q6;
          return v(x, Oe(K, 3));
        }
        function Pue(x, K, v, P) {
          return x == null ? [] : (Qe(K) || (K = K == null ? [] : [K]), v = P ? t : v, Qe(v) || (v = v == null ? [] : [v]), h6(x, K, v));
        }
        var Sue = xF(function(x, K, v) {
          x[v ? 0 : 1].push(K);
        }, function() {
          return [[], []];
        });
        function Nue(x, K, v) {
          var P = Qe(x) ? fK : j5, M = arguments.length < 3;
          return P(x, Oe(K, 4), v, M, no);
        }
        function Mue(x, K, v) {
          var P = Qe(x) ? zte : j5, M = arguments.length < 3;
          return P(x, Oe(K, 4), v, M, a6);
        }
        function Tue(x, K) {
          var v = Qe(x) ? eo : V6;
          return v(x, yF(Oe(K, 3)));
        }
        function Eue(x) {
          var K = Qe(x) ? s6 : Ane;
          return K(x);
        }
        function kue(x, K, v) {
          (v ? mi(x, K, v) : K === t) ? K = 1 : K = ir(K);
          var P = Qe(x) ? nne : wne;
          return P(x, K);
        }
        function Oue(x) {
          var K = Qe(x) ? sne : Pne;
          return K(x);
        }
        function Due(x) {
          if (x == null)
            return 0;
          if (Oi(x))
            return wF(x) ? pa(x) : x.length;
          var K = ai(x);
          return K == oe || K == yt ? x.size : OK(x).length;
        }
        function Rue(x, K, v) {
          var P = Qe(x) ? KK : Sne;
          return v && mi(x, K, v) && (K = t), P(x, Oe(K, 3));
        }
        var Iue = dr(function(x, K) {
          if (x == null)
            return [];
          var v = K.length;
          return v > 1 && mi(x, K[0], K[1]) ? K = [] : v > 2 && mi(K[0], K[1], K[2]) && (K = [K[0]]), h6(x, Zt(K, 1), []);
        }), vF = hie || function() {
          return Ut.Date.now();
        };
        function Lue(x, K) {
          if (typeof K != "function")
            throw new Kn(u);
          return x = ir(x), function() {
            if (--x < 1)
              return K.apply(this, arguments);
          };
        }
        function xw(x, K, v) {
          return K = v ? t : K, K = x && K == null ? x.length : K, Vu(x, w, t, t, t, t, K);
        }
        function Xw(x, K) {
          var v;
          if (typeof K != "function")
            throw new Kn(u);
          return x = ir(x), function() {
            return --x > 0 && (v = K.apply(this, arguments)), x <= 1 && (K = t), v;
          };
        }
        var oh = dr(function(x, K, v) {
          var P = f;
          if (v.length) {
            var M = to(v, Ca(oh));
            P |= b;
          }
          return Vu(x, P, K, v, M);
        }), qw = dr(function(x, K, v) {
          var P = f | p;
          if (v.length) {
            var M = to(v, Ca(qw));
            P |= b;
          }
          return Vu(K, P, x, v, M);
        });
        function Yw(x, K, v) {
          K = v ? t : K;
          var P = Vu(x, g, t, t, t, t, t, K);
          return P.placeholder = Yw.placeholder, P;
        }
        function fw(x, K, v) {
          K = v ? t : K;
          var P = Vu(x, y, t, t, t, t, t, K);
          return P.placeholder = fw.placeholder, P;
        }
        function Kw(x, K, v) {
          var P, M, k, j, G, $, ae = 0, Ve = !1, ce = !1, ge = !0;
          if (typeof x != "function")
            throw new Kn(u);
          K = vn(K) || 0, st(v) && (Ve = !!v.leading, ce = "maxWait" in v, k = ce ? wt(vn(v.maxWait) || 0, K) : k, ge = "trailing" in v ? !!v.trailing : ge);
          function Se(xt) {
            var Wn = P, Xu = M;
            return P = M = t, ae = xt, j = x.apply(Xu, Wn), j;
          }
          function Re(xt) {
            return ae = xt, G = tc(cr, K), Ve ? Se(xt) : j;
          }
          function sr(xt) {
            var Wn = xt - $, Xu = xt - ae, Dw = K - Wn;
            return ce ? di(Dw, k - Xu) : Dw;
          }
          function Ie(xt) {
            var Wn = xt - $, Xu = xt - ae;
            return $ === t || Wn >= K || Wn < 0 || ce && Xu >= k;
          }
          function cr() {
            var xt = vF();
            if (Ie(xt))
              return qr(xt);
            G = tc(cr, sr(xt));
          }
          function qr(xt) {
            return G = t, ge && P ? Se(xt) : (P = M = t, j);
          }
          function sn() {
            G !== t && C6(G), ae = 0, P = $ = M = G = t;
          }
          function gi() {
            return G === t ? j : qr(vF());
          }
          function un() {
            var xt = vF(), Wn = Ie(xt);
            if (P = arguments, M = this, $ = xt, Wn) {
              if (G === t)
                return Re($);
              if (ce)
                return C6(G), G = tc(cr, K), Se($);
            }
            return G === t && (G = tc(cr, K)), j;
          }
          return un.cancel = sn, un.flush = gi, un;
        }
        var _ue = dr(function(x, K) {
          return d6(x, 1, K);
        }), Hue = dr(function(x, K, v) {
          return d6(x, vn(K) || 0, v);
        });
        function jue(x) {
          return Vu(x, N);
        }
        function bF(x, K) {
          if (typeof x != "function" || K != null && typeof K != "function")
            throw new Kn(u);
          var v = function() {
            var P = arguments, M = K ? K.apply(this, P) : P[0], k = v.cache;
            if (k.has(M))
              return k.get(M);
            var j = x.apply(this, P);
            return v.cache = k.set(M, j) || k, j;
          };
          return v.cache = new (bF.Cache || du)(), v;
        }
        bF.Cache = du;
        function yF(x) {
          if (typeof x != "function")
            throw new Kn(u);
          return function() {
            var K = arguments;
            switch (K.length) {
              case 0:
                return !x.call(this);
              case 1:
                return !x.call(this, K[0]);
              case 2:
                return !x.call(this, K[0], K[1]);
              case 3:
                return !x.call(this, K[0], K[1], K[2]);
            }
            return !x.apply(this, K);
          };
        }
        function zue(x) {
          return Xw(2, x);
        }
        var Bue = Nne(function(x, K) {
          K = K.length == 1 && Qe(K[0]) ? tt(K[0], rn(Oe())) : tt(Zt(K, 1), rn(Oe()));
          var v = K.length;
          return dr(function(P) {
            for (var M = -1, k = di(P.length, v); ++M < k; )
              P[M] = K[M].call(this, P[M]);
            return en(x, this, P);
          });
        }), dh = dr(function(x, K) {
          var v = to(K, Ca(dh));
          return Vu(x, b, t, K, v);
        }), hw = dr(function(x, K) {
          var v = to(K, Ca(hw));
          return Vu(x, A, t, K, v);
        }), Wue = lu(function(x, K) {
          return Vu(x, S, t, t, t, K);
        });
        function Gue(x, K) {
          if (typeof x != "function")
            throw new Kn(u);
          return K = K === t ? K : ir(K), dr(x, K);
        }
        function Uue(x, K) {
          if (typeof x != "function")
            throw new Kn(u);
          return K = K == null ? 0 : wt(ir(K), 0), dr(function(v) {
            var P = v[K], M = oo(v, 0, K);
            return P && ro(M, P), en(x, this, M);
          });
        }
        function Zue(x, K, v) {
          var P = !0, M = !0;
          if (typeof x != "function")
            throw new Kn(u);
          return st(v) && (P = "leading" in v ? !!v.leading : P, M = "trailing" in v ? !!v.trailing : M), Kw(x, K, {
            leading: P,
            maxWait: K,
            trailing: M
          });
        }
        function Jue(x) {
          return xw(x, 1);
        }
        function $ue(x, K) {
          return dh(BK(K), x);
        }
        function Que() {
          if (!arguments.length)
            return [];
          var x = arguments[0];
          return Qe(x) ? x : [x];
        }
        function eoe(x) {
          return pn(x, X);
        }
        function roe(x, K) {
          return K = typeof K == "function" ? K : t, pn(x, X, K);
        }
        function toe(x) {
          return pn(x, c | X);
        }
        function ioe(x, K) {
          return K = typeof K == "function" ? K : t, pn(x, c | X, K);
        }
        function noe(x, K) {
          return K == null || o6(x, K, kt(K));
        }
        function Bn(x, K) {
          return x === K || x !== x && K !== K;
        }
        var soe = fF(TK), uoe = fF(function(x, K) {
          return x >= K;
        }), xd = F6(/* @__PURE__ */ function() {
          return arguments;
        }()) ? F6 : function(x) {
          return dt(x) && Cr.call(x, "callee") && !Q5.call(x, "callee");
        }, Qe = ee.isArray, ooe = T5 ? rn(T5) : Xne;
        function Oi(x) {
          return x != null && AF(x.length) && !Fu(x);
        }
        function Ft(x) {
          return dt(x) && Oi(x);
        }
        function doe(x) {
          return x === !0 || x === !1 || dt(x) && pi(x) == me;
        }
        var ao = mie || Kh, aoe = E5 ? rn(E5) : qne;
        function Voe(x) {
          return dt(x) && x.nodeType === 1 && !ic(x);
        }
        function loe(x) {
          if (x == null)
            return !0;
          if (Oi(x) && (Qe(x) || typeof x == "string" || typeof x.splice == "function" || ao(x) || Pa(x) || xd(x)))
            return !x.length;
          var K = ai(x);
          if (K == oe || K == yt)
            return !x.size;
          if (rc(x))
            return !OK(x).length;
          for (var v in x)
            if (Cr.call(x, v))
              return !1;
          return !0;
        }
        function coe(x, K) {
          return $l(x, K);
        }
        function Foe(x, K, v) {
          v = typeof v == "function" ? v : t;
          var P = v ? v(x, K) : t;
          return P === t ? $l(x, K, t, v) : !!P;
        }
        function ah(x) {
          if (!dt(x))
            return !1;
          var K = pi(x);
          return K == Ye || K == fe || typeof x.message == "string" && typeof x.name == "string" && !ic(x);
        }
        function xoe(x) {
          return typeof x == "number" && r6(x);
        }
        function Fu(x) {
          if (!st(x))
            return !1;
          var K = pi(x);
          return K == Q || K == we || K == qe || K == Tr;
        }
        function pw(x) {
          return typeof x == "number" && x == ir(x);
        }
        function AF(x) {
          return typeof x == "number" && x > -1 && x % 1 == 0 && x <= z;
        }
        function st(x) {
          var K = typeof x;
          return x != null && (K == "object" || K == "function");
        }
        function dt(x) {
          return x != null && typeof x == "object";
        }
        var mw = k5 ? rn(k5) : fne;
        function Xoe(x, K) {
          return x === K || kK(x, K, QK(K));
        }
        function qoe(x, K, v) {
          return v = typeof v == "function" ? v : t, kK(x, K, QK(K), v);
        }
        function Yoe(x) {
          return gw(x) && x != +x;
        }
        function foe(x) {
          if (rse(x))
            throw new Je(s);
          return x6(x);
        }
        function Koe(x) {
          return x === null;
        }
        function hoe(x) {
          return x == null;
        }
        function gw(x) {
          return typeof x == "number" || dt(x) && pi(x) == tr;
        }
        function ic(x) {
          if (!dt(x) || pi(x) != or)
            return !1;
          var K = eF(x);
          if (K === null)
            return !0;
          var v = Cr.call(K, "constructor") && K.constructor;
          return typeof v == "function" && v instanceof v && Z2.call(v) == qie;
        }
        var Vh = O5 ? rn(O5) : Kne;
        function poe(x) {
          return pw(x) && x >= -9007199254740991 && x <= z;
        }
        var vw = D5 ? rn(D5) : hne;
        function wF(x) {
          return typeof x == "string" || !Qe(x) && dt(x) && pi(x) == hi;
        }
        function nn(x) {
          return typeof x == "symbol" || dt(x) && pi(x) == $u;
        }
        var Pa = R5 ? rn(R5) : pne;
        function moe(x) {
          return x === t;
        }
        function goe(x) {
          return dt(x) && ai(x) == uu;
        }
        function voe(x) {
          return dt(x) && pi(x) == L2;
        }
        var boe = fF(DK), yoe = fF(function(x, K) {
          return x <= K;
        });
        function bw(x) {
          if (!x)
            return [];
          if (Oi(x))
            return wF(x) ? jn(x) : ki(x);
          if (jl && x[jl])
            return nie(x[jl]());
          var K = ai(x), v = K == oe ? bK : K == yt ? W2 : Sa;
          return v(x);
        }
        function xu(x) {
          if (!x)
            return x === 0 ? x : 0;
          if (x = vn(x), x === L || x === -1 / 0) {
            var K = x < 0 ? -1 : 1;
            return K * Z;
          }
          return x === x ? x : 0;
        }
        function ir(x) {
          var K = xu(x), v = K % 1;
          return K === K ? v ? K - v : K : 0;
        }
        function yw(x) {
          return x ? Vd(ir(x), 0, te) : 0;
        }
        function vn(x) {
          if (typeof x == "number")
            return x;
          if (nn(x))
            return le;
          if (st(x)) {
            var K = typeof x.valueOf == "function" ? x.valueOf() : x;
            x = st(K) ? K + "" : K;
          }
          if (typeof x != "string")
            return x === 0 ? x : +x;
          x = z5(x);
          var v = ote.test(x);
          return v || ate.test(x) ? Lte(x.slice(2), v ? 2 : 8) : ute.test(x) ? le : +x;
        }
        function Aw(x) {
          return vs(x, Di(x));
        }
        function Aoe(x) {
          return x ? Vd(ir(x), -9007199254740991, z) : x === 0 ? x : 0;
        }
        function mr(x) {
          return x == null ? "" : tn(x);
        }
        var woe = Aa(function(x, K) {
          if (rc(K) || Oi(K)) {
            vs(K, kt(K), x);
            return;
          }
          for (var v in K)
            Cr.call(K, v) && Ul(x, v, K[v]);
        }), ww = Aa(function(x, K) {
          vs(K, Di(K), x);
        }), CF = Aa(function(x, K, v, P) {
          vs(K, Di(K), x, P);
        }), Coe = Aa(function(x, K, v, P) {
          vs(K, kt(K), x, P);
        }), Poe = lu(SK);
        function Soe(x, K) {
          var v = ya(x);
          return K == null ? v : u6(v, K);
        }
        var Noe = dr(function(x, K) {
          x = Rr(x);
          var v = -1, P = K.length, M = P > 2 ? K[2] : t;
          for (M && mi(K[0], K[1], M) && (P = 1); ++v < P; )
            for (var k = K[v], j = Di(k), G = -1, $ = j.length; ++G < $; ) {
              var ae = j[G], Ve = x[ae];
              (Ve === t || Bn(Ve, ga[ae]) && !Cr.call(x, ae)) && (x[ae] = k[ae]);
            }
          return x;
        }), Moe = dr(function(x) {
          return x.push(t, z6), en(Cw, t, x);
        });
        function Toe(x, K) {
          return L5(x, Oe(K, 3), gs);
        }
        function Eoe(x, K) {
          return L5(x, Oe(K, 3), MK);
        }
        function koe(x, K) {
          return x == null ? x : NK(x, Oe(K, 3), Di);
        }
        function Ooe(x, K) {
          return x == null ? x : l6(x, Oe(K, 3), Di);
        }
        function Doe(x, K) {
          return x && gs(x, Oe(K, 3));
        }
        function Roe(x, K) {
          return x && MK(x, Oe(K, 3));
        }
        function Ioe(x) {
          return x == null ? [] : VF(x, kt(x));
        }
        function Loe(x) {
          return x == null ? [] : VF(x, Di(x));
        }
        function lh(x, K, v) {
          var P = x == null ? t : ld(x, K);
          return P === t ? v : P;
        }
        function _oe(x, K) {
          return x != null && G6(x, K, lne);
        }
        function ch(x, K) {
          return x != null && G6(x, K, cne);
        }
        var Hoe = I6(function(x, K, v) {
          K != null && typeof K.toString != "function" && (K = J2.call(K)), x[K] = v;
        }, xh(Ri)), joe = I6(function(x, K, v) {
          K != null && typeof K.toString != "function" && (K = J2.call(K)), Cr.call(x, K) ? x[K].push(v) : x[K] = [v];
        }, Oe), zoe = dr(Jl);
        function kt(x) {
          return Oi(x) ? n6(x) : OK(x);
        }
        function Di(x) {
          return Oi(x) ? n6(x, !0) : mne(x);
        }
        function Boe(x, K) {
          var v = {};
          return K = Oe(K, 3), gs(x, function(P, M, k) {
            au(v, K(P, M, k), P);
          }), v;
        }
        function Woe(x, K) {
          var v = {};
          return K = Oe(K, 3), gs(x, function(P, M, k) {
            au(v, M, K(P, M, k));
          }), v;
        }
        var Goe = Aa(function(x, K, v) {
          lF(x, K, v);
        }), Cw = Aa(function(x, K, v, P) {
          lF(x, K, v, P);
        }), Uoe = lu(function(x, K) {
          var v = {};
          if (x == null)
            return v;
          var P = !1;
          K = tt(K, function(k) {
            return k = uo(k, x), P || (P = k.length > 1), k;
          }), vs(x, JK(x), v), P && (v = pn(v, c | F | X, Hne));
          for (var M = K.length; M--; )
            HK(v, K[M]);
          return v;
        });
        function Zoe(x, K) {
          return Pw(x, yF(Oe(K)));
        }
        var Joe = lu(function(x, K) {
          return x == null ? {} : vne(x, K);
        });
        function Pw(x, K) {
          if (x == null)
            return {};
          var v = tt(JK(x), function(P) {
            return [P];
          });
          return K = Oe(K), p6(x, v, function(P, M) {
            return K(P, M[0]);
          });
        }
        function $oe(x, K, v) {
          K = uo(K, x);
          var P = -1, M = K.length;
          for (M || (M = 1, x = t); ++P < M; ) {
            var k = x == null ? t : x[bs(K[P])];
            k === t && (P = M, k = v), x = Fu(k) ? k.call(x) : k;
          }
          return x;
        }
        function Qoe(x, K, v) {
          return x == null ? x : Ql(x, K, v);
        }
        function ede(x, K, v, P) {
          return P = typeof P == "function" ? P : t, x == null ? x : Ql(x, K, v, P);
        }
        var Sw = H6(kt), Nw = H6(Di);
        function rde(x, K, v) {
          var P = Qe(x), M = P || ao(x) || Pa(x);
          if (K = Oe(K, 4), v == null) {
            var k = x && x.constructor;
            M ? v = P ? new k() : [] : st(x) ? v = Fu(k) ? ya(eF(x)) : {} : v = {};
          }
          return (M ? fn : gs)(x, function(j, G, $) {
            return K(v, j, G, $);
          }), v;
        }
        function tde(x, K) {
          return x == null ? !0 : HK(x, K);
        }
        function ide(x, K, v) {
          return x == null ? x : y6(x, K, BK(v));
        }
        function nde(x, K, v, P) {
          return P = typeof P == "function" ? P : t, x == null ? x : y6(x, K, BK(v), P);
        }
        function Sa(x) {
          return x == null ? [] : vK(x, kt(x));
        }
        function sde(x) {
          return x == null ? [] : vK(x, Di(x));
        }
        function ude(x, K, v) {
          return v === t && (v = K, K = t), v !== t && (v = vn(v), v = v === v ? v : 0), K !== t && (K = vn(K), K = K === K ? K : 0), Vd(vn(x), K, v);
        }
        function ode(x, K, v) {
          return K = xu(K), v === t ? (v = K, K = 0) : v = xu(v), x = vn(x), Fne(x, K, v);
        }
        function dde(x, K, v) {
          if (v && typeof v != "boolean" && mi(x, K, v) && (K = v = t), v === t && (typeof K == "boolean" ? (v = K, K = t) : typeof x == "boolean" && (v = x, x = t)), x === t && K === t ? (x = 0, K = 1) : (x = xu(x), K === t ? (K = x, x = 0) : K = xu(K)), x > K) {
            var P = x;
            x = K, K = P;
          }
          if (v || x % 1 || K % 1) {
            var M = t6();
            return di(x + M * (K - x + Ite("1e-" + ((M + "").length - 1))), K);
          }
          return IK(x, K);
        }
        var ade = wa(function(x, K, v) {
          return K = K.toLowerCase(), x + (v ? Mw(K) : K);
        });
        function Mw(x) {
          return Fh(mr(x).toLowerCase());
        }
        function Tw(x) {
          return x = mr(x), x && x.replace(lte, Qte).replace(Pte, "");
        }
        function Vde(x, K, v) {
          x = mr(x), K = tn(K);
          var P = x.length;
          v = v === t ? P : Vd(ir(v), 0, P);
          var M = v;
          return v -= K.length, v >= 0 && x.slice(v, M) == K;
        }
        function lde(x) {
          return x = mr(x), x && zre.test(x) ? x.replace(l5, eie) : x;
        }
        function cde(x) {
          return x = mr(x), x && Jre.test(x) ? x.replace(dK, "\\$&") : x;
        }
        var Fde = wa(function(x, K, v) {
          return x + (v ? "-" : "") + K.toLowerCase();
        }), xde = wa(function(x, K, v) {
          return x + (v ? " " : "") + K.toLowerCase();
        }), Xde = O6("toLowerCase");
        function qde(x, K, v) {
          x = mr(x), K = ir(K);
          var P = K ? pa(x) : 0;
          if (!K || P >= K)
            return x;
          var M = (K - P) / 2;
          return YF(nF(M), v) + x + YF(iF(M), v);
        }
        function Yde(x, K, v) {
          x = mr(x), K = ir(K);
          var P = K ? pa(x) : 0;
          return K && P < K ? x + YF(K - P, v) : x;
        }
        function fde(x, K, v) {
          x = mr(x), K = ir(K);
          var P = K ? pa(x) : 0;
          return K && P < K ? YF(K - P, v) + x : x;
        }
        function Kde(x, K, v) {
          return v || K == null ? K = 0 : K && (K = +K), yie(mr(x).replace(aK, ""), K || 0);
        }
        function hde(x, K, v) {
          return (v ? mi(x, K, v) : K === t) ? K = 1 : K = ir(K), LK(mr(x), K);
        }
        function pde() {
          var x = arguments, K = mr(x[0]);
          return x.length < 3 ? K : K.replace(x[1], x[2]);
        }
        var mde = wa(function(x, K, v) {
          return x + (v ? "_" : "") + K.toLowerCase();
        });
        function gde(x, K, v) {
          return v && typeof v != "number" && mi(x, K, v) && (K = v = t), v = v === t ? te : v >>> 0, v ? (x = mr(x), x && (typeof K == "string" || K != null && !Vh(K)) && (K = tn(K), !K && ha(x)) ? oo(jn(x), 0, v) : x.split(K, v)) : [];
        }
        var vde = wa(function(x, K, v) {
          return x + (v ? " " : "") + Fh(K);
        });
        function bde(x, K, v) {
          return x = mr(x), v = v == null ? 0 : Vd(ir(v), 0, x.length), K = tn(K), x.slice(v, v + K.length) == K;
        }
        function yde(x, K, v) {
          var P = T.templateSettings;
          v && mi(x, K, v) && (K = t), x = mr(x), K = CF({}, K, P, j6);
          var M = CF({}, K.imports, P.imports, j6), k = kt(M), j = vK(M, k), G, $, ae = 0, Ve = K.interpolate || _2, ce = "__p += '", ge = yK(
            (K.escape || _2).source + "|" + Ve.source + "|" + (Ve === c5 ? ste : _2).source + "|" + (K.evaluate || _2).source + "|$",
            "g"
          ), Se = "//# sourceURL=" + (Cr.call(K, "sourceURL") ? (K.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Ete + "]") + `
`;
          x.replace(ge, function(Ie, cr, qr, sn, gi, un) {
            return qr || (qr = sn), ce += x.slice(ae, un).replace(cte, rie), cr && (G = !0, ce += `' +
__e(` + cr + `) +
'`), gi && ($ = !0, ce += `';
` + gi + `;
__p += '`), qr && (ce += `' +
((__t = (` + qr + `)) == null ? '' : __t) +
'`), ae = un + Ie.length, Ie;
          }), ce += `';
`;
          var Re = Cr.call(K, "variable") && K.variable;
          if (!Re)
            ce = `with (obj) {
` + ce + `
}
`;
          else if (ite.test(Re))
            throw new Je(o);
          ce = ($ ? ce.replace(Lre, "") : ce).replace(_re, "$1").replace(Hre, "$1;"), ce = "function(" + (Re || "obj") + `) {
` + (Re ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (G ? ", __e = _.escape" : "") + ($ ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ce + `return __p
}`;
          var sr = kw(function() {
            return pr(k, Se + "return " + ce).apply(t, j);
          });
          if (sr.source = ce, ah(sr))
            throw sr;
          return sr;
        }
        function Ade(x) {
          return mr(x).toLowerCase();
        }
        function wde(x) {
          return mr(x).toUpperCase();
        }
        function Cde(x, K, v) {
          if (x = mr(x), x && (v || K === t))
            return z5(x);
          if (!x || !(K = tn(K)))
            return x;
          var P = jn(x), M = jn(K), k = B5(P, M), j = W5(P, M) + 1;
          return oo(P, k, j).join("");
        }
        function Pde(x, K, v) {
          if (x = mr(x), x && (v || K === t))
            return x.slice(0, U5(x) + 1);
          if (!x || !(K = tn(K)))
            return x;
          var P = jn(x), M = W5(P, jn(K)) + 1;
          return oo(P, 0, M).join("");
        }
        function Sde(x, K, v) {
          if (x = mr(x), x && (v || K === t))
            return x.replace(aK, "");
          if (!x || !(K = tn(K)))
            return x;
          var P = jn(x), M = B5(P, jn(K));
          return oo(P, M).join("");
        }
        function Nde(x, K) {
          var v = O, P = E;
          if (st(K)) {
            var M = "separator" in K ? K.separator : M;
            v = "length" in K ? ir(K.length) : v, P = "omission" in K ? tn(K.omission) : P;
          }
          x = mr(x);
          var k = x.length;
          if (ha(x)) {
            var j = jn(x);
            k = j.length;
          }
          if (v >= k)
            return x;
          var G = v - pa(P);
          if (G < 1)
            return P;
          var $ = j ? oo(j, 0, G).join("") : x.slice(0, G);
          if (M === t)
            return $ + P;
          if (j && (G += $.length - G), Vh(M)) {
            if (x.slice(G).search(M)) {
              var ae, Ve = $;
              for (M.global || (M = yK(M.source, mr(F5.exec(M)) + "g")), M.lastIndex = 0; ae = M.exec(Ve); )
                var ce = ae.index;
              $ = $.slice(0, ce === t ? G : ce);
            }
          } else if (x.indexOf(tn(M), G) != G) {
            var ge = $.lastIndexOf(M);
            ge > -1 && ($ = $.slice(0, ge));
          }
          return $ + P;
        }
        function Mde(x) {
          return x = mr(x), x && jre.test(x) ? x.replace(V5, die) : x;
        }
        var Tde = wa(function(x, K, v) {
          return x + (v ? " " : "") + K.toUpperCase();
        }), Fh = O6("toUpperCase");
        function Ew(x, K, v) {
          return x = mr(x), K = v ? t : K, K === t ? iie(x) ? lie(x) : Gte(x) : x.match(K) || [];
        }
        var kw = dr(function(x, K) {
          try {
            return en(x, t, K);
          } catch (v) {
            return ah(v) ? v : new Je(v);
          }
        }), Ede = lu(function(x, K) {
          return fn(K, function(v) {
            v = bs(v), au(x, v, oh(x[v], x));
          }), x;
        });
        function kde(x) {
          var K = x == null ? 0 : x.length, v = Oe();
          return x = K ? tt(x, function(P) {
            if (typeof P[1] != "function")
              throw new Kn(u);
            return [v(P[0]), P[1]];
          }) : [], dr(function(P) {
            for (var M = -1; ++M < K; ) {
              var k = x[M];
              if (en(k[0], this, P))
                return en(k[1], this, P);
            }
          });
        }
        function Ode(x) {
          return dne(pn(x, c));
        }
        function xh(x) {
          return function() {
            return x;
          };
        }
        function Dde(x, K) {
          return x == null || x !== x ? K : x;
        }
        var Rde = R6(), Ide = R6(!0);
        function Ri(x) {
          return x;
        }
        function Xh(x) {
          return X6(typeof x == "function" ? x : pn(x, c));
        }
        function Lde(x) {
          return Y6(pn(x, c));
        }
        function _de(x, K) {
          return f6(x, pn(K, c));
        }
        var Hde = dr(function(x, K) {
          return function(v) {
            return Jl(v, x, K);
          };
        }), jde = dr(function(x, K) {
          return function(v) {
            return Jl(x, v, K);
          };
        });
        function qh(x, K, v) {
          var P = kt(K), M = VF(K, P);
          v == null && !(st(K) && (M.length || !P.length)) && (v = K, K = x, x = this, M = VF(K, kt(K)));
          var k = !(st(v) && "chain" in v) || !!v.chain, j = Fu(x);
          return fn(M, function(G) {
            var $ = K[G];
            x[G] = $, j && (x.prototype[G] = function() {
              var ae = this.__chain__;
              if (k || ae) {
                var Ve = x(this.__wrapped__), ce = Ve.__actions__ = ki(this.__actions__);
                return ce.push({ func: $, args: arguments, thisArg: x }), Ve.__chain__ = ae, Ve;
              }
              return $.apply(x, ro([this.value()], arguments));
            });
          }), x;
        }
        function zde() {
          return Ut._ === this && (Ut._ = Yie), this;
        }
        function Yh() {
        }
        function Bde(x) {
          return x = ir(x), dr(function(K) {
            return K6(K, x);
          });
        }
        var Wde = GK(tt), Gde = GK(I5), Ude = GK(KK);
        function Ow(x) {
          return rh(x) ? hK(bs(x)) : bne(x);
        }
        function Zde(x) {
          return function(K) {
            return x == null ? t : ld(x, K);
          };
        }
        var Jde = L6(), $de = L6(!0);
        function fh() {
          return [];
        }
        function Kh() {
          return !1;
        }
        function Qde() {
          return {};
        }
        function eae() {
          return "";
        }
        function rae() {
          return !0;
        }
        function tae(x, K) {
          if (x = ir(x), x < 1 || x > z)
            return [];
          var v = te, P = di(x, te);
          K = Oe(K), x -= te;
          for (var M = gK(P, K); ++v < x; )
            K(v);
          return M;
        }
        function iae(x) {
          return Qe(x) ? tt(x, bs) : nn(x) ? [x] : ki(iw(mr(x)));
        }
        function nae(x) {
          var K = ++Xie;
          return mr(x) + K;
        }
        var sae = qF(function(x, K) {
          return x + K;
        }, 0), uae = UK("ceil"), oae = qF(function(x, K) {
          return x / K;
        }, 1), dae = UK("floor");
        function aae(x) {
          return x && x.length ? aF(x, Ri, TK) : t;
        }
        function Vae(x, K) {
          return x && x.length ? aF(x, Oe(K, 2), TK) : t;
        }
        function lae(x) {
          return H5(x, Ri);
        }
        function cae(x, K) {
          return H5(x, Oe(K, 2));
        }
        function Fae(x) {
          return x && x.length ? aF(x, Ri, DK) : t;
        }
        function xae(x, K) {
          return x && x.length ? aF(x, Oe(K, 2), DK) : t;
        }
        var Xae = qF(function(x, K) {
          return x * K;
        }, 1), qae = UK("round"), Yae = qF(function(x, K) {
          return x - K;
        }, 0);
        function fae(x) {
          return x && x.length ? mK(x, Ri) : 0;
        }
        function Kae(x, K) {
          return x && x.length ? mK(x, Oe(K, 2)) : 0;
        }
        return T.after = Lue, T.ary = xw, T.assign = woe, T.assignIn = ww, T.assignInWith = CF, T.assignWith = Coe, T.at = Poe, T.before = Xw, T.bind = oh, T.bindAll = Ede, T.bindKey = qw, T.castArray = Que, T.chain = lw, T.chunk = dse, T.compact = ase, T.concat = Vse, T.cond = kde, T.conforms = Ode, T.constant = xh, T.countBy = fue, T.create = Soe, T.curry = Yw, T.curryRight = fw, T.debounce = Kw, T.defaults = Noe, T.defaultsDeep = Moe, T.defer = _ue, T.delay = Hue, T.difference = lse, T.differenceBy = cse, T.differenceWith = Fse, T.drop = xse, T.dropRight = Xse, T.dropRightWhile = qse, T.dropWhile = Yse, T.fill = fse, T.filter = hue, T.flatMap = gue, T.flatMapDeep = vue, T.flatMapDepth = bue, T.flatten = ow, T.flattenDeep = Kse, T.flattenDepth = hse, T.flip = jue, T.flow = Rde, T.flowRight = Ide, T.fromPairs = pse, T.functions = Ioe, T.functionsIn = Loe, T.groupBy = yue, T.initial = gse, T.intersection = vse, T.intersectionBy = bse, T.intersectionWith = yse, T.invert = Hoe, T.invertBy = joe, T.invokeMap = wue, T.iteratee = Xh, T.keyBy = Cue, T.keys = kt, T.keysIn = Di, T.map = gF, T.mapKeys = Boe, T.mapValues = Woe, T.matches = Lde, T.matchesProperty = _de, T.memoize = bF, T.merge = Goe, T.mergeWith = Cw, T.method = Hde, T.methodOf = jde, T.mixin = qh, T.negate = yF, T.nthArg = Bde, T.omit = Uoe, T.omitBy = Zoe, T.once = zue, T.orderBy = Pue, T.over = Wde, T.overArgs = Bue, T.overEvery = Gde, T.overSome = Ude, T.partial = dh, T.partialRight = hw, T.partition = Sue, T.pick = Joe, T.pickBy = Pw, T.property = Ow, T.propertyOf = Zde, T.pull = Pse, T.pullAll = aw, T.pullAllBy = Sse, T.pullAllWith = Nse, T.pullAt = Mse, T.range = Jde, T.rangeRight = $de, T.rearg = Wue, T.reject = Tue, T.remove = Tse, T.rest = Gue, T.reverse = sh, T.sampleSize = kue, T.set = Qoe, T.setWith = ede, T.shuffle = Oue, T.slice = Ese, T.sortBy = Iue, T.sortedUniq = _se, T.sortedUniqBy = Hse, T.split = gde, T.spread = Uue, T.tail = jse, T.take = zse, T.takeRight = Bse, T.takeRightWhile = Wse, T.takeWhile = Gse, T.tap = aue, T.throttle = Zue, T.thru = mF, T.toArray = bw, T.toPairs = Sw, T.toPairsIn = Nw, T.toPath = iae, T.toPlainObject = Aw, T.transform = rde, T.unary = Jue, T.union = Use, T.unionBy = Zse, T.unionWith = Jse, T.uniq = $se, T.uniqBy = Qse, T.uniqWith = eue, T.unset = tde, T.unzip = uh, T.unzipWith = Vw, T.update = ide, T.updateWith = nde, T.values = Sa, T.valuesIn = sde, T.without = rue, T.words = Ew, T.wrap = $ue, T.xor = tue, T.xorBy = iue, T.xorWith = nue, T.zip = sue, T.zipObject = uue, T.zipObjectDeep = oue, T.zipWith = due, T.entries = Sw, T.entriesIn = Nw, T.extend = ww, T.extendWith = CF, qh(T, T), T.add = sae, T.attempt = kw, T.camelCase = ade, T.capitalize = Mw, T.ceil = uae, T.clamp = ude, T.clone = eoe, T.cloneDeep = toe, T.cloneDeepWith = ioe, T.cloneWith = roe, T.conformsTo = noe, T.deburr = Tw, T.defaultTo = Dde, T.divide = oae, T.endsWith = Vde, T.eq = Bn, T.escape = lde, T.escapeRegExp = cde, T.every = Kue, T.find = pue, T.findIndex = sw, T.findKey = Toe, T.findLast = mue, T.findLastIndex = uw, T.findLastKey = Eoe, T.floor = dae, T.forEach = cw, T.forEachRight = Fw, T.forIn = koe, T.forInRight = Ooe, T.forOwn = Doe, T.forOwnRight = Roe, T.get = lh, T.gt = soe, T.gte = uoe, T.has = _oe, T.hasIn = ch, T.head = dw, T.identity = Ri, T.includes = Aue, T.indexOf = mse, T.inRange = ode, T.invoke = zoe, T.isArguments = xd, T.isArray = Qe, T.isArrayBuffer = ooe, T.isArrayLike = Oi, T.isArrayLikeObject = Ft, T.isBoolean = doe, T.isBuffer = ao, T.isDate = aoe, T.isElement = Voe, T.isEmpty = loe, T.isEqual = coe, T.isEqualWith = Foe, T.isError = ah, T.isFinite = xoe, T.isFunction = Fu, T.isInteger = pw, T.isLength = AF, T.isMap = mw, T.isMatch = Xoe, T.isMatchWith = qoe, T.isNaN = Yoe, T.isNative = foe, T.isNil = hoe, T.isNull = Koe, T.isNumber = gw, T.isObject = st, T.isObjectLike = dt, T.isPlainObject = ic, T.isRegExp = Vh, T.isSafeInteger = poe, T.isSet = vw, T.isString = wF, T.isSymbol = nn, T.isTypedArray = Pa, T.isUndefined = moe, T.isWeakMap = goe, T.isWeakSet = voe, T.join = Ase, T.kebabCase = Fde, T.last = gn, T.lastIndexOf = wse, T.lowerCase = xde, T.lowerFirst = Xde, T.lt = boe, T.lte = yoe, T.max = aae, T.maxBy = Vae, T.mean = lae, T.meanBy = cae, T.min = Fae, T.minBy = xae, T.stubArray = fh, T.stubFalse = Kh, T.stubObject = Qde, T.stubString = eae, T.stubTrue = rae, T.multiply = Xae, T.nth = Cse, T.noConflict = zde, T.noop = Yh, T.now = vF, T.pad = qde, T.padEnd = Yde, T.padStart = fde, T.parseInt = Kde, T.random = dde, T.reduce = Nue, T.reduceRight = Mue, T.repeat = hde, T.replace = pde, T.result = $oe, T.round = qae, T.runInContext = J, T.sample = Eue, T.size = Due, T.snakeCase = mde, T.some = Rue, T.sortedIndex = kse, T.sortedIndexBy = Ose, T.sortedIndexOf = Dse, T.sortedLastIndex = Rse, T.sortedLastIndexBy = Ise, T.sortedLastIndexOf = Lse, T.startCase = vde, T.startsWith = bde, T.subtract = Yae, T.sum = fae, T.sumBy = Kae, T.template = yde, T.times = tae, T.toFinite = xu, T.toInteger = ir, T.toLength = yw, T.toLower = Ade, T.toNumber = vn, T.toSafeInteger = Aoe, T.toString = mr, T.toUpper = wde, T.trim = Cde, T.trimEnd = Pde, T.trimStart = Sde, T.truncate = Nde, T.unescape = Mde, T.uniqueId = nae, T.upperCase = Tde, T.upperFirst = Fh, T.each = cw, T.eachRight = Fw, T.first = dw, qh(T, function() {
          var x = {};
          return gs(T, function(K, v) {
            Cr.call(T.prototype, v) || (x[v] = K);
          }), x;
        }(), { chain: !1 }), T.VERSION = i, fn(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(x) {
          T[x].placeholder = T;
        }), fn(["drop", "take"], function(x, K) {
          xr.prototype[x] = function(v) {
            v = v === t ? 1 : wt(ir(v), 0);
            var P = this.__filtered__ && !K ? new xr(this) : this.clone();
            return P.__filtered__ ? P.__takeCount__ = di(v, P.__takeCount__) : P.__views__.push({
              size: di(v, te),
              type: x + (P.__dir__ < 0 ? "Right" : "")
            }), P;
          }, xr.prototype[x + "Right"] = function(v) {
            return this.reverse()[x](v).reverse();
          };
        }), fn(["filter", "map", "takeWhile"], function(x, K) {
          var v = K + 1, P = v == H || v == B;
          xr.prototype[x] = function(M) {
            var k = this.clone();
            return k.__iteratees__.push({
              iteratee: Oe(M, 3),
              type: v
            }), k.__filtered__ = k.__filtered__ || P, k;
          };
        }), fn(["head", "last"], function(x, K) {
          var v = "take" + (K ? "Right" : "");
          xr.prototype[x] = function() {
            return this[v](1).value()[0];
          };
        }), fn(["initial", "tail"], function(x, K) {
          var v = "drop" + (K ? "" : "Right");
          xr.prototype[x] = function() {
            return this.__filtered__ ? new xr(this) : this[v](1);
          };
        }), xr.prototype.compact = function() {
          return this.filter(Ri);
        }, xr.prototype.find = function(x) {
          return this.filter(x).head();
        }, xr.prototype.findLast = function(x) {
          return this.reverse().find(x);
        }, xr.prototype.invokeMap = dr(function(x, K) {
          return typeof x == "function" ? new xr(this) : this.map(function(v) {
            return Jl(v, x, K);
          });
        }), xr.prototype.reject = function(x) {
          return this.filter(yF(Oe(x)));
        }, xr.prototype.slice = function(x, K) {
          x = ir(x);
          var v = this;
          return v.__filtered__ && (x > 0 || K < 0) ? new xr(v) : (x < 0 ? v = v.takeRight(-x) : x && (v = v.drop(x)), K !== t && (K = ir(K), v = K < 0 ? v.dropRight(-K) : v.take(K - x)), v);
        }, xr.prototype.takeRightWhile = function(x) {
          return this.reverse().takeWhile(x).reverse();
        }, xr.prototype.toArray = function() {
          return this.take(te);
        }, gs(xr.prototype, function(x, K) {
          var v = /^(?:filter|find|map|reject)|While$/.test(K), P = /^(?:head|last)$/.test(K), M = T[P ? "take" + (K == "last" ? "Right" : "") : K], k = P || /^find/.test(K);
          M && (T.prototype[K] = function() {
            var j = this.__wrapped__, G = P ? [1] : arguments, $ = j instanceof xr, ae = G[0], Ve = $ || Qe(j), ce = function(cr) {
              var qr = M.apply(T, ro([cr], G));
              return P && ge ? qr[0] : qr;
            };
            Ve && v && typeof ae == "function" && ae.length != 1 && ($ = Ve = !1);
            var ge = this.__chain__, Se = !!this.__actions__.length, Re = k && !ge, sr = $ && !Se;
            if (!k && Ve) {
              j = sr ? j : new xr(this);
              var Ie = x.apply(j, G);
              return Ie.__actions__.push({ func: mF, args: [ce], thisArg: t }), new hn(Ie, ge);
            }
            return Re && sr ? x.apply(this, G) : (Ie = this.thru(ce), Re ? P ? Ie.value()[0] : Ie.value() : Ie);
          });
        }), fn(["pop", "push", "shift", "sort", "splice", "unshift"], function(x) {
          var K = G2[x], v = /^(?:push|sort|unshift)$/.test(x) ? "tap" : "thru", P = /^(?:pop|shift)$/.test(x);
          T.prototype[x] = function() {
            var M = arguments;
            if (P && !this.__chain__) {
              var k = this.value();
              return K.apply(Qe(k) ? k : [], M);
            }
            return this[v](function(j) {
              return K.apply(Qe(j) ? j : [], M);
            });
          };
        }), gs(xr.prototype, function(x, K) {
          var v = T[K];
          if (v) {
            var P = v.name + "";
            Cr.call(ba, P) || (ba[P] = []), ba[P].push({ name: K, func: v });
          }
        }), ba[XF(t, p).name] = [{
          name: "wrapper",
          func: t
        }], xr.prototype.clone = Mie, xr.prototype.reverse = Tie, xr.prototype.value = Eie, T.prototype.at = Vue, T.prototype.chain = lue, T.prototype.commit = cue, T.prototype.next = Fue, T.prototype.plant = Xue, T.prototype.reverse = que, T.prototype.toJSON = T.prototype.valueOf = T.prototype.value = Yue, T.prototype.first = T.prototype.head, jl && (T.prototype[jl] = xue), T;
      }, ma = cie();
      ud ? ((ud.exports = ma)._ = ma, XK._ = ma) : Ut._ = ma;
    }).call(vbe);
  }(Ac, Ac.exports)), Ac.exports;
}
var ZW = bbe();
const JW = et([
  !1,
  () => {
  }
]), $W = et([
  0,
  () => {
  }
]);
function ybe({
  onBeforeExpand: e,
  translate: r = Dn
}) {
  const [t, i] = rt(JW), [n, s] = rt($W);
  return /* @__PURE__ */ l(he, { children: n > 100 && /* @__PURE__ */ C(
    er,
    {
      className: "text-textLink items-center !justify-start pr-0 pl-0 underline",
      onClick: () => {
        e == null || e(!t), i(!t);
      },
      variant: "link",
      children: [
        t ? r.getText("Show less") : r.getText("Show more"),
        t ? /* @__PURE__ */ l(tVe, { className: "h-4 w-4" }) : /* @__PURE__ */ l(e2, { className: "h-4 w-4" })
      ]
    }
  ) });
}
function yr({
  children: e,
  className: r,
  maxHeight: t = 150,
  translate: i = Dn
}) {
  const [n, s] = ie(!1), [u, o] = ie(0), d = Yr(null);
  Pe(() => {
    d.current && o(d.current.scrollHeight);
  }, []);
  let a = ZW.debounce(() => {
    d.current && o(d.current.scrollHeight);
  });
  return Pe(() => (window.addEventListener("resize", a), () => {
    window.removeEventListener("resize", a);
  })), /* @__PURE__ */ l(JW.Provider, { value: [n, s], children: /* @__PURE__ */ C($W.Provider, { value: [u, o], children: [
    /* @__PURE__ */ l(
      "div",
      {
        className: _("overflow-hidden", r),
        ref: d,
        style: {
          maxHeight: n ? u : t,
          transition: "all .5s ease",
          ...!n && u >= t ? {
            maskImage: "linear-gradient(to bottom, black 50%, transparent 100%)"
          } : {}
        },
        children: e
      }
    ),
    u >= t ? /* @__PURE__ */ l(
      ybe,
      {
        onBeforeExpand: () => {
          a();
        },
        translate: i
      }
    ) : null
  ] }) });
}
const Abe = "sidebar_state", wbe = 60 * 60 * 24 * 7, Cbe = "16rem", Pbe = "18rem", Sbe = "3rem", Nbe = "b", QW = et(null);
function LY() {
  const e = rt(QW);
  if (!e)
    throw new Error("useSidebar must be used within a SidebarProvider.");
  return e;
}
const Mbe = re(
  ({
    defaultOpen: e = !0,
    open: r,
    onOpenChange: t,
    className: i,
    style: n,
    children: s,
    ...u
  }, o) => {
    const d = Pae(), [a, V] = ie(!1), [c, F] = ie(e), X = r ?? c, Y = Yi(
      (m) => {
        const g = typeof m == "function" ? m(X) : m;
        t ? t(g) : F(g), document.cookie = `${Abe}=${g}; path=/; max-age=${wbe}`;
      },
      [t, X]
    ), q = Yi(() => d ? V((m) => !m) : Y((m) => !m), [d, Y, V]);
    Pe(() => {
      const m = (g) => {
        g.key === Nbe && (g.metaKey || g.ctrlKey) && (g.preventDefault(), q());
      };
      return window.addEventListener("keydown", m), () => window.removeEventListener("keydown", m);
    }, [q]);
    const f = X ? "expanded" : "collapsed", p = $e(
      () => ({
        state: f,
        open: X,
        setOpen: Y,
        isMobile: d,
        openMobile: a,
        setOpenMobile: V,
        toggleSidebar: q
      }),
      [
        f,
        X,
        Y,
        d,
        a,
        V,
        q
      ]
    );
    return /* @__PURE__ */ l(QW.Provider, { value: p, children: /* @__PURE__ */ l(bA, { delayDuration: 0, children: /* @__PURE__ */ l(
      "div",
      {
        style: {
          "--sidebar-width": Cbe,
          "--sidebar-width-icon": Sbe,
          ...n
        },
        className: _(
          "group/sidebar-wrapper has-[[data-variant=inset]]:bg-sidebar flex min-h-svh w-full",
          i
        ),
        ref: o,
        ...u,
        children: s
      }
    ) }) });
  }
);
Mbe.displayName = "SidebarProvider";
const Tbe = re(
  ({
    side: e = "left",
    variant: r = "sidebar",
    collapsible: t = "offcanvas",
    className: i,
    children: n,
    ...s
  }, u) => {
    const { isMobile: o, state: d, openMobile: a, setOpenMobile: V } = LY();
    return t === "none" ? /* @__PURE__ */ l(
      "div",
      {
        className: _(
          "bg-sidebar text-sidebar-foreground flex h-full w-(--sidebar-width) flex-col",
          i
        ),
        ref: u,
        ...s,
        children: n
      }
    ) : o ? /* @__PURE__ */ l(BW, { open: a, onOpenChange: V, ...s, children: /* @__PURE__ */ l(
      lA,
      {
        "data-sidebar": "sidebar",
        "data-mobile": "true",
        className: "bg-sidebar text-sidebar-foreground w-(--sidebar-width) p-0 [&>button]:hidden",
        style: {
          "--sidebar-width": Pbe
        },
        side: e,
        children: /* @__PURE__ */ l("div", { className: "flex h-full w-full flex-col", children: n })
      }
    ) }) : /* @__PURE__ */ C(
      "div",
      {
        ref: u,
        className: "text-sidebar-foreground group peer hidden md:block",
        "data-state": d,
        "data-collapsible": d === "collapsed" ? t : "",
        "data-variant": r,
        "data-side": e,
        children: [
          /* @__PURE__ */ l(
            "div",
            {
              className: _(
                "relative h-svh w-(--sidebar-width) bg-transparent transition-[width] duration-200 ease-linear",
                "group-data-[collapsible=offcanvas]:w-0",
                "group-data-[side=right]:rotate-180",
                r === "floating" || r === "inset" ? "group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.4))]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon)"
              )
            }
          ),
          /* @__PURE__ */ l(
            "div",
            {
              className: _(
                "fixed inset-y-0 z-10 hidden h-svh w-(--sidebar-width) transition-[left,right,width] duration-200 ease-linear md:flex",
                e === "left" ? "left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]" : "right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]",
                // Adjust the padding for floating and inset variants.
                r === "floating" || r === "inset" ? "p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.4)_+2px)]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon) group-data-[side=left]:border-r group-data-[side=right]:border-l",
                i
              ),
              ...s,
              children: /* @__PURE__ */ l(
                "div",
                {
                  "data-sidebar": "sidebar",
                  className: "bg-sidebar group-data-[variant=floating]:border-sidebar-border flex h-full w-full flex-col group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:border group-data-[variant=floating]:shadow",
                  children: n
                }
              )
            }
          )
        ]
      }
    );
  }
);
Tbe.displayName = "Sidebar";
const Ebe = re(({ className: e, onClick: r, ...t }, i) => {
  const { toggleSidebar: n } = LY();
  return /* @__PURE__ */ C(
    er,
    {
      ref: i,
      "data-sidebar": "trigger",
      variant: "ghost",
      size: "icon",
      className: _("h-7 w-7", e),
      onClick: (s) => {
        r == null || r(s), n();
      },
      ...t,
      children: [
        /* @__PURE__ */ l(gVe, {}),
        /* @__PURE__ */ l("span", { className: "sr-only", children: "Toggle Sidebar" })
      ]
    }
  );
});
Ebe.displayName = "SidebarTrigger";
const kbe = re(({ className: e, ...r }, t) => {
  const { toggleSidebar: i } = LY();
  return /* @__PURE__ */ l(
    "button",
    {
      ref: t,
      "data-sidebar": "rail",
      "aria-label": "Toggle Sidebar",
      tabIndex: -1,
      onClick: i,
      title: "Toggle Sidebar",
      className: _(
        "hover:after:bg-sidebar-border absolute inset-y-0 z-20 hidden w-4 -translate-x-1/2 transition-all ease-linear after:absolute after:inset-y-0 after:left-1/2 after:w-[2px] group-data-[side=left]:-right-4 group-data-[side=right]:left-0 sm:flex",
        "[[data-side=left]_&]:cursor-w-resize [[data-side=right]_&]:cursor-e-resize",
        "[[data-side=left][data-state=collapsed]_&]:cursor-e-resize [[data-side=right][data-state=collapsed]_&]:cursor-w-resize",
        "group-data-[collapsible=offcanvas]:hover:bg-sidebar group-data-[collapsible=offcanvas]:translate-x-0 group-data-[collapsible=offcanvas]:after:left-full",
        "[[data-side=left][data-collapsible=offcanvas]_&]:-right-2",
        "[[data-side=right][data-collapsible=offcanvas]_&]:-left-2",
        e
      ),
      ...r
    }
  );
});
kbe.displayName = "SidebarRail";
const Obe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "main",
  {
    ref: t,
    className: _(
      "bg-background relative flex min-h-svh flex-1 flex-col",
      "peer-data-[variant=inset]:min-h-[calc(100svh-theme(spacing.4))] md:peer-data-[variant=inset]:m-2 md:peer-data-[state=collapsed]:peer-data-[variant=inset]:ml-2 md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow",
      e
    ),
    ...r
  }
));
Obe.displayName = "SidebarInset";
const Dbe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  G3,
  {
    ref: t,
    "data-sidebar": "input",
    className: _(
      "bg-background focus-visible:ring-sidebar-ring h-8 w-full shadow-none focus-visible:ring-2",
      e
    ),
    ...r
  }
));
Dbe.displayName = "SidebarInput";
const Rbe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "div",
  {
    ref: t,
    "data-sidebar": "header",
    className: _("flex flex-col gap-2 p-2", e),
    ...r
  }
));
Rbe.displayName = "SidebarHeader";
const Ibe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "div",
  {
    ref: t,
    "data-sidebar": "footer",
    className: _("flex flex-col gap-2 p-2", e),
    ...r
  }
));
Ibe.displayName = "SidebarFooter";
const Lbe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  Qd,
  {
    ref: t,
    "data-sidebar": "separator",
    className: _("bg-sidebar-border mx-2 w-auto", e),
    ...r
  }
));
Lbe.displayName = "SidebarSeparator";
const _be = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "div",
  {
    ref: t,
    "data-sidebar": "content",
    className: _(
      "flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden",
      e
    ),
    ...r
  }
));
_be.displayName = "SidebarContent";
const Hbe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "div",
  {
    ref: t,
    "data-sidebar": "group",
    className: _("relative flex w-full min-w-0 flex-col p-2", e),
    ...r
  }
));
Hbe.displayName = "SidebarGroup";
const jbe = re(({ className: e, asChild: r = !1, ...t }, i) => /* @__PURE__ */ l(
  r ? xn : "div",
  {
    ref: i,
    "data-sidebar": "group-label",
    className: _(
      "text-sidebar-foreground/70 ring-sidebar-ring flex h-8 shrink-0 items-center rounded-md px-2 text-bodysm font-medium outline-none transition-[margin,opa] duration-200 ease-linear focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
      "group-data-[collapsible=icon]:-mt-8 group-data-[collapsible=icon]:opacity-0",
      e
    ),
    ...t
  }
));
jbe.displayName = "SidebarGroupLabel";
const zbe = re(({ className: e, asChild: r = !1, ...t }, i) => /* @__PURE__ */ l(
  r ? xn : "button",
  {
    ref: i,
    "data-sidebar": "group-action",
    className: _(
      "text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground absolute right-3 top-3.5 flex aspect-square w-5 items-center justify-center rounded-md p-0 outline-none transition-transform focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
      // Increases the hit area of the button on mobile.
      "after:absolute after:-inset-2 after:md:hidden",
      "group-data-[collapsible=icon]:hidden",
      e
    ),
    ...t
  }
));
zbe.displayName = "SidebarGroupAction";
const Bbe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "div",
  {
    ref: t,
    "data-sidebar": "group-content",
    className: _("w-full text-bodysm", e),
    ...r
  }
));
Bbe.displayName = "SidebarGroupContent";
const Wbe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "ul",
  {
    ref: t,
    "data-sidebar": "menu",
    className: _("flex w-full min-w-0 flex-col gap-1", e),
    ...r
  }
));
Wbe.displayName = "SidebarMenu";
const Gbe = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "li",
  {
    ref: t,
    "data-sidebar": "menu-item",
    className: _("group/menu-item relative", e),
    ...r
  }
));
Gbe.displayName = "SidebarMenuItem";
const Ube = Js(
  "peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-bodysm outline-none ring-sidebar-ring transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 group-has-[[data-sidebar=menu-action]]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-sidebar-accent-foreground data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:!size-8 group-data-[collapsible=icon]:!p-2 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
        outline: "bg-background shadow-[0_0_0_1px_hsl(var(--sidebar-border))] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground hover:shadow-[0_0_0_1px_hsl(var(--sidebar-accent))]"
      },
      size: {
        default: "h-8 text-bodysm",
        sm: "h-7 text-bodysm",
        lg: "h-12 text-bodysm group-data-[collapsible=icon]:!p-0"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Zbe = re(
  ({
    asChild: e = !1,
    isActive: r = !1,
    variant: t = "default",
    size: i = "default",
    tooltip: n,
    className: s,
    ...u
  }, o) => {
    const d = e ? xn : "button", { isMobile: a, state: V } = LY(), c = /* @__PURE__ */ l(
      d,
      {
        ref: o,
        "data-sidebar": "menu-button",
        "data-size": i,
        "data-active": r,
        className: _(Ube({ variant: t, size: i }), s),
        ...u
      }
    );
    return n ? (typeof n == "string" && (n = {
      children: n
    }), /* @__PURE__ */ C(DU, { children: [
      /* @__PURE__ */ l(RU, { asChild: !0, children: c }),
      /* @__PURE__ */ l(
        IU,
        {
          side: "right",
          align: "center",
          hidden: V !== "collapsed" || a,
          ...n
        }
      )
    ] })) : c;
  }
);
Zbe.displayName = "SidebarMenuButton";
const Jbe = re(({ className: e, asChild: r = !1, showOnHover: t = !1, ...i }, n) => /* @__PURE__ */ l(
  r ? xn : "button",
  {
    ref: n,
    "data-sidebar": "menu-action",
    className: _(
      "text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground peer-hover/menu-button:text-sidebar-accent-foreground absolute right-1 top-1.5 flex aspect-square w-5 items-center justify-center rounded-md p-0 outline-none transition-transform focus-visible:ring-2 [&>svg]:size-4 [&>svg]:shrink-0",
      // Increases the hit area of the button on mobile.
      "after:absolute after:-inset-2 after:md:hidden",
      "peer-data-[size=sm]/menu-button:top-1",
      "peer-data-[size=default]/menu-button:top-1.5",
      "peer-data-[size=lg]/menu-button:top-2.5",
      "group-data-[collapsible=icon]:hidden",
      t && "peer-data-[active=true]/menu-button:text-sidebar-accent-foreground group-focus-within/menu-item:opacity-100 group-hover/menu-item:opacity-100 data-[state=open]:opacity-100 md:opacity-0",
      e
    ),
    ...i
  }
));
Jbe.displayName = "SidebarMenuAction";
const $be = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "div",
  {
    ref: t,
    "data-sidebar": "menu-badge",
    className: _(
      "text-sidebar-foreground pointer-events-none absolute right-1 flex h-5 min-w-5 select-none items-center justify-center rounded-md px-1 text-bodysm font-medium tabular-nums",
      "peer-hover/menu-button:text-sidebar-accent-foreground peer-data-[active=true]/menu-button:text-sidebar-accent-foreground",
      "peer-data-[size=sm]/menu-button:top-1",
      "peer-data-[size=default]/menu-button:top-1.5",
      "peer-data-[size=lg]/menu-button:top-2.5",
      "group-data-[collapsible=icon]:hidden",
      e
    ),
    ...r
  }
));
$be.displayName = "SidebarMenuBadge";
const Qbe = re(({ className: e, showIcon: r = !1, ...t }, i) => {
  const n = $e(() => `${Math.floor(Math.random() * 40) + 50}%`, []);
  return /* @__PURE__ */ C(
    "div",
    {
      ref: i,
      "data-sidebar": "menu-skeleton",
      className: _("flex h-8 items-center gap-2 rounded-md px-2", e),
      ...t,
      children: [
        r && /* @__PURE__ */ l(
          Xe,
          {
            className: "size-4 rounded-md",
            "data-sidebar": "menu-skeleton-icon"
          }
        ),
        /* @__PURE__ */ l(
          Xe,
          {
            className: "h-4 max-w-(--skeleton-width) flex-1",
            "data-sidebar": "menu-skeleton-text",
            style: {
              "--skeleton-width": n
            }
          }
        )
      ]
    }
  );
});
Qbe.displayName = "SidebarMenuSkeleton";
const eye = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  "ul",
  {
    ref: t,
    "data-sidebar": "menu-sub",
    className: _(
      "border-sidebar-border mx-3.5 flex min-w-0 translate-x-px flex-col gap-1 border-l px-2.5 py-0.5",
      "group-data-[collapsible=icon]:hidden",
      e
    ),
    ...r
  }
));
eye.displayName = "SidebarMenuSub";
const rye = re(({ ...e }, r) => /* @__PURE__ */ l("li", { ref: r, ...e }));
rye.displayName = "SidebarMenuSubItem";
const tye = re(({ asChild: e = !1, size: r = "md", isActive: t, className: i, ...n }, s) => /* @__PURE__ */ l(
  e ? xn : "a",
  {
    ref: s,
    "data-sidebar": "menu-sub-button",
    "data-size": r,
    "data-active": t,
    className: _(
      "text-sidebar-foreground ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground active:bg-sidebar-accent active:text-sidebar-accent-foreground [&>svg]:text-sidebar-accent-foreground flex h-7 min-w-0 -translate-x-px items-center gap-2 overflow-hidden rounded-md px-2 outline-none focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0",
      "data-[active=true]:bg-sidebar-accent data-[active=true]:text-sidebar-accent-foreground",
      r === "sm" && "text-bodyxs",
      r === "md" && "text-bodysm",
      "group-data-[collapsible=icon]:hidden",
      i
    ),
    ...n
  }
));
tye.displayName = "SidebarMenuSubButton";
function Xe({ className: e, ...r }) {
  return /* @__PURE__ */ l(
    "div",
    {
      className: _("bg-muted animate-pulse rounded-md", e),
      ...r
    }
  );
}
function iye(e, r = []) {
  let t = [];
  function i(s, u) {
    const o = h.createContext(u), d = t.length;
    t = [...t, u];
    const a = (c) => {
      var p;
      const { scope: F, children: X, ...Y } = c, q = ((p = F == null ? void 0 : F[e]) == null ? void 0 : p[d]) || o, f = h.useMemo(() => Y, Object.values(Y));
      return /* @__PURE__ */ l(q.Provider, { value: f, children: X });
    };
    a.displayName = s + "Provider";
    function V(c, F) {
      var q;
      const X = ((q = F == null ? void 0 : F[e]) == null ? void 0 : q[d]) || o, Y = h.useContext(X);
      if (Y) return Y;
      if (u !== void 0) return u;
      throw new Error(`\`${c}\` must be used within \`${s}\``);
    }
    return [a, V];
  }
  const n = () => {
    const s = t.map((u) => h.createContext(u));
    return function(o) {
      const d = (o == null ? void 0 : o[e]) || s;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: d } }),
        [o, d]
      );
    };
  };
  return n.scopeName = e, [i, nye(n, ...r)];
}
function nye(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const t = () => {
    const i = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(s) {
      const u = i.reduce((o, { useScope: d, scopeName: a }) => {
        const c = d(s)[`__scope${a}`];
        return { ...o, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${r.scopeName}`]: u }), [u]);
    };
  };
  return t.scopeName = r.scopeName, t;
}
var eG = ["PageUp", "PageDown"], rG = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], tG = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, Cl = "Slider", [c8, sye, uye] = Lq(Cl), [iG, Fer] = iye(Cl, [
  uye
]), [oye, _Y] = iG(Cl), nG = h.forwardRef(
  (e, r) => {
    const {
      name: t,
      min: i = 0,
      max: n = 100,
      step: s = 1,
      orientation: u = "horizontal",
      disabled: o = !1,
      minStepsBetweenThumbs: d = 0,
      defaultValue: a = [i],
      value: V,
      onValueChange: c = () => {
      },
      onValueCommit: F = () => {
      },
      inverted: X = !1,
      form: Y,
      ...q
    } = e, f = h.useRef(/* @__PURE__ */ new Set()), p = h.useRef(0), g = u === "horizontal" ? dye : aye, [y = [], b] = Gr({
      prop: V,
      defaultProp: a,
      onChange: (E) => {
        var R;
        (R = [...f.current][p.current]) == null || R.focus(), c(E);
      }
    }), A = h.useRef(y);
    function w(E) {
      const I = xye(y, E);
      O(E, I);
    }
    function S(E) {
      O(E, p.current);
    }
    function N() {
      const E = A.current[p.current];
      y[p.current] !== E && F(y);
    }
    function O(E, I, { commit: R } = { commit: !1 }) {
      const H = fye(s), W = Kye(Math.round((E - i) / s) * s + i, H), B = t7(W, [i, n]);
      b((L = []) => {
        const z = cye(L, B, I);
        if (Yye(z, d * s)) {
          p.current = z.indexOf(B);
          const Z = String(z) !== String(L);
          return Z && R && F(z), Z ? z : L;
        } else
          return L;
      });
    }
    return /* @__PURE__ */ l(
      oye,
      {
        scope: e.__scopeSlider,
        name: t,
        disabled: o,
        min: i,
        max: n,
        valueIndexToChangeRef: p,
        thumbs: f.current,
        values: y,
        orientation: u,
        form: Y,
        children: /* @__PURE__ */ l(c8.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ l(c8.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ l(
          g,
          {
            "aria-disabled": o,
            "data-disabled": o ? "" : void 0,
            ...q,
            ref: r,
            onPointerDown: Ne(q.onPointerDown, () => {
              o || (A.current = y);
            }),
            min: i,
            max: n,
            inverted: X,
            onSlideStart: o ? void 0 : w,
            onSlideMove: o ? void 0 : S,
            onSlideEnd: o ? void 0 : N,
            onHomeKeyDown: () => !o && O(i, 0, { commit: !0 }),
            onEndKeyDown: () => !o && O(n, y.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: E, direction: I }) => {
              if (!o) {
                const W = eG.includes(E.key) || E.shiftKey && rG.includes(E.key) ? 10 : 1, B = p.current, L = y[B], z = s * W * I;
                O(L + z, B, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
nG.displayName = Cl;
var [sG, uG] = iG(Cl, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), dye = h.forwardRef(
  (e, r) => {
    const {
      min: t,
      max: i,
      dir: n,
      inverted: s,
      onSlideStart: u,
      onSlideMove: o,
      onSlideEnd: d,
      onStepKeyDown: a,
      ...V
    } = e, [c, F] = h.useState(null), X = rr(r, (g) => F(g)), Y = h.useRef(), q = Rn(n), f = q === "ltr", p = f && !s || !f && s;
    function m(g) {
      const y = Y.current || c.getBoundingClientRect(), b = [0, y.width], w = cA(b, p ? [t, i] : [i, t]);
      return Y.current = y, w(g - y.left);
    }
    return /* @__PURE__ */ l(
      sG,
      {
        scope: e.__scopeSlider,
        startEdge: p ? "left" : "right",
        endEdge: p ? "right" : "left",
        direction: p ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ l(
          oG,
          {
            dir: q,
            "data-orientation": "horizontal",
            ...V,
            ref: X,
            style: {
              ...V.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (g) => {
              const y = m(g.clientX);
              u == null || u(y);
            },
            onSlideMove: (g) => {
              const y = m(g.clientX);
              o == null || o(y);
            },
            onSlideEnd: () => {
              Y.current = void 0, d == null || d();
            },
            onStepKeyDown: (g) => {
              const b = tG[p ? "from-left" : "from-right"].includes(g.key);
              a == null || a({ event: g, direction: b ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), aye = h.forwardRef(
  (e, r) => {
    const {
      min: t,
      max: i,
      inverted: n,
      onSlideStart: s,
      onSlideMove: u,
      onSlideEnd: o,
      onStepKeyDown: d,
      ...a
    } = e, V = h.useRef(null), c = rr(r, V), F = h.useRef(), X = !n;
    function Y(q) {
      const f = F.current || V.current.getBoundingClientRect(), p = [0, f.height], g = cA(p, X ? [i, t] : [t, i]);
      return F.current = f, g(q - f.top);
    }
    return /* @__PURE__ */ l(
      sG,
      {
        scope: e.__scopeSlider,
        startEdge: X ? "bottom" : "top",
        endEdge: X ? "top" : "bottom",
        size: "height",
        direction: X ? 1 : -1,
        children: /* @__PURE__ */ l(
          oG,
          {
            "data-orientation": "vertical",
            ...a,
            ref: c,
            style: {
              ...a.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (q) => {
              const f = Y(q.clientY);
              s == null || s(f);
            },
            onSlideMove: (q) => {
              const f = Y(q.clientY);
              u == null || u(f);
            },
            onSlideEnd: () => {
              F.current = void 0, o == null || o();
            },
            onStepKeyDown: (q) => {
              const p = tG[X ? "from-bottom" : "from-top"].includes(q.key);
              d == null || d({ event: q, direction: p ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), oG = h.forwardRef(
  (e, r) => {
    const {
      __scopeSlider: t,
      onSlideStart: i,
      onSlideMove: n,
      onSlideEnd: s,
      onHomeKeyDown: u,
      onEndKeyDown: o,
      onStepKeyDown: d,
      ...a
    } = e, V = _Y(Cl, t);
    return /* @__PURE__ */ l(
      Me.span,
      {
        ...a,
        ref: r,
        onKeyDown: Ne(e.onKeyDown, (c) => {
          c.key === "Home" ? (u(c), c.preventDefault()) : c.key === "End" ? (o(c), c.preventDefault()) : eG.concat(rG).includes(c.key) && (d(c), c.preventDefault());
        }),
        onPointerDown: Ne(e.onPointerDown, (c) => {
          const F = c.target;
          F.setPointerCapture(c.pointerId), c.preventDefault(), V.thumbs.has(F) ? F.focus() : i(c);
        }),
        onPointerMove: Ne(e.onPointerMove, (c) => {
          c.target.hasPointerCapture(c.pointerId) && n(c);
        }),
        onPointerUp: Ne(e.onPointerUp, (c) => {
          const F = c.target;
          F.hasPointerCapture(c.pointerId) && (F.releasePointerCapture(c.pointerId), s(c));
        })
      }
    );
  }
), dG = "SliderTrack", aG = h.forwardRef(
  (e, r) => {
    const { __scopeSlider: t, ...i } = e, n = _Y(dG, t);
    return /* @__PURE__ */ l(
      Me.span,
      {
        "data-disabled": n.disabled ? "" : void 0,
        "data-orientation": n.orientation,
        ...i,
        ref: r
      }
    );
  }
);
aG.displayName = dG;
var F8 = "SliderRange", VG = h.forwardRef(
  (e, r) => {
    const { __scopeSlider: t, ...i } = e, n = _Y(F8, t), s = uG(F8, t), u = h.useRef(null), o = rr(r, u), d = n.values.length, a = n.values.map(
      (F) => cG(F, n.min, n.max)
    ), V = d > 1 ? Math.min(...a) : 0, c = 100 - Math.max(...a);
    return /* @__PURE__ */ l(
      Me.span,
      {
        "data-orientation": n.orientation,
        "data-disabled": n.disabled ? "" : void 0,
        ...i,
        ref: o,
        style: {
          ...e.style,
          [s.startEdge]: V + "%",
          [s.endEdge]: c + "%"
        }
      }
    );
  }
);
VG.displayName = F8;
var x8 = "SliderThumb", lG = h.forwardRef(
  (e, r) => {
    const t = sye(e.__scopeSlider), [i, n] = h.useState(null), s = rr(r, (o) => n(o)), u = h.useMemo(
      () => i ? t().findIndex((o) => o.ref.current === i) : -1,
      [t, i]
    );
    return /* @__PURE__ */ l(Vye, { ...e, ref: s, index: u });
  }
), Vye = h.forwardRef(
  (e, r) => {
    const { __scopeSlider: t, index: i, name: n, ...s } = e, u = _Y(x8, t), o = uG(x8, t), [d, a] = h.useState(null), V = rr(r, (m) => a(m)), c = d ? u.form || !!d.closest("form") : !0, F = da(d), X = u.values[i], Y = X === void 0 ? 0 : cG(X, u.min, u.max), q = Fye(i, u.values.length), f = F == null ? void 0 : F[o.size], p = f ? Xye(f, Y, o.direction) : 0;
    return h.useEffect(() => {
      if (d)
        return u.thumbs.add(d), () => {
          u.thumbs.delete(d);
        };
    }, [d, u.thumbs]), /* @__PURE__ */ C(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [o.startEdge]: `calc(${Y}% + ${p}px)`
        },
        children: [
          /* @__PURE__ */ l(c8.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ l(
            Me.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || q,
              "aria-valuemin": u.min,
              "aria-valuenow": X,
              "aria-valuemax": u.max,
              "aria-orientation": u.orientation,
              "data-orientation": u.orientation,
              "data-disabled": u.disabled ? "" : void 0,
              tabIndex: u.disabled ? void 0 : 0,
              ...s,
              ref: V,
              style: X === void 0 ? { display: "none" } : e.style,
              onFocus: Ne(e.onFocus, () => {
                u.valueIndexToChangeRef.current = i;
              })
            }
          ) }),
          c && /* @__PURE__ */ l(
            lye,
            {
              name: n ?? (u.name ? u.name + (u.values.length > 1 ? "[]" : "") : void 0),
              form: u.form,
              value: X
            },
            i
          )
        ]
      }
    );
  }
);
lG.displayName = x8;
var lye = (e) => {
  const { value: r, ...t } = e, i = h.useRef(null), n = Kl(r);
  return h.useEffect(() => {
    const s = i.current, u = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(u, "value").set;
    if (n !== r && d) {
      const a = new Event("input", { bubbles: !0 });
      d.call(s, r), s.dispatchEvent(a);
    }
  }, [n, r]), /* @__PURE__ */ l("input", { style: { display: "none" }, ...t, ref: i, defaultValue: r });
};
function cye(e = [], r, t) {
  const i = [...e];
  return i[t] = r, i.sort((n, s) => n - s);
}
function cG(e, r, t) {
  const s = 100 / (t - r) * (e - r);
  return t7(s, [0, 100]);
}
function Fye(e, r) {
  return r > 2 ? `Value ${e + 1} of ${r}` : r === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function xye(e, r) {
  if (e.length === 1) return 0;
  const t = e.map((n) => Math.abs(n - r)), i = Math.min(...t);
  return t.indexOf(i);
}
function Xye(e, r, t) {
  const i = e / 2, s = cA([0, 50], [0, i]);
  return (i - s(r) * t) * t;
}
function qye(e) {
  return e.slice(0, -1).map((r, t) => e[t + 1] - r);
}
function Yye(e, r) {
  if (r > 0) {
    const t = qye(e);
    return Math.min(...t) >= r;
  }
  return !0;
}
function cA(e, r) {
  return (t) => {
    if (e[0] === e[1] || r[0] === r[1]) return r[0];
    const i = (r[1] - r[0]) / (e[1] - e[0]);
    return r[0] + i * (t - e[0]);
  };
}
function fye(e) {
  return (String(e).split(".")[1] || "").length;
}
function Kye(e, r) {
  const t = Math.pow(10, r);
  return Math.round(e * t) / t;
}
var FG = nG, hye = aG, pye = VG, mye = lG;
const gye = re(({ className: e, ...r }, t) => /* @__PURE__ */ C(
  FG,
  {
    ref: t,
    className: _(
      "relative flex w-full touch-none select-none items-center",
      e
    ),
    ...r,
    children: [
      /* @__PURE__ */ l(hye, { className: "bg-secondary relative h-2 w-full grow overflow-hidden rounded-full", children: /* @__PURE__ */ l(pye, { className: "bg-blueBorder absolute h-full" }) }),
      /* @__PURE__ */ l(mye, { className: "border-primary bg-background ring-offset-background focus-visible:ring-ring block h-5 w-5 rounded-full border-2 transition-colors focus-visible:outline-hidden focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50" })
    ]
  }
));
gye.displayName = FG.displayName;
var FA = "Switch", [vye, xer] = Wo(FA), [bye, yye] = vye(FA), xG = h.forwardRef(
  (e, r) => {
    const {
      __scopeSwitch: t,
      name: i,
      checked: n,
      defaultChecked: s,
      required: u,
      disabled: o,
      value: d = "on",
      onCheckedChange: a,
      ...V
    } = e, [c, F] = h.useState(null), X = rr(r, (m) => F(m)), Y = h.useRef(!1), q = c ? !!c.closest("form") : !0, [f = !1, p] = Gr({
      prop: n,
      defaultProp: s,
      onChange: a
    });
    return /* @__PURE__ */ C(bye, { scope: t, checked: f, disabled: o, children: [
      /* @__PURE__ */ l(
        Me.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": f,
          "aria-required": u,
          "data-state": YG(f),
          "data-disabled": o ? "" : void 0,
          disabled: o,
          value: d,
          ...V,
          ref: X,
          onClick: Ne(e.onClick, (m) => {
            p((g) => !g), q && (Y.current = m.isPropagationStopped(), Y.current || m.stopPropagation());
          })
        }
      ),
      q && /* @__PURE__ */ l(
        Aye,
        {
          control: c,
          bubbles: !Y.current,
          name: i,
          value: d,
          checked: f,
          required: u,
          disabled: o,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
xG.displayName = FA;
var XG = "SwitchThumb", qG = h.forwardRef(
  (e, r) => {
    const { __scopeSwitch: t, ...i } = e, n = yye(XG, t);
    return /* @__PURE__ */ l(
      Me.span,
      {
        "data-state": YG(n.checked),
        "data-disabled": n.disabled ? "" : void 0,
        ...i,
        ref: r
      }
    );
  }
);
qG.displayName = XG;
var Aye = (e) => {
  const { control: r, checked: t, bubbles: i = !0, ...n } = e, s = h.useRef(null), u = Kl(t), o = da(r);
  return h.useEffect(() => {
    const d = s.current, a = window.HTMLInputElement.prototype, c = Object.getOwnPropertyDescriptor(a, "checked").set;
    if (u !== t && c) {
      const F = new Event("click", { bubbles: i });
      c.call(d, t), d.dispatchEvent(F);
    }
  }, [u, t, i]), /* @__PURE__ */ l(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: t,
      ...n,
      tabIndex: -1,
      ref: s,
      style: {
        ...e.style,
        ...o,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function YG(e) {
  return e ? "checked" : "unchecked";
}
var fG = xG, wye = qG;
const b2 = re(({ className: e, thumbClassName: r, ...t }, i) => /* @__PURE__ */ l(
  fG,
  {
    className: _(
      "bg-interfaceBgDefault data-[state=checked]:bg-actionDefault focus-visible:ring-ring focus-visible:ring-offset-background data-[state=unchecked]:bg-input inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 peer",
      e
    ),
    ...t,
    ref: i,
    children: /* @__PURE__ */ l(
      wye,
      {
        className: _(
          "bg-interfaceWhite pointer-events-none block h-5 w-5 rounded-full shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0",
          r
        )
      }
    )
  }
));
b2.displayName = fG.displayName;
function Cye({ children: e, className: r }) {
  return /* @__PURE__ */ l(
    "div",
    {
      className: _(
        "flex items-center text-bodysm w-min whitespace-nowrap rounded-xl border px-2",
        r
      ),
      children: e
    }
  );
}
function Pye({
  className: e,
  iconClassName: r,
  itemClassName: t,
  items: i,
  onClick: n,
  selectedId: s
}) {
  return /* @__PURE__ */ l("div", { className: _("flex flex-col", e), children: i.map((u, o) => {
    const d = o === i.length - 1;
    return /* @__PURE__ */ C(
      "div",
      {
        className: _(
          "data-[selected=true]:bg-blueBgSelect flex cursor-pointer gap-2 data-[selected=true]:rounded-lg",
          t
        ),
        "data-selected": s ? s === u.id : void 0,
        onClick: () => n == null ? void 0 : n(u.id || ""),
        children: [
          /* @__PURE__ */ C("div", { className: "flex flex-col items-center", children: [
            /* @__PURE__ */ l("div", { className: "flex min-h-[20px] items-center", children: /* @__PURE__ */ l(
              "div",
              {
                className: _(
                  "bg-blueDefault data-[disabled=true]:bg-blueDisabled text-textWhite flex h-4 w-4 items-center justify-center rounded-full",
                  r
                ),
                "data-disabled": u.disabled,
                "data-selected": s ? s === u.id : void 0,
                children: u.icon
              }
            ) }),
            /* @__PURE__ */ l(
              "div",
              {
                className: _(
                  "bg-blueDefault data-[disabled=true]:bg-blueDisabled h-full w-[2px]",
                  d && "hidden"
                ),
                "data-disabled": u.disabled
              }
            )
          ] }),
          /* @__PURE__ */ C("div", { children: [
            /* @__PURE__ */ l("div", { className: "text-headingsm text-textPrimary", children: u.title }),
            /* @__PURE__ */ l(
              "p",
              {
                className: _(
                  "text-bodymd text-textPrimary data-[disabled=true]:text-textSubdued",
                  (s !== void 0 || !d) && "mb-2"
                ),
                "data-disabled": u.disabled,
                children: u.content
              }
            )
          ] })
        ]
      },
      o
    );
  }) });
}
var xA = "Tabs", [Sye, Xer] = Wo(xA, [
  MY
]), KG = MY(), [Nye, XA] = Sye(xA), hG = h.forwardRef(
  (e, r) => {
    const {
      __scopeTabs: t,
      value: i,
      onValueChange: n,
      defaultValue: s,
      orientation: u = "horizontal",
      dir: o,
      activationMode: d = "automatic",
      ...a
    } = e, V = Rn(o), [c, F] = Gr({
      prop: i,
      onChange: n,
      defaultProp: s
    });
    return /* @__PURE__ */ l(
      Nye,
      {
        scope: t,
        baseId: ot(),
        value: c,
        onValueChange: F,
        orientation: u,
        dir: V,
        activationMode: d,
        children: /* @__PURE__ */ l(
          Me.div,
          {
            dir: V,
            "data-orientation": u,
            ...a,
            ref: r
          }
        )
      }
    );
  }
);
hG.displayName = xA;
var pG = "TabsList", mG = h.forwardRef(
  (e, r) => {
    const { __scopeTabs: t, loop: i = !0, ...n } = e, s = XA(pG, t), u = KG(t);
    return /* @__PURE__ */ l(
      xz,
      {
        asChild: !0,
        ...u,
        orientation: s.orientation,
        dir: s.dir,
        loop: i,
        children: /* @__PURE__ */ l(
          Me.div,
          {
            role: "tablist",
            "aria-orientation": s.orientation,
            ...n,
            ref: r
          }
        )
      }
    );
  }
);
mG.displayName = pG;
var gG = "TabsTrigger", vG = h.forwardRef(
  (e, r) => {
    const { __scopeTabs: t, value: i, disabled: n = !1, ...s } = e, u = XA(gG, t), o = KG(t), d = AG(u.baseId, i), a = wG(u.baseId, i), V = i === u.value;
    return /* @__PURE__ */ l(
      Xz,
      {
        asChild: !0,
        ...o,
        focusable: !n,
        active: V,
        children: /* @__PURE__ */ l(
          Me.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": V,
            "aria-controls": a,
            "data-state": V ? "active" : "inactive",
            "data-disabled": n ? "" : void 0,
            disabled: n,
            id: d,
            ...s,
            ref: r,
            onMouseDown: Ne(e.onMouseDown, (c) => {
              !n && c.button === 0 && c.ctrlKey === !1 ? u.onValueChange(i) : c.preventDefault();
            }),
            onKeyDown: Ne(e.onKeyDown, (c) => {
              [" ", "Enter"].includes(c.key) && u.onValueChange(i);
            }),
            onFocus: Ne(e.onFocus, () => {
              const c = u.activationMode !== "manual";
              !V && !n && c && u.onValueChange(i);
            })
          }
        )
      }
    );
  }
);
vG.displayName = gG;
var bG = "TabsContent", yG = h.forwardRef(
  (e, r) => {
    const { __scopeTabs: t, value: i, forceMount: n, children: s, ...u } = e, o = XA(bG, t), d = AG(o.baseId, i), a = wG(o.baseId, i), V = i === o.value, c = h.useRef(V);
    return h.useEffect(() => {
      const F = requestAnimationFrame(() => c.current = !1);
      return () => cancelAnimationFrame(F);
    }, []), /* @__PURE__ */ l(Hq, { present: n || V, children: ({ present: F }) => /* @__PURE__ */ l(
      Me.div,
      {
        "data-state": V ? "active" : "inactive",
        "data-orientation": o.orientation,
        role: "tabpanel",
        "aria-labelledby": d,
        hidden: !F,
        id: a,
        tabIndex: 0,
        ...u,
        ref: r,
        style: {
          ...e.style,
          animationDuration: c.current ? "0s" : void 0
        },
        children: F && s
      }
    ) });
  }
);
yG.displayName = bG;
function AG(e, r) {
  return `${e}-trigger-${r}`;
}
function wG(e, r) {
  return `${e}-content-${r}`;
}
var Mye = hG, CG = mG, PG = vG, SG = yG;
const vu = Mye, Ms = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  CG,
  {
    ref: t,
    className: _("inline-flex items-center justify-center", e),
    ...r
  }
));
Ms.displayName = CG.displayName;
const Rt = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  PG,
  {
    ref: t,
    className: _(
      "data-[state=active]:bg-background data-[state=active]:border-b-3 inline-flex items-center justify-center whitespace-nowrap border-b border-[#E3E2E1] py-3 text-bodymd font-semibold text-[#7D7C78] transition-all disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-[#0060EA] data-[state=active]:text-black",
      e
    ),
    ...r
  }
));
Rt.displayName = PG.displayName;
const St = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  SG,
  {
    ref: t,
    className: _(
      "ring-offset-background focus-visible:ring-ring focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2",
      e
    ),
    ...r
  }
));
St.displayName = SG.displayName;
const Tye = re(
  ({ className: e, ...r }, t) => /* @__PURE__ */ l(
    "textarea",
    {
      className: _(
        "border-input bg-background ring-offset-background placeholder:text-[1rem] placeholder:leading-[1.25rem] placeholder:text-muted-foreground focus-visible:ring-ring flex min-h-[80px] w-full rounded-md border px-3 py-2 text-[1rem] leading-[1.25rem] focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: t,
      ...r
    }
  )
);
Tye.displayName = "Textarea";
var Eye = "DismissableLayer", X8 = "dismissableLayer.update", kye = "dismissableLayer.pointerDownOutside", Oye = "dismissableLayer.focusOutside", eP, NG = h.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), MG = h.forwardRef(
  (e, r) => {
    const {
      disableOutsidePointerEvents: t = !1,
      onEscapeKeyDown: i,
      onPointerDownOutside: n,
      onFocusOutside: s,
      onInteractOutside: u,
      onDismiss: o,
      ...d
    } = e, a = h.useContext(NG), [V, c] = h.useState(null), F = (V == null ? void 0 : V.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, X] = h.useState({}), Y = rr(r, (w) => c(w)), q = Array.from(a.layers), [f] = [...a.layersWithOutsidePointerEventsDisabled].slice(-1), p = q.indexOf(f), m = V ? q.indexOf(V) : -1, g = a.layersWithOutsidePointerEventsDisabled.size > 0, y = m >= p, b = Rye((w) => {
      const S = w.target, N = [...a.branches].some((O) => O.contains(S));
      !y || N || (n == null || n(w), u == null || u(w), w.defaultPrevented || o == null || o());
    }, F), A = Iye((w) => {
      const S = w.target;
      [...a.branches].some((O) => O.contains(S)) || (s == null || s(w), u == null || u(w), w.defaultPrevented || o == null || o());
    }, F);
    return oa((w) => {
      m === a.layers.size - 1 && (i == null || i(w), !w.defaultPrevented && o && (w.preventDefault(), o()));
    }, F), h.useEffect(() => {
      if (V)
        return t && (a.layersWithOutsidePointerEventsDisabled.size === 0 && (eP = F.body.style.pointerEvents, F.body.style.pointerEvents = "none"), a.layersWithOutsidePointerEventsDisabled.add(V)), a.layers.add(V), rP(), () => {
          t && a.layersWithOutsidePointerEventsDisabled.size === 1 && (F.body.style.pointerEvents = eP);
        };
    }, [V, F, t, a]), h.useEffect(() => () => {
      V && (a.layers.delete(V), a.layersWithOutsidePointerEventsDisabled.delete(V), rP());
    }, [V, a]), h.useEffect(() => {
      const w = () => X({});
      return document.addEventListener(X8, w), () => document.removeEventListener(X8, w);
    }, []), /* @__PURE__ */ l(
      Me.div,
      {
        ...d,
        ref: Y,
        style: {
          pointerEvents: g ? y ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Ne(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: Ne(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: Ne(
          e.onPointerDownCapture,
          b.onPointerDownCapture
        )
      }
    );
  }
);
MG.displayName = Eye;
var Dye = "DismissableLayerBranch", TG = h.forwardRef((e, r) => {
  const t = h.useContext(NG), i = h.useRef(null), n = rr(r, i);
  return h.useEffect(() => {
    const s = i.current;
    if (s)
      return t.branches.add(s), () => {
        t.branches.delete(s);
      };
  }, [t.branches]), /* @__PURE__ */ l(Me.div, { ...e, ref: n });
});
TG.displayName = Dye;
function Rye(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Ee(e), i = h.useRef(!1), n = h.useRef(() => {
  });
  return h.useEffect(() => {
    const s = (o) => {
      if (o.target && !i.current) {
        let d = function() {
          EG(
            kye,
            t,
            a,
            { discrete: !0 }
          );
        };
        const a = { originalEvent: o };
        o.pointerType === "touch" ? (r.removeEventListener("click", n.current), n.current = d, r.addEventListener("click", n.current, { once: !0 })) : d();
      } else
        r.removeEventListener("click", n.current);
      i.current = !1;
    }, u = window.setTimeout(() => {
      r.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(u), r.removeEventListener("pointerdown", s), r.removeEventListener("click", n.current);
    };
  }, [r, t]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => i.current = !0
  };
}
function Iye(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = Ee(e), i = h.useRef(!1);
  return h.useEffect(() => {
    const n = (s) => {
      s.target && !i.current && EG(Oye, t, { originalEvent: s }, {
        discrete: !1
      });
    };
    return r.addEventListener("focusin", n), () => r.removeEventListener("focusin", n);
  }, [r, t]), {
    onFocusCapture: () => i.current = !0,
    onBlurCapture: () => i.current = !1
  };
}
function rP() {
  const e = new CustomEvent(X8);
  document.dispatchEvent(e);
}
function EG(e, r, t, { discrete: i }) {
  const n = t.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: t });
  r && n.addEventListener(e, r, { once: !0 }), i ? _q(n, s) : n.dispatchEvent(s);
}
var Lye = MG, _ye = TG, Hye = "Portal", kG = h.forwardRef((e, r) => {
  var o;
  const { container: t, ...i } = e, [n, s] = h.useState(!1);
  ze(() => s(!0), []);
  const u = t || n && ((o = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : o.body);
  return u ? Us.createPortal(/* @__PURE__ */ l(Me.div, { ...i, ref: r }), u) : null;
});
kG.displayName = Hye;
var jye = "VisuallyHidden", qA = h.forwardRef(
  (e, r) => /* @__PURE__ */ l(
    Me.span,
    {
      ...e,
      ref: r,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
qA.displayName = jye;
var YA = "ToastProvider", [fA, zye, Bye] = Lq("Toast"), [OG, qer] = Wo("Toast", [Bye]), [Wye, HY] = OG(YA), DG = (e) => {
  const {
    __scopeToast: r,
    label: t = "Notification",
    duration: i = 5e3,
    swipeDirection: n = "right",
    swipeThreshold: s = 50,
    children: u
  } = e, [o, d] = h.useState(null), [a, V] = h.useState(0), c = h.useRef(!1), F = h.useRef(!1);
  return t.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${YA}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ l(fA.Provider, { scope: r, children: /* @__PURE__ */ l(
    Wye,
    {
      scope: r,
      label: t,
      duration: i,
      swipeDirection: n,
      swipeThreshold: s,
      toastCount: a,
      viewport: o,
      onViewportChange: d,
      onToastAdd: h.useCallback(() => V((X) => X + 1), []),
      onToastRemove: h.useCallback(() => V((X) => X - 1), []),
      isFocusedToastEscapeKeyDownRef: c,
      isClosePausedRef: F,
      children: u
    }
  ) });
};
DG.displayName = YA;
var RG = "ToastViewport", Gye = ["F8"], q8 = "toast.viewportPause", Y8 = "toast.viewportResume", IG = h.forwardRef(
  (e, r) => {
    const {
      __scopeToast: t,
      hotkey: i = Gye,
      label: n = "Notifications ({hotkey})",
      ...s
    } = e, u = HY(RG, t), o = zye(t), d = h.useRef(null), a = h.useRef(null), V = h.useRef(null), c = h.useRef(null), F = rr(r, c, u.onViewportChange), X = i.join("+").replace(/Key/g, "").replace(/Digit/g, ""), Y = u.toastCount > 0;
    h.useEffect(() => {
      const f = (p) => {
        var g;
        i.every((y) => p[y] || p.code === y) && ((g = c.current) == null || g.focus());
      };
      return document.addEventListener("keydown", f), () => document.removeEventListener("keydown", f);
    }, [i]), h.useEffect(() => {
      const f = d.current, p = c.current;
      if (Y && f && p) {
        const m = () => {
          if (!u.isClosePausedRef.current) {
            const A = new CustomEvent(q8);
            p.dispatchEvent(A), u.isClosePausedRef.current = !0;
          }
        }, g = () => {
          if (u.isClosePausedRef.current) {
            const A = new CustomEvent(Y8);
            p.dispatchEvent(A), u.isClosePausedRef.current = !1;
          }
        }, y = (A) => {
          !f.contains(A.relatedTarget) && g();
        }, b = () => {
          f.contains(document.activeElement) || g();
        };
        return f.addEventListener("focusin", m), f.addEventListener("focusout", y), f.addEventListener("pointermove", m), f.addEventListener("pointerleave", b), window.addEventListener("blur", m), window.addEventListener("focus", g), () => {
          f.removeEventListener("focusin", m), f.removeEventListener("focusout", y), f.removeEventListener("pointermove", m), f.removeEventListener("pointerleave", b), window.removeEventListener("blur", m), window.removeEventListener("focus", g);
        };
      }
    }, [Y, u.isClosePausedRef]);
    const q = h.useCallback(
      ({ tabbingDirection: f }) => {
        const m = o().map((g) => {
          const y = g.ref.current, b = [y, ...o3e(y)];
          return f === "forwards" ? b : b.reverse();
        });
        return (f === "forwards" ? m.reverse() : m).flat();
      },
      [o]
    );
    return h.useEffect(() => {
      const f = c.current;
      if (f) {
        const p = (m) => {
          var b, A, w;
          const g = m.altKey || m.ctrlKey || m.metaKey;
          if (m.key === "Tab" && !g) {
            const S = document.activeElement, N = m.shiftKey;
            if (m.target === f && N) {
              (b = a.current) == null || b.focus();
              return;
            }
            const I = q({ tabbingDirection: N ? "backwards" : "forwards" }), R = I.findIndex((H) => H === S);
            Kp(I.slice(R + 1)) ? m.preventDefault() : N ? (A = a.current) == null || A.focus() : (w = V.current) == null || w.focus();
          }
        };
        return f.addEventListener("keydown", p), () => f.removeEventListener("keydown", p);
      }
    }, [o, q]), /* @__PURE__ */ C(
      _ye,
      {
        ref: d,
        role: "region",
        "aria-label": n.replace("{hotkey}", X),
        tabIndex: -1,
        style: { pointerEvents: Y ? void 0 : "none" },
        children: [
          Y && /* @__PURE__ */ l(
            f8,
            {
              ref: a,
              onFocusFromOutsideViewport: () => {
                const f = q({
                  tabbingDirection: "forwards"
                });
                Kp(f);
              }
            }
          ),
          /* @__PURE__ */ l(fA.Slot, { scope: t, children: /* @__PURE__ */ l(Me.ol, { tabIndex: -1, ...s, ref: F }) }),
          Y && /* @__PURE__ */ l(
            f8,
            {
              ref: V,
              onFocusFromOutsideViewport: () => {
                const f = q({
                  tabbingDirection: "backwards"
                });
                Kp(f);
              }
            }
          )
        ]
      }
    );
  }
);
IG.displayName = RG;
var LG = "ToastFocusProxy", f8 = h.forwardRef(
  (e, r) => {
    const { __scopeToast: t, onFocusFromOutsideViewport: i, ...n } = e, s = HY(LG, t);
    return /* @__PURE__ */ l(
      qA,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...n,
        ref: r,
        style: { position: "fixed" },
        onFocus: (u) => {
          var a;
          const o = u.relatedTarget;
          !((a = s.viewport) != null && a.contains(o)) && i();
        }
      }
    );
  }
);
f8.displayName = LG;
var jY = "Toast", Uye = "toast.swipeStart", Zye = "toast.swipeMove", Jye = "toast.swipeCancel", $ye = "toast.swipeEnd", _G = h.forwardRef(
  (e, r) => {
    const { forceMount: t, open: i, defaultOpen: n, onOpenChange: s, ...u } = e, [o = !0, d] = Gr({
      prop: i,
      defaultProp: n,
      onChange: s
    });
    return /* @__PURE__ */ l(Hq, { present: t || o, children: /* @__PURE__ */ l(
      r3e,
      {
        open: o,
        ...u,
        ref: r,
        onClose: () => d(!1),
        onPause: Ee(e.onPause),
        onResume: Ee(e.onResume),
        onSwipeStart: Ne(e.onSwipeStart, (a) => {
          a.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: Ne(e.onSwipeMove, (a) => {
          const { x: V, y: c } = a.detail.delta;
          a.currentTarget.setAttribute("data-swipe", "move"), a.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${V}px`), a.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${c}px`);
        }),
        onSwipeCancel: Ne(e.onSwipeCancel, (a) => {
          a.currentTarget.setAttribute("data-swipe", "cancel"), a.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), a.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), a.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), a.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: Ne(e.onSwipeEnd, (a) => {
          const { x: V, y: c } = a.detail.delta;
          a.currentTarget.setAttribute("data-swipe", "end"), a.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), a.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), a.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${V}px`), a.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${c}px`), d(!1);
        })
      }
    ) });
  }
);
_G.displayName = jY;
var [Qye, e3e] = OG(jY, {
  onClose() {
  }
}), r3e = h.forwardRef(
  (e, r) => {
    const {
      __scopeToast: t,
      type: i = "foreground",
      duration: n,
      open: s,
      onClose: u,
      onEscapeKeyDown: o,
      onPause: d,
      onResume: a,
      onSwipeStart: V,
      onSwipeMove: c,
      onSwipeCancel: F,
      onSwipeEnd: X,
      ...Y
    } = e, q = HY(jY, t), [f, p] = h.useState(null), m = rr(r, (H) => p(H)), g = h.useRef(null), y = h.useRef(null), b = n || q.duration, A = h.useRef(0), w = h.useRef(b), S = h.useRef(0), { onToastAdd: N, onToastRemove: O } = q, E = Ee(() => {
      var W;
      (f == null ? void 0 : f.contains(document.activeElement)) && ((W = q.viewport) == null || W.focus()), u();
    }), I = h.useCallback(
      (H) => {
        !H || H === 1 / 0 || (window.clearTimeout(S.current), A.current = (/* @__PURE__ */ new Date()).getTime(), S.current = window.setTimeout(E, H));
      },
      [E]
    );
    h.useEffect(() => {
      const H = q.viewport;
      if (H) {
        const W = () => {
          I(w.current), a == null || a();
        }, B = () => {
          const L = (/* @__PURE__ */ new Date()).getTime() - A.current;
          w.current = w.current - L, window.clearTimeout(S.current), d == null || d();
        };
        return H.addEventListener(q8, B), H.addEventListener(Y8, W), () => {
          H.removeEventListener(q8, B), H.removeEventListener(Y8, W);
        };
      }
    }, [q.viewport, b, d, a, I]), h.useEffect(() => {
      s && !q.isClosePausedRef.current && I(b);
    }, [s, b, q.isClosePausedRef, I]), h.useEffect(() => (N(), () => O()), [N, O]);
    const R = h.useMemo(() => f ? UG(f) : null, [f]);
    return q.viewport ? /* @__PURE__ */ C(he, { children: [
      R && /* @__PURE__ */ l(
        t3e,
        {
          __scopeToast: t,
          role: "status",
          "aria-live": i === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: R
        }
      ),
      /* @__PURE__ */ l(Qye, { scope: t, onClose: E, children: qs.createPortal(
        /* @__PURE__ */ l(fA.ItemSlot, { scope: t, children: /* @__PURE__ */ l(
          Lye,
          {
            asChild: !0,
            onEscapeKeyDown: Ne(o, () => {
              q.isFocusedToastEscapeKeyDownRef.current || E(), q.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ l(
              Me.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": s ? "open" : "closed",
                "data-swipe-direction": q.swipeDirection,
                ...Y,
                ref: m,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: Ne(e.onKeyDown, (H) => {
                  H.key === "Escape" && (o == null || o(H.nativeEvent), H.nativeEvent.defaultPrevented || (q.isFocusedToastEscapeKeyDownRef.current = !0, E()));
                }),
                onPointerDown: Ne(e.onPointerDown, (H) => {
                  H.button === 0 && (g.current = { x: H.clientX, y: H.clientY });
                }),
                onPointerMove: Ne(e.onPointerMove, (H) => {
                  if (!g.current) return;
                  const W = H.clientX - g.current.x, B = H.clientY - g.current.y, L = !!y.current, z = ["left", "right"].includes(q.swipeDirection), Z = ["left", "up"].includes(q.swipeDirection) ? Math.min : Math.max, le = z ? Z(0, W) : 0, te = z ? 0 : Z(0, B), U = H.pointerType === "touch" ? 10 : 2, de = { x: le, y: te }, Ke = { originalEvent: H, delta: de };
                  L ? (y.current = de, ox(Zye, c, Ke, {
                    discrete: !1
                  })) : tP(de, q.swipeDirection, U) ? (y.current = de, ox(Uye, V, Ke, {
                    discrete: !1
                  }), H.target.setPointerCapture(H.pointerId)) : (Math.abs(W) > U || Math.abs(B) > U) && (g.current = null);
                }),
                onPointerUp: Ne(e.onPointerUp, (H) => {
                  const W = y.current, B = H.target;
                  if (B.hasPointerCapture(H.pointerId) && B.releasePointerCapture(H.pointerId), y.current = null, g.current = null, W) {
                    const L = H.currentTarget, z = { originalEvent: H, delta: W };
                    tP(W, q.swipeDirection, q.swipeThreshold) ? ox($ye, X, z, {
                      discrete: !0
                    }) : ox(
                      Jye,
                      F,
                      z,
                      {
                        discrete: !0
                      }
                    ), L.addEventListener("click", (Z) => Z.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        q.viewport
      ) })
    ] }) : null;
  }
), t3e = (e) => {
  const { __scopeToast: r, children: t, ...i } = e, n = HY(jY, r), [s, u] = h.useState(!1), [o, d] = h.useState(!1);
  return s3e(() => u(!0)), h.useEffect(() => {
    const a = window.setTimeout(() => d(!0), 1e3);
    return () => window.clearTimeout(a);
  }, []), o ? null : /* @__PURE__ */ l(kG, { asChild: !0, children: /* @__PURE__ */ l(qA, { ...i, children: s && /* @__PURE__ */ C(he, { children: [
    n.label,
    " ",
    t
  ] }) }) });
}, i3e = "ToastTitle", HG = h.forwardRef(
  (e, r) => {
    const { __scopeToast: t, ...i } = e;
    return /* @__PURE__ */ l(Me.div, { ...i, ref: r });
  }
);
HG.displayName = i3e;
var n3e = "ToastDescription", jG = h.forwardRef(
  (e, r) => {
    const { __scopeToast: t, ...i } = e;
    return /* @__PURE__ */ l(Me.div, { ...i, ref: r });
  }
);
jG.displayName = n3e;
var zG = "ToastAction", BG = h.forwardRef(
  (e, r) => {
    const { altText: t, ...i } = e;
    return t.trim() ? /* @__PURE__ */ l(GG, { altText: t, asChild: !0, children: /* @__PURE__ */ l(KA, { ...i, ref: r }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${zG}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
BG.displayName = zG;
var WG = "ToastClose", KA = h.forwardRef(
  (e, r) => {
    const { __scopeToast: t, ...i } = e, n = e3e(WG, t);
    return /* @__PURE__ */ l(GG, { asChild: !0, children: /* @__PURE__ */ l(
      Me.button,
      {
        type: "button",
        ...i,
        ref: r,
        onClick: Ne(e.onClick, n.onClose)
      }
    ) });
  }
);
KA.displayName = WG;
var GG = h.forwardRef((e, r) => {
  const { __scopeToast: t, altText: i, ...n } = e;
  return /* @__PURE__ */ l(
    Me.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": i || void 0,
      ...n,
      ref: r
    }
  );
});
function UG(e) {
  const r = [];
  return Array.from(e.childNodes).forEach((i) => {
    if (i.nodeType === i.TEXT_NODE && i.textContent && r.push(i.textContent), u3e(i)) {
      const n = i.ariaHidden || i.hidden || i.style.display === "none", s = i.dataset.radixToastAnnounceExclude === "";
      if (!n)
        if (s) {
          const u = i.dataset.radixToastAnnounceAlt;
          u && r.push(u);
        } else
          r.push(...UG(i));
    }
  }), r;
}
function ox(e, r, t, { discrete: i }) {
  const n = t.originalEvent.currentTarget, s = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: t });
  r && n.addEventListener(e, r, { once: !0 }), i ? _q(n, s) : n.dispatchEvent(s);
}
var tP = (e, r, t = 0) => {
  const i = Math.abs(e.x), n = Math.abs(e.y), s = i > n;
  return r === "left" || r === "right" ? s && i > t : !s && n > t;
};
function s3e(e = () => {
}) {
  const r = Ee(e);
  ze(() => {
    let t = 0, i = 0;
    return t = window.requestAnimationFrame(() => i = window.requestAnimationFrame(r)), () => {
      window.cancelAnimationFrame(t), window.cancelAnimationFrame(i);
    };
  }, [r]);
}
function u3e(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function o3e(e) {
  const r = [], t = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (i) => {
      const n = i.tagName === "INPUT" && i.type === "hidden";
      return i.disabled || i.hidden || n ? NodeFilter.FILTER_SKIP : i.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); ) r.push(t.currentNode);
  return r;
}
function Kp(e) {
  const r = document.activeElement;
  return e.some((t) => t === r ? !0 : (t.focus(), document.activeElement !== r));
}
var d3e = DG, ZG = IG, JG = _G, $G = HG, QG = jG, eU = BG, rU = KA;
const a3e = d3e, tU = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  ZG,
  {
    ref: t,
    className: _(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      e
    ),
    ...r
  }
));
tU.displayName = ZG.displayName;
const V3e = Js(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), iU = re(({ className: e, variant: r, ...t }, i) => /* @__PURE__ */ l(
  JG,
  {
    ref: i,
    className: _(V3e({ variant: r }), e),
    ...t
  }
));
iU.displayName = JG.displayName;
const l3e = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  eU,
  {
    ref: t,
    className: _(
      "ring-offset-background hover:bg-secondary focus:ring-ring group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-bodysm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      e
    ),
    ...r
  }
));
l3e.displayName = eU.displayName;
const nU = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  rU,
  {
    ref: t,
    className: _(
      "text-foreground/50 hover:text-foreground absolute right-2 top-2 rounded-md p-1 opacity-0 transition-opacity focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...r,
    children: /* @__PURE__ */ l(r2, { className: "h-4 w-4" })
  }
));
nU.displayName = rU.displayName;
const sU = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  $G,
  {
    ref: t,
    className: _("text-bodysm font-semibold", e),
    ...r
  }
));
sU.displayName = $G.displayName;
const uU = re(({ className: e, ...r }, t) => /* @__PURE__ */ l(
  QG,
  {
    ref: t,
    className: _("text-bodysm opacity-90", e),
    ...r
  }
));
uU.displayName = QG.displayName;
const c3e = 1, F3e = 15e5;
let hp = 0;
function x3e() {
  return hp = (hp + 1) % Number.MAX_VALUE, hp.toString();
}
const pp = /* @__PURE__ */ new Map(), iP = (e) => {
  if (pp.has(e))
    return;
  const r = setTimeout(() => {
    pp.delete(e), Oc({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, F3e);
  pp.set(e, r);
}, X3e = (e, r) => {
  switch (r.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [r.toast, ...e.toasts].slice(0, c3e)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map(
          (t) => t.id === r.toast.id ? { ...t, ...r.toast } : t
        )
      };
    case "DISMISS_TOAST": {
      const { toastId: t } = r;
      return t ? iP(t) : e.toasts.forEach((i) => {
        iP(i.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (i) => i.id === t || t === void 0 ? {
            ...i,
            open: !1
          } : i
        )
      };
    }
    case "REMOVE_TOAST":
      return r.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((t) => t.id !== r.toastId)
      };
  }
}, Hx = [];
let jx = { toasts: [] };
function Oc(e) {
  jx = X3e(jx, e), Hx.forEach((r) => {
    r(jx);
  });
}
function q3e({ ...e }) {
  const r = x3e(), t = (n) => Oc({
    type: "UPDATE_TOAST",
    toast: { ...n, id: r }
  }), i = () => Oc({ type: "DISMISS_TOAST", toastId: r });
  return Oc({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: r,
      open: !0,
      onOpenChange: (n) => {
        n || i();
      }
    }
  }), {
    id: r,
    dismiss: i,
    update: t
  };
}
function oU() {
  const [e, r] = ie(jx);
  return Pe(() => (Hx.push(r), () => {
    const t = Hx.indexOf(r);
    t > -1 && Hx.splice(t, 1);
  }), [e]), {
    ...e,
    toast: q3e,
    dismiss: (t) => Oc({ type: "DISMISS_TOAST", toastId: t })
  };
}
function Yer() {
  const { toasts: e } = oU();
  return /* @__PURE__ */ C(a3e, { children: [
    e.map(function({ id: r, title: t, description: i, action: n, ...s }) {
      return /* @__PURE__ */ C(iU, { ...s, children: [
        /* @__PURE__ */ C("div", { className: "grid gap-1", children: [
          t && /* @__PURE__ */ l(sU, { children: t }),
          i && /* @__PURE__ */ l(uU, { children: i })
        ] }),
        n,
        /* @__PURE__ */ l(nU, {})
      ] }, r);
    }),
    /* @__PURE__ */ l(tU, {})
  ] });
}
var Y3e = "Toggle", dU = h.forwardRef((e, r) => {
  const { pressed: t, defaultPressed: i = !1, onPressedChange: n, ...s } = e, [u = !1, o] = Gr({
    prop: t,
    onChange: n,
    defaultProp: i
  });
  return /* @__PURE__ */ l(
    Me.button,
    {
      type: "button",
      "aria-pressed": u,
      "data-state": u ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...s,
      ref: r,
      onClick: Ne(e.onClick, () => {
        e.disabled || o(!u);
      })
    }
  );
});
dU.displayName = Y3e;
var aU = dU;
const f3e = Js(
  "inline-flex items-center justify-center gap-1 rounded-lg text-textSubdued text-bodymd data-[state=on]:bg-textLink data-[state=on]:text-textWhite transition-colors hover:bg-interactiveBgHover focus-visible:outline-hidden data-[state=off]:focus-visible:!bg-interfaceWhite focus-visible:shadow-[0_0_2px_2px_rgba(1,87,255,0.75)] disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border-2 border-blueDisabled bg-transparent data-[state=on]:bg-textLink data-[state=on]:text-textWhite hover:border-blueDefault disabled:border-interactiveBorder data-[state=on]:border-textLink",
        rounded: "border-2 border-blueDisabled bg-transparent data-[state=on]:bg-textLink data-[state=on]:text-textWhite hover:border-blueDefault disabled:border-interactiveBorder data-[state=on]:border-textLink !rounded-[44px]"
      },
      size: {
        default: "h-auto px-2.5 py-1",
        sm: "h-9 px-1",
        lg: "h-11 px-5"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), K3e = re(
  ({ children: e, className: r, disabled: t, pressed: i, size: n, variant: s, ...u }, o) => /* @__PURE__ */ C(
    aU,
    {
      className: _(f3e({ variant: s, size: n, className: r })),
      disabled: t,
      pressed: i,
      ref: o,
      ...u,
      children: [
        i ? /* @__PURE__ */ l(uVe, { className: "fill-interfaceWhite stroke-textLink h-4 w-4" }) : /* @__PURE__ */ l(
          Gc,
          {
            className: _(
              "text-textLink h-4 w-4",
              t ? "text-textSubdued" : ""
            )
          }
        ),
        e
      ]
    }
  )
);
K3e.displayName = aU.displayName;
function mu(e, r, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), t === !1 || !n.defaultPrevented)
      return r == null ? void 0 : r(n);
  };
}
function nP(e, r) {
  if (typeof e == "function")
    return e(r);
  e != null && (e.current = r);
}
function VU(...e) {
  return (r) => {
    let t = !1;
    const i = e.map((n) => {
      const s = nP(n, r);
      return !t && typeof s == "function" && (t = !0), s;
    });
    if (t)
      return () => {
        for (let n = 0; n < i.length; n++) {
          const s = i[n];
          typeof s == "function" ? s() : nP(e[n], null);
        }
      };
  };
}
function la(...e) {
  return h.useCallback(VU(...e), e);
}
function lU(e, r = []) {
  let t = [];
  function i(s, u) {
    const o = h.createContext(u), d = t.length;
    t = [...t, u];
    const a = (c) => {
      var p;
      const { scope: F, children: X, ...Y } = c, q = ((p = F == null ? void 0 : F[e]) == null ? void 0 : p[d]) || o, f = h.useMemo(() => Y, Object.values(Y));
      return /* @__PURE__ */ l(q.Provider, { value: f, children: X });
    };
    a.displayName = s + "Provider";
    function V(c, F) {
      var q;
      const X = ((q = F == null ? void 0 : F[e]) == null ? void 0 : q[d]) || o, Y = h.useContext(X);
      if (Y) return Y;
      if (u !== void 0) return u;
      throw new Error(`\`${c}\` must be used within \`${s}\``);
    }
    return [a, V];
  }
  const n = () => {
    const s = t.map((u) => h.createContext(u));
    return function(o) {
      const d = (o == null ? void 0 : o[e]) || s;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: d } }),
        [o, d]
      );
    };
  };
  return n.scopeName = e, [i, h3e(n, ...r)];
}
function h3e(...e) {
  const r = e[0];
  if (e.length === 1) return r;
  const t = () => {
    const i = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(s) {
      const u = i.reduce((o, { useScope: d, scopeName: a }) => {
        const c = d(s)[`__scope${a}`];
        return { ...o, ...c };
      }, {});
      return h.useMemo(() => ({ [`__scope${r.scopeName}`]: u }), [u]);
    };
  };
  return t.scopeName = r.scopeName, t;
}
// @__NO_SIDE_EFFECTS__
function p3e(e) {
  const r = /* @__PURE__ */ m3e(e), t = h.forwardRef((i, n) => {
    const { children: s, ...u } = i, o = h.Children.toArray(s), d = o.find(v3e);
    if (d) {
      const a = d.props.children, V = o.map((c) => c === d ? h.Children.count(a) > 1 ? h.Children.only(null) : h.isValidElement(a) ? a.props.children : null : c);
      return /* @__PURE__ */ l(r, { ...u, ref: n, children: h.isValidElement(a) ? h.cloneElement(a, void 0, V) : null });
    }
    return /* @__PURE__ */ l(r, { ...u, ref: n, children: s });
  });
  return t.displayName = `${e}.Slot`, t;
}
// @__NO_SIDE_EFFECTS__
function m3e(e) {
  const r = h.forwardRef((t, i) => {
    const { children: n, ...s } = t;
    if (h.isValidElement(n)) {
      const u = y3e(n), o = b3e(s, n.props);
      return n.type !== h.Fragment && (o.ref = i ? VU(i, u) : u), h.cloneElement(n, o);
    }
    return h.Children.count(n) > 1 ? h.Children.only(null) : null;
  });
  return r.displayName = `${e}.SlotClone`, r;
}
var cU = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function g3e(e) {
  const r = ({ children: t }) => /* @__PURE__ */ l(he, { children: t });
  return r.displayName = `${e}.Slottable`, r.__radixId = cU, r;
}
function v3e(e) {
  return h.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === cU;
}
function b3e(e, r) {
  const t = { ...r };
  for (const i in r) {
    const n = e[i], s = r[i];
    /^on[A-Z]/.test(i) ? n && s ? t[i] = (...o) => {
      const d = s(...o);
      return n(...o), d;
    } : n && (t[i] = n) : i === "style" ? t[i] = { ...n, ...s } : i === "className" && (t[i] = [n, s].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function y3e(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var A3e = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], $o = A3e.reduce((e, r) => {
  const t = /* @__PURE__ */ p3e(`Primitive.${r}`), i = h.forwardRef((n, s) => {
    const { asChild: u, ...o } = n, d = u ? t : r;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l(d, { ...o, ref: s });
  });
  return i.displayName = `Primitive.${r}`, { ...e, [r]: i };
}, {});
function w3e(e, r) {
  e && qs.flushSync(() => e.dispatchEvent(r));
}
function zY(e) {
  const r = h.useRef(e);
  return h.useEffect(() => {
    r.current = e;
  }), h.useMemo(() => (...t) => {
    var i;
    return (i = r.current) == null ? void 0 : i.call(r, ...t);
  }, []);
}
function C3e(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = zY(e);
  h.useEffect(() => {
    const i = (n) => {
      n.key === "Escape" && t(n);
    };
    return r.addEventListener("keydown", i, { capture: !0 }), () => r.removeEventListener("keydown", i, { capture: !0 });
  }, [t, r]);
}
var P3e = "DismissableLayer", K8 = "dismissableLayer.update", S3e = "dismissableLayer.pointerDownOutside", N3e = "dismissableLayer.focusOutside", sP, FU = h.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), xU = h.forwardRef(
  (e, r) => {
    const {
      disableOutsidePointerEvents: t = !1,
      onEscapeKeyDown: i,
      onPointerDownOutside: n,
      onFocusOutside: s,
      onInteractOutside: u,
      onDismiss: o,
      ...d
    } = e, a = h.useContext(FU), [V, c] = h.useState(null), F = (V == null ? void 0 : V.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, X] = h.useState({}), Y = la(r, (w) => c(w)), q = Array.from(a.layers), [f] = [...a.layersWithOutsidePointerEventsDisabled].slice(-1), p = q.indexOf(f), m = V ? q.indexOf(V) : -1, g = a.layersWithOutsidePointerEventsDisabled.size > 0, y = m >= p, b = E3e((w) => {
      const S = w.target, N = [...a.branches].some((O) => O.contains(S));
      !y || N || (n == null || n(w), u == null || u(w), w.defaultPrevented || o == null || o());
    }, F), A = k3e((w) => {
      const S = w.target;
      [...a.branches].some((O) => O.contains(S)) || (s == null || s(w), u == null || u(w), w.defaultPrevented || o == null || o());
    }, F);
    return C3e((w) => {
      m === a.layers.size - 1 && (i == null || i(w), !w.defaultPrevented && o && (w.preventDefault(), o()));
    }, F), h.useEffect(() => {
      if (V)
        return t && (a.layersWithOutsidePointerEventsDisabled.size === 0 && (sP = F.body.style.pointerEvents, F.body.style.pointerEvents = "none"), a.layersWithOutsidePointerEventsDisabled.add(V)), a.layers.add(V), uP(), () => {
          t && a.layersWithOutsidePointerEventsDisabled.size === 1 && (F.body.style.pointerEvents = sP);
        };
    }, [V, F, t, a]), h.useEffect(() => () => {
      V && (a.layers.delete(V), a.layersWithOutsidePointerEventsDisabled.delete(V), uP());
    }, [V, a]), h.useEffect(() => {
      const w = () => X({});
      return document.addEventListener(K8, w), () => document.removeEventListener(K8, w);
    }, []), /* @__PURE__ */ l(
      $o.div,
      {
        ...d,
        ref: Y,
        style: {
          pointerEvents: g ? y ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: mu(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: mu(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: mu(
          e.onPointerDownCapture,
          b.onPointerDownCapture
        )
      }
    );
  }
);
xU.displayName = P3e;
var M3e = "DismissableLayerBranch", T3e = h.forwardRef((e, r) => {
  const t = h.useContext(FU), i = h.useRef(null), n = la(r, i);
  return h.useEffect(() => {
    const s = i.current;
    if (s)
      return t.branches.add(s), () => {
        t.branches.delete(s);
      };
  }, [t.branches]), /* @__PURE__ */ l($o.div, { ...e, ref: n });
});
T3e.displayName = M3e;
function E3e(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = zY(e), i = h.useRef(!1), n = h.useRef(() => {
  });
  return h.useEffect(() => {
    const s = (o) => {
      if (o.target && !i.current) {
        let d = function() {
          XU(
            S3e,
            t,
            a,
            { discrete: !0 }
          );
        };
        const a = { originalEvent: o };
        o.pointerType === "touch" ? (r.removeEventListener("click", n.current), n.current = d, r.addEventListener("click", n.current, { once: !0 })) : d();
      } else
        r.removeEventListener("click", n.current);
      i.current = !1;
    }, u = window.setTimeout(() => {
      r.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(u), r.removeEventListener("pointerdown", s), r.removeEventListener("click", n.current);
    };
  }, [r, t]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => i.current = !0
  };
}
function k3e(e, r = globalThis == null ? void 0 : globalThis.document) {
  const t = zY(e), i = h.useRef(!1);
  return h.useEffect(() => {
    const n = (s) => {
      s.target && !i.current && XU(N3e, t, { originalEvent: s }, {
        discrete: !1
      });
    };
    return r.addEventListener("focusin", n), () => r.removeEventListener("focusin", n);
  }, [r, t]), {
    onFocusCapture: () => i.current = !0,
    onBlurCapture: () => i.current = !1
  };
}
function uP() {
  const e = new CustomEvent(K8);
  document.dispatchEvent(e);
}
function XU(e, r, t, { discrete: i }) {
  const n = t.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: t });
  r && n.addEventListener(e, r, { once: !0 }), i ? w3e(n, s) : n.dispatchEvent(s);
}
var Ho = globalThis != null && globalThis.document ? h.useLayoutEffect : () => {
}, O3e = h[" useId ".trim().toString()] || (() => {
}), D3e = 0;
function R3e(e) {
  const [r, t] = h.useState(O3e());
  return Ho(() => {
    t((i) => i ?? String(D3e++));
  }, [e]), r ? `radix-${r}` : "";
}
var I3e = "Arrow", qU = h.forwardRef((e, r) => {
  const { children: t, width: i = 10, height: n = 5, ...s } = e;
  return /* @__PURE__ */ l(
    $o.svg,
    {
      ...s,
      ref: r,
      width: i,
      height: n,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? t : /* @__PURE__ */ l("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
qU.displayName = I3e;
var L3e = qU;
function _3e(e) {
  const [r, t] = h.useState(void 0);
  return Ho(() => {
    if (e) {
      t({ width: e.offsetWidth, height: e.offsetHeight });
      const i = new ResizeObserver((n) => {
        if (!Array.isArray(n) || !n.length)
          return;
        const s = n[0];
        let u, o;
        if ("borderBoxSize" in s) {
          const d = s.borderBoxSize, a = Array.isArray(d) ? d[0] : d;
          u = a.inlineSize, o = a.blockSize;
        } else
          u = e.offsetWidth, o = e.offsetHeight;
        t({ width: u, height: o });
      });
      return i.observe(e, { box: "border-box" }), () => i.unobserve(e);
    } else
      t(void 0);
  }, [e]), r;
}
var hA = "Popper", [YU, fU] = lU(hA), [H3e, KU] = YU(hA), hU = (e) => {
  const { __scopePopper: r, children: t } = e, [i, n] = h.useState(null);
  return /* @__PURE__ */ l(H3e, { scope: r, anchor: i, onAnchorChange: n, children: t });
};
hU.displayName = hA;
var pU = "PopperAnchor", mU = h.forwardRef(
  (e, r) => {
    const { __scopePopper: t, virtualRef: i, ...n } = e, s = KU(pU, t), u = h.useRef(null), o = la(r, u), d = h.useRef(null);
    return h.useEffect(() => {
      const a = d.current;
      d.current = (i == null ? void 0 : i.current) || u.current, a !== d.current && s.onAnchorChange(d.current);
    }), i ? null : /* @__PURE__ */ l($o.div, { ...n, ref: o });
  }
);
mU.displayName = pU;
var pA = "PopperContent", [j3e, z3e] = YU(pA), gU = h.forwardRef(
  (e, r) => {
    var qe, me, ne, fe, Ye, Q;
    const {
      __scopePopper: t,
      side: i = "bottom",
      sideOffset: n = 0,
      align: s = "center",
      alignOffset: u = 0,
      arrowPadding: o = 0,
      avoidCollisions: d = !0,
      collisionBoundary: a = [],
      collisionPadding: V = 0,
      sticky: c = "partial",
      hideWhenDetached: F = !1,
      updatePositionStrategy: X = "optimized",
      onPlaced: Y,
      ...q
    } = e, f = KU(pA, t), [p, m] = h.useState(null), g = la(r, (we) => m(we)), [y, b] = h.useState(null), A = _3e(y), w = (A == null ? void 0 : A.width) ?? 0, S = (A == null ? void 0 : A.height) ?? 0, N = i + (s !== "center" ? "-" + s : ""), O = typeof V == "number" ? V : { top: 0, right: 0, bottom: 0, left: 0, ...V }, E = Array.isArray(a) ? a : [a], I = E.length > 0, R = {
      padding: O,
      boundary: E.filter(W3e),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: I
    }, { refs: H, floatingStyles: W, placement: B, isPositioned: L, middlewareData: z } = oY({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: N,
      whileElementsMounted: (...we) => uY(...we, {
        animationFrame: X === "always"
      }),
      elements: {
        reference: f.anchor
      },
      middleware: [
        dY({ mainAxis: n + S, alignmentAxis: u }),
        d && aY({
          mainAxis: !0,
          crossAxis: !1,
          limiter: c === "partial" ? VY() : void 0,
          ...R
        }),
        d && lY({ ...R }),
        cY({
          ...R,
          apply: ({ elements: we, rects: oe, availableWidth: tr, availableHeight: ar }) => {
            const { width: or, height: bt } = oe.reference, Tr = we.floating.style;
            Tr.setProperty("--radix-popper-available-width", `${tr}px`), Tr.setProperty("--radix-popper-available-height", `${ar}px`), Tr.setProperty("--radix-popper-anchor-width", `${or}px`), Tr.setProperty("--radix-popper-anchor-height", `${bt}px`);
          }
        }),
        y && xY({ element: y, padding: o }),
        G3e({ arrowWidth: w, arrowHeight: S }),
        F && FY({ strategy: "referenceHidden", ...R })
      ]
    }), [Z, le] = yU(B), te = zY(Y);
    Ho(() => {
      L && (te == null || te());
    }, [L, te]);
    const U = (qe = z.arrow) == null ? void 0 : qe.x, de = (me = z.arrow) == null ? void 0 : me.y, Ke = ((ne = z.arrow) == null ? void 0 : ne.centerOffset) !== 0, [xe, be] = h.useState();
    return Ho(() => {
      p && be(window.getComputedStyle(p).zIndex);
    }, [p]), /* @__PURE__ */ l(
      "div",
      {
        ref: H.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...W,
          transform: L ? W.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: xe,
          "--radix-popper-transform-origin": [
            (fe = z.transformOrigin) == null ? void 0 : fe.x,
            (Ye = z.transformOrigin) == null ? void 0 : Ye.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Q = z.hide) == null ? void 0 : Q.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ l(
          j3e,
          {
            scope: t,
            placedSide: Z,
            onArrowChange: b,
            arrowX: U,
            arrowY: de,
            shouldHideArrow: Ke,
            children: /* @__PURE__ */ l(
              $o.div,
              {
                "data-side": Z,
                "data-align": le,
                ...q,
                ref: g,
                style: {
                  ...q.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: L ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
gU.displayName = pA;
var vU = "PopperArrow", B3e = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, bU = h.forwardRef(function(r, t) {
  const { __scopePopper: i, ...n } = r, s = z3e(vU, i), u = B3e[s.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ l(
      "span",
      {
        ref: s.onArrowChange,
        style: {
          position: "absolute",
          left: s.arrowX,
          top: s.arrowY,
          [u]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[s.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[s.placedSide],
          visibility: s.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ l(
          L3e,
          {
            ...n,
            ref: t,
            style: {
              ...n.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
bU.displayName = vU;
function W3e(e) {
  return e !== null;
}
var G3e = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(r) {
    var f, p, m;
    const { placement: t, rects: i, middlewareData: n } = r, u = ((f = n.arrow) == null ? void 0 : f.centerOffset) !== 0, o = u ? 0 : e.arrowWidth, d = u ? 0 : e.arrowHeight, [a, V] = yU(t), c = { start: "0%", center: "50%", end: "100%" }[V], F = (((p = n.arrow) == null ? void 0 : p.x) ?? 0) + o / 2, X = (((m = n.arrow) == null ? void 0 : m.y) ?? 0) + d / 2;
    let Y = "", q = "";
    return a === "bottom" ? (Y = u ? c : `${F}px`, q = `${-d}px`) : a === "top" ? (Y = u ? c : `${F}px`, q = `${i.floating.height + d}px`) : a === "right" ? (Y = `${-d}px`, q = u ? c : `${X}px`) : a === "left" && (Y = `${i.floating.width + d}px`, q = u ? c : `${X}px`), { data: { x: Y, y: q } };
  }
});
function yU(e) {
  const [r, t = "center"] = e.split("-");
  return [r, t];
}
var U3e = hU, Z3e = mU, J3e = gU, $3e = bU, Q3e = "Portal", AU = h.forwardRef((e, r) => {
  var o;
  const { container: t, ...i } = e, [n, s] = h.useState(!1);
  Ho(() => s(!0), []);
  const u = t || n && ((o = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : o.body);
  return u ? Us.createPortal(/* @__PURE__ */ l($o.div, { ...i, ref: r }), u) : null;
});
AU.displayName = Q3e;
function eAe(e, r) {
  return h.useReducer((t, i) => r[t][i] ?? t, e);
}
var mA = (e) => {
  const { present: r, children: t } = e, i = rAe(r), n = typeof t == "function" ? t({ present: i.isPresent }) : h.Children.only(t), s = la(i.ref, tAe(n));
  return typeof t == "function" || i.isPresent ? h.cloneElement(n, { ref: s }) : null;
};
mA.displayName = "Presence";
function rAe(e) {
  const [r, t] = h.useState(), i = h.useRef(null), n = h.useRef(e), s = h.useRef("none"), u = e ? "mounted" : "unmounted", [o, d] = eAe(u, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return h.useEffect(() => {
    const a = dx(i.current);
    s.current = o === "mounted" ? a : "none";
  }, [o]), Ho(() => {
    const a = i.current, V = n.current;
    if (V !== e) {
      const F = s.current, X = dx(a);
      e ? d("MOUNT") : X === "none" || (a == null ? void 0 : a.display) === "none" ? d("UNMOUNT") : d(V && F !== X ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, d]), Ho(() => {
    if (r) {
      let a;
      const V = r.ownerDocument.defaultView ?? window, c = (X) => {
        const q = dx(i.current).includes(CSS.escape(X.animationName));
        if (X.target === r && q && (d("ANIMATION_END"), !n.current)) {
          const f = r.style.animationFillMode;
          r.style.animationFillMode = "forwards", a = V.setTimeout(() => {
            r.style.animationFillMode === "forwards" && (r.style.animationFillMode = f);
          });
        }
      }, F = (X) => {
        X.target === r && (s.current = dx(i.current));
      };
      return r.addEventListener("animationstart", F), r.addEventListener("animationcancel", c), r.addEventListener("animationend", c), () => {
        V.clearTimeout(a), r.removeEventListener("animationstart", F), r.removeEventListener("animationcancel", c), r.removeEventListener("animationend", c);
      };
    } else
      d("ANIMATION_END");
  }, [r, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: h.useCallback((a) => {
      i.current = a ? getComputedStyle(a) : null, t(a);
    }, [])
  };
}
function dx(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function tAe(e) {
  var i, n;
  let r = (i = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : i.get, t = r && "isReactWarning" in r && r.isReactWarning;
  return t ? e.ref : (r = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, t = r && "isReactWarning" in r && r.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var iAe = h[" useInsertionEffect ".trim().toString()] || Ho;
function nAe({
  prop: e,
  defaultProp: r,
  onChange: t = () => {
  },
  caller: i
}) {
  const [n, s, u] = sAe({
    defaultProp: r,
    onChange: t
  }), o = e !== void 0, d = o ? e : n;
  {
    const V = h.useRef(e !== void 0);
    h.useEffect(() => {
      const c = V.current;
      c !== o && console.warn(
        `${i} is changing from ${c ? "controlled" : "uncontrolled"} to ${o ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), V.current = o;
    }, [o, i]);
  }
  const a = h.useCallback(
    (V) => {
      var c;
      if (o) {
        const F = uAe(V) ? V(e) : V;
        F !== e && ((c = u.current) == null || c.call(u, F));
      } else
        s(V);
    },
    [o, e, s, u]
  );
  return [d, a];
}
function sAe({
  defaultProp: e,
  onChange: r
}) {
  const [t, i] = h.useState(e), n = h.useRef(t), s = h.useRef(r);
  return iAe(() => {
    s.current = r;
  }, [r]), h.useEffect(() => {
    var u;
    n.current !== t && ((u = s.current) == null || u.call(s, t), n.current = t);
  }, [t, n]), [t, i, s];
}
function uAe(e) {
  return typeof e == "function";
}
var oAe = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), dAe = "VisuallyHidden", wU = h.forwardRef(
  (e, r) => /* @__PURE__ */ l(
    $o.span,
    {
      ...e,
      ref: r,
      style: { ...oAe, ...e.style }
    }
  )
);
wU.displayName = dAe;
var aAe = wU, [BY, fer] = lU("Tooltip", [
  fU
]), WY = fU(), CU = "TooltipProvider", VAe = 700, h8 = "tooltip.open", [lAe, gA] = BY(CU), PU = (e) => {
  const {
    __scopeTooltip: r,
    delayDuration: t = VAe,
    skipDelayDuration: i = 300,
    disableHoverableContent: n = !1,
    children: s
  } = e, u = h.useRef(!0), o = h.useRef(!1), d = h.useRef(0);
  return h.useEffect(() => {
    const a = d.current;
    return () => window.clearTimeout(a);
  }, []), /* @__PURE__ */ l(
    lAe,
    {
      scope: r,
      isOpenDelayedRef: u,
      delayDuration: t,
      onOpen: h.useCallback(() => {
        window.clearTimeout(d.current), u.current = !1;
      }, []),
      onClose: h.useCallback(() => {
        window.clearTimeout(d.current), d.current = window.setTimeout(
          () => u.current = !0,
          i
        );
      }, [i]),
      isPointerInTransitRef: o,
      onPointerInTransitChange: h.useCallback((a) => {
        o.current = a;
      }, []),
      disableHoverableContent: n,
      children: s
    }
  );
};
PU.displayName = CU;
var n7 = "Tooltip", [cAe, y2] = BY(n7), SU = (e) => {
  const {
    __scopeTooltip: r,
    children: t,
    open: i,
    defaultOpen: n,
    onOpenChange: s,
    disableHoverableContent: u,
    delayDuration: o
  } = e, d = gA(n7, e.__scopeTooltip), a = WY(r), [V, c] = h.useState(null), F = R3e(), X = h.useRef(0), Y = u ?? d.disableHoverableContent, q = o ?? d.delayDuration, f = h.useRef(!1), [p, m] = nAe({
    prop: i,
    defaultProp: n ?? !1,
    onChange: (w) => {
      w ? (d.onOpen(), document.dispatchEvent(new CustomEvent(h8))) : d.onClose(), s == null || s(w);
    },
    caller: n7
  }), g = h.useMemo(() => p ? f.current ? "delayed-open" : "instant-open" : "closed", [p]), y = h.useCallback(() => {
    window.clearTimeout(X.current), X.current = 0, f.current = !1, m(!0);
  }, [m]), b = h.useCallback(() => {
    window.clearTimeout(X.current), X.current = 0, m(!1);
  }, [m]), A = h.useCallback(() => {
    window.clearTimeout(X.current), X.current = window.setTimeout(() => {
      f.current = !0, m(!0), X.current = 0;
    }, q);
  }, [q, m]);
  return h.useEffect(() => () => {
    X.current && (window.clearTimeout(X.current), X.current = 0);
  }, []), /* @__PURE__ */ l(U3e, { ...a, children: /* @__PURE__ */ l(
    cAe,
    {
      scope: r,
      contentId: F,
      open: p,
      stateAttribute: g,
      trigger: V,
      onTriggerChange: c,
      onTriggerEnter: h.useCallback(() => {
        d.isOpenDelayedRef.current ? A() : y();
      }, [d.isOpenDelayedRef, A, y]),
      onTriggerLeave: h.useCallback(() => {
        Y ? b() : (window.clearTimeout(X.current), X.current = 0);
      }, [b, Y]),
      onOpen: y,
      onClose: b,
      disableHoverableContent: Y,
      children: t
    }
  ) });
};
SU.displayName = n7;
var p8 = "TooltipTrigger", NU = h.forwardRef(
  (e, r) => {
    const { __scopeTooltip: t, ...i } = e, n = y2(p8, t), s = gA(p8, t), u = WY(t), o = h.useRef(null), d = la(r, o, n.onTriggerChange), a = h.useRef(!1), V = h.useRef(!1), c = h.useCallback(() => a.current = !1, []);
    return h.useEffect(() => () => document.removeEventListener("pointerup", c), [c]), /* @__PURE__ */ l(Z3e, { asChild: !0, ...u, children: /* @__PURE__ */ l(
      $o.button,
      {
        "aria-describedby": n.open ? n.contentId : void 0,
        "data-state": n.stateAttribute,
        ...i,
        ref: d,
        onPointerMove: mu(e.onPointerMove, (F) => {
          F.pointerType !== "touch" && !V.current && !s.isPointerInTransitRef.current && (n.onTriggerEnter(), V.current = !0);
        }),
        onPointerLeave: mu(e.onPointerLeave, () => {
          n.onTriggerLeave(), V.current = !1;
        }),
        onPointerDown: mu(e.onPointerDown, () => {
          n.open && n.onClose(), a.current = !0, document.addEventListener("pointerup", c, { once: !0 });
        }),
        onFocus: mu(e.onFocus, () => {
          a.current || n.onOpen();
        }),
        onBlur: mu(e.onBlur, n.onClose),
        onClick: mu(e.onClick, n.onClose)
      }
    ) });
  }
);
NU.displayName = p8;
var vA = "TooltipPortal", [FAe, xAe] = BY(vA, {
  forceMount: void 0
}), MU = (e) => {
  const { __scopeTooltip: r, forceMount: t, children: i, container: n } = e, s = y2(vA, r);
  return /* @__PURE__ */ l(FAe, { scope: r, forceMount: t, children: /* @__PURE__ */ l(mA, { present: t || s.open, children: /* @__PURE__ */ l(AU, { asChild: !0, container: n, children: i }) }) });
};
MU.displayName = vA;
var MV = "TooltipContent", TU = h.forwardRef(
  (e, r) => {
    const t = xAe(MV, e.__scopeTooltip), { forceMount: i = t.forceMount, side: n = "top", ...s } = e, u = y2(MV, e.__scopeTooltip);
    return /* @__PURE__ */ l(mA, { present: i || u.open, children: u.disableHoverableContent ? /* @__PURE__ */ l(EU, { side: n, ...s, ref: r }) : /* @__PURE__ */ l(XAe, { side: n, ...s, ref: r }) });
  }
), XAe = h.forwardRef((e, r) => {
  const t = y2(MV, e.__scopeTooltip), i = gA(MV, e.__scopeTooltip), n = h.useRef(null), s = la(r, n), [u, o] = h.useState(null), { trigger: d, onClose: a } = t, V = n.current, { onPointerInTransitChange: c } = i, F = h.useCallback(() => {
    o(null), c(!1);
  }, [c]), X = h.useCallback(
    (Y, q) => {
      const f = Y.currentTarget, p = { x: Y.clientX, y: Y.clientY }, m = KAe(p, f.getBoundingClientRect()), g = hAe(p, m), y = pAe(q.getBoundingClientRect()), b = gAe([...g, ...y]);
      o(b), c(!0);
    },
    [c]
  );
  return h.useEffect(() => () => F(), [F]), h.useEffect(() => {
    if (d && V) {
      const Y = (f) => X(f, V), q = (f) => X(f, d);
      return d.addEventListener("pointerleave", Y), V.addEventListener("pointerleave", q), () => {
        d.removeEventListener("pointerleave", Y), V.removeEventListener("pointerleave", q);
      };
    }
  }, [d, V, X, F]), h.useEffect(() => {
    if (u) {
      const Y = (q) => {
        const f = q.target, p = { x: q.clientX, y: q.clientY }, m = (d == null ? void 0 : d.contains(f)) || (V == null ? void 0 : V.contains(f)), g = !mAe(p, u);
        m ? F() : g && (F(), a());
      };
      return document.addEventListener("pointermove", Y), () => document.removeEventListener("pointermove", Y);
    }
  }, [d, V, u, a, F]), /* @__PURE__ */ l(EU, { ...e, ref: s });
}), [qAe, YAe] = BY(n7, { isInside: !1 }), fAe = /* @__PURE__ */ g3e("TooltipContent"), EU = h.forwardRef(
  (e, r) => {
    const {
      __scopeTooltip: t,
      children: i,
      "aria-label": n,
      onEscapeKeyDown: s,
      onPointerDownOutside: u,
      ...o
    } = e, d = y2(MV, t), a = WY(t), { onClose: V } = d;
    return h.useEffect(() => (document.addEventListener(h8, V), () => document.removeEventListener(h8, V)), [V]), h.useEffect(() => {
      if (d.trigger) {
        const c = (F) => {
          const X = F.target;
          X != null && X.contains(d.trigger) && V();
        };
        return window.addEventListener("scroll", c, { capture: !0 }), () => window.removeEventListener("scroll", c, { capture: !0 });
      }
    }, [d.trigger, V]), /* @__PURE__ */ l(
      xU,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: s,
        onPointerDownOutside: u,
        onFocusOutside: (c) => c.preventDefault(),
        onDismiss: V,
        children: /* @__PURE__ */ C(
          J3e,
          {
            "data-state": d.stateAttribute,
            ...a,
            ...o,
            ref: r,
            style: {
              ...o.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ l(fAe, { children: i }),
              /* @__PURE__ */ l(qAe, { scope: t, isInside: !0, children: /* @__PURE__ */ l(aAe, { id: d.contentId, role: "tooltip", children: n || i }) })
            ]
          }
        )
      }
    );
  }
);
TU.displayName = MV;
var kU = "TooltipArrow", OU = h.forwardRef(
  (e, r) => {
    const { __scopeTooltip: t, ...i } = e, n = WY(t);
    return YAe(
      kU,
      t
    ).isInside ? null : /* @__PURE__ */ l($3e, { ...n, ...i, ref: r });
  }
);
OU.displayName = kU;
function KAe(e, r) {
  const t = Math.abs(r.top - e.y), i = Math.abs(r.bottom - e.y), n = Math.abs(r.right - e.x), s = Math.abs(r.left - e.x);
  switch (Math.min(t, i, n, s)) {
    case s:
      return "left";
    case n:
      return "right";
    case t:
      return "top";
    case i:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function hAe(e, r, t = 5) {
  const i = [];
  switch (r) {
    case "top":
      i.push(
        { x: e.x - t, y: e.y + t },
        { x: e.x + t, y: e.y + t }
      );
      break;
    case "bottom":
      i.push(
        { x: e.x - t, y: e.y - t },
        { x: e.x + t, y: e.y - t }
      );
      break;
    case "left":
      i.push(
        { x: e.x + t, y: e.y - t },
        { x: e.x + t, y: e.y + t }
      );
      break;
    case "right":
      i.push(
        { x: e.x - t, y: e.y - t },
        { x: e.x - t, y: e.y + t }
      );
      break;
  }
  return i;
}
function pAe(e) {
  const { top: r, right: t, bottom: i, left: n } = e;
  return [
    { x: n, y: r },
    { x: t, y: r },
    { x: t, y: i },
    { x: n, y: i }
  ];
}
function mAe(e, r) {
  const { x: t, y: i } = e;
  let n = !1;
  for (let s = 0, u = r.length - 1; s < r.length; u = s++) {
    const o = r[s], d = r[u], a = o.x, V = o.y, c = d.x, F = d.y;
    V > i != F > i && t < (c - a) * (i - V) / (F - V) + a && (n = !n);
  }
  return n;
}
function gAe(e) {
  const r = e.slice();
  return r.sort((t, i) => t.x < i.x ? -1 : t.x > i.x ? 1 : t.y < i.y ? -1 : t.y > i.y ? 1 : 0), vAe(r);
}
function vAe(e) {
  if (e.length <= 1) return e.slice();
  const r = [];
  for (let i = 0; i < e.length; i++) {
    const n = e[i];
    for (; r.length >= 2; ) {
      const s = r[r.length - 1], u = r[r.length - 2];
      if ((s.x - u.x) * (n.y - u.y) >= (s.y - u.y) * (n.x - u.x)) r.pop();
      else break;
    }
    r.push(n);
  }
  r.pop();
  const t = [];
  for (let i = e.length - 1; i >= 0; i--) {
    const n = e[i];
    for (; t.length >= 2; ) {
      const s = t[t.length - 1], u = t[t.length - 2];
      if ((s.x - u.x) * (n.y - u.y) >= (s.y - u.y) * (n.x - u.x)) t.pop();
      else break;
    }
    t.push(n);
  }
  return t.pop(), r.length === 1 && t.length === 1 && r[0].x === t[0].x && r[0].y === t[0].y ? r : r.concat(t);
}
var bAe = PU, yAe = SU, AAe = NU, wAe = MU, CAe = TU, PAe = OU;
function bA({
  delayDuration: e = 0,
  ...r
}) {
  return /* @__PURE__ */ l(
    bAe,
    {
      "data-slot": "tooltip-provider",
      delayDuration: e,
      ...r
    }
  );
}
function DU({
  ...e
}) {
  return /* @__PURE__ */ l(bA, { children: /* @__PURE__ */ l(yAe, { "data-slot": "tooltip", ...e }) });
}
function RU({
  ...e
}) {
  return /* @__PURE__ */ l(AAe, { "data-slot": "tooltip-trigger", ...e });
}
function IU({
  className: e,
  sideOffset: r = 4,
  children: t,
  ...i
}) {
  return /* @__PURE__ */ l(wAe, { children: /* @__PURE__ */ C(
    CAe,
    {
      "data-slot": "tooltip-content",
      sideOffset: r,
      className: _(
        "bg-popover text-popover-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-(--radix-tooltip-content-transform-origin) border-border text-bodysm z-50 max-w-[225px] overflow-hidden text-balance rounded-md px-3 py-1.5 shadow",
        e
      ),
      onPointerDownOutside: (n) => {
        n.preventDefault();
      },
      ...i,
      children: [
        t,
        /* @__PURE__ */ l(PAe, { className: "bg-popover fill-popover border-border z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" })
      ]
    }
  ) });
}
function TV({
  className: e,
  options: r,
  radioValue: t,
  setRadioValue: i
}) {
  return /* @__PURE__ */ l(
    p2,
    {
      className: _("flex w-full flex-col", e),
      value: t,
      onValueChange: (n) => {
        i(n);
      },
      children: r.length > 0 && r.map((n) => /* @__PURE__ */ C(
        yo,
        {
          className: _(
            "data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:border-interactiveBorderHover data-[state=unchecked]:hover:bg-interfaceBgDefault w-full rounded-sm border text-left data-[state=checked]:border-2",
            n.bgColor,
            n.borderColor,
            n.textColor
          ),
          onClick: () => {
            t === n.value && i("");
          },
          tabIndex: 1,
          value: n.value,
          children: [
            n.icon,
            n.text ? /* @__PURE__ */ l("p", { className: "mt-1 text-bodysm font-normal", children: n.text }) : null
          ]
        },
        n.value
      ))
    }
  );
}
function SAe({
  radioValue: e,
  setRadioValue: r
}) {
  return /* @__PURE__ */ C(
    p2,
    {
      className: _(
        "flex w-full flex-col overflow-clip rounded border",
        e !== "" ? "border-actionBorder" : "border-interactiveBorder"
      ),
      value: e,
      onValueChange: (t) => {
        r(t);
      },
      "aria-label": "View density",
      children: [
        /* @__PURE__ */ l(
          yo,
          {
            onClick: () => {
              e === "1" && r("");
            },
            className: "data-[state=checked]:border-actionBorder peer/1 data-[state=checked]:text-actionHover data-[state=checked]:bg-actionBgSelect data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:bg-interfaceBgDefault w-full border-t p-2 text-left first:border-t-0",
            value: "1",
            children: /* @__PURE__ */ C("div", { className: "flex flex-row items-center gap-x-2", children: [
              /* @__PURE__ */ l("div", { className: "text-[21px] font-normal", children: "😃" }),
              /* @__PURE__ */ C("div", { children: [
                /* @__PURE__ */ l("p", { className: "text-bodysm", children: "Mostly/all correct" }),
                /* @__PURE__ */ l(
                  "p",
                  {
                    className: _(
                      "text-bodysm font-normal",
                      e === "1" ? "text-actionHover" : "text-textSubdued"
                    ),
                    children: "Insignificant errors, if any"
                  }
                )
              ] })
            ] })
          }
        ),
        /* @__PURE__ */ l(
          yo,
          {
            onClick: () => {
              e === "2" && r("");
            },
            className: "data-[state=checked]:border-actionBorder peer-data-[state=checked]/1:border-actionBorder peer/2 data-[state=checked]:text-actionHover data-[state=checked]:bg-actionBgSelect data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:bg-interfaceBgDefault w-full border-t p-2 text-left first:border-t-0",
            value: "2",
            children: /* @__PURE__ */ C("div", { className: "flex flex-row items-center gap-x-2", children: [
              /* @__PURE__ */ l("div", { className: "text-bodymd font-normal", children: "🙂" }),
              /* @__PURE__ */ C("div", { children: [
                /* @__PURE__ */ l("p", { className: "text-bodysm", children: "Partly correct" }),
                /* @__PURE__ */ l(
                  "p",
                  {
                    className: _(
                      "text-bodysm font-normal",
                      e === "2" ? "text-actionHover" : "text-textSubdued"
                    ),
                    children: "Correct outcome, but got there the wrong way"
                  }
                )
              ] })
            ] })
          }
        ),
        /* @__PURE__ */ l(
          yo,
          {
            onClick: () => {
              e === "3" && r("");
            },
            className: "data-[state=checked]:border-actionBorder peer-data-[state=checked]/2:border-actionBorder peer/3 data-[state=checked]:text-actionHover data-[state=checked]:bg-actionBgSelect data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:bg-interfaceBgDefault w-full border-t p-2 text-left first:border-t-0",
            value: "3",
            children: /* @__PURE__ */ C("div", { className: "flex flex-row items-center gap-x-2", children: [
              /* @__PURE__ */ l("div", { className: "text-[21px] font-normal", children: "😕" }),
              /* @__PURE__ */ C("div", { children: [
                /* @__PURE__ */ l("p", { className: "text-bodysm", children: "Partly incorrect" }),
                /* @__PURE__ */ l(
                  "p",
                  {
                    className: _(
                      "text-bodysm font-normal",
                      e === "3" ? "text-actionHover" : "text-textSubdued"
                    ),
                    children: "Incorrect outcome, but some other correct reasoning"
                  }
                )
              ] })
            ] })
          }
        ),
        /* @__PURE__ */ l(
          yo,
          {
            onClick: () => {
              e === "4" && r("");
            },
            className: "data-[state=checked]:border-actionBorder peer-data-[state=checked]/3:border-actionBorder peer/4 data-[state=checked]:text-actionHover data-[state=checked]:bg-actionBgSelect data-[state=unchecked]:border-interactiveBorder data-[state=unchecked]:bg-interfaceWhite data-[state=unchecked]:hover:bg-interfaceBgDefault w-full border-b border-t p-2 text-left first:border-t-0 last:border-b-0",
            value: "4",
            children: /* @__PURE__ */ C("div", { className: "flex flex-row items-center gap-x-2", children: [
              /* @__PURE__ */ l("div", { className: "text-bodymd font-normal", children: "☹️" }),
              /* @__PURE__ */ C("div", { children: [
                /* @__PURE__ */ l("p", { className: "text-bodysm", children: "Mostly incorrect" }),
                /* @__PURE__ */ l(
                  "p",
                  {
                    className: _(
                      "text-bodysm font-normal",
                      e === "4" ? "text-actionHover" : "text-textSubdued"
                    ),
                    children: "Major policy or reasoning issues that need resolution"
                  }
                )
              ] })
            ] })
          }
        )
      ]
    }
  );
}
const NAe = {
  [Te.NoPermitRequired]: {
    text: "text-successHover",
    border: "!border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [Te.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "!border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [Te.RequiresPermit]: {
    text: "text-warningHover",
    border: "!border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [Te.Prohibited]: {
    text: "text-destructiveHover",
    border: "!border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  }
};
function Ker({
  allowDraftWatermark: e = !0,
  configPrefix: r,
  conversation: t,
  noticeboardData: i,
  onClickAdjustReport: n
}) {
  const [s, u] = ie({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), [o, d] = ie("assessment"), { getLocalisationEntry: a } = si(t), V = a("councilOrdinanceLink"), c = ua(
    t,
    i,
    r
  );
  Pe(() => {
    c && ["1", "2", "3", "4"].includes(c.toString()) ? u(NAe[c.toString()]) : u({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [c, t == null ? void 0 : t.phase]);
  const F = () => {
    let S = "";
    return t != null && t.created_at && (S = new Intl.DateTimeFormat("en-AU", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit"
    }).format(new Date(t.created_at))), S;
  }, X = () => {
    let S = "";
    return t != null && t.updated_at && (S = new Intl.DateTimeFormat("en-AU", {
      hour: "numeric",
      minute: "2-digit"
    }).format(new Date(t.updated_at))), S;
  }, Y = Iq(
    t,
    i,
    r
  ), q = wy(
    t,
    i,
    r
  ), f = Sce(
    t,
    i,
    r
  );
  Nce(i);
  const p = i2(
    t,
    i,
    r
  ), m = () => /* @__PURE__ */ l("div", { children: We(q, { ordinanceLink: V }) }), g = () => {
    if (c)
      switch (c.toString()) {
        case Te.NoPermitRequired:
          return /* @__PURE__ */ C("div", { children: [
            /* @__PURE__ */ l("p", { className: "text-textPrimary", children: "Based on your responses, it's likely you don't need to apply for a planning permit." }),
            /* @__PURE__ */ l("p", { className: "text-textPrimary", children: "However, you may still require a building permit. Building permits are issued separately from planning permits and are required to ensure construction work complies with national building regulations." }),
            /* @__PURE__ */ l(
              "a",
              {
                href: "https://www.yarraranges.vic.gov.au/Development/Building-advice/Do-I-need-a-building-permit",
                className: "text-blue-500 underline hover:text-blue-800",
                onClick: () => window.open(
                  "https://www.yarraranges.vic.gov.au/Development/Building-advice/Do-I-need-a-building-permit"
                ),
                tabIndex: 0,
                children: "Click here if you need a building permit"
              }
            )
          ] });
        case Te.MoreInformationRequired:
          return /* @__PURE__ */ C("div", { children: [
            /* @__PURE__ */ l("p", { className: "text-textPrimary text-bodymd", children: "The application checklist tells you what documents you'll need to provide when you apply for a planning permit." }),
            /* @__PURE__ */ l("p", { className: "text-textPrimary mt-2 text-bodymd", children: "More information is needed to determine your personalised application checklist." }),
            /* @__PURE__ */ C("ul", { className: "mt-1 list-decimal pl-6", children: [
              /* @__PURE__ */ C("li", { className: "mb-1", children: [
                "Review the summary under",
                " ",
                /* @__PURE__ */ l(
                  "span",
                  {
                    className: "text-textLink cursor-pointer underline",
                    onClick: () => d("assessment"),
                    role: "button",
                    tabIndex: 0,
                    children: "Assessment"
                  }
                ),
                " ",
                "for any mention of further information required."
              ] }),
              /* @__PURE__ */ l("li", { className: "mb-1", children: "Gather the necessary information. You may need to consult a planning or building professional." }),
              /* @__PURE__ */ C("li", { className: "mb-1", children: [
                "Update these details by",
                " ",
                /* @__PURE__ */ l(
                  "span",
                  {
                    className: n ? "text-textLink cursor-pointer underline" : "",
                    onClick: n,
                    role: "button",
                    tabIndex: 0,
                    children: "adjusting your proposal"
                  }
                ),
                "."
              ] }),
              /* @__PURE__ */ l("li", { className: "mb-1", children: "Once completed, we'll determine if your proposal requires a planning permit or not, and if it does, generate an application checklist." })
            ] })
          ] });
        case Te.RequiresPermit:
          return /* @__PURE__ */ C(he, { children: [
            /* @__PURE__ */ l("p", { className: "text-textPrimary", children: "☝️ Use this checklist as a starting point only. Talk to a planner before preparing any reports or plans." }),
            /* @__PURE__ */ l(
              "div",
              {
                className: `mt-6 mb-7 h-px w-full border-t ${s.border}`
              }
            ),
            We(f, {
              ordinanceLink: V
            })
          ] });
        case Te.Prohibited:
          return /* @__PURE__ */ C(he, { children: [
            /* @__PURE__ */ l("p", { className: "text-textPrimary", children: "Based on your responses, it's likely your plans are prohibited. We don't recommend applying for a planning permit because it's unlikely Council will support your proposal." }),
            /* @__PURE__ */ C("p", { className: "text-textPrimary", children: [
              "If you have questions about your result,",
              " ",
              /* @__PURE__ */ l(
                "a",
                {
                  className: "text-blue-500 underline hover:text-blue-800",
                  href: "mailto:mail@yarraranges.vic.gov.au",
                  children: "contact Yarra Ranges Council"
                }
              ),
              " ",
              "to talk to one of our planners."
            ] })
          ] });
      }
  }, y = () => null, b = () => /* @__PURE__ */ C("div", { className: "", children: [
    /* @__PURE__ */ l(yr, { children: We(Y, { ordinanceLink: V }) }),
    y()
  ] }), A = () => p, w = () => /* @__PURE__ */ C(
    "div",
    {
      className: `content-start justify-start rounded-t-md border-x border-t ${s.border} ${s.bgLight} p-5 md:px-10 md:pt-8 md:pb-6`,
      children: [
        /* @__PURE__ */ l("div", { className: "mb-2 inline-flex", children: /* @__PURE__ */ l("div", { className: "", children: /* @__PURE__ */ l(
          "h2",
          {
            className: `text-headinglg font-semibold ${s.text}`,
            children: A()
          }
        ) }) }),
        /* @__PURE__ */ C("p", { className: "mb-2 text-bodysm", children: [
          "Generated at ",
          X(),
          " on ",
          F(),
          " using planning legislation accessed on 31/03/24"
        ] })
      ]
    }
  );
  return /* @__PURE__ */ l("div", { "data-testid": "assessment-report", children: /* @__PURE__ */ C("div", { className: "relative", children: [
    e && ["ready_for_assessment", "report_ready", "amendment"].includes(
      (t == null ? void 0 : t.phase) || ""
    ) ? /* @__PURE__ */ l(spe, {}) : null,
    /* @__PURE__ */ l("div", { children: w() }),
    /* @__PURE__ */ l(
      "div",
      {
        className: `${s.border} border-interactiveBorder flex flex-col ${s.bgLight}`,
        children: /* @__PURE__ */ C(
          vu,
          {
            className: `${s.border} w-full overflow-hidden rounded-b-lg border-x border-b`,
            onValueChange: (S) => d(S),
            value: o,
            children: [
              /* @__PURE__ */ C(
                Ms,
                {
                  className: `!flex w-full items-end justify-start ${s.border}`,
                  children: [
                    /* @__PURE__ */ l(
                      "div",
                      {
                        className: `w-5 self-end border-b md:w-10 ${s.border}`
                      }
                    ),
                    /* @__PURE__ */ l(
                      Rt,
                      {
                        type: void 0,
                        value: "assessment",
                        className: `!rounded-tl !border !border-r-0 data-[state=active]:!border-r-0 ${s.bgDark} data-[state=active]:bg-interfaceWhite ${s.border} data-[state=active]:${s.border} text-textPrimary data-[state=active]:!border-b-interfaceWhite border-b px-4 py-2 text-bodylg font-semibold focus:outline-hidden data-[state=active]:border`,
                        children: "Assessment"
                      }
                    ),
                    /* @__PURE__ */ l(
                      Rt,
                      {
                        type: void 0,
                        value: "easy-read",
                        className: `!rounded-tr-sm !border data-[state=active]:!border-l-0 ${s.bgDark} data-[state=active]:bg-interfaceWhite ${s.border} data-[state=active]:${s.border} text-textPrimary data-[state=active]:!border-b-interfaceWhite border-b px-4 py-2 text-bodylg font-semibold focus:outline-hidden data-[state=active]:border`,
                        children: "Easy read"
                      }
                    ),
                    /* @__PURE__ */ l(
                      "div",
                      {
                        className: `flex-1 self-end border-b ${s.border}`
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ C("div", { className: "bg-interfaceWhite px-5 py-4 md:px-10 md:py-8", children: [
                /* @__PURE__ */ l(St, { value: "assessment", className: "", children: b() }),
                /* @__PURE__ */ l(St, { value: "easy-read", className: "", children: /* @__PURE__ */ l("div", { children: m() }) }),
                /* @__PURE__ */ l(St, { value: "application", className: "", children: /* @__PURE__ */ l("div", { children: g() }) })
              ] })
            ]
          }
        )
      }
    )
  ] }) });
}
function oP({
  configPrefix: e,
  conversation: r,
  noticeboardData: t,
  ordinanceLink: i
}) {
  const n = Cy(
    r,
    t,
    e
  );
  return /* @__PURE__ */ C(he, { children: [
    /* @__PURE__ */ l("h3", { className: "text-headingmd text-textPrimary mb-1", children: "Required documents and information" }),
    /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued mb-5", children: "If your proposal requires a planning permit and isn't eligible for VicSmart, use this list to check off what you'll need to provide when you apply." }),
    /* @__PURE__ */ l(yr, { children: We(n, {
      ordinanceLink: i
    }) })
  ] });
}
function dP({
  configPrefix: e,
  conversation: r,
  noticeboardData: t,
  ordinanceLink: i
}) {
  const n = Py(
    r,
    t,
    e
  ), s = Sy(
    r,
    t,
    e
  ), u = n === void 0 || !s;
  return /* @__PURE__ */ C(he, { children: [
    /* @__PURE__ */ l("h3", { className: "text-headingmd text-textPrimary mb-1", children: "VicSmart eligibility" }),
    /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued mb-5", children: "VicSmart is a faster approval process for straightforward planning applications. If your proposal requires a planning permit and meets certain criteria, you may be able to apply with VicSmart." }),
    u ? /* @__PURE__ */ C("div", { className: "mb-2 flex items-center gap-1", children: [
      /* @__PURE__ */ l(Zs, { className: "min-h-5 min-w-5 animate-spin" }),
      /* @__PURE__ */ l("span", { className: "text-bodymd text-textPrimary", children: "Assessing VicSmart eligibility" })
    ] }) : null,
    !u && n === bV.eligible ? /* @__PURE__ */ l(yr, { children: We(s, {
      ordinanceLink: i
    }) }) : null,
    !u && n !== bV.eligible ? /* @__PURE__ */ l("p", { className: "text-bodymd text-textPrimary", children: "Your proposal is likely ineligible for VicSmart because it doesn't meet the criteria, or you've triggered a planning requirement that has no associated VicSmart approval pathway." }) : null
  ] });
}
function LU({
  conversation: e
}) {
  const { getLocalisationEntry: r } = si(e), t = r("councilContactLink");
  return /* @__PURE__ */ C("div", { className: "rounded border border-interfaceBorder bg-interfaceBgLight text-bodymd text-textPrimary px-6 py-5", children: [
    /* @__PURE__ */ l("h3", { className: "text-headingmd mb-1", children: "✨ This service uses AI to analyse proposals" }),
    /* @__PURE__ */ l("p", { className: "mb-2", children: "It can sometimes make mistakes. It also doesn't account for a few things, such as:" }),
    /* @__PURE__ */ C("ul", { className: "list-disc list-inside pl-2 mb-2", children: [
      /* @__PURE__ */ l("li", { children: "overlays only applying to part of a property" }),
      /* @__PURE__ */ C("li", { children: [
        "covenants, 173 agreements and other restrictions found on a",
        " ",
        /* @__PURE__ */ l(
          "a",
          {
            className: "text-textLink hover:text-textLinkHover inline-flex cursor-pointer underline",
            href: "https://www.land.vic.gov.au/land-registration/for-individuals/property-and-land-titles-information",
            rel: "noreferrer",
            tabIndex: 0,
            target: "_blank",
            children: "Certificate of Title"
          }
        )
      ] }),
      /* @__PURE__ */ l("li", { children: "factors introduced by past planning approvals or existing permit applications" }),
      /* @__PURE__ */ l("li", { children: "other approvals that may be required, such as building and asset protection permits." })
    ] }),
    /* @__PURE__ */ C("p", { children: [
      "This list is not exhaustive. The information provided by this service is intended as a helpful guide and is not a final planning decision.",
      " ",
      /* @__PURE__ */ l(
        "a",
        {
          className: "text-textLink hover:text-textLinkHover inline-flex cursor-pointer underline",
          href: t,
          rel: "noreferrer",
          tabIndex: 0,
          target: "_blank",
          children: "Contact council"
        }
      ),
      " ",
      "to talk to a planner if you're unsure about anything."
    ] })
  ] });
}
const MAe = {
  [Te.NoPermitRequired]: {
    text: "text-successHover",
    border: "!border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [Te.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "!border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [Te.RequiresPermit]: {
    text: "text-warningHover",
    border: "!border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [Te.Prohibited]: {
    text: "text-destructiveHover",
    border: "!border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  }
};
function her({
  configPrefix: e,
  conversation: r,
  noticeboardData: t
}) {
  const [i, n] = ie({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), { getLocalisationEntry: s } = si(r), u = s("councilOrdinanceLink"), o = ua(
    r,
    t,
    e
  );
  Pe(() => {
    o && ["1", "2", "3", "4"].includes(o.toString()) ? n(MAe[o.toString()]) : n({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [o, r == null ? void 0 : r.phase]);
  const d = () => {
    let Y = "";
    return r != null && r.created_at && (Y = new Intl.DateTimeFormat("en-AU", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit"
    }).format(new Date(r.created_at))), Y;
  }, a = () => {
    let Y = "";
    return r != null && r.updated_at && (Y = new Intl.DateTimeFormat("en-AU", {
      hour: "numeric",
      minute: "2-digit"
    }).format(new Date(r.updated_at))), Y;
  }, V = Iq(
    r,
    t,
    e
  ), c = () => {
    switch (o) {
      case Te.NoPermitRequired:
        return /* @__PURE__ */ C(he, { children: [
          /* @__PURE__ */ l("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why your proposal likely doesn't require a planning permit." }),
          /* @__PURE__ */ C(vu, { defaultValue: "summary", children: [
            /* @__PURE__ */ C(Ms, { className: "pb-3", children: [
              /* @__PURE__ */ C(
                Rt,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "summary",
                  children: [
                    /* @__PURE__ */ l(bd, {}),
                    " Full assessment"
                  ]
                }
              ),
              /* @__PURE__ */ C(
                Rt,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "easy-read",
                  children: [
                    /* @__PURE__ */ l(yd, {}),
                    " Easy read"
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ l(St, { value: "summary", children: /* @__PURE__ */ l(yr, { maxHeight: 300, children: We(V, { ordinanceLink: u }) }) }),
            /* @__PURE__ */ l(St, { value: "easy-read", className: "", children: /* @__PURE__ */ l("div", { children: X() }) })
          ] })
        ] });
      case Te.MoreInformationRequired:
        return /* @__PURE__ */ C(he, { children: [
          /* @__PURE__ */ l("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why your proposal may or may not need a planning permit." }),
          /* @__PURE__ */ C(vu, { defaultValue: "summary", children: [
            /* @__PURE__ */ C(Ms, { className: "w-full items-stretch pb-3", children: [
              /* @__PURE__ */ C(
                Rt,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "summary",
                  children: [
                    /* @__PURE__ */ l(bd, {}),
                    " Full assessment"
                  ]
                }
              ),
              /* @__PURE__ */ C(
                Rt,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "easy-read",
                  children: [
                    /* @__PURE__ */ l(yd, {}),
                    " Easy read"
                  ]
                }
              ),
              /* @__PURE__ */ l("div", { className: "w-full border-b" })
            ] }),
            /* @__PURE__ */ l(St, { value: "summary", children: /* @__PURE__ */ l(yr, { maxHeight: 300, children: We(V, { ordinanceLink: u }) }) }),
            /* @__PURE__ */ l(St, { value: "easy-read", className: "", children: /* @__PURE__ */ l("div", { children: X() }) })
          ] }),
          /* @__PURE__ */ l("div", { className: _("my-6 w-full border-b", i.border) }),
          /* @__PURE__ */ l("h2", { className: "text-headinglg text-textPrimary mb-5", children: "Application requirements" }),
          /* @__PURE__ */ l(
            dP,
            {
              configPrefix: e,
              conversation: r,
              noticeboardData: t,
              ordinanceLink: u
            }
          ),
          /* @__PURE__ */ l("div", { className: "mt-4", children: /* @__PURE__ */ l(
            oP,
            {
              configPrefix: e,
              conversation: r,
              noticeboardData: t,
              ordinanceLink: u
            }
          ) })
        ] });
      case Te.RequiresPermit:
        return /* @__PURE__ */ C(he, { children: [
          /* @__PURE__ */ l("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why it's likely your proposal requires a planning permit." }),
          /* @__PURE__ */ C(vu, { defaultValue: "summary", children: [
            /* @__PURE__ */ C(Ms, { className: "w-full items-stretch pb-3", children: [
              /* @__PURE__ */ C(
                Rt,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "summary",
                  children: [
                    /* @__PURE__ */ l(bd, {}),
                    " Full assessment"
                  ]
                }
              ),
              /* @__PURE__ */ C(
                Rt,
                {
                  className: "data-[state=active]:text-textLink flex gap-1 px-2",
                  value: "easy-read",
                  children: [
                    /* @__PURE__ */ l(yd, {}),
                    " Easy read"
                  ]
                }
              ),
              /* @__PURE__ */ l("div", { className: "w-full border-b" })
            ] }),
            /* @__PURE__ */ l(St, { value: "summary", children: /* @__PURE__ */ l(yr, { maxHeight: 300, children: We(V, { ordinanceLink: u }) }) }),
            /* @__PURE__ */ l(St, { value: "easy-read", className: "", children: /* @__PURE__ */ l("div", { children: X() }) })
          ] }),
          /* @__PURE__ */ l("div", { className: _("my-6 w-full border-b", i.border) }),
          /* @__PURE__ */ l("h2", { className: "text-headinglg text-textPrimary mb-5", children: "Application requirements" }),
          /* @__PURE__ */ l(
            dP,
            {
              configPrefix: e,
              conversation: r,
              noticeboardData: t,
              ordinanceLink: u
            }
          ),
          /* @__PURE__ */ l("div", { className: "mt-4", children: /* @__PURE__ */ l(
            oP,
            {
              configPrefix: e,
              conversation: r,
              noticeboardData: t,
              ordinanceLink: u
            }
          ) })
        ] });
      case Te.Prohibited:
        return /* @__PURE__ */ C(he, { children: [
          /* @__PURE__ */ l("h2", { className: "text-headinglg text-textPrimary", children: "Why your proposal is likely prohibited" }),
          /* @__PURE__ */ l(yr, { maxHeight: 300, children: We(V, { ordinanceLink: u }) })
        ] });
    }
  }, F = wy(
    r,
    t,
    e
  ), X = () => /* @__PURE__ */ l("div", { children: We(F, { ordinanceLink: u }) });
  return /* @__PURE__ */ C("div", { "data-testid": "assessment-report", children: [
    /* @__PURE__ */ C(
      "div",
      {
        className: _(
          "content-start justify-start rounded-t-lg border-x border-t p-5 md:px-10 md:pt-8 md:pb-6",
          i.border,
          i.bgLight
        ),
        children: [
          /* @__PURE__ */ l("div", { className: "mb-2 inline-flex", children: /* @__PURE__ */ l(
            "h2",
            {
              className: `text-headingxl font-semibold ${i.text}`,
              children: i2(r, t, e)
            }
          ) }),
          /* @__PURE__ */ C("p", { className: "text-bodysm mb-2", children: [
            "Generated at ",
            a(),
            " on ",
            d()
          ] })
        ]
      }
    ),
    /* @__PURE__ */ C(
      "div",
      {
        className: _(
          "border-interactiveBorder bg-interfaceWhite flex flex-col rounded-b-lg border px-5 py-4 md:px-10 md:py-8",
          i.border
        ),
        children: [
          c(),
          /* @__PURE__ */ l("div", { className: _("my-6 w-full border-b", i.border) }),
          /* @__PURE__ */ l(LU, { conversation: r })
        ]
      }
    )
  ] });
}
function m8({
  title: e,
  content: r
}) {
  const [t, i] = ie(!1);
  return /* @__PURE__ */ l(
    _s,
    {
      type: "single",
      value: t ? "application_requirements" : "",
      children: /* @__PURE__ */ C(
        as,
        {
          className: "border border-interactiveBorder rounded p-1",
          value: "application_requirements",
          children: [
            /* @__PURE__ */ l(
              Vs,
              {
                className: "text-headingmd px-2 py-1",
                onClick: () => i((n) => !n),
                children: e
              }
            ),
            /* @__PURE__ */ l(ls, { className: "px-2", children: r })
          ]
        }
      )
    }
  );
}
function aP({
  assessmentLights: e,
  configPrefix: r,
  conversation: t,
  noticeboardData: i,
  ordinanceLink: n
}) {
  const s = Py(
    t,
    i,
    r
  ), u = Sy(
    t,
    i,
    r
  ), o = Mce(
    t,
    i,
    r
  ), d = s === void 0 || !u;
  return /* @__PURE__ */ C(he, { children: [
    /* @__PURE__ */ l("h2", { className: "text-headinglg text-textPrimary mb-1", children: "VicSmart eligibility" }),
    /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued mb-5", children: "VicSmart is a faster approval process for straightforward planning applications. If your proposal requires a planning permit and meets certain criteria, you may be able to apply with VicSmart." }),
    d ? /* @__PURE__ */ C("div", { className: "mb-2 flex items-center gap-1", children: [
      /* @__PURE__ */ l(Zs, { className: "min-h-5 min-w-5 animate-spin" }),
      /* @__PURE__ */ l("span", { className: "text-bodymd text-textPrimary", children: "Assessing VicSmart eligibility" })
    ] }) : null,
    !d && s === bV.eligible ? /* @__PURE__ */ C(he, { children: [
      /* @__PURE__ */ l(yr, { children: We(u, {
        ordinanceLink: n
      }) }),
      o ? /* @__PURE__ */ l("div", { className: "mt-4", children: /* @__PURE__ */ l(
        m8,
        {
          title: "Preparing your VicSmart application",
          content: /* @__PURE__ */ C(he, { children: [
            e === Te.MoreInformationRequired ? /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: "If you've determined your proposal requires a planning permit and that it's eligible for VicSmart, use this checklist as a starting point for what information is likely required in your application." }) : null,
            e === Te.RequiresPermit ? /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: "If you've determined your proposal is eligible for VicSmart and you're ready to apply, use this checklist as a starting point for what information is likely required when you apply." }) : null,
            /* @__PURE__ */ l(Qd, { className: "border-interactiveBorder my-3" }),
            /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: We(o, {
              ordinanceLink: n
            }) })
          ] })
        }
      ) }) : null
    ] }) : null,
    !d && s !== bV.eligible ? /* @__PURE__ */ l("p", { className: "text-bodymd text-textPrimary", children: "Your proposal is likely ineligible for VicSmart because it doesn't meet the criteria, or you've triggered a planning requirement that has no associated VicSmart approval pathway." }) : null
  ] });
}
const TAe = {
  [Te.NoPermitRequired]: {
    text: "text-successHover",
    border: "!border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  },
  [Te.MoreInformationRequired]: {
    text: "text-actionDefault",
    border: "!border-actionBorder",
    bgLight: "bg-actionBgLight",
    bgDark: "bg-actionBgDefault"
  },
  [Te.RequiresPermit]: {
    text: "text-warningHover",
    border: "!border-warningBorder",
    bgLight: "bg-warningBgLight",
    bgDark: "bg-warningBgDefault"
  },
  [Te.Prohibited]: {
    text: "text-destructiveHover",
    border: "!border-destructiveBorder",
    bgLight: "bg-destructiveBgLight",
    bgDark: "bg-destructiveBgDefault"
  }
};
function per({
  configPrefix: e,
  conversation: r,
  noticeboardData: t
}) {
  const [i, n] = ie({
    text: "text-successHover",
    border: "border-successBorder",
    bgLight: "bg-successBgLight",
    bgDark: "bg-successBgDefault"
  }), { getLocalisationEntry: s } = si(r), u = s("councilOrdinanceLink"), o = ua(
    r,
    t,
    e
  );
  Pe(() => {
    o && ["1", "2", "3", "4"].includes(o.toString()) ? n(TAe[o.toString()]) : n({
      text: "text-warningHover",
      border: "border-warningBorder",
      bgLight: "bg-warningBgLight",
      bgDark: "bg-warningBgDefault"
    });
  }, [o, r == null ? void 0 : r.phase]);
  const d = () => {
    let f = "";
    return r != null && r.created_at && (f = new Intl.DateTimeFormat("en-AU", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit"
    }).format(new Date(r.created_at))), f;
  }, a = () => {
    let f = "";
    return r != null && r.updated_at && (f = new Intl.DateTimeFormat("en-AU", {
      hour: "numeric",
      minute: "2-digit"
    }).format(new Date(r.updated_at))), f;
  }, V = Cy(
    r,
    t,
    e
  ), c = Ay(
    r,
    t,
    e
  ), F = yy(
    r,
    t,
    e
  ), X = Iq(
    r,
    t,
    e
  ), Y = oR(), q = () => {
    switch (o) {
      case Te.NoPermitRequired:
        return /* @__PURE__ */ C(he, { children: [
          /* @__PURE__ */ l("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why your proposal likely doesn't require a planning permit." }),
          /* @__PURE__ */ l(yr, { maxHeight: 300, children: We(X, { ordinanceLink: u }) }),
          c && F ? /* @__PURE__ */ C(he, { children: [
            /* @__PURE__ */ l(
              "div",
              {
                className: _("my-6 w-full border-b", i.border)
              }
            ),
            /* @__PURE__ */ l("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued mb-5", children: "Even though your proposal likely doesn't require a planning permit, it still likely needs to meet the following requirements for it to be permissible." }),
            /* @__PURE__ */ l(yr, { children: We(F, {
              ordinanceLink: u
            }) })
          ] }) : null
        ] });
      case Te.MoreInformationRequired:
        return /* @__PURE__ */ C(he, { children: [
          /* @__PURE__ */ l("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why your proposal may or may not need a planning permit." }),
          /* @__PURE__ */ l(yr, { maxHeight: 300, children: We(X, { ordinanceLink: u }) }),
          V ? /* @__PURE__ */ l("div", { className: "mt-4", children: /* @__PURE__ */ l(
            m8,
            {
              title: "Preparing your planning permit application",
              content: /* @__PURE__ */ C(he, { children: [
                /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: "If you've determined your proposal requires a planning permit and you're ready to apply, use this checklist as a starting point for what information is likely required as part of your application." }),
                /* @__PURE__ */ l(Qd, { className: "border-interactiveBorder my-3" }),
                /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: We(V, {
                  ordinanceLink: u
                }) })
              ] })
            }
          ) }) : null,
          c && F ? /* @__PURE__ */ C(he, { children: [
            /* @__PURE__ */ l(
              "div",
              {
                className: _("my-6 w-full border-b", i.border)
              }
            ),
            /* @__PURE__ */ l("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued mb-5", children: "Regardless of whether your proposal requires a planning permit or not, it will also likely need to meet the following requirements for it to be permissible." }),
            /* @__PURE__ */ l(yr, { children: We(F, {
              ordinanceLink: u
            }) })
          ] }) : null,
          Y ? /* @__PURE__ */ C(he, { children: [
            /* @__PURE__ */ l(
              "div",
              {
                className: _("my-6 w-full border-b", i.border)
              }
            ),
            /* @__PURE__ */ l(
              aP,
              {
                assessmentLights: o,
                configPrefix: e,
                conversation: r,
                noticeboardData: t,
                ordinanceLink: u
              }
            )
          ] }) : null
        ] });
      case Te.RequiresPermit:
        return /* @__PURE__ */ C(he, { children: [
          /* @__PURE__ */ l("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Permit triggers" }),
          /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued mb-5", children: "Why it's likely your proposal requires a planning permit." }),
          /* @__PURE__ */ l(yr, { maxHeight: 300, children: We(X, { ordinanceLink: u }) }),
          V ? /* @__PURE__ */ l("div", { className: "mt-4", children: /* @__PURE__ */ l(
            m8,
            {
              title: "Preparing your planning permit application",
              content: /* @__PURE__ */ C(he, { children: [
                /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: "If you're ready to apply for a planning permit, use this checklist as a starting point for what information is likely required as part of your application." }),
                /* @__PURE__ */ l(Qd, { className: "border-interactiveBorder my-3" }),
                /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued", children: We(V, {
                  ordinanceLink: u
                }) })
              ] })
            }
          ) }) : null,
          c && F ? /* @__PURE__ */ C(he, { children: [
            /* @__PURE__ */ l(
              "div",
              {
                className: _("my-6 w-full border-b", i.border)
              }
            ),
            /* @__PURE__ */ l("h2", { className: "text-headinglg text-textPrimary mb-1", children: "Mandatory requirements" }),
            /* @__PURE__ */ l("p", { className: "text-bodymd text-textSubdued mb-5", children: "Regardless of whether your proposal requires a planning permit or not, it will also likely need to meet the following requirements for it to be permissible." }),
            /* @__PURE__ */ l(yr, { children: We(F, {
              ordinanceLink: u
            }) })
          ] }) : null,
          Y ? /* @__PURE__ */ C(he, { children: [
            /* @__PURE__ */ l(
              "div",
              {
                className: _("my-6 w-full border-b", i.border)
              }
            ),
            /* @__PURE__ */ l(
              aP,
              {
                assessmentLights: o,
                configPrefix: e,
                conversation: r,
                noticeboardData: t,
                ordinanceLink: u
              }
            )
          ] }) : null
        ] });
      case Te.Prohibited:
        return /* @__PURE__ */ C(he, { children: [
          /* @__PURE__ */ l("h2", { className: "text-headinglg text-textPrimary", children: "Why your proposal is likely prohibited" }),
          /* @__PURE__ */ l(yr, { maxHeight: 300, children: We(X, { ordinanceLink: u }) })
        ] });
    }
  };
  return /* @__PURE__ */ C("div", { "data-testid": "assessment-report", children: [
    /* @__PURE__ */ C(
      "div",
      {
        className: _(
          "content-start justify-start rounded-t-lg border-x border-t p-5 md:px-10 md:pt-8 md:pb-6",
          i.border,
          i.bgLight
        ),
        children: [
          /* @__PURE__ */ l("div", { className: "mb-2 inline-flex", children: /* @__PURE__ */ l(
            "h2",
            {
              className: `text-headinglg font-semibold ${i.text}`,
              children: i2(r, t, e)
            }
          ) }),
          /* @__PURE__ */ C("p", { className: "text-bodysm mb-2", children: [
            "Generated at ",
            a(),
            " on ",
            d()
          ] })
        ]
      }
    ),
    /* @__PURE__ */ C(
      "div",
      {
        className: _(
          "border-interactiveBorder bg-interfaceWhite flex flex-col rounded-b-lg border px-5 py-4 md:px-10 md:py-8",
          i.border
        ),
        children: [
          q(),
          /* @__PURE__ */ l("div", { className: _("my-6 w-full border-b", i.border) }),
          /* @__PURE__ */ l(LU, { conversation: r })
        ]
      }
    )
  ] });
}
function mer() {
  return /* @__PURE__ */ C("div", { className: "rounded-lg border border-interfaceBorder bg-interfaceWhite flex flex-col", children: [
    /* @__PURE__ */ l("div", { className: "rounded-t-lg bg-interfaceBgLight border-b border-interfaceBorder flex items-center justify-center px-10 py-8", children: /* @__PURE__ */ l("h2", { className: "text-headingxl font-semibold text-textSubdued", children: "A report hasn't been generated for this conversation yet." }) }),
    /* @__PURE__ */ l("div", { className: "rounded-b-lg bg-interfaceWhite flex items-center justify-center px-10 py-8", children: /* @__PURE__ */ l("p", { className: "text-bodylg font-normal text-textSubdued", children: "A report is generated after the customer has answered all the questions in the chat. Once the customer has done this, allow 2–3 minutes for myLot to generate the report." }) })
  ] });
}
function it({
  chartType: e,
  children: r,
  council: t,
  groupType: i,
  from: n,
  to: s,
  includeInternalUsers: u
}) {
  const { data: o, isLoading: d } = Oae({
    body: {
      council_code: t,
      chart_type: e,
      group_type: i,
      from_date: n,
      to_date: s,
      include_internal_users: u
    }
  });
  return r({
    data: o == null ? void 0 : o.data,
    isLoading: d
  });
}
var mp, VP;
function Qi() {
  if (VP) return mp;
  VP = 1;
  var e = Array.isArray;
  return mp = e, mp;
}
var gp, lP;
function _U() {
  if (lP) return gp;
  lP = 1;
  var e = typeof vo == "object" && vo && vo.Object === Object && vo;
  return gp = e, gp;
}
var vp, cP;
function eu() {
  if (cP) return vp;
  cP = 1;
  var e = _U(), r = typeof self == "object" && self && self.Object === Object && self, t = e || r || Function("return this")();
  return vp = t, vp;
}
var bp, FP;
function A2() {
  if (FP) return bp;
  FP = 1;
  var e = eu(), r = e.Symbol;
  return bp = r, bp;
}
var yp, xP;
function EAe() {
  if (xP) return yp;
  xP = 1;
  var e = A2(), r = Object.prototype, t = r.hasOwnProperty, i = r.toString, n = e ? e.toStringTag : void 0;
  function s(u) {
    var o = t.call(u, n), d = u[n];
    try {
      u[n] = void 0;
      var a = !0;
    } catch {
    }
    var V = i.call(u);
    return a && (o ? u[n] = d : delete u[n]), V;
  }
  return yp = s, yp;
}
var Ap, XP;
function kAe() {
  if (XP) return Ap;
  XP = 1;
  var e = Object.prototype, r = e.toString;
  function t(i) {
    return r.call(i);
  }
  return Ap = t, Ap;
}
var wp, qP;
function Uu() {
  if (qP) return wp;
  qP = 1;
  var e = A2(), r = EAe(), t = kAe(), i = "[object Null]", n = "[object Undefined]", s = e ? e.toStringTag : void 0;
  function u(o) {
    return o == null ? o === void 0 ? n : i : s && s in Object(o) ? r(o) : t(o);
  }
  return wp = u, wp;
}
var Cp, YP;
function Zu() {
  if (YP) return Cp;
  YP = 1;
  function e(r) {
    return r != null && typeof r == "object";
  }
  return Cp = e, Cp;
}
var Pp, fP;
function Pl() {
  if (fP) return Pp;
  fP = 1;
  var e = Uu(), r = Zu(), t = "[object Symbol]";
  function i(n) {
    return typeof n == "symbol" || r(n) && e(n) == t;
  }
  return Pp = i, Pp;
}
var Sp, KP;
function yA() {
  if (KP) return Sp;
  KP = 1;
  var e = Qi(), r = Pl(), t = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function n(s, u) {
    if (e(s))
      return !1;
    var o = typeof s;
    return o == "number" || o == "symbol" || o == "boolean" || s == null || r(s) ? !0 : i.test(s) || !t.test(s) || u != null && s in Object(u);
  }
  return Sp = n, Sp;
}
var Np, hP;
function Qo() {
  if (hP) return Np;
  hP = 1;
  function e(r) {
    var t = typeof r;
    return r != null && (t == "object" || t == "function");
  }
  return Np = e, Np;
}
var Mp, pP;
function AA() {
  if (pP) return Mp;
  pP = 1;
  var e = Uu(), r = Qo(), t = "[object AsyncFunction]", i = "[object Function]", n = "[object GeneratorFunction]", s = "[object Proxy]";
  function u(o) {
    if (!r(o))
      return !1;
    var d = e(o);
    return d == i || d == n || d == t || d == s;
  }
  return Mp = u, Mp;
}
var Tp, mP;
function OAe() {
  if (mP) return Tp;
  mP = 1;
  var e = eu(), r = e["__core-js_shared__"];
  return Tp = r, Tp;
}
var Ep, gP;
function DAe() {
  if (gP) return Ep;
  gP = 1;
  var e = OAe(), r = function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  }();
  function t(i) {
    return !!r && r in i;
  }
  return Ep = t, Ep;
}
var kp, vP;
function HU() {
  if (vP) return kp;
  vP = 1;
  var e = Function.prototype, r = e.toString;
  function t(i) {
    if (i != null) {
      try {
        return r.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return kp = t, kp;
}
var Op, bP;
function RAe() {
  if (bP) return Op;
  bP = 1;
  var e = AA(), r = DAe(), t = Qo(), i = HU(), n = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, u = Function.prototype, o = Object.prototype, d = u.toString, a = o.hasOwnProperty, V = RegExp(
    "^" + d.call(a).replace(n, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function c(F) {
    if (!t(F) || r(F))
      return !1;
    var X = e(F) ? V : s;
    return X.test(i(F));
  }
  return Op = c, Op;
}
var Dp, yP;
function IAe() {
  if (yP) return Dp;
  yP = 1;
  function e(r, t) {
    return r == null ? void 0 : r[t];
  }
  return Dp = e, Dp;
}
var Rp, AP;
function ca() {
  if (AP) return Rp;
  AP = 1;
  var e = RAe(), r = IAe();
  function t(i, n) {
    var s = r(i, n);
    return e(s) ? s : void 0;
  }
  return Rp = t, Rp;
}
var Ip, wP;
function GY() {
  if (wP) return Ip;
  wP = 1;
  var e = ca(), r = e(Object, "create");
  return Ip = r, Ip;
}
var Lp, CP;
function LAe() {
  if (CP) return Lp;
  CP = 1;
  var e = GY();
  function r() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Lp = r, Lp;
}
var _p, PP;
function _Ae() {
  if (PP) return _p;
  PP = 1;
  function e(r) {
    var t = this.has(r) && delete this.__data__[r];
    return this.size -= t ? 1 : 0, t;
  }
  return _p = e, _p;
}
var Hp, SP;
function HAe() {
  if (SP) return Hp;
  SP = 1;
  var e = GY(), r = "__lodash_hash_undefined__", t = Object.prototype, i = t.hasOwnProperty;
  function n(s) {
    var u = this.__data__;
    if (e) {
      var o = u[s];
      return o === r ? void 0 : o;
    }
    return i.call(u, s) ? u[s] : void 0;
  }
  return Hp = n, Hp;
}
var jp, NP;
function jAe() {
  if (NP) return jp;
  NP = 1;
  var e = GY(), r = Object.prototype, t = r.hasOwnProperty;
  function i(n) {
    var s = this.__data__;
    return e ? s[n] !== void 0 : t.call(s, n);
  }
  return jp = i, jp;
}
var zp, MP;
function zAe() {
  if (MP) return zp;
  MP = 1;
  var e = GY(), r = "__lodash_hash_undefined__";
  function t(i, n) {
    var s = this.__data__;
    return this.size += this.has(i) ? 0 : 1, s[i] = e && n === void 0 ? r : n, this;
  }
  return zp = t, zp;
}
var Bp, TP;
function BAe() {
  if (TP) return Bp;
  TP = 1;
  var e = LAe(), r = _Ae(), t = HAe(), i = jAe(), n = zAe();
  function s(u) {
    var o = -1, d = u == null ? 0 : u.length;
    for (this.clear(); ++o < d; ) {
      var a = u[o];
      this.set(a[0], a[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = r, s.prototype.get = t, s.prototype.has = i, s.prototype.set = n, Bp = s, Bp;
}
var Wp, EP;
function WAe() {
  if (EP) return Wp;
  EP = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Wp = e, Wp;
}
var Gp, kP;
function wA() {
  if (kP) return Gp;
  kP = 1;
  function e(r, t) {
    return r === t || r !== r && t !== t;
  }
  return Gp = e, Gp;
}
var Up, OP;
function UY() {
  if (OP) return Up;
  OP = 1;
  var e = wA();
  function r(t, i) {
    for (var n = t.length; n--; )
      if (e(t[n][0], i))
        return n;
    return -1;
  }
  return Up = r, Up;
}
var Zp, DP;
function GAe() {
  if (DP) return Zp;
  DP = 1;
  var e = UY(), r = Array.prototype, t = r.splice;
  function i(n) {
    var s = this.__data__, u = e(s, n);
    if (u < 0)
      return !1;
    var o = s.length - 1;
    return u == o ? s.pop() : t.call(s, u, 1), --this.size, !0;
  }
  return Zp = i, Zp;
}
var Jp, RP;
function UAe() {
  if (RP) return Jp;
  RP = 1;
  var e = UY();
  function r(t) {
    var i = this.__data__, n = e(i, t);
    return n < 0 ? void 0 : i[n][1];
  }
  return Jp = r, Jp;
}
var $p, IP;
function ZAe() {
  if (IP) return $p;
  IP = 1;
  var e = UY();
  function r(t) {
    return e(this.__data__, t) > -1;
  }
  return $p = r, $p;
}
var Qp, LP;
function JAe() {
  if (LP) return Qp;
  LP = 1;
  var e = UY();
  function r(t, i) {
    var n = this.__data__, s = e(n, t);
    return s < 0 ? (++this.size, n.push([t, i])) : n[s][1] = i, this;
  }
  return Qp = r, Qp;
}
var e0, _P;
function ZY() {
  if (_P) return e0;
  _P = 1;
  var e = WAe(), r = GAe(), t = UAe(), i = ZAe(), n = JAe();
  function s(u) {
    var o = -1, d = u == null ? 0 : u.length;
    for (this.clear(); ++o < d; ) {
      var a = u[o];
      this.set(a[0], a[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = r, s.prototype.get = t, s.prototype.has = i, s.prototype.set = n, e0 = s, e0;
}
var r0, HP;
function CA() {
  if (HP) return r0;
  HP = 1;
  var e = ca(), r = eu(), t = e(r, "Map");
  return r0 = t, r0;
}
var t0, jP;
function $Ae() {
  if (jP) return t0;
  jP = 1;
  var e = BAe(), r = ZY(), t = CA();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (t || r)(),
      string: new e()
    };
  }
  return t0 = i, t0;
}
var i0, zP;
function QAe() {
  if (zP) return i0;
  zP = 1;
  function e(r) {
    var t = typeof r;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? r !== "__proto__" : r === null;
  }
  return i0 = e, i0;
}
var n0, BP;
function JY() {
  if (BP) return n0;
  BP = 1;
  var e = QAe();
  function r(t, i) {
    var n = t.__data__;
    return e(i) ? n[typeof i == "string" ? "string" : "hash"] : n.map;
  }
  return n0 = r, n0;
}
var s0, WP;
function e4e() {
  if (WP) return s0;
  WP = 1;
  var e = JY();
  function r(t) {
    var i = e(this, t).delete(t);
    return this.size -= i ? 1 : 0, i;
  }
  return s0 = r, s0;
}
var u0, GP;
function r4e() {
  if (GP) return u0;
  GP = 1;
  var e = JY();
  function r(t) {
    return e(this, t).get(t);
  }
  return u0 = r, u0;
}
var o0, UP;
function t4e() {
  if (UP) return o0;
  UP = 1;
  var e = JY();
  function r(t) {
    return e(this, t).has(t);
  }
  return o0 = r, o0;
}
var d0, ZP;
function i4e() {
  if (ZP) return d0;
  ZP = 1;
  var e = JY();
  function r(t, i) {
    var n = e(this, t), s = n.size;
    return n.set(t, i), this.size += n.size == s ? 0 : 1, this;
  }
  return d0 = r, d0;
}
var a0, JP;
function PA() {
  if (JP) return a0;
  JP = 1;
  var e = $Ae(), r = e4e(), t = r4e(), i = t4e(), n = i4e();
  function s(u) {
    var o = -1, d = u == null ? 0 : u.length;
    for (this.clear(); ++o < d; ) {
      var a = u[o];
      this.set(a[0], a[1]);
    }
  }
  return s.prototype.clear = e, s.prototype.delete = r, s.prototype.get = t, s.prototype.has = i, s.prototype.set = n, a0 = s, a0;
}
var V0, $P;
function jU() {
  if ($P) return V0;
  $P = 1;
  var e = PA(), r = "Expected a function";
  function t(i, n) {
    if (typeof i != "function" || n != null && typeof n != "function")
      throw new TypeError(r);
    var s = function() {
      var u = arguments, o = n ? n.apply(this, u) : u[0], d = s.cache;
      if (d.has(o))
        return d.get(o);
      var a = i.apply(this, u);
      return s.cache = d.set(o, a) || d, a;
    };
    return s.cache = new (t.Cache || e)(), s;
  }
  return t.Cache = e, V0 = t, V0;
}
var l0, QP;
function n4e() {
  if (QP) return l0;
  QP = 1;
  var e = jU(), r = 500;
  function t(i) {
    var n = e(i, function(u) {
      return s.size === r && s.clear(), u;
    }), s = n.cache;
    return n;
  }
  return l0 = t, l0;
}
var c0, eS;
function s4e() {
  if (eS) return c0;
  eS = 1;
  var e = n4e(), r = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, t = /\\(\\)?/g, i = e(function(n) {
    var s = [];
    return n.charCodeAt(0) === 46 && s.push(""), n.replace(r, function(u, o, d, a) {
      s.push(d ? a.replace(t, "$1") : o || u);
    }), s;
  });
  return c0 = i, c0;
}
var F0, rS;
function SA() {
  if (rS) return F0;
  rS = 1;
  function e(r, t) {
    for (var i = -1, n = r == null ? 0 : r.length, s = Array(n); ++i < n; )
      s[i] = t(r[i], i, r);
    return s;
  }
  return F0 = e, F0;
}
var x0, tS;
function u4e() {
  if (tS) return x0;
  tS = 1;
  var e = A2(), r = SA(), t = Qi(), i = Pl(), n = e ? e.prototype : void 0, s = n ? n.toString : void 0;
  function u(o) {
    if (typeof o == "string")
      return o;
    if (t(o))
      return r(o, u) + "";
    if (i(o))
      return s ? s.call(o) : "";
    var d = o + "";
    return d == "0" && 1 / o == -1 / 0 ? "-0" : d;
  }
  return x0 = u, x0;
}
var X0, iS;
function zU() {
  if (iS) return X0;
  iS = 1;
  var e = u4e();
  function r(t) {
    return t == null ? "" : e(t);
  }
  return X0 = r, X0;
}
var q0, nS;
function BU() {
  if (nS) return q0;
  nS = 1;
  var e = Qi(), r = yA(), t = s4e(), i = zU();
  function n(s, u) {
    return e(s) ? s : r(s, u) ? [s] : t(i(s));
  }
  return q0 = n, q0;
}
var Y0, sS;
function $Y() {
  if (sS) return Y0;
  sS = 1;
  var e = Pl();
  function r(t) {
    if (typeof t == "string" || e(t))
      return t;
    var i = t + "";
    return i == "0" && 1 / t == -1 / 0 ? "-0" : i;
  }
  return Y0 = r, Y0;
}
var f0, uS;
function NA() {
  if (uS) return f0;
  uS = 1;
  var e = BU(), r = $Y();
  function t(i, n) {
    n = e(n, i);
    for (var s = 0, u = n.length; i != null && s < u; )
      i = i[r(n[s++])];
    return s && s == u ? i : void 0;
  }
  return f0 = t, f0;
}
var K0, oS;
function WU() {
  if (oS) return K0;
  oS = 1;
  var e = NA();
  function r(t, i, n) {
    var s = t == null ? void 0 : e(t, i);
    return s === void 0 ? n : s;
  }
  return K0 = r, K0;
}
var o4e = WU();
const Mn = /* @__PURE__ */ Mr(o4e);
var h0, dS;
function d4e() {
  if (dS) return h0;
  dS = 1;
  function e(r) {
    return r == null;
  }
  return h0 = e, h0;
}
var a4e = d4e();
const fr = /* @__PURE__ */ Mr(a4e);
var p0, aS;
function V4e() {
  if (aS) return p0;
  aS = 1;
  var e = Uu(), r = Qi(), t = Zu(), i = "[object String]";
  function n(s) {
    return typeof s == "string" || !r(s) && t(s) && e(s) == i;
  }
  return p0 = n, p0;
}
var l4e = V4e();
const w2 = /* @__PURE__ */ Mr(l4e);
var c4e = AA();
const Ue = /* @__PURE__ */ Mr(c4e);
var F4e = Qo();
const Sl = /* @__PURE__ */ Mr(F4e);
var ax = { exports: {} }, vr = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var VS;
function x4e() {
  if (VS) return vr;
  VS = 1;
  var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), n = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), u = Symbol.for("react.context"), o = Symbol.for("react.server_context"), d = Symbol.for("react.forward_ref"), a = Symbol.for("react.suspense"), V = Symbol.for("react.suspense_list"), c = Symbol.for("react.memo"), F = Symbol.for("react.lazy"), X = Symbol.for("react.offscreen"), Y;
  Y = Symbol.for("react.module.reference");
  function q(f) {
    if (typeof f == "object" && f !== null) {
      var p = f.$$typeof;
      switch (p) {
        case e:
          switch (f = f.type, f) {
            case t:
            case n:
            case i:
            case a:
            case V:
              return f;
            default:
              switch (f = f && f.$$typeof, f) {
                case o:
                case u:
                case d:
                case F:
                case c:
                case s:
                  return f;
                default:
                  return p;
              }
          }
        case r:
          return p;
      }
    }
  }
  return vr.ContextConsumer = u, vr.ContextProvider = s, vr.Element = e, vr.ForwardRef = d, vr.Fragment = t, vr.Lazy = F, vr.Memo = c, vr.Portal = r, vr.Profiler = n, vr.StrictMode = i, vr.Suspense = a, vr.SuspenseList = V, vr.isAsyncMode = function() {
    return !1;
  }, vr.isConcurrentMode = function() {
    return !1;
  }, vr.isContextConsumer = function(f) {
    return q(f) === u;
  }, vr.isContextProvider = function(f) {
    return q(f) === s;
  }, vr.isElement = function(f) {
    return typeof f == "object" && f !== null && f.$$typeof === e;
  }, vr.isForwardRef = function(f) {
    return q(f) === d;
  }, vr.isFragment = function(f) {
    return q(f) === t;
  }, vr.isLazy = function(f) {
    return q(f) === F;
  }, vr.isMemo = function(f) {
    return q(f) === c;
  }, vr.isPortal = function(f) {
    return q(f) === r;
  }, vr.isProfiler = function(f) {
    return q(f) === n;
  }, vr.isStrictMode = function(f) {
    return q(f) === i;
  }, vr.isSuspense = function(f) {
    return q(f) === a;
  }, vr.isSuspenseList = function(f) {
    return q(f) === V;
  }, vr.isValidElementType = function(f) {
    return typeof f == "string" || typeof f == "function" || f === t || f === n || f === i || f === a || f === V || f === X || typeof f == "object" && f !== null && (f.$$typeof === F || f.$$typeof === c || f.$$typeof === s || f.$$typeof === u || f.$$typeof === d || f.$$typeof === Y || f.getModuleId !== void 0);
  }, vr.typeOf = q, vr;
}
var br = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lS;
function X4e() {
  return lS || (lS = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), n = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), u = Symbol.for("react.context"), o = Symbol.for("react.server_context"), d = Symbol.for("react.forward_ref"), a = Symbol.for("react.suspense"), V = Symbol.for("react.suspense_list"), c = Symbol.for("react.memo"), F = Symbol.for("react.lazy"), X = Symbol.for("react.offscreen"), Y = !1, q = !1, f = !1, p = !1, m = !1, g;
    g = Symbol.for("react.module.reference");
    function y(oe) {
      return !!(typeof oe == "string" || typeof oe == "function" || oe === t || oe === n || m || oe === i || oe === a || oe === V || p || oe === X || Y || q || f || typeof oe == "object" && oe !== null && (oe.$$typeof === F || oe.$$typeof === c || oe.$$typeof === s || oe.$$typeof === u || oe.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      oe.$$typeof === g || oe.getModuleId !== void 0));
    }
    function b(oe) {
      if (typeof oe == "object" && oe !== null) {
        var tr = oe.$$typeof;
        switch (tr) {
          case e:
            var ar = oe.type;
            switch (ar) {
              case t:
              case n:
              case i:
              case a:
              case V:
                return ar;
              default:
                var or = ar && ar.$$typeof;
                switch (or) {
                  case o:
                  case u:
                  case d:
                  case F:
                  case c:
                  case s:
                    return or;
                  default:
                    return tr;
                }
            }
          case r:
            return tr;
        }
      }
    }
    var A = u, w = s, S = e, N = d, O = t, E = F, I = c, R = r, H = n, W = i, B = a, L = V, z = !1, Z = !1;
    function le(oe) {
      return z || (z = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function te(oe) {
      return Z || (Z = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function U(oe) {
      return b(oe) === u;
    }
    function de(oe) {
      return b(oe) === s;
    }
    function Ke(oe) {
      return typeof oe == "object" && oe !== null && oe.$$typeof === e;
    }
    function xe(oe) {
      return b(oe) === d;
    }
    function be(oe) {
      return b(oe) === t;
    }
    function qe(oe) {
      return b(oe) === F;
    }
    function me(oe) {
      return b(oe) === c;
    }
    function ne(oe) {
      return b(oe) === r;
    }
    function fe(oe) {
      return b(oe) === n;
    }
    function Ye(oe) {
      return b(oe) === i;
    }
    function Q(oe) {
      return b(oe) === a;
    }
    function we(oe) {
      return b(oe) === V;
    }
    br.ContextConsumer = A, br.ContextProvider = w, br.Element = S, br.ForwardRef = N, br.Fragment = O, br.Lazy = E, br.Memo = I, br.Portal = R, br.Profiler = H, br.StrictMode = W, br.Suspense = B, br.SuspenseList = L, br.isAsyncMode = le, br.isConcurrentMode = te, br.isContextConsumer = U, br.isContextProvider = de, br.isElement = Ke, br.isForwardRef = xe, br.isFragment = be, br.isLazy = qe, br.isMemo = me, br.isPortal = ne, br.isProfiler = fe, br.isStrictMode = Ye, br.isSuspense = Q, br.isSuspenseList = we, br.isValidElementType = y, br.typeOf = b;
  }()), br;
}
var cS;
function q4e() {
  return cS || (cS = 1, process.env.NODE_ENV === "production" ? ax.exports = x4e() : ax.exports = X4e()), ax.exports;
}
var Y4e = q4e(), m0, FS;
function GU() {
  if (FS) return m0;
  FS = 1;
  var e = Uu(), r = Zu(), t = "[object Number]";
  function i(n) {
    return typeof n == "number" || r(n) && e(n) == t;
  }
  return m0 = i, m0;
}
var g0, xS;
function f4e() {
  if (xS) return g0;
  xS = 1;
  var e = GU();
  function r(t) {
    return e(t) && t != +t;
  }
  return g0 = r, g0;
}
var K4e = f4e();
const C2 = /* @__PURE__ */ Mr(K4e);
var h4e = GU();
const p4e = /* @__PURE__ */ Mr(h4e);
var ts = function(r) {
  return r === 0 ? 0 : r > 0 ? 1 : -1;
}, wd = function(r) {
  return w2(r) && r.indexOf("%") === r.length - 1;
}, pe = function(r) {
  return p4e(r) && !C2(r);
}, Mt = function(r) {
  return pe(r) || w2(r);
}, m4e = 0, QY = function(r) {
  var t = ++m4e;
  return "".concat(r || "").concat(t);
}, is = function(r, t) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!pe(r) && !w2(r))
    return i;
  var s;
  if (wd(r)) {
    var u = r.indexOf("%");
    s = t * parseFloat(r.slice(0, u)) / 100;
  } else
    s = +r;
  return C2(s) && (s = i), n && s > t && (s = t), s;
}, po = function(r) {
  if (!r)
    return null;
  var t = Object.keys(r);
  return t && t.length ? r[t[0]] : null;
}, g4e = function(r) {
  if (!Array.isArray(r))
    return !1;
  for (var t = r.length, i = {}, n = 0; n < t; n++)
    if (!i[r[n]])
      i[r[n]] = !0;
    else
      return !0;
  return !1;
}, Cs = function(r, t) {
  return pe(r) && pe(t) ? function(i) {
    return r + i * (t - r);
  } : function() {
    return t;
  };
};
function g8(e, r, t) {
  return !e || !e.length ? null : e.find(function(i) {
    return i && (typeof r == "function" ? r(i) : Mn(i, r)) === t;
  });
}
function fV(e, r) {
  for (var t in e)
    if ({}.hasOwnProperty.call(e, t) && (!{}.hasOwnProperty.call(r, t) || e[t] !== r[t]))
      return !1;
  for (var i in r)
    if ({}.hasOwnProperty.call(r, i) && !{}.hasOwnProperty.call(e, i))
      return !1;
  return !0;
}
function v8(e) {
  "@babel/helpers - typeof";
  return v8 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, v8(e);
}
var v4e = ["viewBox", "children"], b4e = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], XS = ["points", "pathLength"], v0 = {
  svg: v4e,
  polygon: XS,
  polyline: XS
}, MA = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], XX = function(r, t) {
  if (!r || typeof r == "function" || typeof r == "boolean")
    return null;
  var i = r;
  if (/* @__PURE__ */ Ci(r) && (i = r.props), !Sl(i))
    return null;
  var n = {};
  return Object.keys(i).forEach(function(s) {
    MA.includes(s) && (n[s] = t || function(u) {
      return i[s](i, u);
    });
  }), n;
}, y4e = function(r, t, i) {
  return function(n) {
    return r(t, i, n), null;
  };
}, EV = function(r, t, i) {
  if (!Sl(r) || v8(r) !== "object")
    return null;
  var n = null;
  return Object.keys(r).forEach(function(s) {
    var u = r[s];
    MA.includes(s) && typeof u == "function" && (n || (n = {}), n[s] = y4e(u, t, i));
  }), n;
}, A4e = ["children"], w4e = ["children"];
function qS(e, r) {
  if (e == null) return {};
  var t = C4e(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function C4e(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
var YS = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
}, Pu = function(r) {
  return typeof r == "string" ? r : r ? r.displayName || r.name || "Component" : "";
}, fS = null, b0 = null, TA = function e(r) {
  if (r === fS && Array.isArray(b0))
    return b0;
  var t = [];
  return Hi.forEach(r, function(i) {
    fr(i) || (Y4e.isFragment(i) ? t = t.concat(e(i.props.children)) : t.push(i));
  }), b0 = t, fS = r, t;
};
function ss(e, r) {
  var t = [], i = [];
  return Array.isArray(r) ? i = r.map(function(n) {
    return Pu(n);
  }) : i = [Pu(r)], TA(e).forEach(function(n) {
    var s = Mn(n, "type.displayName") || Mn(n, "type.name");
    i.indexOf(s) !== -1 && t.push(n);
  }), t;
}
function dn(e, r) {
  var t = ss(e, r);
  return t && t[0];
}
var KS = function(r) {
  if (!r || !r.props)
    return !1;
  var t = r.props, i = t.width, n = t.height;
  return !(!pe(i) || i <= 0 || !pe(n) || n <= 0);
}, P4e = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], S4e = function(r) {
  return r && r.type && w2(r.type) && P4e.indexOf(r.type) >= 0;
}, N4e = function(r, t, i, n) {
  var s, u = (s = v0 == null ? void 0 : v0[n]) !== null && s !== void 0 ? s : [];
  return !Ue(r) && (n && u.includes(t) || b4e.includes(t)) || i && MA.includes(t);
}, _e = function(r, t, i) {
  if (!r || typeof r == "function" || typeof r == "boolean")
    return null;
  var n = r;
  if (/* @__PURE__ */ Ci(r) && (n = r.props), !Sl(n))
    return null;
  var s = {};
  return Object.keys(n).forEach(function(u) {
    var o;
    N4e((o = n) === null || o === void 0 ? void 0 : o[u], u, t, i) && (s[u] = n[u]);
  }), s;
}, b8 = function e(r, t) {
  if (r === t)
    return !0;
  var i = Hi.count(r);
  if (i !== Hi.count(t))
    return !1;
  if (i === 0)
    return !0;
  if (i === 1)
    return hS(Array.isArray(r) ? r[0] : r, Array.isArray(t) ? t[0] : t);
  for (var n = 0; n < i; n++) {
    var s = r[n], u = t[n];
    if (Array.isArray(s) || Array.isArray(u)) {
      if (!e(s, u))
        return !1;
    } else if (!hS(s, u))
      return !1;
  }
  return !0;
}, hS = function(r, t) {
  if (fr(r) && fr(t))
    return !0;
  if (!fr(r) && !fr(t)) {
    var i = r.props || {}, n = i.children, s = qS(i, A4e), u = t.props || {}, o = u.children, d = qS(u, w4e);
    return n && o ? fV(s, d) && b8(n, o) : !n && !o ? fV(s, d) : !1;
  }
  return !1;
}, pS = function(r, t) {
  var i = [], n = {};
  return TA(r).forEach(function(s, u) {
    if (S4e(s))
      i.push(s);
    else if (s) {
      var o = Pu(s.type), d = t[o] || {}, a = d.handler, V = d.once;
      if (a && (!V || !n[o])) {
        var c = a(s, o, u);
        i.push(c), n[o] = !0;
      }
    }
  }), i;
}, M4e = function(r) {
  var t = r && r.type;
  return t && YS[t] ? YS[t] : null;
}, T4e = function(r, t) {
  return TA(t).indexOf(r);
}, E4e = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function y8() {
  return y8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, y8.apply(this, arguments);
}
function k4e(e, r) {
  if (e == null) return {};
  var t = O4e(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function O4e(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
function A8(e) {
  var r = e.children, t = e.width, i = e.height, n = e.viewBox, s = e.className, u = e.style, o = e.title, d = e.desc, a = k4e(e, E4e), V = n || {
    width: t,
    height: i,
    x: 0,
    y: 0
  }, c = ur("recharts-surface", s);
  return /* @__PURE__ */ D.createElement("svg", y8({}, _e(a, !0, "svg"), {
    className: c,
    width: t,
    height: i,
    style: u,
    viewBox: "".concat(V.x, " ").concat(V.y, " ").concat(V.width, " ").concat(V.height)
  }), /* @__PURE__ */ D.createElement("title", null, o), /* @__PURE__ */ D.createElement("desc", null, d), r);
}
var D4e = ["children", "className"];
function w8() {
  return w8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, w8.apply(this, arguments);
}
function R4e(e, r) {
  if (e == null) return {};
  var t = I4e(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function I4e(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
var Hr = /* @__PURE__ */ D.forwardRef(function(e, r) {
  var t = e.children, i = e.className, n = R4e(e, D4e), s = ur("recharts-layer", i);
  return /* @__PURE__ */ D.createElement("g", w8({
    className: s
  }, _e(n, !0), {
    ref: r
  }), t);
}), L4e = process.env.NODE_ENV !== "production", Su = function(r, t) {
  for (var i = arguments.length, n = new Array(i > 2 ? i - 2 : 0), s = 2; s < i; s++)
    n[s - 2] = arguments[s];
  if (L4e && typeof console < "u" && console.warn && (t === void 0 && console.warn("LogUtils requires an error message argument"), !r))
    if (t === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var u = 0;
      console.warn(t.replace(/%s/g, function() {
        return n[u++];
      }));
    }
}, y0, mS;
function _4e() {
  if (mS) return y0;
  mS = 1;
  function e(r, t, i) {
    var n = -1, s = r.length;
    t < 0 && (t = -t > s ? 0 : s + t), i = i > s ? s : i, i < 0 && (i += s), s = t > i ? 0 : i - t >>> 0, t >>>= 0;
    for (var u = Array(s); ++n < s; )
      u[n] = r[n + t];
    return u;
  }
  return y0 = e, y0;
}
var A0, gS;
function H4e() {
  if (gS) return A0;
  gS = 1;
  var e = _4e();
  function r(t, i, n) {
    var s = t.length;
    return n = n === void 0 ? s : n, !i && n >= s ? t : e(t, i, n);
  }
  return A0 = r, A0;
}
var w0, vS;
function UU() {
  if (vS) return w0;
  vS = 1;
  var e = "\\ud800-\\udfff", r = "\\u0300-\\u036f", t = "\\ufe20-\\ufe2f", i = "\\u20d0-\\u20ff", n = r + t + i, s = "\\ufe0e\\ufe0f", u = "\\u200d", o = RegExp("[" + u + e + n + s + "]");
  function d(a) {
    return o.test(a);
  }
  return w0 = d, w0;
}
var C0, bS;
function j4e() {
  if (bS) return C0;
  bS = 1;
  function e(r) {
    return r.split("");
  }
  return C0 = e, C0;
}
var P0, yS;
function z4e() {
  if (yS) return P0;
  yS = 1;
  var e = "\\ud800-\\udfff", r = "\\u0300-\\u036f", t = "\\ufe20-\\ufe2f", i = "\\u20d0-\\u20ff", n = r + t + i, s = "\\ufe0e\\ufe0f", u = "[" + e + "]", o = "[" + n + "]", d = "\\ud83c[\\udffb-\\udfff]", a = "(?:" + o + "|" + d + ")", V = "[^" + e + "]", c = "(?:\\ud83c[\\udde6-\\uddff]){2}", F = "[\\ud800-\\udbff][\\udc00-\\udfff]", X = "\\u200d", Y = a + "?", q = "[" + s + "]?", f = "(?:" + X + "(?:" + [V, c, F].join("|") + ")" + q + Y + ")*", p = q + Y + f, m = "(?:" + [V + o + "?", o, c, F, u].join("|") + ")", g = RegExp(d + "(?=" + d + ")|" + m + p, "g");
  function y(b) {
    return b.match(g) || [];
  }
  return P0 = y, P0;
}
var S0, AS;
function B4e() {
  if (AS) return S0;
  AS = 1;
  var e = j4e(), r = UU(), t = z4e();
  function i(n) {
    return r(n) ? t(n) : e(n);
  }
  return S0 = i, S0;
}
var N0, wS;
function W4e() {
  if (wS) return N0;
  wS = 1;
  var e = H4e(), r = UU(), t = B4e(), i = zU();
  function n(s) {
    return function(u) {
      u = i(u);
      var o = r(u) ? t(u) : void 0, d = o ? o[0] : u.charAt(0), a = o ? e(o, 1).join("") : u.slice(1);
      return d[s]() + a;
    };
  }
  return N0 = n, N0;
}
var M0, CS;
function G4e() {
  if (CS) return M0;
  CS = 1;
  var e = W4e(), r = e("toUpperCase");
  return M0 = r, M0;
}
var U4e = G4e();
const ef = /* @__PURE__ */ Mr(U4e);
function Br(e) {
  return function() {
    return e;
  };
}
const ZU = Math.cos, qX = Math.sin, Ks = Math.sqrt, YX = Math.PI, rf = 2 * YX, C8 = Math.PI, P8 = 2 * C8, Kd = 1e-6, Z4e = P8 - Kd;
function JU(e) {
  this._ += e[0];
  for (let r = 1, t = e.length; r < t; ++r)
    this._ += arguments[r] + e[r];
}
function J4e(e) {
  let r = Math.floor(e);
  if (!(r >= 0)) throw new Error(`invalid digits: ${e}`);
  if (r > 15) return JU;
  const t = 10 ** r;
  return function(i) {
    this._ += i[0];
    for (let n = 1, s = i.length; n < s; ++n)
      this._ += Math.round(arguments[n] * t) / t + i[n];
  };
}
class $4e {
  constructor(r) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = r == null ? JU : J4e(r);
  }
  moveTo(r, t) {
    this._append`M${this._x0 = this._x1 = +r},${this._y0 = this._y1 = +t}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(r, t) {
    this._append`L${this._x1 = +r},${this._y1 = +t}`;
  }
  quadraticCurveTo(r, t, i, n) {
    this._append`Q${+r},${+t},${this._x1 = +i},${this._y1 = +n}`;
  }
  bezierCurveTo(r, t, i, n, s, u) {
    this._append`C${+r},${+t},${+i},${+n},${this._x1 = +s},${this._y1 = +u}`;
  }
  arcTo(r, t, i, n, s) {
    if (r = +r, t = +t, i = +i, n = +n, s = +s, s < 0) throw new Error(`negative radius: ${s}`);
    let u = this._x1, o = this._y1, d = i - r, a = n - t, V = u - r, c = o - t, F = V * V + c * c;
    if (this._x1 === null)
      this._append`M${this._x1 = r},${this._y1 = t}`;
    else if (F > Kd) if (!(Math.abs(c * d - a * V) > Kd) || !s)
      this._append`L${this._x1 = r},${this._y1 = t}`;
    else {
      let X = i - u, Y = n - o, q = d * d + a * a, f = X * X + Y * Y, p = Math.sqrt(q), m = Math.sqrt(F), g = s * Math.tan((C8 - Math.acos((q + F - f) / (2 * p * m))) / 2), y = g / m, b = g / p;
      Math.abs(y - 1) > Kd && this._append`L${r + y * V},${t + y * c}`, this._append`A${s},${s},0,0,${+(c * X > V * Y)},${this._x1 = r + b * d},${this._y1 = t + b * a}`;
    }
  }
  arc(r, t, i, n, s, u) {
    if (r = +r, t = +t, i = +i, u = !!u, i < 0) throw new Error(`negative radius: ${i}`);
    let o = i * Math.cos(n), d = i * Math.sin(n), a = r + o, V = t + d, c = 1 ^ u, F = u ? n - s : s - n;
    this._x1 === null ? this._append`M${a},${V}` : (Math.abs(this._x1 - a) > Kd || Math.abs(this._y1 - V) > Kd) && this._append`L${a},${V}`, i && (F < 0 && (F = F % P8 + P8), F > Z4e ? this._append`A${i},${i},0,1,${c},${r - o},${t - d}A${i},${i},0,1,${c},${this._x1 = a},${this._y1 = V}` : F > Kd && this._append`A${i},${i},0,${+(F >= C8)},${c},${this._x1 = r + i * Math.cos(s)},${this._y1 = t + i * Math.sin(s)}`);
  }
  rect(r, t, i, n) {
    this._append`M${this._x0 = this._x1 = +r},${this._y0 = this._y1 = +t}h${i = +i}v${+n}h${-i}Z`;
  }
  toString() {
    return this._;
  }
}
function EA(e) {
  let r = 3;
  return e.digits = function(t) {
    if (!arguments.length) return r;
    if (t == null)
      r = null;
    else {
      const i = Math.floor(t);
      if (!(i >= 0)) throw new RangeError(`invalid digits: ${t}`);
      r = i;
    }
    return e;
  }, () => new $4e(r);
}
function kA(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function $U(e) {
  this._context = e;
}
$U.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, r) {
    switch (e = +e, r = +r, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, r) : this._context.moveTo(e, r);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(e, r);
        break;
    }
  }
};
function tf(e) {
  return new $U(e);
}
function QU(e) {
  return e[0];
}
function eZ(e) {
  return e[1];
}
function rZ(e, r) {
  var t = Br(!0), i = null, n = tf, s = null, u = EA(o);
  e = typeof e == "function" ? e : e === void 0 ? QU : Br(e), r = typeof r == "function" ? r : r === void 0 ? eZ : Br(r);
  function o(d) {
    var a, V = (d = kA(d)).length, c, F = !1, X;
    for (i == null && (s = n(X = u())), a = 0; a <= V; ++a)
      !(a < V && t(c = d[a], a, d)) === F && ((F = !F) ? s.lineStart() : s.lineEnd()), F && s.point(+e(c, a, d), +r(c, a, d));
    if (X) return s = null, X + "" || null;
  }
  return o.x = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : Br(+d), o) : e;
  }, o.y = function(d) {
    return arguments.length ? (r = typeof d == "function" ? d : Br(+d), o) : r;
  }, o.defined = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : Br(!!d), o) : t;
  }, o.curve = function(d) {
    return arguments.length ? (n = d, i != null && (s = n(i)), o) : n;
  }, o.context = function(d) {
    return arguments.length ? (d == null ? i = s = null : s = n(i = d), o) : i;
  }, o;
}
function Vx(e, r, t) {
  var i = null, n = Br(!0), s = null, u = tf, o = null, d = EA(a);
  e = typeof e == "function" ? e : e === void 0 ? QU : Br(+e), r = typeof r == "function" ? r : Br(r === void 0 ? 0 : +r), t = typeof t == "function" ? t : t === void 0 ? eZ : Br(+t);
  function a(c) {
    var F, X, Y, q = (c = kA(c)).length, f, p = !1, m, g = new Array(q), y = new Array(q);
    for (s == null && (o = u(m = d())), F = 0; F <= q; ++F) {
      if (!(F < q && n(f = c[F], F, c)) === p)
        if (p = !p)
          X = F, o.areaStart(), o.lineStart();
        else {
          for (o.lineEnd(), o.lineStart(), Y = F - 1; Y >= X; --Y)
            o.point(g[Y], y[Y]);
          o.lineEnd(), o.areaEnd();
        }
      p && (g[F] = +e(f, F, c), y[F] = +r(f, F, c), o.point(i ? +i(f, F, c) : g[F], t ? +t(f, F, c) : y[F]));
    }
    if (m) return o = null, m + "" || null;
  }
  function V() {
    return rZ().defined(n).curve(u).context(s);
  }
  return a.x = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : Br(+c), i = null, a) : e;
  }, a.x0 = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : Br(+c), a) : e;
  }, a.x1 = function(c) {
    return arguments.length ? (i = c == null ? null : typeof c == "function" ? c : Br(+c), a) : i;
  }, a.y = function(c) {
    return arguments.length ? (r = typeof c == "function" ? c : Br(+c), t = null, a) : r;
  }, a.y0 = function(c) {
    return arguments.length ? (r = typeof c == "function" ? c : Br(+c), a) : r;
  }, a.y1 = function(c) {
    return arguments.length ? (t = c == null ? null : typeof c == "function" ? c : Br(+c), a) : t;
  }, a.lineX0 = a.lineY0 = function() {
    return V().x(e).y(r);
  }, a.lineY1 = function() {
    return V().x(e).y(t);
  }, a.lineX1 = function() {
    return V().x(i).y(r);
  }, a.defined = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : Br(!!c), a) : n;
  }, a.curve = function(c) {
    return arguments.length ? (u = c, s != null && (o = u(s)), a) : u;
  }, a.context = function(c) {
    return arguments.length ? (c == null ? s = o = null : o = u(s = c), a) : s;
  }, a;
}
class tZ {
  constructor(r, t) {
    this._context = r, this._x = t;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(r, t) {
    switch (r = +r, t = +t, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(r, t) : this._context.moveTo(r, t);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + r) / 2, this._y0, this._x0, t, r, t) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + t) / 2, r, this._y0, r, t);
        break;
      }
    }
    this._x0 = r, this._y0 = t;
  }
}
function Q4e(e) {
  return new tZ(e, !0);
}
function e5e(e) {
  return new tZ(e, !1);
}
const OA = {
  draw(e, r) {
    const t = Ks(r / YX);
    e.moveTo(t, 0), e.arc(0, 0, t, 0, rf);
  }
}, r5e = {
  draw(e, r) {
    const t = Ks(r / 5) / 2;
    e.moveTo(-3 * t, -t), e.lineTo(-t, -t), e.lineTo(-t, -3 * t), e.lineTo(t, -3 * t), e.lineTo(t, -t), e.lineTo(3 * t, -t), e.lineTo(3 * t, t), e.lineTo(t, t), e.lineTo(t, 3 * t), e.lineTo(-t, 3 * t), e.lineTo(-t, t), e.lineTo(-3 * t, t), e.closePath();
  }
}, iZ = Ks(1 / 3), t5e = iZ * 2, i5e = {
  draw(e, r) {
    const t = Ks(r / t5e), i = t * iZ;
    e.moveTo(0, -t), e.lineTo(i, 0), e.lineTo(0, t), e.lineTo(-i, 0), e.closePath();
  }
}, n5e = {
  draw(e, r) {
    const t = Ks(r), i = -t / 2;
    e.rect(i, i, t, t);
  }
}, s5e = 0.8908130915292852, nZ = qX(YX / 10) / qX(7 * YX / 10), u5e = qX(rf / 10) * nZ, o5e = -ZU(rf / 10) * nZ, d5e = {
  draw(e, r) {
    const t = Ks(r * s5e), i = u5e * t, n = o5e * t;
    e.moveTo(0, -t), e.lineTo(i, n);
    for (let s = 1; s < 5; ++s) {
      const u = rf * s / 5, o = ZU(u), d = qX(u);
      e.lineTo(d * t, -o * t), e.lineTo(o * i - d * n, d * i + o * n);
    }
    e.closePath();
  }
}, T0 = Ks(3), a5e = {
  draw(e, r) {
    const t = -Ks(r / (T0 * 3));
    e.moveTo(0, t * 2), e.lineTo(-T0 * t, -t), e.lineTo(T0 * t, -t), e.closePath();
  }
}, bn = -0.5, yn = Ks(3) / 2, S8 = 1 / Ks(12), V5e = (S8 / 2 + 1) * 3, l5e = {
  draw(e, r) {
    const t = Ks(r / V5e), i = t / 2, n = t * S8, s = i, u = t * S8 + t, o = -s, d = u;
    e.moveTo(i, n), e.lineTo(s, u), e.lineTo(o, d), e.lineTo(bn * i - yn * n, yn * i + bn * n), e.lineTo(bn * s - yn * u, yn * s + bn * u), e.lineTo(bn * o - yn * d, yn * o + bn * d), e.lineTo(bn * i + yn * n, bn * n - yn * i), e.lineTo(bn * s + yn * u, bn * u - yn * s), e.lineTo(bn * o + yn * d, bn * d - yn * o), e.closePath();
  }
};
function c5e(e, r) {
  let t = null, i = EA(n);
  e = typeof e == "function" ? e : Br(e || OA), r = typeof r == "function" ? r : Br(r === void 0 ? 64 : +r);
  function n() {
    let s;
    if (t || (t = s = i()), e.apply(this, arguments).draw(t, +r.apply(this, arguments)), s) return t = null, s + "" || null;
  }
  return n.type = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Br(s), n) : e;
  }, n.size = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : Br(+s), n) : r;
  }, n.context = function(s) {
    return arguments.length ? (t = s ?? null, n) : t;
  }, n;
}
function fX() {
}
function KX(e, r, t) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + r) / 6,
    (e._y0 + 4 * e._y1 + t) / 6
  );
}
function sZ(e) {
  this._context = e;
}
sZ.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        KX(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, r) {
    switch (e = +e, r = +r, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, r) : this._context.moveTo(e, r);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        KX(this, e, r);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = r;
  }
};
function F5e(e) {
  return new sZ(e);
}
function uZ(e) {
  this._context = e;
}
uZ.prototype = {
  areaStart: fX,
  areaEnd: fX,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, r) {
    switch (e = +e, r = +r, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = r;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = r;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = r, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + r) / 6);
        break;
      default:
        KX(this, e, r);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = r;
  }
};
function x5e(e) {
  return new uZ(e);
}
function oZ(e) {
  this._context = e;
}
oZ.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, r) {
    switch (e = +e, r = +r, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var t = (this._x0 + 4 * this._x1 + e) / 6, i = (this._y0 + 4 * this._y1 + r) / 6;
        this._line ? this._context.lineTo(t, i) : this._context.moveTo(t, i);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        KX(this, e, r);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = r;
  }
};
function X5e(e) {
  return new oZ(e);
}
function dZ(e) {
  this._context = e;
}
dZ.prototype = {
  areaStart: fX,
  areaEnd: fX,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, r) {
    e = +e, r = +r, this._point ? this._context.lineTo(e, r) : (this._point = 1, this._context.moveTo(e, r));
  }
};
function q5e(e) {
  return new dZ(e);
}
function PS(e) {
  return e < 0 ? -1 : 1;
}
function SS(e, r, t) {
  var i = e._x1 - e._x0, n = r - e._x1, s = (e._y1 - e._y0) / (i || n < 0 && -0), u = (t - e._y1) / (n || i < 0 && -0), o = (s * n + u * i) / (i + n);
  return (PS(s) + PS(u)) * Math.min(Math.abs(s), Math.abs(u), 0.5 * Math.abs(o)) || 0;
}
function NS(e, r) {
  var t = e._x1 - e._x0;
  return t ? (3 * (e._y1 - e._y0) / t - r) / 2 : r;
}
function E0(e, r, t) {
  var i = e._x0, n = e._y0, s = e._x1, u = e._y1, o = (s - i) / 3;
  e._context.bezierCurveTo(i + o, n + o * r, s - o, u - o * t, s, u);
}
function hX(e) {
  this._context = e;
}
hX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        E0(this, this._t0, NS(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, r) {
    var t = NaN;
    if (e = +e, r = +r, !(e === this._x1 && r === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, r) : this._context.moveTo(e, r);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, E0(this, NS(this, t = SS(this, e, r)), t);
          break;
        default:
          E0(this, this._t0, t = SS(this, e, r));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = r, this._t0 = t;
    }
  }
};
function aZ(e) {
  this._context = new VZ(e);
}
(aZ.prototype = Object.create(hX.prototype)).point = function(e, r) {
  hX.prototype.point.call(this, r, e);
};
function VZ(e) {
  this._context = e;
}
VZ.prototype = {
  moveTo: function(e, r) {
    this._context.moveTo(r, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, r) {
    this._context.lineTo(r, e);
  },
  bezierCurveTo: function(e, r, t, i, n, s) {
    this._context.bezierCurveTo(r, e, i, t, s, n);
  }
};
function Y5e(e) {
  return new hX(e);
}
function f5e(e) {
  return new aZ(e);
}
function lZ(e) {
  this._context = e;
}
lZ.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, r = this._y, t = e.length;
    if (t)
      if (this._line ? this._context.lineTo(e[0], r[0]) : this._context.moveTo(e[0], r[0]), t === 2)
        this._context.lineTo(e[1], r[1]);
      else
        for (var i = MS(e), n = MS(r), s = 0, u = 1; u < t; ++s, ++u)
          this._context.bezierCurveTo(i[0][s], n[0][s], i[1][s], n[1][s], e[u], r[u]);
    (this._line || this._line !== 0 && t === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, r) {
    this._x.push(+e), this._y.push(+r);
  }
};
function MS(e) {
  var r, t = e.length - 1, i, n = new Array(t), s = new Array(t), u = new Array(t);
  for (n[0] = 0, s[0] = 2, u[0] = e[0] + 2 * e[1], r = 1; r < t - 1; ++r) n[r] = 1, s[r] = 4, u[r] = 4 * e[r] + 2 * e[r + 1];
  for (n[t - 1] = 2, s[t - 1] = 7, u[t - 1] = 8 * e[t - 1] + e[t], r = 1; r < t; ++r) i = n[r] / s[r - 1], s[r] -= i, u[r] -= i * u[r - 1];
  for (n[t - 1] = u[t - 1] / s[t - 1], r = t - 2; r >= 0; --r) n[r] = (u[r] - n[r + 1]) / s[r];
  for (s[t - 1] = (e[t] + n[t - 1]) / 2, r = 0; r < t - 1; ++r) s[r] = 2 * e[r + 1] - n[r + 1];
  return [n, s];
}
function K5e(e) {
  return new lZ(e);
}
function nf(e, r) {
  this._context = e, this._t = r;
}
nf.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, r) {
    switch (e = +e, r = +r, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, r) : this._context.moveTo(e, r);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, r), this._context.lineTo(e, r);
        else {
          var t = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(t, this._y), this._context.lineTo(t, r);
        }
        break;
      }
    }
    this._x = e, this._y = r;
  }
};
function h5e(e) {
  return new nf(e, 0.5);
}
function p5e(e) {
  return new nf(e, 0);
}
function m5e(e) {
  return new nf(e, 1);
}
function kV(e, r) {
  if ((u = e.length) > 1)
    for (var t = 1, i, n, s = e[r[0]], u, o = s.length; t < u; ++t)
      for (n = s, s = e[r[t]], i = 0; i < o; ++i)
        s[i][1] += s[i][0] = isNaN(n[i][1]) ? n[i][0] : n[i][1];
}
function N8(e) {
  for (var r = e.length, t = new Array(r); --r >= 0; ) t[r] = r;
  return t;
}
function g5e(e, r) {
  return e[r];
}
function v5e(e) {
  const r = [];
  return r.key = e, r;
}
function b5e() {
  var e = Br([]), r = N8, t = kV, i = g5e;
  function n(s) {
    var u = Array.from(e.apply(this, arguments), v5e), o, d = u.length, a = -1, V;
    for (const c of s)
      for (o = 0, ++a; o < d; ++o)
        (u[o][a] = [0, +i(c, u[o].key, a, s)]).data = c;
    for (o = 0, V = kA(r(u)); o < d; ++o)
      u[V[o]].index = o;
    return t(u, V), u;
  }
  return n.keys = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Br(Array.from(s)), n) : e;
  }, n.value = function(s) {
    return arguments.length ? (i = typeof s == "function" ? s : Br(+s), n) : i;
  }, n.order = function(s) {
    return arguments.length ? (r = s == null ? N8 : typeof s == "function" ? s : Br(Array.from(s)), n) : r;
  }, n.offset = function(s) {
    return arguments.length ? (t = s ?? kV, n) : t;
  }, n;
}
function y5e(e, r) {
  if ((i = e.length) > 0) {
    for (var t, i, n = 0, s = e[0].length, u; n < s; ++n) {
      for (u = t = 0; t < i; ++t) u += e[t][n][1] || 0;
      if (u) for (t = 0; t < i; ++t) e[t][n][1] /= u;
    }
    kV(e, r);
  }
}
function A5e(e, r) {
  if ((n = e.length) > 0) {
    for (var t = 0, i = e[r[0]], n, s = i.length; t < s; ++t) {
      for (var u = 0, o = 0; u < n; ++u) o += e[u][t][1] || 0;
      i[t][1] += i[t][0] = -o / 2;
    }
    kV(e, r);
  }
}
function w5e(e, r) {
  if (!(!((u = e.length) > 0) || !((s = (n = e[r[0]]).length) > 0))) {
    for (var t = 0, i = 1, n, s, u; i < s; ++i) {
      for (var o = 0, d = 0, a = 0; o < u; ++o) {
        for (var V = e[r[o]], c = V[i][1] || 0, F = V[i - 1][1] || 0, X = (c - F) / 2, Y = 0; Y < o; ++Y) {
          var q = e[r[Y]], f = q[i][1] || 0, p = q[i - 1][1] || 0;
          X += f - p;
        }
        d += c, a += X * c;
      }
      n[i - 1][1] += n[i - 1][0] = t, d && (t -= a / d);
    }
    n[i - 1][1] += n[i - 1][0] = t, kV(e, r);
  }
}
function s7(e) {
  "@babel/helpers - typeof";
  return s7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, s7(e);
}
var C5e = ["type", "size", "sizeType"];
function M8() {
  return M8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, M8.apply(this, arguments);
}
function TS(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function ES(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? TS(Object(t), !0).forEach(function(i) {
      P5e(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TS(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function P5e(e, r, t) {
  return r = S5e(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function S5e(e) {
  var r = N5e(e, "string");
  return s7(r) == "symbol" ? r : r + "";
}
function N5e(e, r) {
  if (s7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (s7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function M5e(e, r) {
  if (e == null) return {};
  var t = T5e(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function T5e(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
var cZ = {
  symbolCircle: OA,
  symbolCross: r5e,
  symbolDiamond: i5e,
  symbolSquare: n5e,
  symbolStar: d5e,
  symbolTriangle: a5e,
  symbolWye: l5e
}, E5e = Math.PI / 180, k5e = function(r) {
  var t = "symbol".concat(ef(r));
  return cZ[t] || OA;
}, O5e = function(r, t, i) {
  if (t === "area")
    return r;
  switch (i) {
    case "cross":
      return 5 * r * r / 9;
    case "diamond":
      return 0.5 * r * r / Math.sqrt(3);
    case "square":
      return r * r;
    case "star": {
      var n = 18 * E5e;
      return 1.25 * r * r * (Math.tan(n) - Math.tan(n * 2) * Math.pow(Math.tan(n), 2));
    }
    case "triangle":
      return Math.sqrt(3) * r * r / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * r * r / 8;
    default:
      return Math.PI * r * r / 4;
  }
}, D5e = function(r, t) {
  cZ["symbol".concat(ef(r))] = t;
}, DA = function(r) {
  var t = r.type, i = t === void 0 ? "circle" : t, n = r.size, s = n === void 0 ? 64 : n, u = r.sizeType, o = u === void 0 ? "area" : u, d = M5e(r, C5e), a = ES(ES({}, d), {}, {
    type: i,
    size: s,
    sizeType: o
  }), V = function() {
    var f = k5e(i), p = c5e().type(f).size(O5e(s, o, i));
    return p();
  }, c = a.className, F = a.cx, X = a.cy, Y = _e(a, !0);
  return F === +F && X === +X && s === +s ? /* @__PURE__ */ D.createElement("path", M8({}, Y, {
    className: ur("recharts-symbols", c),
    transform: "translate(".concat(F, ", ").concat(X, ")"),
    d: V()
  })) : null;
};
DA.registerSymbol = D5e;
function OV(e) {
  "@babel/helpers - typeof";
  return OV = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, OV(e);
}
function T8() {
  return T8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, T8.apply(this, arguments);
}
function kS(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function R5e(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? kS(Object(t), !0).forEach(function(i) {
      u7(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : kS(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function I5e(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function L5e(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, xZ(i.key), i);
  }
}
function _5e(e, r, t) {
  return r && L5e(e.prototype, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function H5e(e, r, t) {
  return r = pX(r), j5e(e, FZ() ? Reflect.construct(r, t || [], pX(e).constructor) : r.apply(e, t));
}
function j5e(e, r) {
  if (r && (OV(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return z5e(e);
}
function z5e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function FZ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (FZ = function() {
    return !!e;
  })();
}
function pX(e) {
  return pX = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, pX(e);
}
function B5e(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && E8(e, r);
}
function E8(e, r) {
  return E8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, E8(e, r);
}
function u7(e, r, t) {
  return r = xZ(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function xZ(e) {
  var r = W5e(e, "string");
  return OV(r) == "symbol" ? r : r + "";
}
function W5e(e, r) {
  if (OV(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (OV(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Un = 32, RA = /* @__PURE__ */ function(e) {
  function r() {
    return I5e(this, r), H5e(this, r, arguments);
  }
  return B5e(r, e), _5e(r, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(i) {
        var n = this.props.inactiveColor, s = Un / 2, u = Un / 6, o = Un / 3, d = i.inactive ? n : i.color;
        if (i.type === "plainline")
          return /* @__PURE__ */ D.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: d,
            strokeDasharray: i.payload.strokeDasharray,
            x1: 0,
            y1: s,
            x2: Un,
            y2: s,
            className: "recharts-legend-icon"
          });
        if (i.type === "line")
          return /* @__PURE__ */ D.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: d,
            d: "M0,".concat(s, "h").concat(o, `
            A`).concat(u, ",").concat(u, ",0,1,1,").concat(2 * o, ",").concat(s, `
            H`).concat(Un, "M").concat(2 * o, ",").concat(s, `
            A`).concat(u, ",").concat(u, ",0,1,1,").concat(o, ",").concat(s),
            className: "recharts-legend-icon"
          });
        if (i.type === "rect")
          return /* @__PURE__ */ D.createElement("path", {
            stroke: "none",
            fill: d,
            d: "M0,".concat(Un / 8, "h").concat(Un, "v").concat(Un * 3 / 4, "h").concat(-32, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ D.isValidElement(i.legendIcon)) {
          var a = R5e({}, i);
          return delete a.legendIcon, /* @__PURE__ */ D.cloneElement(i.legendIcon, a);
        }
        return /* @__PURE__ */ D.createElement(DA, {
          fill: d,
          cx: s,
          cy: s,
          size: Un,
          sizeType: "diameter",
          type: i.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var i = this, n = this.props, s = n.payload, u = n.iconSize, o = n.layout, d = n.formatter, a = n.inactiveColor, V = {
        x: 0,
        y: 0,
        width: Un,
        height: Un
      }, c = {
        display: o === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, F = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return s.map(function(X, Y) {
        var q = X.formatter || d, f = ur(u7(u7({
          "recharts-legend-item": !0
        }, "legend-item-".concat(Y), !0), "inactive", X.inactive));
        if (X.type === "none")
          return null;
        var p = Ue(X.value) ? null : X.value;
        Su(
          !Ue(X.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var m = X.inactive ? a : X.color;
        return /* @__PURE__ */ D.createElement("li", T8({
          className: f,
          style: c,
          key: "legend-item-".concat(Y)
        }, EV(i.props, X, Y)), /* @__PURE__ */ D.createElement(A8, {
          width: u,
          height: u,
          viewBox: V,
          style: F
        }, i.renderIcon(X)), /* @__PURE__ */ D.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: m
          }
        }, q ? q(p, X, Y) : p));
      });
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, n = i.payload, s = i.layout, u = i.align;
      if (!n || !n.length)
        return null;
      var o = {
        padding: 0,
        margin: 0,
        textAlign: s === "horizontal" ? u : "left"
      };
      return /* @__PURE__ */ D.createElement("ul", {
        className: "recharts-default-legend",
        style: o
      }, this.renderItems());
    }
  }]);
}(Gs);
u7(RA, "displayName", "Legend");
u7(RA, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var k0, OS;
function G5e() {
  if (OS) return k0;
  OS = 1;
  var e = ZY();
  function r() {
    this.__data__ = new e(), this.size = 0;
  }
  return k0 = r, k0;
}
var O0, DS;
function U5e() {
  if (DS) return O0;
  DS = 1;
  function e(r) {
    var t = this.__data__, i = t.delete(r);
    return this.size = t.size, i;
  }
  return O0 = e, O0;
}
var D0, RS;
function Z5e() {
  if (RS) return D0;
  RS = 1;
  function e(r) {
    return this.__data__.get(r);
  }
  return D0 = e, D0;
}
var R0, IS;
function J5e() {
  if (IS) return R0;
  IS = 1;
  function e(r) {
    return this.__data__.has(r);
  }
  return R0 = e, R0;
}
var I0, LS;
function $5e() {
  if (LS) return I0;
  LS = 1;
  var e = ZY(), r = CA(), t = PA(), i = 200;
  function n(s, u) {
    var o = this.__data__;
    if (o instanceof e) {
      var d = o.__data__;
      if (!r || d.length < i - 1)
        return d.push([s, u]), this.size = ++o.size, this;
      o = this.__data__ = new t(d);
    }
    return o.set(s, u), this.size = o.size, this;
  }
  return I0 = n, I0;
}
var L0, _S;
function XZ() {
  if (_S) return L0;
  _S = 1;
  var e = ZY(), r = G5e(), t = U5e(), i = Z5e(), n = J5e(), s = $5e();
  function u(o) {
    var d = this.__data__ = new e(o);
    this.size = d.size;
  }
  return u.prototype.clear = r, u.prototype.delete = t, u.prototype.get = i, u.prototype.has = n, u.prototype.set = s, L0 = u, L0;
}
var _0, HS;
function Q5e() {
  if (HS) return _0;
  HS = 1;
  var e = "__lodash_hash_undefined__";
  function r(t) {
    return this.__data__.set(t, e), this;
  }
  return _0 = r, _0;
}
var H0, jS;
function e6e() {
  if (jS) return H0;
  jS = 1;
  function e(r) {
    return this.__data__.has(r);
  }
  return H0 = e, H0;
}
var j0, zS;
function qZ() {
  if (zS) return j0;
  zS = 1;
  var e = PA(), r = Q5e(), t = e6e();
  function i(n) {
    var s = -1, u = n == null ? 0 : n.length;
    for (this.__data__ = new e(); ++s < u; )
      this.add(n[s]);
  }
  return i.prototype.add = i.prototype.push = r, i.prototype.has = t, j0 = i, j0;
}
var z0, BS;
function YZ() {
  if (BS) return z0;
  BS = 1;
  function e(r, t) {
    for (var i = -1, n = r == null ? 0 : r.length; ++i < n; )
      if (t(r[i], i, r))
        return !0;
    return !1;
  }
  return z0 = e, z0;
}
var B0, WS;
function fZ() {
  if (WS) return B0;
  WS = 1;
  function e(r, t) {
    return r.has(t);
  }
  return B0 = e, B0;
}
var W0, GS;
function KZ() {
  if (GS) return W0;
  GS = 1;
  var e = qZ(), r = YZ(), t = fZ(), i = 1, n = 2;
  function s(u, o, d, a, V, c) {
    var F = d & i, X = u.length, Y = o.length;
    if (X != Y && !(F && Y > X))
      return !1;
    var q = c.get(u), f = c.get(o);
    if (q && f)
      return q == o && f == u;
    var p = -1, m = !0, g = d & n ? new e() : void 0;
    for (c.set(u, o), c.set(o, u); ++p < X; ) {
      var y = u[p], b = o[p];
      if (a)
        var A = F ? a(b, y, p, o, u, c) : a(y, b, p, u, o, c);
      if (A !== void 0) {
        if (A)
          continue;
        m = !1;
        break;
      }
      if (g) {
        if (!r(o, function(w, S) {
          if (!t(g, S) && (y === w || V(y, w, d, a, c)))
            return g.push(S);
        })) {
          m = !1;
          break;
        }
      } else if (!(y === b || V(y, b, d, a, c))) {
        m = !1;
        break;
      }
    }
    return c.delete(u), c.delete(o), m;
  }
  return W0 = s, W0;
}
var G0, US;
function r6e() {
  if (US) return G0;
  US = 1;
  var e = eu(), r = e.Uint8Array;
  return G0 = r, G0;
}
var U0, ZS;
function t6e() {
  if (ZS) return U0;
  ZS = 1;
  function e(r) {
    var t = -1, i = Array(r.size);
    return r.forEach(function(n, s) {
      i[++t] = [s, n];
    }), i;
  }
  return U0 = e, U0;
}
var Z0, JS;
function IA() {
  if (JS) return Z0;
  JS = 1;
  function e(r) {
    var t = -1, i = Array(r.size);
    return r.forEach(function(n) {
      i[++t] = n;
    }), i;
  }
  return Z0 = e, Z0;
}
var J0, $S;
function i6e() {
  if ($S) return J0;
  $S = 1;
  var e = A2(), r = r6e(), t = wA(), i = KZ(), n = t6e(), s = IA(), u = 1, o = 2, d = "[object Boolean]", a = "[object Date]", V = "[object Error]", c = "[object Map]", F = "[object Number]", X = "[object RegExp]", Y = "[object Set]", q = "[object String]", f = "[object Symbol]", p = "[object ArrayBuffer]", m = "[object DataView]", g = e ? e.prototype : void 0, y = g ? g.valueOf : void 0;
  function b(A, w, S, N, O, E, I) {
    switch (S) {
      case m:
        if (A.byteLength != w.byteLength || A.byteOffset != w.byteOffset)
          return !1;
        A = A.buffer, w = w.buffer;
      case p:
        return !(A.byteLength != w.byteLength || !E(new r(A), new r(w)));
      case d:
      case a:
      case F:
        return t(+A, +w);
      case V:
        return A.name == w.name && A.message == w.message;
      case X:
      case q:
        return A == w + "";
      case c:
        var R = n;
      case Y:
        var H = N & u;
        if (R || (R = s), A.size != w.size && !H)
          return !1;
        var W = I.get(A);
        if (W)
          return W == w;
        N |= o, I.set(A, w);
        var B = i(R(A), R(w), N, O, E, I);
        return I.delete(A), B;
      case f:
        if (y)
          return y.call(A) == y.call(w);
    }
    return !1;
  }
  return J0 = b, J0;
}
var $0, QS;
function hZ() {
  if (QS) return $0;
  QS = 1;
  function e(r, t) {
    for (var i = -1, n = t.length, s = r.length; ++i < n; )
      r[s + i] = t[i];
    return r;
  }
  return $0 = e, $0;
}
var Q0, eN;
function n6e() {
  if (eN) return Q0;
  eN = 1;
  var e = hZ(), r = Qi();
  function t(i, n, s) {
    var u = n(i);
    return r(i) ? u : e(u, s(i));
  }
  return Q0 = t, Q0;
}
var e1, rN;
function s6e() {
  if (rN) return e1;
  rN = 1;
  function e(r, t) {
    for (var i = -1, n = r == null ? 0 : r.length, s = 0, u = []; ++i < n; ) {
      var o = r[i];
      t(o, i, r) && (u[s++] = o);
    }
    return u;
  }
  return e1 = e, e1;
}
var r1, tN;
function u6e() {
  if (tN) return r1;
  tN = 1;
  function e() {
    return [];
  }
  return r1 = e, r1;
}
var t1, iN;
function o6e() {
  if (iN) return t1;
  iN = 1;
  var e = s6e(), r = u6e(), t = Object.prototype, i = t.propertyIsEnumerable, n = Object.getOwnPropertySymbols, s = n ? function(u) {
    return u == null ? [] : (u = Object(u), e(n(u), function(o) {
      return i.call(u, o);
    }));
  } : r;
  return t1 = s, t1;
}
var i1, nN;
function d6e() {
  if (nN) return i1;
  nN = 1;
  function e(r, t) {
    for (var i = -1, n = Array(r); ++i < r; )
      n[i] = t(i);
    return n;
  }
  return i1 = e, i1;
}
var n1, sN;
function a6e() {
  if (sN) return n1;
  sN = 1;
  var e = Uu(), r = Zu(), t = "[object Arguments]";
  function i(n) {
    return r(n) && e(n) == t;
  }
  return n1 = i, n1;
}
var s1, uN;
function LA() {
  if (uN) return s1;
  uN = 1;
  var e = a6e(), r = Zu(), t = Object.prototype, i = t.hasOwnProperty, n = t.propertyIsEnumerable, s = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(u) {
    return r(u) && i.call(u, "callee") && !n.call(u, "callee");
  };
  return s1 = s, s1;
}
var wc = { exports: {} }, u1, oN;
function V6e() {
  if (oN) return u1;
  oN = 1;
  function e() {
    return !1;
  }
  return u1 = e, u1;
}
wc.exports;
var dN;
function pZ() {
  return dN || (dN = 1, function(e, r) {
    var t = eu(), i = V6e(), n = r && !r.nodeType && r, s = n && !0 && e && !e.nodeType && e, u = s && s.exports === n, o = u ? t.Buffer : void 0, d = o ? o.isBuffer : void 0, a = d || i;
    e.exports = a;
  }(wc, wc.exports)), wc.exports;
}
var o1, aN;
function _A() {
  if (aN) return o1;
  aN = 1;
  var e = 9007199254740991, r = /^(?:0|[1-9]\d*)$/;
  function t(i, n) {
    var s = typeof i;
    return n = n ?? e, !!n && (s == "number" || s != "symbol" && r.test(i)) && i > -1 && i % 1 == 0 && i < n;
  }
  return o1 = t, o1;
}
var d1, VN;
function HA() {
  if (VN) return d1;
  VN = 1;
  var e = 9007199254740991;
  function r(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= e;
  }
  return d1 = r, d1;
}
var a1, lN;
function l6e() {
  if (lN) return a1;
  lN = 1;
  var e = Uu(), r = HA(), t = Zu(), i = "[object Arguments]", n = "[object Array]", s = "[object Boolean]", u = "[object Date]", o = "[object Error]", d = "[object Function]", a = "[object Map]", V = "[object Number]", c = "[object Object]", F = "[object RegExp]", X = "[object Set]", Y = "[object String]", q = "[object WeakMap]", f = "[object ArrayBuffer]", p = "[object DataView]", m = "[object Float32Array]", g = "[object Float64Array]", y = "[object Int8Array]", b = "[object Int16Array]", A = "[object Int32Array]", w = "[object Uint8Array]", S = "[object Uint8ClampedArray]", N = "[object Uint16Array]", O = "[object Uint32Array]", E = {};
  E[m] = E[g] = E[y] = E[b] = E[A] = E[w] = E[S] = E[N] = E[O] = !0, E[i] = E[n] = E[f] = E[s] = E[p] = E[u] = E[o] = E[d] = E[a] = E[V] = E[c] = E[F] = E[X] = E[Y] = E[q] = !1;
  function I(R) {
    return t(R) && r(R.length) && !!E[e(R)];
  }
  return a1 = I, a1;
}
var V1, cN;
function mZ() {
  if (cN) return V1;
  cN = 1;
  function e(r) {
    return function(t) {
      return r(t);
    };
  }
  return V1 = e, V1;
}
var Cc = { exports: {} };
Cc.exports;
var FN;
function c6e() {
  return FN || (FN = 1, function(e, r) {
    var t = _U(), i = r && !r.nodeType && r, n = i && !0 && e && !e.nodeType && e, s = n && n.exports === i, u = s && t.process, o = function() {
      try {
        var d = n && n.require && n.require("util").types;
        return d || u && u.binding && u.binding("util");
      } catch {
      }
    }();
    e.exports = o;
  }(Cc, Cc.exports)), Cc.exports;
}
var l1, xN;
function gZ() {
  if (xN) return l1;
  xN = 1;
  var e = l6e(), r = mZ(), t = c6e(), i = t && t.isTypedArray, n = i ? r(i) : e;
  return l1 = n, l1;
}
var c1, XN;
function F6e() {
  if (XN) return c1;
  XN = 1;
  var e = d6e(), r = LA(), t = Qi(), i = pZ(), n = _A(), s = gZ(), u = Object.prototype, o = u.hasOwnProperty;
  function d(a, V) {
    var c = t(a), F = !c && r(a), X = !c && !F && i(a), Y = !c && !F && !X && s(a), q = c || F || X || Y, f = q ? e(a.length, String) : [], p = f.length;
    for (var m in a)
      (V || o.call(a, m)) && !(q && // Safari 9 has enumerable `arguments.length` in strict mode.
      (m == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      X && (m == "offset" || m == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      Y && (m == "buffer" || m == "byteLength" || m == "byteOffset") || // Skip index properties.
      n(m, p))) && f.push(m);
    return f;
  }
  return c1 = d, c1;
}
var F1, qN;
function x6e() {
  if (qN) return F1;
  qN = 1;
  var e = Object.prototype;
  function r(t) {
    var i = t && t.constructor, n = typeof i == "function" && i.prototype || e;
    return t === n;
  }
  return F1 = r, F1;
}
var x1, YN;
function vZ() {
  if (YN) return x1;
  YN = 1;
  function e(r, t) {
    return function(i) {
      return r(t(i));
    };
  }
  return x1 = e, x1;
}
var X1, fN;
function X6e() {
  if (fN) return X1;
  fN = 1;
  var e = vZ(), r = e(Object.keys, Object);
  return X1 = r, X1;
}
var q1, KN;
function q6e() {
  if (KN) return q1;
  KN = 1;
  var e = x6e(), r = X6e(), t = Object.prototype, i = t.hasOwnProperty;
  function n(s) {
    if (!e(s))
      return r(s);
    var u = [];
    for (var o in Object(s))
      i.call(s, o) && o != "constructor" && u.push(o);
    return u;
  }
  return q1 = n, q1;
}
var Y1, hN;
function P2() {
  if (hN) return Y1;
  hN = 1;
  var e = AA(), r = HA();
  function t(i) {
    return i != null && r(i.length) && !e(i);
  }
  return Y1 = t, Y1;
}
var f1, pN;
function sf() {
  if (pN) return f1;
  pN = 1;
  var e = F6e(), r = q6e(), t = P2();
  function i(n) {
    return t(n) ? e(n) : r(n);
  }
  return f1 = i, f1;
}
var K1, mN;
function Y6e() {
  if (mN) return K1;
  mN = 1;
  var e = n6e(), r = o6e(), t = sf();
  function i(n) {
    return e(n, t, r);
  }
  return K1 = i, K1;
}
var h1, gN;
function f6e() {
  if (gN) return h1;
  gN = 1;
  var e = Y6e(), r = 1, t = Object.prototype, i = t.hasOwnProperty;
  function n(s, u, o, d, a, V) {
    var c = o & r, F = e(s), X = F.length, Y = e(u), q = Y.length;
    if (X != q && !c)
      return !1;
    for (var f = X; f--; ) {
      var p = F[f];
      if (!(c ? p in u : i.call(u, p)))
        return !1;
    }
    var m = V.get(s), g = V.get(u);
    if (m && g)
      return m == u && g == s;
    var y = !0;
    V.set(s, u), V.set(u, s);
    for (var b = c; ++f < X; ) {
      p = F[f];
      var A = s[p], w = u[p];
      if (d)
        var S = c ? d(w, A, p, u, s, V) : d(A, w, p, s, u, V);
      if (!(S === void 0 ? A === w || a(A, w, o, d, V) : S)) {
        y = !1;
        break;
      }
      b || (b = p == "constructor");
    }
    if (y && !b) {
      var N = s.constructor, O = u.constructor;
      N != O && "constructor" in s && "constructor" in u && !(typeof N == "function" && N instanceof N && typeof O == "function" && O instanceof O) && (y = !1);
    }
    return V.delete(s), V.delete(u), y;
  }
  return h1 = n, h1;
}
var p1, vN;
function K6e() {
  if (vN) return p1;
  vN = 1;
  var e = ca(), r = eu(), t = e(r, "DataView");
  return p1 = t, p1;
}
var m1, bN;
function h6e() {
  if (bN) return m1;
  bN = 1;
  var e = ca(), r = eu(), t = e(r, "Promise");
  return m1 = t, m1;
}
var g1, yN;
function bZ() {
  if (yN) return g1;
  yN = 1;
  var e = ca(), r = eu(), t = e(r, "Set");
  return g1 = t, g1;
}
var v1, AN;
function p6e() {
  if (AN) return v1;
  AN = 1;
  var e = ca(), r = eu(), t = e(r, "WeakMap");
  return v1 = t, v1;
}
var b1, wN;
function m6e() {
  if (wN) return b1;
  wN = 1;
  var e = K6e(), r = CA(), t = h6e(), i = bZ(), n = p6e(), s = Uu(), u = HU(), o = "[object Map]", d = "[object Object]", a = "[object Promise]", V = "[object Set]", c = "[object WeakMap]", F = "[object DataView]", X = u(e), Y = u(r), q = u(t), f = u(i), p = u(n), m = s;
  return (e && m(new e(new ArrayBuffer(1))) != F || r && m(new r()) != o || t && m(t.resolve()) != a || i && m(new i()) != V || n && m(new n()) != c) && (m = function(g) {
    var y = s(g), b = y == d ? g.constructor : void 0, A = b ? u(b) : "";
    if (A)
      switch (A) {
        case X:
          return F;
        case Y:
          return o;
        case q:
          return a;
        case f:
          return V;
        case p:
          return c;
      }
    return y;
  }), b1 = m, b1;
}
var y1, CN;
function g6e() {
  if (CN) return y1;
  CN = 1;
  var e = XZ(), r = KZ(), t = i6e(), i = f6e(), n = m6e(), s = Qi(), u = pZ(), o = gZ(), d = 1, a = "[object Arguments]", V = "[object Array]", c = "[object Object]", F = Object.prototype, X = F.hasOwnProperty;
  function Y(q, f, p, m, g, y) {
    var b = s(q), A = s(f), w = b ? V : n(q), S = A ? V : n(f);
    w = w == a ? c : w, S = S == a ? c : S;
    var N = w == c, O = S == c, E = w == S;
    if (E && u(q)) {
      if (!u(f))
        return !1;
      b = !0, N = !1;
    }
    if (E && !N)
      return y || (y = new e()), b || o(q) ? r(q, f, p, m, g, y) : t(q, f, w, p, m, g, y);
    if (!(p & d)) {
      var I = N && X.call(q, "__wrapped__"), R = O && X.call(f, "__wrapped__");
      if (I || R) {
        var H = I ? q.value() : q, W = R ? f.value() : f;
        return y || (y = new e()), g(H, W, p, m, y);
      }
    }
    return E ? (y || (y = new e()), i(q, f, p, m, g, y)) : !1;
  }
  return y1 = Y, y1;
}
var A1, PN;
function jA() {
  if (PN) return A1;
  PN = 1;
  var e = g6e(), r = Zu();
  function t(i, n, s, u, o) {
    return i === n ? !0 : i == null || n == null || !r(i) && !r(n) ? i !== i && n !== n : e(i, n, s, u, t, o);
  }
  return A1 = t, A1;
}
var w1, SN;
function v6e() {
  if (SN) return w1;
  SN = 1;
  var e = XZ(), r = jA(), t = 1, i = 2;
  function n(s, u, o, d) {
    var a = o.length, V = a, c = !d;
    if (s == null)
      return !V;
    for (s = Object(s); a--; ) {
      var F = o[a];
      if (c && F[2] ? F[1] !== s[F[0]] : !(F[0] in s))
        return !1;
    }
    for (; ++a < V; ) {
      F = o[a];
      var X = F[0], Y = s[X], q = F[1];
      if (c && F[2]) {
        if (Y === void 0 && !(X in s))
          return !1;
      } else {
        var f = new e();
        if (d)
          var p = d(Y, q, X, s, u, f);
        if (!(p === void 0 ? r(q, Y, t | i, d, f) : p))
          return !1;
      }
    }
    return !0;
  }
  return w1 = n, w1;
}
var C1, NN;
function yZ() {
  if (NN) return C1;
  NN = 1;
  var e = Qo();
  function r(t) {
    return t === t && !e(t);
  }
  return C1 = r, C1;
}
var P1, MN;
function b6e() {
  if (MN) return P1;
  MN = 1;
  var e = yZ(), r = sf();
  function t(i) {
    for (var n = r(i), s = n.length; s--; ) {
      var u = n[s], o = i[u];
      n[s] = [u, o, e(o)];
    }
    return n;
  }
  return P1 = t, P1;
}
var S1, TN;
function AZ() {
  if (TN) return S1;
  TN = 1;
  function e(r, t) {
    return function(i) {
      return i == null ? !1 : i[r] === t && (t !== void 0 || r in Object(i));
    };
  }
  return S1 = e, S1;
}
var N1, EN;
function y6e() {
  if (EN) return N1;
  EN = 1;
  var e = v6e(), r = b6e(), t = AZ();
  function i(n) {
    var s = r(n);
    return s.length == 1 && s[0][2] ? t(s[0][0], s[0][1]) : function(u) {
      return u === n || e(u, n, s);
    };
  }
  return N1 = i, N1;
}
var M1, kN;
function A6e() {
  if (kN) return M1;
  kN = 1;
  function e(r, t) {
    return r != null && t in Object(r);
  }
  return M1 = e, M1;
}
var T1, ON;
function w6e() {
  if (ON) return T1;
  ON = 1;
  var e = BU(), r = LA(), t = Qi(), i = _A(), n = HA(), s = $Y();
  function u(o, d, a) {
    d = e(d, o);
    for (var V = -1, c = d.length, F = !1; ++V < c; ) {
      var X = s(d[V]);
      if (!(F = o != null && a(o, X)))
        break;
      o = o[X];
    }
    return F || ++V != c ? F : (c = o == null ? 0 : o.length, !!c && n(c) && i(X, c) && (t(o) || r(o)));
  }
  return T1 = u, T1;
}
var E1, DN;
function C6e() {
  if (DN) return E1;
  DN = 1;
  var e = A6e(), r = w6e();
  function t(i, n) {
    return i != null && r(i, n, e);
  }
  return E1 = t, E1;
}
var k1, RN;
function P6e() {
  if (RN) return k1;
  RN = 1;
  var e = jA(), r = WU(), t = C6e(), i = yA(), n = yZ(), s = AZ(), u = $Y(), o = 1, d = 2;
  function a(V, c) {
    return i(V) && n(c) ? s(u(V), c) : function(F) {
      var X = r(F, V);
      return X === void 0 && X === c ? t(F, V) : e(c, X, o | d);
    };
  }
  return k1 = a, k1;
}
var O1, IN;
function Nl() {
  if (IN) return O1;
  IN = 1;
  function e(r) {
    return r;
  }
  return O1 = e, O1;
}
var D1, LN;
function S6e() {
  if (LN) return D1;
  LN = 1;
  function e(r) {
    return function(t) {
      return t == null ? void 0 : t[r];
    };
  }
  return D1 = e, D1;
}
var R1, _N;
function N6e() {
  if (_N) return R1;
  _N = 1;
  var e = NA();
  function r(t) {
    return function(i) {
      return e(i, t);
    };
  }
  return R1 = r, R1;
}
var I1, HN;
function M6e() {
  if (HN) return I1;
  HN = 1;
  var e = S6e(), r = N6e(), t = yA(), i = $Y();
  function n(s) {
    return t(s) ? e(i(s)) : r(s);
  }
  return I1 = n, I1;
}
var L1, jN;
function ru() {
  if (jN) return L1;
  jN = 1;
  var e = y6e(), r = P6e(), t = Nl(), i = Qi(), n = M6e();
  function s(u) {
    return typeof u == "function" ? u : u == null ? t : typeof u == "object" ? i(u) ? r(u[0], u[1]) : e(u) : n(u);
  }
  return L1 = s, L1;
}
var _1, zN;
function wZ() {
  if (zN) return _1;
  zN = 1;
  function e(r, t, i, n) {
    for (var s = r.length, u = i + (n ? 1 : -1); n ? u-- : ++u < s; )
      if (t(r[u], u, r))
        return u;
    return -1;
  }
  return _1 = e, _1;
}
var H1, BN;
function T6e() {
  if (BN) return H1;
  BN = 1;
  function e(r) {
    return r !== r;
  }
  return H1 = e, H1;
}
var j1, WN;
function E6e() {
  if (WN) return j1;
  WN = 1;
  function e(r, t, i) {
    for (var n = i - 1, s = r.length; ++n < s; )
      if (r[n] === t)
        return n;
    return -1;
  }
  return j1 = e, j1;
}
var z1, GN;
function k6e() {
  if (GN) return z1;
  GN = 1;
  var e = wZ(), r = T6e(), t = E6e();
  function i(n, s, u) {
    return s === s ? t(n, s, u) : e(n, r, u);
  }
  return z1 = i, z1;
}
var B1, UN;
function O6e() {
  if (UN) return B1;
  UN = 1;
  var e = k6e();
  function r(t, i) {
    var n = t == null ? 0 : t.length;
    return !!n && e(t, i, 0) > -1;
  }
  return B1 = r, B1;
}
var W1, ZN;
function D6e() {
  if (ZN) return W1;
  ZN = 1;
  function e(r, t, i) {
    for (var n = -1, s = r == null ? 0 : r.length; ++n < s; )
      if (i(t, r[n]))
        return !0;
    return !1;
  }
  return W1 = e, W1;
}
var G1, JN;
function R6e() {
  if (JN) return G1;
  JN = 1;
  function e() {
  }
  return G1 = e, G1;
}
var U1, $N;
function I6e() {
  if ($N) return U1;
  $N = 1;
  var e = bZ(), r = R6e(), t = IA(), i = 1 / 0, n = e && 1 / t(new e([, -0]))[1] == i ? function(s) {
    return new e(s);
  } : r;
  return U1 = n, U1;
}
var Z1, QN;
function L6e() {
  if (QN) return Z1;
  QN = 1;
  var e = qZ(), r = O6e(), t = D6e(), i = fZ(), n = I6e(), s = IA(), u = 200;
  function o(d, a, V) {
    var c = -1, F = r, X = d.length, Y = !0, q = [], f = q;
    if (V)
      Y = !1, F = t;
    else if (X >= u) {
      var p = a ? null : n(d);
      if (p)
        return s(p);
      Y = !1, F = i, f = new e();
    } else
      f = a ? [] : q;
    e:
      for (; ++c < X; ) {
        var m = d[c], g = a ? a(m) : m;
        if (m = V || m !== 0 ? m : 0, Y && g === g) {
          for (var y = f.length; y--; )
            if (f[y] === g)
              continue e;
          a && f.push(g), q.push(m);
        } else F(f, g, V) || (f !== q && f.push(g), q.push(m));
      }
    return q;
  }
  return Z1 = o, Z1;
}
var J1, eM;
function _6e() {
  if (eM) return J1;
  eM = 1;
  var e = ru(), r = L6e();
  function t(i, n) {
    return i && i.length ? r(i, e(n, 2)) : [];
  }
  return J1 = t, J1;
}
var H6e = _6e();
const rM = /* @__PURE__ */ Mr(H6e);
function CZ(e, r, t) {
  return r === !0 ? rM(e, t) : Ue(r) ? rM(e, r) : e;
}
function DV(e) {
  "@babel/helpers - typeof";
  return DV = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, DV(e);
}
var j6e = ["ref"];
function tM(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function Yu(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? tM(Object(t), !0).forEach(function(i) {
      uf(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : tM(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function z6e(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function iM(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, SZ(i.key), i);
  }
}
function B6e(e, r, t) {
  return r && iM(e.prototype, r), t && iM(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function W6e(e, r, t) {
  return r = mX(r), G6e(e, PZ() ? Reflect.construct(r, t || [], mX(e).constructor) : r.apply(e, t));
}
function G6e(e, r) {
  if (r && (DV(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return U6e(e);
}
function U6e(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function PZ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (PZ = function() {
    return !!e;
  })();
}
function mX(e) {
  return mX = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, mX(e);
}
function Z6e(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && k8(e, r);
}
function k8(e, r) {
  return k8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, k8(e, r);
}
function uf(e, r, t) {
  return r = SZ(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function SZ(e) {
  var r = J6e(e, "string");
  return DV(r) == "symbol" ? r : r + "";
}
function J6e(e, r) {
  if (DV(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (DV(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function $6e(e, r) {
  if (e == null) return {};
  var t = Q6e(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function Q6e(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
function ewe(e) {
  return e.value;
}
function rwe(e, r) {
  if (/* @__PURE__ */ D.isValidElement(e))
    return /* @__PURE__ */ D.cloneElement(e, r);
  if (typeof e == "function")
    return /* @__PURE__ */ D.createElement(e, r);
  r.ref;
  var t = $6e(r, j6e);
  return /* @__PURE__ */ D.createElement(RA, t);
}
var nM = 1, zi = /* @__PURE__ */ function(e) {
  function r() {
    var t;
    z6e(this, r);
    for (var i = arguments.length, n = new Array(i), s = 0; s < i; s++)
      n[s] = arguments[s];
    return t = W6e(this, r, [].concat(n)), uf(t, "lastBoundingBox", {
      width: -1,
      height: -1
    }), t;
  }
  return Z6e(r, e), B6e(r, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var i = this.wrapperNode.getBoundingClientRect();
        return i.height = this.wrapperNode.offsetHeight, i.width = this.wrapperNode.offsetWidth, i;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var i = this.props.onBBoxUpdate, n = this.getBBox();
      n ? (Math.abs(n.width - this.lastBoundingBox.width) > nM || Math.abs(n.height - this.lastBoundingBox.height) > nM) && (this.lastBoundingBox.width = n.width, this.lastBoundingBox.height = n.height, i && i(n)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, i && i(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? Yu({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(i) {
      var n = this.props, s = n.layout, u = n.align, o = n.verticalAlign, d = n.margin, a = n.chartWidth, V = n.chartHeight, c, F;
      if (!i || (i.left === void 0 || i.left === null) && (i.right === void 0 || i.right === null))
        if (u === "center" && s === "vertical") {
          var X = this.getBBoxSnapshot();
          c = {
            left: ((a || 0) - X.width) / 2
          };
        } else
          c = u === "right" ? {
            right: d && d.right || 0
          } : {
            left: d && d.left || 0
          };
      if (!i || (i.top === void 0 || i.top === null) && (i.bottom === void 0 || i.bottom === null))
        if (o === "middle") {
          var Y = this.getBBoxSnapshot();
          F = {
            top: ((V || 0) - Y.height) / 2
          };
        } else
          F = o === "bottom" ? {
            bottom: d && d.bottom || 0
          } : {
            top: d && d.top || 0
          };
      return Yu(Yu({}, c), F);
    }
  }, {
    key: "render",
    value: function() {
      var i = this, n = this.props, s = n.content, u = n.width, o = n.height, d = n.wrapperStyle, a = n.payloadUniqBy, V = n.payload, c = Yu(Yu({
        position: "absolute",
        width: u || "auto",
        height: o || "auto"
      }, this.getDefaultPosition(d)), d);
      return /* @__PURE__ */ D.createElement("div", {
        className: "recharts-legend-wrapper",
        style: c,
        ref: function(X) {
          i.wrapperNode = X;
        }
      }, rwe(s, Yu(Yu({}, this.props), {}, {
        payload: CZ(V, a, ewe)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(i, n) {
      var s = Yu(Yu({}, this.defaultProps), i.props), u = s.layout;
      return u === "vertical" && pe(i.props.height) ? {
        height: i.props.height
      } : u === "horizontal" ? {
        width: i.props.width || n
      } : null;
    }
  }]);
}(Gs);
uf(zi, "displayName", "Legend");
uf(zi, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var $1, sM;
function twe() {
  if (sM) return $1;
  sM = 1;
  var e = A2(), r = LA(), t = Qi(), i = e ? e.isConcatSpreadable : void 0;
  function n(s) {
    return t(s) || r(s) || !!(i && s && s[i]);
  }
  return $1 = n, $1;
}
var Q1, uM;
function NZ() {
  if (uM) return Q1;
  uM = 1;
  var e = hZ(), r = twe();
  function t(i, n, s, u, o) {
    var d = -1, a = i.length;
    for (s || (s = r), o || (o = []); ++d < a; ) {
      var V = i[d];
      n > 0 && s(V) ? n > 1 ? t(V, n - 1, s, u, o) : e(o, V) : u || (o[o.length] = V);
    }
    return o;
  }
  return Q1 = t, Q1;
}
var em, oM;
function iwe() {
  if (oM) return em;
  oM = 1;
  function e(r) {
    return function(t, i, n) {
      for (var s = -1, u = Object(t), o = n(t), d = o.length; d--; ) {
        var a = o[r ? d : ++s];
        if (i(u[a], a, u) === !1)
          break;
      }
      return t;
    };
  }
  return em = e, em;
}
var rm, dM;
function nwe() {
  if (dM) return rm;
  dM = 1;
  var e = iwe(), r = e();
  return rm = r, rm;
}
var tm, aM;
function MZ() {
  if (aM) return tm;
  aM = 1;
  var e = nwe(), r = sf();
  function t(i, n) {
    return i && e(i, n, r);
  }
  return tm = t, tm;
}
var im, VM;
function swe() {
  if (VM) return im;
  VM = 1;
  var e = P2();
  function r(t, i) {
    return function(n, s) {
      if (n == null)
        return n;
      if (!e(n))
        return t(n, s);
      for (var u = n.length, o = i ? u : -1, d = Object(n); (i ? o-- : ++o < u) && s(d[o], o, d) !== !1; )
        ;
      return n;
    };
  }
  return im = r, im;
}
var nm, lM;
function zA() {
  if (lM) return nm;
  lM = 1;
  var e = MZ(), r = swe(), t = r(e);
  return nm = t, nm;
}
var sm, cM;
function TZ() {
  if (cM) return sm;
  cM = 1;
  var e = zA(), r = P2();
  function t(i, n) {
    var s = -1, u = r(i) ? Array(i.length) : [];
    return e(i, function(o, d, a) {
      u[++s] = n(o, d, a);
    }), u;
  }
  return sm = t, sm;
}
var um, FM;
function uwe() {
  if (FM) return um;
  FM = 1;
  function e(r, t) {
    var i = r.length;
    for (r.sort(t); i--; )
      r[i] = r[i].value;
    return r;
  }
  return um = e, um;
}
var om, xM;
function owe() {
  if (xM) return om;
  xM = 1;
  var e = Pl();
  function r(t, i) {
    if (t !== i) {
      var n = t !== void 0, s = t === null, u = t === t, o = e(t), d = i !== void 0, a = i === null, V = i === i, c = e(i);
      if (!a && !c && !o && t > i || o && d && V && !a && !c || s && d && V || !n && V || !u)
        return 1;
      if (!s && !o && !c && t < i || c && n && u && !s && !o || a && n && u || !d && u || !V)
        return -1;
    }
    return 0;
  }
  return om = r, om;
}
var dm, XM;
function dwe() {
  if (XM) return dm;
  XM = 1;
  var e = owe();
  function r(t, i, n) {
    for (var s = -1, u = t.criteria, o = i.criteria, d = u.length, a = n.length; ++s < d; ) {
      var V = e(u[s], o[s]);
      if (V) {
        if (s >= a)
          return V;
        var c = n[s];
        return V * (c == "desc" ? -1 : 1);
      }
    }
    return t.index - i.index;
  }
  return dm = r, dm;
}
var am, qM;
function awe() {
  if (qM) return am;
  qM = 1;
  var e = SA(), r = NA(), t = ru(), i = TZ(), n = uwe(), s = mZ(), u = dwe(), o = Nl(), d = Qi();
  function a(V, c, F) {
    c.length ? c = e(c, function(q) {
      return d(q) ? function(f) {
        return r(f, q.length === 1 ? q[0] : q);
      } : q;
    }) : c = [o];
    var X = -1;
    c = e(c, s(t));
    var Y = i(V, function(q, f, p) {
      var m = e(c, function(g) {
        return g(q);
      });
      return { criteria: m, index: ++X, value: q };
    });
    return n(Y, function(q, f) {
      return u(q, f, F);
    });
  }
  return am = a, am;
}
var Vm, YM;
function Vwe() {
  if (YM) return Vm;
  YM = 1;
  function e(r, t, i) {
    switch (i.length) {
      case 0:
        return r.call(t);
      case 1:
        return r.call(t, i[0]);
      case 2:
        return r.call(t, i[0], i[1]);
      case 3:
        return r.call(t, i[0], i[1], i[2]);
    }
    return r.apply(t, i);
  }
  return Vm = e, Vm;
}
var lm, fM;
function lwe() {
  if (fM) return lm;
  fM = 1;
  var e = Vwe(), r = Math.max;
  function t(i, n, s) {
    return n = r(n === void 0 ? i.length - 1 : n, 0), function() {
      for (var u = arguments, o = -1, d = r(u.length - n, 0), a = Array(d); ++o < d; )
        a[o] = u[n + o];
      o = -1;
      for (var V = Array(n + 1); ++o < n; )
        V[o] = u[o];
      return V[n] = s(a), e(i, this, V);
    };
  }
  return lm = t, lm;
}
var cm, KM;
function cwe() {
  if (KM) return cm;
  KM = 1;
  function e(r) {
    return function() {
      return r;
    };
  }
  return cm = e, cm;
}
var Fm, hM;
function EZ() {
  if (hM) return Fm;
  hM = 1;
  var e = ca(), r = function() {
    try {
      var t = e(Object, "defineProperty");
      return t({}, "", {}), t;
    } catch {
    }
  }();
  return Fm = r, Fm;
}
var xm, pM;
function Fwe() {
  if (pM) return xm;
  pM = 1;
  var e = cwe(), r = EZ(), t = Nl(), i = r ? function(n, s) {
    return r(n, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(s),
      writable: !0
    });
  } : t;
  return xm = i, xm;
}
var Xm, mM;
function xwe() {
  if (mM) return Xm;
  mM = 1;
  var e = 800, r = 16, t = Date.now;
  function i(n) {
    var s = 0, u = 0;
    return function() {
      var o = t(), d = r - (o - u);
      if (u = o, d > 0) {
        if (++s >= e)
          return arguments[0];
      } else
        s = 0;
      return n.apply(void 0, arguments);
    };
  }
  return Xm = i, Xm;
}
var qm, gM;
function Xwe() {
  if (gM) return qm;
  gM = 1;
  var e = Fwe(), r = xwe(), t = r(e);
  return qm = t, qm;
}
var Ym, vM;
function qwe() {
  if (vM) return Ym;
  vM = 1;
  var e = Nl(), r = lwe(), t = Xwe();
  function i(n, s) {
    return t(r(n, s, e), n + "");
  }
  return Ym = i, Ym;
}
var fm, bM;
function of() {
  if (bM) return fm;
  bM = 1;
  var e = wA(), r = P2(), t = _A(), i = Qo();
  function n(s, u, o) {
    if (!i(o))
      return !1;
    var d = typeof u;
    return (d == "number" ? r(o) && t(u, o.length) : d == "string" && u in o) ? e(o[u], s) : !1;
  }
  return fm = n, fm;
}
var Km, yM;
function Ywe() {
  if (yM) return Km;
  yM = 1;
  var e = NZ(), r = awe(), t = qwe(), i = of(), n = t(function(s, u) {
    if (s == null)
      return [];
    var o = u.length;
    return o > 1 && i(s, u[0], u[1]) ? u = [] : o > 2 && i(u[0], u[1], u[2]) && (u = [u[0]]), r(s, e(u, 1), []);
  });
  return Km = n, Km;
}
var fwe = Ywe();
const BA = /* @__PURE__ */ Mr(fwe);
function o7(e) {
  "@babel/helpers - typeof";
  return o7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, o7(e);
}
function O8() {
  return O8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, O8.apply(this, arguments);
}
function Kwe(e, r) {
  return gwe(e) || mwe(e, r) || pwe(e, r) || hwe();
}
function hwe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pwe(e, r) {
  if (e) {
    if (typeof e == "string") return AM(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return AM(e, r);
  }
}
function AM(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
function mwe(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var i, n, s, u, o = [], d = !0, a = !1;
    try {
      if (s = (t = t.call(e)).next, r !== 0) for (; !(d = (i = s.call(t)).done) && (o.push(i.value), o.length !== r); d = !0) ;
    } catch (V) {
      a = !0, n = V;
    } finally {
      try {
        if (!d && t.return != null && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (a) throw n;
      }
    }
    return o;
  }
}
function gwe(e) {
  if (Array.isArray(e)) return e;
}
function wM(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function hm(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? wM(Object(t), !0).forEach(function(i) {
      vwe(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : wM(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function vwe(e, r, t) {
  return r = bwe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function bwe(e) {
  var r = ywe(e, "string");
  return o7(r) == "symbol" ? r : r + "";
}
function ywe(e, r) {
  if (o7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (o7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function Awe(e) {
  return Array.isArray(e) && Mt(e[0]) && Mt(e[1]) ? e.join(" ~ ") : e;
}
var wwe = function(r) {
  var t = r.separator, i = t === void 0 ? " : " : t, n = r.contentStyle, s = n === void 0 ? {} : n, u = r.itemStyle, o = u === void 0 ? {} : u, d = r.labelStyle, a = d === void 0 ? {} : d, V = r.payload, c = r.formatter, F = r.itemSorter, X = r.wrapperClassName, Y = r.labelClassName, q = r.label, f = r.labelFormatter, p = r.accessibilityLayer, m = p === void 0 ? !1 : p, g = function() {
    if (V && V.length) {
      var I = {
        padding: 0,
        margin: 0
      }, R = (F ? BA(V, F) : V).map(function(H, W) {
        if (H.type === "none")
          return null;
        var B = hm({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: H.color || "#000"
        }, o), L = H.formatter || c || Awe, z = H.value, Z = H.name, le = z, te = Z;
        if (L && le != null && te != null) {
          var U = L(z, Z, H, W, V);
          if (Array.isArray(U)) {
            var de = Kwe(U, 2);
            le = de[0], te = de[1];
          } else
            le = U;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ D.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(W),
            style: B
          }, Mt(te) ? /* @__PURE__ */ D.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, te) : null, Mt(te) ? /* @__PURE__ */ D.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, i) : null, /* @__PURE__ */ D.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, le), /* @__PURE__ */ D.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, H.unit || ""))
        );
      });
      return /* @__PURE__ */ D.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: I
      }, R);
    }
    return null;
  }, y = hm({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, s), b = hm({
    margin: 0
  }, a), A = !fr(q), w = A ? q : "", S = ur("recharts-default-tooltip", X), N = ur("recharts-tooltip-label", Y);
  A && f && V !== void 0 && V !== null && (w = f(q, V));
  var O = m ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ D.createElement("div", O8({
    className: S,
    style: y
  }, O), /* @__PURE__ */ D.createElement("p", {
    className: N,
    style: b
  }, /* @__PURE__ */ D.isValidElement(w) ? w : "".concat(w)), g());
};
function d7(e) {
  "@babel/helpers - typeof";
  return d7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, d7(e);
}
function lx(e, r, t) {
  return r = Cwe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Cwe(e) {
  var r = Pwe(e, "string");
  return d7(r) == "symbol" ? r : r + "";
}
function Pwe(e, r) {
  if (d7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (d7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
var lc = "recharts-tooltip-wrapper", Swe = {
  visibility: "hidden"
};
function Nwe(e) {
  var r = e.coordinate, t = e.translateX, i = e.translateY;
  return ur(lc, lx(lx(lx(lx({}, "".concat(lc, "-right"), pe(t) && r && pe(r.x) && t >= r.x), "".concat(lc, "-left"), pe(t) && r && pe(r.x) && t < r.x), "".concat(lc, "-bottom"), pe(i) && r && pe(r.y) && i >= r.y), "".concat(lc, "-top"), pe(i) && r && pe(r.y) && i < r.y));
}
function CM(e) {
  var r = e.allowEscapeViewBox, t = e.coordinate, i = e.key, n = e.offsetTopLeft, s = e.position, u = e.reverseDirection, o = e.tooltipDimension, d = e.viewBox, a = e.viewBoxDimension;
  if (s && pe(s[i]))
    return s[i];
  var V = t[i] - o - n, c = t[i] + n;
  if (r[i])
    return u[i] ? V : c;
  if (u[i]) {
    var F = V, X = d[i];
    return F < X ? Math.max(c, d[i]) : Math.max(V, d[i]);
  }
  var Y = c + o, q = d[i] + a;
  return Y > q ? Math.max(V, d[i]) : Math.max(c, d[i]);
}
function Mwe(e) {
  var r = e.translateX, t = e.translateY, i = e.useTranslate3d;
  return {
    transform: i ? "translate3d(".concat(r, "px, ").concat(t, "px, 0)") : "translate(".concat(r, "px, ").concat(t, "px)")
  };
}
function Twe(e) {
  var r = e.allowEscapeViewBox, t = e.coordinate, i = e.offsetTopLeft, n = e.position, s = e.reverseDirection, u = e.tooltipBox, o = e.useTranslate3d, d = e.viewBox, a, V, c;
  return u.height > 0 && u.width > 0 && t ? (V = CM({
    allowEscapeViewBox: r,
    coordinate: t,
    key: "x",
    offsetTopLeft: i,
    position: n,
    reverseDirection: s,
    tooltipDimension: u.width,
    viewBox: d,
    viewBoxDimension: d.width
  }), c = CM({
    allowEscapeViewBox: r,
    coordinate: t,
    key: "y",
    offsetTopLeft: i,
    position: n,
    reverseDirection: s,
    tooltipDimension: u.height,
    viewBox: d,
    viewBoxDimension: d.height
  }), a = Mwe({
    translateX: V,
    translateY: c,
    useTranslate3d: o
  })) : a = Swe, {
    cssProperties: a,
    cssClasses: Nwe({
      translateX: V,
      translateY: c,
      coordinate: t
    })
  };
}
function RV(e) {
  "@babel/helpers - typeof";
  return RV = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, RV(e);
}
function PM(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function SM(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? PM(Object(t), !0).forEach(function(i) {
      R8(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PM(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function Ewe(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function kwe(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, OZ(i.key), i);
  }
}
function Owe(e, r, t) {
  return r && kwe(e.prototype, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Dwe(e, r, t) {
  return r = gX(r), Rwe(e, kZ() ? Reflect.construct(r, t || [], gX(e).constructor) : r.apply(e, t));
}
function Rwe(e, r) {
  if (r && (RV(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Iwe(e);
}
function Iwe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function kZ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (kZ = function() {
    return !!e;
  })();
}
function gX(e) {
  return gX = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, gX(e);
}
function Lwe(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && D8(e, r);
}
function D8(e, r) {
  return D8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, D8(e, r);
}
function R8(e, r, t) {
  return r = OZ(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function OZ(e) {
  var r = _we(e, "string");
  return RV(r) == "symbol" ? r : r + "";
}
function _we(e, r) {
  if (RV(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (RV(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var NM = 1, Hwe = /* @__PURE__ */ function(e) {
  function r() {
    var t;
    Ewe(this, r);
    for (var i = arguments.length, n = new Array(i), s = 0; s < i; s++)
      n[s] = arguments[s];
    return t = Dwe(this, r, [].concat(n)), R8(t, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), R8(t, "handleKeyDown", function(u) {
      if (u.key === "Escape") {
        var o, d, a, V;
        t.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (o = (d = t.props.coordinate) === null || d === void 0 ? void 0 : d.x) !== null && o !== void 0 ? o : 0,
            y: (a = (V = t.props.coordinate) === null || V === void 0 ? void 0 : V.y) !== null && a !== void 0 ? a : 0
          }
        });
      }
    }), t;
  }
  return Lwe(r, e), Owe(r, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var i = this.wrapperNode.getBoundingClientRect();
        (Math.abs(i.width - this.state.lastBoundingBox.width) > NM || Math.abs(i.height - this.state.lastBoundingBox.height) > NM) && this.setState({
          lastBoundingBox: {
            width: i.width,
            height: i.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var i, n;
      this.props.active && this.updateBBox(), this.state.dismissed && (((i = this.props.coordinate) === null || i === void 0 ? void 0 : i.x) !== this.state.dismissedAtCoordinate.x || ((n = this.props.coordinate) === null || n === void 0 ? void 0 : n.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var i = this, n = this.props, s = n.active, u = n.allowEscapeViewBox, o = n.animationDuration, d = n.animationEasing, a = n.children, V = n.coordinate, c = n.hasPayload, F = n.isAnimationActive, X = n.offset, Y = n.position, q = n.reverseDirection, f = n.useTranslate3d, p = n.viewBox, m = n.wrapperStyle, g = Twe({
        allowEscapeViewBox: u,
        coordinate: V,
        offsetTopLeft: X,
        position: Y,
        reverseDirection: q,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: f,
        viewBox: p
      }), y = g.cssClasses, b = g.cssProperties, A = SM(SM({
        transition: F && s ? "transform ".concat(o, "ms ").concat(d) : void 0
      }, b), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && s && c ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, m);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ D.createElement("div", {
          tabIndex: -1,
          className: y,
          style: A,
          ref: function(S) {
            i.wrapperNode = S;
          }
        }, a)
      );
    }
  }]);
}(Gs), jwe = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, Ml = {
  isSsr: jwe()
};
function IV(e) {
  "@babel/helpers - typeof";
  return IV = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, IV(e);
}
function MM(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function TM(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? MM(Object(t), !0).forEach(function(i) {
      WA(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : MM(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function zwe(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function Bwe(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, RZ(i.key), i);
  }
}
function Wwe(e, r, t) {
  return r && Bwe(e.prototype, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Gwe(e, r, t) {
  return r = vX(r), Uwe(e, DZ() ? Reflect.construct(r, t || [], vX(e).constructor) : r.apply(e, t));
}
function Uwe(e, r) {
  if (r && (IV(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Zwe(e);
}
function Zwe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function DZ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (DZ = function() {
    return !!e;
  })();
}
function vX(e) {
  return vX = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, vX(e);
}
function Jwe(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && I8(e, r);
}
function I8(e, r) {
  return I8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, I8(e, r);
}
function WA(e, r, t) {
  return r = RZ(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function RZ(e) {
  var r = $we(e, "string");
  return IV(r) == "symbol" ? r : r + "";
}
function $we(e, r) {
  if (IV(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (IV(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Qwe(e) {
  return e.dataKey;
}
function e9e(e, r) {
  return /* @__PURE__ */ D.isValidElement(e) ? /* @__PURE__ */ D.cloneElement(e, r) : typeof e == "function" ? /* @__PURE__ */ D.createElement(e, r) : /* @__PURE__ */ D.createElement(wwe, r);
}
var ws = /* @__PURE__ */ function(e) {
  function r() {
    return zwe(this, r), Gwe(this, r, arguments);
  }
  return Jwe(r, e), Wwe(r, [{
    key: "render",
    value: function() {
      var i = this, n = this.props, s = n.active, u = n.allowEscapeViewBox, o = n.animationDuration, d = n.animationEasing, a = n.content, V = n.coordinate, c = n.filterNull, F = n.isAnimationActive, X = n.offset, Y = n.payload, q = n.payloadUniqBy, f = n.position, p = n.reverseDirection, m = n.useTranslate3d, g = n.viewBox, y = n.wrapperStyle, b = Y ?? [];
      c && b.length && (b = CZ(Y.filter(function(w) {
        return w.value != null && (w.hide !== !0 || i.props.includeHidden);
      }), q, Qwe));
      var A = b.length > 0;
      return /* @__PURE__ */ D.createElement(Hwe, {
        allowEscapeViewBox: u,
        animationDuration: o,
        animationEasing: d,
        isAnimationActive: F,
        active: s,
        coordinate: V,
        hasPayload: A,
        offset: X,
        position: f,
        reverseDirection: p,
        useTranslate3d: m,
        viewBox: g,
        wrapperStyle: y
      }, e9e(a, TM(TM({}, this.props), {}, {
        payload: b
      })));
    }
  }]);
}(Gs);
WA(ws, "displayName", "Tooltip");
WA(ws, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !Ml.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var pm, EM;
function r9e() {
  if (EM) return pm;
  EM = 1;
  var e = eu(), r = function() {
    return e.Date.now();
  };
  return pm = r, pm;
}
var mm, kM;
function t9e() {
  if (kM) return mm;
  kM = 1;
  var e = /\s/;
  function r(t) {
    for (var i = t.length; i-- && e.test(t.charAt(i)); )
      ;
    return i;
  }
  return mm = r, mm;
}
var gm, OM;
function i9e() {
  if (OM) return gm;
  OM = 1;
  var e = t9e(), r = /^\s+/;
  function t(i) {
    return i && i.slice(0, e(i) + 1).replace(r, "");
  }
  return gm = t, gm;
}
var vm, DM;
function IZ() {
  if (DM) return vm;
  DM = 1;
  var e = i9e(), r = Qo(), t = Pl(), i = NaN, n = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, u = /^0o[0-7]+$/i, o = parseInt;
  function d(a) {
    if (typeof a == "number")
      return a;
    if (t(a))
      return i;
    if (r(a)) {
      var V = typeof a.valueOf == "function" ? a.valueOf() : a;
      a = r(V) ? V + "" : V;
    }
    if (typeof a != "string")
      return a === 0 ? a : +a;
    a = e(a);
    var c = s.test(a);
    return c || u.test(a) ? o(a.slice(2), c ? 2 : 8) : n.test(a) ? i : +a;
  }
  return vm = d, vm;
}
var bm, RM;
function n9e() {
  if (RM) return bm;
  RM = 1;
  var e = Qo(), r = r9e(), t = IZ(), i = "Expected a function", n = Math.max, s = Math.min;
  function u(o, d, a) {
    var V, c, F, X, Y, q, f = 0, p = !1, m = !1, g = !0;
    if (typeof o != "function")
      throw new TypeError(i);
    d = t(d) || 0, e(a) && (p = !!a.leading, m = "maxWait" in a, F = m ? n(t(a.maxWait) || 0, d) : F, g = "trailing" in a ? !!a.trailing : g);
    function y(R) {
      var H = V, W = c;
      return V = c = void 0, f = R, X = o.apply(W, H), X;
    }
    function b(R) {
      return f = R, Y = setTimeout(S, d), p ? y(R) : X;
    }
    function A(R) {
      var H = R - q, W = R - f, B = d - H;
      return m ? s(B, F - W) : B;
    }
    function w(R) {
      var H = R - q, W = R - f;
      return q === void 0 || H >= d || H < 0 || m && W >= F;
    }
    function S() {
      var R = r();
      if (w(R))
        return N(R);
      Y = setTimeout(S, A(R));
    }
    function N(R) {
      return Y = void 0, g && V ? y(R) : (V = c = void 0, X);
    }
    function O() {
      Y !== void 0 && clearTimeout(Y), f = 0, V = q = c = Y = void 0;
    }
    function E() {
      return Y === void 0 ? X : N(r());
    }
    function I() {
      var R = r(), H = w(R);
      if (V = arguments, c = this, q = R, H) {
        if (Y === void 0)
          return b(q);
        if (m)
          return clearTimeout(Y), Y = setTimeout(S, d), y(q);
      }
      return Y === void 0 && (Y = setTimeout(S, d)), X;
    }
    return I.cancel = O, I.flush = E, I;
  }
  return bm = u, bm;
}
var ym, IM;
function s9e() {
  if (IM) return ym;
  IM = 1;
  var e = n9e(), r = Qo(), t = "Expected a function";
  function i(n, s, u) {
    var o = !0, d = !0;
    if (typeof n != "function")
      throw new TypeError(t);
    return r(u) && (o = "leading" in u ? !!u.leading : o, d = "trailing" in u ? !!u.trailing : d), e(n, s, {
      leading: o,
      maxWait: s,
      trailing: d
    });
  }
  return ym = i, ym;
}
var u9e = s9e();
const LZ = /* @__PURE__ */ Mr(u9e);
function a7(e) {
  "@babel/helpers - typeof";
  return a7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, a7(e);
}
function LM(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function cx(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? LM(Object(t), !0).forEach(function(i) {
      o9e(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : LM(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function o9e(e, r, t) {
  return r = d9e(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function d9e(e) {
  var r = a9e(e, "string");
  return a7(r) == "symbol" ? r : r + "";
}
function a9e(e, r) {
  if (a7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (a7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function V9e(e, r) {
  return x9e(e) || F9e(e, r) || c9e(e, r) || l9e();
}
function l9e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function c9e(e, r) {
  if (e) {
    if (typeof e == "string") return _M(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return _M(e, r);
  }
}
function _M(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
function F9e(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var i, n, s, u, o = [], d = !0, a = !1;
    try {
      if (s = (t = t.call(e)).next, r !== 0) for (; !(d = (i = s.call(t)).done) && (o.push(i.value), o.length !== r); d = !0) ;
    } catch (V) {
      a = !0, n = V;
    } finally {
      try {
        if (!d && t.return != null && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (a) throw n;
      }
    }
    return o;
  }
}
function x9e(e) {
  if (Array.isArray(e)) return e;
}
var X9e = /* @__PURE__ */ re(function(e, r) {
  var t = e.aspect, i = e.initialDimension, n = i === void 0 ? {
    width: -1,
    height: -1
  } : i, s = e.width, u = s === void 0 ? "100%" : s, o = e.height, d = o === void 0 ? "100%" : o, a = e.minWidth, V = a === void 0 ? 0 : a, c = e.minHeight, F = e.maxHeight, X = e.children, Y = e.debounce, q = Y === void 0 ? 0 : Y, f = e.id, p = e.className, m = e.onResize, g = e.style, y = g === void 0 ? {} : g, b = Yr(null), A = Yr();
  A.current = m, kq(r, function() {
    return Object.defineProperty(b.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), b.current;
      },
      configurable: !0
    });
  });
  var w = ie({
    containerWidth: n.width,
    containerHeight: n.height
  }), S = V9e(w, 2), N = S[0], O = S[1], E = Yi(function(R, H) {
    O(function(W) {
      var B = Math.round(R), L = Math.round(H);
      return W.containerWidth === B && W.containerHeight === L ? W : {
        containerWidth: B,
        containerHeight: L
      };
    });
  }, []);
  Pe(function() {
    var R = function(Z) {
      var le, te = Z[0].contentRect, U = te.width, de = te.height;
      E(U, de), (le = A.current) === null || le === void 0 || le.call(A, U, de);
    };
    q > 0 && (R = LZ(R, q, {
      trailing: !0,
      leading: !1
    }));
    var H = new ResizeObserver(R), W = b.current.getBoundingClientRect(), B = W.width, L = W.height;
    return E(B, L), H.observe(b.current), function() {
      H.disconnect();
    };
  }, [E, q]);
  var I = $e(function() {
    var R = N.containerWidth, H = N.containerHeight;
    if (R < 0 || H < 0)
      return null;
    Su(wd(u) || wd(d), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, u, d), Su(!t || t > 0, "The aspect(%s) must be greater than zero.", t);
    var W = wd(u) ? R : u, B = wd(d) ? H : d;
    t && t > 0 && (W ? B = W / t : B && (W = B * t), F && B > F && (B = F)), Su(W > 0 || B > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, W, B, u, d, V, c, t);
    var L = !Array.isArray(X) && Pu(X.type).endsWith("Chart");
    return D.Children.map(X, function(z) {
      return /* @__PURE__ */ D.isValidElement(z) ? /* @__PURE__ */ at(z, cx({
        width: W,
        height: B
      }, L ? {
        style: cx({
          height: "100%",
          width: "100%",
          maxHeight: B,
          maxWidth: W
        }, z.props.style)
      } : {})) : z;
    });
  }, [t, X, d, F, c, V, N, u]);
  return /* @__PURE__ */ D.createElement("div", {
    id: f ? "".concat(f) : void 0,
    className: ur("recharts-responsive-container", p),
    style: cx(cx({}, y), {}, {
      width: u,
      height: d,
      minWidth: V,
      minHeight: c,
      maxHeight: F
    }),
    ref: b
  }, I);
}), _Z = function(r) {
  return null;
};
_Z.displayName = "Cell";
function V7(e) {
  "@babel/helpers - typeof";
  return V7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, V7(e);
}
function HM(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function L8(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? HM(Object(t), !0).forEach(function(i) {
      q9e(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : HM(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function q9e(e, r, t) {
  return r = Y9e(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Y9e(e) {
  var r = f9e(e, "string");
  return V7(r) == "symbol" ? r : r + "";
}
function f9e(e, r) {
  if (V7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (V7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
var Wa = {
  widthCache: {},
  cacheCount: 0
}, K9e = 2e3, h9e = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, jM = "recharts_measurement_span";
function p9e(e) {
  var r = L8({}, e);
  return Object.keys(r).forEach(function(t) {
    r[t] || delete r[t];
  }), r;
}
var Dc = function(r) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (r == null || Ml.isSsr)
    return {
      width: 0,
      height: 0
    };
  var i = p9e(t), n = JSON.stringify({
    text: r,
    copyStyle: i
  });
  if (Wa.widthCache[n])
    return Wa.widthCache[n];
  try {
    var s = document.getElementById(jM);
    s || (s = document.createElement("span"), s.setAttribute("id", jM), s.setAttribute("aria-hidden", "true"), document.body.appendChild(s));
    var u = L8(L8({}, h9e), i);
    Object.assign(s.style, u), s.textContent = "".concat(r);
    var o = s.getBoundingClientRect(), d = {
      width: o.width,
      height: o.height
    };
    return Wa.widthCache[n] = d, ++Wa.cacheCount > K9e && (Wa.cacheCount = 0, Wa.widthCache = {}), d;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, m9e = function(r) {
  return {
    top: r.top + window.scrollY - document.documentElement.clientTop,
    left: r.left + window.scrollX - document.documentElement.clientLeft
  };
};
function l7(e) {
  "@babel/helpers - typeof";
  return l7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, l7(e);
}
function bX(e, r) {
  return y9e(e) || b9e(e, r) || v9e(e, r) || g9e();
}
function g9e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function v9e(e, r) {
  if (e) {
    if (typeof e == "string") return zM(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return zM(e, r);
  }
}
function zM(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
function b9e(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var i, n, s, u, o = [], d = !0, a = !1;
    try {
      if (s = (t = t.call(e)).next, r === 0) {
        if (Object(t) !== t) return;
        d = !1;
      } else for (; !(d = (i = s.call(t)).done) && (o.push(i.value), o.length !== r); d = !0) ;
    } catch (V) {
      a = !0, n = V;
    } finally {
      try {
        if (!d && t.return != null && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (a) throw n;
      }
    }
    return o;
  }
}
function y9e(e) {
  if (Array.isArray(e)) return e;
}
function A9e(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function BM(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, C9e(i.key), i);
  }
}
function w9e(e, r, t) {
  return r && BM(e.prototype, r), t && BM(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function C9e(e) {
  var r = P9e(e, "string");
  return l7(r) == "symbol" ? r : r + "";
}
function P9e(e, r) {
  if (l7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (l7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var WM = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, GM = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, S9e = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, N9e = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, HZ = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, M9e = Object.keys(HZ), tV = "NaN";
function T9e(e, r) {
  return e * HZ[r];
}
var Fx = /* @__PURE__ */ function() {
  function e(r, t) {
    A9e(this, e), this.num = r, this.unit = t, this.num = r, this.unit = t, Number.isNaN(r) && (this.unit = ""), t !== "" && !S9e.test(t) && (this.num = NaN, this.unit = ""), M9e.includes(t) && (this.num = T9e(r, t), this.unit = "px");
  }
  return w9e(e, [{
    key: "add",
    value: function(t) {
      return this.unit !== t.unit ? new e(NaN, "") : new e(this.num + t.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(t) {
      return this.unit !== t.unit ? new e(NaN, "") : new e(this.num - t.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(t) {
      return this.unit !== "" && t.unit !== "" && this.unit !== t.unit ? new e(NaN, "") : new e(this.num * t.num, this.unit || t.unit);
    }
  }, {
    key: "divide",
    value: function(t) {
      return this.unit !== "" && t.unit !== "" && this.unit !== t.unit ? new e(NaN, "") : new e(this.num / t.num, this.unit || t.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(t) {
      var i, n = (i = N9e.exec(t)) !== null && i !== void 0 ? i : [], s = bX(n, 3), u = s[1], o = s[2];
      return new e(parseFloat(u), o ?? "");
    }
  }]);
}();
function jZ(e) {
  if (e.includes(tV))
    return tV;
  for (var r = e; r.includes("*") || r.includes("/"); ) {
    var t, i = (t = WM.exec(r)) !== null && t !== void 0 ? t : [], n = bX(i, 4), s = n[1], u = n[2], o = n[3], d = Fx.parse(s ?? ""), a = Fx.parse(o ?? ""), V = u === "*" ? d.multiply(a) : d.divide(a);
    if (V.isNaN())
      return tV;
    r = r.replace(WM, V.toString());
  }
  for (; r.includes("+") || /.-\d+(?:\.\d+)?/.test(r); ) {
    var c, F = (c = GM.exec(r)) !== null && c !== void 0 ? c : [], X = bX(F, 4), Y = X[1], q = X[2], f = X[3], p = Fx.parse(Y ?? ""), m = Fx.parse(f ?? ""), g = q === "+" ? p.add(m) : p.subtract(m);
    if (g.isNaN())
      return tV;
    r = r.replace(GM, g.toString());
  }
  return r;
}
var UM = /\(([^()]*)\)/;
function E9e(e) {
  for (var r = e; r.includes("("); ) {
    var t = UM.exec(r), i = bX(t, 2), n = i[1];
    r = r.replace(UM, jZ(n));
  }
  return r;
}
function k9e(e) {
  var r = e.replace(/\s+/g, "");
  return r = E9e(r), r = jZ(r), r;
}
function O9e(e) {
  try {
    return k9e(e);
  } catch {
    return tV;
  }
}
function Am(e) {
  var r = O9e(e.slice(5, -1));
  return r === tV ? "" : r;
}
var D9e = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], R9e = ["dx", "dy", "angle", "className", "breakAll"];
function _8() {
  return _8 = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, _8.apply(this, arguments);
}
function ZM(e, r) {
  if (e == null) return {};
  var t = I9e(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function I9e(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
function JM(e, r) {
  return j9e(e) || H9e(e, r) || _9e(e, r) || L9e();
}
function L9e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _9e(e, r) {
  if (e) {
    if (typeof e == "string") return $M(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return $M(e, r);
  }
}
function $M(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
function H9e(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var i, n, s, u, o = [], d = !0, a = !1;
    try {
      if (s = (t = t.call(e)).next, r === 0) {
        if (Object(t) !== t) return;
        d = !1;
      } else for (; !(d = (i = s.call(t)).done) && (o.push(i.value), o.length !== r); d = !0) ;
    } catch (V) {
      a = !0, n = V;
    } finally {
      try {
        if (!d && t.return != null && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (a) throw n;
      }
    }
    return o;
  }
}
function j9e(e) {
  if (Array.isArray(e)) return e;
}
var zZ = /[ \f\n\r\t\v\u2028\u2029]+/, BZ = function(r) {
  var t = r.children, i = r.breakAll, n = r.style;
  try {
    var s = [];
    fr(t) || (i ? s = t.toString().split("") : s = t.toString().split(zZ));
    var u = s.map(function(d) {
      return {
        word: d,
        width: Dc(d, n).width
      };
    }), o = i ? 0 : Dc(" ", n).width;
    return {
      wordsWithComputedWidth: u,
      spaceWidth: o
    };
  } catch {
    return null;
  }
}, z9e = function(r, t, i, n, s) {
  var u = r.maxLines, o = r.children, d = r.style, a = r.breakAll, V = pe(u), c = o, F = function() {
    var W = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return W.reduce(function(B, L) {
      var z = L.word, Z = L.width, le = B[B.length - 1];
      if (le && (n == null || s || le.width + Z + i < Number(n)))
        le.words.push(z), le.width += Z + i;
      else {
        var te = {
          words: [z],
          width: Z
        };
        B.push(te);
      }
      return B;
    }, []);
  }, X = F(t), Y = function(W) {
    return W.reduce(function(B, L) {
      return B.width > L.width ? B : L;
    });
  };
  if (!V)
    return X;
  for (var q = "…", f = function(W) {
    var B = c.slice(0, W), L = BZ({
      breakAll: a,
      style: d,
      children: B + q
    }).wordsWithComputedWidth, z = F(L), Z = z.length > u || Y(z).width > Number(n);
    return [Z, z];
  }, p = 0, m = c.length - 1, g = 0, y; p <= m && g <= c.length - 1; ) {
    var b = Math.floor((p + m) / 2), A = b - 1, w = f(A), S = JM(w, 2), N = S[0], O = S[1], E = f(b), I = JM(E, 1), R = I[0];
    if (!N && !R && (p = b + 1), N && R && (m = b - 1), !N && R) {
      y = O;
      break;
    }
    g++;
  }
  return y || X;
}, QM = function(r) {
  var t = fr(r) ? [] : r.toString().split(zZ);
  return [{
    words: t
  }];
}, B9e = function(r) {
  var t = r.width, i = r.scaleToFit, n = r.children, s = r.style, u = r.breakAll, o = r.maxLines;
  if ((t || i) && !Ml.isSsr) {
    var d, a, V = BZ({
      breakAll: u,
      children: n,
      style: s
    });
    if (V) {
      var c = V.wordsWithComputedWidth, F = V.spaceWidth;
      d = c, a = F;
    } else
      return QM(n);
    return z9e({
      breakAll: u,
      children: n,
      maxLines: o,
      style: s
    }, d, a, t, i);
  }
  return QM(n);
}, eT = "#808080", LV = function(r) {
  var t = r.x, i = t === void 0 ? 0 : t, n = r.y, s = n === void 0 ? 0 : n, u = r.lineHeight, o = u === void 0 ? "1em" : u, d = r.capHeight, a = d === void 0 ? "0.71em" : d, V = r.scaleToFit, c = V === void 0 ? !1 : V, F = r.textAnchor, X = F === void 0 ? "start" : F, Y = r.verticalAnchor, q = Y === void 0 ? "end" : Y, f = r.fill, p = f === void 0 ? eT : f, m = ZM(r, D9e), g = $e(function() {
    return B9e({
      breakAll: m.breakAll,
      children: m.children,
      maxLines: m.maxLines,
      scaleToFit: c,
      style: m.style,
      width: m.width
    });
  }, [m.breakAll, m.children, m.maxLines, c, m.style, m.width]), y = m.dx, b = m.dy, A = m.angle, w = m.className, S = m.breakAll, N = ZM(m, R9e);
  if (!Mt(i) || !Mt(s))
    return null;
  var O = i + (pe(y) ? y : 0), E = s + (pe(b) ? b : 0), I;
  switch (q) {
    case "start":
      I = Am("calc(".concat(a, ")"));
      break;
    case "middle":
      I = Am("calc(".concat((g.length - 1) / 2, " * -").concat(o, " + (").concat(a, " / 2))"));
      break;
    default:
      I = Am("calc(".concat(g.length - 1, " * -").concat(o, ")"));
      break;
  }
  var R = [];
  if (c) {
    var H = g[0].width, W = m.width;
    R.push("scale(".concat((pe(W) ? W / H : 1) / H, ")"));
  }
  return A && R.push("rotate(".concat(A, ", ").concat(O, ", ").concat(E, ")")), R.length && (N.transform = R.join(" ")), /* @__PURE__ */ D.createElement("text", _8({}, _e(N, !0), {
    x: O,
    y: E,
    className: ur("recharts-text", w),
    textAnchor: X,
    fill: p.includes("url") ? eT : p
  }), g.map(function(B, L) {
    var z = B.words.join(S ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ D.createElement("tspan", {
        x: O,
        dy: L === 0 ? I : o,
        key: "".concat(z, "-").concat(L)
      }, z)
    );
  }));
};
function Mo(e, r) {
  return e == null || r == null ? NaN : e < r ? -1 : e > r ? 1 : e >= r ? 0 : NaN;
}
function W9e(e, r) {
  return e == null || r == null ? NaN : r < e ? -1 : r > e ? 1 : r >= e ? 0 : NaN;
}
function GA(e) {
  let r, t, i;
  e.length !== 2 ? (r = Mo, t = (o, d) => Mo(e(o), d), i = (o, d) => e(o) - d) : (r = e === Mo || e === W9e ? e : G9e, t = e, i = e);
  function n(o, d, a = 0, V = o.length) {
    if (a < V) {
      if (r(d, d) !== 0) return V;
      do {
        const c = a + V >>> 1;
        t(o[c], d) < 0 ? a = c + 1 : V = c;
      } while (a < V);
    }
    return a;
  }
  function s(o, d, a = 0, V = o.length) {
    if (a < V) {
      if (r(d, d) !== 0) return V;
      do {
        const c = a + V >>> 1;
        t(o[c], d) <= 0 ? a = c + 1 : V = c;
      } while (a < V);
    }
    return a;
  }
  function u(o, d, a = 0, V = o.length) {
    const c = n(o, d, a, V - 1);
    return c > a && i(o[c - 1], d) > -i(o[c], d) ? c - 1 : c;
  }
  return { left: n, center: u, right: s };
}
function G9e() {
  return 0;
}
function WZ(e) {
  return e === null ? NaN : +e;
}
function* U9e(e, r) {
  for (let t of e)
    t != null && (t = +t) >= t && (yield t);
}
const Z9e = GA(Mo), S2 = Z9e.right;
GA(WZ).center;
class rT extends Map {
  constructor(r, t = Q9e) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: t } }), r != null) for (const [i, n] of r) this.set(i, n);
  }
  get(r) {
    return super.get(tT(this, r));
  }
  has(r) {
    return super.has(tT(this, r));
  }
  set(r, t) {
    return super.set(J9e(this, r), t);
  }
  delete(r) {
    return super.delete($9e(this, r));
  }
}
function tT({ _intern: e, _key: r }, t) {
  const i = r(t);
  return e.has(i) ? e.get(i) : t;
}
function J9e({ _intern: e, _key: r }, t) {
  const i = r(t);
  return e.has(i) ? e.get(i) : (e.set(i, t), t);
}
function $9e({ _intern: e, _key: r }, t) {
  const i = r(t);
  return e.has(i) && (t = e.get(i), e.delete(i)), t;
}
function Q9e(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function eCe(e = Mo) {
  if (e === Mo) return GZ;
  if (typeof e != "function") throw new TypeError("compare is not a function");
  return (r, t) => {
    const i = e(r, t);
    return i || i === 0 ? i : (e(t, t) === 0) - (e(r, r) === 0);
  };
}
function GZ(e, r) {
  return (e == null || !(e >= e)) - (r == null || !(r >= r)) || (e < r ? -1 : e > r ? 1 : 0);
}
const rCe = Math.sqrt(50), tCe = Math.sqrt(10), iCe = Math.sqrt(2);
function yX(e, r, t) {
  const i = (r - e) / Math.max(0, t), n = Math.floor(Math.log10(i)), s = i / Math.pow(10, n), u = s >= rCe ? 10 : s >= tCe ? 5 : s >= iCe ? 2 : 1;
  let o, d, a;
  return n < 0 ? (a = Math.pow(10, -n) / u, o = Math.round(e * a), d = Math.round(r * a), o / a < e && ++o, d / a > r && --d, a = -a) : (a = Math.pow(10, n) * u, o = Math.round(e / a), d = Math.round(r / a), o * a < e && ++o, d * a > r && --d), d < o && 0.5 <= t && t < 2 ? yX(e, r, t * 2) : [o, d, a];
}
function H8(e, r, t) {
  if (r = +r, e = +e, t = +t, !(t > 0)) return [];
  if (e === r) return [e];
  const i = r < e, [n, s, u] = i ? yX(r, e, t) : yX(e, r, t);
  if (!(s >= n)) return [];
  const o = s - n + 1, d = new Array(o);
  if (i)
    if (u < 0) for (let a = 0; a < o; ++a) d[a] = (s - a) / -u;
    else for (let a = 0; a < o; ++a) d[a] = (s - a) * u;
  else if (u < 0) for (let a = 0; a < o; ++a) d[a] = (n + a) / -u;
  else for (let a = 0; a < o; ++a) d[a] = (n + a) * u;
  return d;
}
function j8(e, r, t) {
  return r = +r, e = +e, t = +t, yX(e, r, t)[2];
}
function z8(e, r, t) {
  r = +r, e = +e, t = +t;
  const i = r < e, n = i ? j8(r, e, t) : j8(e, r, t);
  return (i ? -1 : 1) * (n < 0 ? 1 / -n : n);
}
function iT(e, r) {
  let t;
  for (const i of e)
    i != null && (t < i || t === void 0 && i >= i) && (t = i);
  return t;
}
function nT(e, r) {
  let t;
  for (const i of e)
    i != null && (t > i || t === void 0 && i >= i) && (t = i);
  return t;
}
function UZ(e, r, t = 0, i = 1 / 0, n) {
  if (r = Math.floor(r), t = Math.floor(Math.max(0, t)), i = Math.floor(Math.min(e.length - 1, i)), !(t <= r && r <= i)) return e;
  for (n = n === void 0 ? GZ : eCe(n); i > t; ) {
    if (i - t > 600) {
      const d = i - t + 1, a = r - t + 1, V = Math.log(d), c = 0.5 * Math.exp(2 * V / 3), F = 0.5 * Math.sqrt(V * c * (d - c) / d) * (a - d / 2 < 0 ? -1 : 1), X = Math.max(t, Math.floor(r - a * c / d + F)), Y = Math.min(i, Math.floor(r + (d - a) * c / d + F));
      UZ(e, r, X, Y, n);
    }
    const s = e[r];
    let u = t, o = i;
    for (cc(e, t, r), n(e[i], s) > 0 && cc(e, t, i); u < o; ) {
      for (cc(e, u, o), ++u, --o; n(e[u], s) < 0; ) ++u;
      for (; n(e[o], s) > 0; ) --o;
    }
    n(e[t], s) === 0 ? cc(e, t, o) : (++o, cc(e, o, i)), o <= r && (t = o + 1), r <= o && (i = o - 1);
  }
  return e;
}
function cc(e, r, t) {
  const i = e[r];
  e[r] = e[t], e[t] = i;
}
function nCe(e, r, t) {
  if (e = Float64Array.from(U9e(e)), !(!(i = e.length) || isNaN(r = +r))) {
    if (r <= 0 || i < 2) return nT(e);
    if (r >= 1) return iT(e);
    var i, n = (i - 1) * r, s = Math.floor(n), u = iT(UZ(e, s).subarray(0, s + 1)), o = nT(e.subarray(s + 1));
    return u + (o - u) * (n - s);
  }
}
function sCe(e, r, t = WZ) {
  if (!(!(i = e.length) || isNaN(r = +r))) {
    if (r <= 0 || i < 2) return +t(e[0], 0, e);
    if (r >= 1) return +t(e[i - 1], i - 1, e);
    var i, n = (i - 1) * r, s = Math.floor(n), u = +t(e[s], s, e), o = +t(e[s + 1], s + 1, e);
    return u + (o - u) * (n - s);
  }
}
function uCe(e, r, t) {
  e = +e, r = +r, t = (n = arguments.length) < 2 ? (r = e, e = 0, 1) : n < 3 ? 1 : +t;
  for (var i = -1, n = Math.max(0, Math.ceil((r - e) / t)) | 0, s = new Array(n); ++i < n; )
    s[i] = e + i * t;
  return s;
}
function Hn(e, r) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(r).domain(e);
      break;
  }
  return this;
}
function Ju(e, r) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof r == "function" ? this.interpolator(r) : this.range(r);
      break;
    }
  }
  return this;
}
const B8 = Symbol("implicit");
function UA() {
  var e = new rT(), r = [], t = [], i = B8;
  function n(s) {
    let u = e.get(s);
    if (u === void 0) {
      if (i !== B8) return i;
      e.set(s, u = r.push(s) - 1);
    }
    return t[u % t.length];
  }
  return n.domain = function(s) {
    if (!arguments.length) return r.slice();
    r = [], e = new rT();
    for (const u of s)
      e.has(u) || e.set(u, r.push(u) - 1);
    return n;
  }, n.range = function(s) {
    return arguments.length ? (t = Array.from(s), n) : t.slice();
  }, n.unknown = function(s) {
    return arguments.length ? (i = s, n) : i;
  }, n.copy = function() {
    return UA(r, t).unknown(i);
  }, Hn.apply(n, arguments), n;
}
function c7() {
  var e = UA().unknown(void 0), r = e.domain, t = e.range, i = 0, n = 1, s, u, o = !1, d = 0, a = 0, V = 0.5;
  delete e.unknown;
  function c() {
    var F = r().length, X = n < i, Y = X ? n : i, q = X ? i : n;
    s = (q - Y) / Math.max(1, F - d + a * 2), o && (s = Math.floor(s)), Y += (q - Y - s * (F - d)) * V, u = s * (1 - d), o && (Y = Math.round(Y), u = Math.round(u));
    var f = uCe(F).map(function(p) {
      return Y + s * p;
    });
    return t(X ? f.reverse() : f);
  }
  return e.domain = function(F) {
    return arguments.length ? (r(F), c()) : r();
  }, e.range = function(F) {
    return arguments.length ? ([i, n] = F, i = +i, n = +n, c()) : [i, n];
  }, e.rangeRound = function(F) {
    return [i, n] = F, i = +i, n = +n, o = !0, c();
  }, e.bandwidth = function() {
    return u;
  }, e.step = function() {
    return s;
  }, e.round = function(F) {
    return arguments.length ? (o = !!F, c()) : o;
  }, e.padding = function(F) {
    return arguments.length ? (d = Math.min(1, a = +F), c()) : d;
  }, e.paddingInner = function(F) {
    return arguments.length ? (d = Math.min(1, F), c()) : d;
  }, e.paddingOuter = function(F) {
    return arguments.length ? (a = +F, c()) : a;
  }, e.align = function(F) {
    return arguments.length ? (V = Math.max(0, Math.min(1, F)), c()) : V;
  }, e.copy = function() {
    return c7(r(), [i, n]).round(o).paddingInner(d).paddingOuter(a).align(V);
  }, Hn.apply(c(), arguments);
}
function ZZ(e) {
  var r = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return ZZ(r());
  }, e;
}
function Rc() {
  return ZZ(c7.apply(null, arguments).paddingInner(1));
}
function ZA(e, r, t) {
  e.prototype = r.prototype = t, t.constructor = e;
}
function JZ(e, r) {
  var t = Object.create(e.prototype);
  for (var i in r) t[i] = r[i];
  return t;
}
function N2() {
}
var F7 = 0.7, AX = 1 / F7, KV = "\\s*([+-]?\\d+)\\s*", x7 = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Ds = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", oCe = /^#([0-9a-f]{3,8})$/, dCe = new RegExp(`^rgb\\(${KV},${KV},${KV}\\)$`), aCe = new RegExp(`^rgb\\(${Ds},${Ds},${Ds}\\)$`), VCe = new RegExp(`^rgba\\(${KV},${KV},${KV},${x7}\\)$`), lCe = new RegExp(`^rgba\\(${Ds},${Ds},${Ds},${x7}\\)$`), cCe = new RegExp(`^hsl\\(${x7},${Ds},${Ds}\\)$`), FCe = new RegExp(`^hsla\\(${x7},${Ds},${Ds},${x7}\\)$`), sT = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
ZA(N2, X7, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: uT,
  // Deprecated! Use color.formatHex.
  formatHex: uT,
  formatHex8: xCe,
  formatHsl: XCe,
  formatRgb: oT,
  toString: oT
});
function uT() {
  return this.rgb().formatHex();
}
function xCe() {
  return this.rgb().formatHex8();
}
function XCe() {
  return $Z(this).formatHsl();
}
function oT() {
  return this.rgb().formatRgb();
}
function X7(e) {
  var r, t;
  return e = (e + "").trim().toLowerCase(), (r = oCe.exec(e)) ? (t = r[1].length, r = parseInt(r[1], 16), t === 6 ? dT(r) : t === 3 ? new Li(r >> 8 & 15 | r >> 4 & 240, r >> 4 & 15 | r & 240, (r & 15) << 4 | r & 15, 1) : t === 8 ? xx(r >> 24 & 255, r >> 16 & 255, r >> 8 & 255, (r & 255) / 255) : t === 4 ? xx(r >> 12 & 15 | r >> 8 & 240, r >> 8 & 15 | r >> 4 & 240, r >> 4 & 15 | r & 240, ((r & 15) << 4 | r & 15) / 255) : null) : (r = dCe.exec(e)) ? new Li(r[1], r[2], r[3], 1) : (r = aCe.exec(e)) ? new Li(r[1] * 255 / 100, r[2] * 255 / 100, r[3] * 255 / 100, 1) : (r = VCe.exec(e)) ? xx(r[1], r[2], r[3], r[4]) : (r = lCe.exec(e)) ? xx(r[1] * 255 / 100, r[2] * 255 / 100, r[3] * 255 / 100, r[4]) : (r = cCe.exec(e)) ? lT(r[1], r[2] / 100, r[3] / 100, 1) : (r = FCe.exec(e)) ? lT(r[1], r[2] / 100, r[3] / 100, r[4]) : sT.hasOwnProperty(e) ? dT(sT[e]) : e === "transparent" ? new Li(NaN, NaN, NaN, 0) : null;
}
function dT(e) {
  return new Li(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function xx(e, r, t, i) {
  return i <= 0 && (e = r = t = NaN), new Li(e, r, t, i);
}
function qCe(e) {
  return e instanceof N2 || (e = X7(e)), e ? (e = e.rgb(), new Li(e.r, e.g, e.b, e.opacity)) : new Li();
}
function W8(e, r, t, i) {
  return arguments.length === 1 ? qCe(e) : new Li(e, r, t, i ?? 1);
}
function Li(e, r, t, i) {
  this.r = +e, this.g = +r, this.b = +t, this.opacity = +i;
}
ZA(Li, W8, JZ(N2, {
  brighter(e) {
    return e = e == null ? AX : Math.pow(AX, e), new Li(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? F7 : Math.pow(F7, e), new Li(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Li(kd(this.r), kd(this.g), kd(this.b), wX(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: aT,
  // Deprecated! Use color.formatHex.
  formatHex: aT,
  formatHex8: YCe,
  formatRgb: VT,
  toString: VT
}));
function aT() {
  return `#${Cd(this.r)}${Cd(this.g)}${Cd(this.b)}`;
}
function YCe() {
  return `#${Cd(this.r)}${Cd(this.g)}${Cd(this.b)}${Cd((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function VT() {
  const e = wX(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${kd(this.r)}, ${kd(this.g)}, ${kd(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function wX(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function kd(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Cd(e) {
  return e = kd(e), (e < 16 ? "0" : "") + e.toString(16);
}
function lT(e, r, t, i) {
  return i <= 0 ? e = r = t = NaN : t <= 0 || t >= 1 ? e = r = NaN : r <= 0 && (e = NaN), new es(e, r, t, i);
}
function $Z(e) {
  if (e instanceof es) return new es(e.h, e.s, e.l, e.opacity);
  if (e instanceof N2 || (e = X7(e)), !e) return new es();
  if (e instanceof es) return e;
  e = e.rgb();
  var r = e.r / 255, t = e.g / 255, i = e.b / 255, n = Math.min(r, t, i), s = Math.max(r, t, i), u = NaN, o = s - n, d = (s + n) / 2;
  return o ? (r === s ? u = (t - i) / o + (t < i) * 6 : t === s ? u = (i - r) / o + 2 : u = (r - t) / o + 4, o /= d < 0.5 ? s + n : 2 - s - n, u *= 60) : o = d > 0 && d < 1 ? 0 : u, new es(u, o, d, e.opacity);
}
function fCe(e, r, t, i) {
  return arguments.length === 1 ? $Z(e) : new es(e, r, t, i ?? 1);
}
function es(e, r, t, i) {
  this.h = +e, this.s = +r, this.l = +t, this.opacity = +i;
}
ZA(es, fCe, JZ(N2, {
  brighter(e) {
    return e = e == null ? AX : Math.pow(AX, e), new es(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? F7 : Math.pow(F7, e), new es(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, r = isNaN(e) || isNaN(this.s) ? 0 : this.s, t = this.l, i = t + (t < 0.5 ? t : 1 - t) * r, n = 2 * t - i;
    return new Li(
      wm(e >= 240 ? e - 240 : e + 120, n, i),
      wm(e, n, i),
      wm(e < 120 ? e + 240 : e - 120, n, i),
      this.opacity
    );
  },
  clamp() {
    return new es(cT(this.h), Xx(this.s), Xx(this.l), wX(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = wX(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${cT(this.h)}, ${Xx(this.s) * 100}%, ${Xx(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function cT(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function Xx(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function wm(e, r, t) {
  return (e < 60 ? r + (t - r) * e / 60 : e < 180 ? t : e < 240 ? r + (t - r) * (240 - e) / 60 : r) * 255;
}
const JA = (e) => () => e;
function KCe(e, r) {
  return function(t) {
    return e + t * r;
  };
}
function hCe(e, r, t) {
  return e = Math.pow(e, t), r = Math.pow(r, t) - e, t = 1 / t, function(i) {
    return Math.pow(e + i * r, t);
  };
}
function pCe(e) {
  return (e = +e) == 1 ? QZ : function(r, t) {
    return t - r ? hCe(r, t, e) : JA(isNaN(r) ? t : r);
  };
}
function QZ(e, r) {
  var t = r - e;
  return t ? KCe(e, t) : JA(isNaN(e) ? r : e);
}
const FT = function e(r) {
  var t = pCe(r);
  function i(n, s) {
    var u = t((n = W8(n)).r, (s = W8(s)).r), o = t(n.g, s.g), d = t(n.b, s.b), a = QZ(n.opacity, s.opacity);
    return function(V) {
      return n.r = u(V), n.g = o(V), n.b = d(V), n.opacity = a(V), n + "";
    };
  }
  return i.gamma = e, i;
}(1);
function mCe(e, r) {
  r || (r = []);
  var t = e ? Math.min(r.length, e.length) : 0, i = r.slice(), n;
  return function(s) {
    for (n = 0; n < t; ++n) i[n] = e[n] * (1 - s) + r[n] * s;
    return i;
  };
}
function gCe(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function vCe(e, r) {
  var t = r ? r.length : 0, i = e ? Math.min(t, e.length) : 0, n = new Array(i), s = new Array(t), u;
  for (u = 0; u < i; ++u) n[u] = Tl(e[u], r[u]);
  for (; u < t; ++u) s[u] = r[u];
  return function(o) {
    for (u = 0; u < i; ++u) s[u] = n[u](o);
    return s;
  };
}
function bCe(e, r) {
  var t = /* @__PURE__ */ new Date();
  return e = +e, r = +r, function(i) {
    return t.setTime(e * (1 - i) + r * i), t;
  };
}
function CX(e, r) {
  return e = +e, r = +r, function(t) {
    return e * (1 - t) + r * t;
  };
}
function yCe(e, r) {
  var t = {}, i = {}, n;
  (e === null || typeof e != "object") && (e = {}), (r === null || typeof r != "object") && (r = {});
  for (n in r)
    n in e ? t[n] = Tl(e[n], r[n]) : i[n] = r[n];
  return function(s) {
    for (n in t) i[n] = t[n](s);
    return i;
  };
}
var G8 = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Cm = new RegExp(G8.source, "g");
function ACe(e) {
  return function() {
    return e;
  };
}
function wCe(e) {
  return function(r) {
    return e(r) + "";
  };
}
function CCe(e, r) {
  var t = G8.lastIndex = Cm.lastIndex = 0, i, n, s, u = -1, o = [], d = [];
  for (e = e + "", r = r + ""; (i = G8.exec(e)) && (n = Cm.exec(r)); )
    (s = n.index) > t && (s = r.slice(t, s), o[u] ? o[u] += s : o[++u] = s), (i = i[0]) === (n = n[0]) ? o[u] ? o[u] += n : o[++u] = n : (o[++u] = null, d.push({ i: u, x: CX(i, n) })), t = Cm.lastIndex;
  return t < r.length && (s = r.slice(t), o[u] ? o[u] += s : o[++u] = s), o.length < 2 ? d[0] ? wCe(d[0].x) : ACe(r) : (r = d.length, function(a) {
    for (var V = 0, c; V < r; ++V) o[(c = d[V]).i] = c.x(a);
    return o.join("");
  });
}
function Tl(e, r) {
  var t = typeof r, i;
  return r == null || t === "boolean" ? JA(r) : (t === "number" ? CX : t === "string" ? (i = X7(r)) ? (r = i, FT) : CCe : r instanceof X7 ? FT : r instanceof Date ? bCe : gCe(r) ? mCe : Array.isArray(r) ? vCe : typeof r.valueOf != "function" && typeof r.toString != "function" || isNaN(r) ? yCe : CX)(e, r);
}
function $A(e, r) {
  return e = +e, r = +r, function(t) {
    return Math.round(e * (1 - t) + r * t);
  };
}
function PCe(e, r) {
  r === void 0 && (r = e, e = Tl);
  for (var t = 0, i = r.length - 1, n = r[0], s = new Array(i < 0 ? 0 : i); t < i; ) s[t] = e(n, n = r[++t]);
  return function(u) {
    var o = Math.max(0, Math.min(i - 1, Math.floor(u *= i)));
    return s[o](u - o);
  };
}
function SCe(e) {
  return function() {
    return e;
  };
}
function PX(e) {
  return +e;
}
var xT = [0, 1];
function wi(e) {
  return e;
}
function U8(e, r) {
  return (r -= e = +e) ? function(t) {
    return (t - e) / r;
  } : SCe(isNaN(r) ? NaN : 0.5);
}
function NCe(e, r) {
  var t;
  return e > r && (t = e, e = r, r = t), function(i) {
    return Math.max(e, Math.min(r, i));
  };
}
function MCe(e, r, t) {
  var i = e[0], n = e[1], s = r[0], u = r[1];
  return n < i ? (i = U8(n, i), s = t(u, s)) : (i = U8(i, n), s = t(s, u)), function(o) {
    return s(i(o));
  };
}
function TCe(e, r, t) {
  var i = Math.min(e.length, r.length) - 1, n = new Array(i), s = new Array(i), u = -1;
  for (e[i] < e[0] && (e = e.slice().reverse(), r = r.slice().reverse()); ++u < i; )
    n[u] = U8(e[u], e[u + 1]), s[u] = t(r[u], r[u + 1]);
  return function(o) {
    var d = S2(e, o, 1, i) - 1;
    return s[d](n[d](o));
  };
}
function M2(e, r) {
  return r.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function df() {
  var e = xT, r = xT, t = Tl, i, n, s, u = wi, o, d, a;
  function V() {
    var F = Math.min(e.length, r.length);
    return u !== wi && (u = NCe(e[0], e[F - 1])), o = F > 2 ? TCe : MCe, d = a = null, c;
  }
  function c(F) {
    return F == null || isNaN(F = +F) ? s : (d || (d = o(e.map(i), r, t)))(i(u(F)));
  }
  return c.invert = function(F) {
    return u(n((a || (a = o(r, e.map(i), CX)))(F)));
  }, c.domain = function(F) {
    return arguments.length ? (e = Array.from(F, PX), V()) : e.slice();
  }, c.range = function(F) {
    return arguments.length ? (r = Array.from(F), V()) : r.slice();
  }, c.rangeRound = function(F) {
    return r = Array.from(F), t = $A, V();
  }, c.clamp = function(F) {
    return arguments.length ? (u = F ? !0 : wi, V()) : u !== wi;
  }, c.interpolate = function(F) {
    return arguments.length ? (t = F, V()) : t;
  }, c.unknown = function(F) {
    return arguments.length ? (s = F, c) : s;
  }, function(F, X) {
    return i = F, n = X, V();
  };
}
function QA() {
  return df()(wi, wi);
}
function ECe(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function SX(e, r) {
  if ((t = (e = r ? e.toExponential(r - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var t, i = e.slice(0, t);
  return [
    i.length > 1 ? i[0] + i.slice(2) : i,
    +e.slice(t + 1)
  ];
}
function _V(e) {
  return e = SX(Math.abs(e)), e ? e[1] : NaN;
}
function kCe(e, r) {
  return function(t, i) {
    for (var n = t.length, s = [], u = 0, o = e[0], d = 0; n > 0 && o > 0 && (d + o + 1 > i && (o = Math.max(1, i - d)), s.push(t.substring(n -= o, n + o)), !((d += o + 1) > i)); )
      o = e[u = (u + 1) % e.length];
    return s.reverse().join(r);
  };
}
function OCe(e) {
  return function(r) {
    return r.replace(/[0-9]/g, function(t) {
      return e[+t];
    });
  };
}
var DCe = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function q7(e) {
  if (!(r = DCe.exec(e))) throw new Error("invalid format: " + e);
  var r;
  return new e4({
    fill: r[1],
    align: r[2],
    sign: r[3],
    symbol: r[4],
    zero: r[5],
    width: r[6],
    comma: r[7],
    precision: r[8] && r[8].slice(1),
    trim: r[9],
    type: r[10]
  });
}
q7.prototype = e4.prototype;
function e4(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
e4.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function RCe(e) {
  e: for (var r = e.length, t = 1, i = -1, n; t < r; ++t)
    switch (e[t]) {
      case ".":
        i = n = t;
        break;
      case "0":
        i === 0 && (i = t), n = t;
        break;
      default:
        if (!+e[t]) break e;
        i > 0 && (i = 0);
        break;
    }
  return i > 0 ? e.slice(0, i) + e.slice(n + 1) : e;
}
var eJ;
function ICe(e, r) {
  var t = SX(e, r);
  if (!t) return e + "";
  var i = t[0], n = t[1], s = n - (eJ = Math.max(-8, Math.min(8, Math.floor(n / 3))) * 3) + 1, u = i.length;
  return s === u ? i : s > u ? i + new Array(s - u + 1).join("0") : s > 0 ? i.slice(0, s) + "." + i.slice(s) : "0." + new Array(1 - s).join("0") + SX(e, Math.max(0, r + s - 1))[0];
}
function XT(e, r) {
  var t = SX(e, r);
  if (!t) return e + "";
  var i = t[0], n = t[1];
  return n < 0 ? "0." + new Array(-n).join("0") + i : i.length > n + 1 ? i.slice(0, n + 1) + "." + i.slice(n + 1) : i + new Array(n - i.length + 2).join("0");
}
const qT = {
  "%": (e, r) => (e * 100).toFixed(r),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: ECe,
  e: (e, r) => e.toExponential(r),
  f: (e, r) => e.toFixed(r),
  g: (e, r) => e.toPrecision(r),
  o: (e) => Math.round(e).toString(8),
  p: (e, r) => XT(e * 100, r),
  r: XT,
  s: ICe,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function YT(e) {
  return e;
}
var fT = Array.prototype.map, KT = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function LCe(e) {
  var r = e.grouping === void 0 || e.thousands === void 0 ? YT : kCe(fT.call(e.grouping, Number), e.thousands + ""), t = e.currency === void 0 ? "" : e.currency[0] + "", i = e.currency === void 0 ? "" : e.currency[1] + "", n = e.decimal === void 0 ? "." : e.decimal + "", s = e.numerals === void 0 ? YT : OCe(fT.call(e.numerals, String)), u = e.percent === void 0 ? "%" : e.percent + "", o = e.minus === void 0 ? "−" : e.minus + "", d = e.nan === void 0 ? "NaN" : e.nan + "";
  function a(c) {
    c = q7(c);
    var F = c.fill, X = c.align, Y = c.sign, q = c.symbol, f = c.zero, p = c.width, m = c.comma, g = c.precision, y = c.trim, b = c.type;
    b === "n" ? (m = !0, b = "g") : qT[b] || (g === void 0 && (g = 12), y = !0, b = "g"), (f || F === "0" && X === "=") && (f = !0, F = "0", X = "=");
    var A = q === "$" ? t : q === "#" && /[boxX]/.test(b) ? "0" + b.toLowerCase() : "", w = q === "$" ? i : /[%p]/.test(b) ? u : "", S = qT[b], N = /[defgprs%]/.test(b);
    g = g === void 0 ? 6 : /[gprs]/.test(b) ? Math.max(1, Math.min(21, g)) : Math.max(0, Math.min(20, g));
    function O(E) {
      var I = A, R = w, H, W, B;
      if (b === "c")
        R = S(E) + R, E = "";
      else {
        E = +E;
        var L = E < 0 || 1 / E < 0;
        if (E = isNaN(E) ? d : S(Math.abs(E), g), y && (E = RCe(E)), L && +E == 0 && Y !== "+" && (L = !1), I = (L ? Y === "(" ? Y : o : Y === "-" || Y === "(" ? "" : Y) + I, R = (b === "s" ? KT[8 + eJ / 3] : "") + R + (L && Y === "(" ? ")" : ""), N) {
          for (H = -1, W = E.length; ++H < W; )
            if (B = E.charCodeAt(H), 48 > B || B > 57) {
              R = (B === 46 ? n + E.slice(H + 1) : E.slice(H)) + R, E = E.slice(0, H);
              break;
            }
        }
      }
      m && !f && (E = r(E, 1 / 0));
      var z = I.length + E.length + R.length, Z = z < p ? new Array(p - z + 1).join(F) : "";
      switch (m && f && (E = r(Z + E, Z.length ? p - R.length : 1 / 0), Z = ""), X) {
        case "<":
          E = I + E + R + Z;
          break;
        case "=":
          E = I + Z + E + R;
          break;
        case "^":
          E = Z.slice(0, z = Z.length >> 1) + I + E + R + Z.slice(z);
          break;
        default:
          E = Z + I + E + R;
          break;
      }
      return s(E);
    }
    return O.toString = function() {
      return c + "";
    }, O;
  }
  function V(c, F) {
    var X = a((c = q7(c), c.type = "f", c)), Y = Math.max(-8, Math.min(8, Math.floor(_V(F) / 3))) * 3, q = Math.pow(10, -Y), f = KT[8 + Y / 3];
    return function(p) {
      return X(q * p) + f;
    };
  }
  return {
    format: a,
    formatPrefix: V
  };
}
var qx, r4, rJ;
_Ce({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function _Ce(e) {
  return qx = LCe(e), r4 = qx.format, rJ = qx.formatPrefix, qx;
}
function HCe(e) {
  return Math.max(0, -_V(Math.abs(e)));
}
function jCe(e, r) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(_V(r) / 3))) * 3 - _V(Math.abs(e)));
}
function zCe(e, r) {
  return e = Math.abs(e), r = Math.abs(r) - e, Math.max(0, _V(r) - _V(e)) + 1;
}
function tJ(e, r, t, i) {
  var n = z8(e, r, t), s;
  switch (i = q7(i ?? ",f"), i.type) {
    case "s": {
      var u = Math.max(Math.abs(e), Math.abs(r));
      return i.precision == null && !isNaN(s = jCe(n, u)) && (i.precision = s), rJ(i, u);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      i.precision == null && !isNaN(s = zCe(n, Math.max(Math.abs(e), Math.abs(r)))) && (i.precision = s - (i.type === "e"));
      break;
    }
    case "f":
    case "%": {
      i.precision == null && !isNaN(s = HCe(n)) && (i.precision = s - (i.type === "%") * 2);
      break;
    }
  }
  return r4(i);
}
function ed(e) {
  var r = e.domain;
  return e.ticks = function(t) {
    var i = r();
    return H8(i[0], i[i.length - 1], t ?? 10);
  }, e.tickFormat = function(t, i) {
    var n = r();
    return tJ(n[0], n[n.length - 1], t ?? 10, i);
  }, e.nice = function(t) {
    t == null && (t = 10);
    var i = r(), n = 0, s = i.length - 1, u = i[n], o = i[s], d, a, V = 10;
    for (o < u && (a = u, u = o, o = a, a = n, n = s, s = a); V-- > 0; ) {
      if (a = j8(u, o, t), a === d)
        return i[n] = u, i[s] = o, r(i);
      if (a > 0)
        u = Math.floor(u / a) * a, o = Math.ceil(o / a) * a;
      else if (a < 0)
        u = Math.ceil(u * a) / a, o = Math.floor(o * a) / a;
      else
        break;
      d = a;
    }
    return e;
  }, e;
}
function NX() {
  var e = QA();
  return e.copy = function() {
    return M2(e, NX());
  }, Hn.apply(e, arguments), ed(e);
}
function iJ(e) {
  var r;
  function t(i) {
    return i == null || isNaN(i = +i) ? r : i;
  }
  return t.invert = t, t.domain = t.range = function(i) {
    return arguments.length ? (e = Array.from(i, PX), t) : e.slice();
  }, t.unknown = function(i) {
    return arguments.length ? (r = i, t) : r;
  }, t.copy = function() {
    return iJ(e).unknown(r);
  }, e = arguments.length ? Array.from(e, PX) : [0, 1], ed(t);
}
function nJ(e, r) {
  e = e.slice();
  var t = 0, i = e.length - 1, n = e[t], s = e[i], u;
  return s < n && (u = t, t = i, i = u, u = n, n = s, s = u), e[t] = r.floor(n), e[i] = r.ceil(s), e;
}
function hT(e) {
  return Math.log(e);
}
function pT(e) {
  return Math.exp(e);
}
function BCe(e) {
  return -Math.log(-e);
}
function WCe(e) {
  return -Math.exp(-e);
}
function GCe(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function UCe(e) {
  return e === 10 ? GCe : e === Math.E ? Math.exp : (r) => Math.pow(e, r);
}
function ZCe(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (r) => Math.log(r) / e);
}
function mT(e) {
  return (r, t) => -e(-r, t);
}
function t4(e) {
  const r = e(hT, pT), t = r.domain;
  let i = 10, n, s;
  function u() {
    return n = ZCe(i), s = UCe(i), t()[0] < 0 ? (n = mT(n), s = mT(s), e(BCe, WCe)) : e(hT, pT), r;
  }
  return r.base = function(o) {
    return arguments.length ? (i = +o, u()) : i;
  }, r.domain = function(o) {
    return arguments.length ? (t(o), u()) : t();
  }, r.ticks = (o) => {
    const d = t();
    let a = d[0], V = d[d.length - 1];
    const c = V < a;
    c && ([a, V] = [V, a]);
    let F = n(a), X = n(V), Y, q;
    const f = o == null ? 10 : +o;
    let p = [];
    if (!(i % 1) && X - F < f) {
      if (F = Math.floor(F), X = Math.ceil(X), a > 0) {
        for (; F <= X; ++F)
          for (Y = 1; Y < i; ++Y)
            if (q = F < 0 ? Y / s(-F) : Y * s(F), !(q < a)) {
              if (q > V) break;
              p.push(q);
            }
      } else for (; F <= X; ++F)
        for (Y = i - 1; Y >= 1; --Y)
          if (q = F > 0 ? Y / s(-F) : Y * s(F), !(q < a)) {
            if (q > V) break;
            p.push(q);
          }
      p.length * 2 < f && (p = H8(a, V, f));
    } else
      p = H8(F, X, Math.min(X - F, f)).map(s);
    return c ? p.reverse() : p;
  }, r.tickFormat = (o, d) => {
    if (o == null && (o = 10), d == null && (d = i === 10 ? "s" : ","), typeof d != "function" && (!(i % 1) && (d = q7(d)).precision == null && (d.trim = !0), d = r4(d)), o === 1 / 0) return d;
    const a = Math.max(1, i * o / r.ticks().length);
    return (V) => {
      let c = V / s(Math.round(n(V)));
      return c * i < i - 0.5 && (c *= i), c <= a ? d(V) : "";
    };
  }, r.nice = () => t(nJ(t(), {
    floor: (o) => s(Math.floor(n(o))),
    ceil: (o) => s(Math.ceil(n(o)))
  })), r;
}
function sJ() {
  const e = t4(df()).domain([1, 10]);
  return e.copy = () => M2(e, sJ()).base(e.base()), Hn.apply(e, arguments), e;
}
function gT(e) {
  return function(r) {
    return Math.sign(r) * Math.log1p(Math.abs(r / e));
  };
}
function vT(e) {
  return function(r) {
    return Math.sign(r) * Math.expm1(Math.abs(r)) * e;
  };
}
function i4(e) {
  var r = 1, t = e(gT(r), vT(r));
  return t.constant = function(i) {
    return arguments.length ? e(gT(r = +i), vT(r)) : r;
  }, ed(t);
}
function uJ() {
  var e = i4(df());
  return e.copy = function() {
    return M2(e, uJ()).constant(e.constant());
  }, Hn.apply(e, arguments);
}
function bT(e) {
  return function(r) {
    return r < 0 ? -Math.pow(-r, e) : Math.pow(r, e);
  };
}
function JCe(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function $Ce(e) {
  return e < 0 ? -e * e : e * e;
}
function n4(e) {
  var r = e(wi, wi), t = 1;
  function i() {
    return t === 1 ? e(wi, wi) : t === 0.5 ? e(JCe, $Ce) : e(bT(t), bT(1 / t));
  }
  return r.exponent = function(n) {
    return arguments.length ? (t = +n, i()) : t;
  }, ed(r);
}
function s4() {
  var e = n4(df());
  return e.copy = function() {
    return M2(e, s4()).exponent(e.exponent());
  }, Hn.apply(e, arguments), e;
}
function QCe() {
  return s4.apply(null, arguments).exponent(0.5);
}
function yT(e) {
  return Math.sign(e) * e * e;
}
function ePe(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function oJ() {
  var e = QA(), r = [0, 1], t = !1, i;
  function n(s) {
    var u = ePe(e(s));
    return isNaN(u) ? i : t ? Math.round(u) : u;
  }
  return n.invert = function(s) {
    return e.invert(yT(s));
  }, n.domain = function(s) {
    return arguments.length ? (e.domain(s), n) : e.domain();
  }, n.range = function(s) {
    return arguments.length ? (e.range((r = Array.from(s, PX)).map(yT)), n) : r.slice();
  }, n.rangeRound = function(s) {
    return n.range(s).round(!0);
  }, n.round = function(s) {
    return arguments.length ? (t = !!s, n) : t;
  }, n.clamp = function(s) {
    return arguments.length ? (e.clamp(s), n) : e.clamp();
  }, n.unknown = function(s) {
    return arguments.length ? (i = s, n) : i;
  }, n.copy = function() {
    return oJ(e.domain(), r).round(t).clamp(e.clamp()).unknown(i);
  }, Hn.apply(n, arguments), ed(n);
}
function dJ() {
  var e = [], r = [], t = [], i;
  function n() {
    var u = 0, o = Math.max(1, r.length);
    for (t = new Array(o - 1); ++u < o; ) t[u - 1] = sCe(e, u / o);
    return s;
  }
  function s(u) {
    return u == null || isNaN(u = +u) ? i : r[S2(t, u)];
  }
  return s.invertExtent = function(u) {
    var o = r.indexOf(u);
    return o < 0 ? [NaN, NaN] : [
      o > 0 ? t[o - 1] : e[0],
      o < t.length ? t[o] : e[e.length - 1]
    ];
  }, s.domain = function(u) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let o of u) o != null && !isNaN(o = +o) && e.push(o);
    return e.sort(Mo), n();
  }, s.range = function(u) {
    return arguments.length ? (r = Array.from(u), n()) : r.slice();
  }, s.unknown = function(u) {
    return arguments.length ? (i = u, s) : i;
  }, s.quantiles = function() {
    return t.slice();
  }, s.copy = function() {
    return dJ().domain(e).range(r).unknown(i);
  }, Hn.apply(s, arguments);
}
function aJ() {
  var e = 0, r = 1, t = 1, i = [0.5], n = [0, 1], s;
  function u(d) {
    return d != null && d <= d ? n[S2(i, d, 0, t)] : s;
  }
  function o() {
    var d = -1;
    for (i = new Array(t); ++d < t; ) i[d] = ((d + 1) * r - (d - t) * e) / (t + 1);
    return u;
  }
  return u.domain = function(d) {
    return arguments.length ? ([e, r] = d, e = +e, r = +r, o()) : [e, r];
  }, u.range = function(d) {
    return arguments.length ? (t = (n = Array.from(d)).length - 1, o()) : n.slice();
  }, u.invertExtent = function(d) {
    var a = n.indexOf(d);
    return a < 0 ? [NaN, NaN] : a < 1 ? [e, i[0]] : a >= t ? [i[t - 1], r] : [i[a - 1], i[a]];
  }, u.unknown = function(d) {
    return arguments.length && (s = d), u;
  }, u.thresholds = function() {
    return i.slice();
  }, u.copy = function() {
    return aJ().domain([e, r]).range(n).unknown(s);
  }, Hn.apply(ed(u), arguments);
}
function VJ() {
  var e = [0.5], r = [0, 1], t, i = 1;
  function n(s) {
    return s != null && s <= s ? r[S2(e, s, 0, i)] : t;
  }
  return n.domain = function(s) {
    return arguments.length ? (e = Array.from(s), i = Math.min(e.length, r.length - 1), n) : e.slice();
  }, n.range = function(s) {
    return arguments.length ? (r = Array.from(s), i = Math.min(e.length, r.length - 1), n) : r.slice();
  }, n.invertExtent = function(s) {
    var u = r.indexOf(s);
    return [e[u - 1], e[u]];
  }, n.unknown = function(s) {
    return arguments.length ? (t = s, n) : t;
  }, n.copy = function() {
    return VJ().domain(e).range(r).unknown(t);
  }, Hn.apply(n, arguments);
}
const Pm = /* @__PURE__ */ new Date(), Sm = /* @__PURE__ */ new Date();
function Tt(e, r, t, i) {
  function n(s) {
    return e(s = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+s)), s;
  }
  return n.floor = (s) => (e(s = /* @__PURE__ */ new Date(+s)), s), n.ceil = (s) => (e(s = new Date(s - 1)), r(s, 1), e(s), s), n.round = (s) => {
    const u = n(s), o = n.ceil(s);
    return s - u < o - s ? u : o;
  }, n.offset = (s, u) => (r(s = /* @__PURE__ */ new Date(+s), u == null ? 1 : Math.floor(u)), s), n.range = (s, u, o) => {
    const d = [];
    if (s = n.ceil(s), o = o == null ? 1 : Math.floor(o), !(s < u) || !(o > 0)) return d;
    let a;
    do
      d.push(a = /* @__PURE__ */ new Date(+s)), r(s, o), e(s);
    while (a < s && s < u);
    return d;
  }, n.filter = (s) => Tt((u) => {
    if (u >= u) for (; e(u), !s(u); ) u.setTime(u - 1);
  }, (u, o) => {
    if (u >= u)
      if (o < 0) for (; ++o <= 0; )
        for (; r(u, -1), !s(u); )
          ;
      else for (; --o >= 0; )
        for (; r(u, 1), !s(u); )
          ;
  }), t && (n.count = (s, u) => (Pm.setTime(+s), Sm.setTime(+u), e(Pm), e(Sm), Math.floor(t(Pm, Sm))), n.every = (s) => (s = Math.floor(s), !isFinite(s) || !(s > 0) ? null : s > 1 ? n.filter(i ? (u) => i(u) % s === 0 : (u) => n.count(0, u) % s === 0) : n)), n;
}
const MX = Tt(() => {
}, (e, r) => {
  e.setTime(+e + r);
}, (e, r) => r - e);
MX.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Tt((r) => {
  r.setTime(Math.floor(r / e) * e);
}, (r, t) => {
  r.setTime(+r + t * e);
}, (r, t) => (t - r) / e) : MX);
MX.range;
const bu = 1e3, Pn = bu * 60, yu = Pn * 60, Ru = yu * 24, u4 = Ru * 7, AT = Ru * 30, Nm = Ru * 365, Pd = Tt((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, r) => {
  e.setTime(+e + r * bu);
}, (e, r) => (r - e) / bu, (e) => e.getUTCSeconds());
Pd.range;
const o4 = Tt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * bu);
}, (e, r) => {
  e.setTime(+e + r * Pn);
}, (e, r) => (r - e) / Pn, (e) => e.getMinutes());
o4.range;
const d4 = Tt((e) => {
  e.setUTCSeconds(0, 0);
}, (e, r) => {
  e.setTime(+e + r * Pn);
}, (e, r) => (r - e) / Pn, (e) => e.getUTCMinutes());
d4.range;
const a4 = Tt((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * bu - e.getMinutes() * Pn);
}, (e, r) => {
  e.setTime(+e + r * yu);
}, (e, r) => (r - e) / yu, (e) => e.getHours());
a4.range;
const V4 = Tt((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, r) => {
  e.setTime(+e + r * yu);
}, (e, r) => (r - e) / yu, (e) => e.getUTCHours());
V4.range;
const T2 = Tt(
  (e) => e.setHours(0, 0, 0, 0),
  (e, r) => e.setDate(e.getDate() + r),
  (e, r) => (r - e - (r.getTimezoneOffset() - e.getTimezoneOffset()) * Pn) / Ru,
  (e) => e.getDate() - 1
);
T2.range;
const af = Tt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, r) => {
  e.setUTCDate(e.getUTCDate() + r);
}, (e, r) => (r - e) / Ru, (e) => e.getUTCDate() - 1);
af.range;
const lJ = Tt((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, r) => {
  e.setUTCDate(e.getUTCDate() + r);
}, (e, r) => (r - e) / Ru, (e) => Math.floor(e / Ru));
lJ.range;
function Fa(e) {
  return Tt((r) => {
    r.setDate(r.getDate() - (r.getDay() + 7 - e) % 7), r.setHours(0, 0, 0, 0);
  }, (r, t) => {
    r.setDate(r.getDate() + t * 7);
  }, (r, t) => (t - r - (t.getTimezoneOffset() - r.getTimezoneOffset()) * Pn) / u4);
}
const Vf = Fa(0), TX = Fa(1), rPe = Fa(2), tPe = Fa(3), HV = Fa(4), iPe = Fa(5), nPe = Fa(6);
Vf.range;
TX.range;
rPe.range;
tPe.range;
HV.range;
iPe.range;
nPe.range;
function xa(e) {
  return Tt((r) => {
    r.setUTCDate(r.getUTCDate() - (r.getUTCDay() + 7 - e) % 7), r.setUTCHours(0, 0, 0, 0);
  }, (r, t) => {
    r.setUTCDate(r.getUTCDate() + t * 7);
  }, (r, t) => (t - r) / u4);
}
const lf = xa(0), EX = xa(1), sPe = xa(2), uPe = xa(3), jV = xa(4), oPe = xa(5), dPe = xa(6);
lf.range;
EX.range;
sPe.range;
uPe.range;
jV.range;
oPe.range;
dPe.range;
const l4 = Tt((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, r) => {
  e.setMonth(e.getMonth() + r);
}, (e, r) => r.getMonth() - e.getMonth() + (r.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
l4.range;
const c4 = Tt((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, r) => {
  e.setUTCMonth(e.getUTCMonth() + r);
}, (e, r) => r.getUTCMonth() - e.getUTCMonth() + (r.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
c4.range;
const Iu = Tt((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, r) => {
  e.setFullYear(e.getFullYear() + r);
}, (e, r) => r.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Iu.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Tt((r) => {
  r.setFullYear(Math.floor(r.getFullYear() / e) * e), r.setMonth(0, 1), r.setHours(0, 0, 0, 0);
}, (r, t) => {
  r.setFullYear(r.getFullYear() + t * e);
});
Iu.range;
const Lu = Tt((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, r) => {
  e.setUTCFullYear(e.getUTCFullYear() + r);
}, (e, r) => r.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
Lu.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Tt((r) => {
  r.setUTCFullYear(Math.floor(r.getUTCFullYear() / e) * e), r.setUTCMonth(0, 1), r.setUTCHours(0, 0, 0, 0);
}, (r, t) => {
  r.setUTCFullYear(r.getUTCFullYear() + t * e);
});
Lu.range;
function cJ(e, r, t, i, n, s) {
  const u = [
    [Pd, 1, bu],
    [Pd, 5, 5 * bu],
    [Pd, 15, 15 * bu],
    [Pd, 30, 30 * bu],
    [s, 1, Pn],
    [s, 5, 5 * Pn],
    [s, 15, 15 * Pn],
    [s, 30, 30 * Pn],
    [n, 1, yu],
    [n, 3, 3 * yu],
    [n, 6, 6 * yu],
    [n, 12, 12 * yu],
    [i, 1, Ru],
    [i, 2, 2 * Ru],
    [t, 1, u4],
    [r, 1, AT],
    [r, 3, 3 * AT],
    [e, 1, Nm]
  ];
  function o(a, V, c) {
    const F = V < a;
    F && ([a, V] = [V, a]);
    const X = c && typeof c.range == "function" ? c : d(a, V, c), Y = X ? X.range(a, +V + 1) : [];
    return F ? Y.reverse() : Y;
  }
  function d(a, V, c) {
    const F = Math.abs(V - a) / c, X = GA(([, , f]) => f).right(u, F);
    if (X === u.length) return e.every(z8(a / Nm, V / Nm, c));
    if (X === 0) return MX.every(Math.max(z8(a, V, c), 1));
    const [Y, q] = u[F / u[X - 1][2] < u[X][2] / F ? X - 1 : X];
    return Y.every(q);
  }
  return [o, d];
}
const [aPe, VPe] = cJ(Lu, c4, lf, lJ, V4, d4), [lPe, cPe] = cJ(Iu, l4, Vf, T2, a4, o4);
function Mm(e) {
  if (0 <= e.y && e.y < 100) {
    var r = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return r.setFullYear(e.y), r;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function Tm(e) {
  if (0 <= e.y && e.y < 100) {
    var r = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return r.setUTCFullYear(e.y), r;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Fc(e, r, t) {
  return { y: e, m: r, d: t, H: 0, M: 0, S: 0, L: 0 };
}
function FPe(e) {
  var r = e.dateTime, t = e.date, i = e.time, n = e.periods, s = e.days, u = e.shortDays, o = e.months, d = e.shortMonths, a = xc(n), V = Xc(n), c = xc(s), F = Xc(s), X = xc(u), Y = Xc(u), q = xc(o), f = Xc(o), p = xc(d), m = Xc(d), g = {
    a: L,
    A: z,
    b: Z,
    B: le,
    c: null,
    d: MT,
    e: MT,
    f: kPe,
    g: BPe,
    G: GPe,
    H: MPe,
    I: TPe,
    j: EPe,
    L: FJ,
    m: OPe,
    M: DPe,
    p: te,
    q: U,
    Q: kT,
    s: OT,
    S: RPe,
    u: IPe,
    U: LPe,
    V: _Pe,
    w: HPe,
    W: jPe,
    x: null,
    X: null,
    y: zPe,
    Y: WPe,
    Z: UPe,
    "%": ET
  }, y = {
    a: de,
    A: Ke,
    b: xe,
    B: be,
    c: null,
    d: TT,
    e: TT,
    f: QPe,
    g: aSe,
    G: lSe,
    H: ZPe,
    I: JPe,
    j: $Pe,
    L: XJ,
    m: eSe,
    M: rSe,
    p: qe,
    q: me,
    Q: kT,
    s: OT,
    S: tSe,
    u: iSe,
    U: nSe,
    V: sSe,
    w: uSe,
    W: oSe,
    x: null,
    X: null,
    y: dSe,
    Y: VSe,
    Z: cSe,
    "%": ET
  }, b = {
    a: O,
    A: E,
    b: I,
    B: R,
    c: H,
    d: ST,
    e: ST,
    f: CPe,
    g: PT,
    G: CT,
    H: NT,
    I: NT,
    j: bPe,
    L: wPe,
    m: vPe,
    M: yPe,
    p: N,
    q: gPe,
    Q: SPe,
    s: NPe,
    S: APe,
    u: fPe,
    U: KPe,
    V: hPe,
    w: YPe,
    W: pPe,
    x: W,
    X: B,
    y: PT,
    Y: CT,
    Z: mPe,
    "%": PPe
  };
  g.x = A(t, g), g.X = A(i, g), g.c = A(r, g), y.x = A(t, y), y.X = A(i, y), y.c = A(r, y);
  function A(ne, fe) {
    return function(Ye) {
      var Q = [], we = -1, oe = 0, tr = ne.length, ar, or, bt;
      for (Ye instanceof Date || (Ye = /* @__PURE__ */ new Date(+Ye)); ++we < tr; )
        ne.charCodeAt(we) === 37 && (Q.push(ne.slice(oe, we)), (or = wT[ar = ne.charAt(++we)]) != null ? ar = ne.charAt(++we) : or = ar === "e" ? " " : "0", (bt = fe[ar]) && (ar = bt(Ye, or)), Q.push(ar), oe = we + 1);
      return Q.push(ne.slice(oe, we)), Q.join("");
    };
  }
  function w(ne, fe) {
    return function(Ye) {
      var Q = Fc(1900, void 0, 1), we = S(Q, ne, Ye += "", 0), oe, tr;
      if (we != Ye.length) return null;
      if ("Q" in Q) return new Date(Q.Q);
      if ("s" in Q) return new Date(Q.s * 1e3 + ("L" in Q ? Q.L : 0));
      if (fe && !("Z" in Q) && (Q.Z = 0), "p" in Q && (Q.H = Q.H % 12 + Q.p * 12), Q.m === void 0 && (Q.m = "q" in Q ? Q.q : 0), "V" in Q) {
        if (Q.V < 1 || Q.V > 53) return null;
        "w" in Q || (Q.w = 1), "Z" in Q ? (oe = Tm(Fc(Q.y, 0, 1)), tr = oe.getUTCDay(), oe = tr > 4 || tr === 0 ? EX.ceil(oe) : EX(oe), oe = af.offset(oe, (Q.V - 1) * 7), Q.y = oe.getUTCFullYear(), Q.m = oe.getUTCMonth(), Q.d = oe.getUTCDate() + (Q.w + 6) % 7) : (oe = Mm(Fc(Q.y, 0, 1)), tr = oe.getDay(), oe = tr > 4 || tr === 0 ? TX.ceil(oe) : TX(oe), oe = T2.offset(oe, (Q.V - 1) * 7), Q.y = oe.getFullYear(), Q.m = oe.getMonth(), Q.d = oe.getDate() + (Q.w + 6) % 7);
      } else ("W" in Q || "U" in Q) && ("w" in Q || (Q.w = "u" in Q ? Q.u % 7 : "W" in Q ? 1 : 0), tr = "Z" in Q ? Tm(Fc(Q.y, 0, 1)).getUTCDay() : Mm(Fc(Q.y, 0, 1)).getDay(), Q.m = 0, Q.d = "W" in Q ? (Q.w + 6) % 7 + Q.W * 7 - (tr + 5) % 7 : Q.w + Q.U * 7 - (tr + 6) % 7);
      return "Z" in Q ? (Q.H += Q.Z / 100 | 0, Q.M += Q.Z % 100, Tm(Q)) : Mm(Q);
    };
  }
  function S(ne, fe, Ye, Q) {
    for (var we = 0, oe = fe.length, tr = Ye.length, ar, or; we < oe; ) {
      if (Q >= tr) return -1;
      if (ar = fe.charCodeAt(we++), ar === 37) {
        if (ar = fe.charAt(we++), or = b[ar in wT ? fe.charAt(we++) : ar], !or || (Q = or(ne, Ye, Q)) < 0) return -1;
      } else if (ar != Ye.charCodeAt(Q++))
        return -1;
    }
    return Q;
  }
  function N(ne, fe, Ye) {
    var Q = a.exec(fe.slice(Ye));
    return Q ? (ne.p = V.get(Q[0].toLowerCase()), Ye + Q[0].length) : -1;
  }
  function O(ne, fe, Ye) {
    var Q = X.exec(fe.slice(Ye));
    return Q ? (ne.w = Y.get(Q[0].toLowerCase()), Ye + Q[0].length) : -1;
  }
  function E(ne, fe, Ye) {
    var Q = c.exec(fe.slice(Ye));
    return Q ? (ne.w = F.get(Q[0].toLowerCase()), Ye + Q[0].length) : -1;
  }
  function I(ne, fe, Ye) {
    var Q = p.exec(fe.slice(Ye));
    return Q ? (ne.m = m.get(Q[0].toLowerCase()), Ye + Q[0].length) : -1;
  }
  function R(ne, fe, Ye) {
    var Q = q.exec(fe.slice(Ye));
    return Q ? (ne.m = f.get(Q[0].toLowerCase()), Ye + Q[0].length) : -1;
  }
  function H(ne, fe, Ye) {
    return S(ne, r, fe, Ye);
  }
  function W(ne, fe, Ye) {
    return S(ne, t, fe, Ye);
  }
  function B(ne, fe, Ye) {
    return S(ne, i, fe, Ye);
  }
  function L(ne) {
    return u[ne.getDay()];
  }
  function z(ne) {
    return s[ne.getDay()];
  }
  function Z(ne) {
    return d[ne.getMonth()];
  }
  function le(ne) {
    return o[ne.getMonth()];
  }
  function te(ne) {
    return n[+(ne.getHours() >= 12)];
  }
  function U(ne) {
    return 1 + ~~(ne.getMonth() / 3);
  }
  function de(ne) {
    return u[ne.getUTCDay()];
  }
  function Ke(ne) {
    return s[ne.getUTCDay()];
  }
  function xe(ne) {
    return d[ne.getUTCMonth()];
  }
  function be(ne) {
    return o[ne.getUTCMonth()];
  }
  function qe(ne) {
    return n[+(ne.getUTCHours() >= 12)];
  }
  function me(ne) {
    return 1 + ~~(ne.getUTCMonth() / 3);
  }
  return {
    format: function(ne) {
      var fe = A(ne += "", g);
      return fe.toString = function() {
        return ne;
      }, fe;
    },
    parse: function(ne) {
      var fe = w(ne += "", !1);
      return fe.toString = function() {
        return ne;
      }, fe;
    },
    utcFormat: function(ne) {
      var fe = A(ne += "", y);
      return fe.toString = function() {
        return ne;
      }, fe;
    },
    utcParse: function(ne) {
      var fe = w(ne += "", !0);
      return fe.toString = function() {
        return ne;
      }, fe;
    }
  };
}
var wT = { "-": "", _: " ", 0: "0" }, Wt = /^\s*\d+/, xPe = /^%/, XPe = /[\\^$*+?|[\]().{}]/g;
function hr(e, r, t) {
  var i = e < 0 ? "-" : "", n = (i ? -e : e) + "", s = n.length;
  return i + (s < t ? new Array(t - s + 1).join(r) + n : n);
}
function qPe(e) {
  return e.replace(XPe, "\\$&");
}
function xc(e) {
  return new RegExp("^(?:" + e.map(qPe).join("|") + ")", "i");
}
function Xc(e) {
  return new Map(e.map((r, t) => [r.toLowerCase(), t]));
}
function YPe(e, r, t) {
  var i = Wt.exec(r.slice(t, t + 1));
  return i ? (e.w = +i[0], t + i[0].length) : -1;
}
function fPe(e, r, t) {
  var i = Wt.exec(r.slice(t, t + 1));
  return i ? (e.u = +i[0], t + i[0].length) : -1;
}
function KPe(e, r, t) {
  var i = Wt.exec(r.slice(t, t + 2));
  return i ? (e.U = +i[0], t + i[0].length) : -1;
}
function hPe(e, r, t) {
  var i = Wt.exec(r.slice(t, t + 2));
  return i ? (e.V = +i[0], t + i[0].length) : -1;
}
function pPe(e, r, t) {
  var i = Wt.exec(r.slice(t, t + 2));
  return i ? (e.W = +i[0], t + i[0].length) : -1;
}
function CT(e, r, t) {
  var i = Wt.exec(r.slice(t, t + 4));
  return i ? (e.y = +i[0], t + i[0].length) : -1;
}
function PT(e, r, t) {
  var i = Wt.exec(r.slice(t, t + 2));
  return i ? (e.y = +i[0] + (+i[0] > 68 ? 1900 : 2e3), t + i[0].length) : -1;
}
function mPe(e, r, t) {
  var i = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(r.slice(t, t + 6));
  return i ? (e.Z = i[1] ? 0 : -(i[2] + (i[3] || "00")), t + i[0].length) : -1;
}
function gPe(e, r, t) {
  var i = Wt.exec(r.slice(t, t + 1));
  return i ? (e.q = i[0] * 3 - 3, t + i[0].length) : -1;
}
function vPe(e, r, t) {
  var i = Wt.exec(r.slice(t, t + 2));
  return i ? (e.m = i[0] - 1, t + i[0].length) : -1;
}
function ST(e, r, t) {
  var i = Wt.exec(r.slice(t, t + 2));
  return i ? (e.d = +i[0], t + i[0].length) : -1;
}
function bPe(e, r, t) {
  var i = Wt.exec(r.slice(t, t + 3));
  return i ? (e.m = 0, e.d = +i[0], t + i[0].length) : -1;
}
function NT(e, r, t) {
  var i = Wt.exec(r.slice(t, t + 2));
  return i ? (e.H = +i[0], t + i[0].length) : -1;
}
function yPe(e, r, t) {
  var i = Wt.exec(r.slice(t, t + 2));
  return i ? (e.M = +i[0], t + i[0].length) : -1;
}
function APe(e, r, t) {
  var i = Wt.exec(r.slice(t, t + 2));
  return i ? (e.S = +i[0], t + i[0].length) : -1;
}
function wPe(e, r, t) {
  var i = Wt.exec(r.slice(t, t + 3));
  return i ? (e.L = +i[0], t + i[0].length) : -1;
}
function CPe(e, r, t) {
  var i = Wt.exec(r.slice(t, t + 6));
  return i ? (e.L = Math.floor(i[0] / 1e3), t + i[0].length) : -1;
}
function PPe(e, r, t) {
  var i = xPe.exec(r.slice(t, t + 1));
  return i ? t + i[0].length : -1;
}
function SPe(e, r, t) {
  var i = Wt.exec(r.slice(t));
  return i ? (e.Q = +i[0], t + i[0].length) : -1;
}
function NPe(e, r, t) {
  var i = Wt.exec(r.slice(t));
  return i ? (e.s = +i[0], t + i[0].length) : -1;
}
function MT(e, r) {
  return hr(e.getDate(), r, 2);
}
function MPe(e, r) {
  return hr(e.getHours(), r, 2);
}
function TPe(e, r) {
  return hr(e.getHours() % 12 || 12, r, 2);
}
function EPe(e, r) {
  return hr(1 + T2.count(Iu(e), e), r, 3);
}
function FJ(e, r) {
  return hr(e.getMilliseconds(), r, 3);
}
function kPe(e, r) {
  return FJ(e, r) + "000";
}
function OPe(e, r) {
  return hr(e.getMonth() + 1, r, 2);
}
function DPe(e, r) {
  return hr(e.getMinutes(), r, 2);
}
function RPe(e, r) {
  return hr(e.getSeconds(), r, 2);
}
function IPe(e) {
  var r = e.getDay();
  return r === 0 ? 7 : r;
}
function LPe(e, r) {
  return hr(Vf.count(Iu(e) - 1, e), r, 2);
}
function xJ(e) {
  var r = e.getDay();
  return r >= 4 || r === 0 ? HV(e) : HV.ceil(e);
}
function _Pe(e, r) {
  return e = xJ(e), hr(HV.count(Iu(e), e) + (Iu(e).getDay() === 4), r, 2);
}
function HPe(e) {
  return e.getDay();
}
function jPe(e, r) {
  return hr(TX.count(Iu(e) - 1, e), r, 2);
}
function zPe(e, r) {
  return hr(e.getFullYear() % 100, r, 2);
}
function BPe(e, r) {
  return e = xJ(e), hr(e.getFullYear() % 100, r, 2);
}
function WPe(e, r) {
  return hr(e.getFullYear() % 1e4, r, 4);
}
function GPe(e, r) {
  var t = e.getDay();
  return e = t >= 4 || t === 0 ? HV(e) : HV.ceil(e), hr(e.getFullYear() % 1e4, r, 4);
}
function UPe(e) {
  var r = e.getTimezoneOffset();
  return (r > 0 ? "-" : (r *= -1, "+")) + hr(r / 60 | 0, "0", 2) + hr(r % 60, "0", 2);
}
function TT(e, r) {
  return hr(e.getUTCDate(), r, 2);
}
function ZPe(e, r) {
  return hr(e.getUTCHours(), r, 2);
}
function JPe(e, r) {
  return hr(e.getUTCHours() % 12 || 12, r, 2);
}
function $Pe(e, r) {
  return hr(1 + af.count(Lu(e), e), r, 3);
}
function XJ(e, r) {
  return hr(e.getUTCMilliseconds(), r, 3);
}
function QPe(e, r) {
  return XJ(e, r) + "000";
}
function eSe(e, r) {
  return hr(e.getUTCMonth() + 1, r, 2);
}
function rSe(e, r) {
  return hr(e.getUTCMinutes(), r, 2);
}
function tSe(e, r) {
  return hr(e.getUTCSeconds(), r, 2);
}
function iSe(e) {
  var r = e.getUTCDay();
  return r === 0 ? 7 : r;
}
function nSe(e, r) {
  return hr(lf.count(Lu(e) - 1, e), r, 2);
}
function qJ(e) {
  var r = e.getUTCDay();
  return r >= 4 || r === 0 ? jV(e) : jV.ceil(e);
}
function sSe(e, r) {
  return e = qJ(e), hr(jV.count(Lu(e), e) + (Lu(e).getUTCDay() === 4), r, 2);
}
function uSe(e) {
  return e.getUTCDay();
}
function oSe(e, r) {
  return hr(EX.count(Lu(e) - 1, e), r, 2);
}
function dSe(e, r) {
  return hr(e.getUTCFullYear() % 100, r, 2);
}
function aSe(e, r) {
  return e = qJ(e), hr(e.getUTCFullYear() % 100, r, 2);
}
function VSe(e, r) {
  return hr(e.getUTCFullYear() % 1e4, r, 4);
}
function lSe(e, r) {
  var t = e.getUTCDay();
  return e = t >= 4 || t === 0 ? jV(e) : jV.ceil(e), hr(e.getUTCFullYear() % 1e4, r, 4);
}
function cSe() {
  return "+0000";
}
function ET() {
  return "%";
}
function kT(e) {
  return +e;
}
function OT(e) {
  return Math.floor(+e / 1e3);
}
var Ga, YJ, fJ;
FSe({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function FSe(e) {
  return Ga = FPe(e), YJ = Ga.format, Ga.parse, fJ = Ga.utcFormat, Ga.utcParse, Ga;
}
function xSe(e) {
  return new Date(e);
}
function XSe(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function F4(e, r, t, i, n, s, u, o, d, a) {
  var V = QA(), c = V.invert, F = V.domain, X = a(".%L"), Y = a(":%S"), q = a("%I:%M"), f = a("%I %p"), p = a("%a %d"), m = a("%b %d"), g = a("%B"), y = a("%Y");
  function b(A) {
    return (d(A) < A ? X : o(A) < A ? Y : u(A) < A ? q : s(A) < A ? f : i(A) < A ? n(A) < A ? p : m : t(A) < A ? g : y)(A);
  }
  return V.invert = function(A) {
    return new Date(c(A));
  }, V.domain = function(A) {
    return arguments.length ? F(Array.from(A, XSe)) : F().map(xSe);
  }, V.ticks = function(A) {
    var w = F();
    return e(w[0], w[w.length - 1], A ?? 10);
  }, V.tickFormat = function(A, w) {
    return w == null ? b : a(w);
  }, V.nice = function(A) {
    var w = F();
    return (!A || typeof A.range != "function") && (A = r(w[0], w[w.length - 1], A ?? 10)), A ? F(nJ(w, A)) : V;
  }, V.copy = function() {
    return M2(V, F4(e, r, t, i, n, s, u, o, d, a));
  }, V;
}
function qSe() {
  return Hn.apply(F4(lPe, cPe, Iu, l4, Vf, T2, a4, o4, Pd, YJ).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function YSe() {
  return Hn.apply(F4(aPe, VPe, Lu, c4, lf, af, V4, d4, Pd, fJ).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function cf() {
  var e = 0, r = 1, t, i, n, s, u = wi, o = !1, d;
  function a(c) {
    return c == null || isNaN(c = +c) ? d : u(n === 0 ? 0.5 : (c = (s(c) - t) * n, o ? Math.max(0, Math.min(1, c)) : c));
  }
  a.domain = function(c) {
    return arguments.length ? ([e, r] = c, t = s(e = +e), i = s(r = +r), n = t === i ? 0 : 1 / (i - t), a) : [e, r];
  }, a.clamp = function(c) {
    return arguments.length ? (o = !!c, a) : o;
  }, a.interpolator = function(c) {
    return arguments.length ? (u = c, a) : u;
  };
  function V(c) {
    return function(F) {
      var X, Y;
      return arguments.length ? ([X, Y] = F, u = c(X, Y), a) : [u(0), u(1)];
    };
  }
  return a.range = V(Tl), a.rangeRound = V($A), a.unknown = function(c) {
    return arguments.length ? (d = c, a) : d;
  }, function(c) {
    return s = c, t = c(e), i = c(r), n = t === i ? 0 : 1 / (i - t), a;
  };
}
function rd(e, r) {
  return r.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function KJ() {
  var e = ed(cf()(wi));
  return e.copy = function() {
    return rd(e, KJ());
  }, Ju.apply(e, arguments);
}
function hJ() {
  var e = t4(cf()).domain([1, 10]);
  return e.copy = function() {
    return rd(e, hJ()).base(e.base());
  }, Ju.apply(e, arguments);
}
function pJ() {
  var e = i4(cf());
  return e.copy = function() {
    return rd(e, pJ()).constant(e.constant());
  }, Ju.apply(e, arguments);
}
function x4() {
  var e = n4(cf());
  return e.copy = function() {
    return rd(e, x4()).exponent(e.exponent());
  }, Ju.apply(e, arguments);
}
function fSe() {
  return x4.apply(null, arguments).exponent(0.5);
}
function mJ() {
  var e = [], r = wi;
  function t(i) {
    if (i != null && !isNaN(i = +i)) return r((S2(e, i, 1) - 1) / (e.length - 1));
  }
  return t.domain = function(i) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let n of i) n != null && !isNaN(n = +n) && e.push(n);
    return e.sort(Mo), t;
  }, t.interpolator = function(i) {
    return arguments.length ? (r = i, t) : r;
  }, t.range = function() {
    return e.map((i, n) => r(n / (e.length - 1)));
  }, t.quantiles = function(i) {
    return Array.from({ length: i + 1 }, (n, s) => nCe(e, s / i));
  }, t.copy = function() {
    return mJ(r).domain(e);
  }, Ju.apply(t, arguments);
}
function Ff() {
  var e = 0, r = 0.5, t = 1, i = 1, n, s, u, o, d, a = wi, V, c = !1, F;
  function X(q) {
    return isNaN(q = +q) ? F : (q = 0.5 + ((q = +V(q)) - s) * (i * q < i * s ? o : d), a(c ? Math.max(0, Math.min(1, q)) : q));
  }
  X.domain = function(q) {
    return arguments.length ? ([e, r, t] = q, n = V(e = +e), s = V(r = +r), u = V(t = +t), o = n === s ? 0 : 0.5 / (s - n), d = s === u ? 0 : 0.5 / (u - s), i = s < n ? -1 : 1, X) : [e, r, t];
  }, X.clamp = function(q) {
    return arguments.length ? (c = !!q, X) : c;
  }, X.interpolator = function(q) {
    return arguments.length ? (a = q, X) : a;
  };
  function Y(q) {
    return function(f) {
      var p, m, g;
      return arguments.length ? ([p, m, g] = f, a = PCe(q, [p, m, g]), X) : [a(0), a(0.5), a(1)];
    };
  }
  return X.range = Y(Tl), X.rangeRound = Y($A), X.unknown = function(q) {
    return arguments.length ? (F = q, X) : F;
  }, function(q) {
    return V = q, n = q(e), s = q(r), u = q(t), o = n === s ? 0 : 0.5 / (s - n), d = s === u ? 0 : 0.5 / (u - s), i = s < n ? -1 : 1, X;
  };
}
function gJ() {
  var e = ed(Ff()(wi));
  return e.copy = function() {
    return rd(e, gJ());
  }, Ju.apply(e, arguments);
}
function vJ() {
  var e = t4(Ff()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return rd(e, vJ()).base(e.base());
  }, Ju.apply(e, arguments);
}
function bJ() {
  var e = i4(Ff());
  return e.copy = function() {
    return rd(e, bJ()).constant(e.constant());
  }, Ju.apply(e, arguments);
}
function X4() {
  var e = n4(Ff());
  return e.copy = function() {
    return rd(e, X4()).exponent(e.exponent());
  }, Ju.apply(e, arguments);
}
function KSe() {
  return X4.apply(null, arguments).exponent(0.5);
}
const DT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: c7,
  scaleDiverging: gJ,
  scaleDivergingLog: vJ,
  scaleDivergingPow: X4,
  scaleDivergingSqrt: KSe,
  scaleDivergingSymlog: bJ,
  scaleIdentity: iJ,
  scaleImplicit: B8,
  scaleLinear: NX,
  scaleLog: sJ,
  scaleOrdinal: UA,
  scalePoint: Rc,
  scalePow: s4,
  scaleQuantile: dJ,
  scaleQuantize: aJ,
  scaleRadial: oJ,
  scaleSequential: KJ,
  scaleSequentialLog: hJ,
  scaleSequentialPow: x4,
  scaleSequentialQuantile: mJ,
  scaleSequentialSqrt: fSe,
  scaleSequentialSymlog: pJ,
  scaleSqrt: QCe,
  scaleSymlog: uJ,
  scaleThreshold: VJ,
  scaleTime: qSe,
  scaleUtc: YSe,
  tickFormat: tJ
}, Symbol.toStringTag, { value: "Module" }));
var Em, RT;
function xf() {
  if (RT) return Em;
  RT = 1;
  var e = Pl();
  function r(t, i, n) {
    for (var s = -1, u = t.length; ++s < u; ) {
      var o = t[s], d = i(o);
      if (d != null && (a === void 0 ? d === d && !e(d) : n(d, a)))
        var a = d, V = o;
    }
    return V;
  }
  return Em = r, Em;
}
var km, IT;
function yJ() {
  if (IT) return km;
  IT = 1;
  function e(r, t) {
    return r > t;
  }
  return km = e, km;
}
var Om, LT;
function hSe() {
  if (LT) return Om;
  LT = 1;
  var e = xf(), r = yJ(), t = Nl();
  function i(n) {
    return n && n.length ? e(n, t, r) : void 0;
  }
  return Om = i, Om;
}
var pSe = hSe();
const Xf = /* @__PURE__ */ Mr(pSe);
var Dm, _T;
function AJ() {
  if (_T) return Dm;
  _T = 1;
  function e(r, t) {
    return r < t;
  }
  return Dm = e, Dm;
}
var Rm, HT;
function mSe() {
  if (HT) return Rm;
  HT = 1;
  var e = xf(), r = AJ(), t = Nl();
  function i(n) {
    return n && n.length ? e(n, t, r) : void 0;
  }
  return Rm = i, Rm;
}
var gSe = mSe();
const qf = /* @__PURE__ */ Mr(gSe);
var Im, jT;
function vSe() {
  if (jT) return Im;
  jT = 1;
  var e = SA(), r = ru(), t = TZ(), i = Qi();
  function n(s, u) {
    var o = i(s) ? e : t;
    return o(s, r(u, 3));
  }
  return Im = n, Im;
}
var Lm, zT;
function bSe() {
  if (zT) return Lm;
  zT = 1;
  var e = NZ(), r = vSe();
  function t(i, n) {
    return e(r(i, n), 1);
  }
  return Lm = t, Lm;
}
var ySe = bSe();
const ASe = /* @__PURE__ */ Mr(ySe);
var _m, BT;
function wSe() {
  if (BT) return _m;
  BT = 1;
  var e = jA();
  function r(t, i) {
    return e(t, i);
  }
  return _m = r, _m;
}
var CSe = wSe();
const Yf = /* @__PURE__ */ Mr(CSe);
var El = 1e9, PSe = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, Y4, nt = !0, kn = "[DecimalError] ", Od = kn + "Invalid argument: ", q4 = kn + "Exponent out of range: ", kl = Math.floor, hd = Math.pow, SSe = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Vn, Dt = 1e7, Qr = 7, wJ = 9007199254740991, kX = kl(wJ / Qr), Ae = {};
Ae.absoluteValue = Ae.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
Ae.comparedTo = Ae.cmp = function(e) {
  var r, t, i, n, s = this;
  if (e = new s.constructor(e), s.s !== e.s) return s.s || -e.s;
  if (s.e !== e.e) return s.e > e.e ^ s.s < 0 ? 1 : -1;
  for (i = s.d.length, n = e.d.length, r = 0, t = i < n ? i : n; r < t; ++r)
    if (s.d[r] !== e.d[r]) return s.d[r] > e.d[r] ^ s.s < 0 ? 1 : -1;
  return i === n ? 0 : i > n ^ s.s < 0 ? 1 : -1;
};
Ae.decimalPlaces = Ae.dp = function() {
  var e = this, r = e.d.length - 1, t = (r - e.e) * Qr;
  if (r = e.d[r], r) for (; r % 10 == 0; r /= 10) t--;
  return t < 0 ? 0 : t;
};
Ae.dividedBy = Ae.div = function(e) {
  return Nu(this, new this.constructor(e));
};
Ae.dividedToIntegerBy = Ae.idiv = function(e) {
  var r = this, t = r.constructor;
  return jr(Nu(r, new t(e), 0, 1), t.precision);
};
Ae.equals = Ae.eq = function(e) {
  return !this.cmp(e);
};
Ae.exponent = function() {
  return Kt(this);
};
Ae.greaterThan = Ae.gt = function(e) {
  return this.cmp(e) > 0;
};
Ae.greaterThanOrEqualTo = Ae.gte = function(e) {
  return this.cmp(e) >= 0;
};
Ae.isInteger = Ae.isint = function() {
  return this.e > this.d.length - 2;
};
Ae.isNegative = Ae.isneg = function() {
  return this.s < 0;
};
Ae.isPositive = Ae.ispos = function() {
  return this.s > 0;
};
Ae.isZero = function() {
  return this.s === 0;
};
Ae.lessThan = Ae.lt = function(e) {
  return this.cmp(e) < 0;
};
Ae.lessThanOrEqualTo = Ae.lte = function(e) {
  return this.cmp(e) < 1;
};
Ae.logarithm = Ae.log = function(e) {
  var r, t = this, i = t.constructor, n = i.precision, s = n + 5;
  if (e === void 0)
    e = new i(10);
  else if (e = new i(e), e.s < 1 || e.eq(Vn)) throw Error(kn + "NaN");
  if (t.s < 1) throw Error(kn + (t.s ? "NaN" : "-Infinity"));
  return t.eq(Vn) ? new i(0) : (nt = !1, r = Nu(Y7(t, s), Y7(e, s), s), nt = !0, jr(r, n));
};
Ae.minus = Ae.sub = function(e) {
  var r = this;
  return e = new r.constructor(e), r.s == e.s ? SJ(r, e) : CJ(r, (e.s = -e.s, e));
};
Ae.modulo = Ae.mod = function(e) {
  var r, t = this, i = t.constructor, n = i.precision;
  if (e = new i(e), !e.s) throw Error(kn + "NaN");
  return t.s ? (nt = !1, r = Nu(t, e, 0, 1).times(e), nt = !0, t.minus(r)) : jr(new i(t), n);
};
Ae.naturalExponential = Ae.exp = function() {
  return PJ(this);
};
Ae.naturalLogarithm = Ae.ln = function() {
  return Y7(this);
};
Ae.negated = Ae.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
Ae.plus = Ae.add = function(e) {
  var r = this;
  return e = new r.constructor(e), r.s == e.s ? CJ(r, e) : SJ(r, (e.s = -e.s, e));
};
Ae.precision = Ae.sd = function(e) {
  var r, t, i, n = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Od + e);
  if (r = Kt(n) + 1, i = n.d.length - 1, t = i * Qr + 1, i = n.d[i], i) {
    for (; i % 10 == 0; i /= 10) t--;
    for (i = n.d[0]; i >= 10; i /= 10) t++;
  }
  return e && r > t ? r : t;
};
Ae.squareRoot = Ae.sqrt = function() {
  var e, r, t, i, n, s, u, o = this, d = o.constructor;
  if (o.s < 1) {
    if (!o.s) return new d(0);
    throw Error(kn + "NaN");
  }
  for (e = Kt(o), nt = !1, n = Math.sqrt(+o), n == 0 || n == 1 / 0 ? (r = Ts(o.d), (r.length + e) % 2 == 0 && (r += "0"), n = Math.sqrt(r), e = kl((e + 1) / 2) - (e < 0 || e % 2), n == 1 / 0 ? r = "5e" + e : (r = n.toExponential(), r = r.slice(0, r.indexOf("e") + 1) + e), i = new d(r)) : i = new d(n.toString()), t = d.precision, n = u = t + 3; ; )
    if (s = i, i = s.plus(Nu(o, s, u + 2)).times(0.5), Ts(s.d).slice(0, u) === (r = Ts(i.d)).slice(0, u)) {
      if (r = r.slice(u - 3, u + 1), n == u && r == "4999") {
        if (jr(s, t + 1, 0), s.times(s).eq(o)) {
          i = s;
          break;
        }
      } else if (r != "9999")
        break;
      u += 4;
    }
  return nt = !0, jr(i, t);
};
Ae.times = Ae.mul = function(e) {
  var r, t, i, n, s, u, o, d, a, V = this, c = V.constructor, F = V.d, X = (e = new c(e)).d;
  if (!V.s || !e.s) return new c(0);
  for (e.s *= V.s, t = V.e + e.e, d = F.length, a = X.length, d < a && (s = F, F = X, X = s, u = d, d = a, a = u), s = [], u = d + a, i = u; i--; ) s.push(0);
  for (i = a; --i >= 0; ) {
    for (r = 0, n = d + i; n > i; )
      o = s[n] + X[i] * F[n - i - 1] + r, s[n--] = o % Dt | 0, r = o / Dt | 0;
    s[n] = (s[n] + r) % Dt | 0;
  }
  for (; !s[--u]; ) s.pop();
  return r ? ++t : s.shift(), e.d = s, e.e = t, nt ? jr(e, c.precision) : e;
};
Ae.toDecimalPlaces = Ae.todp = function(e, r) {
  var t = this, i = t.constructor;
  return t = new i(t), e === void 0 ? t : (zs(e, 0, El), r === void 0 ? r = i.rounding : zs(r, 0, 8), jr(t, e + Kt(t) + 1, r));
};
Ae.toExponential = function(e, r) {
  var t, i = this, n = i.constructor;
  return e === void 0 ? t = ea(i, !0) : (zs(e, 0, El), r === void 0 ? r = n.rounding : zs(r, 0, 8), i = jr(new n(i), e + 1, r), t = ea(i, !0, e + 1)), t;
};
Ae.toFixed = function(e, r) {
  var t, i, n = this, s = n.constructor;
  return e === void 0 ? ea(n) : (zs(e, 0, El), r === void 0 ? r = s.rounding : zs(r, 0, 8), i = jr(new s(n), e + Kt(n) + 1, r), t = ea(i.abs(), !1, e + Kt(i) + 1), n.isneg() && !n.isZero() ? "-" + t : t);
};
Ae.toInteger = Ae.toint = function() {
  var e = this, r = e.constructor;
  return jr(new r(e), Kt(e) + 1, r.rounding);
};
Ae.toNumber = function() {
  return +this;
};
Ae.toPower = Ae.pow = function(e) {
  var r, t, i, n, s, u, o = this, d = o.constructor, a = 12, V = +(e = new d(e));
  if (!e.s) return new d(Vn);
  if (o = new d(o), !o.s) {
    if (e.s < 1) throw Error(kn + "Infinity");
    return o;
  }
  if (o.eq(Vn)) return o;
  if (i = d.precision, e.eq(Vn)) return jr(o, i);
  if (r = e.e, t = e.d.length - 1, u = r >= t, s = o.s, u) {
    if ((t = V < 0 ? -V : V) <= wJ) {
      for (n = new d(Vn), r = Math.ceil(i / Qr + 4), nt = !1; t % 2 && (n = n.times(o), GT(n.d, r)), t = kl(t / 2), t !== 0; )
        o = o.times(o), GT(o.d, r);
      return nt = !0, e.s < 0 ? new d(Vn).div(n) : jr(n, i);
    }
  } else if (s < 0) throw Error(kn + "NaN");
  return s = s < 0 && e.d[Math.max(r, t)] & 1 ? -1 : 1, o.s = 1, nt = !1, n = e.times(Y7(o, i + a)), nt = !0, n = PJ(n), n.s = s, n;
};
Ae.toPrecision = function(e, r) {
  var t, i, n = this, s = n.constructor;
  return e === void 0 ? (t = Kt(n), i = ea(n, t <= s.toExpNeg || t >= s.toExpPos)) : (zs(e, 1, El), r === void 0 ? r = s.rounding : zs(r, 0, 8), n = jr(new s(n), e, r), t = Kt(n), i = ea(n, e <= t || t <= s.toExpNeg, e)), i;
};
Ae.toSignificantDigits = Ae.tosd = function(e, r) {
  var t = this, i = t.constructor;
  return e === void 0 ? (e = i.precision, r = i.rounding) : (zs(e, 1, El), r === void 0 ? r = i.rounding : zs(r, 0, 8)), jr(new i(t), e, r);
};
Ae.toString = Ae.valueOf = Ae.val = Ae.toJSON = Ae[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, r = Kt(e), t = e.constructor;
  return ea(e, r <= t.toExpNeg || r >= t.toExpPos);
};
function CJ(e, r) {
  var t, i, n, s, u, o, d, a, V = e.constructor, c = V.precision;
  if (!e.s || !r.s)
    return r.s || (r = new V(e)), nt ? jr(r, c) : r;
  if (d = e.d, a = r.d, u = e.e, n = r.e, d = d.slice(), s = u - n, s) {
    for (s < 0 ? (i = d, s = -s, o = a.length) : (i = a, n = u, o = d.length), u = Math.ceil(c / Qr), o = u > o ? u + 1 : o + 1, s > o && (s = o, i.length = 1), i.reverse(); s--; ) i.push(0);
    i.reverse();
  }
  for (o = d.length, s = a.length, o - s < 0 && (s = o, i = a, a = d, d = i), t = 0; s; )
    t = (d[--s] = d[s] + a[s] + t) / Dt | 0, d[s] %= Dt;
  for (t && (d.unshift(t), ++n), o = d.length; d[--o] == 0; ) d.pop();
  return r.d = d, r.e = n, nt ? jr(r, c) : r;
}
function zs(e, r, t) {
  if (e !== ~~e || e < r || e > t)
    throw Error(Od + e);
}
function Ts(e) {
  var r, t, i, n = e.length - 1, s = "", u = e[0];
  if (n > 0) {
    for (s += u, r = 1; r < n; r++)
      i = e[r] + "", t = Qr - i.length, t && (s += Yo(t)), s += i;
    u = e[r], i = u + "", t = Qr - i.length, t && (s += Yo(t));
  } else if (u === 0)
    return "0";
  for (; u % 10 === 0; ) u /= 10;
  return s + u;
}
var Nu = /* @__PURE__ */ function() {
  function e(i, n) {
    var s, u = 0, o = i.length;
    for (i = i.slice(); o--; )
      s = i[o] * n + u, i[o] = s % Dt | 0, u = s / Dt | 0;
    return u && i.unshift(u), i;
  }
  function r(i, n, s, u) {
    var o, d;
    if (s != u)
      d = s > u ? 1 : -1;
    else
      for (o = d = 0; o < s; o++)
        if (i[o] != n[o]) {
          d = i[o] > n[o] ? 1 : -1;
          break;
        }
    return d;
  }
  function t(i, n, s) {
    for (var u = 0; s--; )
      i[s] -= u, u = i[s] < n[s] ? 1 : 0, i[s] = u * Dt + i[s] - n[s];
    for (; !i[0] && i.length > 1; ) i.shift();
  }
  return function(i, n, s, u) {
    var o, d, a, V, c, F, X, Y, q, f, p, m, g, y, b, A, w, S, N = i.constructor, O = i.s == n.s ? 1 : -1, E = i.d, I = n.d;
    if (!i.s) return new N(i);
    if (!n.s) throw Error(kn + "Division by zero");
    for (d = i.e - n.e, w = I.length, b = E.length, X = new N(O), Y = X.d = [], a = 0; I[a] == (E[a] || 0); ) ++a;
    if (I[a] > (E[a] || 0) && --d, s == null ? m = s = N.precision : u ? m = s + (Kt(i) - Kt(n)) + 1 : m = s, m < 0) return new N(0);
    if (m = m / Qr + 2 | 0, a = 0, w == 1)
      for (V = 0, I = I[0], m++; (a < b || V) && m--; a++)
        g = V * Dt + (E[a] || 0), Y[a] = g / I | 0, V = g % I | 0;
    else {
      for (V = Dt / (I[0] + 1) | 0, V > 1 && (I = e(I, V), E = e(E, V), w = I.length, b = E.length), y = w, q = E.slice(0, w), f = q.length; f < w; ) q[f++] = 0;
      S = I.slice(), S.unshift(0), A = I[0], I[1] >= Dt / 2 && ++A;
      do
        V = 0, o = r(I, q, w, f), o < 0 ? (p = q[0], w != f && (p = p * Dt + (q[1] || 0)), V = p / A | 0, V > 1 ? (V >= Dt && (V = Dt - 1), c = e(I, V), F = c.length, f = q.length, o = r(c, q, F, f), o == 1 && (V--, t(c, w < F ? S : I, F))) : (V == 0 && (o = V = 1), c = I.slice()), F = c.length, F < f && c.unshift(0), t(q, c, f), o == -1 && (f = q.length, o = r(I, q, w, f), o < 1 && (V++, t(q, w < f ? S : I, f))), f = q.length) : o === 0 && (V++, q = [0]), Y[a++] = V, o && q[0] ? q[f++] = E[y] || 0 : (q = [E[y]], f = 1);
      while ((y++ < b || q[0] !== void 0) && m--);
    }
    return Y[0] || Y.shift(), X.e = d, jr(X, u ? s + Kt(X) + 1 : s);
  };
}();
function PJ(e, r) {
  var t, i, n, s, u, o, d = 0, a = 0, V = e.constructor, c = V.precision;
  if (Kt(e) > 16) throw Error(q4 + Kt(e));
  if (!e.s) return new V(Vn);
  for (nt = !1, o = c, u = new V(0.03125); e.abs().gte(0.1); )
    e = e.times(u), a += 5;
  for (i = Math.log(hd(2, a)) / Math.LN10 * 2 + 5 | 0, o += i, t = n = s = new V(Vn), V.precision = o; ; ) {
    if (n = jr(n.times(e), o), t = t.times(++d), u = s.plus(Nu(n, t, o)), Ts(u.d).slice(0, o) === Ts(s.d).slice(0, o)) {
      for (; a--; ) s = jr(s.times(s), o);
      return V.precision = c, r == null ? (nt = !0, jr(s, c)) : s;
    }
    s = u;
  }
}
function Kt(e) {
  for (var r = e.e * Qr, t = e.d[0]; t >= 10; t /= 10) r++;
  return r;
}
function Hm(e, r, t) {
  if (r > e.LN10.sd())
    throw nt = !0, t && (e.precision = t), Error(kn + "LN10 precision limit exceeded");
  return jr(new e(e.LN10), r);
}
function Yo(e) {
  for (var r = ""; e--; ) r += "0";
  return r;
}
function Y7(e, r) {
  var t, i, n, s, u, o, d, a, V, c = 1, F = 10, X = e, Y = X.d, q = X.constructor, f = q.precision;
  if (X.s < 1) throw Error(kn + (X.s ? "NaN" : "-Infinity"));
  if (X.eq(Vn)) return new q(0);
  if (r == null ? (nt = !1, a = f) : a = r, X.eq(10))
    return r == null && (nt = !0), Hm(q, a);
  if (a += F, q.precision = a, t = Ts(Y), i = t.charAt(0), s = Kt(X), Math.abs(s) < 15e14) {
    for (; i < 7 && i != 1 || i == 1 && t.charAt(1) > 3; )
      X = X.times(e), t = Ts(X.d), i = t.charAt(0), c++;
    s = Kt(X), i > 1 ? (X = new q("0." + t), s++) : X = new q(i + "." + t.slice(1));
  } else
    return d = Hm(q, a + 2, f).times(s + ""), X = Y7(new q(i + "." + t.slice(1)), a - F).plus(d), q.precision = f, r == null ? (nt = !0, jr(X, f)) : X;
  for (o = u = X = Nu(X.minus(Vn), X.plus(Vn), a), V = jr(X.times(X), a), n = 3; ; ) {
    if (u = jr(u.times(V), a), d = o.plus(Nu(u, new q(n), a)), Ts(d.d).slice(0, a) === Ts(o.d).slice(0, a))
      return o = o.times(2), s !== 0 && (o = o.plus(Hm(q, a + 2, f).times(s + ""))), o = Nu(o, new q(c), a), q.precision = f, r == null ? (nt = !0, jr(o, f)) : o;
    o = d, n += 2;
  }
}
function WT(e, r) {
  var t, i, n;
  for ((t = r.indexOf(".")) > -1 && (r = r.replace(".", "")), (i = r.search(/e/i)) > 0 ? (t < 0 && (t = i), t += +r.slice(i + 1), r = r.substring(0, i)) : t < 0 && (t = r.length), i = 0; r.charCodeAt(i) === 48; ) ++i;
  for (n = r.length; r.charCodeAt(n - 1) === 48; ) --n;
  if (r = r.slice(i, n), r) {
    if (n -= i, t = t - i - 1, e.e = kl(t / Qr), e.d = [], i = (t + 1) % Qr, t < 0 && (i += Qr), i < n) {
      for (i && e.d.push(+r.slice(0, i)), n -= Qr; i < n; ) e.d.push(+r.slice(i, i += Qr));
      r = r.slice(i), i = Qr - r.length;
    } else
      i -= n;
    for (; i--; ) r += "0";
    if (e.d.push(+r), nt && (e.e > kX || e.e < -kX)) throw Error(q4 + t);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function jr(e, r, t) {
  var i, n, s, u, o, d, a, V, c = e.d;
  for (u = 1, s = c[0]; s >= 10; s /= 10) u++;
  if (i = r - u, i < 0)
    i += Qr, n = r, a = c[V = 0];
  else {
    if (V = Math.ceil((i + 1) / Qr), s = c.length, V >= s) return e;
    for (a = s = c[V], u = 1; s >= 10; s /= 10) u++;
    i %= Qr, n = i - Qr + u;
  }
  if (t !== void 0 && (s = hd(10, u - n - 1), o = a / s % 10 | 0, d = r < 0 || c[V + 1] !== void 0 || a % s, d = t < 4 ? (o || d) && (t == 0 || t == (e.s < 0 ? 3 : 2)) : o > 5 || o == 5 && (t == 4 || d || t == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (i > 0 ? n > 0 ? a / hd(10, u - n) : 0 : c[V - 1]) % 10 & 1 || t == (e.s < 0 ? 8 : 7))), r < 1 || !c[0])
    return d ? (s = Kt(e), c.length = 1, r = r - s - 1, c[0] = hd(10, (Qr - r % Qr) % Qr), e.e = kl(-r / Qr) || 0) : (c.length = 1, c[0] = e.e = e.s = 0), e;
  if (i == 0 ? (c.length = V, s = 1, V--) : (c.length = V + 1, s = hd(10, Qr - i), c[V] = n > 0 ? (a / hd(10, u - n) % hd(10, n) | 0) * s : 0), d)
    for (; ; )
      if (V == 0) {
        (c[0] += s) == Dt && (c[0] = 1, ++e.e);
        break;
      } else {
        if (c[V] += s, c[V] != Dt) break;
        c[V--] = 0, s = 1;
      }
  for (i = c.length; c[--i] === 0; ) c.pop();
  if (nt && (e.e > kX || e.e < -kX))
    throw Error(q4 + Kt(e));
  return e;
}
function SJ(e, r) {
  var t, i, n, s, u, o, d, a, V, c, F = e.constructor, X = F.precision;
  if (!e.s || !r.s)
    return r.s ? r.s = -r.s : r = new F(e), nt ? jr(r, X) : r;
  if (d = e.d, c = r.d, i = r.e, a = e.e, d = d.slice(), u = a - i, u) {
    for (V = u < 0, V ? (t = d, u = -u, o = c.length) : (t = c, i = a, o = d.length), n = Math.max(Math.ceil(X / Qr), o) + 2, u > n && (u = n, t.length = 1), t.reverse(), n = u; n--; ) t.push(0);
    t.reverse();
  } else {
    for (n = d.length, o = c.length, V = n < o, V && (o = n), n = 0; n < o; n++)
      if (d[n] != c[n]) {
        V = d[n] < c[n];
        break;
      }
    u = 0;
  }
  for (V && (t = d, d = c, c = t, r.s = -r.s), o = d.length, n = c.length - o; n > 0; --n) d[o++] = 0;
  for (n = c.length; n > u; ) {
    if (d[--n] < c[n]) {
      for (s = n; s && d[--s] === 0; ) d[s] = Dt - 1;
      --d[s], d[n] += Dt;
    }
    d[n] -= c[n];
  }
  for (; d[--o] === 0; ) d.pop();
  for (; d[0] === 0; d.shift()) --i;
  return d[0] ? (r.d = d, r.e = i, nt ? jr(r, X) : r) : new F(0);
}
function ea(e, r, t) {
  var i, n = Kt(e), s = Ts(e.d), u = s.length;
  return r ? (t && (i = t - u) > 0 ? s = s.charAt(0) + "." + s.slice(1) + Yo(i) : u > 1 && (s = s.charAt(0) + "." + s.slice(1)), s = s + (n < 0 ? "e" : "e+") + n) : n < 0 ? (s = "0." + Yo(-n - 1) + s, t && (i = t - u) > 0 && (s += Yo(i))) : n >= u ? (s += Yo(n + 1 - u), t && (i = t - n - 1) > 0 && (s = s + "." + Yo(i))) : ((i = n + 1) < u && (s = s.slice(0, i) + "." + s.slice(i)), t && (i = t - u) > 0 && (n + 1 === u && (s += "."), s += Yo(i))), e.s < 0 ? "-" + s : s;
}
function GT(e, r) {
  if (e.length > r)
    return e.length = r, !0;
}
function NJ(e) {
  var r, t, i;
  function n(s) {
    var u = this;
    if (!(u instanceof n)) return new n(s);
    if (u.constructor = n, s instanceof n) {
      u.s = s.s, u.e = s.e, u.d = (s = s.d) ? s.slice() : s;
      return;
    }
    if (typeof s == "number") {
      if (s * 0 !== 0)
        throw Error(Od + s);
      if (s > 0)
        u.s = 1;
      else if (s < 0)
        s = -s, u.s = -1;
      else {
        u.s = 0, u.e = 0, u.d = [0];
        return;
      }
      if (s === ~~s && s < 1e7) {
        u.e = 0, u.d = [s];
        return;
      }
      return WT(u, s.toString());
    } else if (typeof s != "string")
      throw Error(Od + s);
    if (s.charCodeAt(0) === 45 ? (s = s.slice(1), u.s = -1) : u.s = 1, SSe.test(s)) WT(u, s);
    else throw Error(Od + s);
  }
  if (n.prototype = Ae, n.ROUND_UP = 0, n.ROUND_DOWN = 1, n.ROUND_CEIL = 2, n.ROUND_FLOOR = 3, n.ROUND_HALF_UP = 4, n.ROUND_HALF_DOWN = 5, n.ROUND_HALF_EVEN = 6, n.ROUND_HALF_CEIL = 7, n.ROUND_HALF_FLOOR = 8, n.clone = NJ, n.config = n.set = NSe, e === void 0 && (e = {}), e)
    for (i = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], r = 0; r < i.length; ) e.hasOwnProperty(t = i[r++]) || (e[t] = this[t]);
  return n.config(e), n;
}
function NSe(e) {
  if (!e || typeof e != "object")
    throw Error(kn + "Object expected");
  var r, t, i, n = [
    "precision",
    1,
    El,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (r = 0; r < n.length; r += 3)
    if ((i = e[t = n[r]]) !== void 0)
      if (kl(i) === i && i >= n[r + 1] && i <= n[r + 2]) this[t] = i;
      else throw Error(Od + t + ": " + i);
  if ((i = e[t = "LN10"]) !== void 0)
    if (i == Math.LN10) this[t] = new this(i);
    else throw Error(Od + t + ": " + i);
  return this;
}
var Y4 = NJ(PSe);
Vn = new Y4(1);
const Er = Y4;
function MSe(e) {
  return OSe(e) || kSe(e) || ESe(e) || TSe();
}
function TSe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ESe(e, r) {
  if (e) {
    if (typeof e == "string") return Z8(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Z8(e, r);
  }
}
function kSe(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function OSe(e) {
  if (Array.isArray(e)) return Z8(e);
}
function Z8(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++)
    i[t] = e[t];
  return i;
}
var DSe = function(r) {
  return r;
}, MJ = {}, TJ = function(r) {
  return r === MJ;
}, UT = function(r) {
  return function t() {
    return arguments.length === 0 || arguments.length === 1 && TJ(arguments.length <= 0 ? void 0 : arguments[0]) ? t : r.apply(void 0, arguments);
  };
}, RSe = function e(r, t) {
  return r === 1 ? t : UT(function() {
    for (var i = arguments.length, n = new Array(i), s = 0; s < i; s++)
      n[s] = arguments[s];
    var u = n.filter(function(o) {
      return o !== MJ;
    }).length;
    return u >= r ? t.apply(void 0, n) : e(r - u, UT(function() {
      for (var o = arguments.length, d = new Array(o), a = 0; a < o; a++)
        d[a] = arguments[a];
      var V = n.map(function(c) {
        return TJ(c) ? d.shift() : c;
      });
      return t.apply(void 0, MSe(V).concat(d));
    }));
  });
}, ff = function(r) {
  return RSe(r.length, r);
}, J8 = function(r, t) {
  for (var i = [], n = r; n < t; ++n)
    i[n - r] = n;
  return i;
}, ISe = ff(function(e, r) {
  return Array.isArray(r) ? r.map(e) : Object.keys(r).map(function(t) {
    return r[t];
  }).map(e);
}), LSe = function() {
  for (var r = arguments.length, t = new Array(r), i = 0; i < r; i++)
    t[i] = arguments[i];
  if (!t.length)
    return DSe;
  var n = t.reverse(), s = n[0], u = n.slice(1);
  return function() {
    return u.reduce(function(o, d) {
      return d(o);
    }, s.apply(void 0, arguments));
  };
}, $8 = function(r) {
  return Array.isArray(r) ? r.reverse() : r.split("").reverse.join("");
}, EJ = function(r) {
  var t = null, i = null;
  return function() {
    for (var n = arguments.length, s = new Array(n), u = 0; u < n; u++)
      s[u] = arguments[u];
    return t && s.every(function(o, d) {
      return o === t[d];
    }) || (t = s, i = r.apply(void 0, s)), i;
  };
};
function _Se(e) {
  var r;
  return e === 0 ? r = 1 : r = Math.floor(new Er(e).abs().log(10).toNumber()) + 1, r;
}
function HSe(e, r, t) {
  for (var i = new Er(e), n = 0, s = []; i.lt(r) && n < 1e5; )
    s.push(i.toNumber()), i = i.add(t), n++;
  return s;
}
var jSe = ff(function(e, r, t) {
  var i = +e, n = +r;
  return i + t * (n - i);
}), zSe = ff(function(e, r, t) {
  var i = r - +e;
  return i = i || 1 / 0, (t - e) / i;
}), BSe = ff(function(e, r, t) {
  var i = r - +e;
  return i = i || 1 / 0, Math.max(0, Math.min(1, (t - e) / i));
});
const Kf = {
  rangeStep: HSe,
  getDigitCount: _Se,
  interpolateNumber: jSe,
  uninterpolateNumber: zSe,
  uninterpolateTruncation: BSe
};
function Q8(e) {
  return USe(e) || GSe(e) || kJ(e) || WSe();
}
function WSe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function GSe(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function USe(e) {
  if (Array.isArray(e)) return eb(e);
}
function f7(e, r) {
  return $Se(e) || JSe(e, r) || kJ(e, r) || ZSe();
}
function ZSe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kJ(e, r) {
  if (e) {
    if (typeof e == "string") return eb(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return eb(e, r);
  }
}
function eb(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++)
    i[t] = e[t];
  return i;
}
function JSe(e, r) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var t = [], i = !0, n = !1, s = void 0;
    try {
      for (var u = e[Symbol.iterator](), o; !(i = (o = u.next()).done) && (t.push(o.value), !(r && t.length === r)); i = !0)
        ;
    } catch (d) {
      n = !0, s = d;
    } finally {
      try {
        !i && u.return != null && u.return();
      } finally {
        if (n) throw s;
      }
    }
    return t;
  }
}
function $Se(e) {
  if (Array.isArray(e)) return e;
}
function OJ(e) {
  var r = f7(e, 2), t = r[0], i = r[1], n = t, s = i;
  return t > i && (n = i, s = t), [n, s];
}
function DJ(e, r, t) {
  if (e.lte(0))
    return new Er(0);
  var i = Kf.getDigitCount(e.toNumber()), n = new Er(10).pow(i), s = e.div(n), u = i !== 1 ? 0.05 : 0.1, o = new Er(Math.ceil(s.div(u).toNumber())).add(t).mul(u), d = o.mul(n);
  return r ? d : new Er(Math.ceil(d));
}
function QSe(e, r, t) {
  var i = 1, n = new Er(e);
  if (!n.isint() && t) {
    var s = Math.abs(e);
    s < 1 ? (i = new Er(10).pow(Kf.getDigitCount(e) - 1), n = new Er(Math.floor(n.div(i).toNumber())).mul(i)) : s > 1 && (n = new Er(Math.floor(e)));
  } else e === 0 ? n = new Er(Math.floor((r - 1) / 2)) : t || (n = new Er(Math.floor(e)));
  var u = Math.floor((r - 1) / 2), o = LSe(ISe(function(d) {
    return n.add(new Er(d - u).mul(i)).toNumber();
  }), J8);
  return o(0, r);
}
function RJ(e, r, t, i) {
  var n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((r - e) / (t - 1)))
    return {
      step: new Er(0),
      tickMin: new Er(0),
      tickMax: new Er(0)
    };
  var s = DJ(new Er(r).sub(e).div(t - 1), i, n), u;
  e <= 0 && r >= 0 ? u = new Er(0) : (u = new Er(e).add(r).div(2), u = u.sub(new Er(u).mod(s)));
  var o = Math.ceil(u.sub(e).div(s).toNumber()), d = Math.ceil(new Er(r).sub(u).div(s).toNumber()), a = o + d + 1;
  return a > t ? RJ(e, r, t, i, n + 1) : (a < t && (d = r > 0 ? d + (t - a) : d, o = r > 0 ? o : o + (t - a)), {
    step: s,
    tickMin: u.sub(new Er(o).mul(s)),
    tickMax: u.add(new Er(d).mul(s))
  });
}
function eNe(e) {
  var r = f7(e, 2), t = r[0], i = r[1], n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, u = Math.max(n, 2), o = OJ([t, i]), d = f7(o, 2), a = d[0], V = d[1];
  if (a === -1 / 0 || V === 1 / 0) {
    var c = V === 1 / 0 ? [a].concat(Q8(J8(0, n - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(Q8(J8(0, n - 1).map(function() {
      return -1 / 0;
    })), [V]);
    return t > i ? $8(c) : c;
  }
  if (a === V)
    return QSe(a, n, s);
  var F = RJ(a, V, u, s), X = F.step, Y = F.tickMin, q = F.tickMax, f = Kf.rangeStep(Y, q.add(new Er(0.1).mul(X)), X);
  return t > i ? $8(f) : f;
}
function rNe(e, r) {
  var t = f7(e, 2), i = t[0], n = t[1], s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, u = OJ([i, n]), o = f7(u, 2), d = o[0], a = o[1];
  if (d === -1 / 0 || a === 1 / 0)
    return [i, n];
  if (d === a)
    return [d];
  var V = Math.max(r, 2), c = DJ(new Er(a).sub(d).div(V - 1), s, 0), F = [].concat(Q8(Kf.rangeStep(new Er(d), new Er(a).sub(new Er(0.99).mul(c)), c)), [a]);
  return i > n ? $8(F) : F;
}
var tNe = EJ(eNe), iNe = EJ(rNe), nNe = process.env.NODE_ENV === "production", jm = "Invariant failed";
function _i(e, r) {
  if (nNe)
    throw new Error(jm);
  var t = typeof r == "function" ? r() : r, i = t ? "".concat(jm, ": ").concat(t) : jm;
  throw new Error(i);
}
var sNe = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function zV(e) {
  "@babel/helpers - typeof";
  return zV = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, zV(e);
}
function OX() {
  return OX = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, OX.apply(this, arguments);
}
function uNe(e, r) {
  return VNe(e) || aNe(e, r) || dNe(e, r) || oNe();
}
function oNe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function dNe(e, r) {
  if (e) {
    if (typeof e == "string") return ZT(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return ZT(e, r);
  }
}
function ZT(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
function aNe(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var i, n, s, u, o = [], d = !0, a = !1;
    try {
      if (s = (t = t.call(e)).next, r !== 0) for (; !(d = (i = s.call(t)).done) && (o.push(i.value), o.length !== r); d = !0) ;
    } catch (V) {
      a = !0, n = V;
    } finally {
      try {
        if (!d && t.return != null && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (a) throw n;
      }
    }
    return o;
  }
}
function VNe(e) {
  if (Array.isArray(e)) return e;
}
function lNe(e, r) {
  if (e == null) return {};
  var t = cNe(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function cNe(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
function FNe(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function xNe(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, _J(i.key), i);
  }
}
function XNe(e, r, t) {
  return r && xNe(e.prototype, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function qNe(e, r, t) {
  return r = DX(r), YNe(e, IJ() ? Reflect.construct(r, t || [], DX(e).constructor) : r.apply(e, t));
}
function YNe(e, r) {
  if (r && (zV(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return fNe(e);
}
function fNe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function IJ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (IJ = function() {
    return !!e;
  })();
}
function DX(e) {
  return DX = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, DX(e);
}
function KNe(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && rb(e, r);
}
function rb(e, r) {
  return rb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, rb(e, r);
}
function LJ(e, r, t) {
  return r = _J(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function _J(e) {
  var r = hNe(e, "string");
  return zV(r) == "symbol" ? r : r + "";
}
function hNe(e, r) {
  if (zV(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (zV(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var hf = /* @__PURE__ */ function(e) {
  function r() {
    return FNe(this, r), qNe(this, r, arguments);
  }
  return KNe(r, e), XNe(r, [{
    key: "render",
    value: function() {
      var i = this.props, n = i.offset, s = i.layout, u = i.width, o = i.dataKey, d = i.data, a = i.dataPointFormatter, V = i.xAxis, c = i.yAxis, F = lNe(i, sNe), X = _e(F, !1);
      this.props.direction === "x" && V.type !== "number" && (process.env.NODE_ENV !== "production" ? _i(!1, 'ErrorBar requires Axis type property to be "number".') : _i());
      var Y = d.map(function(q) {
        var f = a(q, o), p = f.x, m = f.y, g = f.value, y = f.errorVal;
        if (!y)
          return null;
        var b = [], A, w;
        if (Array.isArray(y)) {
          var S = uNe(y, 2);
          A = S[0], w = S[1];
        } else
          A = w = y;
        if (s === "vertical") {
          var N = V.scale, O = m + n, E = O + u, I = O - u, R = N(g - A), H = N(g + w);
          b.push({
            x1: H,
            y1: E,
            x2: H,
            y2: I
          }), b.push({
            x1: R,
            y1: O,
            x2: H,
            y2: O
          }), b.push({
            x1: R,
            y1: E,
            x2: R,
            y2: I
          });
        } else if (s === "horizontal") {
          var W = c.scale, B = p + n, L = B - u, z = B + u, Z = W(g - A), le = W(g + w);
          b.push({
            x1: L,
            y1: le,
            x2: z,
            y2: le
          }), b.push({
            x1: B,
            y1: Z,
            x2: B,
            y2: le
          }), b.push({
            x1: L,
            y1: Z,
            x2: z,
            y2: Z
          });
        }
        return /* @__PURE__ */ D.createElement(Hr, OX({
          className: "recharts-errorBar",
          key: "bar-".concat(b.map(function(te) {
            return "".concat(te.x1, "-").concat(te.x2, "-").concat(te.y1, "-").concat(te.y2);
          }))
        }, X), b.map(function(te) {
          return /* @__PURE__ */ D.createElement("line", OX({}, te, {
            key: "line-".concat(te.x1, "-").concat(te.x2, "-").concat(te.y1, "-").concat(te.y2)
          }));
        }));
      });
      return /* @__PURE__ */ D.createElement(Hr, {
        className: "recharts-errorBars"
      }, Y);
    }
  }]);
}(D.Component);
LJ(hf, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
LJ(hf, "displayName", "ErrorBar");
function K7(e) {
  "@babel/helpers - typeof";
  return K7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, K7(e);
}
function JT(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function Xd(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? JT(Object(t), !0).forEach(function(i) {
      pNe(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : JT(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function pNe(e, r, t) {
  return r = mNe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function mNe(e) {
  var r = gNe(e, "string");
  return K7(r) == "symbol" ? r : r + "";
}
function gNe(e, r) {
  if (K7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (K7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
var HJ = function(r) {
  var t = r.children, i = r.formattedGraphicalItems, n = r.legendWidth, s = r.legendContent, u = dn(t, zi);
  if (!u)
    return null;
  var o = zi.defaultProps, d = o !== void 0 ? Xd(Xd({}, o), u.props) : {}, a;
  return u.props && u.props.payload ? a = u.props && u.props.payload : s === "children" ? a = (i || []).reduce(function(V, c) {
    var F = c.item, X = c.props, Y = X.sectors || X.data || [];
    return V.concat(Y.map(function(q) {
      return {
        type: u.props.iconType || F.props.legendType,
        value: q.name,
        color: q.fill,
        payload: q
      };
    }));
  }, []) : a = (i || []).map(function(V) {
    var c = V.item, F = c.type.defaultProps, X = F !== void 0 ? Xd(Xd({}, F), c.props) : {}, Y = X.dataKey, q = X.name, f = X.legendType, p = X.hide;
    return {
      inactive: p,
      dataKey: Y,
      type: d.iconType || f || "square",
      color: f4(c),
      value: q || Y,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: X
    };
  }), Xd(Xd(Xd({}, d), zi.getWithHeight(u, n)), {}, {
    payload: a,
    item: u
  });
};
function h7(e) {
  "@babel/helpers - typeof";
  return h7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, h7(e);
}
function $T(e) {
  return ANe(e) || yNe(e) || bNe(e) || vNe();
}
function vNe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bNe(e, r) {
  if (e) {
    if (typeof e == "string") return tb(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return tb(e, r);
  }
}
function yNe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function ANe(e) {
  if (Array.isArray(e)) return tb(e);
}
function tb(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
function QT(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function Vt(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? QT(Object(t), !0).forEach(function(i) {
      hV(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : QT(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function hV(e, r, t) {
  return r = wNe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function wNe(e) {
  var r = CNe(e, "string");
  return h7(r) == "symbol" ? r : r + "";
}
function CNe(e, r) {
  if (h7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (h7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function On(e, r, t) {
  return fr(e) || fr(r) ? t : Mt(r) ? Mn(e, r, t) : Ue(r) ? r(e) : t;
}
function Ic(e, r, t, i) {
  var n = ASe(e, function(o) {
    return On(o, r);
  });
  if (t === "number") {
    var s = n.filter(function(o) {
      return pe(o) || parseFloat(o);
    });
    return s.length ? [qf(s), Xf(s)] : [1 / 0, -1 / 0];
  }
  var u = i ? n.filter(function(o) {
    return !fr(o);
  }) : n;
  return u.map(function(o) {
    return Mt(o) || o instanceof Date ? o : "";
  });
}
var PNe = function(r) {
  var t, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 ? arguments[2] : void 0, s = arguments.length > 3 ? arguments[3] : void 0, u = -1, o = (t = i == null ? void 0 : i.length) !== null && t !== void 0 ? t : 0;
  if (o <= 1)
    return 0;
  if (s && s.axisType === "angleAxis" && Math.abs(Math.abs(s.range[1] - s.range[0]) - 360) <= 1e-6)
    for (var d = s.range, a = 0; a < o; a++) {
      var V = a > 0 ? n[a - 1].coordinate : n[o - 1].coordinate, c = n[a].coordinate, F = a >= o - 1 ? n[0].coordinate : n[a + 1].coordinate, X = void 0;
      if (ts(c - V) !== ts(F - c)) {
        var Y = [];
        if (ts(F - c) === ts(d[1] - d[0])) {
          X = F;
          var q = c + d[1] - d[0];
          Y[0] = Math.min(q, (q + V) / 2), Y[1] = Math.max(q, (q + V) / 2);
        } else {
          X = V;
          var f = F + d[1] - d[0];
          Y[0] = Math.min(c, (f + c) / 2), Y[1] = Math.max(c, (f + c) / 2);
        }
        var p = [Math.min(c, (X + c) / 2), Math.max(c, (X + c) / 2)];
        if (r > p[0] && r <= p[1] || r >= Y[0] && r <= Y[1]) {
          u = n[a].index;
          break;
        }
      } else {
        var m = Math.min(V, F), g = Math.max(V, F);
        if (r > (m + c) / 2 && r <= (g + c) / 2) {
          u = n[a].index;
          break;
        }
      }
    }
  else
    for (var y = 0; y < o; y++)
      if (y === 0 && r <= (i[y].coordinate + i[y + 1].coordinate) / 2 || y > 0 && y < o - 1 && r > (i[y].coordinate + i[y - 1].coordinate) / 2 && r <= (i[y].coordinate + i[y + 1].coordinate) / 2 || y === o - 1 && r > (i[y].coordinate + i[y - 1].coordinate) / 2) {
        u = i[y].index;
        break;
      }
  return u;
}, f4 = function(r) {
  var t, i = r, n = i.type.displayName, s = (t = r.type) !== null && t !== void 0 && t.defaultProps ? Vt(Vt({}, r.type.defaultProps), r.props) : r.props, u = s.stroke, o = s.fill, d;
  switch (n) {
    case "Line":
      d = u;
      break;
    case "Area":
    case "Radar":
      d = u && u !== "none" ? u : o;
      break;
    default:
      d = o;
      break;
  }
  return d;
}, SNe = function(r) {
  var t = r.barSize, i = r.totalSize, n = r.stackGroups, s = n === void 0 ? {} : n;
  if (!s)
    return {};
  for (var u = {}, o = Object.keys(s), d = 0, a = o.length; d < a; d++)
    for (var V = s[o[d]].stackGroups, c = Object.keys(V), F = 0, X = c.length; F < X; F++) {
      var Y = V[c[F]], q = Y.items, f = Y.cateAxisId, p = q.filter(function(w) {
        return Pu(w.type).indexOf("Bar") >= 0;
      });
      if (p && p.length) {
        var m = p[0].type.defaultProps, g = m !== void 0 ? Vt(Vt({}, m), p[0].props) : p[0].props, y = g.barSize, b = g[f];
        u[b] || (u[b] = []);
        var A = fr(y) ? t : y;
        u[b].push({
          item: p[0],
          stackList: p.slice(1),
          barSize: fr(A) ? void 0 : is(A, i, 0)
        });
      }
    }
  return u;
}, NNe = function(r) {
  var t = r.barGap, i = r.barCategoryGap, n = r.bandSize, s = r.sizeList, u = s === void 0 ? [] : s, o = r.maxBarSize, d = u.length;
  if (d < 1) return null;
  var a = is(t, n, 0, !0), V, c = [];
  if (u[0].barSize === +u[0].barSize) {
    var F = !1, X = n / d, Y = u.reduce(function(y, b) {
      return y + b.barSize || 0;
    }, 0);
    Y += (d - 1) * a, Y >= n && (Y -= (d - 1) * a, a = 0), Y >= n && X > 0 && (F = !0, X *= 0.9, Y = d * X);
    var q = (n - Y) / 2 >> 0, f = {
      offset: q - a,
      size: 0
    };
    V = u.reduce(function(y, b) {
      var A = {
        item: b.item,
        position: {
          offset: f.offset + f.size + a,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: F ? X : b.barSize
        }
      }, w = [].concat($T(y), [A]);
      return f = w[w.length - 1].position, b.stackList && b.stackList.length && b.stackList.forEach(function(S) {
        w.push({
          item: S,
          position: f
        });
      }), w;
    }, c);
  } else {
    var p = is(i, n, 0, !0);
    n - 2 * p - (d - 1) * a <= 0 && (a = 0);
    var m = (n - 2 * p - (d - 1) * a) / d;
    m > 1 && (m >>= 0);
    var g = o === +o ? Math.min(m, o) : m;
    V = u.reduce(function(y, b, A) {
      var w = [].concat($T(y), [{
        item: b.item,
        position: {
          offset: p + (m + a) * A + (m - g) / 2,
          size: g
        }
      }]);
      return b.stackList && b.stackList.length && b.stackList.forEach(function(S) {
        w.push({
          item: S,
          position: w[w.length - 1].position
        });
      }), w;
    }, c);
  }
  return V;
}, MNe = function(r, t, i, n) {
  var s = i.children, u = i.width, o = i.margin, d = u - (o.left || 0) - (o.right || 0), a = HJ({
    children: s,
    legendWidth: d
  });
  if (a) {
    var V = n || {}, c = V.width, F = V.height, X = a.align, Y = a.verticalAlign, q = a.layout;
    if ((q === "vertical" || q === "horizontal" && Y === "middle") && X !== "center" && pe(r[X]))
      return Vt(Vt({}, r), {}, hV({}, X, r[X] + (c || 0)));
    if ((q === "horizontal" || q === "vertical" && X === "center") && Y !== "middle" && pe(r[Y]))
      return Vt(Vt({}, r), {}, hV({}, Y, r[Y] + (F || 0)));
  }
  return r;
}, TNe = function(r, t, i) {
  return fr(t) ? !0 : r === "horizontal" ? t === "yAxis" : r === "vertical" || i === "x" ? t === "xAxis" : i === "y" ? t === "yAxis" : !0;
}, jJ = function(r, t, i, n, s) {
  var u = t.props.children, o = ss(u, hf).filter(function(a) {
    return TNe(n, s, a.props.direction);
  });
  if (o && o.length) {
    var d = o.map(function(a) {
      return a.props.dataKey;
    });
    return r.reduce(function(a, V) {
      var c = On(V, i);
      if (fr(c)) return a;
      var F = Array.isArray(c) ? [qf(c), Xf(c)] : [c, c], X = d.reduce(function(Y, q) {
        var f = On(V, q, 0), p = F[0] - Math.abs(Array.isArray(f) ? f[0] : f), m = F[1] + Math.abs(Array.isArray(f) ? f[1] : f);
        return [Math.min(p, Y[0]), Math.max(m, Y[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(X[0], a[0]), Math.max(X[1], a[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, ENe = function(r, t, i, n, s) {
  var u = t.map(function(o) {
    return jJ(r, o, i, s, n);
  }).filter(function(o) {
    return !fr(o);
  });
  return u && u.length ? u.reduce(function(o, d) {
    return [Math.min(o[0], d[0]), Math.max(o[1], d[1])];
  }, [1 / 0, -1 / 0]) : null;
}, zJ = function(r, t, i, n, s) {
  var u = t.map(function(d) {
    var a = d.props.dataKey;
    return i === "number" && a && jJ(r, d, a, n) || Ic(r, a, i, s);
  });
  if (i === "number")
    return u.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(d, a) {
        return [Math.min(d[0], a[0]), Math.max(d[1], a[1])];
      },
      [1 / 0, -1 / 0]
    );
  var o = {};
  return u.reduce(function(d, a) {
    for (var V = 0, c = a.length; V < c; V++)
      o[a[V]] || (o[a[V]] = !0, d.push(a[V]));
    return d;
  }, []);
}, BJ = function(r, t) {
  return r === "horizontal" && t === "xAxis" || r === "vertical" && t === "yAxis" || r === "centric" && t === "angleAxis" || r === "radial" && t === "radiusAxis";
}, WJ = function(r, t, i, n) {
  if (n)
    return r.map(function(d) {
      return d.coordinate;
    });
  var s, u, o = r.map(function(d) {
    return d.coordinate === t && (s = !0), d.coordinate === i && (u = !0), d.coordinate;
  });
  return s || o.push(t), u || o.push(i), o;
}, Au = function(r, t, i) {
  if (!r) return null;
  var n = r.scale, s = r.duplicateDomain, u = r.type, o = r.range, d = r.realScaleType === "scaleBand" ? n.bandwidth() / 2 : 2, a = (t || i) && u === "category" && n.bandwidth ? n.bandwidth() / d : 0;
  if (a = r.axisType === "angleAxis" && (o == null ? void 0 : o.length) >= 2 ? ts(o[0] - o[1]) * 2 * a : a, t && (r.ticks || r.niceTicks)) {
    var V = (r.ticks || r.niceTicks).map(function(c) {
      var F = s ? s.indexOf(c) : c;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: n(F) + a,
        value: c,
        offset: a
      };
    });
    return V.filter(function(c) {
      return !C2(c.coordinate);
    });
  }
  return r.isCategorical && r.categoricalDomain ? r.categoricalDomain.map(function(c, F) {
    return {
      coordinate: n(c) + a,
      value: c,
      index: F,
      offset: a
    };
  }) : n.ticks && !i ? n.ticks(r.tickCount).map(function(c) {
    return {
      coordinate: n(c) + a,
      value: c,
      offset: a
    };
  }) : n.domain().map(function(c, F) {
    return {
      coordinate: n(c) + a,
      value: s ? s[c] : c,
      index: F,
      offset: a
    };
  });
}, zm = /* @__PURE__ */ new WeakMap(), Yx = function(r, t) {
  if (typeof t != "function")
    return r;
  zm.has(r) || zm.set(r, /* @__PURE__ */ new WeakMap());
  var i = zm.get(r);
  if (i.has(t))
    return i.get(t);
  var n = function() {
    r.apply(void 0, arguments), t.apply(void 0, arguments);
  };
  return i.set(t, n), n;
}, GJ = function(r, t, i) {
  var n = r.scale, s = r.type, u = r.layout, o = r.axisType;
  if (n === "auto")
    return u === "radial" && o === "radiusAxis" ? {
      scale: c7(),
      realScaleType: "band"
    } : u === "radial" && o === "angleAxis" ? {
      scale: NX(),
      realScaleType: "linear"
    } : s === "category" && t && (t.indexOf("LineChart") >= 0 || t.indexOf("AreaChart") >= 0 || t.indexOf("ComposedChart") >= 0 && !i) ? {
      scale: Rc(),
      realScaleType: "point"
    } : s === "category" ? {
      scale: c7(),
      realScaleType: "band"
    } : {
      scale: NX(),
      realScaleType: "linear"
    };
  if (w2(n)) {
    var d = "scale".concat(ef(n));
    return {
      scale: (DT[d] || Rc)(),
      realScaleType: DT[d] ? d : "point"
    };
  }
  return Ue(n) ? {
    scale: n
  } : {
    scale: Rc(),
    realScaleType: "point"
  };
}, eE = 1e-4, UJ = function(r) {
  var t = r.domain();
  if (!(!t || t.length <= 2)) {
    var i = t.length, n = r.range(), s = Math.min(n[0], n[1]) - eE, u = Math.max(n[0], n[1]) + eE, o = r(t[0]), d = r(t[i - 1]);
    (o < s || o > u || d < s || d > u) && r.domain([t[0], t[i - 1]]);
  }
}, kNe = function(r, t) {
  if (!r)
    return null;
  for (var i = 0, n = r.length; i < n; i++)
    if (r[i].item === t)
      return r[i].position;
  return null;
}, ONe = function(r, t) {
  if (!t || t.length !== 2 || !pe(t[0]) || !pe(t[1]))
    return r;
  var i = Math.min(t[0], t[1]), n = Math.max(t[0], t[1]), s = [r[0], r[1]];
  return (!pe(r[0]) || r[0] < i) && (s[0] = i), (!pe(r[1]) || r[1] > n) && (s[1] = n), s[0] > n && (s[0] = n), s[1] < i && (s[1] = i), s;
}, DNe = function(r) {
  var t = r.length;
  if (!(t <= 0))
    for (var i = 0, n = r[0].length; i < n; ++i)
      for (var s = 0, u = 0, o = 0; o < t; ++o) {
        var d = C2(r[o][i][1]) ? r[o][i][0] : r[o][i][1];
        d >= 0 ? (r[o][i][0] = s, r[o][i][1] = s + d, s = r[o][i][1]) : (r[o][i][0] = u, r[o][i][1] = u + d, u = r[o][i][1]);
      }
}, RNe = function(r) {
  var t = r.length;
  if (!(t <= 0))
    for (var i = 0, n = r[0].length; i < n; ++i)
      for (var s = 0, u = 0; u < t; ++u) {
        var o = C2(r[u][i][1]) ? r[u][i][0] : r[u][i][1];
        o >= 0 ? (r[u][i][0] = s, r[u][i][1] = s + o, s = r[u][i][1]) : (r[u][i][0] = 0, r[u][i][1] = 0);
      }
}, INe = {
  sign: DNe,
  // @ts-expect-error definitelytyped types are incorrect
  expand: y5e,
  // @ts-expect-error definitelytyped types are incorrect
  none: kV,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: A5e,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: w5e,
  positive: RNe
}, LNe = function(r, t, i) {
  var n = t.map(function(o) {
    return o.props.dataKey;
  }), s = INe[i], u = b5e().keys(n).value(function(o, d) {
    return +On(o, d, 0);
  }).order(N8).offset(s);
  return u(r);
}, _Ne = function(r, t, i, n, s, u) {
  if (!r)
    return null;
  var o = u ? t.reverse() : t, d = {}, a = o.reduce(function(c, F) {
    var X, Y = (X = F.type) !== null && X !== void 0 && X.defaultProps ? Vt(Vt({}, F.type.defaultProps), F.props) : F.props, q = Y.stackId, f = Y.hide;
    if (f)
      return c;
    var p = Y[i], m = c[p] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (Mt(q)) {
      var g = m.stackGroups[q] || {
        numericAxisId: i,
        cateAxisId: n,
        items: []
      };
      g.items.push(F), m.hasStack = !0, m.stackGroups[q] = g;
    } else
      m.stackGroups[QY("_stackId_")] = {
        numericAxisId: i,
        cateAxisId: n,
        items: [F]
      };
    return Vt(Vt({}, c), {}, hV({}, p, m));
  }, d), V = {};
  return Object.keys(a).reduce(function(c, F) {
    var X = a[F];
    if (X.hasStack) {
      var Y = {};
      X.stackGroups = Object.keys(X.stackGroups).reduce(function(q, f) {
        var p = X.stackGroups[f];
        return Vt(Vt({}, q), {}, hV({}, f, {
          numericAxisId: i,
          cateAxisId: n,
          items: p.items,
          stackedData: LNe(r, p.items, s)
        }));
      }, Y);
    }
    return Vt(Vt({}, c), {}, hV({}, F, X));
  }, V);
}, ZJ = function(r, t) {
  var i = t.realScaleType, n = t.type, s = t.tickCount, u = t.originalDomain, o = t.allowDecimals, d = i || t.scale;
  if (d !== "auto" && d !== "linear")
    return null;
  if (s && n === "number" && u && (u[0] === "auto" || u[1] === "auto")) {
    var a = r.domain();
    if (!a.length)
      return null;
    var V = tNe(a, s, o);
    return r.domain([qf(V), Xf(V)]), {
      niceTicks: V
    };
  }
  if (s && n === "number") {
    var c = r.domain(), F = iNe(c, s, o);
    return {
      niceTicks: F
    };
  }
  return null;
}, rE = function(r) {
  var t = r.axis, i = r.ticks, n = r.offset, s = r.bandSize, u = r.entry, o = r.index;
  if (t.type === "category")
    return i[o] ? i[o].coordinate + n : null;
  var d = On(u, t.dataKey, t.domain[o]);
  return fr(d) ? null : t.scale(d) - s / 2 + n;
}, HNe = function(r) {
  var t = r.numericAxis, i = t.scale.domain();
  if (t.type === "number") {
    var n = Math.min(i[0], i[1]), s = Math.max(i[0], i[1]);
    return n <= 0 && s >= 0 ? 0 : s < 0 ? s : n;
  }
  return i[0];
}, jNe = function(r, t) {
  var i, n = (i = r.type) !== null && i !== void 0 && i.defaultProps ? Vt(Vt({}, r.type.defaultProps), r.props) : r.props, s = n.stackId;
  if (Mt(s)) {
    var u = t[s];
    if (u) {
      var o = u.items.indexOf(r);
      return o >= 0 ? u.stackedData[o] : null;
    }
  }
  return null;
}, zNe = function(r) {
  return r.reduce(function(t, i) {
    return [qf(i.concat([t[0]]).filter(pe)), Xf(i.concat([t[1]]).filter(pe))];
  }, [1 / 0, -1 / 0]);
}, JJ = function(r, t, i) {
  return Object.keys(r).reduce(function(n, s) {
    var u = r[s], o = u.stackedData, d = o.reduce(function(a, V) {
      var c = zNe(V.slice(t, i + 1));
      return [Math.min(a[0], c[0]), Math.max(a[1], c[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(d[0], n[0]), Math.max(d[1], n[1])];
  }, [1 / 0, -1 / 0]).map(function(n) {
    return n === 1 / 0 || n === -1 / 0 ? 0 : n;
  });
}, tE = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, iE = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, ib = function(r, t, i) {
  if (Ue(r))
    return r(t, i);
  if (!Array.isArray(r))
    return t;
  var n = [];
  if (pe(r[0]))
    n[0] = i ? r[0] : Math.min(r[0], t[0]);
  else if (tE.test(r[0])) {
    var s = +tE.exec(r[0])[1];
    n[0] = t[0] - s;
  } else Ue(r[0]) ? n[0] = r[0](t[0]) : n[0] = t[0];
  if (pe(r[1]))
    n[1] = i ? r[1] : Math.max(r[1], t[1]);
  else if (iE.test(r[1])) {
    var u = +iE.exec(r[1])[1];
    n[1] = t[1] + u;
  } else Ue(r[1]) ? n[1] = r[1](t[1]) : n[1] = t[1];
  return n;
}, RX = function(r, t, i) {
  if (r && r.scale && r.scale.bandwidth) {
    var n = r.scale.bandwidth();
    if (!i || n > 0)
      return n;
  }
  if (r && t && t.length >= 2) {
    for (var s = BA(t, function(c) {
      return c.coordinate;
    }), u = 1 / 0, o = 1, d = s.length; o < d; o++) {
      var a = s[o], V = s[o - 1];
      u = Math.min((a.coordinate || 0) - (V.coordinate || 0), u);
    }
    return u === 1 / 0 ? 0 : u;
  }
  return i ? void 0 : 0;
}, nE = function(r, t, i) {
  return !r || !r.length || Yf(r, Mn(i, "type.defaultProps.domain")) ? t : r;
}, $J = function(r, t) {
  var i = r.type.defaultProps ? Vt(Vt({}, r.type.defaultProps), r.props) : r.props, n = i.dataKey, s = i.name, u = i.unit, o = i.formatter, d = i.tooltipType, a = i.chartType, V = i.hide;
  return Vt(Vt({}, _e(r, !1)), {}, {
    dataKey: n,
    unit: u,
    formatter: o,
    name: s || n,
    color: f4(r),
    value: On(t, n),
    type: d,
    payload: t,
    chartType: a,
    hide: V
  });
};
function p7(e) {
  "@babel/helpers - typeof";
  return p7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, p7(e);
}
function sE(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function hu(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? sE(Object(t), !0).forEach(function(i) {
      QJ(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : sE(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function QJ(e, r, t) {
  return r = BNe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function BNe(e) {
  var r = WNe(e, "string");
  return p7(r) == "symbol" ? r : r + "";
}
function WNe(e, r) {
  if (p7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (p7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function GNe(e, r) {
  return $Ne(e) || JNe(e, r) || ZNe(e, r) || UNe();
}
function UNe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ZNe(e, r) {
  if (e) {
    if (typeof e == "string") return uE(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return uE(e, r);
  }
}
function uE(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
function JNe(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var i, n, s, u, o = [], d = !0, a = !1;
    try {
      if (s = (t = t.call(e)).next, r !== 0) for (; !(d = (i = s.call(t)).done) && (o.push(i.value), o.length !== r); d = !0) ;
    } catch (V) {
      a = !0, n = V;
    } finally {
      try {
        if (!d && t.return != null && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (a) throw n;
      }
    }
    return o;
  }
}
function $Ne(e) {
  if (Array.isArray(e)) return e;
}
var IX = Math.PI / 180, QNe = function(r) {
  return r * 180 / Math.PI;
}, kr = function(r, t, i, n) {
  return {
    x: r + Math.cos(-IX * n) * i,
    y: t + Math.sin(-IX * n) * i
  };
}, eMe = function(r, t) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(r - (i.left || 0) - (i.right || 0)), Math.abs(t - (i.top || 0) - (i.bottom || 0))) / 2;
}, rMe = function(r, t, i, n, s) {
  var u = r.width, o = r.height, d = r.startAngle, a = r.endAngle, V = is(r.cx, u, u / 2), c = is(r.cy, o, o / 2), F = eMe(u, o, i), X = is(r.innerRadius, F, 0), Y = is(r.outerRadius, F, F * 0.8), q = Object.keys(t);
  return q.reduce(function(f, p) {
    var m = t[p], g = m.domain, y = m.reversed, b;
    if (fr(m.range))
      n === "angleAxis" ? b = [d, a] : n === "radiusAxis" && (b = [X, Y]), y && (b = [b[1], b[0]]);
    else {
      b = m.range;
      var A = b, w = GNe(A, 2);
      d = w[0], a = w[1];
    }
    var S = GJ(m, s), N = S.realScaleType, O = S.scale;
    O.domain(g).range(b), UJ(O);
    var E = ZJ(O, hu(hu({}, m), {}, {
      realScaleType: N
    })), I = hu(hu(hu({}, m), E), {}, {
      range: b,
      radius: Y,
      realScaleType: N,
      scale: O,
      cx: V,
      cy: c,
      innerRadius: X,
      outerRadius: Y,
      startAngle: d,
      endAngle: a
    });
    return hu(hu({}, f), {}, QJ({}, p, I));
  }, {});
}, tMe = function(r, t) {
  var i = r.x, n = r.y, s = t.x, u = t.y;
  return Math.sqrt(Math.pow(i - s, 2) + Math.pow(n - u, 2));
}, iMe = function(r, t) {
  var i = r.x, n = r.y, s = t.cx, u = t.cy, o = tMe({
    x: i,
    y: n
  }, {
    x: s,
    y: u
  });
  if (o <= 0)
    return {
      radius: o
    };
  var d = (i - s) / o, a = Math.acos(d);
  return n > u && (a = 2 * Math.PI - a), {
    radius: o,
    angle: QNe(a),
    angleInRadian: a
  };
}, nMe = function(r) {
  var t = r.startAngle, i = r.endAngle, n = Math.floor(t / 360), s = Math.floor(i / 360), u = Math.min(n, s);
  return {
    startAngle: t - u * 360,
    endAngle: i - u * 360
  };
}, sMe = function(r, t) {
  var i = t.startAngle, n = t.endAngle, s = Math.floor(i / 360), u = Math.floor(n / 360), o = Math.min(s, u);
  return r + o * 360;
}, oE = function(r, t) {
  var i = r.x, n = r.y, s = iMe({
    x: i,
    y: n
  }, t), u = s.radius, o = s.angle, d = t.innerRadius, a = t.outerRadius;
  if (u < d || u > a)
    return !1;
  if (u === 0)
    return !0;
  var V = nMe(t), c = V.startAngle, F = V.endAngle, X = o, Y;
  if (c <= F) {
    for (; X > F; )
      X -= 360;
    for (; X < c; )
      X += 360;
    Y = X >= c && X <= F;
  } else {
    for (; X > c; )
      X -= 360;
    for (; X < F; )
      X += 360;
    Y = X >= F && X <= c;
  }
  return Y ? hu(hu({}, t), {}, {
    radius: u,
    angle: sMe(X, t)
  }) : null;
}, e$ = function(r) {
  return !/* @__PURE__ */ Ci(r) && !Ue(r) && typeof r != "boolean" ? r.className : "";
};
function m7(e) {
  "@babel/helpers - typeof";
  return m7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, m7(e);
}
var uMe = ["offset"];
function oMe(e) {
  return lMe(e) || VMe(e) || aMe(e) || dMe();
}
function dMe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function aMe(e, r) {
  if (e) {
    if (typeof e == "string") return nb(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return nb(e, r);
  }
}
function VMe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function lMe(e) {
  if (Array.isArray(e)) return nb(e);
}
function nb(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
function cMe(e, r) {
  if (e == null) return {};
  var t = FMe(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function FMe(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
function dE(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function Ct(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? dE(Object(t), !0).forEach(function(i) {
      xMe(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : dE(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function xMe(e, r, t) {
  return r = XMe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function XMe(e) {
  var r = qMe(e, "string");
  return m7(r) == "symbol" ? r : r + "";
}
function qMe(e, r) {
  if (m7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (m7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function g7() {
  return g7 = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, g7.apply(this, arguments);
}
var YMe = function(r) {
  var t = r.value, i = r.formatter, n = fr(r.children) ? t : r.children;
  return Ue(i) ? i(n) : n;
}, fMe = function(r, t) {
  var i = ts(t - r), n = Math.min(Math.abs(t - r), 360);
  return i * n;
}, KMe = function(r, t, i) {
  var n = r.position, s = r.viewBox, u = r.offset, o = r.className, d = s, a = d.cx, V = d.cy, c = d.innerRadius, F = d.outerRadius, X = d.startAngle, Y = d.endAngle, q = d.clockWise, f = (c + F) / 2, p = fMe(X, Y), m = p >= 0 ? 1 : -1, g, y;
  n === "insideStart" ? (g = X + m * u, y = q) : n === "insideEnd" ? (g = Y - m * u, y = !q) : n === "end" && (g = Y + m * u, y = q), y = p <= 0 ? y : !y;
  var b = kr(a, V, f, g), A = kr(a, V, f, g + (y ? 1 : -1) * 359), w = "M".concat(b.x, ",").concat(b.y, `
    A`).concat(f, ",").concat(f, ",0,1,").concat(y ? 0 : 1, `,
    `).concat(A.x, ",").concat(A.y), S = fr(r.id) ? QY("recharts-radial-line-") : r.id;
  return /* @__PURE__ */ D.createElement("text", g7({}, i, {
    dominantBaseline: "central",
    className: ur("recharts-radial-bar-label", o)
  }), /* @__PURE__ */ D.createElement("defs", null, /* @__PURE__ */ D.createElement("path", {
    id: S,
    d: w
  })), /* @__PURE__ */ D.createElement("textPath", {
    xlinkHref: "#".concat(S)
  }, t));
}, hMe = function(r) {
  var t = r.viewBox, i = r.offset, n = r.position, s = t, u = s.cx, o = s.cy, d = s.innerRadius, a = s.outerRadius, V = s.startAngle, c = s.endAngle, F = (V + c) / 2;
  if (n === "outside") {
    var X = kr(u, o, a + i, F), Y = X.x, q = X.y;
    return {
      x: Y,
      y: q,
      textAnchor: Y >= u ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (n === "center")
    return {
      x: u,
      y: o,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (n === "centerTop")
    return {
      x: u,
      y: o,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (n === "centerBottom")
    return {
      x: u,
      y: o,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var f = (d + a) / 2, p = kr(u, o, f, F), m = p.x, g = p.y;
  return {
    x: m,
    y: g,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, pMe = function(r) {
  var t = r.viewBox, i = r.parentViewBox, n = r.offset, s = r.position, u = t, o = u.x, d = u.y, a = u.width, V = u.height, c = V >= 0 ? 1 : -1, F = c * n, X = c > 0 ? "end" : "start", Y = c > 0 ? "start" : "end", q = a >= 0 ? 1 : -1, f = q * n, p = q > 0 ? "end" : "start", m = q > 0 ? "start" : "end";
  if (s === "top") {
    var g = {
      x: o + a / 2,
      y: d - c * n,
      textAnchor: "middle",
      verticalAnchor: X
    };
    return Ct(Ct({}, g), i ? {
      height: Math.max(d - i.y, 0),
      width: a
    } : {});
  }
  if (s === "bottom") {
    var y = {
      x: o + a / 2,
      y: d + V + F,
      textAnchor: "middle",
      verticalAnchor: Y
    };
    return Ct(Ct({}, y), i ? {
      height: Math.max(i.y + i.height - (d + V), 0),
      width: a
    } : {});
  }
  if (s === "left") {
    var b = {
      x: o - f,
      y: d + V / 2,
      textAnchor: p,
      verticalAnchor: "middle"
    };
    return Ct(Ct({}, b), i ? {
      width: Math.max(b.x - i.x, 0),
      height: V
    } : {});
  }
  if (s === "right") {
    var A = {
      x: o + a + f,
      y: d + V / 2,
      textAnchor: m,
      verticalAnchor: "middle"
    };
    return Ct(Ct({}, A), i ? {
      width: Math.max(i.x + i.width - A.x, 0),
      height: V
    } : {});
  }
  var w = i ? {
    width: a,
    height: V
  } : {};
  return s === "insideLeft" ? Ct({
    x: o + f,
    y: d + V / 2,
    textAnchor: m,
    verticalAnchor: "middle"
  }, w) : s === "insideRight" ? Ct({
    x: o + a - f,
    y: d + V / 2,
    textAnchor: p,
    verticalAnchor: "middle"
  }, w) : s === "insideTop" ? Ct({
    x: o + a / 2,
    y: d + F,
    textAnchor: "middle",
    verticalAnchor: Y
  }, w) : s === "insideBottom" ? Ct({
    x: o + a / 2,
    y: d + V - F,
    textAnchor: "middle",
    verticalAnchor: X
  }, w) : s === "insideTopLeft" ? Ct({
    x: o + f,
    y: d + F,
    textAnchor: m,
    verticalAnchor: Y
  }, w) : s === "insideTopRight" ? Ct({
    x: o + a - f,
    y: d + F,
    textAnchor: p,
    verticalAnchor: Y
  }, w) : s === "insideBottomLeft" ? Ct({
    x: o + f,
    y: d + V - F,
    textAnchor: m,
    verticalAnchor: X
  }, w) : s === "insideBottomRight" ? Ct({
    x: o + a - f,
    y: d + V - F,
    textAnchor: p,
    verticalAnchor: X
  }, w) : Sl(s) && (pe(s.x) || wd(s.x)) && (pe(s.y) || wd(s.y)) ? Ct({
    x: o + is(s.x, a),
    y: d + is(s.y, V),
    textAnchor: "end",
    verticalAnchor: "end"
  }, w) : Ct({
    x: o + a / 2,
    y: d + V / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, w);
}, mMe = function(r) {
  return "cx" in r && pe(r.cx);
};
function Qt(e) {
  var r = e.offset, t = r === void 0 ? 5 : r, i = cMe(e, uMe), n = Ct({
    offset: t
  }, i), s = n.viewBox, u = n.position, o = n.value, d = n.children, a = n.content, V = n.className, c = V === void 0 ? "" : V, F = n.textBreakAll;
  if (!s || fr(o) && fr(d) && !/* @__PURE__ */ Ci(a) && !Ue(a))
    return null;
  if (/* @__PURE__ */ Ci(a))
    return /* @__PURE__ */ at(a, n);
  var X;
  if (Ue(a)) {
    if (X = /* @__PURE__ */ lr(a, n), /* @__PURE__ */ Ci(X))
      return X;
  } else
    X = YMe(n);
  var Y = mMe(s), q = _e(n, !0);
  if (Y && (u === "insideStart" || u === "insideEnd" || u === "end"))
    return KMe(n, X, q);
  var f = Y ? hMe(n) : pMe(n);
  return /* @__PURE__ */ D.createElement(LV, g7({
    className: ur("recharts-label", c)
  }, q, f, {
    breakAll: F
  }), X);
}
Qt.displayName = "Label";
var r$ = function(r) {
  var t = r.cx, i = r.cy, n = r.angle, s = r.startAngle, u = r.endAngle, o = r.r, d = r.radius, a = r.innerRadius, V = r.outerRadius, c = r.x, F = r.y, X = r.top, Y = r.left, q = r.width, f = r.height, p = r.clockWise, m = r.labelViewBox;
  if (m)
    return m;
  if (pe(q) && pe(f)) {
    if (pe(c) && pe(F))
      return {
        x: c,
        y: F,
        width: q,
        height: f
      };
    if (pe(X) && pe(Y))
      return {
        x: X,
        y: Y,
        width: q,
        height: f
      };
  }
  return pe(c) && pe(F) ? {
    x: c,
    y: F,
    width: 0,
    height: 0
  } : pe(t) && pe(i) ? {
    cx: t,
    cy: i,
    startAngle: s || n || 0,
    endAngle: u || n || 0,
    innerRadius: a || 0,
    outerRadius: V || d || o || 0,
    clockWise: p
  } : r.viewBox ? r.viewBox : {};
}, gMe = function(r, t) {
  return r ? r === !0 ? /* @__PURE__ */ D.createElement(Qt, {
    key: "label-implicit",
    viewBox: t
  }) : Mt(r) ? /* @__PURE__ */ D.createElement(Qt, {
    key: "label-implicit",
    viewBox: t,
    value: r
  }) : /* @__PURE__ */ Ci(r) ? r.type === Qt ? /* @__PURE__ */ at(r, {
    key: "label-implicit",
    viewBox: t
  }) : /* @__PURE__ */ D.createElement(Qt, {
    key: "label-implicit",
    content: r,
    viewBox: t
  }) : Ue(r) ? /* @__PURE__ */ D.createElement(Qt, {
    key: "label-implicit",
    content: r,
    viewBox: t
  }) : Sl(r) ? /* @__PURE__ */ D.createElement(Qt, g7({
    viewBox: t
  }, r, {
    key: "label-implicit"
  })) : null : null;
}, vMe = function(r, t) {
  var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!r || !r.children && i && !r.label)
    return null;
  var n = r.children, s = r$(r), u = ss(n, Qt).map(function(d, a) {
    return /* @__PURE__ */ at(d, {
      viewBox: t || s,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(a)
    });
  });
  if (!i)
    return u;
  var o = gMe(r.label, t || s);
  return [o].concat(oMe(u));
};
Qt.parseViewBox = r$;
Qt.renderCallByParent = vMe;
var Bm, aE;
function bMe() {
  if (aE) return Bm;
  aE = 1;
  function e(r) {
    var t = r == null ? 0 : r.length;
    return t ? r[t - 1] : void 0;
  }
  return Bm = e, Bm;
}
var yMe = bMe();
const t$ = /* @__PURE__ */ Mr(yMe);
function v7(e) {
  "@babel/helpers - typeof";
  return v7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, v7(e);
}
var AMe = ["valueAccessor"], wMe = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function CMe(e) {
  return MMe(e) || NMe(e) || SMe(e) || PMe();
}
function PMe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function SMe(e, r) {
  if (e) {
    if (typeof e == "string") return sb(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return sb(e, r);
  }
}
function NMe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function MMe(e) {
  if (Array.isArray(e)) return sb(e);
}
function sb(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
function LX() {
  return LX = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, LX.apply(this, arguments);
}
function VE(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function lE(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? VE(Object(t), !0).forEach(function(i) {
      TMe(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : VE(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function TMe(e, r, t) {
  return r = EMe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function EMe(e) {
  var r = kMe(e, "string");
  return v7(r) == "symbol" ? r : r + "";
}
function kMe(e, r) {
  if (v7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (v7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function cE(e, r) {
  if (e == null) return {};
  var t = OMe(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function OMe(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
var DMe = function(r) {
  return Array.isArray(r.value) ? t$(r.value) : r.value;
};
function To(e) {
  var r = e.valueAccessor, t = r === void 0 ? DMe : r, i = cE(e, AMe), n = i.data, s = i.dataKey, u = i.clockWise, o = i.id, d = i.textBreakAll, a = cE(i, wMe);
  return !n || !n.length ? null : /* @__PURE__ */ D.createElement(Hr, {
    className: "recharts-label-list"
  }, n.map(function(V, c) {
    var F = fr(s) ? t(V, c) : On(V && V.payload, s), X = fr(o) ? {} : {
      id: "".concat(o, "-").concat(c)
    };
    return /* @__PURE__ */ D.createElement(Qt, LX({}, _e(V, !0), a, X, {
      parentViewBox: V.parentViewBox,
      value: F,
      textBreakAll: d,
      viewBox: Qt.parseViewBox(fr(u) ? V : lE(lE({}, V), {}, {
        clockWise: u
      })),
      key: "label-".concat(c),
      index: c
    }));
  }));
}
To.displayName = "LabelList";
function RMe(e, r) {
  return e ? e === !0 ? /* @__PURE__ */ D.createElement(To, {
    key: "labelList-implicit",
    data: r
  }) : /* @__PURE__ */ D.isValidElement(e) || Ue(e) ? /* @__PURE__ */ D.createElement(To, {
    key: "labelList-implicit",
    data: r,
    content: e
  }) : Sl(e) ? /* @__PURE__ */ D.createElement(To, LX({
    data: r
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function IMe(e, r) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && t && !e.label)
    return null;
  var i = e.children, n = ss(i, To).map(function(u, o) {
    return /* @__PURE__ */ at(u, {
      data: r,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(o)
    });
  });
  if (!t)
    return n;
  var s = RMe(e.label, r);
  return [s].concat(CMe(n));
}
To.renderCallByParent = IMe;
function b7(e) {
  "@babel/helpers - typeof";
  return b7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, b7(e);
}
function ub() {
  return ub = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, ub.apply(this, arguments);
}
function FE(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function xE(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? FE(Object(t), !0).forEach(function(i) {
      LMe(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FE(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function LMe(e, r, t) {
  return r = _Me(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function _Me(e) {
  var r = HMe(e, "string");
  return b7(r) == "symbol" ? r : r + "";
}
function HMe(e, r) {
  if (b7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (b7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
var jMe = function(r, t) {
  var i = ts(t - r), n = Math.min(Math.abs(t - r), 359.999);
  return i * n;
}, fx = function(r) {
  var t = r.cx, i = r.cy, n = r.radius, s = r.angle, u = r.sign, o = r.isExternal, d = r.cornerRadius, a = r.cornerIsExternal, V = d * (o ? 1 : -1) + n, c = Math.asin(d / V) / IX, F = a ? s : s + u * c, X = kr(t, i, V, F), Y = kr(t, i, n, F), q = a ? s - u * c : s, f = kr(t, i, V * Math.cos(c * IX), q);
  return {
    center: X,
    circleTangency: Y,
    lineTangency: f,
    theta: c
  };
}, i$ = function(r) {
  var t = r.cx, i = r.cy, n = r.innerRadius, s = r.outerRadius, u = r.startAngle, o = r.endAngle, d = jMe(u, o), a = u + d, V = kr(t, i, s, u), c = kr(t, i, s, a), F = "M ".concat(V.x, ",").concat(V.y, `
    A `).concat(s, ",").concat(s, `,0,
    `).concat(+(Math.abs(d) > 180), ",").concat(+(u > a), `,
    `).concat(c.x, ",").concat(c.y, `
  `);
  if (n > 0) {
    var X = kr(t, i, n, u), Y = kr(t, i, n, a);
    F += "L ".concat(Y.x, ",").concat(Y.y, `
            A `).concat(n, ",").concat(n, `,0,
            `).concat(+(Math.abs(d) > 180), ",").concat(+(u <= a), `,
            `).concat(X.x, ",").concat(X.y, " Z");
  } else
    F += "L ".concat(t, ",").concat(i, " Z");
  return F;
}, zMe = function(r) {
  var t = r.cx, i = r.cy, n = r.innerRadius, s = r.outerRadius, u = r.cornerRadius, o = r.forceCornerRadius, d = r.cornerIsExternal, a = r.startAngle, V = r.endAngle, c = ts(V - a), F = fx({
    cx: t,
    cy: i,
    radius: s,
    angle: a,
    sign: c,
    cornerRadius: u,
    cornerIsExternal: d
  }), X = F.circleTangency, Y = F.lineTangency, q = F.theta, f = fx({
    cx: t,
    cy: i,
    radius: s,
    angle: V,
    sign: -c,
    cornerRadius: u,
    cornerIsExternal: d
  }), p = f.circleTangency, m = f.lineTangency, g = f.theta, y = d ? Math.abs(a - V) : Math.abs(a - V) - q - g;
  if (y < 0)
    return o ? "M ".concat(Y.x, ",").concat(Y.y, `
        a`).concat(u, ",").concat(u, ",0,0,1,").concat(u * 2, `,0
        a`).concat(u, ",").concat(u, ",0,0,1,").concat(-u * 2, `,0
      `) : i$({
      cx: t,
      cy: i,
      innerRadius: n,
      outerRadius: s,
      startAngle: a,
      endAngle: V
    });
  var b = "M ".concat(Y.x, ",").concat(Y.y, `
    A`).concat(u, ",").concat(u, ",0,0,").concat(+(c < 0), ",").concat(X.x, ",").concat(X.y, `
    A`).concat(s, ",").concat(s, ",0,").concat(+(y > 180), ",").concat(+(c < 0), ",").concat(p.x, ",").concat(p.y, `
    A`).concat(u, ",").concat(u, ",0,0,").concat(+(c < 0), ",").concat(m.x, ",").concat(m.y, `
  `);
  if (n > 0) {
    var A = fx({
      cx: t,
      cy: i,
      radius: n,
      angle: a,
      sign: c,
      isExternal: !0,
      cornerRadius: u,
      cornerIsExternal: d
    }), w = A.circleTangency, S = A.lineTangency, N = A.theta, O = fx({
      cx: t,
      cy: i,
      radius: n,
      angle: V,
      sign: -c,
      isExternal: !0,
      cornerRadius: u,
      cornerIsExternal: d
    }), E = O.circleTangency, I = O.lineTangency, R = O.theta, H = d ? Math.abs(a - V) : Math.abs(a - V) - N - R;
    if (H < 0 && u === 0)
      return "".concat(b, "L").concat(t, ",").concat(i, "Z");
    b += "L".concat(I.x, ",").concat(I.y, `
      A`).concat(u, ",").concat(u, ",0,0,").concat(+(c < 0), ",").concat(E.x, ",").concat(E.y, `
      A`).concat(n, ",").concat(n, ",0,").concat(+(H > 180), ",").concat(+(c > 0), ",").concat(w.x, ",").concat(w.y, `
      A`).concat(u, ",").concat(u, ",0,0,").concat(+(c < 0), ",").concat(S.x, ",").concat(S.y, "Z");
  } else
    b += "L".concat(t, ",").concat(i, "Z");
  return b;
}, BMe = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, n$ = function(r) {
  var t = xE(xE({}, BMe), r), i = t.cx, n = t.cy, s = t.innerRadius, u = t.outerRadius, o = t.cornerRadius, d = t.forceCornerRadius, a = t.cornerIsExternal, V = t.startAngle, c = t.endAngle, F = t.className;
  if (u < s || V === c)
    return null;
  var X = ur("recharts-sector", F), Y = u - s, q = is(o, Y, 0, !0), f;
  return q > 0 && Math.abs(V - c) < 360 ? f = zMe({
    cx: i,
    cy: n,
    innerRadius: s,
    outerRadius: u,
    cornerRadius: Math.min(q, Y / 2),
    forceCornerRadius: d,
    cornerIsExternal: a,
    startAngle: V,
    endAngle: c
  }) : f = i$({
    cx: i,
    cy: n,
    innerRadius: s,
    outerRadius: u,
    startAngle: V,
    endAngle: c
  }), /* @__PURE__ */ D.createElement("path", ub({}, _e(t, !0), {
    className: X,
    d: f,
    role: "img"
  }));
};
function y7(e) {
  "@babel/helpers - typeof";
  return y7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, y7(e);
}
function ob() {
  return ob = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, ob.apply(this, arguments);
}
function XE(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function qE(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? XE(Object(t), !0).forEach(function(i) {
      WMe(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : XE(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function WMe(e, r, t) {
  return r = GMe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function GMe(e) {
  var r = UMe(e, "string");
  return y7(r) == "symbol" ? r : r + "";
}
function UMe(e, r) {
  if (y7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (y7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
var YE = {
  curveBasisClosed: x5e,
  curveBasisOpen: X5e,
  curveBasis: F5e,
  curveBumpX: Q4e,
  curveBumpY: e5e,
  curveLinearClosed: q5e,
  curveLinear: tf,
  curveMonotoneX: Y5e,
  curveMonotoneY: f5e,
  curveNatural: K5e,
  curveStep: h5e,
  curveStepAfter: m5e,
  curveStepBefore: p5e
}, Kx = function(r) {
  return r.x === +r.x && r.y === +r.y;
}, qc = function(r) {
  return r.x;
}, Yc = function(r) {
  return r.y;
}, ZMe = function(r, t) {
  if (Ue(r))
    return r;
  var i = "curve".concat(ef(r));
  return (i === "curveMonotone" || i === "curveBump") && t ? YE["".concat(i).concat(t === "vertical" ? "Y" : "X")] : YE[i] || tf;
}, JMe = function(r) {
  var t = r.type, i = t === void 0 ? "linear" : t, n = r.points, s = n === void 0 ? [] : n, u = r.baseLine, o = r.layout, d = r.connectNulls, a = d === void 0 ? !1 : d, V = ZMe(i, o), c = a ? s.filter(function(q) {
    return Kx(q);
  }) : s, F;
  if (Array.isArray(u)) {
    var X = a ? u.filter(function(q) {
      return Kx(q);
    }) : u, Y = c.map(function(q, f) {
      return qE(qE({}, q), {}, {
        base: X[f]
      });
    });
    return o === "vertical" ? F = Vx().y(Yc).x1(qc).x0(function(q) {
      return q.base.x;
    }) : F = Vx().x(qc).y1(Yc).y0(function(q) {
      return q.base.y;
    }), F.defined(Kx).curve(V), F(Y);
  }
  return o === "vertical" && pe(u) ? F = Vx().y(Yc).x1(qc).x0(u) : pe(u) ? F = Vx().x(qc).y1(Yc).y0(u) : F = rZ().x(qc).y(Yc), F.defined(Kx).curve(V), F(c);
}, fE = function(r) {
  var t = r.className, i = r.points, n = r.path, s = r.pathRef;
  if ((!i || !i.length) && !n)
    return null;
  var u = i && i.length ? JMe(r) : n;
  return /* @__PURE__ */ D.createElement("path", ob({}, _e(r, !1), XX(r), {
    className: ur("recharts-curve", t),
    d: u,
    ref: s
  }));
}, $Me = Object.getOwnPropertyNames, QMe = Object.getOwnPropertySymbols, eTe = Object.prototype.hasOwnProperty;
function KE(e, r) {
  return function(i, n, s) {
    return e(i, n, s) && r(i, n, s);
  };
}
function hx(e) {
  return function(t, i, n) {
    if (!t || !i || typeof t != "object" || typeof i != "object")
      return e(t, i, n);
    var s = n.cache, u = s.get(t), o = s.get(i);
    if (u && o)
      return u === i && o === t;
    s.set(t, i), s.set(i, t);
    var d = e(t, i, n);
    return s.delete(t), s.delete(i), d;
  };
}
function hE(e) {
  return $Me(e).concat(QMe(e));
}
var rTe = Object.hasOwn || function(e, r) {
  return eTe.call(e, r);
};
function Xa(e, r) {
  return e === r || !e && !r && e !== e && r !== r;
}
var tTe = "__v", iTe = "__o", nTe = "_owner", pE = Object.getOwnPropertyDescriptor, mE = Object.keys;
function sTe(e, r, t) {
  var i = e.length;
  if (r.length !== i)
    return !1;
  for (; i-- > 0; )
    if (!t.equals(e[i], r[i], i, i, e, r, t))
      return !1;
  return !0;
}
function uTe(e, r) {
  return Xa(e.getTime(), r.getTime());
}
function oTe(e, r) {
  return e.name === r.name && e.message === r.message && e.cause === r.cause && e.stack === r.stack;
}
function dTe(e, r) {
  return e === r;
}
function gE(e, r, t) {
  var i = e.size;
  if (i !== r.size)
    return !1;
  if (!i)
    return !0;
  for (var n = new Array(i), s = e.entries(), u, o, d = 0; (u = s.next()) && !u.done; ) {
    for (var a = r.entries(), V = !1, c = 0; (o = a.next()) && !o.done; ) {
      if (n[c]) {
        c++;
        continue;
      }
      var F = u.value, X = o.value;
      if (t.equals(F[0], X[0], d, c, e, r, t) && t.equals(F[1], X[1], F[0], X[0], e, r, t)) {
        V = n[c] = !0;
        break;
      }
      c++;
    }
    if (!V)
      return !1;
    d++;
  }
  return !0;
}
var aTe = Xa;
function VTe(e, r, t) {
  var i = mE(e), n = i.length;
  if (mE(r).length !== n)
    return !1;
  for (; n-- > 0; )
    if (!s$(e, r, t, i[n]))
      return !1;
  return !0;
}
function fc(e, r, t) {
  var i = hE(e), n = i.length;
  if (hE(r).length !== n)
    return !1;
  for (var s, u, o; n-- > 0; )
    if (s = i[n], !s$(e, r, t, s) || (u = pE(e, s), o = pE(r, s), (u || o) && (!u || !o || u.configurable !== o.configurable || u.enumerable !== o.enumerable || u.writable !== o.writable)))
      return !1;
  return !0;
}
function lTe(e, r) {
  return Xa(e.valueOf(), r.valueOf());
}
function cTe(e, r) {
  return e.source === r.source && e.flags === r.flags;
}
function vE(e, r, t) {
  var i = e.size;
  if (i !== r.size)
    return !1;
  if (!i)
    return !0;
  for (var n = new Array(i), s = e.values(), u, o; (u = s.next()) && !u.done; ) {
    for (var d = r.values(), a = !1, V = 0; (o = d.next()) && !o.done; ) {
      if (!n[V] && t.equals(u.value, o.value, u.value, o.value, e, r, t)) {
        a = n[V] = !0;
        break;
      }
      V++;
    }
    if (!a)
      return !1;
  }
  return !0;
}
function FTe(e, r) {
  var t = e.length;
  if (r.length !== t)
    return !1;
  for (; t-- > 0; )
    if (e[t] !== r[t])
      return !1;
  return !0;
}
function xTe(e, r) {
  return e.hostname === r.hostname && e.pathname === r.pathname && e.protocol === r.protocol && e.port === r.port && e.hash === r.hash && e.username === r.username && e.password === r.password;
}
function s$(e, r, t, i) {
  return (i === nTe || i === iTe || i === tTe) && (e.$$typeof || r.$$typeof) ? !0 : rTe(r, i) && t.equals(e[i], r[i], i, i, e, r, t);
}
var XTe = "[object Arguments]", qTe = "[object Boolean]", YTe = "[object Date]", fTe = "[object Error]", KTe = "[object Map]", hTe = "[object Number]", pTe = "[object Object]", mTe = "[object RegExp]", gTe = "[object Set]", vTe = "[object String]", bTe = "[object URL]", yTe = Array.isArray, bE = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, yE = Object.assign, ATe = Object.prototype.toString.call.bind(Object.prototype.toString);
function wTe(e) {
  var r = e.areArraysEqual, t = e.areDatesEqual, i = e.areErrorsEqual, n = e.areFunctionsEqual, s = e.areMapsEqual, u = e.areNumbersEqual, o = e.areObjectsEqual, d = e.arePrimitiveWrappersEqual, a = e.areRegExpsEqual, V = e.areSetsEqual, c = e.areTypedArraysEqual, F = e.areUrlsEqual;
  return function(Y, q, f) {
    if (Y === q)
      return !0;
    if (Y == null || q == null)
      return !1;
    var p = typeof Y;
    if (p !== typeof q)
      return !1;
    if (p !== "object")
      return p === "number" ? u(Y, q, f) : p === "function" ? n(Y, q, f) : !1;
    var m = Y.constructor;
    if (m !== q.constructor)
      return !1;
    if (m === Object)
      return o(Y, q, f);
    if (yTe(Y))
      return r(Y, q, f);
    if (bE != null && bE(Y))
      return c(Y, q, f);
    if (m === Date)
      return t(Y, q, f);
    if (m === RegExp)
      return a(Y, q, f);
    if (m === Map)
      return s(Y, q, f);
    if (m === Set)
      return V(Y, q, f);
    var g = ATe(Y);
    return g === YTe ? t(Y, q, f) : g === mTe ? a(Y, q, f) : g === KTe ? s(Y, q, f) : g === gTe ? V(Y, q, f) : g === pTe ? typeof Y.then != "function" && typeof q.then != "function" && o(Y, q, f) : g === bTe ? F(Y, q, f) : g === fTe ? i(Y, q, f) : g === XTe ? o(Y, q, f) : g === qTe || g === hTe || g === vTe ? d(Y, q, f) : !1;
  };
}
function CTe(e) {
  var r = e.circular, t = e.createCustomConfig, i = e.strict, n = {
    areArraysEqual: i ? fc : sTe,
    areDatesEqual: uTe,
    areErrorsEqual: oTe,
    areFunctionsEqual: dTe,
    areMapsEqual: i ? KE(gE, fc) : gE,
    areNumbersEqual: aTe,
    areObjectsEqual: i ? fc : VTe,
    arePrimitiveWrappersEqual: lTe,
    areRegExpsEqual: cTe,
    areSetsEqual: i ? KE(vE, fc) : vE,
    areTypedArraysEqual: i ? fc : FTe,
    areUrlsEqual: xTe
  };
  if (t && (n = yE({}, n, t(n))), r) {
    var s = hx(n.areArraysEqual), u = hx(n.areMapsEqual), o = hx(n.areObjectsEqual), d = hx(n.areSetsEqual);
    n = yE({}, n, {
      areArraysEqual: s,
      areMapsEqual: u,
      areObjectsEqual: o,
      areSetsEqual: d
    });
  }
  return n;
}
function PTe(e) {
  return function(r, t, i, n, s, u, o) {
    return e(r, t, o);
  };
}
function STe(e) {
  var r = e.circular, t = e.comparator, i = e.createState, n = e.equals, s = e.strict;
  if (i)
    return function(d, a) {
      var V = i(), c = V.cache, F = c === void 0 ? r ? /* @__PURE__ */ new WeakMap() : void 0 : c, X = V.meta;
      return t(d, a, {
        cache: F,
        equals: n,
        meta: X,
        strict: s
      });
    };
  if (r)
    return function(d, a) {
      return t(d, a, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: n,
        meta: void 0,
        strict: s
      });
    };
  var u = {
    cache: void 0,
    equals: n,
    meta: void 0,
    strict: s
  };
  return function(d, a) {
    return t(d, a, u);
  };
}
var NTe = td();
td({ strict: !0 });
td({ circular: !0 });
td({
  circular: !0,
  strict: !0
});
td({
  createInternalComparator: function() {
    return Xa;
  }
});
td({
  strict: !0,
  createInternalComparator: function() {
    return Xa;
  }
});
td({
  circular: !0,
  createInternalComparator: function() {
    return Xa;
  }
});
td({
  circular: !0,
  createInternalComparator: function() {
    return Xa;
  },
  strict: !0
});
function td(e) {
  e === void 0 && (e = {});
  var r = e.circular, t = r === void 0 ? !1 : r, i = e.createInternalComparator, n = e.createState, s = e.strict, u = s === void 0 ? !1 : s, o = CTe(e), d = wTe(o), a = i ? i(d) : PTe(d);
  return STe({ circular: t, comparator: d, createState: n, equals: a, strict: u });
}
function MTe(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function AE(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, t = -1, i = function n(s) {
    t < 0 && (t = s), s - t > r ? (e(s), t = -1) : MTe(n);
  };
  requestAnimationFrame(i);
}
function db(e) {
  "@babel/helpers - typeof";
  return db = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, db(e);
}
function TTe(e) {
  return DTe(e) || OTe(e) || kTe(e) || ETe();
}
function ETe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kTe(e, r) {
  if (e) {
    if (typeof e == "string") return wE(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return wE(e, r);
  }
}
function wE(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
function OTe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function DTe(e) {
  if (Array.isArray(e)) return e;
}
function RTe() {
  var e = {}, r = function() {
    return null;
  }, t = !1, i = function n(s) {
    if (!t) {
      if (Array.isArray(s)) {
        if (!s.length)
          return;
        var u = s, o = TTe(u), d = o[0], a = o.slice(1);
        if (typeof d == "number") {
          AE(n.bind(null, a), d);
          return;
        }
        n(d), AE(n.bind(null, a));
        return;
      }
      db(s) === "object" && (e = s, r(e)), typeof s == "function" && s();
    }
  };
  return {
    stop: function() {
      t = !0;
    },
    start: function(s) {
      t = !1, i(s);
    },
    subscribe: function(s) {
      return r = s, function() {
        r = function() {
          return null;
        };
      };
    }
  };
}
function A7(e) {
  "@babel/helpers - typeof";
  return A7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, A7(e);
}
function CE(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function PE(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? CE(Object(t), !0).forEach(function(i) {
      u$(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : CE(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function u$(e, r, t) {
  return r = ITe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function ITe(e) {
  var r = LTe(e, "string");
  return A7(r) === "symbol" ? r : String(r);
}
function LTe(e, r) {
  if (A7(e) !== "object" || e === null) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (A7(i) !== "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
var _Te = function(r, t) {
  return [Object.keys(r), Object.keys(t)].reduce(function(i, n) {
    return i.filter(function(s) {
      return n.includes(s);
    });
  });
}, HTe = function(r) {
  return r;
}, jTe = function(r) {
  return r.replace(/([A-Z])/g, function(t) {
    return "-".concat(t.toLowerCase());
  });
}, Lc = function(r, t) {
  return Object.keys(t).reduce(function(i, n) {
    return PE(PE({}, i), {}, u$({}, n, r(n, t[n])));
  }, {});
}, SE = function(r, t, i) {
  return r.map(function(n) {
    return "".concat(jTe(n), " ").concat(t, "ms ").concat(i);
  }).join(",");
}, zTe = process.env.NODE_ENV !== "production", _X = function(r, t, i, n, s, u, o, d) {
  if (zTe && typeof console < "u" && console.warn && (t === void 0 && console.warn("LogUtils requires an error message argument"), !r))
    if (t === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var a = [i, n, s, u, o, d], V = 0;
      console.warn(t.replace(/%s/g, function() {
        return a[V++];
      }));
    }
};
function BTe(e, r) {
  return UTe(e) || GTe(e, r) || o$(e, r) || WTe();
}
function WTe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function GTe(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var i, n, s, u, o = [], d = !0, a = !1;
    try {
      if (s = (t = t.call(e)).next, r !== 0) for (; !(d = (i = s.call(t)).done) && (o.push(i.value), o.length !== r); d = !0) ;
    } catch (V) {
      a = !0, n = V;
    } finally {
      try {
        if (!d && t.return != null && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (a) throw n;
      }
    }
    return o;
  }
}
function UTe(e) {
  if (Array.isArray(e)) return e;
}
function ZTe(e) {
  return QTe(e) || $Te(e) || o$(e) || JTe();
}
function JTe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function o$(e, r) {
  if (e) {
    if (typeof e == "string") return ab(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return ab(e, r);
  }
}
function $Te(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function QTe(e) {
  if (Array.isArray(e)) return ab(e);
}
function ab(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
var HX = 1e-4, d$ = function(r, t) {
  return [0, 3 * r, 3 * t - 6 * r, 3 * r - 3 * t + 1];
}, a$ = function(r, t) {
  return r.map(function(i, n) {
    return i * Math.pow(t, n);
  }).reduce(function(i, n) {
    return i + n;
  });
}, NE = function(r, t) {
  return function(i) {
    var n = d$(r, t);
    return a$(n, i);
  };
}, eEe = function(r, t) {
  return function(i) {
    var n = d$(r, t), s = [].concat(ZTe(n.map(function(u, o) {
      return u * o;
    }).slice(1)), [0]);
    return a$(s, i);
  };
}, ME = function() {
  for (var r = arguments.length, t = new Array(r), i = 0; i < r; i++)
    t[i] = arguments[i];
  var n = t[0], s = t[1], u = t[2], o = t[3];
  if (t.length === 1)
    switch (t[0]) {
      case "linear":
        n = 0, s = 0, u = 1, o = 1;
        break;
      case "ease":
        n = 0.25, s = 0.1, u = 0.25, o = 1;
        break;
      case "ease-in":
        n = 0.42, s = 0, u = 1, o = 1;
        break;
      case "ease-out":
        n = 0.42, s = 0, u = 0.58, o = 1;
        break;
      case "ease-in-out":
        n = 0, s = 0, u = 0.58, o = 1;
        break;
      default: {
        var d = t[0].split("(");
        if (d[0] === "cubic-bezier" && d[1].split(")")[0].split(",").length === 4) {
          var a = d[1].split(")")[0].split(",").map(function(f) {
            return parseFloat(f);
          }), V = BTe(a, 4);
          n = V[0], s = V[1], u = V[2], o = V[3];
        } else
          _X(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", t);
      }
    }
  _X([n, u, s, o].every(function(f) {
    return typeof f == "number" && f >= 0 && f <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", t);
  var c = NE(n, u), F = NE(s, o), X = eEe(n, u), Y = function(p) {
    return p > 1 ? 1 : p < 0 ? 0 : p;
  }, q = function(p) {
    for (var m = p > 1 ? 1 : p, g = m, y = 0; y < 8; ++y) {
      var b = c(g) - m, A = X(g);
      if (Math.abs(b - m) < HX || A < HX)
        return F(g);
      g = Y(g - b / A);
    }
    return F(g);
  };
  return q.isStepper = !1, q;
}, rEe = function() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = r.stiff, i = t === void 0 ? 100 : t, n = r.damping, s = n === void 0 ? 8 : n, u = r.dt, o = u === void 0 ? 17 : u, d = function(V, c, F) {
    var X = -(V - c) * i, Y = F * s, q = F + (X - Y) * o / 1e3, f = F * o / 1e3 + V;
    return Math.abs(f - c) < HX && Math.abs(q) < HX ? [c, 0] : [f, q];
  };
  return d.isStepper = !0, d.dt = o, d;
}, tEe = function() {
  for (var r = arguments.length, t = new Array(r), i = 0; i < r; i++)
    t[i] = arguments[i];
  var n = t[0];
  if (typeof n == "string")
    switch (n) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return ME(n);
      case "spring":
        return rEe();
      default:
        if (n.split("(")[0] === "cubic-bezier")
          return ME(n);
        _X(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", t);
    }
  return typeof n == "function" ? n : (_X(!1, "[configEasing]: first argument type should be function or string, instead received %s", t), null);
};
function w7(e) {
  "@babel/helpers - typeof";
  return w7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, w7(e);
}
function TE(e) {
  return sEe(e) || nEe(e) || V$(e) || iEe();
}
function iEe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nEe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function sEe(e) {
  if (Array.isArray(e)) return lb(e);
}
function EE(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function Jt(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? EE(Object(t), !0).forEach(function(i) {
      Vb(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EE(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function Vb(e, r, t) {
  return r = uEe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function uEe(e) {
  var r = oEe(e, "string");
  return w7(r) === "symbol" ? r : String(r);
}
function oEe(e, r) {
  if (w7(e) !== "object" || e === null) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (w7(i) !== "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function dEe(e, r) {
  return lEe(e) || VEe(e, r) || V$(e, r) || aEe();
}
function aEe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function V$(e, r) {
  if (e) {
    if (typeof e == "string") return lb(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return lb(e, r);
  }
}
function lb(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
function VEe(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var i, n, s, u, o = [], d = !0, a = !1;
    try {
      if (s = (t = t.call(e)).next, r !== 0) for (; !(d = (i = s.call(t)).done) && (o.push(i.value), o.length !== r); d = !0) ;
    } catch (V) {
      a = !0, n = V;
    } finally {
      try {
        if (!d && t.return != null && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (a) throw n;
      }
    }
    return o;
  }
}
function lEe(e) {
  if (Array.isArray(e)) return e;
}
var jX = function(r, t, i) {
  return r + (t - r) * i;
}, cb = function(r) {
  var t = r.from, i = r.to;
  return t !== i;
}, cEe = function e(r, t, i) {
  var n = Lc(function(s, u) {
    if (cb(u)) {
      var o = r(u.from, u.to, u.velocity), d = dEe(o, 2), a = d[0], V = d[1];
      return Jt(Jt({}, u), {}, {
        from: a,
        velocity: V
      });
    }
    return u;
  }, t);
  return i < 1 ? Lc(function(s, u) {
    return cb(u) ? Jt(Jt({}, u), {}, {
      velocity: jX(u.velocity, n[s].velocity, i),
      from: jX(u.from, n[s].from, i)
    }) : u;
  }, t) : e(r, n, i - 1);
};
const FEe = function(e, r, t, i, n) {
  var s = _Te(e, r), u = s.reduce(function(f, p) {
    return Jt(Jt({}, f), {}, Vb({}, p, [e[p], r[p]]));
  }, {}), o = s.reduce(function(f, p) {
    return Jt(Jt({}, f), {}, Vb({}, p, {
      from: e[p],
      velocity: 0,
      to: r[p]
    }));
  }, {}), d = -1, a, V, c = function() {
    return null;
  }, F = function() {
    return Lc(function(p, m) {
      return m.from;
    }, o);
  }, X = function() {
    return !Object.values(o).filter(cb).length;
  }, Y = function(p) {
    a || (a = p);
    var m = p - a, g = m / t.dt;
    o = cEe(t, o, g), n(Jt(Jt(Jt({}, e), r), F())), a = p, X() || (d = requestAnimationFrame(c));
  }, q = function(p) {
    V || (V = p);
    var m = (p - V) / i, g = Lc(function(b, A) {
      return jX.apply(void 0, TE(A).concat([t(m)]));
    }, u);
    if (n(Jt(Jt(Jt({}, e), r), g)), m < 1)
      d = requestAnimationFrame(c);
    else {
      var y = Lc(function(b, A) {
        return jX.apply(void 0, TE(A).concat([t(1)]));
      }, u);
      n(Jt(Jt(Jt({}, e), r), y));
    }
  };
  return c = t.isStepper ? Y : q, function() {
    return requestAnimationFrame(c), function() {
      cancelAnimationFrame(d);
    };
  };
};
function BV(e) {
  "@babel/helpers - typeof";
  return BV = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, BV(e);
}
var xEe = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function XEe(e, r) {
  if (e == null) return {};
  var t = qEe(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function qEe(e, r) {
  if (e == null) return {};
  var t = {}, i = Object.keys(e), n, s;
  for (s = 0; s < i.length; s++)
    n = i[s], !(r.indexOf(n) >= 0) && (t[n] = e[n]);
  return t;
}
function Wm(e) {
  return hEe(e) || KEe(e) || fEe(e) || YEe();
}
function YEe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fEe(e, r) {
  if (e) {
    if (typeof e == "string") return Fb(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Fb(e, r);
  }
}
function KEe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function hEe(e) {
  if (Array.isArray(e)) return Fb(e);
}
function Fb(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
function kE(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function Zn(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? kE(Object(t), !0).forEach(function(i) {
      Pc(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : kE(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function Pc(e, r, t) {
  return r = l$(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function pEe(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function mEe(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, l$(i.key), i);
  }
}
function gEe(e, r, t) {
  return r && mEe(e.prototype, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function l$(e) {
  var r = vEe(e, "string");
  return BV(r) === "symbol" ? r : String(r);
}
function vEe(e, r) {
  if (BV(e) !== "object" || e === null) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (BV(i) !== "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function bEe(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && xb(e, r);
}
function xb(e, r) {
  return xb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, xb(e, r);
}
function yEe(e) {
  var r = AEe();
  return function() {
    var i = zX(e), n;
    if (r) {
      var s = zX(this).constructor;
      n = Reflect.construct(i, arguments, s);
    } else
      n = i.apply(this, arguments);
    return Xb(this, n);
  };
}
function Xb(e, r) {
  if (r && (BV(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return qb(e);
}
function qb(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function AEe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function zX(e) {
  return zX = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, zX(e);
}
var _u = /* @__PURE__ */ function(e) {
  bEe(t, e);
  var r = yEe(t);
  function t(i, n) {
    var s;
    pEe(this, t), s = r.call(this, i, n);
    var u = s.props, o = u.isActive, d = u.attributeName, a = u.from, V = u.to, c = u.steps, F = u.children, X = u.duration;
    if (s.handleStyleChange = s.handleStyleChange.bind(qb(s)), s.changeStyle = s.changeStyle.bind(qb(s)), !o || X <= 0)
      return s.state = {
        style: {}
      }, typeof F == "function" && (s.state = {
        style: V
      }), Xb(s);
    if (c && c.length)
      s.state = {
        style: c[0].style
      };
    else if (a) {
      if (typeof F == "function")
        return s.state = {
          style: a
        }, Xb(s);
      s.state = {
        style: d ? Pc({}, d, a) : a
      };
    } else
      s.state = {
        style: {}
      };
    return s;
  }
  return gEe(t, [{
    key: "componentDidMount",
    value: function() {
      var n = this.props, s = n.isActive, u = n.canBegin;
      this.mounted = !0, !(!s || !u) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(n) {
      var s = this.props, u = s.isActive, o = s.canBegin, d = s.attributeName, a = s.shouldReAnimate, V = s.to, c = s.from, F = this.state.style;
      if (o) {
        if (!u) {
          var X = {
            style: d ? Pc({}, d, V) : V
          };
          this.state && F && (d && F[d] !== V || !d && F !== V) && this.setState(X);
          return;
        }
        if (!(NTe(n.to, V) && n.canBegin && n.isActive)) {
          var Y = !n.canBegin || !n.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var q = Y || a ? c : n.to;
          if (this.state && F) {
            var f = {
              style: d ? Pc({}, d, q) : q
            };
            (d && F[d] !== q || !d && F !== q) && this.setState(f);
          }
          this.runAnimation(Zn(Zn({}, this.props), {}, {
            from: q,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var n = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), n && n();
    }
  }, {
    key: "handleStyleChange",
    value: function(n) {
      this.changeStyle(n);
    }
  }, {
    key: "changeStyle",
    value: function(n) {
      this.mounted && this.setState({
        style: n
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(n) {
      var s = this, u = n.from, o = n.to, d = n.duration, a = n.easing, V = n.begin, c = n.onAnimationEnd, F = n.onAnimationStart, X = FEe(u, o, tEe(a), d, this.changeStyle), Y = function() {
        s.stopJSAnimation = X();
      };
      this.manager.start([F, V, Y, d, c]);
    }
  }, {
    key: "runStepAnimation",
    value: function(n) {
      var s = this, u = n.steps, o = n.begin, d = n.onAnimationStart, a = u[0], V = a.style, c = a.duration, F = c === void 0 ? 0 : c, X = function(q, f, p) {
        if (p === 0)
          return q;
        var m = f.duration, g = f.easing, y = g === void 0 ? "ease" : g, b = f.style, A = f.properties, w = f.onAnimationEnd, S = p > 0 ? u[p - 1] : f, N = A || Object.keys(b);
        if (typeof y == "function" || y === "spring")
          return [].concat(Wm(q), [s.runJSAnimation.bind(s, {
            from: S.style,
            to: b,
            duration: m,
            easing: y
          }), m]);
        var O = SE(N, m, y), E = Zn(Zn(Zn({}, S.style), b), {}, {
          transition: O
        });
        return [].concat(Wm(q), [E, m, w]).filter(HTe);
      };
      return this.manager.start([d].concat(Wm(u.reduce(X, [V, Math.max(F, o)])), [n.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(n) {
      this.manager || (this.manager = RTe());
      var s = n.begin, u = n.duration, o = n.attributeName, d = n.to, a = n.easing, V = n.onAnimationStart, c = n.onAnimationEnd, F = n.steps, X = n.children, Y = this.manager;
      if (this.unSubscribe = Y.subscribe(this.handleStyleChange), typeof a == "function" || typeof X == "function" || a === "spring") {
        this.runJSAnimation(n);
        return;
      }
      if (F.length > 1) {
        this.runStepAnimation(n);
        return;
      }
      var q = o ? Pc({}, o, d) : d, f = SE(Object.keys(q), u, a);
      Y.start([V, s, Zn(Zn({}, q), {}, {
        transition: f
      }), u, c]);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, s = n.children;
      n.begin;
      var u = n.duration;
      n.attributeName, n.easing;
      var o = n.isActive;
      n.steps, n.from, n.to, n.canBegin, n.onAnimationEnd, n.shouldReAnimate, n.onAnimationReStart;
      var d = XEe(n, xEe), a = Hi.count(s), V = this.state.style;
      if (typeof s == "function")
        return s(V);
      if (!o || a === 0 || u <= 0)
        return s;
      var c = function(X) {
        var Y = X.props, q = Y.style, f = q === void 0 ? {} : q, p = Y.className, m = /* @__PURE__ */ at(X, Zn(Zn({}, d), {}, {
          style: Zn(Zn({}, f), V),
          className: p
        }));
        return m;
      };
      return a === 1 ? c(Hi.only(s)) : /* @__PURE__ */ D.createElement("div", null, Hi.map(s, function(F) {
        return c(F);
      }));
    }
  }]), t;
}(Gs);
_u.displayName = "Animate";
_u.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
_u.propTypes = {
  from: gr.oneOfType([gr.object, gr.string]),
  to: gr.oneOfType([gr.object, gr.string]),
  attributeName: gr.string,
  // animation duration
  duration: gr.number,
  begin: gr.number,
  easing: gr.oneOfType([gr.string, gr.func]),
  steps: gr.arrayOf(gr.shape({
    duration: gr.number.isRequired,
    style: gr.object.isRequired,
    easing: gr.oneOfType([gr.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), gr.func]),
    // transition css properties(dash case), optional
    properties: gr.arrayOf("string"),
    onAnimationEnd: gr.func
  })),
  children: gr.oneOfType([gr.node, gr.func]),
  isActive: gr.bool,
  canBegin: gr.bool,
  onAnimationEnd: gr.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: gr.bool,
  onAnimationStart: gr.func,
  onAnimationReStart: gr.func
};
function C7(e) {
  "@babel/helpers - typeof";
  return C7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, C7(e);
}
function BX() {
  return BX = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, BX.apply(this, arguments);
}
function wEe(e, r) {
  return NEe(e) || SEe(e, r) || PEe(e, r) || CEe();
}
function CEe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function PEe(e, r) {
  if (e) {
    if (typeof e == "string") return OE(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return OE(e, r);
  }
}
function OE(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
function SEe(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var i, n, s, u, o = [], d = !0, a = !1;
    try {
      if (s = (t = t.call(e)).next, r !== 0) for (; !(d = (i = s.call(t)).done) && (o.push(i.value), o.length !== r); d = !0) ;
    } catch (V) {
      a = !0, n = V;
    } finally {
      try {
        if (!d && t.return != null && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (a) throw n;
      }
    }
    return o;
  }
}
function NEe(e) {
  if (Array.isArray(e)) return e;
}
function DE(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function RE(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? DE(Object(t), !0).forEach(function(i) {
      MEe(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DE(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function MEe(e, r, t) {
  return r = TEe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function TEe(e) {
  var r = EEe(e, "string");
  return C7(r) == "symbol" ? r : r + "";
}
function EEe(e, r) {
  if (C7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (C7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
var IE = function(r, t, i, n, s) {
  var u = Math.min(Math.abs(i) / 2, Math.abs(n) / 2), o = n >= 0 ? 1 : -1, d = i >= 0 ? 1 : -1, a = n >= 0 && i >= 0 || n < 0 && i < 0 ? 1 : 0, V;
  if (u > 0 && s instanceof Array) {
    for (var c = [0, 0, 0, 0], F = 0, X = 4; F < X; F++)
      c[F] = s[F] > u ? u : s[F];
    V = "M".concat(r, ",").concat(t + o * c[0]), c[0] > 0 && (V += "A ".concat(c[0], ",").concat(c[0], ",0,0,").concat(a, ",").concat(r + d * c[0], ",").concat(t)), V += "L ".concat(r + i - d * c[1], ",").concat(t), c[1] > 0 && (V += "A ".concat(c[1], ",").concat(c[1], ",0,0,").concat(a, `,
        `).concat(r + i, ",").concat(t + o * c[1])), V += "L ".concat(r + i, ",").concat(t + n - o * c[2]), c[2] > 0 && (V += "A ".concat(c[2], ",").concat(c[2], ",0,0,").concat(a, `,
        `).concat(r + i - d * c[2], ",").concat(t + n)), V += "L ".concat(r + d * c[3], ",").concat(t + n), c[3] > 0 && (V += "A ".concat(c[3], ",").concat(c[3], ",0,0,").concat(a, `,
        `).concat(r, ",").concat(t + n - o * c[3])), V += "Z";
  } else if (u > 0 && s === +s && s > 0) {
    var Y = Math.min(u, s);
    V = "M ".concat(r, ",").concat(t + o * Y, `
            A `).concat(Y, ",").concat(Y, ",0,0,").concat(a, ",").concat(r + d * Y, ",").concat(t, `
            L `).concat(r + i - d * Y, ",").concat(t, `
            A `).concat(Y, ",").concat(Y, ",0,0,").concat(a, ",").concat(r + i, ",").concat(t + o * Y, `
            L `).concat(r + i, ",").concat(t + n - o * Y, `
            A `).concat(Y, ",").concat(Y, ",0,0,").concat(a, ",").concat(r + i - d * Y, ",").concat(t + n, `
            L `).concat(r + d * Y, ",").concat(t + n, `
            A `).concat(Y, ",").concat(Y, ",0,0,").concat(a, ",").concat(r, ",").concat(t + n - o * Y, " Z");
  } else
    V = "M ".concat(r, ",").concat(t, " h ").concat(i, " v ").concat(n, " h ").concat(-i, " Z");
  return V;
}, kEe = function(r, t) {
  if (!r || !t)
    return !1;
  var i = r.x, n = r.y, s = t.x, u = t.y, o = t.width, d = t.height;
  if (Math.abs(o) > 0 && Math.abs(d) > 0) {
    var a = Math.min(s, s + o), V = Math.max(s, s + o), c = Math.min(u, u + d), F = Math.max(u, u + d);
    return i >= a && i <= V && n >= c && n <= F;
  }
  return !1;
}, OEe = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, K4 = function(r) {
  var t = RE(RE({}, OEe), r), i = Yr(), n = ie(-1), s = wEe(n, 2), u = s[0], o = s[1];
  Pe(function() {
    if (i.current && i.current.getTotalLength)
      try {
        var y = i.current.getTotalLength();
        y && o(y);
      } catch {
      }
  }, []);
  var d = t.x, a = t.y, V = t.width, c = t.height, F = t.radius, X = t.className, Y = t.animationEasing, q = t.animationDuration, f = t.animationBegin, p = t.isAnimationActive, m = t.isUpdateAnimationActive;
  if (d !== +d || a !== +a || V !== +V || c !== +c || V === 0 || c === 0)
    return null;
  var g = ur("recharts-rectangle", X);
  return m ? /* @__PURE__ */ D.createElement(_u, {
    canBegin: u > 0,
    from: {
      width: V,
      height: c,
      x: d,
      y: a
    },
    to: {
      width: V,
      height: c,
      x: d,
      y: a
    },
    duration: q,
    animationEasing: Y,
    isActive: m
  }, function(y) {
    var b = y.width, A = y.height, w = y.x, S = y.y;
    return /* @__PURE__ */ D.createElement(_u, {
      canBegin: u > 0,
      from: "0px ".concat(u === -1 ? 1 : u, "px"),
      to: "".concat(u, "px 0px"),
      attributeName: "strokeDasharray",
      begin: f,
      duration: q,
      isActive: p,
      easing: Y
    }, /* @__PURE__ */ D.createElement("path", BX({}, _e(t, !0), {
      className: g,
      d: IE(w, S, b, A, F),
      ref: i
    })));
  }) : /* @__PURE__ */ D.createElement("path", BX({}, _e(t, !0), {
    className: g,
    d: IE(d, a, V, c, F)
  }));
}, DEe = ["points", "className", "baseLinePoints", "connectNulls"];
function iV() {
  return iV = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, iV.apply(this, arguments);
}
function REe(e, r) {
  if (e == null) return {};
  var t = IEe(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function IEe(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
function LE(e) {
  return jEe(e) || HEe(e) || _Ee(e) || LEe();
}
function LEe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _Ee(e, r) {
  if (e) {
    if (typeof e == "string") return Yb(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Yb(e, r);
  }
}
function HEe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function jEe(e) {
  if (Array.isArray(e)) return Yb(e);
}
function Yb(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
var _E = function(r) {
  return r && r.x === +r.x && r.y === +r.y;
}, zEe = function() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = [[]];
  return r.forEach(function(i) {
    _E(i) ? t[t.length - 1].push(i) : t[t.length - 1].length > 0 && t.push([]);
  }), _E(r[0]) && t[t.length - 1].push(r[0]), t[t.length - 1].length <= 0 && (t = t.slice(0, -1)), t;
}, _c = function(r, t) {
  var i = zEe(r);
  t && (i = [i.reduce(function(s, u) {
    return [].concat(LE(s), LE(u));
  }, [])]);
  var n = i.map(function(s) {
    return s.reduce(function(u, o, d) {
      return "".concat(u).concat(d === 0 ? "M" : "L").concat(o.x, ",").concat(o.y);
    }, "");
  }).join("");
  return i.length === 1 ? "".concat(n, "Z") : n;
}, BEe = function(r, t, i) {
  var n = _c(r, i);
  return "".concat(n.slice(-1) === "Z" ? n.slice(0, -1) : n, "L").concat(_c(t.reverse(), i).slice(1));
}, c$ = function(r) {
  var t = r.points, i = r.className, n = r.baseLinePoints, s = r.connectNulls, u = REe(r, DEe);
  if (!t || !t.length)
    return null;
  var o = ur("recharts-polygon", i);
  if (n && n.length) {
    var d = u.stroke && u.stroke !== "none", a = BEe(t, n, s);
    return /* @__PURE__ */ D.createElement("g", {
      className: o
    }, /* @__PURE__ */ D.createElement("path", iV({}, _e(u, !0), {
      fill: a.slice(-1) === "Z" ? u.fill : "none",
      stroke: "none",
      d: a
    })), d ? /* @__PURE__ */ D.createElement("path", iV({}, _e(u, !0), {
      fill: "none",
      d: _c(t, s)
    })) : null, d ? /* @__PURE__ */ D.createElement("path", iV({}, _e(u, !0), {
      fill: "none",
      d: _c(n, s)
    })) : null);
  }
  var V = _c(t, s);
  return /* @__PURE__ */ D.createElement("path", iV({}, _e(u, !0), {
    fill: V.slice(-1) === "Z" ? u.fill : "none",
    className: o,
    d: V
  }));
};
function fb() {
  return fb = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, fb.apply(this, arguments);
}
var pf = function(r) {
  var t = r.cx, i = r.cy, n = r.r, s = r.className, u = ur("recharts-dot", s);
  return t === +t && i === +i && n === +n ? /* @__PURE__ */ D.createElement("circle", fb({}, _e(r, !1), XX(r), {
    className: u,
    cx: t,
    cy: i,
    r: n
  })) : null;
};
function P7(e) {
  "@babel/helpers - typeof";
  return P7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, P7(e);
}
var WEe = ["x", "y", "top", "left", "width", "height", "className"];
function Kb() {
  return Kb = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Kb.apply(this, arguments);
}
function HE(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function GEe(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? HE(Object(t), !0).forEach(function(i) {
      UEe(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : HE(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function UEe(e, r, t) {
  return r = ZEe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function ZEe(e) {
  var r = JEe(e, "string");
  return P7(r) == "symbol" ? r : r + "";
}
function JEe(e, r) {
  if (P7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (P7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function $Ee(e, r) {
  if (e == null) return {};
  var t = QEe(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function QEe(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
var eke = function(r, t, i, n, s, u) {
  return "M".concat(r, ",").concat(s, "v").concat(n, "M").concat(u, ",").concat(t, "h").concat(i);
}, rke = function(r) {
  var t = r.x, i = t === void 0 ? 0 : t, n = r.y, s = n === void 0 ? 0 : n, u = r.top, o = u === void 0 ? 0 : u, d = r.left, a = d === void 0 ? 0 : d, V = r.width, c = V === void 0 ? 0 : V, F = r.height, X = F === void 0 ? 0 : F, Y = r.className, q = $Ee(r, WEe), f = GEe({
    x: i,
    y: s,
    top: o,
    left: a,
    width: c,
    height: X
  }, q);
  return !pe(i) || !pe(s) || !pe(c) || !pe(X) || !pe(o) || !pe(a) ? null : /* @__PURE__ */ D.createElement("path", Kb({}, _e(f, !0), {
    className: ur("recharts-cross", Y),
    d: eke(i, s, c, X, o, a)
  }));
}, tke = ["cx", "cy", "innerRadius", "outerRadius", "gridType", "radialLines"];
function S7(e) {
  "@babel/helpers - typeof";
  return S7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, S7(e);
}
function ike(e, r) {
  if (e == null) return {};
  var t = nke(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function nke(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
function Hu() {
  return Hu = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Hu.apply(this, arguments);
}
function jE(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function N7(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? jE(Object(t), !0).forEach(function(i) {
      ske(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : jE(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function ske(e, r, t) {
  return r = uke(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function uke(e) {
  var r = oke(e, "string");
  return S7(r) == "symbol" ? r : r + "";
}
function oke(e, r) {
  if (S7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (S7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
var dke = function(r, t, i, n) {
  var s = "";
  return n.forEach(function(u, o) {
    var d = kr(t, i, r, u);
    o ? s += "L ".concat(d.x, ",").concat(d.y) : s += "M ".concat(d.x, ",").concat(d.y);
  }), s += "Z", s;
}, ake = function(r) {
  var t = r.cx, i = r.cy, n = r.innerRadius, s = r.outerRadius, u = r.polarAngles, o = r.radialLines;
  if (!u || !u.length || !o)
    return null;
  var d = N7({
    stroke: "#ccc"
  }, _e(r, !1));
  return /* @__PURE__ */ D.createElement("g", {
    className: "recharts-polar-grid-angle"
  }, u.map(function(a) {
    var V = kr(t, i, n, a), c = kr(t, i, s, a);
    return /* @__PURE__ */ D.createElement("line", Hu({}, d, {
      key: "line-".concat(a),
      x1: V.x,
      y1: V.y,
      x2: c.x,
      y2: c.y
    }));
  }));
}, Vke = function(r) {
  var t = r.cx, i = r.cy, n = r.radius, s = r.index, u = N7(N7({
    stroke: "#ccc"
  }, _e(r, !1)), {}, {
    fill: "none"
  });
  return /* @__PURE__ */ D.createElement("circle", Hu({}, u, {
    className: ur("recharts-polar-grid-concentric-circle", r.className),
    key: "circle-".concat(s),
    cx: t,
    cy: i,
    r: n
  }));
}, lke = function(r) {
  var t = r.radius, i = r.index, n = N7(N7({
    stroke: "#ccc"
  }, _e(r, !1)), {}, {
    fill: "none"
  });
  return /* @__PURE__ */ D.createElement("path", Hu({}, n, {
    className: ur("recharts-polar-grid-concentric-polygon", r.className),
    key: "path-".concat(i),
    d: dke(t, r.cx, r.cy, r.polarAngles)
  }));
}, cke = function(r) {
  var t = r.polarRadius, i = r.gridType;
  return !t || !t.length ? null : /* @__PURE__ */ D.createElement("g", {
    className: "recharts-polar-grid-concentric"
  }, t.map(function(n, s) {
    var u = s;
    return i === "circle" ? /* @__PURE__ */ D.createElement(Vke, Hu({
      key: u
    }, r, {
      radius: n,
      index: s
    })) : /* @__PURE__ */ D.createElement(lke, Hu({
      key: u
    }, r, {
      radius: n,
      index: s
    }));
  }));
}, h4 = function(r) {
  var t = r.cx, i = t === void 0 ? 0 : t, n = r.cy, s = n === void 0 ? 0 : n, u = r.innerRadius, o = u === void 0 ? 0 : u, d = r.outerRadius, a = d === void 0 ? 0 : d, V = r.gridType, c = V === void 0 ? "polygon" : V, F = r.radialLines, X = F === void 0 ? !0 : F, Y = ike(r, tke);
  return a <= 0 ? null : /* @__PURE__ */ D.createElement("g", {
    className: "recharts-polar-grid"
  }, /* @__PURE__ */ D.createElement(ake, Hu({
    cx: i,
    cy: s,
    innerRadius: o,
    outerRadius: a,
    gridType: c,
    radialLines: X
  }, Y)), /* @__PURE__ */ D.createElement(cke, Hu({
    cx: i,
    cy: s,
    innerRadius: o,
    outerRadius: a,
    gridType: c,
    radialLines: X
  }, Y)));
};
h4.displayName = "PolarGrid";
var Gm, zE;
function Fke() {
  if (zE) return Gm;
  zE = 1;
  var e = xf(), r = yJ(), t = ru();
  function i(n, s) {
    return n && n.length ? e(n, t(s, 2), r) : void 0;
  }
  return Gm = i, Gm;
}
var xke = Fke();
const Xke = /* @__PURE__ */ Mr(xke);
var Um, BE;
function qke() {
  if (BE) return Um;
  BE = 1;
  var e = xf(), r = ru(), t = AJ();
  function i(n, s) {
    return n && n.length ? e(n, r(s, 2), t) : void 0;
  }
  return Um = i, Um;
}
var Yke = qke();
const fke = /* @__PURE__ */ Mr(Yke);
var Kke = ["cx", "cy", "angle", "ticks", "axisLine"], hke = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function WV(e) {
  "@babel/helpers - typeof";
  return WV = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, WV(e);
}
function Hc() {
  return Hc = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Hc.apply(this, arguments);
}
function WE(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function qd(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? WE(Object(t), !0).forEach(function(i) {
      mf(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WE(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function GE(e, r) {
  if (e == null) return {};
  var t = pke(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function pke(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
function mke(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function UE(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, x$(i.key), i);
  }
}
function gke(e, r, t) {
  return r && UE(e.prototype, r), t && UE(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function vke(e, r, t) {
  return r = WX(r), bke(e, F$() ? Reflect.construct(r, t || [], WX(e).constructor) : r.apply(e, t));
}
function bke(e, r) {
  if (r && (WV(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return yke(e);
}
function yke(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function F$() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (F$ = function() {
    return !!e;
  })();
}
function WX(e) {
  return WX = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, WX(e);
}
function Ake(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && hb(e, r);
}
function hb(e, r) {
  return hb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, hb(e, r);
}
function mf(e, r, t) {
  return r = x$(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function x$(e) {
  var r = wke(e, "string");
  return WV(r) == "symbol" ? r : r + "";
}
function wke(e, r) {
  if (WV(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (WV(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var gf = /* @__PURE__ */ function(e) {
  function r() {
    return mke(this, r), vke(this, r, arguments);
  }
  return Ake(r, e), gke(r, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function(i) {
        var n = i.coordinate, s = this.props, u = s.angle, o = s.cx, d = s.cy;
        return kr(o, d, n, u);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var i = this.props.orientation, n;
      switch (i) {
        case "left":
          n = "end";
          break;
        case "right":
          n = "start";
          break;
        default:
          n = "middle";
          break;
      }
      return n;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var i = this.props, n = i.cx, s = i.cy, u = i.angle, o = i.ticks, d = Xke(o, function(V) {
        return V.coordinate || 0;
      }), a = fke(o, function(V) {
        return V.coordinate || 0;
      });
      return {
        cx: n,
        cy: s,
        startAngle: u,
        endAngle: u,
        innerRadius: a.coordinate || 0,
        outerRadius: d.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var i = this.props, n = i.cx, s = i.cy, u = i.angle, o = i.ticks, d = i.axisLine, a = GE(i, Kke), V = o.reduce(function(Y, q) {
        return [Math.min(Y[0], q.coordinate), Math.max(Y[1], q.coordinate)];
      }, [1 / 0, -1 / 0]), c = kr(n, s, V[0], u), F = kr(n, s, V[1], u), X = qd(qd(qd({}, _e(a, !1)), {}, {
        fill: "none"
      }, _e(d, !1)), {}, {
        x1: c.x,
        y1: c.y,
        x2: F.x,
        y2: F.y
      });
      return /* @__PURE__ */ D.createElement("line", Hc({
        className: "recharts-polar-radius-axis-line"
      }, X));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var i = this, n = this.props, s = n.ticks, u = n.tick, o = n.angle, d = n.tickFormatter, a = n.stroke, V = GE(n, hke), c = this.getTickTextAnchor(), F = _e(V, !1), X = _e(u, !1), Y = s.map(function(q, f) {
        var p = i.getTickValueCoord(q), m = qd(qd(qd(qd({
          textAnchor: c,
          transform: "rotate(".concat(90 - o, ", ").concat(p.x, ", ").concat(p.y, ")")
        }, F), {}, {
          stroke: "none",
          fill: a
        }, X), {}, {
          index: f
        }, p), {}, {
          payload: q
        });
        return /* @__PURE__ */ D.createElement(Hr, Hc({
          className: ur("recharts-polar-radius-axis-tick", e$(u)),
          key: "tick-".concat(q.coordinate)
        }, EV(i.props, q, f)), r.renderTickItem(u, m, d ? d(q.value, f) : q.value));
      });
      return /* @__PURE__ */ D.createElement(Hr, {
        className: "recharts-polar-radius-axis-ticks"
      }, Y);
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, n = i.ticks, s = i.axisLine, u = i.tick;
      return !n || !n.length ? null : /* @__PURE__ */ D.createElement(Hr, {
        className: ur("recharts-polar-radius-axis", this.props.className)
      }, s && this.renderAxisLine(), u && this.renderTicks(), Qt.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function(i, n, s) {
      var u;
      return /* @__PURE__ */ D.isValidElement(i) ? u = /* @__PURE__ */ D.cloneElement(i, n) : Ue(i) ? u = i(n) : u = /* @__PURE__ */ D.createElement(LV, Hc({}, n, {
        className: "recharts-polar-radius-axis-tick-value"
      }), s), u;
    }
  }]);
}(Gs);
mf(gf, "displayName", "PolarRadiusAxis");
mf(gf, "axisType", "radiusAxis");
mf(gf, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function GV(e) {
  "@babel/helpers - typeof";
  return GV = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, GV(e);
}
function md() {
  return md = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, md.apply(this, arguments);
}
function ZE(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function Yd(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ZE(Object(t), !0).forEach(function(i) {
      vf(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ZE(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function Cke(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function JE(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, q$(i.key), i);
  }
}
function Pke(e, r, t) {
  return r && JE(e.prototype, r), t && JE(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Ske(e, r, t) {
  return r = GX(r), Nke(e, X$() ? Reflect.construct(r, t || [], GX(e).constructor) : r.apply(e, t));
}
function Nke(e, r) {
  if (r && (GV(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Mke(e);
}
function Mke(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function X$() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (X$ = function() {
    return !!e;
  })();
}
function GX(e) {
  return GX = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, GX(e);
}
function Tke(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && pb(e, r);
}
function pb(e, r) {
  return pb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, pb(e, r);
}
function vf(e, r, t) {
  return r = q$(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function q$(e) {
  var r = Eke(e, "string");
  return GV(r) == "symbol" ? r : r + "";
}
function Eke(e, r) {
  if (GV(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (GV(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var kke = Math.PI / 180, Oke = 1e-5, Ol = /* @__PURE__ */ function(e) {
  function r() {
    return Cke(this, r), Ske(this, r, arguments);
  }
  return Tke(r, e), Pke(r, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(i) {
        var n = this.props, s = n.cx, u = n.cy, o = n.radius, d = n.orientation, a = n.tickSize, V = a || 8, c = kr(s, u, o, i.coordinate), F = kr(s, u, o + (d === "inner" ? -1 : 1) * V, i.coordinate);
        return {
          x1: c.x,
          y1: c.y,
          x2: F.x,
          y2: F.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(i) {
      var n = this.props.orientation, s = Math.cos(-i.coordinate * kke), u;
      return s > Oke ? u = n === "outer" ? "start" : "end" : s < -1e-5 ? u = n === "outer" ? "end" : "start" : u = "middle", u;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var i = this.props, n = i.cx, s = i.cy, u = i.radius, o = i.axisLine, d = i.axisLineType, a = Yd(Yd({}, _e(this.props, !1)), {}, {
        fill: "none"
      }, _e(o, !1));
      if (d === "circle")
        return /* @__PURE__ */ D.createElement(pf, md({
          className: "recharts-polar-angle-axis-line"
        }, a, {
          cx: n,
          cy: s,
          r: u
        }));
      var V = this.props.ticks, c = V.map(function(F) {
        return kr(n, s, u, F.coordinate);
      });
      return /* @__PURE__ */ D.createElement(c$, md({
        className: "recharts-polar-angle-axis-line"
      }, a, {
        points: c
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var i = this, n = this.props, s = n.ticks, u = n.tick, o = n.tickLine, d = n.tickFormatter, a = n.stroke, V = _e(this.props, !1), c = _e(u, !1), F = Yd(Yd({}, V), {}, {
        fill: "none"
      }, _e(o, !1)), X = s.map(function(Y, q) {
        var f = i.getTickLineCoord(Y), p = i.getTickTextAnchor(Y), m = Yd(Yd(Yd({
          textAnchor: p
        }, V), {}, {
          stroke: "none",
          fill: a
        }, c), {}, {
          index: q,
          payload: Y,
          x: f.x2,
          y: f.y2
        });
        return /* @__PURE__ */ D.createElement(Hr, md({
          className: ur("recharts-polar-angle-axis-tick", e$(u)),
          key: "tick-".concat(Y.coordinate)
        }, EV(i.props, Y, q)), o && /* @__PURE__ */ D.createElement("line", md({
          className: "recharts-polar-angle-axis-tick-line"
        }, F, f)), u && r.renderTickItem(u, m, d ? d(Y.value, q) : Y.value));
      });
      return /* @__PURE__ */ D.createElement(Hr, {
        className: "recharts-polar-angle-axis-ticks"
      }, X);
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, n = i.ticks, s = i.radius, u = i.axisLine;
      return s <= 0 || !n || !n.length ? null : /* @__PURE__ */ D.createElement(Hr, {
        className: ur("recharts-polar-angle-axis", this.props.className)
      }, u && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(i, n, s) {
      var u;
      return /* @__PURE__ */ D.isValidElement(i) ? u = /* @__PURE__ */ D.cloneElement(i, n) : Ue(i) ? u = i(n) : u = /* @__PURE__ */ D.createElement(LV, md({}, n, {
        className: "recharts-polar-angle-axis-tick-value"
      }), s), u;
    }
  }]);
}(Gs);
vf(Ol, "displayName", "PolarAngleAxis");
vf(Ol, "axisType", "angleAxis");
vf(Ol, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var Zm, $E;
function Dke() {
  if ($E) return Zm;
  $E = 1;
  var e = vZ(), r = e(Object.getPrototypeOf, Object);
  return Zm = r, Zm;
}
var Jm, QE;
function Rke() {
  if (QE) return Jm;
  QE = 1;
  var e = Uu(), r = Dke(), t = Zu(), i = "[object Object]", n = Function.prototype, s = Object.prototype, u = n.toString, o = s.hasOwnProperty, d = u.call(Object);
  function a(V) {
    if (!t(V) || e(V) != i)
      return !1;
    var c = r(V);
    if (c === null)
      return !0;
    var F = o.call(c, "constructor") && c.constructor;
    return typeof F == "function" && F instanceof F && u.call(F) == d;
  }
  return Jm = a, Jm;
}
var Ike = Rke();
const Lke = /* @__PURE__ */ Mr(Ike);
var $m, ek;
function _ke() {
  if (ek) return $m;
  ek = 1;
  var e = Uu(), r = Zu(), t = "[object Boolean]";
  function i(n) {
    return n === !0 || n === !1 || r(n) && e(n) == t;
  }
  return $m = i, $m;
}
var Hke = _ke();
const jke = /* @__PURE__ */ Mr(Hke);
function M7(e) {
  "@babel/helpers - typeof";
  return M7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, M7(e);
}
function UX() {
  return UX = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, UX.apply(this, arguments);
}
function zke(e, r) {
  return Uke(e) || Gke(e, r) || Wke(e, r) || Bke();
}
function Bke() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wke(e, r) {
  if (e) {
    if (typeof e == "string") return rk(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return rk(e, r);
  }
}
function rk(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
function Gke(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var i, n, s, u, o = [], d = !0, a = !1;
    try {
      if (s = (t = t.call(e)).next, r !== 0) for (; !(d = (i = s.call(t)).done) && (o.push(i.value), o.length !== r); d = !0) ;
    } catch (V) {
      a = !0, n = V;
    } finally {
      try {
        if (!d && t.return != null && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (a) throw n;
      }
    }
    return o;
  }
}
function Uke(e) {
  if (Array.isArray(e)) return e;
}
function tk(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function ik(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? tk(Object(t), !0).forEach(function(i) {
      Zke(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : tk(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function Zke(e, r, t) {
  return r = Jke(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Jke(e) {
  var r = $ke(e, "string");
  return M7(r) == "symbol" ? r : r + "";
}
function $ke(e, r) {
  if (M7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (M7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
var nk = function(r, t, i, n, s) {
  var u = i - n, o;
  return o = "M ".concat(r, ",").concat(t), o += "L ".concat(r + i, ",").concat(t), o += "L ".concat(r + i - u / 2, ",").concat(t + s), o += "L ".concat(r + i - u / 2 - n, ",").concat(t + s), o += "L ".concat(r, ",").concat(t, " Z"), o;
}, Qke = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, eOe = function(r) {
  var t = ik(ik({}, Qke), r), i = Yr(), n = ie(-1), s = zke(n, 2), u = s[0], o = s[1];
  Pe(function() {
    if (i.current && i.current.getTotalLength)
      try {
        var g = i.current.getTotalLength();
        g && o(g);
      } catch {
      }
  }, []);
  var d = t.x, a = t.y, V = t.upperWidth, c = t.lowerWidth, F = t.height, X = t.className, Y = t.animationEasing, q = t.animationDuration, f = t.animationBegin, p = t.isUpdateAnimationActive;
  if (d !== +d || a !== +a || V !== +V || c !== +c || F !== +F || V === 0 && c === 0 || F === 0)
    return null;
  var m = ur("recharts-trapezoid", X);
  return p ? /* @__PURE__ */ D.createElement(_u, {
    canBegin: u > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: F,
      x: d,
      y: a
    },
    to: {
      upperWidth: V,
      lowerWidth: c,
      height: F,
      x: d,
      y: a
    },
    duration: q,
    animationEasing: Y,
    isActive: p
  }, function(g) {
    var y = g.upperWidth, b = g.lowerWidth, A = g.height, w = g.x, S = g.y;
    return /* @__PURE__ */ D.createElement(_u, {
      canBegin: u > 0,
      from: "0px ".concat(u === -1 ? 1 : u, "px"),
      to: "".concat(u, "px 0px"),
      attributeName: "strokeDasharray",
      begin: f,
      duration: q,
      easing: Y
    }, /* @__PURE__ */ D.createElement("path", UX({}, _e(t, !0), {
      className: m,
      d: nk(w, S, y, b, A),
      ref: i
    })));
  }) : /* @__PURE__ */ D.createElement("g", null, /* @__PURE__ */ D.createElement("path", UX({}, _e(t, !0), {
    className: m,
    d: nk(d, a, V, c, F)
  })));
}, rOe = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function T7(e) {
  "@babel/helpers - typeof";
  return T7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, T7(e);
}
function tOe(e, r) {
  if (e == null) return {};
  var t = iOe(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function iOe(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
function sk(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function ZX(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? sk(Object(t), !0).forEach(function(i) {
      nOe(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : sk(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function nOe(e, r, t) {
  return r = sOe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function sOe(e) {
  var r = uOe(e, "string");
  return T7(r) == "symbol" ? r : r + "";
}
function uOe(e, r) {
  if (T7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (T7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function oOe(e, r) {
  return ZX(ZX({}, r), e);
}
function dOe(e, r) {
  return e === "symbols";
}
function uk(e) {
  var r = e.shapeType, t = e.elementProps;
  switch (r) {
    case "rectangle":
      return /* @__PURE__ */ D.createElement(K4, t);
    case "trapezoid":
      return /* @__PURE__ */ D.createElement(eOe, t);
    case "sector":
      return /* @__PURE__ */ D.createElement(n$, t);
    case "symbols":
      if (dOe(r))
        return /* @__PURE__ */ D.createElement(DA, t);
      break;
    default:
      return null;
  }
}
function aOe(e) {
  return /* @__PURE__ */ Ci(e) ? e.props : e;
}
function VOe(e) {
  var r = e.option, t = e.shapeType, i = e.propTransformer, n = i === void 0 ? oOe : i, s = e.activeClassName, u = s === void 0 ? "recharts-active-shape" : s, o = e.isActive, d = tOe(e, rOe), a;
  if (/* @__PURE__ */ Ci(r))
    a = /* @__PURE__ */ at(r, ZX(ZX({}, d), aOe(r)));
  else if (Ue(r))
    a = r(d);
  else if (Lke(r) && !jke(r)) {
    var V = n(r, d);
    a = /* @__PURE__ */ D.createElement(uk, {
      shapeType: t,
      elementProps: V
    });
  } else {
    var c = d;
    a = /* @__PURE__ */ D.createElement(uk, {
      shapeType: t,
      elementProps: c
    });
  }
  return o ? /* @__PURE__ */ D.createElement(Hr, {
    className: u
  }, a) : a;
}
function bf(e, r) {
  return r != null && "trapezoids" in e.props;
}
function yf(e, r) {
  return r != null && "sectors" in e.props;
}
function E7(e, r) {
  return r != null && "points" in e.props;
}
function lOe(e, r) {
  var t, i, n = e.x === (r == null || (t = r.labelViewBox) === null || t === void 0 ? void 0 : t.x) || e.x === r.x, s = e.y === (r == null || (i = r.labelViewBox) === null || i === void 0 ? void 0 : i.y) || e.y === r.y;
  return n && s;
}
function cOe(e, r) {
  var t = e.endAngle === r.endAngle, i = e.startAngle === r.startAngle;
  return t && i;
}
function FOe(e, r) {
  var t = e.x === r.x, i = e.y === r.y, n = e.z === r.z;
  return t && i && n;
}
function xOe(e, r) {
  var t;
  return bf(e, r) ? t = lOe : yf(e, r) ? t = cOe : E7(e, r) && (t = FOe), t;
}
function XOe(e, r) {
  var t;
  return bf(e, r) ? t = "trapezoids" : yf(e, r) ? t = "sectors" : E7(e, r) && (t = "points"), t;
}
function qOe(e, r) {
  if (bf(e, r)) {
    var t;
    return (t = r.tooltipPayload) === null || t === void 0 || (t = t[0]) === null || t === void 0 || (t = t.payload) === null || t === void 0 ? void 0 : t.payload;
  }
  if (yf(e, r)) {
    var i;
    return (i = r.tooltipPayload) === null || i === void 0 || (i = i[0]) === null || i === void 0 || (i = i.payload) === null || i === void 0 ? void 0 : i.payload;
  }
  return E7(e, r) ? r.payload : {};
}
function YOe(e) {
  var r = e.activeTooltipItem, t = e.graphicalItem, i = e.itemData, n = XOe(t, r), s = qOe(t, r), u = i.filter(function(d, a) {
    var V = Yf(s, d), c = t.props[n].filter(function(Y) {
      var q = xOe(t, r);
      return q(Y, r);
    }), F = t.props[n].indexOf(c[c.length - 1]), X = a === F;
    return V && X;
  }), o = i.indexOf(u[u.length - 1]);
  return o;
}
var Qm, ok;
function fOe() {
  if (ok) return Qm;
  ok = 1;
  function e(r) {
    return r && r.length ? r[0] : void 0;
  }
  return Qm = e, Qm;
}
var eg, dk;
function KOe() {
  return dk || (dk = 1, eg = fOe()), eg;
}
var hOe = KOe();
const pOe = /* @__PURE__ */ Mr(hOe);
var mOe = ["key"];
function UV(e) {
  "@babel/helpers - typeof";
  return UV = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, UV(e);
}
function gOe(e, r) {
  if (e == null) return {};
  var t = vOe(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function vOe(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
function JX() {
  return JX = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, JX.apply(this, arguments);
}
function ak(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function yi(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ak(Object(t), !0).forEach(function(i) {
      gu(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ak(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function bOe(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function Vk(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, f$(i.key), i);
  }
}
function yOe(e, r, t) {
  return r && Vk(e.prototype, r), t && Vk(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function AOe(e, r, t) {
  return r = $X(r), wOe(e, Y$() ? Reflect.construct(r, t || [], $X(e).constructor) : r.apply(e, t));
}
function wOe(e, r) {
  if (r && (UV(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return COe(e);
}
function COe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Y$() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Y$ = function() {
    return !!e;
  })();
}
function $X(e) {
  return $X = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, $X(e);
}
function POe(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && mb(e, r);
}
function mb(e, r) {
  return mb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, mb(e, r);
}
function gu(e, r, t) {
  return r = f$(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function f$(e) {
  var r = SOe(e, "string");
  return UV(r) == "symbol" ? r : r + "";
}
function SOe(e, r) {
  if (UV(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (UV(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Dl = /* @__PURE__ */ function(e) {
  function r() {
    var t;
    bOe(this, r);
    for (var i = arguments.length, n = new Array(i), s = 0; s < i; s++)
      n[s] = arguments[s];
    return t = AOe(this, r, [].concat(n)), gu(t, "state", {
      isAnimationFinished: !1
    }), gu(t, "handleAnimationEnd", function() {
      var u = t.props.onAnimationEnd;
      t.setState({
        isAnimationFinished: !0
      }), Ue(u) && u();
    }), gu(t, "handleAnimationStart", function() {
      var u = t.props.onAnimationStart;
      t.setState({
        isAnimationFinished: !1
      }), Ue(u) && u();
    }), gu(t, "handleMouseEnter", function(u) {
      var o = t.props.onMouseEnter;
      o && o(t.props, u);
    }), gu(t, "handleMouseLeave", function(u) {
      var o = t.props.onMouseLeave;
      o && o(t.props, u);
    }), t;
  }
  return POe(r, e), yOe(r, [{
    key: "renderDots",
    value: function(i) {
      var n = this.props, s = n.dot, u = n.dataKey, o = _e(this.props, !1), d = _e(s, !0), a = i.map(function(V, c) {
        var F = yi(yi(yi({
          key: "dot-".concat(c),
          r: 3
        }, o), d), {}, {
          dataKey: u,
          cx: V.x,
          cy: V.y,
          index: c,
          payload: V
        });
        return r.renderDotItem(s, F);
      });
      return /* @__PURE__ */ D.createElement(Hr, {
        className: "recharts-radar-dots"
      }, a);
    }
  }, {
    key: "renderPolygonStatically",
    value: function(i) {
      var n = this.props, s = n.shape, u = n.dot, o = n.isRange, d = n.baseLinePoints, a = n.connectNulls, V;
      return /* @__PURE__ */ D.isValidElement(s) ? V = /* @__PURE__ */ D.cloneElement(s, yi(yi({}, this.props), {}, {
        points: i
      })) : Ue(s) ? V = s(yi(yi({}, this.props), {}, {
        points: i
      })) : V = /* @__PURE__ */ D.createElement(c$, JX({}, _e(this.props, !0), {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        points: i,
        baseLinePoints: o ? d : null,
        connectNulls: a
      })), /* @__PURE__ */ D.createElement(Hr, {
        className: "recharts-radar-polygon"
      }, V, u ? this.renderDots(i) : null);
    }
  }, {
    key: "renderPolygonWithAnimation",
    value: function() {
      var i = this, n = this.props, s = n.points, u = n.isAnimationActive, o = n.animationBegin, d = n.animationDuration, a = n.animationEasing, V = n.animationId, c = this.state.prevPoints;
      return /* @__PURE__ */ D.createElement(_u, {
        begin: o,
        duration: d,
        isActive: u,
        easing: a,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "radar-".concat(V),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(F) {
        var X = F.t, Y = c && c.length / s.length, q = s.map(function(f, p) {
          var m = c && c[Math.floor(p * Y)];
          if (m) {
            var g = Cs(m.x, f.x), y = Cs(m.y, f.y);
            return yi(yi({}, f), {}, {
              x: g(X),
              y: y(X)
            });
          }
          var b = Cs(f.cx, f.x), A = Cs(f.cy, f.y);
          return yi(yi({}, f), {}, {
            x: b(X),
            y: A(X)
          });
        });
        return i.renderPolygonStatically(q);
      });
    }
  }, {
    key: "renderPolygon",
    value: function() {
      var i = this.props, n = i.points, s = i.isAnimationActive, u = i.isRange, o = this.state.prevPoints;
      return s && n && n.length && !u && (!o || !Yf(o, n)) ? this.renderPolygonWithAnimation() : this.renderPolygonStatically(n);
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, n = i.hide, s = i.className, u = i.points, o = i.isAnimationActive;
      if (n || !u || !u.length)
        return null;
      var d = this.state.isAnimationFinished, a = ur("recharts-radar", s);
      return /* @__PURE__ */ D.createElement(Hr, {
        className: a
      }, this.renderPolygon(), (!o || d) && To.renderCallByParent(this.props, u));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(i, n) {
      return i.animationId !== n.prevAnimationId ? {
        prevAnimationId: i.animationId,
        curPoints: i.points,
        prevPoints: n.curPoints
      } : i.points !== n.curPoints ? {
        curPoints: i.points
      } : null;
    }
  }, {
    key: "renderDotItem",
    value: function(i, n) {
      var s;
      if (/* @__PURE__ */ D.isValidElement(i))
        s = /* @__PURE__ */ D.cloneElement(i, n);
      else if (Ue(i))
        s = i(n);
      else {
        var u = n.key, o = gOe(n, mOe);
        s = /* @__PURE__ */ D.createElement(pf, JX({}, o, {
          key: u,
          className: ur("recharts-radar-dot", typeof i != "boolean" ? i.className : "")
        }));
      }
      return s;
    }
  }]);
}(Gs);
gu(Dl, "displayName", "Radar");
gu(Dl, "defaultProps", {
  angleAxisId: 0,
  radiusAxisId: 0,
  hide: !1,
  activeDot: !0,
  dot: !1,
  legendType: "rect",
  isAnimationActive: !Ml.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
gu(Dl, "getComposedData", function(e) {
  var r = e.radiusAxis, t = e.angleAxis, i = e.displayedData, n = e.dataKey, s = e.bandSize, u = t.cx, o = t.cy, d = !1, a = [], V = t.type !== "number" ? s ?? 0 : 0;
  i.forEach(function(F, X) {
    var Y = On(F, t.dataKey, X), q = On(F, n), f = t.scale(Y) + V, p = Array.isArray(q) ? t$(q) : q, m = fr(p) ? void 0 : r.scale(p);
    Array.isArray(q) && q.length >= 2 && (d = !0), a.push(yi(yi({}, kr(u, o, m, f)), {}, {
      name: Y,
      value: q,
      cx: u,
      cy: o,
      radius: m,
      angle: f,
      payload: F
    }));
  });
  var c = [];
  return d && a.forEach(function(F) {
    if (Array.isArray(F.value)) {
      var X = pOe(F.value), Y = fr(X) ? void 0 : r.scale(X);
      c.push(yi(yi({}, F), {}, {
        radius: Y
      }, kr(u, o, Y, F.angle)));
    } else
      c.push(F);
  }), {
    points: a,
    isRange: d,
    baseLinePoints: c
  };
});
var rg, lk;
function NOe() {
  if (lk) return rg;
  lk = 1;
  var e = Math.ceil, r = Math.max;
  function t(i, n, s, u) {
    for (var o = -1, d = r(e((n - i) / (s || 1)), 0), a = Array(d); d--; )
      a[u ? d : ++o] = i, i += s;
    return a;
  }
  return rg = t, rg;
}
var tg, ck;
function K$() {
  if (ck) return tg;
  ck = 1;
  var e = IZ(), r = 1 / 0, t = 17976931348623157e292;
  function i(n) {
    if (!n)
      return n === 0 ? n : 0;
    if (n = e(n), n === r || n === -1 / 0) {
      var s = n < 0 ? -1 : 1;
      return s * t;
    }
    return n === n ? n : 0;
  }
  return tg = i, tg;
}
var ig, Fk;
function MOe() {
  if (Fk) return ig;
  Fk = 1;
  var e = NOe(), r = of(), t = K$();
  function i(n) {
    return function(s, u, o) {
      return o && typeof o != "number" && r(s, u, o) && (u = o = void 0), s = t(s), u === void 0 ? (u = s, s = 0) : u = t(u), o = o === void 0 ? s < u ? 1 : -1 : t(o), e(s, u, o, n);
    };
  }
  return ig = i, ig;
}
var ng, xk;
function TOe() {
  if (xk) return ng;
  xk = 1;
  var e = MOe(), r = e();
  return ng = r, ng;
}
var EOe = TOe();
const QX = /* @__PURE__ */ Mr(EOe);
function k7(e) {
  "@babel/helpers - typeof";
  return k7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, k7(e);
}
function Xk(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function qk(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Xk(Object(t), !0).forEach(function(i) {
      h$(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Xk(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function h$(e, r, t) {
  return r = kOe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function kOe(e) {
  var r = OOe(e, "string");
  return k7(r) == "symbol" ? r : r + "";
}
function OOe(e, r) {
  if (k7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (k7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
var DOe = ["Webkit", "Moz", "O", "ms"], ROe = function(r, t) {
  var i = r.replace(/(\w)/, function(s) {
    return s.toUpperCase();
  }), n = DOe.reduce(function(s, u) {
    return qk(qk({}, s), {}, h$({}, u + i, t));
  }, {});
  return n[r] = t, n;
};
function ZV(e) {
  "@babel/helpers - typeof";
  return ZV = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, ZV(e);
}
function eq() {
  return eq = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, eq.apply(this, arguments);
}
function Yk(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function sg(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Yk(Object(t), !0).forEach(function(i) {
      on(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Yk(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function IOe(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function fk(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, m$(i.key), i);
  }
}
function LOe(e, r, t) {
  return r && fk(e.prototype, r), t && fk(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function _Oe(e, r, t) {
  return r = rq(r), HOe(e, p$() ? Reflect.construct(r, t || [], rq(e).constructor) : r.apply(e, t));
}
function HOe(e, r) {
  if (r && (ZV(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return jOe(e);
}
function jOe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function p$() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (p$ = function() {
    return !!e;
  })();
}
function rq(e) {
  return rq = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, rq(e);
}
function zOe(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && gb(e, r);
}
function gb(e, r) {
  return gb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, gb(e, r);
}
function on(e, r, t) {
  return r = m$(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function m$(e) {
  var r = BOe(e, "string");
  return ZV(r) == "symbol" ? r : r + "";
}
function BOe(e, r) {
  if (ZV(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (ZV(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var WOe = function(r) {
  var t = r.data, i = r.startIndex, n = r.endIndex, s = r.x, u = r.width, o = r.travellerWidth;
  if (!t || !t.length)
    return {};
  var d = t.length, a = Rc().domain(QX(0, d)).range([s, s + u - o]), V = a.domain().map(function(c) {
    return a(c);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: a(i),
    endX: a(n),
    scale: a,
    scaleValues: V
  };
}, Kk = function(r) {
  return r.changedTouches && !!r.changedTouches.length;
}, JV = /* @__PURE__ */ function(e) {
  function r(t) {
    var i;
    return IOe(this, r), i = _Oe(this, r, [t]), on(i, "handleDrag", function(n) {
      i.leaveTimer && (clearTimeout(i.leaveTimer), i.leaveTimer = null), i.state.isTravellerMoving ? i.handleTravellerMove(n) : i.state.isSlideMoving && i.handleSlideDrag(n);
    }), on(i, "handleTouchMove", function(n) {
      n.changedTouches != null && n.changedTouches.length > 0 && i.handleDrag(n.changedTouches[0]);
    }), on(i, "handleDragEnd", function() {
      i.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var n = i.props, s = n.endIndex, u = n.onDragEnd, o = n.startIndex;
        u == null || u({
          endIndex: s,
          startIndex: o
        });
      }), i.detachDragEndListener();
    }), on(i, "handleLeaveWrapper", function() {
      (i.state.isTravellerMoving || i.state.isSlideMoving) && (i.leaveTimer = window.setTimeout(i.handleDragEnd, i.props.leaveTimeOut));
    }), on(i, "handleEnterSlideOrTraveller", function() {
      i.setState({
        isTextActive: !0
      });
    }), on(i, "handleLeaveSlideOrTraveller", function() {
      i.setState({
        isTextActive: !1
      });
    }), on(i, "handleSlideDragStart", function(n) {
      var s = Kk(n) ? n.changedTouches[0] : n;
      i.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: s.pageX
      }), i.attachDragEndListener();
    }), i.travellerDragStartHandlers = {
      startX: i.handleTravellerDragStart.bind(i, "startX"),
      endX: i.handleTravellerDragStart.bind(i, "endX")
    }, i.state = {}, i;
  }
  return zOe(r, e), LOe(r, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(i) {
      var n = i.startX, s = i.endX, u = this.state.scaleValues, o = this.props, d = o.gap, a = o.data, V = a.length - 1, c = Math.min(n, s), F = Math.max(n, s), X = r.getIndexInRange(u, c), Y = r.getIndexInRange(u, F);
      return {
        startIndex: X - X % d,
        endIndex: Y === V ? V : Y - Y % d
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(i) {
      var n = this.props, s = n.data, u = n.tickFormatter, o = n.dataKey, d = On(s[i], o, i);
      return Ue(u) ? u(d, i) : d;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(i) {
      var n = this.state, s = n.slideMoveStartX, u = n.startX, o = n.endX, d = this.props, a = d.x, V = d.width, c = d.travellerWidth, F = d.startIndex, X = d.endIndex, Y = d.onChange, q = i.pageX - s;
      q > 0 ? q = Math.min(q, a + V - c - o, a + V - c - u) : q < 0 && (q = Math.max(q, a - u, a - o));
      var f = this.getIndex({
        startX: u + q,
        endX: o + q
      });
      (f.startIndex !== F || f.endIndex !== X) && Y && Y(f), this.setState({
        startX: u + q,
        endX: o + q,
        slideMoveStartX: i.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(i, n) {
      var s = Kk(n) ? n.changedTouches[0] : n;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: i,
        brushMoveStartX: s.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(i) {
      var n = this.state, s = n.brushMoveStartX, u = n.movingTravellerId, o = n.endX, d = n.startX, a = this.state[u], V = this.props, c = V.x, F = V.width, X = V.travellerWidth, Y = V.onChange, q = V.gap, f = V.data, p = {
        startX: this.state.startX,
        endX: this.state.endX
      }, m = i.pageX - s;
      m > 0 ? m = Math.min(m, c + F - X - a) : m < 0 && (m = Math.max(m, c - a)), p[u] = a + m;
      var g = this.getIndex(p), y = g.startIndex, b = g.endIndex, A = function() {
        var S = f.length - 1;
        return u === "startX" && (o > d ? y % q === 0 : b % q === 0) || o < d && b === S || u === "endX" && (o > d ? b % q === 0 : y % q === 0) || o > d && b === S;
      };
      this.setState(on(on({}, u, a + m), "brushMoveStartX", i.pageX), function() {
        Y && A() && Y(g);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(i, n) {
      var s = this, u = this.state, o = u.scaleValues, d = u.startX, a = u.endX, V = this.state[n], c = o.indexOf(V);
      if (c !== -1) {
        var F = c + i;
        if (!(F === -1 || F >= o.length)) {
          var X = o[F];
          n === "startX" && X >= a || n === "endX" && X <= d || this.setState(on({}, n, X), function() {
            s.props.onChange(s.getIndex({
              startX: s.state.startX,
              endX: s.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var i = this.props, n = i.x, s = i.y, u = i.width, o = i.height, d = i.fill, a = i.stroke;
      return /* @__PURE__ */ D.createElement("rect", {
        stroke: a,
        fill: d,
        x: n,
        y: s,
        width: u,
        height: o
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var i = this.props, n = i.x, s = i.y, u = i.width, o = i.height, d = i.data, a = i.children, V = i.padding, c = Hi.only(a);
      return c ? /* @__PURE__ */ D.cloneElement(c, {
        x: n,
        y: s,
        width: u,
        height: o,
        margin: V,
        compact: !0,
        data: d
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(i, n) {
      var s, u, o = this, d = this.props, a = d.y, V = d.travellerWidth, c = d.height, F = d.traveller, X = d.ariaLabel, Y = d.data, q = d.startIndex, f = d.endIndex, p = Math.max(i, this.props.x), m = sg(sg({}, _e(this.props, !1)), {}, {
        x: p,
        y: a,
        width: V,
        height: c
      }), g = X || "Min value: ".concat((s = Y[q]) === null || s === void 0 ? void 0 : s.name, ", Max value: ").concat((u = Y[f]) === null || u === void 0 ? void 0 : u.name);
      return /* @__PURE__ */ D.createElement(Hr, {
        tabIndex: 0,
        role: "slider",
        "aria-label": g,
        "aria-valuenow": i,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[n],
        onTouchStart: this.travellerDragStartHandlers[n],
        onKeyDown: function(b) {
          ["ArrowLeft", "ArrowRight"].includes(b.key) && (b.preventDefault(), b.stopPropagation(), o.handleTravellerMoveKeyboard(b.key === "ArrowRight" ? 1 : -1, n));
        },
        onFocus: function() {
          o.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          o.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, r.renderTraveller(F, m));
    }
  }, {
    key: "renderSlide",
    value: function(i, n) {
      var s = this.props, u = s.y, o = s.height, d = s.stroke, a = s.travellerWidth, V = Math.min(i, n) + a, c = Math.max(Math.abs(n - i) - a, 0);
      return /* @__PURE__ */ D.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: d,
        fillOpacity: 0.2,
        x: V,
        y: u,
        width: c,
        height: o
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var i = this.props, n = i.startIndex, s = i.endIndex, u = i.y, o = i.height, d = i.travellerWidth, a = i.stroke, V = this.state, c = V.startX, F = V.endX, X = 5, Y = {
        pointerEvents: "none",
        fill: a
      };
      return /* @__PURE__ */ D.createElement(Hr, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ D.createElement(LV, eq({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(c, F) - X,
        y: u + o / 2
      }, Y), this.getTextOfTick(n)), /* @__PURE__ */ D.createElement(LV, eq({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(c, F) + d + X,
        y: u + o / 2
      }, Y), this.getTextOfTick(s)));
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, n = i.data, s = i.className, u = i.children, o = i.x, d = i.y, a = i.width, V = i.height, c = i.alwaysShowText, F = this.state, X = F.startX, Y = F.endX, q = F.isTextActive, f = F.isSlideMoving, p = F.isTravellerMoving, m = F.isTravellerFocused;
      if (!n || !n.length || !pe(o) || !pe(d) || !pe(a) || !pe(V) || a <= 0 || V <= 0)
        return null;
      var g = ur("recharts-brush", s), y = D.Children.count(u) === 1, b = ROe("userSelect", "none");
      return /* @__PURE__ */ D.createElement(Hr, {
        className: g,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: b
      }, this.renderBackground(), y && this.renderPanorama(), this.renderSlide(X, Y), this.renderTravellerLayer(X, "startX"), this.renderTravellerLayer(Y, "endX"), (q || f || p || m || c) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(i) {
      var n = i.x, s = i.y, u = i.width, o = i.height, d = i.stroke, a = Math.floor(s + o / 2) - 1;
      return /* @__PURE__ */ D.createElement(D.Fragment, null, /* @__PURE__ */ D.createElement("rect", {
        x: n,
        y: s,
        width: u,
        height: o,
        fill: d,
        stroke: "none"
      }), /* @__PURE__ */ D.createElement("line", {
        x1: n + 1,
        y1: a,
        x2: n + u - 1,
        y2: a,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ D.createElement("line", {
        x1: n + 1,
        y1: a + 2,
        x2: n + u - 1,
        y2: a + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(i, n) {
      var s;
      return /* @__PURE__ */ D.isValidElement(i) ? s = /* @__PURE__ */ D.cloneElement(i, n) : Ue(i) ? s = i(n) : s = r.renderDefaultTraveller(n), s;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(i, n) {
      var s = i.data, u = i.width, o = i.x, d = i.travellerWidth, a = i.updateId, V = i.startIndex, c = i.endIndex;
      if (s !== n.prevData || a !== n.prevUpdateId)
        return sg({
          prevData: s,
          prevTravellerWidth: d,
          prevUpdateId: a,
          prevX: o,
          prevWidth: u
        }, s && s.length ? WOe({
          data: s,
          width: u,
          x: o,
          travellerWidth: d,
          startIndex: V,
          endIndex: c
        }) : {
          scale: null,
          scaleValues: null
        });
      if (n.scale && (u !== n.prevWidth || o !== n.prevX || d !== n.prevTravellerWidth)) {
        n.scale.range([o, o + u - d]);
        var F = n.scale.domain().map(function(X) {
          return n.scale(X);
        });
        return {
          prevData: s,
          prevTravellerWidth: d,
          prevUpdateId: a,
          prevX: o,
          prevWidth: u,
          startX: n.scale(i.startIndex),
          endX: n.scale(i.endIndex),
          scaleValues: F
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(i, n) {
      for (var s = i.length, u = 0, o = s - 1; o - u > 1; ) {
        var d = Math.floor((u + o) / 2);
        i[d] > n ? o = d : u = d;
      }
      return n >= i[o] ? o : u;
    }
  }]);
}(Gs);
on(JV, "displayName", "Brush");
on(JV, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var ug, hk;
function GOe() {
  if (hk) return ug;
  hk = 1;
  var e = zA();
  function r(t, i) {
    var n;
    return e(t, function(s, u, o) {
      return n = i(s, u, o), !n;
    }), !!n;
  }
  return ug = r, ug;
}
var og, pk;
function UOe() {
  if (pk) return og;
  pk = 1;
  var e = YZ(), r = ru(), t = GOe(), i = Qi(), n = of();
  function s(u, o, d) {
    var a = i(u) ? e : t;
    return d && n(u, o, d) && (o = void 0), a(u, r(o, 3));
  }
  return og = s, og;
}
var ZOe = UOe();
const JOe = /* @__PURE__ */ Mr(ZOe);
var Rs = function(r, t) {
  var i = r.alwaysShow, n = r.ifOverflow;
  return i && (n = "extendDomain"), n === t;
}, dg, mk;
function $Oe() {
  if (mk) return dg;
  mk = 1;
  var e = EZ();
  function r(t, i, n) {
    i == "__proto__" && e ? e(t, i, {
      configurable: !0,
      enumerable: !0,
      value: n,
      writable: !0
    }) : t[i] = n;
  }
  return dg = r, dg;
}
var ag, gk;
function QOe() {
  if (gk) return ag;
  gk = 1;
  var e = $Oe(), r = MZ(), t = ru();
  function i(n, s) {
    var u = {};
    return s = t(s, 3), r(n, function(o, d, a) {
      e(u, d, s(o, d, a));
    }), u;
  }
  return ag = i, ag;
}
var eDe = QOe();
const rDe = /* @__PURE__ */ Mr(eDe);
var Vg, vk;
function tDe() {
  if (vk) return Vg;
  vk = 1;
  function e(r, t) {
    for (var i = -1, n = r == null ? 0 : r.length; ++i < n; )
      if (!t(r[i], i, r))
        return !1;
    return !0;
  }
  return Vg = e, Vg;
}
var lg, bk;
function iDe() {
  if (bk) return lg;
  bk = 1;
  var e = zA();
  function r(t, i) {
    var n = !0;
    return e(t, function(s, u, o) {
      return n = !!i(s, u, o), n;
    }), n;
  }
  return lg = r, lg;
}
var cg, yk;
function nDe() {
  if (yk) return cg;
  yk = 1;
  var e = tDe(), r = iDe(), t = ru(), i = Qi(), n = of();
  function s(u, o, d) {
    var a = i(u) ? e : r;
    return d && n(u, o, d) && (o = void 0), a(u, t(o, 3));
  }
  return cg = s, cg;
}
var sDe = nDe();
const g$ = /* @__PURE__ */ Mr(sDe);
var uDe = ["x", "y"];
function $V(e) {
  "@babel/helpers - typeof";
  return $V = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, $V(e);
}
function vb() {
  return vb = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, vb.apply(this, arguments);
}
function Ak(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function Kc(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Ak(Object(t), !0).forEach(function(i) {
      oDe(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Ak(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function oDe(e, r, t) {
  return r = dDe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function dDe(e) {
  var r = aDe(e, "string");
  return $V(r) == "symbol" ? r : r + "";
}
function aDe(e, r) {
  if ($V(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if ($V(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function VDe(e, r) {
  if (e == null) return {};
  var t = lDe(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function lDe(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
function cDe(e, r) {
  var t = e.x, i = e.y, n = VDe(e, uDe), s = "".concat(t), u = parseInt(s, 10), o = "".concat(i), d = parseInt(o, 10), a = "".concat(r.height || n.height), V = parseInt(a, 10), c = "".concat(r.width || n.width), F = parseInt(c, 10);
  return Kc(Kc(Kc(Kc(Kc({}, r), n), u ? {
    x: u
  } : {}), d ? {
    y: d
  } : {}), {}, {
    height: V,
    width: F,
    name: r.name,
    radius: r.radius
  });
}
function wk(e) {
  return /* @__PURE__ */ D.createElement(VOe, vb({
    shapeType: "rectangle",
    propTransformer: cDe,
    activeClassName: "recharts-active-bar"
  }, e));
}
var FDe = function(r) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(i, n) {
    if (typeof r == "number") return r;
    var s = typeof i == "number";
    return s ? r(i, n) : (s || (process.env.NODE_ENV !== "production" ? _i(!1, "minPointSize callback function received a value with type of ".concat($V(i), ". Currently only numbers are supported.")) : _i()), t);
  };
}, xDe = ["value", "background"], v$;
function QV(e) {
  "@babel/helpers - typeof";
  return QV = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, QV(e);
}
function XDe(e, r) {
  if (e == null) return {};
  var t = qDe(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function qDe(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
function tq() {
  return tq = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, tq.apply(this, arguments);
}
function Ck(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function qt(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Ck(Object(t), !0).forEach(function(i) {
      Ao(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Ck(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function YDe(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function Pk(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, y$(i.key), i);
  }
}
function fDe(e, r, t) {
  return r && Pk(e.prototype, r), t && Pk(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function KDe(e, r, t) {
  return r = iq(r), hDe(e, b$() ? Reflect.construct(r, t || [], iq(e).constructor) : r.apply(e, t));
}
function hDe(e, r) {
  if (r && (QV(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return pDe(e);
}
function pDe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function b$() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (b$ = function() {
    return !!e;
  })();
}
function iq(e) {
  return iq = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, iq(e);
}
function mDe(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && bb(e, r);
}
function bb(e, r) {
  return bb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, bb(e, r);
}
function Ao(e, r, t) {
  return r = y$(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function y$(e) {
  var r = gDe(e, "string");
  return QV(r) == "symbol" ? r : r + "";
}
function gDe(e, r) {
  if (QV(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (QV(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Kr = /* @__PURE__ */ function(e) {
  function r() {
    var t;
    YDe(this, r);
    for (var i = arguments.length, n = new Array(i), s = 0; s < i; s++)
      n[s] = arguments[s];
    return t = KDe(this, r, [].concat(n)), Ao(t, "state", {
      isAnimationFinished: !1
    }), Ao(t, "id", QY("recharts-bar-")), Ao(t, "handleAnimationEnd", function() {
      var u = t.props.onAnimationEnd;
      t.setState({
        isAnimationFinished: !0
      }), u && u();
    }), Ao(t, "handleAnimationStart", function() {
      var u = t.props.onAnimationStart;
      t.setState({
        isAnimationFinished: !1
      }), u && u();
    }), t;
  }
  return mDe(r, e), fDe(r, [{
    key: "renderRectanglesStatically",
    value: function(i) {
      var n = this, s = this.props, u = s.shape, o = s.dataKey, d = s.activeIndex, a = s.activeBar, V = _e(this.props, !1);
      return i && i.map(function(c, F) {
        var X = F === d, Y = X ? a : u, q = qt(qt(qt({}, V), c), {}, {
          isActive: X,
          option: Y,
          index: F,
          dataKey: o,
          onAnimationStart: n.handleAnimationStart,
          onAnimationEnd: n.handleAnimationEnd
        });
        return /* @__PURE__ */ D.createElement(Hr, tq({
          className: "recharts-bar-rectangle"
        }, EV(n.props, c, F), {
          key: "rectangle-".concat(c == null ? void 0 : c.x, "-").concat(c == null ? void 0 : c.y, "-").concat(c == null ? void 0 : c.value)
        }), /* @__PURE__ */ D.createElement(wk, q));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var i = this, n = this.props, s = n.data, u = n.layout, o = n.isAnimationActive, d = n.animationBegin, a = n.animationDuration, V = n.animationEasing, c = n.animationId, F = this.state.prevData;
      return /* @__PURE__ */ D.createElement(_u, {
        begin: d,
        duration: a,
        isActive: o,
        easing: V,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(c),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(X) {
        var Y = X.t, q = s.map(function(f, p) {
          var m = F && F[p];
          if (m) {
            var g = Cs(m.x, f.x), y = Cs(m.y, f.y), b = Cs(m.width, f.width), A = Cs(m.height, f.height);
            return qt(qt({}, f), {}, {
              x: g(Y),
              y: y(Y),
              width: b(Y),
              height: A(Y)
            });
          }
          if (u === "horizontal") {
            var w = Cs(0, f.height), S = w(Y);
            return qt(qt({}, f), {}, {
              y: f.y + f.height - S,
              height: S
            });
          }
          var N = Cs(0, f.width), O = N(Y);
          return qt(qt({}, f), {}, {
            width: O
          });
        });
        return /* @__PURE__ */ D.createElement(Hr, null, i.renderRectanglesStatically(q));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var i = this.props, n = i.data, s = i.isAnimationActive, u = this.state.prevData;
      return s && n && n.length && (!u || !Yf(u, n)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(n);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var i = this, n = this.props, s = n.data, u = n.dataKey, o = n.activeIndex, d = _e(this.props.background, !1);
      return s.map(function(a, V) {
        a.value;
        var c = a.background, F = XDe(a, xDe);
        if (!c)
          return null;
        var X = qt(qt(qt(qt(qt({}, F), {}, {
          fill: "#eee"
        }, c), d), EV(i.props, a, V)), {}, {
          onAnimationStart: i.handleAnimationStart,
          onAnimationEnd: i.handleAnimationEnd,
          dataKey: u,
          index: V,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ D.createElement(wk, tq({
          key: "background-bar-".concat(V),
          option: i.props.background,
          isActive: V === o
        }, X));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(i, n) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var s = this.props, u = s.data, o = s.xAxis, d = s.yAxis, a = s.layout, V = s.children, c = ss(V, hf);
      if (!c)
        return null;
      var F = a === "vertical" ? u[0].height / 2 : u[0].width / 2, X = function(f, p) {
        var m = Array.isArray(f.value) ? f.value[1] : f.value;
        return {
          x: f.x,
          y: f.y,
          value: m,
          errorVal: On(f, p)
        };
      }, Y = {
        clipPath: i ? "url(#clipPath-".concat(n, ")") : null
      };
      return /* @__PURE__ */ D.createElement(Hr, Y, c.map(function(q) {
        return /* @__PURE__ */ D.cloneElement(q, {
          key: "error-bar-".concat(n, "-").concat(q.props.dataKey),
          data: u,
          xAxis: o,
          yAxis: d,
          layout: a,
          offset: F,
          dataPointFormatter: X
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, n = i.hide, s = i.data, u = i.className, o = i.xAxis, d = i.yAxis, a = i.left, V = i.top, c = i.width, F = i.height, X = i.isAnimationActive, Y = i.background, q = i.id;
      if (n || !s || !s.length)
        return null;
      var f = this.state.isAnimationFinished, p = ur("recharts-bar", u), m = o && o.allowDataOverflow, g = d && d.allowDataOverflow, y = m || g, b = fr(q) ? this.id : q;
      return /* @__PURE__ */ D.createElement(Hr, {
        className: p
      }, m || g ? /* @__PURE__ */ D.createElement("defs", null, /* @__PURE__ */ D.createElement("clipPath", {
        id: "clipPath-".concat(b)
      }, /* @__PURE__ */ D.createElement("rect", {
        x: m ? a : a - c / 2,
        y: g ? V : V - F / 2,
        width: m ? c : c * 2,
        height: g ? F : F * 2
      }))) : null, /* @__PURE__ */ D.createElement(Hr, {
        className: "recharts-bar-rectangles",
        clipPath: y ? "url(#clipPath-".concat(b, ")") : null
      }, Y ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(y, b), (!X || f) && To.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(i, n) {
      return i.animationId !== n.prevAnimationId ? {
        prevAnimationId: i.animationId,
        curData: i.data,
        prevData: n.curData
      } : i.data !== n.curData ? {
        curData: i.data
      } : null;
    }
  }]);
}(Gs);
v$ = Kr;
Ao(Kr, "displayName", "Bar");
Ao(Kr, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !Ml.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
Ao(Kr, "getComposedData", function(e) {
  var r = e.props, t = e.item, i = e.barPosition, n = e.bandSize, s = e.xAxis, u = e.yAxis, o = e.xAxisTicks, d = e.yAxisTicks, a = e.stackedData, V = e.dataStartIndex, c = e.displayedData, F = e.offset, X = kNe(i, t);
  if (!X)
    return null;
  var Y = r.layout, q = t.type.defaultProps, f = q !== void 0 ? qt(qt({}, q), t.props) : t.props, p = f.dataKey, m = f.children, g = f.minPointSize, y = Y === "horizontal" ? u : s, b = a ? y.scale.domain() : null, A = HNe({
    numericAxis: y
  }), w = ss(m, _Z), S = c.map(function(N, O) {
    var E, I, R, H, W, B;
    a ? E = ONe(a[V + O], b) : (E = On(N, p), Array.isArray(E) || (E = [A, E]));
    var L = FDe(g, v$.defaultProps.minPointSize)(E[1], O);
    if (Y === "horizontal") {
      var z, Z = [u.scale(E[0]), u.scale(E[1])], le = Z[0], te = Z[1];
      I = rE({
        axis: s,
        ticks: o,
        bandSize: n,
        offset: X.offset,
        entry: N,
        index: O
      }), R = (z = te ?? le) !== null && z !== void 0 ? z : void 0, H = X.size;
      var U = le - te;
      if (W = Number.isNaN(U) ? 0 : U, B = {
        x: I,
        y: u.y,
        width: H,
        height: u.height
      }, Math.abs(L) > 0 && Math.abs(W) < Math.abs(L)) {
        var de = ts(W || L) * (Math.abs(L) - Math.abs(W));
        R -= de, W += de;
      }
    } else {
      var Ke = [s.scale(E[0]), s.scale(E[1])], xe = Ke[0], be = Ke[1];
      if (I = xe, R = rE({
        axis: u,
        ticks: d,
        bandSize: n,
        offset: X.offset,
        entry: N,
        index: O
      }), H = be - xe, W = X.size, B = {
        x: s.x,
        y: R,
        width: s.width,
        height: W
      }, Math.abs(L) > 0 && Math.abs(H) < Math.abs(L)) {
        var qe = ts(H || L) * (Math.abs(L) - Math.abs(H));
        H += qe;
      }
    }
    return qt(qt(qt({}, N), {}, {
      x: I,
      y: R,
      width: H,
      height: W,
      value: a ? E : E[1],
      payload: N,
      background: B
    }, w && w[O] && w[O].props), {}, {
      tooltipPayload: [$J(t, N)],
      tooltipPosition: {
        x: I + H / 2,
        y: R + W / 2
      }
    });
  });
  return qt({
    data: S,
    layout: Y
  }, F);
});
function O7(e) {
  "@babel/helpers - typeof";
  return O7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, O7(e);
}
function vDe(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function Sk(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, A$(i.key), i);
  }
}
function bDe(e, r, t) {
  return r && Sk(e.prototype, r), t && Sk(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Nk(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function $n(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Nk(Object(t), !0).forEach(function(i) {
      Af(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Nk(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function Af(e, r, t) {
  return r = A$(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function A$(e) {
  var r = yDe(e, "string");
  return O7(r) == "symbol" ? r : r + "";
}
function yDe(e, r) {
  if (O7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (O7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
var ADe = function(r, t, i, n, s) {
  var u = r.width, o = r.height, d = r.layout, a = r.children, V = Object.keys(t), c = {
    left: i.left,
    leftMirror: i.left,
    right: u - i.right,
    rightMirror: u - i.right,
    top: i.top,
    topMirror: i.top,
    bottom: o - i.bottom,
    bottomMirror: o - i.bottom
  }, F = !!dn(a, Kr);
  return V.reduce(function(X, Y) {
    var q = t[Y], f = q.orientation, p = q.domain, m = q.padding, g = m === void 0 ? {} : m, y = q.mirror, b = q.reversed, A = "".concat(f).concat(y ? "Mirror" : ""), w, S, N, O, E;
    if (q.type === "number" && (q.padding === "gap" || q.padding === "no-gap")) {
      var I = p[1] - p[0], R = 1 / 0, H = q.categoricalDomain.sort();
      if (H.forEach(function(Ke, xe) {
        xe > 0 && (R = Math.min((Ke || 0) - (H[xe - 1] || 0), R));
      }), Number.isFinite(R)) {
        var W = R / I, B = q.layout === "vertical" ? i.height : i.width;
        if (q.padding === "gap" && (w = W * B / 2), q.padding === "no-gap") {
          var L = is(r.barCategoryGap, W * B), z = W * B / 2;
          w = z - L - (z - L) / B * L;
        }
      }
    }
    n === "xAxis" ? S = [i.left + (g.left || 0) + (w || 0), i.left + i.width - (g.right || 0) - (w || 0)] : n === "yAxis" ? S = d === "horizontal" ? [i.top + i.height - (g.bottom || 0), i.top + (g.top || 0)] : [i.top + (g.top || 0) + (w || 0), i.top + i.height - (g.bottom || 0) - (w || 0)] : S = q.range, b && (S = [S[1], S[0]]);
    var Z = GJ(q, s, F), le = Z.scale, te = Z.realScaleType;
    le.domain(p).range(S), UJ(le);
    var U = ZJ(le, $n($n({}, q), {}, {
      realScaleType: te
    }));
    n === "xAxis" ? (E = f === "top" && !y || f === "bottom" && y, N = i.left, O = c[A] - E * q.height) : n === "yAxis" && (E = f === "left" && !y || f === "right" && y, N = c[A] - E * q.width, O = i.top);
    var de = $n($n($n({}, q), U), {}, {
      realScaleType: te,
      x: N,
      y: O,
      scale: le,
      width: n === "xAxis" ? i.width : q.width,
      height: n === "yAxis" ? i.height : q.height
    });
    return de.bandSize = RX(de, U), !q.hide && n === "xAxis" ? c[A] += (E ? -1 : 1) * de.height : q.hide || (c[A] += (E ? -1 : 1) * de.width), $n($n({}, X), {}, Af({}, Y, de));
  }, {});
}, w$ = function(r, t) {
  var i = r.x, n = r.y, s = t.x, u = t.y;
  return {
    x: Math.min(i, s),
    y: Math.min(n, u),
    width: Math.abs(s - i),
    height: Math.abs(u - n)
  };
}, wDe = function(r) {
  var t = r.x1, i = r.y1, n = r.x2, s = r.y2;
  return w$({
    x: t,
    y: i
  }, {
    x: n,
    y: s
  });
}, C$ = /* @__PURE__ */ function() {
  function e(r) {
    vDe(this, e), this.scale = r;
  }
  return bDe(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(t) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = i.bandAware, s = i.position;
      if (t !== void 0) {
        if (s)
          switch (s) {
            case "start":
              return this.scale(t);
            case "middle": {
              var u = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(t) + u;
            }
            case "end": {
              var o = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(t) + o;
            }
            default:
              return this.scale(t);
          }
        if (n) {
          var d = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(t) + d;
        }
        return this.scale(t);
      }
    }
  }, {
    key: "isInRange",
    value: function(t) {
      var i = this.range(), n = i[0], s = i[i.length - 1];
      return n <= s ? t >= n && t <= s : t >= s && t <= n;
    }
  }], [{
    key: "create",
    value: function(t) {
      return new e(t);
    }
  }]);
}();
Af(C$, "EPS", 1e-4);
var p4 = function(r) {
  var t = Object.keys(r).reduce(function(i, n) {
    return $n($n({}, i), {}, Af({}, n, C$.create(r[n])));
  }, {});
  return $n($n({}, t), {}, {
    apply: function(n) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, u = s.bandAware, o = s.position;
      return rDe(n, function(d, a) {
        return t[a].apply(d, {
          bandAware: u,
          position: o
        });
      });
    },
    isInRange: function(n) {
      return g$(n, function(s, u) {
        return t[u].isInRange(s);
      });
    }
  });
};
function CDe(e) {
  return (e % 180 + 180) % 180;
}
var PDe = function(r) {
  var t = r.width, i = r.height, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, s = CDe(n), u = s * Math.PI / 180, o = Math.atan(i / t), d = u > o && u < Math.PI - o ? i / Math.sin(u) : t / Math.cos(u);
  return Math.abs(d);
}, Fg, Mk;
function SDe() {
  if (Mk) return Fg;
  Mk = 1;
  var e = ru(), r = P2(), t = sf();
  function i(n) {
    return function(s, u, o) {
      var d = Object(s);
      if (!r(s)) {
        var a = e(u, 3);
        s = t(s), u = function(c) {
          return a(d[c], c, d);
        };
      }
      var V = n(s, u, o);
      return V > -1 ? d[a ? s[V] : V] : void 0;
    };
  }
  return Fg = i, Fg;
}
var xg, Tk;
function NDe() {
  if (Tk) return xg;
  Tk = 1;
  var e = K$();
  function r(t) {
    var i = e(t), n = i % 1;
    return i === i ? n ? i - n : i : 0;
  }
  return xg = r, xg;
}
var Xg, Ek;
function MDe() {
  if (Ek) return Xg;
  Ek = 1;
  var e = wZ(), r = ru(), t = NDe(), i = Math.max;
  function n(s, u, o) {
    var d = s == null ? 0 : s.length;
    if (!d)
      return -1;
    var a = o == null ? 0 : t(o);
    return a < 0 && (a = i(d + a, 0)), e(s, r(u, 3), a);
  }
  return Xg = n, Xg;
}
var qg, kk;
function TDe() {
  if (kk) return qg;
  kk = 1;
  var e = SDe(), r = MDe(), t = e(r);
  return qg = t, qg;
}
var EDe = TDe();
const kDe = /* @__PURE__ */ Mr(EDe);
var ODe = jU();
const DDe = /* @__PURE__ */ Mr(ODe);
var RDe = DDe(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function nq(e) {
  "@babel/helpers - typeof";
  return nq = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, nq(e);
}
var m4 = /* @__PURE__ */ et(void 0), g4 = /* @__PURE__ */ et(void 0), P$ = /* @__PURE__ */ et(void 0), S$ = /* @__PURE__ */ et({}), N$ = /* @__PURE__ */ et(void 0), M$ = /* @__PURE__ */ et(0), T$ = /* @__PURE__ */ et(0), Ok = function(r) {
  var t = r.state, i = t.xAxisMap, n = t.yAxisMap, s = t.offset, u = r.clipPathId, o = r.children, d = r.width, a = r.height, V = RDe(s);
  return /* @__PURE__ */ D.createElement(m4.Provider, {
    value: i
  }, /* @__PURE__ */ D.createElement(g4.Provider, {
    value: n
  }, /* @__PURE__ */ D.createElement(S$.Provider, {
    value: s
  }, /* @__PURE__ */ D.createElement(P$.Provider, {
    value: V
  }, /* @__PURE__ */ D.createElement(N$.Provider, {
    value: u
  }, /* @__PURE__ */ D.createElement(M$.Provider, {
    value: a
  }, /* @__PURE__ */ D.createElement(T$.Provider, {
    value: d
  }, o)))))));
}, IDe = function() {
  return rt(N$);
};
function E$(e) {
  var r = Object.keys(e);
  return r.length === 0 ? "There are no available ids." : "Available ids are: ".concat(r, ".");
}
var k$ = function(r) {
  var t = rt(m4);
  t == null && (process.env.NODE_ENV !== "production" ? _i(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : _i());
  var i = t[r];
  return i == null && (process.env.NODE_ENV !== "production" ? _i(!1, 'Could not find xAxis by id "'.concat(r, '" [').concat(nq(r), "]. ").concat(E$(t))) : _i()), i;
}, LDe = function() {
  var r = rt(m4);
  return po(r);
}, _De = function() {
  var r = rt(g4), t = kDe(r, function(i) {
    return g$(i.domain, Number.isFinite);
  });
  return t || po(r);
}, O$ = function(r) {
  var t = rt(g4);
  t == null && (process.env.NODE_ENV !== "production" ? _i(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : _i());
  var i = t[r];
  return i == null && (process.env.NODE_ENV !== "production" ? _i(!1, 'Could not find yAxis by id "'.concat(r, '" [').concat(nq(r), "]. ").concat(E$(t))) : _i()), i;
}, HDe = function() {
  var r = rt(P$);
  return r;
}, jDe = function() {
  return rt(S$);
}, v4 = function() {
  return rt(T$);
}, b4 = function() {
  return rt(M$);
};
function el(e) {
  "@babel/helpers - typeof";
  return el = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, el(e);
}
function zDe(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function BDe(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, R$(i.key), i);
  }
}
function WDe(e, r, t) {
  return r && BDe(e.prototype, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function GDe(e, r, t) {
  return r = sq(r), UDe(e, D$() ? Reflect.construct(r, t || [], sq(e).constructor) : r.apply(e, t));
}
function UDe(e, r) {
  if (r && (el(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ZDe(e);
}
function ZDe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function D$() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (D$ = function() {
    return !!e;
  })();
}
function sq(e) {
  return sq = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, sq(e);
}
function JDe(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && yb(e, r);
}
function yb(e, r) {
  return yb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, yb(e, r);
}
function Dk(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function Rk(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Dk(Object(t), !0).forEach(function(i) {
      y4(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Dk(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function y4(e, r, t) {
  return r = R$(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function R$(e) {
  var r = $De(e, "string");
  return el(r) == "symbol" ? r : r + "";
}
function $De(e, r) {
  if (el(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (el(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function QDe(e, r) {
  return iRe(e) || tRe(e, r) || rRe(e, r) || eRe();
}
function eRe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rRe(e, r) {
  if (e) {
    if (typeof e == "string") return Ik(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Ik(e, r);
  }
}
function Ik(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
function tRe(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var i, n, s, u, o = [], d = !0, a = !1;
    try {
      if (s = (t = t.call(e)).next, r !== 0) for (; !(d = (i = s.call(t)).done) && (o.push(i.value), o.length !== r); d = !0) ;
    } catch (V) {
      a = !0, n = V;
    } finally {
      try {
        if (!d && t.return != null && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (a) throw n;
      }
    }
    return o;
  }
}
function iRe(e) {
  if (Array.isArray(e)) return e;
}
function Ab() {
  return Ab = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Ab.apply(this, arguments);
}
var nRe = function(r, t) {
  var i;
  return /* @__PURE__ */ D.isValidElement(r) ? i = /* @__PURE__ */ D.cloneElement(r, t) : Ue(r) ? i = r(t) : i = /* @__PURE__ */ D.createElement("line", Ab({}, t, {
    className: "recharts-reference-line-line"
  })), i;
}, sRe = function(r, t, i, n, s, u, o, d, a) {
  var V = s.x, c = s.y, F = s.width, X = s.height;
  if (i) {
    var Y = a.y, q = r.y.apply(Y, {
      position: u
    });
    if (Rs(a, "discard") && !r.y.isInRange(q))
      return null;
    var f = [{
      x: V + F,
      y: q
    }, {
      x: V,
      y: q
    }];
    return d === "left" ? f.reverse() : f;
  }
  if (t) {
    var p = a.x, m = r.x.apply(p, {
      position: u
    });
    if (Rs(a, "discard") && !r.x.isInRange(m))
      return null;
    var g = [{
      x: m,
      y: c + X
    }, {
      x: m,
      y: c
    }];
    return o === "top" ? g.reverse() : g;
  }
  if (n) {
    var y = a.segment, b = y.map(function(A) {
      return r.apply(A, {
        position: u
      });
    });
    return Rs(a, "discard") && JOe(b, function(A) {
      return !r.isInRange(A);
    }) ? null : b;
  }
  return null;
};
function uRe(e) {
  var r = e.x, t = e.y, i = e.segment, n = e.xAxisId, s = e.yAxisId, u = e.shape, o = e.className, d = e.alwaysShow, a = IDe(), V = k$(n), c = O$(s), F = HDe();
  if (!a || !F)
    return null;
  Su(d === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var X = p4({
    x: V.scale,
    y: c.scale
  }), Y = Mt(r), q = Mt(t), f = i && i.length === 2, p = sRe(X, Y, q, f, F, e.position, V.orientation, c.orientation, e);
  if (!p)
    return null;
  var m = QDe(p, 2), g = m[0], y = g.x, b = g.y, A = m[1], w = A.x, S = A.y, N = Rs(e, "hidden") ? "url(#".concat(a, ")") : void 0, O = Rk(Rk({
    clipPath: N
  }, _e(e, !0)), {}, {
    x1: y,
    y1: b,
    x2: w,
    y2: S
  });
  return /* @__PURE__ */ D.createElement(Hr, {
    className: ur("recharts-reference-line", o)
  }, nRe(u, O), Qt.renderCallByParent(e, wDe({
    x1: y,
    y1: b,
    x2: w,
    y2: S
  })));
}
var A4 = /* @__PURE__ */ function(e) {
  function r() {
    return zDe(this, r), GDe(this, r, arguments);
  }
  return JDe(r, e), WDe(r, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ D.createElement(uRe, this.props);
    }
  }]);
}(D.Component);
y4(A4, "displayName", "ReferenceLine");
y4(A4, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function wb() {
  return wb = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, wb.apply(this, arguments);
}
function rl(e) {
  "@babel/helpers - typeof";
  return rl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, rl(e);
}
function Lk(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function _k(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Lk(Object(t), !0).forEach(function(i) {
      wf(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Lk(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function oRe(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function dRe(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, L$(i.key), i);
  }
}
function aRe(e, r, t) {
  return r && dRe(e.prototype, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function VRe(e, r, t) {
  return r = uq(r), lRe(e, I$() ? Reflect.construct(r, t || [], uq(e).constructor) : r.apply(e, t));
}
function lRe(e, r) {
  if (r && (rl(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return cRe(e);
}
function cRe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function I$() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (I$ = function() {
    return !!e;
  })();
}
function uq(e) {
  return uq = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, uq(e);
}
function FRe(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && Cb(e, r);
}
function Cb(e, r) {
  return Cb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, Cb(e, r);
}
function wf(e, r, t) {
  return r = L$(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function L$(e) {
  var r = xRe(e, "string");
  return rl(r) == "symbol" ? r : r + "";
}
function xRe(e, r) {
  if (rl(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (rl(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var XRe = function(r) {
  var t = r.x, i = r.y, n = r.xAxis, s = r.yAxis, u = p4({
    x: n.scale,
    y: s.scale
  }), o = u.apply({
    x: t,
    y: i
  }, {
    bandAware: !0
  });
  return Rs(r, "discard") && !u.isInRange(o) ? null : o;
}, Cf = /* @__PURE__ */ function(e) {
  function r() {
    return oRe(this, r), VRe(this, r, arguments);
  }
  return FRe(r, e), aRe(r, [{
    key: "render",
    value: function() {
      var i = this.props, n = i.x, s = i.y, u = i.r, o = i.alwaysShow, d = i.clipPathId, a = Mt(n), V = Mt(s);
      if (Su(o === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !a || !V)
        return null;
      var c = XRe(this.props);
      if (!c)
        return null;
      var F = c.x, X = c.y, Y = this.props, q = Y.shape, f = Y.className, p = Rs(this.props, "hidden") ? "url(#".concat(d, ")") : void 0, m = _k(_k({
        clipPath: p
      }, _e(this.props, !0)), {}, {
        cx: F,
        cy: X
      });
      return /* @__PURE__ */ D.createElement(Hr, {
        className: ur("recharts-reference-dot", f)
      }, r.renderDot(q, m), Qt.renderCallByParent(this.props, {
        x: F - u,
        y: X - u,
        width: 2 * u,
        height: 2 * u
      }));
    }
  }]);
}(D.Component);
wf(Cf, "displayName", "ReferenceDot");
wf(Cf, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
wf(Cf, "renderDot", function(e, r) {
  var t;
  return /* @__PURE__ */ D.isValidElement(e) ? t = /* @__PURE__ */ D.cloneElement(e, r) : Ue(e) ? t = e(r) : t = /* @__PURE__ */ D.createElement(pf, wb({}, r, {
    cx: r.cx,
    cy: r.cy,
    className: "recharts-reference-dot-dot"
  })), t;
});
function Pb() {
  return Pb = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Pb.apply(this, arguments);
}
function tl(e) {
  "@babel/helpers - typeof";
  return tl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, tl(e);
}
function Hk(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function jk(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Hk(Object(t), !0).forEach(function(i) {
      Pf(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Hk(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function qRe(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function YRe(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, H$(i.key), i);
  }
}
function fRe(e, r, t) {
  return r && YRe(e.prototype, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function KRe(e, r, t) {
  return r = oq(r), hRe(e, _$() ? Reflect.construct(r, t || [], oq(e).constructor) : r.apply(e, t));
}
function hRe(e, r) {
  if (r && (tl(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return pRe(e);
}
function pRe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _$() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_$ = function() {
    return !!e;
  })();
}
function oq(e) {
  return oq = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, oq(e);
}
function mRe(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && Sb(e, r);
}
function Sb(e, r) {
  return Sb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, Sb(e, r);
}
function Pf(e, r, t) {
  return r = H$(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function H$(e) {
  var r = gRe(e, "string");
  return tl(r) == "symbol" ? r : r + "";
}
function gRe(e, r) {
  if (tl(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (tl(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var vRe = function(r, t, i, n, s) {
  var u = s.x1, o = s.x2, d = s.y1, a = s.y2, V = s.xAxis, c = s.yAxis;
  if (!V || !c) return null;
  var F = p4({
    x: V.scale,
    y: c.scale
  }), X = {
    x: r ? F.x.apply(u, {
      position: "start"
    }) : F.x.rangeMin,
    y: i ? F.y.apply(d, {
      position: "start"
    }) : F.y.rangeMin
  }, Y = {
    x: t ? F.x.apply(o, {
      position: "end"
    }) : F.x.rangeMax,
    y: n ? F.y.apply(a, {
      position: "end"
    }) : F.y.rangeMax
  };
  return Rs(s, "discard") && (!F.isInRange(X) || !F.isInRange(Y)) ? null : w$(X, Y);
}, Sf = /* @__PURE__ */ function(e) {
  function r() {
    return qRe(this, r), KRe(this, r, arguments);
  }
  return mRe(r, e), fRe(r, [{
    key: "render",
    value: function() {
      var i = this.props, n = i.x1, s = i.x2, u = i.y1, o = i.y2, d = i.className, a = i.alwaysShow, V = i.clipPathId;
      Su(a === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var c = Mt(n), F = Mt(s), X = Mt(u), Y = Mt(o), q = this.props.shape;
      if (!c && !F && !X && !Y && !q)
        return null;
      var f = vRe(c, F, X, Y, this.props);
      if (!f && !q)
        return null;
      var p = Rs(this.props, "hidden") ? "url(#".concat(V, ")") : void 0;
      return /* @__PURE__ */ D.createElement(Hr, {
        className: ur("recharts-reference-area", d)
      }, r.renderRect(q, jk(jk({
        clipPath: p
      }, _e(this.props, !0)), f)), Qt.renderCallByParent(this.props, f));
    }
  }]);
}(D.Component);
Pf(Sf, "displayName", "ReferenceArea");
Pf(Sf, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
Pf(Sf, "renderRect", function(e, r) {
  var t;
  return /* @__PURE__ */ D.isValidElement(e) ? t = /* @__PURE__ */ D.cloneElement(e, r) : Ue(e) ? t = e(r) : t = /* @__PURE__ */ D.createElement(K4, Pb({}, r, {
    className: "recharts-reference-area-rect"
  })), t;
});
function j$(e, r, t) {
  if (r < 1)
    return [];
  if (r === 1 && t === void 0)
    return e;
  for (var i = [], n = 0; n < e.length; n += r)
    i.push(e[n]);
  return i;
}
function bRe(e, r, t) {
  var i = {
    width: e.width + r.width,
    height: e.height + r.height
  };
  return PDe(i, t);
}
function yRe(e, r, t) {
  var i = t === "width", n = e.x, s = e.y, u = e.width, o = e.height;
  return r === 1 ? {
    start: i ? n : s,
    end: i ? n + u : s + o
  } : {
    start: i ? n + u : s + o,
    end: i ? n : s
  };
}
function dq(e, r, t, i, n) {
  if (e * r < e * i || e * r > e * n)
    return !1;
  var s = t();
  return e * (r - e * s / 2 - i) >= 0 && e * (r + e * s / 2 - n) <= 0;
}
function ARe(e, r) {
  return j$(e, r + 1);
}
function wRe(e, r, t, i, n) {
  for (var s = (i || []).slice(), u = r.start, o = r.end, d = 0, a = 1, V = u, c = function() {
    var Y = i == null ? void 0 : i[d];
    if (Y === void 0)
      return {
        v: j$(i, a)
      };
    var q = d, f, p = function() {
      return f === void 0 && (f = t(Y, q)), f;
    }, m = Y.coordinate, g = d === 0 || dq(e, m, p, V, o);
    g || (d = 0, V = u, a += 1), g && (V = m + e * (p() / 2 + n), d += a);
  }, F; a <= s.length; )
    if (F = c(), F) return F.v;
  return [];
}
function D7(e) {
  "@babel/helpers - typeof";
  return D7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, D7(e);
}
function zk(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function li(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? zk(Object(t), !0).forEach(function(i) {
      CRe(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : zk(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function CRe(e, r, t) {
  return r = PRe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function PRe(e) {
  var r = SRe(e, "string");
  return D7(r) == "symbol" ? r : r + "";
}
function SRe(e, r) {
  if (D7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (D7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function NRe(e, r, t, i, n) {
  for (var s = (i || []).slice(), u = s.length, o = r.start, d = r.end, a = function(F) {
    var X = s[F], Y, q = function() {
      return Y === void 0 && (Y = t(X, F)), Y;
    };
    if (F === u - 1) {
      var f = e * (X.coordinate + e * q() / 2 - d);
      s[F] = X = li(li({}, X), {}, {
        tickCoord: f > 0 ? X.coordinate - f * e : X.coordinate
      });
    } else
      s[F] = X = li(li({}, X), {}, {
        tickCoord: X.coordinate
      });
    var p = dq(e, X.tickCoord, q, o, d);
    p && (d = X.tickCoord - e * (q() / 2 + n), s[F] = li(li({}, X), {}, {
      isShow: !0
    }));
  }, V = u - 1; V >= 0; V--)
    a(V);
  return s;
}
function MRe(e, r, t, i, n, s) {
  var u = (i || []).slice(), o = u.length, d = r.start, a = r.end;
  if (s) {
    var V = i[o - 1], c = t(V, o - 1), F = e * (V.coordinate + e * c / 2 - a);
    u[o - 1] = V = li(li({}, V), {}, {
      tickCoord: F > 0 ? V.coordinate - F * e : V.coordinate
    });
    var X = dq(e, V.tickCoord, function() {
      return c;
    }, d, a);
    X && (a = V.tickCoord - e * (c / 2 + n), u[o - 1] = li(li({}, V), {}, {
      isShow: !0
    }));
  }
  for (var Y = s ? o - 1 : o, q = function(m) {
    var g = u[m], y, b = function() {
      return y === void 0 && (y = t(g, m)), y;
    };
    if (m === 0) {
      var A = e * (g.coordinate - e * b() / 2 - d);
      u[m] = g = li(li({}, g), {}, {
        tickCoord: A < 0 ? g.coordinate - A * e : g.coordinate
      });
    } else
      u[m] = g = li(li({}, g), {}, {
        tickCoord: g.coordinate
      });
    var w = dq(e, g.tickCoord, b, d, a);
    w && (d = g.tickCoord + e * (b() / 2 + n), u[m] = li(li({}, g), {}, {
      isShow: !0
    }));
  }, f = 0; f < Y; f++)
    q(f);
  return u;
}
function w4(e, r, t) {
  var i = e.tick, n = e.ticks, s = e.viewBox, u = e.minTickGap, o = e.orientation, d = e.interval, a = e.tickFormatter, V = e.unit, c = e.angle;
  if (!n || !n.length || !i)
    return [];
  if (pe(d) || Ml.isSsr)
    return ARe(n, typeof d == "number" && pe(d) ? d : 0);
  var F = [], X = o === "top" || o === "bottom" ? "width" : "height", Y = V && X === "width" ? Dc(V, {
    fontSize: r,
    letterSpacing: t
  }) : {
    width: 0,
    height: 0
  }, q = function(g, y) {
    var b = Ue(a) ? a(g.value, y) : g.value;
    return X === "width" ? bRe(Dc(b, {
      fontSize: r,
      letterSpacing: t
    }), Y, c) : Dc(b, {
      fontSize: r,
      letterSpacing: t
    })[X];
  }, f = n.length >= 2 ? ts(n[1].coordinate - n[0].coordinate) : 1, p = yRe(s, f, X);
  return d === "equidistantPreserveStart" ? wRe(f, p, q, n, u) : (d === "preserveStart" || d === "preserveStartEnd" ? F = MRe(f, p, q, n, u, d === "preserveStartEnd") : F = NRe(f, p, q, n, u), F.filter(function(m) {
    return m.isShow;
  }));
}
var TRe = ["viewBox"], ERe = ["viewBox"], kRe = ["ticks"];
function il(e) {
  "@babel/helpers - typeof";
  return il = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, il(e);
}
function nV() {
  return nV = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, nV.apply(this, arguments);
}
function Bk(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function bi(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Bk(Object(t), !0).forEach(function(i) {
      C4(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Bk(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function Yg(e, r) {
  if (e == null) return {};
  var t = ORe(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function ORe(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
function DRe(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function Wk(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, B$(i.key), i);
  }
}
function RRe(e, r, t) {
  return r && Wk(e.prototype, r), t && Wk(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function IRe(e, r, t) {
  return r = aq(r), LRe(e, z$() ? Reflect.construct(r, t || [], aq(e).constructor) : r.apply(e, t));
}
function LRe(e, r) {
  if (r && (il(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _Re(e);
}
function _Re(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function z$() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (z$ = function() {
    return !!e;
  })();
}
function aq(e) {
  return aq = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, aq(e);
}
function HRe(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && Nb(e, r);
}
function Nb(e, r) {
  return Nb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, Nb(e, r);
}
function C4(e, r, t) {
  return r = B$(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function B$(e) {
  var r = jRe(e, "string");
  return il(r) == "symbol" ? r : r + "";
}
function jRe(e, r) {
  if (il(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (il(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Rl = /* @__PURE__ */ function(e) {
  function r(t) {
    var i;
    return DRe(this, r), i = IRe(this, r, [t]), i.state = {
      fontSize: "",
      letterSpacing: ""
    }, i;
  }
  return HRe(r, e), RRe(r, [{
    key: "shouldComponentUpdate",
    value: function(i, n) {
      var s = i.viewBox, u = Yg(i, TRe), o = this.props, d = o.viewBox, a = Yg(o, ERe);
      return !fV(s, d) || !fV(u, a) || !fV(n, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var i = this.layerReference;
      if (i) {
        var n = i.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        n && this.setState({
          fontSize: window.getComputedStyle(n).fontSize,
          letterSpacing: window.getComputedStyle(n).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(i) {
      var n = this.props, s = n.x, u = n.y, o = n.width, d = n.height, a = n.orientation, V = n.tickSize, c = n.mirror, F = n.tickMargin, X, Y, q, f, p, m, g = c ? -1 : 1, y = i.tickSize || V, b = pe(i.tickCoord) ? i.tickCoord : i.coordinate;
      switch (a) {
        case "top":
          X = Y = i.coordinate, f = u + +!c * d, q = f - g * y, m = q - g * F, p = b;
          break;
        case "left":
          q = f = i.coordinate, Y = s + +!c * o, X = Y - g * y, p = X - g * F, m = b;
          break;
        case "right":
          q = f = i.coordinate, Y = s + +c * o, X = Y + g * y, p = X + g * F, m = b;
          break;
        default:
          X = Y = i.coordinate, f = u + +c * d, q = f + g * y, m = q + g * F, p = b;
          break;
      }
      return {
        line: {
          x1: X,
          y1: q,
          x2: Y,
          y2: f
        },
        tick: {
          x: p,
          y: m
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var i = this.props, n = i.orientation, s = i.mirror, u;
      switch (n) {
        case "left":
          u = s ? "start" : "end";
          break;
        case "right":
          u = s ? "end" : "start";
          break;
        default:
          u = "middle";
          break;
      }
      return u;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var i = this.props, n = i.orientation, s = i.mirror, u = "end";
      switch (n) {
        case "left":
        case "right":
          u = "middle";
          break;
        case "top":
          u = s ? "start" : "end";
          break;
        default:
          u = s ? "end" : "start";
          break;
      }
      return u;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var i = this.props, n = i.x, s = i.y, u = i.width, o = i.height, d = i.orientation, a = i.mirror, V = i.axisLine, c = bi(bi(bi({}, _e(this.props, !1)), _e(V, !1)), {}, {
        fill: "none"
      });
      if (d === "top" || d === "bottom") {
        var F = +(d === "top" && !a || d === "bottom" && a);
        c = bi(bi({}, c), {}, {
          x1: n,
          y1: s + F * o,
          x2: n + u,
          y2: s + F * o
        });
      } else {
        var X = +(d === "left" && !a || d === "right" && a);
        c = bi(bi({}, c), {}, {
          x1: n + X * u,
          y1: s,
          x2: n + X * u,
          y2: s + o
        });
      }
      return /* @__PURE__ */ D.createElement("line", nV({}, c, {
        className: ur("recharts-cartesian-axis-line", Mn(V, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(i, n, s) {
        var u = this, o = this.props, d = o.tickLine, a = o.stroke, V = o.tick, c = o.tickFormatter, F = o.unit, X = w4(bi(bi({}, this.props), {}, {
          ticks: i
        }), n, s), Y = this.getTickTextAnchor(), q = this.getTickVerticalAnchor(), f = _e(this.props, !1), p = _e(V, !1), m = bi(bi({}, f), {}, {
          fill: "none"
        }, _e(d, !1)), g = X.map(function(y, b) {
          var A = u.getTickLineCoord(y), w = A.line, S = A.tick, N = bi(bi(bi(bi({
            textAnchor: Y,
            verticalAnchor: q
          }, f), {}, {
            stroke: "none",
            fill: a
          }, p), S), {}, {
            index: b,
            payload: y,
            visibleTicksCount: X.length,
            tickFormatter: c
          });
          return /* @__PURE__ */ D.createElement(Hr, nV({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(y.value, "-").concat(y.coordinate, "-").concat(y.tickCoord)
          }, EV(u.props, y, b)), d && /* @__PURE__ */ D.createElement("line", nV({}, m, w, {
            className: ur("recharts-cartesian-axis-tick-line", Mn(d, "className"))
          })), V && r.renderTickItem(V, N, "".concat(Ue(c) ? c(y.value, b) : y.value).concat(F || "")));
        });
        return /* @__PURE__ */ D.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, g);
      }
    )
  }, {
    key: "render",
    value: function() {
      var i = this, n = this.props, s = n.axisLine, u = n.width, o = n.height, d = n.ticksGenerator, a = n.className, V = n.hide;
      if (V)
        return null;
      var c = this.props, F = c.ticks, X = Yg(c, kRe), Y = F;
      return Ue(d) && (Y = F && F.length > 0 ? d(this.props) : d(X)), u <= 0 || o <= 0 || !Y || !Y.length ? null : /* @__PURE__ */ D.createElement(Hr, {
        className: ur("recharts-cartesian-axis", a),
        ref: function(f) {
          i.layerReference = f;
        }
      }, s && this.renderAxisLine(), this.renderTicks(Y, this.state.fontSize, this.state.letterSpacing), Qt.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(i, n, s) {
      var u;
      return /* @__PURE__ */ D.isValidElement(i) ? u = /* @__PURE__ */ D.cloneElement(i, n) : Ue(i) ? u = i(n) : u = /* @__PURE__ */ D.createElement(LV, nV({}, n, {
        className: "recharts-cartesian-axis-tick-value"
      }), s), u;
    }
  }]);
}(tR);
C4(Rl, "displayName", "CartesianAxis");
C4(Rl, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var zRe = ["x1", "y1", "x2", "y2", "key"], BRe = ["offset"];
function ra(e) {
  "@babel/helpers - typeof";
  return ra = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, ra(e);
}
function Gk(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function Fi(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Gk(Object(t), !0).forEach(function(i) {
      WRe(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Gk(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function WRe(e, r, t) {
  return r = GRe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function GRe(e) {
  var r = URe(e, "string");
  return ra(r) == "symbol" ? r : r + "";
}
function URe(e, r) {
  if (ra(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (ra(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function Sd() {
  return Sd = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Sd.apply(this, arguments);
}
function Uk(e, r) {
  if (e == null) return {};
  var t = ZRe(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function ZRe(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
var JRe = function(r) {
  var t = r.fill;
  if (!t || t === "none")
    return null;
  var i = r.fillOpacity, n = r.x, s = r.y, u = r.width, o = r.height, d = r.ry;
  return /* @__PURE__ */ D.createElement("rect", {
    x: n,
    y: s,
    ry: d,
    width: u,
    height: o,
    stroke: "none",
    fill: t,
    fillOpacity: i,
    className: "recharts-cartesian-grid-bg"
  });
};
function W$(e, r) {
  var t;
  if (/* @__PURE__ */ D.isValidElement(e))
    t = /* @__PURE__ */ D.cloneElement(e, r);
  else if (Ue(e))
    t = e(r);
  else {
    var i = r.x1, n = r.y1, s = r.x2, u = r.y2, o = r.key, d = Uk(r, zRe), a = _e(d, !1);
    a.offset;
    var V = Uk(a, BRe);
    t = /* @__PURE__ */ D.createElement("line", Sd({}, V, {
      x1: i,
      y1: n,
      x2: s,
      y2: u,
      fill: "none",
      key: o
    }));
  }
  return t;
}
function $Re(e) {
  var r = e.x, t = e.width, i = e.horizontal, n = i === void 0 ? !0 : i, s = e.horizontalPoints;
  if (!n || !s || !s.length)
    return null;
  var u = s.map(function(o, d) {
    var a = Fi(Fi({}, e), {}, {
      x1: r,
      y1: o,
      x2: r + t,
      y2: o,
      key: "line-".concat(d),
      index: d
    });
    return W$(n, a);
  });
  return /* @__PURE__ */ D.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, u);
}
function QRe(e) {
  var r = e.y, t = e.height, i = e.vertical, n = i === void 0 ? !0 : i, s = e.verticalPoints;
  if (!n || !s || !s.length)
    return null;
  var u = s.map(function(o, d) {
    var a = Fi(Fi({}, e), {}, {
      x1: o,
      y1: r,
      x2: o,
      y2: r + t,
      key: "line-".concat(d),
      index: d
    });
    return W$(n, a);
  });
  return /* @__PURE__ */ D.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, u);
}
function eIe(e) {
  var r = e.horizontalFill, t = e.fillOpacity, i = e.x, n = e.y, s = e.width, u = e.height, o = e.horizontalPoints, d = e.horizontal, a = d === void 0 ? !0 : d;
  if (!a || !r || !r.length)
    return null;
  var V = o.map(function(F) {
    return Math.round(F + n - n);
  }).sort(function(F, X) {
    return F - X;
  });
  n !== V[0] && V.unshift(0);
  var c = V.map(function(F, X) {
    var Y = !V[X + 1], q = Y ? n + u - F : V[X + 1] - F;
    if (q <= 0)
      return null;
    var f = X % r.length;
    return /* @__PURE__ */ D.createElement("rect", {
      key: "react-".concat(X),
      y: F,
      x: i,
      height: q,
      width: s,
      stroke: "none",
      fill: r[f],
      fillOpacity: t,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ D.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, c);
}
function rIe(e) {
  var r = e.vertical, t = r === void 0 ? !0 : r, i = e.verticalFill, n = e.fillOpacity, s = e.x, u = e.y, o = e.width, d = e.height, a = e.verticalPoints;
  if (!t || !i || !i.length)
    return null;
  var V = a.map(function(F) {
    return Math.round(F + s - s);
  }).sort(function(F, X) {
    return F - X;
  });
  s !== V[0] && V.unshift(0);
  var c = V.map(function(F, X) {
    var Y = !V[X + 1], q = Y ? s + o - F : V[X + 1] - F;
    if (q <= 0)
      return null;
    var f = X % i.length;
    return /* @__PURE__ */ D.createElement("rect", {
      key: "react-".concat(X),
      x: F,
      y: u,
      width: q,
      height: d,
      stroke: "none",
      fill: i[f],
      fillOpacity: n,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ D.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, c);
}
var tIe = function(r, t) {
  var i = r.xAxis, n = r.width, s = r.height, u = r.offset;
  return WJ(w4(Fi(Fi(Fi({}, Rl.defaultProps), i), {}, {
    ticks: Au(i, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: n,
      height: s
    }
  })), u.left, u.left + u.width, t);
}, iIe = function(r, t) {
  var i = r.yAxis, n = r.width, s = r.height, u = r.offset;
  return WJ(w4(Fi(Fi(Fi({}, Rl.defaultProps), i), {}, {
    ticks: Au(i, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: n,
      height: s
    }
  })), u.top, u.top + u.height, t);
}, Ua = {
  horizontal: !0,
  vertical: !0,
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function Gt(e) {
  var r, t, i, n, s, u, o = v4(), d = b4(), a = jDe(), V = Fi(Fi({}, e), {}, {
    stroke: (r = e.stroke) !== null && r !== void 0 ? r : Ua.stroke,
    fill: (t = e.fill) !== null && t !== void 0 ? t : Ua.fill,
    horizontal: (i = e.horizontal) !== null && i !== void 0 ? i : Ua.horizontal,
    horizontalFill: (n = e.horizontalFill) !== null && n !== void 0 ? n : Ua.horizontalFill,
    vertical: (s = e.vertical) !== null && s !== void 0 ? s : Ua.vertical,
    verticalFill: (u = e.verticalFill) !== null && u !== void 0 ? u : Ua.verticalFill,
    x: pe(e.x) ? e.x : a.left,
    y: pe(e.y) ? e.y : a.top,
    width: pe(e.width) ? e.width : a.width,
    height: pe(e.height) ? e.height : a.height
  }), c = V.x, F = V.y, X = V.width, Y = V.height, q = V.syncWithTicks, f = V.horizontalValues, p = V.verticalValues, m = LDe(), g = _De();
  if (!pe(X) || X <= 0 || !pe(Y) || Y <= 0 || !pe(c) || c !== +c || !pe(F) || F !== +F)
    return null;
  var y = V.verticalCoordinatesGenerator || tIe, b = V.horizontalCoordinatesGenerator || iIe, A = V.horizontalPoints, w = V.verticalPoints;
  if ((!A || !A.length) && Ue(b)) {
    var S = f && f.length, N = b({
      yAxis: g ? Fi(Fi({}, g), {}, {
        ticks: S ? f : g.ticks
      }) : void 0,
      width: o,
      height: d,
      offset: a
    }, S ? !0 : q);
    Su(Array.isArray(N), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(ra(N), "]")), Array.isArray(N) && (A = N);
  }
  if ((!w || !w.length) && Ue(y)) {
    var O = p && p.length, E = y({
      xAxis: m ? Fi(Fi({}, m), {}, {
        ticks: O ? p : m.ticks
      }) : void 0,
      width: o,
      height: d,
      offset: a
    }, O ? !0 : q);
    Su(Array.isArray(E), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(ra(E), "]")), Array.isArray(E) && (w = E);
  }
  return /* @__PURE__ */ D.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ D.createElement(JRe, {
    fill: V.fill,
    fillOpacity: V.fillOpacity,
    x: V.x,
    y: V.y,
    width: V.width,
    height: V.height,
    ry: V.ry
  }), /* @__PURE__ */ D.createElement($Re, Sd({}, V, {
    offset: a,
    horizontalPoints: A,
    xAxis: m,
    yAxis: g
  })), /* @__PURE__ */ D.createElement(QRe, Sd({}, V, {
    offset: a,
    verticalPoints: w,
    xAxis: m,
    yAxis: g
  })), /* @__PURE__ */ D.createElement(eIe, Sd({}, V, {
    horizontalPoints: A
  })), /* @__PURE__ */ D.createElement(rIe, Sd({}, V, {
    verticalPoints: w
  })));
}
Gt.displayName = "CartesianGrid";
function nl(e) {
  "@babel/helpers - typeof";
  return nl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, nl(e);
}
function nIe(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function sIe(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, Z$(i.key), i);
  }
}
function uIe(e, r, t) {
  return r && sIe(e.prototype, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function oIe(e, r, t) {
  return r = Vq(r), dIe(e, G$() ? Reflect.construct(r, t || [], Vq(e).constructor) : r.apply(e, t));
}
function dIe(e, r) {
  if (r && (nl(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return aIe(e);
}
function aIe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function G$() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (G$ = function() {
    return !!e;
  })();
}
function Vq(e) {
  return Vq = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Vq(e);
}
function VIe(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && Mb(e, r);
}
function Mb(e, r) {
  return Mb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, Mb(e, r);
}
function U$(e, r, t) {
  return r = Z$(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Z$(e) {
  var r = lIe(e, "string");
  return nl(r) == "symbol" ? r : r + "";
}
function lIe(e, r) {
  if (nl(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (nl(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Tb() {
  return Tb = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Tb.apply(this, arguments);
}
function cIe(e) {
  var r = e.xAxisId, t = v4(), i = b4(), n = k$(r);
  return n == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ D.createElement(Rl, Tb({}, n, {
      className: ur("recharts-".concat(n.axisType, " ").concat(n.axisType), n.className),
      viewBox: {
        x: 0,
        y: 0,
        width: t,
        height: i
      },
      ticksGenerator: function(u) {
        return Au(u, !0);
      }
    }))
  );
}
var pt = /* @__PURE__ */ function(e) {
  function r() {
    return nIe(this, r), oIe(this, r, arguments);
  }
  return VIe(r, e), uIe(r, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ D.createElement(cIe, this.props);
    }
  }]);
}(D.Component);
U$(pt, "displayName", "XAxis");
U$(pt, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function sl(e) {
  "@babel/helpers - typeof";
  return sl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, sl(e);
}
function FIe(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function xIe(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, Q$(i.key), i);
  }
}
function XIe(e, r, t) {
  return r && xIe(e.prototype, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function qIe(e, r, t) {
  return r = lq(r), YIe(e, J$() ? Reflect.construct(r, t || [], lq(e).constructor) : r.apply(e, t));
}
function YIe(e, r) {
  if (r && (sl(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return fIe(e);
}
function fIe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function J$() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (J$ = function() {
    return !!e;
  })();
}
function lq(e) {
  return lq = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, lq(e);
}
function KIe(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && Eb(e, r);
}
function Eb(e, r) {
  return Eb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, Eb(e, r);
}
function $$(e, r, t) {
  return r = Q$(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Q$(e) {
  var r = hIe(e, "string");
  return sl(r) == "symbol" ? r : r + "";
}
function hIe(e, r) {
  if (sl(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (sl(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function kb() {
  return kb = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, kb.apply(this, arguments);
}
var pIe = function(r) {
  var t = r.yAxisId, i = v4(), n = b4(), s = O$(t);
  return s == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ D.createElement(Rl, kb({}, s, {
      className: ur("recharts-".concat(s.axisType, " ").concat(s.axisType), s.className),
      viewBox: {
        x: 0,
        y: 0,
        width: i,
        height: n
      },
      ticksGenerator: function(o) {
        return Au(o, !0);
      }
    }))
  );
}, mt = /* @__PURE__ */ function(e) {
  function r() {
    return FIe(this, r), qIe(this, r, arguments);
  }
  return KIe(r, e), XIe(r, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ D.createElement(pIe, this.props);
    }
  }]);
}(D.Component);
$$(mt, "displayName", "YAxis");
$$(mt, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function Zk(e) {
  return bIe(e) || vIe(e) || gIe(e) || mIe();
}
function mIe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gIe(e, r) {
  if (e) {
    if (typeof e == "string") return Ob(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Ob(e, r);
  }
}
function vIe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function bIe(e) {
  if (Array.isArray(e)) return Ob(e);
}
function Ob(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
var Db = function(r, t, i, n, s) {
  var u = ss(r, A4), o = ss(r, Cf), d = [].concat(Zk(u), Zk(o)), a = ss(r, Sf), V = "".concat(n, "Id"), c = n[0], F = t;
  if (d.length && (F = d.reduce(function(q, f) {
    if (f.props[V] === i && Rs(f.props, "extendDomain") && pe(f.props[c])) {
      var p = f.props[c];
      return [Math.min(q[0], p), Math.max(q[1], p)];
    }
    return q;
  }, F)), a.length) {
    var X = "".concat(c, "1"), Y = "".concat(c, "2");
    F = a.reduce(function(q, f) {
      if (f.props[V] === i && Rs(f.props, "extendDomain") && pe(f.props[X]) && pe(f.props[Y])) {
        var p = f.props[X], m = f.props[Y];
        return [Math.min(q[0], p, m), Math.max(q[1], p, m)];
      }
      return q;
    }, F);
  }
  return s && s.length && (F = s.reduce(function(q, f) {
    return pe(f) ? [Math.min(q[0], f), Math.max(q[1], f)] : q;
  }, F)), F;
}, fg = { exports: {} }, Jk;
function yIe() {
  return Jk || (Jk = 1, function(e) {
    var r = Object.prototype.hasOwnProperty, t = "~";
    function i() {
    }
    Object.create && (i.prototype = /* @__PURE__ */ Object.create(null), new i().__proto__ || (t = !1));
    function n(d, a, V) {
      this.fn = d, this.context = a, this.once = V || !1;
    }
    function s(d, a, V, c, F) {
      if (typeof V != "function")
        throw new TypeError("The listener must be a function");
      var X = new n(V, c || d, F), Y = t ? t + a : a;
      return d._events[Y] ? d._events[Y].fn ? d._events[Y] = [d._events[Y], X] : d._events[Y].push(X) : (d._events[Y] = X, d._eventsCount++), d;
    }
    function u(d, a) {
      --d._eventsCount === 0 ? d._events = new i() : delete d._events[a];
    }
    function o() {
      this._events = new i(), this._eventsCount = 0;
    }
    o.prototype.eventNames = function() {
      var a = [], V, c;
      if (this._eventsCount === 0) return a;
      for (c in V = this._events)
        r.call(V, c) && a.push(t ? c.slice(1) : c);
      return Object.getOwnPropertySymbols ? a.concat(Object.getOwnPropertySymbols(V)) : a;
    }, o.prototype.listeners = function(a) {
      var V = t ? t + a : a, c = this._events[V];
      if (!c) return [];
      if (c.fn) return [c.fn];
      for (var F = 0, X = c.length, Y = new Array(X); F < X; F++)
        Y[F] = c[F].fn;
      return Y;
    }, o.prototype.listenerCount = function(a) {
      var V = t ? t + a : a, c = this._events[V];
      return c ? c.fn ? 1 : c.length : 0;
    }, o.prototype.emit = function(a, V, c, F, X, Y) {
      var q = t ? t + a : a;
      if (!this._events[q]) return !1;
      var f = this._events[q], p = arguments.length, m, g;
      if (f.fn) {
        switch (f.once && this.removeListener(a, f.fn, void 0, !0), p) {
          case 1:
            return f.fn.call(f.context), !0;
          case 2:
            return f.fn.call(f.context, V), !0;
          case 3:
            return f.fn.call(f.context, V, c), !0;
          case 4:
            return f.fn.call(f.context, V, c, F), !0;
          case 5:
            return f.fn.call(f.context, V, c, F, X), !0;
          case 6:
            return f.fn.call(f.context, V, c, F, X, Y), !0;
        }
        for (g = 1, m = new Array(p - 1); g < p; g++)
          m[g - 1] = arguments[g];
        f.fn.apply(f.context, m);
      } else {
        var y = f.length, b;
        for (g = 0; g < y; g++)
          switch (f[g].once && this.removeListener(a, f[g].fn, void 0, !0), p) {
            case 1:
              f[g].fn.call(f[g].context);
              break;
            case 2:
              f[g].fn.call(f[g].context, V);
              break;
            case 3:
              f[g].fn.call(f[g].context, V, c);
              break;
            case 4:
              f[g].fn.call(f[g].context, V, c, F);
              break;
            default:
              if (!m) for (b = 1, m = new Array(p - 1); b < p; b++)
                m[b - 1] = arguments[b];
              f[g].fn.apply(f[g].context, m);
          }
      }
      return !0;
    }, o.prototype.on = function(a, V, c) {
      return s(this, a, V, c, !1);
    }, o.prototype.once = function(a, V, c) {
      return s(this, a, V, c, !0);
    }, o.prototype.removeListener = function(a, V, c, F) {
      var X = t ? t + a : a;
      if (!this._events[X]) return this;
      if (!V)
        return u(this, X), this;
      var Y = this._events[X];
      if (Y.fn)
        Y.fn === V && (!F || Y.once) && (!c || Y.context === c) && u(this, X);
      else {
        for (var q = 0, f = [], p = Y.length; q < p; q++)
          (Y[q].fn !== V || F && !Y[q].once || c && Y[q].context !== c) && f.push(Y[q]);
        f.length ? this._events[X] = f.length === 1 ? f[0] : f : u(this, X);
      }
      return this;
    }, o.prototype.removeAllListeners = function(a) {
      var V;
      return a ? (V = t ? t + a : a, this._events[V] && u(this, V)) : (this._events = new i(), this._eventsCount = 0), this;
    }, o.prototype.off = o.prototype.removeListener, o.prototype.addListener = o.prototype.on, o.prefixed = t, o.EventEmitter = o, e.exports = o;
  }(fg)), fg.exports;
}
var AIe = yIe();
const wIe = /* @__PURE__ */ Mr(AIe);
var Kg = new wIe(), hg = "recharts.syncMouseEvents";
function R7(e) {
  "@babel/helpers - typeof";
  return R7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, R7(e);
}
function CIe(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function PIe(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, eQ(i.key), i);
  }
}
function SIe(e, r, t) {
  return r && PIe(e.prototype, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function pg(e, r, t) {
  return r = eQ(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function eQ(e) {
  var r = NIe(e, "string");
  return R7(r) == "symbol" ? r : r + "";
}
function NIe(e, r) {
  if (R7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (R7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var MIe = /* @__PURE__ */ function() {
  function e() {
    CIe(this, e), pg(this, "activeIndex", 0), pg(this, "coordinateList", []), pg(this, "layout", "horizontal");
  }
  return SIe(e, [{
    key: "setDetails",
    value: function(t) {
      var i, n = t.coordinateList, s = n === void 0 ? null : n, u = t.container, o = u === void 0 ? null : u, d = t.layout, a = d === void 0 ? null : d, V = t.offset, c = V === void 0 ? null : V, F = t.mouseHandlerCallback, X = F === void 0 ? null : F;
      this.coordinateList = (i = s ?? this.coordinateList) !== null && i !== void 0 ? i : [], this.container = o ?? this.container, this.layout = a ?? this.layout, this.offset = c ?? this.offset, this.mouseHandlerCallback = X ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(t) {
      if (this.coordinateList.length !== 0)
        switch (t.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(t) {
      this.activeIndex = t;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var t, i;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var n = this.container.getBoundingClientRect(), s = n.x, u = n.y, o = n.height, d = this.coordinateList[this.activeIndex].coordinate, a = ((t = window) === null || t === void 0 ? void 0 : t.scrollX) || 0, V = ((i = window) === null || i === void 0 ? void 0 : i.scrollY) || 0, c = s + d + a, F = u + this.offset.top + o / 2 + V;
        this.mouseHandlerCallback({
          pageX: c,
          pageY: F
        });
      }
    }
  }]);
}();
function TIe(e, r, t) {
  if (t === "number" && r === !0 && Array.isArray(e)) {
    var i = e == null ? void 0 : e[0], n = e == null ? void 0 : e[1];
    if (i && n && pe(i) && pe(n))
      return !0;
  }
  return !1;
}
function EIe(e, r, t, i) {
  var n = i / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? r.x - n : t.left + 0.5,
    y: e === "horizontal" ? t.top + 0.5 : r.y - n,
    width: e === "horizontal" ? i : t.width - 1,
    height: e === "horizontal" ? t.height - 1 : i
  };
}
function rQ(e) {
  var r = e.cx, t = e.cy, i = e.radius, n = e.startAngle, s = e.endAngle, u = kr(r, t, i, n), o = kr(r, t, i, s);
  return {
    points: [u, o],
    cx: r,
    cy: t,
    radius: i,
    startAngle: n,
    endAngle: s
  };
}
function kIe(e, r, t) {
  var i, n, s, u;
  if (e === "horizontal")
    i = r.x, s = i, n = t.top, u = t.top + t.height;
  else if (e === "vertical")
    n = r.y, u = n, i = t.left, s = t.left + t.width;
  else if (r.cx != null && r.cy != null)
    if (e === "centric") {
      var o = r.cx, d = r.cy, a = r.innerRadius, V = r.outerRadius, c = r.angle, F = kr(o, d, a, c), X = kr(o, d, V, c);
      i = F.x, n = F.y, s = X.x, u = X.y;
    } else
      return rQ(r);
  return [{
    x: i,
    y: n
  }, {
    x: s,
    y: u
  }];
}
function I7(e) {
  "@babel/helpers - typeof";
  return I7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, I7(e);
}
function $k(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function px(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? $k(Object(t), !0).forEach(function(i) {
      OIe(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $k(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function OIe(e, r, t) {
  return r = DIe(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function DIe(e) {
  var r = RIe(e, "string");
  return I7(r) == "symbol" ? r : r + "";
}
function RIe(e, r) {
  if (I7(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (I7(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function IIe(e) {
  var r, t, i = e.element, n = e.tooltipEventType, s = e.isActive, u = e.activeCoordinate, o = e.activePayload, d = e.offset, a = e.activeTooltipIndex, V = e.tooltipAxisBandSize, c = e.layout, F = e.chartName, X = (r = i.props.cursor) !== null && r !== void 0 ? r : (t = i.type.defaultProps) === null || t === void 0 ? void 0 : t.cursor;
  if (!i || !X || !s || !u || F !== "ScatterChart" && n !== "axis")
    return null;
  var Y, q = fE;
  if (F === "ScatterChart")
    Y = u, q = rke;
  else if (F === "BarChart")
    Y = EIe(c, u, d, V), q = K4;
  else if (c === "radial") {
    var f = rQ(u), p = f.cx, m = f.cy, g = f.radius, y = f.startAngle, b = f.endAngle;
    Y = {
      cx: p,
      cy: m,
      startAngle: y,
      endAngle: b,
      innerRadius: g,
      outerRadius: g
    }, q = n$;
  } else
    Y = {
      points: kIe(c, u, d)
    }, q = fE;
  var A = px(px(px(px({
    stroke: "#ccc",
    pointerEvents: "none"
  }, d), Y), _e(X, !1)), {}, {
    payload: o,
    payloadIndex: a,
    className: ur("recharts-tooltip-cursor", X.className)
  });
  return /* @__PURE__ */ Ci(X) ? /* @__PURE__ */ at(X, A) : /* @__PURE__ */ lr(q, A);
}
var LIe = ["item"], _Ie = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function ul(e) {
  "@babel/helpers - typeof";
  return ul = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, ul(e);
}
function sV() {
  return sV = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, sV.apply(this, arguments);
}
function Qk(e, r) {
  return zIe(e) || jIe(e, r) || iQ(e, r) || HIe();
}
function HIe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jIe(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var i, n, s, u, o = [], d = !0, a = !1;
    try {
      if (s = (t = t.call(e)).next, r !== 0) for (; !(d = (i = s.call(t)).done) && (o.push(i.value), o.length !== r); d = !0) ;
    } catch (V) {
      a = !0, n = V;
    } finally {
      try {
        if (!d && t.return != null && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (a) throw n;
      }
    }
    return o;
  }
}
function zIe(e) {
  if (Array.isArray(e)) return e;
}
function eO(e, r) {
  if (e == null) return {};
  var t = BIe(e, r), i, n;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (n = 0; n < s.length; n++)
      i = s[n], !(r.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(e, i) && (t[i] = e[i]);
  }
  return t;
}
function BIe(e, r) {
  if (e == null) return {};
  var t = {};
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      if (r.indexOf(i) >= 0) continue;
      t[i] = e[i];
    }
  return t;
}
function WIe(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function GIe(e, r) {
  for (var t = 0; t < r.length; t++) {
    var i = r[t];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, nQ(i.key), i);
  }
}
function UIe(e, r, t) {
  return r && GIe(e.prototype, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ZIe(e, r, t) {
  return r = cq(r), JIe(e, tQ() ? Reflect.construct(r, t || [], cq(e).constructor) : r.apply(e, t));
}
function JIe(e, r) {
  if (r && (ul(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return $Ie(e);
}
function $Ie(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function tQ() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (tQ = function() {
    return !!e;
  })();
}
function cq(e) {
  return cq = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, cq(e);
}
function QIe(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && Rb(e, r);
}
function Rb(e, r) {
  return Rb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, n) {
    return i.__proto__ = n, i;
  }, Rb(e, r);
}
function ol(e) {
  return tLe(e) || rLe(e) || iQ(e) || eLe();
}
function eLe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iQ(e, r) {
  if (e) {
    if (typeof e == "string") return Ib(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Ib(e, r);
  }
}
function rLe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function tLe(e) {
  if (Array.isArray(e)) return Ib(e);
}
function Ib(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, i = new Array(r); t < r; t++) i[t] = e[t];
  return i;
}
function rO(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    r && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, i);
  }
  return t;
}
function se(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? rO(Object(t), !0).forEach(function(i) {
      Le(e, i, t[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : rO(Object(t)).forEach(function(i) {
      Object.defineProperty(e, i, Object.getOwnPropertyDescriptor(t, i));
    });
  }
  return e;
}
function Le(e, r, t) {
  return r = nQ(r), r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function nQ(e) {
  var r = iLe(e, "string");
  return ul(r) == "symbol" ? r : r + "";
}
function iLe(e, r) {
  if (ul(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var i = t.call(e, r);
    if (ul(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
var nLe = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, sLe = {
  width: "100%",
  height: "100%"
}, sQ = {
  x: 0,
  y: 0
};
function mx(e) {
  return e;
}
var uLe = function(r, t) {
  return t === "horizontal" ? r.x : t === "vertical" ? r.y : t === "centric" ? r.angle : r.radius;
}, oLe = function(r, t, i, n) {
  var s = t.find(function(V) {
    return V && V.index === i;
  });
  if (s) {
    if (r === "horizontal")
      return {
        x: s.coordinate,
        y: n.y
      };
    if (r === "vertical")
      return {
        x: n.x,
        y: s.coordinate
      };
    if (r === "centric") {
      var u = s.coordinate, o = n.radius;
      return se(se(se({}, n), kr(n.cx, n.cy, o, u)), {}, {
        angle: u,
        radius: o
      });
    }
    var d = s.coordinate, a = n.angle;
    return se(se(se({}, n), kr(n.cx, n.cy, d, a)), {}, {
      angle: a,
      radius: d
    });
  }
  return sQ;
}, Nf = function(r, t) {
  var i = t.graphicalItems, n = t.dataStartIndex, s = t.dataEndIndex, u = (i ?? []).reduce(function(o, d) {
    var a = d.props.data;
    return a && a.length ? [].concat(ol(o), ol(a)) : o;
  }, []);
  return u.length > 0 ? u : r && r.length && pe(n) && pe(s) ? r.slice(n, s + 1) : [];
};
function uQ(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var Lb = function(r, t, i, n) {
  var s = r.graphicalItems, u = r.tooltipAxis, o = Nf(t, r);
  return i < 0 || !s || !s.length || i >= o.length ? null : s.reduce(function(d, a) {
    var V, c = (V = a.props.data) !== null && V !== void 0 ? V : t;
    c && r.dataStartIndex + r.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    r.dataEndIndex - r.dataStartIndex >= i && (c = c.slice(r.dataStartIndex, r.dataEndIndex + 1));
    var F;
    if (u.dataKey && !u.allowDuplicatedCategory) {
      var X = c === void 0 ? o : c;
      F = g8(X, u.dataKey, n);
    } else
      F = c && c[i] || o[i];
    return F ? [].concat(ol(d), [$J(a, F)]) : d;
  }, []);
}, tO = function(r, t, i, n) {
  var s = n || {
    x: r.chartX,
    y: r.chartY
  }, u = uLe(s, i), o = r.orderedTooltipTicks, d = r.tooltipAxis, a = r.tooltipTicks, V = PNe(u, o, a, d);
  if (V >= 0 && a) {
    var c = a[V] && a[V].value, F = Lb(r, t, V, c), X = oLe(i, o, V, s);
    return {
      activeTooltipIndex: V,
      activeLabel: c,
      activePayload: F,
      activeCoordinate: X
    };
  }
  return null;
}, dLe = function(r, t) {
  var i = t.axes, n = t.graphicalItems, s = t.axisType, u = t.axisIdKey, o = t.stackGroups, d = t.dataStartIndex, a = t.dataEndIndex, V = r.layout, c = r.children, F = r.stackOffset, X = BJ(V, s);
  return i.reduce(function(Y, q) {
    var f, p = q.type.defaultProps !== void 0 ? se(se({}, q.type.defaultProps), q.props) : q.props, m = p.type, g = p.dataKey, y = p.allowDataOverflow, b = p.allowDuplicatedCategory, A = p.scale, w = p.ticks, S = p.includeHidden, N = p[u];
    if (Y[N])
      return Y;
    var O = Nf(r.data, {
      graphicalItems: n.filter(function(U) {
        var de, Ke = u in U.props ? U.props[u] : (de = U.type.defaultProps) === null || de === void 0 ? void 0 : de[u];
        return Ke === N;
      }),
      dataStartIndex: d,
      dataEndIndex: a
    }), E = O.length, I, R, H;
    TIe(p.domain, y, m) && (I = ib(p.domain, null, y), X && (m === "number" || A !== "auto") && (H = Ic(O, g, "category")));
    var W = uQ(m);
    if (!I || I.length === 0) {
      var B, L = (B = p.domain) !== null && B !== void 0 ? B : W;
      if (g) {
        if (I = Ic(O, g, m), m === "category" && X) {
          var z = g4e(I);
          b && z ? (R = I, I = QX(0, E)) : b || (I = nE(L, I, q).reduce(function(U, de) {
            return U.indexOf(de) >= 0 ? U : [].concat(ol(U), [de]);
          }, []));
        } else if (m === "category")
          b ? I = I.filter(function(U) {
            return U !== "" && !fr(U);
          }) : I = nE(L, I, q).reduce(function(U, de) {
            return U.indexOf(de) >= 0 || de === "" || fr(de) ? U : [].concat(ol(U), [de]);
          }, []);
        else if (m === "number") {
          var Z = ENe(O, n.filter(function(U) {
            var de, Ke, xe = u in U.props ? U.props[u] : (de = U.type.defaultProps) === null || de === void 0 ? void 0 : de[u], be = "hide" in U.props ? U.props.hide : (Ke = U.type.defaultProps) === null || Ke === void 0 ? void 0 : Ke.hide;
            return xe === N && (S || !be);
          }), g, s, V);
          Z && (I = Z);
        }
        X && (m === "number" || A !== "auto") && (H = Ic(O, g, "category"));
      } else X ? I = QX(0, E) : o && o[N] && o[N].hasStack && m === "number" ? I = F === "expand" ? [0, 1] : JJ(o[N].stackGroups, d, a) : I = zJ(O, n.filter(function(U) {
        var de = u in U.props ? U.props[u] : U.type.defaultProps[u], Ke = "hide" in U.props ? U.props.hide : U.type.defaultProps.hide;
        return de === N && (S || !Ke);
      }), m, V, !0);
      if (m === "number")
        I = Db(c, I, N, s, w), L && (I = ib(L, I, y));
      else if (m === "category" && L) {
        var le = L, te = I.every(function(U) {
          return le.indexOf(U) >= 0;
        });
        te && (I = le);
      }
    }
    return se(se({}, Y), {}, Le({}, N, se(se({}, p), {}, {
      axisType: s,
      domain: I,
      categoricalDomain: H,
      duplicateDomain: R,
      originalDomain: (f = p.domain) !== null && f !== void 0 ? f : W,
      isCategorical: X,
      layout: V
    })));
  }, {});
}, aLe = function(r, t) {
  var i = t.graphicalItems, n = t.Axis, s = t.axisType, u = t.axisIdKey, o = t.stackGroups, d = t.dataStartIndex, a = t.dataEndIndex, V = r.layout, c = r.children, F = Nf(r.data, {
    graphicalItems: i,
    dataStartIndex: d,
    dataEndIndex: a
  }), X = F.length, Y = BJ(V, s), q = -1;
  return i.reduce(function(f, p) {
    var m = p.type.defaultProps !== void 0 ? se(se({}, p.type.defaultProps), p.props) : p.props, g = m[u], y = uQ("number");
    if (!f[g]) {
      q++;
      var b;
      return Y ? b = QX(0, X) : o && o[g] && o[g].hasStack ? (b = JJ(o[g].stackGroups, d, a), b = Db(c, b, g, s)) : (b = ib(y, zJ(F, i.filter(function(A) {
        var w, S, N = u in A.props ? A.props[u] : (w = A.type.defaultProps) === null || w === void 0 ? void 0 : w[u], O = "hide" in A.props ? A.props.hide : (S = A.type.defaultProps) === null || S === void 0 ? void 0 : S.hide;
        return N === g && !O;
      }), "number", V), n.defaultProps.allowDataOverflow), b = Db(c, b, g, s)), se(se({}, f), {}, Le({}, g, se(se({
        axisType: s
      }, n.defaultProps), {}, {
        hide: !0,
        orientation: Mn(nLe, "".concat(s, ".").concat(q % 2), null),
        domain: b,
        originalDomain: y,
        isCategorical: Y,
        layout: V
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return f;
  }, {});
}, VLe = function(r, t) {
  var i = t.axisType, n = i === void 0 ? "xAxis" : i, s = t.AxisComp, u = t.graphicalItems, o = t.stackGroups, d = t.dataStartIndex, a = t.dataEndIndex, V = r.children, c = "".concat(n, "Id"), F = ss(V, s), X = {};
  return F && F.length ? X = dLe(r, {
    axes: F,
    graphicalItems: u,
    axisType: n,
    axisIdKey: c,
    stackGroups: o,
    dataStartIndex: d,
    dataEndIndex: a
  }) : u && u.length && (X = aLe(r, {
    Axis: s,
    graphicalItems: u,
    axisType: n,
    axisIdKey: c,
    stackGroups: o,
    dataStartIndex: d,
    dataEndIndex: a
  })), X;
}, lLe = function(r) {
  var t = po(r), i = Au(t, !1, !0);
  return {
    tooltipTicks: i,
    orderedTooltipTicks: BA(i, function(n) {
      return n.coordinate;
    }),
    tooltipAxis: t,
    tooltipAxisBandSize: RX(t, i)
  };
}, iO = function(r) {
  var t = r.children, i = r.defaultShowTooltip, n = dn(t, JV), s = 0, u = 0;
  return r.data && r.data.length !== 0 && (u = r.data.length - 1), n && n.props && (n.props.startIndex >= 0 && (s = n.props.startIndex), n.props.endIndex >= 0 && (u = n.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: s,
    dataEndIndex: u,
    activeTooltipIndex: -1,
    isTooltipActive: !!i
  };
}, cLe = function(r) {
  return !r || !r.length ? !1 : r.some(function(t) {
    var i = Pu(t && t.type);
    return i && i.indexOf("Bar") >= 0;
  });
}, nO = function(r) {
  return r === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : r === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : r === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, FLe = function(r, t) {
  var i = r.props, n = r.graphicalItems, s = r.xAxisMap, u = s === void 0 ? {} : s, o = r.yAxisMap, d = o === void 0 ? {} : o, a = i.width, V = i.height, c = i.children, F = i.margin || {}, X = dn(c, JV), Y = dn(c, zi), q = Object.keys(d).reduce(function(b, A) {
    var w = d[A], S = w.orientation;
    return !w.mirror && !w.hide ? se(se({}, b), {}, Le({}, S, b[S] + w.width)) : b;
  }, {
    left: F.left || 0,
    right: F.right || 0
  }), f = Object.keys(u).reduce(function(b, A) {
    var w = u[A], S = w.orientation;
    return !w.mirror && !w.hide ? se(se({}, b), {}, Le({}, S, Mn(b, "".concat(S)) + w.height)) : b;
  }, {
    top: F.top || 0,
    bottom: F.bottom || 0
  }), p = se(se({}, f), q), m = p.bottom;
  X && (p.bottom += X.props.height || JV.defaultProps.height), Y && t && (p = MNe(p, n, i, t));
  var g = a - p.left - p.right, y = V - p.top - p.bottom;
  return se(se({
    brushBottom: m
  }, p), {}, {
    // never return negative values for height and width
    width: Math.max(g, 0),
    height: Math.max(y, 0)
  });
}, xLe = function(r, t) {
  if (t === "xAxis")
    return r[t].width;
  if (t === "yAxis")
    return r[t].height;
}, oQ = function(r) {
  var t = r.chartName, i = r.GraphicalChild, n = r.defaultTooltipEventType, s = n === void 0 ? "axis" : n, u = r.validateTooltipEventTypes, o = u === void 0 ? ["axis"] : u, d = r.axisComponents, a = r.legendContent, V = r.formatAxisMap, c = r.defaultProps, F = function(p, m) {
    var g = m.graphicalItems, y = m.stackGroups, b = m.offset, A = m.updateId, w = m.dataStartIndex, S = m.dataEndIndex, N = p.barSize, O = p.layout, E = p.barGap, I = p.barCategoryGap, R = p.maxBarSize, H = nO(O), W = H.numericAxisName, B = H.cateAxisName, L = cLe(g), z = [];
    return g.forEach(function(Z, le) {
      var te = Nf(p.data, {
        graphicalItems: [Z],
        dataStartIndex: w,
        dataEndIndex: S
      }), U = Z.type.defaultProps !== void 0 ? se(se({}, Z.type.defaultProps), Z.props) : Z.props, de = U.dataKey, Ke = U.maxBarSize, xe = U["".concat(W, "Id")], be = U["".concat(B, "Id")], qe = {}, me = d.reduce(function(yt, hi) {
        var $u, _l, uu = m["".concat(hi.axisType, "Map")], L2 = U["".concat(hi.axisType, "Id")];
        uu && uu[L2] || hi.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? _i(!1, "Specifying a(n) ".concat(hi.axisType, "Id requires a corresponding ").concat(
          hi.axisType,
          "Id on the targeted graphical component "
        ).concat(($u = Z == null || (_l = Z.type) === null || _l === void 0 ? void 0 : _l.displayName) !== null && $u !== void 0 ? $u : "")) : _i());
        var Qu = uu[L2];
        return se(se({}, yt), {}, Le(Le({}, hi.axisType, Qu), "".concat(hi.axisType, "Ticks"), Au(Qu)));
      }, qe), ne = me[B], fe = me["".concat(B, "Ticks")], Ye = y && y[xe] && y[xe].hasStack && jNe(Z, y[xe].stackGroups), Q = Pu(Z.type).indexOf("Bar") >= 0, we = RX(ne, fe), oe = [], tr = L && SNe({
        barSize: N,
        stackGroups: y,
        totalSize: xLe(me, B)
      });
      if (Q) {
        var ar, or, bt = fr(Ke) ? R : Ke, Tr = (ar = (or = RX(ne, fe, !0)) !== null && or !== void 0 ? or : bt) !== null && ar !== void 0 ? ar : 0;
        oe = NNe({
          barGap: E,
          barCategoryGap: I,
          bandSize: Tr !== we ? Tr : we,
          sizeList: tr[be],
          maxBarSize: bt
        }), Tr !== we && (oe = oe.map(function(yt) {
          return se(se({}, yt), {}, {
            position: se(se({}, yt.position), {}, {
              offset: yt.position.offset - Tr / 2
            })
          });
        }));
      }
      var ms = Z && Z.type && Z.type.getComposedData;
      ms && z.push({
        props: se(se({}, ms(se(se({}, me), {}, {
          displayedData: te,
          props: p,
          dataKey: de,
          item: Z,
          bandSize: we,
          barPosition: oe,
          offset: b,
          stackedData: Ye,
          layout: O,
          dataStartIndex: w,
          dataEndIndex: S
        }))), {}, Le(Le(Le({
          key: Z.key || "item-".concat(le)
        }, W, me[W]), B, me[B]), "animationId", A)),
        childIndex: T4e(Z, p.children),
        item: Z
      });
    }), z;
  }, X = function(p, m) {
    var g = p.props, y = p.dataStartIndex, b = p.dataEndIndex, A = p.updateId;
    if (!KS({
      props: g
    }))
      return null;
    var w = g.children, S = g.layout, N = g.stackOffset, O = g.data, E = g.reverseStackOrder, I = nO(S), R = I.numericAxisName, H = I.cateAxisName, W = ss(w, i), B = _Ne(O, W, "".concat(R, "Id"), "".concat(H, "Id"), N, E), L = d.reduce(function(U, de) {
      var Ke = "".concat(de.axisType, "Map");
      return se(se({}, U), {}, Le({}, Ke, VLe(g, se(se({}, de), {}, {
        graphicalItems: W,
        stackGroups: de.axisType === R && B,
        dataStartIndex: y,
        dataEndIndex: b
      }))));
    }, {}), z = FLe(se(se({}, L), {}, {
      props: g,
      graphicalItems: W
    }), m == null ? void 0 : m.legendBBox);
    Object.keys(L).forEach(function(U) {
      L[U] = V(g, L[U], z, U.replace("Map", ""), t);
    });
    var Z = L["".concat(H, "Map")], le = lLe(Z), te = F(g, se(se({}, L), {}, {
      dataStartIndex: y,
      dataEndIndex: b,
      updateId: A,
      graphicalItems: W,
      stackGroups: B,
      offset: z
    }));
    return se(se({
      formattedGraphicalItems: te,
      graphicalItems: W,
      offset: z,
      stackGroups: B
    }, le), L);
  }, Y = /* @__PURE__ */ function(f) {
    function p(m) {
      var g, y, b;
      return WIe(this, p), b = ZIe(this, p, [m]), Le(b, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), Le(b, "accessibilityManager", new MIe()), Le(b, "handleLegendBBoxUpdate", function(A) {
        if (A) {
          var w = b.state, S = w.dataStartIndex, N = w.dataEndIndex, O = w.updateId;
          b.setState(se({
            legendBBox: A
          }, X({
            props: b.props,
            dataStartIndex: S,
            dataEndIndex: N,
            updateId: O
          }, se(se({}, b.state), {}, {
            legendBBox: A
          }))));
        }
      }), Le(b, "handleReceiveSyncEvent", function(A, w, S) {
        if (b.props.syncId === A) {
          if (S === b.eventEmitterSymbol && typeof b.props.syncMethod != "function")
            return;
          b.applySyncEvent(w);
        }
      }), Le(b, "handleBrushChange", function(A) {
        var w = A.startIndex, S = A.endIndex;
        if (w !== b.state.dataStartIndex || S !== b.state.dataEndIndex) {
          var N = b.state.updateId;
          b.setState(function() {
            return se({
              dataStartIndex: w,
              dataEndIndex: S
            }, X({
              props: b.props,
              dataStartIndex: w,
              dataEndIndex: S,
              updateId: N
            }, b.state));
          }), b.triggerSyncEvent({
            dataStartIndex: w,
            dataEndIndex: S
          });
        }
      }), Le(b, "handleMouseEnter", function(A) {
        var w = b.getMouseInfo(A);
        if (w) {
          var S = se(se({}, w), {}, {
            isTooltipActive: !0
          });
          b.setState(S), b.triggerSyncEvent(S);
          var N = b.props.onMouseEnter;
          Ue(N) && N(S, A);
        }
      }), Le(b, "triggeredAfterMouseMove", function(A) {
        var w = b.getMouseInfo(A), S = w ? se(se({}, w), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        b.setState(S), b.triggerSyncEvent(S);
        var N = b.props.onMouseMove;
        Ue(N) && N(S, A);
      }), Le(b, "handleItemMouseEnter", function(A) {
        b.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: A,
            activePayload: A.tooltipPayload,
            activeCoordinate: A.tooltipPosition || {
              x: A.cx,
              y: A.cy
            }
          };
        });
      }), Le(b, "handleItemMouseLeave", function() {
        b.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), Le(b, "handleMouseMove", function(A) {
        A.persist(), b.throttleTriggeredAfterMouseMove(A);
      }), Le(b, "handleMouseLeave", function(A) {
        b.throttleTriggeredAfterMouseMove.cancel();
        var w = {
          isTooltipActive: !1
        };
        b.setState(w), b.triggerSyncEvent(w);
        var S = b.props.onMouseLeave;
        Ue(S) && S(w, A);
      }), Le(b, "handleOuterEvent", function(A) {
        var w = M4e(A), S = Mn(b.props, "".concat(w));
        if (w && Ue(S)) {
          var N, O;
          /.*touch.*/i.test(w) ? O = b.getMouseInfo(A.changedTouches[0]) : O = b.getMouseInfo(A), S((N = O) !== null && N !== void 0 ? N : {}, A);
        }
      }), Le(b, "handleClick", function(A) {
        var w = b.getMouseInfo(A);
        if (w) {
          var S = se(se({}, w), {}, {
            isTooltipActive: !0
          });
          b.setState(S), b.triggerSyncEvent(S);
          var N = b.props.onClick;
          Ue(N) && N(S, A);
        }
      }), Le(b, "handleMouseDown", function(A) {
        var w = b.props.onMouseDown;
        if (Ue(w)) {
          var S = b.getMouseInfo(A);
          w(S, A);
        }
      }), Le(b, "handleMouseUp", function(A) {
        var w = b.props.onMouseUp;
        if (Ue(w)) {
          var S = b.getMouseInfo(A);
          w(S, A);
        }
      }), Le(b, "handleTouchMove", function(A) {
        A.changedTouches != null && A.changedTouches.length > 0 && b.throttleTriggeredAfterMouseMove(A.changedTouches[0]);
      }), Le(b, "handleTouchStart", function(A) {
        A.changedTouches != null && A.changedTouches.length > 0 && b.handleMouseDown(A.changedTouches[0]);
      }), Le(b, "handleTouchEnd", function(A) {
        A.changedTouches != null && A.changedTouches.length > 0 && b.handleMouseUp(A.changedTouches[0]);
      }), Le(b, "handleDoubleClick", function(A) {
        var w = b.props.onDoubleClick;
        if (Ue(w)) {
          var S = b.getMouseInfo(A);
          w(S, A);
        }
      }), Le(b, "handleContextMenu", function(A) {
        var w = b.props.onContextMenu;
        if (Ue(w)) {
          var S = b.getMouseInfo(A);
          w(S, A);
        }
      }), Le(b, "triggerSyncEvent", function(A) {
        b.props.syncId !== void 0 && Kg.emit(hg, b.props.syncId, A, b.eventEmitterSymbol);
      }), Le(b, "applySyncEvent", function(A) {
        var w = b.props, S = w.layout, N = w.syncMethod, O = b.state.updateId, E = A.dataStartIndex, I = A.dataEndIndex;
        if (A.dataStartIndex !== void 0 || A.dataEndIndex !== void 0)
          b.setState(se({
            dataStartIndex: E,
            dataEndIndex: I
          }, X({
            props: b.props,
            dataStartIndex: E,
            dataEndIndex: I,
            updateId: O
          }, b.state)));
        else if (A.activeTooltipIndex !== void 0) {
          var R = A.chartX, H = A.chartY, W = A.activeTooltipIndex, B = b.state, L = B.offset, z = B.tooltipTicks;
          if (!L)
            return;
          if (typeof N == "function")
            W = N(z, A);
          else if (N === "value") {
            W = -1;
            for (var Z = 0; Z < z.length; Z++)
              if (z[Z].value === A.activeLabel) {
                W = Z;
                break;
              }
          }
          var le = se(se({}, L), {}, {
            x: L.left,
            y: L.top
          }), te = Math.min(R, le.x + le.width), U = Math.min(H, le.y + le.height), de = z[W] && z[W].value, Ke = Lb(b.state, b.props.data, W), xe = z[W] ? {
            x: S === "horizontal" ? z[W].coordinate : te,
            y: S === "horizontal" ? U : z[W].coordinate
          } : sQ;
          b.setState(se(se({}, A), {}, {
            activeLabel: de,
            activeCoordinate: xe,
            activePayload: Ke,
            activeTooltipIndex: W
          }));
        } else
          b.setState(A);
      }), Le(b, "renderCursor", function(A) {
        var w, S = b.state, N = S.isTooltipActive, O = S.activeCoordinate, E = S.activePayload, I = S.offset, R = S.activeTooltipIndex, H = S.tooltipAxisBandSize, W = b.getTooltipEventType(), B = (w = A.props.active) !== null && w !== void 0 ? w : N, L = b.props.layout, z = A.key || "_recharts-cursor";
        return /* @__PURE__ */ D.createElement(IIe, {
          key: z,
          activeCoordinate: O,
          activePayload: E,
          activeTooltipIndex: R,
          chartName: t,
          element: A,
          isActive: B,
          layout: L,
          offset: I,
          tooltipAxisBandSize: H,
          tooltipEventType: W
        });
      }), Le(b, "renderPolarAxis", function(A, w, S) {
        var N = Mn(A, "type.axisType"), O = Mn(b.state, "".concat(N, "Map")), E = A.type.defaultProps, I = E !== void 0 ? se(se({}, E), A.props) : A.props, R = O && O[I["".concat(N, "Id")]];
        return /* @__PURE__ */ at(A, se(se({}, R), {}, {
          className: ur(N, R.className),
          key: A.key || "".concat(w, "-").concat(S),
          ticks: Au(R, !0)
        }));
      }), Le(b, "renderPolarGrid", function(A) {
        var w = A.props, S = w.radialLines, N = w.polarAngles, O = w.polarRadius, E = b.state, I = E.radiusAxisMap, R = E.angleAxisMap, H = po(I), W = po(R), B = W.cx, L = W.cy, z = W.innerRadius, Z = W.outerRadius;
        return /* @__PURE__ */ at(A, {
          polarAngles: Array.isArray(N) ? N : Au(W, !0).map(function(le) {
            return le.coordinate;
          }),
          polarRadius: Array.isArray(O) ? O : Au(H, !0).map(function(le) {
            return le.coordinate;
          }),
          cx: B,
          cy: L,
          innerRadius: z,
          outerRadius: Z,
          key: A.key || "polar-grid",
          radialLines: S
        });
      }), Le(b, "renderLegend", function() {
        var A = b.state.formattedGraphicalItems, w = b.props, S = w.children, N = w.width, O = w.height, E = b.props.margin || {}, I = N - (E.left || 0) - (E.right || 0), R = HJ({
          children: S,
          formattedGraphicalItems: A,
          legendWidth: I,
          legendContent: a
        });
        if (!R)
          return null;
        var H = R.item, W = eO(R, LIe);
        return /* @__PURE__ */ at(H, se(se({}, W), {}, {
          chartWidth: N,
          chartHeight: O,
          margin: E,
          onBBoxUpdate: b.handleLegendBBoxUpdate
        }));
      }), Le(b, "renderTooltip", function() {
        var A, w = b.props, S = w.children, N = w.accessibilityLayer, O = dn(S, ws);
        if (!O)
          return null;
        var E = b.state, I = E.isTooltipActive, R = E.activeCoordinate, H = E.activePayload, W = E.activeLabel, B = E.offset, L = (A = O.props.active) !== null && A !== void 0 ? A : I;
        return /* @__PURE__ */ at(O, {
          viewBox: se(se({}, B), {}, {
            x: B.left,
            y: B.top
          }),
          active: L,
          label: W,
          payload: L ? H : [],
          coordinate: R,
          accessibilityLayer: N
        });
      }), Le(b, "renderBrush", function(A) {
        var w = b.props, S = w.margin, N = w.data, O = b.state, E = O.offset, I = O.dataStartIndex, R = O.dataEndIndex, H = O.updateId;
        return /* @__PURE__ */ at(A, {
          key: A.key || "_recharts-brush",
          onChange: Yx(b.handleBrushChange, A.props.onChange),
          data: N,
          x: pe(A.props.x) ? A.props.x : E.left,
          y: pe(A.props.y) ? A.props.y : E.top + E.height + E.brushBottom - (S.bottom || 0),
          width: pe(A.props.width) ? A.props.width : E.width,
          startIndex: I,
          endIndex: R,
          updateId: "brush-".concat(H)
        });
      }), Le(b, "renderReferenceElement", function(A, w, S) {
        if (!A)
          return null;
        var N = b, O = N.clipPathId, E = b.state, I = E.xAxisMap, R = E.yAxisMap, H = E.offset, W = A.type.defaultProps || {}, B = A.props, L = B.xAxisId, z = L === void 0 ? W.xAxisId : L, Z = B.yAxisId, le = Z === void 0 ? W.yAxisId : Z;
        return /* @__PURE__ */ at(A, {
          key: A.key || "".concat(w, "-").concat(S),
          xAxis: I[z],
          yAxis: R[le],
          viewBox: {
            x: H.left,
            y: H.top,
            width: H.width,
            height: H.height
          },
          clipPathId: O
        });
      }), Le(b, "renderActivePoints", function(A) {
        var w = A.item, S = A.activePoint, N = A.basePoint, O = A.childIndex, E = A.isRange, I = [], R = w.props.key, H = w.item.type.defaultProps !== void 0 ? se(se({}, w.item.type.defaultProps), w.item.props) : w.item.props, W = H.activeDot, B = H.dataKey, L = se(se({
          index: O,
          dataKey: B,
          cx: S.x,
          cy: S.y,
          r: 4,
          fill: f4(w.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: S.payload,
          value: S.value
        }, _e(W, !1)), XX(W));
        return I.push(p.renderActiveDot(W, L, "".concat(R, "-activePoint-").concat(O))), N ? I.push(p.renderActiveDot(W, se(se({}, L), {}, {
          cx: N.x,
          cy: N.y
        }), "".concat(R, "-basePoint-").concat(O))) : E && I.push(null), I;
      }), Le(b, "renderGraphicChild", function(A, w, S) {
        var N = b.filterFormatItem(A, w, S);
        if (!N)
          return null;
        var O = b.getTooltipEventType(), E = b.state, I = E.isTooltipActive, R = E.tooltipAxis, H = E.activeTooltipIndex, W = E.activeLabel, B = b.props.children, L = dn(B, ws), z = N.props, Z = z.points, le = z.isRange, te = z.baseLine, U = N.item.type.defaultProps !== void 0 ? se(se({}, N.item.type.defaultProps), N.item.props) : N.item.props, de = U.activeDot, Ke = U.hide, xe = U.activeBar, be = U.activeShape, qe = !!(!Ke && I && L && (de || xe || be)), me = {};
        O !== "axis" && L && L.props.trigger === "click" ? me = {
          onClick: Yx(b.handleItemMouseEnter, A.props.onClick)
        } : O !== "axis" && (me = {
          onMouseLeave: Yx(b.handleItemMouseLeave, A.props.onMouseLeave),
          onMouseEnter: Yx(b.handleItemMouseEnter, A.props.onMouseEnter)
        });
        var ne = /* @__PURE__ */ at(A, se(se({}, N.props), me));
        function fe(hi) {
          return typeof R.dataKey == "function" ? R.dataKey(hi.payload) : null;
        }
        if (qe)
          if (H >= 0) {
            var Ye, Q;
            if (R.dataKey && !R.allowDuplicatedCategory) {
              var we = typeof R.dataKey == "function" ? fe : "payload.".concat(R.dataKey.toString());
              Ye = g8(Z, we, W), Q = le && te && g8(te, we, W);
            } else
              Ye = Z == null ? void 0 : Z[H], Q = le && te && te[H];
            if (be || xe) {
              var oe = A.props.activeIndex !== void 0 ? A.props.activeIndex : H;
              return [/* @__PURE__ */ at(A, se(se(se({}, N.props), me), {}, {
                activeIndex: oe
              })), null, null];
            }
            if (!fr(Ye))
              return [ne].concat(ol(b.renderActivePoints({
                item: N,
                activePoint: Ye,
                basePoint: Q,
                childIndex: H,
                isRange: le
              })));
          } else {
            var tr, ar = (tr = b.getItemByXY(b.state.activeCoordinate)) !== null && tr !== void 0 ? tr : {
              graphicalItem: ne
            }, or = ar.graphicalItem, bt = or.item, Tr = bt === void 0 ? A : bt, ms = or.childIndex, yt = se(se(se({}, N.props), me), {}, {
              activeIndex: ms
            });
            return [/* @__PURE__ */ at(Tr, yt), null, null];
          }
        return le ? [ne, null, null] : [ne, null];
      }), Le(b, "renderCustomized", function(A, w, S) {
        return /* @__PURE__ */ at(A, se(se({
          key: "recharts-customized-".concat(S)
        }, b.props), b.state));
      }), Le(b, "renderMap", {
        CartesianGrid: {
          handler: mx,
          once: !0
        },
        ReferenceArea: {
          handler: b.renderReferenceElement
        },
        ReferenceLine: {
          handler: mx
        },
        ReferenceDot: {
          handler: b.renderReferenceElement
        },
        XAxis: {
          handler: mx
        },
        YAxis: {
          handler: mx
        },
        Brush: {
          handler: b.renderBrush,
          once: !0
        },
        Bar: {
          handler: b.renderGraphicChild
        },
        Line: {
          handler: b.renderGraphicChild
        },
        Area: {
          handler: b.renderGraphicChild
        },
        Radar: {
          handler: b.renderGraphicChild
        },
        RadialBar: {
          handler: b.renderGraphicChild
        },
        Scatter: {
          handler: b.renderGraphicChild
        },
        Pie: {
          handler: b.renderGraphicChild
        },
        Funnel: {
          handler: b.renderGraphicChild
        },
        Tooltip: {
          handler: b.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: b.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: b.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: b.renderPolarAxis
        },
        Customized: {
          handler: b.renderCustomized
        }
      }), b.clipPathId = "".concat((g = m.id) !== null && g !== void 0 ? g : QY("recharts"), "-clip"), b.throttleTriggeredAfterMouseMove = LZ(b.triggeredAfterMouseMove, (y = m.throttleDelay) !== null && y !== void 0 ? y : 1e3 / 60), b.state = {}, b;
    }
    return QIe(p, f), UIe(p, [{
      key: "componentDidMount",
      value: function() {
        var g, y;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (g = this.props.margin.left) !== null && g !== void 0 ? g : 0,
            top: (y = this.props.margin.top) !== null && y !== void 0 ? y : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var g = this.props, y = g.children, b = g.data, A = g.height, w = g.layout, S = dn(y, ws);
        if (S) {
          var N = S.props.defaultIndex;
          if (!(typeof N != "number" || N < 0 || N > this.state.tooltipTicks.length - 1)) {
            var O = this.state.tooltipTicks[N] && this.state.tooltipTicks[N].value, E = Lb(this.state, b, N, O), I = this.state.tooltipTicks[N].coordinate, R = (this.state.offset.top + A) / 2, H = w === "horizontal", W = H ? {
              x: I,
              y: R
            } : {
              y: I,
              x: R
            }, B = this.state.formattedGraphicalItems.find(function(z) {
              var Z = z.item;
              return Z.type.name === "Scatter";
            });
            B && (W = se(se({}, W), B.props.points[N].tooltipPosition), E = B.props.points[N].tooltipPayload);
            var L = {
              activeTooltipIndex: N,
              isTooltipActive: !0,
              activeLabel: O,
              activePayload: E,
              activeCoordinate: W
            };
            this.setState(L), this.renderCursor(S), this.accessibilityManager.setIndex(N);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(g, y) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== y.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== g.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== g.margin) {
          var b, A;
          this.accessibilityManager.setDetails({
            offset: {
              left: (b = this.props.margin.left) !== null && b !== void 0 ? b : 0,
              top: (A = this.props.margin.top) !== null && A !== void 0 ? A : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(g) {
        b8([dn(g.children, ws)], [dn(this.props.children, ws)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var g = dn(this.props.children, ws);
        if (g && typeof g.props.shared == "boolean") {
          var y = g.props.shared ? "axis" : "item";
          return o.indexOf(y) >= 0 ? y : s;
        }
        return s;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(g) {
        if (!this.container)
          return null;
        var y = this.container, b = y.getBoundingClientRect(), A = m9e(b), w = {
          chartX: Math.round(g.pageX - A.left),
          chartY: Math.round(g.pageY - A.top)
        }, S = b.width / y.offsetWidth || 1, N = this.inRange(w.chartX, w.chartY, S);
        if (!N)
          return null;
        var O = this.state, E = O.xAxisMap, I = O.yAxisMap, R = this.getTooltipEventType();
        if (R !== "axis" && E && I) {
          var H = po(E).scale, W = po(I).scale, B = H && H.invert ? H.invert(w.chartX) : null, L = W && W.invert ? W.invert(w.chartY) : null;
          return se(se({}, w), {}, {
            xValue: B,
            yValue: L
          });
        }
        var z = tO(this.state, this.props.data, this.props.layout, N);
        return z ? se(se({}, w), z) : null;
      }
    }, {
      key: "inRange",
      value: function(g, y) {
        var b = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, A = this.props.layout, w = g / b, S = y / b;
        if (A === "horizontal" || A === "vertical") {
          var N = this.state.offset, O = w >= N.left && w <= N.left + N.width && S >= N.top && S <= N.top + N.height;
          return O ? {
            x: w,
            y: S
          } : null;
        }
        var E = this.state, I = E.angleAxisMap, R = E.radiusAxisMap;
        if (I && R) {
          var H = po(I);
          return oE({
            x: w,
            y: S
          }, H);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var g = this.props.children, y = this.getTooltipEventType(), b = dn(g, ws), A = {};
        b && y === "axis" && (b.props.trigger === "click" ? A = {
          onClick: this.handleClick
        } : A = {
          onMouseEnter: this.handleMouseEnter,
          onDoubleClick: this.handleDoubleClick,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd,
          onContextMenu: this.handleContextMenu
        });
        var w = XX(this.props, this.handleOuterEvent);
        return se(se({}, w), A);
      }
    }, {
      key: "addListener",
      value: function() {
        Kg.on(hg, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        Kg.removeListener(hg, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(g, y, b) {
        for (var A = this.state.formattedGraphicalItems, w = 0, S = A.length; w < S; w++) {
          var N = A[w];
          if (N.item === g || N.props.key === g.key || y === Pu(N.item.type) && b === N.childIndex)
            return N;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var g = this.clipPathId, y = this.state.offset, b = y.left, A = y.top, w = y.height, S = y.width;
        return /* @__PURE__ */ D.createElement("defs", null, /* @__PURE__ */ D.createElement("clipPath", {
          id: g
        }, /* @__PURE__ */ D.createElement("rect", {
          x: b,
          y: A,
          height: w,
          width: S
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var g = this.state.xAxisMap;
        return g ? Object.entries(g).reduce(function(y, b) {
          var A = Qk(b, 2), w = A[0], S = A[1];
          return se(se({}, y), {}, Le({}, w, S.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var g = this.state.yAxisMap;
        return g ? Object.entries(g).reduce(function(y, b) {
          var A = Qk(b, 2), w = A[0], S = A[1];
          return se(se({}, y), {}, Le({}, w, S.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(g) {
        var y;
        return (y = this.state.xAxisMap) === null || y === void 0 || (y = y[g]) === null || y === void 0 ? void 0 : y.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(g) {
        var y;
        return (y = this.state.yAxisMap) === null || y === void 0 || (y = y[g]) === null || y === void 0 ? void 0 : y.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(g) {
        var y = this.state, b = y.formattedGraphicalItems, A = y.activeItem;
        if (b && b.length)
          for (var w = 0, S = b.length; w < S; w++) {
            var N = b[w], O = N.props, E = N.item, I = E.type.defaultProps !== void 0 ? se(se({}, E.type.defaultProps), E.props) : E.props, R = Pu(E.type);
            if (R === "Bar") {
              var H = (O.data || []).find(function(z) {
                return kEe(g, z);
              });
              if (H)
                return {
                  graphicalItem: N,
                  payload: H
                };
            } else if (R === "RadialBar") {
              var W = (O.data || []).find(function(z) {
                return oE(g, z);
              });
              if (W)
                return {
                  graphicalItem: N,
                  payload: W
                };
            } else if (bf(N, A) || yf(N, A) || E7(N, A)) {
              var B = YOe({
                graphicalItem: N,
                activeTooltipItem: A,
                itemData: I.data
              }), L = I.activeIndex === void 0 ? B : I.activeIndex;
              return {
                graphicalItem: se(se({}, N), {}, {
                  childIndex: L
                }),
                payload: E7(N, A) ? I.data[B] : N.props.data[B]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var g = this;
        if (!KS(this))
          return null;
        var y = this.props, b = y.children, A = y.className, w = y.width, S = y.height, N = y.style, O = y.compact, E = y.title, I = y.desc, R = eO(y, _Ie), H = _e(R, !1);
        if (O)
          return /* @__PURE__ */ D.createElement(Ok, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ D.createElement(A8, sV({}, H, {
            width: w,
            height: S,
            title: E,
            desc: I
          }), this.renderClipPath(), pS(b, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var W, B;
          H.tabIndex = (W = this.props.tabIndex) !== null && W !== void 0 ? W : 0, H.role = (B = this.props.role) !== null && B !== void 0 ? B : "application", H.onKeyDown = function(z) {
            g.accessibilityManager.keyboardEvent(z);
          }, H.onFocus = function() {
            g.accessibilityManager.focus();
          };
        }
        var L = this.parseEventsOfWrapper();
        return /* @__PURE__ */ D.createElement(Ok, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ D.createElement("div", sV({
          className: ur("recharts-wrapper", A),
          style: se({
            position: "relative",
            cursor: "default",
            width: w,
            height: S
          }, N)
        }, L, {
          ref: function(Z) {
            g.container = Z;
          }
        }), /* @__PURE__ */ D.createElement(A8, sV({}, H, {
          width: w,
          height: S,
          title: E,
          desc: I,
          style: sLe
        }), this.renderClipPath(), pS(b, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }(tR);
  Le(Y, "displayName", t), Le(Y, "defaultProps", se({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, c)), Le(Y, "getDerivedStateFromProps", function(f, p) {
    var m = f.dataKey, g = f.data, y = f.children, b = f.width, A = f.height, w = f.layout, S = f.stackOffset, N = f.margin, O = p.dataStartIndex, E = p.dataEndIndex;
    if (p.updateId === void 0) {
      var I = iO(f);
      return se(se(se({}, I), {}, {
        updateId: 0
      }, X(se(se({
        props: f
      }, I), {}, {
        updateId: 0
      }), p)), {}, {
        prevDataKey: m,
        prevData: g,
        prevWidth: b,
        prevHeight: A,
        prevLayout: w,
        prevStackOffset: S,
        prevMargin: N,
        prevChildren: y
      });
    }
    if (m !== p.prevDataKey || g !== p.prevData || b !== p.prevWidth || A !== p.prevHeight || w !== p.prevLayout || S !== p.prevStackOffset || !fV(N, p.prevMargin)) {
      var R = iO(f), H = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: p.chartX,
        chartY: p.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: p.isTooltipActive
      }, W = se(se({}, tO(p, g, w)), {}, {
        updateId: p.updateId + 1
      }), B = se(se(se({}, R), H), W);
      return se(se(se({}, B), X(se({
        props: f
      }, B), p)), {}, {
        prevDataKey: m,
        prevData: g,
        prevWidth: b,
        prevHeight: A,
        prevLayout: w,
        prevStackOffset: S,
        prevMargin: N,
        prevChildren: y
      });
    }
    if (!b8(y, p.prevChildren)) {
      var L, z, Z, le, te = dn(y, JV), U = te && (L = (z = te.props) === null || z === void 0 ? void 0 : z.startIndex) !== null && L !== void 0 ? L : O, de = te && (Z = (le = te.props) === null || le === void 0 ? void 0 : le.endIndex) !== null && Z !== void 0 ? Z : E, Ke = U !== O || de !== E, xe = !fr(g), be = xe && !Ke ? p.updateId : p.updateId + 1;
      return se(se({
        updateId: be
      }, X(se(se({
        props: f
      }, p), {}, {
        updateId: be,
        dataStartIndex: U,
        dataEndIndex: de
      }), p)), {}, {
        prevChildren: y,
        dataStartIndex: U,
        dataEndIndex: de
      });
    }
    return null;
  }), Le(Y, "renderActiveDot", function(f, p, m) {
    var g;
    return /* @__PURE__ */ Ci(f) ? g = /* @__PURE__ */ at(f, p) : Ue(f) ? g = f(p) : g = /* @__PURE__ */ D.createElement(pf, p), /* @__PURE__ */ D.createElement(Hr, {
      className: "recharts-active-dot",
      key: m
    }, g);
  });
  var q = /* @__PURE__ */ re(function(p, m) {
    return /* @__PURE__ */ D.createElement(Y, sV({}, p, {
      ref: m
    }));
  });
  return q.displayName = Y.displayName, q;
}, oi = oQ({
  chartName: "BarChart",
  GraphicalChild: Kr,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: pt
  }, {
    axisType: "yAxis",
    AxisComp: mt
  }],
  formatAxisMap: ADe
}), dQ = oQ({
  chartName: "RadarChart",
  GraphicalChild: Dl,
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: Ol
  }, {
    axisType: "radiusAxis",
    AxisComp: gf
  }],
  formatAxisMap: rMe,
  defaultProps: {
    layout: "centric",
    startAngle: 90,
    endAngle: -270,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
});
const XLe = { light: "", dark: ".dark" }, aQ = h.createContext(null);
function VQ() {
  const e = h.useContext(aQ);
  if (!e)
    throw new Error("useChart must be used within a <ChartContainer />");
  return e;
}
const gt = h.forwardRef(({ id: e, className: r, children: t, config: i, ...n }, s) => {
  const u = h.useId(), o = `chart-${e || u.replace(/:/g, "")}`;
  return /* @__PURE__ */ l(aQ.Provider, { value: { config: i }, children: /* @__PURE__ */ C(
    "div",
    {
      "data-chart": o,
      ref: s,
      className: _(
        "flex aspect-video justify-center text-bodysm [&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-none [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-sector]:outline-none [&_.recharts-surface]:outline-none",
        r
      ),
      ...n,
      children: [
        /* @__PURE__ */ l(qLe, { id: o, config: i }),
        /* @__PURE__ */ l(X9e, { children: t })
      ]
    }
  ) });
});
gt.displayName = "Chart";
const qLe = ({ id: e, config: r }) => {
  const t = Object.entries(r).filter(
    ([, i]) => i.theme || i.color
  );
  return t.length ? /* @__PURE__ */ l(
    "style",
    {
      dangerouslySetInnerHTML: {
        __html: Object.entries(XLe).map(
          ([i, n]) => `
${n} [data-chart=${e}] {
${t.map(([s, u]) => {
            var d;
            const o = ((d = u.theme) == null ? void 0 : d[i]) || u.color;
            return o ? `  --color-${s}: ${o};` : null;
          }).join(`
`)}
}
`
        ).join(`
`)
      }
    }
  ) : null;
}, Et = ws, vt = h.forwardRef(
  ({
    active: e,
    payload: r,
    className: t,
    indicator: i = "dot",
    hideLabel: n = !1,
    hideIndicator: s = !1,
    label: u,
    labelFormatter: o,
    labelClassName: d,
    formatter: a,
    color: V,
    nameKey: c,
    labelKey: F
  }, X) => {
    const { config: Y } = VQ(), q = h.useMemo(() => {
      var b;
      if (n || !(r != null && r.length))
        return null;
      const [p] = r, m = `${F || (p == null ? void 0 : p.dataKey) || (p == null ? void 0 : p.name) || "value"}`, g = _b(Y, p, m), y = !F && typeof u == "string" ? ((b = Y[u]) == null ? void 0 : b.label) || u : g == null ? void 0 : g.label;
      return o ? /* @__PURE__ */ l("div", { className: _("font-medium", d), children: o(y, r) }) : y ? /* @__PURE__ */ l("div", { className: _("font-medium", d), children: y }) : null;
    }, [
      u,
      o,
      r,
      n,
      d,
      Y,
      F
    ]);
    if (!e || !(r != null && r.length))
      return null;
    const f = r.length === 1 && i !== "dot";
    return /* @__PURE__ */ C(
      "div",
      {
        ref: X,
        className: _(
          "grid min-w-[8rem] items-start gap-1.5 rounded-lg border border-border/50 bg-background px-2.5 py-1.5 text-bodysm shadow-xl",
          t
        ),
        children: [
          f ? null : q,
          /* @__PURE__ */ l("div", { className: "grid gap-1.5", children: r.map((p, m) => {
            const g = `${c || p.name || p.dataKey || "value"}`, y = _b(Y, p, g), b = V || p.payload.fill || p.color;
            return /* @__PURE__ */ l(
              "div",
              {
                className: _(
                  "flex w-full flex-wrap items-stretch gap-2 [&>svg]:h-2.5 [&>svg]:w-2.5 [&>svg]:text-muted-foreground",
                  i === "dot" && "items-center"
                ),
                children: a && (p == null ? void 0 : p.value) !== void 0 && p.name ? a(p.value, p.name, p, m, p.payload) : /* @__PURE__ */ C(he, { children: [
                  y != null && y.icon ? /* @__PURE__ */ l(y.icon, {}) : !s && /* @__PURE__ */ l(
                    "div",
                    {
                      className: _(
                        "shrink-0 rounded-[2px] border-[--color-border] bg-[--color-bg]",
                        {
                          "h-2.5 w-2.5": i === "dot",
                          "w-1": i === "line",
                          "w-0 border-[1.5px] border-dashed bg-transparent": i === "dashed",
                          "my-0.5": f && i === "dashed"
                        }
                      ),
                      style: {
                        "--color-bg": b,
                        "--color-border": b
                      }
                    }
                  ),
                  /* @__PURE__ */ C(
                    "div",
                    {
                      className: _(
                        "flex flex-1 justify-between leading-none",
                        f ? "items-end" : "items-center"
                      ),
                      children: [
                        /* @__PURE__ */ C("div", { className: "grid gap-1.5", children: [
                          f ? q : null,
                          /* @__PURE__ */ l("span", { className: "text-muted-foreground", children: (y == null ? void 0 : y.label) || p.name })
                        ] }),
                        p.value && /* @__PURE__ */ l("span", { className: "font-mono font-medium tabular-nums text-foreground", children: p.value.toLocaleString() })
                      ]
                    }
                  )
                ] })
              },
              p.dataKey
            );
          }) })
        ]
      }
    );
  }
);
vt.displayName = "ChartTooltip";
const lQ = zi, tu = h.forwardRef(
  ({ className: e, hideIcon: r = !1, payload: t, verticalAlign: i = "bottom", nameKey: n }, s) => {
    const { config: u } = VQ();
    return t != null && t.length ? /* @__PURE__ */ l(
      "div",
      {
        ref: s,
        className: _(
          "flex items-center justify-center gap-4",
          i === "top" ? "pb-3" : "pt-3",
          e
        ),
        children: t.map((o) => {
          const d = `${n || o.dataKey || "value"}`, a = _b(u, o, d);
          return /* @__PURE__ */ C(
            "div",
            {
              className: _(
                "flex items-center gap-1.5 [&>svg]:h-3 [&>svg]:w-3 [&>svg]:text-muted-foreground"
              ),
              children: [
                a != null && a.icon && !r ? /* @__PURE__ */ l(a.icon, {}) : /* @__PURE__ */ l(
                  "div",
                  {
                    className: "h-2 w-2 shrink-0 rounded-[2px]",
                    style: {
                      backgroundColor: o.color
                    }
                  }
                ),
                a == null ? void 0 : a.label
              ]
            },
            o.value
          );
        })
      }
    ) : null;
  }
);
tu.displayName = "ChartLegend";
function _b(e, r, t) {
  if (typeof r != "object" || r === null)
    return;
  const i = "payload" in r && typeof r.payload == "object" && r.payload !== null ? r.payload : void 0;
  let n = t;
  return t in r && typeof r[t] == "string" ? n = r[t] : i && t in i && typeof i[t] == "string" && (n = i[t]), n in e ? e[n] : e[t];
}
const sO = [
  "hsl(var(--chart-1))",
  "hsl(var(--chart-2))",
  "hsl(var(--chart-3))",
  "hsl(var(--chart-4))",
  "hsl(var(--chart-5))"
], YLe = {
  count: {
    label: "Count",
    color: "var(--color-redDefault)"
    // Default color
  }
};
function fLe({
  data: e,
  groupType: r,
  loading: t = !1
}) {
  const i = e.map((n, s) => ({
    name: n.error_type || "Unknown Error",
    value: n.count,
    fill: sO[s % sO.length]
    // Cycle through colors
  }));
  return /* @__PURE__ */ C(Pr, { className: "h-full w-full", children: [
    /* @__PURE__ */ C(Sr, { className: "items-center", children: [
      /* @__PURE__ */ l(Or, { children: "Error Types" }),
      r && /* @__PURE__ */ C(ii, { children: [
        "by ",
        r.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: t ? /* @__PURE__ */ C("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: [
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ l(gt, { config: YLe, className: "max-h-[400px] w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: i,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ l(Gt, { vertical: !1 }),
          /* @__PURE__ */ l(
            pt,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ l(mt, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(Kr, { dataKey: "value", radius: [4, 4, 4, 4] })
        ]
      }
    ) }) })
  ] });
}
const mg = {
  count: {
    label: "Count",
    color: "hsl(var(--chart-1))"
  }
};
function KLe({
  data: e,
  loading: r = !1
}) {
  const t = e.map((i) => {
    var s;
    const n = (s = i.name) == null ? void 0 : s.split(" ").map((u) => u.charAt(0).toUpperCase() + u.slice(1).toLowerCase()).join(" ");
    return {
      ...i,
      name: n
    };
  });
  return /* @__PURE__ */ C(Pr, { className: "h-full w-full", children: [
    /* @__PURE__ */ C(Sr, { className: "items-center", children: [
      /* @__PURE__ */ l(Or, { children: "Conversation Overlays" }),
      /* @__PURE__ */ l(ii, { children: "Distribution by Overlay Type" })
    ] }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: r ? /* @__PURE__ */ C("div", { className: "relative mx-auto flex aspect-square max-h-[400px] items-center justify-center", children: [
      /* @__PURE__ */ l(Xe, { className: "absolute h-[80%] w-[80%] rounded-full opacity-20" }),
      /* @__PURE__ */ l(Xe, { className: "absolute h-[60%] w-[60%] rounded-full opacity-40" }),
      /* @__PURE__ */ l(Xe, { className: "absolute h-[40%] w-[40%] rounded-full opacity-60" })
    ] }) : /* @__PURE__ */ l(
      gt,
      {
        config: mg,
        className: "mx-auto aspect-square max-h-[400px]",
        children: /* @__PURE__ */ C(
          dQ,
          {
            data: t,
            margin: { top: 20, right: 40, bottom: 20, left: 40 },
            children: [
              /* @__PURE__ */ l(Et, { cursor: !1, content: /* @__PURE__ */ l(vt, {}) }),
              /* @__PURE__ */ l(
                Ol,
                {
                  dataKey: "name",
                  tick: { fontSize: 10 },
                  tickLine: !1,
                  style: { fontSize: 10 },
                  tickFormatter: (i) => i.length > 30 ? i.substring(0, 27) + "..." : i
                }
              ),
              /* @__PURE__ */ l(h4, {}),
              /* @__PURE__ */ l(
                Dl,
                {
                  name: "Count",
                  dataKey: "count",
                  stroke: mg.count.color,
                  fill: mg.count.color,
                  fillOpacity: 0.6,
                  dot: {
                    r: 4,
                    fillOpacity: 1
                  }
                }
              )
            ]
          }
        )
      }
    ) }),
    /* @__PURE__ */ l(e3, { className: "flex-col gap-2 text-bodysm", children: /* @__PURE__ */ l("div", { className: "text-muted-foreground flex items-center gap-2 leading-none", children: "Overlay Type Distribution Analysis" }) })
  ] });
}
const gg = {
  in_progress: {
    label: "In Progress",
    color: "hsl(var(--chart-1))"
  },
  done: {
    label: "Done",
    color: "var(--color-greenDefault)"
  },
  off_topic: {
    label: "Off Topic",
    color: "var(--color-yellowDefault)"
  },
  errors: {
    label: "Error",
    color: "var(--color-redDefault)"
  }
};
function hLe({
  data: e,
  groupType: r,
  loading: t = !1
}) {
  const i = Object.entries(e).map(([n, s]) => ({
    name: gg[n].label,
    value: s,
    fill: gg[n].color
  }));
  return /* @__PURE__ */ C(Pr, { className: "h-full w-full", children: [
    /* @__PURE__ */ C(Sr, { className: "items-center", children: [
      /* @__PURE__ */ l(Or, { children: "Conversation Phases" }),
      r && /* @__PURE__ */ C(ii, { children: [
        "by ",
        r.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: t ? /* @__PURE__ */ C("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: [
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ l(gt, { config: gg, className: "max-h-[400px] w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: i,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ l(Gt, { vertical: !1 }),
          /* @__PURE__ */ l(
            pt,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1
            }
          ),
          /* @__PURE__ */ l(mt, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(Kr, { dataKey: "value", radius: [4, 4, 4, 4] })
        ]
      }
    ) }) })
  ] });
}
function pLe({
  data: e,
  from: r,
  groupType: t,
  loading: i
}) {
  const n = $e(() => e.done + e.errors + e.off_topic + e.in_progress, [e]), s = $e(() => e.done, [e]), u = $e(() => e.errors + e.off_topic + e.in_progress, [e]);
  return /* @__PURE__ */ C("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ C("div", { className: "flex gap-4", children: [
      /* @__PURE__ */ l(
        Ii,
        {
          title: "Attempted",
          subtitle: "Since " + ut(Ss(r), "dd MMM, yyyy"),
          children: i ? "..." : n
        }
      ),
      /* @__PURE__ */ l(
        Ii,
        {
          title: "Completed",
          subtitle: "Since " + ut(Ss(r), "dd MMM, yyyy"),
          children: i ? "..." : s
        }
      ),
      /* @__PURE__ */ l(
        Ii,
        {
          title: "Not completed",
          subtitle: "Since " + ut(Ss(r), "dd MMM, yyyy"),
          children: i ? "..." : u
        }
      )
    ] }),
    /* @__PURE__ */ l(
      hLe,
      {
        data: e,
        groupType: t,
        loading: i
      }
    )
  ] });
}
const vg = {
  abandoned: {
    label: "Abandoned",
    color: "var(--color-yellowDefault)"
  },
  completed: {
    label: "Complete",
    color: "var(--color-greenDefault)"
  },
  discarded: {
    label: "Discarded",
    color: "var(--color-yellowDefault)"
  },
  draft: {
    label: "Draft",
    color: "hsl(var(--chart-1))"
  },
  error: {
    label: "Error",
    color: "var(--color-redDefault)"
  },
  in_progress: {
    label: "In Progress",
    color: "hsl(var(--chart-1))"
  },
  off_topic: {
    label: "Blocked",
    color: "var(--color-yellowDefault)"
  },
  stuck: {
    label: "Stuck",
    color: "var(--color-redDefault)"
  }
};
function mLe({
  data: e,
  groupType: r,
  loading: t = !1
}) {
  const i = Object.entries(e).map(([n, s]) => ({
    name: vg[n].label,
    value: s,
    fill: vg[n].color
  }));
  return /* @__PURE__ */ C(Pr, { className: "h-full w-full", children: [
    /* @__PURE__ */ C(Sr, { className: "items-center", children: [
      /* @__PURE__ */ l(Or, { children: "Conversation States" }),
      r && /* @__PURE__ */ C(ii, { children: [
        "by ",
        r.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: t ? /* @__PURE__ */ C("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: [
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ l(gt, { config: vg, className: "max-h-[400px] w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: i,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ l(Gt, { vertical: !1 }),
          /* @__PURE__ */ l(
            pt,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1
            }
          ),
          /* @__PURE__ */ l(mt, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(Kr, { dataKey: "value", radius: [4, 4, 4, 4] })
        ]
      }
    ) }) })
  ] });
}
function gLe({
  data: e,
  from: r,
  groupType: t,
  loading: i
}) {
  const n = $e(() => Object.keys(e).reduce(
    (d, a) => d + (e[a] || 0),
    0
  ), [e]), s = $e(() => e.draft, [e]), u = $e(() => e.completed, [e]), o = $e(() => e.abandoned + e.discarded + e.draft + e.error + e.off_topic + e.in_progress + e.stuck, [e]);
  return /* @__PURE__ */ C("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ C("div", { className: "flex gap-4", children: [
      /* @__PURE__ */ l(
        Ii,
        {
          title: "Attempted",
          subtitle: "Since " + ut(Ss(r), "dd MMM, yyyy"),
          children: i ? "..." : n
        }
      ),
      /* @__PURE__ */ l(
        Ii,
        {
          title: "Draft",
          subtitle: "Since " + ut(Ss(r), "dd MMM, yyyy"),
          children: i ? "..." : s
        }
      ),
      /* @__PURE__ */ l(
        Ii,
        {
          title: "Completed",
          subtitle: "Since " + ut(Ss(r), "dd MMM, yyyy"),
          children: i ? "..." : u
        }
      ),
      /* @__PURE__ */ l(
        Ii,
        {
          title: "Not completed",
          subtitle: "Since " + ut(Ss(r), "dd MMM, yyyy"),
          children: i ? "..." : o
        }
      )
    ] }),
    /* @__PURE__ */ l(
      mLe,
      {
        data: e,
        groupType: t,
        loading: i
      }
    )
  ] });
}
const hc = {
  completed: {
    label: "Complete",
    color: "var(--color-greenDefault)"
  },
  off_topic: {
    label: "Blocked",
    color: "var(--color-purpleDefault)"
  },
  abandoned: {
    label: "Abandoned",
    color: "var(--color-yellowDefault)"
  },
  address_out_of_scope: {
    label: "Out of scope",
    color: "var(--color-redDefault)"
  }
};
function vLe({
  data: e,
  groupType: r,
  loading: t = !1
}) {
  return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ C(Sr, { children: [
      /* @__PURE__ */ l(Or, { children: "Conversation volume" }),
      r && /* @__PURE__ */ C(ii, { children: [
        "by ",
        r.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: t ? /* @__PURE__ */ C("div", { className: "flex h-[400px] items-end justify-between gap-2 px-12 pb-16", children: [
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ l(gt, { config: hc, className: "h-[400px] w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: e,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ l(Gt, { vertical: !1 }),
          /* @__PURE__ */ l(
            pt,
            {
              dataKey: "week_start",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ l(mt, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(
            zi,
            {
              content: /* @__PURE__ */ l(tu, {}),
              verticalAlign: "top",
              align: "right"
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "completed",
              stackId: "a",
              fill: hc.completed.color,
              radius: [0, 0, 4, 4],
              name: "Completed"
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "off_topic",
              stackId: "a",
              fill: hc.off_topic.color,
              radius: [0, 0, 0, 0],
              name: "Off Topic"
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "abandoned",
              stackId: "a",
              fill: hc.abandoned.color,
              radius: [0, 0, 0, 0],
              name: "Abandoned"
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "address_out_of_scope",
              stackId: "a",
              fill: hc.address_out_of_scope.color,
              radius: [4, 4, 0, 0],
              name: "Out of scope"
            }
          )
        ]
      }
    ) }) })
  ] });
}
function bLe({
  data: e,
  from: r,
  groupType: t,
  loading: i
}) {
  const n = $e(() => e.reduce((V, c) => V + (c.completed || 0) + (c.off_topic || 0) + (c.abandoned || 0) + (c.address_out_of_scope || 0), 0), [e]), s = $e(() => e.reduce((V, c) => V + (c.completed || 0), 0), [e]), u = $e(() => e.reduce((V, c) => V + (c.off_topic || 0), 0), [e]), o = $e(() => e.reduce((V, c) => V + (c.abandoned || 0), 0), [e]), d = $e(() => e.reduce((V, c) => V + (c.address_out_of_scope || 0), 0), [e]), a = (V) => {
    try {
      return ut(Ss(V), "dd MMM, yyyy");
    } catch {
      return "na";
    }
  };
  return /* @__PURE__ */ C("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ C("div", { className: "flex gap-4", children: [
      /* @__PURE__ */ l(
        Ii,
        {
          title: "Total conversations",
          subtitle: "Since " + a(r),
          children: i ? "..." : n
        }
      ),
      /* @__PURE__ */ l(Ii, { title: "Completed", subtitle: "Since " + a(r), children: i ? "..." : s }),
      /* @__PURE__ */ l(Ii, { title: "Off topic", subtitle: "Since " + a(r), children: i ? "..." : u }),
      /* @__PURE__ */ l(Ii, { title: "Abandoned", subtitle: "Since " + a(r), children: i ? "..." : o }),
      /* @__PURE__ */ l(
        Ii,
        {
          title: "Addresses offboarded",
          subtitle: "Since " + a(r),
          children: i ? "..." : d
        }
      )
    ] }),
    /* @__PURE__ */ l(
      vLe,
      {
        data: e,
        groupType: t,
        loading: i
      }
    )
  ] });
}
const bg = {
  count: {
    label: "Count",
    color: "hsl(var(--chart-1))"
  }
};
function yLe({
  data: e,
  loading: r = !1
}) {
  const t = e.map((i) => {
    var s;
    const n = (s = i.name) == null ? void 0 : s.replace(/\bZONE\b/gi, "").trim().split(" ").map((u) => u.charAt(0).toUpperCase() + u.slice(1).toLowerCase()).join(" ");
    return {
      ...i,
      name: `${n} (${i.percentage.toFixed(1)}%)`
    };
  });
  return /* @__PURE__ */ C(Pr, { className: "h-full w-full", children: [
    /* @__PURE__ */ C(Sr, { className: "items-center", children: [
      /* @__PURE__ */ l(Or, { children: "Conversation Zones" }),
      /* @__PURE__ */ l(ii, { children: "Distribution by Zone Type" })
    ] }),
    /* @__PURE__ */ l(Nr, { className: "pb-0", children: r ? /* @__PURE__ */ C("div", { className: "relative mx-auto flex aspect-square max-h-[400px] items-center justify-center", children: [
      /* @__PURE__ */ l(Xe, { className: "absolute h-[80%] w-[80%] rounded-full opacity-20" }),
      /* @__PURE__ */ l(Xe, { className: "absolute h-[60%] w-[60%] rounded-full opacity-40" }),
      /* @__PURE__ */ l(Xe, { className: "absolute h-[40%] w-[40%] rounded-full opacity-60" })
    ] }) : /* @__PURE__ */ l(
      gt,
      {
        config: bg,
        className: "mx-auto aspect-square max-h-[400px]",
        children: /* @__PURE__ */ C(
          dQ,
          {
            data: t,
            margin: { top: 20, right: 40, bottom: 20, left: 40 },
            children: [
              /* @__PURE__ */ l(Et, { cursor: !1, content: /* @__PURE__ */ l(vt, {}) }),
              /* @__PURE__ */ l(
                Ol,
                {
                  dataKey: "name",
                  tick: { fontSize: 10 },
                  tickLine: !1,
                  style: { fontSize: 10 },
                  tickFormatter: (i) => i.length > 30 ? i.substring(0, 27) + "..." : i
                }
              ),
              /* @__PURE__ */ l(h4, {}),
              /* @__PURE__ */ l(
                Dl,
                {
                  name: "Count",
                  dataKey: "count",
                  stroke: bg.count.color,
                  fill: bg.count.color,
                  fillOpacity: 0.6,
                  dot: {
                    r: 4,
                    fillOpacity: 1
                  }
                }
              )
            ]
          }
        )
      }
    ) }),
    /* @__PURE__ */ l(e3, { className: "flex-col gap-2 text-bodysm", children: /* @__PURE__ */ l("div", { className: "text-muted-foreground flex items-center gap-2 leading-none", children: "Zone Type Distribution Analysis" }) })
  ] });
}
const ALe = (e) => e.length > 30 ? e.substring(0, 30) + "..." : e, wLe = (e) => {
  const r = e.toLowerCase();
  return r.includes("residential") ? "bg-blue-50 text-blue-700 border-blue-200" : r.includes("green") || r.includes("wedge") ? "bg-green-50 text-green-700 border-green-200" : r.includes("conservation") || r.includes("rural") ? "bg-amber-50 text-amber-700 border-amber-200" : r.includes("general") ? "bg-purple-50 text-purple-700 border-purple-200" : "bg-gray-50 text-gray-700 border-gray-200";
};
function CLe({
  data: e,
  title: r = "Outcome by Zone",
  loading: t = !1
}) {
  const i = D.useMemo(() => e.reduce(
    (c, F) => ({
      permitRequired: c.permitRequired + F.permitRequired,
      noPermitRequired: c.noPermitRequired + F.noPermitRequired,
      moreInformationRequired: c.moreInformationRequired + F.moreInformationRequired,
      prohibited: c.prohibited + F.prohibited,
      accepted: c.accepted + F.accepted,
      selfAssess: c.selfAssess + F.selfAssess,
      code: c.code + F.code,
      impact: c.impact + F.impact,
      total: c.total + F.total
    }),
    {
      permitRequired: 0,
      noPermitRequired: 0,
      moreInformationRequired: 0,
      prohibited: 0,
      total: 0,
      selfAssess: 0,
      accepted: 0,
      code: 0,
      impact: 0
    }
  ), [e]);
  if (t)
    return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
      /* @__PURE__ */ l(Sr, { className: "pb-3", children: /* @__PURE__ */ l(Or, { className: "text-bodylg font-semibold", children: r }) }),
      /* @__PURE__ */ l(Nr, { children: /* @__PURE__ */ l("div", { className: "space-y-2", children: [...Array(5)].map((c, F) => /* @__PURE__ */ l("div", { className: "h-12 animate-pulse rounded bg-gray-100" }, F)) }) })
    ] });
  const n = e.some((c) => c.noPermitRequired > 0), s = e.some(
    (c) => c.moreInformationRequired > 0
  ), u = e.some((c) => c.prohibited > 0), o = e.some((c) => c.accepted > 0), d = e.some((c) => c.selfAssess > 0), a = e.some((c) => c.code > 0), V = e.some((c) => c.impact > 0);
  return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ l(Sr, { className: "pb-3", children: /* @__PURE__ */ l(Or, { className: "text-bodylg font-semibold text-gray-900", children: r }) }),
    /* @__PURE__ */ l(Nr, { children: /* @__PURE__ */ C(pl, { children: [
      /* @__PURE__ */ l(ml, { children: /* @__PURE__ */ C(ti, { className: "bg-gray-50", children: [
        /* @__PURE__ */ l(Ir, { className: "w-1/3 font-medium text-gray-700", children: "Zone name, outcome" }),
        /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l(
          Pt,
          {
            variant: "default",
            className: "border-amber-200 bg-amber-100 text-amber-800 hover:bg-amber-100",
            children: "Permit required"
          }
        ) }),
        n && /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l(
          Pt,
          {
            variant: "secondary",
            className: "border-green-200 bg-green-100 text-green-800 hover:bg-green-100",
            children: "No permit required"
          }
        ) }),
        s && /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l(
          Pt,
          {
            variant: "outline",
            className: "border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-50",
            children: "More information required"
          }
        ) }),
        u && /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l(
          Pt,
          {
            variant: "destructive",
            className: "border-red-200 bg-red-100 text-red-800 hover:bg-red-100",
            children: "Prohibited"
          }
        ) }),
        o && /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l(
          Pt,
          {
            variant: "destructive",
            className: "border-green-200 bg-green-100 text-green-800 hover:bg-green-100",
            children: "Accepted"
          }
        ) }),
        d && /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l(
          Pt,
          {
            variant: "destructive",
            className: "border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-50",
            children: "Self assess"
          }
        ) }),
        a && /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l(
          Pt,
          {
            variant: "destructive",
            className: "border-amber-200 bg-amber-100 text-amber-800 hover:bg-amber-100",
            children: "Code"
          }
        ) }),
        V && /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l(
          Pt,
          {
            variant: "destructive",
            className: "border-amber-200 bg-amber-100 text-amber-800 hover:bg-amber-100",
            children: "Impact"
          }
        ) }),
        /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l("strong", { children: "Total" }) })
      ] }) }),
      /* @__PURE__ */ C(gl, { children: [
        e.map((c, F) => /* @__PURE__ */ C(ti, { className: "hover:bg-gray-50", children: [
          /* @__PURE__ */ l(De, { className: "font-medium", children: /* @__PURE__ */ l(
            Pt,
            {
              variant: "outline",
              className: `${wLe(c.zone)} font-normal`,
              children: ALe(c.zone)
            }
          ) }),
          /* @__PURE__ */ l(De, { className: "text-center", children: c.permitRequired }),
          n && /* @__PURE__ */ l(De, { className: "text-center", children: c.noPermitRequired }),
          s && /* @__PURE__ */ l(De, { className: "text-center", children: c.moreInformationRequired }),
          u && /* @__PURE__ */ l(De, { className: "text-center", children: c.prohibited }),
          o && /* @__PURE__ */ l(De, { className: "text-center", children: c.accepted }),
          d && /* @__PURE__ */ l(De, { className: "text-center", children: c.selfAssess }),
          a && /* @__PURE__ */ l(De, { className: "text-center", children: c.code }),
          V && /* @__PURE__ */ l(De, { className: "text-center", children: c.impact }),
          /* @__PURE__ */ l(De, { className: "text-center font-semibold", children: c.total })
        ] }, F)),
        /* @__PURE__ */ C(ti, { className: "border-t-2 bg-gray-50 font-semibold", children: [
          /* @__PURE__ */ l(De, { className: "font-bold", children: "Total" }),
          /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.permitRequired }),
          n && /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.noPermitRequired }),
          s && /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.moreInformationRequired }),
          u && /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.prohibited }),
          o && /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.accepted }),
          d && /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.selfAssess }),
          a && /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.code }),
          V && /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.impact }),
          /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.total })
        ] })
      ] })
    ] }) })
  ] });
}
const PLe = (e) => e.length > 30 ? e.substring(0, 30) + "..." : e, SLe = (e) => {
  const r = e.toLowerCase();
  return r.includes("residential") ? "bg-blue-50 text-blue-700 border-blue-200" : r.includes("green") || r.includes("wedge") ? "bg-green-50 text-green-700 border-green-200" : r.includes("conservation") || r.includes("rural") ? "bg-amber-50 text-amber-700 border-amber-200" : r.includes("general") ? "bg-purple-50 text-purple-700 border-purple-200" : "bg-gray-50 text-gray-700 border-gray-200";
};
function NLe({
  data: e,
  title: r = "Outcome by Overlay",
  loading: t = !1
}) {
  const i = D.useMemo(() => e.reduce(
    (c, F) => ({
      permitRequired: c.permitRequired + F.permitRequired,
      noPermitRequired: c.noPermitRequired + F.noPermitRequired,
      moreInformationRequired: c.moreInformationRequired + F.moreInformationRequired,
      prohibited: c.prohibited + F.prohibited,
      accepted: c.accepted + (F.accepted || 0),
      selfAssess: c.selfAssess + (F.selfAssess || 0),
      code: c.code + (F.code || 0),
      impact: c.impact + (F.impact || 0),
      total: c.total + F.total
    }),
    {
      permitRequired: 0,
      noPermitRequired: 0,
      moreInformationRequired: 0,
      prohibited: 0,
      accepted: 0,
      selfAssess: 0,
      code: 0,
      impact: 0,
      total: 0
    }
  ), [e]);
  if (t)
    return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
      /* @__PURE__ */ l(Sr, { className: "pb-3", children: /* @__PURE__ */ l(Or, { className: "text-bodylg font-semibold", children: r }) }),
      /* @__PURE__ */ l(Nr, { children: /* @__PURE__ */ l("div", { className: "space-y-2", children: [...Array(5)].map((c, F) => /* @__PURE__ */ l("div", { className: "h-12 animate-pulse rounded bg-gray-100" }, F)) }) })
    ] });
  const n = e.some((c) => c.noPermitRequired > 0), s = e.some(
    (c) => c.moreInformationRequired > 0
  ), u = e.some((c) => c.prohibited > 0), o = e.some((c) => c.accepted > 0), d = e.some((c) => c.selfAssess > 0), a = e.some((c) => c.code > 0), V = e.some((c) => c.impact > 0);
  return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ l(Sr, { className: "pb-3", children: /* @__PURE__ */ l(Or, { className: "text-bodylg font-semibold text-gray-900", children: r }) }),
    /* @__PURE__ */ l(Nr, { children: /* @__PURE__ */ C(pl, { children: [
      /* @__PURE__ */ l(ml, { children: /* @__PURE__ */ C(ti, { className: "bg-gray-50", children: [
        /* @__PURE__ */ l(Ir, { className: "w-1/3 font-medium text-gray-700", children: "Overlay name, outcome" }),
        /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l(
          Pt,
          {
            variant: "default",
            className: "border-amber-200 bg-amber-100 text-amber-800 hover:bg-amber-100",
            children: "Permit required"
          }
        ) }),
        n && /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l(
          Pt,
          {
            variant: "secondary",
            className: "border-green-200 bg-green-100 text-green-800 hover:bg-green-100",
            children: "No permit required"
          }
        ) }),
        s && /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l(
          Pt,
          {
            variant: "outline",
            className: "border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-50",
            children: "More information required"
          }
        ) }),
        u && /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l(
          Pt,
          {
            variant: "destructive",
            className: "border-red-200 bg-red-100 text-red-800 hover:bg-red-100",
            children: "Prohibited"
          }
        ) }),
        o && /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l(
          Pt,
          {
            variant: "destructive",
            className: "border-green-200 bg-green-100 text-green-800 hover:bg-green-100",
            children: "Accepted"
          }
        ) }),
        d && /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l(
          Pt,
          {
            variant: "destructive",
            className: "border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-50",
            children: "Self assess"
          }
        ) }),
        a && /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l(
          Pt,
          {
            variant: "destructive",
            className: "border-amber-200 bg-amber-100 text-amber-800 hover:bg-amber-100",
            children: "Code"
          }
        ) }),
        V && /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l(
          Pt,
          {
            variant: "destructive",
            className: "border-amber-200 bg-amber-100 text-amber-800 hover:bg-amber-100",
            children: "Impact"
          }
        ) }),
        /* @__PURE__ */ l(Ir, { className: "text-center font-medium text-gray-700", children: /* @__PURE__ */ l("strong", { children: "Total" }) })
      ] }) }),
      /* @__PURE__ */ C(gl, { children: [
        e.map((c, F) => /* @__PURE__ */ C(ti, { className: "hover:bg-gray-50", children: [
          /* @__PURE__ */ l(De, { className: "font-medium", children: /* @__PURE__ */ l(
            Pt,
            {
              title: c.overlay,
              variant: "outline",
              className: `${SLe(c.overlay)} font-normal`,
              children: PLe(c.overlay)
            }
          ) }),
          /* @__PURE__ */ l(De, { className: "text-center", children: c.permitRequired }),
          n && /* @__PURE__ */ l(De, { className: "text-center", children: c.noPermitRequired }),
          s && /* @__PURE__ */ l(De, { className: "text-center", children: c.moreInformationRequired }),
          u && /* @__PURE__ */ l(De, { className: "text-center", children: c.prohibited }),
          o && /* @__PURE__ */ l(De, { className: "text-center", children: c.accepted || 0 }),
          d && /* @__PURE__ */ l(De, { className: "text-center", children: c.selfAssess || 0 }),
          a && /* @__PURE__ */ l(De, { className: "text-center", children: c.code || 0 }),
          V && /* @__PURE__ */ l(De, { className: "text-center", children: c.impact || 0 }),
          /* @__PURE__ */ l(De, { className: "text-center font-semibold", children: c.total })
        ] }, F)),
        /* @__PURE__ */ C(ti, { className: "border-t-2 bg-gray-50 font-semibold", children: [
          /* @__PURE__ */ l(De, { className: "font-bold", children: "Total" }),
          /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.permitRequired }),
          n && /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.noPermitRequired }),
          s && /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.moreInformationRequired }),
          u && /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.prohibited }),
          o && /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.accepted }),
          d && /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.selfAssess }),
          a && /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.code }),
          V && /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.impact }),
          /* @__PURE__ */ l(De, { className: "text-center font-bold", children: i.total })
        ] })
      ] })
    ] }) })
  ] });
}
const Hb = [
  "hsl(var(--chart-1))",
  "hsl(var(--chart-2))",
  "hsl(var(--chart-3))",
  "hsl(var(--chart-4))",
  "hsl(var(--chart-5))"
], MLe = {
  count: {
    label: "Avg cost",
    color: Hb[0]
  }
};
function TLe({
  data: e,
  loading: r = !1
}) {
  const t = e.map((i, n) => ({
    name: i.identifier,
    value: i.average_cost,
    fill: Hb[n % Hb.length]
    // Cycle through colors
  }));
  return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ l(Sr, { children: /* @__PURE__ */ l(Or, { children: "Average cost" }) }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: r ? /* @__PURE__ */ C("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: [
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ l(gt, { config: MLe, className: "h-[400px] w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: t,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ l(Gt, { vertical: !1 }),
          /* @__PURE__ */ l(
            pt,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ l(mt, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(Kr, { dataKey: "value", radius: [4, 4, 4, 4] })
        ]
      }
    ) }) })
  ] });
}
const jb = [
  "hsl(var(--chart-1))",
  "hsl(var(--chart-2))",
  "hsl(var(--chart-3))",
  "hsl(var(--chart-4))",
  "hsl(var(--chart-5))"
], ELe = {
  count: {
    label: "Avg cost",
    color: jb[0]
  }
};
function kLe({
  data: e,
  loading: r = !1
}) {
  const t = e.map((i, n) => ({
    name: i.identifier,
    value: i.average_cost,
    fill: jb[n % jb.length]
    // Cycle through colors
  }));
  return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ l(Sr, { children: /* @__PURE__ */ l(Or, { children: "Average cost pre report" }) }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: r ? /* @__PURE__ */ C("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: [
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ l(gt, { config: ELe, className: "h-[400px] w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: t,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ l(Gt, { vertical: !1 }),
          /* @__PURE__ */ l(
            pt,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ l(mt, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(Kr, { dataKey: "value", radius: [4, 4, 4, 4] })
        ]
      }
    ) }) })
  ] });
}
const zb = [
  "hsl(var(--chart-1))",
  "hsl(var(--chart-2))",
  "hsl(var(--chart-3))",
  "hsl(var(--chart-4))",
  "hsl(var(--chart-5))"
], OLe = {
  count: {
    label: "Avg cost",
    color: zb[0]
  }
};
function DLe({
  data: e,
  loading: r = !1
}) {
  const t = e.map((i, n) => ({
    name: i.identifier,
    value: i.average_cost,
    fill: zb[n % zb.length]
    // Cycle through colors
  }));
  return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ l(Sr, { children: /* @__PURE__ */ l(Or, { children: "Average cost report" }) }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: r ? /* @__PURE__ */ C("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: [
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ l(gt, { config: OLe, className: "h-[400px] w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: t,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ l(Gt, { vertical: !1 }),
          /* @__PURE__ */ l(
            pt,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ l(mt, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(Kr, { dataKey: "value", radius: [4, 4, 4, 4] })
        ]
      }
    ) }) })
  ] });
}
const Bb = [
  "hsl(var(--chart-1))",
  "hsl(var(--chart-2))",
  "hsl(var(--chart-3))",
  "hsl(var(--chart-4))",
  "hsl(var(--chart-5))"
], RLe = {
  count: {
    label: "Avg cost",
    color: Bb[0]
  }
};
function ILe({
  data: e,
  loading: r = !1
}) {
  const t = e.map((i, n) => ({
    name: i.identifier,
    value: i.average_cost,
    fill: Bb[n % Bb.length]
    // Cycle through colors
  }));
  return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ l(Sr, { children: /* @__PURE__ */ l(Or, { children: "Average cost report" }) }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: r ? /* @__PURE__ */ C("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: [
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ l(gt, { config: RLe, className: "h-[400px] w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: t,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ l(Gt, { vertical: !1 }),
          /* @__PURE__ */ l(
            pt,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ l(mt, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(Kr, { dataKey: "value", radius: [4, 4, 4, 4] })
        ]
      }
    ) }) })
  ] });
}
const yg = {
  flagged_for_council_reviewed: {
    label: "Flagged, reviewed",
    color: "hsl(var(--chart-1))"
  },
  flagged_for_council_not_reviewed: {
    label: "Flagged, not reviewed",
    color: "var(--color-yellowDefault)"
  }
  // not_flagged: {
  //   label: "Not flagged",
  //   color: "hsl(var(--chart-3))",
  // },
};
function LLe({
  data: e,
  groupType: r,
  loading: t = !1
}) {
  return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ C(Sr, { children: [
      /* @__PURE__ */ l(Or, { children: "Conversations flagged for review" }),
      r && /* @__PURE__ */ C(ii, { children: [
        "by ",
        r.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: t ? /* @__PURE__ */ C("div", { className: "flex h-[400px] items-end justify-between gap-2 px-12 pb-16", children: [
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ l(gt, { config: yg, className: "h-[400px] w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: e,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ l(Gt, { vertical: !1 }),
          /* @__PURE__ */ l(
            pt,
            {
              dataKey: "time",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ l(mt, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(
            zi,
            {
              content: /* @__PURE__ */ l(tu, {}),
              verticalAlign: "top",
              align: "right"
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "flagged_for_council_reviewed",
              stackId: "a",
              fill: yg.flagged_for_council_reviewed.color,
              radius: [0, 0, 4, 4],
              name: "Flagged, reviewed"
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "flagged_for_council_not_reviewed",
              stackId: "a",
              fill: yg.flagged_for_council_not_reviewed.color,
              radius: [4, 4, 0, 0],
              name: "Flagged, not reviewed"
            }
          )
        ]
      }
    ) }) })
  ] });
}
const pc = {
  completed: {
    label: "Completed",
    color: "var(--color-greenDefault)"
  },
  reviewed: {
    label: "Reviewed",
    color: "hsl(var(--chart-1))"
  },
  review_needed: {
    label: "Flagged",
    color: "var(--color-yellowDefault)"
  },
  report_correct: {
    label: "Report correct",
    color: "var(--color-blueDefault)"
  },
  report_incorrect: {
    label: "Report incorrect",
    color: "var(--color-redDefault)"
  }
};
function _Le({
  data: e,
  groupType: r,
  loading: t = !1
}) {
  return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ C(Sr, { children: [
      /* @__PURE__ */ l(Or, { children: "Conversations flagged for review" }),
      r && /* @__PURE__ */ C(ii, { children: [
        "by ",
        r.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: t ? /* @__PURE__ */ C("div", { className: "flex h-[400px] items-end justify-between gap-2 px-12 pb-16", children: [
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ l(gt, { config: pc, className: "h-[400px] w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: e,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ l(Gt, { vertical: !1 }),
          /* @__PURE__ */ l(
            pt,
            {
              dataKey: "week_start",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ l(mt, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(
            zi,
            {
              content: /* @__PURE__ */ l(tu, {}),
              verticalAlign: "top",
              align: "right"
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "completed",
              fill: pc.completed.color,
              radius: [4, 4, 0, 0],
              name: "Completed"
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "review_needed",
              fill: pc.review_needed.color,
              radius: [4, 4, 0, 0],
              name: "Flagged"
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "reviewed",
              fill: pc.reviewed.color,
              radius: [4, 4, 0, 0],
              name: "Reviewed"
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "report_correct",
              fill: pc.report_correct.color,
              radius: [4, 4, 0, 0],
              name: "Report correct"
            }
          )
        ]
      }
    ) }) })
  ] });
}
function HLe({
  data: e = [],
  loading: r = !1
}) {
  const t = $e(() => [...e].sort(
    (i, n) => n.reviewed_last_week - i.reviewed_last_week
  ), [e]);
  return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ C(Sr, { children: [
      /* @__PURE__ */ l(Or, { children: "Review Leaderboard" }),
      /* @__PURE__ */ l(ii, { children: "Planner review activity" })
    ] }),
    /* @__PURE__ */ l(Nr, { children: /* @__PURE__ */ C(pl, { children: [
      /* @__PURE__ */ l(ml, { children: /* @__PURE__ */ C(ti, { children: [
        /* @__PURE__ */ l(Ir, { className: "w-[200px]", children: "Name" }),
        /* @__PURE__ */ l(Ir, { className: "text-center", children: "Reviews this week" }),
        /* @__PURE__ */ l(Ir, { className: "text-center", children: "Reviews all time" })
      ] }) }),
      /* @__PURE__ */ l(gl, { children: r ? /* @__PURE__ */ l(ti, { children: /* @__PURE__ */ l(De, { colSpan: 3, className: "py-8 text-center", children: "Loading..." }) }) : t.length === 0 ? /* @__PURE__ */ l(ti, { children: /* @__PURE__ */ l(De, { colSpan: 3, className: "py-8 text-center", children: "No review data available" }) }) : t.map((i) => /* @__PURE__ */ C(
        ti,
        {
          className: "border-interfaceBorder",
          children: [
            /* @__PURE__ */ l(De, { children: i.reviewer }),
            /* @__PURE__ */ l(De, { className: "text-center", children: i.reviewed_last_week }),
            /* @__PURE__ */ l(De, { className: "text-center", children: i.reviewed_all_time })
          ]
        },
        i.reviewer
      )) })
    ] }) })
  ] });
}
function jLe({
  data: e = [],
  loading: r = !1
}) {
  return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ C(Sr, { className: "pb-3", children: [
      /* @__PURE__ */ l(Or, { children: "Review Leaderboard" }),
      /* @__PURE__ */ l(ii, { children: "Planner review activity" })
    ] }),
    /* @__PURE__ */ C(Nr, { className: "flex flex-col gap-2", children: [
      r && /* @__PURE__ */ l("p", { children: "Loading..." }),
      !r && e.length === 0 && /* @__PURE__ */ l("p", { children: "No review data available" }),
      !r && e.length > 0 && e.map((t) => {
        const i = Object.entries(t.reviewers);
        return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
          /* @__PURE__ */ l(Sr, { className: "p-3 pb-0", children: /* @__PURE__ */ C(ii, { children: [
            "Reviews for week of:",
            " ",
            /* @__PURE__ */ C("span", { className: "font-medium", children: [
              t.week_start,
              " to ",
              t.week_end
            ] })
          ] }) }),
          /* @__PURE__ */ l(Nr, { className: "p-3 pt-0", children: /* @__PURE__ */ C(pl, { children: [
            /* @__PURE__ */ l(ml, { children: /* @__PURE__ */ C(ti, { children: [
              /* @__PURE__ */ l(Ir, { className: "w-[200px]", children: "Email" }),
              /* @__PURE__ */ l(Ir, { children: "Conversations reviewed" })
            ] }) }),
            /* @__PURE__ */ C(gl, { children: [
              i.length > 0 && i.map(([n, s]) => /* @__PURE__ */ C(
                ti,
                {
                  className: "border-interfaceBorder",
                  children: [
                    /* @__PURE__ */ l(De, { children: n }),
                    /* @__PURE__ */ l(De, { children: s })
                  ]
                },
                n
              )),
              i.length === 0 && /* @__PURE__ */ l(ti, { className: "border-interfaceBorder", children: /* @__PURE__ */ l(
                De,
                {
                  className: "text-bodyxs text-textSubdued",
                  colSpan: 2,
                  children: "No reviews for this period"
                }
              ) })
            ] })
          ] }) })
        ] });
      })
    ] })
  ] });
}
const Ag = {
  sent_to_council: {
    label: "Complete",
    color: "hsl(var(--chart-1))"
  },
  off_topic: {
    label: "Off Topic",
    color: "var(--color-yellowDefault)"
  }
};
function zLe({
  data: e,
  groupType: r,
  loading: t = !1
}) {
  return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ C(Sr, { children: [
      /* @__PURE__ */ l(Or, { children: "Conversation volume" }),
      r && /* @__PURE__ */ C(ii, { children: [
        "by ",
        r.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: t ? /* @__PURE__ */ C("div", { className: "flex h-[400px] items-end justify-between gap-2 px-12 pb-16", children: [
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ l(gt, { config: Ag, className: "h-[400px] w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: e,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ l(Gt, { vertical: !1 }),
          /* @__PURE__ */ l(
            pt,
            {
              dataKey: "time",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ l(mt, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(
            zi,
            {
              content: /* @__PURE__ */ l(tu, {}),
              verticalAlign: "top",
              align: "right"
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "sent_to_council",
              stackId: "a",
              fill: Ag.sent_to_council.color,
              radius: [0, 0, 4, 4],
              name: "Complete"
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "off_topic",
              stackId: "a",
              fill: Ag.off_topic.color,
              radius: [4, 4, 0, 0],
              name: "Off Topic"
            }
          )
        ]
      }
    ) }) })
  ] });
}
function BLe({
  data: e,
  from: r,
  groupType: t,
  loading: i
}) {
  const n = $e(() => e.reduce((u, o) => u + (o.sent_to_council || 0), 0), [e]), s = $e(() => e.reduce((u, o) => u + (o.off_topic || 0), 0), [e]);
  return /* @__PURE__ */ C("div", { className: "space-y-4", children: [
    /* @__PURE__ */ C("div", { className: "grid grid-cols-1 gap-4 md:grid-cols-2", children: [
      /* @__PURE__ */ l(
        Ii,
        {
          title: "Complete Conversations",
          subtitle: "Since " + ut(Ss(r), "dd MMM, yyyy"),
          children: i ? "..." : n
        }
      ),
      /* @__PURE__ */ l(
        Ii,
        {
          title: "Off-Topic Conversations",
          subtitle: "Since " + ut(Ss(r), "dd MMM, yyyy"),
          children: i ? "..." : s
        }
      )
    ] }),
    /* @__PURE__ */ l(
      zLe,
      {
        data: e,
        groupType: t,
        loading: i
      }
    )
  ] });
}
const WLe = {
  abandoned: {
    label: "Abandoned",
    color: "hsl(var(--chart-2))"
  },
  completed: {
    label: "Completed",
    color: "hsl(var(--chart-1))"
  }
};
function GLe({
  data: e,
  loading: r = !1
}) {
  const t = e.map((i) => ({
    name: i.council_name,
    abandoned: i.in_progress + i.off_topic + i.error + i.discarded,
    completed: i.done
  }));
  return /* @__PURE__ */ C(Pr, { className: "h-full w-full", children: [
    /* @__PURE__ */ l(Sr, { className: "items-center", children: /* @__PURE__ */ l(Or, { children: "Customer Completeness" }) }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: r ? /* @__PURE__ */ C("div", { className: "flex h-[400px] flex-col justify-between gap-4 px-12", children: [
      /* @__PURE__ */ l(Xe, { className: "h-16 w-[90%] rounded-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-16 w-[70%] rounded-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-16 w-[80%] rounded-lg" })
    ] }) : /* @__PURE__ */ l(gt, { config: WLe, className: "w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: t,
        width: 100,
        height: 100,
        layout: "vertical",
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ l(Gt, { horizontal: !0, vertical: !1 }),
          /* @__PURE__ */ l(pt, { type: "number", tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ l(
            mt,
            {
              interval: 0,
              type: "category",
              dataKey: "name",
              tickLine: !1,
              axisLine: !1,
              width: 150
            }
          ),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(
            zi,
            {
              content: /* @__PURE__ */ l(tu, {}),
              verticalAlign: "bottom",
              align: "center"
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "abandoned",
              name: "Abandoned",
              fill: "hsl(var(--chart-2))",
              radius: [0, 0, 0, 0],
              stackId: "a"
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "completed",
              name: "Completed",
              fill: "hsl(var(--chart-1))",
              radius: [0, 0, 0, 0],
              stackId: "a"
            }
          )
        ]
      }
    ) }) })
  ] });
}
function ULe(e) {
  const [r, t] = ie(!0), [i, n] = ie(null), [s, u] = ie(!1), o = () => {
    t(!1), u(!0);
  };
  return Pe(() => {
    if (!document) {
      const c = new Error(`[ScriptLoadingError] document not defined when attempting to load ${e}`);
      n(c);
      return;
    }
    const d = document.querySelector(`script[src="${e}"]`);
    if (d != null && d.dataset.loaded) {
      o();
      return;
    }
    const a = d || document.createElement("script");
    d || (a.src = e);
    const V = () => {
      a.dataset.loaded = "1", o();
    };
    a.addEventListener("load", V), a.addEventListener("error", (c) => {
      console.error("Failed to load script:", e, c);
      const F = new Error(`[ScriptLoadingError] Failed to load script: ${e}`);
      n(F);
    }), d || document.head.append(a);
  }, []), {
    isLoading: r,
    error: i,
    isSuccess: s
  };
}
const ZLe = (e) => e && e.charts, uO = (e, r) => {
  const { controls: t, toolbarItems: i, getChartEditor: n } = e;
  return r && r.charts && r.visualization && r.visualization.ChartWrapper && r.visualization.Dashboard && (!t || r.visualization.ChartWrapper) && (!n || r.visualization.ChartEditor) && (!i || r.visualization.drawToolbar);
}, JLe = (e) => window.google;
function $Le(e) {
  const { chartVersion: r = "current", chartPackages: t = [
    "corechart",
    "controls"
  ], chartLanguage: i = "en", mapsApiKey: n } = e, [s, u] = ie(null), [o, d] = ie(null), [a, V] = ie(null), { isLoading: c, error: F, isSuccess: X } = ULe(e.chartLoaderScriptUrl || "https://www.gstatic.com/charts/loader.js");
  return Pe(() => {
    if (!X)
      return;
    const Y = JLe();
    if (!ZLe(Y)) {
      const q = new Error("[ScriptInitializationError] Script loaded but Google not attached to window.");
      d(q);
      return;
    }
    if (uO(e, Y)) {
      u(Y);
      return;
    }
    Y.charts.load(r, {
      packages: t,
      language: i,
      mapsApiKey: n
    }), Y.charts.setOnLoadCallback(() => {
      if (!uO(e, Y)) {
        const q = new Error("[GoogleChartsInitializationError] Google Charts not ready after load callback.");
        console.error(q), V(q);
        return;
      }
      u(Y);
    });
  }, [
    X
  ]), {
    error: F || o || a,
    isLoading: c,
    google: s
  };
}
const cQ = {
  // <DEPRECATED_PROPS>
  legend_toggle: !1,
  // </DEPRECATED_PROPS>
  options: {},
  legendToggle: !1,
  getChartWrapper: () => {
  },
  spreadSheetQueryParameters: {
    headers: 1,
    gid: 1
  },
  rootProps: {},
  chartWrapperParams: {},
  chartLoaderScriptUrl: "https://www.gstatic.com/charts/loader.js"
}, QLe = (e) => {
  const { isReady: r, chartControls: t, filter: i } = e;
  return !r || !t || !(t != null && t.length) ? null : /* @__PURE__ */ D.createElement(D.Fragment, null, t.filter((n) => {
    let { controlProp: s, control: u } = n;
    return i ? i({
      control: u,
      controlProp: s
    }) : !0;
  }).map((n) => {
    let { control: s } = n;
    return /* @__PURE__ */ D.createElement("div", {
      key: s.getContainerId(),
      id: s.getContainerId()
    });
  }));
};
let oO = 0;
const FQ = () => (oO += 1, `reactgooglegraph-${oO}`), As = class As {
};
/**
* Initialize the controls once chart is ready
*/
Gn(As, "initializeControls", (r) => {
  for (let t = 0; t < r.length; t += 1) {
    const { controlType: i, options: n, controlWrapperParams: s } = r[t].controlProp;
    s && "state" in s && r[t].control.setState(s.state), r[t].control.setOptions(n), r[t].control.setControlType(i);
  }
}), /**
* listen to the control events (ready, statechange, error) specified in the controlEvents prop
*/
Gn(As, "listenToControlEvents", (r, t) => {
  const { google: i } = t;
  return r.flatMap((n) => {
    const { control: s, controlProp: u } = n, { controlEvents: o = [] } = u;
    return o.map((d) => {
      const { callback: a, eventName: V } = d;
      return i.visualization.events.addListener(s, V, function() {
        for (var c = arguments.length, F = new Array(c), X = 0; X < c; X++)
          F[X] = arguments[X];
        a({
          chartWrapper: null,
          controlWrapper: s,
          props: t,
          google: i,
          eventArgs: F
        });
      });
    });
  });
}), /**
* If controlID is not provided, generate a unique controlID
*/
Gn(As, "createControlId", (r) => {
  let t;
  return typeof r > "u" ? t = `googlechart-control-${FQ()}` : t = r, t;
}), /**
* Map the control props to Google Chart Controls
*/
Gn(As, "createChartControls", (r) => {
  const { controls: t, google: i } = r;
  return t ? t.map((n, s) => {
    const { controlID: u, controlType: o, options: d, controlWrapperParams: a } = n, V = As.createControlId(u);
    return {
      controlProp: n,
      control: new i.visualization.ControlWrapper({
        containerId: V,
        controlType: o,
        options: d,
        ...a
      })
    };
  }) : null;
}), Gn(As, "addControls", (r) => {
  const { chartWrapper: t, chartDashboard: i } = r, n = As.createChartControls(r);
  return !n || !i || !t ? null : (i.bind(n.map((s) => {
    let { control: u } = s;
    return u;
  }), t), As.initializeControls(n), n);
});
let Fq = As;
const e_e = (e) => {
  const [r, t] = h.useState(null);
  return [
    h.useMemo(() => !r || !e ? null : e.map((n, s) => {
      const u = r[s];
      return u ? {
        controlProp: n,
        control: u
      } : void 0;
    }).flatMap((n) => n ? [
      n
    ] : []), [
      r,
      e
    ]),
    t
  ];
}, r_e = (e, r) => {
  h.useEffect(() => {
    const t = Fq.listenToControlEvents(e ?? [], r);
    return () => {
      t.forEach((i) => {
        r.google.visualization.events.removeListener(i);
      });
    };
  }, [
    e,
    r
  ]);
}, t_e = (e) => {
  const [r, t] = e_e(e.controls);
  return r_e(r ?? [], e), {
    addControls: (n) => {
      const s = Fq.addControls(n);
      t((s == null ? void 0 : s.map((u) => u.control)) ?? null);
    },
    renderControl: (n) => {
      const { chartWrapper: s, chartDashboard: u } = e;
      return /* @__PURE__ */ h.createElement(QLe, {
        ...e,
        isReady: !!(s && u),
        chartControls: r,
        filter: n
      });
    }
  };
}, i_e = (e) => {
  const r = h.useRef(null);
  return {
    chartId: (() => {
      const { graphID: n, graph_id: s } = e, u = n || s;
      let o;
      return u ? o = u : o = r.current || FQ(), r.current = o, r.current;
    })()
  };
}, n_e = [
  "#3366CC",
  "#DC3912",
  "#FF9900",
  "#109618",
  "#990099",
  "#3B3EAC",
  "#0099C6",
  "#DD4477",
  "#66AA00",
  "#B82E2E",
  "#316395",
  "#994499",
  "#22AA99",
  "#AAAA11",
  "#6633CC",
  "#E67300",
  "#8B0707",
  "#329262",
  "#5574A6",
  "#3B3EAC"
], s_e = async function(e, r) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return new Promise((i, n) => {
    const s = `${t.headers ? `headers=${t.headers}` : "headers=0"}`, u = `${t.query ? `&tq=${encodeURIComponent(t.query)}` : ""}`, o = `${t.gid ? `&gid=${t.gid}` : ""}`, d = `${t.sheet ? `&sheet=${t.sheet}` : ""}`, a = `${t.access_token ? `&access_token=${t.access_token}` : ""}`, V = `${s}${o}${d}${u}${a}`, c = `${r}/gviz/tq?${V}`;
    new e.visualization.Query(c).send((X) => {
      X.isError() ? n(`Error in query:  ${X.getMessage()} ${X.getDetailedMessage()}`) : i(X.getDataTable());
    });
  });
}, u_e = "#CCCCCC", An = class An {
};
Gn(An, "grayOutHiddenColumnsLabel", (r, t) => {
  const { googleChartWrapper: i, options: n } = r;
  if (!i) {
    console.error("googleChartWrapper is not defined");
    return;
  }
  const s = i.getDataTable();
  if (!s) return;
  const u = s.getNumberOfColumns();
  if (t.length > 0 === !1) return;
  const d = Array.from({
    length: u - 1
  }).map((a, V) => {
    const c = An.getColumnId(s, V + 1);
    return t.includes(c) ? u_e : n && n.colors ? n.colors[V] : n_e[V];
  });
  i.setOptions({
    ...n,
    colors: d
  }), i.draw();
}), /**
* Listens to user clicking on the legend to toggle the visibility of a column.
* When a user clicks on a legend item, the column id is added to / removed from the hiddenColumns state.
*/
Gn(An, "listenToLegendToggle", (r, t) => {
  const [i, n] = t, { google: s, googleChartWrapper: u } = r;
  if (!u) {
    console.error("googleChartWrapper is not defined");
    return;
  }
  return s.visualization.events.addListener(u, "select", () => {
    const d = u.getChart().getSelection(), a = u.getDataTable();
    if (d.length === 0 || // We want to listen to when a whole row is selected. This is the case only when row === null
    d[0].row !== null || !a)
      return;
    const V = d[0].column, c = An.getColumnId(a, V);
    i != null && i.includes(c) ? n((F) => [
      ...F.filter((X) => X !== c)
    ]) : n((F) => [
      ...F,
      c
    ]);
  });
}), /**
* (Re-)Draw a Google Chart with the given data, options, and chart type.
*/
Gn(An, "draw", async (r) => {
  const { data: t, diffdata: i, rows: n, columns: s, options: u, chartType: o, formatters: d, spreadSheetUrl: a, spreadSheetQueryParameters: V, googleChartDashboard: c, googleChartWrapper: F, google: X, hiddenColumns: Y, legendToggle: q, legend_toggle: f } = r;
  if (!F) {
    console.error("draw was called with googleChartWrapper = null");
    return;
  }
  let p, m = null;
  if (i) {
    const w = X.visualization.arrayToDataTable(i.old), S = X.visualization.arrayToDataTable(i.new);
    m = X.visualization[o].prototype.computeDiff(w, S);
  }
  t ? t instanceof X.visualization.DataTable ? p = t : Array.isArray(t) ? p = X.visualization.arrayToDataTable(t) : p = new X.visualization.DataTable(t) : n && s ? p = X.visualization.arrayToDataTable([
    s,
    ...n
  ]) : a ? p = await s_e(X, a, V) : p = X.visualization.arrayToDataTable([]);
  const g = p.getNumberOfColumns(), y = Array(g).fill(0).map((w, S) => {
    const N = An.getColumnId(p, S);
    return Y.includes(N) ? {
      label: p.getColumnLabel(S),
      type: p.getColumnType(S),
      calc: () => null
    } : S;
  }), b = F.getChart();
  F.getChartType() === "Timeline" && b && b.clearChart(), F.setChartType(o), F.setOptions(u || {});
  const A = new X.visualization.DataView(p);
  A.setColumns(y), F.setDataTable(A), F.draw(), c && c.draw(p), m && (F.setDataTable(m), F.draw()), d && (An.applyFormatters({
    dataTable: p,
    formatters: d,
    google: X
  }), F.setDataTable(p), F.draw()), (q === !0 || f === !0) && An.grayOutHiddenColumnsLabel(r, Y);
}), /**
* Get the column ID of a column in a GoogleDataTable.
* If the column has an ID, return the ID, otherwise return the label.
*/
Gn(An, "getColumnId", (r, t) => r.getColumnId(t) || r.getColumnLabel(t)), /**
* Apply Chart Formatters passed under the formatters prop to the GoogleDataTable
*/
Gn(An, "applyFormatters", (r) => {
  let { dataTable: t, formatters: i, google: n } = r;
  for (let s of i)
    switch (s.type) {
      case "ArrowFormat": {
        new n.visualization.ArrowFormat(s.options).format(t, s.column);
        return;
      }
      case "BarFormat": {
        new n.visualization.BarFormat(s.options).format(t, s.column);
        return;
      }
      case "ColorFormat": {
        const u = new n.visualization.ColorFormat(s.options), { ranges: o } = s;
        if (o)
          for (let d of o)
            u.addRange(...d);
        u.format(t, s.column);
        return;
      }
      case "DateFormat": {
        new n.visualization.DateFormat(s.options).format(t, s.column);
        return;
      }
      case "NumberFormat": {
        new n.visualization.NumberFormat(s.options).format(t, s.column);
        return;
      }
      case "PatternFormat": {
        new n.visualization.PatternFormat(s.options).format(t, s.column);
        return;
      }
      default: {
        console.warn(`Unknown formatter type: ${s.type}`);
        return;
      }
    }
});
let jc = An;
const o_e = (e) => {
  const { google: r, googleChartWrapper: t, googleChartDashboard: i } = e, [n, s] = h.useState([]);
  h.useEffect(() => {
    t && jc.draw({
      ...e,
      hiddenColumns: n,
      googleChartWrapper: t,
      googleChartDashboard: i,
      google: r
    });
  }, [
    n,
    e.data,
    e.rows,
    e.columns,
    e.options,
    e.chartLoaderScriptUrl,
    e.chartType,
    e.formatters,
    e.spreadSheetUrl,
    e.spreadSheetQueryParameters,
    e.legendToggle,
    e.legend_toggle
  ]);
  const u = () => {
    const { googleChartWrapper: a } = e;
    a && a.draw();
  }, o = (a) => {
    const V = [], { legendToggle: c, legend_toggle: F } = e;
    if (jc.draw({
      ...e,
      hiddenColumns: n,
      googleChartWrapper: a,
      googleChartDashboard: i,
      google: r
    }), window.addEventListener("resize", u), F || c) {
      const X = jc.listenToLegendToggle(e, [
        n,
        s
      ]);
      X && V.push(X);
    }
    return V;
  }, d = (a, V) => {
    window.removeEventListener("resize", u), V.forEach((c) => {
      r.visualization.events.removeListener(c);
    }), a.getChartType() === "Timeline" && a.getChart() && a.getChart().clearChart();
  };
  h.useEffect(() => {
    if (!t)
      return;
    const a = o(t);
    return () => {
      d(t, a);
    };
  }, [
    t,
    o,
    d
  ]);
}, d_e = (e) => {
  const { chartEvents: r, google: t, googleChartWrapper: i } = e;
  if (r) {
    if (!i) {
      console.warn("listenToEvents was called before chart wrapper ready.");
      return;
    }
    return r.map((n) => {
      let { eventName: s, callback: u } = n;
      return t.visualization.events.addListener(i, s, function() {
        for (var o = arguments.length, d = new Array(o), a = 0; a < o; a++)
          d[a] = arguments[a];
        u({
          chartWrapper: i,
          props: e,
          google: t,
          eventArgs: d
        });
      });
    });
  }
}, a_e = (e) => {
  Pe(() => {
    if (!e.googleChartWrapper) return;
    const r = d_e(e);
    return () => {
      r == null || r.forEach((t) => {
        e.google.visualization.events.removeListener(t);
      });
    };
  }, [
    e
  ]);
}, V_e = (e) => {
  const [r, t] = h.useState(null), [i, n] = h.useState(null), { addControls: s, renderControl: u } = t_e({
    ...e,
    chartDashboard: i,
    chartWrapper: r
  });
  a_e({
    ...e,
    googleChartWrapper: r
  });
  const { chartId: o } = i_e(e), d = h.useRef(null), a = h.useRef(null);
  h.useEffect(() => {
    const { options: p, google: m, chartType: g, chartWrapperParams: y, toolbarItems: b, getChartEditor: A, getChartWrapper: w, onLoad: S } = e, N = {
      chartType: g,
      options: p,
      containerId: o,
      ...y
    }, O = new m.visualization.ChartWrapper(N);
    O.setOptions(p || {}), w == null || w(O, m);
    const E = new m.visualization.Dashboard(d.current);
    b && m.visualization.drawToolbar(a.current, b);
    let I = null;
    A && (I = new m.visualization.ChartEditor(), A({
      chartEditor: I,
      chartWrapper: O,
      google: m
    })), s({
      ...e,
      chartDashboard: E,
      chartWrapper: O
    }), t(O), n(E), S == null || S(m, {
      google: m,
      chartWrapper: O,
      chartEditor: I,
      chartDashboard: E
    });
  }, []), o_e({
    ...e,
    googleChartWrapper: r,
    googleChartDashboard: i
  });
  const V = () => {
    const { width: p, height: m, options: g, style: y, className: b, rootProps: A, google: w } = e, S = {
      height: m || g && g.height,
      width: p || g && g.width,
      ...y
    };
    return /* @__PURE__ */ h.createElement("div", {
      id: o,
      style: S,
      className: b,
      ...A
    });
  }, c = () => e.toolbarItems ? /* @__PURE__ */ h.createElement("div", {
    ref: a
  }) : null, { width: F, height: X, options: Y, style: q } = e, f = {
    height: X || Y && Y.height,
    width: F || Y && Y.width,
    ...q
  };
  return e.render ? /* @__PURE__ */ h.createElement("div", {
    ref: d,
    style: f
  }, /* @__PURE__ */ h.createElement("div", {
    ref: a,
    id: "toolbar"
  }), e.render({
    renderChart: V,
    renderControl: u,
    renderToolbar: c
  })) : /* @__PURE__ */ h.createElement("div", {
    ref: d,
    style: f
  }, u((p) => {
    let { controlProp: m } = p;
    return m.controlPosition !== "bottom";
  }), V(), u((p) => {
    let { controlProp: m } = p;
    return m.controlPosition === "bottom";
  }), c());
}, l_e = /* @__PURE__ */ h.createContext(cQ), c_e = (e) => {
  let { children: r, value: t } = e;
  return /* @__PURE__ */ h.createElement(l_e.Provider, {
    value: t
  }, r);
}, F_e = (e) => {
  const { google: r, isLoading: t, error: i } = $Le(e);
  return t ? e.loader ?? null : i ? e.errorElement ?? null : r ? /* @__PURE__ */ D.createElement(V_e, {
    google: r,
    ...e
  }) : null;
}, x_e = (e) => {
  const r = {
    ...cQ,
    ...e
  };
  return /* @__PURE__ */ D.createElement(c_e, {
    value: r
  }, /* @__PURE__ */ D.createElement(F_e, r));
};
var dO;
(function(e) {
  e.annotation = "annotation", e.annotationText = "annotationText", e.certainty = "certainty", e.emphasis = "emphasis", e.interval = "interval", e.scope = "scope", e.style = "style", e.tooltip = "tooltip", e.domain = "domain";
})(dO || (dO = {}));
function X_e({
  className: e,
  data: r,
  title: t = "Sankey Chart",
  loading: i = !1,
  options: n = {},
  height: s,
  width: u
}) {
  const [o, d] = ie(null), a = [...r], V = {
    sankey: {
      node: {
        colors: ["#2d5de8", "#6ec6ff", "#53a6f7", "#b9e6fd", "#e5f5ff"],
        label: {
          fontSize: 14,
          color: "#03045F"
        },
        nodePadding: 20
      },
      link: {
        colorMode: "gradient",
        colors: ["#2d5de8", "#6ec6ff", "#53a6f7", "#b9e6fd", "#e5f5ff"]
      }
    },
    tooltip: {
      textStyle: {
        fontSize: 12
      },
      showColorCode: !0,
      isHtml: !0
    },
    backgroundColor: "transparent"
  }, c = ZW.merge(V, n);
  return Pe(() => {
    const F = (X) => {
      (X.message.includes("google") || X.message.includes("chart")) && (console.error("Sankey Chart Error:", X), d(new Error(X.message)));
    };
    return window.addEventListener("error", F), () => window.removeEventListener("error", F);
  }, []), /* @__PURE__ */ C(Pr, { className: "h-full w-full", children: [
    /* @__PURE__ */ l(Sr, { children: /* @__PURE__ */ l(Or, { children: t }) }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: i ? /* @__PURE__ */ C("div", { className: "flex h-[400px] flex-col justify-between gap-4 px-12", children: [
      /* @__PURE__ */ l(Xe, { className: "h-16 w-[90%] rounded-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-16 w-[70%] rounded-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-16 w-[80%] rounded-lg" })
    ] }) : o ? /* @__PURE__ */ C("div", { className: "text-destructive flex h-[400px] items-center justify-center", children: [
      "Error loading chart: ",
      o.message
    ] }) : /* @__PURE__ */ l(
      x_e,
      {
        className: _("w-full", e),
        chartType: "Sankey",
        width: u,
        height: s,
        data: a,
        options: c
      }
    ) })
  ] });
}
const aO = {
  average_response_time_seconds: {
    label: "average_response_time_seconds",
    color: "hsl(var(--chart-1))"
  }
};
function q_e({
  data: e,
  groupType: r,
  loading: t = !1
}) {
  return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ C(Sr, { children: [
      /* @__PURE__ */ l(Or, { children: "Conversation Average Assistant Response Time" }),
      r && /* @__PURE__ */ C(ii, { children: [
        "by ",
        r.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: t ? /* @__PURE__ */ C("div", { className: "flex h-[400px] items-end justify-between gap-2 px-12 pb-16", children: [
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ l(gt, { config: aO, className: "h-[400px] w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: e,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ l(Gt, { vertical: !1 }),
          /* @__PURE__ */ l(
            pt,
            {
              dataKey: "time",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ l(mt, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(
            zi,
            {
              content: /* @__PURE__ */ l(tu, {}),
              verticalAlign: "top",
              align: "right"
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "average_response_time_seconds",
              stackId: "a",
              fill: aO.average_response_time_seconds.color,
              radius: [4, 4, 4, 4],
              name: "average_response_time_seconds"
            }
          )
        ]
      }
    ) }) })
  ] });
}
const VO = {
  average_time_seconds: {
    label: "average_time_seconds",
    color: "hsl(var(--chart-1))"
  }
};
function Y_e({
  data: e,
  groupType: r,
  loading: t = !1
}) {
  return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ C(Sr, { children: [
      /* @__PURE__ */ l(Or, { children: "Conversation Average Report Time" }),
      r && /* @__PURE__ */ C(ii, { children: [
        "by ",
        r.toLowerCase()
      ] })
    ] }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: t ? /* @__PURE__ */ C("div", { className: "flex h-[400px] items-end justify-between gap-2 px-12 pb-16", children: [
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ l(gt, { config: VO, className: "h-[400px] w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: e,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 5 },
        children: [
          /* @__PURE__ */ l(Gt, { vertical: !1 }),
          /* @__PURE__ */ l(
            pt,
            {
              dataKey: "time",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ l(mt, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(
            zi,
            {
              content: /* @__PURE__ */ l(tu, {}),
              verticalAlign: "top",
              align: "right"
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "average_time_seconds",
              stackId: "a",
              fill: VO.average_time_seconds.color,
              radius: [4, 4, 4, 4],
              name: "average_time_seconds"
            }
          )
        ]
      }
    ) }) })
  ] });
}
const f_e = {
  in_hours: {
    label: "In Hours",
    color: "#B0AFAC"
  },
  out_of_hours: {
    label: "Out of Hours",
    color: "hsl(var(--chart-1))"
  }
};
function K_e({
  data: e,
  loading: r = !1
}) {
  const t = e.map((i) => ({
    name: i.week_start,
    in_hours: i.in_hours,
    out_of_hours: i.out_of_hours,
    total: i.in_hours + i.out_of_hours
  }));
  return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ l(Sr, { children: /* @__PURE__ */ l(Or, { children: "Conversations by Operating Hours" }) }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: r ? /* @__PURE__ */ C("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: [
      /* @__PURE__ */ l(Xe, { className: "h-[70%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[90%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[40%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[60%] w-16 rounded-t-lg" }),
      /* @__PURE__ */ l(Xe, { className: "h-[80%] w-16 rounded-t-lg" })
    ] }) : /* @__PURE__ */ l(gt, { config: f_e, className: "h-[400px] w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: t,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 60 },
        children: [
          /* @__PURE__ */ l(Gt, { vertical: !1 }),
          /* @__PURE__ */ l(
            pt,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ l(mt, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(lQ, { content: /* @__PURE__ */ l(tu, {}) }),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "in_hours",
              stackId: "operating_hours",
              fill: "var(--color-in_hours)",
              radius: [0, 0, 4, 4]
            }
          ),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "out_of_hours",
              stackId: "operating_hours",
              fill: "var(--color-out_of_hours)",
              radius: [4, 4, 0, 0]
            }
          )
        ]
      }
    ) }) })
  ] });
}
const xQ = [
  "hsl(var(--chart-1))",
  "hsl(var(--chart-2))",
  "hsl(var(--chart-3))",
  "hsl(var(--chart-4))",
  "hsl(var(--chart-5))"
], h_e = {
  count: {
    label: "Count",
    color: xQ[0]
  }
};
function p_e({
  data: e,
  loading: r = !1
}) {
  const t = Object.entries(e).map(([i, n]) => ({
    name: i,
    count: n
  })).sort((i, n) => n.count - i.count);
  return console.log("<ConversationByOutOfScopeItemsBarChart> chartData", t), /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ C(Sr, { children: [
      /* @__PURE__ */ l(Or, { children: "Conversations by Out of Scope Items" }),
      /* @__PURE__ */ l(ii, { children: "Distribution of conversations by planning zones and overlays" })
    ] }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: r ? /* @__PURE__ */ C("div", { className: "flex h-[600px] flex-col justify-between py-8 pl-16", children: [
      /* @__PURE__ */ l(Xe, { className: "h-6 w-[60%] rounded" }),
      /* @__PURE__ */ l(Xe, { className: "h-6 w-[80%] rounded" }),
      /* @__PURE__ */ l(Xe, { className: "h-6 w-[40%] rounded" }),
      /* @__PURE__ */ l(Xe, { className: "h-6 w-[70%] rounded" }),
      /* @__PURE__ */ l(Xe, { className: "h-6 w-[90%] rounded" }),
      /* @__PURE__ */ l(Xe, { className: "h-6 w-[50%] rounded" }),
      /* @__PURE__ */ l(Xe, { className: "h-6 w-[65%] rounded" }),
      /* @__PURE__ */ l(Xe, { className: "h-6 w-[35%] rounded" })
    ] }) : /* @__PURE__ */ l(gt, { config: h_e, className: "h-[600px] w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: t,
        layout: "vertical",
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 200, bottom: 5 },
        children: [
          /* @__PURE__ */ l(Gt, { horizontal: !1 }),
          /* @__PURE__ */ l(
            pt,
            {
              type: "number",
              tickLine: !1,
              axisLine: !1
            }
          ),
          /* @__PURE__ */ l(
            mt,
            {
              type: "category",
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              width: 180,
              tick: { fontSize: 12 }
            }
          ),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(
            Kr,
            {
              dataKey: "count",
              fill: xQ[0],
              radius: [0, 4, 4, 0]
            }
          )
        ]
      }
    ) }) })
  ] });
}
const gx = [
  "hsl(var(--chart-1))",
  "hsl(var(--chart-2))",
  "hsl(var(--chart-3))",
  "hsl(var(--chart-4))",
  "hsl(var(--chart-5))",
  "hsl(var(--chart-6))"
];
function m_e({
  data: e,
  loading: r = !1
}) {
  const t = e.length ? Object.keys(e[0]).filter(
    (s) => s !== "week_start" && s !== "week_end"
  ) : [], i = Object.fromEntries(
    t.map((s, u) => [
      s,
      {
        label: s,
        color: gx[u % gx.length]
      }
    ])
  ), n = e.map((s) => {
    const u = { name: s.week_start };
    return t.forEach((o) => {
      u[o] = s[o];
    }), u;
  });
  return /* @__PURE__ */ C(Pr, { className: "w-full", children: [
    /* @__PURE__ */ l(Sr, { children: /* @__PURE__ */ l(Or, { children: "Conversations by Language" }) }),
    /* @__PURE__ */ l(Nr, { className: "w-full", children: r ? /* @__PURE__ */ l("div", { className: "flex h-[400px] items-end justify-between px-12 pb-16", children: t.map((s, u) => /* @__PURE__ */ l(Xe, { className: `h-[${60 + u * 10}%] w-16 rounded-t-lg` }, u)) }) : /* @__PURE__ */ l(gt, { config: i, className: "h-[400px] w-full", children: /* @__PURE__ */ C(
      oi,
      {
        accessibilityLayer: !0,
        data: n,
        width: 100,
        height: 100,
        margin: { top: 20, right: 30, left: 20, bottom: 60 },
        children: [
          /* @__PURE__ */ l(Gt, { vertical: !1 }),
          /* @__PURE__ */ l(
            pt,
            {
              dataKey: "name",
              tickLine: !1,
              tickMargin: 10,
              axisLine: !1,
              angle: -45,
              textAnchor: "end",
              height: 100
            }
          ),
          /* @__PURE__ */ l(mt, { tickLine: !1, axisLine: !1 }),
          /* @__PURE__ */ l(Et, { content: /* @__PURE__ */ l(vt, {}) }),
          /* @__PURE__ */ l(lQ, { content: /* @__PURE__ */ l(tu, {}) }),
          t.map((s, u) => /* @__PURE__ */ l(
            Kr,
            {
              dataKey: s,
              stackId: "languages",
              fill: gx[u % gx.length],
              radius: u === 0 ? [0, 0, 4, 4] : u === t.length - 1 ? [4, 4, 0, 0] : [0, 0, 0, 0],
              name: s
            },
            s
          ))
        ]
      }
    ) }) })
  ] });
}
function g_e({
  chartType: e,
  council: r,
  groupType: t,
  from: i,
  to: n,
  includeInternalUsers: s
}) {
  switch (e) {
    case "CONVERSATION_CUSTOMER_COMPLETENESS":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_CUSTOMER_COMPLETENESS",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            GLe,
            {
              data: u || [],
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_ERRORS":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_ERRORS",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            fLe,
            {
              data: u || [],
              groupType: t,
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_BY_OVERLAY":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_BY_OVERLAY",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            KLe,
            {
              data: u || [],
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_BY_PHASE":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_BY_PHASE",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            pLe,
            {
              data: u || [],
              from: i,
              groupType: t,
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_BY_STATE":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_BY_STATE",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            gLe,
            {
              data: u || [],
              from: i,
              groupType: t,
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_BY_STATE_COUNCIL":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_BY_STATE_COUNCIL",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            bLe,
            {
              data: u || [],
              from: i,
              groupType: t,
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_BY_ZONE":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_BY_ZONE",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            yLe,
            {
              data: u || [],
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_BY_ZONE_OUTCOME":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_BY_ZONE_OUTCOME",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            CLe,
            {
              data: u || [],
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_BY_OVERLAY_OUTCOME":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_BY_OVERLAY_OUTCOME",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            NLe,
            {
              data: u || [],
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_COST":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_COST",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            TLe,
            {
              data: u || [],
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_COST_PRE_REPORT":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_COST_PRE_REPORT",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            kLe,
            {
              data: u || [],
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_COST_REPORT":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_COST_REPORT",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            DLe,
            {
              data: u || [],
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_VOLUME_BY_STAGE":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_VOLUME_BY_STAGE",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            BLe,
            {
              data: u || [],
              from: i,
              groupType: t,
              loading: o
            }
          )
        }
      );
    case "CONVERSATIONS_FLAGGED_FOR_REVIEW":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATIONS_FLAGGED_FOR_REVIEW",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            LLe,
            {
              data: u || [],
              groupType: t,
              loading: o
            }
          )
        }
      );
    case "CONVERSATIONS_BY_REVIEW_COUNCIL":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATIONS_BY_REVIEW_COUNCIL",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            _Le,
            {
              data: u || [],
              groupType: t,
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_REVIEW_LEADERBOARD":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_REVIEW_LEADERBOARD",
          council: r,
          groupType: void 0,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            HLe,
            {
              data: u || [],
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_REVIEW_LEADERBOARD_COUNCIL":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_REVIEW_LEADERBOARD_COUNCIL",
          council: r,
          groupType: void 0,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            jLe,
            {
              data: u || [],
              loading: o
            }
          )
        }
      );
    case "APPLICATIONS_REJECTED_REASONS":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "APPLICATIONS_REJECTED_REASONS",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            ILe,
            {
              data: u || [],
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_SANKEY":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_SANKEY",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            X_e,
            {
              data: u || [],
              title: "Conversation Flow",
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_AVERAGE_ASSISTANT_RESPONSE_TIME":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_AVERAGE_ASSISTANT_RESPONSE_TIME",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            q_e,
            {
              data: u || [],
              groupType: t,
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_AVERAGE_REPORT_TIME":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_AVERAGE_REPORT_TIME",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            Y_e,
            {
              data: u || [],
              groupType: t,
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_BY_OPERATING_HOURS":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_BY_OPERATING_HOURS",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            K_e,
            {
              data: u || [],
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_BY_OUT_OF_SCOPE_ITEMS":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_BY_OUT_OF_SCOPE_ITEMS",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            p_e,
            {
              data: u || {},
              loading: o
            }
          )
        }
      );
    case "CONVERSATION_BY_LANGUAGE":
      return /* @__PURE__ */ l(
        it,
        {
          chartType: "CONVERSATION_BY_LANGUAGE",
          council: r,
          groupType: t,
          from: i,
          to: n,
          includeInternalUsers: s,
          children: ({ data: u, isLoading: o }) => /* @__PURE__ */ l(
            m_e,
            {
              data: u || [],
              loading: o
            }
          )
        }
      );
  }
}
const v_e = [
  {
    label: "Week",
    value: "WEEK"
  },
  {
    label: "Month",
    value: "MONTH"
  },
  {
    label: "Year",
    value: "YEAR"
  },
  {
    label: "Hour",
    value: "HOUR"
  },
  {
    label: "Day",
    value: "DAY"
  },
  {
    label: "All",
    value: "ALL"
  }
];
function b_e({ onChange: e, values: r }) {
  return /* @__PURE__ */ l(
    Pz,
    {
      allowMultiSelect: !1,
      onChange: e,
      options: v_e,
      placeholder: "Group by",
      values: r
    }
  );
}
function ger({
  allowSelectingCouncils: e,
  allowSelectingInternal: r,
  allowSelectingGroupType: t = !0,
  defaultCouncil: i,
  defaultDateRange: n,
  chartTypes: s,
  forceIncludeInternal: u
}) {
  const o = /* @__PURE__ */ new Date();
  o.setHours(23, 59, 59, 999);
  const [d, a] = ie(() => n || {
    from: zd(Xt(o, -1)),
    to: zw(Xt(o, -1))
  }), [V, c] = ie([
    { label: "Week", value: "WEEK" }
  ]), [F, X] = ie(() => i || [
    {
      label: "All councils",
      value: ""
    }
  ]), [Y, q] = ie(!!u), f = (g) => {
    a(g);
  }, p = d != null && d.from ? Ec(d.from) : "", m = $e(() => {
    if (!(d != null && d.to)) return "";
    if (Ble(d.to)) {
      const g = /* @__PURE__ */ new Date();
      return Ec(
        dce(d.to, {
          hours: g.getHours(),
          minutes: g.getMinutes(),
          seconds: g.getSeconds(),
          milliseconds: g.getMilliseconds()
        })
      );
    } else
      return Ec(zw(d.to));
  }, [d == null ? void 0 : d.to]);
  return /* @__PURE__ */ C("div", { className: "container mx-auto space-y-4 p-4", children: [
    /* @__PURE__ */ C("div", { className: "mb-8 flex flex-wrap gap-4", children: [
      /* @__PURE__ */ l("div", { children: /* @__PURE__ */ l(
        fhe,
        {
          className: "flex-1",
          onChange: f,
          dateRange: d
        }
      ) }),
      t && /* @__PURE__ */ l("div", { children: /* @__PURE__ */ l(b_e, { onChange: c, values: V }) }),
      e && /* @__PURE__ */ l("div", { className: "md:max-w-[400px]", children: /* @__PURE__ */ l(
        y_e,
        {
          onChange: X,
          values: F
        }
      ) }),
      r && /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ C("label", { className: "text-bodysm font-medium", children: [
          "Include internal:",
          " "
        ] }),
        /* @__PURE__ */ l(
          b2,
          {
            checked: Y,
            onCheckedChange: q
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ l("div", { className: "flex flex-wrap gap-2", children: s.map((g) => {
      var A, w;
      const y = typeof g == "string" ? g : g.chartType, b = typeof g == "object" ? g.fullWidth : !1;
      return /* @__PURE__ */ l(
        "div",
        {
          className: _("w-full", {
            "md:max-w-[calc(50%_-_theme(spacing.2))] md:min-w-[400px]": !b,
            "md:max-w-[calc(100%_-_theme(spacing.2))] md:min-w-[400px]": b
          }),
          children: /* @__PURE__ */ l(
            g_e,
            {
              chartType: y,
              council: ((A = F[0]) == null ? void 0 : A.value) || "",
              groupType: (w = V[0]) == null ? void 0 : w.value,
              from: p,
              to: m,
              includeInternalUsers: Y
            }
          )
        },
        y
      );
    }) })
  ] });
}
function y_e({ onChange: e, values: r }) {
  const [t, i] = ie([
    {
      label: "All councils",
      value: ""
    }
  ]), { data: n, isLoading: s } = Dae({
    query: {
      page: 1,
      page_size: 9999
    }
  });
  return Pe(() => {
    var u;
    if ((u = n == null ? void 0 : n.data) != null && u.results) {
      const o = n.data.results.sort(
        (d, a) => d.name.localeCompare(a.name)
      );
      i(
        [
          {
            label: "All councils",
            value: ""
          }
        ].concat(
          o.map((d) => ({
            label: `${d.code}: ${d.name}`,
            keywords: [
              `${d.code.toLowerCase()}: ${d.name.toLowerCase()}`
            ],
            value: d.code
          }))
        )
      );
    }
  }, [n]), /* @__PURE__ */ l(
    Pz,
    {
      allowMultiSelect: !1,
      disabled: s,
      onChange: e,
      options: t,
      placeholder: "Select a council",
      values: r
    }
  );
}
function ver({
  className: e,
  currentStage: r,
  stages: t
}) {
  const i = Sae(), n = Yr(null), s = Yr(null), [u, o] = ie(!1), [d] = Nae();
  Pe(() => {
    s.current && d(s.current);
  }, [d]), Pe(() => {
    n.current && s.current && o(
      s.current.scrollWidth > n.current.offsetWidth
    );
  }, []), Pe(() => {
    if (s.current) {
      const F = s.current.querySelector(
        `[data-stage="${r}"]`
      );
      F && F.scrollIntoView({ behavior: "smooth", inline: "start" });
    }
  }, [r]);
  const a = $e(() => t.findIndex((F) => F.key === r), [r, t]), V = (F) => /* @__PURE__ */ l(
    "div",
    {
      className: _(
        "h-1 min-w-8 max-w-16 grow rounded-full border-b",
        F < a ? "border-blueDisabled" : "border-textDisabled"
      )
    }
  ), c = (F, X, Y) => X < a ? /* @__PURE__ */ C(
    "div",
    {
      className: "text-blueDisabled flex items-center gap-1 whitespace-nowrap",
      "data-stage": F.key,
      children: [
        /* @__PURE__ */ l(Bo, { className: "h-3 w-3" }),
        F.label,
        Y ? /* @__PURE__ */ l("div", { className: "w-16" }) : null
      ]
    },
    F.key
  ) : X > a ? /* @__PURE__ */ C(
    "div",
    {
      className: "text-textSubdued flex items-center gap-1 whitespace-nowrap",
      "data-stage": F.key,
      children: [
        F.icon || /* @__PURE__ */ l(Gc, { className: "h-3 w-3" }),
        F.label,
        Y ? /* @__PURE__ */ l("div", { className: "w-16" }) : null
      ]
    },
    F.key
  ) : /* @__PURE__ */ C(
    "div",
    {
      className: "text-textLink flex items-center gap-1 whitespace-nowrap",
      "data-stage": F.key,
      children: [
        F.icon || /* @__PURE__ */ l(Gc, { className: "h-3 w-3" }),
        F.label,
        Y ? /* @__PURE__ */ l("div", { className: "w-16" }) : null
      ]
    },
    F.key
  );
  return /* @__PURE__ */ l(
    "div",
    {
      className: _("relative h-7 w-full overflow-hidden", e),
      style: {
        ...u ? {
          maskImage: i ? "linear-gradient(to left, black 80%, transparent 100%)" : "linear-gradient(to right, black 80%, transparent 100%)"
        } : {}
      },
      ref: n,
      children: /* @__PURE__ */ l(
        "div",
        {
          className: "absolute inset-0 bottom-[-20px] box-content overflow-x-scroll",
          ref: s,
          children: /* @__PURE__ */ l("div", { className: "text-bodysm flex items-center gap-3", children: t.map((F, X) => {
            const Y = X === t.length - 1;
            return /* @__PURE__ */ C(Do, { children: [
              c(F, X, Y),
              Y ? null : V(X)
            ] }, F.key);
          }) })
        }
      )
    }
  );
}
function A_e({
  filter: e,
  filterDescriptor: r,
  onChangeFilter: t,
  renderingInHeader: i
}) {
  const n = e != null && e.from ? Xr(e.from) : void 0, s = e != null && e.to ? Xr(e.to) : void 0;
  return /* @__PURE__ */ C(
    "div",
    {
      className: _(
        "flex flex-col gap-1",
        i ? r.headerClassName : ""
      ),
      children: [
        i ? null : /* @__PURE__ */ l(_r, { className: "text-headingsm text-textPrimary", children: r.label }),
        /* @__PURE__ */ C(qY, { children: [
          /* @__PURE__ */ l(YY, { asChild: !0, children: /* @__PURE__ */ C(
            er,
            {
              id: "date",
              variant: "outline",
              className: _(
                "text-bodysm placeholder:text-textSubdued text-textPrimary focus:border-interactiveBorderSelect w-[230px] justify-start",
                (!n || !s) && "text-muted-foreground",
                e != null && e.to || e != null && e.from ? "border-interactiveBorderSelect" : "!border-interactiveBorder"
              ),
              children: [
                /* @__PURE__ */ l(FR, {}),
                n ? ut(n, "dd/MM/yyyy") : "",
                n && s ? /* @__PURE__ */ l("span", { children: " - " }) : null,
                s ? ut(s, "dd/MM/yyyy") : "",
                !n && !s ? /* @__PURE__ */ l("span", { children: r.placeholder }) : ""
              ]
            }
          ) }),
          /* @__PURE__ */ l(x2, { align: "start", className: "w-auto p-0", usePortal: !1, children: /* @__PURE__ */ l(
            Qy,
            {
              className: "text-bodysm",
              defaultMonth: n,
              mode: "range",
              id: r.key,
              numberOfMonths: 2,
              onSelect: (u) => {
                t({
                  from: u != null && u.from ? Ec(u.from) : "",
                  to: u != null && u.to ? Ec(u.to) : ""
                });
              },
              selected: { from: n, to: s }
            }
          ) })
        ] })
      ]
    }
  );
}
function w_e({
  filter: e,
  filterDescriptor: r,
  onChangeFilter: t,
  renderingInHeader: i
}) {
  const n = $e(() => !e || (e == null ? void 0 : e.length) === 0 ? r.options.filter((s) => s.value === "") : r.options.filter(
    (s) => e.includes(s.value)
  ), [e, r]);
  return /* @__PURE__ */ C(
    "div",
    {
      className: _(
        "flex flex-col",
        i ? r.headerClassName : null
      ),
      children: [
        i ? null : /* @__PURE__ */ l(_r, { className: "text-headingsm text-textPrimary", children: r.label }),
        /* @__PURE__ */ l(
          aB,
          {
            allowMultiSelect: !r.singleSelect,
            className: _(
              "text-textSubdued border-interactiveBorder text-bodymd",
              (e == null ? void 0 : e.length) === 1 && e[0] !== "" ? "text-textPrimary border-interactiveBorderSelect" : "",
              (e == null ? void 0 : e.length) > 1 ? "text-textPrimary border-interactiveBorderSelect" : ""
            ),
            filter: (s, u, o) => {
              var d;
              return (d = o == null ? void 0 : o[0]) != null && d.includes(u.toLowerCase()) ? 1 : 0;
            },
            hideHeader: !i,
            hideSearch: !0,
            options: r.options,
            onChange: (s) => {
              s.length > 0 ? t(s.map((u) => u.value)) : t([]);
            },
            placeholder: r.placeholder,
            renderInline: !i,
            values: n
          }
        )
      ]
    }
  );
}
function C_e({
  filter: e,
  filterDescriptor: r,
  onChangeFilter: t,
  renderingInHeader: i
}) {
  const n = $e(() => !e || (e == null ? void 0 : e.length) === 0 ? r.options.filter((s) => s.value === "") : r.options.filter(
    (s) => e.includes(s.value) && s.value !== ""
  ), [e, r]);
  return /* @__PURE__ */ C(
    "div",
    {
      className: _(
        "flex flex-col gap-1",
        i ? r.headerClassName : null
      ),
      children: [
        i ? null : /* @__PURE__ */ l(_r, { className: "text-headingsm text-textPrimary", children: r.label }),
        /* @__PURE__ */ l(
          aB,
          {
            allowMultiSelect: !r.singleSelect,
            className: _(
              "text-bodymd text-textSubdued border-interactiveBorder",
              (e == null ? void 0 : e.length) === 1 && e[0] !== "" ? "text-textPrimary border-interactiveBorderSelect" : "",
              (e == null ? void 0 : e.length) > 1 ? "text-textPrimary border-interactiveBorderSelect" : ""
            ),
            filter: (s, u, o) => {
              var d;
              return (d = o == null ? void 0 : o[0]) != null && d.includes(u.toLowerCase()) ? 1 : 0;
            },
            options: r.options,
            onChange: (s) => {
              if (s.length > 0) {
                const u = n.some(
                  (a) => a.value === ""
                ), o = s.some((a) => a.value === ""), d = s.filter(
                  (a) => a.value !== ""
                );
                !u && o ? t([]) : u && d.length > 0 ? t(d.map((a) => a.value)) : t(s.map((a) => a.value));
              } else
                t([]);
            },
            placeholder: r.placeholder,
            values: n
          }
        )
      ]
    }
  );
}
function P_e({
  filter: e,
  filterDescriptor: r,
  onChangeFilter: t,
  renderingInHeader: i
}) {
  return /* @__PURE__ */ C(
    "div",
    {
      className: _(
        "flex flex-col gap-1",
        i ? r.headerClassName : ""
      ),
      children: [
        i ? null : /* @__PURE__ */ l(_r, { className: "text-headingsm text-textPrimary", children: r.label }),
        /* @__PURE__ */ l(
          G3,
          {
            className: _(
              "placeholder:text-textSubdued text-textPrimary focus:border-interactiveBorderSelect text-bodysm",
              e ? "border-interactiveBorderSelect" : "!border-interactiveBorder"
            ),
            onChange: (n) => {
              t(n.target.value);
            },
            placeholder: r.placeholder,
            value: e ?? ""
          }
        )
      ]
    }
  );
}
function ber({
  filters: e,
  filterDescriptors: r,
  onChangeFilter: t,
  onClearFilters: i
}) {
  const [n, s] = ie(!1), u = Yr(null);
  Pe(() => {
    n && u.current && u.current.scroll({ top: 0, behavior: "instant" });
  }, [n]);
  const o = $e(() => Object.values(e).filter((F) => Array.isArray(F) && F.length === 1 && F[0] !== "" || Array.isArray(F) && F.length > 1 ? !0 : typeof F == "object" ? !!F.from || !!F.to : typeof F == "string" ? F.length > 0 : !1).length, [e]), d = (F) => {
    t(F);
  }, a = (F, X) => {
    switch (F.type) {
      case vx.DATERANGE:
        return /* @__PURE__ */ l(
          A_e,
          {
            filter: e[F.key],
            filterDescriptor: F,
            onChangeFilter: (Y) => {
              d({
                ...e,
                [F.key]: Y
              });
            },
            renderingInHeader: X
          }
        );
      case vx.OPTIONS:
        return /* @__PURE__ */ l(
          w_e,
          {
            filter: e[F.key],
            filterDescriptor: F,
            onChangeFilter: (Y) => {
              d({
                ...e,
                [F.key]: Y
              });
            },
            renderingInHeader: X
          }
        );
      case vx.SEARCHABLE_OPTIONS:
        return /* @__PURE__ */ l(
          C_e,
          {
            filter: e[F.key],
            filterDescriptor: F,
            onChangeFilter: (Y) => {
              d({
                ...e,
                [F.key]: Y
              });
            },
            renderingInHeader: X
          }
        );
      case vx.STRING:
        return /* @__PURE__ */ l(
          P_e,
          {
            filter: e[F.key],
            filterDescriptor: F,
            onChangeFilter: (Y) => {
              d({
                ...e,
                [F.key]: Y
              });
            },
            renderingInHeader: X
          }
        );
    }
  }, V = () => r.filter(
    (X) => X.alwaysShow
  ).map((X) => /* @__PURE__ */ l(Do, { children: a(X, !0) }, X.key)), c = () => r.map((F) => /* @__PURE__ */ l(Do, { children: a(F) }, F.key));
  return /* @__PURE__ */ C("div", { className: "flex grow flex-wrap gap-3", children: [
    V(),
    /* @__PURE__ */ C(BW, { onOpenChange: s, children: [
      /* @__PURE__ */ l(Kbe, { asChild: !0, children: /* @__PURE__ */ C(
        er,
        {
          className: _(
            "text-textPrimary !border-interactiveBorder !rounded",
            o === 0 ? "!border-interactiveBorder" : "!border-blueBorder bg-blueBgDefault"
          ),
          variant: "outline",
          children: [
            /* @__PURE__ */ l(yVe, { className: "h-4 w-4" }),
            " ",
            o > 0 ? `${o} filter${o > 1 ? "s" : ""} applied` : "All filters"
          ]
        }
      ) }),
      /* @__PURE__ */ C(
        lA,
        {
          className: "border-interactiveBorder flex flex-col gap-0 border-l !bg-[#FCFCF9] !p-0 xl:max-w-[720px]",
          onOpenAutoFocus: (F) => {
            F.preventDefault();
          },
          showOverlay: !1,
          children: [
            /* @__PURE__ */ l(UW, { className: "hidden" }),
            /* @__PURE__ */ l(
              "div",
              {
                className: "flex h-full flex-col gap-3 overflow-y-auto px-8 py-6",
                ref: u,
                children: c()
              }
            ),
            /* @__PURE__ */ l(GW, { className: "border-interactiveBorder border-t bg-[#F3F3EE] px-5 py-2", children: /* @__PURE__ */ l(
              er,
              {
                className: "!text-bodysm !border-interactiveBorder text-textPrimary !h-min w-full py-2",
                onClick: i,
                variant: "outline",
                children: "Clear filters"
              }
            ) })
          ]
        }
      )
    ] })
  ] });
}
const vx = {
  DATERANGE: "DATERANGE",
  OPTIONS: "OPTIONS",
  SEARCHABLE_OPTIONS: "SEARCHABLE_OPTIONS",
  STRING: "STRING"
};
function yer(e) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "208px",
      height: "66px",
      viewBox: "0 0 208 66",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      preserveAspectRatio: "none",
      ...e,
      children: [
        /* @__PURE__ */ l("title", { children: "Bayside_City_Council_Logo_Landscape_-_RGB" }),
        /* @__PURE__ */ l(
          "g",
          {
            id: "Styleguide",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /* @__PURE__ */ l(
              "g",
              {
                id: "Artboard",
                transform: "translate(-227.000000, -185.000000)",
                fillRule: "nonzero",
                children: /* @__PURE__ */ C(
                  "g",
                  {
                    id: "Bayside_City_Council_Logo_Landscape_-_RGB",
                    transform: "translate(227.000000, 185.000000)",
                    children: [
                      /* @__PURE__ */ C(
                        "g",
                        {
                          id: "Group",
                          transform: "translate(27.000000, 1.000000)",
                          fill: "#2954A2",
                          children: [
                            /* @__PURE__ */ l(
                              "path",
                              {
                                d: "M29.0985052,23.8258427 C29.036701,21.2247191 28.6321649,19.7865169 28.0984021,17.988764 C29.8626289,15.8314607 30.3795361,13.6460674 29.7671134,10.8707865 C30.963866,9.08988764 31.1717526,6.57865169 30.2727835,4.53932584 C30.7840722,2.87078652 30.1885052,1.34831461 29.3681959,0.516853933 L27.845567,2.09550562 C28.0534536,2.29213483 28.682732,3.04494382 28.1939175,4.20224719 L27.9916495,4.66853933 L28.2220103,5.11235955 C29.0423196,6.63483146 28.8737629,8.7247191 27.845567,9.98314607 L27.5084536,10.3876404 L27.6376804,10.9044944 C28.2950515,13.4550562 27.896134,15.1179775 26.1712371,17.0561798 L25.7779381,17.5 L25.9521134,18.0505618 C26.5364433,19.9438202 27.0926804,21.4494382 27.0758247,24.011236 L27.0870619,24.011236 C27.0364948,28.9325843 26.1319072,36.7640449 20.5807732,41.8820225 C14.563299,47.3595506 9.19757732,48.3483146 0.219123711,49.9494382 C8.82113402,49.7022472 16.8725258,49.9550562 23.777732,44.5674157 C31.3515464,38.6348315 32.1999485,29.1348315 32.1999485,23.8370787 L29.0985052,23.8370787 L29.0985052,23.8258427 Z",
                                id: "Path"
                              }
                            ),
                            /* @__PURE__ */ l(
                              "path",
                              {
                                d: "M108.814588,42.1179775 C107.79201,41.752809 106.926753,41.5449438 105.965979,41.5449438 C104.066907,41.5449438 102.662268,42.4719101 102.662268,43.747191 C102.662268,45.1516854 104.027577,46.0224719 106.005309,46.0224719 C106.949227,46.0224719 107.966186,45.7808989 108.893247,45.3202247 L108.893247,46.3089888 C108.095412,46.6292135 107.196443,46.7921348 105.909794,46.7921348 C102.802732,46.7921348 101.437423,45.1573034 101.437423,43.8314607 C101.437423,42.0617978 103.336495,40.7191011 105.971598,40.7191011 C106.825619,40.7191011 107.685258,40.8707865 108.808969,41.2303371 L108.808969,42.1179775 L108.814588,42.1179775 Z",
                                id: "Path"
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ l(
                        "rect",
                        {
                          id: "Rectangle",
                          fill: "#2954A2",
                          x: "137",
                          y: "42",
                          width: "1",
                          height: "6"
                        }
                      ),
                      /* @__PURE__ */ l(
                        "polygon",
                        {
                          id: "Path",
                          fill: "#2954A2",
                          points: "146 42.8225352 143.100895 42.8225352 143.100895 48 141.882018 48 141.882018 42.8225352 139 42.8225352 139 42 146 42"
                        }
                      ),
                      /* @__PURE__ */ l(
                        "polygon",
                        {
                          id: "Path",
                          fill: "#2954A2",
                          points: "151.423313 42 153 42 149.650307 44.828169 149.650307 48 148.349693 48 148.349693 44.828169 145 42 146.558282 42 148.981595 44.0788732"
                        }
                      ),
                      /* @__PURE__ */ C(
                        "g",
                        {
                          id: "Group",
                          transform: "translate(156.000000, 42.000000)",
                          fill: "#2954A2",
                          children: [
                            /* @__PURE__ */ l(
                              "path",
                              {
                                d: "M7.50608696,1.7325 C6.4773913,1.35333333 5.60130435,1.1375 4.64043478,1.1375 C2.72434783,1.1375 1.30565217,2.1 1.30565217,3.42416667 C1.30565217,4.8825 2.67913043,5.78666667 4.68,5.78666667 C5.62391304,5.78666667 6.64695652,5.53583333 7.57956522,5.0575 L7.57956522,6.08416667 C6.76,6.41666667 5.88391304,6.58583333 4.57826087,6.58583333 C1.44695652,6.58583333 0.0904347826,4.88833333 0.0904347826,3.51166667 C0.0904347826,1.67416667 2.00086957,0.28 4.64043478,0.28 C5.49956522,0.28 6.35869565,0.4375 7.50608696,0.810833333 L7.50608696,1.7325 L7.50608696,1.7325 Z",
                                id: "Path"
                              }
                            ),
                            /* @__PURE__ */ l(
                              "path",
                              {
                                d: "M12.8982609,5.78666667 C14.7691304,5.78666667 16.1482609,4.84166667 16.1482609,3.40666667 C16.1482609,2.0825 14.7747826,1.1375 12.8982609,1.1375 C11.05,1.1375 9.65954805,2.07666667 9.65954805,3.40666667 C9.65391304,4.84166667 11.0443478,5.78666667 12.8982609,5.78666667 M12.8982609,0.28 C15.6565217,0.28 17.3747826,1.72666667 17.3747826,3.4125 C17.3747826,5.075 15.6904348,6.59166667 12.8756522,6.59166667 C10.1682609,6.59166667 8.43868223,5.0925 8.43868223,3.4125 C8.43304348,1.7325 10.2134783,0.28 12.8982609,0.28",
                                id: "Shape"
                              }
                            ),
                            /* @__PURE__ */ l(
                              "path",
                              {
                                d: "M25.5873913,4.1125 C25.5873913,5.60583333 24.3665217,6.58583333 21.8965217,6.58583333 C20.1386957,6.58583333 18.4373913,5.88583333 18.4373913,4.2175 L18.4373913,0.361666667 L19.6243478,0.361666667 L19.6243478,4.01333333 C19.6243478,4.74833333 19.7486957,4.94666667 20.1330435,5.23833333 C20.5908696,5.6175 21.2069565,5.7925 21.9191304,5.7925 C22.8291304,5.7925 23.4847826,5.57083333 23.8691304,5.27333333 C24.2930435,4.94666667 24.3891304,4.5675 24.3891304,3.955 L24.3891304,0.361666667 L25.5817391,0.361666667 L25.5817391,4.1125 L25.5873913,4.1125 Z",
                                id: "Path"
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ l(
                        "polygon",
                        {
                          id: "Path",
                          fill: "#2954A2",
                          points: "191 48 189.921612 48 184.154579 43.3577465 184.154579 48 183 48 183 42 183.972894 42 189.821978 46.5802817 189.821978 42 191 42"
                        }
                      ),
                      /* @__PURE__ */ l(
                        "path",
                        {
                          d: "M198.909228,43.3820537 C197.844175,43.0212766 196.906203,42.8159112 195.859304,42.8159112 C193.813918,42.8159112 192.301059,43.7317299 192.301059,44.9916744 C192.301059,46.3792784 193.77761,47.239593 195.901664,47.239593 C196.93646,47.239593 198.037821,47.0009251 199,46.5457909 L199,47.5226642 C198.170953,47.8390379 197.19062,48 195.792738,48 C192.446293,48 191,46.3848289 191,45.0749306 C191,43.3265495 193.075643,42 195.865356,42 C196.827534,42 197.723147,42.1498612 198.91528,42.5050879 L198.91528,43.3820537 L198.909228,43.3820537 Z",
                          id: "Path",
                          fill: "#2954A2"
                        }
                      ),
                      /* @__PURE__ */ l(
                        "rect",
                        {
                          id: "Rectangle",
                          fill: "#2954A2",
                          x: "200",
                          y: "42",
                          width: "1",
                          height: "6"
                        }
                      ),
                      /* @__PURE__ */ l(
                        "polygon",
                        {
                          id: "Path",
                          fill: "#2954A2",
                          points: "203 42 203 48 208 48 208 47.1943662 204.190205 47.1943662 204.190205 42"
                        }
                      ),
                      /* @__PURE__ */ C("g", { id: "Group", children: [
                        /* @__PURE__ */ l(
                          "path",
                          {
                            d: "M77.238973,23.8830508 C77.238973,24.8562712 77.2893243,24.9122034 79.9243784,24.8562712 C85.2112703,24.7108475 88.0533243,23.6816949 88.0533243,20.4432203 C88.0533243,17.0649153 84.2881622,15.7840678 80.343973,15.7840678 C79.2082703,15.7840678 78.4362162,15.8455932 77.9662703,15.9854237 C77.4515676,16.0916949 77.238973,16.2650847 77.238973,16.8915254 L77.238973,23.8830508 Z M77.238973,31.9037288 C77.238973,33.1454237 77.3396757,34.9184746 78.3299189,35.6288136 C79.3145676,36.4733898 80.8698649,36.6244068 82.4083784,36.6244068 C87.0183243,36.6244068 90.5429189,35.2261017 90.5429189,31.7862712 C90.5429189,29.0511864 88.4841081,25.8798305 80.2432703,25.8798305 C77.4571622,25.8798305 77.238973,26.0923729 77.238973,26.7915254 L77.238973,31.9037288 Z M72.9870811,19.2910169 C72.9870811,16.7516949 72.7856757,16.119661 70.4527297,15.940678 L68.8023243,15.84 C68.3827297,15.6498305 68.4386757,15.129661 68.8526757,14.9898305 C71.6443784,14.8164407 75.168973,14.7045763 79.9747297,14.7045763 C83.2363784,14.7045763 86.346973,14.8779661 88.6799189,15.6722034 C90.9065676,16.399322 92.6073243,17.7808475 92.6073243,19.9845763 C92.6073243,22.4735593 90.431027,23.7432203 87.326027,24.7052542 C87.326027,25.0520339 87.7344324,25.1694915 88.3050811,25.2366102 C91.107973,25.5722034 95.2535676,27.2949153 95.2535676,30.969661 C95.2535676,35.0079661 90.8002703,37.6927119 81.4852703,37.6927119 C79.9747297,37.6927119 77.4515676,37.5752542 75.2696757,37.5752542 C72.9870811,37.5752542 71.235973,37.6647458 69.3114324,37.6927119 C69.0093243,37.5752542 68.8918378,36.9935593 69.2107297,36.8089831 L70.1394324,36.7138983 C72.891973,36.4677966 72.9870811,36.0259322 72.9870811,32.390339 L72.9870811,19.2910169 Z",
                            id: "Shape",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ l(
                          "path",
                          {
                            d: "M104.663676,36.5349153 C105.709865,36.5349153 107.309919,35.9979661 107.830216,35.6344068 C108.462405,35.2316949 108.507162,34.7730508 108.507162,34.0123729 L108.60227,32.0044068 C108.60227,31.629661 108.39527,31.5625424 108.098757,31.5625424 C107.779865,31.5625424 106.890324,31.7079661 105.956027,31.909322 C102.912568,32.5637288 101.407622,33.1174576 101.407622,34.4486441 C101.407622,35.0415254 102.034216,36.5349153 104.663676,36.5349153 M107.880568,30.4438983 C108.658216,30.2816949 108.702973,29.979661 108.758919,29.4315254 L108.80927,27.8486441 C108.859622,26.5845763 108.238622,24.8562712 105.038514,24.8562712 C103.583919,24.8562712 101.821622,25.3484746 101.726514,26.4055932 C101.664973,26.959322 101.625811,27.3732203 101.195027,27.5689831 C100.434162,27.9828814 99.0243243,28.2401695 98.2578649,28.2401695 C97.7879189,28.2401695 97.5193784,28.0555932 97.5193784,27.7535593 C97.5193784,25.9637288 103.376919,23.5083051 107.15327,23.5083051 C110.884865,23.5083051 112.697514,24.9625424 112.546459,27.5410169 L112.221973,33.5537288 C112.132459,35.1477966 112.602405,36.5628814 114.610865,36.5628814 C115.131162,36.5628814 115.595514,36.4789831 115.903216,36.3783051 C116.154973,36.2608475 116.423514,36.1210169 116.580162,36.1210169 C116.781568,36.1210169 116.949405,36.3223729 116.949405,36.5628814 C116.949405,36.7250847 115.131162,38.0954237 112.596811,38.0954237 C111.343622,38.0954237 110.107216,37.7766102 109.217676,36.9767797 C109.01627,36.7866102 108.702973,36.5405085 108.39527,36.5405085 C108.037216,36.5405085 107.405027,36.8201695 106.381216,37.1837288 C105.22873,37.6144068 104.093027,38.0954237 102.644027,38.0954237 C101.139081,38.0954237 99.9082703,37.8101695 99.0187297,37.2620339 C98.0396757,36.6915254 97.4186757,35.8133898 97.4186757,34.879322 C97.4186757,33.5201695 98.4089189,32.7035593 101.726514,31.9316949 L107.880568,30.4438983 Z",
                            id: "Shape",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ l(
                          "path",
                          {
                            d: "M115.690622,44.6450847 C115.690622,43.7557627 116.630514,43.2747458 117.755027,43.2747458 L118.74527,43.2747458 C119.567676,43.2747458 120.093568,43.0398305 120.457216,42.7210169 C121.950973,41.1661017 122.991568,39.7118644 123.455919,38.8449153 C123.606973,38.5484746 123.970622,37.8772881 123.970622,37.3627119 C123.970622,36.6915254 123.758027,36.2944068 123.097865,35.0135593 L119.041784,27.6137288 C118.180216,25.9916949 117.799784,25.1750847 115.998324,24.9122034 L114.705973,24.7444068 C114.387081,24.5766102 114.448622,23.9949153 114.857027,23.8830508 C116.513027,23.9613559 118.06273,23.9949153 119.774676,23.9949153 C121.16773,23.9949153 122.622324,23.9613559 124.278324,23.8830508 C124.692324,23.9949153 124.742676,24.5766102 124.384622,24.7444068 L123.09227,24.9122034 C122.359378,25.0184746 121.945378,25.130339 121.945378,25.3708475 C121.945378,25.7847458 123.137027,28.0164407 123.450324,28.6261017 L125.10073,31.7918644 C125.408432,32.3288136 126.398676,34.1466102 126.605676,34.2305085 C126.751135,34.1466102 127.595919,33.1174576 128.519027,31.7079661 L130.281324,28.9616949 C131.417027,27.1774576 132.088378,25.8854237 132.088378,25.5162712 C132.088378,25.2757627 131.78627,25.0240678 130.851973,24.9177966 L129.24073,24.75 C128.871486,24.5822034 128.927432,24.0005085 129.335838,23.8886441 C131.008622,23.9669492 132.55273,24.0005085 133.901027,24.0005085 C135.198973,24.0005085 136.390622,23.9669492 137.828432,23.8886441 C138.253622,24.0340678 138.309568,24.5430508 137.945919,24.75 L137.056378,24.8618644 C135.344432,25.0632203 134.426919,26.0644068 132.664622,28.5254237 L129.766622,32.4686441 C128.06027,34.8177966 123.813973,40.8137288 121.285216,44.55 C120.384486,45.9147458 119.148081,46.1328814 117.956432,46.1328814 C116.46827,46.1272881 115.690622,45.5679661 115.690622,44.6450847",
                            id: "Path",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ l(
                          "path",
                          {
                            d: "M151.305811,24.1235593 C151.781351,24.8786441 152.122622,25.9861017 152.122622,26.9313559 C151.921216,27.1718644 151.137973,27.2333898 150.886216,27.0320339 C150.019054,25.510678 148.458162,24.5038983 146.332216,24.5038983 C144.306973,24.5038983 143.014622,25.3652542 143.014622,26.6069492 C143.014622,28.0052542 145.202108,28.7827119 147.014757,29.4483051 C149.761703,30.4998305 152.284865,31.6967797 152.284865,34.1074576 C152.284865,36.7474576 148.659568,38.0842373 144.832865,38.0842373 C142.404811,38.0842373 140.592162,37.720678 139.294216,36.9935593 C138.885811,36.3950847 138.578108,34.6891525 138.673216,33.5425424 C138.936162,33.3411864 139.607514,33.3188136 139.870459,33.5089831 C140.737622,35.3771186 142.404811,37.0327119 145.364351,37.0327119 C147.221757,37.0327119 148.827405,36.3671186 148.827405,34.8737288 C148.827405,33.279661 146.746216,32.390339 144.832865,31.7023729 C141.834162,30.5389831 139.708216,29.3252542 139.708216,27.4347458 C139.708216,24.9122034 142.807622,23.5027119 146.746216,23.5027119 C148.916919,23.5027119 150.83027,23.8494915 151.305811,24.1235593",
                            id: "Path",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ l(
                          "path",
                          {
                            d: "M161.085162,16.5 C161.085162,17.7137288 159.798405,18.2618644 158.399757,18.2618644 C156.788514,18.2618644 155.753514,17.4955932 155.753514,16.5727119 C155.753514,15.4428814 157.051459,14.7381356 158.550811,14.7381356 C160.106108,14.7381356 161.085162,15.5379661 161.085162,16.5 M156.838865,27.6752542 C156.838865,26.3272881 156.838865,26.1594915 155.445811,25.5442373 L154.987054,25.3428814 C154.785649,25.2030508 154.785649,24.8115254 155.031811,24.7052542 C156.223459,24.4423729 159.177405,23.5362712 160.363459,23.0272881 C160.632,23.0272881 160.822216,23.0888136 160.889351,23.2286441 C160.777459,24.4423729 160.682351,26.0867797 160.682351,27.5018644 L160.682351,33.710339 C160.682351,36.2161017 160.783054,36.5516949 162.646054,36.7138983 L163.737,36.8089831 C164.089459,36.9655932 163.988757,37.5808475 163.619514,37.6927119 C162.075405,37.6032203 160.576054,37.5752542 158.757811,37.5752542 C156.900405,37.5752542 155.345108,37.6032203 153.896108,37.6927119 C153.526865,37.5752542 153.431757,36.9655932 153.784216,36.8089831 L154.869568,36.7138983 C156.788514,36.5516949 156.838865,36.2161017 156.838865,33.710339 L156.838865,27.6752542 L156.838865,27.6752542 Z",
                            id: "Shape",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ l(
                          "path",
                          {
                            d: "M181.113811,27.3732203 C181.113811,26.679661 180.906811,26.3608475 180.548757,26.0252542 C179.776703,25.3149153 178.221405,24.5766102 176.196162,24.5766102 C171.485514,24.5766102 169.040676,27.3061017 169.040676,30.3152542 C169.040676,33.4474576 171.67573,36.4342373 176.772405,36.4342373 C178.159865,36.4342373 179.922162,35.9979661 180.761351,35.4274576 C181.05227,35.2372881 181.113811,34.7450847 181.113811,34.1466102 L181.113811,27.3732203 Z M184.946108,32.5245763 C184.946108,35.2652542 184.990865,36.5572881 186.456649,36.5572881 C187.004919,36.5572881 187.888865,36.4062712 188.677703,36.2216949 C189.041351,36.2888136 189.097297,37.1054237 188.616162,37.2955932 C186.456649,37.5249153 183.228568,38.0618644 181.796351,38.4030508 C181.471865,38.4030508 181.225703,38.3079661 181.225703,38.1513559 L181.225703,37.5472881 C181.225703,36.9991525 181.225703,36.6244068 181.113811,36.4957627 L180.906811,36.4957627 C178.629811,37.5137288 176.861919,38.0842373 174.394703,38.0842373 C168.637865,38.0842373 164.816757,35.0694915 164.816757,31.4450847 C164.816757,26.6069492 170.282676,23.4971186 177.331865,23.4971186 C179.099757,23.4971186 180.235459,23.6761017 180.800514,23.8159322 C181.046676,23.8159322 181.113811,23.6033898 181.113811,23.3237288 L181.113811,18.1108475 C181.113811,16.0805085 181.05227,15.8735593 179.502568,15.2694915 L178.98227,15.0457627 C178.719324,14.9450847 178.719324,14.4584746 178.98227,14.3522034 C180.291405,14.0837288 182.713865,13.5691525 184.576865,12.9035593 C184.789459,12.9035593 184.98527,12.9762712 185.097162,13.1105085 C185.046811,14.1620339 184.940514,15.8735593 184.940514,17.3949153 L184.940514,32.5245763 L184.946108,32.5245763 Z",
                            id: "Shape",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ l(
                          "path",
                          {
                            d: "M197.19827,27.7144068 C201.030568,27.7144068 202.138297,27.5633898 202.574676,27.3676271 C202.742514,27.2949153 202.910351,27.1662712 202.910351,26.7132203 C202.910351,25.7455932 201.908919,24.5318644 198.899027,24.5318644 C195.844378,24.5318644 193.214919,26.4055932 193.153378,27.5354237 C193.153378,27.6081356 193.153378,27.7144068 193.539405,27.7144068 L197.19827,27.7144068 Z M194.009351,28.7547458 C192.649865,28.7547458 192.599514,28.810678 192.599514,29.6776271 C192.599514,33.1901695 195.648568,36.1433898 201.192811,36.1433898 C202.910351,36.1433898 204.364946,35.7686441 205.959405,34.4374576 C206.507676,34.3367797 206.798595,34.549322 206.854541,34.8737288 C205.137,37.1781356 201.466946,38.0842373 198.759162,38.0842373 C195.419189,38.0842373 192.744973,37.060678 191.245622,35.7686441 C189.68473,34.4374576 189.086108,32.8154237 189.086108,31.2940678 C189.086108,27.0655932 193.259676,23.5027119 199.47527,23.5027119 C203.917378,23.5027119 206.798595,25.5442373 206.798595,27.6081356 C206.798595,28.0835593 206.697892,28.38 206.586,28.5142373 C206.507676,28.7155932 205.741216,28.7547458 203.542541,28.7547458 L194.009351,28.7547458 L194.009351,28.7547458 Z",
                            id: "Shape",
                            fill: "#2954A2"
                          }
                        ),
                        /* @__PURE__ */ l(
                          "path",
                          {
                            d: "M43.47,63.4215254 C36.9019459,63.8801695 28.9296486,59.3049153 23.0329459,57.6828814 C14.1263514,55.2889831 8.32475676,58.2254237 4.75540541,62.5657627 C7.70375676,60.4067797 12.5207027,59.5062712 20.4818108,61.5925424 C26.3952973,63.1530508 32.4822162,66.3579661 39.0670541,65.899322 C48.5722703,65.1945763 50.5863243,61.9952542 50.5863243,61.9952542 C50.5863243,61.9952542 49.6128649,62.9852542 43.47,63.4215254",
                            id: "Path",
                            fill: "#009CCD"
                          }
                        ),
                        /* @__PURE__ */ l(
                          "path",
                          {
                            d: "M25.8134595,56.5194915 C31.698973,58.1750847 37.7243514,61.810678 44.3315676,61.7155932 C52.8409459,61.5869492 57.4005405,56.6928814 57.4005405,56.6928814 L57.4117297,56.3349153 C57.4117297,56.3349153 55.0955676,58.3372881 48.4883514,58.8854237 C41.9202973,59.4894915 33.9424054,54.7967797 28.0401081,53.1635593 C20.051027,50.9262712 14.1431351,55.6413559 14.1431351,55.6413559 C14.1431351,55.6413559 16.4984595,53.9018644 25.8134595,56.5194915",
                            id: "Path",
                            fill: "#009CCD"
                          }
                        ),
                        /* @__PURE__ */ l(
                          "path",
                          {
                            d: "M51.4590811,1.10745763 C47.2687297,-0.285254237 44.6112973,0.945254237 41.5286757,3.40067797 C36.5998378,3.10983051 33.4612703,4.53610169 31.0332162,6.5440678 C23.0665135,6.3259322 15.9837568,9.06661017 9.36535135,15.6722034 C-2.80289189,27.8318644 -1.48256757,44.7569492 4.16237838,53.6837288 C4.16237838,53.6837288 5.10786486,50.9933898 8.04502703,47.3354237 C16.8788919,36.0427119 25.9477297,33.9788136 29.2373514,42.2008475 C29.9366757,37.6927119 29.187,36.0762712 27.4135135,34.6947458 C24.0679459,32.0827119 17.774027,32.3120339 10.2101351,42.2455932 C8.15132432,44.9079661 7.93313514,45.1316949 6.94848649,46.6698305 C2.18748649,38.5037288 4.11202703,26.5733898 12.1906216,18.4408475 C18.2495676,12.310678 24.3700541,9.51966102 31.436027,9.41898305 C31.436027,9.41898305 36.2921351,8.87084746 45.2211081,12.6910169 L35.576027,7.52847458 C39.7663784,5.12338983 46.1833784,6.19169492 50.2338649,7.75779661 L44.8798378,4.77661017 C46.8379459,3.32237288 47.9792432,2.41627119 51.6548919,3.46220339 L52.0912703,3.53491525 L52.5108649,3.36711864 C53.5962162,2.9140678 54.3458919,2.98118644 54.6032432,3.22169492 L56.1417568,1.63881356 C55.2466216,0.749491525 53.4899189,-0.00559322034 51.4590811,1.10745763",
                            id: "Path",
                            fill: "#F7941E"
                          }
                        )
                      ] })
                    ]
                  }
                )
              }
            )
          }
        )
      ]
    }
  );
}
function Aer(e) {
  return /* @__PURE__ */ C(
    "svg",
    {
      version: "1.1",
      id: "Layer_1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      viewBox: "0 0 229.4 57.2",
      ...e,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#F58220",
            d: `M5.5,33.3c0-8.3,5.5-16.4,10.2-21c1.9-2.3,3.5-4.6,3.5-12c0-0.4-0.5-0.4-0.7,0.1c-1,3.3-2,4.4-3.2,5.6
	c-3.1,2.6-4.7,2.8-6.6,5.1c-1.3,1.5-1.5,3.7-3.1,7.3c-1.3,2.9-5,5.5-5.5,10c-0.4,3.9,1.7,7.3,2.1,10.8`
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#084323",
            d: `M19.4,27.5c1.8,0,3.3-1.5,3.3-3.3s-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3C16,26.1,17.5,27.5,19.4,27.5 M32.8,33
	c0,10.7-8.9,20.7-13.5,23.7V9.4C24,12.3,32.8,22.3,32.8,33`
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#F58220",
            d: `M2.3,39.1c0.4,3.5-0.2,5.4,1.8,8.5c2.1,3.5,13.2,9.1,13.9,9.5c0.7,0.4,0.8-0.2,0.5-0.3
	c-4.7-3.3-13-13.1-13-23.5`
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#084323",
            d: `M43.6,30.1h1c3.1,0,5.2-1.3,5.2-3.9c0-2.7-1.5-4.1-4-4.1c-1.9,0-2.2,0.5-2.2,1.7V30.1z M43.6,38
	c0,1.9,1,2.3,2.8,2.3c2.9,0,4.8-1.5,4.8-4.5c0-3.4-2.6-4.7-5.6-4.7c-0.7,0-1.4,0.1-2,0.2C43.6,31.3,43.6,38,43.6,38z M41.1,24
	c0-1.7-1.1-1.7-2.9-1.8c-0.3,0-0.3-0.1-0.3-0.5s0.2-0.4,0.6-0.4c1.1,0,2.2,0.1,3.3,0.1s2.2-0.1,3.3-0.1c3.4,0,7.5,0.6,7.5,5
	c0,3.1-3.1,3.6-4.4,4v0.1c0.6,0,5.9,0.8,5.9,5.3c0,4.3-3.6,5.8-7.4,5.8c-2,0-3.3-0.1-4.5-0.1s-2.3,0.1-3.7,0.1
	c-0.5,0-0.6-0.1-0.6-0.3v-0.3c0-0.2,0.2-0.3,0.3-0.3c2.9,0,2.9-0.6,2.9-2.7C41.1,37.9,41.1,24,41.1,24z`
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#084323",
            d: `M73.1,33.1c0-4-2.7-8.1-7-8.1c-4.4,0-6.5,3.5-6.5,7.5c0,4.1,2.5,8.3,6.9,8.3C70.9,40.8,73.1,37.2,73.1,33.1
	 M57.1,33.3c0-5,4.3-9.1,9.2-9.1c5,0,9.4,3.4,9.4,8.4c0,4.8-4.6,9.1-9.3,9.1C61.4,41.8,57.1,38.5,57.1,33.3`
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#084323",
            d: `M81.3,32.2c0.3,0,0.6,0,0.9,0c1.9,0,4.3-0.7,4.3-3.5c0-2.1-1.4-3.5-3.5-3.5c-1.6,0-1.7,0.4-1.7,1.1
	C81.3,26.3,81.3,32.2,81.3,32.2z M79.1,27.2c0-1.2,0-1.8-1.5-1.8h-1c-0.1,0-0.2-0.3-0.2-0.5c0-0.1,0.1-0.3,0.2-0.3
	c1.4,0,2.8,0.1,4.2,0.1c1.1,0,2.2-0.1,3.3-0.1c2.4,0,4.8,1.6,4.8,4.1c0,2.2-2,3.6-3.8,3.9l0,0c0.9,0.2,1.9,2,2.1,2.3l2.6,4
	c0.8,1.3,1.4,1.5,2.8,1.6l0.1,0.1v0.5c0,0.2-0.2,0.2-0.3,0.2c-0.5,0-1.2-0.1-1.6-0.1c-0.6,0-1.1,0.1-1.7,0.1c-0.5,0-1.6-1.6-3-4.1
	c-1.5-2.7-2.4-4.2-4-4.2c-0.2,0-0.5,0-0.8,0v5.8c0,0.9,0,1.7,1.2,1.7c0.9,0,1.3,0,1.3,0.2c0,0.5-0.1,0.6-0.4,0.6
	c-1.2,0-2.3-0.1-3.3-0.1c-0.4,0-3,0.1-3.4,0.1c-0.1,0-0.2-0.3-0.2-0.5s0.1-0.3,0.6-0.3c1.6-0.1,2.1-0.3,2.1-2L79.1,27.2L79.1,27.2z`
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#084323",
            d: `M109.1,33.1c0-4-2.7-8.1-7-8.1c-4.4,0-6.5,3.5-6.5,7.5c0,4.1,2.5,8.3,6.9,8.3C106.8,40.8,109.1,37.2,109.1,33.1
	 M93,33.3c0-5,4.3-9.1,9.2-9.1c5,0,9.4,3.4,9.4,8.4c0,4.8-4.6,9.1-9.3,9.1C97.3,41.8,93,38.5,93,33.3`
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#084323",
            d: `M130.5,33.1c0-4-2.7-8.1-7-8.1c-4.4,0-6.5,3.5-6.5,7.5c0,4.1,2.5,8.3,6.9,8.3C128.2,40.8,130.5,37.2,130.5,33.1
	 M114.4,33.3c0-5,4.3-9.1,9.2-9.1c5,0,9.4,3.4,9.4,8.4c0,4.8-4.6,9.1-9.3,9.1C118.7,41.8,114.4,38.5,114.4,33.3`
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#084323",
            d: `M137.7,27.5c0-0.5,0-0.6-0.1-0.8c-0.2-0.4-1.3-1.3-1.7-1.3l-1.3-0.1c-0.1,0-0.1-0.2-0.1-0.4
	c0-0.1,0-0.3,0.1-0.3c0.7,0,1.3,0,1.9,0c1.1,0,2.8,0.1,3.3,0.1l7.2,8.7c1.1,1.3,2.2,2.6,3.9,4.3h0.1V27.3c0-1.6-0.6-1.8-1.3-1.8h-1
	c-0.1,0-0.1-0.2-0.1-0.4c0-0.1,0.1-0.4,0.2-0.4c0.5,0,1.8,0.1,2.9,0.1c1.1,0,2.2-0.1,2.9-0.1c0.1,0,0.1,0.1,0.1,0.2v0.5
	c0,0.1,0,0.1-0.2,0.1h-0.6c-1.6,0-1.6,0.8-1.6,2.9v13.8h-0.6l-12.8-14.7v10.9c0,2.1,0.3,2.3,2.3,2.4c0.1,0,0.2,0.2,0.2,0.4
	s0,0.4-0.1,0.4c-0.5,0-2-0.1-3-0.1c-1.2,0-1.7,0.1-2.8,0.1c-0.1,0-0.2-0.2-0.2-0.5c0-0.2,0-0.3,0.3-0.3c1,0,2.1-0.2,2.1-1.5
	L137.7,27.5L137.7,27.5z`
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#084323",
            d: `M161.8,38c0,2.6,2.7,2.6,3.7,2.6c3.3,0,6.7-2.7,6.7-7.7c0-4.2-2.3-6.3-3.9-7.3c-1.1-0.5-2.6-0.6-3.7-0.6
	c-1.9,0-2.9,0.1-2.9,1.7L161.8,38L161.8,38z M159.7,27.4c0-0.9-0.2-1.8-1.1-1.8c-0.3,0-1,0.1-1.5,0.1c-0.1,0-0.1-0.4-0.1-0.5
	s0-0.2,0.4-0.3c1.6-0.3,5.4-0.6,7.4-0.6c1.3,0,2.5,0.1,3.7,0.4c3.2,0.9,6.3,3.8,6.3,8.2c0,5.9-4.9,8.6-9.4,8.6
	c-2.3,0-3.4-0.1-4.6-0.1c-1.2,0-2.4,0.1-3.6,0.1c-0.1,0-0.1-0.2-0.1-0.4s0.1-0.4,0.2-0.4c0.8-0.1,1.4-0.1,1.8-0.4
	c0.4-0.2,0.6-0.6,0.6-1.4L159.7,27.4L159.7,27.4z`
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#084323",
            d: `M185.8,33.8l-2.6-6.8l0,0l-2.3,6.8H185.8z M180.5,34.7l-1,3.4c-0.2,0.6-0.3,1.2-0.3,1.5c0,0.8,1.1,1,1.8,1
	c0.2,0,0.3,0.1,0.3,0.5c0,0.2,0,0.3-0.2,0.3c-0.5,0-2.3-0.1-2.9-0.1c-0.6,0-1.6,0.1-2.4,0.1c-0.5,0-0.5-0.1-0.5-0.4v-0.3
	c0-0.1,0.2-0.2,0.8-0.2c1.2-0.1,1.4-0.4,1.9-1.7l4.7-13.7c0.5-0.4,1-1,1.6-1.1l6,15.1c0.4,1,0.8,1.5,2.2,1.5c0.3,0,0.3,0.3,0.3,0.5
	c0,0.3-0.2,0.3-0.5,0.3c-0.4,0-1.9-0.1-2.8-0.1c-1,0-1.9,0-2.9,0.1c-0.4,0-0.4-0.1-0.4-0.4c0-0.3,0.1-0.4,0.5-0.4s1.5-0.1,1.5-0.6
	c0-0.2-0.1-0.6-0.4-1.4l-1.5-3.8L180.5,34.7L180.5,34.7z`
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#084323",
            d: `M199.5,32.2c0.3,0,0.6,0,0.9,0c1.9,0,4.3-0.7,4.3-3.5c0-2.1-1.4-3.5-3.5-3.5c-1.6,0-1.7,0.4-1.7,1.1V32.2z
	 M197.3,27.2c0-1.2,0-1.8-1.5-1.8h-1c-0.1,0-0.2-0.3-0.2-0.5c0-0.1,0.1-0.3,0.2-0.3c1.4,0,2.8,0.1,4.2,0.1c1.1,0,2.2-0.1,3.3-0.1
	c2.4,0,4.8,1.6,4.8,4.1c0,2.2-2,3.6-3.8,3.9l0,0c0.9,0.2,1.9,2,2.1,2.3l2.6,4c0.8,1.3,1.4,1.5,2.8,1.6l0.1,0.1v0.5
	c0,0.2-0.2,0.2-0.3,0.2c-0.5,0-1.2-0.1-1.6-0.1c-0.6,0-1.1,0.1-1.7,0.1c-0.5,0-1.6-1.6-3-4.1c-1.5-2.7-2.5-4.2-4-4.2
	c-0.2,0-0.5,0-0.8,0v5.8c0,0.9,0,1.7,1.2,1.7c0.9,0,1.3,0,1.3,0.2c0,0.5-0.1,0.6-0.4,0.6c-1.2,0-2.3-0.1-3.3-0.1
	c-0.4,0-3,0.1-3.4,0.1c-0.1,0-0.2-0.3-0.2-0.5s0.1-0.3,0.6-0.3c1.6-0.1,2.1-0.3,2.1-2V27.2H197.3z`
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fill: "#084323",
            d: `M222.4,33.8l-2.6-6.8l0,0l-2.3,6.8H222.4z M217.1,34.7l-1,3.4c-0.2,0.6-0.3,1.2-0.3,1.5c0,0.8,1.1,1,1.8,1
	c0.2,0,0.3,0.1,0.3,0.5c0,0.2,0,0.3-0.2,0.3c-0.5,0-2.3-0.1-2.9-0.1c-0.6,0-1.6,0.1-2.4,0.1c-0.5,0-0.5-0.1-0.5-0.4v-0.3
	c0-0.1,0.2-0.2,0.8-0.2c1.2-0.1,1.4-0.4,1.9-1.7l4.7-13.7c0.5-0.4,1-1,1.6-1.1l6,15.1c0.4,1,0.8,1.5,2.2,1.5c0.3,0,0.3,0.3,0.3,0.5
	c0,0.3-0.2,0.3-0.5,0.3c-0.4,0-1.9-0.1-2.8-0.1c-1,0-1.9,0-2.9,0.1c-0.4,0-0.4-0.1-0.4-0.4c0-0.3,0.1-0.4,0.5-0.4s1.5-0.1,1.5-0.6
	c0-0.2-0.1-0.6-0.4-1.4l-1.5-3.8L217.1,34.7L217.1,34.7z`
          }
        )
      ]
    }
  );
}
function wer({
  className: e,
  ...r
}) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      className: _("h-4 w-4", e),
      viewBox: "0 0 256 256",
      ...r,
      children: /* @__PURE__ */ l("path", { d: "M224 104a8 8 0 0 1-16 0V59.32l-66.33 66.34a8 8 0 0 1-11.32-11.32L196.68 48H152a8 8 0 0 1 0-16h64a8 8 0 0 1 8 8Zm-40 24a8 8 0 0 0-8 8v72H48V80h72a8 8 0 0 0 0-16H48a16 16 0 0 0-16 16v128a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-72a8 8 0 0 0-8-8Z" })
    }
  );
}
function S_e() {
  return /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      children: [
        /* @__PURE__ */ l(
          "mask",
          {
            id: "mask0_7106_5812",
            style: { maskType: "luminance" },
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "20",
            height: "20",
            children: /* @__PURE__ */ l("path", { d: "M20 0H0V20H20V0Z", fill: "white" })
          }
        ),
        /* @__PURE__ */ C("g", { mask: "url(#mask0_7106_5812)", children: [
          /* @__PURE__ */ l(
            "path",
            {
              d: "M19.6 10.2274C19.6 9.51828 19.5364 8.83648 19.4182 8.18188H10V12.0501H15.3818C15.15 13.3001 14.4455 14.3592 13.3864 15.0683V17.5774H16.6182C18.5091 15.8365 19.6 13.2728 19.6 10.2274Z",
              fill: "#4285F4"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M9.99988 19.9999C12.6999 19.9999 14.9635 19.1044 16.618 17.5772L13.3862 15.0681C12.4908 15.6681 11.3453 16.0226 9.99988 16.0226C7.39528 16.0226 5.19078 14.2635 4.40438 11.8999H1.06348V14.4908C2.70898 17.759 6.09078 19.9999 9.99988 19.9999Z",
              fill: "#34A853"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M4.4045 11.8999C4.2045 11.2999 4.0909 10.659 4.0909 9.99993C4.0909 9.34083 4.2045 8.69993 4.4045 8.09993V5.50903H1.0636C0.3864 6.85903 0 8.38633 0 9.99993C0 11.6135 0.3864 13.1408 1.0636 14.4908L4.4045 11.8999Z",
              fill: "#FBBC04"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M9.99988 3.9773C11.468 3.9773 12.7862 4.4818 13.8226 5.4727L16.6908 2.6045C14.959 0.9909 12.6953 0 9.99988 0C6.09078 0 2.70898 2.2409 1.06348 5.5091L4.40438 8.1C5.19078 5.7364 7.39528 3.9773 9.99988 3.9773Z",
              fill: "#E94235"
            }
          )
        ] })
      ]
    }
  );
}
function N_e() {
  return /* @__PURE__ */ C("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", children: [
    /* @__PURE__ */ C("g", { clipPath: "url(#clip0_7106_5805)", children: [
      /* @__PURE__ */ l("path", { d: "M9.52358 0.952393H0.952148V9.52382H9.52358V0.952393Z", fill: "#F25022" }),
      /* @__PURE__ */ l("path", { d: "M9.52358 10.4761H0.952148V19.0475H9.52358V10.4761Z", fill: "#00A4EF" }),
      /* @__PURE__ */ l("path", { d: "M19.048 0.952393H10.4766V9.52382H19.048V0.952393Z", fill: "#7FBA00" }),
      /* @__PURE__ */ l("path", { d: "M19.048 10.4761H10.4766V19.0475H19.048V10.4761Z", fill: "#FFB900" })
    ] }),
    /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_7106_5805", children: /* @__PURE__ */ l("rect", { width: "20", height: "20", fill: "white" }) }) })
  ] });
}
function Cer(e) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "188",
      height: "142",
      viewBox: "0 0 188 142",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            d: "M46.6052 16.0616C47.2546 16.3283 48.4722 16.6762 49.6782 16.6646C51.754 19.3201 55.7663 21.6162 58.3986 21.9409C58.7581 21.9757 59.1176 21.9757 59.4191 21.9525C62.0514 25.9184 67.722 29.9423 71.7111 30.3597C72.3488 30.4177 72.8939 30.3829 73.3693 30.3134C76.825 36.6449 85.2322 43.3707 90.8912 43.9273C91.9696 44.0201 92.8394 43.9041 93.5699 43.6606C93.6047 43.9389 93.6395 44.2056 93.7091 44.4955C93.8019 45.6899 94.3005 46.7568 95.1238 47.5337C96.0051 48.3687 97.1763 48.7977 98.4171 48.7514C98.8114 48.7514 99.0086 48.9137 99.0202 49.2964L99.0317 49.5399L99.1017 49.795C99.4377 51.0126 100.226 51.9867 101.282 52.5781C102.337 53.1695 103.555 53.2855 104.784 52.9376C105.155 52.81 105.398 52.9608 105.491 53.3203L105.549 53.5638L105.688 53.8073C106.326 54.8742 107.323 55.6511 108.483 55.9526C109.643 56.2425 110.895 56.057 111.985 55.4076C112.321 55.2104 112.565 55.2916 112.774 55.6163L112.901 55.8134L113.063 56.0106C113.968 56.8919 115.104 57.3905 116.31 57.3905C117.505 57.3905 118.676 56.9035 119.581 56.0106C119.847 55.7207 120.137 55.7207 120.415 55.999L120.589 56.1729L120.81 56.3005C123.036 57.6225 125.831 56.8919 127.13 54.6538C127.327 54.3059 127.617 54.2364 127.941 54.4219L128.173 54.5611L128.417 54.6538C129.623 54.9785 130.887 54.851 131.931 54.2596C132.997 53.6566 133.774 52.6593 134.111 51.4301C134.157 51.2909 134.238 51.117 134.389 51.0358C134.551 50.943 134.737 50.9894 134.853 51.001L135.108 51.0822L135.363 51.0938C137.961 51.1286 140.013 49.1572 140.071 46.5365C140.094 46.1422 140.303 45.9219 140.674 45.9451H140.941L141.184 45.8871C143.295 45.3884 144.768 43.5446 144.744 41.3877L144.733 36.5057L144.721 35.207L143.515 34.6619C136.986 31.8093 132.835 26.6721 128.672 16.3515C125.506 8.48927 120.74 3.41012 114.525 1.20684C106.465 -1.65743 98.6723 1.21844 94.7064 3.21299C89.7432 -0.880489 80.9532 -0.915277 74.3782 3.21299C70.7486 0.916929 64.8577 0.928519 60.3236 3.35214C57.6796 2.04177 53.7137 2.05336 50.5248 3.52608C48.5418 2.76073 45.376 2.49402 43.138 3.57247C41.3058 4.46538 40.3085 6.10045 40.3085 8.15298C40.3085 12.2465 43.5438 14.9136 46.6052 16.0616Z",
            fill: "#FFF1CC"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M44.831 7.26007C45.7703 6.72664 47.4518 6.8426 48.5418 7.10932L48.507 12.4436C47.7185 12.2117 46.7212 11.771 45.8283 11.0173C44.8194 10.1707 44.3208 9.20823 44.3208 8.14138C44.3324 7.63115 44.5063 7.41082 44.831 7.26007ZM52.6005 7.01655C54.5602 6.2512 56.8911 6.27439 58.2594 6.8426L58.2942 17.8242C56.6476 17.3836 53.6557 15.5282 52.6005 13.8351V7.01655ZM62.3645 6.8542C65.797 5.06838 70.1456 5.25392 72.2909 6.69185V26.3591C71.943 26.3359 71.3052 26.2315 70.4587 25.8836C67.2697 24.6196 63.6169 21.5002 62.3645 19.0302V6.8542ZM76.3379 6.74983C81.4983 3.44491 88.8039 3.34055 92.3407 6.52951V39.7875C92.1436 39.8571 91.8305 39.9266 91.2739 39.8686C86.9369 39.4628 78.634 32.8877 76.3148 27.1708L76.3379 6.74983ZM96.3646 6.90058C102.07 4.01313 108.286 3.29416 113.179 5.022C118.259 6.81941 122.236 11.1448 124.938 17.8706C129.252 28.5623 133.879 34.4648 140.697 37.8393C140.697 39.2656 140.72 41.4109 140.72 41.4341C140.732 41.724 140.547 41.8632 140.384 41.9444C137.972 42.0719 136.094 43.9969 136.036 46.4669C136.024 46.8844 135.78 47.0235 135.56 47.0351C134.482 46.8264 133.368 46.9887 132.429 47.5221C131.351 48.102 130.574 49.1108 130.237 50.3284C130.191 50.4676 130.122 50.6415 129.959 50.7227C129.866 50.7923 129.762 50.8039 129.623 50.7923C127.454 49.7022 124.892 50.4792 123.651 52.6013C123.43 52.9724 123.152 52.9724 122.943 52.8912C121.111 51.3025 118.444 51.3953 116.693 53.1347C116.6 53.2275 116.45 53.355 116.276 53.355C116.171 53.355 116.079 53.2855 115.997 53.2391C114.594 51.2329 112.055 50.6415 109.909 51.9287C109.793 51.9867 109.619 52.0795 109.469 52.0331C109.364 51.9983 109.272 51.9287 109.225 51.8359C108.355 49.5399 106.036 48.3687 103.636 49.0528C103.52 49.0876 103.334 49.1108 103.183 49.0297C103.091 48.9833 103.033 48.9021 102.986 48.7977C102.731 46.3393 100.771 44.6115 98.2896 44.6927C98.0925 44.6927 97.9649 44.6463 97.8605 44.5535C97.7562 44.4723 97.6982 44.2984 97.6982 44.0897V43.9041L97.6518 43.6954C97.5822 43.3475 97.5126 42.9532 97.4547 42.5938C97.3387 41.6777 97.1648 40.4601 96.3762 39.5555V6.90058H96.3646ZM46.6052 16.0616C47.2546 16.3283 48.4722 16.6762 49.6782 16.6646C51.754 19.3201 55.7663 21.6162 58.3986 21.9409C58.7581 21.9757 59.1176 21.9757 59.4191 21.9525C62.0514 25.9184 67.722 29.9423 71.7111 30.3597C72.3488 30.4177 72.8939 30.3829 73.3693 30.3134C76.825 36.6449 85.2322 43.3707 90.8912 43.9273C91.9696 44.0201 92.8394 43.9041 93.5699 43.6606C93.6047 43.9389 93.6395 44.2056 93.7091 44.4955C93.8019 45.6899 94.3005 46.7568 95.1238 47.5337C96.0051 48.3687 97.1763 48.7977 98.4171 48.7514C98.8114 48.7514 99.0086 48.9137 99.0202 49.2964L99.0317 49.5399L99.1017 49.795C99.4377 51.0126 100.226 51.9867 101.282 52.5781C102.337 53.1695 103.555 53.2855 104.784 52.9376C105.155 52.81 105.398 52.9608 105.491 53.3203L105.549 53.5638L105.688 53.8073C106.326 54.8742 107.323 55.6511 108.483 55.9526C109.643 56.2425 110.895 56.057 111.985 55.4076C112.321 55.2104 112.565 55.2916 112.774 55.6163L112.901 55.8134L113.063 56.0106C113.968 56.8919 115.104 57.3905 116.31 57.3905C117.505 57.3905 118.676 56.9035 119.581 56.0106C119.847 55.7207 120.137 55.7207 120.415 55.999L120.589 56.1729L120.81 56.3005C123.036 57.6225 125.831 56.8919 127.13 54.6538C127.327 54.3059 127.617 54.2364 127.941 54.4219L128.173 54.5611L128.417 54.6538C129.623 54.9785 130.887 54.851 131.931 54.2596C132.997 53.6566 133.774 52.6593 134.111 51.4301C134.157 51.2909 134.238 51.117 134.389 51.0358C134.551 50.943 134.737 50.9894 134.853 51.001L135.108 51.0822L135.363 51.0938C137.961 51.1286 140.013 49.1572 140.071 46.5365C140.094 46.1422 140.303 45.9219 140.674 45.9451H140.941L141.184 45.8871C143.295 45.3884 144.768 43.5446 144.744 41.3877L144.733 36.5057L144.721 35.207L143.515 34.6619C136.986 31.8093 132.835 26.6721 128.672 16.3515C125.506 8.48927 120.74 3.41012 114.525 1.20684C106.465 -1.65743 98.6723 1.21844 94.7064 3.21299C89.7432 -0.880489 80.9532 -0.915277 74.3782 3.21299C70.7486 0.916929 64.8577 0.928519 60.3236 3.35214C57.6796 2.04177 53.7137 2.05336 50.5248 3.52608C48.5418 2.76073 45.376 2.49402 43.138 3.57247C41.3058 4.46538 40.3085 6.10045 40.3085 8.15298C40.3085 12.2465 43.5438 14.9136 46.6052 16.0616Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M98.7998 10.3982C98.4867 10.5722 98.2896 10.9317 98.2896 11.3027C98.2896 11.9057 98.7766 12.3928 99.3797 12.3928C99.9597 12.3928 100.458 11.8941 100.458 11.3027C100.458 10.8621 100.168 10.491 99.8087 10.3171C100.11 10.1431 100.331 9.78361 100.331 9.38936C100.331 8.78636 99.8437 8.29932 99.2407 8.29932C98.6491 8.29932 98.1504 8.78636 98.1504 9.38936C98.1504 9.84161 98.4287 10.2243 98.7998 10.3982Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M78.8427 10.1917C79.4457 10.1917 79.9328 9.70464 79.9328 9.09004C79.9328 8.49864 79.4457 8 78.8427 8C78.2513 8 77.7759 8.48704 77.7759 9.09004C77.7759 9.70464 78.2513 10.1917 78.8427 10.1917Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M64.7649 9.6953C65.3563 9.6953 65.8434 9.20825 65.8434 8.60524C65.8434 7.99064 65.3563 7.5152 64.7649 7.5152C64.1619 7.5152 63.6633 7.99064 63.6633 8.60524C63.6633 9.20825 64.1503 9.6953 64.7649 9.6953Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M54.6646 9.81116C55.2676 9.81116 55.7547 9.32416 55.7547 8.70956C55.7547 8.10655 55.2676 7.61951 54.6646 7.61951C54.0616 7.61951 53.5746 8.11815 53.5746 8.70956C53.5746 9.32416 54.0616 9.81116 54.6646 9.81116Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M54.5718 13.6844C54.6762 13.6844 54.7806 13.6728 54.8849 13.638C54.8965 14.2294 55.3836 14.7165 55.9866 14.7165C56.5664 14.7165 57.065 14.2294 57.065 13.638C57.065 13.0234 56.5664 12.5364 55.9866 12.5364C55.8706 12.5364 55.7662 12.548 55.6619 12.5827C55.6503 12.2928 55.5227 12.0145 55.3256 11.8058C55.5923 11.6203 55.7662 11.284 55.7662 10.9245C55.7662 10.3331 55.2908 9.83435 54.6878 9.83435C54.0964 9.83435 53.6094 10.3215 53.6094 10.9245C53.6094 11.226 53.7253 11.5043 53.934 11.713C53.6673 11.887 53.4934 12.2117 53.4934 12.5943C53.505 13.1858 53.9804 13.6844 54.5718 13.6844Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M65.5651 19.8304C65.7274 19.8304 65.8666 19.784 65.9941 19.7376V19.784C65.9941 20.3754 66.4812 20.874 67.0726 20.874L67.1421 20.8624C67.1653 21.4423 67.6524 21.9061 68.209 21.9061C68.325 21.9061 68.4525 21.8713 68.5453 21.8365V21.9525C68.5453 22.5555 69.0323 23.0425 69.6237 23.0425C70.2267 23.0425 70.7138 22.5671 70.7138 21.9525C70.7138 21.3379 69.5889 20.8624 69.7629 20.8624C70.3543 20.8624 70.8413 20.3638 70.8413 19.7724C70.8413 19.181 70.3543 18.6824 69.7629 18.6824L69.5658 18.7171C69.5542 18.1373 69.0787 17.6619 68.4989 17.6619C68.2438 17.6619 68.0119 17.7431 67.8379 17.9054C67.6408 17.7199 67.3857 17.5923 67.0958 17.5923C66.7943 17.5923 66.5276 17.7199 66.3188 17.917L66.1681 17.8126C66.2145 17.6967 66.226 17.2444 66.226 17.1285L66.2145 17.0125C66.4 17.1401 66.5971 17.2212 66.8406 17.2212C67.4437 17.2212 67.9191 16.8154 67.9191 16.2124C67.9191 15.5978 67.4321 15.3542 66.8406 15.3542C66.7363 15.3542 66.6551 15.3658 66.5623 15.4006C66.4928 15.2847 66.4116 15.1919 66.2956 15.0991C66.5971 14.902 66.8059 14.5541 66.8059 14.1598C66.8059 13.7192 66.516 13.3365 66.1449 13.1742C66.0637 12.9306 65.8782 12.7567 65.6462 12.6407C65.9941 12.4552 66.226 12.1073 66.226 11.6782C66.226 11.0752 65.7506 10.5882 65.136 10.5882C64.533 10.5882 64.0576 11.0752 64.0576 11.6782C64.0576 12.1073 64.3011 12.4552 64.6374 12.6407C64.3011 12.8263 64.0576 13.1857 64.0576 13.6032C64.0576 13.9047 64.1967 14.2062 64.3938 14.4149C63.9068 14.5077 63.5473 14.9484 63.5473 15.4586C63.5473 16.05 63.988 16.5023 64.533 16.5487C64.2547 16.7342 64.0692 17.0705 64.0692 17.4648C64.0692 17.8358 64.2663 18.1721 64.5562 18.3693C64.5214 18.4968 64.4982 18.6012 64.4982 18.7287C64.4866 19.3317 64.9737 19.8304 65.5651 19.8304Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M81.3011 30.0003C81.2316 30.1742 81.1736 30.3481 81.1736 30.4989C81.1736 30.9975 81.4983 31.3918 81.9389 31.5542C81.8925 31.6585 81.8577 31.7977 81.8577 31.9484C81.8577 32.5514 82.3564 33.0385 82.9594 33.0385C83.1333 33.0385 83.3305 32.9805 83.4928 32.8877V32.9457C83.4928 33.5487 83.9567 34.0126 84.5713 34.0126C84.7684 34.0126 84.9655 33.9662 85.1395 33.8734L85.1163 34.0937C85.1163 34.6967 85.5917 35.207 86.2179 35.207L86.4035 35.1722C86.6122 35.3461 86.8557 35.4621 87.1224 35.4621C87.679 35.4621 88.1545 35.033 88.2009 34.488L88.2704 34.4532C88.3748 34.6272 88.514 34.8127 88.6763 34.9287C88.3168 35.1142 88.0849 35.4737 88.0849 35.8911C88.0849 36.5173 88.572 37.0044 89.175 37.0044C89.7664 37.0044 90.2418 36.5173 90.2418 35.8911C90.2418 35.5433 90.0679 35.2186 89.7896 35.0098C90.1259 34.8243 90.3694 34.4648 90.3694 34.0241C90.3694 33.4559 89.9055 32.9805 89.3141 32.9573V32.9457C89.8939 32.9225 90.3694 32.4587 90.3694 31.8673C90.3694 31.2642 89.8823 30.754 89.2909 30.754C88.8039 30.754 88.4096 31.0787 88.2589 31.5194L88.1893 31.4846C88.2589 31.3338 88.3284 31.1483 88.3284 30.9627C88.3284 30.3597 87.8414 29.8727 87.2616 29.8727C86.9833 29.8727 86.7745 29.9655 86.589 30.1162C86.6702 29.9423 86.7513 29.7567 86.7513 29.5712C86.7513 28.945 86.2643 28.4812 85.6729 28.4812C85.3366 28.4812 85.0583 28.6087 84.8612 28.8406C84.896 28.7363 84.9076 28.6435 84.9076 28.5275C84.9076 27.9477 84.4205 27.4259 83.8059 27.4259L83.7363 27.4491C83.8059 27.3215 83.8639 27.1708 83.8639 27.0084C84.0262 27.1128 84.235 27.194 84.4321 27.194C85.0351 27.194 85.5222 26.6953 85.5222 26.0807C85.5222 25.4545 85.0351 24.9907 84.4321 24.9907C83.8755 24.9907 83.4232 25.4429 83.3653 25.988C83.2029 25.8836 82.9942 25.8256 82.7854 25.8256C82.5071 25.8256 82.0085 26.0228 81.9737 25.9996C82.1824 25.8024 82.2984 25.5357 82.2984 25.2458C82.2984 24.6428 81.7998 24.1442 81.22 24.1442C81.1272 24.1442 81.1852 23.7731 81.1852 23.518C81.1852 22.915 80.7097 22.4279 80.1067 22.4279C80.0487 22.4279 81.0692 21.9525 81.0692 21.3495C81.0692 20.7697 80.6169 20.2942 80.0255 20.2594L80.0371 20.2478C80.0371 19.8536 79.8052 19.5173 79.5037 19.3085C79.782 19.1114 79.9444 18.8099 79.9444 18.4272C79.9444 18.2533 79.898 18.1141 79.8284 17.9402C80.1995 17.7547 80.4662 17.4068 80.4662 16.9661C80.4662 16.6066 80.3038 16.2819 80.0371 16.0848C80.3154 15.8761 80.5474 15.5514 80.5474 15.1571C80.5474 14.7048 80.2691 14.3222 79.8864 14.1598C79.782 13.9163 79.5965 13.7424 79.3877 13.6148C79.724 13.4177 79.9676 13.0698 79.9676 12.6523C79.9676 12.0493 79.4805 11.5739 78.8775 11.5739C78.2861 11.5739 77.8107 12.0377 77.8107 12.6523C77.8107 13.0698 78.031 13.4177 78.3905 13.6148C78.031 13.8119 77.8107 14.1598 77.8107 14.5657C77.8107 14.8904 77.9382 15.1803 78.147 15.3658C77.6483 15.4586 77.2888 15.8993 77.2888 16.4327C77.2888 17.0125 77.7295 17.4647 78.2745 17.5111C77.9846 17.7083 77.8107 18.0446 77.8107 18.4156C77.8107 18.8099 78.0078 19.1694 78.3093 19.3549C78.0426 19.5521 77.8802 19.8768 77.8802 20.2246C77.8802 20.6769 78.1701 21.0712 78.5644 21.2335C78.1238 21.3727 77.7991 21.7669 77.7991 22.2772C77.7991 22.7642 78.1238 23.1817 78.5644 23.3208C78.4021 23.4948 78.3093 23.7267 78.3093 24.0282C78.3093 24.4921 78.6224 24.9095 79.0631 25.0487V25.0603L78.8427 25.0255C78.2513 25.0255 77.7759 25.5473 77.7759 26.1387C77.7759 26.6953 78.2049 27.194 78.7732 27.2172L78.75 27.4259C78.75 28.0405 79.237 28.5275 79.8284 28.5275L80.0023 28.5159C79.9328 28.6551 79.9096 28.8058 79.9096 28.9914C79.9096 29.5944 80.3966 30.0814 80.9996 30.0814C81.104 30.0698 81.2084 30.035 81.3011 30.0003Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M89.2909 30.0003C89.8823 30.0003 90.3694 29.5364 90.3694 28.9218C90.3694 28.3188 89.8823 27.8434 89.2909 27.8434C88.6879 27.8434 88.2125 28.3188 88.2125 28.9218C88.2125 29.5248 88.6879 30.0003 89.2909 30.0003Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M98.765 24.8007C98.4635 24.9863 98.278 25.3342 98.278 25.7052C98.278 26.2966 98.7187 26.7489 99.2757 26.7953V27.062C98.765 27.1548 98.3476 27.5954 98.3476 28.152C98.3476 28.4188 98.4287 28.6275 98.5679 28.8014C98.3824 29.0102 98.2664 29.2653 98.2664 29.5668C98.2664 30.0654 98.5911 30.4481 99.0317 30.5873C98.8694 30.796 98.7766 31.0279 98.7766 31.283C98.7766 31.6425 98.9274 31.944 99.1827 32.1411V32.3499C98.6491 32.4311 98.2664 32.8717 98.2664 33.4283C98.2664 33.8342 98.4983 34.1937 98.8462 34.3908C98.5099 34.5763 98.2664 34.9358 98.2664 35.3301C98.2664 35.6548 98.4171 35.9679 98.6375 36.1534C98.2316 36.3158 97.9533 36.6985 97.9533 37.1739C97.9533 37.6957 98.336 38.1364 98.8346 38.2408C98.4983 38.4263 98.278 38.7858 98.278 39.1916C98.278 39.7831 98.765 40.2817 99.3677 40.2817L99.5647 40.2585C99.6467 40.7803 100.087 41.1862 100.644 41.1862C100.911 41.1862 101.166 41.0934 101.351 40.9079L101.34 41.0586C101.34 41.6732 101.827 42.1603 102.418 42.1603C102.905 42.1603 103.323 41.8356 103.439 41.3833C103.589 41.8008 103.995 42.0907 104.447 42.0907C104.819 42.0907 105.155 41.8936 105.364 41.6384C105.503 42.0443 105.897 42.3458 106.372 42.3458C106.581 42.3458 106.778 42.2878 106.941 42.1835C106.964 42.7749 107.428 43.2503 108.019 43.2503C108.622 43.2503 109.109 42.7517 109.109 42.1603C109.109 42.0791 109.643 42.6357 110.095 42.6357C110.246 42.6357 110.396 42.6009 110.512 42.5545C110.709 42.7749 110.999 42.9256 111.347 42.9256C111.834 42.9256 112.24 42.5893 112.368 42.1255C112.542 42.5082 112.924 42.8097 113.388 42.8097C113.968 42.8097 114.467 42.3226 114.467 41.708C114.467 41.6269 115 42.4154 115.545 42.4154C115.789 42.4154 116.009 42.3342 116.183 42.2183C116.38 42.485 116.705 42.6705 117.064 42.6705C117.54 42.6705 117.945 42.369 118.073 41.9515C118.27 42.0907 118.491 42.1719 118.722 42.1719C119.325 42.1719 119.812 41.6848 119.812 41.0702L119.952 40.9543C119.952 41.5573 120.415 42.0443 121.018 42.0443C121.575 42.0443 122.016 41.6384 122.097 41.1166C122.294 41.2906 122.549 41.3949 122.816 41.3949C123.268 41.3949 123.651 41.1166 123.802 40.7339C124.103 40.5716 124.312 40.2585 124.358 39.9222C124.509 40.3165 124.892 40.618 125.355 40.618C125.947 40.618 126.434 40.1425 126.434 39.5279C126.434 38.9365 125.947 38.4379 125.355 38.4379C124.81 38.4379 124.358 38.8554 124.277 39.3772C124.184 39.1453 124.01 38.9597 123.813 38.8322C123.651 38.4263 123.257 38.1132 122.793 38.1132C122.375 38.1132 122.004 38.3683 121.83 38.7046C121.645 38.4727 121.343 38.3335 120.984 38.3335C120.903 38.3335 120.787 38.3567 120.671 38.3915C120.671 38.2292 120.636 38.0784 120.601 37.9393C120.937 37.7653 121.192 37.4058 121.192 36.9768C121.192 36.3622 120.694 35.8635 120.114 35.8635C119.499 35.8635 119.012 36.3622 119.012 36.9768C119.012 37.1159 119.059 37.2783 119.117 37.4058C118.757 37.5914 118.409 38.4263 118.375 38.4263L118.398 38.2639C118.398 37.6378 117.911 37.1855 117.296 37.1855C117.18 37.1855 117.076 37.1855 116.96 37.2319C116.902 36.6985 116.45 36.2578 115.893 36.2578C115.487 36.2578 115.139 36.5013 114.942 36.8492C114.757 36.5013 114.409 36.2578 113.98 36.2578C113.539 36.2578 113.145 36.5477 112.982 36.9304C112.843 36.4665 112.449 36.1302 111.927 36.1302C111.544 36.1302 110.965 36.6521 110.941 36.6521C111.046 36.4665 111.104 36.2694 111.104 36.0955C111.104 35.4693 110.628 34.9938 110.025 34.9938C109.469 34.9938 109.19 35.3881 109.19 35.0518L109.179 34.8547C109.701 34.7503 110.106 34.3096 110.106 33.7762C110.106 33.1848 109.608 32.663 109.005 32.663C108.413 32.663 107.926 33.1848 107.926 33.7762L107.95 33.9965H107.602L107.683 33.6023C107.683 32.7905 106.859 32.7094 106.755 32.6746C106.314 32.6862 105.967 32.9529 105.781 33.3356C105.688 32.8369 105.271 32.4658 104.772 32.4658C104.935 32.2687 105.027 32.0136 105.027 31.7353C105.027 31.1207 104.552 30.6452 103.949 30.6452C103.752 30.6452 103.589 30.7032 103.439 30.7612C103.485 30.6684 103.497 30.5641 103.497 30.4481L103.485 30.251H103.694C104.285 30.251 104.772 29.7639 104.772 29.1493C104.772 28.5695 104.517 28.1752 103.926 28.1752C103.334 28.1752 102.812 28.4304 102.812 29.0218L102.673 29.5668L102.349 29.648C101.977 29.648 101.827 29.8335 101.63 30.0886C101.572 29.9842 101.456 29.5784 101.398 29.474L101.514 29.4972C102.128 29.4972 102.615 29.0102 102.615 28.3956C102.615 27.781 102.128 27.3171 101.514 27.3171L101.363 27.3287C101.653 27.1896 101.873 26.9228 101.931 26.5866C102.337 26.4242 102.615 26.0299 102.615 25.5777C102.615 24.9631 102.128 24.4644 101.514 24.4644C101.27 24.4644 101.05 24.5688 100.876 24.708C100.922 24.5804 100.957 24.4413 100.957 24.2905C100.957 23.931 100.783 23.6295 100.528 23.3976C100.725 23.27 100.887 23.0729 100.957 22.8294C101.189 22.6438 101.351 22.3539 101.351 22.0176C101.351 21.403 100.853 20.916 100.261 20.916C100.145 20.916 100.029 20.9392 99.9127 20.974L99.8667 20.9508C100.215 20.7537 100.458 20.4058 100.458 19.9767C100.458 19.5824 100.261 19.2461 99.9477 19.049C100.458 18.9446 100.841 18.5156 100.841 17.9822C100.841 17.4951 100.516 17.0893 100.076 16.9501C100.308 16.7298 100.47 16.4399 100.47 16.1152C100.47 15.6977 100.226 15.3382 99.8787 15.1759C100.226 14.9787 100.47 14.6077 100.47 14.2134C100.47 13.5872 99.9707 13.1233 99.3917 13.1233C98.7882 13.1233 98.3012 13.5872 98.3012 14.2134C98.3012 14.6077 98.5331 14.9787 98.881 15.1759C98.5447 15.3498 98.3012 15.6977 98.3012 16.1152C98.3012 16.6254 98.6259 17.0197 99.0667 17.1472C98.823 17.3792 98.6839 17.6575 98.6839 17.9822C98.6839 18.3532 98.881 18.7011 99.1827 18.8983C98.6839 19.0026 98.3128 19.4201 98.3128 19.9767C98.3128 20.3942 98.5447 20.7421 98.8926 20.9508C98.5563 21.1247 98.3128 21.4958 98.3128 21.9133C98.3128 22.2264 98.4403 22.5047 98.6491 22.6902C98.162 22.7946 97.8025 23.2352 97.8025 23.7571C97.7678 24.2673 98.22 24.7428 98.765 24.8007Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M128.208 39.4468C128.811 39.4468 129.275 38.9597 129.275 38.3451C129.275 37.7537 128.811 37.2551 128.208 37.2551C127.605 37.2551 127.13 37.7421 127.13 38.3451C127.13 38.9597 127.605 39.4468 128.208 39.4468Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M125.854 44.0041L125.866 44.12C125.773 44.236 125.703 44.3404 125.645 44.4911C125.471 44.3404 125.263 44.2476 125.019 44.2476C124.521 44.2476 124.103 44.5955 123.964 45.0709C123.778 44.897 123.512 44.781 123.222 44.781C122.851 44.781 122.549 44.955 122.34 45.2333C122.143 45.0361 121.865 44.9086 121.564 44.9086C120.972 44.9086 120.473 45.3956 120.473 45.987C120.473 46.59 120.972 47.0887 121.564 47.0887C121.935 47.0887 122.248 46.9147 122.456 46.6248C122.642 46.822 122.92 46.9611 123.222 46.9611C123.72 46.9611 124.138 46.6016 124.277 46.1494C124.474 46.3233 124.729 46.4393 125.019 46.4393C125.471 46.4393 125.889 46.1378 126.028 45.7087C126.214 45.8595 126.434 45.9291 126.666 45.9291C127.107 45.9291 127.478 45.6739 127.652 45.2913C127.837 45.4536 128.081 45.5348 128.336 45.5348C128.881 45.5348 129.321 45.1289 129.403 44.5955C129.565 44.6998 129.762 44.781 130.006 44.781C130.516 44.781 130.98 44.3752 131.061 43.8533C131.246 44.0157 131.501 44.1316 131.791 44.1316C132.394 44.1316 132.87 43.6446 132.87 43.0416L132.835 42.7981C133.009 42.914 133.218 42.9836 133.438 42.9836C134.029 42.9836 134.516 42.4966 134.516 41.9168C134.69 42.0211 134.888 42.0791 135.108 42.0791C135.699 42.0791 136.186 41.5921 136.186 41.0007L136.175 40.8151C136.302 40.8731 136.465 40.9311 136.627 40.9311C137.23 40.9311 137.729 40.444 137.729 39.841C137.729 39.2148 137.23 38.7278 136.627 38.7278C136.349 38.7278 136.105 38.8438 135.896 39.0293C135.699 38.7046 135.363 38.4959 134.969 38.4959C134.366 38.4959 133.879 38.9829 133.879 39.5627C133.879 39.8874 134.006 40.1541 134.215 40.3629L134.134 40.5136C134.041 39.9802 133.612 39.5627 133.067 39.5627C132.452 39.5627 131.965 40.0614 131.965 40.6644C131.965 40.7455 131.977 40.8267 132.012 40.9311C131.815 40.7919 131.629 40.7339 131.386 40.7339C130.794 40.7339 130.307 41.221 130.307 41.824C130.307 42.2067 130.493 42.4966 130.759 42.7053L130.701 42.8792C130.585 42.7981 130.469 42.7169 130.33 42.6705C130.145 42.2878 129.785 42.0327 129.345 42.0327C128.742 42.0327 128.266 42.5198 128.266 43.1344L128.301 43.3895C128.15 43.4011 127.999 43.4243 127.86 43.4822C127.686 43.1576 127.315 42.9372 126.909 42.9372C126.33 42.914 125.854 43.3895 125.854 44.0041Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M113.527 35.0054C114.119 35.0054 114.606 34.5184 114.606 33.927C114.606 33.324 114.119 32.8369 113.527 32.8369C112.901 32.8369 112.426 33.3356 112.426 33.927C112.414 34.5184 112.901 35.0054 113.527 35.0054Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M106.755 31.0859C107.381 31.0859 107.868 30.5989 107.868 30.0074C107.868 29.3928 107.381 28.9174 106.755 28.9174C106.164 28.9174 105.677 29.3928 105.677 30.0074C105.677 30.5989 106.164 31.0859 106.755 31.0859Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M103.578 24.4065C104.181 24.4065 104.656 23.931 104.656 23.328C104.656 22.725 104.169 22.238 103.578 22.238C102.986 22.238 102.511 22.725 102.511 23.328C102.499 23.931 102.986 24.4065 103.578 24.4065Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M119.267 45.0361C118.676 45.0361 118.189 45.5348 118.189 46.1262C118.189 46.7292 118.676 47.2162 119.267 47.2162C119.87 47.2162 120.358 46.7292 120.358 46.1262C120.358 45.5348 119.87 45.0361 119.267 45.0361Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M116.461 45.0361C115.87 45.0361 115.383 45.5348 115.383 46.1262C115.383 46.7292 115.881 47.2162 116.461 47.2162C117.076 47.2162 117.551 46.7292 117.551 46.1262C117.551 45.5348 117.076 45.0361 116.461 45.0361Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M112.507 45.1637C111.904 45.1637 111.417 45.6391 111.417 46.2422C111.417 46.8452 111.892 47.3322 112.507 47.3322C113.121 47.3322 113.585 46.8452 113.585 46.2422C113.585 45.6276 113.121 45.1637 112.507 45.1637Z",
            fill: "#19227D"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M66.829 41.7008C66.829 41.0978 66.3304 40.6224 65.7506 40.6224C65.1476 40.6224 64.649 41.0978 64.649 41.7008C64.649 42.3038 65.136 42.7909 65.7506 42.7909C66.3304 42.7909 66.829 42.3038 66.829 41.7008Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M69.9948 45.1101C69.9948 44.5303 69.5078 44.0201 68.8932 44.0201C68.3018 44.0201 67.8147 44.5187 67.8147 45.1101C67.8147 45.7247 68.3134 46.2234 68.8932 46.2234C69.5078 46.2234 69.9948 45.7363 69.9948 45.1101Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M80.7097 49.0761C80.7097 48.473 80.2111 47.9744 79.6197 47.9744C79.0051 47.9744 78.5412 48.473 78.5412 49.0761C78.5412 49.6791 79.0051 50.1661 79.6197 50.1661C80.2111 50.1661 80.7097 49.6791 80.7097 49.0761Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M85.5801 54.2828C85.5801 53.6797 85.1047 53.1927 84.4901 53.1927C83.8871 53.1927 83.4116 53.6913 83.4116 54.2828C83.4116 54.8742 83.8987 55.3612 84.4901 55.3612C85.1047 55.3728 85.5801 54.8742 85.5801 54.2828Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M87.9342 62.3885C88.5488 62.3885 89.0242 61.9015 89.0242 61.3101C89.0242 60.7071 88.5488 60.1968 87.9342 60.1968C87.3428 60.1968 86.8557 60.6955 86.8557 61.3101C86.8557 61.9015 87.3428 62.3885 87.9342 62.3885Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M78.9239 46.2234C78.9703 46.7916 79.4225 47.2438 80.0139 47.2438C80.2923 47.2438 80.559 47.1395 80.7445 46.9307V47.0351C80.7445 47.6497 81.2315 48.1367 81.8114 48.1367C82.2984 48.1367 82.6927 47.8121 82.8318 47.383L82.8898 47.4758C82.8086 47.6497 82.7391 47.8352 82.7391 48.044C82.7391 48.6354 83.2145 49.134 83.8175 49.134C84.4089 49.134 84.9076 48.647 84.9076 48.044C84.9076 47.9396 84.9887 47.4642 84.9539 47.383C85.1279 47.7657 85.3946 48.4151 85.8468 48.4151C86.2527 48.4151 86.6006 48.2063 86.7861 47.8932C86.9601 48.2411 87.3312 48.473 87.7486 48.473C88.0965 48.473 88.398 48.3107 88.6067 48.0556V48.4846C88.6067 48.6354 88.6183 48.7629 88.6879 48.8905C88.1777 48.9949 87.8066 49.4355 87.8066 49.9689C87.8066 50.0269 87.737 50.3632 87.7022 50.4792C87.5979 50.4096 87.4819 50.4096 87.3544 50.4096C87.0181 50.4096 86.7166 50.5604 86.5194 50.8039L86.3803 50.7923C85.8005 50.7923 85.3018 51.2793 85.3018 51.9055C85.3018 52.4969 85.8005 52.9724 86.3803 52.9724C86.7282 52.9724 86.8673 52.5781 87.0644 52.3346L87.3544 52.2998C87.4703 52.2998 87.5747 52.5781 87.6675 52.5549C87.6559 52.6129 87.6443 52.7868 87.2036 52.8448C86.7282 52.9144 86.6006 53.0767 86.6006 53.6797C86.6006 54.0508 86.589 54.5031 86.8673 54.7234C86.589 54.9089 86.3803 55.2452 86.3803 55.6163C86.3803 55.8598 86.473 56.0918 86.6238 56.2889L86.3803 56.2541C85.7889 56.2541 85.3018 56.7411 85.3018 57.3557C85.3018 57.9587 85.7889 58.4458 86.3803 58.4458C86.7977 58.4458 87.134 58.2255 87.3312 57.9124C87.5167 58.1327 87.8182 58.2602 88.1197 58.2602C88.2473 58.2602 88.3632 58.2255 88.4792 58.2023C88.456 58.295 88.4444 58.3646 88.4444 58.4458C88.4444 59.0488 88.9314 59.5474 89.5112 59.5474C90.1142 59.5474 90.6129 59.0488 90.6129 58.4458L90.5897 58.353C90.7057 58.4226 91.1231 58.5386 91.2507 58.6197C90.9608 58.8169 90.752 59.1532 90.752 59.5474C90.752 60.1504 90.9492 60.5911 91.5522 60.5911C91.7725 60.5911 91.9696 60.5215 92.132 60.4171C92.2132 60.939 92.6654 61.3448 93.2104 61.3448C93.4772 61.3448 93.7091 61.2637 93.9178 61.0897C94.0222 61.1825 94.1497 61.2637 94.2657 61.2869C93.7091 61.3332 93.2684 61.8087 93.2684 62.4001C93.2684 62.9915 93.7439 63.4785 94.3469 63.4785C94.9267 63.4785 95.4253 62.9915 95.4253 62.4001C95.4253 61.9015 95.1006 61.484 94.6948 61.3564C94.8455 61.3448 94.9847 61.3217 95.1238 61.2405C95.3094 61.5536 95.6457 61.7391 96.0283 61.7391C96.4342 61.7391 96.7937 61.5188 96.9792 61.1825V61.1941C96.9792 61.7855 97.4779 62.2841 98.0693 62.2841C98.6839 62.2841 99.1477 61.7855 99.1477 61.1941V61.1825L99.2867 61.1941V61.2985C99.2867 61.8203 99.6467 62.2493 100.11 62.3769C99.8317 62.574 99.6577 62.9103 99.6577 63.2698C99.6577 63.8612 100.134 64.3599 100.748 64.3599C101.351 64.3599 101.815 63.8612 101.815 63.2698C101.815 63.1423 101.815 63.0263 101.769 62.9219C101.92 63.0031 102.093 63.0495 102.291 63.0495C102.847 63.0495 103.311 62.6204 103.346 62.0638C103.485 62.4929 103.891 62.8292 104.378 62.8292C104.749 62.8292 105.074 62.6552 105.271 62.3421C105.271 62.9451 105.758 63.4438 106.361 63.4438L106.419 63.4322C106.523 63.9424 106.952 64.3367 107.497 64.3367C108.089 64.3367 108.576 63.8496 108.576 63.2466L108.564 63.0495C109.144 63.0379 109.596 62.5508 109.596 61.971C109.596 61.7971 109.561 61.6463 109.503 61.4956H109.654C109.759 61.9015 110.13 62.2262 110.559 62.2725C110.512 62.3769 110.501 62.4813 110.501 62.6088C110.501 63.2118 110.988 63.6989 111.591 63.6989C112.194 63.6989 112.681 63.2002 112.681 62.6088L112.623 62.3421L112.75 62.3537C113.295 62.3537 113.771 61.9478 113.84 61.4144C114.038 61.6347 114.327 61.7739 114.652 61.7739C115.116 61.7739 115.522 61.484 115.661 61.0549C115.835 61.484 116.229 61.7739 116.705 61.7739C117.203 61.7739 117.632 61.4376 117.737 60.9854C117.934 61.1593 118.201 61.2753 118.479 61.2753C119.001 61.2753 119.43 60.9042 119.534 60.4519C119.696 60.5679 119.905 60.6491 120.149 60.6491C120.729 60.6491 121.227 60.1504 121.227 59.5474C121.227 58.9444 120.729 58.4458 120.149 58.4458C119.639 58.4458 119.209 58.7937 119.094 59.2923C118.92 59.1532 118.711 59.1068 118.479 59.1068C117.992 59.1068 117.551 59.4547 117.447 59.8953C117.238 59.7098 116.971 59.6054 116.705 59.6054C116.229 59.6054 115.835 59.9185 115.661 60.3592C115.522 59.9185 115.128 59.6054 114.652 59.6054C114.385 59.6054 114.119 59.7098 113.922 59.8953C113.852 59.3967 113.411 58.9676 112.855 58.9676L112.774 58.9792C112.704 58.4806 112.24 58.0863 111.695 58.0863C111.347 58.0863 111.057 58.2371 110.849 58.4922C110.767 58.4922 110.663 58.4458 110.559 58.4458C109.967 58.4458 109.492 58.9328 109.492 59.5242C109.48 58.9328 108.993 58.4458 108.39 58.4458C107.903 58.4458 107.497 58.7937 107.358 59.2111L107.138 59.13L107.184 58.898C107.184 58.295 106.674 57.8196 106.083 57.8196C105.688 57.8196 105.34 58.0399 105.132 58.3762C105.213 58.2139 105.259 58.0399 105.259 57.8776C105.259 57.263 104.772 56.7875 104.181 56.7875C104.204 56.6832 104.227 56.5672 104.227 56.4512C104.227 55.8598 103.74 55.3612 103.149 55.3612C102.557 55.3612 102.465 55.7671 102.465 56.3701C102.465 56.602 102.151 56.9035 102.279 57.1006C102.151 57.031 102.024 56.9615 101.908 56.9035C102.024 56.7411 102.082 56.544 102.082 56.3237C102.082 55.7207 101.583 55.2336 100.992 55.2336C100.76 55.2336 100.551 55.3264 100.389 55.4424C100.273 54.9437 99.8317 54.5958 99.3447 54.5958L99.1247 54.619C99.0317 54.1088 98.6143 53.7029 98.0577 53.7029C97.7678 53.7029 97.5126 53.8421 97.3039 54.016C97.4894 53.8189 97.6054 53.5522 97.6054 53.2739C97.6054 52.7868 97.2923 52.3694 96.8401 52.2186C96.9096 52.0679 96.956 51.8939 96.956 51.7084C96.956 51.117 96.4806 50.6183 95.8776 50.6183C95.5877 50.6183 95.3094 50.7575 95.1006 50.9314C94.9383 50.5256 94.5556 50.2357 94.0918 50.2357L93.883 50.2705C93.8019 49.737 93.3496 49.3428 92.8046 49.3428L92.5611 49.3891C92.677 49.2036 92.7582 48.9949 92.7582 48.7629C92.7582 48.1715 92.2712 47.7077 91.6913 47.6845C91.7957 47.5105 91.8653 47.325 91.8653 47.1047C91.8653 46.4785 91.3666 46.0146 90.7868 46.0146C90.2882 46.0146 89.8591 46.3509 89.72 46.8148H89.6736L89.6852 46.7104C89.6852 46.1074 89.2213 45.632 88.6067 45.632C88.4444 45.632 88.2705 45.6783 88.1313 45.7363C87.9226 45.4348 87.5863 45.2261 87.2268 45.2261C86.9833 45.2261 86.7977 45.2957 86.6122 45.4116C86.5658 44.8666 86.102 44.4607 85.5569 44.4607C85.267 44.4607 85.0003 44.5767 84.8148 44.7507C84.6872 44.2984 84.2698 43.9505 83.7595 43.9505C83.5624 43.9505 83.3421 44.0201 83.1797 44.1245L83.1913 44.0201C83.1913 43.4171 82.7043 42.93 82.1013 42.93C81.823 42.93 81.5678 43.0228 81.3823 43.1852C81.3011 42.6865 80.8837 42.3386 80.3618 42.2807L80.3734 42.2111C80.3734 41.6081 79.8748 41.1326 79.295 41.1326L79.0515 41.1558C79.0862 41.0631 79.0862 40.9587 79.0862 40.8543C79.0862 40.2397 78.6224 39.7527 78.0078 39.7527C77.4976 39.7527 77.4396 39.8918 77.4396 39.4396C77.4396 38.825 76.9525 38.3611 76.3611 38.3611C76.2336 38.3611 76.1408 38.3843 76.048 38.4075C76.1292 38.2568 76.1756 38.0828 76.1756 37.9089C76.1756 37.3059 75.6886 36.8304 75.0971 36.8304C74.958 36.8304 74.8072 36.842 74.6913 36.9C74.7377 36.7956 74.7609 36.6449 74.7609 36.5057C74.7609 35.9027 74.2738 35.3925 73.6824 35.3925L73.6128 35.4157V35.207C73.6128 34.604 73.1258 34.0937 72.546 34.0937H72.5112C72.5344 34.0357 72.5576 33.9546 72.5576 33.8502C72.5576 33.2588 72.0589 32.737 71.4559 32.737C71.2008 32.737 70.9573 32.8645 70.7718 33.0153C70.6326 32.563 70.2267 32.2499 69.7513 32.2499C69.5426 32.2499 69.357 32.3195 69.1947 32.3891C69.0555 32.3195 68.87 32.2499 68.6729 32.2499C68.4989 31.8673 68.1394 31.6121 67.6872 31.6121C67.2581 31.6121 66.8522 31.8788 66.6899 32.2847H66.6783C66.8059 32.0876 66.8522 31.8788 66.8522 31.6585C66.8522 31.0555 66.3768 30.5685 65.7738 30.5685C65.6346 30.5685 65.4723 30.6265 65.3447 30.696C65.1708 30.325 64.7997 30.0582 64.3822 30.0582C64.0807 30.0582 63.8024 30.1858 63.6053 30.4061C63.6517 30.2786 63.6749 30.151 63.6749 30.0003C63.6749 29.3857 63.1994 28.8986 62.5848 28.8986C62.2717 28.8986 61.9818 29.0726 61.7963 29.2929L61.7383 29.2581C61.8311 29.0842 61.8891 28.8986 61.8891 28.7015C61.8891 28.0985 61.402 27.6114 60.8106 27.6114C60.6831 27.6114 60.5787 27.6346 60.4511 27.6694L60.4859 27.4143C60.4859 26.8113 59.9989 26.3127 59.4075 26.3127L59.3495 26.3243L59.3263 26.2431C59.3263 25.8372 59.1176 25.4893 58.7697 25.3038C58.8045 25.211 58.8393 25.0835 58.8393 24.9675C58.8393 24.3645 58.3522 23.8891 57.7492 23.8891C57.3433 23.8891 56.9723 24.1326 56.7983 24.4689C56.6012 24.1326 56.2533 23.8891 55.8358 23.8891C55.6271 23.8891 55.4068 23.9354 55.256 24.0514C55.1864 23.518 54.7458 23.1121 54.1892 23.1121C53.8645 23.1121 53.563 23.2629 53.3426 23.5064C53.3195 23.0077 52.9484 22.5787 52.4497 22.4743C52.4381 21.9061 51.9511 21.4423 51.3713 21.4423C51.2321 21.4423 51.0698 21.4886 50.9306 21.5466V21.5002C50.9306 20.8972 50.4436 20.4218 49.8406 20.4218C49.6898 20.4218 49.5739 20.4334 49.4695 20.4914L49.4811 20.3174C49.4811 19.7028 48.9941 19.2158 48.4027 19.2158C48.1939 19.2158 48.0432 19.2622 47.8924 19.3433C47.7533 18.8911 47.3474 18.5896 46.8604 18.5896C46.5009 18.5896 46.1994 18.7635 45.9906 19.007C45.9559 18.462 45.492 18.0098 44.9122 18.0098L44.7383 18.0214C44.6223 17.5227 44.1932 17.1516 43.6598 17.1516C43.3235 17.1516 42.9988 17.3256 42.8133 17.6039C42.8249 17.5227 42.8365 17.4416 42.8365 17.3372C42.8365 16.7226 42.361 16.2355 41.758 16.2355C41.6305 16.2355 41.4913 16.2819 41.3638 16.3283C41.4101 16.224 41.4217 16.1196 41.4217 16.0036C41.4217 15.4006 40.9347 14.902 40.3317 14.902L40.1809 14.9136L40.2157 14.7048C40.2157 14.2758 39.949 13.8815 39.5547 13.7076C39.5084 13.151 39.0445 12.7219 38.4763 12.7219C38.0356 12.7219 37.6414 12.9886 37.4906 13.3829C37.3051 13.1857 37.0268 13.0698 36.7253 13.0698C36.1339 13.0698 35.6352 13.5684 35.6352 14.1714C35.6352 14.4961 35.7744 14.7744 35.9947 14.9716C35.8324 15.1571 35.728 15.389 35.728 15.6789C35.728 16.2819 36.215 16.769 36.8064 16.769C36.9456 16.769 37.05 16.7342 37.1775 16.6878L37.2007 16.8617C36.7137 16.9777 36.3658 17.4068 36.3658 17.9054C36.3658 18.5084 36.8644 18.9954 37.4558 18.9954C38.0588 18.9954 38.5459 18.52 38.5459 17.9054L38.5227 17.7199C38.6618 17.6735 38.7894 17.6387 38.917 17.5227C38.9633 18.0909 39.4272 18.52 39.9838 18.52C40.3781 18.52 40.7144 18.3229 40.9115 18.0098C41.097 18.2649 41.4101 18.4156 41.7464 18.4156C42.0943 18.4156 42.4074 18.2533 42.6045 17.975L42.5814 18.2533C42.5814 18.8447 43.0568 19.3433 43.6598 19.3433L43.8453 19.3317C43.9381 19.7956 44.344 20.1319 44.8194 20.1899L44.7035 20.3174C44.1584 20.3638 43.7178 20.8045 43.7178 21.3843C43.7178 21.9409 44.1584 22.4163 44.7035 22.4627L44.6687 22.7294C44.6687 23.3208 45.1673 23.8195 45.7471 23.8195C46.1414 23.8195 46.4777 23.6223 46.6632 23.3092C46.7212 23.8659 47.1735 24.3065 47.7417 24.3065C48.2287 24.3065 48.623 23.9934 48.7737 23.5528L49.0057 23.7151L48.9593 23.9818C48.9593 24.5964 49.4347 25.0603 50.0493 25.0603C50.3276 25.0603 50.5943 24.9559 50.7915 24.782H50.919C51.0118 24.782 51.1046 24.782 51.2089 24.7356C51.3249 25.2226 51.754 25.5589 52.2642 25.5589C52.7512 25.5589 53.1455 25.2342 53.2731 24.7936C53.4818 25.1067 53.8297 25.3154 54.2124 25.3154C54.4211 25.3154 54.6298 25.2342 54.7806 25.1183C54.8038 25.3038 54.8733 25.4545 54.9545 25.5705C54.8386 25.5125 54.6994 25.4893 54.5603 25.4893C54.0268 25.4893 53.5862 25.872 53.4818 26.3822C52.9832 26.475 52.6121 26.9273 52.6121 27.4491C52.6121 28.0405 53.0991 28.5623 53.7021 28.5623L53.9225 28.5275C53.8529 28.6783 53.8297 28.7943 53.8297 28.9682C53.8297 29.5828 54.3167 30.0466 54.9081 30.0466C55.1633 30.0466 55.4068 29.9539 55.5923 29.8147L55.5691 29.8727C55.5691 30.4641 56.0678 30.9512 56.6708 30.9512C56.8331 30.9512 56.9839 30.9048 57.123 30.8584L57.1114 30.9396C57.1114 31.0439 57.1462 31.1599 57.181 31.2874C57.0766 31.2526 56.9607 31.2063 56.8331 31.2063C56.2301 31.2063 55.7547 31.7049 55.7547 32.3195C55.7547 32.9109 56.2417 33.398 56.8331 33.398C57.4245 33.398 57.9232 32.9109 57.9232 32.3195C57.9232 32.1803 57.8884 32.076 57.8536 31.9484C57.9579 32.0064 58.0739 32.018 58.1899 32.018C58.5493 32.018 58.8856 31.8441 59.0828 31.5426C59.1524 31.7513 59.2799 31.96 59.477 32.0876C59.3611 32.2383 59.3147 32.4471 59.3147 32.6558C59.3147 33.2588 59.8017 33.7458 60.3931 33.7458C60.857 33.7458 61.2513 33.4559 61.402 33.0385C61.5528 33.1196 61.7267 33.166 61.9238 33.166C62.2601 33.166 62.5616 33.0037 62.7704 32.7602L62.7472 32.8529C62.7472 33.4559 63.2458 33.943 63.8372 33.943C64.0692 33.943 64.2779 33.885 64.4634 33.7458C64.6606 33.9778 64.9505 34.1285 65.2752 34.1285C65.4259 34.1285 65.5767 34.0821 65.6926 34.0357C65.9014 34.2793 66.1913 34.4184 66.5275 34.4184C66.9682 34.4184 67.3625 34.1633 67.5248 33.7574L67.7104 33.769C67.8727 34.1517 68.2438 34.4068 68.696 34.4068C68.8932 34.4068 69.0787 34.3488 69.2295 34.2445C69.3454 34.3141 69.4498 34.372 69.5774 34.3836C69.5542 34.4764 69.5426 34.5692 69.5426 34.6619L69.299 34.6387C68.754 34.6387 68.3018 35.0446 68.2206 35.578L68.0003 35.5548C67.3973 35.5548 66.9102 36.0303 66.9102 36.6333C66.9102 36.8072 66.945 36.9696 67.0262 37.0971C66.829 36.8768 66.5159 36.7145 66.2028 36.7145C65.5998 36.7145 65.1128 37.2015 65.1128 37.8045C65.1128 38.4191 65.5998 38.8946 66.2028 38.8946C66.4464 38.8946 66.6899 38.8018 66.8754 38.6394C66.9102 38.8946 66.9914 39.1149 67.1769 39.2772C66.7827 39.4396 66.5044 39.8223 66.5044 40.2861C66.5044 40.8891 66.9914 41.3877 67.5828 41.3877C67.7452 41.3877 67.9075 41.3414 68.0582 41.2834C67.9655 41.4341 67.9191 41.6197 67.9191 41.7936C67.9191 42.3966 68.4061 42.8953 68.9975 42.8953C69.1367 42.8953 69.2643 42.8373 69.3802 42.8257C69.4846 43.3359 69.9136 43.707 70.4587 43.707C70.621 43.707 70.795 43.6722 70.9457 43.6026C70.9457 44.0317 71.1892 44.4144 71.5719 44.5767L71.5487 44.7854C71.5487 45.3884 72.0358 45.8755 72.6388 45.8755C73.0098 45.8755 73.3345 45.6899 73.5433 45.4C73.7056 45.516 73.8564 45.4116 74.0767 45.4116C74.297 45.4116 74.3898 45.3884 74.5637 45.2725L74.6449 45.6436L74.5637 45.6204C73.9607 45.6204 73.4737 46.0958 73.4737 46.6988C73.4737 47.3018 73.9607 47.812 74.5637 47.812C75.0856 47.812 75.5146 47.4294 75.6306 46.9307L75.7118 46.9423C76.3032 46.9423 76.7902 46.4553 76.7902 45.8291L76.7554 45.574L77.1265 45.6088C77.0917 45.7131 76.9757 45.8755 76.9757 45.9914C76.9757 46.606 77.312 47.0467 77.8918 47.0467C78.3789 46.9887 78.7963 46.664 78.9239 46.2234Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M123.802 59.9881C123.802 59.3851 123.303 58.8864 122.7 58.8864C122.109 58.8864 121.633 59.3851 121.633 59.9881C121.633 60.5911 122.109 61.0665 122.7 61.0665C123.303 61.0665 123.802 60.6027 123.802 59.9881Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M127.246 59.0836C127.246 58.4922 126.759 58.0051 126.144 58.0051C125.564 58.0051 125.077 58.4922 125.077 59.0836C125.077 59.6982 125.564 60.1852 126.144 60.1852C126.759 60.1852 127.246 59.6982 127.246 59.0836Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M53.389 30.209C53.389 29.5944 52.902 29.1074 52.3106 29.1074C51.7192 29.1074 51.2437 29.5944 51.2437 30.209C51.2437 30.8004 51.7308 31.2874 52.3106 31.2874C52.902 31.2874 53.389 30.7888 53.389 30.209Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M48.8201 26.046C48.8201 25.443 48.3447 24.9675 47.7533 24.9675C47.1503 24.9675 46.6516 25.4546 46.6516 26.046C46.6516 26.6606 47.1387 27.136 47.7533 27.136C48.3447 27.136 48.8201 26.649 48.8201 26.046Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M43.2887 22.5671C43.2887 21.9525 42.8017 21.4539 42.2103 21.4539C41.6189 21.4539 41.1202 21.9409 41.1202 22.5671C41.1202 23.1585 41.6189 23.6455 42.2103 23.6455C42.7901 23.6455 43.2887 23.1585 43.2887 22.5671Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M34.1741 16.4559C34.7655 16.4559 35.2525 15.9688 35.2525 15.3542C35.2525 14.7512 34.7655 14.2758 34.1741 14.2758C33.5711 14.2758 33.0724 14.7512 33.0724 15.3542C33.0724 15.9688 33.5595 16.4559 34.1741 16.4559Z",
            fill: "#FFB902"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M71.9778 124.266C69.0787 124.266 67.1305 126.04 67.1305 128.696C67.1305 130.992 68.6497 132.059 70.9341 132.963C73.1142 133.821 74.4362 134.482 74.4362 136.477C74.4362 138.564 72.9982 139.863 70.6906 139.863C68.0582 139.863 66.7247 138.471 66.7247 135.735V135.41H65.3911V135.955C65.3911 139.26 67.2697 141.162 70.563 141.162C73.81 141.162 75.8161 139.364 75.8161 136.477C75.8161 134.447 74.7841 133.137 72.3604 132.105L71.7922 131.861C69.8093 131.027 68.5105 130.482 68.5105 128.649C68.5105 126.748 69.8673 125.565 72.0473 125.565C74.3434 125.565 75.6074 126.794 75.6074 129.044V129.519H76.6394L76.9641 129.461V129.136C76.9525 126.075 75.0972 124.266 71.9778 124.266Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M87.3196 128.73C85.9396 128.73 84.7336 129.218 83.7363 130.18L84.9191 124.591H83.5972L80.1647 140.814H81.4867L82.7275 134.9C83.4116 131.63 84.9539 129.971 87.308 129.971C88.7575 129.971 89.4881 130.644 89.4881 131.966C89.4881 132.244 89.4533 132.557 89.3837 132.917L87.7254 140.814H89.0474L90.5201 133.763L90.5433 133.636C90.6709 133.021 90.7868 132.43 90.7868 131.873C90.7868 129.902 89.4881 128.73 87.3196 128.73Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M97.3619 128.904L94.8455 140.814H96.1675L98.6955 128.904H97.3619Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M97.675 127.061H99.1477L99.6697 124.591H98.1968L97.675 127.061Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M107.892 128.754C107.103 128.754 106.384 129.055 105.793 129.612L105.943 128.904H104.61L102.105 140.802H103.404L104.842 134.042C105.375 131.502 106.488 130.052 107.868 130.052C108.089 130.052 108.355 130.11 108.692 130.192L109.005 130.273L109.306 128.997L109.005 128.916C108.587 128.812 108.239 128.754 107.892 128.754Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M117.98 129.948C120.613 129.948 121.169 132.024 121.169 133.763C121.169 133.81 121.169 133.868 121.169 133.914H113.864C114.536 131.49 116.113 129.948 117.98 129.948ZM118.108 128.684C114.745 128.684 112.205 131.885 112.205 136.117C112.205 139.132 113.933 141.08 116.624 141.08C118.954 141.08 120.949 139.538 121.842 137.045L121.993 136.616H120.578L120.497 136.825C119.754 138.703 118.259 139.828 116.508 139.828C114.745 139.828 113.551 138.379 113.551 136.222C113.551 136.024 113.551 135.677 113.585 135.155H122.41L122.433 134.853C122.48 134.227 122.48 133.856 122.48 133.728C122.48 130.574 120.845 128.684 118.108 128.684Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M15.6201 75.701L9.65967 88.8743L3.84994 75.701H0V92.0052H2.80629L2.69032 79.203L8.32609 92.0052H10.9816L16.7334 79.1798L16.6174 92.0052H19.4121V75.701H15.6201Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M38.4067 83.8531C38.4067 87.5639 36.2498 89.686 32.5042 89.686C28.7355 89.686 26.5786 87.5639 26.5786 83.8531C26.5786 80.1423 28.7355 78.0202 32.4926 78.0202C36.2382 78.0086 38.4067 80.1423 38.4067 83.8531ZM41.329 83.8531C41.329 78.6464 37.8617 75.2835 32.4926 75.2835C27.0308 75.2835 23.6331 78.5652 23.6331 83.8531C23.6331 89.0598 27.1004 92.4227 32.4694 92.4227C37.9313 92.4111 41.329 89.1294 41.329 83.8531Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M48.3679 78.2289H53.0064C56.1489 78.2289 57.065 78.7276 57.065 80.467C57.065 82.1369 56.0909 82.7051 53.2035 82.7051H48.3795V78.2289H48.3679ZM48.3679 85.2794H53.8877C55.975 85.2794 56.5316 85.7665 56.6939 87.761L56.8911 90.0803C56.9259 90.6949 56.9955 91.3211 57.1926 91.8081L57.2738 92.0052H60.6715L60.312 91.495C59.9177 90.95 59.8713 90.3354 59.8133 89.6164L59.6162 87.0769C59.5002 85.465 58.9784 84.5141 57.9 84.0618C59.2335 83.3313 59.8945 82.0673 59.8945 80.2931C59.8945 77.3244 57.8188 75.701 54.0616 75.701H45.55V92.0052H48.3679V85.2794Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M77.486 88.3988L68.1626 75.701H64.7069V92.0052H67.5016V79.3074L76.8018 92.0052H80.2575V75.701H77.486V88.3988Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M88.3516 75.701H85.5106V92.0052H88.3516V75.701Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M96.3878 79.3074L105.688 92.0052H109.144V75.701H106.372V88.3988L97.0488 75.701H93.5931V92.0052H96.3878V79.3074Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M121.714 92.4111C124.207 92.4111 126.19 91.5646 127.501 89.9527L127.663 92.0053H129.808V82.9602H122.19V85.6621H127.083C126.677 88.1089 124.613 89.6744 121.737 89.6744C118.363 89.6744 116.264 87.4363 116.264 83.8415C116.264 80.2467 118.386 78.0086 121.807 78.0086C124.474 78.0086 126.248 79.0871 126.805 81.0468L126.875 81.2788H129.716L129.681 80.9193C129.356 77.6491 126.121 75.2719 121.993 75.2719C116.705 75.2719 113.423 78.5536 113.423 83.8415C113.388 88.9786 116.739 92.4111 121.714 92.4111Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M141.393 92.0052V78.3797H147.319V75.701H132.649V78.3797H138.564V92.0052H141.393Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M158.509 89.686C154.74 89.686 152.583 87.5639 152.583 83.8531C152.583 80.1423 154.74 78.0202 158.497 78.0202C162.266 78.0202 164.423 80.1423 164.423 83.8531C164.412 87.5639 162.255 89.686 158.509 89.686ZM167.334 83.8531C167.334 78.6464 163.867 75.2835 158.497 75.2835C153.036 75.2835 149.638 78.5652 149.638 83.8531C149.638 89.0598 153.105 92.4227 158.474 92.4227C163.948 92.4111 167.334 89.1294 167.334 83.8531Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M184.345 75.701V88.3988L175.022 75.701H171.566V92.0052H174.361V79.3074L183.661 92.0052H187.117V75.701H184.345Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M28.434 104.796C28.434 106.605 27.4483 107.185 24.3637 107.185H20.5833V102.384H24.5028C27.4831 102.384 28.434 102.975 28.434 104.796ZM25.245 99.786H17.7422V116.091H20.5833V109.666H25.245C29.3037 109.666 31.275 108.054 31.275 104.726C31.275 101.398 29.3037 99.786 25.245 99.786Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M38.1052 109.11H47.6489V106.408H38.1052V102.43H48.2751V99.786H35.2641V116.091H48.4258V113.342H38.1052V109.11Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M65.5187 112.496L56.1953 99.786H52.728V116.091H55.5343V103.393L64.8345 116.091H68.2902V99.786H65.5187V112.496Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M76.3843 99.786H73.5433V116.091H76.3843V99.786Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M94.4048 112.496L85.0815 99.786H81.6258V116.091H84.4205V103.393L93.7207 116.091H97.1879V99.786H94.4048V112.496Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M110.965 106.709L107.532 106.037C105.642 105.666 105.039 105.225 105.039 104.228C105.039 102.43 107.08 102.059 108.784 102.059C111.324 102.059 112.507 102.871 112.646 104.692L112.669 104.993H115.487V104.668C115.441 101.259 113.121 99.3804 108.958 99.3804C104.575 99.3804 102.07 101.224 102.07 104.436C102.07 106.895 103.589 108.321 106.836 108.901L110.698 109.597C112.704 109.956 113.11 110.582 113.11 111.487C113.11 112.96 111.66 113.806 109.121 113.806C106.083 113.806 104.633 112.751 104.552 110.478L104.54 110.165H101.572L101.583 110.49C101.653 114.49 104.146 116.508 108.993 116.508C113.481 116.508 116.055 114.606 116.055 111.29C116.055 108.286 114.107 107.312 110.965 106.709Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M131.919 109.005C131.919 112.322 130.62 113.737 127.559 113.737C124.544 113.737 123.21 112.275 123.21 109.005V99.786H120.369V109.933C120.369 114.166 122.92 116.508 127.559 116.508C132.197 116.508 134.76 114.177 134.76 109.933V99.786H131.919V109.005Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M142.286 99.786H139.456V116.091H151.818V113.342H142.286V99.786Z",
            fill: "#182281"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M165.154 108.947H160.04L162.672 103.358L165.154 108.947ZM161.397 99.786L153.697 116.091H156.735L158.811 111.626H166.348L168.331 116.091H171.323L164.11 99.786H161.397Z",
            fill: "#182281"
          }
        )
      ]
    }
  );
}
function Per(e) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "82",
      height: "22",
      viewBox: "0 0 82 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ C("g", { clipPath: "url(#clip0_982_12)", children: [
          /* @__PURE__ */ l(
            "path",
            {
              d: "M7.63302 5.31663C7.92132 5.31663 8.15502 5.08292 8.15502 4.79463C8.15502 4.50634 7.92132 4.27263 7.63302 4.27263C7.34473 4.27263 7.11102 4.50634 7.11102 4.79463C7.11102 5.08292 7.34473 5.31663 7.63302 5.31663Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M7.63299 0C6.09197 0.00187383 4.61459 0.614874 3.52492 1.70454C2.43525 2.79421 1.82225 4.27159 1.82038 5.81261C1.81856 7.07197 2.22998 8.29715 2.99152 9.30018C2.99152 9.30018 3.15004 9.50864 3.17551 9.53887L7.63299 14.5648L12.0923 9.53659C12.1158 9.50843 12.2745 9.29997 12.2745 9.29997L12.2753 9.2987C13.0363 8.29605 13.4475 7.0714 13.4456 5.81261C13.4437 4.27159 12.8307 2.79421 11.7411 1.70454C10.6514 0.614874 9.17402 0.00187383 7.63299 0ZM7.63299 3.17052C7.94652 3.17052 8.25302 3.26349 8.51371 3.43768C8.77441 3.61187 8.97759 3.85945 9.09758 4.14912C9.21756 4.43879 9.24895 4.75753 9.18779 5.06504C9.12662 5.37255 8.97564 5.65502 8.75394 5.87672C8.53223 6.09842 8.24977 6.2494 7.94226 6.31057C7.63475 6.37174 7.31601 6.34034 7.02634 6.22036C6.73667 6.10038 6.48909 5.89719 6.3149 5.63649C6.14071 5.3758 6.04773 5.06931 6.04773 4.75577C6.04819 4.33548 6.21536 3.93253 6.51255 3.63534C6.80975 3.33814 7.2127 3.17098 7.63299 3.17052ZM9.74667 8.98313H8.68983V7.92629H6.57615V8.98313H5.51931V7.92629C5.51964 7.64609 5.63108 7.37747 5.82921 7.17935C6.02734 6.98122 6.29596 6.86977 6.57615 6.86945H8.68983C8.97002 6.86977 9.23865 6.98122 9.43677 7.17935C9.6349 7.37747 9.74635 7.64609 9.74667 7.92629V8.98313Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M1.52294 13.5965L3.7864 12.3947L2.69125 11.8508L0.256336 13.1713C0.0978611 13.2566 -0.000691396 13.4224 3.65235e-06 13.6023C0.00069873 13.7823 0.100528 13.9473 0.259658 14.0314L7.39761 17.8038C7.54122 17.8797 7.71321 17.879 7.85626 17.8021L14.8684 14.0297C15.0262 13.9448 15.1247 13.7801 15.1248 13.6009C15.125 13.4217 15.0268 13.2568 14.8691 13.1716L12.5084 11.8508L11.4315 12.447L13.6103 13.5996L7.62331 16.8205L1.52294 13.5965Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M1.51805 17.1073L2.27632 16.6897L1.19879 16.1181L0.254173 16.6859C0.0965182 16.7718 -0.00113655 16.9375 9.98623e-06 17.117C0.00115652 17.2965 0.100919 17.4609 0.259658 17.5448L7.39761 21.3172C7.54122 21.3931 7.71321 21.3924 7.85626 21.3155L14.8684 17.5431C15.0257 17.4585 15.1241 17.2945 15.1248 17.1159C15.1256 16.9372 15.0285 16.7725 14.8718 16.6865L13.9965 16.1573L12.9404 16.739L13.6164 17.1097L7.6233 20.3339L1.51805 17.1073Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M80.1641 16.5194C79.6219 16.5194 79.1195 16.4317 78.657 16.2563C78.2105 16.0649 77.8198 15.7938 77.4848 15.4429C77.1659 15.0921 76.9107 14.6774 76.7193 14.199C76.5439 13.7205 76.4562 13.1783 76.4562 12.5723V7.90753H74.7817V5.63495H75.4993C76.3765 5.63495 76.815 5.19639 76.815 4.31925V2.76433H79.2072V5.39573H81.5994V7.90753H79.2072V12.4527C79.2072 12.9311 79.3428 13.3139 79.6139 13.6009C79.901 13.8721 80.2837 14.0076 80.7621 14.0076C80.8897 14.0076 80.9934 14.0076 81.0731 14.0076C81.1529 13.9917 81.2246 13.9757 81.2884 13.9598C81.3522 13.9438 81.416 13.9199 81.4798 13.888V16.2802C81.3682 16.328 81.2406 16.3679 81.0971 16.3998C80.8259 16.4795 80.515 16.5194 80.1641 16.5194Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M68.5733 16.5194C67.8238 16.5194 67.1141 16.3758 66.4443 16.0888C65.7904 15.7857 65.2083 15.3791 64.698 14.8687C64.2036 14.3584 63.8049 13.7683 63.5019 13.0985C63.2148 12.4128 63.0713 11.6792 63.0713 10.8977C63.0713 10.1163 63.2148 9.39064 63.5019 8.72083C63.8049 8.03507 64.2036 7.43702 64.698 6.92669C65.2083 6.41635 65.7904 6.01766 66.4443 5.73059C67.1141 5.42758 67.8238 5.27608 68.5733 5.27608C69.3229 5.27608 70.0246 5.42758 70.6784 5.73059C71.3483 6.01766 71.9304 6.41635 72.4247 6.92669C72.9351 7.43702 73.3338 8.03507 73.6208 8.72083C73.9238 9.39064 74.0753 10.1163 74.0753 10.8977C74.0753 11.6792 73.9238 12.4128 73.6208 13.0985C73.3338 13.7683 72.9351 14.3584 72.4247 14.8687C71.9304 15.3791 71.3483 15.7857 70.6784 16.0888C70.0246 16.3758 69.3229 16.5194 68.5733 16.5194ZM68.5733 13.8879C69.3548 13.8879 70.0086 13.6168 70.5349 13.0746C71.0612 12.5324 71.3243 11.8067 71.3243 10.8977C71.3243 9.98869 71.0612 9.26306 70.5349 8.72083C70.0086 8.1786 69.3548 7.90748 68.5733 7.90748C67.7919 7.90748 67.138 8.1786 66.6117 8.72083C66.0854 9.26306 65.8223 9.98869 65.8223 10.8977C65.8223 11.8067 66.0854 12.5324 66.6117 13.0746C67.138 13.6168 67.7919 13.8879 68.5733 13.8879Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M54.5894 1.32898H57.46V13.6487H61.6473C61.6473 13.6487 62.5017 15.5454 63.6408 16.3998C63.356 16.3998 54.5894 16.3998 54.5894 16.3998V1.32898Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M45.1468 20.347C45.0192 20.347 44.8916 20.339 44.764 20.323C44.6524 20.323 44.5567 20.3151 44.477 20.2991C44.3653 20.2832 44.2696 20.2593 44.1899 20.2274V17.9548C44.7959 17.9548 45.2584 17.8192 45.5774 17.5481C45.9123 17.277 46.1674 16.9341 46.3429 16.5195L46.5821 15.9214L42.3958 5.3958H45.2664L48.0174 12.5724L50.5292 5.3958H53.3998C52.6184 7.40523 51.9087 9.2233 51.2708 10.85C50.9997 11.5517 50.7285 12.2375 50.4574 12.9073C50.2023 13.5771 49.971 14.1911 49.7637 14.7492C49.5564 15.2915 49.3809 15.746 49.2374 16.1128C49.0939 16.4796 49.0062 16.6949 48.9743 16.7587C48.7032 17.4126 48.432 17.9628 48.1609 18.4093C47.9058 18.8718 47.6267 19.2466 47.3237 19.5336C47.0206 19.8207 46.6937 20.028 46.3429 20.1556C45.992 20.2832 45.5933 20.347 45.1468 20.347Z",
              fill: "#0157FF"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              d: "M26.1289 5.39569H28.1623L28.6407 6.47217C28.864 6.2489 29.1112 6.04955 29.3823 5.87412C29.6056 5.73059 29.8767 5.59504 30.1956 5.46745C30.5146 5.33987 30.8734 5.27608 31.2721 5.27608C31.8303 5.27608 32.3087 5.35582 32.7074 5.5153C33.1061 5.65883 33.4331 5.81831 33.6882 5.99373C33.9753 6.20106 34.2065 6.44028 34.382 6.71139C34.6371 6.44028 34.9322 6.20106 35.2671 5.99373C35.5541 5.81831 35.897 5.65883 36.2957 5.5153C36.6944 5.35582 37.133 5.27608 37.6114 5.27608C38.8075 5.27608 39.7644 5.65883 40.482 6.42433C41.1997 7.18983 41.5585 8.32213 41.5585 9.82123V16.3997H38.8075V10.0605C38.8075 9.39064 38.6241 8.86436 38.2573 8.48161C37.9064 8.09886 37.4918 7.90748 37.0134 7.90748C36.5349 7.90748 36.1123 8.09886 35.7455 8.48161C35.3946 8.86436 35.2192 9.39064 35.2192 10.0605V16.3997H32.4682V10.0605C32.4682 9.39064 32.2848 8.86436 31.918 8.48161C31.5671 8.09886 31.1525 7.90748 30.6741 7.90748C30.1956 7.90748 29.773 8.09886 29.4062 8.48161C29.0553 8.86436 28.8799 9.39064 28.8799 10.0605V16.3997H26.1289V5.39569Z",
              fill: "#0157FF"
            }
          )
        ] }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_982_12", children: /* @__PURE__ */ l("rect", { width: "81.5994", height: "21.3736", fill: "white" }) }) })
      ]
    }
  );
}
function Ser(e) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "153",
      height: "41",
      viewBox: "0 0 153 41",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ l(
          "path",
          {
            d: "M32.1542 22.2731C31.2427 25.0948 27.5786 34.3816 26.0593 33.7565C23.7714 32.8279 23.1637 11.1289 24.54 1.64571C24.7902 0.0562428 24.8617 -0.908154 24.1647 1.48498C19.0349 19.237 21.984 37.2748 25.6839 38.2928C28.1684 38.9714 30.9746 32.0421 32.5475 23.1125C33.0658 20.7908 32.7262 20.0407 32.1542 22.2552V22.2731Z",
            fill: "url(#paint0_radial_16047_22228)"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M17.6235 16.8249C15.8004 12.1279 12.9227 13.5209 12.8333 16.7356C12.6546 22.5756 15.0318 30.1479 9.18708 20.0395C3.05636 9.43118 1.75158 7.43095 0.857885 5.89506C-0.0358053 4.37703 -0.19667 4.41275 0.518283 6.14509C9.91991 28.5405 11.5464 30.1479 13.8343 30.0943C14.871 30.0764 15.7289 28.987 15.5859 26.2903C15.4429 23.5935 15.3893 21.504 15.2642 20.2539C15.1391 19.0037 15.7825 18.7358 16.4081 20.5932C17.0337 22.4505 18.6066 25.433 20.7336 36.8093C20.9838 37.5951 21.1268 37.5416 21.0374 36.2736C20.948 34.9877 20.6442 23.9686 17.6414 16.8428L17.6235 16.8249Z",
            fill: "url(#paint1_radial_16047_22228)"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M32.1553 38.1496C32.7273 33.2383 37.7319 26.3625 40.985 22.5228C41.6642 21.7192 41.8787 21.2905 40.7169 22.2371C33.621 27.827 28.8665 36.5959 29.8853 39.3462C30.3501 40.632 31.9587 39.7569 32.1553 38.1496Z",
            fill: "url(#paint2_radial_16047_22228)"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M129.243 23.7546C129.243 24.469 129.136 25.1298 128.922 25.737C128.707 26.3263 128.403 26.8442 128.01 27.2729C127.617 27.7015 127.134 28.0229 126.58 28.2551C126.026 28.4873 125.4 28.6123 124.721 28.6123C124.042 28.6123 123.434 28.4873 122.88 28.2551C122.326 28.0229 121.844 27.7015 121.45 27.2729C121.057 26.8442 120.753 26.3442 120.521 25.737C120.306 25.1476 120.199 24.4868 120.199 23.7546C120.199 23.0224 120.306 22.3794 120.539 21.7901C120.771 21.2007 121.075 20.6828 121.486 20.2721C121.897 19.8613 122.362 19.522 122.916 19.2898C123.47 19.0576 124.078 18.9326 124.721 18.9326C125.365 18.9326 125.99 19.0576 126.544 19.2898C127.099 19.522 127.563 19.8434 127.974 20.2721C128.368 20.6828 128.671 21.2007 128.904 21.7901C129.118 22.3794 129.243 23.0402 129.243 23.7546ZM126.598 23.7546C126.598 22.9509 126.437 22.3259 126.115 21.8615C125.794 21.3972 125.347 21.165 124.739 21.165C124.131 21.165 123.685 21.3972 123.363 21.8615C123.041 22.3259 122.88 22.9509 122.88 23.7546C122.88 24.5583 123.041 25.2012 123.363 25.6655C123.685 26.1299 124.149 26.362 124.739 26.362C125.329 26.362 125.794 26.1299 126.115 25.6655C126.437 25.2012 126.598 24.5583 126.598 23.7546Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M133.766 18.9326C134.535 18.9326 135.178 19.0219 135.696 19.2005C136.215 19.3791 136.626 19.6291 136.93 19.9506C137.233 20.2721 137.466 20.6828 137.591 21.1472C137.716 21.6115 137.788 22.1294 137.788 22.7009V28.1301C137.412 28.2194 136.894 28.3087 136.233 28.4158C135.571 28.523 134.767 28.5766 133.82 28.5766C133.23 28.5766 132.676 28.523 132.193 28.4158C131.71 28.3087 131.281 28.1301 130.942 27.8979C130.584 27.6658 130.316 27.3443 130.138 26.9693C129.959 26.5764 129.852 26.112 129.852 25.5584C129.852 25.0047 129.959 24.5761 130.173 24.2011C130.388 23.826 130.674 23.5224 131.049 23.3081C131.407 23.0938 131.818 22.9331 132.3 22.8259C132.765 22.7188 133.248 22.683 133.748 22.683C134.088 22.683 134.392 22.683 134.66 22.7188C134.928 22.7545 135.142 22.7902 135.303 22.8259V22.5759C135.303 22.1294 135.16 21.7722 134.892 21.5043C134.624 21.2365 134.159 21.0936 133.498 21.0936C133.051 21.0936 132.64 21.1472 132.318 21.2722L130.727 19.3612C130.87 19.3077 131.067 19.2719 131.299 19.2184C131.532 19.1648 131.782 19.1112 132.05 19.0755C132.318 19.0398 132.604 19.0041 132.908 18.9683C133.212 18.9326 133.498 18.9326 133.82 18.9326H133.766ZM133.98 26.5764C134.231 26.5764 134.481 26.5764 134.713 26.5585C134.946 26.5585 135.142 26.5228 135.267 26.5049V24.5225C135.16 24.5047 134.999 24.469 134.785 24.4511C134.57 24.4332 134.392 24.4154 134.213 24.4154C133.963 24.4154 133.73 24.4154 133.516 24.4511C133.301 24.4868 133.105 24.5404 132.944 24.6118C132.783 24.7011 132.658 24.8083 132.551 24.9512C132.461 25.094 132.408 25.2726 132.408 25.4691C132.408 25.8798 132.551 26.1656 132.819 26.3085C133.087 26.4692 133.462 26.5406 133.945 26.5406L133.98 26.5764Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M144.652 21.4876L148.62 16.7549V19.0766H151.301V21.4697H148.62V24.6486C148.62 25.1844 148.71 25.613 148.906 25.9345C149.103 26.256 149.478 26.4167 150.05 26.4167C150.318 26.4167 150.604 26.3631 150.604 26.3631L152.07 28.1133C151.766 28.2383 151.409 28.3455 151.033 28.4348C150.658 28.5241 150.193 28.5777 149.639 28.5777C148.942 28.5777 148.352 28.4884 147.905 28.2919C147.441 28.0955 147.083 27.8454 146.797 27.5061C146.511 27.1668 146.332 26.756 146.225 26.2738C146.118 25.7916 146.064 25.2559 146.064 24.6844V21.4697H144.67L144.652 21.4876Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M119.164 25.7366C118.986 25.8259 118.771 25.8973 118.521 25.9509C118.271 26.0224 118.003 26.0759 117.681 26.1116C117.359 26.1652 117.02 26.1831 116.626 26.1831C116.001 26.1831 115.465 26.0759 115.018 25.8795C114.571 25.683 114.213 25.3973 113.945 25.058C113.677 24.7186 113.481 24.29 113.355 23.8078C113.23 23.3256 113.177 22.8077 113.177 22.2541C113.177 21.5576 113.266 20.9682 113.463 20.486C113.641 20.0038 113.892 19.593 114.195 19.2894C114.499 18.9858 114.857 18.7537 115.268 18.6286C115.661 18.4858 116.036 18.4143 116.519 18.4143C117.145 18.4143 117.592 18.4679 118.181 18.6286C118.503 18.7179 118.789 18.8251 119.057 18.9323C119.343 18.6108 120.576 17.1463 120.576 17.1463C120.398 17.0392 120.183 16.8784 119.826 16.7177C119.611 16.6106 119.361 16.5213 119.039 16.4141C118.718 16.3069 118.36 16.2355 117.949 16.1462C117.538 16.0569 117.073 16.0391 116.555 16.0391C115.679 16.0391 114.857 16.1819 114.106 16.4498C113.355 16.7356 112.694 17.1463 112.158 17.6821C111.604 18.2179 111.175 18.8787 110.871 19.6645C110.549 20.4503 110.406 21.3432 110.406 22.3434C110.406 24.3436 110.925 25.8973 111.943 26.9867C112.98 28.0762 114.464 28.6298 116.43 28.6298C117.341 28.6298 118.163 28.5405 118.861 28.344C119.558 28.1655 120.094 27.9511 120.487 27.719L119.433 25.683C119.433 25.683 119.29 25.7366 119.218 25.7723L119.164 25.7366Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M141.506 26.4692C141.988 26.4692 142.328 26.4156 142.525 26.3263C142.721 26.237 142.828 26.0584 142.828 25.7905C142.828 25.5762 142.703 25.3976 142.435 25.2369C142.185 25.0762 141.792 24.8976 141.273 24.7011C140.862 24.5583 140.505 24.3975 140.165 24.2368C139.843 24.0761 139.558 23.8796 139.325 23.6474C139.093 23.4153 138.914 23.1474 138.789 22.8438C138.664 22.5223 138.592 22.1473 138.592 21.7187C138.592 20.8614 138.914 20.1828 139.558 19.6827C140.201 19.1826 141.077 18.9326 142.185 18.9326C142.739 18.9326 143.275 18.9862 143.794 19.0755C144.312 19.1648 144.705 19.2898 145.009 19.397L143.526 21.165C143.043 21.04 142.811 21.0221 142.364 21.0221C141.542 21.0221 141.148 21.2543 141.148 21.7008C141.148 21.8079 141.148 21.8972 141.202 21.9865C141.238 22.0758 141.309 22.1473 141.416 22.2187C141.524 22.2901 141.667 22.3794 141.845 22.4687C142.024 22.558 142.256 22.6473 142.525 22.7545C143.097 22.9688 143.561 23.1652 143.937 23.3796C144.312 23.576 144.598 23.8082 144.812 24.0403C145.027 24.2725 145.17 24.5404 145.259 24.8262C145.349 25.1119 145.384 25.4512 145.384 25.8263C145.384 26.7371 145.045 27.4157 144.366 27.8801C143.686 28.3444 142.721 28.5766 141.488 28.5766C140.666 28.5766 140.004 28.5051 139.45 28.3623C138.914 28.2194 138.539 28.1122 138.324 28.0051L139.808 26.237C140.451 26.4156 141.041 26.4513 141.506 26.4513V26.4692Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M86.5078 15.9316V18.5212H89.0995L86.5078 15.9316Z",
            fill: "#006DA4"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M48.5248 18.6835C48.0422 18.4692 47.2379 18.3263 46.666 18.3263C46.0225 18.3263 45.5399 18.4156 45.2718 18.5942C44.9858 18.7728 44.8428 19.0407 44.8428 19.4157C44.8428 19.63 44.8964 19.8265 45.0037 19.9693C45.1109 20.1122 45.2539 20.2551 45.4505 20.3801C45.6471 20.5051 45.8616 20.6123 46.1119 20.7194C46.3621 20.8266 46.6302 20.9159 46.9341 21.023C47.5596 21.2552 48.1137 21.4874 48.5784 21.7195C49.0432 21.9517 49.4364 22.2017 49.7402 22.5054C50.0441 22.809 50.2765 23.1661 50.4195 23.559C50.5624 23.9698 50.6518 24.452 50.6518 25.0414C50.6518 26.1665 50.2586 27.0416 49.4721 27.6488C48.6857 28.2739 47.4881 28.5775 45.8974 28.5775C45.3612 28.5775 44.8786 28.5418 44.4496 28.4882C44.0206 28.4167 43.6453 28.3453 43.3057 28.256C42.9839 28.1667 42.698 28.0596 42.4477 27.9524C42.2154 27.8453 42.1081 27.8095 41.9473 27.7202L43.4844 25.8807C43.4844 25.8807 43.6274 25.9343 43.9313 26.0415C44.4675 26.2022 45.1109 26.2736 45.8795 26.2736C46.2549 26.2736 46.5766 26.2379 46.8268 26.1843C47.077 26.1129 47.2737 26.0415 47.4345 25.9165C47.5775 25.8093 47.6848 25.6843 47.7384 25.5236C47.792 25.3807 47.8278 25.2021 47.8278 25.0235C47.8278 24.6306 47.649 24.3091 47.2737 24.0412C46.8983 23.7734 46.2549 23.5055 45.3612 23.2019C44.9679 23.059 44.5747 22.8983 44.1815 22.7197C43.7883 22.5411 43.4308 22.3089 43.1269 22.041C42.8052 21.7731 42.555 21.4338 42.3584 21.0409C42.1618 20.648 42.0545 20.1837 42.0545 19.63C42.0545 19.0764 42.1618 18.5763 42.3584 18.1298C42.5728 17.6834 42.8588 17.3083 43.2521 16.9869C43.6274 16.6833 44.0921 16.4332 44.6462 16.2725C45.2003 16.1118 45.808 16.0225 46.4872 16.0225C47.3094 16.0225 48.0065 16.1118 48.5963 16.2903C49.1862 16.4689 49.6688 16.6475 50.062 16.8618L48.5248 18.7013V18.6835Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M72.7089 26.4692C73.1915 26.4692 73.5132 26.4156 73.7098 26.3263C73.9064 26.237 74.0137 26.0584 74.0137 25.7905C74.0137 25.5762 73.8886 25.3976 73.6383 25.2369C73.3881 25.0762 72.9949 24.8976 72.4765 24.7011C72.0654 24.5583 71.7079 24.3975 71.3683 24.2368C71.0287 24.0761 70.7606 23.8796 70.5283 23.6474C70.2959 23.4153 70.1172 23.1474 69.9921 22.8438C69.8669 22.5223 69.7955 22.1473 69.7955 21.7187C69.7955 20.8614 70.1172 20.1828 70.7606 19.6827C71.4041 19.1826 72.2799 18.9326 73.3881 18.9326C73.9422 18.9326 74.4784 18.9862 74.9967 19.0755C75.5151 19.1648 75.9083 19.2898 76.2121 19.397L74.7286 21.165C74.246 21.04 74.0137 21.0221 73.5668 21.0221C72.7625 21.0221 72.3514 21.2543 72.3514 21.7008C72.3514 21.8079 72.3514 21.8972 72.405 21.9865C72.4408 22.0758 72.5123 22.1473 72.6195 22.2187C72.7268 22.2901 72.8697 22.3794 73.0485 22.4687C73.2272 22.558 73.4596 22.6473 73.7277 22.7545C74.2996 22.9688 74.7644 23.1652 75.1397 23.3796C75.5151 23.576 75.8011 23.8082 76.0155 24.0403C76.23 24.2725 76.3909 24.5404 76.4624 24.8262C76.5518 25.1119 76.5875 25.4512 76.5875 25.8263C76.5875 26.7371 76.2479 27.4157 75.5687 27.8801C74.8895 28.3444 73.9243 28.5766 72.691 28.5766C71.8688 28.5766 71.2075 28.5051 70.6534 28.3623C70.1172 28.2194 69.7418 28.1122 69.5273 28.0051L71.0109 26.237C71.6543 26.4156 72.2442 26.4513 72.7089 26.4513V26.4692Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M77.4277 28.3438V15.9316H80.0194V19.2356C80.1982 19.182 80.4127 19.1284 80.6986 19.0749C80.9668 19.0213 81.2349 19.0034 81.4851 19.0034C82.2358 19.0034 82.8435 19.1106 83.344 19.307C83.8444 19.5035 84.2377 19.7892 84.5236 20.1643C84.8096 20.5393 85.0241 20.9858 85.1492 21.4859C85.2743 22.0038 85.328 22.5574 85.328 23.1825V28.3438H82.7363V23.4861C82.7363 22.6467 82.629 22.0573 82.4145 21.718C82.2 21.3787 81.8068 21.2001 81.217 21.2001C80.9846 21.2001 80.7701 21.218 80.5735 21.2537C80.3769 21.2894 80.1803 21.343 80.0194 21.3787V28.3259H77.4277V28.3438Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M89.0995 28.3441H86.5078V19.2002H89.0995V28.3441Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M90.3496 19.5052C90.7965 19.3802 91.3684 19.2552 92.0655 19.148C92.7626 19.0409 93.4954 18.9873 94.264 18.9873C95.0325 18.9873 95.6939 19.0945 96.2122 19.2909C96.7306 19.4874 97.1417 19.7731 97.4455 20.1482C97.7494 20.5232 97.9638 20.9697 98.089 21.4697C98.2141 21.9877 98.2856 22.5413 98.2856 23.1664V28.3277H95.6939V23.47C95.6939 22.6306 95.5866 22.0412 95.3543 21.7019C95.1398 21.3626 94.7287 21.184 94.121 21.184C93.9422 21.184 93.7456 21.184 93.5311 21.2018C93.3167 21.2197 93.1379 21.2376 92.9771 21.2554V28.3098H90.3854V19.4695L90.3496 19.5052Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M60.7852 19.5052C61.232 19.3802 61.804 19.2552 62.501 19.148C63.1981 19.0409 63.9309 18.9873 64.6995 18.9873C65.4681 18.9873 66.1294 19.0945 66.6478 19.2909C67.1661 19.4874 67.5772 19.7731 67.8811 20.1482C68.1849 20.5232 68.3994 20.9697 68.5245 21.4697C68.6496 21.9877 68.7211 22.5413 68.7211 23.1664V28.3277H66.1294V23.47C66.1294 22.6306 66.0222 22.0412 65.8077 21.7019C65.5932 21.3626 65.1821 21.184 64.5744 21.184C64.3957 21.184 64.1991 21.184 63.9846 21.2018C63.7701 21.2197 63.5913 21.2376 63.4305 21.2554V28.3098H60.8388V19.4695L60.7852 19.5052Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M59.4806 28.0588C59.0338 28.1838 58.4797 28.3088 57.7826 28.416C57.0855 28.5231 56.3527 28.5767 55.5841 28.5767C54.8155 28.5767 54.1542 28.4695 53.6359 28.2731C53.1175 28.0766 52.7064 27.7909 52.4026 27.4158C52.0987 27.0408 51.8842 26.6122 51.7591 26.0943C51.634 25.5763 51.5625 25.0227 51.5625 24.3976V19.2363H54.1542V24.094C54.1542 24.9334 54.2614 25.5228 54.4759 25.8621C54.6904 26.2014 55.1015 26.38 55.7092 26.38C55.888 26.38 56.0846 26.38 56.2991 26.3443C56.5135 26.3443 56.6923 26.3086 56.8531 26.2907V19.2363H59.4449V28.0766L59.4806 28.0588Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M103.861 28.5766C104.165 28.5766 104.487 28.5766 104.791 28.523L107.132 25.737C106.685 25.9691 106.077 26.1299 105.613 26.2192C105.148 26.3085 104.683 26.3442 104.219 26.3442C103.468 26.3442 102.878 26.1834 102.449 25.8798C102.002 25.5584 101.752 25.1476 101.698 24.6118H107.579C107.579 24.469 107.597 24.3082 107.615 24.1296C107.615 23.9511 107.615 23.7903 107.615 23.6296C107.615 22.0937 107.239 20.915 106.489 20.1292C105.738 19.3434 104.701 18.9326 103.414 18.9326C102.86 18.9326 102.306 19.0398 101.788 19.2541C101.252 19.4684 100.787 19.772 100.394 20.1828C99.9825 20.5935 99.6607 21.0936 99.4105 21.7008C99.1603 22.308 99.0352 23.0224 99.0352 23.826C99.0352 24.5047 99.1245 25.1298 99.3211 25.7013C99.5177 26.2906 99.8037 26.7728 100.215 27.2014C100.608 27.63 101.126 27.9515 101.734 28.2015C102.342 28.4516 103.057 28.5587 103.879 28.5587L103.861 28.5766ZM101.841 22.2009C101.913 21.9865 102.02 21.7901 102.163 21.6294C102.306 21.4686 102.485 21.3436 102.681 21.2365C102.896 21.1472 103.146 21.0936 103.432 21.0936C103.718 21.0936 103.986 21.1472 104.183 21.2543C104.379 21.3615 104.558 21.4865 104.683 21.6472C104.808 21.8079 104.916 21.9865 104.987 22.2009C105.059 22.4152 105.094 22.6295 105.094 22.8438H101.663C101.698 22.6295 101.752 22.3973 101.823 22.183L101.841 22.2009Z",
            fill: "#343841"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M46.185 40.025C45.613 40.025 45.0768 39.9357 44.6121 39.7392C44.1473 39.5428 43.7363 39.2749 43.3966 38.9177C43.057 38.5605 42.7889 38.114 42.6102 37.5783C42.4315 37.0425 42.3242 36.4353 42.3242 35.7566C42.3242 35.078 42.4315 34.4708 42.6459 33.935C42.8604 33.3992 43.1285 32.9527 43.486 32.5956C43.8435 32.2384 44.2546 31.9526 44.7193 31.774C45.184 31.5776 45.7024 31.4883 46.2386 31.4883C46.5782 31.4883 46.882 31.5061 47.1501 31.5597C47.4183 31.6133 47.6506 31.6669 47.8651 31.7205C48.0617 31.7919 48.2226 31.8455 48.3477 31.9169C48.4728 31.9883 48.5622 32.0241 48.6158 32.0598L48.2762 33.0063C48.2762 33.0063 48.0975 32.917 47.9723 32.8456C47.8294 32.792 47.6864 32.7384 47.5076 32.6848C47.3468 32.6313 47.1501 32.5777 46.9535 32.542C46.7569 32.5063 46.5424 32.4884 46.3458 32.4884C45.9169 32.4884 45.5236 32.5598 45.184 32.7206C44.8444 32.8634 44.5406 33.0778 44.2903 33.3635C44.0401 33.6492 43.8614 33.9886 43.7363 34.3993C43.6111 34.8101 43.5396 35.2566 43.5396 35.7566C43.5396 36.2567 43.5933 36.6853 43.7184 37.0961C43.8256 37.489 44.0044 37.8462 44.2367 38.1319C44.4691 38.4177 44.7551 38.632 45.0947 38.7927C45.4343 38.9534 45.8454 39.0249 46.2922 39.0249C46.8284 39.0249 47.2574 38.9713 47.597 38.8641C47.9366 38.757 48.2047 38.6498 48.3834 38.5784L48.6694 39.5249C48.6694 39.5249 48.5086 39.6142 48.3834 39.6678C48.2404 39.7214 48.0617 39.7749 47.8472 39.8464C47.6327 39.9 47.3825 39.9535 47.0965 39.9893C46.8105 40.025 46.5067 40.0428 46.1671 40.0428L46.185 40.025Z",
            fill: "#838187"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M49.0078 35.7566C49.0078 35.0601 49.1151 34.435 49.3295 33.8993C49.544 33.3635 49.83 32.917 50.1875 32.5598C50.545 32.2026 50.9561 31.9348 51.4387 31.7562C51.9212 31.5776 52.4217 31.4883 52.9579 31.4883C53.4941 31.4883 53.9767 31.5776 54.4593 31.7562C54.924 31.9348 55.3351 32.2026 55.6926 32.5598C56.0501 32.917 56.3361 33.3635 56.5327 33.8993C56.7472 34.435 56.8544 35.0601 56.8544 35.7566C56.8544 36.4531 56.7472 37.0782 56.5327 37.614C56.3182 38.1498 56.0501 38.5962 55.6926 38.9534C55.3351 39.3106 54.924 39.5785 54.4593 39.7571C53.9946 39.9357 53.4941 40.025 52.9579 40.025C52.4217 40.025 51.9212 39.9357 51.4387 39.7571C50.9561 39.5785 50.545 39.3106 50.1875 38.9534C49.83 38.5962 49.544 38.1498 49.3295 37.614C49.1151 37.0782 49.0078 36.4531 49.0078 35.7566ZM50.2054 35.7566C50.2054 36.2567 50.2769 36.7032 50.402 37.1139C50.5271 37.5247 50.7058 37.864 50.9382 38.1498C51.1705 38.4355 51.4565 38.6498 51.7961 38.8106C52.1357 38.9713 52.5111 39.0427 52.9222 39.0427C53.3333 39.0427 53.7086 38.9713 54.0482 38.8106C54.3878 38.6498 54.6559 38.4355 54.8883 38.1498C55.1207 37.864 55.2994 37.5247 55.4245 37.1139C55.5496 36.7032 55.6211 36.2567 55.6211 35.7566C55.6211 35.2566 55.5496 34.8101 55.4245 34.3993C55.2994 33.9886 55.1207 33.6492 54.8883 33.3635C54.6559 33.0778 54.37 32.8634 54.0482 32.7027C53.7265 32.542 53.3511 32.4705 52.9222 32.4705C52.4932 32.4705 52.1357 32.542 51.7961 32.7027C51.4565 32.8634 51.1705 33.0778 50.9382 33.3635C50.7058 33.6492 50.5271 33.9886 50.402 34.3993C50.2769 34.8101 50.2054 35.2566 50.2054 35.7566Z",
            fill: "#838187"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M61.1273 40.0241C60.5911 40.0241 60.1264 39.9348 59.7332 39.7741C59.3399 39.6134 59.0182 39.3812 58.768 39.0954C58.5177 38.8097 58.3211 38.4704 58.2139 38.0775C58.0888 37.6846 58.0352 37.2559 58.0352 36.8095V31.666H59.1791V36.6666C59.1791 37.4881 59.3578 38.0775 59.7153 38.4525C60.0728 38.8276 60.5554 39.0061 61.1273 39.0061C61.4133 39.0061 61.6814 38.9704 61.9316 38.8633C62.164 38.774 62.3785 38.6311 62.5572 38.4525C62.736 38.2561 62.8611 38.0239 62.9683 37.7203C63.0577 37.4167 63.1113 37.0774 63.1113 36.6666V31.666H64.2552V36.8095C64.2552 37.2738 64.2016 37.6846 64.0765 38.0775C63.9514 38.4704 63.7727 38.8097 63.5045 39.0954C63.2543 39.3812 62.9326 39.6134 62.5394 39.7741C62.1461 39.9348 61.6814 40.0241 61.1452 40.0241H61.1273Z",
            fill: "#838187"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M71.5128 39.8455C71.334 39.5598 71.1374 39.2205 70.9229 38.8633C70.6906 38.5061 70.4582 38.131 70.1901 37.7381C69.9399 37.3452 69.6539 36.9523 69.3858 36.5416C69.0998 36.1487 68.8317 35.7558 68.5457 35.3807C68.2776 35.0057 68.0095 34.6485 67.7414 34.327C67.4733 34.0056 67.2409 33.702 67.0264 33.4519V39.8455H65.9004V31.666H66.812C67.1873 32.0589 67.5805 32.5233 67.9916 33.0412C68.4206 33.5591 68.8317 34.1127 69.2428 34.6664C69.6539 35.22 70.0471 35.7736 70.4046 36.3094C70.7799 36.8452 71.0838 37.3274 71.334 37.7381V31.6839H72.4601V39.8634H71.4949L71.5128 39.8455Z",
            fill: "#838187"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M77.5697 40.025C76.9978 40.025 76.4615 39.9357 75.9968 39.7392C75.5321 39.5428 75.121 39.2749 74.7814 38.9177C74.4418 38.5605 74.1737 38.114 73.995 37.5783C73.8162 37.0425 73.709 36.4353 73.709 35.7566C73.709 35.078 73.8162 34.4708 74.0307 33.935C74.2452 33.3992 74.5133 32.9527 74.8708 32.5956C75.2283 32.2384 75.6394 31.9526 76.1041 31.774C76.5688 31.5776 77.0871 31.4883 77.6233 31.4883C77.9629 31.4883 78.2668 31.5061 78.5349 31.5597C78.803 31.6133 79.0354 31.6669 79.2499 31.7205C79.4465 31.7919 79.6073 31.8455 79.7325 31.9169C79.8576 31.9883 79.9469 32.0241 80.0006 32.0598L79.6788 33.0063C79.6788 33.0063 79.5001 32.917 79.375 32.8456C79.2499 32.792 79.089 32.7384 78.9281 32.6848C78.7494 32.6313 78.5707 32.5777 78.374 32.542C78.1774 32.5063 77.963 32.4884 77.7663 32.4884C77.3374 32.4884 76.9441 32.5598 76.6045 32.7206C76.2649 32.8634 75.9611 33.0778 75.7108 33.3635C75.4606 33.6492 75.2819 33.9886 75.1568 34.3993C75.0316 34.8101 74.9602 35.2566 74.9602 35.7566C74.9602 36.2567 75.0138 36.6853 75.1389 37.0961C75.2461 37.489 75.4249 37.8462 75.6572 38.1319C75.8896 38.4177 76.1756 38.632 76.5152 38.7927C76.8548 38.9534 77.248 39.0249 77.7127 39.0249C78.2489 39.0249 78.6779 38.9713 79.0175 38.8641C79.3571 38.757 79.6252 38.6498 79.804 38.5784L80.1078 39.5249C80.1078 39.5249 79.9469 39.6142 79.804 39.6678C79.661 39.7214 79.4822 39.7749 79.2677 39.8464C79.0533 39.9 78.803 39.9535 78.517 39.9893C78.2311 40.025 77.9272 40.0428 77.5876 40.0428L77.5697 40.025Z",
            fill: "#838187"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M81.3047 31.666H82.4486V39.8455H81.3047V31.666Z",
            fill: "#838187"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M89.1011 38.863V39.8631H84.168V31.6836H85.3119V38.8809H89.1011V38.863Z",
            fill: "#838187"
          }
        ),
        /* @__PURE__ */ C("defs", { children: [
          /* @__PURE__ */ C(
            "radialGradient",
            {
              id: "paint0_radial_16047_22228",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(29.3663 -11.3693 11.3786 29.3422 17.3514 38.2764)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ l("stop", { stopColor: "#009189" }),
                /* @__PURE__ */ l("stop", { offset: "0.11", stopColor: "#1D6676" }),
                /* @__PURE__ */ l("stop", { offset: "0.21", stopColor: "#205C69" }),
                /* @__PURE__ */ l("stop", { offset: "0.38", stopColor: "#006CA3" }),
                /* @__PURE__ */ l("stop", { offset: "0.61", stopColor: "#229FBC" }),
                /* @__PURE__ */ l("stop", { offset: "0.8", stopColor: "#1DA997" }),
                /* @__PURE__ */ l("stop", { offset: "0.91", stopColor: "#2FB691" }),
                /* @__PURE__ */ l("stop", { offset: "1", stopColor: "#00B5AF" })
              ]
            }
          ),
          /* @__PURE__ */ C(
            "radialGradient",
            {
              id: "paint1_radial_16047_22228",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(30.6902 -7.06268 7.06846 30.6651 16.7167 34.9008)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ l("stop", { stopColor: "#009189" }),
                /* @__PURE__ */ l("stop", { offset: "0.11", stopColor: "#1D6676" }),
                /* @__PURE__ */ l("stop", { offset: "0.21", stopColor: "#205C69" }),
                /* @__PURE__ */ l("stop", { offset: "0.38", stopColor: "#006CA3" }),
                /* @__PURE__ */ l("stop", { offset: "0.61", stopColor: "#229FBC" }),
                /* @__PURE__ */ l("stop", { offset: "0.8", stopColor: "#1DA997" }),
                /* @__PURE__ */ l("stop", { offset: "0.91", stopColor: "#2FB691" }),
                /* @__PURE__ */ l("stop", { offset: "1", stopColor: "#00B5AF" })
              ]
            }
          ),
          /* @__PURE__ */ C(
            "radialGradient",
            {
              id: "paint2_radial_16047_22228",
              cx: "0",
              cy: "0",
              r: "1",
              gradientTransform: "matrix(-27.8457 -0.72857 -0.681905 26.0196 20.8487 45.827)",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ l("stop", { stopColor: "#009189" }),
                /* @__PURE__ */ l("stop", { offset: "0.11", stopColor: "#1D6676" }),
                /* @__PURE__ */ l("stop", { offset: "0.21", stopColor: "#205C69" }),
                /* @__PURE__ */ l("stop", { offset: "0.38", stopColor: "#006CA3" }),
                /* @__PURE__ */ l("stop", { offset: "0.61", stopColor: "#229FBC" }),
                /* @__PURE__ */ l("stop", { offset: "0.8", stopColor: "#1DA997" }),
                /* @__PURE__ */ l("stop", { offset: "0.91", stopColor: "#2FB691" }),
                /* @__PURE__ */ l("stop", { offset: "1", stopColor: "#00B5AF" })
              ]
            }
          )
        ] })
      ]
    }
  );
}
function Ner(e) {
  return /* @__PURE__ */ l(
    "svg",
    {
      version: "1.1",
      id: "Layer_1",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      viewBox: "0 0 100 100",
      ...e,
      children: /* @__PURE__ */ C("g", { fill: "rgb(25, 28, 43)", children: [
        /* @__PURE__ */ l("path", { d: "M46.6,14.5c3.2,0,5.9-2.6,5.9-5.9c0-3.2-2.6-5.9-5.9-5.9c-3.2,0-5.9,2.6-5.9,5.9   C40.8,11.9,43.4,14.5,46.6,14.5z" }),
        /* @__PURE__ */ l("path", { d: "M73.4,7.9c-11.3,1.9-15,6.6-15,6.6c-6.5,5.7-4.3,11.2-4.3,11.2c2.3,3.4,5.4,0.9,5.4,0.9   c1.6-1.6,2.8-3.4,3.7-5.4c3-7.1,13.2-13,13.2-13C58.1,12.6,55.2,26,55.2,26C53.6,14.3,73.4,7.9,73.4,7.9z" }),
        /* @__PURE__ */ l("path", { d: "M81.5,23.5c-14.2,0.6-22.2,10.2-22.2,10.2c-7.2,6.3-4.7,13.2-4.7,13.2c2.5,3.8,6.5,1.2,6.5,1.2   c2.3-2.2,4.5-5.3,6.8-9.1c7.8-11.9,16.3-14.9,16.3-14.9c-21.9,3.4-28.4,22.7-28.4,22.7C56.9,29.4,81.5,23.5,81.5,23.5z" }),
        /* @__PURE__ */ l("path", { d: "M67.8,51.6c8.5-6.2,19.5-8.2,19.5-8.2C68,45.3,59.5,55.2,59.5,55.2c-7.2,6.3-4.7,13.5-4.7,13.5   c2.4,5,7.5,2.4,7.5,2.4c4.4-2.8,5.8-7,7.8-9.5C78.5,50,90.5,43.9,90.5,43.9C63.3,48.1,56,69.2,56,69.2C56.2,61.8,61,56.6,67.8,51.6   z" }),
        /* @__PURE__ */ l("path", { d: "M17.2,14.5c12.7,0.6,20.3,9.9,20.3,9.9c8.4,8.2,5.2,13,5.2,13c-2.5,3.8-6.5,1.2-6.5,1.2   c-3.2-2.8-4-5.7-6.8-9.1c-8.1-13.1-16.3-14.9-16.3-14.9C36.7,19,41.4,37.6,41.4,37.6C41.7,21.7,17.2,14.5,17.2,14.5z" }),
        /* @__PURE__ */ l("path", { d: "M13,28.4c15.1,4.1,23.6,15.7,23.6,15.7c8,10.1,2.7,16.2,2.7,16.2c-3.3,3.7-7.3,0.4-7.3,0.4   c-3.1-3.5-4-6.5-5.9-11.1C19.5,36.1,9.5,28.4,9.5,28.4C34.6,36.5,38.6,60,38.6,60C40.9,41.4,13,28.4,13,28.4z" }),
        /* @__PURE__ */ l("path", { d: "M54.4,14.8c-6.2,0.9-12.1,8.3-9.2,14.7c2.1,4.6-0.2,9-0.2,9s-4.3,6.3-1.4,12.4c0,0.5,2.4,3.3-0.9,10.6   c-5.3,10.6,2.6,19.6,2.6,19.6l6.6-5.5c-4.2-7.7-0.6-13.7-0.6-13.7c3.1-8.4,0.3-13.2,0.3-13.2c-1.8-4.4,0.2-9,0.2-9   c2.5-6.3-0.3-11.3-0.3-11.3C48.1,19,54.4,14.8,54.4,14.8z" }),
        /* @__PURE__ */ l("rect", { x: "10.2", y: "76.4", width: "29.2", height: "3.3" }),
        /* @__PURE__ */ l("rect", { x: "54.7", y: "76.4", width: "33.9", height: "3.3" }),
        /* @__PURE__ */ l("path", { d: "M11.8,85.6v1h1.8V88h-1.8v1h1.9v1.3h-3.5v-6.1h3.5v1.3H11.8z" }),
        /* @__PURE__ */ l("path", { d: "M18.6,88.1h-1.3l0.7-1.9h0L18.6,88.1z M19,89.3l0.4,1.1h1.7l-2.3-6.1h-1.7l-2.3,6.1h1.7l0.4-1.1H19z" }),
        /* @__PURE__ */ l("path", { d: "M25.6,85.8c-0.3-0.2-0.7-0.4-1-0.4c-0.3,0-0.7,0.2-0.7,0.5c0,0.4,0.4,0.5,0.7,0.6l0.4,0.1   c0.8,0.2,1.5,0.7,1.5,1.7c0,0.6-0.1,1.2-0.6,1.6c-0.5,0.4-1.1,0.6-1.7,0.6c-0.8,0-1.5-0.3-2.1-0.7l0.7-1.3c0.4,0.3,0.9,0.6,1.4,0.6   c0.4,0,0.8-0.2,0.8-0.6c0-0.4-0.6-0.6-1-0.7c-1-0.3-1.6-0.5-1.6-1.7c0-1.2,0.9-2,2.1-2c0.6,0,1.4,0.2,1.9,0.5L25.6,85.8z" }),
        /* @__PURE__ */ l("path", { d: "M30.3,90.4h-1.6v-4.7h-1.3v-1.3h4.2v1.3h-1.3V90.4z" }),
        /* @__PURE__ */ l("path", { d: "M42.2,87c0,0.9-0.1,1.6-0.6,2.4c-0.6,0.8-1.5,1.2-2.5,1.2c-1.9,0-3.2-1.3-3.2-3.2c0-2,1.3-3.3,3.3-3.3   c1.2,0,2.2,0.6,2.7,1.7l-1.5,0.6c-0.2-0.6-0.7-1-1.3-1c-1,0-1.6,1-1.6,1.9c0,0.9,0.6,1.9,1.6,1.9c0.7,0,1.2-0.4,1.3-1.1h-1.3V87   H42.2z" }),
        /* @__PURE__ */ l("path", { d: "M45.2,90.4h-1.6v-6.1h1.6V90.4z" }),
        /* @__PURE__ */ l("path", { d: "M48.4,85.6h0.3c0.6,0,1.1,0,1.1,0.8c0,0.7-0.6,0.7-1.1,0.7h-0.3V85.6z M46.9,90.4h1.6v-2h0.9   c1.4,0,2.2-0.6,2.2-2.1c0-1.4-0.9-2-2.2-2h-2.4V90.4z" }),
        /* @__PURE__ */ l("path", { d: "M54.4,85.6h0.3c0.6,0,1.1,0,1.1,0.8c0,0.7-0.6,0.7-1.1,0.7h-0.3V85.6z M52.8,90.4h1.6v-2h0.9   c1.4,0,2.2-0.6,2.2-2.1c0-1.4-0.9-2-2.2-2h-2.4V90.4z" }),
        /* @__PURE__ */ l("path", { d: "M62.1,85.8c-0.3-0.2-0.7-0.4-1-0.4c-0.3,0-0.7,0.2-0.7,0.5c0,0.4,0.4,0.5,0.7,0.6l0.4,0.1   c0.8,0.2,1.5,0.7,1.5,1.7c0,0.6-0.1,1.2-0.6,1.6c-0.5,0.4-1.1,0.6-1.7,0.6c-0.8,0-1.5-0.3-2.1-0.7l0.7-1.3c0.4,0.3,0.9,0.6,1.4,0.6   c0.4,0,0.8-0.2,0.8-0.6c0-0.4-0.6-0.6-1-0.7c-1-0.3-1.6-0.5-1.6-1.7c0-1.2,0.9-2,2.1-2c0.6,0,1.4,0.2,1.9,0.5L62.1,85.8z" }),
        /* @__PURE__ */ l("path", { d: "M66,89h1.9v1.3h-3.5v-6.1H66V89z" }),
        /* @__PURE__ */ l("path", { d: "M72.3,88.1H71l0.7-1.9h0L72.3,88.1z M72.7,89.3l0.4,1.1h1.7l-2.3-6.1h-1.7l-2.3,6.1h1.7l0.4-1.1H72.7z" }),
        /* @__PURE__ */ l("path", { d: "M76,84.3h1.6l2.9,3.7h0v-3.7H82v6.1h-1.6l-2.9-3.7h0v3.7H76V84.3z" }),
        /* @__PURE__ */ l("path", { d: "M85.3,85.6h0.4c1,0,1.7,0.6,1.7,1.7c0,1.2-0.8,1.7-1.7,1.7h-0.4V85.6z M83.7,90.4h2.2c1.7,0,3.1-1.3,3.1-3   c0-1.7-1.4-3-3.1-3h-2.2V90.4z" }),
        /* @__PURE__ */ l("path", { d: "M12,94.1c-0.1-0.3-0.3-0.4-0.6-0.4c-0.3,0-0.6,0.2-0.6,0.6c0,0.3,0.3,0.5,0.6,0.6l0.2,0.1   c0.5,0.2,0.9,0.4,0.9,1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1-0.4-1.1-0.9l0.4-0.1c0.1,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7   c0-0.4-0.3-0.6-0.7-0.7l-0.2-0.1c-0.4-0.2-0.8-0.4-0.8-0.9c0-0.6,0.5-0.9,1-0.9c0.4,0,0.7,0.2,0.9,0.6L12,94.1z" }),
        /* @__PURE__ */ l("path", { d: "M19.2,94.9v-1.5h0.4V97h-0.4v-1.8h-1.9V97H17v-3.6h0.4v1.5H19.2z" }),
        /* @__PURE__ */ l("path", { d: "M24.7,93.4h-0.4V97h0.4V93.4z" }),
        /* @__PURE__ */ l("path", { d: "M29.7,93.8h0.1c0.5,0,0.9,0.1,0.9,0.7c0,0.6-0.5,0.7-0.9,0.7h-0.1V93.8z M29.7,95.4h0.1l1.1,1.6h0.5l-1.2-1.6   c0.6,0,0.9-0.4,0.9-1c0-0.8-0.6-1-1.3-1h-0.5V97h0.4V95.4z" }),
        /* @__PURE__ */ l("path", { d: "M35.8,97h1.9v-0.4h-1.5v-1.4h1.4v-0.4h-1.4v-1.1h1.5v-0.4h-1.9V97z" }),
        /* @__PURE__ */ l("path", { d: "M48.3,94.2c-0.3-0.3-0.7-0.5-1.1-0.5c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5c0.4,0,0.8-0.2,1.1-0.5v0.5   c-0.3,0.2-0.7,0.4-1.1,0.4c-1,0-1.9-0.8-1.9-1.9c0-1,0.9-1.9,1.9-1.9c0.4,0,0.8,0.1,1.1,0.4V94.2z" }),
        /* @__PURE__ */ l("path", { d: "M53.4,93.7c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5S52,96,52,95.2C52,94.4,52.6,93.7,53.4,93.7z    M53.4,93.3c-1,0-1.9,0.8-1.9,1.9c0,1,0.9,1.9,1.9,1.9c1,0,1.9-0.8,1.9-1.9C55.3,94.2,54.5,93.3,53.4,93.3z" }),
        /* @__PURE__ */ l("path", { d: "M60.1,95.6c0,0.3,0,0.6,0.2,0.8c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.2-0.6,0.2-0.8v-2.2   h0.4v2.3c0,0.4,0,0.7-0.3,1c-0.3,0.3-0.6,0.4-1,0.4c-0.3,0-0.7-0.1-0.9-0.4c-0.3-0.3-0.4-0.6-0.4-1.1v-2.3h0.4V95.6z" }),
        /* @__PURE__ */ l("path", { d: "M66.8,97h0.4v-2.8l2.8,3v-3.8h-0.4v2.8l-2.8-3V97z" }),
        /* @__PURE__ */ l("path", { d: "M77.3,94.2c-0.3-0.3-0.7-0.5-1.1-0.5c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5c0.4,0,0.8-0.2,1.1-0.5v0.5   c-0.3,0.2-0.7,0.4-1.1,0.4c-1,0-1.9-0.8-1.9-1.9c0-1,0.9-1.9,1.9-1.9c0.4,0,0.8,0.1,1.1,0.4V94.2z" }),
        /* @__PURE__ */ l("path", { d: "M82.2,97h-0.4v-3.6h0.4V97z" }),
        /* @__PURE__ */ l("path", { d: "M86.2,96.7h1V97h-1.4v-3.6h0.4V96.7z" })
      ] })
    }
  );
}
function Mer(e) {
  return /* @__PURE__ */ l(
    "svg",
    {
      width: "25",
      height: "24",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ l("g", { id: "Remove", children: /* @__PURE__ */ l(
        "path",
        {
          id: "Union",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.233 2.3189C13.0438 2.11552 12.7786 2 12.5008 2C12.223 2 11.9578 2.11552 11.7686 2.3189L7.77758 6.60925C7.49607 6.89854 7.30858 7.26638 7.23999 7.66446C7.17035 8.06867 7.22667 8.48451 7.40132 8.85564C7.49728 9.05956 7.62642 9.24456 7.78233 9.4037L5.77137 11.6158C5.50571 11.8928 5.32525 12.2405 5.25177 12.6175C5.17689 13.0018 5.21643 13.3996 5.36549 13.7616C5.46384 14.0005 5.60703 14.2168 5.78607 14.3996L3.77137 16.6158C3.50571 16.8928 3.32525 17.2405 3.25177 17.6175C3.19115 17.9286 3.20552 18.2486 3.29228 18.5512L8.3582 13.4853C8.17912 13.1868 7.85486 13 7.5008 13H7.21494C7.22371 12.9911 7.23231 12.9819 7.24074 12.9727L10.2407 9.67267C10.507 9.37979 10.5754 8.95743 10.4153 8.59545C10.2552 8.23347 9.89662 8 9.5008 8H9.3008C9.27081 8 9.24083 8.00135 9.21096 8.00404C9.21842 7.99651 9.22576 7.98887 9.23299 7.9811L12.5008 4.4682L14.85 6.99355L16.2651 5.57841L13.233 2.3189ZM11.5 20L7.50034 20L9.50036 18H12.5H19.7867C19.7779 17.9911 19.7693 17.9819 19.7609 17.9727L16.7609 14.6727C16.4946 14.3798 16.4262 13.9574 16.5863 13.5954C16.7464 13.2335 17.105 13 17.5008 13H17.7867C17.7779 12.9911 17.7693 12.9819 17.7609 12.9727L16.2213 11.2791L17.6371 9.86329L19.2302 11.6158C19.4959 11.8928 19.6763 12.2405 19.7498 12.6175C19.8247 13.0018 19.7852 13.3996 19.6361 13.7616C19.5378 14.0005 19.3946 14.2168 19.2155 14.3996L21.2302 16.6158C21.4959 16.8928 21.6763 17.2405 21.7498 17.6175C21.8247 18.0018 21.7852 18.3996 21.6361 18.7616C21.487 19.1236 21.235 19.4339 20.9113 19.654C20.5875 19.8741 20.2063 19.9944 19.8148 19.9999L19.8008 20.0001L13.5 20.0001V22C13.5 22.5523 13.0523 23 12.5 23C11.9477 23 11.5 22.5523 11.5 22V20ZM19.1337 6.90097C19.4836 6.55101 19.4836 5.98362 19.1337 5.63366C18.7837 5.2837 18.2163 5.2837 17.8663 5.63366L4.13366 19.3663C3.7837 19.7163 3.7837 20.2837 4.13366 20.6337C4.48362 20.9836 5.05101 20.9836 5.40097 20.6337L19.1337 6.90097Z",
          fill: "currentcolor"
        }
      ) })
    }
  );
}
function Ter(e) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "25",
      height: "24",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ l("g", { id: "Duplicate", clipPath: "url(#clip0_10111_17814)", children: /* @__PURE__ */ l(
          "path",
          {
            id: "Union",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.9008 2C15.1783 2.00023 15.4432 2.11574 15.6322 2.3189L19.6232 6.60925C19.9047 6.89854 20.0922 7.26638 20.1608 7.66446C20.2304 8.06867 20.1741 8.48452 19.9995 8.85564C19.9035 9.05956 19.7744 9.24456 19.6185 9.4037L21.6294 11.6158C21.8951 11.8928 22.0756 12.2405 22.149 12.6175C22.2239 13.0018 22.1844 13.3996 22.0353 13.7616C21.937 14.0005 21.7938 14.2168 21.6147 14.3996L23.6294 16.6158C23.8951 16.8928 24.0756 17.2405 24.149 17.6175C24.2239 18.0018 24.1844 18.3996 24.0353 18.7616C23.8863 19.1236 23.6342 19.4339 23.3105 19.654C22.9867 19.8741 22.6055 19.9944 22.214 19.9999L22.2 20.0001V20H17.093L17.086 20.0001L15.9004 20.0001V22C15.9004 22.5523 15.4527 23 14.9004 23C14.3481 23 13.9004 22.5523 13.9004 22V20.0001L10.7852 20.0001V22C10.7852 22.5523 10.3374 23 9.78516 23C9.23287 23 8.78516 22.5523 8.78516 22V20L2.47191 20C2.08046 19.9945 1.69923 19.8741 1.37548 19.654C1.05173 19.4339 0.799704 19.1236 0.650645 18.7616C0.501584 18.3996 0.462046 18.0018 0.536929 17.6175C0.610403 17.2405 0.790861 16.8928 1.05652 16.6158L3.07122 14.3996C2.89219 14.2168 2.749 14.0005 2.65064 13.7616C2.50159 13.3996 2.46204 13.0018 2.53693 12.6175C2.6104 12.2405 2.79086 11.8928 3.05652 11.6158L5.06749 9.4037C4.91157 9.24456 4.78244 9.05956 4.68647 8.85564C4.51183 8.48452 4.45551 8.06867 4.52515 7.66446C4.59374 7.26638 4.78123 6.89855 5.06274 6.60925L9.05377 2.3189C9.24295 2.11553 9.5082 2 9.78595 2C10.0637 2 10.329 2.11553 10.5181 2.3189L12.5012 4.45068C12.5123 4.22282 12.6011 3.99753 12.7689 3.81768L14.1689 2.31768C14.3583 2.11484 14.6234 1.99977 14.9008 2ZM13.4771 5.49975L14.5092 6.60923C14.7907 6.89853 14.9782 7.26637 15.0468 7.66446C15.1164 8.06867 15.0601 8.48452 14.8854 8.85564C14.7895 9.05956 14.6603 9.24456 14.5044 9.4037L16.5154 11.6158C16.781 11.8928 16.9615 12.2405 17.035 12.6175C17.1099 13.0018 17.0703 13.3996 16.9213 13.7616C16.8229 14.0005 16.6797 14.2168 16.5007 14.3996L18.5154 16.6158C18.781 16.8928 18.9615 17.2405 19.035 17.6175C19.0597 17.7441 19.0719 17.8722 19.0719 18H22.1859C22.1771 17.9911 22.1685 17.9819 22.1601 17.9727L19.1601 14.6727C18.8938 14.3798 18.8254 13.9574 18.9855 13.5954C19.1456 13.2335 19.5042 13 19.9 13H20.1859C20.1771 12.9911 20.1685 12.9819 20.1601 12.9727L17.1601 9.67267C16.8938 9.37979 16.8254 8.95743 16.9855 8.59545C17.1456 8.23347 17.5042 8 17.9 8H18.1C18.13 8 18.16 8.00135 18.1898 8.00405C18.1824 7.99652 18.175 7.98887 18.1678 7.9811L14.8988 4.4669L14.2311 5.18232C14.0286 5.39929 13.7521 5.50596 13.4771 5.49975ZM17.0718 18C17.063 17.9911 17.0544 17.9819 17.046 17.9727L14.046 14.6727C13.7798 14.3798 13.7113 13.9574 13.8714 13.5954C14.0316 13.2335 14.3901 13 14.786 13H15.0718C15.063 12.9911 15.0544 12.9819 15.046 12.9727L12.046 9.67267C11.7798 9.37979 11.7113 8.95743 11.8714 8.59545C12.0316 8.23347 12.3901 8 12.786 8H12.986C13.0159 8 13.0459 8.00135 13.0758 8.00405C13.0683 7.99652 13.061 7.98887 13.0538 7.9811L9.78595 4.4682L6.51814 7.9811C6.51092 7.98887 6.50358 7.99652 6.49611 8.00404C6.52598 8.00135 6.55596 8 6.58596 8H6.78595C7.18177 8 7.54034 8.23347 7.70047 8.59545C7.8606 8.95743 7.79215 9.37979 7.5259 9.67267L4.52589 12.9727C4.51747 12.9819 4.50887 12.9911 4.5001 13H4.78595C5.18177 13 5.54034 13.2335 5.70047 13.5954C5.8606 13.9574 5.79215 14.3798 5.52589 14.6727L2.52589 17.9727C2.51747 17.9819 2.50887 17.9911 2.5001 18H9.78516H13.9H14.9004H17.0718Z",
            fill: "currentcolor"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_10111_17814", children: /* @__PURE__ */ l(
          "rect",
          {
            width: "24",
            height: "24",
            fill: "transparent",
            transform: "translate(0.5)"
          }
        ) }) })
      ]
    }
  );
}
function Mf({ className: e, ...r }) {
  return /* @__PURE__ */ l(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      className: _("h-4 w-4", e),
      ...r,
      children: /* @__PURE__ */ l(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
        }
      )
    }
  );
}
function Fn({ className: e }) {
  return /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      className: e,
      children: [
        /* @__PURE__ */ l(
          "mask",
          {
            id: "mask0_4938_6991",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "24",
            height: "24",
            children: /* @__PURE__ */ l("rect", { width: "24", height: "24", fill: "#D9D9D9" })
          }
        ),
        /* @__PURE__ */ l("g", { mask: "url(#mask0_4938_6991)", children: /* @__PURE__ */ l(
          "path",
          {
            d: "M14 21L12.575 19.575L16.175 16H5V4H7V14H16.175L12.575 10.4L13.975 8.975L20 15L14 21Z",
            fill: "currentcolor"
          }
        ) })
      ]
    }
  );
}
function M_e(e) {
  return /* @__PURE__ */ C(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      ...e,
      children: [
        /* @__PURE__ */ l(
          "mask",
          {
            id: "mask0_13737_12564",
            style: { maskType: "alpha" },
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "20",
            height: "20",
            children: /* @__PURE__ */ l("rect", { width: "20", height: "20", fill: "#D9D9D9" })
          }
        ),
        /* @__PURE__ */ l("g", { mask: "url(#mask0_13737_12564)", children: /* @__PURE__ */ l(
          "path",
          {
            d: "M7.25 13.9167L6.08333 12.75L9.66667 9.16667H6.66667V7.5H12.5V13.3333H10.8333V10.3333L7.25 13.9167ZM15.8333 10V4.16667H10V2.5H17.5V10H15.8333ZM4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V2.5H4.16667V15.8333H17.5V17.5H4.16667Z",
            fill: "#0157FF"
          }
        ) })
      ]
    }
  );
}
function Eer(e) {
  return /* @__PURE__ */ C(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: [
        /* @__PURE__ */ l("circle", { cx: "12", cy: "12", r: "10", fill: "#039469" }),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M6.01074 5.2832C4.6392 6.50705 3.64672 8.14462 3.22559 10H5L5.2959 10.0146C5.98282 10.0828 6.62871 10.3865 7.12109 10.8789C7.68364 11.4415 8 12.2044 8 13V14L8.00488 14.0986C8.02758 14.3276 8.12883 14.5429 8.29297 14.707C8.45715 14.8712 8.67234 14.9725 8.90137 14.9951L9.2959 15.0146C9.98282 15.0828 10.6287 15.3865 11.1211 15.8789C11.6836 16.4415 12 17.2044 12 18V21C12.6877 21 13.3565 20.9195 14 20.7734V17C14 16.2043 14.3163 15.4415 14.8789 14.8789C15.4415 14.3163 16.2043 14 17 14H20.7744C20.9205 13.3566 21 12.6876 21 12C21 10.9479 20.8181 9.93847 20.4863 9H18C17.4524 9 17.0001 9.45239 17 10C17 10.7955 16.6836 11.5585 16.1211 12.1211C15.5585 12.6837 14.7956 13 14 13C12.3478 13 11.0001 11.6522 11 10C10.9999 9.73491 10.8945 9.48044 10.707 9.29297C10.5195 9.10551 10.2652 9 10 9C8.93917 9 7.92201 8.57822 7.17188 7.82812C6.48883 7.14502 6.07869 6.2405 6.01074 5.2832Z",
            fill: "#373530"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 1C16.4781 1 20.3276 3.67753 22.0439 7.51758C22.0695 7.56373 22.0913 7.61186 22.1094 7.66211C22.6813 8.99331 23 10.4593 23 12C23 18.0751 18.0751 23 12 23C11.6309 23 11.2661 22.9808 10.9062 22.9453C10.902 22.9449 10.8978 22.9448 10.8936 22.9443C5.33802 22.3894 1 17.7017 1 12C1 7.93868 3.20232 4.39373 6.47656 2.48828C6.49603 2.47629 6.51581 2.46476 6.53613 2.4541C8.14622 1.53053 10.0107 1 12 1ZM3.22559 10C3.64672 8.14462 4.6392 6.50705 6.01074 5.2832C6.07869 6.2405 6.48883 7.14502 7.17188 7.82812C7.92201 8.57822 8.93917 9 10 9C10.2652 9 10.5195 9.10551 10.707 9.29297C10.8945 9.48044 10.9999 9.73491 11 10C11.0001 11.6522 12.3478 13 14 13C14.7956 13 15.5585 12.6837 16.1211 12.1211C16.6836 11.5585 17 10.7955 17 10C17.0001 9.45239 17.4524 9 18 9H20.4863C20.8181 9.93847 21 10.9479 21 12C21 12.6876 20.9205 13.3566 20.7744 14H17C16.2043 14 15.4415 14.3163 14.8789 14.8789C14.3163 15.4415 14 16.2043 14 17V20.7734C13.3565 20.9195 12.6877 21 12 21V18C12 17.2044 11.6836 16.4415 11.1211 15.8789C10.6287 15.3865 9.98282 15.0828 9.2959 15.0146L8.90137 14.9951C8.67234 14.9725 8.45715 14.8712 8.29297 14.707C8.12883 14.5429 8.02758 14.3276 8.00488 14.0986L8 14V13C8 12.2044 7.68364 11.4415 7.12109 10.8789C6.62871 10.3865 5.98282 10.0828 5.2959 10.0146L5 10H3.22559ZM10 20.7734C5.99241 19.8637 3 16.2829 3 12H5L5.09863 12.0049C5.32756 12.0276 5.54293 12.1289 5.70703 12.293C5.89451 12.4805 6 12.7348 6 13V14C6 14.7957 6.3163 15.5585 6.87891 16.1211C7.44151 16.6836 8.2044 17 9 17C9.26515 17.0001 9.51954 17.1055 9.70703 17.293C9.89451 17.4805 10 17.7348 10 18V20.7734ZM16.293 16.293C16.4805 16.1054 16.7348 16 17 16H20.0625C19.1888 17.7577 17.7577 19.1877 16 20.0615V17C16 16.7348 16.1054 16.4805 16.293 16.293ZM8 3.9375C9.20516 3.33844 10.5628 3 12 3C15.1202 3 17.8688 4.5883 19.4834 7H18C16.3478 7 15.0001 8.34783 15 10C15 10.2651 14.8945 10.5195 14.707 10.707C14.5195 10.8945 14.2652 11 14 11C13.4523 11 13.0001 10.5476 13 10C12.9999 9.20447 12.6836 8.44145 12.1211 7.87891C11.5585 7.31637 10.7956 7 10 7C9.4696 7 8.961 6.78909 8.58594 6.41406C8.21098 6.03904 8.00004 5.53032 8 5V3.9375Z",
            fill: "#373530"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            d: "M6.01074 5.2832C4.6392 6.50705 3.64672 8.14462 3.22559 10H5L5.2959 10.0146C5.98282 10.0828 6.62871 10.3865 7.12109 10.8789C7.68364 11.4415 8 12.2044 8 13V14L8.00488 14.0986C8.02758 14.3276 8.12883 14.5429 8.29297 14.707C8.45715 14.8712 8.67234 14.9725 8.90137 14.9951L9.2959 15.0146C9.98282 15.0828 10.6287 15.3865 11.1211 15.8789C11.6836 16.4415 12 17.2044 12 18V21C12.6877 21 13.3565 20.9195 14 20.7734V17C14 16.2043 14.3163 15.4415 14.8789 14.8789C15.4415 14.3163 16.2043 14 17 14H20.7744C20.9205 13.3566 21 12.6876 21 12C21 10.9479 20.8181 9.93847 20.4863 9H18C17.4524 9 17.0001 9.45239 17 10C17 10.7955 16.6836 11.5585 16.1211 12.1211C15.5585 12.6837 14.7956 13 14 13C12.3478 13 11.0001 11.6522 11 10C10.9999 9.73491 10.8945 9.48044 10.707 9.29297C10.5195 9.10551 10.2652 9 10 9C8.93917 9 7.92201 8.57822 7.17188 7.82812C6.48883 7.14502 6.07869 6.2405 6.01074 5.2832Z",
            fill: "#77AAF4"
          }
        )
      ]
    }
  );
}
function T_e() {
  return /* @__PURE__ */ C(
    "svg",
    {
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      x: "0px",
      y: "0px",
      viewBox: "0 0 145.3 109.9",
      xmlSpace: "preserve",
      children: [
        /* @__PURE__ */ l("style", { type: "text/css", children: `.st0{fill:#502D3C;}
        .st1{display:none;}
        .st2{display:inline;fill:none;stroke:#2DAAE1;stroke-width:0.25;stroke-miterlimit:10;}
        .st3{display:inline;}
        .st4{fill:none;stroke:#2DAAE1;stroke-width:0.25;stroke-miterlimit:10;}` }),
        /* @__PURE__ */ l("g", { id: "Layer_1", children: /* @__PURE__ */ l(
          "path",
          {
            className: "st0",
            d: `M17.5,30.5C17.5,18.4,11.4,8.4,0,0h26.5c9.3,7.2,15,18.2,15,30.5c0,12.3-5.7,23.3-15,30.5
          c8.6,3.6,13.5,12.4,13.5,25v24H16v-24c0-12-5.7-20.4-16-25C11.4,52.5,17.5,42.6,17.5,30.5 M69.4,30.5c0-12.1-6.1-22.1-17.5-30.5
          h26.5c9.3,7.2,15,18.2,15,30.5c0,12.3-5.7,23.3-15,30.5c8.6,3.6,13.5,12.4,13.5,25v24h-24v-24c0-12-5.7-20.4-16-25
          C63.3,52.5,69.4,42.6,69.4,30.5 M121.4,30.5c0-12.1-6.1-22.1-17.5-30.5h26.5c9.3,7.2,15,18.2,15,30.5c0,12.3-5.7,23.3-15,30.5
          c8.6,3.6,13.5,12.4,13.5,25v24h-24v-24c0-12-5.7-20.4-16-25C115.3,52.5,121.4,42.6,121.4,30.5`
          }
        ) }),
        /* @__PURE__ */ C("g", { id: "grid_for_exports", className: "st1", children: [
          /* @__PURE__ */ l("line", { className: "st2", x1: "215.7", y1: "181.8", x2: "-71.9", y2: "181.8" }),
          /* @__PURE__ */ l("line", { className: "st2", x1: "215.7", y1: "0", x2: "-71.9", y2: "0" }),
          /* @__PURE__ */ l("line", { className: "st2", x1: "215.7", y1: "109.8", x2: "-71.9", y2: "109.8" }),
          /* @__PURE__ */ l("line", { className: "st2", x1: "143.7", y1: "181.6", x2: "143.7", y2: "-72" }),
          /* @__PURE__ */ l("line", { className: "st2", x1: "0", y1: "-71.2", x2: "0", y2: "181.6" }),
          /* @__PURE__ */ l("rect", { x: "15.7", y: "85.8", className: "st2", width: "24", height: "24" }),
          /* @__PURE__ */ l("rect", { x: "-24", y: "-24", className: "st2", width: "24", height: "24" }),
          /* @__PURE__ */ l("rect", { x: "-48", y: "-48", className: "st2", width: "24", height: "24" }),
          /* @__PURE__ */ l("rect", { x: "-72", y: "-72", className: "st2", width: "24", height: "24" }),
          /* @__PURE__ */ C("g", { className: "st3", children: [
            /* @__PURE__ */ l(
              "rect",
              {
                x: "-72",
                y: "157.8",
                transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -120 339.6799)",
                className: "st4",
                width: "24",
                height: "24"
              }
            ),
            /* @__PURE__ */ l(
              "rect",
              {
                x: "-48",
                y: "133.8",
                transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -72 291.6799)",
                className: "st4",
                width: "24",
                height: "24"
              }
            ),
            /* @__PURE__ */ l(
              "rect",
              {
                x: "-24",
                y: "109.8",
                transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 -24 243.6799)",
                className: "st4",
                width: "24",
                height: "24"
              }
            )
          ] }),
          /* @__PURE__ */ C("g", { className: "st3", children: [
            /* @__PURE__ */ l("rect", { x: "191.7", y: "157.8", className: "st4", width: "24", height: "24" }),
            /* @__PURE__ */ l("rect", { x: "167.7", y: "133.8", className: "st4", width: "24", height: "24" }),
            /* @__PURE__ */ l("rect", { x: "143.7", y: "109.8", className: "st4", width: "24", height: "24" })
          ] }),
          /* @__PURE__ */ C("g", { className: "st3", children: [
            /* @__PURE__ */ l(
              "rect",
              {
                x: "143.7",
                y: "-24",
                transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 311.4358 -24)",
                className: "st4",
                width: "24",
                height: "24"
              }
            ),
            /* @__PURE__ */ l(
              "rect",
              {
                x: "167.7",
                y: "-48",
                transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 359.4358 -72)",
                className: "st4",
                width: "24",
                height: "24"
              }
            ),
            /* @__PURE__ */ l(
              "rect",
              {
                x: "191.7",
                y: "-72",
                transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 407.4358 -120)",
                className: "st4",
                width: "24",
                height: "24"
              }
            )
          ] }),
          /* @__PURE__ */ l("rect", { x: "-72", y: "-72", className: "st2", width: "287.7", height: "253.8" })
        ] })
      ]
    }
  );
}
const E_e = "data:image/jpeg;base64,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";
function ker(e) {
  return /* @__PURE__ */ l("img", { src: E_e, alt: "Melton City Council Logo", ...e });
}
function Oer({ className: e }) {
  return /* @__PURE__ */ l("div", { className: _("grid-loader relative h-[160px]", e), children: /* @__PURE__ */ l("div", { className: "absolute inset-0 flex flex-col", children: Array.from({ length: 8 }).map((r, t) => /* @__PURE__ */ l("div", { className: "flex grow", children: Array.from({ length: 24 }).map((i, n) => /* @__PURE__ */ l(
    "div",
    {
      className: "grow border-2 border-[#FCFCF9]"
    },
    n
  )) }, t)) }) });
}
function $t(e) {
  this.content = e;
}
$t.prototype = {
  constructor: $t,
  find: function(e) {
    for (var r = 0; r < this.content.length; r += 2)
      if (this.content[r] === e) return r;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(e) {
    var r = this.find(e);
    return r == -1 ? void 0 : this.content[r + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(e, r, t) {
    var i = t && t != e ? this.remove(t) : this, n = i.find(e), s = i.content.slice();
    return n == -1 ? s.push(t || e, r) : (s[n + 1] = r, t && (s[n] = t)), new $t(s);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(e) {
    var r = this.find(e);
    if (r == -1) return this;
    var t = this.content.slice();
    return t.splice(r, 2), new $t(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(e, r) {
    return new $t([e, r].concat(this.remove(e).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(e, r) {
    var t = this.remove(e).content.slice();
    return t.push(e, r), new $t(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(e, r, t) {
    var i = this.remove(r), n = i.content.slice(), s = i.find(e);
    return n.splice(s == -1 ? n.length : s, 0, r, t), new $t(n);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(e) {
    for (var r = 0; r < this.content.length; r += 2)
      e(this.content[r], this.content[r + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(e) {
    return e = $t.from(e), e.size ? new $t(e.content.concat(this.subtract(e).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(e) {
    return e = $t.from(e), e.size ? new $t(this.subtract(e).content.concat(e.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(e) {
    var r = this;
    e = $t.from(e);
    for (var t = 0; t < e.content.length; t += 2)
      r = r.remove(e.content[t]);
    return r;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var e = {};
    return this.forEach(function(r, t) {
      e[r] = t;
    }), e;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
$t.from = function(e) {
  if (e instanceof $t) return e;
  var r = [];
  if (e) for (var t in e) r.push(t, e[t]);
  return new $t(r);
};
function XQ(e, r, t) {
  for (let i = 0; ; i++) {
    if (i == e.childCount || i == r.childCount)
      return e.childCount == r.childCount ? null : t;
    let n = e.child(i), s = r.child(i);
    if (n == s) {
      t += n.nodeSize;
      continue;
    }
    if (!n.sameMarkup(s))
      return t;
    if (n.isText && n.text != s.text) {
      for (let u = 0; n.text[u] == s.text[u]; u++)
        t++;
      return t;
    }
    if (n.content.size || s.content.size) {
      let u = XQ(n.content, s.content, t + 1);
      if (u != null)
        return u;
    }
    t += n.nodeSize;
  }
}
function qQ(e, r, t, i) {
  for (let n = e.childCount, s = r.childCount; ; ) {
    if (n == 0 || s == 0)
      return n == s ? null : { a: t, b: i };
    let u = e.child(--n), o = r.child(--s), d = u.nodeSize;
    if (u == o) {
      t -= d, i -= d;
      continue;
    }
    if (!u.sameMarkup(o))
      return { a: t, b: i };
    if (u.isText && u.text != o.text) {
      let a = 0, V = Math.min(u.text.length, o.text.length);
      for (; a < V && u.text[u.text.length - a - 1] == o.text[o.text.length - a - 1]; )
        a++, t--, i--;
      return { a: t, b: i };
    }
    if (u.content.size || o.content.size) {
      let a = qQ(u.content, o.content, t - 1, i - 1);
      if (a)
        return a;
    }
    t -= d, i -= d;
  }
}
class Fe {
  /**
  @internal
  */
  constructor(r, t) {
    if (this.content = r, this.size = t || 0, t == null)
      for (let i = 0; i < r.length; i++)
        this.size += r[i].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(r, t, i, n = 0, s) {
    for (let u = 0, o = 0; o < t; u++) {
      let d = this.content[u], a = o + d.nodeSize;
      if (a > r && i(d, n + o, s || null, u) !== !1 && d.content.size) {
        let V = o + 1;
        d.nodesBetween(Math.max(0, r - V), Math.min(d.content.size, t - V), i, n + V);
      }
      o = a;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(r) {
    this.nodesBetween(0, this.size, r);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(r, t, i, n) {
    let s = "", u = !0;
    return this.nodesBetween(r, t, (o, d) => {
      let a = o.isText ? o.text.slice(Math.max(r, d) - d, t - d) : o.isLeaf ? n ? typeof n == "function" ? n(o) : n : o.type.spec.leafText ? o.type.spec.leafText(o) : "" : "";
      o.isBlock && (o.isLeaf && a || o.isTextblock) && i && (u ? u = !1 : s += i), s += a;
    }, 0), s;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(r) {
    if (!r.size)
      return this;
    if (!this.size)
      return r;
    let t = this.lastChild, i = r.firstChild, n = this.content.slice(), s = 0;
    for (t.isText && t.sameMarkup(i) && (n[n.length - 1] = t.withText(t.text + i.text), s = 1); s < r.content.length; s++)
      n.push(r.content[s]);
    return new Fe(n, this.size + r.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(r, t = this.size) {
    if (r == 0 && t == this.size)
      return this;
    let i = [], n = 0;
    if (t > r)
      for (let s = 0, u = 0; u < t; s++) {
        let o = this.content[s], d = u + o.nodeSize;
        d > r && ((u < r || d > t) && (o.isText ? o = o.cut(Math.max(0, r - u), Math.min(o.text.length, t - u)) : o = o.cut(Math.max(0, r - u - 1), Math.min(o.content.size, t - u - 1))), i.push(o), n += o.nodeSize), u = d;
      }
    return new Fe(i, n);
  }
  /**
  @internal
  */
  cutByIndex(r, t) {
    return r == t ? Fe.empty : r == 0 && t == this.content.length ? this : new Fe(this.content.slice(r, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(r, t) {
    let i = this.content[r];
    if (i == t)
      return this;
    let n = this.content.slice(), s = this.size + t.nodeSize - i.nodeSize;
    return n[r] = t, new Fe(n, s);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(r) {
    return new Fe([r].concat(this.content), this.size + r.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(r) {
    return new Fe(this.content.concat(r), this.size + r.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(r) {
    if (this.content.length != r.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(r.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(r) {
    let t = this.content[r];
    if (!t)
      throw new RangeError("Index " + r + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(r) {
    return this.content[r] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(r) {
    for (let t = 0, i = 0; t < this.content.length; t++) {
      let n = this.content[t];
      r(n, i, t), i += n.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(r, t = 0) {
    return XQ(this, r, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(r, t = this.size, i = r.size) {
    return qQ(this, r, t, i);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(r, t = -1) {
    if (r == 0)
      return bx(0, r);
    if (r == this.size)
      return bx(this.content.length, r);
    if (r > this.size || r < 0)
      throw new RangeError(`Position ${r} outside of fragment (${this})`);
    for (let i = 0, n = 0; ; i++) {
      let s = this.child(i), u = n + s.nodeSize;
      if (u >= r)
        return u == r || t > 0 ? bx(i + 1, u) : bx(i, n);
      n = u;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((r) => r.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(r, t) {
    if (!t)
      return Fe.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new Fe(t.map(r.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(r) {
    if (!r.length)
      return Fe.empty;
    let t, i = 0;
    for (let n = 0; n < r.length; n++) {
      let s = r[n];
      i += s.nodeSize, n && s.isText && r[n - 1].sameMarkup(s) ? (t || (t = r.slice(0, n)), t[t.length - 1] = s.withText(t[t.length - 1].text + s.text)) : t && t.push(s);
    }
    return new Fe(t || r, i);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(r) {
    if (!r)
      return Fe.empty;
    if (r instanceof Fe)
      return r;
    if (Array.isArray(r))
      return this.fromArray(r);
    if (r.attrs)
      return new Fe([r], r.nodeSize);
    throw new RangeError("Can not convert " + r + " to a Fragment" + (r.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
Fe.empty = new Fe([], 0);
const wg = { index: 0, offset: 0 };
function bx(e, r) {
  return wg.index = e, wg.offset = r, wg;
}
function xq(e, r) {
  if (e === r)
    return !0;
  if (!(e && typeof e == "object") || !(r && typeof r == "object"))
    return !1;
  let t = Array.isArray(e);
  if (Array.isArray(r) != t)
    return !1;
  if (t) {
    if (e.length != r.length)
      return !1;
    for (let i = 0; i < e.length; i++)
      if (!xq(e[i], r[i]))
        return !1;
  } else {
    for (let i in e)
      if (!(i in r) || !xq(e[i], r[i]))
        return !1;
    for (let i in r)
      if (!(i in e))
        return !1;
  }
  return !0;
}
let wr = class Wb {
  /**
  @internal
  */
  constructor(r, t) {
    this.type = r, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(r) {
    let t, i = !1;
    for (let n = 0; n < r.length; n++) {
      let s = r[n];
      if (this.eq(s))
        return r;
      if (this.type.excludes(s.type))
        t || (t = r.slice(0, n));
      else {
        if (s.type.excludes(this.type))
          return r;
        !i && s.type.rank > this.type.rank && (t || (t = r.slice(0, n)), t.push(this), i = !0), t && t.push(s);
      }
    }
    return t || (t = r.slice()), i || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(r) {
    for (let t = 0; t < r.length; t++)
      if (this.eq(r[t]))
        return r.slice(0, t).concat(r.slice(t + 1));
    return r;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(r) {
    for (let t = 0; t < r.length; t++)
      if (this.eq(r[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(r) {
    return this == r || this.type == r.type && xq(this.attrs, r.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let r = { type: this.type.name };
    for (let t in this.attrs) {
      r.attrs = this.attrs;
      break;
    }
    return r;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(r, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let i = r.marks[t.type];
    if (!i)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    let n = i.create(t.attrs);
    return i.checkAttrs(n.attrs), n;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(r, t) {
    if (r == t)
      return !0;
    if (r.length != t.length)
      return !1;
    for (let i = 0; i < r.length; i++)
      if (!r[i].eq(t[i]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(r) {
    if (!r || Array.isArray(r) && r.length == 0)
      return Wb.none;
    if (r instanceof Wb)
      return [r];
    let t = r.slice();
    return t.sort((i, n) => i.type.rank - n.type.rank), t;
  }
};
wr.none = [];
class Xq extends Error {
}
class ve {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(r, t, i) {
    this.content = r, this.openStart = t, this.openEnd = i;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(r, t) {
    let i = fQ(this.content, r + this.openStart, t);
    return i && new ve(i, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(r, t) {
    return new ve(YQ(this.content, r + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(r) {
    return this.content.eq(r.content) && this.openStart == r.openStart && this.openEnd == r.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let r = { content: this.content.toJSON() };
    return this.openStart > 0 && (r.openStart = this.openStart), this.openEnd > 0 && (r.openEnd = this.openEnd), r;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(r, t) {
    if (!t)
      return ve.empty;
    let i = t.openStart || 0, n = t.openEnd || 0;
    if (typeof i != "number" || typeof n != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new ve(Fe.fromJSON(r, t.content), i, n);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(r, t = !0) {
    let i = 0, n = 0;
    for (let s = r.firstChild; s && !s.isLeaf && (t || !s.type.spec.isolating); s = s.firstChild)
      i++;
    for (let s = r.lastChild; s && !s.isLeaf && (t || !s.type.spec.isolating); s = s.lastChild)
      n++;
    return new ve(r, i, n);
  }
}
ve.empty = new ve(Fe.empty, 0, 0);
function YQ(e, r, t) {
  let { index: i, offset: n } = e.findIndex(r), s = e.maybeChild(i), { index: u, offset: o } = e.findIndex(t);
  if (n == r || s.isText) {
    if (o != t && !e.child(u).isText)
      throw new RangeError("Removing non-flat range");
    return e.cut(0, r).append(e.cut(t));
  }
  if (i != u)
    throw new RangeError("Removing non-flat range");
  return e.replaceChild(i, s.copy(YQ(s.content, r - n - 1, t - n - 1)));
}
function fQ(e, r, t, i) {
  let { index: n, offset: s } = e.findIndex(r), u = e.maybeChild(n);
  if (s == r || u.isText)
    return e.cut(0, r).append(t).append(e.cut(r));
  let o = fQ(u.content, r - s - 1, t);
  return o && e.replaceChild(n, u.copy(o));
}
function k_e(e, r, t) {
  if (t.openStart > e.depth)
    throw new Xq("Inserted content deeper than insertion position");
  if (e.depth - t.openStart != r.depth - t.openEnd)
    throw new Xq("Inconsistent open depths");
  return KQ(e, r, t, 0);
}
function KQ(e, r, t, i) {
  let n = e.index(i), s = e.node(i);
  if (n == r.index(i) && i < e.depth - t.openStart) {
    let u = KQ(e, r, t, i + 1);
    return s.copy(s.content.replaceChild(n, u));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && e.depth == i && r.depth == i) {
      let u = e.parent, o = u.content;
      return Rd(u, o.cut(0, e.parentOffset).append(t.content).append(o.cut(r.parentOffset)));
    } else {
      let { start: u, end: o } = O_e(t, e);
      return Rd(s, pQ(e, u, o, r, i));
    }
  else return Rd(s, qq(e, r, i));
}
function hQ(e, r) {
  if (!r.type.compatibleContent(e.type))
    throw new Xq("Cannot join " + r.type.name + " onto " + e.type.name);
}
function Gb(e, r, t) {
  let i = e.node(t);
  return hQ(i, r.node(t)), i;
}
function Dd(e, r) {
  let t = r.length - 1;
  t >= 0 && e.isText && e.sameMarkup(r[t]) ? r[t] = e.withText(r[t].text + e.text) : r.push(e);
}
function zc(e, r, t, i) {
  let n = (r || e).node(t), s = 0, u = r ? r.index(t) : n.childCount;
  e && (s = e.index(t), e.depth > t ? s++ : e.textOffset && (Dd(e.nodeAfter, i), s++));
  for (let o = s; o < u; o++)
    Dd(n.child(o), i);
  r && r.depth == t && r.textOffset && Dd(r.nodeBefore, i);
}
function Rd(e, r) {
  return e.type.checkContent(r), e.copy(r);
}
function pQ(e, r, t, i, n) {
  let s = e.depth > n && Gb(e, r, n + 1), u = i.depth > n && Gb(t, i, n + 1), o = [];
  return zc(null, e, n, o), s && u && r.index(n) == t.index(n) ? (hQ(s, u), Dd(Rd(s, pQ(e, r, t, i, n + 1)), o)) : (s && Dd(Rd(s, qq(e, r, n + 1)), o), zc(r, t, n, o), u && Dd(Rd(u, qq(t, i, n + 1)), o)), zc(i, null, n, o), new Fe(o);
}
function qq(e, r, t) {
  let i = [];
  if (zc(null, e, t, i), e.depth > t) {
    let n = Gb(e, r, t + 1);
    Dd(Rd(n, qq(e, r, t + 1)), i);
  }
  return zc(r, null, t, i), new Fe(i);
}
function O_e(e, r) {
  let t = r.depth - e.openStart, n = r.node(t).copy(e.content);
  for (let s = t - 1; s >= 0; s--)
    n = r.node(s).copy(Fe.from(n));
  return {
    start: n.resolveNoCache(e.openStart + t),
    end: n.resolveNoCache(n.content.size - e.openEnd - t)
  };
}
class L7 {
  /**
  @internal
  */
  constructor(r, t, i) {
    this.pos = r, this.path = t, this.parentOffset = i, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(r) {
    return r == null ? this.depth : r < 0 ? this.depth + r : r;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(r) {
    return this.path[this.resolveDepth(r) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(r) {
    return this.path[this.resolveDepth(r) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(r) {
    return r = this.resolveDepth(r), this.index(r) + (r == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(r) {
    return r = this.resolveDepth(r), r == 0 ? 0 : this.path[r * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(r) {
    return r = this.resolveDepth(r), this.start(r) + this.node(r).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(r) {
    if (r = this.resolveDepth(r), !r)
      throw new RangeError("There is no position before the top-level node");
    return r == this.depth + 1 ? this.pos : this.path[r * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(r) {
    if (r = this.resolveDepth(r), !r)
      throw new RangeError("There is no position after the top-level node");
    return r == this.depth + 1 ? this.pos : this.path[r * 3 - 1] + this.path[r * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let r = this.parent, t = this.index(this.depth);
    if (t == r.childCount)
      return null;
    let i = this.pos - this.path[this.path.length - 1], n = r.child(t);
    return i ? r.child(t).cut(i) : n;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let r = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(r).cut(0, t) : r == 0 ? null : this.parent.child(r - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(r, t) {
    t = this.resolveDepth(t);
    let i = this.path[t * 3], n = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let s = 0; s < r; s++)
      n += i.child(s).nodeSize;
    return n;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let r = this.parent, t = this.index();
    if (r.content.size == 0)
      return wr.none;
    if (this.textOffset)
      return r.child(t).marks;
    let i = r.maybeChild(t - 1), n = r.maybeChild(t);
    if (!i) {
      let o = i;
      i = n, n = o;
    }
    let s = i.marks;
    for (var u = 0; u < s.length; u++)
      s[u].type.spec.inclusive === !1 && (!n || !s[u].isInSet(n.marks)) && (s = s[u--].removeFromSet(s));
    return s;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(r) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let i = t.marks, n = r.parent.maybeChild(r.index());
    for (var s = 0; s < i.length; s++)
      i[s].type.spec.inclusive === !1 && (!n || !i[s].isInSet(n.marks)) && (i = i[s--].removeFromSet(i));
    return i;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(r) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= r && this.end(t) >= r)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(r = this, t) {
    if (r.pos < this.pos)
      return r.blockRange(this);
    for (let i = this.depth - (this.parent.inlineContent || this.pos == r.pos ? 1 : 0); i >= 0; i--)
      if (r.pos <= this.end(i) && (!t || t(this.node(i))))
        return new Yq(this, r, i);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(r) {
    return this.pos - this.parentOffset == r.pos - r.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(r) {
    return r.pos > this.pos ? r : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(r) {
    return r.pos < this.pos ? r : this;
  }
  /**
  @internal
  */
  toString() {
    let r = "";
    for (let t = 1; t <= this.depth; t++)
      r += (r ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return r + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(r, t) {
    if (!(t >= 0 && t <= r.content.size))
      throw new RangeError("Position " + t + " out of range");
    let i = [], n = 0, s = t;
    for (let u = r; ; ) {
      let { index: o, offset: d } = u.content.findIndex(s), a = s - d;
      if (i.push(u, o, n + d), !a || (u = u.child(o), u.isText))
        break;
      s = a - 1, n += d + 1;
    }
    return new L7(t, i, s);
  }
  /**
  @internal
  */
  static resolveCached(r, t) {
    let i = lO.get(r);
    if (i)
      for (let s = 0; s < i.elts.length; s++) {
        let u = i.elts[s];
        if (u.pos == t)
          return u;
      }
    else
      lO.set(r, i = new D_e());
    let n = i.elts[i.i] = L7.resolve(r, t);
    return i.i = (i.i + 1) % R_e, n;
  }
}
class D_e {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const R_e = 12, lO = /* @__PURE__ */ new WeakMap();
class Yq {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(r, t, i) {
    this.$from = r, this.$to = t, this.depth = i;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const I_e = /* @__PURE__ */ Object.create(null);
let Id = class Ub {
  /**
  @internal
  */
  constructor(r, t, i, n = wr.none) {
    this.type = r, this.attrs = t, this.marks = n, this.content = i || Fe.empty;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(r) {
    return this.content.child(r);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(r) {
    return this.content.maybeChild(r);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(r) {
    this.content.forEach(r);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(r, t, i, n = 0) {
    this.content.nodesBetween(r, t, i, n, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(r) {
    this.nodesBetween(0, this.content.size, r);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(r, t, i, n) {
    return this.content.textBetween(r, t, i, n);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(r) {
    return this == r || this.sameMarkup(r) && this.content.eq(r.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(r) {
    return this.hasMarkup(r.type, r.attrs, r.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(r, t, i) {
    return this.type == r && xq(this.attrs, t || r.defaultAttrs || I_e) && wr.sameSet(this.marks, i || wr.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(r = null) {
    return r == this.content ? this : new Ub(this.type, this.attrs, r, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(r) {
    return r == this.marks ? this : new Ub(this.type, this.attrs, this.content, r);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(r, t = this.content.size) {
    return r == 0 && t == this.content.size ? this : this.copy(this.content.cut(r, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(r, t = this.content.size, i = !1) {
    if (r == t)
      return ve.empty;
    let n = this.resolve(r), s = this.resolve(t), u = i ? 0 : n.sharedDepth(t), o = n.start(u), a = n.node(u).content.cut(n.pos - o, s.pos - o);
    return new ve(a, n.depth - u, s.depth - u);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(r, t, i) {
    return k_e(this.resolve(r), this.resolve(t), i);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(r) {
    for (let t = this; ; ) {
      let { index: i, offset: n } = t.content.findIndex(r);
      if (t = t.maybeChild(i), !t)
        return null;
      if (n == r || t.isText)
        return t;
      r -= n + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(r) {
    let { index: t, offset: i } = this.content.findIndex(r);
    return { node: this.content.maybeChild(t), index: t, offset: i };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(r) {
    if (r == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: i } = this.content.findIndex(r);
    if (i < r)
      return { node: this.content.child(t), index: t, offset: i };
    let n = this.content.child(t - 1);
    return { node: n, index: t - 1, offset: i - n.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(r) {
    return L7.resolveCached(this, r);
  }
  /**
  @internal
  */
  resolveNoCache(r) {
    return L7.resolve(this, r);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(r, t, i) {
    let n = !1;
    return t > r && this.nodesBetween(r, t, (s) => (i.isInSet(s.marks) && (n = !0), !n)), n;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let r = this.type.name;
    return this.content.size && (r += "(" + this.content.toStringInner() + ")"), mQ(this.marks, r);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(r) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, r);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(r, t, i = Fe.empty, n = 0, s = i.childCount) {
    let u = this.contentMatchAt(r).matchFragment(i, n, s), o = u && u.matchFragment(this.content, t);
    if (!o || !o.validEnd)
      return !1;
    for (let d = n; d < s; d++)
      if (!this.type.allowsMarks(i.child(d).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(r, t, i, n) {
    if (n && !this.type.allowsMarks(n))
      return !1;
    let s = this.contentMatchAt(r).matchType(i), u = s && s.matchFragment(this.content, t);
    return u ? u.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(r) {
    return r.content.size ? this.canReplace(this.childCount, this.childCount, r.content) : this.type.compatibleContent(r.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let r = wr.none;
    for (let t = 0; t < this.marks.length; t++) {
      let i = this.marks[t];
      i.type.checkAttrs(i.attrs), r = i.addToSet(r);
    }
    if (!wr.sameSet(r, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let r = { type: this.type.name };
    for (let t in this.attrs) {
      r.attrs = this.attrs;
      break;
    }
    return this.content.size && (r.content = this.content.toJSON()), this.marks.length && (r.marks = this.marks.map((t) => t.toJSON())), r;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(r, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let i;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      i = t.marks.map(r.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return r.text(t.text, i);
    }
    let n = Fe.fromJSON(r, t.content), s = r.nodeType(t.type).create(t.attrs, n, i);
    return s.type.checkAttrs(s.attrs), s;
  }
};
Id.prototype.text = void 0;
class fq extends Id {
  /**
  @internal
  */
  constructor(r, t, i, n) {
    if (super(r, t, null, n), !i)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = i;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : mQ(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(r, t) {
    return this.text.slice(r, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(r) {
    return r == this.marks ? this : new fq(this.type, this.attrs, this.text, r);
  }
  withText(r) {
    return r == this.text ? this : new fq(this.type, this.attrs, r, this.marks);
  }
  cut(r = 0, t = this.text.length) {
    return r == 0 && t == this.text.length ? this : this.withText(this.text.slice(r, t));
  }
  eq(r) {
    return this.sameMarkup(r) && this.text == r.text;
  }
  toJSON() {
    let r = super.toJSON();
    return r.text = this.text, r;
  }
}
function mQ(e, r) {
  for (let t = e.length - 1; t >= 0; t--)
    r = e[t].type.name + "(" + r + ")";
  return r;
}
class ta {
  /**
  @internal
  */
  constructor(r) {
    this.validEnd = r, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(r, t) {
    let i = new L_e(r, t);
    if (i.next == null)
      return ta.empty;
    let n = gQ(i);
    i.next && i.err("Unexpected trailing text");
    let s = G_e(W_e(n));
    return U_e(s, i), s;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(r) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == r)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(r, t = 0, i = r.childCount) {
    let n = this;
    for (let s = t; n && s < i; s++)
      n = n.matchType(r.child(s).type);
    return n;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let r = 0; r < this.next.length; r++) {
      let { type: t } = this.next[r];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(r) {
    for (let t = 0; t < this.next.length; t++)
      for (let i = 0; i < r.next.length; i++)
        if (this.next[t].type == r.next[i].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(r, t = !1, i = 0) {
    let n = [this];
    function s(u, o) {
      let d = u.matchFragment(r, i);
      if (d && (!t || d.validEnd))
        return Fe.from(o.map((a) => a.createAndFill()));
      for (let a = 0; a < u.next.length; a++) {
        let { type: V, next: c } = u.next[a];
        if (!(V.isText || V.hasRequiredAttrs()) && n.indexOf(c) == -1) {
          n.push(c);
          let F = s(c, o.concat(V));
          if (F)
            return F;
        }
      }
      return null;
    }
    return s(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(r) {
    for (let i = 0; i < this.wrapCache.length; i += 2)
      if (this.wrapCache[i] == r)
        return this.wrapCache[i + 1];
    let t = this.computeWrapping(r);
    return this.wrapCache.push(r, t), t;
  }
  /**
  @internal
  */
  computeWrapping(r) {
    let t = /* @__PURE__ */ Object.create(null), i = [{ match: this, type: null, via: null }];
    for (; i.length; ) {
      let n = i.shift(), s = n.match;
      if (s.matchType(r)) {
        let u = [];
        for (let o = n; o.type; o = o.via)
          u.push(o.type);
        return u.reverse();
      }
      for (let u = 0; u < s.next.length; u++) {
        let { type: o, next: d } = s.next[u];
        !o.isLeaf && !o.hasRequiredAttrs() && !(o.name in t) && (!n.type || d.validEnd) && (i.push({ match: o.contentMatch, type: o, via: n }), t[o.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(r) {
    if (r >= this.next.length)
      throw new RangeError(`There's no ${r}th edge in this content match`);
    return this.next[r];
  }
  /**
  @internal
  */
  toString() {
    let r = [];
    function t(i) {
      r.push(i);
      for (let n = 0; n < i.next.length; n++)
        r.indexOf(i.next[n].next) == -1 && t(i.next[n].next);
    }
    return t(this), r.map((i, n) => {
      let s = n + (i.validEnd ? "*" : " ") + " ";
      for (let u = 0; u < i.next.length; u++)
        s += (u ? ", " : "") + i.next[u].type.name + "->" + r.indexOf(i.next[u].next);
      return s;
    }).join(`
`);
  }
}
ta.empty = new ta(!0);
class L_e {
  constructor(r, t) {
    this.string = r, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = r.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(r) {
    return this.next == r && (this.pos++ || !0);
  }
  err(r) {
    throw new SyntaxError(r + " (in content expression '" + this.string + "')");
  }
}
function gQ(e) {
  let r = [];
  do
    r.push(__e(e));
  while (e.eat("|"));
  return r.length == 1 ? r[0] : { type: "choice", exprs: r };
}
function __e(e) {
  let r = [];
  do
    r.push(H_e(e));
  while (e.next && e.next != ")" && e.next != "|");
  return r.length == 1 ? r[0] : { type: "seq", exprs: r };
}
function H_e(e) {
  let r = B_e(e);
  for (; ; )
    if (e.eat("+"))
      r = { type: "plus", expr: r };
    else if (e.eat("*"))
      r = { type: "star", expr: r };
    else if (e.eat("?"))
      r = { type: "opt", expr: r };
    else if (e.eat("{"))
      r = j_e(e, r);
    else
      break;
  return r;
}
function cO(e) {
  /\D/.test(e.next) && e.err("Expected number, got '" + e.next + "'");
  let r = Number(e.next);
  return e.pos++, r;
}
function j_e(e, r) {
  let t = cO(e), i = t;
  return e.eat(",") && (e.next != "}" ? i = cO(e) : i = -1), e.eat("}") || e.err("Unclosed braced range"), { type: "range", min: t, max: i, expr: r };
}
function z_e(e, r) {
  let t = e.nodeTypes, i = t[r];
  if (i)
    return [i];
  let n = [];
  for (let s in t) {
    let u = t[s];
    u.isInGroup(r) && n.push(u);
  }
  return n.length == 0 && e.err("No node type or group '" + r + "' found"), n;
}
function B_e(e) {
  if (e.eat("(")) {
    let r = gQ(e);
    return e.eat(")") || e.err("Missing closing paren"), r;
  } else if (/\W/.test(e.next))
    e.err("Unexpected token '" + e.next + "'");
  else {
    let r = z_e(e, e.next).map((t) => (e.inline == null ? e.inline = t.isInline : e.inline != t.isInline && e.err("Mixing inline and block content"), { type: "name", value: t }));
    return e.pos++, r.length == 1 ? r[0] : { type: "choice", exprs: r };
  }
}
function W_e(e) {
  let r = [[]];
  return n(s(e, 0), t()), r;
  function t() {
    return r.push([]) - 1;
  }
  function i(u, o, d) {
    let a = { term: d, to: o };
    return r[u].push(a), a;
  }
  function n(u, o) {
    u.forEach((d) => d.to = o);
  }
  function s(u, o) {
    if (u.type == "choice")
      return u.exprs.reduce((d, a) => d.concat(s(a, o)), []);
    if (u.type == "seq")
      for (let d = 0; ; d++) {
        let a = s(u.exprs[d], o);
        if (d == u.exprs.length - 1)
          return a;
        n(a, o = t());
      }
    else if (u.type == "star") {
      let d = t();
      return i(o, d), n(s(u.expr, d), d), [i(d)];
    } else if (u.type == "plus") {
      let d = t();
      return n(s(u.expr, o), d), n(s(u.expr, d), d), [i(d)];
    } else {
      if (u.type == "opt")
        return [i(o)].concat(s(u.expr, o));
      if (u.type == "range") {
        let d = o;
        for (let a = 0; a < u.min; a++) {
          let V = t();
          n(s(u.expr, d), V), d = V;
        }
        if (u.max == -1)
          n(s(u.expr, d), d);
        else
          for (let a = u.min; a < u.max; a++) {
            let V = t();
            i(d, V), n(s(u.expr, d), V), d = V;
          }
        return [i(d)];
      } else {
        if (u.type == "name")
          return [i(o, void 0, u.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function vQ(e, r) {
  return r - e;
}
function FO(e, r) {
  let t = [];
  return i(r), t.sort(vQ);
  function i(n) {
    let s = e[n];
    if (s.length == 1 && !s[0].term)
      return i(s[0].to);
    t.push(n);
    for (let u = 0; u < s.length; u++) {
      let { term: o, to: d } = s[u];
      !o && t.indexOf(d) == -1 && i(d);
    }
  }
}
function G_e(e) {
  let r = /* @__PURE__ */ Object.create(null);
  return t(FO(e, 0));
  function t(i) {
    let n = [];
    i.forEach((u) => {
      e[u].forEach(({ term: o, to: d }) => {
        if (!o)
          return;
        let a;
        for (let V = 0; V < n.length; V++)
          n[V][0] == o && (a = n[V][1]);
        FO(e, d).forEach((V) => {
          a || n.push([o, a = []]), a.indexOf(V) == -1 && a.push(V);
        });
      });
    });
    let s = r[i.join(",")] = new ta(i.indexOf(e.length - 1) > -1);
    for (let u = 0; u < n.length; u++) {
      let o = n[u][1].sort(vQ);
      s.next.push({ type: n[u][0], next: r[o.join(",")] || t(o) });
    }
    return s;
  }
}
function U_e(e, r) {
  for (let t = 0, i = [e]; t < i.length; t++) {
    let n = i[t], s = !n.validEnd, u = [];
    for (let o = 0; o < n.next.length; o++) {
      let { type: d, next: a } = n.next[o];
      u.push(d.name), s && !(d.isText || d.hasRequiredAttrs()) && (s = !1), i.indexOf(a) == -1 && i.push(a);
    }
    s && r.err("Only non-generatable nodes (" + u.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function bQ(e) {
  let r = /* @__PURE__ */ Object.create(null);
  for (let t in e) {
    let i = e[t];
    if (!i.hasDefault)
      return null;
    r[t] = i.default;
  }
  return r;
}
function yQ(e, r) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let i in e) {
    let n = r && r[i];
    if (n === void 0) {
      let s = e[i];
      if (s.hasDefault)
        n = s.default;
      else
        throw new RangeError("No value supplied for attribute " + i);
    }
    t[i] = n;
  }
  return t;
}
function AQ(e, r, t, i) {
  for (let n in r)
    if (!(n in e))
      throw new RangeError(`Unsupported attribute ${n} for ${t} of type ${n}`);
  for (let n in e) {
    let s = e[n];
    s.validate && s.validate(r[n]);
  }
}
function wQ(e, r) {
  let t = /* @__PURE__ */ Object.create(null);
  if (r)
    for (let i in r)
      t[i] = new J_e(e, i, r[i]);
  return t;
}
let xO = class CQ {
  /**
  @internal
  */
  constructor(r, t, i) {
    this.name = r, this.schema = t, this.spec = i, this.markSet = null, this.groups = i.group ? i.group.split(" ") : [], this.attrs = wQ(r, i.attrs), this.defaultAttrs = bQ(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(i.inline || r == "text"), this.isText = r == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == ta.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(r) {
    return this.groups.indexOf(r) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let r in this.attrs)
      if (this.attrs[r].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(r) {
    return this == r || this.contentMatch.compatible(r.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(r) {
    return !r && this.defaultAttrs ? this.defaultAttrs : yQ(this.attrs, r);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(r = null, t, i) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Id(this, this.computeAttrs(r), Fe.from(t), wr.setFrom(i));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(r = null, t, i) {
    return t = Fe.from(t), this.checkContent(t), new Id(this, this.computeAttrs(r), t, wr.setFrom(i));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(r = null, t, i) {
    if (r = this.computeAttrs(r), t = Fe.from(t), t.size) {
      let u = this.contentMatch.fillBefore(t);
      if (!u)
        return null;
      t = u.append(t);
    }
    let n = this.contentMatch.matchFragment(t), s = n && n.fillBefore(Fe.empty, !0);
    return s ? new Id(this, r, t.append(s), wr.setFrom(i)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(r) {
    let t = this.contentMatch.matchFragment(r);
    if (!t || !t.validEnd)
      return !1;
    for (let i = 0; i < r.childCount; i++)
      if (!this.allowsMarks(r.child(i).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(r) {
    if (!this.validContent(r))
      throw new RangeError(`Invalid content for node ${this.name}: ${r.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(r) {
    AQ(this.attrs, r, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(r) {
    return this.markSet == null || this.markSet.indexOf(r) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(r) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < r.length; t++)
      if (!this.allowsMarkType(r[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(r) {
    if (this.markSet == null)
      return r;
    let t;
    for (let i = 0; i < r.length; i++)
      this.allowsMarkType(r[i].type) ? t && t.push(r[i]) : t || (t = r.slice(0, i));
    return t ? t.length ? t : wr.none : r;
  }
  /**
  @internal
  */
  static compile(r, t) {
    let i = /* @__PURE__ */ Object.create(null);
    r.forEach((s, u) => i[s] = new CQ(s, t, u));
    let n = t.spec.topNode || "doc";
    if (!i[n])
      throw new RangeError("Schema is missing its top node type ('" + n + "')");
    if (!i.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let s in i.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return i;
  }
};
function Z_e(e, r, t) {
  let i = t.split("|");
  return (n) => {
    let s = n === null ? "null" : typeof n;
    if (i.indexOf(s) < 0)
      throw new RangeError(`Expected value of type ${i} for attribute ${r} on type ${e}, got ${s}`);
  };
}
class J_e {
  constructor(r, t, i) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(i, "default"), this.default = i.default, this.validate = typeof i.validate == "string" ? Z_e(r, t, i.validate) : i.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Tf {
  /**
  @internal
  */
  constructor(r, t, i, n) {
    this.name = r, this.rank = t, this.schema = i, this.spec = n, this.attrs = wQ(r, n.attrs), this.excluded = null;
    let s = bQ(this.attrs);
    this.instance = s ? new wr(this, s) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(r = null) {
    return !r && this.instance ? this.instance : new wr(this, yQ(this.attrs, r));
  }
  /**
  @internal
  */
  static compile(r, t) {
    let i = /* @__PURE__ */ Object.create(null), n = 0;
    return r.forEach((s, u) => i[s] = new Tf(s, n++, t, u)), i;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(r) {
    for (var t = 0; t < r.length; t++)
      r[t].type == this && (r = r.slice(0, t).concat(r.slice(t + 1)), t--);
    return r;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(r) {
    for (let t = 0; t < r.length; t++)
      if (r[t].type == this)
        return r[t];
  }
  /**
  @internal
  */
  checkAttrs(r) {
    AQ(this.attrs, r, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(r) {
    return this.excluded.indexOf(r) > -1;
  }
}
class P4 {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(r) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let n in r)
      t[n] = r[n];
    t.nodes = $t.from(r.nodes), t.marks = $t.from(r.marks || {}), this.nodes = xO.compile(this.spec.nodes, this), this.marks = Tf.compile(this.spec.marks, this);
    let i = /* @__PURE__ */ Object.create(null);
    for (let n in this.nodes) {
      if (n in this.marks)
        throw new RangeError(n + " can not be both a node and a mark");
      let s = this.nodes[n], u = s.spec.content || "", o = s.spec.marks;
      if (s.contentMatch = i[u] || (i[u] = ta.parse(u, this.nodes)), s.inlineContent = s.contentMatch.inlineContent, s.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!s.isInline || !s.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = s;
      }
      s.markSet = o == "_" ? null : o ? XO(this, o.split(" ")) : o == "" || !s.inlineContent ? [] : null;
    }
    for (let n in this.marks) {
      let s = this.marks[n], u = s.spec.excludes;
      s.excluded = u == null ? [s] : u == "" ? [] : XO(this, u.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(r, t = null, i, n) {
    if (typeof r == "string")
      r = this.nodeType(r);
    else if (r instanceof xO) {
      if (r.schema != this)
        throw new RangeError("Node type from different schema used (" + r.name + ")");
    } else throw new RangeError("Invalid node type: " + r);
    return r.createChecked(t, i, n);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(r, t) {
    let i = this.nodes.text;
    return new fq(i, i.defaultAttrs, r, wr.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(r, t) {
    return typeof r == "string" && (r = this.marks[r]), r.create(t);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(r) {
    return Id.fromJSON(this, r);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(r) {
    return wr.fromJSON(this, r);
  }
  /**
  @internal
  */
  nodeType(r) {
    let t = this.nodes[r];
    if (!t)
      throw new RangeError("Unknown node type: " + r);
    return t;
  }
}
function XO(e, r) {
  let t = [];
  for (let i = 0; i < r.length; i++) {
    let n = r[i], s = e.marks[n], u = s;
    if (s)
      t.push(s);
    else
      for (let o in e.marks) {
        let d = e.marks[o];
        (n == "_" || d.spec.group && d.spec.group.split(" ").indexOf(n) > -1) && t.push(u = d);
      }
    if (!u)
      throw new SyntaxError("Unknown mark type: '" + r[i] + "'");
  }
  return t;
}
function $_e(e) {
  return e.tag != null;
}
function Q_e(e) {
  return e.style != null;
}
class Mu {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(r, t) {
    this.schema = r, this.rules = t, this.tags = [], this.styles = [];
    let i = this.matchedStyles = [];
    t.forEach((n) => {
      if ($_e(n))
        this.tags.push(n);
      else if (Q_e(n)) {
        let s = /[^=]*/.exec(n.style)[0];
        i.indexOf(s) < 0 && i.push(s), this.styles.push(n);
      }
    }), this.normalizeLists = !this.tags.some((n) => {
      if (!/^(ul|ol)\b/.test(n.tag) || !n.node)
        return !1;
      let s = r.nodes[n.node];
      return s.contentMatch.matchType(s);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(r, t = {}) {
    let i = new YO(this, t, !1);
    return i.addAll(r, wr.none, t.from, t.to), i.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(r, t = {}) {
    let i = new YO(this, t, !0);
    return i.addAll(r, wr.none, t.from, t.to), ve.maxOpen(i.finish());
  }
  /**
  @internal
  */
  matchTag(r, t, i) {
    for (let n = i ? this.tags.indexOf(i) + 1 : 0; n < this.tags.length; n++) {
      let s = this.tags[n];
      if (tHe(r, s.tag) && (s.namespace === void 0 || r.namespaceURI == s.namespace) && (!s.context || t.matchesContext(s.context))) {
        if (s.getAttrs) {
          let u = s.getAttrs(r);
          if (u === !1)
            continue;
          s.attrs = u || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(r, t, i, n) {
    for (let s = n ? this.styles.indexOf(n) + 1 : 0; s < this.styles.length; s++) {
      let u = this.styles[s], o = u.style;
      if (!(o.indexOf(r) != 0 || u.context && !i.matchesContext(u.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      o.length > r.length && (o.charCodeAt(r.length) != 61 || o.slice(r.length + 1) != t))) {
        if (u.getAttrs) {
          let d = u.getAttrs(t);
          if (d === !1)
            continue;
          u.attrs = d || void 0;
        }
        return u;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(r) {
    let t = [];
    function i(n) {
      let s = n.priority == null ? 50 : n.priority, u = 0;
      for (; u < t.length; u++) {
        let o = t[u];
        if ((o.priority == null ? 50 : o.priority) < s)
          break;
      }
      t.splice(u, 0, n);
    }
    for (let n in r.marks) {
      let s = r.marks[n].spec.parseDOM;
      s && s.forEach((u) => {
        i(u = fO(u)), u.mark || u.ignore || u.clearMark || (u.mark = n);
      });
    }
    for (let n in r.nodes) {
      let s = r.nodes[n].spec.parseDOM;
      s && s.forEach((u) => {
        i(u = fO(u)), u.node || u.ignore || u.mark || (u.node = n);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(r) {
    return r.cached.domParser || (r.cached.domParser = new Mu(r, Mu.schemaRules(r)));
  }
}
const PQ = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, eHe = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, SQ = { ol: !0, ul: !0 }, Kq = 1, hq = 2, zx = 4;
function qO(e, r, t) {
  return r != null ? (r ? Kq : 0) | (r === "full" ? hq : 0) : e && e.whitespace == "pre" ? Kq | hq : t & -5;
}
class yx {
  constructor(r, t, i, n, s, u) {
    this.type = r, this.attrs = t, this.marks = i, this.solid = n, this.options = u, this.content = [], this.activeMarks = wr.none, this.match = s || (u & zx ? null : r.contentMatch);
  }
  findWrapping(r) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(Fe.from(r));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let i = this.type.contentMatch, n;
        return (n = i.findWrapping(r.type)) ? (this.match = i, n) : null;
      }
    }
    return this.match.findWrapping(r.type);
  }
  finish(r) {
    if (!(this.options & Kq)) {
      let i = this.content[this.content.length - 1], n;
      if (i && i.isText && (n = /[ \t\r\n\u000c]+$/.exec(i.text))) {
        let s = i;
        i.text.length == n[0].length ? this.content.pop() : this.content[this.content.length - 1] = s.withText(s.text.slice(0, s.text.length - n[0].length));
      }
    }
    let t = Fe.from(this.content);
    return !r && this.match && (t = t.append(this.match.fillBefore(Fe.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  inlineContext(r) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : r.parentNode && !PQ.hasOwnProperty(r.parentNode.nodeName.toLowerCase());
  }
}
class YO {
  constructor(r, t, i) {
    this.parser = r, this.options = t, this.isOpen = i, this.open = 0;
    let n = t.topNode, s, u = qO(null, t.preserveWhitespace, 0) | (i ? zx : 0);
    n ? s = new yx(n.type, n.attrs, wr.none, !0, t.topMatch || n.type.contentMatch, u) : i ? s = new yx(null, null, wr.none, !0, null, u) : s = new yx(r.schema.topNodeType, null, wr.none, !0, null, u), this.nodes = [s], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(r, t) {
    r.nodeType == 3 ? this.addTextNode(r, t) : r.nodeType == 1 && this.addElement(r, t);
  }
  addTextNode(r, t) {
    let i = r.nodeValue, n = this.top;
    if (n.options & hq || n.inlineContext(r) || /[^ \t\r\n\u000c]/.test(i)) {
      if (n.options & Kq)
        n.options & hq ? i = i.replace(/\r\n?/g, `
`) : i = i.replace(/\r?\n|\r/g, " ");
      else if (i = i.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(i) && this.open == this.nodes.length - 1) {
        let s = n.content[n.content.length - 1], u = r.previousSibling;
        (!s || u && u.nodeName == "BR" || s.isText && /[ \t\r\n\u000c]$/.test(s.text)) && (i = i.slice(1));
      }
      i && this.insertNode(this.parser.schema.text(i), t), this.findInText(r);
    } else
      this.findInside(r);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(r, t, i) {
    let n = r.nodeName.toLowerCase(), s;
    SQ.hasOwnProperty(n) && this.parser.normalizeLists && rHe(r);
    let u = this.options.ruleFromNode && this.options.ruleFromNode(r) || (s = this.parser.matchTag(r, this, i));
    if (u ? u.ignore : eHe.hasOwnProperty(n))
      this.findInside(r), this.ignoreFallback(r, t);
    else if (!u || u.skip || u.closeParent) {
      u && u.closeParent ? this.open = Math.max(0, this.open - 1) : u && u.skip.nodeType && (r = u.skip);
      let o, d = this.top, a = this.needsBlock;
      if (PQ.hasOwnProperty(n))
        d.content.length && d.content[0].isInline && this.open && (this.open--, d = this.top), o = !0, d.type || (this.needsBlock = !0);
      else if (!r.firstChild) {
        this.leafFallback(r, t);
        return;
      }
      let V = u && u.skip ? t : this.readStyles(r, t);
      V && this.addAll(r, V), o && this.sync(d), this.needsBlock = a;
    } else {
      let o = this.readStyles(r, t);
      o && this.addElementByRule(r, u, o, u.consuming === !1 ? s : void 0);
    }
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(r, t) {
    r.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(r.ownerDocument.createTextNode(`
`), t);
  }
  // Called for ignored nodes
  ignoreFallback(r, t) {
    r.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), t);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(r, t) {
    let i = r.style;
    if (i && i.length)
      for (let n = 0; n < this.parser.matchedStyles.length; n++) {
        let s = this.parser.matchedStyles[n], u = i.getPropertyValue(s);
        if (u)
          for (let o = void 0; ; ) {
            let d = this.parser.matchStyle(s, u, this, o);
            if (!d)
              break;
            if (d.ignore)
              return null;
            if (d.clearMark ? t = t.filter((a) => !d.clearMark(a)) : t = t.concat(this.parser.schema.marks[d.mark].create(d.attrs)), d.consuming === !1)
              o = d;
            else
              break;
          }
      }
    return t;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(r, t, i, n) {
    let s, u;
    if (t.node)
      if (u = this.parser.schema.nodes[t.node], u.isLeaf)
        this.insertNode(u.create(t.attrs), i) || this.leafFallback(r, i);
      else {
        let d = this.enter(u, t.attrs || null, i, t.preserveWhitespace);
        d && (s = !0, i = d);
      }
    else {
      let d = this.parser.schema.marks[t.mark];
      i = i.concat(d.create(t.attrs));
    }
    let o = this.top;
    if (u && u.isLeaf)
      this.findInside(r);
    else if (n)
      this.addElement(r, i, n);
    else if (t.getContent)
      this.findInside(r), t.getContent(r, this.parser.schema).forEach((d) => this.insertNode(d, i));
    else {
      let d = r;
      typeof t.contentElement == "string" ? d = r.querySelector(t.contentElement) : typeof t.contentElement == "function" ? d = t.contentElement(r) : t.contentElement && (d = t.contentElement), this.findAround(r, d, !0), this.addAll(d, i), this.findAround(r, d, !1);
    }
    s && this.sync(o) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(r, t, i, n) {
    let s = i || 0;
    for (let u = i ? r.childNodes[i] : r.firstChild, o = n == null ? null : r.childNodes[n]; u != o; u = u.nextSibling, ++s)
      this.findAtPoint(r, s), this.addDOM(u, t);
    this.findAtPoint(r, s);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(r, t) {
    let i, n;
    for (let s = this.open; s >= 0; s--) {
      let u = this.nodes[s], o = u.findWrapping(r);
      if (o && (!i || i.length > o.length) && (i = o, n = u, !o.length) || u.solid)
        break;
    }
    if (!i)
      return null;
    this.sync(n);
    for (let s = 0; s < i.length; s++)
      t = this.enterInner(i[s], null, t, !1);
    return t;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(r, t) {
    if (r.isInline && this.needsBlock && !this.top.type) {
      let n = this.textblockFromContext();
      n && (t = this.enterInner(n, null, t));
    }
    let i = this.findPlace(r, t);
    if (i) {
      this.closeExtra();
      let n = this.top;
      n.match && (n.match = n.match.matchType(r.type));
      let s = wr.none;
      for (let u of i.concat(r.marks))
        (n.type ? n.type.allowsMarkType(u.type) : KO(u.type, r.type)) && (s = u.addToSet(s));
      return n.content.push(r.mark(s)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(r, t, i, n) {
    let s = this.findPlace(r.create(t), i);
    return s && (s = this.enterInner(r, t, i, !0, n)), s;
  }
  // Open a node of the given type
  enterInner(r, t, i, n = !1, s) {
    this.closeExtra();
    let u = this.top;
    u.match = u.match && u.match.matchType(r);
    let o = qO(r, s, u.options);
    u.options & zx && u.content.length == 0 && (o |= zx);
    let d = wr.none;
    return i = i.filter((a) => (u.type ? u.type.allowsMarkType(a.type) : KO(a.type, r)) ? (d = a.addToSet(d), !1) : !0), this.nodes.push(new yx(r, t, d, n, null, o)), this.open++, i;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(r = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(r));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(this.isOpen || this.options.topOpen);
  }
  sync(r) {
    for (let t = this.open; t >= 0; t--)
      if (this.nodes[t] == r)
        return this.open = t, !0;
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let r = 0;
    for (let t = this.open; t >= 0; t--) {
      let i = this.nodes[t].content;
      for (let n = i.length - 1; n >= 0; n--)
        r += i[n].nodeSize;
      t && r++;
    }
    return r;
  }
  findAtPoint(r, t) {
    if (this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].node == r && this.find[i].offset == t && (this.find[i].pos = this.currentPos);
  }
  findInside(r) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && r.nodeType == 1 && r.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(r, t, i) {
    if (r != t && this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && r.nodeType == 1 && r.contains(this.find[n].node) && t.compareDocumentPosition(this.find[n].node) & (i ? 2 : 4) && (this.find[n].pos = this.currentPos);
  }
  findInText(r) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == r && (this.find[t].pos = this.currentPos - (r.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(r) {
    if (r.indexOf("|") > -1)
      return r.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = r.split("/"), i = this.options.context, n = !this.isOpen && (!i || i.parent.type == this.nodes[0].type), s = -(i ? i.depth + 1 : 0) + (n ? 0 : 1), u = (o, d) => {
      for (; o >= 0; o--) {
        let a = t[o];
        if (a == "") {
          if (o == t.length - 1 || o == 0)
            continue;
          for (; d >= s; d--)
            if (u(o - 1, d))
              return !0;
          return !1;
        } else {
          let V = d > 0 || d == 0 && n ? this.nodes[d].type : i && d >= s ? i.node(d - s).type : null;
          if (!V || V.name != a && !V.isInGroup(a))
            return !1;
          d--;
        }
      }
      return !0;
    };
    return u(t.length - 1, this.open);
  }
  textblockFromContext() {
    let r = this.options.context;
    if (r)
      for (let t = r.depth; t >= 0; t--) {
        let i = r.node(t).contentMatchAt(r.indexAfter(t)).defaultType;
        if (i && i.isTextblock && i.defaultAttrs)
          return i;
      }
    for (let t in this.parser.schema.nodes) {
      let i = this.parser.schema.nodes[t];
      if (i.isTextblock && i.defaultAttrs)
        return i;
    }
  }
}
function rHe(e) {
  for (let r = e.firstChild, t = null; r; r = r.nextSibling) {
    let i = r.nodeType == 1 ? r.nodeName.toLowerCase() : null;
    i && SQ.hasOwnProperty(i) && t ? (t.appendChild(r), r = t) : i == "li" ? t = r : i && (t = null);
  }
}
function tHe(e, r) {
  return (e.matches || e.msMatchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector).call(e, r);
}
function fO(e) {
  let r = {};
  for (let t in e)
    r[t] = e[t];
  return r;
}
function KO(e, r) {
  let t = r.schema.nodes;
  for (let i in t) {
    let n = t[i];
    if (!n.allowsMarkType(e))
      continue;
    let s = [], u = (o) => {
      s.push(o);
      for (let d = 0; d < o.edgeCount; d++) {
        let { type: a, next: V } = o.edge(d);
        if (a == r || s.indexOf(V) < 0 && u(V))
          return !0;
      }
    };
    if (u(n.contentMatch))
      return !0;
  }
}
class qa {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(r, t) {
    this.nodes = r, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(r, t = {}, i) {
    i || (i = Cg(t).createDocumentFragment());
    let n = i, s = [];
    return r.forEach((u) => {
      if (s.length || u.marks.length) {
        let o = 0, d = 0;
        for (; o < s.length && d < u.marks.length; ) {
          let a = u.marks[d];
          if (!this.marks[a.type.name]) {
            d++;
            continue;
          }
          if (!a.eq(s[o][0]) || a.type.spec.spanning === !1)
            break;
          o++, d++;
        }
        for (; o < s.length; )
          n = s.pop()[1];
        for (; d < u.marks.length; ) {
          let a = u.marks[d++], V = this.serializeMark(a, u.isInline, t);
          V && (s.push([a, n]), n.appendChild(V.dom), n = V.contentDOM || V.dom);
        }
      }
      n.appendChild(this.serializeNodeInner(u, t));
    }), i;
  }
  /**
  @internal
  */
  serializeNodeInner(r, t) {
    let { dom: i, contentDOM: n } = Bx(Cg(t), this.nodes[r.type.name](r), null, r.attrs);
    if (n) {
      if (r.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(r.content, t, n);
    }
    return i;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(r, t = {}) {
    let i = this.serializeNodeInner(r, t);
    for (let n = r.marks.length - 1; n >= 0; n--) {
      let s = this.serializeMark(r.marks[n], r.isInline, t);
      s && ((s.contentDOM || s.dom).appendChild(i), i = s.dom);
    }
    return i;
  }
  /**
  @internal
  */
  serializeMark(r, t, i = {}) {
    let n = this.marks[r.type.name];
    return n && Bx(Cg(i), n(r, t), null, r.attrs);
  }
  static renderSpec(r, t, i = null, n) {
    return Bx(r, t, i, n);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(r) {
    return r.cached.domSerializer || (r.cached.domSerializer = new qa(this.nodesFromSchema(r), this.marksFromSchema(r)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(r) {
    let t = hO(r.nodes);
    return t.text || (t.text = (i) => i.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(r) {
    return hO(r.marks);
  }
}
function hO(e) {
  let r = {};
  for (let t in e) {
    let i = e[t].spec.toDOM;
    i && (r[t] = i);
  }
  return r;
}
function Cg(e) {
  return e.document || window.document;
}
const pO = /* @__PURE__ */ new WeakMap();
function iHe(e) {
  let r = pO.get(e);
  return r === void 0 && pO.set(e, r = nHe(e)), r;
}
function nHe(e) {
  let r = null;
  function t(i) {
    if (i && typeof i == "object")
      if (Array.isArray(i))
        if (typeof i[0] == "string")
          r || (r = []), r.push(i);
        else
          for (let n = 0; n < i.length; n++)
            t(i[n]);
      else
        for (let n in i)
          t(i[n]);
  }
  return t(e), r;
}
function Bx(e, r, t, i) {
  if (typeof r == "string")
    return { dom: e.createTextNode(r) };
  if (r.nodeType != null)
    return { dom: r };
  if (r.dom && r.dom.nodeType != null)
    return r;
  let n = r[0], s;
  if (typeof n != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (i && (s = iHe(i)) && s.indexOf(r) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let u = n.indexOf(" ");
  u > 0 && (t = n.slice(0, u), n = n.slice(u + 1));
  let o, d = t ? e.createElementNS(t, n) : e.createElement(n), a = r[1], V = 1;
  if (a && typeof a == "object" && a.nodeType == null && !Array.isArray(a)) {
    V = 2;
    for (let c in a)
      if (a[c] != null) {
        let F = c.indexOf(" ");
        F > 0 ? d.setAttributeNS(c.slice(0, F), c.slice(F + 1), a[c]) : d.setAttribute(c, a[c]);
      }
  }
  for (let c = V; c < r.length; c++) {
    let F = r[c];
    if (F === 0) {
      if (c < r.length - 1 || c > V)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: d, contentDOM: d };
    } else {
      let { dom: X, contentDOM: Y } = Bx(e, F, t, i);
      if (d.appendChild(X), Y) {
        if (o)
          throw new RangeError("Multiple content holes");
        o = Y;
      }
    }
  }
  return { dom: d, contentDOM: o };
}
const NQ = 65535, MQ = Math.pow(2, 16);
function sHe(e, r) {
  return e + r * MQ;
}
function mO(e) {
  return e & NQ;
}
function uHe(e) {
  return (e - (e & NQ)) / MQ;
}
const TQ = 1, EQ = 2, Wx = 4, kQ = 8;
class Zb {
  /**
  @internal
  */
  constructor(r, t, i) {
    this.pos = r, this.delInfo = t, this.recover = i;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & kQ) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (TQ | Wx)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (EQ | Wx)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & Wx) > 0;
  }
}
class ln {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(r, t = !1) {
    if (this.ranges = r, this.inverted = t, !r.length && ln.empty)
      return ln.empty;
  }
  /**
  @internal
  */
  recover(r) {
    let t = 0, i = mO(r);
    if (!this.inverted)
      for (let n = 0; n < i; n++)
        t += this.ranges[n * 3 + 2] - this.ranges[n * 3 + 1];
    return this.ranges[i * 3] + t + uHe(r);
  }
  mapResult(r, t = 1) {
    return this._map(r, t, !1);
  }
  map(r, t = 1) {
    return this._map(r, t, !0);
  }
  /**
  @internal
  */
  _map(r, t, i) {
    let n = 0, s = this.inverted ? 2 : 1, u = this.inverted ? 1 : 2;
    for (let o = 0; o < this.ranges.length; o += 3) {
      let d = this.ranges[o] - (this.inverted ? n : 0);
      if (d > r)
        break;
      let a = this.ranges[o + s], V = this.ranges[o + u], c = d + a;
      if (r <= c) {
        let F = a ? r == d ? -1 : r == c ? 1 : t : t, X = d + n + (F < 0 ? 0 : V);
        if (i)
          return X;
        let Y = r == (t < 0 ? d : c) ? null : sHe(o / 3, r - d), q = r == d ? EQ : r == c ? TQ : Wx;
        return (t < 0 ? r != d : r != c) && (q |= kQ), new Zb(X, q, Y);
      }
      n += V - a;
    }
    return i ? r + n : new Zb(r + n, 0, null);
  }
  /**
  @internal
  */
  touches(r, t) {
    let i = 0, n = mO(t), s = this.inverted ? 2 : 1, u = this.inverted ? 1 : 2;
    for (let o = 0; o < this.ranges.length; o += 3) {
      let d = this.ranges[o] - (this.inverted ? i : 0);
      if (d > r)
        break;
      let a = this.ranges[o + s], V = d + a;
      if (r <= V && o == n * 3)
        return !0;
      i += this.ranges[o + u] - a;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(r) {
    let t = this.inverted ? 2 : 1, i = this.inverted ? 1 : 2;
    for (let n = 0, s = 0; n < this.ranges.length; n += 3) {
      let u = this.ranges[n], o = u - (this.inverted ? s : 0), d = u + (this.inverted ? 0 : s), a = this.ranges[n + t], V = this.ranges[n + i];
      r(o, o + a, d, d + V), s += V - a;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new ln(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(r) {
    return r == 0 ? ln.empty : new ln(r < 0 ? [0, -r, 0] : [0, 0, r]);
  }
}
ln.empty = new ln([]);
class pV {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(r = [], t, i = 0, n = r.length) {
    this.maps = r, this.mirror = t, this.from = i, this.to = n;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(r = 0, t = this.maps.length) {
    return new pV(this.maps, this.mirror, r, t);
  }
  /**
  @internal
  */
  copy() {
    return new pV(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(r, t) {
    this.to = this.maps.push(r), t != null && this.setMirror(this.maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(r) {
    for (let t = 0, i = this.maps.length; t < r.maps.length; t++) {
      let n = r.getMirror(t);
      this.appendMap(r.maps[t], n != null && n < t ? i + n : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(r) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == r)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(r, t) {
    this.mirror || (this.mirror = []), this.mirror.push(r, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(r) {
    for (let t = r.maps.length - 1, i = this.maps.length + r.maps.length; t >= 0; t--) {
      let n = r.getMirror(t);
      this.appendMap(r.maps[t].invert(), n != null && n > t ? i - n - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let r = new pV();
    return r.appendMappingInverted(this), r;
  }
  /**
  Map a position through this mapping.
  */
  map(r, t = 1) {
    if (this.mirror)
      return this._map(r, t, !0);
    for (let i = this.from; i < this.to; i++)
      r = this.maps[i].map(r, t);
    return r;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(r, t = 1) {
    return this._map(r, t, !1);
  }
  /**
  @internal
  */
  _map(r, t, i) {
    let n = 0;
    for (let s = this.from; s < this.to; s++) {
      let u = this.maps[s], o = u.mapResult(r, t);
      if (o.recover != null) {
        let d = this.getMirror(s);
        if (d != null && d > s && d < this.to) {
          s = d, r = this.maps[d].recover(o.recover);
          continue;
        }
      }
      n |= o.delInfo, r = o.pos;
    }
    return i ? r : new Zb(r, n, null);
  }
}
const Pg = /* @__PURE__ */ Object.create(null);
class Ki {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return ln.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(r) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(r, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let i = Pg[t.stepType];
    if (!i)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return i.fromJSON(r, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(r, t) {
    if (r in Pg)
      throw new RangeError("Duplicate use of step JSON ID " + r);
    return Pg[r] = t, t.prototype.jsonID = r, t;
  }
}
class ft {
  /**
  @internal
  */
  constructor(r, t) {
    this.doc = r, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(r) {
    return new ft(r, null);
  }
  /**
  Create a failed step result.
  */
  static fail(r) {
    return new ft(null, r);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(r, t, i, n) {
    try {
      return ft.ok(r.replace(t, i, n));
    } catch (s) {
      if (s instanceof Xq)
        return ft.fail(s.message);
      throw s;
    }
  }
}
function S4(e, r, t) {
  let i = [];
  for (let n = 0; n < e.childCount; n++) {
    let s = e.child(n);
    s.content.size && (s = s.copy(S4(s.content, r, s))), s.isInline && (s = r(s, t, n)), i.push(s);
  }
  return Fe.fromArray(i);
}
class wo extends Ki {
  /**
  Create a mark step.
  */
  constructor(r, t, i) {
    super(), this.from = r, this.to = t, this.mark = i;
  }
  apply(r) {
    let t = r.slice(this.from, this.to), i = r.resolve(this.from), n = i.node(i.sharedDepth(this.to)), s = new ve(S4(t.content, (u, o) => !u.isAtom || !o.type.allowsMarkType(this.mark.type) ? u : u.mark(this.mark.addToSet(u.marks)), n), t.openStart, t.openEnd);
    return ft.fromReplace(r, this.from, this.to, s);
  }
  invert() {
    return new Es(this.from, this.to, this.mark);
  }
  map(r) {
    let t = r.mapResult(this.from, 1), i = r.mapResult(this.to, -1);
    return t.deleted && i.deleted || t.pos >= i.pos ? null : new wo(t.pos, i.pos, this.mark);
  }
  merge(r) {
    return r instanceof wo && r.mark.eq(this.mark) && this.from <= r.to && this.to >= r.from ? new wo(Math.min(this.from, r.from), Math.max(this.to, r.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(r, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new wo(t.from, t.to, r.markFromJSON(t.mark));
  }
}
Ki.jsonID("addMark", wo);
class Es extends Ki {
  /**
  Create a mark-removing step.
  */
  constructor(r, t, i) {
    super(), this.from = r, this.to = t, this.mark = i;
  }
  apply(r) {
    let t = r.slice(this.from, this.to), i = new ve(S4(t.content, (n) => n.mark(this.mark.removeFromSet(n.marks)), r), t.openStart, t.openEnd);
    return ft.fromReplace(r, this.from, this.to, i);
  }
  invert() {
    return new wo(this.from, this.to, this.mark);
  }
  map(r) {
    let t = r.mapResult(this.from, 1), i = r.mapResult(this.to, -1);
    return t.deleted && i.deleted || t.pos >= i.pos ? null : new Es(t.pos, i.pos, this.mark);
  }
  merge(r) {
    return r instanceof Es && r.mark.eq(this.mark) && this.from <= r.to && this.to >= r.from ? new Es(Math.min(this.from, r.from), Math.max(this.to, r.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(r, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new Es(t.from, t.to, r.markFromJSON(t.mark));
  }
}
Ki.jsonID("removeMark", Es);
class Co extends Ki {
  /**
  Create a node mark step.
  */
  constructor(r, t) {
    super(), this.pos = r, this.mark = t;
  }
  apply(r) {
    let t = r.nodeAt(this.pos);
    if (!t)
      return ft.fail("No node at mark step's position");
    let i = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return ft.fromReplace(r, this.pos, this.pos + 1, new ve(Fe.from(i), 0, t.isLeaf ? 0 : 1));
  }
  invert(r) {
    let t = r.nodeAt(this.pos);
    if (t) {
      let i = this.mark.addToSet(t.marks);
      if (i.length == t.marks.length) {
        for (let n = 0; n < t.marks.length; n++)
          if (!t.marks[n].isInSet(i))
            return new Co(this.pos, t.marks[n]);
        return new Co(this.pos, this.mark);
      }
    }
    return new dl(this.pos, this.mark);
  }
  map(r) {
    let t = r.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Co(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(r, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Co(t.pos, r.markFromJSON(t.mark));
  }
}
Ki.jsonID("addNodeMark", Co);
class dl extends Ki {
  /**
  Create a mark-removing step.
  */
  constructor(r, t) {
    super(), this.pos = r, this.mark = t;
  }
  apply(r) {
    let t = r.nodeAt(this.pos);
    if (!t)
      return ft.fail("No node at mark step's position");
    let i = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return ft.fromReplace(r, this.pos, this.pos + 1, new ve(Fe.from(i), 0, t.isLeaf ? 0 : 1));
  }
  invert(r) {
    let t = r.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new Co(this.pos, this.mark);
  }
  map(r) {
    let t = r.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new dl(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(r, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new dl(t.pos, r.markFromJSON(t.mark));
  }
}
Ki.jsonID("removeNodeMark", dl);
class It extends Ki {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(r, t, i, n = !1) {
    super(), this.from = r, this.to = t, this.slice = i, this.structure = n;
  }
  apply(r) {
    return this.structure && Jb(r, this.from, this.to) ? ft.fail("Structure replace would overwrite content") : ft.fromReplace(r, this.from, this.to, this.slice);
  }
  getMap() {
    return new ln([this.from, this.to - this.from, this.slice.size]);
  }
  invert(r) {
    return new It(this.from, this.from + this.slice.size, r.slice(this.from, this.to));
  }
  map(r) {
    let t = r.mapResult(this.from, 1), i = r.mapResult(this.to, -1);
    return t.deletedAcross && i.deletedAcross ? null : new It(t.pos, Math.max(t.pos, i.pos), this.slice);
  }
  merge(r) {
    if (!(r instanceof It) || r.structure || this.structure)
      return null;
    if (this.from + this.slice.size == r.from && !this.slice.openEnd && !r.slice.openStart) {
      let t = this.slice.size + r.slice.size == 0 ? ve.empty : new ve(this.slice.content.append(r.slice.content), this.slice.openStart, r.slice.openEnd);
      return new It(this.from, this.to + (r.to - r.from), t, this.structure);
    } else if (r.to == this.from && !this.slice.openStart && !r.slice.openEnd) {
      let t = this.slice.size + r.slice.size == 0 ? ve.empty : new ve(r.slice.content.append(this.slice.content), r.slice.openStart, this.slice.openEnd);
      return new It(r.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let r = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (r.slice = this.slice.toJSON()), this.structure && (r.structure = !0), r;
  }
  /**
  @internal
  */
  static fromJSON(r, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new It(t.from, t.to, ve.fromJSON(r, t.slice), !!t.structure);
  }
}
Ki.jsonID("replace", It);
class Ht extends Ki {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(r, t, i, n, s, u, o = !1) {
    super(), this.from = r, this.to = t, this.gapFrom = i, this.gapTo = n, this.slice = s, this.insert = u, this.structure = o;
  }
  apply(r) {
    if (this.structure && (Jb(r, this.from, this.gapFrom) || Jb(r, this.gapTo, this.to)))
      return ft.fail("Structure gap-replace would overwrite content");
    let t = r.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return ft.fail("Gap is not a flat range");
    let i = this.slice.insertAt(this.insert, t.content);
    return i ? ft.fromReplace(r, this.from, this.to, i) : ft.fail("Content does not fit in gap");
  }
  getMap() {
    return new ln([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(r) {
    let t = this.gapTo - this.gapFrom;
    return new Ht(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, r.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(r) {
    let t = r.mapResult(this.from, 1), i = r.mapResult(this.to, -1), n = this.from == this.gapFrom ? t.pos : r.map(this.gapFrom, -1), s = this.to == this.gapTo ? i.pos : r.map(this.gapTo, 1);
    return t.deletedAcross && i.deletedAcross || n < t.pos || s > i.pos ? null : new Ht(t.pos, i.pos, n, s, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let r = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (r.slice = this.slice.toJSON()), this.structure && (r.structure = !0), r;
  }
  /**
  @internal
  */
  static fromJSON(r, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new Ht(t.from, t.to, t.gapFrom, t.gapTo, ve.fromJSON(r, t.slice), t.insert, !!t.structure);
  }
}
Ki.jsonID("replaceAround", Ht);
function Jb(e, r, t) {
  let i = e.resolve(r), n = t - r, s = i.depth;
  for (; n > 0 && s > 0 && i.indexAfter(s) == i.node(s).childCount; )
    s--, n--;
  if (n > 0) {
    let u = i.node(s).maybeChild(i.indexAfter(s));
    for (; n > 0; ) {
      if (!u || u.isLeaf)
        return !0;
      u = u.firstChild, n--;
    }
  }
  return !1;
}
function oHe(e, r, t, i) {
  let n = [], s = [], u, o;
  e.doc.nodesBetween(r, t, (d, a, V) => {
    if (!d.isInline)
      return;
    let c = d.marks;
    if (!i.isInSet(c) && V.type.allowsMarkType(i.type)) {
      let F = Math.max(a, r), X = Math.min(a + d.nodeSize, t), Y = i.addToSet(c);
      for (let q = 0; q < c.length; q++)
        c[q].isInSet(Y) || (u && u.to == F && u.mark.eq(c[q]) ? u.to = X : n.push(u = new Es(F, X, c[q])));
      o && o.to == F ? o.to = X : s.push(o = new wo(F, X, i));
    }
  }), n.forEach((d) => e.step(d)), s.forEach((d) => e.step(d));
}
function dHe(e, r, t, i) {
  let n = [], s = 0;
  e.doc.nodesBetween(r, t, (u, o) => {
    if (!u.isInline)
      return;
    s++;
    let d = null;
    if (i instanceof Tf) {
      let a = u.marks, V;
      for (; V = i.isInSet(a); )
        (d || (d = [])).push(V), a = V.removeFromSet(a);
    } else i ? i.isInSet(u.marks) && (d = [i]) : d = u.marks;
    if (d && d.length) {
      let a = Math.min(o + u.nodeSize, t);
      for (let V = 0; V < d.length; V++) {
        let c = d[V], F;
        for (let X = 0; X < n.length; X++) {
          let Y = n[X];
          Y.step == s - 1 && c.eq(n[X].style) && (F = Y);
        }
        F ? (F.to = a, F.step = s) : n.push({ style: c, from: Math.max(o, r), to: a, step: s });
      }
    }
  }), n.forEach((u) => e.step(new Es(u.from, u.to, u.style)));
}
function N4(e, r, t, i = t.contentMatch, n = !0) {
  let s = e.doc.nodeAt(r), u = [], o = r + 1;
  for (let d = 0; d < s.childCount; d++) {
    let a = s.child(d), V = o + a.nodeSize, c = i.matchType(a.type);
    if (!c)
      u.push(new It(o, V, ve.empty));
    else {
      i = c;
      for (let F = 0; F < a.marks.length; F++)
        t.allowsMarkType(a.marks[F].type) || e.step(new Es(o, V, a.marks[F]));
      if (n && a.isText && t.whitespace != "pre") {
        let F, X = /\r?\n|\r/g, Y;
        for (; F = X.exec(a.text); )
          Y || (Y = new ve(Fe.from(t.schema.text(" ", t.allowedMarks(a.marks))), 0, 0)), u.push(new It(o + F.index, o + F.index + F[0].length, Y));
      }
    }
    o = V;
  }
  if (!i.validEnd) {
    let d = i.fillBefore(Fe.empty, !0);
    e.replace(o, o, new ve(d, 0, 0));
  }
  for (let d = u.length - 1; d >= 0; d--)
    e.step(u[d]);
}
function aHe(e, r, t) {
  return (r == 0 || e.canReplace(r, e.childCount)) && (t == e.childCount || e.canReplace(0, t));
}
function Il(e) {
  let t = e.parent.content.cutByIndex(e.startIndex, e.endIndex);
  for (let i = e.depth; ; --i) {
    let n = e.$from.node(i), s = e.$from.index(i), u = e.$to.indexAfter(i);
    if (i < e.depth && n.canReplace(s, u, t))
      return i;
    if (i == 0 || n.type.spec.isolating || !aHe(n, s, u))
      break;
  }
  return null;
}
function VHe(e, r, t) {
  let { $from: i, $to: n, depth: s } = r, u = i.before(s + 1), o = n.after(s + 1), d = u, a = o, V = Fe.empty, c = 0;
  for (let Y = s, q = !1; Y > t; Y--)
    q || i.index(Y) > 0 ? (q = !0, V = Fe.from(i.node(Y).copy(V)), c++) : d--;
  let F = Fe.empty, X = 0;
  for (let Y = s, q = !1; Y > t; Y--)
    q || n.after(Y + 1) < n.end(Y) ? (q = !0, F = Fe.from(n.node(Y).copy(F)), X++) : a++;
  e.step(new Ht(d, a, u, o, new ve(V.append(F), c, X), V.size - c, !0));
}
function M4(e, r, t = null, i = e) {
  let n = lHe(e, r), s = n && cHe(i, r);
  return s ? n.map(gO).concat({ type: r, attrs: t }).concat(s.map(gO)) : null;
}
function gO(e) {
  return { type: e, attrs: null };
}
function lHe(e, r) {
  let { parent: t, startIndex: i, endIndex: n } = e, s = t.contentMatchAt(i).findWrapping(r);
  if (!s)
    return null;
  let u = s.length ? s[0] : r;
  return t.canReplaceWith(i, n, u) ? s : null;
}
function cHe(e, r) {
  let { parent: t, startIndex: i, endIndex: n } = e, s = t.child(i), u = r.contentMatch.findWrapping(s.type);
  if (!u)
    return null;
  let d = (u.length ? u[u.length - 1] : r).contentMatch;
  for (let a = i; d && a < n; a++)
    d = d.matchType(t.child(a).type);
  return !d || !d.validEnd ? null : u;
}
function FHe(e, r, t) {
  let i = Fe.empty;
  for (let u = t.length - 1; u >= 0; u--) {
    if (i.size) {
      let o = t[u].type.contentMatch.matchFragment(i);
      if (!o || !o.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    i = Fe.from(t[u].type.create(t[u].attrs, i));
  }
  let n = r.start, s = r.end;
  e.step(new Ht(n, s, n, s, new ve(i, 0, 0), t.length, !0));
}
function xHe(e, r, t, i, n) {
  if (!i.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let s = e.steps.length;
  e.doc.nodesBetween(r, t, (u, o) => {
    let d = typeof n == "function" ? n(u) : n;
    if (u.isTextblock && !u.hasMarkup(i, d) && XHe(e.doc, e.mapping.slice(s).map(o), i)) {
      let a = null;
      if (i.schema.linebreakReplacement) {
        let X = i.whitespace == "pre", Y = !!i.contentMatch.matchType(i.schema.linebreakReplacement);
        X && !Y ? a = !1 : !X && Y && (a = !0);
      }
      a === !1 && DQ(e, u, o, s), N4(e, e.mapping.slice(s).map(o, 1), i, void 0, a === null);
      let V = e.mapping.slice(s), c = V.map(o, 1), F = V.map(o + u.nodeSize, 1);
      return e.step(new Ht(c, F, c + 1, F - 1, new ve(Fe.from(i.create(d, null, u.marks)), 0, 0), 1, !0)), a === !0 && OQ(e, u, o, s), !1;
    }
  });
}
function OQ(e, r, t, i) {
  r.forEach((n, s) => {
    if (n.isText) {
      let u, o = /\r?\n|\r/g;
      for (; u = o.exec(n.text); ) {
        let d = e.mapping.slice(i).map(t + 1 + s + u.index);
        e.replaceWith(d, d + 1, r.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function DQ(e, r, t, i) {
  r.forEach((n, s) => {
    if (n.type == n.type.schema.linebreakReplacement) {
      let u = e.mapping.slice(i).map(t + 1 + s);
      e.replaceWith(u, u + 1, r.type.schema.text(`
`));
    }
  });
}
function XHe(e, r, t) {
  let i = e.resolve(r), n = i.index();
  return i.parent.canReplaceWith(n, n + 1, t);
}
function qHe(e, r, t, i, n) {
  let s = e.doc.nodeAt(r);
  if (!s)
    throw new RangeError("No node at given position");
  t || (t = s.type);
  let u = t.create(i, null, n || s.marks);
  if (s.isLeaf)
    return e.replaceWith(r, r + s.nodeSize, u);
  if (!t.validContent(s.content))
    throw new RangeError("Invalid content for node type " + t.name);
  e.step(new Ht(r, r + s.nodeSize, r + 1, r + s.nodeSize - 1, new ve(Fe.from(u), 0, 0), 1, !0));
}
function Tu(e, r, t = 1, i) {
  let n = e.resolve(r), s = n.depth - t, u = i && i[i.length - 1] || n.parent;
  if (s < 0 || n.parent.type.spec.isolating || !n.parent.canReplace(n.index(), n.parent.childCount) || !u.type.validContent(n.parent.content.cutByIndex(n.index(), n.parent.childCount)))
    return !1;
  for (let a = n.depth - 1, V = t - 2; a > s; a--, V--) {
    let c = n.node(a), F = n.index(a);
    if (c.type.spec.isolating)
      return !1;
    let X = c.content.cutByIndex(F, c.childCount), Y = i && i[V + 1];
    Y && (X = X.replaceChild(0, Y.type.create(Y.attrs)));
    let q = i && i[V] || c;
    if (!c.canReplace(F + 1, c.childCount) || !q.type.validContent(X))
      return !1;
  }
  let o = n.indexAfter(s), d = i && i[0];
  return n.node(s).canReplaceWith(o, o, d ? d.type : n.node(s + 1).type);
}
function YHe(e, r, t = 1, i) {
  let n = e.doc.resolve(r), s = Fe.empty, u = Fe.empty;
  for (let o = n.depth, d = n.depth - t, a = t - 1; o > d; o--, a--) {
    s = Fe.from(n.node(o).copy(s));
    let V = i && i[a];
    u = Fe.from(V ? V.type.create(V.attrs, u) : n.node(o).copy(u));
  }
  e.step(new It(r, r, new ve(s.append(u), t, t), !0));
}
function id(e, r) {
  let t = e.resolve(r), i = t.index();
  return RQ(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(i, i + 1);
}
function fHe(e, r) {
  r.content.size || e.type.compatibleContent(r.type);
  let t = e.contentMatchAt(e.childCount), { linebreakReplacement: i } = e.type.schema;
  for (let n = 0; n < r.childCount; n++) {
    let s = r.child(n), u = s.type == i ? e.type.schema.nodes.text : s.type;
    if (t = t.matchType(u), !t || !e.type.allowsMarks(s.marks))
      return !1;
  }
  return t.validEnd;
}
function RQ(e, r) {
  return !!(e && r && !e.isLeaf && fHe(e, r));
}
function Ef(e, r, t = -1) {
  let i = e.resolve(r);
  for (let n = i.depth; ; n--) {
    let s, u, o = i.index(n);
    if (n == i.depth ? (s = i.nodeBefore, u = i.nodeAfter) : t > 0 ? (s = i.node(n + 1), o++, u = i.node(n).maybeChild(o)) : (s = i.node(n).maybeChild(o - 1), u = i.node(n + 1)), s && !s.isTextblock && RQ(s, u) && i.node(n).canReplace(o, o + 1))
      return r;
    if (n == 0)
      break;
    r = t < 0 ? i.before(n) : i.after(n);
  }
}
function KHe(e, r, t) {
  let i = null, { linebreakReplacement: n } = e.doc.type.schema, s = e.doc.resolve(r - t), u = s.node().type;
  if (n && u.inlineContent) {
    let V = u.whitespace == "pre", c = !!u.contentMatch.matchType(n);
    V && !c ? i = !1 : !V && c && (i = !0);
  }
  let o = e.steps.length;
  if (i === !1) {
    let V = e.doc.resolve(r + t);
    DQ(e, V.node(), V.before(), o);
  }
  u.inlineContent && N4(e, r + t - 1, u, s.node().contentMatchAt(s.index()), i == null);
  let d = e.mapping.slice(o), a = d.map(r - t);
  if (e.step(new It(a, d.map(r + t, -1), ve.empty, !0)), i === !0) {
    let V = e.doc.resolve(a);
    OQ(e, V.node(), V.before(), e.steps.length);
  }
  return e;
}
function hHe(e, r, t) {
  let i = e.resolve(r);
  if (i.parent.canReplaceWith(i.index(), i.index(), t))
    return r;
  if (i.parentOffset == 0)
    for (let n = i.depth - 1; n >= 0; n--) {
      let s = i.index(n);
      if (i.node(n).canReplaceWith(s, s, t))
        return i.before(n + 1);
      if (s > 0)
        return null;
    }
  if (i.parentOffset == i.parent.content.size)
    for (let n = i.depth - 1; n >= 0; n--) {
      let s = i.indexAfter(n);
      if (i.node(n).canReplaceWith(s, s, t))
        return i.after(n + 1);
      if (s < i.node(n).childCount)
        return null;
    }
  return null;
}
function IQ(e, r, t) {
  let i = e.resolve(r);
  if (!t.content.size)
    return r;
  let n = t.content;
  for (let s = 0; s < t.openStart; s++)
    n = n.firstChild.content;
  for (let s = 1; s <= (t.openStart == 0 && t.size ? 2 : 1); s++)
    for (let u = i.depth; u >= 0; u--) {
      let o = u == i.depth ? 0 : i.pos <= (i.start(u + 1) + i.end(u + 1)) / 2 ? -1 : 1, d = i.index(u) + (o > 0 ? 1 : 0), a = i.node(u), V = !1;
      if (s == 1)
        V = a.canReplace(d, d, n);
      else {
        let c = a.contentMatchAt(d).findWrapping(n.firstChild.type);
        V = c && a.canReplaceWith(d, d, c[0]);
      }
      if (V)
        return o == 0 ? i.pos : o < 0 ? i.before(u + 1) : i.after(u + 1);
    }
  return null;
}
function kf(e, r, t = r, i = ve.empty) {
  if (r == t && !i.size)
    return null;
  let n = e.resolve(r), s = e.resolve(t);
  return LQ(n, s, i) ? new It(r, t, i) : new pHe(n, s, i).fit();
}
function LQ(e, r, t) {
  return !t.openStart && !t.openEnd && e.start() == r.start() && e.parent.canReplace(e.index(), r.index(), t.content);
}
class pHe {
  constructor(r, t, i) {
    this.$from = r, this.$to = t, this.unplaced = i, this.frontier = [], this.placed = Fe.empty;
    for (let n = 0; n <= r.depth; n++) {
      let s = r.node(n);
      this.frontier.push({
        type: s.type,
        match: s.contentMatchAt(r.indexAfter(n))
      });
    }
    for (let n = r.depth; n > 0; n--)
      this.placed = Fe.from(r.node(n).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let a = this.findFittable();
      a ? this.placeNodes(a) : this.openMore() || this.dropNode();
    }
    let r = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, i = this.$from, n = this.close(r < 0 ? this.$to : i.doc.resolve(r));
    if (!n)
      return null;
    let s = this.placed, u = i.depth, o = n.depth;
    for (; u && o && s.childCount == 1; )
      s = s.firstChild.content, u--, o--;
    let d = new ve(s, u, o);
    return r > -1 ? new Ht(i.pos, r, this.$to.pos, this.$to.end(), d, t) : d.size || i.pos != this.$to.pos ? new It(i.pos, n.pos, d) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let r = this.unplaced.openStart;
    for (let t = this.unplaced.content, i = 0, n = this.unplaced.openEnd; i < r; i++) {
      let s = t.firstChild;
      if (t.childCount > 1 && (n = 0), s.type.spec.isolating && n <= i) {
        r = i;
        break;
      }
      t = s.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let i = t == 1 ? r : this.unplaced.openStart; i >= 0; i--) {
        let n, s = null;
        i ? (s = Sg(this.unplaced.content, i - 1).firstChild, n = s.content) : n = this.unplaced.content;
        let u = n.firstChild;
        for (let o = this.depth; o >= 0; o--) {
          let { type: d, match: a } = this.frontier[o], V, c = null;
          if (t == 1 && (u ? a.matchType(u.type) || (c = a.fillBefore(Fe.from(u), !1)) : s && d.compatibleContent(s.type)))
            return { sliceDepth: i, frontierDepth: o, parent: s, inject: c };
          if (t == 2 && u && (V = a.findWrapping(u.type)))
            return { sliceDepth: i, frontierDepth: o, parent: s, wrap: V };
          if (s && a.matchType(s.type))
            break;
        }
      }
  }
  openMore() {
    let { content: r, openStart: t, openEnd: i } = this.unplaced, n = Sg(r, t);
    return !n.childCount || n.firstChild.isLeaf ? !1 : (this.unplaced = new ve(r, t + 1, Math.max(i, n.size + t >= r.size - i ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: r, openStart: t, openEnd: i } = this.unplaced, n = Sg(r, t);
    if (n.childCount <= 1 && t > 0) {
      let s = r.size - t <= t + n.size;
      this.unplaced = new ve(Sc(r, t - 1, 1), t - 1, s ? t - 1 : i);
    } else
      this.unplaced = new ve(Sc(r, t, 1), t, i);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: r, frontierDepth: t, parent: i, inject: n, wrap: s }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (s)
      for (let q = 0; q < s.length; q++)
        this.openFrontierNode(s[q]);
    let u = this.unplaced, o = i ? i.content : u.content, d = u.openStart - r, a = 0, V = [], { match: c, type: F } = this.frontier[t];
    if (n) {
      for (let q = 0; q < n.childCount; q++)
        V.push(n.child(q));
      c = c.matchFragment(n);
    }
    let X = o.size + r - (u.content.size - u.openEnd);
    for (; a < o.childCount; ) {
      let q = o.child(a), f = c.matchType(q.type);
      if (!f)
        break;
      a++, (a > 1 || d == 0 || q.content.size) && (c = f, V.push(_Q(q.mark(F.allowedMarks(q.marks)), a == 1 ? d : 0, a == o.childCount ? X : -1)));
    }
    let Y = a == o.childCount;
    Y || (X = -1), this.placed = Nc(this.placed, t, Fe.from(V)), this.frontier[t].match = c, Y && X < 0 && i && i.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let q = 0, f = o; q < X; q++) {
      let p = f.lastChild;
      this.frontier.push({ type: p.type, match: p.contentMatchAt(p.childCount) }), f = p.content;
    }
    this.unplaced = Y ? r == 0 ? ve.empty : new ve(Sc(u.content, r - 1, 1), r - 1, X < 0 ? u.openEnd : r - 1) : new ve(Sc(u.content, r, a), u.openStart, u.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let r = this.frontier[this.depth], t;
    if (!r.type.isTextblock || !Ng(this.$to, this.$to.depth, r.type, r.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: i } = this.$to, n = this.$to.after(i);
    for (; i > 1 && n == this.$to.end(--i); )
      ++n;
    return n;
  }
  findCloseLevel(r) {
    e: for (let t = Math.min(this.depth, r.depth); t >= 0; t--) {
      let { match: i, type: n } = this.frontier[t], s = t < r.depth && r.end(t + 1) == r.pos + (r.depth - (t + 1)), u = Ng(r, t, n, i, s);
      if (u) {
        for (let o = t - 1; o >= 0; o--) {
          let { match: d, type: a } = this.frontier[o], V = Ng(r, o, a, d, !0);
          if (!V || V.childCount)
            continue e;
        }
        return { depth: t, fit: u, move: s ? r.doc.resolve(r.after(t + 1)) : r };
      }
    }
  }
  close(r) {
    let t = this.findCloseLevel(r);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = Nc(this.placed, t.depth, t.fit)), r = t.move;
    for (let i = t.depth + 1; i <= r.depth; i++) {
      let n = r.node(i), s = n.type.contentMatch.fillBefore(n.content, !0, r.index(i));
      this.openFrontierNode(n.type, n.attrs, s);
    }
    return r;
  }
  openFrontierNode(r, t = null, i) {
    let n = this.frontier[this.depth];
    n.match = n.match.matchType(r), this.placed = Nc(this.placed, this.depth, Fe.from(r.create(t, i))), this.frontier.push({ type: r, match: r.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(Fe.empty, !0);
    t.childCount && (this.placed = Nc(this.placed, this.frontier.length, t));
  }
}
function Sc(e, r, t) {
  return r == 0 ? e.cutByIndex(t, e.childCount) : e.replaceChild(0, e.firstChild.copy(Sc(e.firstChild.content, r - 1, t)));
}
function Nc(e, r, t) {
  return r == 0 ? e.append(t) : e.replaceChild(e.childCount - 1, e.lastChild.copy(Nc(e.lastChild.content, r - 1, t)));
}
function Sg(e, r) {
  for (let t = 0; t < r; t++)
    e = e.firstChild.content;
  return e;
}
function _Q(e, r, t) {
  if (r <= 0)
    return e;
  let i = e.content;
  return r > 1 && (i = i.replaceChild(0, _Q(i.firstChild, r - 1, i.childCount == 1 ? t - 1 : 0))), r > 0 && (i = e.type.contentMatch.fillBefore(i).append(i), t <= 0 && (i = i.append(e.type.contentMatch.matchFragment(i).fillBefore(Fe.empty, !0)))), e.copy(i);
}
function Ng(e, r, t, i, n) {
  let s = e.node(r), u = n ? e.indexAfter(r) : e.index(r);
  if (u == s.childCount && !t.compatibleContent(s.type))
    return null;
  let o = i.fillBefore(s.content, !0, u);
  return o && !mHe(t, s.content, u) ? o : null;
}
function mHe(e, r, t) {
  for (let i = t; i < r.childCount; i++)
    if (!e.allowsMarks(r.child(i).marks))
      return !0;
  return !1;
}
function gHe(e) {
  return e.spec.defining || e.spec.definingForContent;
}
function vHe(e, r, t, i) {
  if (!i.size)
    return e.deleteRange(r, t);
  let n = e.doc.resolve(r), s = e.doc.resolve(t);
  if (LQ(n, s, i))
    return e.step(new It(r, t, i));
  let u = jQ(n, e.doc.resolve(t));
  u[u.length - 1] == 0 && u.pop();
  let o = -(n.depth + 1);
  u.unshift(o);
  for (let F = n.depth, X = n.pos - 1; F > 0; F--, X--) {
    let Y = n.node(F).type.spec;
    if (Y.defining || Y.definingAsContext || Y.isolating)
      break;
    u.indexOf(F) > -1 ? o = F : n.before(F) == X && u.splice(1, 0, -F);
  }
  let d = u.indexOf(o), a = [], V = i.openStart;
  for (let F = i.content, X = 0; ; X++) {
    let Y = F.firstChild;
    if (a.push(Y), X == i.openStart)
      break;
    F = Y.content;
  }
  for (let F = V - 1; F >= 0; F--) {
    let X = a[F], Y = gHe(X.type);
    if (Y && !X.sameMarkup(n.node(Math.abs(o) - 1)))
      V = F;
    else if (Y || !X.type.isTextblock)
      break;
  }
  for (let F = i.openStart; F >= 0; F--) {
    let X = (F + V + 1) % (i.openStart + 1), Y = a[X];
    if (Y)
      for (let q = 0; q < u.length; q++) {
        let f = u[(q + d) % u.length], p = !0;
        f < 0 && (p = !1, f = -f);
        let m = n.node(f - 1), g = n.index(f - 1);
        if (m.canReplaceWith(g, g, Y.type, Y.marks))
          return e.replace(n.before(f), p ? s.after(f) : t, new ve(HQ(i.content, 0, i.openStart, X), X, i.openEnd));
      }
  }
  let c = e.steps.length;
  for (let F = u.length - 1; F >= 0 && (e.replace(r, t, i), !(e.steps.length > c)); F--) {
    let X = u[F];
    X < 0 || (r = n.before(X), t = s.after(X));
  }
}
function HQ(e, r, t, i, n) {
  if (r < t) {
    let s = e.firstChild;
    e = e.replaceChild(0, s.copy(HQ(s.content, r + 1, t, i, s)));
  }
  if (r > i) {
    let s = n.contentMatchAt(0), u = s.fillBefore(e).append(e);
    e = u.append(s.matchFragment(u).fillBefore(Fe.empty, !0));
  }
  return e;
}
function bHe(e, r, t, i) {
  if (!i.isInline && r == t && e.doc.resolve(r).parent.content.size) {
    let n = hHe(e.doc, r, i.type);
    n != null && (r = t = n);
  }
  e.replaceRange(r, t, new ve(Fe.from(i), 0, 0));
}
function yHe(e, r, t) {
  let i = e.doc.resolve(r), n = e.doc.resolve(t), s = jQ(i, n);
  for (let u = 0; u < s.length; u++) {
    let o = s[u], d = u == s.length - 1;
    if (d && o == 0 || i.node(o).type.contentMatch.validEnd)
      return e.delete(i.start(o), n.end(o));
    if (o > 0 && (d || i.node(o - 1).canReplace(i.index(o - 1), n.indexAfter(o - 1))))
      return e.delete(i.before(o), n.after(o));
  }
  for (let u = 1; u <= i.depth && u <= n.depth; u++)
    if (r - i.start(u) == i.depth - u && t > i.end(u) && n.end(u) - t != n.depth - u && i.start(u - 1) == n.start(u - 1) && i.node(u - 1).canReplace(i.index(u - 1), n.index(u - 1)))
      return e.delete(i.before(u), t);
  e.delete(r, t);
}
function jQ(e, r) {
  let t = [], i = Math.min(e.depth, r.depth);
  for (let n = i; n >= 0; n--) {
    let s = e.start(n);
    if (s < e.pos - (e.depth - n) || r.end(n) > r.pos + (r.depth - n) || e.node(n).type.spec.isolating || r.node(n).type.spec.isolating)
      break;
    (s == r.start(n) || n == e.depth && n == r.depth && e.parent.inlineContent && r.parent.inlineContent && n && r.start(n - 1) == s - 1) && t.push(n);
  }
  return t;
}
class mV extends Ki {
  /**
  Construct an attribute step.
  */
  constructor(r, t, i) {
    super(), this.pos = r, this.attr = t, this.value = i;
  }
  apply(r) {
    let t = r.nodeAt(this.pos);
    if (!t)
      return ft.fail("No node at attribute step's position");
    let i = /* @__PURE__ */ Object.create(null);
    for (let s in t.attrs)
      i[s] = t.attrs[s];
    i[this.attr] = this.value;
    let n = t.type.create(i, null, t.marks);
    return ft.fromReplace(r, this.pos, this.pos + 1, new ve(Fe.from(n), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return ln.empty;
  }
  invert(r) {
    return new mV(this.pos, this.attr, r.nodeAt(this.pos).attrs[this.attr]);
  }
  map(r) {
    let t = r.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new mV(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(r, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new mV(t.pos, t.attr, t.value);
  }
}
Ki.jsonID("attr", mV);
class _7 extends Ki {
  /**
  Construct an attribute step.
  */
  constructor(r, t) {
    super(), this.attr = r, this.value = t;
  }
  apply(r) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let n in r.attrs)
      t[n] = r.attrs[n];
    t[this.attr] = this.value;
    let i = r.type.create(t, r.content, r.marks);
    return ft.ok(i);
  }
  getMap() {
    return ln.empty;
  }
  invert(r) {
    return new _7(this.attr, r.attrs[this.attr]);
  }
  map(r) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(r, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new _7(t.attr, t.value);
  }
}
Ki.jsonID("docAttr", _7);
let al = class extends Error {
};
al = function e(r) {
  let t = Error.call(this, r);
  return t.__proto__ = e.prototype, t;
};
al.prototype = Object.create(Error.prototype);
al.prototype.constructor = al;
al.prototype.name = "TransformError";
class AHe {
  /**
  Create a transform that starts with the given document.
  */
  constructor(r) {
    this.doc = r, this.steps = [], this.docs = [], this.mapping = new pV();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(r) {
    let t = this.maybeStep(r);
    if (t.failed)
      throw new al(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(r) {
    let t = r.apply(this.doc);
    return t.failed || this.addStep(r, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(r, t) {
    this.docs.push(this.doc), this.steps.push(r), this.mapping.appendMap(r.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(r, t = r, i = ve.empty) {
    let n = kf(this.doc, r, t, i);
    return n && this.step(n), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(r, t, i) {
    return this.replace(r, t, new ve(Fe.from(i), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(r, t) {
    return this.replace(r, t, ve.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(r, t) {
    return this.replaceWith(r, r, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(r, t, i) {
    return vHe(this, r, t, i), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(r, t, i) {
    return bHe(this, r, t, i), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(r, t) {
    return yHe(this, r, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(r, t) {
    return VHe(this, r, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(r, t = 1) {
    return KHe(this, r, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(r, t) {
    return FHe(this, r, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(r, t = r, i, n = null) {
    return xHe(this, r, t, i, n), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(r, t, i = null, n) {
    return qHe(this, r, t, i, n), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(r, t, i) {
    return this.step(new mV(r, t, i)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(r, t) {
    return this.step(new _7(r, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(r, t) {
    return this.step(new Co(r, t)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(r, t) {
    if (!(t instanceof wr)) {
      let i = this.doc.nodeAt(r);
      if (!i)
        throw new RangeError("No node at position " + r);
      if (t = t.isInSet(i.marks), !t)
        return this;
    }
    return this.step(new dl(r, t)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split.
  */
  split(r, t = 1, i) {
    return YHe(this, r, t, i), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(r, t, i) {
    return oHe(this, r, t, i), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(r, t, i) {
    return dHe(this, r, t, i), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(r, t, i) {
    return N4(this, r, t, i), this;
  }
}
const Mg = /* @__PURE__ */ Object.create(null);
class nr {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(r, t, i) {
    this.$anchor = r, this.$head = t, this.ranges = i || [new wHe(r.min(t), r.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let r = this.ranges;
    for (let t = 0; t < r.length; t++)
      if (r[t].$from.pos != r[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(r, t = ve.empty) {
    let i = t.content.lastChild, n = null;
    for (let o = 0; o < t.openEnd; o++)
      n = i, i = i.lastChild;
    let s = r.steps.length, u = this.ranges;
    for (let o = 0; o < u.length; o++) {
      let { $from: d, $to: a } = u[o], V = r.mapping.slice(s);
      r.replaceRange(V.map(d.pos), V.map(a.pos), o ? ve.empty : t), o == 0 && yO(r, s, (i ? i.isInline : n && n.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(r, t) {
    let i = r.steps.length, n = this.ranges;
    for (let s = 0; s < n.length; s++) {
      let { $from: u, $to: o } = n[s], d = r.mapping.slice(i), a = d.map(u.pos), V = d.map(o.pos);
      s ? r.deleteRange(a, V) : (r.replaceRangeWith(a, V, t), yO(r, i, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(r, t, i = !1) {
    let n = r.parent.inlineContent ? new Ze(r) : eV(r.node(0), r.parent, r.pos, r.index(), t, i);
    if (n)
      return n;
    for (let s = r.depth - 1; s >= 0; s--) {
      let u = t < 0 ? eV(r.node(0), r.node(s), r.before(s + 1), r.index(s), t, i) : eV(r.node(0), r.node(s), r.after(s + 1), r.index(s) + 1, t, i);
      if (u)
        return u;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(r, t = 1) {
    return this.findFrom(r, t) || this.findFrom(r, -t) || new Tn(r.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(r) {
    return eV(r, r, 0, 0, 1) || new Tn(r);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(r) {
    return eV(r, r, r.content.size, r.childCount, -1) || new Tn(r);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(r, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let i = Mg[t.type];
    if (!i)
      throw new RangeError(`No selection type ${t.type} defined`);
    return i.fromJSON(r, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(r, t) {
    if (r in Mg)
      throw new RangeError("Duplicate use of selection JSON ID " + r);
    return Mg[r] = t, t.prototype.jsonID = r, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Ze.between(this.$anchor, this.$head).getBookmark();
  }
}
nr.prototype.visible = !0;
class wHe {
  /**
  Create a range.
  */
  constructor(r, t) {
    this.$from = r, this.$to = t;
  }
}
let vO = !1;
function bO(e) {
  !vO && !e.parent.inlineContent && (vO = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
class Ze extends nr {
  /**
  Construct a text selection between the given points.
  */
  constructor(r, t = r) {
    bO(r), bO(t), super(r, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(r, t) {
    let i = r.resolve(t.map(this.head));
    if (!i.parent.inlineContent)
      return nr.near(i);
    let n = r.resolve(t.map(this.anchor));
    return new Ze(n.parent.inlineContent ? n : i, i);
  }
  replace(r, t = ve.empty) {
    if (super.replace(r, t), t == ve.empty) {
      let i = this.$from.marksAcross(this.$to);
      i && r.ensureMarks(i);
    }
  }
  eq(r) {
    return r instanceof Ze && r.anchor == this.anchor && r.head == this.head;
  }
  getBookmark() {
    return new Of(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(r, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Ze(r.resolve(t.anchor), r.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(r, t, i = t) {
    let n = r.resolve(t);
    return new this(n, i == t ? n : r.resolve(i));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(r, t, i) {
    let n = r.pos - t.pos;
    if ((!i || n) && (i = n >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let s = nr.findFrom(t, i, !0) || nr.findFrom(t, -i, !0);
      if (s)
        t = s.$head;
      else
        return nr.near(t, i);
    }
    return r.parent.inlineContent || (n == 0 ? r = t : (r = (nr.findFrom(r, -i, !0) || nr.findFrom(r, i, !0)).$anchor, r.pos < t.pos != n < 0 && (r = t))), new Ze(r, t);
  }
}
nr.jsonID("text", Ze);
class Of {
  constructor(r, t) {
    this.anchor = r, this.head = t;
  }
  map(r) {
    return new Of(r.map(this.anchor), r.map(this.head));
  }
  resolve(r) {
    return Ze.between(r.resolve(this.anchor), r.resolve(this.head));
  }
}
class ke extends nr {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(r) {
    let t = r.nodeAfter, i = r.node(0).resolve(r.pos + t.nodeSize);
    super(r, i), this.node = t;
  }
  map(r, t) {
    let { deleted: i, pos: n } = t.mapResult(this.anchor), s = r.resolve(n);
    return i ? nr.near(s) : new ke(s);
  }
  content() {
    return new ve(Fe.from(this.node), 0, 0);
  }
  eq(r) {
    return r instanceof ke && r.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new T4(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(r, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new ke(r.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(r, t) {
    return new ke(r.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(r) {
    return !r.isText && r.type.spec.selectable !== !1;
  }
}
ke.prototype.visible = !1;
nr.jsonID("node", ke);
class T4 {
  constructor(r) {
    this.anchor = r;
  }
  map(r) {
    let { deleted: t, pos: i } = r.mapResult(this.anchor);
    return t ? new Of(i, i) : new T4(i);
  }
  resolve(r) {
    let t = r.resolve(this.anchor), i = t.nodeAfter;
    return i && ke.isSelectable(i) ? new ke(t) : nr.near(t);
  }
}
class Tn extends nr {
  /**
  Create an all-selection over the given document.
  */
  constructor(r) {
    super(r.resolve(0), r.resolve(r.content.size));
  }
  replace(r, t = ve.empty) {
    if (t == ve.empty) {
      r.delete(0, r.doc.content.size);
      let i = nr.atStart(r.doc);
      i.eq(r.selection) || r.setSelection(i);
    } else
      super.replace(r, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(r) {
    return new Tn(r);
  }
  map(r) {
    return new Tn(r);
  }
  eq(r) {
    return r instanceof Tn;
  }
  getBookmark() {
    return CHe;
  }
}
nr.jsonID("all", Tn);
const CHe = {
  map() {
    return this;
  },
  resolve(e) {
    return new Tn(e);
  }
};
function eV(e, r, t, i, n, s = !1) {
  if (r.inlineContent)
    return Ze.create(e, t);
  for (let u = i - (n > 0 ? 0 : 1); n > 0 ? u < r.childCount : u >= 0; u += n) {
    let o = r.child(u);
    if (o.isAtom) {
      if (!s && ke.isSelectable(o))
        return ke.create(e, t - (n < 0 ? o.nodeSize : 0));
    } else {
      let d = eV(e, o, t + n, n < 0 ? o.childCount : 0, n, s);
      if (d)
        return d;
    }
    t += o.nodeSize * n;
  }
  return null;
}
function yO(e, r, t) {
  let i = e.steps.length - 1;
  if (i < r)
    return;
  let n = e.steps[i];
  if (!(n instanceof It || n instanceof Ht))
    return;
  let s = e.mapping.maps[i], u;
  s.forEach((o, d, a, V) => {
    u == null && (u = V);
  }), e.setSelection(nr.near(e.doc.resolve(u), t));
}
const AO = 1, wO = 2, CO = 4;
class PHe extends AHe {
  /**
  @internal
  */
  constructor(r) {
    super(r.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = r.selection, this.storedMarks = r.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(r) {
    if (r.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = r, this.curSelectionFor = this.steps.length, this.updated = (this.updated | AO) & -3, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & AO) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(r) {
    return this.storedMarks = r, this.updated |= wO, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(r) {
    return wr.sameSet(this.storedMarks || this.selection.$from.marks(), r) || this.setStoredMarks(r), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(r) {
    return this.ensureMarks(r.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(r) {
    return this.ensureMarks(r.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & wO) > 0;
  }
  /**
  @internal
  */
  addStep(r, t) {
    super.addStep(r, t), this.updated = this.updated & -3, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(r) {
    return this.time = r, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(r) {
    return this.selection.replace(this, r), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(r, t = !0) {
    let i = this.selection;
    return t && (r = r.mark(this.storedMarks || (i.empty ? i.$from.marks() : i.$from.marksAcross(i.$to) || wr.none))), i.replaceWith(this, r), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(r, t, i) {
    let n = this.doc.type.schema;
    if (t == null)
      return r ? this.replaceSelectionWith(n.text(r), !0) : this.deleteSelection();
    {
      if (i == null && (i = t), i = i ?? t, !r)
        return this.deleteRange(t, i);
      let s = this.storedMarks;
      if (!s) {
        let u = this.doc.resolve(t);
        s = i == t ? u.marks() : u.marksAcross(this.doc.resolve(i));
      }
      return this.replaceRangeWith(t, i, n.text(r, s)), this.selection.empty || this.setSelection(nr.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(r, t) {
    return this.meta[typeof r == "string" ? r : r.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(r) {
    return this.meta[typeof r == "string" ? r : r.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let r in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= CO, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & CO) > 0;
  }
}
function PO(e, r) {
  return !r || !e ? e : e.bind(r);
}
class Mc {
  constructor(r, t, i) {
    this.name = r, this.init = PO(t.init, i), this.apply = PO(t.apply, i);
  }
}
const SHe = [
  new Mc("doc", {
    init(e) {
      return e.doc || e.schema.topNodeType.createAndFill();
    },
    apply(e) {
      return e.doc;
    }
  }),
  new Mc("selection", {
    init(e, r) {
      return e.selection || nr.atStart(r.doc);
    },
    apply(e) {
      return e.selection;
    }
  }),
  new Mc("storedMarks", {
    init(e) {
      return e.storedMarks || null;
    },
    apply(e, r, t, i) {
      return i.selection.$cursor ? e.storedMarks : null;
    }
  }),
  new Mc("scrollToSelection", {
    init() {
      return 0;
    },
    apply(e, r) {
      return e.scrolledIntoView ? r + 1 : r;
    }
  })
];
class Tg {
  constructor(r, t) {
    this.schema = r, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = SHe.slice(), t && t.forEach((i) => {
      if (this.pluginsByKey[i.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + i.key + ")");
      this.plugins.push(i), this.pluginsByKey[i.key] = i, i.spec.state && this.fields.push(new Mc(i.key, i.spec.state, i));
    });
  }
}
class uV {
  /**
  @internal
  */
  constructor(r) {
    this.config = r;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(r) {
    return this.applyTransaction(r).state;
  }
  /**
  @internal
  */
  filterTransaction(r, t = -1) {
    for (let i = 0; i < this.config.plugins.length; i++)
      if (i != t) {
        let n = this.config.plugins[i];
        if (n.spec.filterTransaction && !n.spec.filterTransaction.call(n, r, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(r) {
    if (!this.filterTransaction(r))
      return { state: this, transactions: [] };
    let t = [r], i = this.applyInner(r), n = null;
    for (; ; ) {
      let s = !1;
      for (let u = 0; u < this.config.plugins.length; u++) {
        let o = this.config.plugins[u];
        if (o.spec.appendTransaction) {
          let d = n ? n[u].n : 0, a = n ? n[u].state : this, V = d < t.length && o.spec.appendTransaction.call(o, d ? t.slice(d) : t, a, i);
          if (V && i.filterTransaction(V, u)) {
            if (V.setMeta("appendedTransaction", r), !n) {
              n = [];
              for (let c = 0; c < this.config.plugins.length; c++)
                n.push(c < u ? { state: i, n: t.length } : { state: this, n: 0 });
            }
            t.push(V), i = i.applyInner(V), s = !0;
          }
          n && (n[u] = { state: i, n: t.length });
        }
      }
      if (!s)
        return { state: i, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(r) {
    if (!r.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new uV(this.config), i = this.config.fields;
    for (let n = 0; n < i.length; n++) {
      let s = i[n];
      t[s.name] = s.apply(r, this[s.name], this, t);
    }
    return t;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new PHe(this);
  }
  /**
  Create a new state.
  */
  static create(r) {
    let t = new Tg(r.doc ? r.doc.type.schema : r.schema, r.plugins), i = new uV(t);
    for (let n = 0; n < t.fields.length; n++)
      i[t.fields[n].name] = t.fields[n].init(r, i);
    return i;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(r) {
    let t = new Tg(this.schema, r.plugins), i = t.fields, n = new uV(t);
    for (let s = 0; s < i.length; s++) {
      let u = i[s].name;
      n[u] = this.hasOwnProperty(u) ? this[u] : i[s].init(r, n);
    }
    return n;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(r) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((i) => i.toJSON())), r && typeof r == "object")
      for (let i in r) {
        if (i == "doc" || i == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let n = r[i], s = n.spec.state;
        s && s.toJSON && (t[i] = s.toJSON.call(n, this[n.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(r, t, i) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!r.schema)
      throw new RangeError("Required config field 'schema' missing");
    let n = new Tg(r.schema, r.plugins), s = new uV(n);
    return n.fields.forEach((u) => {
      if (u.name == "doc")
        s.doc = Id.fromJSON(r.schema, t.doc);
      else if (u.name == "selection")
        s.selection = nr.fromJSON(s.doc, t.selection);
      else if (u.name == "storedMarks")
        t.storedMarks && (s.storedMarks = t.storedMarks.map(r.schema.markFromJSON));
      else {
        if (i)
          for (let o in i) {
            let d = i[o], a = d.spec.state;
            if (d.key == u.name && a && a.fromJSON && Object.prototype.hasOwnProperty.call(t, o)) {
              s[u.name] = a.fromJSON.call(d, r, t[o], s);
              return;
            }
          }
        s[u.name] = u.init(r, s);
      }
    }), s;
  }
}
function zQ(e, r, t) {
  for (let i in e) {
    let n = e[i];
    n instanceof Function ? n = n.bind(r) : i == "handleDOMEvents" && (n = zQ(n, r, {})), t[i] = n;
  }
  return t;
}
class Ei {
  /**
  Create a plugin.
  */
  constructor(r) {
    this.spec = r, this.props = {}, r.props && zQ(r.props, this, this.props), this.key = r.key ? r.key.key : BQ("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(r) {
    return r[this.key];
  }
}
const Eg = /* @__PURE__ */ Object.create(null);
function BQ(e) {
  return e in Eg ? e + "$" + ++Eg[e] : (Eg[e] = 0, e + "$");
}
class hs {
  /**
  Create a plugin key.
  */
  constructor(r = "key") {
    this.key = BQ(r);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(r) {
    return r.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(r) {
    return r[this.key];
  }
}
const ei = function(e) {
  for (var r = 0; ; r++)
    if (e = e.previousSibling, !e)
      return r;
}, H7 = function(e) {
  let r = e.assignedSlot || e.parentNode;
  return r && r.nodeType == 11 ? r.host : r;
};
let $b = null;
const pu = function(e, r, t) {
  let i = $b || ($b = document.createRange());
  return i.setEnd(e, t ?? e.nodeValue.length), i.setStart(e, r || 0), i;
}, NHe = function() {
  $b = null;
}, ia = function(e, r, t, i) {
  return t && (SO(e, r, t, i, -1) || SO(e, r, t, i, 1));
}, MHe = /^(img|br|input|textarea|hr)$/i;
function SO(e, r, t, i, n) {
  for (; ; ) {
    if (e == t && r == i)
      return !0;
    if (r == (n < 0 ? 0 : Cn(e))) {
      let s = e.parentNode;
      if (!s || s.nodeType != 1 || E2(e) || MHe.test(e.nodeName) || e.contentEditable == "false")
        return !1;
      r = ei(e) + (n < 0 ? 0 : 1), e = s;
    } else if (e.nodeType == 1) {
      if (e = e.childNodes[r + (n < 0 ? -1 : 0)], e.contentEditable == "false")
        return !1;
      r = n < 0 ? Cn(e) : 0;
    } else
      return !1;
  }
}
function Cn(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function THe(e, r) {
  for (; ; ) {
    if (e.nodeType == 3 && r)
      return e;
    if (e.nodeType == 1 && r > 0) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[r - 1], r = Cn(e);
    } else if (e.parentNode && !E2(e))
      r = ei(e), e = e.parentNode;
    else
      return null;
  }
}
function EHe(e, r) {
  for (; ; ) {
    if (e.nodeType == 3 && r < e.nodeValue.length)
      return e;
    if (e.nodeType == 1 && r < e.childNodes.length) {
      if (e.contentEditable == "false")
        return null;
      e = e.childNodes[r], r = 0;
    } else if (e.parentNode && !E2(e))
      r = ei(e) + 1, e = e.parentNode;
    else
      return null;
  }
}
function kHe(e, r, t) {
  for (let i = r == 0, n = r == Cn(e); i || n; ) {
    if (e == t)
      return !0;
    let s = ei(e);
    if (e = e.parentNode, !e)
      return !1;
    i = i && s == 0, n = n && s == Cn(e);
  }
}
function E2(e) {
  let r;
  for (let t = e; t && !(r = t.pmViewDesc); t = t.parentNode)
    ;
  return r && r.node && r.node.isBlock && (r.dom == e || r.contentDOM == e);
}
const Df = function(e) {
  return e.focusNode && ia(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function gd(e, r) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = e, t.key = t.code = r, t;
}
function OHe(e) {
  let r = e.activeElement;
  for (; r && r.shadowRoot; )
    r = r.shadowRoot.activeElement;
  return r;
}
function DHe(e, r, t) {
  if (e.caretPositionFromPoint)
    try {
      let i = e.caretPositionFromPoint(r, t);
      if (i)
        return { node: i.offsetNode, offset: Math.min(Cn(i.offsetNode), i.offset) };
    } catch {
    }
  if (e.caretRangeFromPoint) {
    let i = e.caretRangeFromPoint(r, t);
    if (i)
      return { node: i.startContainer, offset: Math.min(Cn(i.startContainer), i.startOffset) };
  }
}
const Bs = typeof navigator < "u" ? navigator : null, NO = typeof document < "u" ? document : null, nd = Bs && Bs.userAgent || "", Qb = /Edge\/(\d+)/.exec(nd), WQ = /MSIE \d/.exec(nd), ey = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(nd), Bi = !!(WQ || ey || Qb), Eo = WQ ? document.documentMode : ey ? +ey[1] : Qb ? +Qb[1] : 0, Xs = !Bi && /gecko\/(\d+)/i.test(nd);
Xs && +(/Firefox\/(\d+)/.exec(nd) || [0, 0])[1];
const ry = !Bi && /Chrome\/(\d+)/.exec(nd), qi = !!ry, GQ = ry ? +ry[1] : 0, Si = !Bi && !!Bs && /Apple Computer/.test(Bs.vendor), Vl = Si && (/Mobile\/\w+/.test(nd) || !!Bs && Bs.maxTouchPoints > 2), wn = Vl || (Bs ? /Mac/.test(Bs.platform) : !1), RHe = Bs ? /Win/.test(Bs.platform) : !1, Qn = /Android \d/.test(nd), k2 = !!NO && "webkitFontSmoothing" in NO.documentElement.style, IHe = k2 ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function LHe(e) {
  let r = e.defaultView && e.defaultView.visualViewport;
  return r ? {
    left: 0,
    right: r.width,
    top: 0,
    bottom: r.height
  } : {
    left: 0,
    right: e.documentElement.clientWidth,
    top: 0,
    bottom: e.documentElement.clientHeight
  };
}
function fu(e, r) {
  return typeof e == "number" ? e : e[r];
}
function _He(e) {
  let r = e.getBoundingClientRect(), t = r.width / e.offsetWidth || 1, i = r.height / e.offsetHeight || 1;
  return {
    left: r.left,
    right: r.left + e.clientWidth * t,
    top: r.top,
    bottom: r.top + e.clientHeight * i
  };
}
function MO(e, r, t) {
  let i = e.someProp("scrollThreshold") || 0, n = e.someProp("scrollMargin") || 5, s = e.dom.ownerDocument;
  for (let u = t || e.dom; u; u = H7(u)) {
    if (u.nodeType != 1)
      continue;
    let o = u, d = o == s.body, a = d ? LHe(s) : _He(o), V = 0, c = 0;
    if (r.top < a.top + fu(i, "top") ? c = -(a.top - r.top + fu(n, "top")) : r.bottom > a.bottom - fu(i, "bottom") && (c = r.bottom - r.top > a.bottom - a.top ? r.top + fu(n, "top") - a.top : r.bottom - a.bottom + fu(n, "bottom")), r.left < a.left + fu(i, "left") ? V = -(a.left - r.left + fu(n, "left")) : r.right > a.right - fu(i, "right") && (V = r.right - a.right + fu(n, "right")), V || c)
      if (d)
        s.defaultView.scrollBy(V, c);
      else {
        let F = o.scrollLeft, X = o.scrollTop;
        c && (o.scrollTop += c), V && (o.scrollLeft += V);
        let Y = o.scrollLeft - F, q = o.scrollTop - X;
        r = { left: r.left - Y, top: r.top - q, right: r.right - Y, bottom: r.bottom - q };
      }
    if (d || /^(fixed|sticky)$/.test(getComputedStyle(u).position))
      break;
  }
}
function HHe(e) {
  let r = e.dom.getBoundingClientRect(), t = Math.max(0, r.top), i, n;
  for (let s = (r.left + r.right) / 2, u = t + 1; u < Math.min(innerHeight, r.bottom); u += 5) {
    let o = e.root.elementFromPoint(s, u);
    if (!o || o == e.dom || !e.dom.contains(o))
      continue;
    let d = o.getBoundingClientRect();
    if (d.top >= t - 20) {
      i = o, n = d.top;
      break;
    }
  }
  return { refDOM: i, refTop: n, stack: UQ(e.dom) };
}
function UQ(e) {
  let r = [], t = e.ownerDocument;
  for (let i = e; i && (r.push({ dom: i, top: i.scrollTop, left: i.scrollLeft }), e != t); i = H7(i))
    ;
  return r;
}
function jHe({ refDOM: e, refTop: r, stack: t }) {
  let i = e ? e.getBoundingClientRect().top : 0;
  ZQ(t, i == 0 ? 0 : i - r);
}
function ZQ(e, r) {
  for (let t = 0; t < e.length; t++) {
    let { dom: i, top: n, left: s } = e[t];
    i.scrollTop != n + r && (i.scrollTop = n + r), i.scrollLeft != s && (i.scrollLeft = s);
  }
}
let Za = null;
function zHe(e) {
  if (e.setActive)
    return e.setActive();
  if (Za)
    return e.focus(Za);
  let r = UQ(e);
  e.focus(Za == null ? {
    get preventScroll() {
      return Za = { preventScroll: !0 }, !0;
    }
  } : void 0), Za || (Za = !1, ZQ(r, 0));
}
function JQ(e, r) {
  let t, i = 2e8, n, s = 0, u = r.top, o = r.top, d, a;
  for (let V = e.firstChild, c = 0; V; V = V.nextSibling, c++) {
    let F;
    if (V.nodeType == 1)
      F = V.getClientRects();
    else if (V.nodeType == 3)
      F = pu(V).getClientRects();
    else
      continue;
    for (let X = 0; X < F.length; X++) {
      let Y = F[X];
      if (Y.top <= u && Y.bottom >= o) {
        u = Math.max(Y.bottom, u), o = Math.min(Y.top, o);
        let q = Y.left > r.left ? Y.left - r.left : Y.right < r.left ? r.left - Y.right : 0;
        if (q < i) {
          t = V, i = q, n = q && t.nodeType == 3 ? {
            left: Y.right < r.left ? Y.right : Y.left,
            top: r.top
          } : r, V.nodeType == 1 && q && (s = c + (r.left >= (Y.left + Y.right) / 2 ? 1 : 0));
          continue;
        }
      } else Y.top > r.top && !d && Y.left <= r.left && Y.right >= r.left && (d = V, a = { left: Math.max(Y.left, Math.min(Y.right, r.left)), top: Y.top });
      !t && (r.left >= Y.right && r.top >= Y.top || r.left >= Y.left && r.top >= Y.bottom) && (s = c + 1);
    }
  }
  return !t && d && (t = d, n = a, i = 0), t && t.nodeType == 3 ? BHe(t, n) : !t || i && t.nodeType == 1 ? { node: e, offset: s } : JQ(t, n);
}
function BHe(e, r) {
  let t = e.nodeValue.length, i = document.createRange();
  for (let n = 0; n < t; n++) {
    i.setEnd(e, n + 1), i.setStart(e, n);
    let s = qo(i, 1);
    if (s.top != s.bottom && E4(r, s))
      return { node: e, offset: n + (r.left >= (s.left + s.right) / 2 ? 1 : 0) };
  }
  return { node: e, offset: 0 };
}
function E4(e, r) {
  return e.left >= r.left - 1 && e.left <= r.right + 1 && e.top >= r.top - 1 && e.top <= r.bottom + 1;
}
function WHe(e, r) {
  let t = e.parentNode;
  return t && /^li$/i.test(t.nodeName) && r.left < e.getBoundingClientRect().left ? t : e;
}
function GHe(e, r, t) {
  let { node: i, offset: n } = JQ(r, t), s = -1;
  if (i.nodeType == 1 && !i.firstChild) {
    let u = i.getBoundingClientRect();
    s = u.left != u.right && t.left > (u.left + u.right) / 2 ? 1 : -1;
  }
  return e.docView.posFromDOM(i, n, s);
}
function UHe(e, r, t, i) {
  let n = -1;
  for (let s = r, u = !1; s != e.dom; ) {
    let o = e.docView.nearestDesc(s, !0);
    if (!o)
      return null;
    if (o.dom.nodeType == 1 && (o.node.isBlock && o.parent || !o.contentDOM)) {
      let d = o.dom.getBoundingClientRect();
      if (o.node.isBlock && o.parent && (!u && d.left > i.left || d.top > i.top ? n = o.posBefore : (!u && d.right < i.left || d.bottom < i.top) && (n = o.posAfter), u = !0), !o.contentDOM && n < 0 && !o.node.isText)
        return (o.node.isBlock ? i.top < (d.top + d.bottom) / 2 : i.left < (d.left + d.right) / 2) ? o.posBefore : o.posAfter;
    }
    s = o.dom.parentNode;
  }
  return n > -1 ? n : e.docView.posFromDOM(r, t, -1);
}
function $Q(e, r, t) {
  let i = e.childNodes.length;
  if (i && t.top < t.bottom)
    for (let n = Math.max(0, Math.min(i - 1, Math.floor(i * (r.top - t.top) / (t.bottom - t.top)) - 2)), s = n; ; ) {
      let u = e.childNodes[s];
      if (u.nodeType == 1) {
        let o = u.getClientRects();
        for (let d = 0; d < o.length; d++) {
          let a = o[d];
          if (E4(r, a))
            return $Q(u, r, a);
        }
      }
      if ((s = (s + 1) % i) == n)
        break;
    }
  return e;
}
function ZHe(e, r) {
  let t = e.dom.ownerDocument, i, n = 0, s = DHe(t, r.left, r.top);
  s && ({ node: i, offset: n } = s);
  let u = (e.root.elementFromPoint ? e.root : t).elementFromPoint(r.left, r.top), o;
  if (!u || !e.dom.contains(u.nodeType != 1 ? u.parentNode : u)) {
    let a = e.dom.getBoundingClientRect();
    if (!E4(r, a) || (u = $Q(e.dom, r, a), !u))
      return null;
  }
  if (Si)
    for (let a = u; i && a; a = H7(a))
      a.draggable && (i = void 0);
  if (u = WHe(u, r), i) {
    if (Xs && i.nodeType == 1 && (n = Math.min(n, i.childNodes.length), n < i.childNodes.length)) {
      let V = i.childNodes[n], c;
      V.nodeName == "IMG" && (c = V.getBoundingClientRect()).right <= r.left && c.bottom > r.top && n++;
    }
    let a;
    k2 && n && i.nodeType == 1 && (a = i.childNodes[n - 1]).nodeType == 1 && a.contentEditable == "false" && a.getBoundingClientRect().top >= r.top && n--, i == e.dom && n == i.childNodes.length - 1 && i.lastChild.nodeType == 1 && r.top > i.lastChild.getBoundingClientRect().bottom ? o = e.state.doc.content.size : (n == 0 || i.nodeType != 1 || i.childNodes[n - 1].nodeName != "BR") && (o = UHe(e, i, n, r));
  }
  o == null && (o = GHe(e, u, r));
  let d = e.docView.nearestDesc(u, !0);
  return { pos: o, inside: d ? d.posAtStart - d.border : -1 };
}
function TO(e) {
  return e.top < e.bottom || e.left < e.right;
}
function qo(e, r) {
  let t = e.getClientRects();
  if (t.length) {
    let i = t[r < 0 ? 0 : t.length - 1];
    if (TO(i))
      return i;
  }
  return Array.prototype.find.call(t, TO) || e.getBoundingClientRect();
}
const JHe = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function QQ(e, r, t) {
  let { node: i, offset: n, atom: s } = e.docView.domFromPos(r, t < 0 ? -1 : 1), u = k2 || Xs;
  if (i.nodeType == 3)
    if (u && (JHe.test(i.nodeValue) || (t < 0 ? !n : n == i.nodeValue.length))) {
      let d = qo(pu(i, n, n), t);
      if (Xs && n && /\s/.test(i.nodeValue[n - 1]) && n < i.nodeValue.length) {
        let a = qo(pu(i, n - 1, n - 1), -1);
        if (a.top == d.top) {
          let V = qo(pu(i, n, n + 1), -1);
          if (V.top != d.top)
            return mc(V, V.left < a.left);
        }
      }
      return d;
    } else {
      let d = n, a = n, V = t < 0 ? 1 : -1;
      return t < 0 && !n ? (a++, V = -1) : t >= 0 && n == i.nodeValue.length ? (d--, V = 1) : t < 0 ? d-- : a++, mc(qo(pu(i, d, a), V), V < 0);
    }
  if (!e.state.doc.resolve(r - (s || 0)).parent.inlineContent) {
    if (s == null && n && (t < 0 || n == Cn(i))) {
      let d = i.childNodes[n - 1];
      if (d.nodeType == 1)
        return kg(d.getBoundingClientRect(), !1);
    }
    if (s == null && n < Cn(i)) {
      let d = i.childNodes[n];
      if (d.nodeType == 1)
        return kg(d.getBoundingClientRect(), !0);
    }
    return kg(i.getBoundingClientRect(), t >= 0);
  }
  if (s == null && n && (t < 0 || n == Cn(i))) {
    let d = i.childNodes[n - 1], a = d.nodeType == 3 ? pu(d, Cn(d) - (u ? 0 : 1)) : d.nodeType == 1 && (d.nodeName != "BR" || !d.nextSibling) ? d : null;
    if (a)
      return mc(qo(a, 1), !1);
  }
  if (s == null && n < Cn(i)) {
    let d = i.childNodes[n];
    for (; d.pmViewDesc && d.pmViewDesc.ignoreForCoords; )
      d = d.nextSibling;
    let a = d ? d.nodeType == 3 ? pu(d, 0, u ? 0 : 1) : d.nodeType == 1 ? d : null : null;
    if (a)
      return mc(qo(a, -1), !0);
  }
  return mc(qo(i.nodeType == 3 ? pu(i) : i, -t), t >= 0);
}
function mc(e, r) {
  if (e.width == 0)
    return e;
  let t = r ? e.left : e.right;
  return { top: e.top, bottom: e.bottom, left: t, right: t };
}
function kg(e, r) {
  if (e.height == 0)
    return e;
  let t = r ? e.top : e.bottom;
  return { top: t, bottom: t, left: e.left, right: e.right };
}
function eee(e, r, t) {
  let i = e.state, n = e.root.activeElement;
  i != r && e.updateState(r), n != e.dom && e.focus();
  try {
    return t();
  } finally {
    i != r && e.updateState(i), n != e.dom && n && n.focus();
  }
}
function $He(e, r, t) {
  let i = r.selection, n = t == "up" ? i.$from : i.$to;
  return eee(e, r, () => {
    let { node: s } = e.docView.domFromPos(n.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let o = e.docView.nearestDesc(s, !0);
      if (!o)
        break;
      if (o.node.isBlock) {
        s = o.contentDOM || o.dom;
        break;
      }
      s = o.dom.parentNode;
    }
    let u = QQ(e, n.pos, 1);
    for (let o = s.firstChild; o; o = o.nextSibling) {
      let d;
      if (o.nodeType == 1)
        d = o.getClientRects();
      else if (o.nodeType == 3)
        d = pu(o, 0, o.nodeValue.length).getClientRects();
      else
        continue;
      for (let a = 0; a < d.length; a++) {
        let V = d[a];
        if (V.bottom > V.top + 1 && (t == "up" ? u.top - V.top > (V.bottom - u.top) * 2 : V.bottom - u.bottom > (u.bottom - V.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const QHe = /[\u0590-\u08ac]/;
function eje(e, r, t) {
  let { $head: i } = r.selection;
  if (!i.parent.isTextblock)
    return !1;
  let n = i.parentOffset, s = !n, u = n == i.parent.content.size, o = e.domSelection();
  return o ? !QHe.test(i.parent.textContent) || !o.modify ? t == "left" || t == "backward" ? s : u : eee(e, r, () => {
    let { focusNode: d, focusOffset: a, anchorNode: V, anchorOffset: c } = e.domSelectionRange(), F = o.caretBidiLevel;
    o.modify("move", t, "character");
    let X = i.depth ? e.docView.domAfterPos(i.before()) : e.dom, { focusNode: Y, focusOffset: q } = e.domSelectionRange(), f = Y && !X.contains(Y.nodeType == 1 ? Y : Y.parentNode) || d == Y && a == q;
    try {
      o.collapse(V, c), d && (d != V || a != c) && o.extend && o.extend(d, a);
    } catch {
    }
    return F != null && (o.caretBidiLevel = F), f;
  }) : i.pos == i.start() || i.pos == i.end();
}
let EO = null, kO = null, OO = !1;
function rje(e, r, t) {
  return EO == r && kO == t ? OO : (EO = r, kO = t, OO = t == "up" || t == "down" ? $He(e, r, t) : eje(e, r, t));
}
const En = 0, DO = 1, Nd = 2, Ws = 3;
class O2 {
  constructor(r, t, i, n) {
    this.parent = r, this.children = t, this.dom = i, this.contentDOM = n, this.dirty = En, i.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(r) {
    return !1;
  }
  matchesMark(r) {
    return !1;
  }
  matchesNode(r, t, i) {
    return !1;
  }
  matchesHack(r) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(r) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let r = 0;
    for (let t = 0; t < this.children.length; t++)
      r += this.children[t].size;
    return r;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let r = 0; r < this.children.length; r++)
      this.children[r].destroy();
  }
  posBeforeChild(r) {
    for (let t = 0, i = this.posAtStart; ; t++) {
      let n = this.children[t];
      if (n == r)
        return i;
      i += n.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(r, t, i) {
    if (this.contentDOM && this.contentDOM.contains(r.nodeType == 1 ? r : r.parentNode))
      if (i < 0) {
        let s, u;
        if (r == this.contentDOM)
          s = r.childNodes[t - 1];
        else {
          for (; r.parentNode != this.contentDOM; )
            r = r.parentNode;
          s = r.previousSibling;
        }
        for (; s && !((u = s.pmViewDesc) && u.parent == this); )
          s = s.previousSibling;
        return s ? this.posBeforeChild(u) + u.size : this.posAtStart;
      } else {
        let s, u;
        if (r == this.contentDOM)
          s = r.childNodes[t];
        else {
          for (; r.parentNode != this.contentDOM; )
            r = r.parentNode;
          s = r.nextSibling;
        }
        for (; s && !((u = s.pmViewDesc) && u.parent == this); )
          s = s.nextSibling;
        return s ? this.posBeforeChild(u) : this.posAtEnd;
      }
    let n;
    if (r == this.dom && this.contentDOM)
      n = t > ei(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      n = r.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let s = r; ; s = s.parentNode) {
          if (s == this.dom) {
            n = !1;
            break;
          }
          if (s.previousSibling)
            break;
        }
      if (n == null && t == r.childNodes.length)
        for (let s = r; ; s = s.parentNode) {
          if (s == this.dom) {
            n = !0;
            break;
          }
          if (s.nextSibling)
            break;
        }
    }
    return n ?? i > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(r, t = !1) {
    for (let i = !0, n = r; n; n = n.parentNode) {
      let s = this.getDesc(n), u;
      if (s && (!t || s.node))
        if (i && (u = s.nodeDOM) && !(u.nodeType == 1 ? u.contains(r.nodeType == 1 ? r : r.parentNode) : u == r))
          i = !1;
        else
          return s;
    }
  }
  getDesc(r) {
    let t = r.pmViewDesc;
    for (let i = t; i; i = i.parent)
      if (i == this)
        return t;
  }
  posFromDOM(r, t, i) {
    for (let n = r; n; n = n.parentNode) {
      let s = this.getDesc(n);
      if (s)
        return s.localPosFromDOM(r, t, i);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(r) {
    for (let t = 0, i = 0; t < this.children.length; t++) {
      let n = this.children[t], s = i + n.size;
      if (i == r && s != i) {
        for (; !n.border && n.children.length; )
          n = n.children[0];
        return n;
      }
      if (r < s)
        return n.descAt(r - i - n.border);
      i = s;
    }
  }
  domFromPos(r, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: r + 1 };
    let i = 0, n = 0;
    for (let s = 0; i < this.children.length; i++) {
      let u = this.children[i], o = s + u.size;
      if (o > r || u instanceof tee) {
        n = r - s;
        break;
      }
      s = o;
    }
    if (n)
      return this.children[i].domFromPos(n - this.children[i].border, t);
    for (let s; i && !(s = this.children[i - 1]).size && s instanceof ree && s.side >= 0; i--)
      ;
    if (t <= 0) {
      let s, u = !0;
      for (; s = i ? this.children[i - 1] : null, !(!s || s.dom.parentNode == this.contentDOM); i--, u = !1)
        ;
      return s && t && u && !s.border && !s.domAtom ? s.domFromPos(s.size, t) : { node: this.contentDOM, offset: s ? ei(s.dom) + 1 : 0 };
    } else {
      let s, u = !0;
      for (; s = i < this.children.length ? this.children[i] : null, !(!s || s.dom.parentNode == this.contentDOM); i++, u = !1)
        ;
      return s && u && !s.border && !s.domAtom ? s.domFromPos(0, t) : { node: this.contentDOM, offset: s ? ei(s.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(r, t, i = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: r, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let n = -1, s = -1;
    for (let u = i, o = 0; ; o++) {
      let d = this.children[o], a = u + d.size;
      if (n == -1 && r <= a) {
        let V = u + d.border;
        if (r >= V && t <= a - d.border && d.node && d.contentDOM && this.contentDOM.contains(d.contentDOM))
          return d.parseRange(r, t, V);
        r = u;
        for (let c = o; c > 0; c--) {
          let F = this.children[c - 1];
          if (F.size && F.dom.parentNode == this.contentDOM && !F.emptyChildAt(1)) {
            n = ei(F.dom) + 1;
            break;
          }
          r -= F.size;
        }
        n == -1 && (n = 0);
      }
      if (n > -1 && (a > t || o == this.children.length - 1)) {
        t = a;
        for (let V = o + 1; V < this.children.length; V++) {
          let c = this.children[V];
          if (c.size && c.dom.parentNode == this.contentDOM && !c.emptyChildAt(-1)) {
            s = ei(c.dom);
            break;
          }
          t += c.size;
        }
        s == -1 && (s = this.contentDOM.childNodes.length);
        break;
      }
      u = a;
    }
    return { node: this.contentDOM, from: r, to: t, fromOffset: n, toOffset: s };
  }
  emptyChildAt(r) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[r < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(r);
  }
  domAfterPos(r) {
    let { node: t, offset: i } = this.domFromPos(r, 0);
    if (t.nodeType != 1 || i == t.childNodes.length)
      throw new RangeError("No node after pos " + r);
    return t.childNodes[i];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(r, t, i, n = !1) {
    let s = Math.min(r, t), u = Math.max(r, t);
    for (let F = 0, X = 0; F < this.children.length; F++) {
      let Y = this.children[F], q = X + Y.size;
      if (s > X && u < q)
        return Y.setSelection(r - X - Y.border, t - X - Y.border, i, n);
      X = q;
    }
    let o = this.domFromPos(r, r ? -1 : 1), d = t == r ? o : this.domFromPos(t, t ? -1 : 1), a = i.getSelection(), V = !1;
    if ((Xs || Si) && r == t) {
      let { node: F, offset: X } = o;
      if (F.nodeType == 3) {
        if (V = !!(X && F.nodeValue[X - 1] == `
`), V && X == F.nodeValue.length)
          for (let Y = F, q; Y; Y = Y.parentNode) {
            if (q = Y.nextSibling) {
              q.nodeName == "BR" && (o = d = { node: q.parentNode, offset: ei(q) + 1 });
              break;
            }
            let f = Y.pmViewDesc;
            if (f && f.node && f.node.isBlock)
              break;
          }
      } else {
        let Y = F.childNodes[X - 1];
        V = Y && (Y.nodeName == "BR" || Y.contentEditable == "false");
      }
    }
    if (Xs && a.focusNode && a.focusNode != d.node && a.focusNode.nodeType == 1) {
      let F = a.focusNode.childNodes[a.focusOffset];
      F && F.contentEditable == "false" && (n = !0);
    }
    if (!(n || V && Si) && ia(o.node, o.offset, a.anchorNode, a.anchorOffset) && ia(d.node, d.offset, a.focusNode, a.focusOffset))
      return;
    let c = !1;
    if ((a.extend || r == t) && !V) {
      a.collapse(o.node, o.offset);
      try {
        r != t && a.extend(d.node, d.offset), c = !0;
      } catch {
      }
    }
    if (!c) {
      if (r > t) {
        let X = o;
        o = d, d = X;
      }
      let F = document.createRange();
      F.setEnd(d.node, d.offset), F.setStart(o.node, o.offset), a.removeAllRanges(), a.addRange(F);
    }
  }
  ignoreMutation(r) {
    return !this.contentDOM && r.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(r, t) {
    for (let i = 0, n = 0; n < this.children.length; n++) {
      let s = this.children[n], u = i + s.size;
      if (i == u ? r <= u && t >= i : r < u && t > i) {
        let o = i + s.border, d = u - s.border;
        if (r >= o && t <= d) {
          this.dirty = r == i || t == u ? Nd : DO, r == o && t == d && (s.contentLost || s.dom.parentNode != this.contentDOM) ? s.dirty = Ws : s.markDirty(r - o, t - o);
          return;
        } else
          s.dirty = s.dom == s.contentDOM && s.dom.parentNode == this.contentDOM && !s.children.length ? Nd : Ws;
      }
      i = u;
    }
    this.dirty = Nd;
  }
  markParentsDirty() {
    let r = 1;
    for (let t = this.parent; t; t = t.parent, r++) {
      let i = r == 1 ? Nd : DO;
      t.dirty < i && (t.dirty = i);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  isText(r) {
    return !1;
  }
}
class ree extends O2 {
  constructor(r, t, i, n) {
    let s, u = t.type.toDOM;
    if (typeof u == "function" && (u = u(i, () => {
      if (!s)
        return n;
      if (s.parent)
        return s.parent.posBeforeChild(s);
    })), !t.type.spec.raw) {
      if (u.nodeType != 1) {
        let o = document.createElement("span");
        o.appendChild(u), u = o;
      }
      u.contentEditable = "false", u.classList.add("ProseMirror-widget");
    }
    super(r, [], u, null), this.widget = t, this.widget = t, s = this;
  }
  matchesWidget(r) {
    return this.dirty == En && r.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(r) {
    let t = this.widget.spec.stopEvent;
    return t ? t(r) : !1;
  }
  ignoreMutation(r) {
    return r.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class tje extends O2 {
  constructor(r, t, i, n) {
    super(r, [], t, null), this.textDOM = i, this.text = n;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(r, t) {
    return r != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(r) {
    return { node: this.textDOM, offset: r };
  }
  ignoreMutation(r) {
    return r.type === "characterData" && r.target.nodeValue == r.oldValue;
  }
}
class na extends O2 {
  constructor(r, t, i, n, s) {
    super(r, [], i, n), this.mark = t, this.spec = s;
  }
  static create(r, t, i, n) {
    let s = n.nodeViews[t.type.name], u = s && s(t, n, i);
    return (!u || !u.dom) && (u = qa.renderSpec(document, t.type.spec.toDOM(t, i), null, t.attrs)), new na(r, t, u.dom, u.contentDOM || u.dom, u);
  }
  parseRule() {
    return this.dirty & Ws || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(r) {
    return this.dirty != Ws && this.mark.eq(r);
  }
  markDirty(r, t) {
    if (super.markDirty(r, t), this.dirty != En) {
      let i = this.parent;
      for (; !i.node; )
        i = i.parent;
      i.dirty < this.dirty && (i.dirty = this.dirty), this.dirty = En;
    }
  }
  slice(r, t, i) {
    let n = na.create(this.parent, this.mark, !0, i), s = this.children, u = this.size;
    t < u && (s = iy(s, t, u, i)), r > 0 && (s = iy(s, 0, r, i));
    for (let o = 0; o < s.length; o++)
      s[o].parent = n;
    return n.children = s, n;
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class ko extends O2 {
  constructor(r, t, i, n, s, u, o, d, a) {
    super(r, [], s, u), this.node = t, this.outerDeco = i, this.innerDeco = n, this.nodeDOM = o;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(r, t, i, n, s, u) {
    let o = s.nodeViews[t.type.name], d, a = o && o(t, s, () => {
      if (!d)
        return u;
      if (d.parent)
        return d.parent.posBeforeChild(d);
    }, i, n), V = a && a.dom, c = a && a.contentDOM;
    if (t.isText) {
      if (!V)
        V = document.createTextNode(t.text);
      else if (V.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else V || ({ dom: V, contentDOM: c } = qa.renderSpec(document, t.type.spec.toDOM(t), null, t.attrs));
    !c && !t.isText && V.nodeName != "BR" && (V.hasAttribute("contenteditable") || (V.contentEditable = "false"), t.type.spec.draggable && (V.draggable = !0));
    let F = V;
    return V = see(V, i, t), a ? d = new ije(r, t, i, n, V, c || null, F, a, s, u + 1) : t.isText ? new Rf(r, t, i, n, V, F, s) : new ko(r, t, i, n, V, c || null, F, s, u + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let r = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (r.preserveWhitespace = "full"), !this.contentDOM)
      r.getContent = () => this.node.content;
    else if (!this.contentLost)
      r.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let i = this.children[t];
        if (this.dom.contains(i.dom.parentNode)) {
          r.contentElement = i.dom.parentNode;
          break;
        }
      }
      r.contentElement || (r.getContent = () => Fe.empty);
    }
    return r;
  }
  matchesNode(r, t, i) {
    return this.dirty == En && r.eq(this.node) && pq(t, this.outerDeco) && i.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(r, t) {
    let i = this.node.inlineContent, n = t, s = r.composing ? this.localCompositionInfo(r, t) : null, u = s && s.pos > -1 ? s : null, o = s && s.pos < 0, d = new sje(this, u && u.node, r);
    dje(this.node, this.innerDeco, (a, V, c) => {
      a.spec.marks ? d.syncToMarks(a.spec.marks, i, r) : a.type.side >= 0 && !c && d.syncToMarks(V == this.node.childCount ? wr.none : this.node.child(V).marks, i, r), d.placeWidget(a, r, n);
    }, (a, V, c, F) => {
      d.syncToMarks(a.marks, i, r);
      let X;
      d.findNodeMatch(a, V, c, F) || o && r.state.selection.from > n && r.state.selection.to < n + a.nodeSize && (X = d.findIndexWithChild(s.node)) > -1 && d.updateNodeAt(a, V, c, X, r) || d.updateNextNode(a, V, c, r, F, n) || d.addNode(a, V, c, r, n), n += a.nodeSize;
    }), d.syncToMarks([], i, r), this.node.isTextblock && d.addTextblockHacks(), d.destroyRest(), (d.changed || this.dirty == Nd) && (u && this.protectLocalComposition(r, u), iee(this.contentDOM, this.children, r), Vl && aje(this.dom));
  }
  localCompositionInfo(r, t) {
    let { from: i, to: n } = r.state.selection;
    if (!(r.state.selection instanceof Ze) || i < t || n > t + this.node.content.size)
      return null;
    let s = r.input.compositionNode;
    if (!s || !this.dom.contains(s.parentNode))
      return null;
    if (this.node.inlineContent) {
      let u = s.nodeValue, o = Vje(this.node.content, u, i - t, n - t);
      return o < 0 ? null : { node: s, pos: o, text: u };
    } else
      return { node: s, pos: -1, text: "" };
  }
  protectLocalComposition(r, { node: t, pos: i, text: n }) {
    if (this.getDesc(t))
      return;
    let s = t;
    for (; s.parentNode != this.contentDOM; s = s.parentNode) {
      for (; s.previousSibling; )
        s.parentNode.removeChild(s.previousSibling);
      for (; s.nextSibling; )
        s.parentNode.removeChild(s.nextSibling);
      s.pmViewDesc && (s.pmViewDesc = void 0);
    }
    let u = new tje(this, s, t, n);
    r.input.compositionNodes.push(u), this.children = iy(this.children, i, i + n.length, r, u);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(r, t, i, n) {
    return this.dirty == Ws || !r.sameMarkup(this.node) ? !1 : (this.updateInner(r, t, i, n), !0);
  }
  updateInner(r, t, i, n) {
    this.updateOuterDeco(t), this.node = r, this.innerDeco = i, this.contentDOM && this.updateChildren(n, this.posAtStart), this.dirty = En;
  }
  updateOuterDeco(r) {
    if (pq(r, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, i = this.dom;
    this.dom = nee(this.dom, this.nodeDOM, ty(this.outerDeco, this.node, t), ty(r, this.node, t)), this.dom != i && (i.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = r;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function RO(e, r, t, i, n) {
  see(i, r, e);
  let s = new ko(void 0, e, r, t, i, i, i, n, 0);
  return s.contentDOM && s.updateChildren(n, 0), s;
}
class Rf extends ko {
  constructor(r, t, i, n, s, u, o) {
    super(r, t, i, n, s, null, u, o, 0);
  }
  parseRule() {
    let r = this.nodeDOM.parentNode;
    for (; r && r != this.dom && !r.pmIsDeco; )
      r = r.parentNode;
    return { skip: r || !0 };
  }
  update(r, t, i, n) {
    return this.dirty == Ws || this.dirty != En && !this.inParent() || !r.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != En || r.text != this.node.text) && r.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = r.text, n.trackWrites == this.nodeDOM && (n.trackWrites = null)), this.node = r, this.dirty = En, !0);
  }
  inParent() {
    let r = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == r)
        return !0;
    return !1;
  }
  domFromPos(r) {
    return { node: this.nodeDOM, offset: r };
  }
  localPosFromDOM(r, t, i) {
    return r == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(r, t, i);
  }
  ignoreMutation(r) {
    return r.type != "characterData" && r.type != "selection";
  }
  slice(r, t, i) {
    let n = this.node.cut(r, t), s = document.createTextNode(n.text);
    return new Rf(this.parent, n, this.outerDeco, this.innerDeco, s, s, i);
  }
  markDirty(r, t) {
    super.markDirty(r, t), this.dom != this.nodeDOM && (r == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = Ws);
  }
  get domAtom() {
    return !1;
  }
  isText(r) {
    return this.node.text == r;
  }
}
class tee extends O2 {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(r) {
    return this.dirty == En && this.dom.nodeName == r;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class ije extends ko {
  constructor(r, t, i, n, s, u, o, d, a, V) {
    super(r, t, i, n, s, u, o, a, V), this.spec = d;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(r, t, i, n) {
    if (this.dirty == Ws)
      return !1;
    if (this.spec.update && (this.node.type == r.type || this.spec.multiType)) {
      let s = this.spec.update(r, t, i);
      return s && this.updateInner(r, t, i, n), s;
    } else return !this.contentDOM && !r.isLeaf ? !1 : super.update(r, t, i, n);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(r, t, i, n) {
    this.spec.setSelection ? this.spec.setSelection(r, t, i) : super.setSelection(r, t, i, n);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(r) {
    return this.spec.stopEvent ? this.spec.stopEvent(r) : !1;
  }
  ignoreMutation(r) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(r) : super.ignoreMutation(r);
  }
}
function iee(e, r, t) {
  let i = e.firstChild, n = !1;
  for (let s = 0; s < r.length; s++) {
    let u = r[s], o = u.dom;
    if (o.parentNode == e) {
      for (; o != i; )
        i = IO(i), n = !0;
      i = i.nextSibling;
    } else
      n = !0, e.insertBefore(o, i);
    if (u instanceof na) {
      let d = i ? i.previousSibling : e.lastChild;
      iee(u.contentDOM, u.children, t), i = d ? d.nextSibling : e.firstChild;
    }
  }
  for (; i; )
    i = IO(i), n = !0;
  n && t.trackWrites == e && (t.trackWrites = null);
}
const Bc = function(e) {
  e && (this.nodeName = e);
};
Bc.prototype = /* @__PURE__ */ Object.create(null);
const Md = [new Bc()];
function ty(e, r, t) {
  if (e.length == 0)
    return Md;
  let i = t ? Md[0] : new Bc(), n = [i];
  for (let s = 0; s < e.length; s++) {
    let u = e[s].type.attrs;
    if (u) {
      u.nodeName && n.push(i = new Bc(u.nodeName));
      for (let o in u) {
        let d = u[o];
        d != null && (t && n.length == 1 && n.push(i = new Bc(r.isInline ? "span" : "div")), o == "class" ? i.class = (i.class ? i.class + " " : "") + d : o == "style" ? i.style = (i.style ? i.style + ";" : "") + d : o != "nodeName" && (i[o] = d));
      }
    }
  }
  return n;
}
function nee(e, r, t, i) {
  if (t == Md && i == Md)
    return r;
  let n = r;
  for (let s = 0; s < i.length; s++) {
    let u = i[s], o = t[s];
    if (s) {
      let d;
      o && o.nodeName == u.nodeName && n != e && (d = n.parentNode) && d.nodeName.toLowerCase() == u.nodeName || (d = document.createElement(u.nodeName), d.pmIsDeco = !0, d.appendChild(n), o = Md[0]), n = d;
    }
    nje(n, o || Md[0], u);
  }
  return n;
}
function nje(e, r, t) {
  for (let i in r)
    i != "class" && i != "style" && i != "nodeName" && !(i in t) && e.removeAttribute(i);
  for (let i in t)
    i != "class" && i != "style" && i != "nodeName" && t[i] != r[i] && e.setAttribute(i, t[i]);
  if (r.class != t.class) {
    let i = r.class ? r.class.split(" ").filter(Boolean) : [], n = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let s = 0; s < i.length; s++)
      n.indexOf(i[s]) == -1 && e.classList.remove(i[s]);
    for (let s = 0; s < n.length; s++)
      i.indexOf(n[s]) == -1 && e.classList.add(n[s]);
    e.classList.length == 0 && e.removeAttribute("class");
  }
  if (r.style != t.style) {
    if (r.style) {
      let i = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, n;
      for (; n = i.exec(r.style); )
        e.style.removeProperty(n[1]);
    }
    t.style && (e.style.cssText += t.style);
  }
}
function see(e, r, t) {
  return nee(e, e, Md, ty(r, t, e.nodeType != 1));
}
function pq(e, r) {
  if (e.length != r.length)
    return !1;
  for (let t = 0; t < e.length; t++)
    if (!e[t].type.eq(r[t].type))
      return !1;
  return !0;
}
function IO(e) {
  let r = e.nextSibling;
  return e.parentNode.removeChild(e), r;
}
class sje {
  constructor(r, t, i) {
    this.lock = t, this.view = i, this.index = 0, this.stack = [], this.changed = !1, this.top = r, this.preMatch = uje(r.node.content, r);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(r, t) {
    if (r != t) {
      for (let i = r; i < t; i++)
        this.top.children[i].destroy();
      this.top.children.splice(r, t - r), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(r, t, i) {
    let n = 0, s = this.stack.length >> 1, u = Math.min(s, r.length);
    for (; n < u && (n == s - 1 ? this.top : this.stack[n + 1 << 1]).matchesMark(r[n]) && r[n].type.spec.spanning !== !1; )
      n++;
    for (; n < s; )
      this.destroyRest(), this.top.dirty = En, this.index = this.stack.pop(), this.top = this.stack.pop(), s--;
    for (; s < r.length; ) {
      this.stack.push(this.top, this.index + 1);
      let o = -1;
      for (let d = this.index; d < Math.min(this.index + 3, this.top.children.length); d++) {
        let a = this.top.children[d];
        if (a.matchesMark(r[s]) && !this.isLocked(a.dom)) {
          o = d;
          break;
        }
      }
      if (o > -1)
        o > this.index && (this.changed = !0, this.destroyBetween(this.index, o)), this.top = this.top.children[this.index];
      else {
        let d = na.create(this.top, r[s], t, i);
        this.top.children.splice(this.index, 0, d), this.top = d, this.changed = !0;
      }
      this.index = 0, s++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(r, t, i, n) {
    let s = -1, u;
    if (n >= this.preMatch.index && (u = this.preMatch.matches[n - this.preMatch.index]).parent == this.top && u.matchesNode(r, t, i))
      s = this.top.children.indexOf(u, this.index);
    else
      for (let o = this.index, d = Math.min(this.top.children.length, o + 5); o < d; o++) {
        let a = this.top.children[o];
        if (a.matchesNode(r, t, i) && !this.preMatch.matched.has(a)) {
          s = o;
          break;
        }
      }
    return s < 0 ? !1 : (this.destroyBetween(this.index, s), this.index++, !0);
  }
  updateNodeAt(r, t, i, n, s) {
    let u = this.top.children[n];
    return u.dirty == Ws && u.dom == u.contentDOM && (u.dirty = Nd), u.update(r, t, i, s) ? (this.destroyBetween(this.index, n), this.index++, !0) : !1;
  }
  findIndexWithChild(r) {
    for (; ; ) {
      let t = r.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let i = r.pmViewDesc;
        if (i) {
          for (let n = this.index; n < this.top.children.length; n++)
            if (this.top.children[n] == i)
              return n;
        }
        return -1;
      }
      r = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(r, t, i, n, s, u) {
    for (let o = this.index; o < this.top.children.length; o++) {
      let d = this.top.children[o];
      if (d instanceof ko) {
        let a = this.preMatch.matched.get(d);
        if (a != null && a != s)
          return !1;
        let V = d.dom, c, F = this.isLocked(V) && !(r.isText && d.node && d.node.isText && d.nodeDOM.nodeValue == r.text && d.dirty != Ws && pq(t, d.outerDeco));
        if (!F && d.update(r, t, i, n))
          return this.destroyBetween(this.index, o), d.dom != V && (this.changed = !0), this.index++, !0;
        if (!F && (c = this.recreateWrapper(d, r, t, i, n, u)))
          return this.destroyBetween(this.index, o), this.top.children[this.index] = c, c.contentDOM && (c.dirty = Nd, c.updateChildren(n, u + 1), c.dirty = En), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(r, t, i, n, s, u) {
    if (r.dirty || t.isAtom || !r.children.length || !r.node.content.eq(t.content) || !pq(i, r.outerDeco) || !n.eq(r.innerDeco))
      return null;
    let o = ko.create(this.top, t, i, n, s, u);
    if (o.contentDOM) {
      o.children = r.children, r.children = [];
      for (let d of o.children)
        d.parent = o;
    }
    return r.destroy(), o;
  }
  // Insert the node as a newly created node desc.
  addNode(r, t, i, n, s) {
    let u = ko.create(this.top, r, t, i, n, s);
    u.contentDOM && u.updateChildren(n, s + 1), this.top.children.splice(this.index++, 0, u), this.changed = !0;
  }
  placeWidget(r, t, i) {
    let n = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (n && n.matchesWidget(r) && (r == n.widget || !n.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let s = new ree(this.top, r, t, i);
      this.top.children.splice(this.index++, 0, s), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let r = this.top.children[this.index - 1], t = this.top;
    for (; r instanceof na; )
      t = r, r = t.children[t.children.length - 1];
    (!r || // Empty textblock
    !(r instanceof Rf) || /\n$/.test(r.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(r.node.text)) && ((Si || qi) && r && r.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(r, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(r))
      this.index++;
    else {
      let i = document.createElement(r);
      r == "IMG" && (i.className = "ProseMirror-separator", i.alt = ""), r == "BR" && (i.className = "ProseMirror-trailingBreak");
      let n = new tee(this.top, [], i, null);
      t != this.top ? t.children.push(n) : t.children.splice(this.index++, 0, n), this.changed = !0;
    }
  }
  isLocked(r) {
    return this.lock && (r == this.lock || r.nodeType == 1 && r.contains(this.lock.parentNode));
  }
}
function uje(e, r) {
  let t = r, i = t.children.length, n = e.childCount, s = /* @__PURE__ */ new Map(), u = [];
  e: for (; n > 0; ) {
    let o;
    for (; ; )
      if (i) {
        let a = t.children[i - 1];
        if (a instanceof na)
          t = a, i = a.children.length;
        else {
          o = a, i--;
          break;
        }
      } else {
        if (t == r)
          break e;
        i = t.parent.children.indexOf(t), t = t.parent;
      }
    let d = o.node;
    if (d) {
      if (d != e.child(n - 1))
        break;
      --n, s.set(o, n), u.push(o);
    }
  }
  return { index: n, matched: s, matches: u.reverse() };
}
function oje(e, r) {
  return e.type.side - r.type.side;
}
function dje(e, r, t, i) {
  let n = r.locals(e), s = 0;
  if (n.length == 0) {
    for (let a = 0; a < e.childCount; a++) {
      let V = e.child(a);
      i(V, n, r.forChild(s, V), a), s += V.nodeSize;
    }
    return;
  }
  let u = 0, o = [], d = null;
  for (let a = 0; ; ) {
    let V, c;
    for (; u < n.length && n[u].to == s; ) {
      let f = n[u++];
      f.widget && (V ? (c || (c = [V])).push(f) : V = f);
    }
    if (V)
      if (c) {
        c.sort(oje);
        for (let f = 0; f < c.length; f++)
          t(c[f], a, !!d);
      } else
        t(V, a, !!d);
    let F, X;
    if (d)
      X = -1, F = d, d = null;
    else if (a < e.childCount)
      X = a, F = e.child(a++);
    else
      break;
    for (let f = 0; f < o.length; f++)
      o[f].to <= s && o.splice(f--, 1);
    for (; u < n.length && n[u].from <= s && n[u].to > s; )
      o.push(n[u++]);
    let Y = s + F.nodeSize;
    if (F.isText) {
      let f = Y;
      u < n.length && n[u].from < f && (f = n[u].from);
      for (let p = 0; p < o.length; p++)
        o[p].to < f && (f = o[p].to);
      f < Y && (d = F.cut(f - s), F = F.cut(0, f - s), Y = f, X = -1);
    } else
      for (; u < n.length && n[u].to < Y; )
        u++;
    let q = F.isInline && !F.isLeaf ? o.filter((f) => !f.inline) : o.slice();
    i(F, q, r.forChild(s, F), X), s = Y;
  }
}
function aje(e) {
  if (e.nodeName == "UL" || e.nodeName == "OL") {
    let r = e.style.cssText;
    e.style.cssText = r + "; list-style: square !important", window.getComputedStyle(e).listStyle, e.style.cssText = r;
  }
}
function Vje(e, r, t, i) {
  for (let n = 0, s = 0; n < e.childCount && s <= i; ) {
    let u = e.child(n++), o = s;
    if (s += u.nodeSize, !u.isText)
      continue;
    let d = u.text;
    for (; n < e.childCount; ) {
      let a = e.child(n++);
      if (s += a.nodeSize, !a.isText)
        break;
      d += a.text;
    }
    if (s >= t) {
      if (s >= i && d.slice(i - r.length - o, i - o) == r)
        return i - r.length;
      let a = o < i ? d.lastIndexOf(r, i - o - 1) : -1;
      if (a >= 0 && a + r.length + o >= t)
        return o + a;
      if (t == i && d.length >= i + r.length - o && d.slice(i - o, i - o + r.length) == r)
        return i;
    }
  }
  return -1;
}
function iy(e, r, t, i, n) {
  let s = [];
  for (let u = 0, o = 0; u < e.length; u++) {
    let d = e[u], a = o, V = o += d.size;
    a >= t || V <= r ? s.push(d) : (a < r && s.push(d.slice(0, r - a, i)), n && (s.push(n), n = void 0), V > t && s.push(d.slice(t - a, d.size, i)));
  }
  return s;
}
function k4(e, r = null) {
  let t = e.domSelectionRange(), i = e.state.doc;
  if (!t.focusNode)
    return null;
  let n = e.docView.nearestDesc(t.focusNode), s = n && n.size == 0, u = e.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (u < 0)
    return null;
  let o = i.resolve(u), d, a;
  if (Df(t)) {
    for (d = u; n && !n.node; )
      n = n.parent;
    let c = n.node;
    if (n && c.isAtom && ke.isSelectable(c) && n.parent && !(c.isInline && kHe(t.focusNode, t.focusOffset, n.dom))) {
      let F = n.posBefore;
      a = new ke(u == F ? o : i.resolve(F));
    }
  } else {
    if (t instanceof e.dom.ownerDocument.defaultView.Selection && t.rangeCount > 1) {
      let c = u, F = u;
      for (let X = 0; X < t.rangeCount; X++) {
        let Y = t.getRangeAt(X);
        c = Math.min(c, e.docView.posFromDOM(Y.startContainer, Y.startOffset, 1)), F = Math.max(F, e.docView.posFromDOM(Y.endContainer, Y.endOffset, -1));
      }
      if (c < 0)
        return null;
      [d, u] = F == e.state.selection.anchor ? [F, c] : [c, F], o = i.resolve(u);
    } else
      d = e.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (d < 0)
      return null;
  }
  let V = i.resolve(d);
  if (!a) {
    let c = r == "pointer" || e.state.selection.head < o.pos && !s ? 1 : -1;
    a = O4(e, V, o, c);
  }
  return a;
}
function uee(e) {
  return e.editable ? e.hasFocus() : dee(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function Eu(e, r = !1) {
  let t = e.state.selection;
  if (oee(e, t), !!uee(e)) {
    if (!r && e.input.mouseDown && e.input.mouseDown.allowDefault && qi) {
      let i = e.domSelectionRange(), n = e.domObserver.currentSelection;
      if (i.anchorNode && n.anchorNode && ia(i.anchorNode, i.anchorOffset, n.anchorNode, n.anchorOffset)) {
        e.input.mouseDown.delayedSelectionSync = !0, e.domObserver.setCurSelection();
        return;
      }
    }
    if (e.domObserver.disconnectSelection(), e.cursorWrapper)
      cje(e);
    else {
      let { anchor: i, head: n } = t, s, u;
      LO && !(t instanceof Ze) && (t.$from.parent.inlineContent || (s = _O(e, t.from)), !t.empty && !t.$from.parent.inlineContent && (u = _O(e, t.to))), e.docView.setSelection(i, n, e.root, r), LO && (s && HO(s), u && HO(u)), t.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && lje(e));
    }
    e.domObserver.setCurSelection(), e.domObserver.connectSelection();
  }
}
const LO = Si || qi && GQ < 63;
function _O(e, r) {
  let { node: t, offset: i } = e.docView.domFromPos(r, 0), n = i < t.childNodes.length ? t.childNodes[i] : null, s = i ? t.childNodes[i - 1] : null;
  if (Si && n && n.contentEditable == "false")
    return Og(n);
  if ((!n || n.contentEditable == "false") && (!s || s.contentEditable == "false")) {
    if (n)
      return Og(n);
    if (s)
      return Og(s);
  }
}
function Og(e) {
  return e.contentEditable = "true", Si && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function HO(e) {
  e.contentEditable = "false", e.wasDraggable && (e.draggable = !0, e.wasDraggable = null);
}
function lje(e) {
  let r = e.dom.ownerDocument;
  r.removeEventListener("selectionchange", e.input.hideSelectionGuard);
  let t = e.domSelectionRange(), i = t.anchorNode, n = t.anchorOffset;
  r.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
    (t.anchorNode != i || t.anchorOffset != n) && (r.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
      (!uee(e) || e.state.selection.visible) && e.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function cje(e) {
  let r = e.domSelection(), t = document.createRange();
  if (!r)
    return;
  let i = e.cursorWrapper.dom, n = i.nodeName == "IMG";
  n ? t.setStart(i.parentNode, ei(i) + 1) : t.setStart(i, 0), t.collapse(!0), r.removeAllRanges(), r.addRange(t), !n && !e.state.selection.visible && Bi && Eo <= 11 && (i.disabled = !0, i.disabled = !1);
}
function oee(e, r) {
  if (r instanceof ke) {
    let t = e.docView.descAt(r.from);
    t != e.lastSelectedViewDesc && (jO(e), t && t.selectNode(), e.lastSelectedViewDesc = t);
  } else
    jO(e);
}
function jO(e) {
  e.lastSelectedViewDesc && (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), e.lastSelectedViewDesc = void 0);
}
function O4(e, r, t, i) {
  return e.someProp("createSelectionBetween", (n) => n(e, r, t)) || Ze.between(r, t, i);
}
function zO(e) {
  return e.editable && !e.hasFocus() ? !1 : dee(e);
}
function dee(e) {
  let r = e.domSelectionRange();
  if (!r.anchorNode)
    return !1;
  try {
    return e.dom.contains(r.anchorNode.nodeType == 3 ? r.anchorNode.parentNode : r.anchorNode) && (e.editable || e.dom.contains(r.focusNode.nodeType == 3 ? r.focusNode.parentNode : r.focusNode));
  } catch {
    return !1;
  }
}
function Fje(e) {
  let r = e.docView.domFromPos(e.state.selection.anchor, 0), t = e.domSelectionRange();
  return ia(r.node, r.offset, t.anchorNode, t.anchorOffset);
}
function ny(e, r) {
  let { $anchor: t, $head: i } = e.selection, n = r > 0 ? t.max(i) : t.min(i), s = n.parent.inlineContent ? n.depth ? e.doc.resolve(r > 0 ? n.after() : n.before()) : null : n;
  return s && nr.findFrom(s, r);
}
function fo(e, r) {
  return e.dispatch(e.state.tr.setSelection(r).scrollIntoView()), !0;
}
function BO(e, r, t) {
  let i = e.state.selection;
  if (i instanceof Ze)
    if (t.indexOf("s") > -1) {
      let { $head: n } = i, s = n.textOffset ? null : r < 0 ? n.nodeBefore : n.nodeAfter;
      if (!s || s.isText || !s.isLeaf)
        return !1;
      let u = e.state.doc.resolve(n.pos + s.nodeSize * (r < 0 ? -1 : 1));
      return fo(e, new Ze(i.$anchor, u));
    } else if (i.empty) {
      if (e.endOfTextblock(r > 0 ? "forward" : "backward")) {
        let n = ny(e.state, r);
        return n && n instanceof ke ? fo(e, n) : !1;
      } else if (!(wn && t.indexOf("m") > -1)) {
        let n = i.$head, s = n.textOffset ? null : r < 0 ? n.nodeBefore : n.nodeAfter, u;
        if (!s || s.isText)
          return !1;
        let o = r < 0 ? n.pos - s.nodeSize : n.pos;
        return s.isAtom || (u = e.docView.descAt(o)) && !u.contentDOM ? ke.isSelectable(s) ? fo(e, new ke(r < 0 ? e.state.doc.resolve(n.pos - s.nodeSize) : n)) : k2 ? fo(e, new Ze(e.state.doc.resolve(r < 0 ? o : o + s.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (i instanceof ke && i.node.isInline)
      return fo(e, new Ze(r > 0 ? i.$to : i.$from));
    {
      let n = ny(e.state, r);
      return n ? fo(e, n) : !1;
    }
  }
}
function mq(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function Wc(e, r) {
  let t = e.pmViewDesc;
  return t && t.size == 0 && (r < 0 || e.nextSibling || e.nodeName != "BR");
}
function Ja(e, r) {
  return r < 0 ? xje(e) : Xje(e);
}
function xje(e) {
  let r = e.domSelectionRange(), t = r.focusNode, i = r.focusOffset;
  if (!t)
    return;
  let n, s, u = !1;
  for (Xs && t.nodeType == 1 && i < mq(t) && Wc(t.childNodes[i], -1) && (u = !0); ; )
    if (i > 0) {
      if (t.nodeType != 1)
        break;
      {
        let o = t.childNodes[i - 1];
        if (Wc(o, -1))
          n = t, s = --i;
        else if (o.nodeType == 3)
          t = o, i = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (aee(t))
        break;
      {
        let o = t.previousSibling;
        for (; o && Wc(o, -1); )
          n = t.parentNode, s = ei(o), o = o.previousSibling;
        if (o)
          t = o, i = mq(t);
        else {
          if (t = t.parentNode, t == e.dom)
            break;
          i = 0;
        }
      }
    }
  u ? sy(e, t, i) : n && sy(e, n, s);
}
function Xje(e) {
  let r = e.domSelectionRange(), t = r.focusNode, i = r.focusOffset;
  if (!t)
    return;
  let n = mq(t), s, u;
  for (; ; )
    if (i < n) {
      if (t.nodeType != 1)
        break;
      let o = t.childNodes[i];
      if (Wc(o, 1))
        s = t, u = ++i;
      else
        break;
    } else {
      if (aee(t))
        break;
      {
        let o = t.nextSibling;
        for (; o && Wc(o, 1); )
          s = o.parentNode, u = ei(o) + 1, o = o.nextSibling;
        if (o)
          t = o, i = 0, n = mq(t);
        else {
          if (t = t.parentNode, t == e.dom)
            break;
          i = n = 0;
        }
      }
    }
  s && sy(e, s, u);
}
function aee(e) {
  let r = e.pmViewDesc;
  return r && r.node && r.node.isBlock;
}
function qje(e, r) {
  for (; e && r == e.childNodes.length && !E2(e); )
    r = ei(e) + 1, e = e.parentNode;
  for (; e && r < e.childNodes.length; ) {
    let t = e.childNodes[r];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    e = t, r = 0;
  }
}
function Yje(e, r) {
  for (; e && !r && !E2(e); )
    r = ei(e), e = e.parentNode;
  for (; e && r; ) {
    let t = e.childNodes[r - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    e = t, r = e.childNodes.length;
  }
}
function sy(e, r, t) {
  if (r.nodeType != 3) {
    let s, u;
    (u = qje(r, t)) ? (r = u, t = 0) : (s = Yje(r, t)) && (r = s, t = s.nodeValue.length);
  }
  let i = e.domSelection();
  if (!i)
    return;
  if (Df(i)) {
    let s = document.createRange();
    s.setEnd(r, t), s.setStart(r, t), i.removeAllRanges(), i.addRange(s);
  } else i.extend && i.extend(r, t);
  e.domObserver.setCurSelection();
  let { state: n } = e;
  setTimeout(() => {
    e.state == n && Eu(e);
  }, 50);
}
function WO(e, r) {
  let t = e.state.doc.resolve(r);
  if (!(qi || RHe) && t.parent.inlineContent) {
    let n = e.coordsAtPos(r);
    if (r > t.start()) {
      let s = e.coordsAtPos(r - 1), u = (s.top + s.bottom) / 2;
      if (u > n.top && u < n.bottom && Math.abs(s.left - n.left) > 1)
        return s.left < n.left ? "ltr" : "rtl";
    }
    if (r < t.end()) {
      let s = e.coordsAtPos(r + 1), u = (s.top + s.bottom) / 2;
      if (u > n.top && u < n.bottom && Math.abs(s.left - n.left) > 1)
        return s.left > n.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(e.dom).direction == "rtl" ? "rtl" : "ltr";
}
function GO(e, r, t) {
  let i = e.state.selection;
  if (i instanceof Ze && !i.empty || t.indexOf("s") > -1 || wn && t.indexOf("m") > -1)
    return !1;
  let { $from: n, $to: s } = i;
  if (!n.parent.inlineContent || e.endOfTextblock(r < 0 ? "up" : "down")) {
    let u = ny(e.state, r);
    if (u && u instanceof ke)
      return fo(e, u);
  }
  if (!n.parent.inlineContent) {
    let u = r < 0 ? n : s, o = i instanceof Tn ? nr.near(u, r) : nr.findFrom(u, r);
    return o ? fo(e, o) : !1;
  }
  return !1;
}
function UO(e, r) {
  if (!(e.state.selection instanceof Ze))
    return !0;
  let { $head: t, $anchor: i, empty: n } = e.state.selection;
  if (!t.sameParent(i))
    return !0;
  if (!n)
    return !1;
  if (e.endOfTextblock(r > 0 ? "forward" : "backward"))
    return !0;
  let s = !t.textOffset && (r < 0 ? t.nodeBefore : t.nodeAfter);
  if (s && !s.isText) {
    let u = e.state.tr;
    return r < 0 ? u.delete(t.pos - s.nodeSize, t.pos) : u.delete(t.pos, t.pos + s.nodeSize), e.dispatch(u), !0;
  }
  return !1;
}
function ZO(e, r, t) {
  e.domObserver.stop(), r.contentEditable = t, e.domObserver.start();
}
function fje(e) {
  if (!Si || e.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: r, focusOffset: t } = e.domSelectionRange();
  if (r && r.nodeType == 1 && t == 0 && r.firstChild && r.firstChild.contentEditable == "false") {
    let i = r.firstChild;
    ZO(e, i, "true"), setTimeout(() => ZO(e, i, "false"), 20);
  }
  return !1;
}
function Kje(e) {
  let r = "";
  return e.ctrlKey && (r += "c"), e.metaKey && (r += "m"), e.altKey && (r += "a"), e.shiftKey && (r += "s"), r;
}
function hje(e, r) {
  let t = r.keyCode, i = Kje(r);
  if (t == 8 || wn && t == 72 && i == "c")
    return UO(e, -1) || Ja(e, -1);
  if (t == 46 && !r.shiftKey || wn && t == 68 && i == "c")
    return UO(e, 1) || Ja(e, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || wn && t == 66 && i == "c") {
    let n = t == 37 ? WO(e, e.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return BO(e, n, i) || Ja(e, n);
  } else if (t == 39 || wn && t == 70 && i == "c") {
    let n = t == 39 ? WO(e, e.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return BO(e, n, i) || Ja(e, n);
  } else {
    if (t == 38 || wn && t == 80 && i == "c")
      return GO(e, -1, i) || Ja(e, -1);
    if (t == 40 || wn && t == 78 && i == "c")
      return fje(e) || GO(e, 1, i) || Ja(e, 1);
    if (i == (wn ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function Vee(e, r) {
  e.someProp("transformCopied", (X) => {
    r = X(r, e);
  });
  let t = [], { content: i, openStart: n, openEnd: s } = r;
  for (; n > 1 && s > 1 && i.childCount == 1 && i.firstChild.childCount == 1; ) {
    n--, s--;
    let X = i.firstChild;
    t.push(X.type.name, X.attrs != X.type.defaultAttrs ? X.attrs : null), i = X.content;
  }
  let u = e.someProp("clipboardSerializer") || qa.fromSchema(e.state.schema), o = qee(), d = o.createElement("div");
  d.appendChild(u.serializeFragment(i, { document: o }));
  let a = d.firstChild, V, c = 0;
  for (; a && a.nodeType == 1 && (V = Xee[a.nodeName.toLowerCase()]); ) {
    for (let X = V.length - 1; X >= 0; X--) {
      let Y = o.createElement(V[X]);
      for (; d.firstChild; )
        Y.appendChild(d.firstChild);
      d.appendChild(Y), c++;
    }
    a = d.firstChild;
  }
  a && a.nodeType == 1 && a.setAttribute("data-pm-slice", `${n} ${s}${c ? ` -${c}` : ""} ${JSON.stringify(t)}`);
  let F = e.someProp("clipboardTextSerializer", (X) => X(r, e)) || r.content.textBetween(0, r.content.size, `

`);
  return { dom: d, text: F, slice: r };
}
function lee(e, r, t, i, n) {
  let s = n.parent.type.spec.code, u, o;
  if (!t && !r)
    return null;
  let d = r && (i || s || !t);
  if (d) {
    if (e.someProp("transformPastedText", (F) => {
      r = F(r, s || i, e);
    }), s)
      return r ? new ve(Fe.from(e.state.schema.text(r.replace(/\r\n?/g, `
`))), 0, 0) : ve.empty;
    let c = e.someProp("clipboardTextParser", (F) => F(r, n, i, e));
    if (c)
      o = c;
    else {
      let F = n.marks(), { schema: X } = e.state, Y = qa.fromSchema(X);
      u = document.createElement("div"), r.split(/(?:\r\n?|\n)+/).forEach((q) => {
        let f = u.appendChild(document.createElement("p"));
        q && f.appendChild(Y.serializeNode(X.text(q, F)));
      });
    }
  } else
    e.someProp("transformPastedHTML", (c) => {
      t = c(t, e);
    }), u = vje(t), k2 && bje(u);
  let a = u && u.querySelector("[data-pm-slice]"), V = a && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(a.getAttribute("data-pm-slice") || "");
  if (V && V[3])
    for (let c = +V[3]; c > 0; c--) {
      let F = u.firstChild;
      for (; F && F.nodeType != 1; )
        F = F.nextSibling;
      if (!F)
        break;
      u = F;
    }
  if (o || (o = (e.someProp("clipboardParser") || e.someProp("domParser") || Mu.fromSchema(e.state.schema)).parseSlice(u, {
    preserveWhitespace: !!(d || V),
    context: n,
    ruleFromNode(F) {
      return F.nodeName == "BR" && !F.nextSibling && F.parentNode && !pje.test(F.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), V)
    o = yje(JO(o, +V[1], +V[2]), V[4]);
  else if (o = ve.maxOpen(mje(o.content, n), !0), o.openStart || o.openEnd) {
    let c = 0, F = 0;
    for (let X = o.content.firstChild; c < o.openStart && !X.type.spec.isolating; c++, X = X.firstChild)
      ;
    for (let X = o.content.lastChild; F < o.openEnd && !X.type.spec.isolating; F++, X = X.lastChild)
      ;
    o = JO(o, c, F);
  }
  return e.someProp("transformPasted", (c) => {
    o = c(o, e);
  }), o;
}
const pje = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function mje(e, r) {
  if (e.childCount < 2)
    return e;
  for (let t = r.depth; t >= 0; t--) {
    let n = r.node(t).contentMatchAt(r.index(t)), s, u = [];
    if (e.forEach((o) => {
      if (!u)
        return;
      let d = n.findWrapping(o.type), a;
      if (!d)
        return u = null;
      if (a = u.length && s.length && Fee(d, s, o, u[u.length - 1], 0))
        u[u.length - 1] = a;
      else {
        u.length && (u[u.length - 1] = xee(u[u.length - 1], s.length));
        let V = cee(o, d);
        u.push(V), n = n.matchType(V.type), s = d;
      }
    }), u)
      return Fe.from(u);
  }
  return e;
}
function cee(e, r, t = 0) {
  for (let i = r.length - 1; i >= t; i--)
    e = r[i].create(null, Fe.from(e));
  return e;
}
function Fee(e, r, t, i, n) {
  if (n < e.length && n < r.length && e[n] == r[n]) {
    let s = Fee(e, r, t, i.lastChild, n + 1);
    if (s)
      return i.copy(i.content.replaceChild(i.childCount - 1, s));
    if (i.contentMatchAt(i.childCount).matchType(n == e.length - 1 ? t.type : e[n + 1]))
      return i.copy(i.content.append(Fe.from(cee(t, e, n + 1))));
  }
}
function xee(e, r) {
  if (r == 0)
    return e;
  let t = e.content.replaceChild(e.childCount - 1, xee(e.lastChild, r - 1)), i = e.contentMatchAt(e.childCount).fillBefore(Fe.empty, !0);
  return e.copy(t.append(i));
}
function uy(e, r, t, i, n, s) {
  let u = r < 0 ? e.firstChild : e.lastChild, o = u.content;
  return e.childCount > 1 && (s = 0), n < i - 1 && (o = uy(o, r, t, i, n + 1, s)), n >= t && (o = r < 0 ? u.contentMatchAt(0).fillBefore(o, s <= n).append(o) : o.append(u.contentMatchAt(u.childCount).fillBefore(Fe.empty, !0))), e.replaceChild(r < 0 ? 0 : e.childCount - 1, u.copy(o));
}
function JO(e, r, t) {
  return r < e.openStart && (e = new ve(uy(e.content, -1, r, e.openStart, 0, e.openEnd), r, e.openEnd)), t < e.openEnd && (e = new ve(uy(e.content, 1, t, e.openEnd, 0, 0), e.openStart, t)), e;
}
const Xee = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let $O = null;
function qee() {
  return $O || ($O = document.implementation.createHTMLDocument("title"));
}
let Dg = null;
function gje(e) {
  let r = window.trustedTypes;
  return r ? (Dg || (Dg = r.createPolicy("ProseMirrorClipboard", { createHTML: (t) => t })), Dg.createHTML(e)) : e;
}
function vje(e) {
  let r = /^(\s*<meta [^>]*>)*/.exec(e);
  r && (e = e.slice(r[0].length));
  let t = qee().createElement("div"), i = /<([a-z][^>\s]+)/i.exec(e), n;
  if ((n = i && Xee[i[1].toLowerCase()]) && (e = n.map((s) => "<" + s + ">").join("") + e + n.map((s) => "</" + s + ">").reverse().join("")), t.innerHTML = gje(e), n)
    for (let s = 0; s < n.length; s++)
      t = t.querySelector(n[s]) || t;
  return t;
}
function bje(e) {
  let r = e.querySelectorAll(qi ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < r.length; t++) {
    let i = r[t];
    i.childNodes.length == 1 && i.textContent == " " && i.parentNode && i.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), i);
  }
}
function yje(e, r) {
  if (!e.size)
    return e;
  let t = e.content.firstChild.type.schema, i;
  try {
    i = JSON.parse(r);
  } catch {
    return e;
  }
  let { content: n, openStart: s, openEnd: u } = e;
  for (let o = i.length - 2; o >= 0; o -= 2) {
    let d = t.nodes[i[o]];
    if (!d || d.hasRequiredAttrs())
      break;
    n = Fe.from(d.create(i[o + 1], n)), s++, u++;
  }
  return new ve(n, s, u);
}
const Ni = {}, Mi = {}, Aje = { touchstart: !0, touchmove: !0 };
class wje {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastAndroidDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function Cje(e) {
  for (let r in Ni) {
    let t = Ni[r];
    e.dom.addEventListener(r, e.input.eventHandlers[r] = (i) => {
      Sje(e, i) && !D4(e, i) && (e.editable || !(i.type in Mi)) && t(e, i);
    }, Aje[r] ? { passive: !0 } : void 0);
  }
  Si && e.dom.addEventListener("input", () => null), oy(e);
}
function Po(e, r) {
  e.input.lastSelectionOrigin = r, e.input.lastSelectionTime = Date.now();
}
function Pje(e) {
  e.domObserver.stop();
  for (let r in e.input.eventHandlers)
    e.dom.removeEventListener(r, e.input.eventHandlers[r]);
  clearTimeout(e.input.composingTimeout), clearTimeout(e.input.lastIOSEnterFallbackTimeout);
}
function oy(e) {
  e.someProp("handleDOMEvents", (r) => {
    for (let t in r)
      e.input.eventHandlers[t] || e.dom.addEventListener(t, e.input.eventHandlers[t] = (i) => D4(e, i));
  });
}
function D4(e, r) {
  return e.someProp("handleDOMEvents", (t) => {
    let i = t[r.type];
    return i ? i(e, r) || r.defaultPrevented : !1;
  });
}
function Sje(e, r) {
  if (!r.bubbles)
    return !0;
  if (r.defaultPrevented)
    return !1;
  for (let t = r.target; t != e.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(r))
      return !1;
  return !0;
}
function Nje(e, r) {
  !D4(e, r) && Ni[r.type] && (e.editable || !(r.type in Mi)) && Ni[r.type](e, r);
}
Mi.keydown = (e, r) => {
  let t = r;
  if (e.input.shiftKey = t.keyCode == 16 || t.shiftKey, !fee(e, t) && (e.input.lastKeyCode = t.keyCode, e.input.lastKeyCodeTime = Date.now(), !(Qn && qi && t.keyCode == 13)))
    if (t.keyCode != 229 && e.domObserver.forceFlush(), Vl && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let i = Date.now();
      e.input.lastIOSEnter = i, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        e.input.lastIOSEnter == i && (e.someProp("handleKeyDown", (n) => n(e, gd(13, "Enter"))), e.input.lastIOSEnter = 0);
      }, 200);
    } else e.someProp("handleKeyDown", (i) => i(e, t)) || hje(e, t) ? t.preventDefault() : Po(e, "key");
};
Mi.keyup = (e, r) => {
  r.keyCode == 16 && (e.input.shiftKey = !1);
};
Mi.keypress = (e, r) => {
  let t = r;
  if (fee(e, t) || !t.charCode || t.ctrlKey && !t.altKey || wn && t.metaKey)
    return;
  if (e.someProp("handleKeyPress", (n) => n(e, t))) {
    t.preventDefault();
    return;
  }
  let i = e.state.selection;
  if (!(i instanceof Ze) || !i.$from.sameParent(i.$to)) {
    let n = String.fromCharCode(t.charCode);
    !/[\r\n]/.test(n) && !e.someProp("handleTextInput", (s) => s(e, i.$from.pos, i.$to.pos, n)) && e.dispatch(e.state.tr.insertText(n).scrollIntoView()), t.preventDefault();
  }
};
function If(e) {
  return { left: e.clientX, top: e.clientY };
}
function Mje(e, r) {
  let t = r.x - e.clientX, i = r.y - e.clientY;
  return t * t + i * i < 100;
}
function R4(e, r, t, i, n) {
  if (i == -1)
    return !1;
  let s = e.state.doc.resolve(i);
  for (let u = s.depth + 1; u > 0; u--)
    if (e.someProp(r, (o) => u > s.depth ? o(e, t, s.nodeAfter, s.before(u), n, !0) : o(e, t, s.node(u), s.before(u), n, !1)))
      return !0;
  return !1;
}
function gV(e, r, t) {
  if (e.focused || e.focus(), e.state.selection.eq(r))
    return;
  let i = e.state.tr.setSelection(r);
  i.setMeta("pointer", !0), e.dispatch(i);
}
function Tje(e, r) {
  if (r == -1)
    return !1;
  let t = e.state.doc.resolve(r), i = t.nodeAfter;
  return i && i.isAtom && ke.isSelectable(i) ? (gV(e, new ke(t)), !0) : !1;
}
function Eje(e, r) {
  if (r == -1)
    return !1;
  let t = e.state.selection, i, n;
  t instanceof ke && (i = t.node);
  let s = e.state.doc.resolve(r);
  for (let u = s.depth + 1; u > 0; u--) {
    let o = u > s.depth ? s.nodeAfter : s.node(u);
    if (ke.isSelectable(o)) {
      i && t.$from.depth > 0 && u >= t.$from.depth && s.before(t.$from.depth + 1) == t.$from.pos ? n = s.before(t.$from.depth) : n = s.before(u);
      break;
    }
  }
  return n != null ? (gV(e, ke.create(e.state.doc, n)), !0) : !1;
}
function kje(e, r, t, i, n) {
  return R4(e, "handleClickOn", r, t, i) || e.someProp("handleClick", (s) => s(e, r, i)) || (n ? Eje(e, t) : Tje(e, t));
}
function Oje(e, r, t, i) {
  return R4(e, "handleDoubleClickOn", r, t, i) || e.someProp("handleDoubleClick", (n) => n(e, r, i));
}
function Dje(e, r, t, i) {
  return R4(e, "handleTripleClickOn", r, t, i) || e.someProp("handleTripleClick", (n) => n(e, r, i)) || Rje(e, t, i);
}
function Rje(e, r, t) {
  if (t.button != 0)
    return !1;
  let i = e.state.doc;
  if (r == -1)
    return i.inlineContent ? (gV(e, Ze.create(i, 0, i.content.size)), !0) : !1;
  let n = i.resolve(r);
  for (let s = n.depth + 1; s > 0; s--) {
    let u = s > n.depth ? n.nodeAfter : n.node(s), o = n.before(s);
    if (u.inlineContent)
      gV(e, Ze.create(i, o + 1, o + 1 + u.content.size));
    else if (ke.isSelectable(u))
      gV(e, ke.create(i, o));
    else
      continue;
    return !0;
  }
}
function I4(e) {
  return gq(e);
}
const Yee = wn ? "metaKey" : "ctrlKey";
Ni.mousedown = (e, r) => {
  let t = r;
  e.input.shiftKey = t.shiftKey;
  let i = I4(e), n = Date.now(), s = "singleClick";
  n - e.input.lastClick.time < 500 && Mje(t, e.input.lastClick) && !t[Yee] && (e.input.lastClick.type == "singleClick" ? s = "doubleClick" : e.input.lastClick.type == "doubleClick" && (s = "tripleClick")), e.input.lastClick = { time: n, x: t.clientX, y: t.clientY, type: s };
  let u = e.posAtCoords(If(t));
  u && (s == "singleClick" ? (e.input.mouseDown && e.input.mouseDown.done(), e.input.mouseDown = new Ije(e, u, t, !!i)) : (s == "doubleClick" ? Oje : Dje)(e, u.pos, u.inside, t) ? t.preventDefault() : Po(e, "pointer"));
};
class Ije {
  constructor(r, t, i, n) {
    this.view = r, this.pos = t, this.event = i, this.flushed = n, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = r.state.doc, this.selectNode = !!i[Yee], this.allowDefault = i.shiftKey;
    let s, u;
    if (t.inside > -1)
      s = r.state.doc.nodeAt(t.inside), u = t.inside;
    else {
      let V = r.state.doc.resolve(t.pos);
      s = V.parent, u = V.depth ? V.before() : 0;
    }
    const o = n ? null : i.target, d = o ? r.docView.nearestDesc(o, !0) : null;
    this.target = d && d.dom.nodeType == 1 ? d.dom : null;
    let { selection: a } = r.state;
    (i.button == 0 && s.type.spec.draggable && s.type.spec.selectable !== !1 || a instanceof ke && a.from <= u && a.to > u) && (this.mightDrag = {
      node: s,
      pos: u,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Xs && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), r.root.addEventListener("mouseup", this.up = this.up.bind(this)), r.root.addEventListener("mousemove", this.move = this.move.bind(this)), Po(r, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => Eu(this.view)), this.view.input.mouseDown = null;
  }
  up(r) {
    if (this.done(), !this.view.dom.contains(r.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(If(r))), this.updateAllowDefault(r), this.allowDefault || !t ? Po(this.view, "pointer") : kje(this.view, t.pos, t.inside, r, this.selectNode) ? r.preventDefault() : r.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Si && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    qi && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (gV(this.view, nr.near(this.view.state.doc.resolve(t.pos))), r.preventDefault()) : Po(this.view, "pointer");
  }
  move(r) {
    this.updateAllowDefault(r), Po(this.view, "pointer"), r.buttons == 0 && this.done();
  }
  updateAllowDefault(r) {
    !this.allowDefault && (Math.abs(this.event.x - r.clientX) > 4 || Math.abs(this.event.y - r.clientY) > 4) && (this.allowDefault = !0);
  }
}
Ni.touchstart = (e) => {
  e.input.lastTouch = Date.now(), I4(e), Po(e, "pointer");
};
Ni.touchmove = (e) => {
  e.input.lastTouch = Date.now(), Po(e, "pointer");
};
Ni.contextmenu = (e) => I4(e);
function fee(e, r) {
  return e.composing ? !0 : Si && Math.abs(r.timeStamp - e.input.compositionEndedAt) < 500 ? (e.input.compositionEndedAt = -2e8, !0) : !1;
}
const Lje = Qn ? 5e3 : -1;
Mi.compositionstart = Mi.compositionupdate = (e) => {
  if (!e.composing) {
    e.domObserver.flush();
    let { state: r } = e, t = r.selection.$to;
    if (r.selection instanceof Ze && (r.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((i) => i.type.spec.inclusive === !1)))
      e.markCursor = e.state.storedMarks || t.marks(), gq(e, !0), e.markCursor = null;
    else if (gq(e, !r.selection.empty), Xs && r.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let i = e.domSelectionRange();
      for (let n = i.focusNode, s = i.focusOffset; n && n.nodeType == 1 && s != 0; ) {
        let u = s < 0 ? n.lastChild : n.childNodes[s - 1];
        if (!u)
          break;
        if (u.nodeType == 3) {
          let o = e.domSelection();
          o && o.collapse(u, u.nodeValue.length);
          break;
        } else
          n = u, s = -1;
      }
    }
    e.input.composing = !0;
  }
  Kee(e, Lje);
};
Mi.compositionend = (e, r) => {
  e.composing && (e.input.composing = !1, e.input.compositionEndedAt = r.timeStamp, e.input.compositionPendingChanges = e.domObserver.pendingRecords().length ? e.input.compositionID : 0, e.input.compositionNode = null, e.input.compositionPendingChanges && Promise.resolve().then(() => e.domObserver.flush()), e.input.compositionID++, Kee(e, 20));
};
function Kee(e, r) {
  clearTimeout(e.input.composingTimeout), r > -1 && (e.input.composingTimeout = setTimeout(() => gq(e), r));
}
function hee(e) {
  for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = Hje()); e.input.compositionNodes.length > 0; )
    e.input.compositionNodes.pop().markParentsDirty();
}
function _je(e) {
  let r = e.domSelectionRange();
  if (!r.focusNode)
    return null;
  let t = THe(r.focusNode, r.focusOffset), i = EHe(r.focusNode, r.focusOffset);
  if (t && i && t != i) {
    let n = i.pmViewDesc, s = e.domObserver.lastChangedTextNode;
    if (t == s || i == s)
      return s;
    if (!n || !n.isText(i.nodeValue))
      return i;
    if (e.input.compositionNode == i) {
      let u = t.pmViewDesc;
      if (!(!u || !u.isText(t.nodeValue)))
        return i;
    }
  }
  return t || i;
}
function Hje() {
  let e = document.createEvent("Event");
  return e.initEvent("event", !0, !0), e.timeStamp;
}
function gq(e, r = !1) {
  if (!(Qn && e.domObserver.flushingSoon >= 0)) {
    if (e.domObserver.forceFlush(), hee(e), r || e.docView && e.docView.dirty) {
      let t = k4(e);
      return t && !t.eq(e.state.selection) ? e.dispatch(e.state.tr.setSelection(t)) : (e.markCursor || r) && !e.state.selection.empty ? e.dispatch(e.state.tr.deleteSelection()) : e.updateState(e.state), !0;
    }
    return !1;
  }
}
function jje(e, r) {
  if (!e.dom.parentNode)
    return;
  let t = e.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(r), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let i = getSelection(), n = document.createRange();
  n.selectNodeContents(r), e.dom.blur(), i.removeAllRanges(), i.addRange(n), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), e.focus();
  }, 50);
}
const j7 = Bi && Eo < 15 || Vl && IHe < 604;
Ni.copy = Mi.cut = (e, r) => {
  let t = r, i = e.state.selection, n = t.type == "cut";
  if (i.empty)
    return;
  let s = j7 ? null : t.clipboardData, u = i.content(), { dom: o, text: d } = Vee(e, u);
  s ? (t.preventDefault(), s.clearData(), s.setData("text/html", o.innerHTML), s.setData("text/plain", d)) : jje(e, o), n && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function zje(e) {
  return e.openStart == 0 && e.openEnd == 0 && e.content.childCount == 1 ? e.content.firstChild : null;
}
function Bje(e, r) {
  if (!e.dom.parentNode)
    return;
  let t = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code, i = e.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (i.contentEditable = "true"), i.style.cssText = "position: fixed; left: -10000px; top: 10px", i.focus();
  let n = e.input.shiftKey && e.input.lastKeyCode != 45;
  setTimeout(() => {
    e.focus(), i.parentNode && i.parentNode.removeChild(i), t ? z7(e, i.value, null, n, r) : z7(e, i.textContent, i.innerHTML, n, r);
  }, 50);
}
function z7(e, r, t, i, n) {
  let s = lee(e, r, t, i, e.state.selection.$from);
  if (e.someProp("handlePaste", (d) => d(e, n, s || ve.empty)))
    return !0;
  if (!s)
    return !1;
  let u = zje(s), o = u ? e.state.tr.replaceSelectionWith(u, i) : e.state.tr.replaceSelection(s);
  return e.dispatch(o.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function pee(e) {
  let r = e.getData("text/plain") || e.getData("Text");
  if (r)
    return r;
  let t = e.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
Mi.paste = (e, r) => {
  let t = r;
  if (e.composing && !Qn)
    return;
  let i = j7 ? null : t.clipboardData, n = e.input.shiftKey && e.input.lastKeyCode != 45;
  i && z7(e, pee(i), i.getData("text/html"), n, t) ? t.preventDefault() : Bje(e, t);
};
class mee {
  constructor(r, t, i) {
    this.slice = r, this.move = t, this.node = i;
  }
}
const gee = wn ? "altKey" : "ctrlKey";
Ni.dragstart = (e, r) => {
  let t = r, i = e.input.mouseDown;
  if (i && i.done(), !t.dataTransfer)
    return;
  let n = e.state.selection, s = n.empty ? null : e.posAtCoords(If(t)), u;
  if (!(s && s.pos >= n.from && s.pos <= (n instanceof ke ? n.to - 1 : n.to))) {
    if (i && i.mightDrag)
      u = ke.create(e.state.doc, i.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let c = e.docView.nearestDesc(t.target, !0);
      c && c.node.type.spec.draggable && c != e.docView && (u = ke.create(e.state.doc, c.posBefore));
    }
  }
  let o = (u || e.state.selection).content(), { dom: d, text: a, slice: V } = Vee(e, o);
  (!t.dataTransfer.files.length || !qi || GQ > 120) && t.dataTransfer.clearData(), t.dataTransfer.setData(j7 ? "Text" : "text/html", d.innerHTML), t.dataTransfer.effectAllowed = "copyMove", j7 || t.dataTransfer.setData("text/plain", a), e.dragging = new mee(V, !t[gee], u);
};
Ni.dragend = (e) => {
  let r = e.dragging;
  window.setTimeout(() => {
    e.dragging == r && (e.dragging = null);
  }, 50);
};
Mi.dragover = Mi.dragenter = (e, r) => r.preventDefault();
Mi.drop = (e, r) => {
  let t = r, i = e.dragging;
  if (e.dragging = null, !t.dataTransfer)
    return;
  let n = e.posAtCoords(If(t));
  if (!n)
    return;
  let s = e.state.doc.resolve(n.pos), u = i && i.slice;
  u ? e.someProp("transformPasted", (Y) => {
    u = Y(u, e);
  }) : u = lee(e, pee(t.dataTransfer), j7 ? null : t.dataTransfer.getData("text/html"), !1, s);
  let o = !!(i && !t[gee]);
  if (e.someProp("handleDrop", (Y) => Y(e, t, u || ve.empty, o))) {
    t.preventDefault();
    return;
  }
  if (!u)
    return;
  t.preventDefault();
  let d = u ? IQ(e.state.doc, s.pos, u) : s.pos;
  d == null && (d = s.pos);
  let a = e.state.tr;
  if (o) {
    let { node: Y } = i;
    Y ? Y.replace(a) : a.deleteSelection();
  }
  let V = a.mapping.map(d), c = u.openStart == 0 && u.openEnd == 0 && u.content.childCount == 1, F = a.doc;
  if (c ? a.replaceRangeWith(V, V, u.content.firstChild) : a.replaceRange(V, V, u), a.doc.eq(F))
    return;
  let X = a.doc.resolve(V);
  if (c && ke.isSelectable(u.content.firstChild) && X.nodeAfter && X.nodeAfter.sameMarkup(u.content.firstChild))
    a.setSelection(new ke(X));
  else {
    let Y = a.mapping.map(d);
    a.mapping.maps[a.mapping.maps.length - 1].forEach((q, f, p, m) => Y = m), a.setSelection(O4(e, X, a.doc.resolve(Y)));
  }
  e.focus(), e.dispatch(a.setMeta("uiEvent", "drop"));
};
Ni.focus = (e) => {
  e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
    e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && Eu(e);
  }, 20));
};
Ni.blur = (e, r) => {
  let t = r;
  e.focused && (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), t.relatedTarget && e.dom.contains(t.relatedTarget) && e.domObserver.currentSelection.clear(), e.focused = !1);
};
Ni.beforeinput = (e, r) => {
  if (qi && Qn && r.inputType == "deleteContentBackward") {
    e.domObserver.flushSoon();
    let { domChangeCount: i } = e.input;
    setTimeout(() => {
      if (e.input.domChangeCount != i || (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", (s) => s(e, gd(8, "Backspace")))))
        return;
      let { $cursor: n } = e.state.selection;
      n && n.pos > 0 && e.dispatch(e.state.tr.delete(n.pos - 1, n.pos).scrollIntoView());
    }, 50);
  }
};
for (let e in Mi)
  Ni[e] = Mi[e];
function B7(e, r) {
  if (e == r)
    return !0;
  for (let t in e)
    if (e[t] !== r[t])
      return !1;
  for (let t in r)
    if (!(t in e))
      return !1;
  return !0;
}
class vq {
  constructor(r, t) {
    this.toDOM = r, this.spec = t || Ld, this.side = this.spec.side || 0;
  }
  map(r, t, i, n) {
    let { pos: s, deleted: u } = r.mapResult(t.from + n, this.side < 0 ? -1 : 1);
    return u ? null : new Sn(s - i, s - i, this);
  }
  valid() {
    return !0;
  }
  eq(r) {
    return this == r || r instanceof vq && (this.spec.key && this.spec.key == r.spec.key || this.toDOM == r.toDOM && B7(this.spec, r.spec));
  }
  destroy(r) {
    this.spec.destroy && this.spec.destroy(r);
  }
}
class Oo {
  constructor(r, t) {
    this.attrs = r, this.spec = t || Ld;
  }
  map(r, t, i, n) {
    let s = r.map(t.from + n, this.spec.inclusiveStart ? -1 : 1) - i, u = r.map(t.to + n, this.spec.inclusiveEnd ? 1 : -1) - i;
    return s >= u ? null : new Sn(s, u, this);
  }
  valid(r, t) {
    return t.from < t.to;
  }
  eq(r) {
    return this == r || r instanceof Oo && B7(this.attrs, r.attrs) && B7(this.spec, r.spec);
  }
  static is(r) {
    return r.type instanceof Oo;
  }
  destroy() {
  }
}
class L4 {
  constructor(r, t) {
    this.attrs = r, this.spec = t || Ld;
  }
  map(r, t, i, n) {
    let s = r.mapResult(t.from + n, 1);
    if (s.deleted)
      return null;
    let u = r.mapResult(t.to + n, -1);
    return u.deleted || u.pos <= s.pos ? null : new Sn(s.pos - i, u.pos - i, this);
  }
  valid(r, t) {
    let { index: i, offset: n } = r.content.findIndex(t.from), s;
    return n == t.from && !(s = r.child(i)).isText && n + s.nodeSize == t.to;
  }
  eq(r) {
    return this == r || r instanceof L4 && B7(this.attrs, r.attrs) && B7(this.spec, r.spec);
  }
  destroy() {
  }
}
class Sn {
  /**
  @internal
  */
  constructor(r, t, i) {
    this.from = r, this.to = t, this.type = i;
  }
  /**
  @internal
  */
  copy(r, t) {
    return new Sn(r, t, this.type);
  }
  /**
  @internal
  */
  eq(r, t = 0) {
    return this.type.eq(r.type) && this.from + t == r.from && this.to + t == r.to;
  }
  /**
  @internal
  */
  map(r, t, i) {
    return this.type.map(r, this, t, i);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(r, t, i) {
    return new Sn(r, r, new vq(t, i));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(r, t, i, n) {
    return new Sn(r, t, new Oo(i, n));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(r, t, i, n) {
    return new Sn(r, t, new L4(i, n));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Oo;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof vq;
  }
}
const rV = [], Ld = {};
class Nt {
  /**
  @internal
  */
  constructor(r, t) {
    this.local = r.length ? r : rV, this.children = t.length ? t : rV;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(r, t) {
    return t.length ? bq(t, r, 0, Ld) : ci;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(r, t, i) {
    let n = [];
    return this.findInner(r ?? 0, t ?? 1e9, n, 0, i), n;
  }
  findInner(r, t, i, n, s) {
    for (let u = 0; u < this.local.length; u++) {
      let o = this.local[u];
      o.from <= t && o.to >= r && (!s || s(o.spec)) && i.push(o.copy(o.from + n, o.to + n));
    }
    for (let u = 0; u < this.children.length; u += 3)
      if (this.children[u] < t && this.children[u + 1] > r) {
        let o = this.children[u] + 1;
        this.children[u + 2].findInner(r - o, t - o, i, n + o, s);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(r, t, i) {
    return this == ci || r.maps.length == 0 ? this : this.mapInner(r, t, 0, 0, i || Ld);
  }
  /**
  @internal
  */
  mapInner(r, t, i, n, s) {
    let u;
    for (let o = 0; o < this.local.length; o++) {
      let d = this.local[o].map(r, i, n);
      d && d.type.valid(t, d) ? (u || (u = [])).push(d) : s.onRemove && s.onRemove(this.local[o].spec);
    }
    return this.children.length ? Wje(this.children, u || [], r, t, i, n, s) : u ? new Nt(u.sort(_d), rV) : ci;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(r, t) {
    return t.length ? this == ci ? Nt.create(r, t) : this.addInner(r, t, 0) : this;
  }
  addInner(r, t, i) {
    let n, s = 0;
    r.forEach((o, d) => {
      let a = d + i, V;
      if (V = bee(t, o, a)) {
        for (n || (n = this.children.slice()); s < n.length && n[s] < d; )
          s += 3;
        n[s] == d ? n[s + 2] = n[s + 2].addInner(o, V, a + 1) : n.splice(s, 0, d, d + o.nodeSize, bq(V, o, a + 1, Ld)), s += 3;
      }
    });
    let u = vee(s ? yee(t) : t, -i);
    for (let o = 0; o < u.length; o++)
      u[o].type.valid(r, u[o]) || u.splice(o--, 1);
    return new Nt(u.length ? this.local.concat(u).sort(_d) : this.local, n || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(r) {
    return r.length == 0 || this == ci ? this : this.removeInner(r, 0);
  }
  removeInner(r, t) {
    let i = this.children, n = this.local;
    for (let s = 0; s < i.length; s += 3) {
      let u, o = i[s] + t, d = i[s + 1] + t;
      for (let V = 0, c; V < r.length; V++)
        (c = r[V]) && c.from > o && c.to < d && (r[V] = null, (u || (u = [])).push(c));
      if (!u)
        continue;
      i == this.children && (i = this.children.slice());
      let a = i[s + 2].removeInner(u, o + 1);
      a != ci ? i[s + 2] = a : (i.splice(s, 3), s -= 3);
    }
    if (n.length) {
      for (let s = 0, u; s < r.length; s++)
        if (u = r[s])
          for (let o = 0; o < n.length; o++)
            n[o].eq(u, t) && (n == this.local && (n = this.local.slice()), n.splice(o--, 1));
    }
    return i == this.children && n == this.local ? this : n.length || i.length ? new Nt(n, i) : ci;
  }
  forChild(r, t) {
    if (this == ci)
      return this;
    if (t.isLeaf)
      return Nt.empty;
    let i, n;
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] >= r) {
        this.children[o] == r && (i = this.children[o + 2]);
        break;
      }
    let s = r + 1, u = s + t.content.size;
    for (let o = 0; o < this.local.length; o++) {
      let d = this.local[o];
      if (d.from < u && d.to > s && d.type instanceof Oo) {
        let a = Math.max(s, d.from) - s, V = Math.min(u, d.to) - s;
        a < V && (n || (n = [])).push(d.copy(a, V));
      }
    }
    if (n) {
      let o = new Nt(n.sort(_d), rV);
      return i ? new mo([o, i]) : o;
    }
    return i || ci;
  }
  /**
  @internal
  */
  eq(r) {
    if (this == r)
      return !0;
    if (!(r instanceof Nt) || this.local.length != r.local.length || this.children.length != r.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(r.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != r.children[t] || this.children[t + 1] != r.children[t + 1] || !this.children[t + 2].eq(r.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(r) {
    return _4(this.localsInner(r));
  }
  /**
  @internal
  */
  localsInner(r) {
    if (this == ci)
      return rV;
    if (r.inlineContent || !this.local.some(Oo.is))
      return this.local;
    let t = [];
    for (let i = 0; i < this.local.length; i++)
      this.local[i].type instanceof Oo || t.push(this.local[i]);
    return t;
  }
  forEachSet(r) {
    r(this);
  }
}
Nt.empty = new Nt([], []);
Nt.removeOverlap = _4;
const ci = Nt.empty;
class mo {
  constructor(r) {
    this.members = r;
  }
  map(r, t) {
    const i = this.members.map((n) => n.map(r, t, Ld));
    return mo.from(i);
  }
  forChild(r, t) {
    if (t.isLeaf)
      return Nt.empty;
    let i = [];
    for (let n = 0; n < this.members.length; n++) {
      let s = this.members[n].forChild(r, t);
      s != ci && (s instanceof mo ? i = i.concat(s.members) : i.push(s));
    }
    return mo.from(i);
  }
  eq(r) {
    if (!(r instanceof mo) || r.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(r.members[t]))
        return !1;
    return !0;
  }
  locals(r) {
    let t, i = !0;
    for (let n = 0; n < this.members.length; n++) {
      let s = this.members[n].localsInner(r);
      if (s.length)
        if (!t)
          t = s;
        else {
          i && (t = t.slice(), i = !1);
          for (let u = 0; u < s.length; u++)
            t.push(s[u]);
        }
    }
    return t ? _4(i ? t : t.sort(_d)) : rV;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(r) {
    switch (r.length) {
      case 0:
        return ci;
      case 1:
        return r[0];
      default:
        return new mo(r.every((t) => t instanceof Nt) ? r : r.reduce((t, i) => t.concat(i instanceof Nt ? i : i.members), []));
    }
  }
  forEachSet(r) {
    for (let t = 0; t < this.members.length; t++)
      this.members[t].forEachSet(r);
  }
}
function Wje(e, r, t, i, n, s, u) {
  let o = e.slice();
  for (let a = 0, V = s; a < t.maps.length; a++) {
    let c = 0;
    t.maps[a].forEach((F, X, Y, q) => {
      let f = q - Y - (X - F);
      for (let p = 0; p < o.length; p += 3) {
        let m = o[p + 1];
        if (m < 0 || F > m + V - c)
          continue;
        let g = o[p] + V - c;
        X >= g ? o[p + 1] = F <= g ? -2 : -1 : F >= V && f && (o[p] += f, o[p + 1] += f);
      }
      c += f;
    }), V = t.maps[a].map(V, -1);
  }
  let d = !1;
  for (let a = 0; a < o.length; a += 3)
    if (o[a + 1] < 0) {
      if (o[a + 1] == -2) {
        d = !0, o[a + 1] = -1;
        continue;
      }
      let V = t.map(e[a] + s), c = V - n;
      if (c < 0 || c >= i.content.size) {
        d = !0;
        continue;
      }
      let F = t.map(e[a + 1] + s, -1), X = F - n, { index: Y, offset: q } = i.content.findIndex(c), f = i.maybeChild(Y);
      if (f && q == c && q + f.nodeSize == X) {
        let p = o[a + 2].mapInner(t, f, V + 1, e[a] + s + 1, u);
        p != ci ? (o[a] = c, o[a + 1] = X, o[a + 2] = p) : (o[a + 1] = -2, d = !0);
      } else
        d = !0;
    }
  if (d) {
    let a = Gje(o, e, r, t, n, s, u), V = bq(a, i, 0, u);
    r = V.local;
    for (let c = 0; c < o.length; c += 3)
      o[c + 1] < 0 && (o.splice(c, 3), c -= 3);
    for (let c = 0, F = 0; c < V.children.length; c += 3) {
      let X = V.children[c];
      for (; F < o.length && o[F] < X; )
        F += 3;
      o.splice(F, 0, V.children[c], V.children[c + 1], V.children[c + 2]);
    }
  }
  return new Nt(r.sort(_d), o);
}
function vee(e, r) {
  if (!r || !e.length)
    return e;
  let t = [];
  for (let i = 0; i < e.length; i++) {
    let n = e[i];
    t.push(new Sn(n.from + r, n.to + r, n.type));
  }
  return t;
}
function Gje(e, r, t, i, n, s, u) {
  function o(d, a) {
    for (let V = 0; V < d.local.length; V++) {
      let c = d.local[V].map(i, n, a);
      c ? t.push(c) : u.onRemove && u.onRemove(d.local[V].spec);
    }
    for (let V = 0; V < d.children.length; V += 3)
      o(d.children[V + 2], d.children[V] + a + 1);
  }
  for (let d = 0; d < e.length; d += 3)
    e[d + 1] == -1 && o(e[d + 2], r[d] + s + 1);
  return t;
}
function bee(e, r, t) {
  if (r.isLeaf)
    return null;
  let i = t + r.nodeSize, n = null;
  for (let s = 0, u; s < e.length; s++)
    (u = e[s]) && u.from > t && u.to < i && ((n || (n = [])).push(u), e[s] = null);
  return n;
}
function yee(e) {
  let r = [];
  for (let t = 0; t < e.length; t++)
    e[t] != null && r.push(e[t]);
  return r;
}
function bq(e, r, t, i) {
  let n = [], s = !1;
  r.forEach((o, d) => {
    let a = bee(e, o, d + t);
    if (a) {
      s = !0;
      let V = bq(a, o, t + d + 1, i);
      V != ci && n.push(d, d + o.nodeSize, V);
    }
  });
  let u = vee(s ? yee(e) : e, -t).sort(_d);
  for (let o = 0; o < u.length; o++)
    u[o].type.valid(r, u[o]) || (i.onRemove && i.onRemove(u[o].spec), u.splice(o--, 1));
  return u.length || n.length ? new Nt(u, n) : ci;
}
function _d(e, r) {
  return e.from - r.from || e.to - r.to;
}
function _4(e) {
  let r = e;
  for (let t = 0; t < r.length - 1; t++) {
    let i = r[t];
    if (i.from != i.to)
      for (let n = t + 1; n < r.length; n++) {
        let s = r[n];
        if (s.from == i.from) {
          s.to != i.to && (r == e && (r = e.slice()), r[n] = s.copy(s.from, i.to), QO(r, n + 1, s.copy(i.to, s.to)));
          continue;
        } else {
          s.from < i.to && (r == e && (r = e.slice()), r[t] = i.copy(i.from, s.from), QO(r, n, i.copy(s.from, i.to)));
          break;
        }
      }
  }
  return r;
}
function QO(e, r, t) {
  for (; r < e.length && _d(t, e[r]) > 0; )
    r++;
  e.splice(r, 0, t);
}
function Rg(e) {
  let r = [];
  return e.someProp("decorations", (t) => {
    let i = t(e.state);
    i && i != ci && r.push(i);
  }), e.cursorWrapper && r.push(Nt.create(e.state.doc, [e.cursorWrapper.deco])), mo.from(r);
}
const Uje = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, Zje = Bi && Eo <= 11;
class Jje {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(r) {
    this.anchorNode = r.anchorNode, this.anchorOffset = r.anchorOffset, this.focusNode = r.focusNode, this.focusOffset = r.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(r) {
    return r.anchorNode == this.anchorNode && r.anchorOffset == this.anchorOffset && r.focusNode == this.focusNode && r.focusOffset == this.focusOffset;
  }
}
class $je {
  constructor(r, t) {
    this.view = r, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new Jje(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((i) => {
      for (let n = 0; n < i.length; n++)
        this.queue.push(i[n]);
      Bi && Eo <= 11 && i.some((n) => n.type == "childList" && n.removedNodes.length || n.type == "characterData" && n.oldValue.length > n.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), Zje && (this.onCharData = (i) => {
      this.queue.push({ target: i.target, type: "characterData", oldValue: i.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, Uje)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let r = this.observer.takeRecords();
      if (r.length) {
        for (let t = 0; t < r.length; t++)
          this.queue.push(r[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (zO(this.view)) {
      if (this.suppressingSelectionUpdates)
        return Eu(this.view);
      if (Bi && Eo <= 11 && !this.view.state.selection.empty) {
        let r = this.view.domSelectionRange();
        if (r.focusNode && ia(r.focusNode, r.focusOffset, r.anchorNode, r.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(r) {
    if (!r.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), i;
    for (let s = r.focusNode; s; s = H7(s))
      t.add(s);
    for (let s = r.anchorNode; s; s = H7(s))
      if (t.has(s)) {
        i = s;
        break;
      }
    let n = i && this.view.docView.nearestDesc(i);
    if (n && n.ignoreMutation({
      type: "selection",
      target: i.nodeType == 3 ? i.parentNode : i
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let r of this.observer.takeRecords())
        this.queue.push(r);
    return this.queue;
  }
  flush() {
    let { view: r } = this;
    if (!r.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let i = r.domSelectionRange(), n = !this.suppressingSelectionUpdates && !this.currentSelection.eq(i) && zO(r) && !this.ignoreSelectionChange(i), s = -1, u = -1, o = !1, d = [];
    if (r.editable)
      for (let V = 0; V < t.length; V++) {
        let c = this.registerMutation(t[V], d);
        c && (s = s < 0 ? c.from : Math.min(c.from, s), u = u < 0 ? c.to : Math.max(c.to, u), c.typeOver && (o = !0));
      }
    if (Xs && d.length) {
      let V = d.filter((c) => c.nodeName == "BR");
      if (V.length == 2) {
        let [c, F] = V;
        c.parentNode && c.parentNode.parentNode == F.parentNode ? F.remove() : c.remove();
      } else {
        let { focusNode: c } = this.currentSelection;
        for (let F of V) {
          let X = F.parentNode;
          X && X.nodeName == "LI" && (!c || rze(r, c) != X) && F.remove();
        }
      }
    }
    let a = null;
    s < 0 && n && r.input.lastFocus > Date.now() - 200 && Math.max(r.input.lastTouch, r.input.lastClick.time) < Date.now() - 300 && Df(i) && (a = k4(r)) && a.eq(nr.near(r.state.doc.resolve(0), 1)) ? (r.input.lastFocus = 0, Eu(r), this.currentSelection.set(i), r.scrollToSelection()) : (s > -1 || n) && (s > -1 && (r.docView.markDirty(s, u), Qje(r)), this.handleDOMChange(s, u, o, d), r.docView && r.docView.dirty ? r.updateState(r.state) : this.currentSelection.eq(i) || Eu(r), this.currentSelection.set(i));
  }
  registerMutation(r, t) {
    if (t.indexOf(r.target) > -1)
      return null;
    let i = this.view.docView.nearestDesc(r.target);
    if (r.type == "attributes" && (i == this.view.docView || r.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    r.attributeName == "style" && !r.oldValue && !r.target.getAttribute("style")) || !i || i.ignoreMutation(r))
      return null;
    if (r.type == "childList") {
      for (let V = 0; V < r.addedNodes.length; V++) {
        let c = r.addedNodes[V];
        t.push(c), c.nodeType == 3 && (this.lastChangedTextNode = c);
      }
      if (i.contentDOM && i.contentDOM != i.dom && !i.contentDOM.contains(r.target))
        return { from: i.posBefore, to: i.posAfter };
      let n = r.previousSibling, s = r.nextSibling;
      if (Bi && Eo <= 11 && r.addedNodes.length)
        for (let V = 0; V < r.addedNodes.length; V++) {
          let { previousSibling: c, nextSibling: F } = r.addedNodes[V];
          (!c || Array.prototype.indexOf.call(r.addedNodes, c) < 0) && (n = c), (!F || Array.prototype.indexOf.call(r.addedNodes, F) < 0) && (s = F);
        }
      let u = n && n.parentNode == r.target ? ei(n) + 1 : 0, o = i.localPosFromDOM(r.target, u, -1), d = s && s.parentNode == r.target ? ei(s) : r.target.childNodes.length, a = i.localPosFromDOM(r.target, d, 1);
      return { from: o, to: a };
    } else return r.type == "attributes" ? { from: i.posAtStart - i.border, to: i.posAtEnd + i.border } : (this.lastChangedTextNode = r.target, {
      from: i.posAtStart,
      to: i.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: r.target.nodeValue == r.oldValue
    });
  }
}
let eD = /* @__PURE__ */ new WeakMap(), rD = !1;
function Qje(e) {
  if (!eD.has(e) && (eD.set(e, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(e.dom).whiteSpace) !== -1)) {
    if (e.requiresGeckoHackNode = Xs, rD)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), rD = !0;
  }
}
function tD(e, r) {
  let t = r.startContainer, i = r.startOffset, n = r.endContainer, s = r.endOffset, u = e.domAtPos(e.state.selection.anchor);
  return ia(u.node, u.offset, n, s) && ([t, i, n, s] = [n, s, t, i]), { anchorNode: t, anchorOffset: i, focusNode: n, focusOffset: s };
}
function eze(e, r) {
  if (r.getComposedRanges) {
    let n = r.getComposedRanges(e.root)[0];
    if (n)
      return tD(e, n);
  }
  let t;
  function i(n) {
    n.preventDefault(), n.stopImmediatePropagation(), t = n.getTargetRanges()[0];
  }
  return e.dom.addEventListener("beforeinput", i, !0), document.execCommand("indent"), e.dom.removeEventListener("beforeinput", i, !0), t ? tD(e, t) : null;
}
function rze(e, r) {
  for (let t = r.parentNode; t && t != e.dom; t = t.parentNode) {
    let i = e.docView.nearestDesc(t, !0);
    if (i && i.node.isBlock)
      return t;
  }
  return null;
}
function tze(e, r, t) {
  let { node: i, fromOffset: n, toOffset: s, from: u, to: o } = e.docView.parseRange(r, t), d = e.domSelectionRange(), a, V = d.anchorNode;
  if (V && e.dom.contains(V.nodeType == 1 ? V : V.parentNode) && (a = [{ node: V, offset: d.anchorOffset }], Df(d) || a.push({ node: d.focusNode, offset: d.focusOffset })), qi && e.input.lastKeyCode === 8)
    for (let f = s; f > n; f--) {
      let p = i.childNodes[f - 1], m = p.pmViewDesc;
      if (p.nodeName == "BR" && !m) {
        s = f;
        break;
      }
      if (!m || m.size)
        break;
    }
  let c = e.state.doc, F = e.someProp("domParser") || Mu.fromSchema(e.state.schema), X = c.resolve(u), Y = null, q = F.parse(i, {
    topNode: X.parent,
    topMatch: X.parent.contentMatchAt(X.index()),
    topOpen: !0,
    from: n,
    to: s,
    preserveWhitespace: X.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: a,
    ruleFromNode: ize,
    context: X
  });
  if (a && a[0].pos != null) {
    let f = a[0].pos, p = a[1] && a[1].pos;
    p == null && (p = f), Y = { anchor: f + u, head: p + u };
  }
  return { doc: q, sel: Y, from: u, to: o };
}
function ize(e) {
  let r = e.pmViewDesc;
  if (r)
    return r.parseRule();
  if (e.nodeName == "BR" && e.parentNode) {
    if (Si && /^(ul|ol)$/i.test(e.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (e.parentNode.lastChild == e || Si && /^(tr|table)$/i.test(e.parentNode.nodeName))
      return { ignore: !0 };
  } else if (e.nodeName == "IMG" && e.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const nze = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function sze(e, r, t, i, n) {
  let s = e.input.compositionPendingChanges || (e.composing ? e.input.compositionID : 0);
  if (e.input.compositionPendingChanges = 0, r < 0) {
    let N = e.input.lastSelectionTime > Date.now() - 50 ? e.input.lastSelectionOrigin : null, O = k4(e, N);
    if (O && !e.state.selection.eq(O)) {
      if (qi && Qn && e.input.lastKeyCode === 13 && Date.now() - 100 < e.input.lastKeyCodeTime && e.someProp("handleKeyDown", (I) => I(e, gd(13, "Enter"))))
        return;
      let E = e.state.tr.setSelection(O);
      N == "pointer" ? E.setMeta("pointer", !0) : N == "key" && E.scrollIntoView(), s && E.setMeta("composition", s), e.dispatch(E);
    }
    return;
  }
  let u = e.state.doc.resolve(r), o = u.sharedDepth(t);
  r = u.before(o + 1), t = e.state.doc.resolve(t).after(o + 1);
  let d = e.state.selection, a = tze(e, r, t), V = e.state.doc, c = V.slice(a.from, a.to), F, X;
  e.input.lastKeyCode === 8 && Date.now() - 100 < e.input.lastKeyCodeTime ? (F = e.state.selection.to, X = "end") : (F = e.state.selection.from, X = "start"), e.input.lastKeyCode = null;
  let Y = dze(c.content, a.doc.content, a.from, F, X);
  if (Y && e.input.domChangeCount++, (Vl && e.input.lastIOSEnter > Date.now() - 225 || Qn) && n.some((N) => N.nodeType == 1 && !nze.test(N.nodeName)) && (!Y || Y.endA >= Y.endB) && e.someProp("handleKeyDown", (N) => N(e, gd(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (!Y)
    if (i && d instanceof Ze && !d.empty && d.$head.sameParent(d.$anchor) && !e.composing && !(a.sel && a.sel.anchor != a.sel.head))
      Y = { start: d.from, endA: d.to, endB: d.to };
    else {
      if (a.sel) {
        let N = iD(e, e.state.doc, a.sel);
        if (N && !N.eq(e.state.selection)) {
          let O = e.state.tr.setSelection(N);
          s && O.setMeta("composition", s), e.dispatch(O);
        }
      }
      return;
    }
  e.state.selection.from < e.state.selection.to && Y.start == Y.endB && e.state.selection instanceof Ze && (Y.start > e.state.selection.from && Y.start <= e.state.selection.from + 2 && e.state.selection.from >= a.from ? Y.start = e.state.selection.from : Y.endA < e.state.selection.to && Y.endA >= e.state.selection.to - 2 && e.state.selection.to <= a.to && (Y.endB += e.state.selection.to - Y.endA, Y.endA = e.state.selection.to)), Bi && Eo <= 11 && Y.endB == Y.start + 1 && Y.endA == Y.start && Y.start > a.from && a.doc.textBetween(Y.start - a.from - 1, Y.start - a.from + 1) == "  " && (Y.start--, Y.endA--, Y.endB--);
  let q = a.doc.resolveNoCache(Y.start - a.from), f = a.doc.resolveNoCache(Y.endB - a.from), p = V.resolve(Y.start), m = q.sameParent(f) && q.parent.inlineContent && p.end() >= Y.endA, g;
  if ((Vl && e.input.lastIOSEnter > Date.now() - 225 && (!m || n.some((N) => N.nodeName == "DIV" || N.nodeName == "P")) || !m && q.pos < a.doc.content.size && !q.sameParent(f) && (g = nr.findFrom(a.doc.resolve(q.pos + 1), 1, !0)) && g.head == f.pos) && e.someProp("handleKeyDown", (N) => N(e, gd(13, "Enter")))) {
    e.input.lastIOSEnter = 0;
    return;
  }
  if (e.state.selection.anchor > Y.start && oze(V, Y.start, Y.endA, q, f) && e.someProp("handleKeyDown", (N) => N(e, gd(8, "Backspace")))) {
    Qn && qi && e.domObserver.suppressSelectionUpdates();
    return;
  }
  qi && Qn && Y.endB == Y.start && (e.input.lastAndroidDelete = Date.now()), Qn && !m && q.start() != f.start() && f.parentOffset == 0 && q.depth == f.depth && a.sel && a.sel.anchor == a.sel.head && a.sel.head == Y.endA && (Y.endB -= 2, f = a.doc.resolveNoCache(Y.endB - a.from), setTimeout(() => {
    e.someProp("handleKeyDown", function(N) {
      return N(e, gd(13, "Enter"));
    });
  }, 20));
  let y = Y.start, b = Y.endA, A, w, S;
  if (m) {
    if (q.pos == f.pos)
      Bi && Eo <= 11 && q.parentOffset == 0 && (e.domObserver.suppressSelectionUpdates(), setTimeout(() => Eu(e), 20)), A = e.state.tr.delete(y, b), w = V.resolve(Y.start).marksAcross(V.resolve(Y.endA));
    else if (
      // Adding or removing a mark
      Y.endA == Y.endB && (S = uze(q.parent.content.cut(q.parentOffset, f.parentOffset), p.parent.content.cut(p.parentOffset, Y.endA - p.start())))
    )
      A = e.state.tr, S.type == "add" ? A.addMark(y, b, S.mark) : A.removeMark(y, b, S.mark);
    else if (q.parent.child(q.index()).isText && q.index() == f.index() - (f.textOffset ? 0 : 1)) {
      let N = q.parent.textBetween(q.parentOffset, f.parentOffset);
      if (e.someProp("handleTextInput", (O) => O(e, y, b, N)))
        return;
      A = e.state.tr.insertText(N, y, b);
    }
  }
  if (A || (A = e.state.tr.replace(y, b, a.doc.slice(Y.start - a.from, Y.endB - a.from))), a.sel) {
    let N = iD(e, A.doc, a.sel);
    N && !(qi && Qn && e.composing && N.empty && (Y.start != Y.endB || e.input.lastAndroidDelete < Date.now() - 100) && (N.head == y || N.head == A.mapping.map(b) - 1) || Bi && N.empty && N.head == y) && A.setSelection(N);
  }
  w && A.ensureMarks(w), s && A.setMeta("composition", s), e.dispatch(A.scrollIntoView());
}
function iD(e, r, t) {
  return Math.max(t.anchor, t.head) > r.content.size ? null : O4(e, r.resolve(t.anchor), r.resolve(t.head));
}
function uze(e, r) {
  let t = e.firstChild.marks, i = r.firstChild.marks, n = t, s = i, u, o, d;
  for (let V = 0; V < i.length; V++)
    n = i[V].removeFromSet(n);
  for (let V = 0; V < t.length; V++)
    s = t[V].removeFromSet(s);
  if (n.length == 1 && s.length == 0)
    o = n[0], u = "add", d = (V) => V.mark(o.addToSet(V.marks));
  else if (n.length == 0 && s.length == 1)
    o = s[0], u = "remove", d = (V) => V.mark(o.removeFromSet(V.marks));
  else
    return null;
  let a = [];
  for (let V = 0; V < r.childCount; V++)
    a.push(d(r.child(V)));
  if (Fe.from(a).eq(e))
    return { mark: o, type: u };
}
function oze(e, r, t, i, n) {
  if (
    // The content must have shrunk
    t - r <= n.pos - i.pos || // newEnd must point directly at or after the end of the block that newStart points into
    Ig(i, !0, !1) < n.pos
  )
    return !1;
  let s = e.resolve(r);
  if (!i.parent.isTextblock) {
    let o = s.nodeAfter;
    return o != null && t == r + o.nodeSize;
  }
  if (s.parentOffset < s.parent.content.size || !s.parent.isTextblock)
    return !1;
  let u = e.resolve(Ig(s, !0, !0));
  return !u.parent.isTextblock || u.pos > t || Ig(u, !0, !1) < t ? !1 : i.parent.content.cut(i.parentOffset).eq(u.parent.content);
}
function Ig(e, r, t) {
  let i = e.depth, n = r ? e.end() : e.pos;
  for (; i > 0 && (r || e.indexAfter(i) == e.node(i).childCount); )
    i--, n++, r = !1;
  if (t) {
    let s = e.node(i).maybeChild(e.indexAfter(i));
    for (; s && !s.isLeaf; )
      s = s.firstChild, n++;
  }
  return n;
}
function dze(e, r, t, i, n) {
  let s = e.findDiffStart(r, t);
  if (s == null)
    return null;
  let { a: u, b: o } = e.findDiffEnd(r, t + e.size, t + r.size);
  if (n == "end") {
    let d = Math.max(0, s - Math.min(u, o));
    i -= u + d - s;
  }
  if (u < s && e.size < r.size) {
    let d = i <= s && i >= u ? s - i : 0;
    s -= d, s && s < r.size && nD(r.textBetween(s - 1, s + 1)) && (s += d ? 1 : -1), o = s + (o - u), u = s;
  } else if (o < s) {
    let d = i <= s && i >= o ? s - i : 0;
    s -= d, s && s < e.size && nD(e.textBetween(s - 1, s + 1)) && (s += d ? 1 : -1), u = s + (u - o), o = s;
  }
  return { start: s, endA: u, endB: o };
}
function nD(e) {
  if (e.length != 2)
    return !1;
  let r = e.charCodeAt(0), t = e.charCodeAt(1);
  return r >= 56320 && r <= 57343 && t >= 55296 && t <= 56319;
}
class aze {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(r, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new wje(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(aD), this.dispatch = this.dispatch.bind(this), this.dom = r && r.mount || document.createElement("div"), r && (r.appendChild ? r.appendChild(this.dom) : typeof r == "function" ? r(this.dom) : r.mount && (this.mounted = !0)), this.editable = oD(this), uD(this), this.nodeViews = dD(this), this.docView = RO(this.state.doc, sD(this), Rg(this), this.dom, this), this.domObserver = new $je(this, (i, n, s, u) => sze(this, i, n, s, u)), this.domObserver.start(), Cje(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let r = this._props;
      this._props = {};
      for (let t in r)
        this._props[t] = r[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(r) {
    r.handleDOMEvents != this._props.handleDOMEvents && oy(this);
    let t = this._props;
    this._props = r, r.plugins && (r.plugins.forEach(aD), this.directPlugins = r.plugins), this.updateStateInner(r.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(r) {
    let t = {};
    for (let i in this._props)
      t[i] = this._props[i];
    t.state = this.state;
    for (let i in r)
      t[i] = r[i];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(r) {
    this.updateStateInner(r, this._props);
  }
  updateStateInner(r, t) {
    var i;
    let n = this.state, s = !1, u = !1;
    r.storedMarks && this.composing && (hee(this), u = !0), this.state = r;
    let o = n.plugins != r.plugins || this._props.plugins != t.plugins;
    if (o || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let X = dD(this);
      lze(X, this.nodeViews) && (this.nodeViews = X, s = !0);
    }
    (o || t.handleDOMEvents != this._props.handleDOMEvents) && oy(this), this.editable = oD(this), uD(this);
    let d = Rg(this), a = sD(this), V = n.plugins != r.plugins && !n.doc.eq(r.doc) ? "reset" : r.scrollToSelection > n.scrollToSelection ? "to selection" : "preserve", c = s || !this.docView.matchesNode(r.doc, a, d);
    (c || !r.selection.eq(n.selection)) && (u = !0);
    let F = V == "preserve" && u && this.dom.style.overflowAnchor == null && HHe(this);
    if (u) {
      this.domObserver.stop();
      let X = c && (Bi || qi) && !this.composing && !n.selection.empty && !r.selection.empty && Vze(n.selection, r.selection);
      if (c) {
        let Y = qi ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = _je(this)), (s || !this.docView.update(r.doc, a, d, this)) && (this.docView.updateOuterDeco(a), this.docView.destroy(), this.docView = RO(r.doc, a, d, this.dom, this)), Y && !this.trackWrites && (X = !0);
      }
      X || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && Fje(this)) ? Eu(this, X) : (oee(this, r.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(n), !((i = this.dragging) === null || i === void 0) && i.node && !n.doc.eq(r.doc) && this.updateDraggedNode(this.dragging, n), V == "reset" ? this.dom.scrollTop = 0 : V == "to selection" ? this.scrollToSelection() : F && jHe(F);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let r = this.domSelectionRange().focusNode;
    if (!this.someProp("handleScrollToSelection", (t) => t(this))) if (this.state.selection instanceof ke) {
      let t = this.docView.domAfterPos(this.state.selection.from);
      t.nodeType == 1 && MO(this, t.getBoundingClientRect(), r);
    } else
      MO(this, this.coordsAtPos(this.state.selection.head, 1), r);
  }
  destroyPluginViews() {
    let r;
    for (; r = this.pluginViews.pop(); )
      r.destroy && r.destroy();
  }
  updatePluginViews(r) {
    if (!r || r.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let i = this.directPlugins[t];
        i.spec.view && this.pluginViews.push(i.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let i = this.state.plugins[t];
        i.spec.view && this.pluginViews.push(i.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let i = this.pluginViews[t];
        i.update && i.update(this, r);
      }
  }
  updateDraggedNode(r, t) {
    let i = r.node, n = -1;
    if (this.state.doc.nodeAt(i.from) == i.node)
      n = i.from;
    else {
      let s = i.from + (this.state.doc.content.size - t.doc.content.size);
      (s > 0 && this.state.doc.nodeAt(s)) == i.node && (n = s);
    }
    this.dragging = new mee(r.slice, r.move, n < 0 ? void 0 : ke.create(this.state.doc, n));
  }
  someProp(r, t) {
    let i = this._props && this._props[r], n;
    if (i != null && (n = t ? t(i) : i))
      return n;
    for (let u = 0; u < this.directPlugins.length; u++) {
      let o = this.directPlugins[u].props[r];
      if (o != null && (n = t ? t(o) : o))
        return n;
    }
    let s = this.state.plugins;
    if (s)
      for (let u = 0; u < s.length; u++) {
        let o = s[u].props[r];
        if (o != null && (n = t ? t(o) : o))
          return n;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (Bi) {
      let r = this.root.activeElement;
      if (r == this.dom)
        return !0;
      if (!r || !this.dom.contains(r))
        return !1;
      for (; r && this.dom != r && this.dom.contains(r); ) {
        if (r.contentEditable == "false")
          return !1;
        r = r.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && zHe(this.dom), Eu(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let r = this._root;
    if (r == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return r || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(r) {
    return ZHe(this, r);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(r, t = 1) {
    return QQ(this, r, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(r, t = 0) {
    return this.docView.domFromPos(r, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(r) {
    let t = this.docView.descAt(r);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(r, t, i = -1) {
    let n = this.docView.posFromDOM(r, t, i);
    if (n == null)
      throw new RangeError("DOM position not inside the editor");
    return n;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(r, t) {
    return rje(this, t || this.state, r);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(r, t) {
    return z7(this, "", r, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(r, t) {
    return z7(this, r, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (Pje(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], Rg(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, NHe());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(r) {
    return Nje(this, r);
  }
  /**
  Dispatch a transaction. Will call
  [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
  when given, and otherwise defaults to applying the transaction to
  the current state and calling
  [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
  This method is bound to the view instance, so that it can be
  easily passed around.
  */
  dispatch(r) {
    let t = this._props.dispatchTransaction;
    t ? t.call(this, r) : this.updateState(this.state.apply(r));
  }
  /**
  @internal
  */
  domSelectionRange() {
    let r = this.domSelection();
    return r ? Si && this.root.nodeType === 11 && OHe(this.dom.ownerDocument) == this.dom && eze(this, r) || r : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
function sD(e) {
  let r = /* @__PURE__ */ Object.create(null);
  return r.class = "ProseMirror", r.contenteditable = String(e.editable), e.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(e.state)), t)
      for (let i in t)
        i == "class" ? r.class += " " + t[i] : i == "style" ? r.style = (r.style ? r.style + ";" : "") + t[i] : !r[i] && i != "contenteditable" && i != "nodeName" && (r[i] = String(t[i]));
  }), r.translate || (r.translate = "no"), [Sn.node(0, e.state.doc.content.size, r)];
}
function uD(e) {
  if (e.markCursor) {
    let r = document.createElement("img");
    r.className = "ProseMirror-separator", r.setAttribute("mark-placeholder", "true"), r.setAttribute("alt", ""), e.cursorWrapper = { dom: r, deco: Sn.widget(e.state.selection.from, r, { raw: !0, marks: e.markCursor }) };
  } else
    e.cursorWrapper = null;
}
function oD(e) {
  return !e.someProp("editable", (r) => r(e.state) === !1);
}
function Vze(e, r) {
  let t = Math.min(e.$anchor.sharedDepth(e.head), r.$anchor.sharedDepth(r.head));
  return e.$anchor.start(t) != r.$anchor.start(t);
}
function dD(e) {
  let r = /* @__PURE__ */ Object.create(null);
  function t(i) {
    for (let n in i)
      Object.prototype.hasOwnProperty.call(r, n) || (r[n] = i[n]);
  }
  return e.someProp("nodeViews", t), e.someProp("markViews", t), r;
}
function lze(e, r) {
  let t = 0, i = 0;
  for (let n in e) {
    if (e[n] != r[n])
      return !0;
    t++;
  }
  for (let n in r)
    i++;
  return t != i;
}
function aD(e) {
  if (e.spec.state || e.spec.filterTransaction || e.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var jo = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, yq = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, cze = typeof navigator < "u" && /Mac/.test(navigator.platform), Fze = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var ri = 0; ri < 10; ri++) jo[48 + ri] = jo[96 + ri] = String(ri);
for (var ri = 1; ri <= 24; ri++) jo[ri + 111] = "F" + ri;
for (var ri = 65; ri <= 90; ri++)
  jo[ri] = String.fromCharCode(ri + 32), yq[ri] = String.fromCharCode(ri);
for (var Lg in jo) yq.hasOwnProperty(Lg) || (yq[Lg] = jo[Lg]);
function xze(e) {
  var r = cze && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || Fze && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified", t = !r && e.key || (e.shiftKey ? yq : jo)[e.keyCode] || e.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const Xze = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function qze(e) {
  let r = e.split(/-(?!$)/), t = r[r.length - 1];
  t == "Space" && (t = " ");
  let i, n, s, u;
  for (let o = 0; o < r.length - 1; o++) {
    let d = r[o];
    if (/^(cmd|meta|m)$/i.test(d))
      u = !0;
    else if (/^a(lt)?$/i.test(d))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(d))
      n = !0;
    else if (/^s(hift)?$/i.test(d))
      s = !0;
    else if (/^mod$/i.test(d))
      Xze ? u = !0 : n = !0;
    else
      throw new Error("Unrecognized modifier name: " + d);
  }
  return i && (t = "Alt-" + t), n && (t = "Ctrl-" + t), u && (t = "Meta-" + t), s && (t = "Shift-" + t), t;
}
function Yze(e) {
  let r = /* @__PURE__ */ Object.create(null);
  for (let t in e)
    r[qze(t)] = e[t];
  return r;
}
function _g(e, r, t = !0) {
  return r.altKey && (e = "Alt-" + e), r.ctrlKey && (e = "Ctrl-" + e), r.metaKey && (e = "Meta-" + e), t && r.shiftKey && (e = "Shift-" + e), e;
}
function fze(e) {
  return new Ei({ props: { handleKeyDown: Aee(e) } });
}
function Aee(e) {
  let r = Yze(e);
  return function(t, i) {
    let n = xze(i), s, u = r[_g(n, i)];
    if (u && u(t.state, t.dispatch, t))
      return !0;
    if (n.length == 1 && n != " ") {
      if (i.shiftKey) {
        let o = r[_g(n, i, !1)];
        if (o && o(t.state, t.dispatch, t))
          return !0;
      }
      if ((i.shiftKey || i.altKey || i.metaKey || n.charCodeAt(0) > 127) && (s = jo[i.keyCode]) && s != n) {
        let o = r[_g(s, i)];
        if (o && o(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
const H4 = (e, r) => e.selection.empty ? !1 : (r && r(e.tr.deleteSelection().scrollIntoView()), !0);
function wee(e, r) {
  let { $cursor: t } = e.selection;
  return !t || (r ? !r.endOfTextblock("backward", e) : t.parentOffset > 0) ? null : t;
}
const Cee = (e, r, t) => {
  let i = wee(e, t);
  if (!i)
    return !1;
  let n = j4(i);
  if (!n) {
    let u = i.blockRange(), o = u && Il(u);
    return o == null ? !1 : (r && r(e.tr.lift(u, o).scrollIntoView()), !0);
  }
  let s = n.nodeBefore;
  if (Dee(e, n, r, -1))
    return !0;
  if (i.parent.content.size == 0 && (ll(s, "end") || ke.isSelectable(s)))
    for (let u = i.depth; ; u--) {
      let o = kf(e.doc, i.before(u), i.after(u), ve.empty);
      if (o && o.slice.size < o.to - o.from) {
        if (r) {
          let d = e.tr.step(o);
          d.setSelection(ll(s, "end") ? nr.findFrom(d.doc.resolve(d.mapping.map(n.pos, -1)), -1) : ke.create(d.doc, n.pos - s.nodeSize)), r(d.scrollIntoView());
        }
        return !0;
      }
      if (u == 1 || i.node(u - 1).childCount > 1)
        break;
    }
  return s.isAtom && n.depth == i.depth - 1 ? (r && r(e.tr.delete(n.pos - s.nodeSize, n.pos).scrollIntoView()), !0) : !1;
}, Kze = (e, r, t) => {
  let i = wee(e, t);
  if (!i)
    return !1;
  let n = j4(i);
  return n ? Pee(e, n, r) : !1;
}, hze = (e, r, t) => {
  let i = Nee(e, t);
  if (!i)
    return !1;
  let n = z4(i);
  return n ? Pee(e, n, r) : !1;
};
function Pee(e, r, t) {
  let i = r.nodeBefore, n = i, s = r.pos - 1;
  for (; !n.isTextblock; s--) {
    if (n.type.spec.isolating)
      return !1;
    let V = n.lastChild;
    if (!V)
      return !1;
    n = V;
  }
  let u = r.nodeAfter, o = u, d = r.pos + 1;
  for (; !o.isTextblock; d++) {
    if (o.type.spec.isolating)
      return !1;
    let V = o.firstChild;
    if (!V)
      return !1;
    o = V;
  }
  let a = kf(e.doc, s, d, ve.empty);
  if (!a || a.from != s || a instanceof It && a.slice.size >= d - s)
    return !1;
  if (t) {
    let V = e.tr.step(a);
    V.setSelection(Ze.create(V.doc, s)), t(V.scrollIntoView());
  }
  return !0;
}
function ll(e, r, t = !1) {
  for (let i = e; i; i = r == "start" ? i.firstChild : i.lastChild) {
    if (i.isTextblock)
      return !0;
    if (t && i.childCount != 1)
      return !1;
  }
  return !1;
}
const See = (e, r, t) => {
  let { $head: i, empty: n } = e.selection, s = i;
  if (!n)
    return !1;
  if (i.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", e) : i.parentOffset > 0)
      return !1;
    s = j4(i);
  }
  let u = s && s.nodeBefore;
  return !u || !ke.isSelectable(u) ? !1 : (r && r(e.tr.setSelection(ke.create(e.doc, s.pos - u.nodeSize)).scrollIntoView()), !0);
};
function j4(e) {
  if (!e.parent.type.spec.isolating)
    for (let r = e.depth - 1; r >= 0; r--) {
      if (e.index(r) > 0)
        return e.doc.resolve(e.before(r + 1));
      if (e.node(r).type.spec.isolating)
        break;
    }
  return null;
}
function Nee(e, r) {
  let { $cursor: t } = e.selection;
  return !t || (r ? !r.endOfTextblock("forward", e) : t.parentOffset < t.parent.content.size) ? null : t;
}
const Mee = (e, r, t) => {
  let i = Nee(e, t);
  if (!i)
    return !1;
  let n = z4(i);
  if (!n)
    return !1;
  let s = n.nodeAfter;
  if (Dee(e, n, r, 1))
    return !0;
  if (i.parent.content.size == 0 && (ll(s, "start") || ke.isSelectable(s))) {
    let u = kf(e.doc, i.before(), i.after(), ve.empty);
    if (u && u.slice.size < u.to - u.from) {
      if (r) {
        let o = e.tr.step(u);
        o.setSelection(ll(s, "start") ? nr.findFrom(o.doc.resolve(o.mapping.map(n.pos)), 1) : ke.create(o.doc, o.mapping.map(n.pos))), r(o.scrollIntoView());
      }
      return !0;
    }
  }
  return s.isAtom && n.depth == i.depth - 1 ? (r && r(e.tr.delete(n.pos, n.pos + s.nodeSize).scrollIntoView()), !0) : !1;
}, Tee = (e, r, t) => {
  let { $head: i, empty: n } = e.selection, s = i;
  if (!n)
    return !1;
  if (i.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", e) : i.parentOffset < i.parent.content.size)
      return !1;
    s = z4(i);
  }
  let u = s && s.nodeAfter;
  return !u || !ke.isSelectable(u) ? !1 : (r && r(e.tr.setSelection(ke.create(e.doc, s.pos)).scrollIntoView()), !0);
};
function z4(e) {
  if (!e.parent.type.spec.isolating)
    for (let r = e.depth - 1; r >= 0; r--) {
      let t = e.node(r);
      if (e.index(r) + 1 < t.childCount)
        return e.doc.resolve(e.after(r + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const pze = (e, r) => {
  let t = e.selection, i = t instanceof ke, n;
  if (i) {
    if (t.node.isTextblock || !id(e.doc, t.from))
      return !1;
    n = t.from;
  } else if (n = Ef(e.doc, t.from, -1), n == null)
    return !1;
  if (r) {
    let s = e.tr.join(n);
    i && s.setSelection(ke.create(s.doc, n - e.doc.resolve(n).nodeBefore.nodeSize)), r(s.scrollIntoView());
  }
  return !0;
}, mze = (e, r) => {
  let t = e.selection, i;
  if (t instanceof ke) {
    if (t.node.isTextblock || !id(e.doc, t.to))
      return !1;
    i = t.to;
  } else if (i = Ef(e.doc, t.to, 1), i == null)
    return !1;
  return r && r(e.tr.join(i).scrollIntoView()), !0;
}, gze = (e, r) => {
  let { $from: t, $to: i } = e.selection, n = t.blockRange(i), s = n && Il(n);
  return s == null ? !1 : (r && r(e.tr.lift(n, s).scrollIntoView()), !0);
}, Eee = (e, r) => {
  let { $head: t, $anchor: i } = e.selection;
  return !t.parent.type.spec.code || !t.sameParent(i) ? !1 : (r && r(e.tr.insertText(`
`).scrollIntoView()), !0);
};
function B4(e) {
  for (let r = 0; r < e.edgeCount; r++) {
    let { type: t } = e.edge(r);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const vze = (e, r) => {
  let { $head: t, $anchor: i } = e.selection;
  if (!t.parent.type.spec.code || !t.sameParent(i))
    return !1;
  let n = t.node(-1), s = t.indexAfter(-1), u = B4(n.contentMatchAt(s));
  if (!u || !n.canReplaceWith(s, s, u))
    return !1;
  if (r) {
    let o = t.after(), d = e.tr.replaceWith(o, o, u.createAndFill());
    d.setSelection(nr.near(d.doc.resolve(o), 1)), r(d.scrollIntoView());
  }
  return !0;
}, kee = (e, r) => {
  let t = e.selection, { $from: i, $to: n } = t;
  if (t instanceof Tn || i.parent.inlineContent || n.parent.inlineContent)
    return !1;
  let s = B4(n.parent.contentMatchAt(n.indexAfter()));
  if (!s || !s.isTextblock)
    return !1;
  if (r) {
    let u = (!i.parentOffset && n.index() < n.parent.childCount ? i : n).pos, o = e.tr.insert(u, s.createAndFill());
    o.setSelection(Ze.create(o.doc, u + 1)), r(o.scrollIntoView());
  }
  return !0;
}, Oee = (e, r) => {
  let { $cursor: t } = e.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let s = t.before();
    if (Tu(e.doc, s))
      return r && r(e.tr.split(s).scrollIntoView()), !0;
  }
  let i = t.blockRange(), n = i && Il(i);
  return n == null ? !1 : (r && r(e.tr.lift(i, n).scrollIntoView()), !0);
};
function bze(e) {
  return (r, t) => {
    let { $from: i, $to: n } = r.selection;
    if (r.selection instanceof ke && r.selection.node.isBlock)
      return !i.parentOffset || !Tu(r.doc, i.pos) ? !1 : (t && t(r.tr.split(i.pos).scrollIntoView()), !0);
    if (!i.depth)
      return !1;
    let s = [], u, o, d = !1, a = !1;
    for (let X = i.depth; ; X--)
      if (i.node(X).isBlock) {
        d = i.end(X) == i.pos + (i.depth - X), a = i.start(X) == i.pos - (i.depth - X), o = B4(i.node(X - 1).contentMatchAt(i.indexAfter(X - 1))), s.unshift(d && o ? { type: o } : null), u = X;
        break;
      } else {
        if (X == 1)
          return !1;
        s.unshift(null);
      }
    let V = r.tr;
    (r.selection instanceof Ze || r.selection instanceof Tn) && V.deleteSelection();
    let c = V.mapping.map(i.pos), F = Tu(V.doc, c, s.length, s);
    if (F || (s[0] = o ? { type: o } : null, F = Tu(V.doc, c, s.length, s)), V.split(c, s.length, s), !d && a && i.node(u).type != o) {
      let X = V.mapping.map(i.before(u)), Y = V.doc.resolve(X);
      o && i.node(u - 1).canReplaceWith(Y.index(), Y.index() + 1, o) && V.setNodeMarkup(V.mapping.map(i.before(u)), o);
    }
    return t && t(V.scrollIntoView()), !0;
  };
}
const yze = bze(), Aze = (e, r) => {
  let { $from: t, to: i } = e.selection, n, s = t.sharedDepth(i);
  return s == 0 ? !1 : (n = t.before(s), r && r(e.tr.setSelection(ke.create(e.doc, n))), !0);
};
function wze(e, r, t) {
  let i = r.nodeBefore, n = r.nodeAfter, s = r.index();
  return !i || !n || !i.type.compatibleContent(n.type) ? !1 : !i.content.size && r.parent.canReplace(s - 1, s) ? (t && t(e.tr.delete(r.pos - i.nodeSize, r.pos).scrollIntoView()), !0) : !r.parent.canReplace(s, s + 1) || !(n.isTextblock || id(e.doc, r.pos)) ? !1 : (t && t(e.tr.join(r.pos).scrollIntoView()), !0);
}
function Dee(e, r, t, i) {
  let n = r.nodeBefore, s = r.nodeAfter, u, o, d = n.type.spec.isolating || s.type.spec.isolating;
  if (!d && wze(e, r, t))
    return !0;
  let a = !d && r.parent.canReplace(r.index(), r.index() + 1);
  if (a && (u = (o = n.contentMatchAt(n.childCount)).findWrapping(s.type)) && o.matchType(u[0] || s.type).validEnd) {
    if (t) {
      let X = r.pos + s.nodeSize, Y = Fe.empty;
      for (let p = u.length - 1; p >= 0; p--)
        Y = Fe.from(u[p].create(null, Y));
      Y = Fe.from(n.copy(Y));
      let q = e.tr.step(new Ht(r.pos - 1, X, r.pos, X, new ve(Y, 1, 0), u.length, !0)), f = q.doc.resolve(X + 2 * u.length);
      f.nodeAfter && f.nodeAfter.type == n.type && id(q.doc, f.pos) && q.join(f.pos), t(q.scrollIntoView());
    }
    return !0;
  }
  let V = s.type.spec.isolating || i > 0 && d ? null : nr.findFrom(r, 1), c = V && V.$from.blockRange(V.$to), F = c && Il(c);
  if (F != null && F >= r.depth)
    return t && t(e.tr.lift(c, F).scrollIntoView()), !0;
  if (a && ll(s, "start", !0) && ll(n, "end")) {
    let X = n, Y = [];
    for (; Y.push(X), !X.isTextblock; )
      X = X.lastChild;
    let q = s, f = 1;
    for (; !q.isTextblock; q = q.firstChild)
      f++;
    if (X.canReplace(X.childCount, X.childCount, q.content)) {
      if (t) {
        let p = Fe.empty;
        for (let g = Y.length - 1; g >= 0; g--)
          p = Fe.from(Y[g].copy(p));
        let m = e.tr.step(new Ht(r.pos - Y.length, r.pos + s.nodeSize, r.pos + f, r.pos + s.nodeSize - f, new ve(p, Y.length, 0), 0, !0));
        t(m.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function Ree(e) {
  return function(r, t) {
    let i = r.selection, n = e < 0 ? i.$from : i.$to, s = n.depth;
    for (; n.node(s).isInline; ) {
      if (!s)
        return !1;
      s--;
    }
    return n.node(s).isTextblock ? (t && t(r.tr.setSelection(Ze.create(r.doc, e < 0 ? n.start(s) : n.end(s)))), !0) : !1;
  };
}
const Cze = Ree(-1), Pze = Ree(1);
function Sze(e, r = null) {
  return function(t, i) {
    let { $from: n, $to: s } = t.selection, u = n.blockRange(s), o = u && M4(u, e, r);
    return o ? (i && i(t.tr.wrap(u, o).scrollIntoView()), !0) : !1;
  };
}
function VD(e, r = null) {
  return function(t, i) {
    let n = !1;
    for (let s = 0; s < t.selection.ranges.length && !n; s++) {
      let { $from: { pos: u }, $to: { pos: o } } = t.selection.ranges[s];
      t.doc.nodesBetween(u, o, (d, a) => {
        if (n)
          return !1;
        if (!(!d.isTextblock || d.hasMarkup(e, r)))
          if (d.type == e)
            n = !0;
          else {
            let V = t.doc.resolve(a), c = V.index();
            n = V.parent.canReplaceWith(c, c + 1, e);
          }
      });
    }
    if (!n)
      return !1;
    if (i) {
      let s = t.tr;
      for (let u = 0; u < t.selection.ranges.length; u++) {
        let { $from: { pos: o }, $to: { pos: d } } = t.selection.ranges[u];
        s.setBlockType(o, d, e, r);
      }
      i(s.scrollIntoView());
    }
    return !0;
  };
}
function W4(...e) {
  return function(r, t, i) {
    for (let n = 0; n < e.length; n++)
      if (e[n](r, t, i))
        return !0;
    return !1;
  };
}
W4(H4, Cee, See);
W4(H4, Mee, Tee);
W4(Eee, kee, Oee, yze);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function Nze(e, r = null) {
  return function(t, i) {
    let { $from: n, $to: s } = t.selection, u = n.blockRange(s), o = !1, d = u;
    if (!u)
      return !1;
    if (u.depth >= 2 && n.node(u.depth - 1).type.compatibleContent(e) && u.startIndex == 0) {
      if (n.index(u.depth - 1) == 0)
        return !1;
      let V = t.doc.resolve(u.start - 2);
      d = new Yq(V, V, u.depth), u.endIndex < u.parent.childCount && (u = new Yq(n, t.doc.resolve(s.end(u.depth)), u.depth)), o = !0;
    }
    let a = M4(d, e, r, u);
    return a ? (i && i(Mze(t.tr, u, a, o, e).scrollIntoView()), !0) : !1;
  };
}
function Mze(e, r, t, i, n) {
  let s = Fe.empty;
  for (let V = t.length - 1; V >= 0; V--)
    s = Fe.from(t[V].type.create(t[V].attrs, s));
  e.step(new Ht(r.start - (i ? 2 : 0), r.end, r.start, r.end, new ve(s, 0, 0), t.length, !0));
  let u = 0;
  for (let V = 0; V < t.length; V++)
    t[V].type == n && (u = V + 1);
  let o = t.length - u, d = r.start + t.length - (i ? 2 : 0), a = r.parent;
  for (let V = r.startIndex, c = r.endIndex, F = !0; V < c; V++, F = !1)
    !F && Tu(e.doc, d, o) && (e.split(d, o), d += 2 * o), d += a.child(V).nodeSize;
  return e;
}
function Tze(e) {
  return function(r, t) {
    let { $from: i, $to: n } = r.selection, s = i.blockRange(n, (u) => u.childCount > 0 && u.firstChild.type == e);
    return s ? t ? i.node(s.depth - 1).type == e ? Eze(r, t, e, s) : kze(r, t, s) : !0 : !1;
  };
}
function Eze(e, r, t, i) {
  let n = e.tr, s = i.end, u = i.$to.end(i.depth);
  s < u && (n.step(new Ht(s - 1, u, s, u, new ve(Fe.from(t.create(null, i.parent.copy())), 1, 0), 1, !0)), i = new Yq(n.doc.resolve(i.$from.pos), n.doc.resolve(u), i.depth));
  const o = Il(i);
  if (o == null)
    return !1;
  n.lift(i, o);
  let d = n.mapping.map(s, -1) - 1;
  return id(n.doc, d) && n.join(d), r(n.scrollIntoView()), !0;
}
function kze(e, r, t) {
  let i = e.tr, n = t.parent;
  for (let X = t.end, Y = t.endIndex - 1, q = t.startIndex; Y > q; Y--)
    X -= n.child(Y).nodeSize, i.delete(X - 1, X + 1);
  let s = i.doc.resolve(t.start), u = s.nodeAfter;
  if (i.mapping.map(t.end) != t.start + s.nodeAfter.nodeSize)
    return !1;
  let o = t.startIndex == 0, d = t.endIndex == n.childCount, a = s.node(-1), V = s.index(-1);
  if (!a.canReplace(V + (o ? 0 : 1), V + 1, u.content.append(d ? Fe.empty : Fe.from(n))))
    return !1;
  let c = s.pos, F = c + u.nodeSize;
  return i.step(new Ht(c - (o ? 1 : 0), F + (d ? 1 : 0), c + 1, F - 1, new ve((o ? Fe.empty : Fe.from(n.copy(Fe.empty))).append(d ? Fe.empty : Fe.from(n.copy(Fe.empty))), o ? 0 : 1, d ? 0 : 1), o ? 0 : 1)), r(i.scrollIntoView()), !0;
}
function Oze(e) {
  return function(r, t) {
    let { $from: i, $to: n } = r.selection, s = i.blockRange(n, (a) => a.childCount > 0 && a.firstChild.type == e);
    if (!s)
      return !1;
    let u = s.startIndex;
    if (u == 0)
      return !1;
    let o = s.parent, d = o.child(u - 1);
    if (d.type != e)
      return !1;
    if (t) {
      let a = d.lastChild && d.lastChild.type == o.type, V = Fe.from(a ? e.create() : null), c = new ve(Fe.from(e.create(null, Fe.from(o.type.create(null, V)))), a ? 3 : 1, 0), F = s.start, X = s.end;
      t(r.tr.step(new Ht(F - (a ? 3 : 1), X, F, X, c, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function Lf(e) {
  const { state: r, transaction: t } = e;
  let { selection: i } = t, { doc: n } = t, { storedMarks: s } = t;
  return {
    ...r,
    apply: r.apply.bind(r),
    applyTransaction: r.applyTransaction.bind(r),
    plugins: r.plugins,
    schema: r.schema,
    reconfigure: r.reconfigure.bind(r),
    toJSON: r.toJSON.bind(r),
    get storedMarks() {
      return s;
    },
    get selection() {
      return i;
    },
    get doc() {
      return n;
    },
    get tr() {
      return i = t.selection, n = t.doc, s = t.storedMarks, t;
    }
  };
}
class _f {
  constructor(r) {
    this.editor = r.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = r.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: r, editor: t, state: i } = this, { view: n } = t, { tr: s } = i, u = this.buildProps(s);
    return Object.fromEntries(Object.entries(r).map(([o, d]) => [o, (...V) => {
      const c = d(...V)(u);
      return !s.getMeta("preventDispatch") && !this.hasCustomState && n.dispatch(s), c;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(r, t = !0) {
    const { rawCommands: i, editor: n, state: s } = this, { view: u } = n, o = [], d = !!r, a = r || s.tr, V = () => (!d && t && !a.getMeta("preventDispatch") && !this.hasCustomState && u.dispatch(a), o.every((F) => F === !0)), c = {
      ...Object.fromEntries(Object.entries(i).map(([F, X]) => [F, (...q) => {
        const f = this.buildProps(a, t), p = X(...q)(f);
        return o.push(p), c;
      }])),
      run: V
    };
    return c;
  }
  createCan(r) {
    const { rawCommands: t, state: i } = this, n = !1, s = r || i.tr, u = this.buildProps(s, n);
    return {
      ...Object.fromEntries(Object.entries(t).map(([d, a]) => [d, (...V) => a(...V)({ ...u, dispatch: void 0 })])),
      chain: () => this.createChain(s, n)
    };
  }
  buildProps(r, t = !0) {
    const { rawCommands: i, editor: n, state: s } = this, { view: u } = n, o = {
      tr: r,
      editor: n,
      view: u,
      state: Lf({
        state: s,
        transaction: r
      }),
      dispatch: t ? () => {
      } : void 0,
      chain: () => this.createChain(r, t),
      can: () => this.createCan(r),
      get commands() {
        return Object.fromEntries(Object.entries(i).map(([d, a]) => [d, (...V) => a(...V)(o)]));
      }
    };
    return o;
  }
}
class Dze {
  constructor() {
    this.callbacks = {};
  }
  on(r, t) {
    return this.callbacks[r] || (this.callbacks[r] = []), this.callbacks[r].push(t), this;
  }
  emit(r, ...t) {
    const i = this.callbacks[r];
    return i && i.forEach((n) => n.apply(this, t)), this;
  }
  off(r, t) {
    const i = this.callbacks[r];
    return i && (t ? this.callbacks[r] = i.filter((n) => n !== t) : delete this.callbacks[r]), this;
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function Ce(e, r, t) {
  return e.config[r] === void 0 && e.parent ? Ce(e.parent, r, t) : typeof e.config[r] == "function" ? e.config[r].bind({
    ...t,
    parent: e.parent ? Ce(e.parent, r, t) : null
  }) : e.config[r];
}
function Hf(e) {
  const r = e.filter((n) => n.type === "extension"), t = e.filter((n) => n.type === "node"), i = e.filter((n) => n.type === "mark");
  return {
    baseExtensions: r,
    nodeExtensions: t,
    markExtensions: i
  };
}
function Iee(e) {
  const r = [], { nodeExtensions: t, markExtensions: i } = Hf(e), n = [...t, ...i], s = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return e.forEach((u) => {
    const o = {
      name: u.name,
      options: u.options,
      storage: u.storage,
      extensions: n
    }, d = Ce(u, "addGlobalAttributes", o);
    if (!d)
      return;
    d().forEach((V) => {
      V.types.forEach((c) => {
        Object.entries(V.attributes).forEach(([F, X]) => {
          r.push({
            type: c,
            name: F,
            attribute: {
              ...s,
              ...X
            }
          });
        });
      });
    });
  }), n.forEach((u) => {
    const o = {
      name: u.name,
      options: u.options,
      storage: u.storage
    }, d = Ce(u, "addAttributes", o);
    if (!d)
      return;
    const a = d();
    Object.entries(a).forEach(([V, c]) => {
      const F = {
        ...s,
        ...c
      };
      typeof (F == null ? void 0 : F.default) == "function" && (F.default = F.default()), F != null && F.isRequired && (F == null ? void 0 : F.default) === void 0 && delete F.default, r.push({
        type: u.name,
        name: V,
        attribute: F
      });
    });
  }), r;
}
function zt(e, r) {
  if (typeof e == "string") {
    if (!r.nodes[e])
      throw Error(`There is no node type named '${e}'. Maybe you forgot to add the extension?`);
    return r.nodes[e];
  }
  return e;
}
function Ti(...e) {
  return e.filter((r) => !!r).reduce((r, t) => {
    const i = { ...r };
    return Object.entries(t).forEach(([n, s]) => {
      if (!i[n]) {
        i[n] = s;
        return;
      }
      if (n === "class") {
        const o = s ? s.split(" ") : [], d = i[n] ? i[n].split(" ") : [], a = o.filter((V) => !d.includes(V));
        i[n] = [...d, ...a].join(" ");
      } else if (n === "style") {
        const o = s ? s.split(";").map((V) => V.trim()).filter(Boolean) : [], d = i[n] ? i[n].split(";").map((V) => V.trim()).filter(Boolean) : [], a = /* @__PURE__ */ new Map();
        d.forEach((V) => {
          const [c, F] = V.split(":").map((X) => X.trim());
          a.set(c, F);
        }), o.forEach((V) => {
          const [c, F] = V.split(":").map((X) => X.trim());
          a.set(c, F);
        }), i[n] = Array.from(a.entries()).map(([V, c]) => `${V}: ${c}`).join("; ");
      } else
        i[n] = s;
    }), i;
  }, {});
}
function dy(e, r) {
  return r.filter((t) => t.type === e.type.name).filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(e.attrs) || {} : {
    [t.name]: e.attrs[t.name]
  }).reduce((t, i) => Ti(t, i), {});
}
function Lee(e) {
  return typeof e == "function";
}
function Vr(e, r = void 0, ...t) {
  return Lee(e) ? r ? e.bind(r)(...t) : e(...t) : e;
}
function Rze(e = {}) {
  return Object.keys(e).length === 0 && e.constructor === Object;
}
function Ize(e) {
  return typeof e != "string" ? e : e.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(e) : e === "true" ? !0 : e === "false" ? !1 : e;
}
function lD(e, r) {
  return "style" in e ? e : {
    ...e,
    getAttrs: (t) => {
      const i = e.getAttrs ? e.getAttrs(t) : e.attrs;
      if (i === !1)
        return !1;
      const n = r.reduce((s, u) => {
        const o = u.attribute.parseHTML ? u.attribute.parseHTML(t) : Ize(t.getAttribute(u.name));
        return o == null ? s : {
          ...s,
          [u.name]: o
        };
      }, {});
      return { ...i, ...n };
    }
  };
}
function cD(e) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(e).filter(([r, t]) => r === "attrs" && Rze(t) ? !1 : t != null)
  );
}
function Lze(e, r) {
  var t;
  const i = Iee(e), { nodeExtensions: n, markExtensions: s } = Hf(e), u = (t = n.find((a) => Ce(a, "topNode"))) === null || t === void 0 ? void 0 : t.name, o = Object.fromEntries(n.map((a) => {
    const V = i.filter((p) => p.type === a.name), c = {
      name: a.name,
      options: a.options,
      storage: a.storage,
      editor: r
    }, F = e.reduce((p, m) => {
      const g = Ce(m, "extendNodeSchema", c);
      return {
        ...p,
        ...g ? g(a) : {}
      };
    }, {}), X = cD({
      ...F,
      content: Vr(Ce(a, "content", c)),
      marks: Vr(Ce(a, "marks", c)),
      group: Vr(Ce(a, "group", c)),
      inline: Vr(Ce(a, "inline", c)),
      atom: Vr(Ce(a, "atom", c)),
      selectable: Vr(Ce(a, "selectable", c)),
      draggable: Vr(Ce(a, "draggable", c)),
      code: Vr(Ce(a, "code", c)),
      whitespace: Vr(Ce(a, "whitespace", c)),
      defining: Vr(Ce(a, "defining", c)),
      isolating: Vr(Ce(a, "isolating", c)),
      attrs: Object.fromEntries(V.map((p) => {
        var m;
        return [p.name, { default: (m = p == null ? void 0 : p.attribute) === null || m === void 0 ? void 0 : m.default }];
      }))
    }), Y = Vr(Ce(a, "parseHTML", c));
    Y && (X.parseDOM = Y.map((p) => lD(p, V)));
    const q = Ce(a, "renderHTML", c);
    q && (X.toDOM = (p) => q({
      node: p,
      HTMLAttributes: dy(p, V)
    }));
    const f = Ce(a, "renderText", c);
    return f && (X.toText = f), [a.name, X];
  })), d = Object.fromEntries(s.map((a) => {
    const V = i.filter((f) => f.type === a.name), c = {
      name: a.name,
      options: a.options,
      storage: a.storage,
      editor: r
    }, F = e.reduce((f, p) => {
      const m = Ce(p, "extendMarkSchema", c);
      return {
        ...f,
        ...m ? m(a) : {}
      };
    }, {}), X = cD({
      ...F,
      inclusive: Vr(Ce(a, "inclusive", c)),
      excludes: Vr(Ce(a, "excludes", c)),
      group: Vr(Ce(a, "group", c)),
      spanning: Vr(Ce(a, "spanning", c)),
      code: Vr(Ce(a, "code", c)),
      attrs: Object.fromEntries(V.map((f) => {
        var p;
        return [f.name, { default: (p = f == null ? void 0 : f.attribute) === null || p === void 0 ? void 0 : p.default }];
      }))
    }), Y = Vr(Ce(a, "parseHTML", c));
    Y && (X.parseDOM = Y.map((f) => lD(f, V)));
    const q = Ce(a, "renderHTML", c);
    return q && (X.toDOM = (f) => q({
      mark: f,
      HTMLAttributes: dy(f, V)
    })), [a.name, X];
  }));
  return new P4({
    topNode: u,
    nodes: o,
    marks: d
  });
}
function Hg(e, r) {
  return r.nodes[e] || r.marks[e] || null;
}
function FD(e, r) {
  return Array.isArray(r) ? r.some((t) => (typeof t == "string" ? t : t.name) === e.name) : r;
}
const _ze = (e, r = 500) => {
  let t = "";
  const i = e.parentOffset;
  return e.parent.nodesBetween(Math.max(0, i - r), i, (n, s, u, o) => {
    var d, a;
    const V = ((a = (d = n.type.spec).toText) === null || a === void 0 ? void 0 : a.call(d, {
      node: n,
      pos: s,
      parent: u,
      index: o
    })) || n.textContent || "%leaf%";
    t += n.isAtom && !n.isText ? V : V.slice(0, Math.max(0, i - s));
  }), t;
};
function G4(e) {
  return Object.prototype.toString.call(e) === "[object RegExp]";
}
class jf {
  constructor(r) {
    this.find = r.find, this.handler = r.handler;
  }
}
const Hze = (e, r) => {
  if (G4(r))
    return r.exec(e);
  const t = r(e);
  if (!t)
    return null;
  const i = [t.text];
  return i.index = t.index, i.input = e, i.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), i.push(t.replaceWith)), i;
};
function Ax(e) {
  var r;
  const { editor: t, from: i, to: n, text: s, rules: u, plugin: o } = e, { view: d } = t;
  if (d.composing)
    return !1;
  const a = d.state.doc.resolve(i);
  if (
    // check for code node
    a.parent.type.spec.code || !((r = a.nodeBefore || a.nodeAfter) === null || r === void 0) && r.marks.find((F) => F.type.spec.code)
  )
    return !1;
  let V = !1;
  const c = _ze(a) + s;
  return u.forEach((F) => {
    if (V)
      return;
    const X = Hze(c, F.find);
    if (!X)
      return;
    const Y = d.state.tr, q = Lf({
      state: d.state,
      transaction: Y
    }), f = {
      from: i - (X[0].length - s.length),
      to: n
    }, { commands: p, chain: m, can: g } = new _f({
      editor: t,
      state: q
    });
    F.handler({
      state: q,
      range: f,
      match: X,
      commands: p,
      chain: m,
      can: g
    }) === null || !Y.steps.length || (Y.setMeta(o, {
      transform: Y,
      from: i,
      to: n,
      text: s
    }), d.dispatch(Y), V = !0);
  }), V;
}
function jze(e) {
  const { editor: r, rules: t } = e, i = new Ei({
    state: {
      init() {
        return null;
      },
      apply(n, s) {
        const u = n.getMeta(i);
        if (u)
          return u;
        const o = n.getMeta("applyInputRules");
        return !!o && setTimeout(() => {
          const { from: a, text: V } = o, c = a + V.length;
          Ax({
            editor: r,
            from: a,
            to: c,
            text: V,
            rules: t,
            plugin: i
          });
        }), n.selectionSet || n.docChanged ? null : s;
      }
    },
    props: {
      handleTextInput(n, s, u, o) {
        return Ax({
          editor: r,
          from: s,
          to: u,
          text: o,
          rules: t,
          plugin: i
        });
      },
      handleDOMEvents: {
        compositionend: (n) => (setTimeout(() => {
          const { $cursor: s } = n.state.selection;
          s && Ax({
            editor: r,
            from: s.pos,
            to: s.pos,
            text: "",
            rules: t,
            plugin: i
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(n, s) {
        if (s.key !== "Enter")
          return !1;
        const { $cursor: u } = n.state.selection;
        return u ? Ax({
          editor: r,
          from: u.pos,
          to: u.pos,
          text: `
`,
          rules: t,
          plugin: i
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return i;
}
function zze(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function wx(e) {
  return zze(e) !== "Object" ? !1 : e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function zf(e, r) {
  const t = { ...e };
  return wx(e) && wx(r) && Object.keys(r).forEach((i) => {
    wx(r[i]) && wx(e[i]) ? t[i] = zf(e[i], r[i]) : t[i] = r[i];
  }), t;
}
class Ui {
  constructor(r = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...r
    }, this.name = this.config.name, r.defaultOptions && Object.keys(r.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Vr(Ce(this, "addOptions", {
      name: this.name
    }))), this.storage = Vr(Ce(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(r = {}) {
    return new Ui(r);
  }
  configure(r = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => zf(this.options, r)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(r = {}) {
    const t = new Ui(r);
    return t.parent = this, this.child = t, t.name = r.name ? r.name : t.parent.name, r.defaultOptions && Object.keys(r.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = Vr(Ce(t, "addOptions", {
      name: t.name
    })), t.storage = Vr(Ce(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  static handleExit({ editor: r, mark: t }) {
    const { tr: i } = r.state, n = r.state.selection.$from;
    if (n.pos === n.end()) {
      const u = n.marks();
      if (!!!u.find((a) => (a == null ? void 0 : a.type.name) === t.name))
        return !1;
      const d = u.find((a) => (a == null ? void 0 : a.type.name) === t.name);
      return d && i.removeStoredMark(d), i.insertText(" ", n.pos), r.view.dispatch(i), !0;
    }
    return !1;
  }
}
function Bze(e) {
  return typeof e == "number";
}
class Wze {
  constructor(r) {
    this.find = r.find, this.handler = r.handler;
  }
}
const Gze = (e, r, t) => {
  if (G4(r))
    return [...e.matchAll(r)];
  const i = r(e, t);
  return i ? i.map((n) => {
    const s = [n.text];
    return s.index = n.index, s.input = e, s.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), s.push(n.replaceWith)), s;
  }) : [];
};
function Uze(e) {
  const { editor: r, state: t, from: i, to: n, rule: s, pasteEvent: u, dropEvent: o } = e, { commands: d, chain: a, can: V } = new _f({
    editor: r,
    state: t
  }), c = [];
  return t.doc.nodesBetween(i, n, (X, Y) => {
    if (!X.isTextblock || X.type.spec.code)
      return;
    const q = Math.max(i, Y), f = Math.min(n, Y + X.content.size), p = X.textBetween(q - Y, f - Y, void 0, "￼");
    Gze(p, s.find, u).forEach((g) => {
      if (g.index === void 0)
        return;
      const y = q + g.index + 1, b = y + g[0].length, A = {
        from: t.tr.mapping.map(y),
        to: t.tr.mapping.map(b)
      }, w = s.handler({
        state: t,
        range: A,
        match: g,
        commands: d,
        chain: a,
        can: V,
        pasteEvent: u,
        dropEvent: o
      });
      c.push(w);
    });
  }), c.every((X) => X !== null);
}
const Zze = (e) => {
  var r;
  const t = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (r = t.clipboardData) === null || r === void 0 || r.setData("text/html", e), t;
};
function Jze(e) {
  const { editor: r, rules: t } = e;
  let i = null, n = !1, s = !1, u = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, o = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  const d = ({ state: V, from: c, to: F, rule: X, pasteEvt: Y }) => {
    const q = V.tr, f = Lf({
      state: V,
      transaction: q
    });
    if (!(!Uze({
      editor: r,
      state: f,
      from: Math.max(c - 1, 0),
      to: F.b - 1,
      rule: X,
      pasteEvent: Y,
      dropEvent: o
    }) || !q.steps.length))
      return o = typeof DragEvent < "u" ? new DragEvent("drop") : null, u = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, q;
  };
  return t.map((V) => new Ei({
    // we register a global drag handler to track the current drag source element
    view(c) {
      const F = (X) => {
        var Y;
        i = !((Y = c.dom.parentElement) === null || Y === void 0) && Y.contains(X.target) ? c.dom.parentElement : null;
      };
      return window.addEventListener("dragstart", F), {
        destroy() {
          window.removeEventListener("dragstart", F);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (c, F) => (s = i === c.dom.parentElement, o = F, !1),
        paste: (c, F) => {
          var X;
          const Y = (X = F.clipboardData) === null || X === void 0 ? void 0 : X.getData("text/html");
          return u = F, n = !!(Y != null && Y.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (c, F, X) => {
      const Y = c[0], q = Y.getMeta("uiEvent") === "paste" && !n, f = Y.getMeta("uiEvent") === "drop" && !s, p = Y.getMeta("applyPasteRules"), m = !!p;
      if (!q && !f && !m)
        return;
      if (m) {
        const { from: b, text: A } = p, w = b + A.length, S = Zze(A);
        return d({
          rule: V,
          state: X,
          from: b,
          to: { b: w },
          pasteEvt: S
        });
      }
      const g = F.doc.content.findDiffStart(X.doc.content), y = F.doc.content.findDiffEnd(X.doc.content);
      if (!(!Bze(g) || !y || g === y.b))
        return d({
          rule: V,
          state: X,
          from: g,
          to: y,
          pasteEvt: u
        });
    }
  }));
}
function $ze(e) {
  const r = e.filter((t, i) => e.indexOf(t) !== i);
  return Array.from(new Set(r));
}
class oV {
  constructor(r, t) {
    this.splittableMarks = [], this.editor = t, this.extensions = oV.resolve(r), this.schema = Lze(this.extensions, t), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(r) {
    const t = oV.sort(oV.flatten(r)), i = $ze(t.map((n) => n.name));
    return i.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${i.map((n) => `'${n}'`).join(", ")}]. This can lead to issues.`), t;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(r) {
    return r.map((t) => {
      const i = {
        name: t.name,
        options: t.options,
        storage: t.storage
      }, n = Ce(t, "addExtensions", i);
      return n ? [t, ...this.flatten(n())] : t;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(r) {
    return r.sort((i, n) => {
      const s = Ce(i, "priority") || 100, u = Ce(n, "priority") || 100;
      return s > u ? -1 : s < u ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((r, t) => {
      const i = {
        name: t.name,
        options: t.options,
        storage: t.storage,
        editor: this.editor,
        type: Hg(t.name, this.schema)
      }, n = Ce(t, "addCommands", i);
      return n ? {
        ...r,
        ...n()
      } : r;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: r } = this, t = oV.sort([...this.extensions].reverse()), i = [], n = [], s = t.map((u) => {
      const o = {
        name: u.name,
        options: u.options,
        storage: u.storage,
        editor: r,
        type: Hg(u.name, this.schema)
      }, d = [], a = Ce(u, "addKeyboardShortcuts", o);
      let V = {};
      if (u.type === "mark" && Ce(u, "exitable", o) && (V.ArrowRight = () => Ui.handleExit({ editor: r, mark: u })), a) {
        const q = Object.fromEntries(Object.entries(a()).map(([f, p]) => [f, () => p({ editor: r })]));
        V = { ...V, ...q };
      }
      const c = fze(V);
      d.push(c);
      const F = Ce(u, "addInputRules", o);
      FD(u, r.options.enableInputRules) && F && i.push(...F());
      const X = Ce(u, "addPasteRules", o);
      FD(u, r.options.enablePasteRules) && X && n.push(...X());
      const Y = Ce(u, "addProseMirrorPlugins", o);
      if (Y) {
        const q = Y();
        d.push(...q);
      }
      return d;
    }).flat();
    return [
      jze({
        editor: r,
        rules: i
      }),
      ...Jze({
        editor: r,
        rules: n
      }),
      ...s
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return Iee(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: r } = this, { nodeExtensions: t } = Hf(this.extensions);
    return Object.fromEntries(t.filter((i) => !!Ce(i, "addNodeView")).map((i) => {
      const n = this.attributes.filter((d) => d.type === i.name), s = {
        name: i.name,
        options: i.options,
        storage: i.storage,
        editor: r,
        type: zt(i.name, this.schema)
      }, u = Ce(i, "addNodeView", s);
      if (!u)
        return [];
      const o = (d, a, V, c, F) => {
        const X = dy(d, n);
        return u()({
          // pass-through
          node: d,
          view: a,
          getPos: V,
          decorations: c,
          innerDecorations: F,
          // tiptap-specific
          editor: r,
          extension: i,
          HTMLAttributes: X
        });
      };
      return [i.name, o];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((r) => {
      var t;
      this.editor.extensionStorage[r.name] = r.storage;
      const i = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: this.editor,
        type: Hg(r.name, this.schema)
      };
      r.type === "mark" && (!((t = Vr(Ce(r, "keepOnSplit", i))) !== null && t !== void 0) || t) && this.splittableMarks.push(r.name);
      const n = Ce(r, "onBeforeCreate", i), s = Ce(r, "onCreate", i), u = Ce(r, "onUpdate", i), o = Ce(r, "onSelectionUpdate", i), d = Ce(r, "onTransaction", i), a = Ce(r, "onFocus", i), V = Ce(r, "onBlur", i), c = Ce(r, "onDestroy", i);
      n && this.editor.on("beforeCreate", n), s && this.editor.on("create", s), u && this.editor.on("update", u), o && this.editor.on("selectionUpdate", o), d && this.editor.on("transaction", d), a && this.editor.on("focus", a), V && this.editor.on("blur", V), c && this.editor.on("destroy", c);
    });
  }
}
class Bt {
  constructor(r = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...r
    }, this.name = this.config.name, r.defaultOptions && Object.keys(r.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Vr(Ce(this, "addOptions", {
      name: this.name
    }))), this.storage = Vr(Ce(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(r = {}) {
    return new Bt(r);
  }
  configure(r = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => zf(this.options, r)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(r = {}) {
    const t = new Bt({ ...this.config, ...r });
    return t.parent = this, this.child = t, t.name = r.name ? r.name : t.parent.name, r.defaultOptions && Object.keys(r.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = Vr(Ce(t, "addOptions", {
      name: t.name
    })), t.storage = Vr(Ce(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
function _ee(e, r, t) {
  const { from: i, to: n } = r, { blockSeparator: s = `

`, textSerializers: u = {} } = t || {};
  let o = "";
  return e.nodesBetween(i, n, (d, a, V, c) => {
    var F;
    d.isBlock && a > i && (o += s);
    const X = u == null ? void 0 : u[d.type.name];
    if (X)
      return V && (o += X({
        node: d,
        pos: a,
        parent: V,
        index: c,
        range: r
      })), !1;
    d.isText && (o += (F = d == null ? void 0 : d.text) === null || F === void 0 ? void 0 : F.slice(Math.max(i, a) - a, n - a));
  }), o;
}
function Hee(e) {
  return Object.fromEntries(Object.entries(e.nodes).filter(([, r]) => r.spec.toText).map(([r, t]) => [r, t.spec.toText]));
}
const jee = Bt.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Ei({
        key: new hs("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: e } = this, { state: r, schema: t } = e, { doc: i, selection: n } = r, { ranges: s } = n, u = Math.min(...s.map((V) => V.$from.pos)), o = Math.max(...s.map((V) => V.$to.pos)), d = Hee(t);
            return _ee(i, { from: u, to: o }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: d
            });
          }
        }
      })
    ];
  }
}), Qze = () => ({ editor: e, view: r }) => (requestAnimationFrame(() => {
  var t;
  e.isDestroyed || (r.dom.blur(), (t = window == null ? void 0 : window.getSelection()) === null || t === void 0 || t.removeAllRanges());
}), !0), eBe = (e = !1) => ({ commands: r }) => r.setContent("", e), rBe = () => ({ state: e, tr: r, dispatch: t }) => {
  const { selection: i } = r, { ranges: n } = i;
  return t && n.forEach(({ $from: s, $to: u }) => {
    e.doc.nodesBetween(s.pos, u.pos, (o, d) => {
      if (o.type.isText)
        return;
      const { doc: a, mapping: V } = r, c = a.resolve(V.map(d)), F = a.resolve(V.map(d + o.nodeSize)), X = c.blockRange(F);
      if (!X)
        return;
      const Y = Il(X);
      if (o.type.isTextblock) {
        const { defaultType: q } = c.parent.contentMatchAt(c.index());
        r.setNodeMarkup(X.start, q);
      }
      (Y || Y === 0) && r.lift(X, Y);
    });
  }), !0;
}, tBe = (e) => (r) => e(r), iBe = () => ({ state: e, dispatch: r }) => kee(e, r), nBe = (e, r) => ({ editor: t, tr: i }) => {
  const { state: n } = t, s = n.doc.slice(e.from, e.to);
  i.deleteRange(e.from, e.to);
  const u = i.mapping.map(r);
  return i.insert(u, s.content), i.setSelection(new Ze(i.doc.resolve(u - 1))), !0;
}, sBe = () => ({ tr: e, dispatch: r }) => {
  const { selection: t } = e, i = t.$anchor.node();
  if (i.content.size > 0)
    return !1;
  const n = e.selection.$anchor;
  for (let s = n.depth; s > 0; s -= 1)
    if (n.node(s).type === i.type) {
      if (r) {
        const o = n.before(s), d = n.after(s);
        e.delete(o, d).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, uBe = (e) => ({ tr: r, state: t, dispatch: i }) => {
  const n = zt(e, t.schema), s = r.selection.$anchor;
  for (let u = s.depth; u > 0; u -= 1)
    if (s.node(u).type === n) {
      if (i) {
        const d = s.before(u), a = s.after(u);
        r.delete(d, a).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, oBe = (e) => ({ tr: r, dispatch: t }) => {
  const { from: i, to: n } = e;
  return t && r.delete(i, n), !0;
}, dBe = () => ({ state: e, dispatch: r }) => H4(e, r), aBe = () => ({ commands: e }) => e.keyboardShortcut("Enter"), VBe = () => ({ state: e, dispatch: r }) => vze(e, r);
function Aq(e, r, t = { strict: !0 }) {
  const i = Object.keys(r);
  return i.length ? i.every((n) => t.strict ? r[n] === e[n] : G4(r[n]) ? r[n].test(e[n]) : r[n] === e[n]) : !0;
}
function ay(e, r, t = {}) {
  return e.find((i) => i.type === r && Aq(i.attrs, t));
}
function lBe(e, r, t = {}) {
  return !!ay(e, r, t);
}
function U4(e, r, t = {}) {
  if (!e || !r)
    return;
  let i = e.parent.childAfter(e.parentOffset);
  if ((!i.node || !i.node.marks.some((a) => a.type === r)) && (i = e.parent.childBefore(e.parentOffset)), !i.node || !i.node.marks.some((a) => a.type === r))
    return;
  const n = ay([...i.node.marks], r, t);
  if (!n)
    return;
  let s = i.index, u = e.start() + i.offset, o = s + 1, d = u + i.node.nodeSize;
  for (ay([...i.node.marks], r, t); s > 0 && n.isInSet(e.parent.child(s - 1).marks); )
    s -= 1, u -= e.parent.child(s).nodeSize;
  for (; o < e.parent.childCount && lBe([...e.parent.child(o).marks], r, t); )
    d += e.parent.child(o).nodeSize, o += 1;
  return {
    from: u,
    to: d
  };
}
function sd(e, r) {
  if (typeof e == "string") {
    if (!r.marks[e])
      throw Error(`There is no mark type named '${e}'. Maybe you forgot to add the extension?`);
    return r.marks[e];
  }
  return e;
}
const cBe = (e, r = {}) => ({ tr: t, state: i, dispatch: n }) => {
  const s = sd(e, i.schema), { doc: u, selection: o } = t, { $from: d, from: a, to: V } = o;
  if (n) {
    const c = U4(d, s, r);
    if (c && c.from <= a && c.to >= V) {
      const F = Ze.create(u, c.from, c.to);
      t.setSelection(F);
    }
  }
  return !0;
}, FBe = (e) => (r) => {
  const t = typeof e == "function" ? e(r) : e;
  for (let i = 0; i < t.length; i += 1)
    if (t[i](r))
      return !0;
  return !1;
};
function zee(e) {
  return e instanceof Ze;
}
function Td(e = 0, r = 0, t = 0) {
  return Math.min(Math.max(e, r), t);
}
function Bee(e, r = null) {
  if (!r)
    return null;
  const t = nr.atStart(e), i = nr.atEnd(e);
  if (r === "start" || r === !0)
    return t;
  if (r === "end")
    return i;
  const n = t.from, s = i.to;
  return r === "all" ? Ze.create(e, Td(0, n, s), Td(e.content.size, n, s)) : Ze.create(e, Td(r, n, s), Td(r, n, s));
}
function Z4() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const xBe = (e = null, r = {}) => ({ editor: t, view: i, tr: n, dispatch: s }) => {
  r = {
    scrollIntoView: !0,
    ...r
  };
  const u = () => {
    Z4() && i.dom.focus(), requestAnimationFrame(() => {
      t.isDestroyed || (i.focus(), r != null && r.scrollIntoView && t.commands.scrollIntoView());
    });
  };
  if (i.hasFocus() && e === null || e === !1)
    return !0;
  if (s && e === null && !zee(t.state.selection))
    return u(), !0;
  const o = Bee(n.doc, e) || t.state.selection, d = t.state.selection.eq(o);
  return s && (d || n.setSelection(o), d && n.storedMarks && n.setStoredMarks(n.storedMarks), u()), !0;
}, XBe = (e, r) => (t) => e.every((i, n) => r(i, { ...t, index: n })), qBe = (e, r) => ({ tr: t, commands: i }) => i.insertContentAt({ from: t.selection.from, to: t.selection.to }, e, r), Wee = (e) => {
  const r = e.childNodes;
  for (let t = r.length - 1; t >= 0; t -= 1) {
    const i = r[t];
    i.nodeType === 3 && i.nodeValue && /^(\n\s\s|\n)$/.test(i.nodeValue) ? e.removeChild(i) : i.nodeType === 1 && Wee(i);
  }
  return e;
};
function Cx(e) {
  const r = `<body>${e}</body>`, t = new window.DOMParser().parseFromString(r, "text/html").body;
  return Wee(t);
}
function wq(e, r, t) {
  t = {
    slice: !0,
    parseOptions: {},
    ...t
  };
  const i = typeof e == "object" && e !== null, n = typeof e == "string";
  if (i)
    try {
      if (Array.isArray(e) && e.length > 0)
        return Fe.fromArray(e.map((o) => r.nodeFromJSON(o)));
      const u = r.nodeFromJSON(e);
      return t.errorOnInvalidContent && u.check(), u;
    } catch (s) {
      if (t.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: s });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", s), wq("", r, t);
    }
  if (n) {
    if (t.errorOnInvalidContent) {
      let u = !1, o = "";
      const d = new P4({
        topNode: r.spec.topNode,
        marks: r.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: r.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (a) => (u = !0, o = typeof a == "string" ? a : a.outerHTML, null)
              }
            ]
          }
        })
      });
      if (t.slice ? Mu.fromSchema(d).parseSlice(Cx(e), t.parseOptions) : Mu.fromSchema(d).parse(Cx(e), t.parseOptions), t.errorOnInvalidContent && u)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${o}`) });
    }
    const s = Mu.fromSchema(r);
    return t.slice ? s.parseSlice(Cx(e), t.parseOptions).content : s.parse(Cx(e), t.parseOptions);
  }
  return wq("", r, t);
}
function YBe(e, r, t) {
  const i = e.steps.length - 1;
  if (i < r)
    return;
  const n = e.steps[i];
  if (!(n instanceof It || n instanceof Ht))
    return;
  const s = e.mapping.maps[i];
  let u = 0;
  s.forEach((o, d, a, V) => {
    u === 0 && (u = V);
  }), e.setSelection(nr.near(e.doc.resolve(u), t));
}
const fBe = (e) => !("type" in e), KBe = (e, r, t) => ({ tr: i, dispatch: n, editor: s }) => {
  var u;
  if (n) {
    t = {
      parseOptions: s.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...t
    };
    let o;
    try {
      o = wq(r, s.schema, {
        parseOptions: {
          preserveWhitespace: "full",
          ...t.parseOptions
        },
        errorOnInvalidContent: (u = t.errorOnInvalidContent) !== null && u !== void 0 ? u : s.options.enableContentCheck
      });
    } catch (Y) {
      return s.emit("contentError", {
        editor: s,
        error: Y,
        disableCollaboration: () => {
          s.storage.collaboration && (s.storage.collaboration.isDisabled = !0);
        }
      }), !1;
    }
    let { from: d, to: a } = typeof e == "number" ? { from: e, to: e } : { from: e.from, to: e.to }, V = !0, c = !0;
    if ((fBe(o) ? o : [o]).forEach((Y) => {
      Y.check(), V = V ? Y.isText && Y.marks.length === 0 : !1, c = c ? Y.isBlock : !1;
    }), d === a && c) {
      const { parent: Y } = i.doc.resolve(d);
      Y.isTextblock && !Y.type.spec.code && !Y.childCount && (d -= 1, a += 1);
    }
    let X;
    V ? (Array.isArray(r) ? X = r.map((Y) => Y.text || "").join("") : typeof r == "object" && r && r.text ? X = r.text : X = r, i.insertText(X, d, a)) : (X = o, i.replaceWith(d, a, X)), t.updateSelection && YBe(i, i.steps.length - 1, -1), t.applyInputRules && i.setMeta("applyInputRules", { from: d, text: X }), t.applyPasteRules && i.setMeta("applyPasteRules", { from: d, text: X });
  }
  return !0;
}, hBe = () => ({ state: e, dispatch: r }) => pze(e, r), pBe = () => ({ state: e, dispatch: r }) => mze(e, r), mBe = () => ({ state: e, dispatch: r }) => Cee(e, r), gBe = () => ({ state: e, dispatch: r }) => Mee(e, r), vBe = () => ({ state: e, dispatch: r, tr: t }) => {
  try {
    const i = Ef(e.doc, e.selection.$from.pos, -1);
    return i == null ? !1 : (t.join(i, 2), r && r(t), !0);
  } catch {
    return !1;
  }
}, bBe = () => ({ state: e, dispatch: r, tr: t }) => {
  try {
    const i = Ef(e.doc, e.selection.$from.pos, 1);
    return i == null ? !1 : (t.join(i, 2), r && r(t), !0);
  } catch {
    return !1;
  }
}, yBe = () => ({ state: e, dispatch: r }) => Kze(e, r), ABe = () => ({ state: e, dispatch: r }) => hze(e, r);
function Gee() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function wBe(e) {
  const r = e.split(/-(?!$)/);
  let t = r[r.length - 1];
  t === "Space" && (t = " ");
  let i, n, s, u;
  for (let o = 0; o < r.length - 1; o += 1) {
    const d = r[o];
    if (/^(cmd|meta|m)$/i.test(d))
      u = !0;
    else if (/^a(lt)?$/i.test(d))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(d))
      n = !0;
    else if (/^s(hift)?$/i.test(d))
      s = !0;
    else if (/^mod$/i.test(d))
      Z4() || Gee() ? u = !0 : n = !0;
    else
      throw new Error(`Unrecognized modifier name: ${d}`);
  }
  return i && (t = `Alt-${t}`), n && (t = `Ctrl-${t}`), u && (t = `Meta-${t}`), s && (t = `Shift-${t}`), t;
}
const CBe = (e) => ({ editor: r, view: t, tr: i, dispatch: n }) => {
  const s = wBe(e).split(/-(?!$)/), u = s.find((a) => !["Alt", "Ctrl", "Meta", "Shift"].includes(a)), o = new KeyboardEvent("keydown", {
    key: u === "Space" ? " " : u,
    altKey: s.includes("Alt"),
    ctrlKey: s.includes("Ctrl"),
    metaKey: s.includes("Meta"),
    shiftKey: s.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), d = r.captureTransaction(() => {
    t.someProp("handleKeyDown", (a) => a(t, o));
  });
  return d == null || d.steps.forEach((a) => {
    const V = a.map(i.mapping);
    V && n && i.maybeStep(V);
  }), !0;
};
function W7(e, r, t = {}) {
  const { from: i, to: n, empty: s } = e.selection, u = r ? zt(r, e.schema) : null, o = [];
  e.doc.nodesBetween(i, n, (c, F) => {
    if (c.isText)
      return;
    const X = Math.max(i, F), Y = Math.min(n, F + c.nodeSize);
    o.push({
      node: c,
      from: X,
      to: Y
    });
  });
  const d = n - i, a = o.filter((c) => u ? u.name === c.node.type.name : !0).filter((c) => Aq(c.node.attrs, t, { strict: !1 }));
  return s ? !!a.length : a.reduce((c, F) => c + F.to - F.from, 0) >= d;
}
const PBe = (e, r = {}) => ({ state: t, dispatch: i }) => {
  const n = zt(e, t.schema);
  return W7(t, n, r) ? gze(t, i) : !1;
}, SBe = () => ({ state: e, dispatch: r }) => Oee(e, r), NBe = (e) => ({ state: r, dispatch: t }) => {
  const i = zt(e, r.schema);
  return Tze(i)(r, t);
}, MBe = () => ({ state: e, dispatch: r }) => Eee(e, r);
function Bf(e, r) {
  return r.nodes[e] ? "node" : r.marks[e] ? "mark" : null;
}
function xD(e, r) {
  const t = typeof r == "string" ? [r] : r;
  return Object.keys(e).reduce((i, n) => (t.includes(n) || (i[n] = e[n]), i), {});
}
const TBe = (e, r) => ({ tr: t, state: i, dispatch: n }) => {
  let s = null, u = null;
  const o = Bf(typeof e == "string" ? e : e.name, i.schema);
  return o ? (o === "node" && (s = zt(e, i.schema)), o === "mark" && (u = sd(e, i.schema)), n && t.selection.ranges.forEach((d) => {
    i.doc.nodesBetween(d.$from.pos, d.$to.pos, (a, V) => {
      s && s === a.type && t.setNodeMarkup(V, void 0, xD(a.attrs, r)), u && a.marks.length && a.marks.forEach((c) => {
        u === c.type && t.addMark(V, V + a.nodeSize, u.create(xD(c.attrs, r)));
      });
    });
  }), !0) : !1;
}, EBe = () => ({ tr: e, dispatch: r }) => (r && e.scrollIntoView(), !0), kBe = () => ({ tr: e, commands: r }) => r.setTextSelection({
  from: 0,
  to: e.doc.content.size
}), OBe = () => ({ state: e, dispatch: r }) => See(e, r), DBe = () => ({ state: e, dispatch: r }) => Tee(e, r), RBe = () => ({ state: e, dispatch: r }) => Aze(e, r), IBe = () => ({ state: e, dispatch: r }) => Pze(e, r), LBe = () => ({ state: e, dispatch: r }) => Cze(e, r);
function Vy(e, r, t = {}, i = {}) {
  return wq(e, r, {
    slice: !1,
    parseOptions: t,
    errorOnInvalidContent: i.errorOnInvalidContent
  });
}
const _Be = (e, r = !1, t = {}, i = {}) => ({ editor: n, tr: s, dispatch: u, commands: o }) => {
  var d, a;
  const { doc: V } = s;
  if (t.preserveWhitespace !== "full") {
    const c = Vy(e, n.schema, t, {
      errorOnInvalidContent: (d = i.errorOnInvalidContent) !== null && d !== void 0 ? d : n.options.enableContentCheck
    });
    return u && s.replaceWith(0, V.content.size, c).setMeta("preventUpdate", !r), !0;
  }
  return u && s.setMeta("preventUpdate", !r), o.insertContentAt({ from: 0, to: V.content.size }, e, {
    parseOptions: t,
    errorOnInvalidContent: (a = i.errorOnInvalidContent) !== null && a !== void 0 ? a : n.options.enableContentCheck
  });
};
function Uee(e, r) {
  const t = sd(r, e.schema), { from: i, to: n, empty: s } = e.selection, u = [];
  s ? (e.storedMarks && u.push(...e.storedMarks), u.push(...e.selection.$head.marks())) : e.doc.nodesBetween(i, n, (d) => {
    u.push(...d.marks);
  });
  const o = u.find((d) => d.type.name === t.name);
  return o ? { ...o.attrs } : {};
}
function HBe(e) {
  for (let r = 0; r < e.edgeCount; r += 1) {
    const { type: t } = e.edge(r);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function jBe(e, r) {
  for (let t = e.depth; t > 0; t -= 1) {
    const i = e.node(t);
    if (r(i))
      return {
        pos: t > 0 ? e.before(t) : 0,
        start: e.start(t),
        depth: t,
        node: i
      };
  }
}
function J4(e) {
  return (r) => jBe(r.$from, e);
}
function $4(e, r) {
  const t = qa.fromSchema(r).serializeFragment(e), n = document.implementation.createHTMLDocument().createElement("div");
  return n.appendChild(t), n.innerHTML;
}
function zBe(e, r) {
  const t = {
    from: 0,
    to: e.content.size
  };
  return _ee(e, t, r);
}
function BBe(e, r) {
  const t = zt(r, e.schema), { from: i, to: n } = e.selection, s = [];
  e.doc.nodesBetween(i, n, (o) => {
    s.push(o);
  });
  const u = s.reverse().find((o) => o.type.name === t.name);
  return u ? { ...u.attrs } : {};
}
function WBe(e, r) {
  const t = Bf(typeof r == "string" ? r : r.name, e.schema);
  return t === "node" ? BBe(e, r) : t === "mark" ? Uee(e, r) : {};
}
function Zee(e, r, t) {
  const i = [];
  return e === r ? t.resolve(e).marks().forEach((n) => {
    const s = t.resolve(e), u = U4(s, n.type);
    u && i.push({
      mark: n,
      ...u
    });
  }) : t.nodesBetween(e, r, (n, s) => {
    !n || (n == null ? void 0 : n.nodeSize) === void 0 || i.push(...n.marks.map((u) => ({
      from: s,
      to: s + n.nodeSize,
      mark: u
    })));
  }), i;
}
function Gx(e, r, t) {
  return Object.fromEntries(Object.entries(t).filter(([i]) => {
    const n = e.find((s) => s.type === r && s.name === i);
    return n ? n.attribute.keepOnSplit : !1;
  }));
}
function ly(e, r, t = {}) {
  const { empty: i, ranges: n } = e.selection, s = r ? sd(r, e.schema) : null;
  if (i)
    return !!(e.storedMarks || e.selection.$from.marks()).filter((c) => s ? s.name === c.type.name : !0).find((c) => Aq(c.attrs, t, { strict: !1 }));
  let u = 0;
  const o = [];
  if (n.forEach(({ $from: c, $to: F }) => {
    const X = c.pos, Y = F.pos;
    e.doc.nodesBetween(X, Y, (q, f) => {
      if (!q.isText && !q.marks.length)
        return;
      const p = Math.max(X, f), m = Math.min(Y, f + q.nodeSize), g = m - p;
      u += g, o.push(...q.marks.map((y) => ({
        mark: y,
        from: p,
        to: m
      })));
    });
  }), u === 0)
    return !1;
  const d = o.filter((c) => s ? s.name === c.mark.type.name : !0).filter((c) => Aq(c.mark.attrs, t, { strict: !1 })).reduce((c, F) => c + F.to - F.from, 0), a = o.filter((c) => s ? c.mark.type !== s && c.mark.type.excludes(s) : !0).reduce((c, F) => c + F.to - F.from, 0);
  return (d > 0 ? d + a : d) >= u;
}
function GBe(e, r, t = {}) {
  if (!r)
    return W7(e, null, t) || ly(e, null, t);
  const i = Bf(r, e.schema);
  return i === "node" ? W7(e, r, t) : i === "mark" ? ly(e, r, t) : !1;
}
function XD(e, r) {
  const { nodeExtensions: t } = Hf(r), i = t.find((u) => u.name === e);
  if (!i)
    return !1;
  const n = {
    name: i.name,
    options: i.options,
    storage: i.storage
  }, s = Vr(Ce(i, "group", n));
  return typeof s != "string" ? !1 : s.split(" ").includes("list");
}
function Q4(e, { checkChildren: r = !0, ignoreWhitespace: t = !1 } = {}) {
  var i;
  if (t) {
    if (e.type.name === "hardBreak")
      return !0;
    if (e.isText)
      return /^\s*$/m.test((i = e.text) !== null && i !== void 0 ? i : "");
  }
  if (e.isText)
    return !e.text;
  if (e.isAtom || e.isLeaf)
    return !1;
  if (e.content.childCount === 0)
    return !0;
  if (r) {
    let n = !0;
    return e.content.forEach((s) => {
      n !== !1 && (Q4(s, { ignoreWhitespace: t, checkChildren: r }) || (n = !1));
    }), n;
  }
  return !1;
}
function UBe(e) {
  return e instanceof ke;
}
function ZBe(e, r, t) {
  var i;
  const { selection: n } = r;
  let s = null;
  if (zee(n) && (s = n.$cursor), s) {
    const o = (i = e.storedMarks) !== null && i !== void 0 ? i : s.marks();
    return !!t.isInSet(o) || !o.some((d) => d.type.excludes(t));
  }
  const { ranges: u } = n;
  return u.some(({ $from: o, $to: d }) => {
    let a = o.depth === 0 ? e.doc.inlineContent && e.doc.type.allowsMarkType(t) : !1;
    return e.doc.nodesBetween(o.pos, d.pos, (V, c, F) => {
      if (a)
        return !1;
      if (V.isInline) {
        const X = !F || F.type.allowsMarkType(t), Y = !!t.isInSet(V.marks) || !V.marks.some((q) => q.type.excludes(t));
        a = X && Y;
      }
      return !a;
    }), a;
  });
}
const JBe = (e, r = {}) => ({ tr: t, state: i, dispatch: n }) => {
  const { selection: s } = t, { empty: u, ranges: o } = s, d = sd(e, i.schema);
  if (n)
    if (u) {
      const a = Uee(i, d);
      t.addStoredMark(d.create({
        ...a,
        ...r
      }));
    } else
      o.forEach((a) => {
        const V = a.$from.pos, c = a.$to.pos;
        i.doc.nodesBetween(V, c, (F, X) => {
          const Y = Math.max(X, V), q = Math.min(X + F.nodeSize, c);
          F.marks.find((p) => p.type === d) ? F.marks.forEach((p) => {
            d === p.type && t.addMark(Y, q, d.create({
              ...p.attrs,
              ...r
            }));
          }) : t.addMark(Y, q, d.create(r));
        });
      });
  return ZBe(i, t, d);
}, $Be = (e, r) => ({ tr: t }) => (t.setMeta(e, r), !0), QBe = (e, r = {}) => ({ state: t, dispatch: i, chain: n }) => {
  const s = zt(e, t.schema);
  return s.isTextblock ? n().command(({ commands: u }) => VD(s, r)(t) ? !0 : u.clearNodes()).command(({ state: u }) => VD(s, r)(u, i)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, eWe = (e) => ({ tr: r, dispatch: t }) => {
  if (t) {
    const { doc: i } = r, n = Td(e, 0, i.content.size), s = ke.create(i, n);
    r.setSelection(s);
  }
  return !0;
}, rWe = (e) => ({ tr: r, dispatch: t }) => {
  if (t) {
    const { doc: i } = r, { from: n, to: s } = typeof e == "number" ? { from: e, to: e } : e, u = Ze.atStart(i).from, o = Ze.atEnd(i).to, d = Td(n, u, o), a = Td(s, u, o), V = Ze.create(i, d, a);
    r.setSelection(V);
  }
  return !0;
}, tWe = (e) => ({ state: r, dispatch: t }) => {
  const i = zt(e, r.schema);
  return Oze(i)(r, t);
};
function qD(e, r) {
  const t = e.storedMarks || e.selection.$to.parentOffset && e.selection.$from.marks();
  if (t) {
    const i = t.filter((n) => r == null ? void 0 : r.includes(n.type.name));
    e.tr.ensureMarks(i);
  }
}
const iWe = ({ keepMarks: e = !0 } = {}) => ({ tr: r, state: t, dispatch: i, editor: n }) => {
  const { selection: s, doc: u } = r, { $from: o, $to: d } = s, a = n.extensionManager.attributes, V = Gx(a, o.node().type.name, o.node().attrs);
  if (s instanceof ke && s.node.isBlock)
    return !o.parentOffset || !Tu(u, o.pos) ? !1 : (i && (e && qD(t, n.extensionManager.splittableMarks), r.split(o.pos).scrollIntoView()), !0);
  if (!o.parent.isBlock)
    return !1;
  const c = d.parentOffset === d.parent.content.size, F = o.depth === 0 ? void 0 : HBe(o.node(-1).contentMatchAt(o.indexAfter(-1)));
  let X = c && F ? [
    {
      type: F,
      attrs: V
    }
  ] : void 0, Y = Tu(r.doc, r.mapping.map(o.pos), 1, X);
  if (!X && !Y && Tu(r.doc, r.mapping.map(o.pos), 1, F ? [{ type: F }] : void 0) && (Y = !0, X = F ? [
    {
      type: F,
      attrs: V
    }
  ] : void 0), i) {
    if (Y && (s instanceof Ze && r.deleteSelection(), r.split(r.mapping.map(o.pos), 1, X), F && !c && !o.parentOffset && o.parent.type !== F)) {
      const q = r.mapping.map(o.before()), f = r.doc.resolve(q);
      o.node(-1).canReplaceWith(f.index(), f.index() + 1, F) && r.setNodeMarkup(r.mapping.map(o.before()), F);
    }
    e && qD(t, n.extensionManager.splittableMarks), r.scrollIntoView();
  }
  return Y;
}, nWe = (e, r = {}) => ({ tr: t, state: i, dispatch: n, editor: s }) => {
  var u;
  const o = zt(e, i.schema), { $from: d, $to: a } = i.selection, V = i.selection.node;
  if (V && V.isBlock || d.depth < 2 || !d.sameParent(a))
    return !1;
  const c = d.node(-1);
  if (c.type !== o)
    return !1;
  const F = s.extensionManager.attributes;
  if (d.parent.content.size === 0 && d.node(-1).childCount === d.indexAfter(-1)) {
    if (d.depth === 2 || d.node(-3).type !== o || d.index(-2) !== d.node(-2).childCount - 1)
      return !1;
    if (n) {
      let p = Fe.empty;
      const m = d.index(-1) ? 1 : d.index(-2) ? 2 : 3;
      for (let S = d.depth - m; S >= d.depth - 3; S -= 1)
        p = Fe.from(d.node(S).copy(p));
      const g = d.indexAfter(-1) < d.node(-2).childCount ? 1 : d.indexAfter(-2) < d.node(-3).childCount ? 2 : 3, y = {
        ...Gx(F, d.node().type.name, d.node().attrs),
        ...r
      }, b = ((u = o.contentMatch.defaultType) === null || u === void 0 ? void 0 : u.createAndFill(y)) || void 0;
      p = p.append(Fe.from(o.createAndFill(null, b) || void 0));
      const A = d.before(d.depth - (m - 1));
      t.replace(A, d.after(-g), new ve(p, 4 - m, 0));
      let w = -1;
      t.doc.nodesBetween(A, t.doc.content.size, (S, N) => {
        if (w > -1)
          return !1;
        S.isTextblock && S.content.size === 0 && (w = N + 1);
      }), w > -1 && t.setSelection(Ze.near(t.doc.resolve(w))), t.scrollIntoView();
    }
    return !0;
  }
  const X = a.pos === d.end() ? c.contentMatchAt(0).defaultType : null, Y = {
    ...Gx(F, c.type.name, c.attrs),
    ...r
  }, q = {
    ...Gx(F, d.node().type.name, d.node().attrs),
    ...r
  };
  t.delete(d.pos, a.pos);
  const f = X ? [
    { type: o, attrs: Y },
    { type: X, attrs: q }
  ] : [{ type: o, attrs: Y }];
  if (!Tu(t.doc, d.pos, 2))
    return !1;
  if (n) {
    const { selection: p, storedMarks: m } = i, { splittableMarks: g } = s.extensionManager, y = m || p.$to.parentOffset && p.$from.marks();
    if (t.split(d.pos, 2, f).scrollIntoView(), !y || !n)
      return !0;
    const b = y.filter((A) => g.includes(A.type.name));
    t.ensureMarks(b);
  }
  return !0;
}, jg = (e, r) => {
  const t = J4((u) => u.type === r)(e.selection);
  if (!t)
    return !0;
  const i = e.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (i === void 0)
    return !0;
  const n = e.doc.nodeAt(i);
  return t.node.type === (n == null ? void 0 : n.type) && id(e.doc, t.pos) && e.join(t.pos), !0;
}, zg = (e, r) => {
  const t = J4((u) => u.type === r)(e.selection);
  if (!t)
    return !0;
  const i = e.doc.resolve(t.start).after(t.depth);
  if (i === void 0)
    return !0;
  const n = e.doc.nodeAt(i);
  return t.node.type === (n == null ? void 0 : n.type) && id(e.doc, i) && e.join(i), !0;
}, sWe = (e, r, t, i = {}) => ({ editor: n, tr: s, state: u, dispatch: o, chain: d, commands: a, can: V }) => {
  const { extensions: c, splittableMarks: F } = n.extensionManager, X = zt(e, u.schema), Y = zt(r, u.schema), { selection: q, storedMarks: f } = u, { $from: p, $to: m } = q, g = p.blockRange(m), y = f || q.$to.parentOffset && q.$from.marks();
  if (!g)
    return !1;
  const b = J4((A) => XD(A.type.name, c))(q);
  if (g.depth >= 1 && b && g.depth - b.depth <= 1) {
    if (b.node.type === X)
      return a.liftListItem(Y);
    if (XD(b.node.type.name, c) && X.validContent(b.node.content) && o)
      return d().command(() => (s.setNodeMarkup(b.pos, X), !0)).command(() => jg(s, X)).command(() => zg(s, X)).run();
  }
  return !t || !y || !o ? d().command(() => V().wrapInList(X, i) ? !0 : a.clearNodes()).wrapInList(X, i).command(() => jg(s, X)).command(() => zg(s, X)).run() : d().command(() => {
    const A = V().wrapInList(X, i), w = y.filter((S) => F.includes(S.type.name));
    return s.ensureMarks(w), A ? !0 : a.clearNodes();
  }).wrapInList(X, i).command(() => jg(s, X)).command(() => zg(s, X)).run();
}, uWe = (e, r = {}, t = {}) => ({ state: i, commands: n }) => {
  const { extendEmptyMarkRange: s = !1 } = t, u = sd(e, i.schema);
  return ly(i, u, r) ? n.unsetMark(u, { extendEmptyMarkRange: s }) : n.setMark(u, r);
}, oWe = (e, r, t = {}) => ({ state: i, commands: n }) => {
  const s = zt(e, i.schema), u = zt(r, i.schema), o = W7(i, s, t);
  let d;
  return i.selection.$anchor.sameParent(i.selection.$head) && (d = i.selection.$anchor.parent.attrs), o ? n.setNode(u, d) : n.setNode(s, { ...d, ...t });
}, dWe = (e, r = {}) => ({ state: t, commands: i }) => {
  const n = zt(e, t.schema);
  return W7(t, n, r) ? i.lift(n) : i.wrapIn(n, r);
}, aWe = () => ({ state: e, dispatch: r }) => {
  const t = e.plugins;
  for (let i = 0; i < t.length; i += 1) {
    const n = t[i];
    let s;
    if (n.spec.isInputRules && (s = n.getState(e))) {
      if (r) {
        const u = e.tr, o = s.transform;
        for (let d = o.steps.length - 1; d >= 0; d -= 1)
          u.step(o.steps[d].invert(o.docs[d]));
        if (s.text) {
          const d = u.doc.resolve(s.from).marks();
          u.replaceWith(s.from, s.to, e.schema.text(s.text, d));
        } else
          u.delete(s.from, s.to);
      }
      return !0;
    }
  }
  return !1;
}, VWe = () => ({ tr: e, dispatch: r }) => {
  const { selection: t } = e, { empty: i, ranges: n } = t;
  return i || r && n.forEach((s) => {
    e.removeMark(s.$from.pos, s.$to.pos);
  }), !0;
}, lWe = (e, r = {}) => ({ tr: t, state: i, dispatch: n }) => {
  var s;
  const { extendEmptyMarkRange: u = !1 } = r, { selection: o } = t, d = sd(e, i.schema), { $from: a, empty: V, ranges: c } = o;
  if (!n)
    return !0;
  if (V && u) {
    let { from: F, to: X } = o;
    const Y = (s = a.marks().find((f) => f.type === d)) === null || s === void 0 ? void 0 : s.attrs, q = U4(a, d, Y);
    q && (F = q.from, X = q.to), t.removeMark(F, X, d);
  } else
    c.forEach((F) => {
      t.removeMark(F.$from.pos, F.$to.pos, d);
    });
  return t.removeStoredMark(d), !0;
}, cWe = (e, r = {}) => ({ tr: t, state: i, dispatch: n }) => {
  let s = null, u = null;
  const o = Bf(typeof e == "string" ? e : e.name, i.schema);
  return o ? (o === "node" && (s = zt(e, i.schema)), o === "mark" && (u = sd(e, i.schema)), n && t.selection.ranges.forEach((d) => {
    const a = d.$from.pos, V = d.$to.pos;
    i.doc.nodesBetween(a, V, (c, F) => {
      s && s === c.type && t.setNodeMarkup(F, void 0, {
        ...c.attrs,
        ...r
      }), u && c.marks.length && c.marks.forEach((X) => {
        if (u === X.type) {
          const Y = Math.max(F, a), q = Math.min(F + c.nodeSize, V);
          t.addMark(Y, q, u.create({
            ...X.attrs,
            ...r
          }));
        }
      });
    });
  }), !0) : !1;
}, FWe = (e, r = {}) => ({ state: t, dispatch: i }) => {
  const n = zt(e, t.schema);
  return Sze(n, r)(t, i);
}, xWe = (e, r = {}) => ({ state: t, dispatch: i }) => {
  const n = zt(e, t.schema);
  return Nze(n, r)(t, i);
};
var XWe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: Qze,
  clearContent: eBe,
  clearNodes: rBe,
  command: tBe,
  createParagraphNear: iBe,
  cut: nBe,
  deleteCurrentNode: sBe,
  deleteNode: uBe,
  deleteRange: oBe,
  deleteSelection: dBe,
  enter: aBe,
  exitCode: VBe,
  extendMarkRange: cBe,
  first: FBe,
  focus: xBe,
  forEach: XBe,
  insertContent: qBe,
  insertContentAt: KBe,
  joinBackward: mBe,
  joinDown: pBe,
  joinForward: gBe,
  joinItemBackward: vBe,
  joinItemForward: bBe,
  joinTextblockBackward: yBe,
  joinTextblockForward: ABe,
  joinUp: hBe,
  keyboardShortcut: CBe,
  lift: PBe,
  liftEmptyBlock: SBe,
  liftListItem: NBe,
  newlineInCode: MBe,
  resetAttributes: TBe,
  scrollIntoView: EBe,
  selectAll: kBe,
  selectNodeBackward: OBe,
  selectNodeForward: DBe,
  selectParentNode: RBe,
  selectTextblockEnd: IBe,
  selectTextblockStart: LBe,
  setContent: _Be,
  setMark: JBe,
  setMeta: $Be,
  setNode: QBe,
  setNodeSelection: eWe,
  setTextSelection: rWe,
  sinkListItem: tWe,
  splitBlock: iWe,
  splitListItem: nWe,
  toggleList: sWe,
  toggleMark: uWe,
  toggleNode: oWe,
  toggleWrap: dWe,
  undoInputRule: aWe,
  unsetAllMarks: VWe,
  unsetMark: lWe,
  updateAttributes: cWe,
  wrapIn: FWe,
  wrapInList: xWe
});
const Jee = Bt.create({
  name: "commands",
  addCommands() {
    return {
      ...XWe
    };
  }
}), $ee = Bt.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Ei({
        key: new hs("tiptapDrop"),
        props: {
          handleDrop: (e, r, t, i) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: r,
              slice: t,
              moved: i
            });
          }
        }
      })
    ];
  }
}), Qee = Bt.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Ei({
        key: new hs("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), ere = Bt.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: e } = this;
    return [
      new Ei({
        key: new hs("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (r, t) => {
              e.isFocused = !0;
              const i = e.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return r.dispatch(i), !1;
            },
            blur: (r, t) => {
              e.isFocused = !1;
              const i = e.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return r.dispatch(i), !1;
            }
          }
        }
      })
    ];
  }
}), rre = Bt.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const e = () => this.editor.commands.first(({ commands: u }) => [
      () => u.undoInputRule(),
      // maybe convert first text block node to default node
      () => u.command(({ tr: o }) => {
        const { selection: d, doc: a } = o, { empty: V, $anchor: c } = d, { pos: F, parent: X } = c, Y = c.parent.isTextblock && F > 0 ? o.doc.resolve(F - 1) : c, q = Y.parent.type.spec.isolating, f = c.pos - c.parentOffset, p = q && Y.parent.childCount === 1 ? f === c.pos : nr.atStart(a).from === F;
        return !V || !X.type.isTextblock || X.textContent.length || !p || p && c.parent.type.name === "paragraph" ? !1 : u.clearNodes();
      }),
      () => u.deleteSelection(),
      () => u.joinBackward(),
      () => u.selectNodeBackward()
    ]), r = () => this.editor.commands.first(({ commands: u }) => [
      () => u.deleteSelection(),
      () => u.deleteCurrentNode(),
      () => u.joinForward(),
      () => u.selectNodeForward()
    ]), i = {
      Enter: () => this.editor.commands.first(({ commands: u }) => [
        () => u.newlineInCode(),
        () => u.createParagraphNear(),
        () => u.liftEmptyBlock(),
        () => u.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: e,
      "Mod-Backspace": e,
      "Shift-Backspace": e,
      Delete: r,
      "Mod-Delete": r,
      "Mod-a": () => this.editor.commands.selectAll()
    }, n = {
      ...i
    }, s = {
      ...i,
      "Ctrl-h": e,
      "Alt-Backspace": e,
      "Ctrl-d": r,
      "Ctrl-Alt-Backspace": r,
      "Alt-Delete": r,
      "Alt-d": r,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return Z4() || Gee() ? s : n;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Ei({
        key: new hs("clearDocument"),
        appendTransaction: (e, r, t) => {
          const i = e.some((q) => q.docChanged) && !r.doc.eq(t.doc), n = e.some((q) => q.getMeta("preventClearDocument"));
          if (!i || n)
            return;
          const { empty: s, from: u, to: o } = r.selection, d = nr.atStart(r.doc).from, a = nr.atEnd(r.doc).to;
          if (s || !(u === d && o === a) || !Q4(t.doc))
            return;
          const F = t.tr, X = Lf({
            state: t,
            transaction: F
          }), { commands: Y } = new _f({
            editor: this.editor,
            state: X
          });
          if (Y.clearNodes(), !!F.steps.length)
            return F;
        }
      })
    ];
  }
}), tre = Bt.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Ei({
        key: new hs("tiptapPaste"),
        props: {
          handlePaste: (e, r, t) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: r,
              slice: t
            });
          }
        }
      })
    ];
  }
}), ire = Bt.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new Ei({
        key: new hs("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
var qWe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ClipboardTextSerializer: jee,
  Commands: Jee,
  Drop: $ee,
  Editable: Qee,
  FocusEvents: ere,
  Keymap: rre,
  Paste: tre,
  Tabindex: ire
});
class vd {
  get name() {
    return this.node.type.name;
  }
  constructor(r, t, i = !1, n = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = i, this.resolvedPos = r, this.editor = t, this.currentNode = n;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var r;
    return (r = this.actualDepth) !== null && r !== void 0 ? r : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(r) {
    let t = this.from, i = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      t = this.from + 1, i = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: t, to: i }, r);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const r = this.resolvedPos.start(this.resolvedPos.depth - 1), t = this.resolvedPos.doc.resolve(r);
    return new vd(t, this.editor);
  }
  get before() {
    let r = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return r.depth !== this.depth && (r = this.resolvedPos.doc.resolve(this.from - 3)), new vd(r, this.editor);
  }
  get after() {
    let r = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return r.depth !== this.depth && (r = this.resolvedPos.doc.resolve(this.to + 3)), new vd(r, this.editor);
  }
  get children() {
    const r = [];
    return this.node.content.forEach((t, i) => {
      const n = t.isBlock && !t.isTextblock, s = t.isAtom && !t.isText, u = this.pos + i + (s ? 0 : 1), o = this.resolvedPos.doc.resolve(u);
      if (!n && o.depth <= this.depth)
        return;
      const d = new vd(o, this.editor, n, n ? t : null);
      n && (d.actualDepth = this.depth + 1), r.push(new vd(o, this.editor, n, n ? t : null));
    }), r;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const r = this.children;
    return r[r.length - 1] || null;
  }
  closest(r, t = {}) {
    let i = null, n = this.parent;
    for (; n && !i; ) {
      if (n.node.type.name === r)
        if (Object.keys(t).length > 0) {
          const s = n.node.attrs, u = Object.keys(t);
          for (let o = 0; o < u.length; o += 1) {
            const d = u[o];
            if (s[d] !== t[d])
              break;
          }
        } else
          i = n;
      n = n.parent;
    }
    return i;
  }
  querySelector(r, t = {}) {
    return this.querySelectorAll(r, t, !0)[0] || null;
  }
  querySelectorAll(r, t = {}, i = !1) {
    let n = [];
    if (!this.children || this.children.length === 0)
      return n;
    const s = Object.keys(t);
    return this.children.forEach((u) => {
      i && n.length > 0 || (u.node.type.name === r && s.every((d) => t[d] === u.node.attrs[d]) && n.push(u), !(i && n.length > 0) && (n = n.concat(u.querySelectorAll(r, t, i))));
    }), n;
  }
  setAttribute(r) {
    const { tr: t } = this.editor.state;
    t.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...r
    }), this.editor.view.dispatch(t);
  }
}
const YWe = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function fWe(e, r, t) {
  const i = document.querySelector("style[data-tiptap-style]");
  if (i !== null)
    return i;
  const n = document.createElement("style");
  return r && n.setAttribute("nonce", r), n.setAttribute("data-tiptap-style", ""), n.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(n), n;
}
class KWe extends Dze {
  constructor(r = {}) {
    super(), this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: t }) => {
        throw t;
      },
      onPaste: () => null,
      onDrop: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(r), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: t, slice: i, moved: n }) => this.options.onDrop(t, i, n)), this.on("paste", ({ event: t, slice: i }) => this.options.onPaste(t, i)), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = fWe(YWe, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(r = {}) {
    this.options = {
      ...this.options,
      ...r
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(r, t = !0) {
    this.setOptions({ editable: r }), t && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(r, t) {
    const i = Lee(t) ? t(r, [...this.state.plugins]) : [...this.state.plugins, r], n = this.state.reconfigure({ plugins: i });
    return this.view.updateState(n), n;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(r) {
    if (this.isDestroyed)
      return;
    const t = this.state.plugins;
    let i = t;
    if ([].concat(r).forEach((s) => {
      const u = typeof s == "string" ? `${s}$` : s.key;
      i = t.filter((o) => !o.key.startsWith(u));
    }), t.length === i.length)
      return;
    const n = this.state.reconfigure({
      plugins: i
    });
    return this.view.updateState(n), n;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var r, t;
    const n = [...this.options.enableCoreExtensions ? [
      Qee,
      jee.configure({
        blockSeparator: (t = (r = this.options.coreExtensionOptions) === null || r === void 0 ? void 0 : r.clipboardTextSerializer) === null || t === void 0 ? void 0 : t.blockSeparator
      }),
      Jee,
      ere,
      rre,
      ire,
      $ee,
      tre
    ].filter((s) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[s.name] !== !1 : !0) : [], ...this.options.extensions].filter((s) => ["extension", "node", "mark"].includes(s == null ? void 0 : s.type));
    this.extensionManager = new oV(n, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new _f({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    let r;
    try {
      r = Vy(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (s) {
      if (!(s instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(s.message))
        throw s;
      this.emit("contentError", {
        editor: this,
        error: s,
        disableCollaboration: () => {
          this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((u) => u.name !== "collaboration"), this.createExtensionManager();
        }
      }), r = Vy(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
    }
    const t = Bee(r, this.options.autofocus);
    this.view = new aze(this.options.element, {
      ...this.options.editorProps,
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: uV.create({
        doc: r,
        selection: t || void 0
      })
    }), this.view.dom.setAttribute("role", "textbox"), this.view.dom.getAttribute("aria-label") || this.view.dom.setAttribute("aria-label", "Rich-Text Editor");
    const i = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(i), this.createNodeViews(), this.prependClass();
    const n = this.view.dom;
    n.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(r) {
    this.isCapturingTransaction = !0, r(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(r) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = r;
        return;
      }
      r.steps.forEach((u) => {
        var o;
        return (o = this.capturedTransaction) === null || o === void 0 ? void 0 : o.step(u);
      });
      return;
    }
    const t = this.state.apply(r), i = !this.state.selection.eq(t.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction: r,
      nextState: t
    }), this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: r
    }), i && this.emit("selectionUpdate", {
      editor: this,
      transaction: r
    });
    const n = r.getMeta("focus"), s = r.getMeta("blur");
    n && this.emit("focus", {
      editor: this,
      event: n.event,
      transaction: r
    }), s && this.emit("blur", {
      editor: this,
      event: s.event,
      transaction: r
    }), !(!r.docChanged || r.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: r
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(r) {
    return WBe(this.state, r);
  }
  isActive(r, t) {
    const i = typeof r == "string" ? r : null, n = typeof r == "string" ? t : r;
    return GBe(this.state, i, n);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return $4(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(r) {
    const { blockSeparator: t = `

`, textSerializers: i = {} } = r || {};
    return zBe(this.state.doc, {
      blockSeparator: t,
      textSerializers: {
        ...Hee(this.schema),
        ...i
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return Q4(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    if (this.emit("destroy"), this.view) {
      const r = this.view.dom;
      r && r.editor && delete r.editor, this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var r;
    return !(!((r = this.view) === null || r === void 0) && r.docView);
  }
  $node(r, t) {
    var i;
    return ((i = this.$doc) === null || i === void 0 ? void 0 : i.querySelector(r, t)) || null;
  }
  $nodes(r, t) {
    var i;
    return ((i = this.$doc) === null || i === void 0 ? void 0 : i.querySelectorAll(r, t)) || null;
  }
  $pos(r) {
    const t = this.state.doc.resolve(r);
    return new vd(t, this);
  }
  get $doc() {
    return this.$pos(0);
  }
}
function cl(e) {
  return new jf({
    find: e.find,
    handler: ({ state: r, range: t, match: i }) => {
      const n = Vr(e.getAttributes, void 0, i);
      if (n === !1 || n === null)
        return null;
      const { tr: s } = r, u = i[i.length - 1], o = i[0];
      if (u) {
        const d = o.search(/\S/), a = t.from + o.indexOf(u), V = a + u.length;
        if (Zee(t.from, t.to, r.doc).filter((X) => X.mark.type.excluded.find((q) => q === e.type && q !== X.mark.type)).filter((X) => X.to > a).length)
          return null;
        V < t.to && s.delete(V, t.to), a > t.from && s.delete(t.from + d, a);
        const F = t.from + d + u.length;
        s.addMark(t.from + d, F, e.type.create(n || {})), s.removeStoredMark(e.type);
      }
    }
  });
}
function hWe(e) {
  return new jf({
    find: e.find,
    handler: ({ state: r, range: t, match: i }) => {
      const n = Vr(e.getAttributes, void 0, i) || {}, { tr: s } = r, u = t.from;
      let o = t.to;
      const d = e.type.create(n);
      if (i[1]) {
        const a = i[0].lastIndexOf(i[1]);
        let V = u + a;
        V > o ? V = o : o = V + i[1].length;
        const c = i[0][i[0].length - 1];
        s.insertText(c, u + i[0].length - 1), s.replaceWith(V, o, d);
      } else if (i[0]) {
        const a = e.type.isInline ? u : u - 1;
        s.insert(a, e.type.create(n)).delete(s.mapping.map(u), s.mapping.map(o));
      }
      s.scrollIntoView();
    }
  });
}
function cy(e) {
  return new jf({
    find: e.find,
    handler: ({ state: r, range: t, match: i }) => {
      const n = r.doc.resolve(t.from), s = Vr(e.getAttributes, void 0, i) || {};
      if (!n.node(-1).canReplaceWith(n.index(-1), n.indexAfter(-1), e.type))
        return null;
      r.tr.delete(t.from, t.to).setBlockType(t.from, t.from, e.type, s);
    }
  });
}
function G7(e) {
  return new jf({
    find: e.find,
    handler: ({ state: r, range: t, match: i, chain: n }) => {
      const s = Vr(e.getAttributes, void 0, i) || {}, u = r.tr.delete(t.from, t.to), d = u.doc.resolve(t.from).blockRange(), a = d && M4(d, e.type, s);
      if (!a)
        return null;
      if (u.wrap(d, a), e.keepMarks && e.editor) {
        const { selection: c, storedMarks: F } = r, { splittableMarks: X } = e.editor.extensionManager, Y = F || c.$to.parentOffset && c.$from.marks();
        if (Y) {
          const q = Y.filter((f) => X.includes(f.type.name));
          u.ensureMarks(q);
        }
      }
      if (e.keepAttributes) {
        const c = e.type.name === "bulletList" || e.type.name === "orderedList" ? "listItem" : "taskList";
        n().updateAttributes(c, s).run();
      }
      const V = u.doc.resolve(t.from - 1).nodeBefore;
      V && V.type === e.type && id(u.doc, t.from - 1) && (!e.joinPredicate || e.joinPredicate(i, V)) && u.join(t.from - 1);
    }
  });
}
let Jr = class Fy {
  constructor(r = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...r
    }, this.name = this.config.name, r.defaultOptions && Object.keys(r.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Vr(Ce(this, "addOptions", {
      name: this.name
    }))), this.storage = Vr(Ce(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(r = {}) {
    return new Fy(r);
  }
  configure(r = {}) {
    const t = this.extend({
      ...this.config,
      addOptions: () => zf(this.options, r)
    });
    return t.name = this.name, t.parent = this.parent, t;
  }
  extend(r = {}) {
    const t = new Fy(r);
    return t.parent = this, this.child = t, t.name = r.name ? r.name : t.parent.name, r.defaultOptions && Object.keys(r.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = Vr(Ce(t, "addOptions", {
      name: t.name
    })), t.storage = Vr(Ce(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
};
function Fl(e) {
  return new Wze({
    find: e.find,
    handler: ({ state: r, range: t, match: i, pasteEvent: n }) => {
      const s = Vr(e.getAttributes, void 0, i, n);
      if (s === !1 || s === null)
        return null;
      const { tr: u } = r, o = i[i.length - 1], d = i[0];
      let a = t.to;
      if (o) {
        const V = d.search(/\S/), c = t.from + d.indexOf(o), F = c + o.length;
        if (Zee(t.from, t.to, r.doc).filter((Y) => Y.mark.type.excluded.find((f) => f === e.type && f !== Y.mark.type)).filter((Y) => Y.to > c).length)
          return null;
        F < t.to && u.delete(F, t.to), c > t.from && u.delete(t.from + V, c), a = t.from + V + o.length, u.addMark(t.from + V, a, e.type.create(s || {})), u.removeStoredMark(e.type);
      }
    }
  });
}
function pWe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var xy = { exports: {} }, Bg = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var YD;
function mWe() {
  if (YD) return Bg;
  YD = 1;
  var e = D;
  function r(c, F) {
    return c === F && (c !== 0 || 1 / c === 1 / F) || c !== c && F !== F;
  }
  var t = typeof Object.is == "function" ? Object.is : r, i = e.useState, n = e.useEffect, s = e.useLayoutEffect, u = e.useDebugValue;
  function o(c, F) {
    var X = F(), Y = i({ inst: { value: X, getSnapshot: F } }), q = Y[0].inst, f = Y[1];
    return s(function() {
      q.value = X, q.getSnapshot = F, d(q) && f({ inst: q });
    }, [c, X, F]), n(function() {
      return d(q) && f({ inst: q }), c(function() {
        d(q) && f({ inst: q });
      });
    }, [c]), u(X), X;
  }
  function d(c) {
    var F = c.getSnapshot;
    c = c.value;
    try {
      var X = F();
      return !t(c, X);
    } catch {
      return !0;
    }
  }
  function a(c, F) {
    return F();
  }
  var V = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? a : o;
  return Bg.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : V, Bg;
}
var Wg = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fD;
function gWe() {
  return fD || (fD = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = D, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function t(g) {
      {
        for (var y = arguments.length, b = new Array(y > 1 ? y - 1 : 0), A = 1; A < y; A++)
          b[A - 1] = arguments[A];
        i("error", g, b);
      }
    }
    function i(g, y, b) {
      {
        var A = r.ReactDebugCurrentFrame, w = A.getStackAddendum();
        w !== "" && (y += "%s", b = b.concat([w]));
        var S = b.map(function(N) {
          return String(N);
        });
        S.unshift("Warning: " + y), Function.prototype.apply.call(console[g], console, S);
      }
    }
    function n(g, y) {
      return g === y && (g !== 0 || 1 / g === 1 / y) || g !== g && y !== y;
    }
    var s = typeof Object.is == "function" ? Object.is : n, u = e.useState, o = e.useEffect, d = e.useLayoutEffect, a = e.useDebugValue, V = !1, c = !1;
    function F(g, y, b) {
      V || e.startTransition !== void 0 && (V = !0, t("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var A = y();
      if (!c) {
        var w = y();
        s(A, w) || (t("The result of getSnapshot should be cached to avoid an infinite loop"), c = !0);
      }
      var S = u({
        inst: {
          value: A,
          getSnapshot: y
        }
      }), N = S[0].inst, O = S[1];
      return d(function() {
        N.value = A, N.getSnapshot = y, X(N) && O({
          inst: N
        });
      }, [g, A, y]), o(function() {
        X(N) && O({
          inst: N
        });
        var E = function() {
          X(N) && O({
            inst: N
          });
        };
        return g(E);
      }, [g]), a(A), A;
    }
    function X(g) {
      var y = g.getSnapshot, b = g.value;
      try {
        var A = y();
        return !s(b, A);
      } catch {
        return !0;
      }
    }
    function Y(g, y, b) {
      return y();
    }
    var q = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", f = !q, p = f ? Y : F, m = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : p;
    Wg.useSyncExternalStore = m, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Wg;
}
process.env.NODE_ENV === "production" ? xy.exports = mWe() : xy.exports = gWe();
var Wf = xy.exports;
const vWe = (...e) => (r) => {
  e.forEach((t) => {
    typeof t == "function" ? t(r) : t && (t.current = r);
  });
}, bWe = ({ contentComponent: e }) => {
  const r = Wf.useSyncExternalStore(e.subscribe, e.getSnapshot, e.getServerSnapshot);
  return D.createElement(D.Fragment, null, Object.values(r));
};
function yWe() {
  const e = /* @__PURE__ */ new Set();
  let r = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(t) {
      return e.add(t), () => {
        e.delete(t);
      };
    },
    getSnapshot() {
      return r;
    },
    getServerSnapshot() {
      return r;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(t, i) {
      r = {
        ...r,
        [t]: Us.createPortal(i.reactElement, i.element, t)
      }, e.forEach((n) => n());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(t) {
      const i = { ...r };
      delete i[t], r = i, e.forEach((n) => n());
    }
  };
}
class AWe extends D.Component {
  constructor(r) {
    var t;
    super(r), this.editorContentRef = D.createRef(), this.initialized = !1, this.state = {
      hasContentComponentInitialized: !!(!((t = r.editor) === null || t === void 0) && t.contentComponent)
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const r = this.props.editor;
    if (r && !r.isDestroyed && r.options.element) {
      if (r.contentComponent)
        return;
      const t = this.editorContentRef.current;
      t.append(...r.options.element.childNodes), r.setOptions({
        element: t
      }), r.contentComponent = yWe(), this.state.hasContentComponentInitialized || (this.unsubscribeToContentComponent = r.contentComponent.subscribe(() => {
        this.setState((i) => i.hasContentComponentInitialized ? i : {
          hasContentComponentInitialized: !0
        }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent();
      })), r.createNodeViews(), this.initialized = !0;
    }
  }
  componentWillUnmount() {
    const r = this.props.editor;
    if (!r || (this.initialized = !1, r.isDestroyed || r.view.setProps({
      nodeViews: {}
    }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent(), r.contentComponent = null, !r.options.element.firstChild))
      return;
    const t = document.createElement("div");
    t.append(...r.options.element.childNodes), r.setOptions({
      element: t
    });
  }
  render() {
    const { editor: r, innerRef: t, ...i } = this.props;
    return D.createElement(
      D.Fragment,
      null,
      D.createElement("div", { ref: vWe(t, this.editorContentRef), ...i }),
      (r == null ? void 0 : r.contentComponent) && D.createElement(bWe, { contentComponent: r.contentComponent })
    );
  }
}
const wWe = re((e, r) => {
  const t = D.useMemo(() => Math.floor(Math.random() * 4294967295).toString(), [e.editor]);
  return D.createElement(AWe, {
    key: t,
    innerRef: r,
    ...e
  });
}), CWe = D.memo(wWe);
var PWe = function e(r, t) {
  if (r === t) return !0;
  if (r && t && typeof r == "object" && typeof t == "object") {
    if (r.constructor !== t.constructor) return !1;
    var i, n, s;
    if (Array.isArray(r)) {
      if (i = r.length, i != t.length) return !1;
      for (n = i; n-- !== 0; )
        if (!e(r[n], t[n])) return !1;
      return !0;
    }
    if (r instanceof Map && t instanceof Map) {
      if (r.size !== t.size) return !1;
      for (n of r.entries())
        if (!t.has(n[0])) return !1;
      for (n of r.entries())
        if (!e(n[1], t.get(n[0]))) return !1;
      return !0;
    }
    if (r instanceof Set && t instanceof Set) {
      if (r.size !== t.size) return !1;
      for (n of r.entries())
        if (!t.has(n[0])) return !1;
      return !0;
    }
    if (ArrayBuffer.isView(r) && ArrayBuffer.isView(t)) {
      if (i = r.length, i != t.length) return !1;
      for (n = i; n-- !== 0; )
        if (r[n] !== t[n]) return !1;
      return !0;
    }
    if (r.constructor === RegExp) return r.source === t.source && r.flags === t.flags;
    if (r.valueOf !== Object.prototype.valueOf) return r.valueOf() === t.valueOf();
    if (r.toString !== Object.prototype.toString) return r.toString() === t.toString();
    if (s = Object.keys(r), i = s.length, i !== Object.keys(t).length) return !1;
    for (n = i; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, s[n])) return !1;
    for (n = i; n-- !== 0; ) {
      var u = s[n];
      if (!(u === "_owner" && r.$$typeof) && !e(r[u], t[u]))
        return !1;
    }
    return !0;
  }
  return r !== r && t !== t;
}, SWe = /* @__PURE__ */ pWe(PWe), Xy = { exports: {} }, Gg = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var KD;
function NWe() {
  if (KD) return Gg;
  KD = 1;
  var e = D, r = Wf;
  function t(a, V) {
    return a === V && (a !== 0 || 1 / a === 1 / V) || a !== a && V !== V;
  }
  var i = typeof Object.is == "function" ? Object.is : t, n = r.useSyncExternalStore, s = e.useRef, u = e.useEffect, o = e.useMemo, d = e.useDebugValue;
  return Gg.useSyncExternalStoreWithSelector = function(a, V, c, F, X) {
    var Y = s(null);
    if (Y.current === null) {
      var q = { hasValue: !1, value: null };
      Y.current = q;
    } else q = Y.current;
    Y = o(function() {
      function p(A) {
        if (!m) {
          if (m = !0, g = A, A = F(A), X !== void 0 && q.hasValue) {
            var w = q.value;
            if (X(w, A)) return y = w;
          }
          return y = A;
        }
        if (w = y, i(g, A)) return w;
        var S = F(A);
        return X !== void 0 && X(w, S) ? w : (g = A, y = S);
      }
      var m = !1, g, y, b = c === void 0 ? null : c;
      return [function() {
        return p(V());
      }, b === null ? void 0 : function() {
        return p(b());
      }];
    }, [V, c, F, X]);
    var f = n(a, Y[0], Y[1]);
    return u(function() {
      q.hasValue = !0, q.value = f;
    }, [f]), d(f), f;
  }, Gg;
}
var Ug = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hD;
function MWe() {
  return hD || (hD = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = D, r = Wf;
    function t(V, c) {
      return V === c && (V !== 0 || 1 / V === 1 / c) || V !== V && c !== c;
    }
    var i = typeof Object.is == "function" ? Object.is : t, n = r.useSyncExternalStore, s = e.useRef, u = e.useEffect, o = e.useMemo, d = e.useDebugValue;
    function a(V, c, F, X, Y) {
      var q = s(null), f;
      q.current === null ? (f = {
        hasValue: !1,
        value: null
      }, q.current = f) : f = q.current;
      var p = o(function() {
        var b = !1, A, w, S = function(I) {
          if (!b) {
            b = !0, A = I;
            var R = X(I);
            if (Y !== void 0 && f.hasValue) {
              var H = f.value;
              if (Y(H, R))
                return w = H, H;
            }
            return w = R, R;
          }
          var W = A, B = w;
          if (i(W, I))
            return B;
          var L = X(I);
          return Y !== void 0 && Y(B, L) ? B : (A = I, w = L, L);
        }, N = F === void 0 ? null : F, O = function() {
          return S(c());
        }, E = N === null ? void 0 : function() {
          return S(N());
        };
        return [O, E];
      }, [c, F, X, Y]), m = p[0], g = p[1], y = n(V, m, g);
      return u(function() {
        f.hasValue = !0, f.value = y;
      }, [y]), d(y), y;
    }
    Ug.useSyncExternalStoreWithSelector = a, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Ug;
}
process.env.NODE_ENV === "production" ? Xy.exports = NWe() : Xy.exports = MWe();
var TWe = Xy.exports;
class EWe {
  constructor(r) {
    this.transactionNumber = 0, this.lastTransactionNumber = 0, this.subscribers = /* @__PURE__ */ new Set(), this.editor = r, this.lastSnapshot = { editor: r, transactionNumber: 0 }, this.getSnapshot = this.getSnapshot.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.watch = this.watch.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    return this.transactionNumber === this.lastTransactionNumber ? this.lastSnapshot : (this.lastTransactionNumber = this.transactionNumber, this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber }, this.lastSnapshot);
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(r) {
    return this.subscribers.add(r), () => {
      this.subscribers.delete(r);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(r) {
    if (this.editor = r, this.editor) {
      const t = () => {
        this.transactionNumber += 1, this.subscribers.forEach((n) => n());
      }, i = this.editor;
      return i.on("transaction", t), () => {
        i.off("transaction", t);
      };
    }
  }
}
function kWe(e) {
  var r;
  const [t] = ie(() => new EWe(e.editor)), i = TWe.useSyncExternalStoreWithSelector(t.subscribe, t.getSnapshot, t.getServerSnapshot, e.selector, (r = e.equalityFn) !== null && r !== void 0 ? r : SWe);
  return Pe(() => t.watch(e.editor), [e.editor, t]), iR(i), i;
}
const pD = process.env.NODE_ENV !== "production", qy = typeof window > "u", OWe = qy || !!(typeof window < "u" && window.next);
class DWe {
  constructor(r) {
    this.editor = null, this.subscriptions = /* @__PURE__ */ new Set(), this.isComponentMounted = !1, this.previousDeps = null, this.instanceId = "", this.options = r, this.subscriptions = /* @__PURE__ */ new Set(), this.setEditor(this.getInitialEditor()), this.scheduleDestroy(), this.getEditor = this.getEditor.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.subscribe = this.subscribe.bind(this), this.refreshEditorInstance = this.refreshEditorInstance.bind(this), this.scheduleDestroy = this.scheduleDestroy.bind(this), this.onRender = this.onRender.bind(this), this.createEditor = this.createEditor.bind(this);
  }
  setEditor(r) {
    this.editor = r, this.instanceId = Math.random().toString(36).slice(2, 9), this.subscriptions.forEach((t) => t());
  }
  getInitialEditor() {
    if (this.options.current.immediatelyRender === void 0)
      return qy || OWe ? (pD && console.warn("Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches."), null) : this.createEditor();
    if (this.options.current.immediatelyRender && qy && pD)
      throw new Error("Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.");
    return this.options.current.immediatelyRender ? this.createEditor() : null;
  }
  /**
   * Create a new editor instance. And attach event listeners.
   */
  createEditor() {
    const r = {
      ...this.options.current,
      // Always call the most recent version of the callback function by default
      onBeforeCreate: (...i) => {
        var n, s;
        return (s = (n = this.options.current).onBeforeCreate) === null || s === void 0 ? void 0 : s.call(n, ...i);
      },
      onBlur: (...i) => {
        var n, s;
        return (s = (n = this.options.current).onBlur) === null || s === void 0 ? void 0 : s.call(n, ...i);
      },
      onCreate: (...i) => {
        var n, s;
        return (s = (n = this.options.current).onCreate) === null || s === void 0 ? void 0 : s.call(n, ...i);
      },
      onDestroy: (...i) => {
        var n, s;
        return (s = (n = this.options.current).onDestroy) === null || s === void 0 ? void 0 : s.call(n, ...i);
      },
      onFocus: (...i) => {
        var n, s;
        return (s = (n = this.options.current).onFocus) === null || s === void 0 ? void 0 : s.call(n, ...i);
      },
      onSelectionUpdate: (...i) => {
        var n, s;
        return (s = (n = this.options.current).onSelectionUpdate) === null || s === void 0 ? void 0 : s.call(n, ...i);
      },
      onTransaction: (...i) => {
        var n, s;
        return (s = (n = this.options.current).onTransaction) === null || s === void 0 ? void 0 : s.call(n, ...i);
      },
      onUpdate: (...i) => {
        var n, s;
        return (s = (n = this.options.current).onUpdate) === null || s === void 0 ? void 0 : s.call(n, ...i);
      },
      onContentError: (...i) => {
        var n, s;
        return (s = (n = this.options.current).onContentError) === null || s === void 0 ? void 0 : s.call(n, ...i);
      },
      onDrop: (...i) => {
        var n, s;
        return (s = (n = this.options.current).onDrop) === null || s === void 0 ? void 0 : s.call(n, ...i);
      },
      onPaste: (...i) => {
        var n, s;
        return (s = (n = this.options.current).onPaste) === null || s === void 0 ? void 0 : s.call(n, ...i);
      }
    };
    return new KWe(r);
  }
  /**
   * Get the current editor instance.
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return null;
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(r) {
    return this.subscriptions.add(r), () => {
      this.subscriptions.delete(r);
    };
  }
  /**
   * On each render, we will create, update, or destroy the editor instance.
   * @param deps The dependencies to watch for changes
   * @returns A cleanup function
   */
  onRender(r) {
    return () => (this.isComponentMounted = !0, clearTimeout(this.scheduledDestructionTimeout), this.editor && !this.editor.isDestroyed && r.length === 0 ? this.editor.setOptions({
      ...this.options.current,
      editable: this.editor.isEditable
    }) : this.refreshEditorInstance(r), () => {
      this.isComponentMounted = !1, this.scheduleDestroy();
    });
  }
  /**
   * Recreate the editor instance if the dependencies have changed.
   */
  refreshEditorInstance(r) {
    if (this.editor && !this.editor.isDestroyed) {
      if (this.previousDeps === null) {
        this.previousDeps = r;
        return;
      }
      if (this.previousDeps.length === r.length && this.previousDeps.every((i, n) => i === r[n]))
        return;
    }
    this.editor && !this.editor.isDestroyed && this.editor.destroy(), this.setEditor(this.createEditor()), this.previousDeps = r;
  }
  /**
   * Schedule the destruction of the editor instance.
   * This will only destroy the editor if it was not mounted on the next tick.
   * This is to avoid destroying the editor instance when it's actually still mounted.
   */
  scheduleDestroy() {
    const r = this.instanceId, t = this.editor;
    this.scheduledDestructionTimeout = setTimeout(() => {
      if (this.isComponentMounted && this.instanceId === r) {
        t && t.setOptions(this.options.current);
        return;
      }
      t && !t.isDestroyed && (t.destroy(), this.instanceId === r && this.setEditor(null));
    }, 1);
  }
}
function RWe(e = {}, r = []) {
  const t = Yr(e);
  t.current = e;
  const [i] = ie(() => new DWe(t)), n = Wf.useSyncExternalStore(i.subscribe, i.getEditor, i.getServerSnapshot);
  return iR(n), Pe(i.onRender(r)), kWe({
    editor: n,
    selector: ({ transactionNumber: s }) => e.shouldRerenderOnTransaction === !1 ? null : e.immediatelyRender && s === 0 ? 0 : s + 1
  }), n;
}
const IWe = et({
  editor: null
});
IWe.Consumer;
const LWe = et({
  onDragStart: void 0
}), _We = () => rt(LWe);
D.forwardRef((e, r) => {
  const { onDragStart: t } = _We(), i = e.as || "div";
  return (
    // @ts-ignore
    D.createElement(i, { ...e, ref: r, "data-node-view-wrapper": "", onDragStart: t, style: {
      whiteSpace: "normal",
      ...e.style
    } })
  );
});
const HWe = /^\s*>\s$/, jWe = Jr.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["blockquote", Ti(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: e }) => e.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: e }) => e.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: e }) => e.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      G7({
        find: HWe,
        type: this.type
      })
    ];
  }
}), zWe = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, BWe = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, WWe = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, GWe = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, UWe = Ui.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (e) => e.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["strong", Ti(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: e }) => e.setMark(this.name),
      toggleBold: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetBold: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      cl({
        find: zWe,
        type: this.type
      }),
      cl({
        find: WWe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Fl({
        find: BWe,
        type: this.type
      }),
      Fl({
        find: GWe,
        type: this.type
      })
    ];
  }
}), ZWe = "listItem", mD = "textStyle", gD = /^\s*([-+*])\s$/, JWe = Jr.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["ul", Ti(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: e, chain: r }) => this.options.keepAttributes ? r().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(ZWe, this.editor.getAttributes(mD)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let e = G7({
      find: gD,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = G7({
      find: gD,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(mD),
      editor: this.editor
    })), [
      e
    ];
  }
}), $We = /(?:^|\s)(`(?!\s+`)((?:[^`]+))`(?!\s+`))$/, QWe = /(?:^|\s)(`(?!\s+`)((?:[^`]+))`(?!\s+`))/g, eGe = Ui.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["code", Ti(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: e }) => e.setMark(this.name),
      toggleCode: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetCode: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      cl({
        find: $We,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Fl({
        find: QWe,
        type: this.type
      })
    ];
  }
}), rGe = /^```([a-z]+)?[\s\n]$/, tGe = /^~~~([a-z]+)?[\s\n]$/, iGe = Jr.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (e) => {
          var r;
          const { languageClassPrefix: t } = this.options, s = [...((r = e.firstElementChild) === null || r === void 0 ? void 0 : r.classList) || []].filter((u) => u.startsWith(t)).map((u) => u.replace(t, ""))[0];
          return s || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: e, HTMLAttributes: r }) {
    return [
      "pre",
      Ti(this.options.HTMLAttributes, r),
      [
        "code",
        {
          class: e.attrs.language ? this.options.languageClassPrefix + e.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (e) => ({ commands: r }) => r.setNode(this.name, e),
      toggleCodeBlock: (e) => ({ commands: r }) => r.toggleNode(this.name, "paragraph", e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: e, $anchor: r } = this.editor.state.selection, t = r.pos === 1;
        return !e || r.parent.type.name !== this.name ? !1 : t || !r.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: e }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: r } = e, { selection: t } = r, { $from: i, empty: n } = t;
        if (!n || i.parent.type !== this.type)
          return !1;
        const s = i.parentOffset === i.parent.nodeSize - 2, u = i.parent.textContent.endsWith(`

`);
        return !s || !u ? !1 : e.chain().command(({ tr: o }) => (o.delete(i.pos - 2, i.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: e }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: r } = e, { selection: t, doc: i } = r, { $from: n, empty: s } = t;
        if (!s || n.parent.type !== this.type || !(n.parentOffset === n.parent.nodeSize - 2))
          return !1;
        const o = n.after();
        return o === void 0 ? !1 : i.nodeAt(o) ? e.commands.command(({ tr: a }) => (a.setSelection(nr.near(i.resolve(o))), !0)) : e.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      cy({
        find: rGe,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      }),
      cy({
        find: tGe,
        type: this.type,
        getAttributes: (e) => ({
          language: e[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new Ei({
        key: new hs("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (e, r) => {
            if (!r.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const t = r.clipboardData.getData("text/plain"), i = r.clipboardData.getData("vscode-editor-data"), n = i ? JSON.parse(i) : void 0, s = n == null ? void 0 : n.mode;
            if (!t || !s)
              return !1;
            const { tr: u, schema: o } = e.state, d = o.text(t.replace(/\r\n?/g, `
`));
            return u.replaceSelectionWith(this.type.create({ language: s }, d)), u.selection.$from.parent.type !== this.type && u.setSelection(Ze.near(u.doc.resolve(Math.max(0, u.selection.from - 2)))), u.setMeta("paste", !0), e.dispatch(u), !0;
          }
        }
      })
    ];
  }
}), nGe = Jr.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function sGe(e = {}) {
  return new Ei({
    view(r) {
      return new uGe(r, e);
    }
  });
}
class uGe {
  constructor(r, t) {
    var i;
    this.editorView = r, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (i = t.width) !== null && i !== void 0 ? i : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((n) => {
      let s = (u) => {
        this[n](u);
      };
      return r.dom.addEventListener(n, s), { name: n, handler: s };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: r, handler: t }) => this.editorView.dom.removeEventListener(r, t));
  }
  update(r, t) {
    this.cursorPos != null && t.doc != r.state.doc && (this.cursorPos > r.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(r) {
    r != this.cursorPos && (this.cursorPos = r, r == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let r = this.editorView.state.doc.resolve(this.cursorPos), t = !r.parent.inlineContent, i;
    if (t) {
      let o = r.nodeBefore, d = r.nodeAfter;
      if (o || d) {
        let a = this.editorView.nodeDOM(this.cursorPos - (o ? o.nodeSize : 0));
        if (a) {
          let V = a.getBoundingClientRect(), c = o ? V.bottom : V.top;
          o && d && (c = (c + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), i = { left: V.left, right: V.right, top: c - this.width / 2, bottom: c + this.width / 2 };
        }
      }
    }
    if (!i) {
      let o = this.editorView.coordsAtPos(this.cursorPos);
      i = { left: o.left - this.width / 2, right: o.left + this.width / 2, top: o.top, bottom: o.bottom };
    }
    let n = this.editorView.dom.offsetParent;
    this.element || (this.element = n.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let s, u;
    if (!n || n == document.body && getComputedStyle(n).position == "static")
      s = -pageXOffset, u = -pageYOffset;
    else {
      let o = n.getBoundingClientRect();
      s = o.left - n.scrollLeft, u = o.top - n.scrollTop;
    }
    this.element.style.left = i.left - s + "px", this.element.style.top = i.top - u + "px", this.element.style.width = i.right - i.left + "px", this.element.style.height = i.bottom - i.top + "px";
  }
  scheduleRemoval(r) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), r);
  }
  dragover(r) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: r.clientX, top: r.clientY }), i = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), n = i && i.type.spec.disableDropCursor, s = typeof n == "function" ? n(this.editorView, t, r) : n;
    if (t && !s) {
      let u = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let o = IQ(this.editorView.state.doc, u, this.editorView.dragging.slice);
        o != null && (u = o);
      }
      this.setCursor(u), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(r) {
    (r.target == this.editorView.dom || !this.editorView.dom.contains(r.relatedTarget)) && this.setCursor(null);
  }
}
const oGe = Bt.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      sGe(this.options)
    ];
  }
});
class lt extends nr {
  /**
  Create a gap cursor.
  */
  constructor(r) {
    super(r, r);
  }
  map(r, t) {
    let i = r.resolve(t.map(this.head));
    return lt.valid(i) ? new lt(i) : nr.near(i);
  }
  content() {
    return ve.empty;
  }
  eq(r) {
    return r instanceof lt && r.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(r, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new lt(r.resolve(t.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new e5(this.anchor);
  }
  /**
  @internal
  */
  static valid(r) {
    let t = r.parent;
    if (t.isTextblock || !dGe(r) || !aGe(r))
      return !1;
    let i = t.type.spec.allowGapCursor;
    if (i != null)
      return i;
    let n = t.contentMatchAt(r.index()).defaultType;
    return n && n.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(r, t, i = !1) {
    e: for (; ; ) {
      if (!i && lt.valid(r))
        return r;
      let n = r.pos, s = null;
      for (let u = r.depth; ; u--) {
        let o = r.node(u);
        if (t > 0 ? r.indexAfter(u) < o.childCount : r.index(u) > 0) {
          s = o.child(t > 0 ? r.indexAfter(u) : r.index(u) - 1);
          break;
        } else if (u == 0)
          return null;
        n += t;
        let d = r.doc.resolve(n);
        if (lt.valid(d))
          return d;
      }
      for (; ; ) {
        let u = t > 0 ? s.firstChild : s.lastChild;
        if (!u) {
          if (s.isAtom && !s.isText && !ke.isSelectable(s)) {
            r = r.doc.resolve(n + s.nodeSize * t), i = !1;
            continue e;
          }
          break;
        }
        s = u, n += t;
        let o = r.doc.resolve(n);
        if (lt.valid(o))
          return o;
      }
      return null;
    }
  }
}
lt.prototype.visible = !1;
lt.findFrom = lt.findGapCursorFrom;
nr.jsonID("gapcursor", lt);
class e5 {
  constructor(r) {
    this.pos = r;
  }
  map(r) {
    return new e5(r.map(this.pos));
  }
  resolve(r) {
    let t = r.resolve(this.pos);
    return lt.valid(t) ? new lt(t) : nr.near(t);
  }
}
function dGe(e) {
  for (let r = e.depth; r >= 0; r--) {
    let t = e.index(r), i = e.node(r);
    if (t == 0) {
      if (i.type.spec.isolating)
        return !0;
      continue;
    }
    for (let n = i.child(t - 1); ; n = n.lastChild) {
      if (n.childCount == 0 && !n.inlineContent || n.isAtom || n.type.spec.isolating)
        return !0;
      if (n.inlineContent)
        return !1;
    }
  }
  return !0;
}
function aGe(e) {
  for (let r = e.depth; r >= 0; r--) {
    let t = e.indexAfter(r), i = e.node(r);
    if (t == i.childCount) {
      if (i.type.spec.isolating)
        return !0;
      continue;
    }
    for (let n = i.child(t); ; n = n.firstChild) {
      if (n.childCount == 0 && !n.inlineContent || n.isAtom || n.type.spec.isolating)
        return !0;
      if (n.inlineContent)
        return !1;
    }
  }
  return !0;
}
function VGe() {
  return new Ei({
    props: {
      decorations: xGe,
      createSelectionBetween(e, r, t) {
        return r.pos == t.pos && lt.valid(t) ? new lt(t) : null;
      },
      handleClick: cGe,
      handleKeyDown: lGe,
      handleDOMEvents: { beforeinput: FGe }
    }
  });
}
const lGe = Aee({
  ArrowLeft: Px("horiz", -1),
  ArrowRight: Px("horiz", 1),
  ArrowUp: Px("vert", -1),
  ArrowDown: Px("vert", 1)
});
function Px(e, r) {
  const t = e == "vert" ? r > 0 ? "down" : "up" : r > 0 ? "right" : "left";
  return function(i, n, s) {
    let u = i.selection, o = r > 0 ? u.$to : u.$from, d = u.empty;
    if (u instanceof Ze) {
      if (!s.endOfTextblock(t) || o.depth == 0)
        return !1;
      d = !1, o = i.doc.resolve(r > 0 ? o.after() : o.before());
    }
    let a = lt.findGapCursorFrom(o, r, d);
    return a ? (n && n(i.tr.setSelection(new lt(a))), !0) : !1;
  };
}
function cGe(e, r, t) {
  if (!e || !e.editable)
    return !1;
  let i = e.state.doc.resolve(r);
  if (!lt.valid(i))
    return !1;
  let n = e.posAtCoords({ left: t.clientX, top: t.clientY });
  return n && n.inside > -1 && ke.isSelectable(e.state.doc.nodeAt(n.inside)) ? !1 : (e.dispatch(e.state.tr.setSelection(new lt(i))), !0);
}
function FGe(e, r) {
  if (r.inputType != "insertCompositionText" || !(e.state.selection instanceof lt))
    return !1;
  let { $from: t } = e.state.selection, i = t.parent.contentMatchAt(t.index()).findWrapping(e.state.schema.nodes.text);
  if (!i)
    return !1;
  let n = Fe.empty;
  for (let u = i.length - 1; u >= 0; u--)
    n = Fe.from(i[u].createAndFill(null, n));
  let s = e.state.tr.replace(t.pos, t.pos, new ve(n, 0, 0));
  return s.setSelection(Ze.near(s.doc.resolve(t.pos + 1))), e.dispatch(s), !1;
}
function xGe(e) {
  if (!(e.selection instanceof lt))
    return null;
  let r = document.createElement("div");
  return r.className = "ProseMirror-gapcursor", Nt.create(e.doc, [Sn.widget(e.selection.head, r, { key: "gapcursor" })]);
}
const XGe = Bt.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      VGe()
    ];
  },
  extendNodeSchema(e) {
    var r;
    const t = {
      name: e.name,
      options: e.options,
      storage: e.storage
    };
    return {
      allowGapCursor: (r = Vr(Ce(e, "allowGapCursor", t))) !== null && r !== void 0 ? r : null
    };
  }
}), qGe = Jr.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["br", Ti(this.options.HTMLAttributes, e)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: e, chain: r, state: t, editor: i }) => e.first([
        () => e.exitCode(),
        () => e.command(() => {
          const { selection: n, storedMarks: s } = t;
          if (n.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: u } = this.options, { splittableMarks: o } = i.extensionManager, d = s || n.$to.parentOffset && n.$from.marks();
          return r().insertContent({ type: this.name }).command(({ tr: a, dispatch: V }) => {
            if (V && d && u) {
              const c = d.filter((F) => o.includes(F.type.name));
              a.ensureMarks(c);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), YGe = Jr.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((e) => ({
      tag: `h${e}`,
      attrs: { level: e }
    }));
  },
  renderHTML({ node: e, HTMLAttributes: r }) {
    return [`h${this.options.levels.includes(e.attrs.level) ? e.attrs.level : this.options.levels[0]}`, Ti(this.options.HTMLAttributes, r), 0];
  },
  addCommands() {
    return {
      setHeading: (e) => ({ commands: r }) => this.options.levels.includes(e.level) ? r.setNode(this.name, e) : !1,
      toggleHeading: (e) => ({ commands: r }) => this.options.levels.includes(e.level) ? r.toggleNode(this.name, "paragraph", e) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((e, r) => ({
      ...e,
      [`Mod-Alt-${r}`]: () => this.editor.commands.toggleHeading({ level: r })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((e) => cy({
      find: new RegExp(`^(#{1,${e}})\\s$`),
      type: this.type,
      getAttributes: {
        level: e
      }
    }));
  }
});
var Cq = 200, jt = function() {
};
jt.prototype.append = function(r) {
  return r.length ? (r = jt.from(r), !this.length && r || r.length < Cq && this.leafAppend(r) || this.length < Cq && r.leafPrepend(this) || this.appendInner(r)) : this;
};
jt.prototype.prepend = function(r) {
  return r.length ? jt.from(r).append(this) : this;
};
jt.prototype.appendInner = function(r) {
  return new fGe(this, r);
};
jt.prototype.slice = function(r, t) {
  return r === void 0 && (r = 0), t === void 0 && (t = this.length), r >= t ? jt.empty : this.sliceInner(Math.max(0, r), Math.min(this.length, t));
};
jt.prototype.get = function(r) {
  if (!(r < 0 || r >= this.length))
    return this.getInner(r);
};
jt.prototype.forEach = function(r, t, i) {
  t === void 0 && (t = 0), i === void 0 && (i = this.length), t <= i ? this.forEachInner(r, t, i, 0) : this.forEachInvertedInner(r, t, i, 0);
};
jt.prototype.map = function(r, t, i) {
  t === void 0 && (t = 0), i === void 0 && (i = this.length);
  var n = [];
  return this.forEach(function(s, u) {
    return n.push(r(s, u));
  }, t, i), n;
};
jt.from = function(r) {
  return r instanceof jt ? r : r && r.length ? new nre(r) : jt.empty;
};
var nre = /* @__PURE__ */ function(e) {
  function r(i) {
    e.call(this), this.values = i;
  }
  e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return r.prototype.flatten = function() {
    return this.values;
  }, r.prototype.sliceInner = function(n, s) {
    return n == 0 && s == this.length ? this : new r(this.values.slice(n, s));
  }, r.prototype.getInner = function(n) {
    return this.values[n];
  }, r.prototype.forEachInner = function(n, s, u, o) {
    for (var d = s; d < u; d++)
      if (n(this.values[d], o + d) === !1)
        return !1;
  }, r.prototype.forEachInvertedInner = function(n, s, u, o) {
    for (var d = s - 1; d >= u; d--)
      if (n(this.values[d], o + d) === !1)
        return !1;
  }, r.prototype.leafAppend = function(n) {
    if (this.length + n.length <= Cq)
      return new r(this.values.concat(n.flatten()));
  }, r.prototype.leafPrepend = function(n) {
    if (this.length + n.length <= Cq)
      return new r(n.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(r.prototype, t), r;
}(jt);
jt.empty = new nre([]);
var fGe = /* @__PURE__ */ function(e) {
  function r(t, i) {
    e.call(this), this.left = t, this.right = i, this.length = t.length + i.length, this.depth = Math.max(t.depth, i.depth) + 1;
  }
  return e && (r.__proto__ = e), r.prototype = Object.create(e && e.prototype), r.prototype.constructor = r, r.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, r.prototype.getInner = function(i) {
    return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
  }, r.prototype.forEachInner = function(i, n, s, u) {
    var o = this.left.length;
    if (n < o && this.left.forEachInner(i, n, Math.min(s, o), u) === !1 || s > o && this.right.forEachInner(i, Math.max(n - o, 0), Math.min(this.length, s) - o, u + o) === !1)
      return !1;
  }, r.prototype.forEachInvertedInner = function(i, n, s, u) {
    var o = this.left.length;
    if (n > o && this.right.forEachInvertedInner(i, n - o, Math.max(s, o) - o, u + o) === !1 || s < o && this.left.forEachInvertedInner(i, Math.min(n, o), s, u) === !1)
      return !1;
  }, r.prototype.sliceInner = function(i, n) {
    if (i == 0 && n == this.length)
      return this;
    var s = this.left.length;
    return n <= s ? this.left.slice(i, n) : i >= s ? this.right.slice(i - s, n - s) : this.left.slice(i, s).append(this.right.slice(0, n - s));
  }, r.prototype.leafAppend = function(i) {
    var n = this.right.leafAppend(i);
    if (n)
      return new r(this.left, n);
  }, r.prototype.leafPrepend = function(i) {
    var n = this.left.leafPrepend(i);
    if (n)
      return new r(n, this.right);
  }, r.prototype.appendInner = function(i) {
    return this.left.depth >= Math.max(this.right.depth, i.depth) + 1 ? new r(this.left, new r(this.right, i)) : new r(this, i);
  }, r;
}(jt);
const KGe = 500;
class rs {
  constructor(r, t) {
    this.items = r, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(r, t) {
    if (this.eventCount == 0)
      return null;
    let i = this.items.length;
    for (; ; i--)
      if (this.items.get(i - 1).selection) {
        --i;
        break;
      }
    let n, s;
    t && (n = this.remapping(i, this.items.length), s = n.maps.length);
    let u = r.tr, o, d, a = [], V = [];
    return this.items.forEach((c, F) => {
      if (!c.step) {
        n || (n = this.remapping(i, F + 1), s = n.maps.length), s--, V.push(c);
        return;
      }
      if (n) {
        V.push(new ys(c.map));
        let X = c.step.map(n.slice(s)), Y;
        X && u.maybeStep(X).doc && (Y = u.mapping.maps[u.mapping.maps.length - 1], a.push(new ys(Y, void 0, void 0, a.length + V.length))), s--, Y && n.appendMap(Y, s);
      } else
        u.maybeStep(c.step);
      if (c.selection)
        return o = n ? c.selection.map(n.slice(s)) : c.selection, d = new rs(this.items.slice(0, i).append(V.reverse().concat(a)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: d, transform: u, selection: o };
  }
  // Create a new branch with the given transform added.
  addTransform(r, t, i, n) {
    let s = [], u = this.eventCount, o = this.items, d = !n && o.length ? o.get(o.length - 1) : null;
    for (let V = 0; V < r.steps.length; V++) {
      let c = r.steps[V].invert(r.docs[V]), F = new ys(r.mapping.maps[V], c, t), X;
      (X = d && d.merge(F)) && (F = X, V ? s.pop() : o = o.slice(0, o.length - 1)), s.push(F), t && (u++, t = void 0), n || (d = F);
    }
    let a = u - i.depth;
    return a > pGe && (o = hGe(o, a), u -= a), new rs(o.append(s), u);
  }
  remapping(r, t) {
    let i = new pV();
    return this.items.forEach((n, s) => {
      let u = n.mirrorOffset != null && s - n.mirrorOffset >= r ? i.maps.length - n.mirrorOffset : void 0;
      i.appendMap(n.map, u);
    }, r, t), i;
  }
  addMaps(r) {
    return this.eventCount == 0 ? this : new rs(this.items.append(r.map((t) => new ys(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(r, t) {
    if (!this.eventCount)
      return this;
    let i = [], n = Math.max(0, this.items.length - t), s = r.mapping, u = r.steps.length, o = this.eventCount;
    this.items.forEach((F) => {
      F.selection && o--;
    }, n);
    let d = t;
    this.items.forEach((F) => {
      let X = s.getMirror(--d);
      if (X == null)
        return;
      u = Math.min(u, X);
      let Y = s.maps[X];
      if (F.step) {
        let q = r.steps[X].invert(r.docs[X]), f = F.selection && F.selection.map(s.slice(d + 1, X));
        f && o++, i.push(new ys(Y, q, f));
      } else
        i.push(new ys(Y));
    }, n);
    let a = [];
    for (let F = t; F < u; F++)
      a.push(new ys(s.maps[F]));
    let V = this.items.slice(0, n).append(a).append(i), c = new rs(V, o);
    return c.emptyItemCount() > KGe && (c = c.compress(this.items.length - i.length)), c;
  }
  emptyItemCount() {
    let r = 0;
    return this.items.forEach((t) => {
      t.step || r++;
    }), r;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(r = this.items.length) {
    let t = this.remapping(0, r), i = t.maps.length, n = [], s = 0;
    return this.items.forEach((u, o) => {
      if (o >= r)
        n.push(u), u.selection && s++;
      else if (u.step) {
        let d = u.step.map(t.slice(i)), a = d && d.getMap();
        if (i--, a && t.appendMap(a, i), d) {
          let V = u.selection && u.selection.map(t.slice(i));
          V && s++;
          let c = new ys(a.invert(), d, V), F, X = n.length - 1;
          (F = n.length && n[X].merge(c)) ? n[X] = F : n.push(c);
        }
      } else u.map && i--;
    }, this.items.length, 0), new rs(jt.from(n.reverse()), s);
  }
}
rs.empty = new rs(jt.empty, 0);
function hGe(e, r) {
  let t;
  return e.forEach((i, n) => {
    if (i.selection && r-- == 0)
      return t = n, !1;
  }), e.slice(t);
}
class ys {
  constructor(r, t, i, n) {
    this.map = r, this.step = t, this.selection = i, this.mirrorOffset = n;
  }
  merge(r) {
    if (this.step && r.step && !r.selection) {
      let t = r.step.merge(this.step);
      if (t)
        return new ys(t.getMap().invert(), t, this.selection);
    }
  }
}
class Ko {
  constructor(r, t, i, n, s) {
    this.done = r, this.undone = t, this.prevRanges = i, this.prevTime = n, this.prevComposition = s;
  }
}
const pGe = 20;
function mGe(e, r, t, i) {
  let n = t.getMeta(Hd), s;
  if (n)
    return n.historyState;
  t.getMeta(bGe) && (e = new Ko(e.done, e.undone, null, 0, -1));
  let u = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return e;
  if (u && u.getMeta(Hd))
    return u.getMeta(Hd).redo ? new Ko(e.done.addTransform(t, void 0, i, Ux(r)), e.undone, vD(t.mapping.maps), e.prevTime, e.prevComposition) : new Ko(e.done, e.undone.addTransform(t, void 0, i, Ux(r)), null, e.prevTime, e.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(u && u.getMeta("addToHistory") === !1)) {
    let o = t.getMeta("composition"), d = e.prevTime == 0 || !u && e.prevComposition != o && (e.prevTime < (t.time || 0) - i.newGroupDelay || !gGe(t, e.prevRanges)), a = u ? Zg(e.prevRanges, t.mapping) : vD(t.mapping.maps);
    return new Ko(e.done.addTransform(t, d ? r.selection.getBookmark() : void 0, i, Ux(r)), rs.empty, a, t.time, o ?? e.prevComposition);
  } else return (s = t.getMeta("rebased")) ? new Ko(e.done.rebased(t, s), e.undone.rebased(t, s), Zg(e.prevRanges, t.mapping), e.prevTime, e.prevComposition) : new Ko(e.done.addMaps(t.mapping.maps), e.undone.addMaps(t.mapping.maps), Zg(e.prevRanges, t.mapping), e.prevTime, e.prevComposition);
}
function gGe(e, r) {
  if (!r)
    return !1;
  if (!e.docChanged)
    return !0;
  let t = !1;
  return e.mapping.maps[0].forEach((i, n) => {
    for (let s = 0; s < r.length; s += 2)
      i <= r[s + 1] && n >= r[s] && (t = !0);
  }), t;
}
function vD(e) {
  let r = [];
  for (let t = e.length - 1; t >= 0 && r.length == 0; t--)
    e[t].forEach((i, n, s, u) => r.push(s, u));
  return r;
}
function Zg(e, r) {
  if (!e)
    return null;
  let t = [];
  for (let i = 0; i < e.length; i += 2) {
    let n = r.map(e[i], 1), s = r.map(e[i + 1], -1);
    n <= s && t.push(n, s);
  }
  return t;
}
function vGe(e, r, t) {
  let i = Ux(r), n = Hd.get(r).spec.config, s = (t ? e.undone : e.done).popEvent(r, i);
  if (!s)
    return null;
  let u = s.selection.resolve(s.transform.doc), o = (t ? e.done : e.undone).addTransform(s.transform, r.selection.getBookmark(), n, i), d = new Ko(t ? o : s.remaining, t ? s.remaining : o, null, 0, -1);
  return s.transform.setSelection(u).setMeta(Hd, { redo: t, historyState: d });
}
let Jg = !1, bD = null;
function Ux(e) {
  let r = e.plugins;
  if (bD != r) {
    Jg = !1, bD = r;
    for (let t = 0; t < r.length; t++)
      if (r[t].spec.historyPreserveItems) {
        Jg = !0;
        break;
      }
  }
  return Jg;
}
const Hd = new hs("history"), bGe = new hs("closeHistory");
function yGe(e = {}) {
  return e = {
    depth: e.depth || 100,
    newGroupDelay: e.newGroupDelay || 500
  }, new Ei({
    key: Hd,
    state: {
      init() {
        return new Ko(rs.empty, rs.empty, null, 0, -1);
      },
      apply(r, t, i) {
        return mGe(t, i, r, e);
      }
    },
    config: e,
    props: {
      handleDOMEvents: {
        beforeinput(r, t) {
          let i = t.inputType, n = i == "historyUndo" ? ure : i == "historyRedo" ? ore : null;
          return n ? (t.preventDefault(), n(r.state, r.dispatch)) : !1;
        }
      }
    }
  });
}
function sre(e, r) {
  return (t, i) => {
    let n = Hd.getState(t);
    if (!n || (e ? n.undone : n.done).eventCount == 0)
      return !1;
    if (i) {
      let s = vGe(n, t, e);
      s && i(r ? s.scrollIntoView() : s);
    }
    return !0;
  };
}
const ure = sre(!1, !0), ore = sre(!0, !0), AGe = Bt.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: e, dispatch: r }) => ure(e, r),
      redo: () => ({ state: e, dispatch: r }) => ore(e, r)
    };
  },
  addProseMirrorPlugins() {
    return [
      yGe(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), wGe = Jr.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["hr", Ti(this.options.HTMLAttributes, e)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: e, state: r }) => {
        const { selection: t } = r, { $from: i, $to: n } = t, s = e();
        return i.parentOffset === 0 ? s.insertContentAt({
          from: Math.max(i.pos - 1, 0),
          to: n.pos
        }, {
          type: this.name
        }) : UBe(t) ? s.insertContentAt(n.pos, {
          type: this.name
        }) : s.insertContent({ type: this.name }), s.command(({ tr: u, dispatch: o }) => {
          var d;
          if (o) {
            const { $to: a } = u.selection, V = a.end();
            if (a.nodeAfter)
              a.nodeAfter.isTextblock ? u.setSelection(Ze.create(u.doc, a.pos + 1)) : a.nodeAfter.isBlock ? u.setSelection(ke.create(u.doc, a.pos)) : u.setSelection(Ze.create(u.doc, a.pos));
            else {
              const c = (d = a.parent.type.contentMatch.defaultType) === null || d === void 0 ? void 0 : d.create();
              c && (u.insert(V, c), u.setSelection(Ze.create(u.doc, V + 1)));
            }
            u.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      hWe({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), CGe = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, PGe = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, SGe = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, NGe = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, MGe = Ui.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (e) => e.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (e) => e.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["em", Ti(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: e }) => e.setMark(this.name),
      toggleItalic: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetItalic: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      cl({
        find: CGe,
        type: this.type
      }),
      cl({
        find: SGe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Fl({
        find: PGe,
        type: this.type
      }),
      Fl({
        find: NGe,
        type: this.type
      })
    ];
  }
}), TGe = Jr.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["li", Ti(this.options.HTMLAttributes, e), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), EGe = "listItem", yD = "textStyle", AD = /^(\d+)\.\s$/, kGe = Jr.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (e) => e.hasAttribute("start") ? parseInt(e.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: void 0,
        parseHTML: (e) => e.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    const { start: r, ...t } = e;
    return r === 1 ? ["ol", Ti(this.options.HTMLAttributes, t), 0] : ["ol", Ti(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: e, chain: r }) => this.options.keepAttributes ? r().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(EGe, this.editor.getAttributes(yD)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let e = G7({
      find: AD,
      type: this.type,
      getAttributes: (r) => ({ start: +r[1] }),
      joinPredicate: (r, t) => t.childCount + t.attrs.start === +r[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (e = G7({
      find: AD,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (r) => ({ start: +r[1], ...this.editor.getAttributes(yD) }),
      joinPredicate: (r, t) => t.childCount + t.attrs.start === +r[1],
      editor: this.editor
    })), [
      e
    ];
  }
}), OGe = Jr.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["p", Ti(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: e }) => e.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), DGe = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, RGe = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, IGe = Ui.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (e) => e.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: e }) {
    return ["s", Ti(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: e }) => e.setMark(this.name),
      toggleStrike: () => ({ commands: e }) => e.toggleMark(this.name),
      unsetStrike: () => ({ commands: e }) => e.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      cl({
        find: DGe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Fl({
        find: RGe,
        type: this.type
      })
    ];
  }
}), LGe = Jr.create({
  name: "text",
  group: "inline"
}), _Ge = Bt.create({
  name: "starterKit",
  addExtensions() {
    var e, r, t, i, n, s, u, o, d, a, V, c, F, X, Y, q, f, p;
    const m = [];
    return this.options.bold !== !1 && m.push(UWe.configure((e = this.options) === null || e === void 0 ? void 0 : e.bold)), this.options.blockquote !== !1 && m.push(jWe.configure((r = this.options) === null || r === void 0 ? void 0 : r.blockquote)), this.options.bulletList !== !1 && m.push(JWe.configure((t = this.options) === null || t === void 0 ? void 0 : t.bulletList)), this.options.code !== !1 && m.push(eGe.configure((i = this.options) === null || i === void 0 ? void 0 : i.code)), this.options.codeBlock !== !1 && m.push(iGe.configure((n = this.options) === null || n === void 0 ? void 0 : n.codeBlock)), this.options.document !== !1 && m.push(nGe.configure((s = this.options) === null || s === void 0 ? void 0 : s.document)), this.options.dropcursor !== !1 && m.push(oGe.configure((u = this.options) === null || u === void 0 ? void 0 : u.dropcursor)), this.options.gapcursor !== !1 && m.push(XGe.configure((o = this.options) === null || o === void 0 ? void 0 : o.gapcursor)), this.options.hardBreak !== !1 && m.push(qGe.configure((d = this.options) === null || d === void 0 ? void 0 : d.hardBreak)), this.options.heading !== !1 && m.push(YGe.configure((a = this.options) === null || a === void 0 ? void 0 : a.heading)), this.options.history !== !1 && m.push(AGe.configure((V = this.options) === null || V === void 0 ? void 0 : V.history)), this.options.horizontalRule !== !1 && m.push(wGe.configure((c = this.options) === null || c === void 0 ? void 0 : c.horizontalRule)), this.options.italic !== !1 && m.push(MGe.configure((F = this.options) === null || F === void 0 ? void 0 : F.italic)), this.options.listItem !== !1 && m.push(TGe.configure((X = this.options) === null || X === void 0 ? void 0 : X.listItem)), this.options.orderedList !== !1 && m.push(kGe.configure((Y = this.options) === null || Y === void 0 ? void 0 : Y.orderedList)), this.options.paragraph !== !1 && m.push(OGe.configure((q = this.options) === null || q === void 0 ? void 0 : q.paragraph)), this.options.strike !== !1 && m.push(IGe.configure((f = this.options) === null || f === void 0 ? void 0 : f.strike)), this.options.text !== !1 && m.push(LGe.configure((p = this.options) === null || p === void 0 ? void 0 : p.text)), m;
  }
}), wD = {};
function HGe(e) {
  let r = wD[e];
  if (r)
    return r;
  r = wD[e] = [];
  for (let t = 0; t < 128; t++) {
    const i = String.fromCharCode(t);
    r.push(i);
  }
  for (let t = 0; t < e.length; t++) {
    const i = e.charCodeAt(t);
    r[i] = "%" + ("0" + i.toString(16).toUpperCase()).slice(-2);
  }
  return r;
}
function xl(e, r) {
  typeof r != "string" && (r = xl.defaultChars);
  const t = HGe(r);
  return e.replace(/(%[a-f0-9]{2})+/gi, function(i) {
    let n = "";
    for (let s = 0, u = i.length; s < u; s += 3) {
      const o = parseInt(i.slice(s + 1, s + 3), 16);
      if (o < 128) {
        n += t[o];
        continue;
      }
      if ((o & 224) === 192 && s + 3 < u) {
        const d = parseInt(i.slice(s + 4, s + 6), 16);
        if ((d & 192) === 128) {
          const a = o << 6 & 1984 | d & 63;
          a < 128 ? n += "��" : n += String.fromCharCode(a), s += 3;
          continue;
        }
      }
      if ((o & 240) === 224 && s + 6 < u) {
        const d = parseInt(i.slice(s + 4, s + 6), 16), a = parseInt(i.slice(s + 7, s + 9), 16);
        if ((d & 192) === 128 && (a & 192) === 128) {
          const V = o << 12 & 61440 | d << 6 & 4032 | a & 63;
          V < 2048 || V >= 55296 && V <= 57343 ? n += "���" : n += String.fromCharCode(V), s += 6;
          continue;
        }
      }
      if ((o & 248) === 240 && s + 9 < u) {
        const d = parseInt(i.slice(s + 4, s + 6), 16), a = parseInt(i.slice(s + 7, s + 9), 16), V = parseInt(i.slice(s + 10, s + 12), 16);
        if ((d & 192) === 128 && (a & 192) === 128 && (V & 192) === 128) {
          let c = o << 18 & 1835008 | d << 12 & 258048 | a << 6 & 4032 | V & 63;
          c < 65536 || c > 1114111 ? n += "����" : (c -= 65536, n += String.fromCharCode(55296 + (c >> 10), 56320 + (c & 1023))), s += 9;
          continue;
        }
      }
      n += "�";
    }
    return n;
  });
}
xl.defaultChars = ";/?:@&=+$,#";
xl.componentChars = "";
const CD = {};
function jGe(e) {
  let r = CD[e];
  if (r)
    return r;
  r = CD[e] = [];
  for (let t = 0; t < 128; t++) {
    const i = String.fromCharCode(t);
    /^[0-9a-z]$/i.test(i) ? r.push(i) : r.push("%" + ("0" + t.toString(16).toUpperCase()).slice(-2));
  }
  for (let t = 0; t < e.length; t++)
    r[e.charCodeAt(t)] = e[t];
  return r;
}
function D2(e, r, t) {
  typeof r != "string" && (t = r, r = D2.defaultChars), typeof t > "u" && (t = !0);
  const i = jGe(r);
  let n = "";
  for (let s = 0, u = e.length; s < u; s++) {
    const o = e.charCodeAt(s);
    if (t && o === 37 && s + 2 < u && /^[0-9a-f]{2}$/i.test(e.slice(s + 1, s + 3))) {
      n += e.slice(s, s + 3), s += 2;
      continue;
    }
    if (o < 128) {
      n += i[o];
      continue;
    }
    if (o >= 55296 && o <= 57343) {
      if (o >= 55296 && o <= 56319 && s + 1 < u) {
        const d = e.charCodeAt(s + 1);
        if (d >= 56320 && d <= 57343) {
          n += encodeURIComponent(e[s] + e[s + 1]), s++;
          continue;
        }
      }
      n += "%EF%BF%BD";
      continue;
    }
    n += encodeURIComponent(e[s]);
  }
  return n;
}
D2.defaultChars = ";/?:@&=+$,-_.!~*'()#";
D2.componentChars = "-_.!~*'()";
function r5(e) {
  let r = "";
  return r += e.protocol || "", r += e.slashes ? "//" : "", r += e.auth ? e.auth + "@" : "", e.hostname && e.hostname.indexOf(":") !== -1 ? r += "[" + e.hostname + "]" : r += e.hostname || "", r += e.port ? ":" + e.port : "", r += e.pathname || "", r += e.search || "", r += e.hash || "", r;
}
function Pq() {
  this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
}
const zGe = /^([a-z0-9.+-]+:)/i, BGe = /:[0-9]*$/, WGe = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, GGe = ["<", ">", '"', "`", " ", "\r", `
`, "	"], UGe = ["{", "}", "|", "\\", "^", "`"].concat(GGe), ZGe = ["'"].concat(UGe), PD = ["%", "/", "?", ";", "#"].concat(ZGe), SD = ["/", "?", "#"], JGe = 255, ND = /^[+a-z0-9A-Z_-]{0,63}$/, $Ge = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, MD = {
  javascript: !0,
  "javascript:": !0
}, TD = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
};
function t5(e, r) {
  if (e && e instanceof Pq) return e;
  const t = new Pq();
  return t.parse(e, r), t;
}
Pq.prototype.parse = function(e, r) {
  let t, i, n, s = e;
  if (s = s.trim(), !r && e.split("#").length === 1) {
    const a = WGe.exec(s);
    if (a)
      return this.pathname = a[1], a[2] && (this.search = a[2]), this;
  }
  let u = zGe.exec(s);
  if (u && (u = u[0], t = u.toLowerCase(), this.protocol = u, s = s.substr(u.length)), (r || u || s.match(/^\/\/[^@\/]+@[^@\/]+/)) && (n = s.substr(0, 2) === "//", n && !(u && MD[u]) && (s = s.substr(2), this.slashes = !0)), !MD[u] && (n || u && !TD[u])) {
    let a = -1;
    for (let Y = 0; Y < SD.length; Y++)
      i = s.indexOf(SD[Y]), i !== -1 && (a === -1 || i < a) && (a = i);
    let V, c;
    a === -1 ? c = s.lastIndexOf("@") : c = s.lastIndexOf("@", a), c !== -1 && (V = s.slice(0, c), s = s.slice(c + 1), this.auth = V), a = -1;
    for (let Y = 0; Y < PD.length; Y++)
      i = s.indexOf(PD[Y]), i !== -1 && (a === -1 || i < a) && (a = i);
    a === -1 && (a = s.length), s[a - 1] === ":" && a--;
    const F = s.slice(0, a);
    s = s.slice(a), this.parseHost(F), this.hostname = this.hostname || "";
    const X = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!X) {
      const Y = this.hostname.split(/\./);
      for (let q = 0, f = Y.length; q < f; q++) {
        const p = Y[q];
        if (p && !p.match(ND)) {
          let m = "";
          for (let g = 0, y = p.length; g < y; g++)
            p.charCodeAt(g) > 127 ? m += "x" : m += p[g];
          if (!m.match(ND)) {
            const g = Y.slice(0, q), y = Y.slice(q + 1), b = p.match($Ge);
            b && (g.push(b[1]), y.unshift(b[2])), y.length && (s = y.join(".") + s), this.hostname = g.join(".");
            break;
          }
        }
      }
    }
    this.hostname.length > JGe && (this.hostname = ""), X && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
  }
  const o = s.indexOf("#");
  o !== -1 && (this.hash = s.substr(o), s = s.slice(0, o));
  const d = s.indexOf("?");
  return d !== -1 && (this.search = s.substr(d), s = s.slice(0, d)), s && (this.pathname = s), TD[t] && this.hostname && !this.pathname && (this.pathname = ""), this;
};
Pq.prototype.parseHost = function(e) {
  let r = BGe.exec(e);
  r && (r = r[0], r !== ":" && (this.port = r.substr(1)), e = e.substr(0, e.length - r.length)), e && (this.hostname = e);
};
const QGe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: xl,
  encode: D2,
  format: r5,
  parse: t5
}, Symbol.toStringTag, { value: "Module" })), dre = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, are = /[\0-\x1F\x7F-\x9F]/, eUe = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/, i5 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, Vre = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/, lre = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/, rUe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Any: dre,
  Cc: are,
  Cf: eUe,
  P: i5,
  S: Vre,
  Z: lre
}, Symbol.toStringTag, { value: "Module" })), tUe = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), iUe = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((e) => e.charCodeAt(0))
);
var $g;
const nUe = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), sUe = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  ($g = String.fromCodePoint) !== null && $g !== void 0 ? $g : function(e) {
    let r = "";
    return e > 65535 && (e -= 65536, r += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | e & 1023), r += String.fromCharCode(e), r;
  }
);
function uUe(e) {
  var r;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (r = nUe.get(e)) !== null && r !== void 0 ? r : e;
}
var _t;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(_t || (_t = {}));
const oUe = 32;
var So;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(So || (So = {}));
function Yy(e) {
  return e >= _t.ZERO && e <= _t.NINE;
}
function dUe(e) {
  return e >= _t.UPPER_A && e <= _t.UPPER_F || e >= _t.LOWER_A && e <= _t.LOWER_F;
}
function aUe(e) {
  return e >= _t.UPPER_A && e <= _t.UPPER_Z || e >= _t.LOWER_A && e <= _t.LOWER_Z || Yy(e);
}
function VUe(e) {
  return e === _t.EQUALS || aUe(e);
}
var Ot;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(Ot || (Ot = {}));
var go;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(go || (go = {}));
class lUe {
  constructor(r, t, i) {
    this.decodeTree = r, this.emitCodePoint = t, this.errors = i, this.state = Ot.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = go.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(r) {
    this.decodeMode = r, this.state = Ot.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(r, t) {
    switch (this.state) {
      case Ot.EntityStart:
        return r.charCodeAt(t) === _t.NUM ? (this.state = Ot.NumericStart, this.consumed += 1, this.stateNumericStart(r, t + 1)) : (this.state = Ot.NamedEntity, this.stateNamedEntity(r, t));
      case Ot.NumericStart:
        return this.stateNumericStart(r, t);
      case Ot.NumericDecimal:
        return this.stateNumericDecimal(r, t);
      case Ot.NumericHex:
        return this.stateNumericHex(r, t);
      case Ot.NamedEntity:
        return this.stateNamedEntity(r, t);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(r, t) {
    return t >= r.length ? -1 : (r.charCodeAt(t) | oUe) === _t.LOWER_X ? (this.state = Ot.NumericHex, this.consumed += 1, this.stateNumericHex(r, t + 1)) : (this.state = Ot.NumericDecimal, this.stateNumericDecimal(r, t));
  }
  addToNumericResult(r, t, i, n) {
    if (t !== i) {
      const s = i - t;
      this.result = this.result * Math.pow(n, s) + parseInt(r.substr(t, s), n), this.consumed += s;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(r, t) {
    const i = t;
    for (; t < r.length; ) {
      const n = r.charCodeAt(t);
      if (Yy(n) || dUe(n))
        t += 1;
      else
        return this.addToNumericResult(r, i, t, 16), this.emitNumericEntity(n, 3);
    }
    return this.addToNumericResult(r, i, t, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(r, t) {
    const i = t;
    for (; t < r.length; ) {
      const n = r.charCodeAt(t);
      if (Yy(n))
        t += 1;
      else
        return this.addToNumericResult(r, i, t, 10), this.emitNumericEntity(n, 2);
    }
    return this.addToNumericResult(r, i, t, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(r, t) {
    var i;
    if (this.consumed <= t)
      return (i = this.errors) === null || i === void 0 || i.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (r === _t.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === go.Strict)
      return 0;
    return this.emitCodePoint(uUe(this.result), this.consumed), this.errors && (r !== _t.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(r, t) {
    const { decodeTree: i } = this;
    let n = i[this.treeIndex], s = (n & So.VALUE_LENGTH) >> 14;
    for (; t < r.length; t++, this.excess++) {
      const u = r.charCodeAt(t);
      if (this.treeIndex = cUe(i, n, this.treeIndex + Math.max(1, s), u), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === go.Attribute && // We shouldn't have consumed any characters after the entity,
        (s === 0 || // And there should be no invalid characters.
        VUe(u)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (n = i[this.treeIndex], s = (n & So.VALUE_LENGTH) >> 14, s !== 0) {
        if (u === _t.SEMI)
          return this.emitNamedEntityData(this.treeIndex, s, this.consumed + this.excess);
        this.decodeMode !== go.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var r;
    const { result: t, decodeTree: i } = this, n = (i[t] & So.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(t, n, this.consumed), (r = this.errors) === null || r === void 0 || r.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(r, t, i) {
    const { decodeTree: n } = this;
    return this.emitCodePoint(t === 1 ? n[r] & ~So.VALUE_LENGTH : n[r + 1], i), t === 3 && this.emitCodePoint(n[r + 2], i), i;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var r;
    switch (this.state) {
      case Ot.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== go.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case Ot.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case Ot.NumericHex:
        return this.emitNumericEntity(0, 3);
      case Ot.NumericStart:
        return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case Ot.EntityStart:
        return 0;
    }
  }
}
function cre(e) {
  let r = "";
  const t = new lUe(e, (i) => r += sUe(i));
  return function(n, s) {
    let u = 0, o = 0;
    for (; (o = n.indexOf("&", o)) >= 0; ) {
      r += n.slice(u, o), t.startEntity(s);
      const a = t.write(
        n,
        // Skip the "&"
        o + 1
      );
      if (a < 0) {
        u = o + t.end();
        break;
      }
      u = o + a, o = a === 0 ? u + 1 : u;
    }
    const d = r + n.slice(u);
    return r = "", d;
  };
}
function cUe(e, r, t, i) {
  const n = (r & So.BRANCH_LENGTH) >> 7, s = r & So.JUMP_TABLE;
  if (n === 0)
    return s !== 0 && i === s ? t : -1;
  if (s) {
    const d = i - s;
    return d < 0 || d >= n ? -1 : e[t + d] - 1;
  }
  let u = t, o = u + n - 1;
  for (; u <= o; ) {
    const d = u + o >>> 1, a = e[d];
    if (a < i)
      u = d + 1;
    else if (a > i)
      o = d - 1;
    else
      return e[d + n];
  }
  return -1;
}
const FUe = cre(tUe);
cre(iUe);
function Fre(e, r = go.Legacy) {
  return FUe(e, r);
}
function xUe(e) {
  return Object.prototype.toString.call(e);
}
function n5(e) {
  return xUe(e) === "[object String]";
}
const XUe = Object.prototype.hasOwnProperty;
function qUe(e, r) {
  return XUe.call(e, r);
}
function Gf(e) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(t) {
    if (t) {
      if (typeof t != "object")
        throw new TypeError(t + "must be object");
      Object.keys(t).forEach(function(i) {
        e[i] = t[i];
      });
    }
  }), e;
}
function xre(e, r, t) {
  return [].concat(e.slice(0, r), t, e.slice(r + 1));
}
function s5(e) {
  return !(e >= 55296 && e <= 57343 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 || (e & 65535) === 65534 || e >= 0 && e <= 8 || e === 11 || e >= 14 && e <= 31 || e >= 127 && e <= 159 || e > 1114111);
}
function Sq(e) {
  if (e > 65535) {
    e -= 65536;
    const r = 55296 + (e >> 10), t = 56320 + (e & 1023);
    return String.fromCharCode(r, t);
  }
  return String.fromCharCode(e);
}
const Xre = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g, YUe = /&([a-z#][a-z0-9]{1,31});/gi, fUe = new RegExp(Xre.source + "|" + YUe.source, "gi"), KUe = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function hUe(e, r) {
  if (r.charCodeAt(0) === 35 && KUe.test(r)) {
    const i = r[1].toLowerCase() === "x" ? parseInt(r.slice(2), 16) : parseInt(r.slice(1), 10);
    return s5(i) ? Sq(i) : e;
  }
  const t = Fre(e);
  return t !== e ? t : e;
}
function pUe(e) {
  return e.indexOf("\\") < 0 ? e : e.replace(Xre, "$1");
}
function Xl(e) {
  return e.indexOf("\\") < 0 && e.indexOf("&") < 0 ? e : e.replace(fUe, function(r, t, i) {
    return t || hUe(r, i);
  });
}
const mUe = /[&<>"]/, gUe = /[&<>"]/g, vUe = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;"
};
function bUe(e) {
  return vUe[e];
}
function zo(e) {
  return mUe.test(e) ? e.replace(gUe, bUe) : e;
}
const yUe = /[.?*+^$[\]\\(){}|-]/g;
function AUe(e) {
  return e.replace(yUe, "\\$&");
}
function Wr(e) {
  switch (e) {
    case 9:
    case 32:
      return !0;
  }
  return !1;
}
function U7(e) {
  if (e >= 8192 && e <= 8202)
    return !0;
  switch (e) {
    case 9:
    // \t
    case 10:
    // \n
    case 11:
    // \v
    case 12:
    // \f
    case 13:
    // \r
    case 32:
    case 160:
    case 5760:
    case 8239:
    case 8287:
    case 12288:
      return !0;
  }
  return !1;
}
function Z7(e) {
  return i5.test(e) || Vre.test(e);
}
function J7(e) {
  switch (e) {
    case 33:
    case 34:
    case 35:
    case 36:
    case 37:
    case 38:
    case 39:
    case 40:
    case 41:
    case 42:
    case 43:
    case 44:
    case 45:
    case 46:
    case 47:
    case 58:
    case 59:
    case 60:
    case 61:
    case 62:
    case 63:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 124:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function Uf(e) {
  return e = e.trim().replace(/\s+/g, " "), "ẞ".toLowerCase() === "Ṿ" && (e = e.replace(/ẞ/g, "ß")), e.toLowerCase().toUpperCase();
}
const wUe = { mdurl: QGe, ucmicro: rUe }, CUe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrayReplaceAt: xre,
  assign: Gf,
  escapeHtml: zo,
  escapeRE: AUe,
  fromCodePoint: Sq,
  has: qUe,
  isMdAsciiPunct: J7,
  isPunctChar: Z7,
  isSpace: Wr,
  isString: n5,
  isValidEntityCode: s5,
  isWhiteSpace: U7,
  lib: wUe,
  normalizeReference: Uf,
  unescapeAll: Xl,
  unescapeMd: pUe
}, Symbol.toStringTag, { value: "Module" }));
function PUe(e, r, t) {
  let i, n, s, u;
  const o = e.posMax, d = e.pos;
  for (e.pos = r + 1, i = 1; e.pos < o; ) {
    if (s = e.src.charCodeAt(e.pos), s === 93 && (i--, i === 0)) {
      n = !0;
      break;
    }
    if (u = e.pos, e.md.inline.skipToken(e), s === 91) {
      if (u === e.pos - 1)
        i++;
      else if (t)
        return e.pos = d, -1;
    }
  }
  let a = -1;
  return n && (a = e.pos), e.pos = d, a;
}
function SUe(e, r, t) {
  let i, n = r;
  const s = {
    ok: !1,
    pos: 0,
    str: ""
  };
  if (e.charCodeAt(n) === 60) {
    for (n++; n < t; ) {
      if (i = e.charCodeAt(n), i === 10 || i === 60)
        return s;
      if (i === 62)
        return s.pos = n + 1, s.str = Xl(e.slice(r + 1, n)), s.ok = !0, s;
      if (i === 92 && n + 1 < t) {
        n += 2;
        continue;
      }
      n++;
    }
    return s;
  }
  let u = 0;
  for (; n < t && (i = e.charCodeAt(n), !(i === 32 || i < 32 || i === 127)); ) {
    if (i === 92 && n + 1 < t) {
      if (e.charCodeAt(n + 1) === 32)
        break;
      n += 2;
      continue;
    }
    if (i === 40 && (u++, u > 32))
      return s;
    if (i === 41) {
      if (u === 0)
        break;
      u--;
    }
    n++;
  }
  return r === n || u !== 0 || (s.str = Xl(e.slice(r, n)), s.pos = n, s.ok = !0), s;
}
function NUe(e, r, t, i) {
  let n, s = r;
  const u = {
    // if `true`, this is a valid link title
    ok: !1,
    // if `true`, this link can be continued on the next line
    can_continue: !1,
    // if `ok`, it's the position of the first character after the closing marker
    pos: 0,
    // if `ok`, it's the unescaped title
    str: "",
    // expected closing marker character code
    marker: 0
  };
  if (i)
    u.str = i.str, u.marker = i.marker;
  else {
    if (s >= t)
      return u;
    let o = e.charCodeAt(s);
    if (o !== 34 && o !== 39 && o !== 40)
      return u;
    r++, s++, o === 40 && (o = 41), u.marker = o;
  }
  for (; s < t; ) {
    if (n = e.charCodeAt(s), n === u.marker)
      return u.pos = s + 1, u.str += Xl(e.slice(r, s)), u.ok = !0, u;
    if (n === 40 && u.marker === 41)
      return u;
    n === 92 && s + 1 < t && s++, s++;
  }
  return u.can_continue = !0, u.str += Xl(e.slice(r, s)), u;
}
const MUe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  parseLinkDestination: SUe,
  parseLinkLabel: PUe,
  parseLinkTitle: NUe
}, Symbol.toStringTag, { value: "Module" })), iu = {};
iu.code_inline = function(e, r, t, i, n) {
  const s = e[r];
  return "<code" + n.renderAttrs(s) + ">" + zo(s.content) + "</code>";
};
iu.code_block = function(e, r, t, i, n) {
  const s = e[r];
  return "<pre" + n.renderAttrs(s) + "><code>" + zo(e[r].content) + `</code></pre>
`;
};
iu.fence = function(e, r, t, i, n) {
  const s = e[r], u = s.info ? Xl(s.info).trim() : "";
  let o = "", d = "";
  if (u) {
    const V = u.split(/(\s+)/g);
    o = V[0], d = V.slice(2).join("");
  }
  let a;
  if (t.highlight ? a = t.highlight(s.content, o, d) || zo(s.content) : a = zo(s.content), a.indexOf("<pre") === 0)
    return a + `
`;
  if (u) {
    const V = s.attrIndex("class"), c = s.attrs ? s.attrs.slice() : [];
    V < 0 ? c.push(["class", t.langPrefix + o]) : (c[V] = c[V].slice(), c[V][1] += " " + t.langPrefix + o);
    const F = {
      attrs: c
    };
    return `<pre><code${n.renderAttrs(F)}>${a}</code></pre>
`;
  }
  return `<pre><code${n.renderAttrs(s)}>${a}</code></pre>
`;
};
iu.image = function(e, r, t, i, n) {
  const s = e[r];
  return s.attrs[s.attrIndex("alt")][1] = n.renderInlineAsText(s.children, t, i), n.renderToken(e, r, t);
};
iu.hardbreak = function(e, r, t) {
  return t.xhtmlOut ? `<br />
` : `<br>
`;
};
iu.softbreak = function(e, r, t) {
  return t.breaks ? t.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
iu.text = function(e, r) {
  return zo(e[r].content);
};
iu.html_block = function(e, r) {
  return e[r].content;
};
iu.html_inline = function(e, r) {
  return e[r].content;
};
function Ll() {
  this.rules = Gf({}, iu);
}
Ll.prototype.renderAttrs = function(r) {
  let t, i, n;
  if (!r.attrs)
    return "";
  for (n = "", t = 0, i = r.attrs.length; t < i; t++)
    n += " " + zo(r.attrs[t][0]) + '="' + zo(r.attrs[t][1]) + '"';
  return n;
};
Ll.prototype.renderToken = function(r, t, i) {
  const n = r[t];
  let s = "";
  if (n.hidden)
    return "";
  n.block && n.nesting !== -1 && t && r[t - 1].hidden && (s += `
`), s += (n.nesting === -1 ? "</" : "<") + n.tag, s += this.renderAttrs(n), n.nesting === 0 && i.xhtmlOut && (s += " /");
  let u = !1;
  if (n.block && (u = !0, n.nesting === 1 && t + 1 < r.length)) {
    const o = r[t + 1];
    (o.type === "inline" || o.hidden || o.nesting === -1 && o.tag === n.tag) && (u = !1);
  }
  return s += u ? `>
` : ">", s;
};
Ll.prototype.renderInline = function(e, r, t) {
  let i = "";
  const n = this.rules;
  for (let s = 0, u = e.length; s < u; s++) {
    const o = e[s].type;
    typeof n[o] < "u" ? i += n[o](e, s, r, t, this) : i += this.renderToken(e, s, r);
  }
  return i;
};
Ll.prototype.renderInlineAsText = function(e, r, t) {
  let i = "";
  for (let n = 0, s = e.length; n < s; n++)
    switch (e[n].type) {
      case "text":
        i += e[n].content;
        break;
      case "image":
        i += this.renderInlineAsText(e[n].children, r, t);
        break;
      case "html_inline":
      case "html_block":
        i += e[n].content;
        break;
      case "softbreak":
      case "hardbreak":
        i += `
`;
        break;
    }
  return i;
};
Ll.prototype.render = function(e, r, t) {
  let i = "";
  const n = this.rules;
  for (let s = 0, u = e.length; s < u; s++) {
    const o = e[s].type;
    o === "inline" ? i += this.renderInline(e[s].children, r, t) : typeof n[o] < "u" ? i += n[o](e, s, r, t, this) : i += this.renderToken(e, s, r, t);
  }
  return i;
};
function Zi() {
  this.__rules__ = [], this.__cache__ = null;
}
Zi.prototype.__find__ = function(e) {
  for (let r = 0; r < this.__rules__.length; r++)
    if (this.__rules__[r].name === e)
      return r;
  return -1;
};
Zi.prototype.__compile__ = function() {
  const e = this, r = [""];
  e.__rules__.forEach(function(t) {
    t.enabled && t.alt.forEach(function(i) {
      r.indexOf(i) < 0 && r.push(i);
    });
  }), e.__cache__ = {}, r.forEach(function(t) {
    e.__cache__[t] = [], e.__rules__.forEach(function(i) {
      i.enabled && (t && i.alt.indexOf(t) < 0 || e.__cache__[t].push(i.fn));
    });
  });
};
Zi.prototype.at = function(e, r, t) {
  const i = this.__find__(e), n = t || {};
  if (i === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__[i].fn = r, this.__rules__[i].alt = n.alt || [], this.__cache__ = null;
};
Zi.prototype.before = function(e, r, t, i) {
  const n = this.__find__(e), s = i || {};
  if (n === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(n, 0, {
    name: r,
    enabled: !0,
    fn: t,
    alt: s.alt || []
  }), this.__cache__ = null;
};
Zi.prototype.after = function(e, r, t, i) {
  const n = this.__find__(e), s = i || {};
  if (n === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(n + 1, 0, {
    name: r,
    enabled: !0,
    fn: t,
    alt: s.alt || []
  }), this.__cache__ = null;
};
Zi.prototype.push = function(e, r, t) {
  const i = t || {};
  this.__rules__.push({
    name: e,
    enabled: !0,
    fn: r,
    alt: i.alt || []
  }), this.__cache__ = null;
};
Zi.prototype.enable = function(e, r) {
  Array.isArray(e) || (e = [e]);
  const t = [];
  return e.forEach(function(i) {
    const n = this.__find__(i);
    if (n < 0) {
      if (r)
        return;
      throw new Error("Rules manager: invalid rule name " + i);
    }
    this.__rules__[n].enabled = !0, t.push(i);
  }, this), this.__cache__ = null, t;
};
Zi.prototype.enableOnly = function(e, r) {
  Array.isArray(e) || (e = [e]), this.__rules__.forEach(function(t) {
    t.enabled = !1;
  }), this.enable(e, r);
};
Zi.prototype.disable = function(e, r) {
  Array.isArray(e) || (e = [e]);
  const t = [];
  return e.forEach(function(i) {
    const n = this.__find__(i);
    if (n < 0) {
      if (r)
        return;
      throw new Error("Rules manager: invalid rule name " + i);
    }
    this.__rules__[n].enabled = !1, t.push(i);
  }, this), this.__cache__ = null, t;
};
Zi.prototype.getRules = function(e) {
  return this.__cache__ === null && this.__compile__(), this.__cache__[e] || [];
};
function ps(e, r, t) {
  this.type = e, this.tag = r, this.attrs = null, this.map = null, this.nesting = t, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
ps.prototype.attrIndex = function(r) {
  if (!this.attrs)
    return -1;
  const t = this.attrs;
  for (let i = 0, n = t.length; i < n; i++)
    if (t[i][0] === r)
      return i;
  return -1;
};
ps.prototype.attrPush = function(r) {
  this.attrs ? this.attrs.push(r) : this.attrs = [r];
};
ps.prototype.attrSet = function(r, t) {
  const i = this.attrIndex(r), n = [r, t];
  i < 0 ? this.attrPush(n) : this.attrs[i] = n;
};
ps.prototype.attrGet = function(r) {
  const t = this.attrIndex(r);
  let i = null;
  return t >= 0 && (i = this.attrs[t][1]), i;
};
ps.prototype.attrJoin = function(r, t) {
  const i = this.attrIndex(r);
  i < 0 ? this.attrPush([r, t]) : this.attrs[i][1] = this.attrs[i][1] + " " + t;
};
function qre(e, r, t) {
  this.src = e, this.env = t, this.tokens = [], this.inlineMode = !1, this.md = r;
}
qre.prototype.Token = ps;
const TUe = /\r\n?|\n/g, EUe = /\0/g;
function kUe(e) {
  let r;
  r = e.src.replace(TUe, `
`), r = r.replace(EUe, "�"), e.src = r;
}
function OUe(e) {
  let r;
  e.inlineMode ? (r = new e.Token("inline", "", 0), r.content = e.src, r.map = [0, 1], r.children = [], e.tokens.push(r)) : e.md.block.parse(e.src, e.md, e.env, e.tokens);
}
function DUe(e) {
  const r = e.tokens;
  for (let t = 0, i = r.length; t < i; t++) {
    const n = r[t];
    n.type === "inline" && e.md.inline.parse(n.content, e.md, e.env, n.children);
  }
}
function RUe(e) {
  return /^<a[>\s]/i.test(e);
}
function IUe(e) {
  return /^<\/a\s*>/i.test(e);
}
function LUe(e) {
  const r = e.tokens;
  if (e.md.options.linkify)
    for (let t = 0, i = r.length; t < i; t++) {
      if (r[t].type !== "inline" || !e.md.linkify.pretest(r[t].content))
        continue;
      let n = r[t].children, s = 0;
      for (let u = n.length - 1; u >= 0; u--) {
        const o = n[u];
        if (o.type === "link_close") {
          for (u--; n[u].level !== o.level && n[u].type !== "link_open"; )
            u--;
          continue;
        }
        if (o.type === "html_inline" && (RUe(o.content) && s > 0 && s--, IUe(o.content) && s++), !(s > 0) && o.type === "text" && e.md.linkify.test(o.content)) {
          const d = o.content;
          let a = e.md.linkify.match(d);
          const V = [];
          let c = o.level, F = 0;
          a.length > 0 && a[0].index === 0 && u > 0 && n[u - 1].type === "text_special" && (a = a.slice(1));
          for (let X = 0; X < a.length; X++) {
            const Y = a[X].url, q = e.md.normalizeLink(Y);
            if (!e.md.validateLink(q))
              continue;
            let f = a[X].text;
            a[X].schema ? a[X].schema === "mailto:" && !/^mailto:/i.test(f) ? f = e.md.normalizeLinkText("mailto:" + f).replace(/^mailto:/, "") : f = e.md.normalizeLinkText(f) : f = e.md.normalizeLinkText("http://" + f).replace(/^http:\/\//, "");
            const p = a[X].index;
            if (p > F) {
              const b = new e.Token("text", "", 0);
              b.content = d.slice(F, p), b.level = c, V.push(b);
            }
            const m = new e.Token("link_open", "a", 1);
            m.attrs = [["href", q]], m.level = c++, m.markup = "linkify", m.info = "auto", V.push(m);
            const g = new e.Token("text", "", 0);
            g.content = f, g.level = c, V.push(g);
            const y = new e.Token("link_close", "a", -1);
            y.level = --c, y.markup = "linkify", y.info = "auto", V.push(y), F = a[X].lastIndex;
          }
          if (F < d.length) {
            const X = new e.Token("text", "", 0);
            X.content = d.slice(F), X.level = c, V.push(X);
          }
          r[t].children = n = xre(n, u, V);
        }
      }
    }
}
const Yre = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, _Ue = /\((c|tm|r)\)/i, HUe = /\((c|tm|r)\)/ig, jUe = {
  c: "©",
  r: "®",
  tm: "™"
};
function zUe(e, r) {
  return jUe[r.toLowerCase()];
}
function BUe(e) {
  let r = 0;
  for (let t = e.length - 1; t >= 0; t--) {
    const i = e[t];
    i.type === "text" && !r && (i.content = i.content.replace(HUe, zUe)), i.type === "link_open" && i.info === "auto" && r--, i.type === "link_close" && i.info === "auto" && r++;
  }
}
function WUe(e) {
  let r = 0;
  for (let t = e.length - 1; t >= 0; t--) {
    const i = e[t];
    i.type === "text" && !r && Yre.test(i.content) && (i.content = i.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—").replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–")), i.type === "link_open" && i.info === "auto" && r--, i.type === "link_close" && i.info === "auto" && r++;
  }
}
function GUe(e) {
  let r;
  if (e.md.options.typographer)
    for (r = e.tokens.length - 1; r >= 0; r--)
      e.tokens[r].type === "inline" && (_Ue.test(e.tokens[r].content) && BUe(e.tokens[r].children), Yre.test(e.tokens[r].content) && WUe(e.tokens[r].children));
}
const UUe = /['"]/, ED = /['"]/g, kD = "’";
function Sx(e, r, t) {
  return e.slice(0, r) + t + e.slice(r + 1);
}
function ZUe(e, r) {
  let t;
  const i = [];
  for (let n = 0; n < e.length; n++) {
    const s = e[n], u = e[n].level;
    for (t = i.length - 1; t >= 0 && !(i[t].level <= u); t--)
      ;
    if (i.length = t + 1, s.type !== "text")
      continue;
    let o = s.content, d = 0, a = o.length;
    e:
      for (; d < a; ) {
        ED.lastIndex = d;
        const V = ED.exec(o);
        if (!V)
          break;
        let c = !0, F = !0;
        d = V.index + 1;
        const X = V[0] === "'";
        let Y = 32;
        if (V.index - 1 >= 0)
          Y = o.charCodeAt(V.index - 1);
        else
          for (t = n - 1; t >= 0 && !(e[t].type === "softbreak" || e[t].type === "hardbreak"); t--)
            if (e[t].content) {
              Y = e[t].content.charCodeAt(e[t].content.length - 1);
              break;
            }
        let q = 32;
        if (d < a)
          q = o.charCodeAt(d);
        else
          for (t = n + 1; t < e.length && !(e[t].type === "softbreak" || e[t].type === "hardbreak"); t++)
            if (e[t].content) {
              q = e[t].content.charCodeAt(0);
              break;
            }
        const f = J7(Y) || Z7(String.fromCharCode(Y)), p = J7(q) || Z7(String.fromCharCode(q)), m = U7(Y), g = U7(q);
        if (g ? c = !1 : p && (m || f || (c = !1)), m ? F = !1 : f && (g || p || (F = !1)), q === 34 && V[0] === '"' && Y >= 48 && Y <= 57 && (F = c = !1), c && F && (c = f, F = p), !c && !F) {
          X && (s.content = Sx(s.content, V.index, kD));
          continue;
        }
        if (F)
          for (t = i.length - 1; t >= 0; t--) {
            let y = i[t];
            if (i[t].level < u)
              break;
            if (y.single === X && i[t].level === u) {
              y = i[t];
              let b, A;
              X ? (b = r.md.options.quotes[2], A = r.md.options.quotes[3]) : (b = r.md.options.quotes[0], A = r.md.options.quotes[1]), s.content = Sx(s.content, V.index, A), e[y.token].content = Sx(
                e[y.token].content,
                y.pos,
                b
              ), d += A.length - 1, y.token === n && (d += b.length - 1), o = s.content, a = o.length, i.length = t;
              continue e;
            }
          }
        c ? i.push({
          token: n,
          pos: V.index,
          single: X,
          level: u
        }) : F && X && (s.content = Sx(s.content, V.index, kD));
      }
  }
}
function JUe(e) {
  if (e.md.options.typographer)
    for (let r = e.tokens.length - 1; r >= 0; r--)
      e.tokens[r].type !== "inline" || !UUe.test(e.tokens[r].content) || ZUe(e.tokens[r].children, e);
}
function $Ue(e) {
  let r, t;
  const i = e.tokens, n = i.length;
  for (let s = 0; s < n; s++) {
    if (i[s].type !== "inline") continue;
    const u = i[s].children, o = u.length;
    for (r = 0; r < o; r++)
      u[r].type === "text_special" && (u[r].type = "text");
    for (r = t = 0; r < o; r++)
      u[r].type === "text" && r + 1 < o && u[r + 1].type === "text" ? u[r + 1].content = u[r].content + u[r + 1].content : (r !== t && (u[t] = u[r]), t++);
    r !== t && (u.length = t);
  }
}
const Qg = [
  ["normalize", kUe],
  ["block", OUe],
  ["inline", DUe],
  ["linkify", LUe],
  ["replacements", GUe],
  ["smartquotes", JUe],
  // `text_join` finds `text_special` tokens (for escape sequences)
  // and joins them with the rest of the text
  ["text_join", $Ue]
];
function u5() {
  this.ruler = new Zi();
  for (let e = 0; e < Qg.length; e++)
    this.ruler.push(Qg[e][0], Qg[e][1]);
}
u5.prototype.process = function(e) {
  const r = this.ruler.getRules("");
  for (let t = 0, i = r.length; t < i; t++)
    r[t](e);
};
u5.prototype.State = qre;
function nu(e, r, t, i) {
  this.src = e, this.md = r, this.env = t, this.tokens = i, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0;
  const n = this.src;
  for (let s = 0, u = 0, o = 0, d = 0, a = n.length, V = !1; u < a; u++) {
    const c = n.charCodeAt(u);
    if (!V)
      if (Wr(c)) {
        o++, c === 9 ? d += 4 - d % 4 : d++;
        continue;
      } else
        V = !0;
    (c === 10 || u === a - 1) && (c !== 10 && u++, this.bMarks.push(s), this.eMarks.push(u), this.tShift.push(o), this.sCount.push(d), this.bsCount.push(0), V = !1, o = 0, d = 0, s = u + 1);
  }
  this.bMarks.push(n.length), this.eMarks.push(n.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
nu.prototype.push = function(e, r, t) {
  const i = new ps(e, r, t);
  return i.block = !0, t < 0 && this.level--, i.level = this.level, t > 0 && this.level++, this.tokens.push(i), i;
};
nu.prototype.isEmpty = function(r) {
  return this.bMarks[r] + this.tShift[r] >= this.eMarks[r];
};
nu.prototype.skipEmptyLines = function(r) {
  for (let t = this.lineMax; r < t && !(this.bMarks[r] + this.tShift[r] < this.eMarks[r]); r++)
    ;
  return r;
};
nu.prototype.skipSpaces = function(r) {
  for (let t = this.src.length; r < t; r++) {
    const i = this.src.charCodeAt(r);
    if (!Wr(i))
      break;
  }
  return r;
};
nu.prototype.skipSpacesBack = function(r, t) {
  if (r <= t)
    return r;
  for (; r > t; )
    if (!Wr(this.src.charCodeAt(--r)))
      return r + 1;
  return r;
};
nu.prototype.skipChars = function(r, t) {
  for (let i = this.src.length; r < i && this.src.charCodeAt(r) === t; r++)
    ;
  return r;
};
nu.prototype.skipCharsBack = function(r, t, i) {
  if (r <= i)
    return r;
  for (; r > i; )
    if (t !== this.src.charCodeAt(--r))
      return r + 1;
  return r;
};
nu.prototype.getLines = function(r, t, i, n) {
  if (r >= t)
    return "";
  const s = new Array(t - r);
  for (let u = 0, o = r; o < t; o++, u++) {
    let d = 0;
    const a = this.bMarks[o];
    let V = a, c;
    for (o + 1 < t || n ? c = this.eMarks[o] + 1 : c = this.eMarks[o]; V < c && d < i; ) {
      const F = this.src.charCodeAt(V);
      if (Wr(F))
        F === 9 ? d += 4 - (d + this.bsCount[o]) % 4 : d++;
      else if (V - a < this.tShift[o])
        d++;
      else
        break;
      V++;
    }
    d > i ? s[u] = new Array(d - i + 1).join(" ") + this.src.slice(V, c) : s[u] = this.src.slice(V, c);
  }
  return s.join("");
};
nu.prototype.Token = ps;
const QUe = 65536;
function ev(e, r) {
  const t = e.bMarks[r] + e.tShift[r], i = e.eMarks[r];
  return e.src.slice(t, i);
}
function OD(e) {
  const r = [], t = e.length;
  let i = 0, n = e.charCodeAt(i), s = !1, u = 0, o = "";
  for (; i < t; )
    n === 124 && (s ? (o += e.substring(u, i - 1), u = i) : (r.push(o + e.substring(u, i)), o = "", u = i + 1)), s = n === 92, i++, n = e.charCodeAt(i);
  return r.push(o + e.substring(u)), r;
}
function eZe(e, r, t, i) {
  if (r + 2 > t)
    return !1;
  let n = r + 1;
  if (e.sCount[n] < e.blkIndent || e.sCount[n] - e.blkIndent >= 4)
    return !1;
  let s = e.bMarks[n] + e.tShift[n];
  if (s >= e.eMarks[n])
    return !1;
  const u = e.src.charCodeAt(s++);
  if (u !== 124 && u !== 45 && u !== 58 || s >= e.eMarks[n])
    return !1;
  const o = e.src.charCodeAt(s++);
  if (o !== 124 && o !== 45 && o !== 58 && !Wr(o) || u === 45 && Wr(o))
    return !1;
  for (; s < e.eMarks[n]; ) {
    const y = e.src.charCodeAt(s);
    if (y !== 124 && y !== 45 && y !== 58 && !Wr(y))
      return !1;
    s++;
  }
  let d = ev(e, r + 1), a = d.split("|");
  const V = [];
  for (let y = 0; y < a.length; y++) {
    const b = a[y].trim();
    if (!b) {
      if (y === 0 || y === a.length - 1)
        continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(b))
      return !1;
    b.charCodeAt(b.length - 1) === 58 ? V.push(b.charCodeAt(0) === 58 ? "center" : "right") : b.charCodeAt(0) === 58 ? V.push("left") : V.push("");
  }
  if (d = ev(e, r).trim(), d.indexOf("|") === -1 || e.sCount[r] - e.blkIndent >= 4)
    return !1;
  a = OD(d), a.length && a[0] === "" && a.shift(), a.length && a[a.length - 1] === "" && a.pop();
  const c = a.length;
  if (c === 0 || c !== V.length)
    return !1;
  if (i)
    return !0;
  const F = e.parentType;
  e.parentType = "table";
  const X = e.md.block.ruler.getRules("blockquote"), Y = e.push("table_open", "table", 1), q = [r, 0];
  Y.map = q;
  const f = e.push("thead_open", "thead", 1);
  f.map = [r, r + 1];
  const p = e.push("tr_open", "tr", 1);
  p.map = [r, r + 1];
  for (let y = 0; y < a.length; y++) {
    const b = e.push("th_open", "th", 1);
    V[y] && (b.attrs = [["style", "text-align:" + V[y]]]);
    const A = e.push("inline", "", 0);
    A.content = a[y].trim(), A.children = [], e.push("th_close", "th", -1);
  }
  e.push("tr_close", "tr", -1), e.push("thead_close", "thead", -1);
  let m, g = 0;
  for (n = r + 2; n < t && !(e.sCount[n] < e.blkIndent); n++) {
    let y = !1;
    for (let A = 0, w = X.length; A < w; A++)
      if (X[A](e, n, t, !0)) {
        y = !0;
        break;
      }
    if (y || (d = ev(e, n).trim(), !d) || e.sCount[n] - e.blkIndent >= 4 || (a = OD(d), a.length && a[0] === "" && a.shift(), a.length && a[a.length - 1] === "" && a.pop(), g += c - a.length, g > QUe))
      break;
    if (n === r + 2) {
      const A = e.push("tbody_open", "tbody", 1);
      A.map = m = [r + 2, 0];
    }
    const b = e.push("tr_open", "tr", 1);
    b.map = [n, n + 1];
    for (let A = 0; A < c; A++) {
      const w = e.push("td_open", "td", 1);
      V[A] && (w.attrs = [["style", "text-align:" + V[A]]]);
      const S = e.push("inline", "", 0);
      S.content = a[A] ? a[A].trim() : "", S.children = [], e.push("td_close", "td", -1);
    }
    e.push("tr_close", "tr", -1);
  }
  return m && (e.push("tbody_close", "tbody", -1), m[1] = n), e.push("table_close", "table", -1), q[1] = n, e.parentType = F, e.line = n, !0;
}
function rZe(e, r, t) {
  if (e.sCount[r] - e.blkIndent < 4)
    return !1;
  let i = r + 1, n = i;
  for (; i < t; ) {
    if (e.isEmpty(i)) {
      i++;
      continue;
    }
    if (e.sCount[i] - e.blkIndent >= 4) {
      i++, n = i;
      continue;
    }
    break;
  }
  e.line = n;
  const s = e.push("code_block", "code", 0);
  return s.content = e.getLines(r, n, 4 + e.blkIndent, !1) + `
`, s.map = [r, e.line], !0;
}
function tZe(e, r, t, i) {
  let n = e.bMarks[r] + e.tShift[r], s = e.eMarks[r];
  if (e.sCount[r] - e.blkIndent >= 4 || n + 3 > s)
    return !1;
  const u = e.src.charCodeAt(n);
  if (u !== 126 && u !== 96)
    return !1;
  let o = n;
  n = e.skipChars(n, u);
  let d = n - o;
  if (d < 3)
    return !1;
  const a = e.src.slice(o, n), V = e.src.slice(n, s);
  if (u === 96 && V.indexOf(String.fromCharCode(u)) >= 0)
    return !1;
  if (i)
    return !0;
  let c = r, F = !1;
  for (; c++, !(c >= t || (n = o = e.bMarks[c] + e.tShift[c], s = e.eMarks[c], n < s && e.sCount[c] < e.blkIndent)); )
    if (e.src.charCodeAt(n) === u && !(e.sCount[c] - e.blkIndent >= 4) && (n = e.skipChars(n, u), !(n - o < d) && (n = e.skipSpaces(n), !(n < s)))) {
      F = !0;
      break;
    }
  d = e.sCount[r], e.line = c + (F ? 1 : 0);
  const X = e.push("fence", "code", 0);
  return X.info = V, X.content = e.getLines(r + 1, c, d, !0), X.markup = a, X.map = [r, e.line], !0;
}
function iZe(e, r, t, i) {
  let n = e.bMarks[r] + e.tShift[r], s = e.eMarks[r];
  const u = e.lineMax;
  if (e.sCount[r] - e.blkIndent >= 4 || e.src.charCodeAt(n) !== 62)
    return !1;
  if (i)
    return !0;
  const o = [], d = [], a = [], V = [], c = e.md.block.ruler.getRules("blockquote"), F = e.parentType;
  e.parentType = "blockquote";
  let X = !1, Y;
  for (Y = r; Y < t; Y++) {
    const g = e.sCount[Y] < e.blkIndent;
    if (n = e.bMarks[Y] + e.tShift[Y], s = e.eMarks[Y], n >= s)
      break;
    if (e.src.charCodeAt(n++) === 62 && !g) {
      let b = e.sCount[Y] + 1, A, w;
      e.src.charCodeAt(n) === 32 ? (n++, b++, w = !1, A = !0) : e.src.charCodeAt(n) === 9 ? (A = !0, (e.bsCount[Y] + b) % 4 === 3 ? (n++, b++, w = !1) : w = !0) : A = !1;
      let S = b;
      for (o.push(e.bMarks[Y]), e.bMarks[Y] = n; n < s; ) {
        const N = e.src.charCodeAt(n);
        if (Wr(N))
          N === 9 ? S += 4 - (S + e.bsCount[Y] + (w ? 1 : 0)) % 4 : S++;
        else
          break;
        n++;
      }
      X = n >= s, d.push(e.bsCount[Y]), e.bsCount[Y] = e.sCount[Y] + 1 + (A ? 1 : 0), a.push(e.sCount[Y]), e.sCount[Y] = S - b, V.push(e.tShift[Y]), e.tShift[Y] = n - e.bMarks[Y];
      continue;
    }
    if (X)
      break;
    let y = !1;
    for (let b = 0, A = c.length; b < A; b++)
      if (c[b](e, Y, t, !0)) {
        y = !0;
        break;
      }
    if (y) {
      e.lineMax = Y, e.blkIndent !== 0 && (o.push(e.bMarks[Y]), d.push(e.bsCount[Y]), V.push(e.tShift[Y]), a.push(e.sCount[Y]), e.sCount[Y] -= e.blkIndent);
      break;
    }
    o.push(e.bMarks[Y]), d.push(e.bsCount[Y]), V.push(e.tShift[Y]), a.push(e.sCount[Y]), e.sCount[Y] = -1;
  }
  const q = e.blkIndent;
  e.blkIndent = 0;
  const f = e.push("blockquote_open", "blockquote", 1);
  f.markup = ">";
  const p = [r, 0];
  f.map = p, e.md.block.tokenize(e, r, Y);
  const m = e.push("blockquote_close", "blockquote", -1);
  m.markup = ">", e.lineMax = u, e.parentType = F, p[1] = e.line;
  for (let g = 0; g < V.length; g++)
    e.bMarks[g + r] = o[g], e.tShift[g + r] = V[g], e.sCount[g + r] = a[g], e.bsCount[g + r] = d[g];
  return e.blkIndent = q, !0;
}
function nZe(e, r, t, i) {
  const n = e.eMarks[r];
  if (e.sCount[r] - e.blkIndent >= 4)
    return !1;
  let s = e.bMarks[r] + e.tShift[r];
  const u = e.src.charCodeAt(s++);
  if (u !== 42 && u !== 45 && u !== 95)
    return !1;
  let o = 1;
  for (; s < n; ) {
    const a = e.src.charCodeAt(s++);
    if (a !== u && !Wr(a))
      return !1;
    a === u && o++;
  }
  if (o < 3)
    return !1;
  if (i)
    return !0;
  e.line = r + 1;
  const d = e.push("hr", "hr", 0);
  return d.map = [r, e.line], d.markup = Array(o + 1).join(String.fromCharCode(u)), !0;
}
function DD(e, r) {
  const t = e.eMarks[r];
  let i = e.bMarks[r] + e.tShift[r];
  const n = e.src.charCodeAt(i++);
  if (n !== 42 && n !== 45 && n !== 43)
    return -1;
  if (i < t) {
    const s = e.src.charCodeAt(i);
    if (!Wr(s))
      return -1;
  }
  return i;
}
function RD(e, r) {
  const t = e.bMarks[r] + e.tShift[r], i = e.eMarks[r];
  let n = t;
  if (n + 1 >= i)
    return -1;
  let s = e.src.charCodeAt(n++);
  if (s < 48 || s > 57)
    return -1;
  for (; ; ) {
    if (n >= i)
      return -1;
    if (s = e.src.charCodeAt(n++), s >= 48 && s <= 57) {
      if (n - t >= 10)
        return -1;
      continue;
    }
    if (s === 41 || s === 46)
      break;
    return -1;
  }
  return n < i && (s = e.src.charCodeAt(n), !Wr(s)) ? -1 : n;
}
function sZe(e, r) {
  const t = e.level + 2;
  for (let i = r + 2, n = e.tokens.length - 2; i < n; i++)
    e.tokens[i].level === t && e.tokens[i].type === "paragraph_open" && (e.tokens[i + 2].hidden = !0, e.tokens[i].hidden = !0, i += 2);
}
function uZe(e, r, t, i) {
  let n, s, u, o, d = r, a = !0;
  if (e.sCount[d] - e.blkIndent >= 4 || e.listIndent >= 0 && e.sCount[d] - e.listIndent >= 4 && e.sCount[d] < e.blkIndent)
    return !1;
  let V = !1;
  i && e.parentType === "paragraph" && e.sCount[d] >= e.blkIndent && (V = !0);
  let c, F, X;
  if ((X = RD(e, d)) >= 0) {
    if (c = !0, u = e.bMarks[d] + e.tShift[d], F = Number(e.src.slice(u, X - 1)), V && F !== 1) return !1;
  } else if ((X = DD(e, d)) >= 0)
    c = !1;
  else
    return !1;
  if (V && e.skipSpaces(X) >= e.eMarks[d])
    return !1;
  if (i)
    return !0;
  const Y = e.src.charCodeAt(X - 1), q = e.tokens.length;
  c ? (o = e.push("ordered_list_open", "ol", 1), F !== 1 && (o.attrs = [["start", F]])) : o = e.push("bullet_list_open", "ul", 1);
  const f = [d, 0];
  o.map = f, o.markup = String.fromCharCode(Y);
  let p = !1;
  const m = e.md.block.ruler.getRules("list"), g = e.parentType;
  for (e.parentType = "list"; d < t; ) {
    s = X, n = e.eMarks[d];
    const y = e.sCount[d] + X - (e.bMarks[d] + e.tShift[d]);
    let b = y;
    for (; s < n; ) {
      const W = e.src.charCodeAt(s);
      if (W === 9)
        b += 4 - (b + e.bsCount[d]) % 4;
      else if (W === 32)
        b++;
      else
        break;
      s++;
    }
    const A = s;
    let w;
    A >= n ? w = 1 : w = b - y, w > 4 && (w = 1);
    const S = y + w;
    o = e.push("list_item_open", "li", 1), o.markup = String.fromCharCode(Y);
    const N = [d, 0];
    o.map = N, c && (o.info = e.src.slice(u, X - 1));
    const O = e.tight, E = e.tShift[d], I = e.sCount[d], R = e.listIndent;
    if (e.listIndent = e.blkIndent, e.blkIndent = S, e.tight = !0, e.tShift[d] = A - e.bMarks[d], e.sCount[d] = b, A >= n && e.isEmpty(d + 1) ? e.line = Math.min(e.line + 2, t) : e.md.block.tokenize(e, d, t, !0), (!e.tight || p) && (a = !1), p = e.line - d > 1 && e.isEmpty(e.line - 1), e.blkIndent = e.listIndent, e.listIndent = R, e.tShift[d] = E, e.sCount[d] = I, e.tight = O, o = e.push("list_item_close", "li", -1), o.markup = String.fromCharCode(Y), d = e.line, N[1] = d, d >= t || e.sCount[d] < e.blkIndent || e.sCount[d] - e.blkIndent >= 4)
      break;
    let H = !1;
    for (let W = 0, B = m.length; W < B; W++)
      if (m[W](e, d, t, !0)) {
        H = !0;
        break;
      }
    if (H)
      break;
    if (c) {
      if (X = RD(e, d), X < 0)
        break;
      u = e.bMarks[d] + e.tShift[d];
    } else if (X = DD(e, d), X < 0)
      break;
    if (Y !== e.src.charCodeAt(X - 1))
      break;
  }
  return c ? o = e.push("ordered_list_close", "ol", -1) : o = e.push("bullet_list_close", "ul", -1), o.markup = String.fromCharCode(Y), f[1] = d, e.line = d, e.parentType = g, a && sZe(e, q), !0;
}
function oZe(e, r, t, i) {
  let n = e.bMarks[r] + e.tShift[r], s = e.eMarks[r], u = r + 1;
  if (e.sCount[r] - e.blkIndent >= 4 || e.src.charCodeAt(n) !== 91)
    return !1;
  function o(m) {
    const g = e.lineMax;
    if (m >= g || e.isEmpty(m))
      return null;
    let y = !1;
    if (e.sCount[m] - e.blkIndent > 3 && (y = !0), e.sCount[m] < 0 && (y = !0), !y) {
      const w = e.md.block.ruler.getRules("reference"), S = e.parentType;
      e.parentType = "reference";
      let N = !1;
      for (let O = 0, E = w.length; O < E; O++)
        if (w[O](e, m, g, !0)) {
          N = !0;
          break;
        }
      if (e.parentType = S, N)
        return null;
    }
    const b = e.bMarks[m] + e.tShift[m], A = e.eMarks[m];
    return e.src.slice(b, A + 1);
  }
  let d = e.src.slice(n, s + 1);
  s = d.length;
  let a = -1;
  for (n = 1; n < s; n++) {
    const m = d.charCodeAt(n);
    if (m === 91)
      return !1;
    if (m === 93) {
      a = n;
      break;
    } else if (m === 10) {
      const g = o(u);
      g !== null && (d += g, s = d.length, u++);
    } else if (m === 92 && (n++, n < s && d.charCodeAt(n) === 10)) {
      const g = o(u);
      g !== null && (d += g, s = d.length, u++);
    }
  }
  if (a < 0 || d.charCodeAt(a + 1) !== 58)
    return !1;
  for (n = a + 2; n < s; n++) {
    const m = d.charCodeAt(n);
    if (m === 10) {
      const g = o(u);
      g !== null && (d += g, s = d.length, u++);
    } else if (!Wr(m)) break;
  }
  const V = e.md.helpers.parseLinkDestination(d, n, s);
  if (!V.ok)
    return !1;
  const c = e.md.normalizeLink(V.str);
  if (!e.md.validateLink(c))
    return !1;
  n = V.pos;
  const F = n, X = u, Y = n;
  for (; n < s; n++) {
    const m = d.charCodeAt(n);
    if (m === 10) {
      const g = o(u);
      g !== null && (d += g, s = d.length, u++);
    } else if (!Wr(m)) break;
  }
  let q = e.md.helpers.parseLinkTitle(d, n, s);
  for (; q.can_continue; ) {
    const m = o(u);
    if (m === null) break;
    d += m, n = s, s = d.length, u++, q = e.md.helpers.parseLinkTitle(d, n, s, q);
  }
  let f;
  for (n < s && Y !== n && q.ok ? (f = q.str, n = q.pos) : (f = "", n = F, u = X); n < s; ) {
    const m = d.charCodeAt(n);
    if (!Wr(m))
      break;
    n++;
  }
  if (n < s && d.charCodeAt(n) !== 10 && f)
    for (f = "", n = F, u = X; n < s; ) {
      const m = d.charCodeAt(n);
      if (!Wr(m))
        break;
      n++;
    }
  if (n < s && d.charCodeAt(n) !== 10)
    return !1;
  const p = Uf(d.slice(1, a));
  return p ? (i || (typeof e.env.references > "u" && (e.env.references = {}), typeof e.env.references[p] > "u" && (e.env.references[p] = { title: f, href: c }), e.line = u), !0) : !1;
}
const dZe = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], aZe = "[a-zA-Z_:][a-zA-Z0-9:._-]*", VZe = "[^\"'=<>`\\x00-\\x20]+", lZe = "'[^']*'", cZe = '"[^"]*"', FZe = "(?:" + VZe + "|" + lZe + "|" + cZe + ")", xZe = "(?:\\s+" + aZe + "(?:\\s*=\\s*" + FZe + ")?)", fre = "<[A-Za-z][A-Za-z0-9\\-]*" + xZe + "*\\s*\\/?>", Kre = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", XZe = "<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->", qZe = "<[?][\\s\\S]*?[?]>", YZe = "<![A-Za-z][^>]*>", fZe = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", KZe = new RegExp("^(?:" + fre + "|" + Kre + "|" + XZe + "|" + qZe + "|" + YZe + "|" + fZe + ")"), hZe = new RegExp("^(?:" + fre + "|" + Kre + ")"), $a = [
  [/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0],
  [/^<!--/, /-->/, !0],
  [/^<\?/, /\?>/, !0],
  [/^<![A-Z]/, />/, !0],
  [/^<!\[CDATA\[/, /\]\]>/, !0],
  [new RegExp("^</?(" + dZe.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0],
  [new RegExp(hZe.source + "\\s*$"), /^$/, !1]
];
function pZe(e, r, t, i) {
  let n = e.bMarks[r] + e.tShift[r], s = e.eMarks[r];
  if (e.sCount[r] - e.blkIndent >= 4 || !e.md.options.html || e.src.charCodeAt(n) !== 60)
    return !1;
  let u = e.src.slice(n, s), o = 0;
  for (; o < $a.length && !$a[o][0].test(u); o++)
    ;
  if (o === $a.length)
    return !1;
  if (i)
    return $a[o][2];
  let d = r + 1;
  if (!$a[o][1].test(u)) {
    for (; d < t && !(e.sCount[d] < e.blkIndent); d++)
      if (n = e.bMarks[d] + e.tShift[d], s = e.eMarks[d], u = e.src.slice(n, s), $a[o][1].test(u)) {
        u.length !== 0 && d++;
        break;
      }
  }
  e.line = d;
  const a = e.push("html_block", "", 0);
  return a.map = [r, d], a.content = e.getLines(r, d, e.blkIndent, !0), !0;
}
function mZe(e, r, t, i) {
  let n = e.bMarks[r] + e.tShift[r], s = e.eMarks[r];
  if (e.sCount[r] - e.blkIndent >= 4)
    return !1;
  let u = e.src.charCodeAt(n);
  if (u !== 35 || n >= s)
    return !1;
  let o = 1;
  for (u = e.src.charCodeAt(++n); u === 35 && n < s && o <= 6; )
    o++, u = e.src.charCodeAt(++n);
  if (o > 6 || n < s && !Wr(u))
    return !1;
  if (i)
    return !0;
  s = e.skipSpacesBack(s, n);
  const d = e.skipCharsBack(s, 35, n);
  d > n && Wr(e.src.charCodeAt(d - 1)) && (s = d), e.line = r + 1;
  const a = e.push("heading_open", "h" + String(o), 1);
  a.markup = "########".slice(0, o), a.map = [r, e.line];
  const V = e.push("inline", "", 0);
  V.content = e.src.slice(n, s).trim(), V.map = [r, e.line], V.children = [];
  const c = e.push("heading_close", "h" + String(o), -1);
  return c.markup = "########".slice(0, o), !0;
}
function gZe(e, r, t) {
  const i = e.md.block.ruler.getRules("paragraph");
  if (e.sCount[r] - e.blkIndent >= 4)
    return !1;
  const n = e.parentType;
  e.parentType = "paragraph";
  let s = 0, u, o = r + 1;
  for (; o < t && !e.isEmpty(o); o++) {
    if (e.sCount[o] - e.blkIndent > 3)
      continue;
    if (e.sCount[o] >= e.blkIndent) {
      let X = e.bMarks[o] + e.tShift[o];
      const Y = e.eMarks[o];
      if (X < Y && (u = e.src.charCodeAt(X), (u === 45 || u === 61) && (X = e.skipChars(X, u), X = e.skipSpaces(X), X >= Y))) {
        s = u === 61 ? 1 : 2;
        break;
      }
    }
    if (e.sCount[o] < 0)
      continue;
    let F = !1;
    for (let X = 0, Y = i.length; X < Y; X++)
      if (i[X](e, o, t, !0)) {
        F = !0;
        break;
      }
    if (F)
      break;
  }
  if (!s)
    return !1;
  const d = e.getLines(r, o, e.blkIndent, !1).trim();
  e.line = o + 1;
  const a = e.push("heading_open", "h" + String(s), 1);
  a.markup = String.fromCharCode(u), a.map = [r, e.line];
  const V = e.push("inline", "", 0);
  V.content = d, V.map = [r, e.line - 1], V.children = [];
  const c = e.push("heading_close", "h" + String(s), -1);
  return c.markup = String.fromCharCode(u), e.parentType = n, !0;
}
function vZe(e, r, t) {
  const i = e.md.block.ruler.getRules("paragraph"), n = e.parentType;
  let s = r + 1;
  for (e.parentType = "paragraph"; s < t && !e.isEmpty(s); s++) {
    if (e.sCount[s] - e.blkIndent > 3 || e.sCount[s] < 0)
      continue;
    let a = !1;
    for (let V = 0, c = i.length; V < c; V++)
      if (i[V](e, s, t, !0)) {
        a = !0;
        break;
      }
    if (a)
      break;
  }
  const u = e.getLines(r, s, e.blkIndent, !1).trim();
  e.line = s;
  const o = e.push("paragraph_open", "p", 1);
  o.map = [r, e.line];
  const d = e.push("inline", "", 0);
  return d.content = u, d.map = [r, e.line], d.children = [], e.push("paragraph_close", "p", -1), e.parentType = n, !0;
}
const Nx = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  ["table", eZe, ["paragraph", "reference"]],
  ["code", rZe],
  ["fence", tZe, ["paragraph", "reference", "blockquote", "list"]],
  ["blockquote", iZe, ["paragraph", "reference", "blockquote", "list"]],
  ["hr", nZe, ["paragraph", "reference", "blockquote", "list"]],
  ["list", uZe, ["paragraph", "reference", "blockquote"]],
  ["reference", oZe],
  ["html_block", pZe, ["paragraph", "reference", "blockquote"]],
  ["heading", mZe, ["paragraph", "reference", "blockquote"]],
  ["lheading", gZe],
  ["paragraph", vZe]
];
function Zf() {
  this.ruler = new Zi();
  for (let e = 0; e < Nx.length; e++)
    this.ruler.push(Nx[e][0], Nx[e][1], { alt: (Nx[e][2] || []).slice() });
}
Zf.prototype.tokenize = function(e, r, t) {
  const i = this.ruler.getRules(""), n = i.length, s = e.md.options.maxNesting;
  let u = r, o = !1;
  for (; u < t && (e.line = u = e.skipEmptyLines(u), !(u >= t || e.sCount[u] < e.blkIndent)); ) {
    if (e.level >= s) {
      e.line = t;
      break;
    }
    const d = e.line;
    let a = !1;
    for (let V = 0; V < n; V++)
      if (a = i[V](e, u, t, !1), a) {
        if (d >= e.line)
          throw new Error("block rule didn't increment state.line");
        break;
      }
    if (!a) throw new Error("none of the block rules matched");
    e.tight = !o, e.isEmpty(e.line - 1) && (o = !0), u = e.line, u < t && e.isEmpty(u) && (o = !0, u++, e.line = u);
  }
};
Zf.prototype.parse = function(e, r, t, i) {
  if (!e)
    return;
  const n = new this.State(e, r, t, i);
  this.tokenize(n, n.line, n.lineMax);
};
Zf.prototype.State = nu;
function R2(e, r, t, i) {
  this.src = e, this.env = t, this.md = r, this.tokens = i, this.tokens_meta = Array(i.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
R2.prototype.pushPending = function() {
  const e = new ps("text", "", 0);
  return e.content = this.pending, e.level = this.pendingLevel, this.tokens.push(e), this.pending = "", e;
};
R2.prototype.push = function(e, r, t) {
  this.pending && this.pushPending();
  const i = new ps(e, r, t);
  let n = null;
  return t < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), i.level = this.level, t > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], n = { delimiters: this.delimiters }), this.pendingLevel = this.level, this.tokens.push(i), this.tokens_meta.push(n), i;
};
R2.prototype.scanDelims = function(e, r) {
  const t = this.posMax, i = this.src.charCodeAt(e), n = e > 0 ? this.src.charCodeAt(e - 1) : 32;
  let s = e;
  for (; s < t && this.src.charCodeAt(s) === i; )
    s++;
  const u = s - e, o = s < t ? this.src.charCodeAt(s) : 32, d = J7(n) || Z7(String.fromCharCode(n)), a = J7(o) || Z7(String.fromCharCode(o)), V = U7(n), c = U7(o), F = !c && (!a || V || d), X = !V && (!d || c || a);
  return { can_open: F && (r || !X || d), can_close: X && (r || !F || a), length: u };
};
R2.prototype.Token = ps;
function bZe(e) {
  switch (e) {
    case 10:
    case 33:
    case 35:
    case 36:
    case 37:
    case 38:
    case 42:
    case 43:
    case 45:
    case 58:
    case 60:
    case 61:
    case 62:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function yZe(e, r) {
  let t = e.pos;
  for (; t < e.posMax && !bZe(e.src.charCodeAt(t)); )
    t++;
  return t === e.pos ? !1 : (r || (e.pending += e.src.slice(e.pos, t)), e.pos = t, !0);
}
const AZe = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function wZe(e, r) {
  if (!e.md.options.linkify || e.linkLevel > 0) return !1;
  const t = e.pos, i = e.posMax;
  if (t + 3 > i || e.src.charCodeAt(t) !== 58 || e.src.charCodeAt(t + 1) !== 47 || e.src.charCodeAt(t + 2) !== 47) return !1;
  const n = e.pending.match(AZe);
  if (!n) return !1;
  const s = n[1], u = e.md.linkify.matchAtStart(e.src.slice(t - s.length));
  if (!u) return !1;
  let o = u.url;
  if (o.length <= s.length) return !1;
  o = o.replace(/\*+$/, "");
  const d = e.md.normalizeLink(o);
  if (!e.md.validateLink(d)) return !1;
  if (!r) {
    e.pending = e.pending.slice(0, -s.length);
    const a = e.push("link_open", "a", 1);
    a.attrs = [["href", d]], a.markup = "linkify", a.info = "auto";
    const V = e.push("text", "", 0);
    V.content = e.md.normalizeLinkText(o);
    const c = e.push("link_close", "a", -1);
    c.markup = "linkify", c.info = "auto";
  }
  return e.pos += o.length - s.length, !0;
}
function CZe(e, r) {
  let t = e.pos;
  if (e.src.charCodeAt(t) !== 10)
    return !1;
  const i = e.pending.length - 1, n = e.posMax;
  if (!r)
    if (i >= 0 && e.pending.charCodeAt(i) === 32)
      if (i >= 1 && e.pending.charCodeAt(i - 1) === 32) {
        let s = i - 1;
        for (; s >= 1 && e.pending.charCodeAt(s - 1) === 32; ) s--;
        e.pending = e.pending.slice(0, s), e.push("hardbreak", "br", 0);
      } else
        e.pending = e.pending.slice(0, -1), e.push("softbreak", "br", 0);
    else
      e.push("softbreak", "br", 0);
  for (t++; t < n && Wr(e.src.charCodeAt(t)); )
    t++;
  return e.pos = t, !0;
}
const o5 = [];
for (let e = 0; e < 256; e++)
  o5.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(e) {
  o5[e.charCodeAt(0)] = 1;
});
function PZe(e, r) {
  let t = e.pos;
  const i = e.posMax;
  if (e.src.charCodeAt(t) !== 92 || (t++, t >= i)) return !1;
  let n = e.src.charCodeAt(t);
  if (n === 10) {
    for (r || e.push("hardbreak", "br", 0), t++; t < i && (n = e.src.charCodeAt(t), !!Wr(n)); )
      t++;
    return e.pos = t, !0;
  }
  let s = e.src[t];
  if (n >= 55296 && n <= 56319 && t + 1 < i) {
    const o = e.src.charCodeAt(t + 1);
    o >= 56320 && o <= 57343 && (s += e.src[t + 1], t++);
  }
  const u = "\\" + s;
  if (!r) {
    const o = e.push("text_special", "", 0);
    n < 256 && o5[n] !== 0 ? o.content = s : o.content = u, o.markup = u, o.info = "escape";
  }
  return e.pos = t + 1, !0;
}
function SZe(e, r) {
  let t = e.pos;
  if (e.src.charCodeAt(t) !== 96)
    return !1;
  const n = t;
  t++;
  const s = e.posMax;
  for (; t < s && e.src.charCodeAt(t) === 96; )
    t++;
  const u = e.src.slice(n, t), o = u.length;
  if (e.backticksScanned && (e.backticks[o] || 0) <= n)
    return r || (e.pending += u), e.pos += o, !0;
  let d = t, a;
  for (; (a = e.src.indexOf("`", d)) !== -1; ) {
    for (d = a + 1; d < s && e.src.charCodeAt(d) === 96; )
      d++;
    const V = d - a;
    if (V === o) {
      if (!r) {
        const c = e.push("code_inline", "code", 0);
        c.markup = u, c.content = e.src.slice(t, a).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
      }
      return e.pos = d, !0;
    }
    e.backticks[V] = a;
  }
  return e.backticksScanned = !0, r || (e.pending += u), e.pos += o, !0;
}
function NZe(e, r) {
  const t = e.pos, i = e.src.charCodeAt(t);
  if (r || i !== 126)
    return !1;
  const n = e.scanDelims(e.pos, !0);
  let s = n.length;
  const u = String.fromCharCode(i);
  if (s < 2)
    return !1;
  let o;
  s % 2 && (o = e.push("text", "", 0), o.content = u, s--);
  for (let d = 0; d < s; d += 2)
    o = e.push("text", "", 0), o.content = u + u, e.delimiters.push({
      marker: i,
      length: 0,
      // disable "rule of 3" length checks meant for emphasis
      token: e.tokens.length - 1,
      end: -1,
      open: n.can_open,
      close: n.can_close
    });
  return e.pos += n.length, !0;
}
function ID(e, r) {
  let t;
  const i = [], n = r.length;
  for (let s = 0; s < n; s++) {
    const u = r[s];
    if (u.marker !== 126 || u.end === -1)
      continue;
    const o = r[u.end];
    t = e.tokens[u.token], t.type = "s_open", t.tag = "s", t.nesting = 1, t.markup = "~~", t.content = "", t = e.tokens[o.token], t.type = "s_close", t.tag = "s", t.nesting = -1, t.markup = "~~", t.content = "", e.tokens[o.token - 1].type === "text" && e.tokens[o.token - 1].content === "~" && i.push(o.token - 1);
  }
  for (; i.length; ) {
    const s = i.pop();
    let u = s + 1;
    for (; u < e.tokens.length && e.tokens[u].type === "s_close"; )
      u++;
    u--, s !== u && (t = e.tokens[u], e.tokens[u] = e.tokens[s], e.tokens[s] = t);
  }
}
function MZe(e) {
  const r = e.tokens_meta, t = e.tokens_meta.length;
  ID(e, e.delimiters);
  for (let i = 0; i < t; i++)
    r[i] && r[i].delimiters && ID(e, r[i].delimiters);
}
const hre = {
  tokenize: NZe,
  postProcess: MZe
};
function TZe(e, r) {
  const t = e.pos, i = e.src.charCodeAt(t);
  if (r || i !== 95 && i !== 42)
    return !1;
  const n = e.scanDelims(e.pos, i === 42);
  for (let s = 0; s < n.length; s++) {
    const u = e.push("text", "", 0);
    u.content = String.fromCharCode(i), e.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: i,
      // Total length of these series of delimiters.
      //
      length: n.length,
      // A position of the token this delimiter corresponds to.
      //
      token: e.tokens.length - 1,
      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end: -1,
      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open: n.can_open,
      close: n.can_close
    });
  }
  return e.pos += n.length, !0;
}
function LD(e, r) {
  const t = r.length;
  for (let i = t - 1; i >= 0; i--) {
    const n = r[i];
    if (n.marker !== 95 && n.marker !== 42 || n.end === -1)
      continue;
    const s = r[n.end], u = i > 0 && r[i - 1].end === n.end + 1 && // check that first two markers match and adjacent
    r[i - 1].marker === n.marker && r[i - 1].token === n.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
    r[n.end + 1].token === s.token + 1, o = String.fromCharCode(n.marker), d = e.tokens[n.token];
    d.type = u ? "strong_open" : "em_open", d.tag = u ? "strong" : "em", d.nesting = 1, d.markup = u ? o + o : o, d.content = "";
    const a = e.tokens[s.token];
    a.type = u ? "strong_close" : "em_close", a.tag = u ? "strong" : "em", a.nesting = -1, a.markup = u ? o + o : o, a.content = "", u && (e.tokens[r[i - 1].token].content = "", e.tokens[r[n.end + 1].token].content = "", i--);
  }
}
function EZe(e) {
  const r = e.tokens_meta, t = e.tokens_meta.length;
  LD(e, e.delimiters);
  for (let i = 0; i < t; i++)
    r[i] && r[i].delimiters && LD(e, r[i].delimiters);
}
const pre = {
  tokenize: TZe,
  postProcess: EZe
};
function kZe(e, r) {
  let t, i, n, s, u = "", o = "", d = e.pos, a = !0;
  if (e.src.charCodeAt(e.pos) !== 91)
    return !1;
  const V = e.pos, c = e.posMax, F = e.pos + 1, X = e.md.helpers.parseLinkLabel(e, e.pos, !0);
  if (X < 0)
    return !1;
  let Y = X + 1;
  if (Y < c && e.src.charCodeAt(Y) === 40) {
    for (a = !1, Y++; Y < c && (t = e.src.charCodeAt(Y), !(!Wr(t) && t !== 10)); Y++)
      ;
    if (Y >= c)
      return !1;
    if (d = Y, n = e.md.helpers.parseLinkDestination(e.src, Y, e.posMax), n.ok) {
      for (u = e.md.normalizeLink(n.str), e.md.validateLink(u) ? Y = n.pos : u = "", d = Y; Y < c && (t = e.src.charCodeAt(Y), !(!Wr(t) && t !== 10)); Y++)
        ;
      if (n = e.md.helpers.parseLinkTitle(e.src, Y, e.posMax), Y < c && d !== Y && n.ok)
        for (o = n.str, Y = n.pos; Y < c && (t = e.src.charCodeAt(Y), !(!Wr(t) && t !== 10)); Y++)
          ;
    }
    (Y >= c || e.src.charCodeAt(Y) !== 41) && (a = !0), Y++;
  }
  if (a) {
    if (typeof e.env.references > "u")
      return !1;
    if (Y < c && e.src.charCodeAt(Y) === 91 ? (d = Y + 1, Y = e.md.helpers.parseLinkLabel(e, Y), Y >= 0 ? i = e.src.slice(d, Y++) : Y = X + 1) : Y = X + 1, i || (i = e.src.slice(F, X)), s = e.env.references[Uf(i)], !s)
      return e.pos = V, !1;
    u = s.href, o = s.title;
  }
  if (!r) {
    e.pos = F, e.posMax = X;
    const q = e.push("link_open", "a", 1), f = [["href", u]];
    q.attrs = f, o && f.push(["title", o]), e.linkLevel++, e.md.inline.tokenize(e), e.linkLevel--, e.push("link_close", "a", -1);
  }
  return e.pos = Y, e.posMax = c, !0;
}
function OZe(e, r) {
  let t, i, n, s, u, o, d, a, V = "";
  const c = e.pos, F = e.posMax;
  if (e.src.charCodeAt(e.pos) !== 33 || e.src.charCodeAt(e.pos + 1) !== 91)
    return !1;
  const X = e.pos + 2, Y = e.md.helpers.parseLinkLabel(e, e.pos + 1, !1);
  if (Y < 0)
    return !1;
  if (s = Y + 1, s < F && e.src.charCodeAt(s) === 40) {
    for (s++; s < F && (t = e.src.charCodeAt(s), !(!Wr(t) && t !== 10)); s++)
      ;
    if (s >= F)
      return !1;
    for (a = s, o = e.md.helpers.parseLinkDestination(e.src, s, e.posMax), o.ok && (V = e.md.normalizeLink(o.str), e.md.validateLink(V) ? s = o.pos : V = ""), a = s; s < F && (t = e.src.charCodeAt(s), !(!Wr(t) && t !== 10)); s++)
      ;
    if (o = e.md.helpers.parseLinkTitle(e.src, s, e.posMax), s < F && a !== s && o.ok)
      for (d = o.str, s = o.pos; s < F && (t = e.src.charCodeAt(s), !(!Wr(t) && t !== 10)); s++)
        ;
    else
      d = "";
    if (s >= F || e.src.charCodeAt(s) !== 41)
      return e.pos = c, !1;
    s++;
  } else {
    if (typeof e.env.references > "u")
      return !1;
    if (s < F && e.src.charCodeAt(s) === 91 ? (a = s + 1, s = e.md.helpers.parseLinkLabel(e, s), s >= 0 ? n = e.src.slice(a, s++) : s = Y + 1) : s = Y + 1, n || (n = e.src.slice(X, Y)), u = e.env.references[Uf(n)], !u)
      return e.pos = c, !1;
    V = u.href, d = u.title;
  }
  if (!r) {
    i = e.src.slice(X, Y);
    const q = [];
    e.md.inline.parse(
      i,
      e.md,
      e.env,
      q
    );
    const f = e.push("image", "img", 0), p = [["src", V], ["alt", ""]];
    f.attrs = p, f.children = q, f.content = i, d && p.push(["title", d]);
  }
  return e.pos = s, e.posMax = F, !0;
}
const DZe = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, RZe = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function IZe(e, r) {
  let t = e.pos;
  if (e.src.charCodeAt(t) !== 60)
    return !1;
  const i = e.pos, n = e.posMax;
  for (; ; ) {
    if (++t >= n) return !1;
    const u = e.src.charCodeAt(t);
    if (u === 60) return !1;
    if (u === 62) break;
  }
  const s = e.src.slice(i + 1, t);
  if (RZe.test(s)) {
    const u = e.md.normalizeLink(s);
    if (!e.md.validateLink(u))
      return !1;
    if (!r) {
      const o = e.push("link_open", "a", 1);
      o.attrs = [["href", u]], o.markup = "autolink", o.info = "auto";
      const d = e.push("text", "", 0);
      d.content = e.md.normalizeLinkText(s);
      const a = e.push("link_close", "a", -1);
      a.markup = "autolink", a.info = "auto";
    }
    return e.pos += s.length + 2, !0;
  }
  if (DZe.test(s)) {
    const u = e.md.normalizeLink("mailto:" + s);
    if (!e.md.validateLink(u))
      return !1;
    if (!r) {
      const o = e.push("link_open", "a", 1);
      o.attrs = [["href", u]], o.markup = "autolink", o.info = "auto";
      const d = e.push("text", "", 0);
      d.content = e.md.normalizeLinkText(s);
      const a = e.push("link_close", "a", -1);
      a.markup = "autolink", a.info = "auto";
    }
    return e.pos += s.length + 2, !0;
  }
  return !1;
}
function LZe(e) {
  return /^<a[>\s]/i.test(e);
}
function _Ze(e) {
  return /^<\/a\s*>/i.test(e);
}
function HZe(e) {
  const r = e | 32;
  return r >= 97 && r <= 122;
}
function jZe(e, r) {
  if (!e.md.options.html)
    return !1;
  const t = e.posMax, i = e.pos;
  if (e.src.charCodeAt(i) !== 60 || i + 2 >= t)
    return !1;
  const n = e.src.charCodeAt(i + 1);
  if (n !== 33 && n !== 63 && n !== 47 && !HZe(n))
    return !1;
  const s = e.src.slice(i).match(KZe);
  if (!s)
    return !1;
  if (!r) {
    const u = e.push("html_inline", "", 0);
    u.content = s[0], LZe(u.content) && e.linkLevel++, _Ze(u.content) && e.linkLevel--;
  }
  return e.pos += s[0].length, !0;
}
const zZe = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, BZe = /^&([a-z][a-z0-9]{1,31});/i;
function WZe(e, r) {
  const t = e.pos, i = e.posMax;
  if (e.src.charCodeAt(t) !== 38 || t + 1 >= i) return !1;
  if (e.src.charCodeAt(t + 1) === 35) {
    const s = e.src.slice(t).match(zZe);
    if (s) {
      if (!r) {
        const u = s[1][0].toLowerCase() === "x" ? parseInt(s[1].slice(1), 16) : parseInt(s[1], 10), o = e.push("text_special", "", 0);
        o.content = s5(u) ? Sq(u) : Sq(65533), o.markup = s[0], o.info = "entity";
      }
      return e.pos += s[0].length, !0;
    }
  } else {
    const s = e.src.slice(t).match(BZe);
    if (s) {
      const u = Fre(s[0]);
      if (u !== s[0]) {
        if (!r) {
          const o = e.push("text_special", "", 0);
          o.content = u, o.markup = s[0], o.info = "entity";
        }
        return e.pos += s[0].length, !0;
      }
    }
  }
  return !1;
}
function _D(e) {
  const r = {}, t = e.length;
  if (!t) return;
  let i = 0, n = -2;
  const s = [];
  for (let u = 0; u < t; u++) {
    const o = e[u];
    if (s.push(0), (e[i].marker !== o.marker || n !== o.token - 1) && (i = u), n = o.token, o.length = o.length || 0, !o.close) continue;
    r.hasOwnProperty(o.marker) || (r[o.marker] = [-1, -1, -1, -1, -1, -1]);
    const d = r[o.marker][(o.open ? 3 : 0) + o.length % 3];
    let a = i - s[i] - 1, V = a;
    for (; a > d; a -= s[a] + 1) {
      const c = e[a];
      if (c.marker === o.marker && c.open && c.end < 0) {
        let F = !1;
        if ((c.close || o.open) && (c.length + o.length) % 3 === 0 && (c.length % 3 !== 0 || o.length % 3 !== 0) && (F = !0), !F) {
          const X = a > 0 && !e[a - 1].open ? s[a - 1] + 1 : 0;
          s[u] = u - a + X, s[a] = X, o.open = !1, c.end = u, c.close = !1, V = -1, n = -2;
          break;
        }
      }
    }
    V !== -1 && (r[o.marker][(o.open ? 3 : 0) + (o.length || 0) % 3] = V);
  }
}
function GZe(e) {
  const r = e.tokens_meta, t = e.tokens_meta.length;
  _D(e.delimiters);
  for (let i = 0; i < t; i++)
    r[i] && r[i].delimiters && _D(r[i].delimiters);
}
function UZe(e) {
  let r, t, i = 0;
  const n = e.tokens, s = e.tokens.length;
  for (r = t = 0; r < s; r++)
    n[r].nesting < 0 && i--, n[r].level = i, n[r].nesting > 0 && i++, n[r].type === "text" && r + 1 < s && n[r + 1].type === "text" ? n[r + 1].content = n[r].content + n[r + 1].content : (r !== t && (n[t] = n[r]), t++);
  r !== t && (n.length = t);
}
const rv = [
  ["text", yZe],
  ["linkify", wZe],
  ["newline", CZe],
  ["escape", PZe],
  ["backticks", SZe],
  ["strikethrough", hre.tokenize],
  ["emphasis", pre.tokenize],
  ["link", kZe],
  ["image", OZe],
  ["autolink", IZe],
  ["html_inline", jZe],
  ["entity", WZe]
], tv = [
  ["balance_pairs", GZe],
  ["strikethrough", hre.postProcess],
  ["emphasis", pre.postProcess],
  // rules for pairs separate '**' into its own text tokens, which may be left unused,
  // rule below merges unused segments back with the rest of the text
  ["fragments_join", UZe]
];
function I2() {
  this.ruler = new Zi();
  for (let e = 0; e < rv.length; e++)
    this.ruler.push(rv[e][0], rv[e][1]);
  this.ruler2 = new Zi();
  for (let e = 0; e < tv.length; e++)
    this.ruler2.push(tv[e][0], tv[e][1]);
}
I2.prototype.skipToken = function(e) {
  const r = e.pos, t = this.ruler.getRules(""), i = t.length, n = e.md.options.maxNesting, s = e.cache;
  if (typeof s[r] < "u") {
    e.pos = s[r];
    return;
  }
  let u = !1;
  if (e.level < n) {
    for (let o = 0; o < i; o++)
      if (e.level++, u = t[o](e, !0), e.level--, u) {
        if (r >= e.pos)
          throw new Error("inline rule didn't increment state.pos");
        break;
      }
  } else
    e.pos = e.posMax;
  u || e.pos++, s[r] = e.pos;
};
I2.prototype.tokenize = function(e) {
  const r = this.ruler.getRules(""), t = r.length, i = e.posMax, n = e.md.options.maxNesting;
  for (; e.pos < i; ) {
    const s = e.pos;
    let u = !1;
    if (e.level < n) {
      for (let o = 0; o < t; o++)
        if (u = r[o](e, !1), u) {
          if (s >= e.pos)
            throw new Error("inline rule didn't increment state.pos");
          break;
        }
    }
    if (u) {
      if (e.pos >= i)
        break;
      continue;
    }
    e.pending += e.src[e.pos++];
  }
  e.pending && e.pushPending();
};
I2.prototype.parse = function(e, r, t, i) {
  const n = new this.State(e, r, t, i);
  this.tokenize(n);
  const s = this.ruler2.getRules(""), u = s.length;
  for (let o = 0; o < u; o++)
    s[o](n);
};
I2.prototype.State = R2;
function ZZe(e) {
  const r = {};
  e = e || {}, r.src_Any = dre.source, r.src_Cc = are.source, r.src_Z = lre.source, r.src_P = i5.source, r.src_ZPCc = [r.src_Z, r.src_P, r.src_Cc].join("|"), r.src_ZCc = [r.src_Z, r.src_Cc].join("|");
  const t = "[><｜]";
  return r.src_pseudo_letter = "(?:(?!" + t + "|" + r.src_ZPCc + ")" + r.src_Any + ")", r.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", r.src_auth = "(?:(?:(?!" + r.src_ZCc + "|[@/\\[\\]()]).)+@)?", r.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", r.src_host_terminator = "(?=$|" + t + "|" + r.src_ZPCc + ")(?!" + (e["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + r.src_ZPCc + "))", r.src_path = "(?:[/?#](?:(?!" + r.src_ZCc + "|" + t + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + r.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + r.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + r.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + r.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + r.src_ZCc + "|[']).)+\\'|\\'(?=" + r.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + r.src_ZCc + "|[.]|$)|" + (e["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + // allow `,,,` in paths
  ",(?!" + r.src_ZCc + "|$)|;(?!" + r.src_ZCc + "|$)|\\!+(?!" + r.src_ZCc + "|[!]|$)|\\?(?!" + r.src_ZCc + "|[?]|$))+|\\/)?", r.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', r.src_xn = "xn--[a-z0-9\\-]{1,59}", r.src_domain_root = // Allow letters & digits (http://test1)
  "(?:" + r.src_xn + "|" + r.src_pseudo_letter + "{1,63})", r.src_domain = "(?:" + r.src_xn + "|(?:" + r.src_pseudo_letter + ")|(?:" + r.src_pseudo_letter + "(?:-|" + r.src_pseudo_letter + "){0,61}" + r.src_pseudo_letter + "))", r.src_host = "(?:(?:(?:(?:" + r.src_domain + ")\\.)*" + r.src_domain + "))", r.tpl_host_fuzzy = "(?:" + r.src_ip4 + "|(?:(?:(?:" + r.src_domain + ")\\.)+(?:%TLDS%)))", r.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + r.src_domain + ")\\.)+(?:%TLDS%))", r.src_host_strict = r.src_host + r.src_host_terminator, r.tpl_host_fuzzy_strict = r.tpl_host_fuzzy + r.src_host_terminator, r.src_host_port_strict = r.src_host + r.src_port + r.src_host_terminator, r.tpl_host_port_fuzzy_strict = r.tpl_host_fuzzy + r.src_port + r.src_host_terminator, r.tpl_host_port_no_ip_fuzzy_strict = r.tpl_host_no_ip_fuzzy + r.src_port + r.src_host_terminator, r.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + r.src_ZPCc + "|>|$))", r.tpl_email_fuzzy = "(^|" + t + '|"|\\(|' + r.src_ZCc + ")(" + r.src_email_name + "@" + r.tpl_host_fuzzy_strict + ")", r.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + r.src_ZPCc + "))((?![$+<=>^`|｜])" + r.tpl_host_port_fuzzy_strict + r.src_path + ")", r.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + r.src_ZPCc + "))((?![$+<=>^`|｜])" + r.tpl_host_port_no_ip_fuzzy_strict + r.src_path + ")", r;
}
function fy(e) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(t) {
    t && Object.keys(t).forEach(function(i) {
      e[i] = t[i];
    });
  }), e;
}
function Jf(e) {
  return Object.prototype.toString.call(e);
}
function JZe(e) {
  return Jf(e) === "[object String]";
}
function $Ze(e) {
  return Jf(e) === "[object Object]";
}
function QZe(e) {
  return Jf(e) === "[object RegExp]";
}
function HD(e) {
  return Jf(e) === "[object Function]";
}
function eJe(e) {
  return e.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
const mre = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1
};
function rJe(e) {
  return Object.keys(e || {}).reduce(function(r, t) {
    return r || mre.hasOwnProperty(t);
  }, !1);
}
const tJe = {
  "http:": {
    validate: function(e, r, t) {
      const i = e.slice(r);
      return t.re.http || (t.re.http = new RegExp(
        "^\\/\\/" + t.re.src_auth + t.re.src_host_port_strict + t.re.src_path,
        "i"
      )), t.re.http.test(i) ? i.match(t.re.http)[0].length : 0;
    }
  },
  "https:": "http:",
  "ftp:": "http:",
  "//": {
    validate: function(e, r, t) {
      const i = e.slice(r);
      return t.re.no_http || (t.re.no_http = new RegExp(
        "^" + t.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        "(?:localhost|(?:(?:" + t.re.src_domain + ")\\.)+" + t.re.src_domain_root + ")" + t.re.src_port + t.re.src_host_terminator + t.re.src_path,
        "i"
      )), t.re.no_http.test(i) ? r >= 3 && e[r - 3] === ":" || r >= 3 && e[r - 3] === "/" ? 0 : i.match(t.re.no_http)[0].length : 0;
    }
  },
  "mailto:": {
    validate: function(e, r, t) {
      const i = e.slice(r);
      return t.re.mailto || (t.re.mailto = new RegExp(
        "^" + t.re.src_email_name + "@" + t.re.src_host_strict,
        "i"
      )), t.re.mailto.test(i) ? i.match(t.re.mailto)[0].length : 0;
    }
  }
}, iJe = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", nJe = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function sJe(e) {
  e.__index__ = -1, e.__text_cache__ = "";
}
function uJe(e) {
  return function(r, t) {
    const i = r.slice(t);
    return e.test(i) ? i.match(e)[0].length : 0;
  };
}
function jD() {
  return function(e, r) {
    r.normalize(e);
  };
}
function Nq(e) {
  const r = e.re = ZZe(e.__opts__), t = e.__tlds__.slice();
  e.onCompile(), e.__tlds_replaced__ || t.push(iJe), t.push(r.src_xn), r.src_tlds = t.join("|");
  function i(o) {
    return o.replace("%TLDS%", r.src_tlds);
  }
  r.email_fuzzy = RegExp(i(r.tpl_email_fuzzy), "i"), r.link_fuzzy = RegExp(i(r.tpl_link_fuzzy), "i"), r.link_no_ip_fuzzy = RegExp(i(r.tpl_link_no_ip_fuzzy), "i"), r.host_fuzzy_test = RegExp(i(r.tpl_host_fuzzy_test), "i");
  const n = [];
  e.__compiled__ = {};
  function s(o, d) {
    throw new Error('(LinkifyIt) Invalid schema "' + o + '": ' + d);
  }
  Object.keys(e.__schemas__).forEach(function(o) {
    const d = e.__schemas__[o];
    if (d === null)
      return;
    const a = { validate: null, link: null };
    if (e.__compiled__[o] = a, $Ze(d)) {
      QZe(d.validate) ? a.validate = uJe(d.validate) : HD(d.validate) ? a.validate = d.validate : s(o, d), HD(d.normalize) ? a.normalize = d.normalize : d.normalize ? s(o, d) : a.normalize = jD();
      return;
    }
    if (JZe(d)) {
      n.push(o);
      return;
    }
    s(o, d);
  }), n.forEach(function(o) {
    e.__compiled__[e.__schemas__[o]] && (e.__compiled__[o].validate = e.__compiled__[e.__schemas__[o]].validate, e.__compiled__[o].normalize = e.__compiled__[e.__schemas__[o]].normalize);
  }), e.__compiled__[""] = { validate: null, normalize: jD() };
  const u = Object.keys(e.__compiled__).filter(function(o) {
    return o.length > 0 && e.__compiled__[o];
  }).map(eJe).join("|");
  e.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + r.src_ZPCc + "))(" + u + ")", "i"), e.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + r.src_ZPCc + "))(" + u + ")", "ig"), e.re.schema_at_start = RegExp("^" + e.re.schema_search.source, "i"), e.re.pretest = RegExp(
    "(" + e.re.schema_test.source + ")|(" + e.re.host_fuzzy_test.source + ")|@",
    "i"
  ), sJe(e);
}
function oJe(e, r) {
  const t = e.__index__, i = e.__last_index__, n = e.__text_cache__.slice(t, i);
  this.schema = e.__schema__.toLowerCase(), this.index = t + r, this.lastIndex = i + r, this.raw = n, this.text = n, this.url = n;
}
function Ky(e, r) {
  const t = new oJe(e, r);
  return e.__compiled__[t.schema].normalize(t, e), t;
}
function qn(e, r) {
  if (!(this instanceof qn))
    return new qn(e, r);
  r || rJe(e) && (r = e, e = {}), this.__opts__ = fy({}, mre, r), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = fy({}, tJe, e), this.__compiled__ = {}, this.__tlds__ = nJe, this.__tlds_replaced__ = !1, this.re = {}, Nq(this);
}
qn.prototype.add = function(r, t) {
  return this.__schemas__[r] = t, Nq(this), this;
};
qn.prototype.set = function(r) {
  return this.__opts__ = fy(this.__opts__, r), this;
};
qn.prototype.test = function(r) {
  if (this.__text_cache__ = r, this.__index__ = -1, !r.length)
    return !1;
  let t, i, n, s, u, o, d, a, V;
  if (this.re.schema_test.test(r)) {
    for (d = this.re.schema_search, d.lastIndex = 0; (t = d.exec(r)) !== null; )
      if (s = this.testSchemaAt(r, t[2], d.lastIndex), s) {
        this.__schema__ = t[2], this.__index__ = t.index + t[1].length, this.__last_index__ = t.index + t[0].length + s;
        break;
      }
  }
  return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (a = r.search(this.re.host_fuzzy_test), a >= 0 && (this.__index__ < 0 || a < this.__index__) && (i = r.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (u = i.index + i[1].length, (this.__index__ < 0 || u < this.__index__) && (this.__schema__ = "", this.__index__ = u, this.__last_index__ = i.index + i[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (V = r.indexOf("@"), V >= 0 && (n = r.match(this.re.email_fuzzy)) !== null && (u = n.index + n[1].length, o = n.index + n[0].length, (this.__index__ < 0 || u < this.__index__ || u === this.__index__ && o > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = u, this.__last_index__ = o))), this.__index__ >= 0;
};
qn.prototype.pretest = function(r) {
  return this.re.pretest.test(r);
};
qn.prototype.testSchemaAt = function(r, t, i) {
  return this.__compiled__[t.toLowerCase()] ? this.__compiled__[t.toLowerCase()].validate(r, i, this) : 0;
};
qn.prototype.match = function(r) {
  const t = [];
  let i = 0;
  this.__index__ >= 0 && this.__text_cache__ === r && (t.push(Ky(this, i)), i = this.__last_index__);
  let n = i ? r.slice(i) : r;
  for (; this.test(n); )
    t.push(Ky(this, i)), n = n.slice(this.__last_index__), i += this.__last_index__;
  return t.length ? t : null;
};
qn.prototype.matchAtStart = function(r) {
  if (this.__text_cache__ = r, this.__index__ = -1, !r.length) return null;
  const t = this.re.schema_at_start.exec(r);
  if (!t) return null;
  const i = this.testSchemaAt(r, t[2], t[0].length);
  return i ? (this.__schema__ = t[2], this.__index__ = t.index + t[1].length, this.__last_index__ = t.index + t[0].length + i, Ky(this, 0)) : null;
};
qn.prototype.tlds = function(r, t) {
  return r = Array.isArray(r) ? r : [r], t ? (this.__tlds__ = this.__tlds__.concat(r).sort().filter(function(i, n, s) {
    return i !== s[n - 1];
  }).reverse(), Nq(this), this) : (this.__tlds__ = r.slice(), this.__tlds_replaced__ = !0, Nq(this), this);
};
qn.prototype.normalize = function(r) {
  r.schema || (r.url = "http://" + r.url), r.schema === "mailto:" && !/^mailto:/i.test(r.url) && (r.url = "mailto:" + r.url);
};
qn.prototype.onCompile = function() {
};
const vV = 2147483647, ks = 36, d5 = 1, $7 = 26, dJe = 38, aJe = 700, gre = 72, vre = 128, bre = "-", VJe = /^xn--/, lJe = /[^\0-\x7F]/, cJe = /[\x2E\u3002\uFF0E\uFF61]/g, FJe = {
  overflow: "Overflow: input needs wider integers to process",
  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
  "invalid-input": "Invalid input"
}, iv = ks - d5, Os = Math.floor, nv = String.fromCharCode;
function ho(e) {
  throw new RangeError(FJe[e]);
}
function xJe(e, r) {
  const t = [];
  let i = e.length;
  for (; i--; )
    t[i] = r(e[i]);
  return t;
}
function yre(e, r) {
  const t = e.split("@");
  let i = "";
  t.length > 1 && (i = t[0] + "@", e = t[1]), e = e.replace(cJe, ".");
  const n = e.split("."), s = xJe(n, r).join(".");
  return i + s;
}
function Are(e) {
  const r = [];
  let t = 0;
  const i = e.length;
  for (; t < i; ) {
    const n = e.charCodeAt(t++);
    if (n >= 55296 && n <= 56319 && t < i) {
      const s = e.charCodeAt(t++);
      (s & 64512) == 56320 ? r.push(((n & 1023) << 10) + (s & 1023) + 65536) : (r.push(n), t--);
    } else
      r.push(n);
  }
  return r;
}
const XJe = (e) => String.fromCodePoint(...e), qJe = function(e) {
  return e >= 48 && e < 58 ? 26 + (e - 48) : e >= 65 && e < 91 ? e - 65 : e >= 97 && e < 123 ? e - 97 : ks;
}, zD = function(e, r) {
  return e + 22 + 75 * (e < 26) - ((r != 0) << 5);
}, wre = function(e, r, t) {
  let i = 0;
  for (e = t ? Os(e / aJe) : e >> 1, e += Os(e / r); e > iv * $7 >> 1; i += ks)
    e = Os(e / iv);
  return Os(i + (iv + 1) * e / (e + dJe));
}, Cre = function(e) {
  const r = [], t = e.length;
  let i = 0, n = vre, s = gre, u = e.lastIndexOf(bre);
  u < 0 && (u = 0);
  for (let o = 0; o < u; ++o)
    e.charCodeAt(o) >= 128 && ho("not-basic"), r.push(e.charCodeAt(o));
  for (let o = u > 0 ? u + 1 : 0; o < t; ) {
    const d = i;
    for (let V = 1, c = ks; ; c += ks) {
      o >= t && ho("invalid-input");
      const F = qJe(e.charCodeAt(o++));
      F >= ks && ho("invalid-input"), F > Os((vV - i) / V) && ho("overflow"), i += F * V;
      const X = c <= s ? d5 : c >= s + $7 ? $7 : c - s;
      if (F < X)
        break;
      const Y = ks - X;
      V > Os(vV / Y) && ho("overflow"), V *= Y;
    }
    const a = r.length + 1;
    s = wre(i - d, a, d == 0), Os(i / a) > vV - n && ho("overflow"), n += Os(i / a), i %= a, r.splice(i++, 0, n);
  }
  return String.fromCodePoint(...r);
}, Pre = function(e) {
  const r = [];
  e = Are(e);
  const t = e.length;
  let i = vre, n = 0, s = gre;
  for (const d of e)
    d < 128 && r.push(nv(d));
  const u = r.length;
  let o = u;
  for (u && r.push(bre); o < t; ) {
    let d = vV;
    for (const V of e)
      V >= i && V < d && (d = V);
    const a = o + 1;
    d - i > Os((vV - n) / a) && ho("overflow"), n += (d - i) * a, i = d;
    for (const V of e)
      if (V < i && ++n > vV && ho("overflow"), V === i) {
        let c = n;
        for (let F = ks; ; F += ks) {
          const X = F <= s ? d5 : F >= s + $7 ? $7 : F - s;
          if (c < X)
            break;
          const Y = c - X, q = ks - X;
          r.push(
            nv(zD(X + Y % q, 0))
          ), c = Os(Y / q);
        }
        r.push(nv(zD(c, 0))), s = wre(n, a, o === u), n = 0, ++o;
      }
    ++n, ++i;
  }
  return r.join("");
}, YJe = function(e) {
  return yre(e, function(r) {
    return VJe.test(r) ? Cre(r.slice(4).toLowerCase()) : r;
  });
}, fJe = function(e) {
  return yre(e, function(r) {
    return lJe.test(r) ? "xn--" + Pre(r) : r;
  });
}, Sre = {
  /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
  version: "2.3.1",
  /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
  ucs2: {
    decode: Are,
    encode: XJe
  },
  decode: Cre,
  encode: Pre,
  toASCII: fJe,
  toUnicode: YJe
}, KJe = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 100
  },
  components: {
    core: {},
    block: {},
    inline: {}
  }
}, hJe = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "text"
      ],
      rules2: [
        "balance_pairs",
        "fragments_join"
      ]
    }
  }
}, pJe = {
  options: {
    // Enable HTML tags in source
    html: !0,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !0,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "blockquote",
        "code",
        "fence",
        "heading",
        "hr",
        "html_block",
        "lheading",
        "list",
        "reference",
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "autolink",
        "backticks",
        "emphasis",
        "entity",
        "escape",
        "html_inline",
        "image",
        "link",
        "newline",
        "text"
      ],
      rules2: [
        "balance_pairs",
        "emphasis",
        "fragments_join"
      ]
    }
  }
}, mJe = {
  default: KJe,
  zero: hJe,
  commonmark: pJe
}, gJe = /^(vbscript|javascript|file|data):/, vJe = /^data:image\/(gif|png|jpeg|webp);/;
function bJe(e) {
  const r = e.trim().toLowerCase();
  return gJe.test(r) ? vJe.test(r) : !0;
}
const Nre = ["http:", "https:", "mailto:"];
function yJe(e) {
  const r = t5(e, !0);
  if (r.hostname && (!r.protocol || Nre.indexOf(r.protocol) >= 0))
    try {
      r.hostname = Sre.toASCII(r.hostname);
    } catch {
    }
  return D2(r5(r));
}
function AJe(e) {
  const r = t5(e, !0);
  if (r.hostname && (!r.protocol || Nre.indexOf(r.protocol) >= 0))
    try {
      r.hostname = Sre.toUnicode(r.hostname);
    } catch {
    }
  return xl(r5(r), xl.defaultChars + "%");
}
function Ji(e, r) {
  if (!(this instanceof Ji))
    return new Ji(e, r);
  r || n5(e) || (r = e || {}, e = "default"), this.inline = new I2(), this.block = new Zf(), this.core = new u5(), this.renderer = new Ll(), this.linkify = new qn(), this.validateLink = bJe, this.normalizeLink = yJe, this.normalizeLinkText = AJe, this.utils = CUe, this.helpers = Gf({}, MUe), this.options = {}, this.configure(e), r && this.set(r);
}
Ji.prototype.set = function(e) {
  return Gf(this.options, e), this;
};
Ji.prototype.configure = function(e) {
  const r = this;
  if (n5(e)) {
    const t = e;
    if (e = mJe[t], !e)
      throw new Error('Wrong `markdown-it` preset "' + t + '", check name');
  }
  if (!e)
    throw new Error("Wrong `markdown-it` preset, can't be empty");
  return e.options && r.set(e.options), e.components && Object.keys(e.components).forEach(function(t) {
    e.components[t].rules && r[t].ruler.enableOnly(e.components[t].rules), e.components[t].rules2 && r[t].ruler2.enableOnly(e.components[t].rules2);
  }), this;
};
Ji.prototype.enable = function(e, r) {
  let t = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(n) {
    t = t.concat(this[n].ruler.enable(e, !0));
  }, this), t = t.concat(this.inline.ruler2.enable(e, !0));
  const i = e.filter(function(n) {
    return t.indexOf(n) < 0;
  });
  if (i.length && !r)
    throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + i);
  return this;
};
Ji.prototype.disable = function(e, r) {
  let t = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(n) {
    t = t.concat(this[n].ruler.disable(e, !0));
  }, this), t = t.concat(this.inline.ruler2.disable(e, !0));
  const i = e.filter(function(n) {
    return t.indexOf(n) < 0;
  });
  if (i.length && !r)
    throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + i);
  return this;
};
Ji.prototype.use = function(e) {
  const r = [this].concat(Array.prototype.slice.call(arguments, 1));
  return e.apply(e, r), this;
};
Ji.prototype.parse = function(e, r) {
  if (typeof e != "string")
    throw new Error("Input data should be a String");
  const t = new this.core.State(e, this, r);
  return this.core.process(t), t.tokens;
};
Ji.prototype.render = function(e, r) {
  return r = r || {}, this.renderer.render(this.parse(e, r), this.options, r);
};
Ji.prototype.parseInline = function(e, r) {
  const t = new this.core.State(e, this, r);
  return t.inlineMode = !0, this.core.process(t), t.tokens;
};
Ji.prototype.renderInline = function(e, r) {
  return r = r || {}, this.renderer.render(this.parseInline(e, r), this.options, r);
};
const wJe = new P4({
  nodes: {
    doc: {
      content: "block+"
    },
    paragraph: {
      content: "inline*",
      group: "block",
      parseDOM: [{ tag: "p" }],
      toDOM() {
        return ["p", 0];
      }
    },
    blockquote: {
      content: "block+",
      group: "block",
      parseDOM: [{ tag: "blockquote" }],
      toDOM() {
        return ["blockquote", 0];
      }
    },
    horizontal_rule: {
      group: "block",
      parseDOM: [{ tag: "hr" }],
      toDOM() {
        return ["div", ["hr"]];
      }
    },
    heading: {
      attrs: { level: { default: 1 } },
      content: "(text | image)*",
      group: "block",
      defining: !0,
      parseDOM: [
        { tag: "h1", attrs: { level: 1 } },
        { tag: "h2", attrs: { level: 2 } },
        { tag: "h3", attrs: { level: 3 } },
        { tag: "h4", attrs: { level: 4 } },
        { tag: "h5", attrs: { level: 5 } },
        { tag: "h6", attrs: { level: 6 } }
      ],
      toDOM(e) {
        return ["h" + e.attrs.level, 0];
      }
    },
    code_block: {
      content: "text*",
      group: "block",
      code: !0,
      defining: !0,
      marks: "",
      attrs: { params: { default: "" } },
      parseDOM: [{ tag: "pre", preserveWhitespace: "full", getAttrs: (e) => ({ params: e.getAttribute("data-params") || "" }) }],
      toDOM(e) {
        return ["pre", e.attrs.params ? { "data-params": e.attrs.params } : {}, ["code", 0]];
      }
    },
    ordered_list: {
      content: "list_item+",
      group: "block",
      attrs: { order: { default: 1 }, tight: { default: !1 } },
      parseDOM: [{ tag: "ol", getAttrs(e) {
        return {
          order: e.hasAttribute("start") ? +e.getAttribute("start") : 1,
          tight: e.hasAttribute("data-tight")
        };
      } }],
      toDOM(e) {
        return ["ol", {
          start: e.attrs.order == 1 ? null : e.attrs.order,
          "data-tight": e.attrs.tight ? "true" : null
        }, 0];
      }
    },
    bullet_list: {
      content: "list_item+",
      group: "block",
      attrs: { tight: { default: !1 } },
      parseDOM: [{ tag: "ul", getAttrs: (e) => ({ tight: e.hasAttribute("data-tight") }) }],
      toDOM(e) {
        return ["ul", { "data-tight": e.attrs.tight ? "true" : null }, 0];
      }
    },
    list_item: {
      content: "block+",
      defining: !0,
      parseDOM: [{ tag: "li" }],
      toDOM() {
        return ["li", 0];
      }
    },
    text: {
      group: "inline"
    },
    image: {
      inline: !0,
      attrs: {
        src: {},
        alt: { default: null },
        title: { default: null }
      },
      group: "inline",
      draggable: !0,
      parseDOM: [{ tag: "img[src]", getAttrs(e) {
        return {
          src: e.getAttribute("src"),
          title: e.getAttribute("title"),
          alt: e.getAttribute("alt")
        };
      } }],
      toDOM(e) {
        return ["img", e.attrs];
      }
    },
    hard_break: {
      inline: !0,
      group: "inline",
      selectable: !1,
      parseDOM: [{ tag: "br" }],
      toDOM() {
        return ["br"];
      }
    }
  },
  marks: {
    em: {
      parseDOM: [
        { tag: "i" },
        { tag: "em" },
        { style: "font-style=italic" },
        { style: "font-style=normal", clearMark: (e) => e.type.name == "em" }
      ],
      toDOM() {
        return ["em"];
      }
    },
    strong: {
      parseDOM: [
        { tag: "strong" },
        { tag: "b", getAttrs: (e) => e.style.fontWeight != "normal" && null },
        { style: "font-weight=400", clearMark: (e) => e.type.name == "strong" },
        { style: "font-weight", getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null }
      ],
      toDOM() {
        return ["strong"];
      }
    },
    link: {
      attrs: {
        href: {},
        title: { default: null }
      },
      inclusive: !1,
      parseDOM: [{ tag: "a[href]", getAttrs(e) {
        return { href: e.getAttribute("href"), title: e.getAttribute("title") };
      } }],
      toDOM(e) {
        return ["a", e.attrs];
      }
    },
    code: {
      parseDOM: [{ tag: "code" }],
      toDOM() {
        return ["code"];
      }
    }
  }
});
function CJe(e, r) {
  if (e.isText && r.isText && wr.sameSet(e.marks, r.marks))
    return e.withText(e.text + r.text);
}
class PJe {
  constructor(r, t) {
    this.schema = r, this.tokenHandlers = t, this.stack = [{ type: r.topNodeType, attrs: null, content: [], marks: wr.none }];
  }
  top() {
    return this.stack[this.stack.length - 1];
  }
  push(r) {
    this.stack.length && this.top().content.push(r);
  }
  // Adds the given text to the current position in the document,
  // using the current marks as styling.
  addText(r) {
    if (!r)
      return;
    let t = this.top(), i = t.content, n = i[i.length - 1], s = this.schema.text(r, t.marks), u;
    n && (u = CJe(n, s)) ? i[i.length - 1] = u : i.push(s);
  }
  // Adds the given mark to the set of active marks.
  openMark(r) {
    let t = this.top();
    t.marks = r.addToSet(t.marks);
  }
  // Removes the given mark from the set of active marks.
  closeMark(r) {
    let t = this.top();
    t.marks = r.removeFromSet(t.marks);
  }
  parseTokens(r) {
    for (let t = 0; t < r.length; t++) {
      let i = r[t], n = this.tokenHandlers[i.type];
      if (!n)
        throw new Error("Token type `" + i.type + "` not supported by Markdown parser");
      n(this, i, r, t);
    }
  }
  // Add a node at the current position.
  addNode(r, t, i) {
    let n = this.top(), s = r.createAndFill(t, i, n ? n.marks : []);
    return s ? (this.push(s), s) : null;
  }
  // Wrap subsequent content in a node of the given type.
  openNode(r, t) {
    this.stack.push({ type: r, attrs: t, content: [], marks: wr.none });
  }
  // Close and return the node that is currently on top of the stack.
  closeNode() {
    let r = this.stack.pop();
    return this.addNode(r.type, r.attrs, r.content);
  }
}
function gc(e, r, t, i) {
  return e.getAttrs ? e.getAttrs(r, t, i) : e.attrs instanceof Function ? e.attrs(r) : e.attrs;
}
function sv(e, r) {
  return e.noCloseToken || r == "code_inline" || r == "code_block" || r == "fence";
}
function BD(e) {
  return e[e.length - 1] == `
` ? e.slice(0, e.length - 1) : e;
}
function uv() {
}
function SJe(e, r) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let i in r) {
    let n = r[i];
    if (n.block) {
      let s = e.nodeType(n.block);
      sv(n, i) ? t[i] = (u, o, d, a) => {
        u.openNode(s, gc(n, o, d, a)), u.addText(BD(o.content)), u.closeNode();
      } : (t[i + "_open"] = (u, o, d, a) => u.openNode(s, gc(n, o, d, a)), t[i + "_close"] = (u) => u.closeNode());
    } else if (n.node) {
      let s = e.nodeType(n.node);
      t[i] = (u, o, d, a) => u.addNode(s, gc(n, o, d, a));
    } else if (n.mark) {
      let s = e.marks[n.mark];
      sv(n, i) ? t[i] = (u, o, d, a) => {
        u.openMark(s.create(gc(n, o, d, a))), u.addText(BD(o.content)), u.closeMark(s);
      } : (t[i + "_open"] = (u, o, d, a) => u.openMark(s.create(gc(n, o, d, a))), t[i + "_close"] = (u) => u.closeMark(s));
    } else if (n.ignore)
      sv(n, i) ? t[i] = uv : (t[i + "_open"] = uv, t[i + "_close"] = uv);
    else
      throw new RangeError("Unrecognized parsing spec " + JSON.stringify(n));
  }
  return t.text = (i, n) => i.addText(n.content), t.inline = (i, n) => i.parseTokens(n.children), t.softbreak = t.softbreak || ((i) => i.addText(" ")), t;
}
let NJe = class {
  /**
  Create a parser with the given configuration. You can configure
  the markdown-it parser to parse the dialect you want, and provide
  a description of the ProseMirror entities those tokens map to in
  the `tokens` object, which maps token names to descriptions of
  what to do with them. Such a description is an object, and may
  have the following properties:
  */
  constructor(r, t, i) {
    this.schema = r, this.tokenizer = t, this.tokens = i, this.tokenHandlers = SJe(r, i);
  }
  /**
  Parse a string as [CommonMark](http://commonmark.org/) markup,
  and create a ProseMirror document as prescribed by this parser's
  rules.
  
  The second argument, when given, is passed through to the
  [Markdown
  parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
  */
  parse(r, t = {}) {
    let i = new PJe(this.schema, this.tokenHandlers), n;
    i.parseTokens(this.tokenizer.parse(r, t));
    do
      n = i.closeNode();
    while (i.stack.length);
    return n || this.schema.topNodeType.createAndFill();
  }
};
function WD(e, r) {
  for (; ++r < e.length; )
    if (e[r].type != "list_item_open")
      return e[r].hidden;
  return !1;
}
new NJe(wJe, Ji("commonmark", { html: !1 }), {
  blockquote: { block: "blockquote" },
  paragraph: { block: "paragraph" },
  list_item: { block: "list_item" },
  bullet_list: { block: "bullet_list", getAttrs: (e, r, t) => ({ tight: WD(r, t) }) },
  ordered_list: { block: "ordered_list", getAttrs: (e, r, t) => ({
    order: +e.attrGet("start") || 1,
    tight: WD(r, t)
  }) },
  heading: { block: "heading", getAttrs: (e) => ({ level: +e.tag.slice(1) }) },
  code_block: { block: "code_block", noCloseToken: !0 },
  fence: { block: "code_block", getAttrs: (e) => ({ params: e.info || "" }), noCloseToken: !0 },
  hr: { node: "horizontal_rule" },
  image: { node: "image", getAttrs: (e) => ({
    src: e.attrGet("src"),
    title: e.attrGet("title") || null,
    alt: e.children[0] && e.children[0].content || null
  }) },
  hardbreak: { node: "hard_break" },
  em: { mark: "em" },
  strong: { mark: "strong" },
  link: { mark: "link", getAttrs: (e) => ({
    href: e.attrGet("href"),
    title: e.attrGet("title") || null
  }) },
  code_inline: { mark: "code", noCloseToken: !0 }
});
const MJe = { open: "", close: "", mixable: !0 };
let TJe = class {
  /**
  Construct a serializer with the given configuration. The `nodes`
  object should map node names in a given schema to function that
  take a serializer state and such a node, and serialize the node.
  */
  constructor(r, t, i = {}) {
    this.nodes = r, this.marks = t, this.options = i;
  }
  /**
  Serialize the content of the given node to
  [CommonMark](http://commonmark.org/).
  */
  serialize(r, t = {}) {
    t = Object.assign({}, this.options, t);
    let i = new Mre(this.nodes, this.marks, t);
    return i.renderContent(r), i.out;
  }
};
const su = new TJe({
  blockquote(e, r) {
    e.wrapBlock("> ", null, r, () => e.renderContent(r));
  },
  code_block(e, r) {
    const t = r.textContent.match(/`{3,}/gm), i = t ? t.sort().slice(-1)[0] + "`" : "```";
    e.write(i + (r.attrs.params || "") + `
`), e.text(r.textContent, !1), e.write(`
`), e.write(i), e.closeBlock(r);
  },
  heading(e, r) {
    e.write(e.repeat("#", r.attrs.level) + " "), e.renderInline(r, !1), e.closeBlock(r);
  },
  horizontal_rule(e, r) {
    e.write(r.attrs.markup || "---"), e.closeBlock(r);
  },
  bullet_list(e, r) {
    e.renderList(r, "  ", () => (r.attrs.bullet || "*") + " ");
  },
  ordered_list(e, r) {
    let t = r.attrs.order || 1, i = String(t + r.childCount - 1).length, n = e.repeat(" ", i + 2);
    e.renderList(r, n, (s) => {
      let u = String(t + s);
      return e.repeat(" ", i - u.length) + u + ". ";
    });
  },
  list_item(e, r) {
    e.renderContent(r);
  },
  paragraph(e, r) {
    e.renderInline(r), e.closeBlock(r);
  },
  image(e, r) {
    e.write("![" + e.esc(r.attrs.alt || "") + "](" + r.attrs.src.replace(/[\(\)]/g, "\\$&") + (r.attrs.title ? ' "' + r.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
  },
  hard_break(e, r, t, i) {
    for (let n = i + 1; n < t.childCount; n++)
      if (t.child(n).type != r.type) {
        e.write(`\\
`);
        return;
      }
  },
  text(e, r) {
    e.text(r.text, !e.inAutolink);
  }
}, {
  em: { open: "*", close: "*", mixable: !0, expelEnclosingWhitespace: !0 },
  strong: { open: "**", close: "**", mixable: !0, expelEnclosingWhitespace: !0 },
  link: {
    open(e, r, t, i) {
      return e.inAutolink = EJe(r, t, i), e.inAutolink ? "<" : "[";
    },
    close(e, r, t, i) {
      let { inAutolink: n } = e;
      return e.inAutolink = void 0, n ? ">" : "](" + r.attrs.href.replace(/[\(\)"]/g, "\\$&") + (r.attrs.title ? ` "${r.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
    },
    mixable: !0
  },
  code: {
    open(e, r, t, i) {
      return GD(t.child(i), -1);
    },
    close(e, r, t, i) {
      return GD(t.child(i - 1), 1);
    },
    escape: !1
  }
});
function GD(e, r) {
  let t = /`+/g, i, n = 0;
  if (e.isText)
    for (; i = t.exec(e.text); )
      n = Math.max(n, i[0].length);
  let s = n > 0 && r > 0 ? " `" : "`";
  for (let u = 0; u < n; u++)
    s += "`";
  return n > 0 && r < 0 && (s += " "), s;
}
function EJe(e, r, t) {
  if (e.attrs.title || !/^\w+:/.test(e.attrs.href))
    return !1;
  let i = r.child(t);
  return !i.isText || i.text != e.attrs.href || i.marks[i.marks.length - 1] != e ? !1 : t == r.childCount - 1 || !e.isInSet(r.child(t + 1).marks);
}
let Mre = class {
  /**
  @internal
  */
  constructor(r, t, i) {
    this.nodes = r, this.marks = t, this.options = i, this.delim = "", this.out = "", this.closed = null, this.inAutolink = void 0, this.atBlockStart = !1, this.inTightList = !1, typeof this.options.tightLists > "u" && (this.options.tightLists = !1), typeof this.options.hardBreakNodeName > "u" && (this.options.hardBreakNodeName = "hard_break");
  }
  /**
  @internal
  */
  flushClose(r = 2) {
    if (this.closed) {
      if (this.atBlank() || (this.out += `
`), r > 1) {
        let t = this.delim, i = /\s+$/.exec(t);
        i && (t = t.slice(0, t.length - i[0].length));
        for (let n = 1; n < r; n++)
          this.out += t + `
`;
      }
      this.closed = null;
    }
  }
  /**
  @internal
  */
  getMark(r) {
    let t = this.marks[r];
    if (!t) {
      if (this.options.strict !== !1)
        throw new Error(`Mark type \`${r}\` not supported by Markdown renderer`);
      t = MJe;
    }
    return t;
  }
  /**
  Render a block, prefixing each line with `delim`, and the first
  line in `firstDelim`. `node` should be the node that is closed at
  the end of the block, and `f` is a function that renders the
  content of the block.
  */
  wrapBlock(r, t, i, n) {
    let s = this.delim;
    this.write(t ?? r), this.delim += r, n(), this.delim = s, this.closeBlock(i);
  }
  /**
  @internal
  */
  atBlank() {
    return /(^|\n)$/.test(this.out);
  }
  /**
  Ensure the current content ends with a newline.
  */
  ensureNewLine() {
    this.atBlank() || (this.out += `
`);
  }
  /**
  Prepare the state for writing output (closing closed paragraphs,
  adding delimiters, and so on), and then optionally add content
  (unescaped) to the output.
  */
  write(r) {
    this.flushClose(), this.delim && this.atBlank() && (this.out += this.delim), r && (this.out += r);
  }
  /**
  Close the block for the given node.
  */
  closeBlock(r) {
    this.closed = r;
  }
  /**
  Add the given text to the document. When escape is not `false`,
  it will be escaped.
  */
  text(r, t = !0) {
    let i = r.split(`
`);
    for (let n = 0; n < i.length; n++)
      this.write(), !t && i[n][0] == "[" && /(^|[^\\])\!$/.test(this.out) && (this.out = this.out.slice(0, this.out.length - 1) + "\\!"), this.out += t ? this.esc(i[n], this.atBlockStart) : i[n], n != i.length - 1 && (this.out += `
`);
  }
  /**
  Render the given node as a block.
  */
  render(r, t, i) {
    if (this.nodes[r.type.name])
      this.nodes[r.type.name](this, r, t, i);
    else {
      if (this.options.strict !== !1)
        throw new Error("Token type `" + r.type.name + "` not supported by Markdown renderer");
      r.type.isLeaf || (r.type.inlineContent ? this.renderInline(r) : this.renderContent(r), r.isBlock && this.closeBlock(r));
    }
  }
  /**
  Render the contents of `parent` as block nodes.
  */
  renderContent(r) {
    r.forEach((t, i, n) => this.render(t, r, n));
  }
  /**
  Render the contents of `parent` as inline content.
  */
  renderInline(r, t = !0) {
    this.atBlockStart = t;
    let i = [], n = "", s = (u, o, d) => {
      let a = u ? u.marks : [];
      u && u.type.name === this.options.hardBreakNodeName && (a = a.filter((q) => {
        if (d + 1 == r.childCount)
          return !1;
        let f = r.child(d + 1);
        return q.isInSet(f.marks) && (!f.isText || /\S/.test(f.text));
      }));
      let V = n;
      if (n = "", u && u.isText && a.some((q) => {
        let f = this.getMark(q.type.name);
        return f && f.expelEnclosingWhitespace && !q.isInSet(i);
      })) {
        let [q, f, p] = /^(\s*)(.*)$/m.exec(u.text);
        f && (V += f, u = p ? u.withText(p) : null, u || (a = i));
      }
      if (u && u.isText && a.some((q) => {
        let f = this.getMark(q.type.name);
        return f && f.expelEnclosingWhitespace && (d == r.childCount - 1 || !q.isInSet(r.child(d + 1).marks));
      })) {
        let [q, f, p] = /^(.*?)(\s*)$/m.exec(u.text);
        p && (n = p, u = f ? u.withText(f) : null, u || (a = i));
      }
      let c = a.length ? a[a.length - 1] : null, F = c && this.getMark(c.type.name).escape === !1, X = a.length - (F ? 1 : 0);
      e: for (let q = 0; q < X; q++) {
        let f = a[q];
        if (!this.getMark(f.type.name).mixable)
          break;
        for (let p = 0; p < i.length; p++) {
          let m = i[p];
          if (!this.getMark(m.type.name).mixable)
            break;
          if (f.eq(m)) {
            q > p ? a = a.slice(0, p).concat(f).concat(a.slice(p, q)).concat(a.slice(q + 1, X)) : p > q && (a = a.slice(0, q).concat(a.slice(q + 1, p)).concat(f).concat(a.slice(p, X)));
            continue e;
          }
        }
      }
      let Y = 0;
      for (; Y < Math.min(i.length, X) && a[Y].eq(i[Y]); )
        ++Y;
      for (; Y < i.length; )
        this.text(this.markString(i.pop(), !1, r, d), !1);
      if (V && this.text(V), u) {
        for (; i.length < X; ) {
          let q = a[i.length];
          i.push(q), this.text(this.markString(q, !0, r, d), !1), this.atBlockStart = !1;
        }
        F && u.isText ? this.text(this.markString(c, !0, r, d) + u.text + this.markString(c, !1, r, d + 1), !1) : this.render(u, r, d), this.atBlockStart = !1;
      }
      u != null && u.isText && u.nodeSize > 0 && (this.atBlockStart = !1);
    };
    r.forEach(s), s(null, 0, r.childCount), this.atBlockStart = !1;
  }
  /**
  Render a node's content as a list. `delim` should be the extra
  indentation added to all lines except the first in an item,
  `firstDelim` is a function going from an item index to a
  delimiter for the first line of the item.
  */
  renderList(r, t, i) {
    this.closed && this.closed.type == r.type ? this.flushClose(3) : this.inTightList && this.flushClose(1);
    let n = typeof r.attrs.tight < "u" ? r.attrs.tight : this.options.tightLists, s = this.inTightList;
    this.inTightList = n, r.forEach((u, o, d) => {
      d && n && this.flushClose(1), this.wrapBlock(t, i(d), r, () => this.render(u, r, d));
    }), this.inTightList = s;
  }
  /**
  Escape the given string so that it can safely appear in Markdown
  content. If `startOfLine` is true, also escape characters that
  have special meaning only at the start of the line.
  */
  esc(r, t = !1) {
    return r = r.replace(/[`*\\~\[\]_]/g, (i, n) => i == "_" && n > 0 && n + 1 < r.length && r[n - 1].match(/\w/) && r[n + 1].match(/\w/) ? i : "\\" + i), t && (r = r.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, "$1\\$2$3").replace(/^(\s*\d+)\.\s/, "$1\\. ")), this.options.escapeExtraCharacters && (r = r.replace(this.options.escapeExtraCharacters, "\\$&")), r;
  }
  /**
  @internal
  */
  quote(r) {
    let t = r.indexOf('"') == -1 ? '""' : r.indexOf("'") == -1 ? "''" : "()";
    return t[0] + r + t[1];
  }
  /**
  Repeat the given string `n` times.
  */
  repeat(r, t) {
    let i = "";
    for (let n = 0; n < t; n++)
      i += r;
    return i;
  }
  /**
  Get the markdown string for a given opening or closing mark.
  */
  markString(r, t, i, n) {
    let s = this.getMark(r.type.name), u = t ? s.open : s.close;
    return typeof u == "string" ? u : u(this, r, i, n);
  }
  /**
  Get leading and trailing whitespace from a string. Values of
  leading or trailing property of the return object will be undefined
  if there is no match.
  */
  getEnclosingWhitespace(r) {
    return {
      leading: (r.match(/^(\s+)/) || [void 0])[0],
      trailing: (r.match(/(\s+)$/) || [void 0])[0]
    };
  }
};
var ov, UD;
function kJe() {
  if (UD) return ov;
  UD = 1;
  var e = !0, r = !1, t = !1;
  ov = function(q, f) {
    f && (e = !f.enabled, r = !!f.label, t = !!f.labelAfter), q.core.ruler.after("inline", "github-task-lists", function(p) {
      for (var m = p.tokens, g = 2; g < m.length; g++)
        s(m, g) && (u(m[g], p.Token), i(m[g - 2], "class", "task-list-item" + (e ? "" : " enabled")), i(m[n(m, g - 2)], "class", "contains-task-list"));
    });
  };
  function i(q, f, p) {
    var m = q.attrIndex(f), g = [f, p];
    m < 0 ? q.attrPush(g) : q.attrs[m] = g;
  }
  function n(q, f) {
    for (var p = q[f].level - 1, m = f - 1; m >= 0; m--)
      if (q[m].level === p)
        return m;
    return -1;
  }
  function s(q, f) {
    return c(q[f]) && F(q[f - 1]) && X(q[f - 2]) && Y(q[f]);
  }
  function u(q, f) {
    if (q.children.unshift(o(q, f)), q.children[1].content = q.children[1].content.slice(3), q.content = q.content.slice(3), r)
      if (t) {
        q.children.pop();
        var p = "task-item-" + Math.ceil(Math.random() * (1e4 * 1e3) - 1e3);
        q.children[0].content = q.children[0].content.slice(0, -1) + ' id="' + p + '">', q.children.push(V(q.content, p, f));
      } else
        q.children.unshift(d(f)), q.children.push(a(f));
  }
  function o(q, f) {
    var p = new f("html_inline", "", 0), m = e ? ' disabled="" ' : "";
    return q.content.indexOf("[ ] ") === 0 ? p.content = '<input class="task-list-item-checkbox"' + m + 'type="checkbox">' : (q.content.indexOf("[x] ") === 0 || q.content.indexOf("[X] ") === 0) && (p.content = '<input class="task-list-item-checkbox" checked=""' + m + 'type="checkbox">'), p;
  }
  function d(q) {
    var f = new q("html_inline", "", 0);
    return f.content = "<label>", f;
  }
  function a(q) {
    var f = new q("html_inline", "", 0);
    return f.content = "</label>", f;
  }
  function V(q, f, p) {
    var m = new p("html_inline", "", 0);
    return m.content = '<label class="task-list-item-label" for="' + f + '">' + q + "</label>", m.attrs = [{ for: f }], m;
  }
  function c(q) {
    return q.type === "inline";
  }
  function F(q) {
    return q.type === "paragraph_open";
  }
  function X(q) {
    return q.type === "list_item_open";
  }
  function Y(q) {
    return q.content.indexOf("[ ] ") === 0 || q.content.indexOf("[x] ") === 0 || q.content.indexOf("[X] ") === 0;
  }
  return ov;
}
var OJe = kJe();
const DJe = /* @__PURE__ */ Mr(OJe);
var RJe = Object.defineProperty, IJe = (e, r, t) => r in e ? RJe(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Mq = (e, r, t) => (IJe(e, typeof r != "symbol" ? r + "" : r, t), t);
const LJe = Bt.create({
  name: "markdownTightLists",
  addOptions: () => ({
    tight: !0,
    tightClass: "tight",
    listTypes: ["bulletList", "orderedList"]
  }),
  addGlobalAttributes() {
    return [{
      types: this.options.listTypes,
      attributes: {
        tight: {
          default: this.options.tight,
          parseHTML: (e) => e.getAttribute("data-tight") === "true" || !e.querySelector("p"),
          renderHTML: (e) => ({
            class: e.tight ? this.options.tightClass : null,
            "data-tight": e.tight ? "true" : null
          })
        }
      }
    }];
  },
  addCommands() {
    var e = this;
    return {
      toggleTight: function() {
        let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        return (t) => {
          let {
            editor: i,
            commands: n
          } = t;
          function s(u) {
            if (!i.isActive(u))
              return !1;
            const o = i.getAttributes(u);
            return n.updateAttributes(u, {
              tight: r ?? !(o != null && o.tight)
            });
          }
          return e.options.listTypes.some((u) => s(u));
        };
      }
    };
  }
}), ZD = Ji();
function Tre(e, r) {
  return ZD.inline.State.prototype.scanDelims.call({
    src: e,
    posMax: e.length
  }), new ZD.inline.State(e, null, null, []).scanDelims(r, !0);
}
function Ere(e, r, t, i) {
  let n = e.substring(0, t) + e.substring(t + r.length);
  return n = n.substring(0, t + i) + r + n.substring(t + i), n;
}
function _Je(e, r, t, i) {
  let n = t, s = e;
  for (; n < i && !Tre(s, n).can_open; )
    s = Ere(s, r, n, 1), n++;
  return {
    text: s,
    from: n,
    to: i
  };
}
function HJe(e, r, t, i) {
  let n = i, s = e;
  for (; n > t && !Tre(s, n).can_close; )
    s = Ere(s, r, n, -1), n--;
  return {
    text: s,
    from: t,
    to: n
  };
}
function jJe(e, r, t, i) {
  let n = {
    text: e,
    from: t,
    to: i
  };
  return n = _Je(n.text, r, n.from, n.to), n = HJe(n.text, r, n.from, n.to), n.to - n.from < r.length + 1 && (n.text = n.text.substring(0, n.from) + n.text.substring(n.to + r.length)), n.text;
}
class zJe extends Mre {
  constructor(r, t, i) {
    super(r, t, i ?? {}), Mq(this, "inTable", !1), this.inlines = [];
  }
  render(r, t, i) {
    super.render(r, t, i);
    const n = this.inlines[this.inlines.length - 1];
    if (n != null && n.start && n !== null && n !== void 0 && n.end) {
      const {
        delimiter: s,
        start: u,
        end: o
      } = this.normalizeInline(n);
      this.out = jJe(this.out, s, u, o), this.inlines.pop();
    }
  }
  markString(r, t, i, n) {
    const s = this.marks[r.type.name];
    if (s.expelEnclosingWhitespace)
      if (t)
        this.inlines.push({
          start: this.out.length,
          delimiter: s.open
        });
      else {
        const u = this.inlines.pop();
        this.inlines.push({
          ...u,
          end: this.out.length
        });
      }
    return super.markString(r, t, i, n);
  }
  normalizeInline(r) {
    let {
      start: t,
      end: i
    } = r;
    for (; this.out.charAt(t).match(/\s/); )
      t++;
    return {
      ...r,
      start: t
    };
  }
}
const kre = Ui.create({
  name: "markdownHTMLMark",
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: {
          open(e, r) {
            var t, i;
            return this.editor.storage.markdown.options.html ? (t = (i = JD(r)) === null || i === void 0 ? void 0 : i[0]) !== null && t !== void 0 ? t : "" : (console.warn(`Tiptap Markdown: "${r.type.name}" mark is only available in html mode`), "");
          },
          close(e, r) {
            var t, i;
            return this.editor.storage.markdown.options.html && (t = (i = JD(r)) === null || i === void 0 ? void 0 : i[1]) !== null && t !== void 0 ? t : "";
          }
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
});
function JD(e) {
  const r = e.type.schema, t = r.text(" ", [e]), n = $4(Fe.from(t), r).match(/^(<.*?>) (<\/.*?>)$/);
  return n ? [n[1], n[2]] : null;
}
function a5(e) {
  const r = `<body>${e}</body>`;
  return new window.DOMParser().parseFromString(r, "text/html").body;
}
function BJe(e) {
  return e == null ? void 0 : e.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function WJe(e) {
  const r = e.parentElement, t = r.cloneNode();
  for (; r.firstChild && r.firstChild !== e; )
    t.appendChild(r.firstChild);
  t.childNodes.length > 0 && r.parentElement.insertBefore(t, r), r.parentElement.insertBefore(e, r), r.childNodes.length === 0 && r.remove();
}
function GJe(e) {
  const r = e.parentNode;
  for (; e.firstChild; )
    r.insertBefore(e.firstChild, e);
  r.removeChild(e);
}
const $f = Jr.create({
  name: "markdownHTMLNode",
  addStorage() {
    return {
      markdown: {
        serialize(e, r, t) {
          this.editor.storage.markdown.options.html ? e.write(UJe(r, t)) : (console.warn(`Tiptap Markdown: "${r.type.name}" node is only available in html mode`), e.write(`[${r.type.name}]`)), r.isBlock && e.closeBlock(r);
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
});
function UJe(e, r) {
  const t = e.type.schema, i = $4(Fe.from(e), t);
  return e.isBlock && (r instanceof Fe || r.type.name === t.topNodeType.name) ? ZJe(i) : i;
}
function ZJe(e) {
  const t = a5(e).firstElementChild;
  return t.innerHTML = t.innerHTML.trim() ? `
${t.innerHTML}
` : `
`, t.outerHTML;
}
const JJe = Jr.create({
  name: "blockquote"
}), $Je = JJe.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: su.nodes.blockquote,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), QJe = Jr.create({
  name: "bulletList"
}), Ore = QJe.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(e, r) {
          return e.renderList(r, "  ", () => (this.editor.storage.markdown.options.bulletListMarker || "-") + " ");
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), e$e = Jr.create({
  name: "codeBlock"
}), r$e = e$e.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(e, r) {
          e.write("```" + (r.attrs.language || "") + `
`), e.text(r.textContent, !1), e.ensureNewLine(), e.write("```"), e.closeBlock(r);
        },
        parse: {
          setup(e) {
            var r;
            e.set({
              langPrefix: (r = this.options.languageClassPrefix) !== null && r !== void 0 ? r : "language-"
            });
          },
          updateDOM(e) {
            e.innerHTML = e.innerHTML.replace(/\n<\/code><\/pre>/g, "</code></pre>");
          }
        }
      }
    };
  }
}), t$e = Jr.create({
  name: "hardBreak"
}), Dre = t$e.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(e, r, t, i) {
          for (let n = i + 1; n < t.childCount; n++)
            if (t.child(n).type != r.type) {
              e.write(e.inTable ? $f.storage.markdown.serialize.call(this, e, r, t) : `\\
`);
              return;
            }
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), i$e = Jr.create({
  name: "heading"
}), n$e = i$e.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: su.nodes.heading,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), s$e = Jr.create({
  name: "horizontalRule"
}), u$e = s$e.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: su.nodes.horizontal_rule,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), o$e = Jr.create({
  name: "image"
}), d$e = o$e.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: su.nodes.image,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), a$e = Jr.create({
  name: "listItem"
}), V$e = a$e.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: su.nodes.list_item,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), l$e = Jr.create({
  name: "orderedList"
});
function c$e(e, r, t) {
  let i = 0;
  for (; t - i > 0 && r.child(t - i - 1).type.name === e.type.name; i++)
    ;
  return i;
}
const F$e = l$e.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(e, r, t, i) {
          const n = r.attrs.start || 1, s = String(n + r.childCount - 1).length, u = e.repeat(" ", s + 2), d = c$e(r, t, i) % 2 ? ") " : ". ";
          e.renderList(r, u, (a) => {
            const V = String(n + a);
            return e.repeat(" ", s - V.length) + V + d;
          });
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), x$e = Jr.create({
  name: "paragraph"
}), X$e = x$e.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: su.nodes.paragraph,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
});
function dv(e) {
  var r, t;
  return (r = e == null || (t = e.content) === null || t === void 0 ? void 0 : t.content) !== null && r !== void 0 ? r : [];
}
const q$e = Jr.create({
  name: "table"
}), Y$e = q$e.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(e, r, t) {
          if (!f$e(r)) {
            $f.storage.markdown.serialize.call(this, e, r, t);
            return;
          }
          e.inTable = !0, r.forEach((i, n, s) => {
            if (e.write("| "), i.forEach((u, o, d) => {
              d && e.write(" | ");
              const a = u.firstChild;
              a.textContent.trim() && e.renderInline(a);
            }), e.write(" |"), e.ensureNewLine(), !s) {
              const u = Array.from({
                length: i.childCount
              }).map(() => "---").join(" | ");
              e.write(`| ${u} |`), e.ensureNewLine();
            }
          }), e.closeBlock(r), e.inTable = !1;
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
});
function $D(e) {
  return e.attrs.colspan > 1 || e.attrs.rowspan > 1;
}
function f$e(e) {
  const r = dv(e), t = r[0], i = r.slice(1);
  return !(dv(t).some((n) => n.type.name !== "tableHeader" || $D(n) || n.childCount > 1) || i.some((n) => dv(n).some((s) => s.type.name === "tableHeader" || $D(s) || s.childCount > 1)));
}
const K$e = Jr.create({
  name: "taskItem"
}), h$e = K$e.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(e, r) {
          const t = r.attrs.checked ? "[x]" : "[ ]";
          e.write(`${t} `), e.renderContent(r);
        },
        parse: {
          updateDOM(e) {
            [...e.querySelectorAll(".task-list-item")].forEach((r) => {
              const t = r.querySelector("input");
              r.setAttribute("data-type", "taskItem"), t && (r.setAttribute("data-checked", t.checked), t.remove());
            });
          }
        }
      }
    };
  }
}), p$e = Jr.create({
  name: "taskList"
}), m$e = p$e.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: Ore.storage.markdown.serialize,
        parse: {
          setup(e) {
            e.use(DJe);
          },
          updateDOM(e) {
            [...e.querySelectorAll(".contains-task-list")].forEach((r) => {
              r.setAttribute("data-type", "taskList");
            });
          }
        }
      }
    };
  }
}), g$e = Jr.create({
  name: "text"
}), v$e = g$e.extend({
  /**
   * @return {{markdown: MarkdownNodeSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize(e, r) {
          e.text(BJe(r.text));
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), b$e = Ui.create({
  name: "bold"
}), y$e = b$e.extend({
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: su.marks.strong,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), A$e = Ui.create({
  name: "code"
}), w$e = A$e.extend({
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: su.marks.code,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), C$e = Ui.create({
  name: "italic"
}), P$e = C$e.extend({
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: su.marks.em,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), S$e = Ui.create({
  name: "link"
}), N$e = S$e.extend({
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: su.marks.link,
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), M$e = Ui.create({
  name: "strike"
}), T$e = M$e.extend({
  /**
   * @return {{markdown: MarkdownMarkSpec}}
   */
  addStorage() {
    return {
      markdown: {
        serialize: {
          open: "~~",
          close: "~~",
          expelEnclosingWhitespace: !0
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
}), E$e = [$Je, Ore, r$e, Dre, n$e, u$e, $f, d$e, V$e, F$e, X$e, Y$e, h$e, m$e, v$e, y$e, w$e, kre, P$e, N$e, T$e];
function Tq(e) {
  var r, t;
  const i = (r = e.storage) === null || r === void 0 ? void 0 : r.markdown, n = (t = E$e.find((s) => s.name === e.name)) === null || t === void 0 ? void 0 : t.storage.markdown;
  return i || n ? {
    ...n,
    ...i
  } : null;
}
class k$e {
  constructor(r) {
    Mq(this, "editor", null), this.editor = r;
  }
  serialize(r) {
    const t = new zJe(this.nodes, this.marks, {
      hardBreakNodeName: Dre.name
    });
    return t.renderContent(r), t.out;
  }
  get nodes() {
    var r;
    return {
      ...Object.fromEntries(Object.keys(this.editor.schema.nodes).map((t) => [t, this.serializeNode($f)])),
      ...Object.fromEntries((r = this.editor.extensionManager.extensions.filter((t) => t.type === "node" && this.serializeNode(t)).map((t) => [t.name, this.serializeNode(t)])) !== null && r !== void 0 ? r : [])
    };
  }
  get marks() {
    var r;
    return {
      ...Object.fromEntries(Object.keys(this.editor.schema.marks).map((t) => [t, this.serializeMark(kre)])),
      ...Object.fromEntries((r = this.editor.extensionManager.extensions.filter((t) => t.type === "mark" && this.serializeMark(t)).map((t) => [t.name, this.serializeMark(t)])) !== null && r !== void 0 ? r : [])
    };
  }
  serializeNode(r) {
    var t;
    return (t = Tq(r)) === null || t === void 0 || (t = t.serialize) === null || t === void 0 ? void 0 : t.bind({
      editor: this.editor,
      options: r.options
    });
  }
  serializeMark(r) {
    var t;
    const i = (t = Tq(r)) === null || t === void 0 ? void 0 : t.serialize;
    return i ? {
      ...i,
      open: typeof i.open == "function" ? i.open.bind({
        editor: this.editor,
        options: r.options
      }) : i.open,
      close: typeof i.close == "function" ? i.close.bind({
        editor: this.editor,
        options: r.options
      }) : i.close
    } : null;
  }
}
class O$e {
  constructor(r, t) {
    Mq(this, "editor", null), Mq(this, "md", null);
    let {
      html: i,
      linkify: n,
      breaks: s
    } = t;
    this.editor = r, this.md = this.withPatchedRenderer(Ji({
      html: i,
      linkify: n,
      breaks: s
    }));
  }
  parse(r) {
    let {
      inline: t
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (typeof r == "string") {
      this.editor.extensionManager.extensions.forEach((s) => {
        var u;
        return (u = Tq(s)) === null || u === void 0 || (u = u.parse) === null || u === void 0 || (u = u.setup) === null || u === void 0 ? void 0 : u.call({
          editor: this.editor,
          options: s.options
        }, this.md);
      });
      const i = this.md.render(r), n = a5(i);
      return this.editor.extensionManager.extensions.forEach((s) => {
        var u;
        return (u = Tq(s)) === null || u === void 0 || (u = u.parse) === null || u === void 0 || (u = u.updateDOM) === null || u === void 0 ? void 0 : u.call({
          editor: this.editor,
          options: s.options
        }, n);
      }), this.normalizeDOM(n, {
        inline: t,
        content: r
      }), n.innerHTML;
    }
    return r;
  }
  normalizeDOM(r, t) {
    let {
      inline: i,
      content: n
    } = t;
    return this.normalizeBlocks(r), r.querySelectorAll("*").forEach((s) => {
      var u;
      ((u = s.nextSibling) === null || u === void 0 ? void 0 : u.nodeType) === Node.TEXT_NODE && !s.closest("pre") && (s.nextSibling.textContent = s.nextSibling.textContent.replace(/^\n/, ""));
    }), i && this.normalizeInline(r, n), r;
  }
  normalizeBlocks(r) {
    const i = Object.values(this.editor.schema.nodes).filter((n) => n.isBlock).map((n) => {
      var s;
      return (s = n.spec.parseDOM) === null || s === void 0 ? void 0 : s.map((u) => u.tag);
    }).flat().filter(Boolean).join(",");
    i && [...r.querySelectorAll(i)].forEach((n) => {
      n.parentElement.matches("p") && WJe(n);
    });
  }
  normalizeInline(r, t) {
    var i;
    if ((i = r.firstElementChild) !== null && i !== void 0 && i.matches("p")) {
      var n, s, u, o;
      const d = r.firstElementChild, {
        nextElementSibling: a
      } = d, V = (n = (s = t.match(/^\s+/)) === null || s === void 0 ? void 0 : s[0]) !== null && n !== void 0 ? n : "", c = a ? "" : (u = (o = t.match(/\s+$/)) === null || o === void 0 ? void 0 : o[0]) !== null && u !== void 0 ? u : "";
      if (t.match(/^\n\n/)) {
        d.innerHTML = `${d.innerHTML}${c}`;
        return;
      }
      GJe(d), r.innerHTML = `${V}${r.innerHTML}${c}`;
    }
  }
  /**
   * @param {markdownit} md
   */
  withPatchedRenderer(r) {
    const t = (i) => function() {
      const n = i(...arguments);
      return n === `
` ? n : n[n.length - 1] === `
` ? n.slice(0, -1) : n;
    };
    return r.renderer.rules.hardbreak = t(r.renderer.rules.hardbreak), r.renderer.rules.softbreak = t(r.renderer.rules.softbreak), r.renderer.rules.fence = t(r.renderer.rules.fence), r.renderer.rules.code_block = t(r.renderer.rules.code_block), r.renderer.renderToken = t(r.renderer.renderToken.bind(r.renderer)), r;
  }
}
const D$e = Bt.create({
  name: "markdownClipboard",
  addOptions() {
    return {
      transformPastedText: !1,
      transformCopiedText: !1
    };
  },
  addProseMirrorPlugins() {
    return [new Ei({
      key: new hs("markdownClipboard"),
      props: {
        clipboardTextParser: (e, r, t) => {
          if (t || !this.options.transformPastedText)
            return null;
          const i = this.editor.storage.markdown.parser.parse(e, {
            inline: !0
          });
          return Mu.fromSchema(this.editor.schema).parseSlice(a5(i), {
            preserveWhitespace: !0,
            context: r
          });
        },
        /**
         * @param {import('prosemirror-model').Slice} slice
         */
        clipboardTextSerializer: (e) => this.options.transformCopiedText ? this.editor.storage.markdown.serializer.serialize(e.content) : null
      }
    })];
  }
}), R$e = Bt.create({
  name: "markdown",
  priority: 50,
  addOptions() {
    return {
      html: !0,
      tightLists: !0,
      tightListClass: "tight",
      bulletListMarker: "-",
      linkify: !1,
      breaks: !1,
      transformPastedText: !1,
      transformCopiedText: !1
    };
  },
  addCommands() {
    const e = qWe.Commands.config.addCommands();
    return {
      setContent: (r, t, i) => (n) => e.setContent(n.editor.storage.markdown.parser.parse(r), t, i)(n),
      insertContentAt: (r, t, i) => (n) => e.insertContentAt(r, n.editor.storage.markdown.parser.parse(t, {
        inline: !0
      }), i)(n)
    };
  },
  onBeforeCreate() {
    this.editor.storage.markdown = {
      options: {
        ...this.options
      },
      parser: new O$e(this.editor, this.options),
      serializer: new k$e(this.editor),
      getMarkdown: () => this.editor.storage.markdown.serializer.serialize(this.editor.state.doc)
    }, this.editor.options.initialContent = this.editor.options.content, this.editor.options.content = this.editor.storage.markdown.parser.parse(this.editor.options.content);
  },
  onCreate() {
    this.editor.options.content = this.editor.options.initialContent, delete this.editor.options.initialContent;
  },
  addStorage() {
    return {
      /// storage will be defined in onBeforeCreate() to prevent initial object overriding
    };
  },
  addExtensions() {
    return [LJe.configure({
      tight: this.options.tightLists,
      tightClass: this.options.tightListClass
    }), D$e.configure({
      transformPastedText: this.options.transformPastedText,
      transformCopiedText: this.options.transformCopiedText
    })];
  }
});
function I$e({
  disabled: e,
  editor: r
}) {
  return r ? /* @__PURE__ */ C("div", { className: "bg-interfaceBgLight border-interactiveBorder flex items-center gap-3 rounded-t border-b px-1", children: [
    /* @__PURE__ */ C(
      cbe,
      {
        disabled: e,
        onValueChange: (t) => {
          t === "paragraph" ? r.chain().focus().setParagraph().run() : t === "heading" && r.chain().focus().toggleHeading({ level: 1 }).run();
        },
        value: r.isActive("heading") ? "heading" : "paragraph",
        children: [
          /* @__PURE__ */ l(_W, { className: "bg-interfaceBgLight my-0 h-fit w-fit rounded-none border-0 py-0", children: /* @__PURE__ */ l(Fbe, { placeholder: "Text format" }) }),
          /* @__PURE__ */ C(HW, { children: [
            /* @__PURE__ */ l(l8, { value: "paragraph", children: "Normal text" }),
            /* @__PURE__ */ l(l8, { value: "heading", children: "Heading" })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ l("div", { className: "bg-interactiveBorder w-[1px]", children: " " }),
    /* @__PURE__ */ l(
      er,
      {
        className: _(
          "my-0 ml-0 mr-0 h-fit px-2 py-1",
          r.isActive("bulletList") ? "bg-actionBgSelect" : ""
        ),
        disabled: e,
        onClick: () => r.chain().focus().toggleBulletList().run(),
        variant: "ghost",
        children: /* @__PURE__ */ l(hVe, { className: "h-4 w-4" })
      }
    ),
    /* @__PURE__ */ l(
      er,
      {
        className: _(
          "my-0 ml-0 mr-0 h-fit px-2 py-1",
          r.isActive("orderedList") ? "bg-actionBgSelect" : ""
        ),
        disabled: e,
        onClick: () => r.chain().focus().toggleOrderedList().run(),
        variant: "ghost",
        children: /* @__PURE__ */ l(YVe, { className: "h-4 w-4" })
      }
    ),
    /* @__PURE__ */ l("div", { className: "bg-interactiveBorder w-[1px]", children: " " }),
    /* @__PURE__ */ l(
      er,
      {
        className: "my-0 ml-0 mr-0 h-fit px-2 py-1",
        disabled: e || !r.can().chain().focus().undo().run(),
        onClick: () => r.chain().focus().undo().run(),
        variant: "ghost",
        children: "Undo"
      }
    ),
    /* @__PURE__ */ l(
      er,
      {
        className: "my-0 ml-0 mr-0 h-fit px-2 py-1",
        disabled: e || !r.can().chain().focus().redo().run(),
        onClick: () => r.chain().focus().redo().run(),
        variant: "ghost",
        children: "Redo"
      }
    )
  ] }) : null;
}
const Ler = re(function({ content: r, readonly: t }, i) {
  const [n, s] = ie(!0), u = $e(() => [
    _Ge.configure({
      heading: {
        HTMLAttributes: {
          class: "text-bodylg font-semibold"
        },
        levels: [1]
      },
      paragraph: {
        HTMLAttributes: {
          class: "text-bodylg"
        }
      },
      bulletList: {
        HTMLAttributes: {
          class: "list-disc ml-6"
        }
      },
      orderedList: {
        HTMLAttributes: {
          class: "list-decimal ml-6"
        }
      },
      listItem: {
        HTMLAttributes: {
          class: "marker:text-bodysm"
        }
      }
    }),
    R$e.configure({
      html: !1,
      breaks: !0,
      tightLists: !0
    })
  ], []), o = RWe({
    content: r,
    extensions: u,
    editorProps: {
      attributes: {
        class: _(
          "prose prose-sm sm:prose-base lg:prose-lg xl:prose-2xl focus:outline-hidden",
          !n && "text-textSubdued bg-interfaceBgLight"
        )
      },
      editable: () => n
    },
    onCreate: ({ editor: d }) => {
      d.view.dom.setAttribute("spellcheck", "true");
    },
    onUpdate({ editor: d }) {
      s(d.isEditable);
    }
  });
  return Pe(() => {
    o && o.commands.setContent(r);
  }, []), Pe(() => {
    s(!t);
  }, [t]), kq(i, () => ({
    getMarkdown: () => o == null ? void 0 : o.storage.markdown.getMarkdown()
  }), [o]), /* @__PURE__ */ C(
    "div",
    {
      className: _(
        "border-interactiveBorder focus-within:ring-ring flex flex-col overflow-hidden rounded border focus-within:ring-2 focus-within:ring-offset-2",
        !n && "bg-interfaceBgLight"
      ),
      children: [
        /* @__PURE__ */ l(I$e, { disabled: !n, editor: o }),
        /* @__PURE__ */ l("div", { className: "flex grow flex-col overflow-hidden", children: /* @__PURE__ */ l("div", { className: "h-full grow overflow-y-auto px-5 py-4", children: /* @__PURE__ */ l(CWe, { editor: o }) }) })
      ]
    }
  );
});
function _er({
  latitude: e,
  longitude: r,
  addressBoundary: t,
  nearObjects: i,
  className: n
}) {
  const s = Yr(null), u = Yr([]), o = Yr([]), d = Yr([]), a = Yr([]);
  return Pe(() => {
    if (!s.current) {
      let q;
      if (e != null && r != null)
        q = { lat: e, lng: r };
      else if (t && t.length > 0) {
        const p = t.reduce((g, y) => g + y.latitude, 0) / t.length, m = t.reduce((g, y) => g + y.longitude, 0) / t.length;
        q = { lat: p, lng: m };
      } else {
        console.warn("No latitude, longitude, or addressBoundary provided");
        return;
      }
      const f = {
        zoom: 18,
        // Zoom level to display the area in detail
        center: q,
        mapTypeId: google.maps.MapTypeId.SATELLITE
        // Set to satellite view
      };
      s.current = new google.maps.Map(
        document.getElementById("map"),
        f
      ), console.log("Map initialized with center:", q);
    }
    const V = s.current;
    if (!V) return;
    u.current.forEach((q) => q.setMap(null)), o.current.forEach((q) => q.setMap(null)), d.current.forEach((q) => q.setMap(null)), a.current.forEach((q) => q.close()), u.current = [], o.current = [], d.current = [], a.current = [];
    const c = {
      WATER: {
        strokeColor: "#0000FF",
        fillColor: "#0000FF",
        strokeOpacity: 0.5,
        fillOpacity: 0.05,
        strokeWeight: 2
      },
      // Blue
      ROAD: {
        strokeColor: "#808080",
        fillColor: "#808080",
        strokeOpacity: 0.4,
        fillOpacity: 0.05,
        strokeWeight: 2
      },
      // Gray
      OVERLAY: {
        strokeColor: "#FFFF00",
        fillColor: "#FFFF00",
        strokeOpacity: 0.3,
        fillOpacity: 0.05,
        strokeWeight: 2
      },
      // Yellow
      ZONE: {
        strokeColor: "#800080",
        fillColor: "#800080",
        strokeOpacity: 0.6,
        fillOpacity: 0.05,
        strokeWeight: 2
      },
      // Purple
      BUSHFIRE_PRONE_AREA: {
        strokeColor: "#FF0000",
        fillColor: "#FF0000",
        strokeOpacity: 0.5,
        fillOpacity: 0.05,
        strokeWeight: 2
      },
      // Red
      SIGNIFICANT_TREE: {
        strokeColor: "#228800",
        fillColor: "#228800",
        strokeOpacity: 0.5,
        fillOpacity: 0.05,
        strokeWeight: 2
      }
    }, F = (q, f) => {
      const p = new google.maps.Polygon({
        paths: q,
        strokeColor: f.strokeColor,
        strokeOpacity: f.strokeOpacity,
        strokeWeight: f.strokeWeight,
        fillColor: f.fillColor,
        fillOpacity: f.fillOpacity
      });
      return p.setMap(V), u.current.push(p), p;
    }, X = (q, f) => {
      const p = new google.maps.Polyline({
        path: q,
        geodesic: !0,
        strokeColor: f.strokeColor,
        strokeOpacity: f.strokeOpacity,
        strokeWeight: f.strokeWeight
      });
      return p.setMap(V), o.current.push(p), p;
    }, Y = (q, f) => {
      const p = new google.maps.Marker({
        position: q,
        map: V,
        title: f.object_name
      });
      d.current.push(p);
      const m = `
        <div>
          <h3>${f.object_name}</h3>
          <p>Type: ${f.object_type}</p>
          <p>Sub-Type: ${f.object_sub_type}</p>
          <p>Distance: ${f.object_distance} m</p>
        </div>
      `, g = new google.maps.InfoWindow({
        content: m
      });
      a.current.push(g), p.addListener("click", () => {
        console.log(`Marker for ${f.object_name} clicked.`), a.current.forEach((y) => y.close()), g.open(V, p);
      });
    };
    if (t && t.length > 0) {
      const q = t.map(
        (p) => ({
          lat: p.latitude,
          lng: p.longitude
        })
      ), f = new google.maps.LatLngBounds();
      q.forEach((p) => f.extend(p)), V.fitBounds(f), console.log("Map bounds adjusted to boundary polygon:", f), F(q, {
        strokeColor: "#FF0000",
        fillColor: "#FF0000",
        strokeOpacity: 0.8,
        fillOpacity: 0,
        strokeWeight: 2
      });
    }
    return i && i.length > 0 && i.forEach((q, f) => {
      if (console.log(`Processing nearObject ${f}:`, q), !q.geo_data || !Array.isArray(q.geo_data)) {
        console.warn(
          `nearObjects[${f}].geo_data is undefined or not an array.`
        );
        return;
      }
      const p = q.geo_data.length;
      if (p === 1) {
        const m = {
          lat: q.geo_data[0][1],
          lng: q.geo_data[0][0]
        };
        Y(m, q);
      } else if (p === 2) {
        const m = q.geo_data.map(
          (y, b) => ({ lat: y[1], lng: y[0] })
        ), g = {
          strokeColor: c[q.object_type].strokeColor,
          strokeOpacity: c[q.object_type].strokeOpacity,
          strokeWeight: 2
        };
        X(m, g);
      } else if (p >= 3) {
        const m = q.geo_data.map(
          (w, S) => ({ lat: w[1], lng: w[0] })
        ), g = c[q.object_type];
        if (!g) {
          console.warn(
            `nearObjects[${f}] has an unknown object_type: ${q.object_type}`
          );
          return;
        }
        const y = F(m, g), b = `
            <div>
              <h3>${q.object_name}</h3>
              <p>Type: ${q.object_type}</p>
              <p>Sub-Type: ${q.object_sub_type}</p>
              <p>Distance: ${q.object_distance} m</p>
            </div>
          `, A = new google.maps.InfoWindow({
          content: b
        });
        a.current.push(A), y.addListener("click", (w) => {
          w.latLng ? (console.log(`Polygon ${f} clicked at:`, {
            lat: w.latLng.lat(),
            lng: w.latLng.lng()
          }), a.current.forEach((S) => S.close()), A.setPosition(w.latLng), A.open(V)) : console.warn(
            `Clicked position is undefined for polygon ${f}.`
          );
        });
      } else
        console.warn(
          `nearObjects[${f}] has invalid geo_data length: ${p}`
        );
    }), () => {
      console.log("Cleaning up map overlays."), u.current.forEach((q) => q.setMap(null)), o.current.forEach((q) => q.setMap(null)), d.current.forEach((q) => q.setMap(null)), a.current.forEach((q) => q.close()), u.current = [], o.current = [], d.current = [], a.current = [];
    };
  }, [e, r, t, i]), /* @__PURE__ */ l(
    "div",
    {
      id: "map",
      className: n,
      style: { width: "100%", height: "500px" },
      children: e == null && r == null && (!t || t.length === 0) ? /* @__PURE__ */ l("p", { children: "Please provide latitude and longitude or an address boundary to display the map." }) : null
    }
  );
}
var Zx = /* @__PURE__ */ ((e) => (e.none = "none", e.loading = "loading", e.done = "done", e))(Zx || {});
function Her({ items: e }) {
  const r = (t) => {
    switch (t.status) {
      case Zx.done:
        return /* @__PURE__ */ C("span", { className: "text-successDefault flex gap-1 text-bodymd", children: [
          /* @__PURE__ */ l("span", { className: "w-6", children: /* @__PURE__ */ l(Bo, {}) }),
          /* @__PURE__ */ l("span", { className: "line-through", children: t.text })
        ] });
      case Zx.loading:
        return /* @__PURE__ */ C("span", { className: "flex gap-1 text-bodymd", children: [
          /* @__PURE__ */ l("span", { className: "w-6", children: /* @__PURE__ */ l(Zs, { className: "animate-spin" }) }),
          /* @__PURE__ */ l("span", { className: "text-textPrimary", children: t.text })
        ] });
      case Zx.none:
        return /* @__PURE__ */ C("span", { className: "flex gap-1 text-bodymd", children: [
          /* @__PURE__ */ l("span", { className: "w-6", children: t.icon }),
          /* @__PURE__ */ l("span", { className: "text-textDisabled", children: t.text })
        ] });
    }
  };
  return /* @__PURE__ */ l("ul", { className: "flex flex-col space-y-2", children: e.map((t, i) => /* @__PURE__ */ l("li", { children: r(t) }, i)) });
}
function L$e({
  message: e,
  hideTime: r = !1,
  translate: t
}) {
  return /* @__PURE__ */ l(he, { children: /* @__PURE__ */ C(
    "div",
    {
      className: `flex w-full flex-col ${e.sender_account_type === Tc.USER ? "justify-start" : "justify-end"}`,
      children: [
        /* @__PURE__ */ l(
          "div",
          {
            hidden: r,
            className: `mb-0.5 flex w-full flex-row items-center ${e.sender_account_type === Tc.USER ? "justify-end" : "justify-start"}`,
            children: /* @__PURE__ */ l("div", { className: "text-textSubdued text-bodyxs ml-1", children: new Date(e.created_at || "").toLocaleDateString("en-AU", {
              hour: "2-digit",
              minute: "2-digit",
              year: "2-digit",
              month: "2-digit",
              day: "2-digit",
              timeZone: "Australia/Sydney"
            }) })
          }
        ),
        /* @__PURE__ */ l(
          "div",
          {
            className: _(
              "text-textPrimary bg-interfaceTags text-bodylg rounded-lg px-5 py-2",
              e.sender_account_type === Tc.USER ? "bg-actionDefault text-textWhite self-end" : "self-start",
              e.message_type === Q7.PLANNER_MESSAGE && "bg-greenBgDefault text-textPrimary"
            ),
            children: We(
              t != null && t.getText ? t.getText(e.text || "") : e.text || "",
              {
                components: {
                  h1({ children: i }) {
                    return /* @__PURE__ */ l(he, { children: i });
                  },
                  h2({ children: i }) {
                    return /* @__PURE__ */ l(he, { children: i });
                  },
                  h3({ children: i }) {
                    return /* @__PURE__ */ l(he, { children: i });
                  },
                  h4({ children: i }) {
                    return /* @__PURE__ */ l(he, { children: i });
                  },
                  h5({ children: i }) {
                    return /* @__PURE__ */ l(he, { children: i });
                  },
                  h6({ children: i }) {
                    return /* @__PURE__ */ l(he, { children: i });
                  },
                  p({ children: i }) {
                    return /* @__PURE__ */ l("p", { children: i });
                  }
                }
              }
            )
          }
        )
      ]
    }
  ) });
}
function jer({
  className: e,
  conversationMessages: r,
  isPublic: t,
  translate: i = Dn
}) {
  const n = (r || []).filter((s) => t && s.message_type === Q7.PLANNER_MESSAGE ? !1 : [Tc.USER, Tc.ASSISTANT].includes(
    s.sender_account_type
  ));
  return /* @__PURE__ */ l("div", { className: _("h-full min-h-0 grow", e), children: n.map((s) => /* @__PURE__ */ l(
    "div",
    {
      className: "message-styles mb-3 last:mb-0",
      "data-testid": s.id,
      children: /* @__PURE__ */ l(L$e, { message: s, translate: i })
    },
    s.id
  )) });
}
const _$e = [
  {
    items: [
      {
        experts: [["existing_landuse_assessor", "existing_landuse_conclusion"]],
        title: "Existing land use"
      },
      {
        experts: [
          ["proposed_land_use_assessor", "proposed_land_use_assessment"]
        ],
        title: "Proposed land use"
      },
      {
        experts: [["land_use_assessor_checker", "output"], "land_use_assessor"],
        title: "Land use"
      },
      {
        experts: ["zone_assessor_checker", "zone_works_report"],
        title: "Buildings and works"
      },
      {
        experts: ["vicsmart_classifier"],
        title: "VicSmart"
      }
    ],
    title: "Zone"
  },
  {
    items: [
      {
        experts: [
          "bmo_overlay_checker",
          ["bmo_overlay_assessor", "final_output"]
        ],
        title: "Bushfire Management Overlay (BMO)"
      },
      {
        experts: [
          "emo_overlay_checker",
          ["emo_overlay_assessor", "final_output"]
        ],
        title: "Erosion Management Overlay (EMO)"
      },
      {
        experts: [
          "LSIO_overlay_checker",
          ["lsio_overlay_assessor", "final_output"]
        ],
        title: "Land Subject To Inundation Overlay (LSIO)"
      },
      {
        experts: [
          "slo_overlay_checker",
          ["slo_overlay_assessor", "final_output"]
        ],
        title: "Significant Landscape Overlay (SLO)"
      },
      {
        experts: [
          "ddo_overlay_checker",
          ["ddo_overlay_assessor", "final_output"]
        ],
        title: "Design and Development Overlay (DDO)"
      },
      {
        experts: [
          "vpo_overlay_checker",
          ["vpo_overlay_assessor", "final_output"]
        ],
        title: "Vegetation Protection Overlay (VPO)"
      },
      {
        experts: [
          "sbo_overlay_checker",
          ["sbo_overlay_assessor", "final_output"]
        ],
        title: "Special Building Overlay (SBO)"
      },
      {
        experts: [["ho_overlay_assessor", "ho_overlay_report"]],
        title: "Heritage Overlay (HO)"
      },
      {
        experts: [["eso_overlay_assessor", "final_output"]],
        title: "Environmental Significance Overlay (ESO)"
      },
      {
        experts: ["slo_vicsmart_classifier"],
        title: "VicSmart Significant Landscape Overlay (SLO)"
      },
      {
        experts: ["emo_vicsmart_classifier"],
        title: "VicSmart Erosion Management Overlay (EMO)"
      },
      {
        experts: ["eso_vicsmart_classifier"],
        title: "VicSmart Environmental Significance Overlay (ESO)"
      },
      {
        experts: ["sbo_vicsmart_classifier"],
        title: "VicSmart Special Building Overlay (SBO)"
      },
      {
        experts: ["ddo_vicsmart_classifier"],
        title: "VicSmart Design and Development Overlay (DDO)"
      },
      {
        experts: ["vpo_vicsmart_classifier"],
        title: "VicSmart Vegetation Protection Overlay (VPO)"
      },
      {
        experts: ["ho_vicsmart_classifier"],
        title: "VicSmart Heritage Overlay (HO)"
      }
    ],
    title: "Overlay"
  },
  {
    items: [
      {
        experts: ["vicsmart_classifier_combined"],
        title: "VicSmart classifier"
      }
    ],
    title: "VicSmart"
  },
  {
    items: [
      {
        experts: ["mandatory_requirements_combined"],
        title: "Combined mandatory requirements"
      },
      {
        experts: ["zone_mandatory_requirements"],
        title: "Zone mandatory requirements"
      },
      {
        experts: ["DDO_mandatory_requirements"],
        title: "DDO mandatory requirements"
      }
    ],
    title: "Mandatory requirements"
  },
  {
    items: [
      {
        experts: ["application_requirements"],
        title: "Application requirements"
      }
    ],
    title: "Application requirements"
  },
  {
    items: [{ experts: ["significant_GIS"], title: "Significant GIS" }],
    title: "GIS Data"
  }
], QD = /^(No).*(at this address)$/;
function H$e({
  allowEditing: e,
  conversation: r,
  experts: t,
  info: i,
  noticeboardData: n,
  title: s
}) {
  const { getLocalisationEntry: u } = si(r), o = u("councilOrdinanceLink"), d = (f) => {
    if (Array.isArray(f)) {
      const [p, m] = f, g = n == null ? void 0 : n[p].parsed_output, y = (g == null ? void 0 : g[m]) || "";
      return ["", "No content"].includes(y) ? "Not applicable to this address" : y;
    } else if (f) {
      const p = n == null ? void 0 : n[f], m = (p == null ? void 0 : p.raw_output) || "";
      return ["", "No content"].includes(m) ? "Not applicable to this address" : m;
    }
    return "";
  }, a = Yi(
    (f) => {
      var p;
      if (Array.isArray(f)) {
        const [m, g] = f;
        return n && m in n && "parsed_output" in n[m] && ((p = n[m].parsed_output) == null ? void 0 : p[g]) && !QD.test(
          n[m].parsed_output[g]
        );
      } else {
        const m = f;
        return n && m in n && n[m].raw_output && !QD.test(n[m].raw_output);
      }
    },
    [n]
  ), V = $e(() => t.find((f) => a(f)), [a, t]), c = $e(() => Array.isArray(V) ? V[0] : V, [V]), F = $e(() => Array.isArray(V) ? V[1] : null, [V]), { hasRevisions: X } = uR({
    expertName: c || "",
    noticeboardData: n
  });
  if (!c)
    return null;
  const Y = () => /* @__PURE__ */ l(
    XR,
    {
      conversation: r,
      expertName: c,
      noticeboardData: n,
      outputKey: F,
      subTitle: /* @__PURE__ */ C("p", { className: "text-bodysm font-semibold", children: [
        "Expert:",
        " ",
        /* @__PURE__ */ C("span", { className: "text-textSubdued", children: [
          c,
          F && ` --> ${F}`
        ] })
      ] }),
      title: "Amend expert result",
      children: ({ setOpen: f }) => /* @__PURE__ */ l(
        er,
        {
          className: "text-bodyxs px-1",
          onClick: (p) => {
            p.preventDefault(), p.stopPropagation(), f(!0);
          },
          size: "tight",
          variant: "outline",
          children: "Amend"
        }
      )
    }
  ), q = () => /* @__PURE__ */ l(
    wR,
    {
      expertName: c,
      noticeboardData: n,
      subTitle: /* @__PURE__ */ C("p", { className: "text-bodysm font-semibold", children: [
        "Expert:",
        " ",
        /* @__PURE__ */ C("span", { className: "text-textSubdued", children: [
          c,
          F && ` --> ${F}`
        ] })
      ] }),
      title: "Expert result revisions",
      children: ({ setOpen: f }) => /* @__PURE__ */ l(
        er,
        {
          className: "text-bodyxs px-1",
          onClick: () => f(!0),
          size: "tight",
          variant: "outline",
          children: "Revisions"
        }
      )
    }
  );
  return /* @__PURE__ */ C(as, { className: "border-interactiveBorder", value: c, children: [
    /* @__PURE__ */ l(Vs, { className: "!px-4 !py-3 text-bodylg !font-semibold", children: /* @__PURE__ */ C("span", { className: "flex items-center gap-2", children: [
      s,
      i ? /* @__PURE__ */ C(DU, { children: [
        /* @__PURE__ */ l(RU, { children: /* @__PURE__ */ l(XVe, { className: "text-textLink" }) }),
        /* @__PURE__ */ l(IU, { children: i })
      ] }) : null,
      e && Y(),
      e && X && q()
    ] }) }),
    /* @__PURE__ */ l(ls, { className: "p-5 pt-0", children: We(d(V), { ordinanceLink: o }) })
  ] });
}
const eR = /^(No).*(at this address)$/;
function j$e({
  allowEditing: e,
  conversation: r,
  header: t,
  onChange: i,
  noticeboardData: n,
  sections: s
}) {
  const u = (o) => o.some(
    (d) => d.experts.some((a) => {
      var V, c;
      if (Array.isArray(a)) {
        const [F, X] = a;
        return n && F in n && "parsed_output" in n[F] && ((c = (V = n[F]) == null ? void 0 : V.parsed_output) == null ? void 0 : c[X]) && !eR.test(
          n[F].parsed_output[X]
        );
      } else {
        const F = a;
        return n && F in n && n[F].raw_output && !eR.test(n[F].raw_output);
      }
    })
  );
  return /* @__PURE__ */ l(bA, { children: /* @__PURE__ */ C("div", { className: "border-interfaceBorder bg-interfaceWhite flex flex-col gap-6 rounded-lg border px-10 py-8", children: [
    t,
    Array.isArray(s) && s.map((o, d) => {
      if (u(o.items))
        return /* @__PURE__ */ C("div", { children: [
          o.title && /* @__PURE__ */ l("span", { className: "text-textPrimary text-headinglg font-semibold", children: o.title }),
          /* @__PURE__ */ l(
            _s,
            {
              className: "!border-interactiveBorder mt-3 rounded-[4px] border",
              onValueChange: (a) => i == null ? void 0 : i(o == null ? void 0 : o.title, a),
              type: "multiple",
              children: o.items.map((a, V) => /* @__PURE__ */ l(
                H$e,
                {
                  allowEditing: e,
                  conversation: r,
                  experts: a.experts,
                  info: a.info,
                  title: a.title,
                  noticeboardData: n
                },
                V
              ))
            }
          )
        ] }, d);
    })
  ] }) });
}
j$e.defaultReasoningPanelSections = _$e;
function sa({ comment: e, spacer: r = /* @__PURE__ */ l("br", {}) }) {
  return e.split(`
`).map((t, i, n) => /* @__PURE__ */ C(Do, { children: [
    t,
    i < n.length - 1 ? r : null
  ] }, i));
}
function z$e({
  reviews: e,
  conversationId: r,
  onSubmitSuccess: t
}) {
  const i = e.at(-1), [n, s] = ie(""), [u, o] = ie(""), [d, a] = ie(""), [V, c] = ie([]), [F, X] = ie(""), [Y, q] = ie(""), [f, p] = ie(""), [m, g] = ie(!1), {
    mutate: y,
    isPending: b,
    reset: A
  } = Dq({
    onError(R) {
      console.error(
        "<ExistingReviewPanel> useCreateConversationReview() onError()",
        R.message
      );
    },
    onSuccess() {
      console.log(
        "<ExistingReviewPanel> useCreateConversationReview() onSuccess()"
      ), g(!1), s(""), t == null || t();
    }
  });
  Pe(() => {
    i && !ku(i.review_data) && (console.log("<ReviewPanelV0> currentReview", i), o(i.review_data.customer_report_status), a(i.review_data.reasoning_correctness), c(i.review_data.reasoning_issues), X(i.review_data.conversation_quality), s(i.review_data.comments), q(i.created_at || ""), p(i.created_by_email || ""));
  }, [e]);
  const w = () => {
    if (!S()) {
      console.log("<ReviewPanelV0> handleClick() Adding review");
      const R = {
        customer_report_status: u,
        reasoning_correctness: d,
        reasoning_issues: V,
        conversation_quality: F,
        comments: n
      };
      A(), y({
        path: { conversation_id: r },
        body: {
          review_data: R
        }
      });
    }
  }, S = () => n !== "" || u !== "" || d !== "" || F !== "" ? !1 : V.length <= 0, N = () => u === "Yes" ? /* @__PURE__ */ C("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ l(Xi, { className: "text-successText h-4 w-4" }),
    /* @__PURE__ */ l("p", { className: "text-successText ml-1.5 text-bodysm font-normal", children: "Yes" })
  ] }) : u === "No" ? /* @__PURE__ */ C("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ l(xi, { className: "text-destructiveText h-4 w-4" }),
    /* @__PURE__ */ l("p", { className: "text-destructiveText ml-1.5 text-bodysm font-normal", children: "No" })
  ] }) : /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), O = () => F === "Poor" ? /* @__PURE__ */ C("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ l(Lw, { className: "text-destructiveText h-4 w-4" }),
    /* @__PURE__ */ l("p", { className: "text-destructiveText ml-1.5 text-bodysm font-normal", children: "Poor" })
  ] }) : F === "Ok" ? /* @__PURE__ */ C("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ l(_w, { className: "text-warningText h-4 w-4" }),
    /* @__PURE__ */ l("p", { className: "text-warningText ml-1.5 text-bodysm font-normal", children: "Ok" })
  ] }) : F === "Good" ? /* @__PURE__ */ C("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ l(Hw, { className: "text-successText h-4 w-4" }),
    /* @__PURE__ */ l("p", { className: "text-successText ml-1.5 text-bodysm font-normal", children: "Good" })
  ] }) : /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), E = () => {
    let R = "";
    switch (d) {
      case "1":
        R = "😃 Mostly/all correct";
        break;
      case "2":
        R = "🙂 Partly correct";
        break;
      case "3":
        R = "😕 Partly incorrect";
        break;
      case "4":
        R = "☹️ Mostly incorrect";
        break;
      case "":
        return /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." });
    }
    return /* @__PURE__ */ l("p", { className: "text-bodysm font-normal", children: R });
  }, I = () => V.length > 0 ? V.map((R, H) => /* @__PURE__ */ C("div", { className: "flex flex-row gap-x-0.5", children: [
    /* @__PURE__ */ l(Bo, { className: "text-actionDefault h-5 w-5 p-[1px]" }),
    /* @__PURE__ */ l("p", { className: "text-actionHover text-bodymd font-normal", children: R })
  ] })) : /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." });
  return /* @__PURE__ */ C("div", { className: "bg-interfaceWhite border-interfaceBorder text-textPrimary flex flex-col rounded-lg border p-8", children: [
    (e.length === 0 || m) && /* @__PURE__ */ C("section", { className: "flex flex-col gap-y-5 text-bodymd font-semibold", children: [
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { children: "Was the report good enough to send to the customer?" }),
        /* @__PURE__ */ l(
          "h4",
          {
            hidden: u !== "",
            className: "text-textSubdued text-bodysm font-normal",
            children: "If No, follow up with the customer."
          }
        ),
        /* @__PURE__ */ l("div", { className: "mt-2", children: /* @__PURE__ */ l(
          Ed,
          {
            radioValue: u,
            setRadioValue: (R) => o(R),
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ l(Xi, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ l(xi, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ) })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { children: "How correct is the reasoning?" }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: /* @__PURE__ */ l(
          SAe,
          {
            radioValue: d,
            setRadioValue: (R) => a(R)
          }
        ) })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { children: "If there are issues with the reasoning, what are they?" }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: /* @__PURE__ */ l(
          tve,
          {
            options: [
              "Land use term",
              "Zone trigger",
              "Overlay trigger",
              "Provision trigger",
              "Exemption",
              "Other"
            ],
            groupValue: V,
            setGroupValue: (R) => c(R)
          }
        ) })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { children: "How was the quality of the conversation?" }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: /* @__PURE__ */ l(
          Ed,
          {
            radioValue: F,
            setRadioValue: (R) => X(R),
            options: [
              {
                text: "Poor",
                icon: /* @__PURE__ */ l(Lw, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              },
              {
                text: "Ok",
                icon: /* @__PURE__ */ l(_w, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-warningBgDefault",
                borderColor: "data-[state=checked]:border-warningBorder",
                textColor: "data-[state=checked]:text-warningText"
              },
              {
                text: "Good",
                icon: /* @__PURE__ */ l(Hw, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              }
            ]
          }
        ) })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { children: "Comments" }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: /* @__PURE__ */ l(
          Cu,
          {
            value: n,
            onChange: (R) => {
              s(R.target.value);
            },
            className: `${n === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-bodymd font-normal focus:outline-0`,
            placeholder: "Enter additional comments"
          }
        ) })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ C("div", { className: "flex w-full flex-row justify-end gap-x-2", children: [
          m && /* @__PURE__ */ l(
            "button",
            {
              onClick: () => g(!1),
              className: "text-actionDefault border-actionDefault flex flex-row items-center justify-center rounded border bg-transparent px-4 py-2 text-bodylg font-semibold",
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ C(
            "button",
            {
              onClick: w,
              disabled: S() || b,
              className: "disabled:bg-interactiveBgHover text-textWhite disabled:text-textDisabled bg-actionDefault border-actionDefault flex flex-row items-center justify-center rounded border px-4 py-2 text-bodylg font-semibold disabled:border disabled:border-[#CCCCCB]",
              children: [
                b && /* @__PURE__ */ l(Zs, { className: "mr-2 h-4 w-4 animate-spin" }),
                b ? "Submitting" : m ? "Update review" : "Submit review"
              ]
            }
          )
        ] }),
        m && /* @__PURE__ */ l("div", { className: "mt-2 flex w-full flex-row justify-end", children: /* @__PURE__ */ C("p", { className: "text-textSubdued text-bodysm font-normal", children: [
          "Previously updated by ",
          /* @__PURE__ */ l("span", { className: "text-textPrimary", children: f }),
          " on " + Is(Y).replace(",", " at")
        ] }) })
      ] })
    ] }),
    e.length !== 0 && !m && /* @__PURE__ */ C("section", { className: "flex flex-col gap-y-5 text-bodymd font-semibold", children: [
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { children: "Was the report good enough to send to the customer?" }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: N() })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { children: "How correct is the reasoning?" }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: E() })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { children: "If there are issues with the reasoning, what are they?" }),
        /* @__PURE__ */ l("div", { className: "mt-2 flex flex-row flex-wrap gap-x-3", children: I() })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { children: "How was the quality of the conversation?" }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: O() })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { children: "Comments" }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: n === "" ? /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }) : /* @__PURE__ */ l("p", { className: "text-wrap break-all text-bodymd font-normal", children: /* @__PURE__ */ l(sa, { comment: n }) }) })
      ] }),
      /* @__PURE__ */ l("div", { className: "border-interfaceBorder w-full border-t" }),
      /* @__PURE__ */ C("div", { className: "flex flex-col gap-y-1", children: [
        /* @__PURE__ */ C(
          "button",
          {
            onClick: () => g(!0),
            className: "text-textLink flex flex-row items-center text-bodysm font-normal underline",
            children: [
              /* @__PURE__ */ l(Mf, { className: "h-4 w-4" }),
              /* @__PURE__ */ l("p", { className: "ml-1", children: "Edit review" })
            ]
          }
        ),
        /* @__PURE__ */ C("p", { className: "text-textSubdued text-bodysm font-normal", children: [
          "Last updated " + Is(Y).replace(",", " at") + " by ",
          /* @__PURE__ */ l("span", { className: "text-textPrimary", children: f })
        ] })
      ] })
    ] })
  ] });
}
function Rre({
  outcome: e
}) {
  switch (e) {
    case "Planning permit not required":
      return /* @__PURE__ */ C(he, { children: [
        "Buildings and works",
        " ",
        /* @__PURE__ */ l("span", { className: "text-actionDefault ml-1", children: "does not trigger a planning permit" }),
        ", is this correct?"
      ] });
    case "Planning permit maybe required":
      return /* @__PURE__ */ C(he, { children: [
        "Buildings and works",
        " ",
        /* @__PURE__ */ l("span", { className: "text-actionDefault ml-1", children: "does not trigger a planning permit" }),
        ", is this correct?"
      ] });
    case "Planning permit required":
      return /* @__PURE__ */ C(he, { children: [
        "Buildings and works",
        " ",
        /* @__PURE__ */ l("span", { className: "text-actionDefault ml-1", children: "triggers a planning permit" }),
        ", is this correct?"
      ] });
  }
}
function Ire({ outcome: e }) {
  switch (e) {
    case "Planning permit not required":
      return /* @__PURE__ */ C(he, { children: [
        "Land use",
        " ",
        /* @__PURE__ */ l("span", { className: "text-actionDefault ml-1", children: "does not trigger a planning permit" }),
        ", is this correct?"
      ] });
    case "Planning permit maybe required":
      return /* @__PURE__ */ C(he, { children: [
        "Land use",
        " ",
        /* @__PURE__ */ l("span", { className: "text-actionDefault ml-1", children: "does not trigger a planning permit" }),
        ", is this correct?"
      ] });
    case "Planning permit required":
      return /* @__PURE__ */ C(he, { children: [
        "Land use",
        " ",
        /* @__PURE__ */ l("span", { className: "text-actionDefault ml-1", children: "triggers a planning permit" }),
        ", is this correct?"
      ] });
    case "Prohibited":
      return /* @__PURE__ */ C(he, { children: [
        "Land use",
        " ",
        /* @__PURE__ */ l("span", { className: "text-actionDefault ml-1", children: "is prohibited" }),
        ", is this correct?"
      ] });
  }
}
function B$e({
  conversation: e,
  noticeboard: r,
  onClickCancel: t,
  onSubmitSuccess: i,
  review: n
}) {
  var z, Z, le;
  const {
    mutate: s,
    isPending: u,
    reset: o
  } = Dq({
    onError(te) {
      console.error(
        "<ReviewPanelV1EditMode> useCreateConversationReview() onError()",
        te.message
      );
    },
    onSuccess() {
      console.log(
        "<ReviewPanelV1EditMode> useCreateConversationReview() onSuccess()"
      ), E(""), i();
    }
  }), d = e == null ? void 0 : e.id, a = /* @__PURE__ */ l(
    Lr,
    {
      value: e != null && e.report_outcome ? e.report_outcome : ""
    }
  ), V = ((Z = (z = r == null ? void 0 : r.building_works_assessment_result) == null ? void 0 : z.parsed_output) == null ? void 0 : Z.land_use_assessor_result) ?? "", c = ((le = r == null ? void 0 : r.building_works_assessment_result) == null ? void 0 : le.parsed_output.building_works_assessment_result) ?? "", [F, X] = ie(""), [Y, q] = ie(""), [f, p] = ie(""), [m, g] = ie(""), [y, b] = ie(""), [A, w] = ie(""), [S, N] = ie(""), [O, E] = ie(""), [I, R] = ie(""), [H, W] = ie("");
  Pe(() => {
    n && ku(n.review_data) && n.review_data.version === 1 && (X(n.review_data.report_outcome), q(
      n.review_data.report_outcome_expected
    ), p(n.review_data.land_use_correctness), g(n.review_data.land_use_correctness_comment), b(
      n.review_data.buildings_and_works_correctness
    ), w(
      n.review_data.buildings_and_works_correctness_comment
    ), N(n.review_data.report_good_enough), E(n.review_data.comments), R(n.created_at || ""), W(n.created_by || ""));
  }, [n]);
  const B = () => F !== "" || f !== "" || y !== "" ? !1 : S !== "" ? "" : O === "", L = () => {
    if (!B() && d) {
      console.log("<ReviewPanelV1EditMode> Adding review.");
      const te = {
        version: 1,
        report_outcome: F,
        report_outcome_expected: Y,
        land_use_correctness: f,
        land_use_correctness_comment: m,
        buildings_and_works_correctness: y,
        buildings_and_works_correctness_comment: A,
        report_good_enough: S,
        comments: O
      };
      o(), s({
        path: { conversation_id: d },
        body: {
          review_data: te
        }
      });
    }
  };
  return /* @__PURE__ */ C("section", { className: "flex flex-col gap-y-5 text-bodymd font-semibold", children: [
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ C("h3", { className: "flex", children: [
        "The result is ",
        /* @__PURE__ */ l("span", { className: "ml-1", children: a }),
        ", is this correct?"
      ] }),
      /* @__PURE__ */ C("div", { className: "mt-2", children: [
        /* @__PURE__ */ l(
          Ed,
          {
            radioValue: F,
            setRadioValue: (te) => X(te),
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ l(Xi, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ l(xi, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ),
        F === "No" ? /* @__PURE__ */ C("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ l(Fn, {}),
          /* @__PURE__ */ C("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ l(_r, { children: "What should the result be?" }),
            /* @__PURE__ */ l(
              TV,
              {
                className: "gap-1",
                radioValue: Y,
                setRadioValue: (te) => q(te),
                options: [
                  {
                    icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "No permit required" }) }),
                    bgColor: "data-[state=checked]:bg-successBgDefault",
                    borderColor: "data-[state=checked]:border-successBorder",
                    textColor: "data-[state=checked]:text-successText",
                    value: "No permit required"
                  },
                  {
                    icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "More information required" }) }),
                    bgColor: "data-[state=checked]:bg-actionBgLight",
                    borderColor: "data-[state=checked]:border-actionBorder",
                    textColor: "data-[state=checked]:text-actionDefault",
                    value: "More information required"
                  },
                  {
                    icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "Permit required" }) }),
                    bgColor: "data-[state=checked]:bg-warningBgLight",
                    borderColor: "data-[state=checked]:border-warningBorder",
                    textColor: "data-[state=checked]:text-warningText",
                    value: "Permit required"
                  },
                  {
                    icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "Prohibited" }) }),
                    bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                    borderColor: "data-[state=checked]:border-destructiveBorder",
                    textColor: "data-[state=checked]:text-destructiveText",
                    value: "Prohibited"
                  }
                ].filter(
                  (te) => te.value !== (e == null ? void 0 : e.report_outcome)
                )
              }
            )
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { className: "inline", children: /* @__PURE__ */ l(Ire, { outcome: V }) }),
      /* @__PURE__ */ C("div", { className: "mt-2", children: [
        /* @__PURE__ */ l(
          Ed,
          {
            radioValue: f,
            setRadioValue: (te) => p(te),
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ l(Xi, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ l(xi, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ),
        f ? /* @__PURE__ */ C("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ l(Fn, {}),
          /* @__PURE__ */ C("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ l(_r, { children: f === "Yes" ? "Comments" : "What is incorrect about it?" }),
            /* @__PURE__ */ l(
              Cu,
              {
                className: `${O === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-bodymd font-normal focus:outline-0`,
                onChange: (te) => {
                  g(te.target.value);
                },
                placeholder: f === "Yes" ? "Enter comments" : "Describe what's incorrect and what it should have been.",
                tabIndex: 1,
                value: m
              }
            )
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { className: "inline", children: /* @__PURE__ */ l(Rre, { outcome: c }) }),
      /* @__PURE__ */ C("div", { className: "mt-2", children: [
        /* @__PURE__ */ l(
          Ed,
          {
            radioValue: y,
            setRadioValue: (te) => b(te),
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ l(Xi, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ l(xi, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ),
        y ? /* @__PURE__ */ C("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ l(Fn, {}),
          /* @__PURE__ */ C("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ l(_r, { children: y === "Yes" ? "Comments" : "What is incorrect about it?" }),
            /* @__PURE__ */ l(
              Cu,
              {
                className: `${O === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-bodymd font-normal focus:outline-0`,
                onChange: (te) => {
                  w(te.target.value);
                },
                placeholder: y === "Yes" ? "Enter comments" : "Describe what's incorrect and what it should have been.",
                tabIndex: 1,
                value: A
              }
            )
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { children: "Is the report good enough, or is a follow-up required?" }),
      /* @__PURE__ */ l("div", { className: "mt-2", children: /* @__PURE__ */ l(
        TV,
        {
          className: "gap-1",
          radioValue: S,
          setRadioValue: (te) => N(te),
          options: [
            {
              icon: /* @__PURE__ */ C("div", { className: "flex items-center py-2 pl-2 pr-3", children: [
                /* @__PURE__ */ l(Xi, { className: "mr-2.5 h-4 w-4" }),
                /* @__PURE__ */ l(
                  "span",
                  {
                    className: `text-bodysm ${S === "Yes" ? "text-successText" : "text-textPrimary"} font-normal`,
                    children: "The report is good enough"
                  }
                )
              ] }),
              bgColor: "data-[state=checked]:bg-successBgDefault",
              borderColor: "data-[state=checked]:border-successBorder",
              textColor: "data-[state=checked]:text-successText",
              value: "Yes"
            },
            {
              icon: /* @__PURE__ */ C("div", { className: "flex items-center py-2 pl-2 pr-3", children: [
                /* @__PURE__ */ l(xi, { className: "mr-2.5 h-4 w-4" }),
                /* @__PURE__ */ l(
                  "span",
                  {
                    className: `text-bodysm ${S === "No" ? "text-destructiveText" : "text-textPrimary"} font-normal`,
                    children: "A follow-up with the customer is required"
                  }
                )
              ] }),
              bgColor: "data-[state=checked]:bg-destructiveBgDefault",
              borderColor: "data-[state=checked]:border-destructiveBorder",
              textColor: "data-[state=checked]:text-destructiveText",
              value: "No"
            }
          ]
        }
      ) })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { children: "Additional comments" }),
      /* @__PURE__ */ l("div", { className: "mt-2", children: /* @__PURE__ */ l(
        Cu,
        {
          className: `${O === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-bodymd font-normal focus:outline-0`,
          onChange: (te) => {
            E(te.target.value);
          },
          placeholder: "Enter additional comments",
          tabIndex: 1,
          value: O
        }
      ) })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ C("div", { className: "flex w-full flex-row justify-end gap-x-2", children: [
        I ? /* @__PURE__ */ l(
          er,
          {
            className: "text-actionDefault border-actionDefault",
            onClick: t,
            tabIndex: 1,
            variant: "outline",
            children: "Cancel"
          }
        ) : null,
        /* @__PURE__ */ C(
          er,
          {
            disabled: B() || u,
            onClick: L,
            tabIndex: 1,
            variant: "default",
            children: [
              u && /* @__PURE__ */ l(Zs, { className: "mr-2 h-4 w-4 animate-spin" }),
              u ? "Submitting" : "Submit review"
            ]
          }
        )
      ] }),
      I ? /* @__PURE__ */ l("div", { className: "mt-2 flex w-full flex-row justify-end", children: /* @__PURE__ */ C("p", { className: "text-textSubdued text-bodysm font-normal", children: [
        "Previously updated by ",
        /* @__PURE__ */ l("span", { className: "text-textPrimary", children: H }),
        " on " + Is(I).replace(",", " at")
      ] }) }) : null
    ] })
  ] });
}
function W$e({
  conversation: e,
  noticeboard: r,
  onSubmitSuccess: t
}) {
  const i = Oq({ conversation: e }), n = i.at(-1), [s, u] = ie(""), [o, d] = ie(""), [a, V] = ie(""), [c, F] = ie(""), [X, Y] = ie(""), [q, f] = ie(""), [p, m] = ie(""), [g, y] = ie(""), [b, A] = ie(""), [w, S] = ie(""), [N, O] = ie(i.length === 0);
  Pe(() => {
    i.length > 0 && O(!1);
  }, [i.length]), Pe(() => {
    n && ku(n.review_data) && n.review_data.version === 1 && (console.log("<ReviewPanelV1> currentReview:", n), u(n.review_data.report_outcome), d(
      n.review_data.report_outcome_expected
    ), V(n.review_data.land_use_correctness), F(
      n.review_data.land_use_correctness_comment
    ), Y(
      n.review_data.buildings_and_works_correctness
    ), f(
      n.review_data.buildings_and_works_correctness_comment
    ), m(
      n.review_data.report_good_enough
    ), y(n.review_data.comments), A(n.created_at || ""), S(n.created_by_email || ""));
  }, [n]);
  const E = (L, z) => /* @__PURE__ */ C("div", { className: "mt-2 flex pl-1", children: [
    /* @__PURE__ */ l(Fn, {}),
    /* @__PURE__ */ C("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
      /* @__PURE__ */ l(_r, { children: z ? "Comments" : "What is incorrect about it?" }),
      L ? /* @__PURE__ */ l("span", { className: "text-textSubdued text-bodysm", children: /* @__PURE__ */ l(sa, { comment: L }) }) : /* @__PURE__ */ l("span", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." })
    ] })
  ] }), I = () => s === "Yes" ? /* @__PURE__ */ C("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ l(Xi, { className: "text-successText h-4 w-4" }),
    /* @__PURE__ */ l("p", { className: "text-successText ml-1.5 text-bodysm font-normal", children: "Yes" })
  ] }) : s === "No" ? /* @__PURE__ */ C("div", { children: [
    /* @__PURE__ */ C("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ l(xi, { className: "text-destructiveText h-4 w-4" }),
      /* @__PURE__ */ l("p", { className: "text-destructiveText ml-1.5 text-bodysm font-normal", children: "No" })
    ] }),
    /* @__PURE__ */ C("div", { className: "mt-2 flex pl-1", children: [
      /* @__PURE__ */ l(Fn, {}),
      /* @__PURE__ */ C("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
        /* @__PURE__ */ l(_r, { children: "What should the result be?" }),
        o ? /* @__PURE__ */ l(Lr, { value: o }) : /* @__PURE__ */ l("span", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." })
      ] })
    ] })
  ] }) : /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), R = () => a === "Yes" ? /* @__PURE__ */ C("div", { children: [
    /* @__PURE__ */ C("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ l(Xi, { className: "text-successText h-4 w-4" }),
      /* @__PURE__ */ l("p", { className: "text-successText ml-1.5 text-bodysm font-normal", children: "Yes" })
    ] }),
    E(c, !0)
  ] }) : a === "No" ? /* @__PURE__ */ C("div", { children: [
    /* @__PURE__ */ C("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ l(xi, { className: "text-destructiveText h-4 w-4" }),
      /* @__PURE__ */ l("p", { className: "text-destructiveText ml-1.5 text-bodysm font-normal", children: "No" })
    ] }),
    E(c, !1)
  ] }) : /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), H = () => X === "Yes" ? /* @__PURE__ */ C("div", { children: [
    /* @__PURE__ */ C("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ l(Xi, { className: "text-successText h-4 w-4" }),
      /* @__PURE__ */ l("p", { className: "text-successText ml-1.5 text-bodysm font-normal", children: "Yes" })
    ] }),
    E(q, !0)
  ] }) : X === "No" ? /* @__PURE__ */ C("div", { children: [
    /* @__PURE__ */ C("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ l(xi, { className: "text-destructiveText h-4 w-4" }),
      /* @__PURE__ */ l("p", { className: "text-destructiveText ml-1.5 text-bodysm font-normal", children: "No" })
    ] }),
    E(q, !1)
  ] }) : /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), W = () => p === "Yes" ? /* @__PURE__ */ C("div", { className: "flex items-center", children: [
    /* @__PURE__ */ l(Xi, { className: "text-successText mr-2.5 h-4 w-4" }),
    /* @__PURE__ */ l("span", { className: "text-successText text-bodysm font-normal", children: "The report is good enough" })
  ] }) : p === "No" ? /* @__PURE__ */ C("div", { className: "flex items-center", children: [
    /* @__PURE__ */ l(xi, { className: "text-destructiveText mr-2.5 h-4 w-4" }),
    /* @__PURE__ */ l("span", { className: " text-destructiveText text-bodysm font-normal", children: "A follow-up with the customer is required" })
  ] }) : /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), B = () => {
    const L = /* @__PURE__ */ l(
      Lr,
      {
        value: e != null && e.report_outcome ? e.report_outcome : ""
      }
    ), z = (r == null ? void 0 : r.building_works_assessment_result.parsed_output.land_use_assessor_result) ?? "", Z = (r == null ? void 0 : r.building_works_assessment_result.parsed_output.building_works_assessment_result) ?? "";
    return /* @__PURE__ */ C("section", { className: "flex flex-col gap-y-5 text-bodymd font-semibold", children: [
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ C("h3", { className: "flex", children: [
          "The result is ",
          /* @__PURE__ */ l("span", { className: "ml-1", children: L }),
          ", is this correct?"
        ] }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: I() })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { className: "inline", children: /* @__PURE__ */ l(Ire, { outcome: z }) }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: R() })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { className: "inline", children: /* @__PURE__ */ l(Rre, { outcome: Z }) }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: H() })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { children: "Is the report good enough, or is a follow-up required?" }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: W() })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { children: "Comments" }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: g === "" ? /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." }) : /* @__PURE__ */ l("p", { className: "text-wrap break-all text-bodymd font-normal", children: /* @__PURE__ */ l(sa, { comment: g }) }) })
      ] }),
      /* @__PURE__ */ l("div", { className: "border-interfaceBorder w-full border-t" }),
      /* @__PURE__ */ C("div", { className: "flex flex-col gap-y-1", children: [
        /* @__PURE__ */ C(
          "button",
          {
            onClick: () => O(!0),
            className: "text-textLink flex flex-row items-center text-bodysm font-normal underline",
            children: [
              /* @__PURE__ */ l(Mf, { className: "h-4 w-4" }),
              /* @__PURE__ */ l("p", { className: "ml-1", children: "Edit review" })
            ]
          }
        ),
        /* @__PURE__ */ C("p", { className: "text-textSubdued text-bodysm font-normal", children: [
          "Last updated " + Is(b).replace(",", " at") + " by ",
          /* @__PURE__ */ l("span", { className: "text-textPrimary", children: w })
        ] })
      ] })
    ] });
  };
  return /* @__PURE__ */ C("div", { className: "bg-interfaceWhite border-interfaceBorder text-textPrimary flex flex-col rounded-lg border p-8", children: [
    i.length === 0 || N ? /* @__PURE__ */ l(
      B$e,
      {
        conversation: e,
        noticeboard: r,
        onClickCancel: () => O(!1),
        onSubmitSuccess: () => {
          O(!1), t == null || t();
        },
        review: n
      }
    ) : null,
    i.length > 0 && !N ? B() : null
  ] });
}
function G$e({
  conversation: e,
  onClickCancel: r,
  onSubmitSuccess: t,
  review: i
}) {
  const {
    mutate: n,
    isPending: s,
    reset: u
  } = Dq({
    onError(N) {
      console.error(
        "<ReviewPanelV2EditMode> useCreateConversationReview() onError()",
        N.message
      );
    },
    onSuccess() {
      console.log(
        "<ReviewPanelV2EditMode> useCreateConversationReview() onSuccess()"
      ), m(""), t();
    }
  }), o = e == null ? void 0 : e.id, d = /* @__PURE__ */ l(
    Lr,
    {
      value: e != null && e.report_outcome ? e.report_outcome : ""
    }
  ), [a, V] = ie(""), [c, F] = ie(""), [X, Y] = ie(""), [q, f] = ie(""), [p, m] = ie(""), [g, y] = ie(""), [b, A] = ie("");
  Pe(() => {
    i && ku(i.review_data) && i.review_data.version === 2 && (V(i.review_data.report_outcome), F(
      i.review_data.report_outcome_expected
    ), Y(i.review_data.report_good_enough), f(
      i.review_data.report_good_enough_comment
    ), m(i.review_data.comments), y(i.created_at || ""), A(i.created_by || ""));
  }, [i]);
  const w = () => a !== "" ? !1 : X !== "" ? "" : p === "", S = () => {
    if (!w() && o) {
      console.log("<ReviewPanelV2EditMode> Adding review.");
      const N = {
        version: 2,
        report_outcome: a,
        report_outcome_expected: c,
        report_good_enough: X,
        report_good_enough_comment: q,
        comments: p
      };
      u(), n({
        path: { conversation_id: o },
        body: {
          review_data: N
        }
      });
    }
  };
  return /* @__PURE__ */ C("section", { className: "flex flex-col gap-y-5 text-bodymd font-semibold", children: [
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ C("h3", { className: "flex", children: [
        "The result is ",
        /* @__PURE__ */ l("span", { className: "ml-1", children: d }),
        ", is this correct?"
      ] }),
      /* @__PURE__ */ C("div", { className: "mt-2", children: [
        /* @__PURE__ */ l(
          Ed,
          {
            radioValue: a,
            setRadioValue: (N) => V(N),
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ l(Xi, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ l(xi, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ),
        a === "No" ? /* @__PURE__ */ C("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ l(Fn, {}),
          /* @__PURE__ */ C("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ l(_r, { children: "What should the result be?" }),
            /* @__PURE__ */ l(
              TV,
              {
                className: "gap-1",
                radioValue: c,
                setRadioValue: (N) => F(N),
                options: [
                  {
                    icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "No permit required" }) }),
                    bgColor: "data-[state=checked]:bg-successBgDefault",
                    borderColor: "data-[state=checked]:border-successBorder",
                    textColor: "data-[state=checked]:text-successText",
                    value: "No permit required"
                  },
                  {
                    icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "More information required" }) }),
                    bgColor: "data-[state=checked]:bg-actionBgLight",
                    borderColor: "data-[state=checked]:border-actionBorder",
                    textColor: "data-[state=checked]:text-actionDefault",
                    value: "More information required"
                  },
                  {
                    icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "Permit required" }) }),
                    bgColor: "data-[state=checked]:bg-warningBgLight",
                    borderColor: "data-[state=checked]:border-warningBorder",
                    textColor: "data-[state=checked]:text-warningText",
                    value: "Permit required"
                  },
                  {
                    icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "Prohibited" }) }),
                    bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                    borderColor: "data-[state=checked]:border-destructiveBorder",
                    textColor: "data-[state=checked]:text-destructiveText",
                    value: "Prohibited"
                  }
                ].filter(
                  (N) => N.value !== (e == null ? void 0 : e.report_outcome)
                )
              }
            )
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { children: "Is the report good enough, or is a follow-up required?" }),
      /* @__PURE__ */ C("div", { className: "mt-2", children: [
        /* @__PURE__ */ l(
          TV,
          {
            className: "gap-1",
            radioValue: X,
            setRadioValue: (N) => Y(N),
            options: [
              {
                icon: /* @__PURE__ */ C("div", { className: "flex items-center py-2 pl-2 pr-3", children: [
                  /* @__PURE__ */ l(Xi, { className: "mr-2.5 h-4 w-4" }),
                  /* @__PURE__ */ l(
                    "span",
                    {
                      className: `text-bodysm ${X === "Yes" ? "text-successText" : "text-textPrimary"} font-normal`,
                      children: "The report is good enough"
                    }
                  )
                ] }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText",
                value: "Yes"
              },
              {
                icon: /* @__PURE__ */ C("div", { className: "flex items-center py-2 pl-2 pr-3", children: [
                  /* @__PURE__ */ l(xi, { className: "mr-2.5 h-4 w-4" }),
                  /* @__PURE__ */ l(
                    "span",
                    {
                      className: `text-bodysm ${X === "No" ? "text-destructiveText" : "text-textPrimary"} font-normal`,
                      children: "A follow-up with the customer is required"
                    }
                  )
                ] }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText",
                value: "No"
              }
            ]
          }
        ),
        X === "No" ? /* @__PURE__ */ C("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ l(Fn, {}),
          /* @__PURE__ */ C("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ l(_r, { children: "What risk has the report introduced?" }),
            /* @__PURE__ */ l(
              Cu,
              {
                className: "border-interactiveBorder focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-bodymd font-normal focus:outline-0",
                onChange: (N) => {
                  f(N.target.value);
                },
                placeholder: "Describe how the council or customer may be affected due to the report's content.",
                tabIndex: 1,
                value: q
              }
            )
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { children: "Was the reasoning by zone and overlay correct?" }),
      /* @__PURE__ */ l("span", { className: "text-textSubdued inline-block text-bodysm font-normal", children: "Write your response against each applicable zone and overlay, e.g. “Zone: <comment>, BMO: <comment>, SLO: <comment>”." }),
      /* @__PURE__ */ l("div", { className: "mt-1", children: /* @__PURE__ */ l(
        Cu,
        {
          className: `${p === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-bodymd font-normal focus:outline-0`,
          onChange: (N) => {
            m(N.target.value);
          },
          placeholder: "Enter response",
          tabIndex: 1,
          value: p
        }
      ) })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ C("div", { className: "flex w-full flex-row justify-end gap-x-2", children: [
        g ? /* @__PURE__ */ l(
          er,
          {
            className: "text-actionDefault border-actionDefault",
            onClick: r,
            tabIndex: 1,
            variant: "outline",
            children: "Cancel"
          }
        ) : null,
        /* @__PURE__ */ C(
          er,
          {
            disabled: w() || s,
            onClick: S,
            tabIndex: 1,
            variant: "default",
            children: [
              s && /* @__PURE__ */ l(Zs, { className: "mr-2 h-4 w-4 animate-spin" }),
              s ? "Submitting" : "Submit review"
            ]
          }
        )
      ] }),
      g ? /* @__PURE__ */ l("div", { className: "mt-2 flex w-full flex-row justify-end", children: /* @__PURE__ */ C("p", { className: "text-textSubdued text-bodysm font-normal", children: [
        "Previously updated by ",
        /* @__PURE__ */ l("span", { className: "text-textPrimary", children: b }),
        " on " + Is(g).replace(",", " at")
      ] }) }) : null
    ] })
  ] });
}
function U$e({
  conversation: e,
  onSubmitSuccess: r
}) {
  const t = Oq({ conversation: e }), i = t.at(-1), [n, s] = ie(""), [u, o] = ie(""), [d, a] = ie(""), [V, c] = ie(""), [F, X] = ie(""), [Y, q] = ie(""), [f, p] = ie(""), [m, g] = ie(t.length === 0);
  Pe(() => {
    t.length > 0 && g(!1);
  }, [t.length]), Pe(() => {
    i && ku(i.review_data) && i.review_data.version === 2 && (console.log("<ReviewPanelV2> currentReview:", i), s(i.review_data.report_outcome), o(
      i.review_data.report_outcome_expected
    ), a(
      i.review_data.report_good_enough
    ), c(
      i.review_data.report_good_enough_comment
    ), X(i.review_data.comments), q(i.created_at || ""), p(i.created_by_email || ""));
  }, [i]);
  const y = (S, N) => /* @__PURE__ */ C("div", { className: "mt-2 flex pl-1", children: [
    /* @__PURE__ */ l(Fn, {}),
    /* @__PURE__ */ C("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
      /* @__PURE__ */ l(_r, { children: "What risk has the report introduced?" }),
      S ? /* @__PURE__ */ l("span", { className: "text-textSubdued text-bodysm", children: /* @__PURE__ */ l(sa, { comment: S }) }) : /* @__PURE__ */ l("span", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." })
    ] })
  ] }), b = () => n === "Yes" ? /* @__PURE__ */ C("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ l(Xi, { className: "text-successText h-4 w-4" }),
    /* @__PURE__ */ l("p", { className: "text-successText ml-1.5 text-bodysm font-normal", children: "Yes" })
  ] }) : n === "No" ? /* @__PURE__ */ C("div", { children: [
    /* @__PURE__ */ C("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ l(xi, { className: "text-destructiveText h-4 w-4" }),
      /* @__PURE__ */ l("p", { className: "text-destructiveText ml-1.5 text-bodysm font-normal", children: "No" })
    ] }),
    /* @__PURE__ */ C("div", { className: "mt-2 flex pl-1", children: [
      /* @__PURE__ */ l(Fn, {}),
      /* @__PURE__ */ C("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
        /* @__PURE__ */ l(_r, { children: "What should the result be?" }),
        u ? /* @__PURE__ */ l(Lr, { value: u }) : /* @__PURE__ */ l("span", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." })
      ] })
    ] })
  ] }) : /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), A = () => d === "Yes" ? /* @__PURE__ */ C("div", { className: "flex items-center", children: [
    /* @__PURE__ */ l(Xi, { className: "text-successText mr-2.5 h-4 w-4" }),
    /* @__PURE__ */ l("span", { className: "text-successText text-bodysm font-normal", children: "The report is good enough" })
  ] }) : d === "No" ? /* @__PURE__ */ C("div", { children: [
    /* @__PURE__ */ C("div", { className: "flex items-center", children: [
      /* @__PURE__ */ l(xi, { className: "text-destructiveText mr-2.5 h-4 w-4" }),
      /* @__PURE__ */ l("span", { className: " text-destructiveText text-bodysm font-normal", children: "A follow-up with the customer is required" })
    ] }),
    y(V)
  ] }) : /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), w = () => {
    const S = /* @__PURE__ */ l(
      Lr,
      {
        value: e != null && e.report_outcome ? e.report_outcome : ""
      }
    );
    return /* @__PURE__ */ C("section", { className: "flex flex-col gap-y-5 text-bodymd font-semibold", children: [
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ C("h3", { className: "flex", children: [
          "The result is ",
          /* @__PURE__ */ l("span", { className: "ml-1", children: S }),
          ", is this correct?"
        ] }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: b() })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { children: "Is the report good enough, or is a follow-up required?" }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: A() })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { children: "Was the reasoning by zone and overlay correct?" }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: F === "" ? /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." }) : /* @__PURE__ */ l("p", { className: "text-wrap break-all text-bodymd font-normal", children: /* @__PURE__ */ l(sa, { comment: F }) }) })
      ] }),
      /* @__PURE__ */ l("div", { className: "border-interfaceBorder w-full border-t" }),
      /* @__PURE__ */ C("div", { className: "flex flex-col gap-y-1", children: [
        /* @__PURE__ */ C(
          "button",
          {
            onClick: () => g(!0),
            className: "text-textLink flex flex-row items-center text-bodysm font-normal underline",
            children: [
              /* @__PURE__ */ l(Mf, { className: "h-4 w-4" }),
              /* @__PURE__ */ l("p", { className: "ml-1", children: "Edit review" })
            ]
          }
        ),
        /* @__PURE__ */ C("p", { className: "text-textSubdued text-bodysm font-normal", children: [
          "Last updated " + Is(Y).replace(",", " at") + " by ",
          /* @__PURE__ */ l("span", { className: "text-textPrimary", children: f })
        ] })
      ] })
    ] });
  };
  return /* @__PURE__ */ C("div", { className: "bg-interfaceWhite border-interfaceBorder text-textPrimary flex flex-col rounded-lg border p-8", children: [
    t.length === 0 || m ? /* @__PURE__ */ l(
      G$e,
      {
        conversation: e,
        onClickCancel: () => g(!1),
        onSubmitSuccess: () => {
          g(!1), r == null || r();
        },
        review: i
      }
    ) : null,
    t.length > 0 && !m ? w() : null
  ] });
}
function Z$e({ onOpenChange: e, open: r }) {
  return /* @__PURE__ */ l(vY, { open: r, onOpenChange: e, children: /* @__PURE__ */ C(q2, { children: [
    /* @__PURE__ */ l(yY, { children: "Risk types" }),
    /* @__PURE__ */ l("p", { className: "text-bodymd", children: "Risk types are defined as follows:" }),
    /* @__PURE__ */ C("ul", { className: "text-bodymd ml-4 list-outside list-decimal", children: [
      /* @__PURE__ */ C("li", { className: "marker:font-semibold", children: [
        /* @__PURE__ */ l("b", { children: "Monetary:" }),
        " Where as a result of the report they received, the customer may end up spending money unnecessarily, such as commissioning a report they don't actually need."
      ] }),
      /* @__PURE__ */ C("li", { className: "marker:font-semibold", children: [
        /* @__PURE__ */ l("b", { children: "Incorrect or unnecessary design changes:" }),
        " Where the customer may be encouraged to alter their design based on incorrect information provided about permit triggers."
      ] }),
      /* @__PURE__ */ C("li", { className: "marker:font-semibold", children: [
        /* @__PURE__ */ l("b", { children: "Irreversible actions:" }),
        " Where the customer may be encouraged to take a development action that is prohibited or requires a permit, which could have irreversible consequences."
      ] }),
      /* @__PURE__ */ C("li", { className: "marker:font-semibold", children: [
        /* @__PURE__ */ l("b", { children: "Reputational:" }),
        " Where the report includes content that may result in a negative reputational impact to the council."
      ] })
    ] }),
    /* @__PURE__ */ l("p", { className: "text-bodymd", children: "After selecting the risk type(s) you've identified, describe the language or error in the report that has introduced this risk." }),
    /* @__PURE__ */ l(bY, { children: /* @__PURE__ */ l(er, { onClick: () => e(!1), variant: "outline", children: "Close" }) })
  ] }) });
}
function J$e({
  conversation: e,
  onChange: r,
  value: t
}) {
  var n;
  const i = $e(() => {
    var u;
    const s = [];
    return ((u = e == null ? void 0 : e.address_data) == null ? void 0 : u.state) === "QLD" ? s.push(
      {
        icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "Accepted" }) }),
        bgColor: "data-[state=checked]:bg-successBgDefault",
        borderColor: "data-[state=checked]:border-successBorder",
        textColor: "data-[state=checked]:text-successText",
        value: "Accepted"
      },
      {
        icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "Self assess" }) }),
        bgColor: "data-[state=checked]:bg-actionBgLight",
        borderColor: "data-[state=checked]:border-actionBorder",
        textColor: "data-[state=checked]:text-actionDefault",
        value: "Self assess"
      },
      {
        icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "Code" }) }),
        bgColor: "data-[state=checked]:bg-warningBgLight",
        borderColor: "data-[state=checked]:border-warningBorder",
        textColor: "data-[state=checked]:text-warningText",
        value: "Code"
      },
      {
        icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "Impact" }) }),
        bgColor: "data-[state=checked]:bg-warningBgLight",
        borderColor: "data-[state=checked]:border-warningBorder",
        textColor: "data-[state=checked]:text-warningText",
        value: "Impact"
      },
      {
        icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "Permit required" }) }),
        bgColor: "data-[state=checked]:bg-warningBgLight",
        borderColor: "data-[state=checked]:border-warningBorder",
        textColor: "data-[state=checked]:text-warningText",
        value: "Permit required"
      },
      {
        icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "Prohibited" }) }),
        bgColor: "data-[state=checked]:bg-destructiveBgDefault",
        borderColor: "data-[state=checked]:border-destructiveBorder",
        textColor: "data-[state=checked]:text-destructiveText",
        value: "Prohibited"
      }
    ) : s.push(
      {
        icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "No permit required" }) }),
        bgColor: "data-[state=checked]:bg-successBgDefault",
        borderColor: "data-[state=checked]:border-successBorder",
        textColor: "data-[state=checked]:text-successText",
        value: "No permit required"
      },
      {
        icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "More information required" }) }),
        bgColor: "data-[state=checked]:bg-actionBgLight",
        borderColor: "data-[state=checked]:border-actionBorder",
        textColor: "data-[state=checked]:text-actionDefault",
        value: "More information required"
      },
      {
        icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "Permit required" }) }),
        bgColor: "data-[state=checked]:bg-warningBgLight",
        borderColor: "data-[state=checked]:border-warningBorder",
        textColor: "data-[state=checked]:text-warningText",
        value: "Permit required"
      },
      {
        icon: /* @__PURE__ */ l("div", { className: "py-2 pl-2 pr-3", children: /* @__PURE__ */ l(Lr, { value: "Prohibited" }) }),
        bgColor: "data-[state=checked]:bg-destructiveBgDefault",
        borderColor: "data-[state=checked]:border-destructiveBorder",
        textColor: "data-[state=checked]:text-destructiveText",
        value: "Prohibited"
      }
    ), s.filter(
      (o) => o.value !== (e == null ? void 0 : e.report_outcome)
    );
  }, [(n = e == null ? void 0 : e.address_data) == null ? void 0 : n.state, e == null ? void 0 : e.report_outcome]);
  return /* @__PURE__ */ l(
    TV,
    {
      className: "gap-1",
      radioValue: t,
      setRadioValue: r,
      options: i
    }
  );
}
function $$e({
  conversation: e,
  onClickCancel: r,
  onSubmitSuccess: t,
  review: i
}) {
  const {
    mutate: n,
    isPending: s,
    reset: u
  } = Dq({
    onError(B) {
      console.error(
        "<ReviewPanelV3EditMode> useCreateConversationReview() onError()",
        B.message
      );
    },
    onSuccess() {
      console.log(
        "<ReviewPanelV3EditMode> useCreateConversationReview() onSuccess()"
      ), y(""), t();
    }
  }), o = e == null ? void 0 : e.id, d = /* @__PURE__ */ l(
    Lr,
    {
      value: e != null && e.report_outcome ? e.report_outcome : ""
    }
  ), [a, V] = ie(""), [c, F] = ie(""), [X, Y] = ie(""), [q, f] = ie({
    monetary: !1,
    incorrectOrUnnecessaryDesignChange: !1,
    irreversibleActions: !1,
    reputational: !1
  }), [p, m] = ie(""), [g, y] = ie(""), [b, A] = ie(""), [w, S] = ie(""), [N, O] = ie(!1), [E, I] = ie({
    reportOutcome: "",
    reportRiskComment: ""
  }), R = () => {
    I({
      reportOutcome: "",
      reportRiskComment: ""
    });
  }, H = () => {
    R();
    let B = !0;
    return a === "" && (I((L) => ({
      ...L,
      reportOutcome: "This field is required"
    })), B = !1), ["Minor", "Yes"].includes(X) && p === "" && (I((L) => ({
      ...L,
      reportRiskComment: "This field is required"
    })), B = !1), B;
  };
  Pe(() => {
    i && ku(i.review_data) && i.review_data.version === 3 && (V(i.review_data.report_outcome), F(
      i.review_data.report_outcome_expected
    ), Y(i.review_data.report_risk), f(
      i.review_data.report_risk_types || {
        monetary: !1,
        incorrectOrUnnecessaryDesignChange: !1,
        irreversibleActions: !1,
        reputational: !1
      }
    ), m(i.review_data.report_risk_comment), y(i.review_data.comments), A(i.created_at || ""), S(i.created_by || ""));
  }, [i]);
  const W = () => {
    if (o && H()) {
      console.log("<ReviewPanelV3EditMode> Adding review.");
      const B = {
        version: 3,
        report_outcome: a,
        report_outcome_expected: c,
        report_risk: X,
        report_risk_types: q,
        report_risk_comment: p,
        comments: g
      };
      u(), n({
        path: { conversation_id: o },
        body: {
          review_data: B
        }
      });
    }
  };
  return /* @__PURE__ */ C("section", { className: "flex flex-col gap-y-5 text-bodymd font-semibold", children: [
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ C(
        "h3",
        {
          className: _(
            "flex",
            E.reportOutcome && "text-destructiveDefault"
          ),
          children: [
            "The result is ",
            /* @__PURE__ */ l("span", { className: "ml-1", children: d }),
            ", is this correct?"
          ]
        }
      ),
      /* @__PURE__ */ C("div", { className: "mt-2", children: [
        /* @__PURE__ */ l(
          Ed,
          {
            radioValue: a,
            setRadioValue: (B) => {
              R(), V(B);
            },
            options: [
              {
                text: "Yes",
                icon: /* @__PURE__ */ l(Xi, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText"
              },
              {
                text: "No",
                icon: /* @__PURE__ */ l(xi, { className: "h-4 w-4" }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText"
              }
            ]
          }
        ),
        a === "No" ? /* @__PURE__ */ C("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ l(Fn, {}),
          /* @__PURE__ */ C("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
            /* @__PURE__ */ l(_r, { children: "What should the result be?" }),
            /* @__PURE__ */ l(
              J$e,
              {
                conversation: e,
                onChange: F,
                value: c
              }
            )
          ] })
        ] }) : null,
        E.reportOutcome ? /* @__PURE__ */ l("div", { className: "text-destructiveDefault mt-2", children: E.reportOutcome }) : null
      ] })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { children: "Has the report introduced risk to the customer or council?" }),
      /* @__PURE__ */ C("div", { className: "mt-2", children: [
        /* @__PURE__ */ l(
          TV,
          {
            className: "gap-1",
            radioValue: X,
            setRadioValue: (B) => Y(B),
            options: [
              {
                icon: /* @__PURE__ */ l("div", { className: "flex items-center py-2 pl-2 pr-3", children: /* @__PURE__ */ l(
                  "span",
                  {
                    className: `text-bodysm ${X === "No" ? "text-successText" : "text-textPrimary"} font-normal`,
                    children: "✅ No risk"
                  }
                ) }),
                bgColor: "data-[state=checked]:bg-successBgDefault",
                borderColor: "data-[state=checked]:border-successBorder",
                textColor: "data-[state=checked]:text-successText",
                value: "No"
              },
              {
                icon: /* @__PURE__ */ l("div", { className: "flex items-center py-2 pl-2 pr-3", children: /* @__PURE__ */ l(
                  "span",
                  {
                    className: `text-bodysm ${X === "Minor" ? "text-warningText" : "text-textPrimary"} font-normal`,
                    children: "⚠️ Yes, but it's only minor"
                  }
                ) }),
                bgColor: "data-[state=checked]:bg-warningBgDefault",
                borderColor: "data-[state=checked]:border-warningBorder",
                textColor: "data-[state=checked]:text-warningText",
                value: "Minor"
              },
              {
                icon: /* @__PURE__ */ l("div", { className: "flex items-center py-2 pl-2 pr-3", children: /* @__PURE__ */ l(
                  "span",
                  {
                    className: `text-bodysm ${X === "Yes" ? "text-destructiveText" : "text-textPrimary"} font-normal`,
                    children: "🚨 Yes, and it's potentially significant"
                  }
                ) }),
                bgColor: "data-[state=checked]:bg-destructiveBgDefault",
                borderColor: "data-[state=checked]:border-destructiveBorder",
                textColor: "data-[state=checked]:text-destructiveText",
                value: "Yes"
              }
            ]
          }
        ),
        ["Minor", "Yes"].includes(X) ? /* @__PURE__ */ C("div", { className: "mt-2 flex pl-1", children: [
          /* @__PURE__ */ l(Fn, {}),
          /* @__PURE__ */ C("div", { className: "mt-2 flex w-full flex-col gap-2", children: [
            /* @__PURE__ */ C("div", { className: "flex w-full justify-between", children: [
              /* @__PURE__ */ l(_r, { className: "text-bodymd text-textPrimary", children: "What type of risk has been introduced?" }),
              /* @__PURE__ */ C(
                er,
                {
                  className: "mt-[-4px] h-0 gap-1 pr-0",
                  onClick: () => {
                    O(!0);
                  },
                  variant: "link",
                  children: [
                    /* @__PURE__ */ l(dVe, { className: "h-5 w-5" }),
                    "Risk types"
                  ]
                }
              ),
              /* @__PURE__ */ l(
                Z$e,
                {
                  onOpenChange: O,
                  open: N
                }
              )
            ] }),
            /* @__PURE__ */ C("div", { className: "flex flex-col gap-1", children: [
              /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ l(
                  Ad,
                  {
                    id: "reportRiskMonetary",
                    checked: q.monetary,
                    onCheckedChange: (B) => {
                      f((L) => ({
                        ...L,
                        monetary: !!B
                      }));
                    },
                    name: "monetary"
                  }
                ),
                /* @__PURE__ */ l(_r, { htmlFor: "reportRiskMonetary", children: "Monetary" })
              ] }),
              /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ l(
                  Ad,
                  {
                    id: "reportRiskIncorrectOrUnnecessaryDesignChange",
                    checked: q.incorrectOrUnnecessaryDesignChange,
                    onCheckedChange: (B) => {
                      f((L) => ({
                        ...L,
                        incorrectOrUnnecessaryDesignChange: !!B
                      }));
                    }
                  }
                ),
                /* @__PURE__ */ l(_r, { htmlFor: "reportRiskIncorrectOrUnnecessaryDesignChange", children: "Incorrect or unnecessary design changes" })
              ] }),
              /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ l(
                  Ad,
                  {
                    id: "reportRiskIrreversibleActions",
                    checked: q.irreversibleActions,
                    onCheckedChange: (B) => {
                      f((L) => ({
                        ...L,
                        irreversibleActions: !!B
                      }));
                    }
                  }
                ),
                /* @__PURE__ */ l(_r, { htmlFor: "reportRiskIrreversibleActions", children: "Irreversible actions" })
              ] }),
              /* @__PURE__ */ C("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ l(
                  Ad,
                  {
                    id: "reportRiskReputational",
                    checked: q.reputational,
                    onCheckedChange: (B) => {
                      f((L) => ({
                        ...L,
                        reputational: !!B
                      }));
                    }
                  }
                ),
                /* @__PURE__ */ l(_r, { htmlFor: "reportRiskReputational", children: "Reputational" })
              ] })
            ] }),
            /* @__PURE__ */ l(
              _r,
              {
                className: _(
                  "mt-1",
                  E.reportRiskComment && "text-destructiveDefault"
                ),
                children: "Describe the risk"
              }
            ),
            /* @__PURE__ */ l(
              Cu,
              {
                className: "border-interactiveBorder focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-bodymd font-normal focus:outline-0",
                onChange: (B) => {
                  R(), m(B.target.value);
                },
                placeholder: "Enter response",
                tabIndex: 1,
                value: p
              }
            ),
            E.reportRiskComment ? /* @__PURE__ */ l("div", { className: "text-destructiveDefault", children: E.reportRiskComment }) : null
          ] })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { children: "Feedback on zone and overlay reasoning" }),
      /* @__PURE__ */ l("span", { className: "text-textSubdued inline-block text-bodysm font-normal", children: "Write your response against each applicable zone and overlay, e.g. “Zone: <comment>, BMO: <comment>, SLO: <comment>”." }),
      /* @__PURE__ */ l("div", { className: "mt-1", children: /* @__PURE__ */ l(
        Cu,
        {
          className: `${g === "" ? "border-interactiveBorder" : "border-interactiveBorderSelect"} focus:border-interactiveBorderSelect placeholder:text-textSubdued text-textPrimary hover:border-interactiveBorderHover min-h-[80px] w-full rounded border p-3 text-bodymd font-normal focus:outline-0`,
          onChange: (B) => {
            y(B.target.value);
          },
          placeholder: "Enter response",
          tabIndex: 1,
          value: g
        }
      ) })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ C("div", { className: "flex w-full flex-row justify-end gap-x-2", children: [
        b ? /* @__PURE__ */ l(
          er,
          {
            className: "text-actionDefault border-actionDefault",
            onClick: r,
            tabIndex: 1,
            variant: "outline",
            children: "Cancel"
          }
        ) : null,
        /* @__PURE__ */ C(
          er,
          {
            disabled: s,
            onClick: W,
            tabIndex: 1,
            variant: "default",
            children: [
              s && /* @__PURE__ */ l(Zs, { className: "mr-2 h-4 w-4 animate-spin" }),
              s ? "Submitting" : "Submit review"
            ]
          }
        )
      ] }),
      b ? /* @__PURE__ */ l("div", { className: "mt-2 flex w-full flex-row justify-end", children: /* @__PURE__ */ C("p", { className: "text-textSubdued text-bodysm font-normal", children: [
        "Previously updated by ",
        /* @__PURE__ */ l("span", { className: "text-textPrimary", children: w }),
        " on " + Is(b).replace(",", " at")
      ] }) }) : null
    ] })
  ] });
}
function rR({
  conversation: e,
  onSubmitSuccess: r
}) {
  const t = Oq({ conversation: e }), i = t.at(-1), [n, s] = ie(""), [u, o] = ie(""), [d, a] = ie(""), [V, c] = ie({
    monetary: !1,
    incorrectOrUnnecessaryDesignChange: !1,
    irreversibleActions: !1,
    reputational: !1
  }), [F, X] = ie(""), [Y, q] = ie(""), [f, p] = ie(""), [m, g] = ie(""), [y, b] = ie(t.length === 0);
  Pe(() => {
    t.length > 0 && b(!1);
  }, [t.length]), Pe(() => {
    i && ku(i.review_data) && i.review_data.version === 3 && (console.log("<ReviewPanelV3> currentReview:", i), s(i.review_data.report_outcome), o(
      i.review_data.report_outcome_expected
    ), a(i.review_data.report_risk), c(
      i.review_data.report_risk_types || {
        monetary: !1,
        incorrectOrUnnecessaryDesignChange: !1,
        irreversibleActions: !1,
        reputational: !1
      }
    ), X(i.review_data.report_risk_comment), q(i.review_data.comments), p(i.created_at || ""), g(i.created_by_email || ""));
  }, [i]);
  const A = () => {
    const O = [];
    return V.monetary && O.push("Monetary"), V.incorrectOrUnnecessaryDesignChange && O.push("Incorrect or unnecessary design change"), V.irreversibleActions && O.push("Irreversible actions"), V.reputational && O.push("Reputational"), /* @__PURE__ */ C("div", { className: "mt-2 flex pl-1", children: [
      /* @__PURE__ */ l(Fn, {}),
      /* @__PURE__ */ C("div", { className: "mt-2 flex w-full flex-col", children: [
        /* @__PURE__ */ l(_r, { className: "text-bodymd text-textPrimary", children: "What type of risk has been introduced?" }),
        O.length > 0 ? /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm", children: O.join(", ") }) : /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." }),
        /* @__PURE__ */ l(_r, { className: "text-bodymd text-textPrimary mt-3", children: "Describe the risk" }),
        F ? /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm", children: /* @__PURE__ */ l(sa, { comment: F }) }) : /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." })
      ] })
    ] });
  }, w = () => n === "Yes" ? /* @__PURE__ */ C("div", { className: "flex flex-row items-center", children: [
    /* @__PURE__ */ l(Xi, { className: "text-successText h-4 w-4" }),
    /* @__PURE__ */ l("p", { className: "text-successText ml-1.5 text-bodysm font-normal", children: "Yes" })
  ] }) : n === "No" ? /* @__PURE__ */ C("div", { children: [
    /* @__PURE__ */ C("div", { className: "flex flex-row items-center", children: [
      /* @__PURE__ */ l(xi, { className: "text-destructiveText h-4 w-4" }),
      /* @__PURE__ */ l("p", { className: "text-destructiveText ml-1.5 text-bodysm font-normal", children: "No" })
    ] }),
    /* @__PURE__ */ C("div", { className: "mt-2 flex pl-1", children: [
      /* @__PURE__ */ l(Fn, {}),
      /* @__PURE__ */ C("div", { className: "mt-2 flex w-full flex-col gap-1", children: [
        /* @__PURE__ */ l(_r, { children: "What should the result be?" }),
        u ? /* @__PURE__ */ l(Lr, { value: u }) : /* @__PURE__ */ l("span", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." })
      ] })
    ] })
  ] }) : /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), S = () => d === "No" ? /* @__PURE__ */ l("div", { className: "flex items-center", children: /* @__PURE__ */ l("span", { className: "text-successText text-bodysm font-normal", children: "✅ No risk" }) }) : d === "Minor" ? /* @__PURE__ */ C("div", { children: [
    /* @__PURE__ */ l("div", { className: "flex items-center", children: /* @__PURE__ */ l("span", { className: " text-warningText text-bodysm font-normal", children: "⚠️ Yes, but it's only minor" }) }),
    A()
  ] }) : d === "Yes" ? /* @__PURE__ */ C("div", { children: [
    /* @__PURE__ */ l("div", { className: "flex items-center", children: /* @__PURE__ */ l("span", { className: " text-destructiveText text-bodysm font-normal", children: "🚨 Yes, and it's potentially significant" }) }),
    A()
  ] }) : /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response entered." }), N = () => {
    const O = /* @__PURE__ */ l(
      Lr,
      {
        value: e != null && e.report_outcome ? e.report_outcome : ""
      }
    );
    return /* @__PURE__ */ C("section", { className: "flex flex-col gap-y-5 text-bodymd font-semibold", children: [
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ C("h3", { className: "flex", children: [
          "The result is ",
          /* @__PURE__ */ l("span", { className: "ml-1", children: O }),
          ", is this correct?"
        ] }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: w() })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { children: "Has the report introduced risk to the customer or council?" }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: S() })
      ] }),
      /* @__PURE__ */ C("div", { children: [
        /* @__PURE__ */ l("h3", { children: "Feedback on zone and overlay reasoning" }),
        /* @__PURE__ */ l("div", { className: "mt-2", children: Y === "" ? /* @__PURE__ */ l("p", { className: "text-textSubdued text-bodysm font-normal", children: "No response provided." }) : /* @__PURE__ */ l("p", { className: "text-wrap break-all text-bodymd font-normal", children: /* @__PURE__ */ l(sa, { comment: Y }) }) })
      ] }),
      /* @__PURE__ */ l("div", { className: "border-interfaceBorder w-full border-t" }),
      /* @__PURE__ */ C("div", { className: "flex flex-col gap-y-1", children: [
        /* @__PURE__ */ C(
          "button",
          {
            onClick: () => b(!0),
            className: "text-textLink flex flex-row items-center text-bodysm font-normal underline",
            children: [
              /* @__PURE__ */ l(Mf, { className: "h-4 w-4" }),
              /* @__PURE__ */ l("p", { className: "ml-1", children: "Edit review" })
            ]
          }
        ),
        /* @__PURE__ */ C("p", { className: "text-textSubdued text-bodysm font-normal", children: [
          "Last updated " + Is(f).replace(",", " at") + " by ",
          /* @__PURE__ */ l("span", { className: "text-textPrimary", children: m })
        ] })
      ] })
    ] });
  };
  return /* @__PURE__ */ C("div", { className: "bg-interfaceWhite border-interfaceBorder text-textPrimary flex flex-col rounded-lg border p-8", children: [
    t.length === 0 || y ? /* @__PURE__ */ l(
      $$e,
      {
        review: i,
        conversation: e,
        onClickCancel: () => b(!1),
        onSubmitSuccess: () => {
          b(!1), r == null || r();
        }
      }
    ) : null,
    t.length > 0 && !y ? N() : null
  ] });
}
function zer({
  conversation: e,
  noticeboard: r,
  onSubmitSuccess: t
}) {
  const i = e == null ? void 0 : e.id, n = Oq({ conversation: e }), s = n.at(-1);
  if (n.length > 0 && s && !ku(s == null ? void 0 : s.review_data))
    return /* @__PURE__ */ l(
      z$e,
      {
        conversationId: i || "",
        onSubmitSuccess: t,
        reviews: n
      }
    );
  if (n.length > 0 && s && ku(s.review_data))
    switch (console.log("<ReviewPanel> currentReview", s), s.review_data.version) {
      case 1:
        return /* @__PURE__ */ l(
          W$e,
          {
            conversation: e,
            noticeboard: r,
            onSubmitSuccess: t
          }
        );
      case 2:
        return /* @__PURE__ */ l(
          U$e,
          {
            conversation: e,
            onSubmitSuccess: t
          }
        );
      case 3:
        return /* @__PURE__ */ l(
          rR,
          {
            conversation: e,
            onSubmitSuccess: t
          }
        );
    }
  return /* @__PURE__ */ l(
    rR,
    {
      conversation: e,
      onSubmitSuccess: t
    }
  );
}
function Ber({
  checked: e,
  language: r,
  onChange: t
}) {
  return /* @__PURE__ */ C("div", { className: "text-bodymd flex items-center gap-1", children: [
    /* @__PURE__ */ l(
      b2,
      {
        checked: e,
        className: "!data-[state=unchecked]:bg-interactiveBorder !w-5.5 !h-3 border-none",
        onCheckedChange: t,
        thumbClassName: "!h-2 !w-2 data-[state=checked]:!translate-x-3 data-[state=unchecked]:!translate-x-0.5"
      }
    ),
    "View in users selected language (",
    sR(r),
    ")"
  ] });
}
function Wer({
  conversation: e,
  publicReportLink: r
}) {
  var u, o, d, a, V;
  const { getLocalisationEntry: t } = si(e), i = t("councilName"), n = e != null && e.language && (e == null ? void 0 : e.language) !== "en" ? e.language : "", s = () => {
    if (e != null && e.updated_at && (e != null && e.created_at)) {
      const c = vae(
        new Date(e == null ? void 0 : e.updated_at),
        new Date(e == null ? void 0 : e.created_at)
      );
      let F = "";
      return c.days !== 0 && (F = F + c.days.toString() + " days "), c.minutes !== 0 && (F = F + c.minutes.toString() + " minutes "), F;
    }
    return "N/A";
  };
  return /* @__PURE__ */ C("div", { className: "flex h-full min-h-0 flex-col gap-y-6", children: [
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { className: "mb-0.5 font-semibold", children: "User" }),
      e != null && e.user_email ? /* @__PURE__ */ l(
        "a",
        {
          className: "text-textLink flex cursor-pointer flex-row underline",
          href: `mailto:${e.user_email}?subject=${i}%2planning%2enquiry%2follow-up`,
          rel: "noreferrer",
          tabIndex: 0,
          target: "_blank",
          children: e.user_email
        }
      ) : /* @__PURE__ */ l("p", { children: '"N/A"' })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { className: "mb-0.5 font-semibold", children: "Feedback consent" }),
      /* @__PURE__ */ l("p", { children: e != null && e.user_consent ? "Yes" : "No" })
    ] }),
    n && /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { className: "mb-0.5 font-semibold", children: "Language" }),
      /* @__PURE__ */ l("p", { children: sR(n) })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { className: "mb-0.5 font-semibold", children: "ID" }),
      /* @__PURE__ */ l("p", { children: ((u = e == null ? void 0 : e.identifier) == null ? void 0 : u.toUpperCase()) || "N/A" })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { className: "mb-0.5 font-semibold", children: "State" }),
      /* @__PURE__ */ l(rQe, { value: e != null && e.state ? e.state : "" })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { className: "mb-0.5 font-semibold", children: "Public report link" }),
      ["report_ready", "saved_report", "sent_to_council"].includes(
        (e == null ? void 0 : e.phase) || ""
      ) ? /* @__PURE__ */ l(
        "a",
        {
          href: `${r}${(o = e == null ? void 0 : e.identifier) == null ? void 0 : o.toUpperCase()}`,
          target: "_blank",
          className: "text-textLink hover:text-textLinkHover flex flex-row underline",
          children: `${r}${(d = e == null ? void 0 : e.identifier) == null ? void 0 : d.toUpperCase()}`
        }
      ) : /* @__PURE__ */ l("p", { children: "---" })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { className: "mb-1 font-semibold", children: "Time and duration" }),
      /* @__PURE__ */ l("table", { className: "w-full text-left text-bodymd font-normal", children: /* @__PURE__ */ C("tbody", { children: [
        /* @__PURE__ */ C("tr", { className: "border-interfaceBorder w-full border-b", children: [
          /* @__PURE__ */ l("th", { className: "border-interfaceBorder w-1/2 border-r py-2 ", children: "Started" }),
          /* @__PURE__ */ l("td", { className: "w-1/2 py-2 pl-3", children: Is(e == null ? void 0 : e.created_at) })
        ] }),
        /* @__PURE__ */ C("tr", { className: "border-interfaceBorder w-full border-b", children: [
          /* @__PURE__ */ l("th", { className: "border-interfaceBorder w-1/2 border-r py-2 ", children: "Last interaction" }),
          /* @__PURE__ */ l("td", { className: "w-1/2 py-2 pl-3", children: Is(e == null ? void 0 : e.updated_at) })
        ] }),
        /* @__PURE__ */ C("tr", { className: "w-full", children: [
          /* @__PURE__ */ l("th", { className: "border-interfaceBorder w-1/2 border-r py-2 ", children: "Duration" }),
          /* @__PURE__ */ l("td", { className: "w-1/2 py-2 pl-3", children: s() })
        ] })
      ] }) })
    ] }),
    /* @__PURE__ */ C("div", { children: [
      /* @__PURE__ */ l("h3", { className: "mb-0.5 font-semibold", children: "Ordinance" }),
      e != null && e.report_ordinance_version ? /* @__PURE__ */ l("p", { className: "text-bodymd", children: "Outcome determined using planning legislation accessed on " + ((a = Rw((e == null ? void 0 : e.report_ordinance_version) || "")) == null ? void 0 : a.date) + " (version " + ((V = Rw((e == null ? void 0 : e.report_ordinance_version) || "")) == null ? void 0 : V.version) + ")." }) : /* @__PURE__ */ l("p", { children: "---" })
    ] })
  ] });
}
const Q$e = {
  microsoft: /* @__PURE__ */ l(N_e, {}),
  google: /* @__PURE__ */ l(S_e, {})
};
function Ger({
  disabled: e,
  socialApps: r,
  action: t = "login"
}) {
  const i = t === "signup" ? "Sign up with" : "Log in with";
  return /* @__PURE__ */ l("div", { className: "flex gap-3", children: r.map((n) => {
    const s = Q$e[n.provider];
    return /* @__PURE__ */ l("a", { href: n.login_url, className: "grow", children: /* @__PURE__ */ C(
      er,
      {
        className: "text-bodymd mt-1 w-full rounded-sm px-4 py-2 text-black",
        disabled: e,
        variant: "outline",
        children: [
          s ? /* @__PURE__ */ l("span", { className: "mr-2", children: s }) : null,
          " ",
          i,
          " ",
          n.name
        ]
      },
      n.provider
    ) }, n.provider);
  }) });
}
const eQe = {
  rippling: /* @__PURE__ */ l(T_e, {})
};
function Uer({ disabled: e, ssoApp: r }) {
  if (!r)
    return null;
  const t = eQe[r.provider];
  return /* @__PURE__ */ l("div", { className: "flex gap-3", children: /* @__PURE__ */ l("a", { href: r.login_url, className: "grow", children: /* @__PURE__ */ C(
    er,
    {
      className: "text-bodymd mt-1 w-full rounded-sm px-4 py-2 text-black",
      disabled: e,
      variant: "outline",
      children: [
        t ? /* @__PURE__ */ l("span", { className: "mr-2", children: t }) : null,
        " Log in with",
        " ",
        r.name
      ]
    },
    r.provider
  ) }, r.provider) });
}
function Zer({ value: e }) {
  let r = e, t = !1, i = "text-textPrimary", n = "", s = "";
  switch (r) {
    case "Internal":
      i = "text-blueDefault", n = "bg-blueBgLight", s = "border-blueBorder";
      break;
    case "Council":
      i = "text-greenDefault", n = "bg-greenBgLight", s = "border-greenBorder";
      break;
    case null:
      t = !0;
      break;
    case "":
      t = !0;
      break;
  }
  return t ? "---" : /* @__PURE__ */ l(
    "div",
    {
      className: `${i} ${n} ${s} w-min whitespace-nowrap rounded-xl border px-3 text-bodysm font-medium`,
      children: r
    }
  );
}
function Lr({ value: e }) {
  let r = e, t = !1, i = "text-textPrimary", n = "", s = "";
  switch (r) {
    //
    // generic outcomes
    //
    case "No permit required":
      r = "Permit not required", i = "text-successText", n = "bg-successBgLight", s = "border-successBorder";
      break;
    case "More information required":
      r = "Exemptions may apply", i = "text-actionDefault", n = "bg-actionBgLight", s = "border-actionBorder";
      break;
    case "Permit required":
      i = "text-warningText", n = "bg-warningBgLight", s = "border-warningBorder";
      break;
    case "Prohibited":
      i = "text-destructiveText", n = "bg-destructiveBgLight", s = "border-destructiveBorder";
      break;
    //
    // council specific outcomes
    // SSC
    //
    case "Accepted":
      i = "text-successText", n = "bg-successBgLight", s = "border-successBorder";
      break;
    case "Self assess":
      i = "text-actionDefault", n = "bg-actionBgLight", s = "border-actionBorder";
      break;
    case "Code":
      i = "text-warningText", n = "bg-warningBgLight", s = "border-warningBorder";
      break;
    case "Impact":
      i = "text-warningText", n = "bg-warningBgLight", s = "border-warningBorder";
      break;
    case null:
      t = !0;
      break;
    case "":
      t = !0;
  }
  return t ? "---" : /* @__PURE__ */ l(
    "div",
    {
      className: _(
        "w-min rounded-xl border px-3 text-bodysm font-medium whitespace-nowrap",
        i,
        n,
        s
      ),
      children: r
    }
  );
}
function Jer({ value: e }) {
  let r = e, t = !1, i = "text-textPrimary", n = "", s = "";
  switch (r) {
    case "No priority":
      i = "text-gray-500", n = "bg-gray-100", s = "border-gray-300";
      break;
    case "Low":
      i = "text-successText", n = "bg-successBgLight", s = "border-successBorder";
      break;
    case "Medium":
      i = "text-actionDefault", n = "bg-actionBgLight", s = "border-actionBorder";
      break;
    case "High":
      i = "text-warningText", n = "bg-warningBgLight", s = "border-warningBorder";
      break;
    case "Urgent":
      i = "text-destructiveText", n = "bg-destructiveBgLight", s = "border-destructiveBorder";
      break;
    case null:
      t = !0;
      break;
    case "":
      t = !0;
      break;
  }
  return t ? "---" : /* @__PURE__ */ l(
    "div",
    {
      className: `${i} ${n} ${s} w-min whitespace-nowrap rounded-xl border px-3 text-bodysm font-medium`,
      children: r
    }
  );
}
function $er({ value: e }) {
  let r = e, t = "text-textPrimary", i = "", n = "";
  return r === !0 || r === "True" ? (r = "Yes", t = "text-successText", i = "bg-successBgLight", n = "border-successBorder") : (r = "No", t = "text-textSubdued", i = "bg-interfaceTags", n = "border-interactiveBorder"), /* @__PURE__ */ l(
    "div",
    {
      className: `${t} ${i} ${n} w-min whitespace-nowrap rounded-xl border px-3 text-bodysm font-medium`,
      children: r
    }
  );
}
function Qer({ value: e }) {
  let r = e, t = "text-textPrimary", i = "", n = "";
  return r === !0 || r === "True" ? (r = "🚩 Yes", t = "text-redText", i = "bg-redBgLight", n = "border-redBorder") : (r = "No", t = "text-textSubdued", i = "bg-interfaceTags", n = "border-interactiveBorder"), /* @__PURE__ */ l(
    "div",
    {
      className: `${t} ${i} ${n} w-min whitespace-nowrap rounded-xl border px-3 text-bodysm font-medium`,
      children: r
    }
  );
}
function err({ value: e }) {
  let r = e, t = !1, i = "", n = "", s = "";
  return r === "Non-blocking" ? (i = "text-textSubdued", n = "bg-interfaceBgLight", s = "border-interfaceBorder") : r === "Blocking" ? (i = "text-destructiveText", n = "bg-destructiveBgLight", s = "border-destructiveBorder") : r == null ? t = !0 : (i = "text-textPrimary", n = "bg-interfaceBgLight", s = "border-interfaceBorder"), t ? "---" : /* @__PURE__ */ l(
    "div",
    {
      className: `${i} ${n} ${s} w-min rounded-xl border px-3 text-bodysm font-medium whitespace-nowrap`,
      children: r
    }
  );
}
function rrr({ value: e }) {
  let r = e, t = !1, i = "text-textPrimary", n = "", s = "";
  return r === "sent_to_council" ? (r = "Complete", i = "text-successText", n = "bg-successBgLight", s = "border-successBorder") : r === "saved_report" ? (r = "Review requested", i = "text-[#3A0075]", n = "bg-[#F8F3FF]", s = "border-[#D2B7FF]") : ["report_ready"].includes(r) ? (r = "Draft", i = "text-warningText", n = "bg-warningBgLight", s = "border-warningBorder") : r === "discarded" ? (r = "Discarded", i = "text-textSubdued", n = "bg-interfaceTags", s = "border-interactiveBorder") : r === null ? t = !0 : (r = "In progress", i = "text-actionPress", n = "bg-actionBgLight", s = "border-actionBorder"), t ? "---" : /* @__PURE__ */ l(
    "div",
    {
      className: `${i} ${n} ${s} w-min whitespace-nowrap rounded-xl border px-3 text-bodysm font-medium`,
      children: r
    }
  );
}
function rQe({ value: e }) {
  let r = e, t = !1, i = "text-textPrimary", n = "", s = "";
  return e === "in_progress" ? (r = "In progress", i = "text-actionPress", n = "bg-actionBgLight", s = "border-actionBorder") : e === "draft" ? (r = "Draft", i = "text-warningText", n = "bg-warningBgLight", s = "border-warningBorder") : e === "completed" ? (r = "Complete", i = "text-successText", n = "bg-successBgLight", s = "border-successBorder") : e === "error" ? (r = "Error", i = "text-destructiveText", n = "bg-destructiveBgLight", s = "border-destructiveBorder") : e === "stuck" ? (r = "Stuck", i = "text-destructiveText", n = "bg-destructiveBgLight", s = "border-destructiveBorder") : e === "abandoned" ? (r = "Abandoned", i = "text-textPrimary", n = "bg-interfaceBorder", s = "border-interfaceBorder") : e === "discarded" ? (r = "Discarded", i = "text-textPrimary", n = "bg-interfaceTags", s = "border-interfaceTags") : e === "off_topic" ? (r = "Blocked", i = "text-[#3A0075]", n = "bg-[#F8F3FF]", s = "border-[#D2B7FF]") : e ? (r = "In progress", i = "text-actionPress", n = "bg-actionBgLight", s = "border-actionBorder") : t = !0, t ? "---" : /* @__PURE__ */ l(
    "div",
    {
      className: `${i} ${n} ${s} text-bodysm w-min whitespace-nowrap rounded-xl border px-3 font-medium`,
      children: r
    }
  );
}
function trr({ value: e }) {
  let r = e, t = !1, i = "", n = "", s = "";
  return r === "Backlog" ? (i = "text-textSubdued", n = "bg-interfaceBgLight", s = "border-interfaceBorder") : r === "To Do" ? (i = "text-blueText", n = "bg-blueBgLight", s = "border-blueBorder") : r === "In Progress" ? (i = "text-actionPress", n = "bg-actionBgLight", s = "border-actionBorder") : r === "Clarification Required" ? (i = "text-destructiveText", n = "bg-destructiveBgLight", s = "border-destructiveBorder") : r === "Wont Do" ? (i = "text-purpleText", n = "bg-purpleBgLight", s = "border-purpleBorder") : r === "Not An Issue" ? (i = "text-yellowText", n = "bg-yellowBgLight", s = "border-yellowBorder") : r === "Resolved" ? (i = "text-successText", n = "bg-successBgLight", s = "border-successBorder") : r == null ? t = !0 : (i = "text-textPrimary", n = "bg-interfaceBgLight", s = "border-interfaceBorder"), t ? "---" : /* @__PURE__ */ l(
    "div",
    {
      className: `${i} ${n} ${s} w-min whitespace-nowrap rounded-xl border px-3 text-body font-medium`,
      children: r
    }
  );
}
function irr({ value: e }) {
  let r = "text-textPrimary", t = "", i = "", n;
  return e ? (n = "Yes", r = "text-successText", t = "bg-successBgLight", i = "border-successBorder") : (n = "No", r = "text-destructiveText", t = "bg-destructiveBgLight", i = "border-destructiveBorder"), /* @__PURE__ */ l(
    "div",
    {
      className: `${r} ${t} ${i} w-min whitespace-nowrap rounded-xl border px-3 text-bodysm font-medium`,
      children: n
    }
  );
}
export {
  _s as Accordion,
  ls as AccordionContent,
  as as AccordionItem,
  Vs as AccordionTrigger,
  bQe as AddressAutoCompleteInput,
  X7e as Alert,
  Y7e as AlertDescription,
  Q2e as AlertDialog,
  QI as AlertDialogAction,
  iFe as AlertDialogCancel,
  ZI as AlertDialogContent,
  tFe as AlertDialogDescription,
  JI as AlertDialogFooter,
  rFe as AlertDialogHeader,
  UI as AlertDialogOverlay,
  eFe as AlertDialogPortal,
  $I as AlertDialogTitle,
  AQe as AlertDialogTrigger,
  q7e as AlertTitle,
  Rq as AnalysisCallout,
  Ma as AnalysisCalloutType,
  mQe as AnalysisReport,
  gQe as AnalysisReportAggregated,
  ger as AnalyticsDashboard,
  wQe as AnimatedText,
  KQe as ApplicationRequirementsReport,
  Ker as AssessmentReport,
  her as AssessmentReportDemo,
  per as AssessmentReportFastEnquiry,
  eL as AutoResizeTextarea,
  Pt as Badge,
  yer as BaysideCityCouncilLogo,
  Aer as BoroondaraCityCouncilLogo,
  er as Button,
  Qy as Calendar,
  CQe as CallOut,
  Pr as Card,
  Nr as CardContent,
  ii as CardDescription,
  e3 as CardFooter,
  Sr as CardHeader,
  Or as CardTitle,
  Ad as Checkbox,
  SQe as CheckboxGroup,
  kQe as Collapsible,
  DQe as CollapsibleContent,
  OQe as CollapsibleTrigger,
  RQe as ColumnVisibility,
  NQe as Combobox,
  hl as Command,
  TQe as CommandDialog,
  a3 as CommandEmpty,
  V2 as CommandGroup,
  HL as CommandInput,
  l2 as CommandItem,
  a2 as CommandList,
  ui as CommandPrimitive,
  fYe as CommandSeparator,
  KYe as CommandShortcut,
  ver as ConversationProgressIndicator,
  y_e as CouncilsDropdown,
  LQe as DataTable,
  yfe as DataTablePagination,
  Ii as DataTile,
  fhe as DatePickerWithRange,
  Mer as DeleteTreeIcon,
  vY as Dialog,
  UQe as DialogClose,
  q2 as DialogContent,
  ipe as DialogDescription,
  bY as DialogFooter,
  tpe as DialogHeader,
  yH as DialogOverlay,
  rpe as DialogPortal,
  yY as DialogTitle,
  GQe as DialogTrigger,
  spe as DraftWatermarkOverlay,
  JQe as DropdownMenu,
  eme as DropdownMenuCheckboxItem,
  $1e as DropdownMenuContent,
  QQe as DropdownMenuGroup,
  Q1e as DropdownMenuItem,
  tme as DropdownMenuLabel,
  eer as DropdownMenuPortal,
  ter as DropdownMenuRadioGroup,
  rme as DropdownMenuRadioItem,
  ime as DropdownMenuSeparator,
  nme as DropdownMenuShortcut,
  rer as DropdownMenuSub,
  J1e as DropdownMenuSubContent,
  Z1e as DropdownMenuSubTrigger,
  $Qe as DropdownMenuTrigger,
  Ter as DuplicateTreeIcon,
  Ner as EastGippslandCouncilLogo,
  mer as EmptyAssessmentReport,
  wer as ExternalLinkIcon,
  vx as FilterType,
  ber as Filters,
  ome as FormControl,
  dme as FormDescription,
  ier as FormField,
  uz as FormFieldContext,
  sme as FormItem,
  oz as FormItemContext,
  ume as FormLabel,
  ame as FormMessage,
  urr as FormProvider,
  S_e as GoogleSocialLoginLogo,
  Oer as GridLoader,
  Ed as HorizontalRadioGroup,
  Mf as IconEdit,
  G3 as Input,
  Eme as Input2,
  Zer as IssueTypeTag,
  _r as Label,
  _er as MapComponent,
  Ler as MarkdownEditor,
  ker as MeltonCityCouncilLogo,
  N_e as MicrosoftSocialLoginLogo,
  pQe as MissingInformationReport,
  Cer as MorningtonPeninsulaShireCouncilLogo,
  Pz as MultiSelect,
  Per as MyLotLogoBlue,
  pge as NavigationMenu,
  bge as NavigationMenuContent,
  yge as NavigationMenuIndicator,
  uer as NavigationMenuItem,
  oer as NavigationMenuLink,
  mge as NavigationMenuList,
  vge as NavigationMenuTrigger,
  dB as NavigationMenuViewport,
  Lr as OutcomeTag,
  n_ as Pagination,
  s_ as PaginationContent,
  d_ as PaginationEllipsis,
  vc as PaginationItem,
  _Qe as PaginationLabel,
  iY as PaginationLink,
  o_ as PaginationNext,
  u_ as PaginationPrevious,
  hQe as PermitRequirementsReport,
  qY as Popover,
  zQe as PopoverAnchor,
  x2 as PopoverContent,
  YY as PopoverTrigger,
  Jer as PriorityTag,
  Her as ProgressIndicatorList,
  Zx as ProgressIndicatorListStatus,
  jer as PublicConversation,
  Cge as RadioBoxCircle,
  Age as RadioGroup,
  wge as RadioGroupItem,
  aB as RadioMultiSelect,
  j$e as ReasoningPanel,
  g_e as RenderChart,
  tve as ReviewCheckboxGroup,
  Qer as ReviewNeededTag,
  zer as ReviewPanel,
  z$e as ReviewPanelV0,
  W$e as ReviewPanelV1,
  $er as ReviewedTag,
  T_e as RipplingIcon,
  Uer as SSOButton,
  pve as ScrollArea,
  OB as ScrollBar,
  cbe as Select,
  HW as SelectContent,
  ler as SelectGroup,
  l8 as SelectItem,
  xbe as SelectLabel,
  Xbe as SelectSeparator,
  _W as SelectTrigger,
  Fbe as SelectValue,
  Ber as SelectedLanguageToggle,
  Qd as Separator,
  Wer as SessionPanel,
  err as SeverityTag,
  BW as Sheet,
  cer as SheetClose,
  lA as SheetContent,
  gbe as SheetDescription,
  GW as SheetFooter,
  mbe as SheetHeader,
  WW as SheetOverlay,
  hbe as SheetPortal,
  UW as SheetTitle,
  Kbe as SheetTrigger,
  yr as ShowMore,
  Tbe as Sidebar,
  _be as SidebarContent,
  Ibe as SidebarFooter,
  Hbe as SidebarGroup,
  zbe as SidebarGroupAction,
  Bbe as SidebarGroupContent,
  jbe as SidebarGroupLabel,
  Rbe as SidebarHeader,
  Dbe as SidebarInput,
  Obe as SidebarInset,
  Wbe as SidebarMenu,
  Jbe as SidebarMenuAction,
  $be as SidebarMenuBadge,
  Zbe as SidebarMenuButton,
  Gbe as SidebarMenuItem,
  Qbe as SidebarMenuSkeleton,
  eye as SidebarMenuSub,
  tye as SidebarMenuSubButton,
  rye as SidebarMenuSubItem,
  Mbe as SidebarProvider,
  kbe as SidebarRail,
  Lbe as SidebarSeparator,
  Ebe as SidebarTrigger,
  Xe as Skeleton,
  gye as Slider,
  Ger as SocialLoginButtons,
  rrr as StageTag,
  rQe as StateTag,
  trr as StatusTag,
  Fn as SubdirectoryArrowRightIcon,
  Ser as SunshineCoastCouncilLogo,
  b2 as Switch,
  pl as Table,
  gl as TableBody,
  vfe as TableCaption,
  De as TableCell,
  gfe as TableFooter,
  Ir as TableHead,
  ml as TableHeader,
  ti as TableRow,
  vu as Tabs,
  St as TabsContent,
  Ms as TabsList,
  Rt as TabsTrigger,
  Cye as Tag,
  Lae as TemplateRenderer,
  Tye as Textarea,
  Pye as TimeLine,
  iU as Toast,
  l3e as ToastAction,
  nU as ToastClose,
  uU as ToastDescription,
  a3e as ToastProvider,
  sU as ToastTitle,
  tU as ToastViewport,
  Yer as Toaster,
  K3e as Toggle,
  DU as Tooltip,
  IU as TooltipContent,
  bA as TooltipProvider,
  RU as TooltipTrigger,
  M_e as UngroupIcon,
  TV as VerticalRadioGroup,
  SAe as VerticalReasoningCorrectnessRadioGroup,
  Eer as WorldIcon,
  irr as YesNoTag,
  bFe as badgeVariants,
  AV as buttonVariants,
  IQe as createColumnHelper,
  _$e as defaultReasoningPanelSections,
  Tme as input2Variants,
  gge as navigationMenuTriggerStyle,
  X3e as reducer,
  q3e as toast,
  f3e as toggleVariants,
  orr as useController,
  HQe as useDataTablePagination,
  fce as useDesignAndSittingClause,
  drr as useFieldArray,
  arr as useForm,
  Vrr as useFormContext,
  SY as useFormField,
  xce as useGetApplicationRequirements,
  fQe as useGetFeaturesInTesting,
  CR as useGetMandatoryRequirements,
  Fce as useGetMissingInformationText,
  Xce as useGetReportAbstract,
  qce as useGetReportHeading,
  cce as useGetVicSmartEligibility,
  Yce as useShowMandatoryRequirements,
  LY as useSidebar,
  oU as useToast,
  lrr as useWatch
};
//# sourceMappingURL=components.js.map
